(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2835"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2835"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3LkHX", function(module, exports) {

var $dvYFb = parcelRequire("dvYFb");
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */ (function(global, factory) {
    "use strict";
    if ((0, $dvYFb._)(module.exports) === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var flat = arr.flat ? function flat(array) {
        return arr.flat.call(array);
    } : function(array) {
        return arr.concat.apply([], array);
    };
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    var isFunction = function isFunction(obj) {
        // Support: Chrome <=57, Firefox <=52
        // In some browsers, typeof returns "function" for HTML <object> elements
        // (i.e., `typeof document.createElement( "object" ) === "function"`).
        // We don't want to classify *any* DOM node as a function.
        // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
        // Plus for old WebKit, typeof returns "function" for HTML collections
        // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
        return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
    };
    var isWindow = function isWindow(obj) {
        return obj != null && obj === obj.window;
    };
    var document = window1.document;
    var preservedScriptAttributes = {
        type: true,
        src: true,
        nonce: true,
        noModule: true
    };
    function DOMEval(code, node, doc) {
        doc = doc || document;
        var i, val, script = doc.createElement("script");
        script.text = code;
        if (node) for(i in preservedScriptAttributes){
            // Support: Firefox 64+, Edge 18+
            // Some browsers don't support the "nonce" property on scripts.
            // On the other hand, just using `getAttribute` is not enough as
            // the `nonce` attribute is reset to an empty string whenever it
            // becomes browsing-context connected.
            // See https://github.com/whatwg/html/issues/2369
            // See https://html.spec.whatwg.org/#nonce-attributes
            // The `node.getAttribute` check was added for the sake of
            // `jQuery.globalEval` so that it can fake a nonce-containing node
            // via an object.
            val = node[i] || node.getAttribute && node.getAttribute(i);
            if (val) script.setAttribute(i, val);
        }
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    function toType(obj) {
        if (obj == null) return obj + "";
        // Support: Android <=2.3 only (functionish RegExp)
        return (typeof obj === "undefined" ? "undefined" : (0, $dvYFb._)(obj)) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : (0, $dvYFb._)(obj);
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.7.1", rhtmlSuffix = /HTML$/i, // Define a local copy of jQuery
    jQuery = function jQuery1(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function toArray() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function get(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function pushStack(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function each(callback) {
            return jQuery.each(this, callback);
        },
        map: function map(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function slice1() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function first() {
            return this.eq(0);
        },
        last: function last() {
            return this.eq(-1);
        },
        even: function even() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return (i + 1) % 2;
            }));
        },
        odd: function odd() {
            return this.pushStack(jQuery.grep(this, function(_elem, i) {
                return i % 2;
            }));
        },
        eq: function eq(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function end() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if ((typeof target === "undefined" ? "undefined" : (0, $dvYFb._)(target)) !== "object" && !isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                copy = options[name];
                // Prevent Object.prototype pollution
                // Prevent never-ending loop
                if (name === "__proto__" || target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    src = target[name];
                    // Ensure proper type for the source value
                    if (copyIsArray && !Array.isArray(src)) clone = [];
                    else if (!copyIsArray && !jQuery.isPlainObject(src)) clone = {};
                    else clone = src;
                    copyIsArray = false;
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function error(msg) {
            throw new Error(msg);
        },
        noop: function noop() {},
        isPlainObject: function isPlainObject(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function isEmptyObject(obj) {
            var name;
            for(name in obj)return false;
            return true;
        },
        // Evaluates a script in a provided context; falls back to the global one
        // if not specified.
        globalEval: function globalEval(code, options, doc) {
            DOMEval(code, {
                nonce: options && options.nonce
            }, doc);
        },
        each: function each(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Retrieve the text value of an array of DOM nodes
        text: function text(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += jQuery.text(node);
            if (nodeType === 1 || nodeType === 11) return elem.textContent;
            if (nodeType === 9) return elem.documentElement.textContent;
            if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        },
        // results is for internal usage only
        makeArray: function makeArray(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function inArray(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        isXMLDoc: function isXMLDoc(elem) {
            var namespace = elem && elem.namespaceURI, docElem = elem && (elem.ownerDocument || elem).documentElement;
            // Assume HTML when documentElement doesn't yet exist, such as inside
            // document fragments.
            return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function merge(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function grep(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function map(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return flat(ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(_i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = toType(obj);
        if (isFunction(obj) || isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var pop = arr.pop;
    var sort = arr.sort;
    var splice = arr.splice;
    var whitespace = "[\\x20\\t\\r\\n\\f]";
    var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");
    // Note: an element does not contain itself
    jQuery.contains = function(a, b) {
        var bup = b && b.parentNode;
        return a === bup || !!(bup && bup.nodeType === 1 && // Support: IE 9 - 11+
        // IE doesn't have `contains` on SVG.
        (a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
    };
    // CSS string/identifier serialization
    // https://drafts.csswg.org/cssom/#common-serializing-idioms
    var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
    function fcssescape(ch, asCodePoint) {
        if (asCodePoint) {
            // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
            if (ch === "\0") return "\uFFFD";
            // Control characters and (dependent upon position) numbers get escaped as code points
            return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
        }
        // Other potentially-special ASCII characters get backslash-escaped
        return "\\" + ch;
    }
    jQuery.escapeSelector = function(sel) {
        return (sel + "").replace(rcssescape, fcssescape);
    };
    var preferredDoc = document, pushNative = push;
    (function() {
        var i, Expr, outermostContext, sortInput, hasDuplicate, push = pushNative, // Local document vars
        document, documentElement, documentIsHTML, rbuggyQSA, matches, // Instance-specific data
        expando = jQuery.expando, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), nonnativeSelectorCache = createCache(), sortOrder = function sortOrder(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
        identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+", // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rdescend = new RegExp(whitespace + "|>"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            ID: new RegExp("^#(" + identifier + ")"),
            CLASS: new RegExp("^\\.(" + identifier + ")"),
            TAG: new RegExp("^(" + identifier + "|[*])"),
            ATTR: new RegExp("^" + attributes),
            PSEUDO: new RegExp("^" + pseudos),
            CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            bool: new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"), funescape = function funescape(escape, nonHex) {
            var high = "0x" + escape.slice(1) - 0x10000;
            if (nonHex) // Strip the backslash prefix from a non-hex escape sequence
            return nonHex;
            // Replace a hexadecimal escape sequence with the encoded Unicode code point
            // Support: IE <=11+
            // For values outside the Basic Multilingual Plane (BMP), manually construct a
            // surrogate pair
            return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // Used for iframes; see `setDocument`.
        // Support: IE 9 - 11+, Edge 12 - 18+
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE/Edge.
        unloadHandler = function unloadHandler() {
            setDocument();
        }, inDisabledFieldset = addCombinator(function(elem) {
            return elem.disabled === true && nodeName(elem, "fieldset");
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Support: IE <=9 only
        // Accessing document.activeElement can throw unexpectedly
        // https://bugs.jquery.com/ticket/13393
        function safeActiveElement() {
            try {
                return document.activeElement;
            } catch (err) {}
        }
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android <=4.0
            // Detect silently failing push.apply
            // eslint-disable-next-line no-unused-expressions
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: function apply(target, els) {
                    pushNative.apply(target, slice.call(els));
                },
                call: function call(target) {
                    pushNative.apply(target, slice.call(arguments, 1));
                }
            };
        }
        function find(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE 9 only
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        push.call(results, elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE 9 only
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                                push.call(results, elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        newSelector = selector;
                        newContext = context;
                        // qSA considers elements outside a scoping root when evaluating child or
                        // descendant combinators, which is not what we want.
                        // In such cases, we work around the behavior by prefixing every selector in the
                        // list with an ID selector referencing the scope context.
                        // The technique has to be used as well when a leading combinator is used
                        // as such selectors are not recognized by querySelectorAll.
                        // Thanks to Andrew Dupont for this technique.
                        if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                            // We can use :scope instead of the ID hack if the browser
                            // supports it & if we're not changing the context.
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when
                            // strict-comparing two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if (newContext != context || !support.scope) {
                                // Capture the context ID, setting it first if necessary
                                if (nid = context.getAttribute("id")) nid = jQuery.escapeSelector(nid);
                                else context.setAttribute("id", nid = expando);
                            }
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                        }
                        try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {
                            nonnativeSelectorCache(selector, true);
                        } finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties
                // (see https://github.com/jquery/sizzle/issues/157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                return nodeName(elem, "input") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11+
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ function setDocument(node) {
            var subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if (doc == document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            documentElement = document.documentElement;
            documentIsHTML = !jQuery.isXMLDoc(document);
            // Support: iOS 7 only, IE 9 - 11+
            // Older browsers didn't support unprefixed `matches`.
            matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;
            // Support: IE 9 - 11+, Edge 12 - 18+
            // Accessing iframe documents after unload throws "permission denied" errors
            // (see trac-13936).
            // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
            // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
            if (documentElement.msMatchesSelector && // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) // Support: IE 9 - 11+, Edge 12 - 18+
            subWindow.addEventListener("unload", unloadHandler);
            // Support: IE <10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                documentElement.appendChild(el).id = jQuery.expando;
                return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
            });
            // Support: IE 9 only
            // Check to see if it's possible to do matchesSelector
            // on a disconnected node.
            support.disconnectedMatch = assert(function(el) {
                return matches.call(el, "*");
            });
            // Support: IE 9 - 11+, Edge 12 - 18+
            // IE/Edge don't support the :scope pseudo-class.
            support.scope = assert(function() {
                return document.querySelectorAll(":scope");
            });
            // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
            // Make sure the `:has()` argument is parsed unforgivingly.
            // We include `*` in the test to detect buggy implementations that are
            // _selectively_ forgiving (specifically when the list includes at least
            // one valid selector).
            // Note that we treat complete lack of support for `:has()` as if it were
            // spec-compliant support, which is fine because use of `:has()` in such
            // environments will fail in the qSA path and fall back to jQuery traversal
            // anyway.
            support.cssHas = assert(function() {
                try {
                    document.querySelector(":has(*,:jqfake)");
                    return false;
                } catch (e) {
                    return true;
                }
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter.ID = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var _$node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return _$node && _$node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find.ID = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var _$node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            _$node = elem.getAttributeNode("id");
                            if (_$node && _$node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                _$node = elem.getAttributeNode("id");
                                if (_$node && _$node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find.TAG = function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else return context.querySelectorAll(tag);
            };
            // Class
            Expr.find.CLASS = function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            rbuggyQSA = [];
            // Build QSA regex
            // Regex strategy adopted from Diego Perini
            assert(function(el) {
                var input;
                documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";
                // Support: iOS <=7 - 8 only
                // Boolean attributes and "value" are not treated correctly in some XML documents
                if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                // Support: iOS <=7 - 8 only
                if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                // Support: iOS 8 only
                // https://bugs.webkit.org/show_bug.cgi?id=136851
                // In-page `selector#id sibling-combinator selector` fails
                if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                // Support: Windows 8 Native Apps
                // The type and name attributes are restricted during .innerHTML assignment
                input = document.createElement("input");
                input.setAttribute("type", "hidden");
                el.appendChild(input).setAttribute("name", "D");
                // Support: IE 9 - 11+
                // IE's :disabled selector does not pick up the children of disabled fieldsets
                // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
                // In some of the document kinds, these selectors wouldn't work natively.
                // This is probably OK but for backwards compatibility we want to maintain
                // handling them through jQuery traversal in jQuery 3.x.
                documentElement.appendChild(el).disabled = true;
                if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                // Support: IE 11+, Edge 15 - 18+
                // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                // Adding a temporary attribute to the document before the selection works
                // around the issue.
                // Interestingly, IE 10 & older don't seem to have the issue.
                input = document.createElement("input");
                input.setAttribute("name", "");
                el.appendChild(input);
                if (!el.querySelectorAll("[name='']").length) rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
            });
            if (!support.cssHas) // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
            // Our regular `try-catch` mechanism fails to detect natively-unsupported
            // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
            // in browsers that parse the `:has()` argument as a forgiving selector list.
            // https://drafts.csswg.org/selectors/#relational now requires the argument
            // to be parsed unforgivingly, but browsers have not yet fully adjusted.
            rbuggyQSA.push(":has");
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = function sortOrder(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) return -1;
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            };
            return document;
        }
        find.matches = function(expr, elements) {
            return find(expr, null, null, elements);
        };
        find.matchesSelector = function(elem, expr) {
            setDocument(elem);
            if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {
                nonnativeSelectorCache(expr, true);
            }
            return find(expr, document, null, [
                elem
            ]).length > 0;
        };
        find.contains = function(context, elem) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((context.ownerDocument || context) != document) setDocument(context);
            return jQuery.contains(context, elem);
        };
        find.attr = function(elem, name) {
            // Set document vars if needed
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            if ((elem.ownerDocument || elem) != document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (see trac-13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            if (val !== undefined) return val;
            return elem.getAttribute(name);
        };
        find.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ jQuery.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            //
            // Support: Android <=4.0+
            // Testing for detecting duplicates is unpredictable so instead assume we can't
            // depend on duplicate detection in all browsers without a stable sort.
            hasDuplicate = !support.sortStable;
            sortInput = !support.sortStable && slice.call(results, 0);
            sort.call(results, sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)splice.call(results, duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        jQuery.fn.uniqueSort = function() {
            return this.pushStack(jQuery.uniqueSort(slice.apply(this)));
        };
        Expr = jQuery.expr = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                ATTR: function ATTR(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                CHILD: function CHILD(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) find.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) find.error(match[0]);
                    return match;
                },
                PSEUDO: function PSEUDO(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr.CHILD.test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                TAG: function TAG(nodeNameSelector) {
                    var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return nodeName(elem, expectedNodeName);
                    };
                },
                CLASS: function CLASS(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                ATTR: function ATTR(name, operator, check) {
                    return function(elem) {
                        var result = find.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        if (operator === "=") return result === check;
                        if (operator === "!=") return result !== check;
                        if (operator === "^=") return check && result.indexOf(check) === 0;
                        if (operator === "*=") return check && result.indexOf(check) > -1;
                        if (operator === "$=") return check && result.slice(-check.length) === check;
                        if (operator === "~=") return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
                        if (operator === "|=") return result === check || result.slice(0, check.length + 1) === check + "-";
                        return false;
                    };
                },
                CHILD: function CHILD(type, what, _argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, _context, xml) {
                        var cache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? nodeName(node, name) : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                outerCache = parent[expando] || (parent[expando] = {});
                                cache = outerCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    outerCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    outerCache = elem[expando] || (elem[expando] = {});
                                    cache = outerCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            outerCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                PSEUDO: function PSEUDO(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // https://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as jQuery does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf.call(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                not: markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrimCSS, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, _context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, _context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element
                        // (see https://github.com/jquery/sizzle/issues/299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                has: markFunction(function(selector) {
                    return function(elem) {
                        return find(selector, elem).length > 0;
                    };
                }),
                contains: markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // https://www.w3.org/TR/selectors/#lang-pseudo
                lang: markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) find.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                target: function target(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                root: function root(elem) {
                    return elem === documentElement;
                },
                focus: function focus(elem) {
                    return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                enabled: createDisabledPseudo(false),
                disabled: createDisabledPseudo(true),
                checked: function checked(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
                },
                selected: function selected(elem) {
                    // Support: IE <=11+
                    // Accessing the selectedIndex property
                    // forces the browser to treat the default option as
                    // selected when in an optgroup.
                    if (elem.parentNode) // eslint-disable-next-line no-unused-expressions
                    elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                empty: function empty(elem) {
                    // https://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                parent: function parent(elem) {
                    return !Expr.pseudos.empty(elem);
                },
                // Element/input types
                header: function header(elem) {
                    return rheader.test(elem.nodeName);
                },
                input: function input(elem) {
                    return rinputs.test(elem.nodeName);
                },
                button: function button(elem) {
                    return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
                },
                text: function text(elem) {
                    var attr;
                    return nodeName(elem, "input") && elem.type === "text" && // Support: IE <10 only
                    // New HTML5 attribute values (e.g., "search") appear
                    // with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                first: createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                last: createPositionalPseudo(function(_matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                eq: createPositionalPseudo(function(_matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                even: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                odd: createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                lt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i;
                    if (argument < 0) i = argument + length;
                    else if (argument > length) i = length;
                    else i = argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                gt: createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos.nth = Expr.pseudos.eq;
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rleadingCombinator.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrimCSS, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            if (parseOnly) return soFar.length;
            return soFar ? find.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        }
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        if (skip && nodeName(elem, skip)) elem = elem[dir] || elem;
                        else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            outerCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)find(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, matcherOut, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
                if (matcher) {
                    // If we have a postFinder, or filtered seed, or non-seed postFilter
                    // or preexisting results,
                    matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                    [] : // ...otherwise use results directly
                    results;
                    // Find primary matches
                    matcher(matcherIn, matcherOut, context, xml);
                } else matcherOut = matcherIn;
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf.call(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    // Support: IE 11+, Edge 17 - 18+
                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                    // two documents; shallow comparisons work.
                    // eslint-disable-next-line eqeqeq
                    var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element
                    // (see https://github.com/jquery/sizzle/issues/299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function superMatcher(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find.TAG("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) // Support: IE 11+, Edge 17 - 18+
                // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                // two documents; shallow comparisons work.
                // eslint-disable-next-line eqeqeq
                outermostContext = context == document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: iOS <=7 - 9 only
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
                // elements by id. (see trac-14142)
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        // Support: IE 11+, Edge 17 - 18+
                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                        // two documents; shallow comparisons work.
                        // eslint-disable-next-line eqeqeq
                        if (!context && elem.ownerDocument != document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            push.call(results, elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) jQuery.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        }
        /**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ function select(selector, context, results, seed) {
            var i, tokens, token, type, _$find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (_$find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = _$find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        }
        // One-time assignments
        // Support: Android <=4.0 - 4.1+
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Initialize against the default document
        setDocument();
        // Support: Android <=4.0 - 4.1+
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        jQuery.find = find;
        // Deprecated
        jQuery.expr[":"] = jQuery.expr.pseudos;
        jQuery.unique = jQuery.uniqueSort;
        // These have always been private, but they used to be documented as part of
        // Sizzle so let's maintain them for now for backwards compatibility purposes.
        find.compile = compile;
        find.select = select;
        find.setDocument = setDocument;
        find.tokenize = tokenize;
        find.escape = jQuery.escapeSelector;
        find.getText = jQuery.text;
        find.isXML = jQuery.isXMLDoc;
        find.selectors = jQuery.expr;
        find.support = jQuery.support;
        find.uniqueSort = jQuery.uniqueSort;
    /* eslint-enable */ })();
    var dir = function dir(elem, _dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[_dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Filtered directly for both simple and complex selectors
        return jQuery.filter(qualifier, elements, not);
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function find(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function filter(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function not(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function is(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function init(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function has(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function closest(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to jQuery#find
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function index(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function add(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function addBack(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function parent(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function parents(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function parentsUntil(elem, _i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function next(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function prev(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function nextAll(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function prevAll(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function nextUntil(elem, _i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function prevUntil(elem, _i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function siblings1(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function children(elem) {
            return siblings(elem.firstChild);
        },
        contents: function contents(elem) {
            if (elem.contentDocument != null && // Support: IE 11+
            // <object> elements with no `data` attribute has an object
            // `contentDocument` with a `null` prototype.
            getProto(elem.contentDocument)) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function fire() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && toType(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function has(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function disable() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function lock() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function locked1() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired1() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function Deferred(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function state1() {
                    return state;
                },
                always: function always() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function pipe() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(_i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function then(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function mightThrow() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                ((typeof returned === "undefined" ? "undefined" : (0, $dvYFb._)(returned)) === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function process1() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.error);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the error, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getErrorHook) process.error = jQuery.Deferred.getErrorHook();
                                else if (jQuery.Deferred.getStackHook) process.error = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function promise1(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // rejected_handlers.disable
                // fulfilled_handlers.disable
                tuples[3 - i][3].disable, // progress_callbacks.lock
                tuples[0][2].lock, // progress_handlers.lock
                tuples[0][3].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function when(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the primary Deferred
            primary = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function updateFunc(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) primary.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) return primary.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), primary.reject);
            return primary.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
    // captured before the async barrier to get the original error cause
    // which may otherwise be hidden.
    jQuery.Deferred.exceptionHook = function(error, asyncError) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See trac-6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function ready(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function access1(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (toType(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function fn(elem, _key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    // Matches dashed string for camelizing
    var rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g;
    // Used by camelCase as callback to replace()
    function fcamelCase(_all, letter) {
        return letter.toUpperCase();
    }
    // Convert dashed to camelCase; used by the css and data modules
    // Support: IE <=9 - 11, Edge 12 - 15
    // Microsoft forgot to hump their vendor prefix (trac-9572)
    function camelCase(string) {
        return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
    }
    var acceptData = function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function cache(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see trac-8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function set(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[camelCase(prop)] = data[prop];
            return cache;
        },
        get: function get(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][camelCase(key)];
        },
        access: function access(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function remove(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(camelCase);
                else {
                    key = camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function hasData(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function hasData(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function data(elem, name, _data) {
            return dataUser.access(elem, name, _data);
        },
        removeData: function removeData(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function _data(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function _removeData(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function data(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (trac-14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if ((typeof key === "undefined" ? "undefined" : (0, $dvYFb._)(key)) === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function removeData(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function queue(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function dequeue(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function next() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function _queueHooks(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function queue(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function dequeue(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function clearQueue(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function promise(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function resolve() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var documentElement = document.documentElement;
    var isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem);
    }, composed = {
        composed: true
    };
    // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
    // Check attachment across shadow DOM boundaries when possible (gh-3504)
    // Support: iOS 10.0-10.2 only
    // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
    // leading to errors. We need to check for `getRootNode`.
    if (documentElement.getRootNode) isAttached = function isAttached(elem) {
        return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
    var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        isAttached(elem) && jQuery.css(elem, "display") === "none";
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale, maxIterations = 20, currentValue = tween ? function currentValue() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Support: Firefox <=54
            // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
            initial = initial / 2;
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            while(maxIterations--){
                // Evaluate and update our best guess (doubling guesses that zero out).
                // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                jQuery.style(elem, prop, initialInUnit + unit);
                if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) maxIterations = 0;
                initialInUnit = initialInUnit / scale;
            }
            initialInUnit = initialInUnit * 2;
            jQuery.style(elem, prop, initialInUnit + unit);
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, _$nodeName = elem.nodeName, display = defaultDisplayMap[_$nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(_$nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[_$nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function show() {
            return showHide(this, true);
        },
        hide: function hide() {
            return showHide(this);
        },
        toggle: function toggle(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
    var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (trac-11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (trac-14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
        // Support: IE <=9 only
        // IE <=9 replaces <option> tags with their contents when inserted outside of
        // the select element.
        div.innerHTML = "<option></option>";
        support.option = !!div.lastChild;
    })();
    // We have to close these tags to support XHTML (trac-13200)
    var wrapMap = {
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    // Support: IE <=9 only
    if (!support.option) wrapMap.optgroup = wrapMap.option = [
        1,
        "<select multiple='multiple'>",
        "</select>"
    ];
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, attached, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (toType(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (trac-12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            attached = isAttached(elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (attached) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if ((typeof types === "undefined" ? "undefined" : (0, $dvYFb._)(types)) === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function fn(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function add(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Only attach events to objects that accept data
            if (!acceptData(elem)) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = Object.create(null);
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function eventHandle(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function remove(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function dispatch(nativeEvent) {
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), // Make a writable jQuery.Event from the native event object
            event = jQuery.event.fix(nativeEvent), handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// If the event is namespaced, then each handler is only invoked if it is
                // specially universal or its namespaces are a superset of the event's.
                if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function handlers(event, _handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = _handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (trac-13208)
                // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = _handlers[i];
                        // Don't conflict with Object.prototype properties (trac-13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < _handlers.length) handlerQueue.push({
                elem: cur,
                handlers: _handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function addProp(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function set(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function fix(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            click: {
                // Utilize native event to ensure correct state for checkable inputs
                setup: function setup(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Claim the first handler
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) // dataPriv.set( el, "click", ... )
                    leverageNative(el, "click", true);
                    // Return false to allow normal processing in the caller
                    return false;
                },
                trigger: function trigger(data) {
                    // For mutual compressibility with _default, replace `this` access with a local var.
                    // `|| data` is dead code meant only to preserve the variable through minification.
                    var el = this || data;
                    // Force setup before triggering a click
                    if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) leverageNative(el, "click");
                    // Return non-false to allow normal event-path propagation
                    return true;
                },
                // For cross-browser consistency, suppress native .click() on links
                // Also prevent it if we're currently inside a leveraged native-event stack
                _default: function _default(event) {
                    var target = event.target;
                    return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
                }
            },
            beforeunload: {
                postDispatch: function postDispatch(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    // Ensure the presence of an event listener that handles manually-triggered
    // synthetic events by interrupting progress until reinvoked in response to
    // *native* events that it fires directly, ensuring that state changes have
    // already occurred before other listeners are invoked.
    function leverageNative(el, type, isSetup) {
        // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
        if (!isSetup) {
            if (dataPriv.get(el, type) === undefined) jQuery.event.add(el, type, returnTrue);
            return;
        }
        // Register the controller as a special universal handler for all event namespaces
        dataPriv.set(el, type, false);
        jQuery.event.add(el, type, {
            namespace: false,
            handler: function handler(event) {
                var result, saved = dataPriv.get(this, type);
                if (event.isTrigger & 1 && this[type]) {
                    // Interrupt processing of the outer synthetic .trigger()ed event
                    if (!saved) {
                        // Store arguments for use when handling the inner native event
                        // There will always be at least one argument (an event object), so this array
                        // will not be confused with a leftover capture object.
                        saved = slice.call(arguments);
                        dataPriv.set(this, type, saved);
                        // Trigger the native event and capture its result
                        this[type]();
                        result = dataPriv.get(this, type);
                        dataPriv.set(this, type, false);
                        if (saved !== result) {
                            // Cancel the outer synthetic event
                            event.stopImmediatePropagation();
                            event.preventDefault();
                            return result;
                        }
                    // If this is an inner synthetic event for an event with a bubbling surrogate
                    // (focus or blur), assume that the surrogate already propagated from triggering
                    // the native event and prevent that from happening again here.
                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                    // less bad than duplication.
                    } else if ((jQuery.event.special[type] || {}).delegateType) event.stopPropagation();
                // If this is a native event triggered above, everything is now in order
                // Fire an inner synthetic event with the original arguments
                } else if (saved) {
                    // ...and capture the result
                    dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));
                    // Abort handling of the native event by all jQuery handlers while allowing
                    // native handlers on the same element to run. On target, this is achieved
                    // by stopping immediate propagation just on the jQuery event. However,
                    // the native event is re-wrapped by a jQuery one on each level of the
                    // propagation so the only way to stop it for jQuery is to stop it for
                    // everyone via native `stopPropagation()`. This is not a problem for
                    // focus/blur which don't bubble, but it does also stop click on checkboxes
                    // and radios. We accept this limitation.
                    event.stopPropagation();
                    event.isImmediatePropagationStopped = returnTrue;
                }
            }
        });
    }
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (trac-504, trac-13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || Date.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function preventDefault() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        code: true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: true
    }, jQuery.event.addProp);
    jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(type, delegateType) {
        function focusMappedHandler(nativeEvent) {
            if (document.documentMode) {
                // Support: IE 11+
                // Attach a single focusin/focusout handler on the document while someone wants
                // focus/blur. This is because the former are synchronous in IE while the latter
                // are async. In other browsers, all those handlers are invoked synchronously.
                // `handle` from private data would already wrap the event, but we need
                // to change the `type` here.
                var handle = dataPriv.get(this, "handle"), event = jQuery.event.fix(nativeEvent);
                event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
                event.isSimulated = true;
                // First, handle focusin/focusout
                handle(nativeEvent);
                // ...then, handle focus/blur
                //
                // focus/blur don't bubble while focusin/focusout do; simulate the former by only
                // invoking the handler at the lower level.
                if (event.target === event.currentTarget) // The setup part calls `leverageNative`, which, in turn, calls
                // `jQuery.event.add`, so event handle will already have been set
                // by this point.
                handle(event);
            } else // For non-IE browsers, attach a single capturing handler on the document
            // while someone wants focusin/focusout.
            jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
        }
        jQuery.event.special[type] = {
            // Utilize native event if possible so blur/focus sequence is correct
            setup: function setup() {
                var attaches;
                // Claim the first handler
                // dataPriv.set( this, "focus", ... )
                // dataPriv.set( this, "blur", ... )
                leverageNative(this, type, true);
                if (document.documentMode) {
                    // Support: IE 9 - 11+
                    // We use the same native handler for focusin & focus (and focusout & blur)
                    // so we need to coordinate setup & teardown parts between those events.
                    // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                    attaches = dataPriv.get(this, delegateType);
                    if (!attaches) this.addEventListener(delegateType, focusMappedHandler);
                    dataPriv.set(this, delegateType, (attaches || 0) + 1);
                } else // Return false to allow normal processing in the caller
                return false;
            },
            trigger: function trigger() {
                // Force setup before trigger
                leverageNative(this, type);
                // Return non-false to allow normal event-path propagation
                return true;
            },
            teardown: function teardown() {
                var attaches;
                if (document.documentMode) {
                    attaches = dataPriv.get(this, delegateType) - 1;
                    if (!attaches) {
                        this.removeEventListener(delegateType, focusMappedHandler);
                        dataPriv.remove(this, delegateType);
                    } else dataPriv.set(this, delegateType, attaches);
                } else // Return false to indicate standard teardown should be applied
                return false;
            },
            // Suppress native focus or blur if we're currently inside
            // a leveraged native-event stack
            _default: function _default(event) {
                return dataPriv.get(event.target, type);
            },
            delegateType: delegateType
        };
        // Support: Firefox <=44
        // Firefox doesn't have focus(in | out) events
        // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
        //
        // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
        // focus(in | out) events fire after focus & blur events,
        // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
        // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
        //
        // Support: IE 9 - 11+
        // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
        // attach a single handler for both events in IE.
        jQuery.event.special[delegateType] = {
            setup: function setup() {
                // Handle: regular nodes (via `this.ownerDocument`), window
                // (via `this.document`) & document (via `this`).
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType);
                // Support: IE 9 - 11+
                // We use the same native handler for focusin & focus (and focusout & blur)
                // so we need to coordinate setup & teardown parts between those events.
                // Use `delegateType` as the key as `type` is already used by `leverageNative`.
                if (!attaches) {
                    if (document.documentMode) this.addEventListener(delegateType, focusMappedHandler);
                    else doc.addEventListener(type, focusMappedHandler, true);
                }
                dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
            },
            teardown: function teardown() {
                var doc = this.ownerDocument || this.document || this, dataHolder = document.documentMode ? this : doc, attaches = dataPriv.get(dataHolder, delegateType) - 1;
                if (!attaches) {
                    if (document.documentMode) this.removeEventListener(delegateType, focusMappedHandler);
                    else doc.removeEventListener(type, focusMappedHandler, true);
                    dataPriv.remove(dataHolder, delegateType);
                } else dataPriv.set(dataHolder, delegateType, attaches);
            }
        };
    });
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function handle(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function on1(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function one(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function off(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if ((typeof types === "undefined" ? "undefined" : (0, $dvYFb._)(types)) === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(elem).children("tbody")[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        if ((elem.type || "").slice(0, 5) === "true/") elem.type = elem.type.slice(5);
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.get(src);
            events = pdataOld.events;
            if (events) {
                dataPriv.remove(dest, "handle events");
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var _$nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (_$nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (_$nodeName === "input" || _$nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = flat(args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], valueIsFunction = isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (valueIsFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (trac-8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Re-enable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src && (node.type || "").toLowerCase() !== "module") // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl && !node.noModule) jQuery._evalUrl(node.src, {
                                    nonce: node.nonce || node.getAttribute("nonce")
                                }, doc);
                            } else // Unwrap a CDATA section containing script contents. This shouldn't be
                            // needed as in XML documents they're already not visible when
                            // inspecting element contents and in HTML documents they have no
                            // meaning but we're preserving that logic for backwards compatibility.
                            // This will be removed completely in 4.0. See gh-4904.
                            DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && isAttached(node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function htmlPrefilter(html) {
            return html;
        },
        clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = isAttached(elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew jQuery#find here for performance reasons:
                // https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function cleanData(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function detach(selector) {
            return remove(this, selector, true);
        },
        remove: function remove1(selector) {
            return remove(this, selector);
        },
        text: function text(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function append() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function prepend() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function before() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function after() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function empty() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function clone(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function html(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function replaceWith() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var rcustomProp = /^--/;
    var getStyles = function getStyles(elem) {
        // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    var swap = function swap(elem, options, callback) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.call(elem);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    var rboxStyle = new RegExp(cssExpand.join("|"), "i");
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            container.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0";
            div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%";
            documentElement.appendChild(container).appendChild(div);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;
            // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
            // Some styles come back with percentage values, even though they shouldn't
            div.style.right = "60%";
            pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;
            // Support: IE 9 - 11 only
            // Detect misreporting of content dimensions for box-sizing:border-box elements
            boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;
            // Support: IE 9 only
            // Detect overflow:scroll screwiness (gh-3699)
            // Support: Chrome <=64
            // Don't get tricked when zoom affects offsetWidth (gh-4029)
            div.style.position = "absolute";
            scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        function roundPixelMeasures(measure) {
            return Math.round(parseFloat(measure));
        }
        var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal, reliableTrDimensionsVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (trac-8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        jQuery.extend(support, {
            boxSizingReliable: function boxSizingReliable() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelBoxStyles: function pixelBoxStyles() {
                computeStyleTests();
                return pixelBoxStylesVal;
            },
            pixelPosition: function pixelPosition() {
                computeStyleTests();
                return pixelPositionVal;
            },
            reliableMarginLeft: function reliableMarginLeft() {
                computeStyleTests();
                return reliableMarginLeftVal;
            },
            scrollboxSize: function scrollboxSize() {
                computeStyleTests();
                return scrollboxSizeVal;
            },
            // Support: IE 9 - 11+, Edge 15 - 18+
            // IE/Edge misreport `getComputedStyle` of table rows with width/height
            // set in CSS while `offset*` properties report correct values.
            // Behavior in IE 9 is more subtle than in newer versions & it passes
            // some versions of this test; make sure not to make it pass there!
            //
            // Support: Firefox 70+
            // Only Firefox includes border widths
            // in computed dimensions. (gh-4529)
            reliableTrDimensions: function reliableTrDimensions() {
                var table, tr, trChild, trStyle;
                if (reliableTrDimensionsVal == null) {
                    table = document.createElement("table");
                    tr = document.createElement("tr");
                    trChild = document.createElement("div");
                    table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                    tr.style.cssText = "box-sizing:content-box;border:1px solid";
                    // Support: Chrome 86+
                    // Height set through cssText does not get applied.
                    // Computed height then comes back as 0.
                    tr.style.height = "1px";
                    trChild.style.height = "9px";
                    // Support: Android 8 Chrome 86+
                    // In our bodyBackground.html iframe,
                    // display for all div elements is set to "inline",
                    // which causes a problem only in Android 8 Chrome 86.
                    // Ensuring the div is `display: block`
                    // gets around this issue.
                    trChild.style.display = "block";
                    documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
                    trStyle = window1.getComputedStyle(tr);
                    reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
                    documentElement.removeChild(table);
                }
                return reliableTrDimensionsVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, isCustomProp = rcustomProp.test(name), // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, trac-12537)
        //   .css('--customProperty) (gh-3144)
        if (computed) {
            // Support: IE <=9 - 11+
            // IE only supports `"float"` in `getPropertyValue`; in computed styles
            // it's only available as `"cssFloat"`. We no longer modify properties
            // sent to `.css()` apart from camelCasing, so we need to check both.
            // Normally, this would create difference in behavior: if
            // `getPropertyValue` returns an empty string, the value returned
            // by `.css()` would be `undefined`. This is usually the case for
            // disconnected elements. However, in IE even disconnected elements
            // with no styles return `"none"` for `getPropertyValue( "float" )`
            ret = computed.getPropertyValue(name) || computed[name];
            if (isCustomProp && ret) // Support: Firefox 105+, Chrome <=105+
            // Spec requires trimming whitespace for custom properties (gh-4926).
            // Firefox only trims leading whitespace. Chrome just collapses
            // both leading & trailing whitespace to a single space.
            //
            // Fall back to `undefined` if empty string returned.
            // This collapses a missing definition with property defined
            // and set to an empty string but there's no standard API
            // allowing us to differentiate them without a performance penalty
            // and returning `undefined` aligns with older jQuery.
            //
            // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
            // as whitespace while CSS does not, but this is not a problem
            // because CSS preprocessing replaces them with U+000A LINE FEED
            // (which *is* CSS whitespace)
            // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
            ret = ret.replace(rtrimCSS, "$1") || undefined;
            if (ret === "" && !isAttached(elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function get() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style, vendorProps = {};
    // Return a vendor-prefixed property or undefined
    function vendorPropName(name) {
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
    function finalPropName(name) {
        var final = jQuery.cssProps[name] || vendorProps[name];
        if (final) return final;
        if (name in emptyStyle) return name;
        return vendorProps[name] = vendorPropName(name) || name;
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    };
    function setPositiveNumber(_elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
        var i = dimension === "width" ? 1 : 0, extra = 0, delta = 0, marginDelta = 0;
        // Adjustment may not be necessary
        if (box === (isBorderBox ? "border" : "content")) return 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin
            // Count margin delta separately to only add it after scroll gutter adjustment.
            // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
            if (box === "margin") marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
            // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
            if (!isBorderBox) {
                // Add padding
                delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "border" or "margin", add border
                if (box !== "padding") delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
                else extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            // If we get here with a border-box (content + padding + border), we're seeking "content" or
            // "padding" or "margin"
            } else {
                // For "content", subtract padding
                if (box === "content") delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // For "content" or "padding", subtract border
                if (box !== "margin") delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        // Account for positive content-box scroll gutter when requested by providing computedVal
        if (!isBorderBox && computedVal >= 0) // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
        // Assuming integer scroll gutter, subtract the rest and round down
        delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5)) || 0;
        return delta + marginDelta;
    }
    function getWidthOrHeight(elem, dimension, extra) {
        // Start with computed style
        var styles = getStyles(elem), // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
        // Fake content-box until we know it's needed to know the true value.
        boxSizingNeeded = !support.boxSizingReliable() || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", valueIsBorderBox = isBorderBox, val = curCSS(elem, dimension, styles), offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);
        // Support: Firefox <=54
        // Return a confounding non-pixel value or feign ignorance, as appropriate.
        if (rnumnonpx.test(val)) {
            if (!extra) return val;
            val = "auto";
        }
        // Support: IE 9 - 11 only
        // Use offsetWidth/offsetHeight for when box sizing is unreliable.
        // In those cases, the computed value can be trusted to be border-box.
        if ((!support.boxSizingReliable() && isBorderBox || // Support: IE 10 - 11+, Edge 15 - 18+
        // IE/Edge misreport `getComputedStyle` of table rows with width/height
        // set in CSS while `offset*` properties report correct values.
        // Interestingly, in some cases IE 9 doesn't suffer from this issue.
        !support.reliableTrDimensions() && nodeName(elem, "tr") || // Fall back to offsetWidth/offsetHeight when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        val === "auto" || // Support: Android <=4.1 - 4.3 only
        // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
        !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") && // Make sure the element is visible & connected
        elem.getClientRects().length) {
            isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
            // Where available, offsetWidth/offsetHeight approximate border box dimensions.
            // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
            // retrieved value as a content box dimension.
            valueIsBorderBox = offsetProp in elem;
            if (valueIsBorderBox) val = elem[offsetProp];
        }
        // Normalize "" and auto
        val = parseFloat(val) || 0;
        // Adjust for the element's box model
        return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles, // Provide the current computed size to request scroll gutter calculation (gh-3589)
        val) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function get(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            animationIterationCount: true,
            aspectRatio: true,
            borderImageSlice: true,
            columnCount: true,
            flexGrow: true,
            flexShrink: true,
            fontWeight: true,
            gridArea: true,
            gridColumn: true,
            gridColumnEnd: true,
            gridColumnStart: true,
            gridRow: true,
            gridRowEnd: true,
            gridRowStart: true,
            lineHeight: true,
            opacity: true,
            order: true,
            orphans: true,
            scale: true,
            widows: true,
            zIndex: true,
            zoom: true,
            // SVG-related
            fillOpacity: true,
            floodOpacity: true,
            stopOpacity: true,
            strokeMiterlimit: true,
            strokeOpacity: true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {},
        // Get and set the style property on a DOM Node
        style: function style(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value === "undefined" ? "undefined" : (0, $dvYFb._)(value);
                // Convert "+=" or "-=" to relative numbers (trac-7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug trac-9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (trac-7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                // "px" to a few hardcoded values.
                if (type === "number" && !isCustomProp) value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function css(elem, name, extra, styles) {
            var val, num, hooks, origName = camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(_i, dimension) {
        jQuery.cssHooks[dimension] = {
            get: function get(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, dimension, extra);
                }) : getWidthOrHeight(elem, dimension, extra);
            },
            set: function set(elem, value, extra) {
                var matches, styles = getStyles(elem), // Only read styles.position if the test has a chance to fail
                // to avoid forcing a reflow.
                scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute", // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                boxSizingNeeded = scrollboxSizeBuggy || extra, isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box", subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;
                // Account for unreliable border-box dimensions by comparing offset* to computed and
                // faking a content-box to get border and padding (gh-3699)
                if (isBorderBox && scrollboxSizeBuggy) subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[dimension] = value;
                    value = jQuery.css(elem, dimension);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function expand(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (prefix !== "margin") jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function css(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function init(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function cur() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function run(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function get(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function set(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function set(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function linear(p) {
            return p;
        },
        swing: function swing(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = Date.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 15
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY and Edge just mirrors
            // the overflowX value there.
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function tick() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function createTween(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function stop(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function tweener(props, callback) {
            if (isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function prefilter(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && (typeof speed === "undefined" ? "undefined" : (0, $dvYFb._)(speed)) === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function fadeTo(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function animate(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function doAnimation() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function stop(type, clearQueue, gotoEnd) {
            var stopQueue = function stopQueue(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function finish(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(_i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = Date.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function attr(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function removeAttr(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function attr(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function set(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function removeAttr(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function set(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(_i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function prop(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function removeProp(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function prop(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function get(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // Use proper attribute retrieval (trac-12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function get(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function set(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    function classesToArray(value) {
        if (Array.isArray(value)) return value;
        if (typeof value === "string") return value.match(rnothtmlwhite) || [];
        return [];
    }
    jQuery.fn.extend({
        addClass: function addClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        if (cur.indexOf(" " + className + " ") < 0) cur += className + " ";
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        removeClass: function removeClass(value) {
            var classNames, cur, curValue, className, i, finalValue;
            if (isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            classNames = classesToArray(value);
            if (classNames.length) return this.each(function() {
                curValue = getClass(this);
                // This expression is here for better compressibility (see addClass)
                cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                if (cur) {
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Remove *all* instances
                        while(cur.indexOf(" " + className + " ") > -1)cur = cur.replace(" " + className + " ", " ");
                    }
                    // Only assign if different to avoid unneeded rendering.
                    finalValue = stripAndCollapse(cur);
                    if (curValue !== finalValue) this.setAttribute("class", finalValue);
                }
            });
            return this;
        },
        toggleClass: function toggleClass(value, stateVal) {
            var classNames, className, i, self, type = typeof value === "undefined" ? "undefined" : (0, $dvYFb._)(value), isValidValue = type === "string" || Array.isArray(value);
            if (isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            if (typeof stateVal === "boolean" && isValidValue) return stateVal ? this.addClass(value) : this.removeClass(value);
            classNames = classesToArray(value);
            return this.each(function() {
                if (isValidValue) {
                    // Toggle individual class names
                    self = jQuery(this);
                    for(i = 0; i < classNames.length; i++){
                        className = classNames[i];
                        // Check each className given, space separated list
                        if (self.hasClass(className)) self.removeClass(className);
                        else self.addClass(className);
                    }
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function hasClass(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function val(value) {
            var hooks, ret, valueIsFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            valueIsFunction = isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (valueIsFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function get(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (trac-14686, trac-14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function get(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (trac-2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function set(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function set(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var location = window1.location;
    var nonce = {
        guid: Date.now()
    };
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml, parserErrorElem;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {}
        parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
        if (!xml || parserErrorElem) jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function(el) {
            return el.textContent;
        }).join("\n") : data));
        return xml;
    };
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/, stopPropagationCallback = function stopPropagationCallback(e) {
        e.stopPropagation();
    };
    jQuery.extend(jQuery.event, {
        trigger: function trigger(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, lastElement, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = lastElement = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, (typeof event === "undefined" ? "undefined" : (0, $dvYFb._)(event)) === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (trac-9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
            if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                lastElement = cur;
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (trac-6170)
                {
                    if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        if (event.isPropagationStopped()) lastElement.addEventListener(type, stopPropagationCallback);
                        elem[type]();
                        if (event.isPropagationStopped()) lastElement.removeEventListener(type, stopPropagationCallback);
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function simulate(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function trigger(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function triggerHandler(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + ((typeof v === "undefined" ? "undefined" : (0, $dvYFb._)(v)) === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && toType(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function add(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        if (a == null) return "";
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function serialize() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(_i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes trac-9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function ajaxSetup(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function ajax(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if ((typeof url === "undefined" ? "undefined" : (0, $dvYFb._)(url)) === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            _$completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function getResponseHeader(key) {
                    var match;
                    if (_$completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                        }
                        match = responseHeaders[key.toLowerCase() + " "];
                    }
                    return match == null ? null : match.join(", ");
                },
                // Raw string
                getAllResponseHeaders: function getAllResponseHeaders() {
                    return _$completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function setRequestHeader(name, value) {
                    if (_$completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function overrideMimeType(type) {
                    if (_$completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function statusCode1(map) {
                    var code;
                    if (map) {
                        if (_$completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function abort(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (trac-10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket trac-12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 15
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (_$completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available and should be processed, append data to url
                if (s.data && (s.processData || typeof s.data === "string")) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // trac-9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || _$completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (_$completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    _$completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (_$completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (_$completed) return;
                _$completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Use a noop converter for missing script but not if jsonp
                if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) s.converters["text script"] = function() {};
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function getJSON(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function getScript(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(_i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery.ajaxPrefilter(function(s) {
        var i;
        for(i in s.headers)if (i.toLowerCase() === "content-type") s.contentType = s.headers[i] || "";
    });
    jQuery._evalUrl = function(url, options, doc) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (trac-11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            // Only evaluate the response if it is successful (gh-4126)
            // dataFilter is not invoked for failure responses, so using it instead
            // of the default converter is kludgy but it works.
            converters: {
                "text script": function() {}
            },
            dataFilter: function dataFilter(response) {
                jQuery.globalEval(response, options, doc);
            }
        });
    };
    jQuery.fn.extend({
        wrapAll: function wrapAll(html) {
            var wrap;
            if (this[0]) {
                if (isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function wrapInner(html) {
            if (isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function wrap(html) {
            var htmlIsFunction = isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function unwrap(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // trac-1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function send(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see trac-8605, trac-14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = xhr.ontimeout = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // trac-14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function abort() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain or forced-by-attrs requests
        if (s.crossDomain || s.scriptAttrs) {
            var script, callback;
            return {
                send: function send(_, complete) {
                    script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function abort() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && (typeof params === "undefined" ? "undefined" : (0, $dvYFb._)(params)) === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function setOffset(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        // offset() relates an element's border box to the document origin
        offset: function offset(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            // Get document-relative position by adding viewport scroll to viewport-relative gBCR
            rect = elem.getBoundingClientRect();
            win = elem.ownerDocument.defaultView;
            return {
                top: rect.top + win.pageYOffset,
                left: rect.left + win.pageXOffset
            };
        },
        // position() relates an element's margin box to its offset parent's padding box
        // This corresponds to the behavior of CSS absolute positioning
        position: function position() {
            if (!this[0]) return;
            var offsetParent, offset, doc, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // position:fixed elements are offset from the viewport, which itself always has zero offset
            if (jQuery.css(elem, "position") === "fixed") // Assume position:fixed implies availability of getBoundingClientRect
            offset = elem.getBoundingClientRect();
            else {
                offset = this.offset();
                // Account for the *real* offset parent, which can be the document or its root element
                // when a statically positioned element is identified
                doc = elem.ownerDocument;
                offsetParent = elem.offsetParent || doc.documentElement;
                while(offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.parentNode;
                if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
                    // Incorporate borders into its offset, since they are outside its content origin
                    parentOffset = jQuery(offsetParent).offset();
                    parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
                    parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
                }
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function offsetParent() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(_i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(_i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.fn.extend({
        bind: function bind(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function unbind(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function delegate(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function undelegate(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        },
        hover: function hover(fnOver, fnOut) {
            return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(_i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    // Require that the "whitespace run" starts from a non-whitespace
    // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
    var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
    // Bind a function to a context, optionally partially applying any
    // arguments.
    // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
    // However, it is not slated for removal any time soon
    jQuery.proxy = function(fn, context) {
        var tmp, args, proxy;
        if (typeof context === "string") {
            tmp = fn[context];
            context = fn;
            fn = tmp;
        }
        // Quick check to determine if target is callable, in the spec
        // this throws a TypeError, but we will just return undefined.
        if (!isFunction(fn)) return undefined;
        // Simulated bind
        args = slice.call(arguments, 2);
        proxy = function proxy() {
            return fn.apply(context || this, args.concat(slice.call(arguments)));
        };
        // Set the guid of unique handler to the same of original handler, so it can be removed
        proxy.guid = fn.guid = fn.guid || jQuery.guid++;
        return proxy;
    };
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    jQuery.isFunction = isFunction;
    jQuery.isWindow = isWindow;
    jQuery.camelCase = camelCase;
    jQuery.type = toType;
    jQuery.now = Date.now;
    jQuery.isNumeric = function(obj) {
        // As of jQuery 3.0, isNumeric is limited to
        // strings and numbers (primitives or objects)
        // that can be coerced to finite numbers (gh-2662)
        var type = jQuery.type(obj);
        return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
        // subtraction forces infinities to NaN
        !isNaN(obj - parseFloat(obj));
    };
    jQuery.trim = function(text) {
        return text == null ? "" : (text + "").replace(rtrim, "$1");
    };
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (trac-13566)
    if (typeof noGlobal === "undefined") window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});
parcelRegister("dvYFb", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $9d6d3a12581f8329$export$71511d61b312f219; });
function $9d6d3a12581f8329$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


// import Bootstrap
/*!
  * Bootstrap v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ function $f35a8e455e15bfdc$export$71511d61b312f219(o) {
    $f35a8e455e15bfdc$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f35a8e455e15bfdc$export$71511d61b312f219(o);
}


function $5ef16d409dbf6610$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($5ef16d409dbf6610$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $611fea1b3c02f9bd$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $dvYFb = parcelRequire("dvYFb");
function $d463395515ae1209$export$71511d61b312f219(self, call) {
    if (call && ((0, $dvYFb._)(call) === "object" || typeof call === "function")) return call;
    return (0, $611fea1b3c02f9bd$export$71511d61b312f219)(self);
}


function $44950fec9206880e$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $f35a8e455e15bfdc$export$71511d61b312f219)(derived);
    return (0, $d463395515ae1209$export$71511d61b312f219)(_this, (0, $5ef16d409dbf6610$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $f35a8e455e15bfdc$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}


function $7417b380464c38c1$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $c546c01220e295dd$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c546c01220e295dd$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $c546c01220e295dd$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c546c01220e295dd$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $6194eebaf067e4d1$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}



function $8321f30be5858bc3$export$71511d61b312f219(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $f35a8e455e15bfdc$export$71511d61b312f219)(object);
        if (object === null) break;
    }
    return object;
}


function $c10a0453d6c10b57$export$71511d61b312f219(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $c10a0453d6c10b57$export$71511d61b312f219 = Reflect.get;
    else $c10a0453d6c10b57$export$71511d61b312f219 = function get(target, property, receiver) {
        var base = (0, $8321f30be5858bc3$export$71511d61b312f219)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $c10a0453d6c10b57$export$71511d61b312f219(target, property, receiver || target);
}



function $0b881900a1aeb6fe$export$71511d61b312f219(o, p) {
    $0b881900a1aeb6fe$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $0b881900a1aeb6fe$export$71511d61b312f219(o, p);
}


function $cdf6b0397ffac486$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $0b881900a1aeb6fe$export$71511d61b312f219)(subClass, superClass);
}



function $d33814db45cf8e23$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $6194eebaf067e4d1$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $234c1bbf5d6bbebf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $234c1bbf5d6bbebf$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $234c1bbf5d6bbebf$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}



function $3920012f9e49ab68$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $bcdbcb6c4078a936$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $2442b555ac3dc2d8$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $67fa0ccdaa4347f0$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $1f1189da1ae074e0$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $67fa0ccdaa4347f0$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $67fa0ccdaa4347f0$export$71511d61b312f219)(o, minLen);
}


function $db95b225ee8036d6$export$71511d61b312f219(arr, i) {
    return (0, $3920012f9e49ab68$export$71511d61b312f219)(arr) || (0, $bcdbcb6c4078a936$export$71511d61b312f219)(arr, i) || (0, $1f1189da1ae074e0$export$71511d61b312f219)(arr, i) || (0, $2442b555ac3dc2d8$export$71511d61b312f219)();
}



function $a185b452d3e253f6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $67fa0ccdaa4347f0$export$71511d61b312f219)(arr);
}


function $c7ccf52f37db4126$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


function $e9429c1bd6fe93fb$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}



function $eb3e8a8ee265ba96$export$71511d61b312f219(arr) {
    return (0, $a185b452d3e253f6$export$71511d61b312f219)(arr) || (0, $c7ccf52f37db4126$export$71511d61b312f219)(arr) || (0, $1f1189da1ae074e0$export$71511d61b312f219)(arr) || (0, $e9429c1bd6fe93fb$export$71511d61b312f219)();
}



var $dvYFb = parcelRequire("dvYFb");
var $d61ef8003b796318$exports = {};

$parcel$export($d61ef8003b796318$exports, "popperGenerator", function () { return $29c697c1d55e87ca$export$ed5e13716264f202; });
$parcel$export($d61ef8003b796318$exports, "detectOverflow", function () { return $8ef048dc1a2ef86d$export$2e2bcd8739ae039; });
$parcel$export($d61ef8003b796318$exports, "createPopperBase", function () { return $29c697c1d55e87ca$export$8f7491d57c8f97a9; });
$parcel$export($d61ef8003b796318$exports, "createPopper", function () { return $f0ba3bf3fb8501ef$export$8f7491d57c8f97a9; });
$parcel$export($d61ef8003b796318$exports, "createPopperLite", function () { return $bdeb9e4d8ea7364b$export$8f7491d57c8f97a9; });
var $4098656b2955b164$exports = {};

$parcel$export($4098656b2955b164$exports, "top", function () { return $4098656b2955b164$export$1e95b668f3b82d; });
$parcel$export($4098656b2955b164$exports, "bottom", function () { return $4098656b2955b164$export$40e543e69a8b3fbb; });
$parcel$export($4098656b2955b164$exports, "right", function () { return $4098656b2955b164$export$79ffe56a765070d2; });
$parcel$export($4098656b2955b164$exports, "left", function () { return $4098656b2955b164$export$eabcd2c8791e7bf4; });
$parcel$export($4098656b2955b164$exports, "auto", function () { return $4098656b2955b164$export$dfb5619354ba860; });
$parcel$export($4098656b2955b164$exports, "basePlacements", function () { return $4098656b2955b164$export$aec2ce47c367b8c3; });
$parcel$export($4098656b2955b164$exports, "start", function () { return $4098656b2955b164$export$b3571188c770cc5a; });
$parcel$export($4098656b2955b164$exports, "end", function () { return $4098656b2955b164$export$bd5df0f255a350f8; });
$parcel$export($4098656b2955b164$exports, "clippingParents", function () { return $4098656b2955b164$export$390fd549c5303b4d; });
$parcel$export($4098656b2955b164$exports, "viewport", function () { return $4098656b2955b164$export$d7b7311ec04a3e8f; });
$parcel$export($4098656b2955b164$exports, "popper", function () { return $4098656b2955b164$export$ae5ab1c730825774; });
$parcel$export($4098656b2955b164$exports, "reference", function () { return $4098656b2955b164$export$ca50aac9f3ba507f; });
$parcel$export($4098656b2955b164$exports, "variationPlacements", function () { return $4098656b2955b164$export$368f9a87e87fa4e1; });
$parcel$export($4098656b2955b164$exports, "placements", function () { return $4098656b2955b164$export$803cd8101b6c182b; });
$parcel$export($4098656b2955b164$exports, "beforeRead", function () { return $4098656b2955b164$export$421679a7c3d56e; });
$parcel$export($4098656b2955b164$exports, "read", function () { return $4098656b2955b164$export$aafa59e2e03f2942; });
$parcel$export($4098656b2955b164$exports, "afterRead", function () { return $4098656b2955b164$export$6964f6c886723980; });
$parcel$export($4098656b2955b164$exports, "beforeMain", function () { return $4098656b2955b164$export$c65e99957a05207c; });
$parcel$export($4098656b2955b164$exports, "main", function () { return $4098656b2955b164$export$f22da7240b7add18; });
$parcel$export($4098656b2955b164$exports, "afterMain", function () { return $4098656b2955b164$export$bab79516f2d662fe; });
$parcel$export($4098656b2955b164$exports, "beforeWrite", function () { return $4098656b2955b164$export$8d4d2d70e7d46032; });
$parcel$export($4098656b2955b164$exports, "write", function () { return $4098656b2955b164$export$68d8715fc104d294; });
$parcel$export($4098656b2955b164$exports, "afterWrite", function () { return $4098656b2955b164$export$70a6e5159acce2e6; });
$parcel$export($4098656b2955b164$exports, "modifierPhases", function () { return $4098656b2955b164$export$d087d3878fdf71d5; });
var $4098656b2955b164$export$1e95b668f3b82d = 'top';
var $4098656b2955b164$export$40e543e69a8b3fbb = 'bottom';
var $4098656b2955b164$export$79ffe56a765070d2 = 'right';
var $4098656b2955b164$export$eabcd2c8791e7bf4 = 'left';
var $4098656b2955b164$export$dfb5619354ba860 = 'auto';
var $4098656b2955b164$export$aec2ce47c367b8c3 = [
    $4098656b2955b164$export$1e95b668f3b82d,
    $4098656b2955b164$export$40e543e69a8b3fbb,
    $4098656b2955b164$export$79ffe56a765070d2,
    $4098656b2955b164$export$eabcd2c8791e7bf4
];
var $4098656b2955b164$export$b3571188c770cc5a = 'start';
var $4098656b2955b164$export$bd5df0f255a350f8 = 'end';
var $4098656b2955b164$export$390fd549c5303b4d = 'clippingParents';
var $4098656b2955b164$export$d7b7311ec04a3e8f = 'viewport';
var $4098656b2955b164$export$ae5ab1c730825774 = 'popper';
var $4098656b2955b164$export$ca50aac9f3ba507f = 'reference';
var $4098656b2955b164$export$368f9a87e87fa4e1 = /*#__PURE__*/ $4098656b2955b164$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $4098656b2955b164$export$b3571188c770cc5a,
        placement + "-" + $4098656b2955b164$export$bd5df0f255a350f8
    ]);
}, []);
var $4098656b2955b164$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($4098656b2955b164$export$aec2ce47c367b8c3, [
    $4098656b2955b164$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $4098656b2955b164$export$b3571188c770cc5a,
        placement + "-" + $4098656b2955b164$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $4098656b2955b164$export$421679a7c3d56e = 'beforeRead';
var $4098656b2955b164$export$aafa59e2e03f2942 = 'read';
var $4098656b2955b164$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $4098656b2955b164$export$c65e99957a05207c = 'beforeMain';
var $4098656b2955b164$export$f22da7240b7add18 = 'main';
var $4098656b2955b164$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $4098656b2955b164$export$8d4d2d70e7d46032 = 'beforeWrite';
var $4098656b2955b164$export$68d8715fc104d294 = 'write';
var $4098656b2955b164$export$70a6e5159acce2e6 = 'afterWrite';
var $4098656b2955b164$export$d087d3878fdf71d5 = [
    $4098656b2955b164$export$421679a7c3d56e,
    $4098656b2955b164$export$aafa59e2e03f2942,
    $4098656b2955b164$export$6964f6c886723980,
    $4098656b2955b164$export$c65e99957a05207c,
    $4098656b2955b164$export$f22da7240b7add18,
    $4098656b2955b164$export$bab79516f2d662fe,
    $4098656b2955b164$export$8d4d2d70e7d46032,
    $4098656b2955b164$export$68d8715fc104d294,
    $4098656b2955b164$export$70a6e5159acce2e6
];


var $4df56e8a75efbd07$exports = {};

$parcel$export($4df56e8a75efbd07$exports, "applyStyles", function () { return $ed8e88be0eb3743a$export$2e2bcd8739ae039; });
$parcel$export($4df56e8a75efbd07$exports, "arrow", function () { return $43a34fad1f81bb6d$export$2e2bcd8739ae039; });
$parcel$export($4df56e8a75efbd07$exports, "computeStyles", function () { return $3893e9dbf96237c4$export$2e2bcd8739ae039; });
$parcel$export($4df56e8a75efbd07$exports, "eventListeners", function () { return $2def0c61bad17d2b$export$2e2bcd8739ae039; });
$parcel$export($4df56e8a75efbd07$exports, "flip", function () { return $6114a1be128deafa$export$2e2bcd8739ae039; });
$parcel$export($4df56e8a75efbd07$exports, "hide", function () { return $bc3de2222c85b67d$export$2e2bcd8739ae039; });
$parcel$export($4df56e8a75efbd07$exports, "offset", function () { return $458d6de7580ce6b5$export$2e2bcd8739ae039; });
$parcel$export($4df56e8a75efbd07$exports, "popperOffsets", function () { return $8cd9ebd489eeeba0$export$2e2bcd8739ae039; });
$parcel$export($4df56e8a75efbd07$exports, "preventOverflow", function () { return $aae07ef240d2dd24$export$2e2bcd8739ae039; });
function $bb3772a97e409184$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}


function $dc0b7c05726de722$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $067f46365fa069fe$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $067f46365fa069fe$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $067f46365fa069fe$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


// and applies them to the HTMLElements such as popper and arrow
function $ed8e88be0eb3743a$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element) || !(0, $bb3772a97e409184$export$2e2bcd8739ae039)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? '' : value);
        });
    });
}
function $ed8e88be0eb3743a$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: '0',
            top: '0',
            margin: '0'
        },
        arrow: {
            position: 'absolute'
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = '';
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element) || !(0, $bb3772a97e409184$export$2e2bcd8739ae039)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $ed8e88be0eb3743a$export$2e2bcd8739ae039 = {
    name: 'applyStyles',
    enabled: true,
    phase: 'write',
    fn: $ed8e88be0eb3743a$var$applyStyles,
    effect: $ed8e88be0eb3743a$var$effect,
    requires: [
        'computeStyles'
    ]
};



function $80412d06b7a84ca2$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}



var $9f26897deb02d93b$export$8960430cfd85939f = Math.max;
var $9f26897deb02d93b$export$96ec731ed4dcb222 = Math.min;
var $9f26897deb02d93b$export$2077e0241d6afd3c = Math.round;



function $fad1410a0ea124b9$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $5d459bcfdac1eddb$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $fad1410a0ea124b9$export$2e2bcd8739ae039)());
}


function $cfa3bbbe93337bd1$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(element) ? (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $5d459bcfdac1eddb$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $7c647f2d888a0b83$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $0c9e96e527df5368$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $067f46365fa069fe$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}





function $9e057dbbdba645c7$export$2e2bcd8739ae039(element) {
    return (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $6154ba4d4a24ebce$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $bb3772a97e409184$export$2e2bcd8739ae039)(element)) >= 0;
}




function $fcab88e4d39bd8b4$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $50e0f579e4b2a308$export$2e2bcd8739ae039(element) {
    if ((0, $bb3772a97e409184$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $067f46365fa069fe$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $625fab30081d2448$var$getTrueOffsetParent(element) {
    if (!(0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $625fab30081d2448$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $fad1410a0ea124b9$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $fad1410a0ea124b9$export$2e2bcd8739ae039)());
    if (isIE && (0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $50e0f579e4b2a308$export$2e2bcd8739ae039)(element);
    if ((0, $067f46365fa069fe$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $067f46365fa069fe$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $bb3772a97e409184$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $625fab30081d2448$export$2e2bcd8739ae039(element) {
    var window = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(element);
    var offsetParent = $625fab30081d2448$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $6154ba4d4a24ebce$export$2e2bcd8739ae039)(offsetParent) && (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $625fab30081d2448$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $bb3772a97e409184$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $bb3772a97e409184$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $625fab30081d2448$var$getContainingBlock(element) || window;
}


function $c5e9945532622584$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $5073f6077b368081$export$f28d906d67a997f3(min, value, max) {
    return (0, $9f26897deb02d93b$export$8960430cfd85939f)(min, (0, $9f26897deb02d93b$export$96ec731ed4dcb222)(value, max));
}
function $5073f6077b368081$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $5073f6077b368081$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $ccf353a84ccd5d0e$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $902788756916d769$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $ccf353a84ccd5d0e$export$2e2bcd8739ae039)(), paddingObject);
}


function $4aac45be6d8d440e$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}



var $43a34fad1f81bb6d$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $902788756916d769$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4aac45be6d8d440e$export$2e2bcd8739ae039)(padding, (0, $4098656b2955b164$export$aec2ce47c367b8c3)));
};
function $43a34fad1f81bb6d$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $c5e9945532622584$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $4098656b2955b164$export$eabcd2c8791e7bf4),
        (0, $4098656b2955b164$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $43a34fad1f81bb6d$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $7c647f2d888a0b83$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $4098656b2955b164$export$1e95b668f3b82d) : (0, $4098656b2955b164$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $4098656b2955b164$export$40e543e69a8b3fbb) : (0, $4098656b2955b164$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $625fab30081d2448$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $5073f6077b368081$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $43a34fad1f81bb6d$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $0c9e96e527df5368$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $43a34fad1f81bb6d$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $43a34fad1f81bb6d$var$arrow,
    effect: $43a34fad1f81bb6d$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $bc1371cbec6dec03$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $3893e9dbf96237c4$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3893e9dbf96237c4$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $3893e9dbf96237c4$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $4098656b2955b164$export$eabcd2c8791e7bf4);
    var sideY = (0, $4098656b2955b164$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $625fab30081d2448$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(popper);
            if ((0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $4098656b2955b164$export$1e95b668f3b82d) || (placement === (0, $4098656b2955b164$export$eabcd2c8791e7bf4) || placement === (0, $4098656b2955b164$export$79ffe56a765070d2)) && variation === (0, $4098656b2955b164$export$bd5df0f255a350f8)) {
            sideY = (0, $4098656b2955b164$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $4098656b2955b164$export$eabcd2c8791e7bf4) || (placement === (0, $4098656b2955b164$export$1e95b668f3b82d) || placement === (0, $4098656b2955b164$export$40e543e69a8b3fbb)) && variation === (0, $4098656b2955b164$export$bd5df0f255a350f8)) {
            sideX = (0, $4098656b2955b164$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3893e9dbf96237c4$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3893e9dbf96237c4$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $3893e9dbf96237c4$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3893e9dbf96237c4$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3893e9dbf96237c4$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3893e9dbf96237c4$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $3893e9dbf96237c4$var$computeStyles,
    data: {}
};



var $2def0c61bad17d2b$var$passive = {
    passive: true
};
function $2def0c61bad17d2b$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $2def0c61bad17d2b$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $2def0c61bad17d2b$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $2def0c61bad17d2b$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $2def0c61bad17d2b$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $2def0c61bad17d2b$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $2def0c61bad17d2b$var$effect,
    data: {}
};


var $50c1cba17513c010$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $50c1cba17513c010$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $50c1cba17513c010$var$hash[matched];
    });
}



var $ddb6289923396499$var$hash = {
    start: 'end',
    end: 'start'
};
function $ddb6289923396499$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $ddb6289923396499$var$hash[matched];
    });
}








function $73efdde3871f9d9c$export$2e2bcd8739ae039(node) {
    var win = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $d871a90b7e33d329$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)((0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(element)).left + (0, $73efdde3871f9d9c$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $b18aaddf90a7a585$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(element);
    var html = (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $5d459bcfdac1eddb$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $d871a90b7e33d329$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $6575f0ee16188e63$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $73efdde3871f9d9c$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $9f26897deb02d93b$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $9f26897deb02d93b$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $d871a90b7e33d329$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $9f26897deb02d93b$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $05730bb1bbcd8823$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $6ee19e0b9f6a7cde$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $bb3772a97e409184$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $067f46365fa069fe$export$1b3bfaa9684536aa)(node) && (0, $05730bb1bbcd8823$export$2e2bcd8739ae039)(node)) return node;
    return $6ee19e0b9f6a7cde$export$2e2bcd8739ae039((0, $50e0f579e4b2a308$export$2e2bcd8739ae039)(node));
}





function $fc5ee93a8c241eee$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $6ee19e0b9f6a7cde$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $05730bb1bbcd8823$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($fc5ee93a8c241eee$export$2e2bcd8739ae039((0, $50e0f579e4b2a308$export$2e2bcd8739ae039)(target)));
}










function $d1dfd81a90e1618f$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $79a5624379259815$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $79a5624379259815$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $4098656b2955b164$export$d7b7311ec04a3e8f) ? (0, $d1dfd81a90e1618f$export$2e2bcd8739ae039)((0, $b18aaddf90a7a585$export$2e2bcd8739ae039)(element, strategy)) : (0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(clippingParent) ? $79a5624379259815$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $d1dfd81a90e1618f$export$2e2bcd8739ae039)((0, $6575f0ee16188e63$export$2e2bcd8739ae039)((0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $79a5624379259815$var$getClippingParents(element) {
    var clippingParents = (0, $fc5ee93a8c241eee$export$2e2bcd8739ae039)((0, $50e0f579e4b2a308$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $9e057dbbdba645c7$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $067f46365fa069fe$export$1b3bfaa9684536aa)(element) ? (0, $625fab30081d2448$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(clippingParent) && (0, $0c9e96e527df5368$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $bb3772a97e409184$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $79a5624379259815$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $79a5624379259815$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $79a5624379259815$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $9f26897deb02d93b$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $9f26897deb02d93b$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $9f26897deb02d93b$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $9f26897deb02d93b$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $79a5624379259815$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $964dc21e1f81b7e4$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $4098656b2955b164$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $4098656b2955b164$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $4098656b2955b164$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $4098656b2955b164$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $c5e9945532622584$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $4098656b2955b164$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $4098656b2955b164$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $8ef048dc1a2ef86d$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $4098656b2955b164$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $4098656b2955b164$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $4098656b2955b164$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $902788756916d769$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $4aac45be6d8d440e$export$2e2bcd8739ae039)(padding, (0, $4098656b2955b164$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $4098656b2955b164$export$ae5ab1c730825774) ? (0, $4098656b2955b164$export$ca50aac9f3ba507f) : (0, $4098656b2955b164$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $79a5624379259815$export$2e2bcd8739ae039)((0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $964dc21e1f81b7e4$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $d1dfd81a90e1618f$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $4098656b2955b164$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $4098656b2955b164$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $4098656b2955b164$export$79ffe56a765070d2),
                (0, $4098656b2955b164$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $4098656b2955b164$export$1e95b668f3b82d),
                (0, $4098656b2955b164$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $15f823052b9188e0$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $4098656b2955b164$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $4098656b2955b164$export$368f9a87e87fa4e1) : (0, $4098656b2955b164$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $4098656b2955b164$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $8ef048dc1a2ef86d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $6114a1be128deafa$var$getExpandedFallbackPlacements(placement) {
    if ((0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement) === (0, $4098656b2955b164$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $50c1cba17513c010$export$2e2bcd8739ae039)(placement);
    return [
        (0, $ddb6289923396499$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $ddb6289923396499$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $6114a1be128deafa$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $50c1cba17513c010$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $6114a1be128deafa$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement) === (0, $4098656b2955b164$export$dfb5619354ba860) ? (0, $15f823052b9188e0$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(placement) === (0, $4098656b2955b164$export$b3571188c770cc5a);
        var isVertical = [
            (0, $4098656b2955b164$export$1e95b668f3b82d),
            (0, $4098656b2955b164$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $8ef048dc1a2ef86d$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $4098656b2955b164$export$79ffe56a765070d2) : (0, $4098656b2955b164$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $4098656b2955b164$export$40e543e69a8b3fbb) : (0, $4098656b2955b164$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $50c1cba17513c010$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $50c1cba17513c010$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $6114a1be128deafa$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $6114a1be128deafa$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $bc3de2222c85b67d$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $bc3de2222c85b67d$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $4098656b2955b164$export$1e95b668f3b82d),
        (0, $4098656b2955b164$export$79ffe56a765070d2),
        (0, $4098656b2955b164$export$40e543e69a8b3fbb),
        (0, $4098656b2955b164$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $bc3de2222c85b67d$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $8ef048dc1a2ef86d$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $8ef048dc1a2ef86d$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $bc3de2222c85b67d$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $bc3de2222c85b67d$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $bc3de2222c85b67d$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $bc3de2222c85b67d$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $bc3de2222c85b67d$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $bc3de2222c85b67d$var$hide
};




function $458d6de7580ce6b5$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $4098656b2955b164$export$eabcd2c8791e7bf4),
        (0, $4098656b2955b164$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $4098656b2955b164$export$eabcd2c8791e7bf4),
        (0, $4098656b2955b164$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $458d6de7580ce6b5$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $4098656b2955b164$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $458d6de7580ce6b5$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $458d6de7580ce6b5$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $458d6de7580ce6b5$var$offset
};



function $8cd9ebd489eeeba0$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $964dc21e1f81b7e4$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $8cd9ebd489eeeba0$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $8cd9ebd489eeeba0$var$popperOffsets,
    data: {}
};





function $1540d72155215430$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $aae07ef240d2dd24$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $8ef048dc1a2ef86d$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $80412d06b7a84ca2$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $bc1371cbec6dec03$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $c5e9945532622584$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $1540d72155215430$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $4098656b2955b164$export$1e95b668f3b82d) : (0, $4098656b2955b164$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $4098656b2955b164$export$40e543e69a8b3fbb) : (0, $4098656b2955b164$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $4098656b2955b164$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $4098656b2955b164$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $7c647f2d888a0b83$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $ccf353a84ccd5d0e$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $5073f6077b368081$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $625fab30081d2448$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $5073f6077b368081$export$f28d906d67a997f3)(tether ? (0, $9f26897deb02d93b$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $9f26897deb02d93b$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $4098656b2955b164$export$1e95b668f3b82d) : (0, $4098656b2955b164$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $4098656b2955b164$export$40e543e69a8b3fbb) : (0, $4098656b2955b164$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $4098656b2955b164$export$1e95b668f3b82d),
            (0, $4098656b2955b164$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $5073f6077b368081$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $5073f6077b368081$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $aae07ef240d2dd24$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $aae07ef240d2dd24$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};








function $e7d32fdb97c3afe8$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $d4580a5cb061b013$export$2e2bcd8739ae039(node) {
    if (node === (0, $dc0b7c05726de722$export$2e2bcd8739ae039)(node) || !(0, $067f46365fa069fe$export$1b3bfaa9684536aa)(node)) return (0, $73efdde3871f9d9c$export$2e2bcd8739ae039)(node);
    else return (0, $e7d32fdb97c3afe8$export$2e2bcd8739ae039)(node);
}








function $3745518cf5d078fb$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $9f26897deb02d93b$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $3745518cf5d078fb$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $067f46365fa069fe$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $067f46365fa069fe$export$1b3bfaa9684536aa)(offsetParent) && $3745518cf5d078fb$var$isElementScaled(offsetParent);
    var documentElement = (0, $fcab88e4d39bd8b4$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $bb3772a97e409184$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $05730bb1bbcd8823$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $d4580a5cb061b013$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $067f46365fa069fe$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $cfa3bbbe93337bd1$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $d871a90b7e33d329$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $f774b12ee628c024$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $f774b12ee628c024$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $f774b12ee628c024$var$order(modifiers); // order based on phase
    return (0, $4098656b2955b164$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $7746e2758afef0df$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $c3f1a0406e083cd0$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $29c697c1d55e87ca$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $29c697c1d55e87ca$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $29c697c1d55e87ca$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $29c697c1d55e87ca$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $29c697c1d55e87ca$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $067f46365fa069fe$export$45a5e7f76e0caa8d)(reference) ? (0, $fc5ee93a8c241eee$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $fc5ee93a8c241eee$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $fc5ee93a8c241eee$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $f774b12ee628c024$export$2e2bcd8739ae039)((0, $c3f1a0406e083cd0$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$29c697c1d55e87ca$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $3745518cf5d078fb$export$2e2bcd8739ae039)(_$reference, (0, $625fab30081d2448$export$2e2bcd8739ae039)(_$popper), state.options.strategy === 'fixed'),
                    popper: (0, $7c647f2d888a0b83$export$2e2bcd8739ae039)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $7746e2758afef0df$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$29c697c1d55e87ca$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $29c697c1d55e87ca$export$8f7491d57c8f97a9 = /*#__PURE__*/ $29c697c1d55e87ca$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules














var $f0ba3bf3fb8501ef$export$d34966752335dd47 = [
    (0, $2def0c61bad17d2b$export$2e2bcd8739ae039),
    (0, $8cd9ebd489eeeba0$export$2e2bcd8739ae039),
    (0, $3893e9dbf96237c4$export$2e2bcd8739ae039),
    (0, $ed8e88be0eb3743a$export$2e2bcd8739ae039),
    (0, $458d6de7580ce6b5$export$2e2bcd8739ae039),
    (0, $6114a1be128deafa$export$2e2bcd8739ae039),
    (0, $aae07ef240d2dd24$export$2e2bcd8739ae039),
    (0, $43a34fad1f81bb6d$export$2e2bcd8739ae039),
    (0, $bc3de2222c85b67d$export$2e2bcd8739ae039)
];
var $f0ba3bf3fb8501ef$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $29c697c1d55e87ca$export$ed5e13716264f202)({
    defaultModifiers: $f0ba3bf3fb8501ef$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules







var $bdeb9e4d8ea7364b$export$d34966752335dd47 = [
    (0, $2def0c61bad17d2b$export$2e2bcd8739ae039),
    (0, $8cd9ebd489eeeba0$export$2e2bcd8739ae039),
    (0, $3893e9dbf96237c4$export$2e2bcd8739ae039),
    (0, $ed8e88be0eb3743a$export$2e2bcd8739ae039)
];
var $bdeb9e4d8ea7364b$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $29c697c1d55e87ca$export$ed5e13716264f202)({
    defaultModifiers: $bdeb9e4d8ea7364b$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules


$parcel$exportWildcard($d61ef8003b796318$exports, $4098656b2955b164$exports);
$parcel$exportWildcard($d61ef8003b796318$exports, $4df56e8a75efbd07$exports);


/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/data.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$elementMap = new Map();
var $834ee70cc5b953d1$var$Data = {
    set: function(element, key, instance) {
        if (!$834ee70cc5b953d1$var$elementMap.has(element)) $834ee70cc5b953d1$var$elementMap.set(element, new Map());
        var instanceMap = $834ee70cc5b953d1$var$elementMap.get(element);
        // make it clear we only want one instance per element
        // can be removed later when multiple key/instances are fine to be used
        if (!instanceMap.has(key) && instanceMap.size !== 0) {
            // eslint-disable-next-line no-console
            console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
            return;
        }
        instanceMap.set(key, instance);
    },
    get: function(element, key) {
        if ($834ee70cc5b953d1$var$elementMap.has(element)) return $834ee70cc5b953d1$var$elementMap.get(element).get(key) || null;
        return null;
    },
    remove: function(element, key) {
        if (!$834ee70cc5b953d1$var$elementMap.has(element)) return;
        var instanceMap = $834ee70cc5b953d1$var$elementMap.get(element);
        instanceMap.delete(key);
        // free up element references if there are no instances left for an element
        if (instanceMap.size === 0) $834ee70cc5b953d1$var$elementMap.delete(element);
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/index.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $834ee70cc5b953d1$var$MAX_UID = 1000000;
var $834ee70cc5b953d1$var$MILLISECONDS_MULTIPLIER = 1000;
var $834ee70cc5b953d1$var$TRANSITION_END = 'transitionend';
/**
 * Properly escape IDs selectors to handle weird IDs
 * @param {string} selector
 * @returns {string}
 */ var $834ee70cc5b953d1$var$parseSelector = function(selector) {
    if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
    selector = selector.replace(/#([^\s"#']+)/g, function(match, id) {
        return "#".concat(CSS.escape(id));
    });
    return selector;
};
// Shout-out Angus Croll (https://goo.gl/pxwQGp)
var $834ee70cc5b953d1$var$toType = function(object) {
    if (object === null || object === undefined) return "".concat(object);
    return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
};
/**
 * Public Util API
 */ var $834ee70cc5b953d1$var$getUID = function(prefix) {
    do prefix += Math.floor(Math.random() * $834ee70cc5b953d1$var$MAX_UID);
    while (document.getElementById(prefix));
    return prefix;
};
var $834ee70cc5b953d1$var$getTransitionDurationFromElement = function(element) {
    if (!element) return 0;
    // Get transition-duration of the element
    var _window_getComputedStyle = window.getComputedStyle(element), transitionDuration = _window_getComputedStyle.transitionDuration, transitionDelay = _window_getComputedStyle.transitionDelay;
    var floatTransitionDuration = Number.parseFloat(transitionDuration);
    var floatTransitionDelay = Number.parseFloat(transitionDelay);
    // Return 0 if element or transition duration is not found
    if (!floatTransitionDuration && !floatTransitionDelay) return 0;
    // If multiple durations are defined, take the first
    transitionDuration = transitionDuration.split(',')[0];
    transitionDelay = transitionDelay.split(',')[0];
    return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * $834ee70cc5b953d1$var$MILLISECONDS_MULTIPLIER;
};
var $834ee70cc5b953d1$var$triggerTransitionEnd = function(element) {
    element.dispatchEvent(new Event($834ee70cc5b953d1$var$TRANSITION_END));
};
var $834ee70cc5b953d1$var$isElement = function(object) {
    if (!object || (typeof object === "undefined" ? "undefined" : (0, $dvYFb._)(object)) !== 'object') return false;
    if (typeof object.jquery !== 'undefined') object = object[0];
    return typeof object.nodeType !== 'undefined';
};
var $834ee70cc5b953d1$var$getElement = function(object) {
    // it's a jQuery object or a node element
    if ($834ee70cc5b953d1$var$isElement(object)) return object.jquery ? object[0] : object;
    if (typeof object === 'string' && object.length > 0) return document.querySelector($834ee70cc5b953d1$var$parseSelector(object));
    return null;
};
var $834ee70cc5b953d1$var$isVisible = function(element) {
    if (!$834ee70cc5b953d1$var$isElement(element) || element.getClientRects().length === 0) return false;
    var elementIsVisible = getComputedStyle(element).getPropertyValue('visibility') === 'visible';
    // Handle `details` element as its content may falsie appear visible when it is closed
    var closedDetails = element.closest('details:not([open])');
    if (!closedDetails) return elementIsVisible;
    if (closedDetails !== element) {
        var summary = element.closest('summary');
        if (summary && summary.parentNode !== closedDetails) return false;
        if (summary === null) return false;
    }
    return elementIsVisible;
};
var $834ee70cc5b953d1$var$isDisabled = function(element) {
    if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
    if (element.classList.contains('disabled')) return true;
    if (typeof element.disabled !== 'undefined') return element.disabled;
    return element.hasAttribute('disabled') && element.getAttribute('disabled') !== 'false';
};
var $834ee70cc5b953d1$var$findShadowRoot = function(element) {
    if (!document.documentElement.attachShadow) return null;
    // Can find the shadow root otherwise it'll return the document
    if (typeof element.getRootNode === 'function') {
        var root = element.getRootNode();
        return root instanceof ShadowRoot ? root : null;
    }
    if (element instanceof ShadowRoot) return element;
    // when we don't find a shadow root
    if (!element.parentNode) return null;
    return $834ee70cc5b953d1$var$findShadowRoot(element.parentNode);
};
var $834ee70cc5b953d1$var$noop = function() {};
/**
 * Trick to restart an element's animation
 *
 * @param {HTMLElement} element
 * @return void
 *
 * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
 */ var $834ee70cc5b953d1$var$reflow = function(element) {
    element.offsetHeight; // eslint-disable-line no-unused-expressions
};
var $834ee70cc5b953d1$var$getjQuery = function() {
    if (window.jQuery && !document.body.hasAttribute('data-bs-no-jquery')) return window.jQuery;
    return null;
};
var $834ee70cc5b953d1$var$DOMContentLoadedCallbacks = [];
var $834ee70cc5b953d1$var$onDOMContentLoaded = function(callback) {
    if (document.readyState === 'loading') {
        // add listener on the first call when the document is in loading state
        if (!$834ee70cc5b953d1$var$DOMContentLoadedCallbacks.length) document.addEventListener('DOMContentLoaded', function() {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = $834ee70cc5b953d1$var$DOMContentLoadedCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$callback = _step.value;
                    _$callback();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        $834ee70cc5b953d1$var$DOMContentLoadedCallbacks.push(callback);
    } else callback();
};
var $834ee70cc5b953d1$var$isRTL = function() {
    return document.documentElement.dir === 'rtl';
};
var $834ee70cc5b953d1$var$defineJQueryPlugin = function(plugin) {
    $834ee70cc5b953d1$var$onDOMContentLoaded(function() {
        var $ = $834ee70cc5b953d1$var$getjQuery();
        /* istanbul ignore if */ if ($) {
            var name = plugin.NAME;
            var JQUERY_NO_CONFLICT = $.fn[name];
            $.fn[name] = plugin.jQueryInterface;
            $.fn[name].Constructor = plugin;
            $.fn[name].noConflict = function() {
                $.fn[name] = JQUERY_NO_CONFLICT;
                return plugin.jQueryInterface;
            };
        }
    });
};
var $834ee70cc5b953d1$var$execute = function(possibleCallback) {
    var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : possibleCallback;
    return typeof possibleCallback === 'function' ? possibleCallback.apply(void 0, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(args)) : defaultValue;
};
var $834ee70cc5b953d1$var$executeAfterTransition = function(callback, transitionElement) {
    var waitForTransition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    if (!waitForTransition) {
        $834ee70cc5b953d1$var$execute(callback);
        return;
    }
    var durationPadding = 5;
    var emulatedDuration = $834ee70cc5b953d1$var$getTransitionDurationFromElement(transitionElement) + durationPadding;
    var called = false;
    var handler = function(param) {
        var target = param.target;
        if (target !== transitionElement) return;
        called = true;
        transitionElement.removeEventListener($834ee70cc5b953d1$var$TRANSITION_END, handler);
        $834ee70cc5b953d1$var$execute(callback);
    };
    transitionElement.addEventListener($834ee70cc5b953d1$var$TRANSITION_END, handler);
    setTimeout(function() {
        if (!called) $834ee70cc5b953d1$var$triggerTransitionEnd(transitionElement);
    }, emulatedDuration);
};
/**
 * Return the previous/next element of a list.
 *
 * @param {array} list    The list of elements
 * @param activeElement   The active element
 * @param shouldGetNext   Choose to get next or previous element
 * @param isCycleAllowed
 * @return {Element|elem} The proper element
 */ var $834ee70cc5b953d1$var$getNextActiveElement = function(list, activeElement, shouldGetNext, isCycleAllowed) {
    var listLength = list.length;
    var index = list.indexOf(activeElement);
    // if the element does not exist in the list return an element
    // depending on the direction and if cycle is allowed
    if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
    index += shouldGetNext ? 1 : -1;
    if (isCycleAllowed) index = (index + listLength) % listLength;
    return list[Math.max(0, Math.min(index, listLength - 1))];
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/event-handler.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$namespaceRegex = /[^.]*(?=\..*)\.|.*/;
var $834ee70cc5b953d1$var$stripNameRegex = /\..*/;
var $834ee70cc5b953d1$var$stripUidRegex = /::\d+$/;
var $834ee70cc5b953d1$var$eventRegistry = {}; // Events storage
var $834ee70cc5b953d1$var$uidEvent = 1;
var $834ee70cc5b953d1$var$customEvents = {
    mouseenter: 'mouseover',
    mouseleave: 'mouseout'
};
var $834ee70cc5b953d1$var$nativeEvents = new Set([
    'click',
    'dblclick',
    'mouseup',
    'mousedown',
    'contextmenu',
    'mousewheel',
    'DOMMouseScroll',
    'mouseover',
    'mouseout',
    'mousemove',
    'selectstart',
    'selectend',
    'keydown',
    'keypress',
    'keyup',
    'orientationchange',
    'touchstart',
    'touchmove',
    'touchend',
    'touchcancel',
    'pointerdown',
    'pointermove',
    'pointerup',
    'pointerleave',
    'pointercancel',
    'gesturestart',
    'gesturechange',
    'gestureend',
    'focus',
    'blur',
    'change',
    'reset',
    'select',
    'submit',
    'focusin',
    'focusout',
    'load',
    'unload',
    'beforeunload',
    'resize',
    'move',
    'DOMContentLoaded',
    'readystatechange',
    'error',
    'abort',
    'scroll'
]);
/**
 * Private methods
 */ function $834ee70cc5b953d1$var$makeEventUid(element, uid) {
    return uid && "".concat(uid, "::").concat($834ee70cc5b953d1$var$uidEvent++) || element.uidEvent || $834ee70cc5b953d1$var$uidEvent++;
}
function $834ee70cc5b953d1$var$getElementEvents(element) {
    var uid = $834ee70cc5b953d1$var$makeEventUid(element);
    element.uidEvent = uid;
    $834ee70cc5b953d1$var$eventRegistry[uid] = $834ee70cc5b953d1$var$eventRegistry[uid] || {};
    return $834ee70cc5b953d1$var$eventRegistry[uid];
}
function $834ee70cc5b953d1$var$bootstrapHandler(element, fn) {
    return function handler(event) {
        $834ee70cc5b953d1$var$hydrateObj(event, {
            delegateTarget: element
        });
        if (handler.oneOff) $834ee70cc5b953d1$var$EventHandler.off(element, event.type, fn);
        return fn.apply(element, [
            event
        ]);
    };
}
function $834ee70cc5b953d1$var$bootstrapDelegationHandler(element, selector, fn) {
    return function handler(event) {
        var domElements = element.querySelectorAll(selector);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        for(var target = event.target; target && target !== this; target = target.parentNode)try {
            for(var _iterator = domElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var domElement = _step.value;
                if (domElement !== target) continue;
                $834ee70cc5b953d1$var$hydrateObj(event, {
                    delegateTarget: target
                });
                if (handler.oneOff) $834ee70cc5b953d1$var$EventHandler.off(element, event.type, selector, fn);
                return fn.apply(target, [
                    event
                ]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
}
function $834ee70cc5b953d1$var$findHandler(events, callable) {
    var delegationSelector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
    return Object.values(events).find(function(event) {
        return event.callable === callable && event.delegationSelector === delegationSelector;
    });
}
function $834ee70cc5b953d1$var$normalizeParameters(originalTypeEvent, handler, delegationFunction) {
    var isDelegated = typeof handler === 'string';
    // TODO: tooltip passes `false` instead of selector, so we need to check
    var callable = isDelegated ? delegationFunction : handler || delegationFunction;
    var typeEvent = $834ee70cc5b953d1$var$getTypeEvent(originalTypeEvent);
    if (!$834ee70cc5b953d1$var$nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
    return [
        isDelegated,
        callable,
        typeEvent
    ];
}
function $834ee70cc5b953d1$var$addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
    if (typeof originalTypeEvent !== 'string' || !element) return;
    var _normalizeParameters = (0, $db95b225ee8036d6$export$71511d61b312f219)($834ee70cc5b953d1$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
    // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
    // this prevents the handler from being dispatched the same way as mouseover or mouseout does
    if (originalTypeEvent in $834ee70cc5b953d1$var$customEvents) {
        var wrapFunction = function(fn) {
            return function wrapFunction(event) {
                if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
            };
        };
        callable = wrapFunction(callable);
    }
    var events = $834ee70cc5b953d1$var$getElementEvents(element);
    var handlers = events[typeEvent] || (events[typeEvent] = {});
    var previousFunction = $834ee70cc5b953d1$var$findHandler(handlers, callable, isDelegated ? handler : null);
    if (previousFunction) {
        previousFunction.oneOff = previousFunction.oneOff && oneOff;
        return;
    }
    var uid = $834ee70cc5b953d1$var$makeEventUid(callable, originalTypeEvent.replace($834ee70cc5b953d1$var$namespaceRegex, ''));
    var fn = isDelegated ? $834ee70cc5b953d1$var$bootstrapDelegationHandler(element, handler, callable) : $834ee70cc5b953d1$var$bootstrapHandler(element, callable);
    fn.delegationSelector = isDelegated ? handler : null;
    fn.callable = callable;
    fn.oneOff = oneOff;
    fn.uidEvent = uid;
    handlers[uid] = fn;
    element.addEventListener(typeEvent, fn, isDelegated);
}
function $834ee70cc5b953d1$var$removeHandler(element, events, typeEvent, handler, delegationSelector) {
    var fn = $834ee70cc5b953d1$var$findHandler(events[typeEvent], handler, delegationSelector);
    if (!fn) return;
    element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
    delete events[typeEvent][fn.uidEvent];
}
function $834ee70cc5b953d1$var$removeNamespacedHandlers(element, events, typeEvent, namespace) {
    var storeElementEvent = events[typeEvent] || {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(storeElementEvent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), handlerKey = _step_value[0], event = _step_value[1];
            if (handlerKey.includes(namespace)) $834ee70cc5b953d1$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
}
function $834ee70cc5b953d1$var$getTypeEvent(event) {
    // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
    event = event.replace($834ee70cc5b953d1$var$stripNameRegex, '');
    return $834ee70cc5b953d1$var$customEvents[event] || event;
}
var $834ee70cc5b953d1$var$EventHandler = {
    on: function(element, event, handler, delegationFunction) {
        $834ee70cc5b953d1$var$addHandler(element, event, handler, delegationFunction, false);
    },
    one: function(element, event, handler, delegationFunction) {
        $834ee70cc5b953d1$var$addHandler(element, event, handler, delegationFunction, true);
    },
    off: function(element, originalTypeEvent, handler, delegationFunction) {
        if (typeof originalTypeEvent !== 'string' || !element) return;
        var _normalizeParameters = (0, $db95b225ee8036d6$export$71511d61b312f219)($834ee70cc5b953d1$var$normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
        var inNamespace = typeEvent !== originalTypeEvent;
        var events = $834ee70cc5b953d1$var$getElementEvents(element);
        var storeElementEvent = events[typeEvent] || {};
        var isNamespace = originalTypeEvent.startsWith('.');
        if (typeof callable !== 'undefined') {
            // Simplest case: handler is passed, remove that listener ONLY.
            if (!Object.keys(storeElementEvent).length) return;
            $834ee70cc5b953d1$var$removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
            return;
        }
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (isNamespace) try {
            for(var _iterator = Object.keys(events)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elementEvent = _step.value;
                $834ee70cc5b953d1$var$removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
        try {
            for(var _iterator1 = Object.entries(storeElementEvent)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step1.value, 2), keyHandlers = _step_value[0], event = _step_value[1];
                var handlerKey = keyHandlers.replace($834ee70cc5b953d1$var$stripUidRegex, '');
                if (!inNamespace || originalTypeEvent.includes(handlerKey)) $834ee70cc5b953d1$var$removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        } catch (err) {
            _didIteratorError1 = true;
            _iteratorError1 = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                    _iterator1.return();
                }
            } finally{
                if (_didIteratorError1) {
                    throw _iteratorError1;
                }
            }
        }
    },
    trigger: function(element, event, args) {
        if (typeof event !== 'string' || !element) return null;
        var $ = $834ee70cc5b953d1$var$getjQuery();
        var typeEvent = $834ee70cc5b953d1$var$getTypeEvent(event);
        var inNamespace = event !== typeEvent;
        var jQueryEvent = null;
        var bubbles = true;
        var nativeDispatch = true;
        var defaultPrevented = false;
        if (inNamespace && $) {
            jQueryEvent = $.Event(event, args);
            $(element).trigger(jQueryEvent);
            bubbles = !jQueryEvent.isPropagationStopped();
            nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
            defaultPrevented = jQueryEvent.isDefaultPrevented();
        }
        var evt = $834ee70cc5b953d1$var$hydrateObj(new Event(event, {
            bubbles: bubbles,
            cancelable: true
        }), args);
        if (defaultPrevented) evt.preventDefault();
        if (nativeDispatch) element.dispatchEvent(evt);
        if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
        return evt;
    }
};
function $834ee70cc5b953d1$var$hydrateObj(obj) {
    var meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            try {
                obj[key] = value;
            } catch (_unused) {
                Object.defineProperty(obj, key, {
                    configurable: true,
                    get: function() {
                        return value;
                    }
                });
            }
        };
        for(var _iterator = Object.entries(meta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return obj;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/manipulator.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ function $834ee70cc5b953d1$var$normalizeData(value) {
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (value === Number(value).toString()) return Number(value);
    if (value === '' || value === 'null') return null;
    if (typeof value !== 'string') return value;
    try {
        return JSON.parse(decodeURIComponent(value));
    } catch (_unused) {
        return value;
    }
}
function $834ee70cc5b953d1$var$normalizeDataKey(key) {
    return key.replace(/[A-Z]/g, function(chr) {
        return "-".concat(chr.toLowerCase());
    });
}
var $834ee70cc5b953d1$var$Manipulator = {
    setDataAttribute: function(element, key, value) {
        element.setAttribute("data-bs-".concat($834ee70cc5b953d1$var$normalizeDataKey(key)), value);
    },
    removeDataAttribute: function(element, key) {
        element.removeAttribute("data-bs-".concat($834ee70cc5b953d1$var$normalizeDataKey(key)));
    },
    getDataAttributes: function(element) {
        if (!element) return {};
        var attributes = {};
        var bsKeys = Object.keys(element.dataset).filter(function(key) {
            return key.startsWith('bs') && !key.startsWith('bsConfig');
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = bsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var pureKey = key.replace(/^bs/, '');
                pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                attributes[pureKey] = $834ee70cc5b953d1$var$normalizeData(element.dataset[key]);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return attributes;
    },
    getDataAttribute: function(element, key) {
        return $834ee70cc5b953d1$var$normalizeData(element.getAttribute("data-bs-".concat($834ee70cc5b953d1$var$normalizeDataKey(key))));
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/config.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Class definition
 */ var $834ee70cc5b953d1$var$Config = /*#__PURE__*/ function() {
    "use strict";
    function Config() {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Config);
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Config, [
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                return config;
            }
        },
        {
            key: "_mergeConfigObj",
            value: function _mergeConfigObj(config, element) {
                var jsonConfig = $834ee70cc5b953d1$var$isElement(element) ? $834ee70cc5b953d1$var$Manipulator.getDataAttribute(element, 'config') : {}; // try to parse
                return (0, $d33814db45cf8e23$export$71511d61b312f219)({}, this.constructor.Default, (typeof jsonConfig === "undefined" ? "undefined" : (0, $dvYFb._)(jsonConfig)) === 'object' ? jsonConfig : {}, $834ee70cc5b953d1$var$isElement(element) ? $834ee70cc5b953d1$var$Manipulator.getDataAttributes(element) : {}, (typeof config === "undefined" ? "undefined" : (0, $dvYFb._)(config)) === 'object' ? config : {});
            }
        },
        {
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                var configTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.constructor.DefaultType;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(configTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), property = _step_value[0], expectedTypes = _step_value[1];
                        var value = config[property];
                        var valueType = $834ee70cc5b953d1$var$isElement(value) ? 'element' : $834ee70cc5b953d1$var$toType(value);
                        if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ': Option "').concat(property, '" provided type "').concat(valueType, '" but expected type "').concat(expectedTypes, '".'));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return {};
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return {};
            }
        },
        {
            key: "NAME",
            get: function get() {
                throw new Error('You have to implement the static method "NAME", for each component!');
            }
        }
    ]);
    return Config;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap base-component.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$VERSION = '5.3.2';
/**
 * Class definition
 */ var $834ee70cc5b953d1$var$BaseComponent = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(BaseComponent, Config);
    function BaseComponent(element, config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, BaseComponent);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, BaseComponent);
        element = $834ee70cc5b953d1$var$getElement(element);
        if (!element) return (0, $d463395515ae1209$export$71511d61b312f219)(_this);
        _this._element = element;
        _this._config = _this._getConfig(config);
        $834ee70cc5b953d1$var$Data.set(_this._element, _this.constructor.DATA_KEY, _this);
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(BaseComponent, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $834ee70cc5b953d1$var$Data.remove(this._element, this.constructor.DATA_KEY);
                $834ee70cc5b953d1$var$EventHandler.off(this._element, this.constructor.EVENT_KEY);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.getOwnPropertyNames(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var propertyName = _step.value;
                        this[propertyName] = null;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_queueCallback",
            value: function _queueCallback(callback, element) {
                var isAnimated = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                $834ee70cc5b953d1$var$executeAfterTransition(callback, element, isAnimated);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = this._mergeConfigObj(config, this._element);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        }
    ], [
        {
            key: "getInstance",
            value: // Static
            function getInstance(element) {
                return $834ee70cc5b953d1$var$Data.get($834ee70cc5b953d1$var$getElement(element), this.DATA_KEY);
            }
        },
        {
            key: "getOrCreateInstance",
            value: function getOrCreateInstance(element) {
                var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                return this.getInstance(element) || new this(element, (typeof config === "undefined" ? "undefined" : (0, $dvYFb._)(config)) === 'object' ? config : null);
            }
        },
        {
            key: "VERSION",
            get: function get() {
                return $834ee70cc5b953d1$var$VERSION;
            }
        },
        {
            key: "DATA_KEY",
            get: function get() {
                return "bs.".concat(this.NAME);
            }
        },
        {
            key: "EVENT_KEY",
            get: function get() {
                return ".".concat(this.DATA_KEY);
            }
        },
        {
            key: "eventName",
            value: function eventName(name) {
                return "".concat(name).concat(this.EVENT_KEY);
            }
        }
    ]);
    return BaseComponent;
}($834ee70cc5b953d1$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dom/selector-engine.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $834ee70cc5b953d1$var$getSelector = function(element) {
    var selector = element.getAttribute('data-bs-target');
    if (!selector || selector === '#') {
        var hrefAttribute = element.getAttribute('href');
        // The only valid content that could double as a selector are IDs or classes,
        // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
        // `document.querySelector` will rightfully complain it is invalid.
        // See https://github.com/twbs/bootstrap/issues/32273
        if (!hrefAttribute || !hrefAttribute.includes('#') && !hrefAttribute.startsWith('.')) return null;
        // Just in case some CMS puts out a full URL with the anchor appended
        if (hrefAttribute.includes('#') && !hrefAttribute.startsWith('#')) hrefAttribute = "#".concat(hrefAttribute.split('#')[1]);
        selector = hrefAttribute && hrefAttribute !== '#' ? $834ee70cc5b953d1$var$parseSelector(hrefAttribute.trim()) : null;
    }
    return selector;
};
var $834ee70cc5b953d1$var$SelectorEngine = {
    find: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(Element.prototype.querySelectorAll.call(element, selector)));
    },
    findOne: function(selector) {
        var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
        return Element.prototype.querySelector.call(element, selector);
    },
    children: function(element, selector) {
        var _instance;
        return (_instance = []).concat.apply(_instance, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(element.children)).filter(function(child) {
            return child.matches(selector);
        });
    },
    parents: function(element, selector) {
        var parents = [];
        var ancestor = element.parentNode.closest(selector);
        while(ancestor){
            parents.push(ancestor);
            ancestor = ancestor.parentNode.closest(selector);
        }
        return parents;
    },
    prev: function(element, selector) {
        var previous = element.previousElementSibling;
        while(previous){
            if (previous.matches(selector)) return [
                previous
            ];
            previous = previous.previousElementSibling;
        }
        return [];
    },
    // TODO: this is now unused; remove later along with prev()
    next: function(element, selector) {
        var next = element.nextElementSibling;
        while(next){
            if (next.matches(selector)) return [
                next
            ];
            next = next.nextElementSibling;
        }
        return [];
    },
    focusableChildren: function(element) {
        var focusables = [
            'a',
            'button',
            'input',
            'textarea',
            'select',
            'details',
            '[tabindex]',
            '[contenteditable="true"]'
        ].map(function(selector) {
            return "".concat(selector, ':not([tabindex^="-"])');
        }).join(',');
        return this.find(focusables, element).filter(function(el) {
            return !$834ee70cc5b953d1$var$isDisabled(el) && $834ee70cc5b953d1$var$isVisible(el);
        });
    },
    getSelectorFromElement: function(element) {
        var selector = $834ee70cc5b953d1$var$getSelector(element);
        if (selector) return $834ee70cc5b953d1$var$SelectorEngine.findOne(selector) ? selector : null;
        return null;
    },
    getElementFromSelector: function(element) {
        var selector = $834ee70cc5b953d1$var$getSelector(element);
        return selector ? $834ee70cc5b953d1$var$SelectorEngine.findOne(selector) : null;
    },
    getMultipleElementsFromSelector: function(element) {
        var selector = $834ee70cc5b953d1$var$getSelector(element);
        return selector ? $834ee70cc5b953d1$var$SelectorEngine.find(selector) : [];
    }
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/component-functions.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ var $834ee70cc5b953d1$var$enableDismissTrigger = function(component) {
    var method = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'hide';
    var clickEvent = "click.dismiss".concat(component.EVENT_KEY);
    var name = component.NAME;
    $834ee70cc5b953d1$var$EventHandler.on(document, clickEvent, '[data-bs-dismiss="'.concat(name, '"]'), function(event) {
        if ([
            'A',
            'AREA'
        ].includes(this.tagName)) event.preventDefault();
        if ($834ee70cc5b953d1$var$isDisabled(this)) return;
        var target = $834ee70cc5b953d1$var$SelectorEngine.getElementFromSelector(this) || this.closest(".".concat(name));
        var instance = component.getOrCreateInstance(target);
        // Method argument is left, for Alert and only, as it doesn't implement the 'hide' method
        instance[method]();
    });
};
/**
 * --------------------------------------------------------------------------
 * Bootstrap alert.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$f = 'alert';
var $834ee70cc5b953d1$var$DATA_KEY$a = 'bs.alert';
var $834ee70cc5b953d1$var$EVENT_KEY$b = ".".concat($834ee70cc5b953d1$var$DATA_KEY$a);
var $834ee70cc5b953d1$var$EVENT_CLOSE = "close".concat($834ee70cc5b953d1$var$EVENT_KEY$b);
var $834ee70cc5b953d1$var$EVENT_CLOSED = "closed".concat($834ee70cc5b953d1$var$EVENT_KEY$b);
var $834ee70cc5b953d1$var$CLASS_NAME_FADE$5 = 'fade';
var $834ee70cc5b953d1$var$CLASS_NAME_SHOW$8 = 'show';
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$caec2af78bcc877f = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Alert, BaseComponent);
    function Alert() {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Alert);
        return (0, $44950fec9206880e$export$71511d61b312f219)(this, Alert, arguments);
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Alert, [
        {
            // Public
            key: "close",
            value: function close() {
                var _this = this;
                var closeEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_CLOSE);
                if (closeEvent.defaultPrevented) return;
                this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOW$8);
                var isAnimated = this._element.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_FADE$5);
                this._queueCallback(function() {
                    return _this._destroyElement();
                }, this._element, isAnimated);
            }
        },
        {
            // Private
            key: "_destroyElement",
            value: function _destroyElement() {
                this._element.remove();
                $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_CLOSED);
                this.dispose();
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$NAME$f;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Alert.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Alert;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * Data API implementation
 */ $834ee70cc5b953d1$var$enableDismissTrigger($834ee70cc5b953d1$export$caec2af78bcc877f, 'close');
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$caec2af78bcc877f);
/**
 * --------------------------------------------------------------------------
 * Bootstrap button.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$e = 'button';
var $834ee70cc5b953d1$var$DATA_KEY$9 = 'bs.button';
var $834ee70cc5b953d1$var$EVENT_KEY$a = ".".concat($834ee70cc5b953d1$var$DATA_KEY$9);
var $834ee70cc5b953d1$var$DATA_API_KEY$6 = '.data-api';
var $834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$3 = 'active';
var $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$5 = '[data-bs-toggle="button"]';
var $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$6 = "click".concat($834ee70cc5b953d1$var$EVENT_KEY$a).concat($834ee70cc5b953d1$var$DATA_API_KEY$6);
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$353f5b6fc5456de1 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Button, BaseComponent);
    function Button() {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Button);
        return (0, $44950fec9206880e$export$71511d61b312f219)(this, Button, arguments);
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Button, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                // Toggle class and sync the `aria-pressed` attribute with the return value of the `.toggle()` method
                this._element.setAttribute('aria-pressed', this._element.classList.toggle($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$3));
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$NAME$e;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Button.getOrCreateInstance(this);
                    if (config === 'toggle') data[config]();
                });
            }
        }
    ]);
    return Button;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * Data API implementation
 */ $834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$6, $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$5, function(event) {
    event.preventDefault();
    var button = event.target.closest($834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$5);
    var data = $834ee70cc5b953d1$export$353f5b6fc5456de1.getOrCreateInstance(button);
    data.toggle();
});
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$353f5b6fc5456de1);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/swipe.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$d = 'swipe';
var $834ee70cc5b953d1$var$EVENT_KEY$9 = '.bs.swipe';
var $834ee70cc5b953d1$var$EVENT_TOUCHSTART = "touchstart".concat($834ee70cc5b953d1$var$EVENT_KEY$9);
var $834ee70cc5b953d1$var$EVENT_TOUCHMOVE = "touchmove".concat($834ee70cc5b953d1$var$EVENT_KEY$9);
var $834ee70cc5b953d1$var$EVENT_TOUCHEND = "touchend".concat($834ee70cc5b953d1$var$EVENT_KEY$9);
var $834ee70cc5b953d1$var$EVENT_POINTERDOWN = "pointerdown".concat($834ee70cc5b953d1$var$EVENT_KEY$9);
var $834ee70cc5b953d1$var$EVENT_POINTERUP = "pointerup".concat($834ee70cc5b953d1$var$EVENT_KEY$9);
var $834ee70cc5b953d1$var$POINTER_TYPE_TOUCH = 'touch';
var $834ee70cc5b953d1$var$POINTER_TYPE_PEN = 'pen';
var $834ee70cc5b953d1$var$CLASS_NAME_POINTER_EVENT = 'pointer-event';
var $834ee70cc5b953d1$var$SWIPE_THRESHOLD = 40;
var $834ee70cc5b953d1$var$Default$c = {
    endCallback: null,
    leftCallback: null,
    rightCallback: null
};
var $834ee70cc5b953d1$var$DefaultType$c = {
    endCallback: '(function|null)',
    leftCallback: '(function|null)',
    rightCallback: '(function|null)'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$var$Swipe = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Swipe, Config);
    function Swipe(element, config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Swipe);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Swipe);
        _this._element = element;
        if (!element || !Swipe.isSupported()) return (0, $d463395515ae1209$export$71511d61b312f219)(_this);
        _this._config = _this._getConfig(config);
        _this._deltaX = 0;
        _this._supportPointerEvents = Boolean(window.PointerEvent);
        _this._initEvents();
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Swipe, [
        {
            // Public
            key: "dispose",
            value: function dispose() {
                $834ee70cc5b953d1$var$EventHandler.off(this._element, $834ee70cc5b953d1$var$EVENT_KEY$9);
            }
        },
        {
            // Private
            key: "_start",
            value: function _start(event) {
                if (!this._supportPointerEvents) {
                    this._deltaX = event.touches[0].clientX;
                    return;
                }
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX;
            }
        },
        {
            key: "_end",
            value: function _end(event) {
                if (this._eventIsPointerPenTouch(event)) this._deltaX = event.clientX - this._deltaX;
                this._handleSwipe();
                $834ee70cc5b953d1$var$execute(this._config.endCallback);
            }
        },
        {
            key: "_move",
            value: function _move(event) {
                this._deltaX = event.touches && event.touches.length > 1 ? 0 : event.touches[0].clientX - this._deltaX;
            }
        },
        {
            key: "_handleSwipe",
            value: function _handleSwipe() {
                var absDeltaX = Math.abs(this._deltaX);
                if (absDeltaX <= $834ee70cc5b953d1$var$SWIPE_THRESHOLD) return;
                var direction = absDeltaX / this._deltaX;
                this._deltaX = 0;
                if (!direction) return;
                $834ee70cc5b953d1$var$execute(direction > 0 ? this._config.rightCallback : this._config.leftCallback);
            }
        },
        {
            key: "_initEvents",
            value: function _initEvents() {
                var _this = this;
                if (this._supportPointerEvents) {
                    $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_POINTERDOWN, function(event) {
                        return _this._start(event);
                    });
                    $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_POINTERUP, function(event) {
                        return _this._end(event);
                    });
                    this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_POINTER_EVENT);
                } else {
                    $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_TOUCHSTART, function(event) {
                        return _this._start(event);
                    });
                    $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_TOUCHMOVE, function(event) {
                        return _this._move(event);
                    });
                    $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_TOUCHEND, function(event) {
                        return _this._end(event);
                    });
                }
            }
        },
        {
            key: "_eventIsPointerPenTouch",
            value: function _eventIsPointerPenTouch(event) {
                return this._supportPointerEvents && (event.pointerType === $834ee70cc5b953d1$var$POINTER_TYPE_PEN || event.pointerType === $834ee70cc5b953d1$var$POINTER_TYPE_TOUCH);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$c;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$c;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$d;
            }
        },
        {
            key: "isSupported",
            value: // Static
            function isSupported() {
                return 'ontouchstart' in document.documentElement || navigator.maxTouchPoints > 0;
            }
        }
    ]);
    return Swipe;
}($834ee70cc5b953d1$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$c = 'carousel';
var $834ee70cc5b953d1$var$DATA_KEY$8 = 'bs.carousel';
var $834ee70cc5b953d1$var$EVENT_KEY$8 = ".".concat($834ee70cc5b953d1$var$DATA_KEY$8);
var $834ee70cc5b953d1$var$DATA_API_KEY$5 = '.data-api';
var $834ee70cc5b953d1$var$ARROW_LEFT_KEY$1 = 'ArrowLeft';
var $834ee70cc5b953d1$var$ARROW_RIGHT_KEY$1 = 'ArrowRight';
var $834ee70cc5b953d1$var$TOUCHEVENT_COMPAT_WAIT = 500; // Time for mouse compat events to fire after touch
var $834ee70cc5b953d1$var$ORDER_NEXT = 'next';
var $834ee70cc5b953d1$var$ORDER_PREV = 'prev';
var $834ee70cc5b953d1$var$DIRECTION_LEFT = 'left';
var $834ee70cc5b953d1$var$DIRECTION_RIGHT = 'right';
var $834ee70cc5b953d1$var$EVENT_SLIDE = "slide".concat($834ee70cc5b953d1$var$EVENT_KEY$8);
var $834ee70cc5b953d1$var$EVENT_SLID = "slid".concat($834ee70cc5b953d1$var$EVENT_KEY$8);
var $834ee70cc5b953d1$var$EVENT_KEYDOWN$1 = "keydown".concat($834ee70cc5b953d1$var$EVENT_KEY$8);
var $834ee70cc5b953d1$var$EVENT_MOUSEENTER$1 = "mouseenter".concat($834ee70cc5b953d1$var$EVENT_KEY$8);
var $834ee70cc5b953d1$var$EVENT_MOUSELEAVE$1 = "mouseleave".concat($834ee70cc5b953d1$var$EVENT_KEY$8);
var $834ee70cc5b953d1$var$EVENT_DRAG_START = "dragstart".concat($834ee70cc5b953d1$var$EVENT_KEY$8);
var $834ee70cc5b953d1$var$EVENT_LOAD_DATA_API$3 = "load".concat($834ee70cc5b953d1$var$EVENT_KEY$8).concat($834ee70cc5b953d1$var$DATA_API_KEY$5);
var $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$5 = "click".concat($834ee70cc5b953d1$var$EVENT_KEY$8).concat($834ee70cc5b953d1$var$DATA_API_KEY$5);
var $834ee70cc5b953d1$var$CLASS_NAME_CAROUSEL = 'carousel';
var $834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$2 = 'active';
var $834ee70cc5b953d1$var$CLASS_NAME_SLIDE = 'slide';
var $834ee70cc5b953d1$var$CLASS_NAME_END = 'carousel-item-end';
var $834ee70cc5b953d1$var$CLASS_NAME_START = 'carousel-item-start';
var $834ee70cc5b953d1$var$CLASS_NAME_NEXT = 'carousel-item-next';
var $834ee70cc5b953d1$var$CLASS_NAME_PREV = 'carousel-item-prev';
var $834ee70cc5b953d1$var$SELECTOR_ACTIVE = '.active';
var $834ee70cc5b953d1$var$SELECTOR_ITEM = '.carousel-item';
var $834ee70cc5b953d1$var$SELECTOR_ACTIVE_ITEM = $834ee70cc5b953d1$var$SELECTOR_ACTIVE + $834ee70cc5b953d1$var$SELECTOR_ITEM;
var $834ee70cc5b953d1$var$SELECTOR_ITEM_IMG = '.carousel-item img';
var $834ee70cc5b953d1$var$SELECTOR_INDICATORS = '.carousel-indicators';
var $834ee70cc5b953d1$var$SELECTOR_DATA_SLIDE = '[data-bs-slide], [data-bs-slide-to]';
var $834ee70cc5b953d1$var$SELECTOR_DATA_RIDE = '[data-bs-ride="carousel"]';
var $834ee70cc5b953d1$var$_obj;
var $834ee70cc5b953d1$var$KEY_TO_DIRECTION = ($834ee70cc5b953d1$var$_obj = {}, (0, $6194eebaf067e4d1$export$71511d61b312f219)($834ee70cc5b953d1$var$_obj, $834ee70cc5b953d1$var$ARROW_LEFT_KEY$1, $834ee70cc5b953d1$var$DIRECTION_RIGHT), (0, $6194eebaf067e4d1$export$71511d61b312f219)($834ee70cc5b953d1$var$_obj, $834ee70cc5b953d1$var$ARROW_RIGHT_KEY$1, $834ee70cc5b953d1$var$DIRECTION_LEFT), $834ee70cc5b953d1$var$_obj);
var $834ee70cc5b953d1$var$Default$b = {
    interval: 5000,
    keyboard: true,
    pause: 'hover',
    ride: false,
    touch: true,
    wrap: true
};
var $834ee70cc5b953d1$var$DefaultType$b = {
    interval: '(number|boolean)',
    // TODO:v6 remove boolean support
    keyboard: 'boolean',
    pause: '(string|boolean)',
    ride: '(boolean|string)',
    touch: 'boolean',
    wrap: 'boolean'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$144901db2ea8e967 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Carousel, BaseComponent);
    function Carousel(element, config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Carousel);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Carousel, [
            element,
            config
        ]);
        _this._interval = null;
        _this._activeElement = null;
        _this._isSliding = false;
        _this.touchTimeout = null;
        _this._swipeHelper = null;
        _this._indicatorsElement = $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$SELECTOR_INDICATORS, _this._element);
        _this._addEventListeners();
        if (_this._config.ride === $834ee70cc5b953d1$var$CLASS_NAME_CAROUSEL) _this.cycle();
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Carousel, [
        {
            // Public
            key: "next",
            value: function next() {
                this._slide($834ee70cc5b953d1$var$ORDER_NEXT);
            }
        },
        {
            key: "nextWhenVisible",
            value: function nextWhenVisible() {
                // FIXME TODO use `document.visibilityState`
                // Don't call next when the page isn't visible
                // or the carousel or its parent isn't visible
                if (!document.hidden && $834ee70cc5b953d1$var$isVisible(this._element)) this.next();
            }
        },
        {
            key: "prev",
            value: function prev() {
                this._slide($834ee70cc5b953d1$var$ORDER_PREV);
            }
        },
        {
            key: "pause",
            value: function pause() {
                if (this._isSliding) $834ee70cc5b953d1$var$triggerTransitionEnd(this._element);
                this._clearInterval();
            }
        },
        {
            key: "cycle",
            value: function cycle() {
                var _this = this;
                this._clearInterval();
                this._updateInterval();
                this._interval = setInterval(function() {
                    return _this.nextWhenVisible();
                }, this._config.interval);
            }
        },
        {
            key: "_maybeEnableCycle",
            value: function _maybeEnableCycle() {
                var _this = this;
                if (!this._config.ride) return;
                if (this._isSliding) {
                    $834ee70cc5b953d1$var$EventHandler.one(this._element, $834ee70cc5b953d1$var$EVENT_SLID, function() {
                        return _this.cycle();
                    });
                    return;
                }
                this.cycle();
            }
        },
        {
            key: "to",
            value: function to(index) {
                var _this = this;
                var items = this._getItems();
                if (index > items.length - 1 || index < 0) return;
                if (this._isSliding) {
                    $834ee70cc5b953d1$var$EventHandler.one(this._element, $834ee70cc5b953d1$var$EVENT_SLID, function() {
                        return _this.to(index);
                    });
                    return;
                }
                var activeIndex = this._getItemIndex(this._getActive());
                if (activeIndex === index) return;
                var order = index > activeIndex ? $834ee70cc5b953d1$var$ORDER_NEXT : $834ee70cc5b953d1$var$ORDER_PREV;
                this._slide(order, items[index]);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._swipeHelper) this._swipeHelper.dispose();
                (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(Carousel.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.defaultInterval = config.interval;
                return config;
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                if (this._config.keyboard) $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_KEYDOWN$1, function(event) {
                    return _this._keydown(event);
                });
                if (this._config.pause === 'hover') {
                    $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_MOUSEENTER$1, function() {
                        return _this.pause();
                    });
                    $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_MOUSELEAVE$1, function() {
                        return _this._maybeEnableCycle();
                    });
                }
                if (this._config.touch && $834ee70cc5b953d1$var$Swipe.isSupported()) this._addTouchEventListeners();
            }
        },
        {
            key: "_addTouchEventListeners",
            value: function _addTouchEventListeners() {
                var _this = this;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$SELECTOR_ITEM_IMG, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var img = _step.value;
                        $834ee70cc5b953d1$var$EventHandler.on(img, $834ee70cc5b953d1$var$EVENT_DRAG_START, function(event) {
                            return event.preventDefault();
                        });
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var endCallBack = function() {
                    if (_this._config.pause !== 'hover') return;
                    // If it's a touch-enabled device, mouseenter/leave are fired as
                    // part of the mouse compatibility events on first tap - the carousel
                    // would stop cycling until user tapped out of it;
                    // here, we listen for touchend, explicitly pause the carousel
                    // (as if it's the second time we tap on it, mouseenter compat event
                    // is NOT fired) and after a timeout (to allow for mouse compatibility
                    // events to fire) we explicitly restart cycling
                    _this.pause();
                    if (_this.touchTimeout) clearTimeout(_this.touchTimeout);
                    _this.touchTimeout = setTimeout(function() {
                        return _this._maybeEnableCycle();
                    }, $834ee70cc5b953d1$var$TOUCHEVENT_COMPAT_WAIT + _this._config.interval);
                };
                var swipeConfig = {
                    leftCallback: function() {
                        return _this._slide(_this._directionToOrder($834ee70cc5b953d1$var$DIRECTION_LEFT));
                    },
                    rightCallback: function() {
                        return _this._slide(_this._directionToOrder($834ee70cc5b953d1$var$DIRECTION_RIGHT));
                    },
                    endCallback: endCallBack
                };
                this._swipeHelper = new $834ee70cc5b953d1$var$Swipe(this._element, swipeConfig);
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (/input|textarea/i.test(event.target.tagName)) return;
                var direction = $834ee70cc5b953d1$var$KEY_TO_DIRECTION[event.key];
                if (direction) {
                    event.preventDefault();
                    this._slide(this._directionToOrder(direction));
                }
            }
        },
        {
            key: "_getItemIndex",
            value: function _getItemIndex(element) {
                return this._getItems().indexOf(element);
            }
        },
        {
            key: "_setActiveIndicatorElement",
            value: function _setActiveIndicatorElement(index) {
                if (!this._indicatorsElement) return;
                var activeIndicator = $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$SELECTOR_ACTIVE, this._indicatorsElement);
                activeIndicator.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$2);
                activeIndicator.removeAttribute('aria-current');
                var newActiveIndicator = $834ee70cc5b953d1$var$SelectorEngine.findOne('[data-bs-slide-to="'.concat(index, '"]'), this._indicatorsElement);
                if (newActiveIndicator) {
                    newActiveIndicator.classList.add($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$2);
                    newActiveIndicator.setAttribute('aria-current', 'true');
                }
            }
        },
        {
            key: "_updateInterval",
            value: function _updateInterval() {
                var element = this._activeElement || this._getActive();
                if (!element) return;
                var elementInterval = Number.parseInt(element.getAttribute('data-bs-interval'), 10);
                this._config.interval = elementInterval || this._config.defaultInterval;
            }
        },
        {
            key: "_slide",
            value: function _slide(order) {
                var _this = this;
                var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
                if (this._isSliding) return;
                var activeElement = this._getActive();
                var isNext = order === $834ee70cc5b953d1$var$ORDER_NEXT;
                var nextElement = element || $834ee70cc5b953d1$var$getNextActiveElement(this._getItems(), activeElement, isNext, this._config.wrap);
                if (nextElement === activeElement) return;
                var nextElementIndex = this._getItemIndex(nextElement);
                var triggerEvent = function(eventName) {
                    return $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, eventName, {
                        relatedTarget: nextElement,
                        direction: _this._orderToDirection(order),
                        from: _this._getItemIndex(activeElement),
                        to: nextElementIndex
                    });
                };
                var slideEvent = triggerEvent($834ee70cc5b953d1$var$EVENT_SLIDE);
                if (slideEvent.defaultPrevented) return;
                if (!activeElement || !nextElement) // Some weirdness is happening, so we bail
                // TODO: change tests that use empty divs to avoid this check
                return;
                var isCycling = Boolean(this._interval);
                this.pause();
                this._isSliding = true;
                this._setActiveIndicatorElement(nextElementIndex);
                this._activeElement = nextElement;
                var directionalClassName = isNext ? $834ee70cc5b953d1$var$CLASS_NAME_START : $834ee70cc5b953d1$var$CLASS_NAME_END;
                var orderClassName = isNext ? $834ee70cc5b953d1$var$CLASS_NAME_NEXT : $834ee70cc5b953d1$var$CLASS_NAME_PREV;
                nextElement.classList.add(orderClassName);
                $834ee70cc5b953d1$var$reflow(nextElement);
                activeElement.classList.add(directionalClassName);
                nextElement.classList.add(directionalClassName);
                var completeCallBack = function() {
                    nextElement.classList.remove(directionalClassName, orderClassName);
                    nextElement.classList.add($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$2);
                    activeElement.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$2, orderClassName, directionalClassName);
                    _this._isSliding = false;
                    triggerEvent($834ee70cc5b953d1$var$EVENT_SLID);
                };
                this._queueCallback(completeCallBack, activeElement, this._isAnimated());
                if (isCycling) this.cycle();
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_SLIDE);
            }
        },
        {
            key: "_getActive",
            value: function _getActive() {
                return $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$SELECTOR_ACTIVE_ITEM, this._element);
            }
        },
        {
            key: "_getItems",
            value: function _getItems() {
                return $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$SELECTOR_ITEM, this._element);
            }
        },
        {
            key: "_clearInterval",
            value: function _clearInterval() {
                if (this._interval) {
                    clearInterval(this._interval);
                    this._interval = null;
                }
            }
        },
        {
            key: "_directionToOrder",
            value: function _directionToOrder(direction) {
                if ($834ee70cc5b953d1$var$isRTL()) return direction === $834ee70cc5b953d1$var$DIRECTION_LEFT ? $834ee70cc5b953d1$var$ORDER_PREV : $834ee70cc5b953d1$var$ORDER_NEXT;
                return direction === $834ee70cc5b953d1$var$DIRECTION_LEFT ? $834ee70cc5b953d1$var$ORDER_NEXT : $834ee70cc5b953d1$var$ORDER_PREV;
            }
        },
        {
            key: "_orderToDirection",
            value: function _orderToDirection(order) {
                if ($834ee70cc5b953d1$var$isRTL()) return order === $834ee70cc5b953d1$var$ORDER_PREV ? $834ee70cc5b953d1$var$DIRECTION_LEFT : $834ee70cc5b953d1$var$DIRECTION_RIGHT;
                return order === $834ee70cc5b953d1$var$ORDER_PREV ? $834ee70cc5b953d1$var$DIRECTION_RIGHT : $834ee70cc5b953d1$var$DIRECTION_LEFT;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$b;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$b;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$c;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Carousel.getOrCreateInstance(this, config);
                    if (typeof config === 'number') {
                        data.to(config);
                        return;
                    }
                    if (typeof config === 'string') {
                        if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Carousel;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * Data API implementation
 */ $834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$5, $834ee70cc5b953d1$var$SELECTOR_DATA_SLIDE, function(event) {
    var target = $834ee70cc5b953d1$var$SelectorEngine.getElementFromSelector(this);
    if (!target || !target.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_CAROUSEL)) return;
    event.preventDefault();
    var carousel = $834ee70cc5b953d1$export$144901db2ea8e967.getOrCreateInstance(target);
    var slideIndex = this.getAttribute('data-bs-slide-to');
    if (slideIndex) {
        carousel.to(slideIndex);
        carousel._maybeEnableCycle();
        return;
    }
    if ($834ee70cc5b953d1$var$Manipulator.getDataAttribute(this, 'slide') === 'next') {
        carousel.next();
        carousel._maybeEnableCycle();
        return;
    }
    carousel.prev();
    carousel._maybeEnableCycle();
});
$834ee70cc5b953d1$var$EventHandler.on(window, $834ee70cc5b953d1$var$EVENT_LOAD_DATA_API$3, function() {
    var carousels = $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$SELECTOR_DATA_RIDE);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = carousels[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var carousel = _step.value;
            $834ee70cc5b953d1$export$144901db2ea8e967.getOrCreateInstance(carousel);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$144901db2ea8e967);
/**
 * --------------------------------------------------------------------------
 * Bootstrap collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$b = 'collapse';
var $834ee70cc5b953d1$var$DATA_KEY$7 = 'bs.collapse';
var $834ee70cc5b953d1$var$EVENT_KEY$7 = ".".concat($834ee70cc5b953d1$var$DATA_KEY$7);
var $834ee70cc5b953d1$var$DATA_API_KEY$4 = '.data-api';
var $834ee70cc5b953d1$var$EVENT_SHOW$6 = "show".concat($834ee70cc5b953d1$var$EVENT_KEY$7);
var $834ee70cc5b953d1$var$EVENT_SHOWN$6 = "shown".concat($834ee70cc5b953d1$var$EVENT_KEY$7);
var $834ee70cc5b953d1$var$EVENT_HIDE$6 = "hide".concat($834ee70cc5b953d1$var$EVENT_KEY$7);
var $834ee70cc5b953d1$var$EVENT_HIDDEN$6 = "hidden".concat($834ee70cc5b953d1$var$EVENT_KEY$7);
var $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$4 = "click".concat($834ee70cc5b953d1$var$EVENT_KEY$7).concat($834ee70cc5b953d1$var$DATA_API_KEY$4);
var $834ee70cc5b953d1$var$CLASS_NAME_SHOW$7 = 'show';
var $834ee70cc5b953d1$var$CLASS_NAME_COLLAPSE = 'collapse';
var $834ee70cc5b953d1$var$CLASS_NAME_COLLAPSING = 'collapsing';
var $834ee70cc5b953d1$var$CLASS_NAME_COLLAPSED = 'collapsed';
var $834ee70cc5b953d1$var$CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSE, " .").concat($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSE);
var $834ee70cc5b953d1$var$CLASS_NAME_HORIZONTAL = 'collapse-horizontal';
var $834ee70cc5b953d1$var$WIDTH = 'width';
var $834ee70cc5b953d1$var$HEIGHT = 'height';
var $834ee70cc5b953d1$var$SELECTOR_ACTIVES = '.collapse.show, .collapse.collapsing';
var $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$4 = '[data-bs-toggle="collapse"]';
var $834ee70cc5b953d1$var$Default$a = {
    parent: null,
    toggle: true
};
var $834ee70cc5b953d1$var$DefaultType$a = {
    parent: '(null|element)',
    toggle: 'boolean'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$78768a9af065a7b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Collapse, BaseComponent);
    function Collapse(element, config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Collapse);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Collapse, [
            element,
            config
        ]);
        _this._isTransitioning = false;
        _this._triggerArray = [];
        var toggleList = $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$4);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = toggleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var elem = _step.value;
                var selector = $834ee70cc5b953d1$var$SelectorEngine.getSelectorFromElement(elem);
                var filterElement = $834ee70cc5b953d1$var$SelectorEngine.find(selector).filter(function(foundElement) {
                    return foundElement === _this._element;
                });
                if (selector !== null && filterElement.length) _this._triggerArray.push(elem);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        _this._initializeChildren();
        if (!_this._config.parent) _this._addAriaAndCollapsedClass(_this._triggerArray, _this._isShown());
        if (_this._config.toggle) _this.toggle();
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Collapse, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                if (this._isShown()) this.hide();
                else this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                if (this._isTransitioning || this._isShown()) return;
                var activeChildren = [];
                // find active children
                if (this._config.parent) activeChildren = this._getFirstLevelChildren($834ee70cc5b953d1$var$SELECTOR_ACTIVES).filter(function(element) {
                    return element !== _this._element;
                }).map(function(element) {
                    return Collapse.getOrCreateInstance(element, {
                        toggle: false
                    });
                });
                if (activeChildren.length && activeChildren[0]._isTransitioning) return;
                var startEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_SHOW$6);
                if (startEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var activeInstance = _step.value;
                        activeInstance.hide();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var dimension = this._getDimension();
                this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSE);
                this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSING);
                this._element.style[dimension] = 0;
                this._addAriaAndCollapsedClass(this._triggerArray, true);
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSE, $834ee70cc5b953d1$var$CLASS_NAME_SHOW$7);
                    _this._element.style[dimension] = '';
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, $834ee70cc5b953d1$var$EVENT_SHOWN$6);
                };
                var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                var scrollSize = "scroll".concat(capitalizedDimension);
                this._queueCallback(complete, this._element, true);
                this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (this._isTransitioning || !this._isShown()) return;
                var startEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_HIDE$6);
                if (startEvent.defaultPrevented) return;
                var dimension = this._getDimension();
                this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
                $834ee70cc5b953d1$var$reflow(this._element);
                this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSING);
                this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSE, $834ee70cc5b953d1$var$CLASS_NAME_SHOW$7);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        var element = $834ee70cc5b953d1$var$SelectorEngine.getElementFromSelector(trigger);
                        if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                            trigger
                        ], false);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._isTransitioning = true;
                var complete = function() {
                    _this._isTransitioning = false;
                    _this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSING);
                    _this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSE);
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, $834ee70cc5b953d1$var$EVENT_HIDDEN$6);
                };
                this._element.style[dimension] = '';
                this._queueCallback(complete, this._element, true);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._element;
                return element.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_SHOW$7);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.toggle = Boolean(config.toggle); // Coerce string values
                config.parent = $834ee70cc5b953d1$var$getElement(config.parent);
                return config;
            }
        },
        {
            key: "_getDimension",
            value: function _getDimension() {
                return this._element.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_HORIZONTAL) ? $834ee70cc5b953d1$var$WIDTH : $834ee70cc5b953d1$var$HEIGHT;
            }
        },
        {
            key: "_initializeChildren",
            value: function _initializeChildren() {
                if (!this._config.parent) return;
                var children = this._getFirstLevelChildren($834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$4);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        var selected = $834ee70cc5b953d1$var$SelectorEngine.getElementFromSelector(element);
                        if (selected) this._addAriaAndCollapsedClass([
                            element
                        ], this._isShown(selected));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_getFirstLevelChildren",
            value: function _getFirstLevelChildren(selector) {
                var children = $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                // remove children if greater depth
                return $834ee70cc5b953d1$var$SelectorEngine.find(selector, this._config.parent).filter(function(element) {
                    return !children.includes(element);
                });
            }
        },
        {
            key: "_addAriaAndCollapsedClass",
            value: function _addAriaAndCollapsedClass(triggerArray, isOpen) {
                if (!triggerArray.length) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        element.classList.toggle($834ee70cc5b953d1$var$CLASS_NAME_COLLAPSED, !isOpen);
                        element.setAttribute('aria-expanded', isOpen);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$a;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$a;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$b;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                var _config = {};
                if (typeof config === 'string' && /show|hide/.test(config)) _config.toggle = false;
                return this.each(function() {
                    var data = Collapse.getOrCreateInstance(this, _config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    }
                });
            }
        }
    ]);
    return Collapse;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * Data API implementation
 */ $834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$4, $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$4, function(event) {
    // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
    if (event.target.tagName === 'A' || event.delegateTarget && event.delegateTarget.tagName === 'A') event.preventDefault();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $834ee70cc5b953d1$var$SelectorEngine.getMultipleElementsFromSelector(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $834ee70cc5b953d1$export$78768a9af065a7b.getOrCreateInstance(element, {
                toggle: false
            }).toggle();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$78768a9af065a7b);
/**
 * --------------------------------------------------------------------------
 * Bootstrap dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$a = 'dropdown';
var $834ee70cc5b953d1$var$DATA_KEY$6 = 'bs.dropdown';
var $834ee70cc5b953d1$var$EVENT_KEY$6 = ".".concat($834ee70cc5b953d1$var$DATA_KEY$6);
var $834ee70cc5b953d1$var$DATA_API_KEY$3 = '.data-api';
var $834ee70cc5b953d1$var$ESCAPE_KEY$2 = 'Escape';
var $834ee70cc5b953d1$var$TAB_KEY$1 = 'Tab';
var $834ee70cc5b953d1$var$ARROW_UP_KEY$1 = 'ArrowUp';
var $834ee70cc5b953d1$var$ARROW_DOWN_KEY$1 = 'ArrowDown';
var $834ee70cc5b953d1$var$RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
var $834ee70cc5b953d1$var$EVENT_HIDE$5 = "hide".concat($834ee70cc5b953d1$var$EVENT_KEY$6);
var $834ee70cc5b953d1$var$EVENT_HIDDEN$5 = "hidden".concat($834ee70cc5b953d1$var$EVENT_KEY$6);
var $834ee70cc5b953d1$var$EVENT_SHOW$5 = "show".concat($834ee70cc5b953d1$var$EVENT_KEY$6);
var $834ee70cc5b953d1$var$EVENT_SHOWN$5 = "shown".concat($834ee70cc5b953d1$var$EVENT_KEY$6);
var $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$3 = "click".concat($834ee70cc5b953d1$var$EVENT_KEY$6).concat($834ee70cc5b953d1$var$DATA_API_KEY$3);
var $834ee70cc5b953d1$var$EVENT_KEYDOWN_DATA_API = "keydown".concat($834ee70cc5b953d1$var$EVENT_KEY$6).concat($834ee70cc5b953d1$var$DATA_API_KEY$3);
var $834ee70cc5b953d1$var$EVENT_KEYUP_DATA_API = "keyup".concat($834ee70cc5b953d1$var$EVENT_KEY$6).concat($834ee70cc5b953d1$var$DATA_API_KEY$3);
var $834ee70cc5b953d1$var$CLASS_NAME_SHOW$6 = 'show';
var $834ee70cc5b953d1$var$CLASS_NAME_DROPUP = 'dropup';
var $834ee70cc5b953d1$var$CLASS_NAME_DROPEND = 'dropend';
var $834ee70cc5b953d1$var$CLASS_NAME_DROPSTART = 'dropstart';
var $834ee70cc5b953d1$var$CLASS_NAME_DROPUP_CENTER = 'dropup-center';
var $834ee70cc5b953d1$var$CLASS_NAME_DROPDOWN_CENTER = 'dropdown-center';
var $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$3 = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
var $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE_SHOWN = "".concat($834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$3, ".").concat($834ee70cc5b953d1$var$CLASS_NAME_SHOW$6);
var $834ee70cc5b953d1$var$SELECTOR_MENU = '.dropdown-menu';
var $834ee70cc5b953d1$var$SELECTOR_NAVBAR = '.navbar';
var $834ee70cc5b953d1$var$SELECTOR_NAVBAR_NAV = '.navbar-nav';
var $834ee70cc5b953d1$var$SELECTOR_VISIBLE_ITEMS = '.dropdown-menu .dropdown-item:not(.disabled):not(:disabled)';
var $834ee70cc5b953d1$var$PLACEMENT_TOP = $834ee70cc5b953d1$var$isRTL() ? 'top-end' : 'top-start';
var $834ee70cc5b953d1$var$PLACEMENT_TOPEND = $834ee70cc5b953d1$var$isRTL() ? 'top-start' : 'top-end';
var $834ee70cc5b953d1$var$PLACEMENT_BOTTOM = $834ee70cc5b953d1$var$isRTL() ? 'bottom-end' : 'bottom-start';
var $834ee70cc5b953d1$var$PLACEMENT_BOTTOMEND = $834ee70cc5b953d1$var$isRTL() ? 'bottom-start' : 'bottom-end';
var $834ee70cc5b953d1$var$PLACEMENT_RIGHT = $834ee70cc5b953d1$var$isRTL() ? 'left-start' : 'right-start';
var $834ee70cc5b953d1$var$PLACEMENT_LEFT = $834ee70cc5b953d1$var$isRTL() ? 'right-start' : 'left-start';
var $834ee70cc5b953d1$var$PLACEMENT_TOPCENTER = 'top';
var $834ee70cc5b953d1$var$PLACEMENT_BOTTOMCENTER = 'bottom';
var $834ee70cc5b953d1$var$Default$9 = {
    autoClose: true,
    boundary: 'clippingParents',
    display: 'dynamic',
    offset: [
        0,
        2
    ],
    popperConfig: null,
    reference: 'toggle'
};
var $834ee70cc5b953d1$var$DefaultType$9 = {
    autoClose: '(boolean|string)',
    boundary: '(string|element)',
    display: 'string',
    offset: '(array|string|function)',
    popperConfig: '(null|object|function)',
    reference: '(string|element|object)'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$931cbfb6bfb85fc = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Dropdown, BaseComponent);
    function Dropdown(element, config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Dropdown);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Dropdown, [
            element,
            config
        ]);
        _this._popper = null;
        _this._parent = _this._element.parentNode; // dropdown wrapper
        // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
        _this._menu = $834ee70cc5b953d1$var$SelectorEngine.next(_this._element, $834ee70cc5b953d1$var$SELECTOR_MENU)[0] || $834ee70cc5b953d1$var$SelectorEngine.prev(_this._element, $834ee70cc5b953d1$var$SELECTOR_MENU)[0] || $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$SELECTOR_MENU, _this._parent);
        _this._inNavbar = _this._detectNavbar();
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Dropdown, [
        {
            // Public
            key: "toggle",
            value: function toggle() {
                return this._isShown() ? this.hide() : this.show();
            }
        },
        {
            key: "show",
            value: function show() {
                var _instance;
                if ($834ee70cc5b953d1$var$isDisabled(this._element) || this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                var showEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_SHOW$5, relatedTarget);
                if (showEvent.defaultPrevented) return;
                this._createPopper();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement && !this._parent.closest($834ee70cc5b953d1$var$SELECTOR_NAVBAR_NAV)) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $834ee70cc5b953d1$var$EventHandler.on(element, 'mouseover', $834ee70cc5b953d1$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._element.focus();
                this._element.setAttribute('aria-expanded', true);
                this._menu.classList.add($834ee70cc5b953d1$var$CLASS_NAME_SHOW$6);
                this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_SHOW$6);
                $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_SHOWN$5, relatedTarget);
            }
        },
        {
            key: "hide",
            value: function hide() {
                if ($834ee70cc5b953d1$var$isDisabled(this._element) || !this._isShown()) return;
                var relatedTarget = {
                    relatedTarget: this._element
                };
                this._completeHide(relatedTarget);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (this._popper) this._popper.destroy();
                (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(Dropdown.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "update",
            value: function update() {
                this._inNavbar = this._detectNavbar();
                if (this._popper) this._popper.update();
            }
        },
        {
            // Private
            key: "_completeHide",
            value: function _completeHide(relatedTarget) {
                var _instance;
                var hideEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_HIDE$5, relatedTarget);
                if (hideEvent.defaultPrevented) return;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $834ee70cc5b953d1$var$EventHandler.off(element, 'mouseover', $834ee70cc5b953d1$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (this._popper) this._popper.destroy();
                this._menu.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOW$6);
                this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOW$6);
                this._element.setAttribute('aria-expanded', 'false');
                $834ee70cc5b953d1$var$Manipulator.removeDataAttribute(this._menu, 'popper');
                $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_HIDDEN$5, relatedTarget);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                config = (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(Dropdown.prototype), "_getConfig", this).call(this, config);
                if ((0, $dvYFb._)(config.reference) === 'object' && !$834ee70cc5b953d1$var$isElement(config.reference) && typeof config.reference.getBoundingClientRect !== 'function') // Popper virtual elements require a getBoundingClientRect method
                throw new TypeError("".concat($834ee70cc5b953d1$var$NAME$a.toUpperCase(), ': Option "reference" provided type "object" without a required "getBoundingClientRect" method.'));
                return config;
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper() {
                if (typeof $d61ef8003b796318$exports === 'undefined') throw new TypeError('Bootstrap\'s dropdowns require Popper (https://popper.js.org)');
                var referenceElement = this._element;
                if (this._config.reference === 'parent') referenceElement = this._parent;
                else if ($834ee70cc5b953d1$var$isElement(this._config.reference)) referenceElement = $834ee70cc5b953d1$var$getElement(this._config.reference);
                else if ((0, $dvYFb._)(this._config.reference) === 'object') referenceElement = this._config.reference;
                var popperConfig = this._getPopperConfig();
                this._popper = $d61ef8003b796318$exports.createPopper(referenceElement, this._menu, popperConfig);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this._menu.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_SHOW$6);
            }
        },
        {
            key: "_getPlacement",
            value: function _getPlacement() {
                var parentDropdown = this._parent;
                if (parentDropdown.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_DROPEND)) return $834ee70cc5b953d1$var$PLACEMENT_RIGHT;
                if (parentDropdown.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_DROPSTART)) return $834ee70cc5b953d1$var$PLACEMENT_LEFT;
                if (parentDropdown.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_DROPUP_CENTER)) return $834ee70cc5b953d1$var$PLACEMENT_TOPCENTER;
                if (parentDropdown.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_DROPDOWN_CENTER)) return $834ee70cc5b953d1$var$PLACEMENT_BOTTOMCENTER;
                // We need to trim the value because custom properties can also include spaces
                var isEnd = getComputedStyle(this._menu).getPropertyValue('--bs-position').trim() === 'end';
                if (parentDropdown.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_DROPUP)) return isEnd ? $834ee70cc5b953d1$var$PLACEMENT_TOPEND : $834ee70cc5b953d1$var$PLACEMENT_TOP;
                return isEnd ? $834ee70cc5b953d1$var$PLACEMENT_BOTTOMEND : $834ee70cc5b953d1$var$PLACEMENT_BOTTOM;
            }
        },
        {
            key: "_detectNavbar",
            value: function _detectNavbar() {
                return this._element.closest($834ee70cc5b953d1$var$SELECTOR_NAVBAR) !== null;
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig() {
                var defaultBsPopperConfig = {
                    placement: this._getPlacement(),
                    modifiers: [
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        }
                    ]
                };
                // Disable Popper if we have a static display or Dropdown is in Navbar
                if (this._inNavbar || this._config.display === 'static') {
                    $834ee70cc5b953d1$var$Manipulator.setDataAttribute(this._menu, 'popper', 'static'); // TODO: v6 remove
                    defaultBsPopperConfig.modifiers = [
                        {
                            name: 'applyStyles',
                            enabled: false
                        }
                    ];
                }
                return (0, $d33814db45cf8e23$export$71511d61b312f219)({}, defaultBsPopperConfig, $834ee70cc5b953d1$var$execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_selectMenuItem",
            value: function _selectMenuItem(param) {
                var key = param.key, target = param.target;
                var items = $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$SELECTOR_VISIBLE_ITEMS, this._menu).filter(function(element) {
                    return $834ee70cc5b953d1$var$isVisible(element);
                });
                if (!items.length) return;
                // if target isn't included in items (e.g. when expanding the dropdown)
                // allow cycling to get the last item in case key equals ARROW_UP_KEY
                $834ee70cc5b953d1$var$getNextActiveElement(items, target, key === $834ee70cc5b953d1$var$ARROW_DOWN_KEY$1, !items.includes(target)).focus();
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$9;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$9;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$a;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Dropdown.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        },
        {
            key: "clearMenus",
            value: function clearMenus(event) {
                if (event.button === $834ee70cc5b953d1$var$RIGHT_MOUSE_BUTTON || event.type === 'keyup' && event.key !== $834ee70cc5b953d1$var$TAB_KEY$1) return;
                var openToggles = $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE_SHOWN);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = openToggles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var toggle = _step.value;
                        var context = Dropdown.getInstance(toggle);
                        if (!context || context._config.autoClose === false) continue;
                        var composedPath = event.composedPath();
                        var isMenuTarget = composedPath.includes(context._menu);
                        if (composedPath.includes(context._element) || context._config.autoClose === 'inside' && !isMenuTarget || context._config.autoClose === 'outside' && isMenuTarget) continue;
                        // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                        if (context._menu.contains(event.target) && (event.type === 'keyup' && event.key === $834ee70cc5b953d1$var$TAB_KEY$1 || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                        var relatedTarget = {
                            relatedTarget: context._element
                        };
                        if (event.type === 'click') relatedTarget.clickEvent = event;
                        context._completeHide(relatedTarget);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dataApiKeydownHandler",
            value: function dataApiKeydownHandler(event) {
                // If not an UP | DOWN | ESCAPE key => not a dropdown command
                // If input/textarea && if key is other than ESCAPE => not a dropdown command
                var isInput = /input|textarea/i.test(event.target.tagName);
                var isEscapeEvent = event.key === $834ee70cc5b953d1$var$ESCAPE_KEY$2;
                var isUpOrDownEvent = [
                    $834ee70cc5b953d1$var$ARROW_UP_KEY$1,
                    $834ee70cc5b953d1$var$ARROW_DOWN_KEY$1
                ].includes(event.key);
                if (!isUpOrDownEvent && !isEscapeEvent) return;
                if (isInput && !isEscapeEvent) return;
                event.preventDefault();
                // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
                var getToggleButton = this.matches($834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$3) ? this : $834ee70cc5b953d1$var$SelectorEngine.prev(this, $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$3)[0] || $834ee70cc5b953d1$var$SelectorEngine.next(this, $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$3)[0] || $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$3, event.delegateTarget.parentNode);
                var instance = Dropdown.getOrCreateInstance(getToggleButton);
                if (isUpOrDownEvent) {
                    event.stopPropagation();
                    instance.show();
                    instance._selectMenuItem(event);
                    return;
                }
                if (instance._isShown()) {
                    // else is escape and we check if it is shown
                    event.stopPropagation();
                    instance.hide();
                    getToggleButton.focus();
                }
            }
        }
    ]);
    return Dropdown;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * Data API implementation
 */ $834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_KEYDOWN_DATA_API, $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$3, $834ee70cc5b953d1$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_KEYDOWN_DATA_API, $834ee70cc5b953d1$var$SELECTOR_MENU, $834ee70cc5b953d1$export$931cbfb6bfb85fc.dataApiKeydownHandler);
$834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$3, $834ee70cc5b953d1$export$931cbfb6bfb85fc.clearMenus);
$834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_KEYUP_DATA_API, $834ee70cc5b953d1$export$931cbfb6bfb85fc.clearMenus);
$834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$3, $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$3, function(event) {
    event.preventDefault();
    $834ee70cc5b953d1$export$931cbfb6bfb85fc.getOrCreateInstance(this).toggle();
});
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$931cbfb6bfb85fc);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/backdrop.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$9 = 'backdrop';
var $834ee70cc5b953d1$var$CLASS_NAME_FADE$4 = 'fade';
var $834ee70cc5b953d1$var$CLASS_NAME_SHOW$5 = 'show';
var $834ee70cc5b953d1$var$EVENT_MOUSEDOWN = "mousedown.bs.".concat($834ee70cc5b953d1$var$NAME$9);
var $834ee70cc5b953d1$var$Default$8 = {
    className: 'modal-backdrop',
    clickCallback: null,
    isAnimated: false,
    isVisible: true,
    // if false, we use the backdrop helper without adding any element to the dom
    rootElement: 'body' // give the choice to place backdrop under different elements
};
var $834ee70cc5b953d1$var$DefaultType$8 = {
    className: 'string',
    clickCallback: '(function|null)',
    isAnimated: 'boolean',
    isVisible: 'boolean',
    rootElement: '(element|string)'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$var$Backdrop = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Backdrop, Config);
    function Backdrop(config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Backdrop);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Backdrop);
        _this._config = _this._getConfig(config);
        _this._isAppended = false;
        _this._element = null;
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Backdrop, [
        {
            // Public
            key: "show",
            value: function show(callback) {
                if (!this._config.isVisible) {
                    $834ee70cc5b953d1$var$execute(callback);
                    return;
                }
                this._append();
                var element = this._getElement();
                if (this._config.isAnimated) $834ee70cc5b953d1$var$reflow(element);
                element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    $834ee70cc5b953d1$var$execute(callback);
                });
            }
        },
        {
            key: "hide",
            value: function hide(callback) {
                var _this = this;
                if (!this._config.isVisible) {
                    $834ee70cc5b953d1$var$execute(callback);
                    return;
                }
                this._getElement().classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOW$5);
                this._emulateAnimation(function() {
                    _this.dispose();
                    $834ee70cc5b953d1$var$execute(callback);
                });
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                if (!this._isAppended) return;
                $834ee70cc5b953d1$var$EventHandler.off(this._element, $834ee70cc5b953d1$var$EVENT_MOUSEDOWN);
                this._element.remove();
                this._isAppended = false;
            }
        },
        {
            // Private
            key: "_getElement",
            value: function _getElement() {
                if (!this._element) {
                    var backdrop = document.createElement('div');
                    backdrop.className = this._config.className;
                    if (this._config.isAnimated) backdrop.classList.add($834ee70cc5b953d1$var$CLASS_NAME_FADE$4);
                    this._element = backdrop;
                }
                return this._element;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // use getElement() with the default "body" to get a fresh Element on each instantiation
                config.rootElement = $834ee70cc5b953d1$var$getElement(config.rootElement);
                return config;
            }
        },
        {
            key: "_append",
            value: function _append() {
                var _this = this;
                if (this._isAppended) return;
                var element = this._getElement();
                this._config.rootElement.append(element);
                $834ee70cc5b953d1$var$EventHandler.on(element, $834ee70cc5b953d1$var$EVENT_MOUSEDOWN, function() {
                    $834ee70cc5b953d1$var$execute(_this._config.clickCallback);
                });
                this._isAppended = true;
            }
        },
        {
            key: "_emulateAnimation",
            value: function _emulateAnimation(callback) {
                $834ee70cc5b953d1$var$executeAfterTransition(callback, this._getElement(), this._config.isAnimated);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$8;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$8;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$9;
            }
        }
    ]);
    return Backdrop;
}($834ee70cc5b953d1$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/focustrap.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$8 = 'focustrap';
var $834ee70cc5b953d1$var$DATA_KEY$5 = 'bs.focustrap';
var $834ee70cc5b953d1$var$EVENT_KEY$5 = ".".concat($834ee70cc5b953d1$var$DATA_KEY$5);
var $834ee70cc5b953d1$var$EVENT_FOCUSIN$2 = "focusin".concat($834ee70cc5b953d1$var$EVENT_KEY$5);
var $834ee70cc5b953d1$var$EVENT_KEYDOWN_TAB = "keydown.tab".concat($834ee70cc5b953d1$var$EVENT_KEY$5);
var $834ee70cc5b953d1$var$TAB_KEY = 'Tab';
var $834ee70cc5b953d1$var$TAB_NAV_FORWARD = 'forward';
var $834ee70cc5b953d1$var$TAB_NAV_BACKWARD = 'backward';
var $834ee70cc5b953d1$var$Default$7 = {
    autofocus: true,
    trapElement: null // The element to trap focus inside of
};
var $834ee70cc5b953d1$var$DefaultType$7 = {
    autofocus: 'boolean',
    trapElement: 'element'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$var$FocusTrap = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(FocusTrap, Config);
    function FocusTrap(config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, FocusTrap);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, FocusTrap);
        _this._config = _this._getConfig(config);
        _this._isActive = false;
        _this._lastTabNavDirection = null;
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(FocusTrap, [
        {
            // Public
            key: "activate",
            value: function activate() {
                var _this = this;
                if (this._isActive) return;
                if (this._config.autofocus) this._config.trapElement.focus();
                $834ee70cc5b953d1$var$EventHandler.off(document, $834ee70cc5b953d1$var$EVENT_KEY$5); // guard against infinite focus loop
                $834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_FOCUSIN$2, function(event) {
                    return _this._handleFocusin(event);
                });
                $834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_KEYDOWN_TAB, function(event) {
                    return _this._handleKeydown(event);
                });
                this._isActive = true;
            }
        },
        {
            key: "deactivate",
            value: function deactivate() {
                if (!this._isActive) return;
                this._isActive = false;
                $834ee70cc5b953d1$var$EventHandler.off(document, $834ee70cc5b953d1$var$EVENT_KEY$5);
            }
        },
        {
            // Private
            key: "_handleFocusin",
            value: function _handleFocusin(event) {
                var trapElement = this._config.trapElement;
                if (event.target === document || event.target === trapElement || trapElement.contains(event.target)) return;
                var elements = $834ee70cc5b953d1$var$SelectorEngine.focusableChildren(trapElement);
                if (elements.length === 0) trapElement.focus();
                else if (this._lastTabNavDirection === $834ee70cc5b953d1$var$TAB_NAV_BACKWARD) elements[elements.length - 1].focus();
                else elements[0].focus();
            }
        },
        {
            key: "_handleKeydown",
            value: function _handleKeydown(event) {
                if (event.key !== $834ee70cc5b953d1$var$TAB_KEY) return;
                this._lastTabNavDirection = event.shiftKey ? $834ee70cc5b953d1$var$TAB_NAV_BACKWARD : $834ee70cc5b953d1$var$TAB_NAV_FORWARD;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$7;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$7;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$8;
            }
        }
    ]);
    return FocusTrap;
}($834ee70cc5b953d1$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/scrollBar.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$SELECTOR_FIXED_CONTENT = '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top';
var $834ee70cc5b953d1$var$SELECTOR_STICKY_CONTENT = '.sticky-top';
var $834ee70cc5b953d1$var$PROPERTY_PADDING = 'padding-right';
var $834ee70cc5b953d1$var$PROPERTY_MARGIN = 'margin-right';
/**
 * Class definition
 */ var $834ee70cc5b953d1$var$ScrollBarHelper = /*#__PURE__*/ function() {
    "use strict";
    function ScrollBarHelper() {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, ScrollBarHelper);
        this._element = document.body;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(ScrollBarHelper, [
        {
            // Public
            key: "getWidth",
            value: function getWidth() {
                // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
                var documentWidth = document.documentElement.clientWidth;
                return Math.abs(window.innerWidth - documentWidth);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var width = this.getWidth();
                this._disableOverFlow();
                // give padding to element to balance the hidden scrollbar width
                this._setElementAttributes(this._element, $834ee70cc5b953d1$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                // trick: We adjust positive paddingRight and negative marginRight to sticky-top elements to keep showing fullwidth
                this._setElementAttributes($834ee70cc5b953d1$var$SELECTOR_FIXED_CONTENT, $834ee70cc5b953d1$var$PROPERTY_PADDING, function(calculatedValue) {
                    return calculatedValue + width;
                });
                this._setElementAttributes($834ee70cc5b953d1$var$SELECTOR_STICKY_CONTENT, $834ee70cc5b953d1$var$PROPERTY_MARGIN, function(calculatedValue) {
                    return calculatedValue - width;
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this._resetElementAttributes(this._element, 'overflow');
                this._resetElementAttributes(this._element, $834ee70cc5b953d1$var$PROPERTY_PADDING);
                this._resetElementAttributes($834ee70cc5b953d1$var$SELECTOR_FIXED_CONTENT, $834ee70cc5b953d1$var$PROPERTY_PADDING);
                this._resetElementAttributes($834ee70cc5b953d1$var$SELECTOR_STICKY_CONTENT, $834ee70cc5b953d1$var$PROPERTY_MARGIN);
            }
        },
        {
            key: "isOverflowing",
            value: function isOverflowing() {
                return this.getWidth() > 0;
            }
        },
        {
            // Private
            key: "_disableOverFlow",
            value: function _disableOverFlow() {
                this._saveInitialAttribute(this._element, 'overflow');
                this._element.style.overflow = 'hidden';
            }
        },
        {
            key: "_setElementAttributes",
            value: function _setElementAttributes(selector, styleProperty, callback) {
                var _this = this;
                var scrollbarWidth = this.getWidth();
                var manipulationCallBack = function(element) {
                    if (element !== _this._element && window.innerWidth > element.clientWidth + scrollbarWidth) return;
                    _this._saveInitialAttribute(element, styleProperty);
                    var calculatedValue = window.getComputedStyle(element).getPropertyValue(styleProperty);
                    element.style.setProperty(styleProperty, "".concat(callback(Number.parseFloat(calculatedValue)), "px"));
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_saveInitialAttribute",
            value: function _saveInitialAttribute(element, styleProperty) {
                var actualValue = element.style.getPropertyValue(styleProperty);
                if (actualValue) $834ee70cc5b953d1$var$Manipulator.setDataAttribute(element, styleProperty, actualValue);
            }
        },
        {
            key: "_resetElementAttributes",
            value: function _resetElementAttributes(selector, styleProperty) {
                var manipulationCallBack = function(element) {
                    var value = $834ee70cc5b953d1$var$Manipulator.getDataAttribute(element, styleProperty);
                    // We only want to remove the property if the value is `null`; the value can also be zero
                    if (value === null) {
                        element.style.removeProperty(styleProperty);
                        return;
                    }
                    $834ee70cc5b953d1$var$Manipulator.removeDataAttribute(element, styleProperty);
                    element.style.setProperty(styleProperty, value);
                };
                this._applyManipulationCallback(selector, manipulationCallBack);
            }
        },
        {
            key: "_applyManipulationCallback",
            value: function _applyManipulationCallback(selector, callBack) {
                if ($834ee70cc5b953d1$var$isElement(selector)) {
                    callBack(selector);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = $834ee70cc5b953d1$var$SelectorEngine.find(selector, this._element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var sel = _step.value;
                        callBack(sel);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ]);
    return ScrollBarHelper;
}();
/**
 * --------------------------------------------------------------------------
 * Bootstrap modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$7 = 'modal';
var $834ee70cc5b953d1$var$DATA_KEY$4 = 'bs.modal';
var $834ee70cc5b953d1$var$EVENT_KEY$4 = ".".concat($834ee70cc5b953d1$var$DATA_KEY$4);
var $834ee70cc5b953d1$var$DATA_API_KEY$2 = '.data-api';
var $834ee70cc5b953d1$var$ESCAPE_KEY$1 = 'Escape';
var $834ee70cc5b953d1$var$EVENT_HIDE$4 = "hide".concat($834ee70cc5b953d1$var$EVENT_KEY$4);
var $834ee70cc5b953d1$var$EVENT_HIDE_PREVENTED$1 = "hidePrevented".concat($834ee70cc5b953d1$var$EVENT_KEY$4);
var $834ee70cc5b953d1$var$EVENT_HIDDEN$4 = "hidden".concat($834ee70cc5b953d1$var$EVENT_KEY$4);
var $834ee70cc5b953d1$var$EVENT_SHOW$4 = "show".concat($834ee70cc5b953d1$var$EVENT_KEY$4);
var $834ee70cc5b953d1$var$EVENT_SHOWN$4 = "shown".concat($834ee70cc5b953d1$var$EVENT_KEY$4);
var $834ee70cc5b953d1$var$EVENT_RESIZE$1 = "resize".concat($834ee70cc5b953d1$var$EVENT_KEY$4);
var $834ee70cc5b953d1$var$EVENT_CLICK_DISMISS = "click.dismiss".concat($834ee70cc5b953d1$var$EVENT_KEY$4);
var $834ee70cc5b953d1$var$EVENT_MOUSEDOWN_DISMISS = "mousedown.dismiss".concat($834ee70cc5b953d1$var$EVENT_KEY$4);
var $834ee70cc5b953d1$var$EVENT_KEYDOWN_DISMISS$1 = "keydown.dismiss".concat($834ee70cc5b953d1$var$EVENT_KEY$4);
var $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$2 = "click".concat($834ee70cc5b953d1$var$EVENT_KEY$4).concat($834ee70cc5b953d1$var$DATA_API_KEY$2);
var $834ee70cc5b953d1$var$CLASS_NAME_OPEN = 'modal-open';
var $834ee70cc5b953d1$var$CLASS_NAME_FADE$3 = 'fade';
var $834ee70cc5b953d1$var$CLASS_NAME_SHOW$4 = 'show';
var $834ee70cc5b953d1$var$CLASS_NAME_STATIC = 'modal-static';
var $834ee70cc5b953d1$var$OPEN_SELECTOR$1 = '.modal.show';
var $834ee70cc5b953d1$var$SELECTOR_DIALOG = '.modal-dialog';
var $834ee70cc5b953d1$var$SELECTOR_MODAL_BODY = '.modal-body';
var $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$2 = '[data-bs-toggle="modal"]';
var $834ee70cc5b953d1$var$Default$6 = {
    backdrop: true,
    focus: true,
    keyboard: true
};
var $834ee70cc5b953d1$var$DefaultType$6 = {
    backdrop: '(boolean|string)',
    focus: 'boolean',
    keyboard: 'boolean'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$2b77a92f1a5ad772 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Modal, BaseComponent);
    function Modal(element, config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Modal);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Modal, [
            element,
            config
        ]);
        _this._dialog = $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$SELECTOR_DIALOG, _this._element);
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._isShown = false;
        _this._isTransitioning = false;
        _this._scrollBar = new $834ee70cc5b953d1$var$ScrollBarHelper();
        _this._addEventListeners();
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Modal, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown || this._isTransitioning) return;
                var showEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_SHOW$4, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._isTransitioning = true;
                this._scrollBar.hide();
                document.body.classList.add($834ee70cc5b953d1$var$CLASS_NAME_OPEN);
                this._adjustDialog();
                this._backdrop.show(function() {
                    return _this._showElement(relatedTarget);
                });
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown || this._isTransitioning) return;
                var hideEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_HIDE$4);
                if (hideEvent.defaultPrevented) return;
                this._isShown = false;
                this._isTransitioning = true;
                this._focustrap.deactivate();
                this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOW$4);
                this._queueCallback(function() {
                    return _this._hideModal();
                }, this._element, this._isAnimated());
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                $834ee70cc5b953d1$var$EventHandler.off(window, $834ee70cc5b953d1$var$EVENT_KEY$4);
                $834ee70cc5b953d1$var$EventHandler.off(this._dialog, $834ee70cc5b953d1$var$EVENT_KEY$4);
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(Modal.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "handleUpdate",
            value: function handleUpdate() {
                this._adjustDialog();
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                return new $834ee70cc5b953d1$var$Backdrop({
                    isVisible: Boolean(this._config.backdrop),
                    // 'static' option will be translated to true, and booleans will keep their value,
                    isAnimated: this._isAnimated()
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $834ee70cc5b953d1$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_showElement",
            value: function _showElement(relatedTarget) {
                var _this = this;
                // try to append dynamic modal
                if (!document.body.contains(this._element)) document.body.append(this._element);
                this._element.style.display = 'block';
                this._element.removeAttribute('aria-hidden');
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.scrollTop = 0;
                var modalBody = $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$SELECTOR_MODAL_BODY, this._dialog);
                if (modalBody) modalBody.scrollTop = 0;
                $834ee70cc5b953d1$var$reflow(this._element);
                this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_SHOW$4);
                var transitionComplete = function() {
                    if (_this._config.focus) _this._focustrap.activate();
                    _this._isTransitioning = false;
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, $834ee70cc5b953d1$var$EVENT_SHOWN$4, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(transitionComplete, this._dialog, this._isAnimated());
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_KEYDOWN_DISMISS$1, function(event) {
                    if (event.key !== $834ee70cc5b953d1$var$ESCAPE_KEY$1) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    _this._triggerBackdropTransition();
                });
                $834ee70cc5b953d1$var$EventHandler.on(window, $834ee70cc5b953d1$var$EVENT_RESIZE$1, function() {
                    if (_this._isShown && !_this._isTransitioning) _this._adjustDialog();
                });
                $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_MOUSEDOWN_DISMISS, function(event) {
                    // a bad trick to segregate clicks that may start inside dialog but end outside, and avoid listen to scrollbar clicks
                    $834ee70cc5b953d1$var$EventHandler.one(_this._element, $834ee70cc5b953d1$var$EVENT_CLICK_DISMISS, function(event2) {
                        if (_this._element !== event.target || _this._element !== event2.target) return;
                        if (_this._config.backdrop === 'static') {
                            _this._triggerBackdropTransition();
                            return;
                        }
                        if (_this._config.backdrop) _this.hide();
                    });
                });
            }
        },
        {
            key: "_hideModal",
            value: function _hideModal() {
                var _this = this;
                this._element.style.display = 'none';
                this._element.setAttribute('aria-hidden', true);
                this._element.removeAttribute('aria-modal');
                this._element.removeAttribute('role');
                this._isTransitioning = false;
                this._backdrop.hide(function() {
                    document.body.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_OPEN);
                    _this._resetAdjustments();
                    _this._scrollBar.reset();
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, $834ee70cc5b953d1$var$EVENT_HIDDEN$4);
                });
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._element.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_FADE$3);
            }
        },
        {
            key: "_triggerBackdropTransition",
            value: function _triggerBackdropTransition() {
                var _this = this;
                var hideEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_HIDE_PREVENTED$1);
                if (hideEvent.defaultPrevented) return;
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var initialOverflowY = this._element.style.overflowY;
                // return if the following background transition hasn't yet completed
                if (initialOverflowY === 'hidden' || this._element.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_STATIC)) return;
                if (!isModalOverflowing) this._element.style.overflowY = 'hidden';
                this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_STATIC);
                this._queueCallback(function() {
                    _this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_STATIC);
                    _this._queueCallback(function() {
                        _this._element.style.overflowY = initialOverflowY;
                    }, _this._dialog);
                }, this._dialog);
                this._element.focus();
            }
        },
        {
            /**
   * The following methods are used to handle overflowing modals
   */ key: "_adjustDialog",
            value: function _adjustDialog() {
                var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                var scrollbarWidth = this._scrollBar.getWidth();
                var isBodyOverflowing = scrollbarWidth > 0;
                if (isBodyOverflowing && !isModalOverflowing) {
                    var property = $834ee70cc5b953d1$var$isRTL() ? 'paddingLeft' : 'paddingRight';
                    this._element.style[property] = "".concat(scrollbarWidth, "px");
                }
                if (!isBodyOverflowing && isModalOverflowing) {
                    var property1 = $834ee70cc5b953d1$var$isRTL() ? 'paddingRight' : 'paddingLeft';
                    this._element.style[property1] = "".concat(scrollbarWidth, "px");
                }
            }
        },
        {
            key: "_resetAdjustments",
            value: function _resetAdjustments() {
                this._element.style.paddingLeft = '';
                this._element.style.paddingRight = '';
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$6;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$6;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$7;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config, relatedTarget) {
                return this.each(function() {
                    var data = Modal.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](relatedTarget);
                });
            }
        }
    ]);
    return Modal;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * Data API implementation
 */ $834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$2, $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$2, function(event) {
    var _this = this;
    var target = $834ee70cc5b953d1$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    $834ee70cc5b953d1$var$EventHandler.one(target, $834ee70cc5b953d1$var$EVENT_SHOW$4, function(showEvent) {
        if (showEvent.defaultPrevented) // only register focus restorer if modal will actually get shown
        return;
        $834ee70cc5b953d1$var$EventHandler.one(target, $834ee70cc5b953d1$var$EVENT_HIDDEN$4, function() {
            if ($834ee70cc5b953d1$var$isVisible(_this)) _this.focus();
        });
    });
    // avoid conflict when clicking modal toggler while another one is open
    var alreadyOpen = $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$OPEN_SELECTOR$1);
    if (alreadyOpen) $834ee70cc5b953d1$export$2b77a92f1a5ad772.getInstance(alreadyOpen).hide();
    var data = $834ee70cc5b953d1$export$2b77a92f1a5ad772.getOrCreateInstance(target);
    data.toggle(this);
});
$834ee70cc5b953d1$var$enableDismissTrigger($834ee70cc5b953d1$export$2b77a92f1a5ad772);
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$2b77a92f1a5ad772);
/**
 * --------------------------------------------------------------------------
 * Bootstrap offcanvas.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$6 = 'offcanvas';
var $834ee70cc5b953d1$var$DATA_KEY$3 = 'bs.offcanvas';
var $834ee70cc5b953d1$var$EVENT_KEY$3 = ".".concat($834ee70cc5b953d1$var$DATA_KEY$3);
var $834ee70cc5b953d1$var$DATA_API_KEY$1 = '.data-api';
var $834ee70cc5b953d1$var$EVENT_LOAD_DATA_API$2 = "load".concat($834ee70cc5b953d1$var$EVENT_KEY$3).concat($834ee70cc5b953d1$var$DATA_API_KEY$1);
var $834ee70cc5b953d1$var$ESCAPE_KEY = 'Escape';
var $834ee70cc5b953d1$var$CLASS_NAME_SHOW$3 = 'show';
var $834ee70cc5b953d1$var$CLASS_NAME_SHOWING$1 = 'showing';
var $834ee70cc5b953d1$var$CLASS_NAME_HIDING = 'hiding';
var $834ee70cc5b953d1$var$CLASS_NAME_BACKDROP = 'offcanvas-backdrop';
var $834ee70cc5b953d1$var$OPEN_SELECTOR = '.offcanvas.show';
var $834ee70cc5b953d1$var$EVENT_SHOW$3 = "show".concat($834ee70cc5b953d1$var$EVENT_KEY$3);
var $834ee70cc5b953d1$var$EVENT_SHOWN$3 = "shown".concat($834ee70cc5b953d1$var$EVENT_KEY$3);
var $834ee70cc5b953d1$var$EVENT_HIDE$3 = "hide".concat($834ee70cc5b953d1$var$EVENT_KEY$3);
var $834ee70cc5b953d1$var$EVENT_HIDE_PREVENTED = "hidePrevented".concat($834ee70cc5b953d1$var$EVENT_KEY$3);
var $834ee70cc5b953d1$var$EVENT_HIDDEN$3 = "hidden".concat($834ee70cc5b953d1$var$EVENT_KEY$3);
var $834ee70cc5b953d1$var$EVENT_RESIZE = "resize".concat($834ee70cc5b953d1$var$EVENT_KEY$3);
var $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$1 = "click".concat($834ee70cc5b953d1$var$EVENT_KEY$3).concat($834ee70cc5b953d1$var$DATA_API_KEY$1);
var $834ee70cc5b953d1$var$EVENT_KEYDOWN_DISMISS = "keydown.dismiss".concat($834ee70cc5b953d1$var$EVENT_KEY$3);
var $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$1 = '[data-bs-toggle="offcanvas"]';
var $834ee70cc5b953d1$var$Default$5 = {
    backdrop: true,
    keyboard: true,
    scroll: false
};
var $834ee70cc5b953d1$var$DefaultType$5 = {
    backdrop: '(boolean|string)',
    keyboard: 'boolean',
    scroll: 'boolean'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$591ca0244c9dfcd4 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Offcanvas, BaseComponent);
    function Offcanvas(element, config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Offcanvas);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Offcanvas, [
            element,
            config
        ]);
        _this._isShown = false;
        _this._backdrop = _this._initializeBackDrop();
        _this._focustrap = _this._initializeFocusTrap();
        _this._addEventListeners();
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Offcanvas, [
        {
            // Public
            key: "toggle",
            value: function toggle(relatedTarget) {
                return this._isShown ? this.hide() : this.show(relatedTarget);
            }
        },
        {
            key: "show",
            value: function show(relatedTarget) {
                var _this = this;
                if (this._isShown) return;
                var showEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_SHOW$3, {
                    relatedTarget: relatedTarget
                });
                if (showEvent.defaultPrevented) return;
                this._isShown = true;
                this._backdrop.show();
                if (!this._config.scroll) new $834ee70cc5b953d1$var$ScrollBarHelper().hide();
                this._element.setAttribute('aria-modal', true);
                this._element.setAttribute('role', 'dialog');
                this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_SHOWING$1);
                var completeCallBack = function() {
                    if (!_this._config.scroll || _this._config.backdrop) _this._focustrap.activate();
                    _this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_SHOW$3);
                    _this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOWING$1);
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, $834ee70cc5b953d1$var$EVENT_SHOWN$3, {
                        relatedTarget: relatedTarget
                    });
                };
                this._queueCallback(completeCallBack, this._element, true);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this._isShown) return;
                var hideEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_HIDE$3);
                if (hideEvent.defaultPrevented) return;
                this._focustrap.deactivate();
                this._element.blur();
                this._isShown = false;
                this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_HIDING);
                this._backdrop.hide();
                var completeCallback = function() {
                    _this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOW$3, $834ee70cc5b953d1$var$CLASS_NAME_HIDING);
                    _this._element.removeAttribute('aria-modal');
                    _this._element.removeAttribute('role');
                    if (!_this._config.scroll) new $834ee70cc5b953d1$var$ScrollBarHelper().reset();
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, $834ee70cc5b953d1$var$EVENT_HIDDEN$3);
                };
                this._queueCallback(completeCallback, this._element, true);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._backdrop.dispose();
                this._focustrap.deactivate();
                (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(Offcanvas.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_initializeBackDrop",
            value: function _initializeBackDrop() {
                var _this = this;
                var clickCallback = function() {
                    if (_this._config.backdrop === 'static') {
                        $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, $834ee70cc5b953d1$var$EVENT_HIDE_PREVENTED);
                        return;
                    }
                    _this.hide();
                };
                // 'static' option will be translated to true, and booleans will keep their value
                var isVisible = Boolean(this._config.backdrop);
                return new $834ee70cc5b953d1$var$Backdrop({
                    className: $834ee70cc5b953d1$var$CLASS_NAME_BACKDROP,
                    isVisible: isVisible,
                    isAnimated: true,
                    rootElement: this._element.parentNode,
                    clickCallback: isVisible ? clickCallback : null
                });
            }
        },
        {
            key: "_initializeFocusTrap",
            value: function _initializeFocusTrap() {
                return new $834ee70cc5b953d1$var$FocusTrap({
                    trapElement: this._element
                });
            }
        },
        {
            key: "_addEventListeners",
            value: function _addEventListeners() {
                var _this = this;
                $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_KEYDOWN_DISMISS, function(event) {
                    if (event.key !== $834ee70cc5b953d1$var$ESCAPE_KEY) return;
                    if (_this._config.keyboard) {
                        _this.hide();
                        return;
                    }
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, $834ee70cc5b953d1$var$EVENT_HIDE_PREVENTED);
                });
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$5;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$5;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$6;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Offcanvas.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config](this);
                });
            }
        }
    ]);
    return Offcanvas;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * Data API implementation
 */ $834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API$1, $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE$1, function(event) {
    var _this = this;
    var target = $834ee70cc5b953d1$var$SelectorEngine.getElementFromSelector(this);
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($834ee70cc5b953d1$var$isDisabled(this)) return;
    $834ee70cc5b953d1$var$EventHandler.one(target, $834ee70cc5b953d1$var$EVENT_HIDDEN$3, function() {
        // focus on trigger when it is closed
        if ($834ee70cc5b953d1$var$isVisible(_this)) _this.focus();
    });
    // avoid conflict when clicking a toggler of an offcanvas, while another is open
    var alreadyOpen = $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$OPEN_SELECTOR);
    if (alreadyOpen && alreadyOpen !== target) $834ee70cc5b953d1$export$591ca0244c9dfcd4.getInstance(alreadyOpen).hide();
    var data = $834ee70cc5b953d1$export$591ca0244c9dfcd4.getOrCreateInstance(target);
    data.toggle(this);
});
$834ee70cc5b953d1$var$EventHandler.on(window, $834ee70cc5b953d1$var$EVENT_LOAD_DATA_API$2, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$OPEN_SELECTOR)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var selector = _step.value;
            $834ee70cc5b953d1$export$591ca0244c9dfcd4.getOrCreateInstance(selector).show();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$834ee70cc5b953d1$var$EventHandler.on(window, $834ee70cc5b953d1$var$EVENT_RESIZE, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $834ee70cc5b953d1$var$SelectorEngine.find('[aria-modal][class*=show][class*=offcanvas-]')[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            if (getComputedStyle(element).position !== 'fixed') $834ee70cc5b953d1$export$591ca0244c9dfcd4.getOrCreateInstance(element).hide();
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
$834ee70cc5b953d1$var$enableDismissTrigger($834ee70cc5b953d1$export$591ca0244c9dfcd4);
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$591ca0244c9dfcd4);
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/sanitizer.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ // js-docs-start allow-list
var $834ee70cc5b953d1$var$ARIA_ATTRIBUTE_PATTERN = /^aria-[\w-]*$/i;
var $834ee70cc5b953d1$var$DefaultAllowlist = {
    // Global attributes allowed on any supplied element below.
    '*': [
        'class',
        'dir',
        'id',
        'lang',
        'role',
        $834ee70cc5b953d1$var$ARIA_ATTRIBUTE_PATTERN
    ],
    a: [
        'target',
        'href',
        'title',
        'rel'
    ],
    area: [],
    b: [],
    br: [],
    col: [],
    code: [],
    div: [],
    em: [],
    hr: [],
    h1: [],
    h2: [],
    h3: [],
    h4: [],
    h5: [],
    h6: [],
    i: [],
    img: [
        'src',
        'srcset',
        'alt',
        'title',
        'width',
        'height'
    ],
    li: [],
    ol: [],
    p: [],
    pre: [],
    s: [],
    small: [],
    span: [],
    sub: [],
    sup: [],
    strong: [],
    u: [],
    ul: []
};
// js-docs-end allow-list
var $834ee70cc5b953d1$var$uriAttributes = new Set([
    'background',
    'cite',
    'href',
    'itemtype',
    'longdesc',
    'poster',
    'src',
    'xlink:href'
]);
/**
 * A pattern that recognizes URLs that are safe wrt. XSS in URL navigation
 * contexts.
 *
 * Shout-out to Angular https://github.com/angular/angular/blob/15.2.8/packages/core/src/sanitization/url_sanitizer.ts#L38
 */ // eslint-disable-next-line unicorn/better-regex
var $834ee70cc5b953d1$var$SAFE_URL_PATTERN = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i;
var $834ee70cc5b953d1$var$allowedAttribute = function(attribute, allowedAttributeList) {
    var attributeName = attribute.nodeName.toLowerCase();
    if (allowedAttributeList.includes(attributeName)) {
        if ($834ee70cc5b953d1$var$uriAttributes.has(attributeName)) return Boolean($834ee70cc5b953d1$var$SAFE_URL_PATTERN.test(attribute.nodeValue));
        return true;
    }
    // Check if a regular expression validates the attribute.
    return allowedAttributeList.filter(function(attributeRegex) {
        return attributeRegex instanceof RegExp;
    }).some(function(regex) {
        return regex.test(attributeName);
    });
};
function $834ee70cc5b953d1$var$sanitizeHtml(unsafeHtml, allowList, sanitizeFunction) {
    var _instance;
    if (!unsafeHtml.length) return unsafeHtml;
    if (sanitizeFunction && typeof sanitizeFunction === 'function') return sanitizeFunction(unsafeHtml);
    var domParser = new window.DOMParser();
    var createdDocument = domParser.parseFromString(unsafeHtml, 'text/html');
    var elements = (_instance = []).concat.apply(_instance, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(createdDocument.body.querySelectorAll('*')));
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            var _instance1;
            var elementName = element.nodeName.toLowerCase();
            if (!Object.keys(allowList).includes(elementName)) {
                element.remove();
                continue;
            }
            var attributeList = (_instance1 = []).concat.apply(_instance1, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(element.attributes));
            var allowedAttributes = [].concat(allowList['*'] || [], allowList[elementName] || []);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = attributeList[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var attribute = _step1.value;
                    if (!$834ee70cc5b953d1$var$allowedAttribute(attribute, allowedAttributes)) element.removeAttribute(attribute.nodeName);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return createdDocument.body.innerHTML;
}
/**
 * --------------------------------------------------------------------------
 * Bootstrap util/template-factory.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$5 = 'TemplateFactory';
var $834ee70cc5b953d1$var$Default$4 = {
    allowList: $834ee70cc5b953d1$var$DefaultAllowlist,
    content: {},
    // { selector : text ,  selector2 : text2 , }
    extraClass: '',
    html: false,
    sanitize: true,
    sanitizeFn: null,
    template: '<div></div>'
};
var $834ee70cc5b953d1$var$DefaultType$4 = {
    allowList: 'object',
    content: 'object',
    extraClass: '(string|function)',
    html: 'boolean',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    template: 'string'
};
var $834ee70cc5b953d1$var$DefaultContentType = {
    entry: '(string|element|function|null)',
    selector: '(string|element)'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$var$TemplateFactory = /*#__PURE__*/ function(Config) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(TemplateFactory, Config);
    function TemplateFactory(config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, TemplateFactory);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, TemplateFactory);
        _this._config = _this._getConfig(config);
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(TemplateFactory, [
        {
            // Public
            key: "getContent",
            value: function getContent() {
                var _this = this;
                return Object.values(this._config.content).map(function(config) {
                    return _this._resolvePossibleFunction(config);
                }).filter(Boolean);
            }
        },
        {
            key: "hasContent",
            value: function hasContent() {
                return this.getContent().length > 0;
            }
        },
        {
            key: "changeContent",
            value: function changeContent(content) {
                this._checkContent(content);
                this._config.content = (0, $d33814db45cf8e23$export$71511d61b312f219)({}, this._config.content, content);
                return this;
            }
        },
        {
            key: "toHtml",
            value: function toHtml() {
                var _template_classList;
                var templateWrapper = document.createElement('div');
                templateWrapper.innerHTML = this._maybeSanitize(this._config.template);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config.content)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], text = _step_value[1];
                        this._setContent(templateWrapper, text, selector);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var template = templateWrapper.children[0];
                var extraClass = this._resolvePossibleFunction(this._config.extraClass);
                if (extraClass) (_template_classList = template.classList).add.apply(_template_classList, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(extraClass.split(' ')));
                return template;
            }
        },
        {
            // Private
            key: "_typeCheckConfig",
            value: function _typeCheckConfig(config) {
                (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, config);
                this._checkContent(config.content);
            }
        },
        {
            key: "_checkContent",
            value: function _checkContent(arg) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(arg)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), selector = _step_value[0], content = _step_value[1];
                        (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(TemplateFactory.prototype), "_typeCheckConfig", this).call(this, {
                            selector: selector,
                            entry: content
                        }, $834ee70cc5b953d1$var$DefaultContentType);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setContent",
            value: function _setContent(template, content, selector) {
                var templateElement = $834ee70cc5b953d1$var$SelectorEngine.findOne(selector, template);
                if (!templateElement) return;
                content = this._resolvePossibleFunction(content);
                if (!content) {
                    templateElement.remove();
                    return;
                }
                if ($834ee70cc5b953d1$var$isElement(content)) {
                    this._putElementInTemplate($834ee70cc5b953d1$var$getElement(content), templateElement);
                    return;
                }
                if (this._config.html) {
                    templateElement.innerHTML = this._maybeSanitize(content);
                    return;
                }
                templateElement.textContent = content;
            }
        },
        {
            key: "_maybeSanitize",
            value: function _maybeSanitize(arg) {
                return this._config.sanitize ? $834ee70cc5b953d1$var$sanitizeHtml(arg, this._config.allowList, this._config.sanitizeFn) : arg;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $834ee70cc5b953d1$var$execute(arg, [
                    this
                ]);
            }
        },
        {
            key: "_putElementInTemplate",
            value: function _putElementInTemplate(element, templateElement) {
                if (this._config.html) {
                    templateElement.innerHTML = '';
                    templateElement.append(element);
                    return;
                }
                templateElement.textContent = element.textContent;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$4;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$4;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$5;
            }
        }
    ]);
    return TemplateFactory;
}($834ee70cc5b953d1$var$Config);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tooltip.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$4 = 'tooltip';
var $834ee70cc5b953d1$var$DISALLOWED_ATTRIBUTES = new Set([
    'sanitize',
    'allowList',
    'sanitizeFn'
]);
var $834ee70cc5b953d1$var$CLASS_NAME_FADE$2 = 'fade';
var $834ee70cc5b953d1$var$CLASS_NAME_MODAL = 'modal';
var $834ee70cc5b953d1$var$CLASS_NAME_SHOW$2 = 'show';
var $834ee70cc5b953d1$var$SELECTOR_TOOLTIP_INNER = '.tooltip-inner';
var $834ee70cc5b953d1$var$SELECTOR_MODAL = ".".concat($834ee70cc5b953d1$var$CLASS_NAME_MODAL);
var $834ee70cc5b953d1$var$EVENT_MODAL_HIDE = 'hide.bs.modal';
var $834ee70cc5b953d1$var$TRIGGER_HOVER = 'hover';
var $834ee70cc5b953d1$var$TRIGGER_FOCUS = 'focus';
var $834ee70cc5b953d1$var$TRIGGER_CLICK = 'click';
var $834ee70cc5b953d1$var$TRIGGER_MANUAL = 'manual';
var $834ee70cc5b953d1$var$EVENT_HIDE$2 = 'hide';
var $834ee70cc5b953d1$var$EVENT_HIDDEN$2 = 'hidden';
var $834ee70cc5b953d1$var$EVENT_SHOW$2 = 'show';
var $834ee70cc5b953d1$var$EVENT_SHOWN$2 = 'shown';
var $834ee70cc5b953d1$var$EVENT_INSERTED = 'inserted';
var $834ee70cc5b953d1$var$EVENT_CLICK$1 = 'click';
var $834ee70cc5b953d1$var$EVENT_FOCUSIN$1 = 'focusin';
var $834ee70cc5b953d1$var$EVENT_FOCUSOUT$1 = 'focusout';
var $834ee70cc5b953d1$var$EVENT_MOUSEENTER = 'mouseenter';
var $834ee70cc5b953d1$var$EVENT_MOUSELEAVE = 'mouseleave';
var $834ee70cc5b953d1$var$AttachmentMap = {
    AUTO: 'auto',
    TOP: 'top',
    RIGHT: $834ee70cc5b953d1$var$isRTL() ? 'left' : 'right',
    BOTTOM: 'bottom',
    LEFT: $834ee70cc5b953d1$var$isRTL() ? 'right' : 'left'
};
var $834ee70cc5b953d1$var$Default$3 = {
    allowList: $834ee70cc5b953d1$var$DefaultAllowlist,
    animation: true,
    boundary: 'clippingParents',
    container: false,
    customClass: '',
    delay: 0,
    fallbackPlacements: [
        'top',
        'right',
        'bottom',
        'left'
    ],
    html: false,
    offset: [
        0,
        6
    ],
    placement: 'top',
    popperConfig: null,
    sanitize: true,
    sanitizeFn: null,
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    title: '',
    trigger: 'hover focus'
};
var $834ee70cc5b953d1$var$DefaultType$3 = {
    allowList: 'object',
    animation: 'boolean',
    boundary: '(string|element)',
    container: '(string|element|boolean)',
    customClass: '(string|function)',
    delay: '(number|object)',
    fallbackPlacements: 'array',
    html: 'boolean',
    offset: '(array|string|function)',
    placement: '(string|function)',
    popperConfig: '(null|object|function)',
    sanitize: 'boolean',
    sanitizeFn: '(null|function)',
    selector: '(string|boolean)',
    template: 'string',
    title: '(string|element|function)',
    trigger: 'string'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$28c660c63b792dea = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Tooltip, BaseComponent);
    function Tooltip(element, config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Tooltip);
        var _this;
        if (typeof $d61ef8003b796318$exports === 'undefined') throw new TypeError('Bootstrap\'s tooltips require Popper (https://popper.js.org)');
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Tooltip, [
            element,
            config
        ]);
        // Private
        _this._isEnabled = true;
        _this._timeout = 0;
        _this._isHovered = null;
        _this._activeTrigger = {};
        _this._popper = null;
        _this._templateFactory = null;
        _this._newContent = null;
        // Protected
        _this.tip = null;
        _this._setListeners();
        if (!_this._config.selector) _this._fixTitle();
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Tooltip, [
        {
            // Public
            key: "enable",
            value: function enable() {
                this._isEnabled = true;
            }
        },
        {
            key: "disable",
            value: function disable() {
                this._isEnabled = false;
            }
        },
        {
            key: "toggleEnabled",
            value: function toggleEnabled() {
                this._isEnabled = !this._isEnabled;
            }
        },
        {
            key: "toggle",
            value: function toggle() {
                if (!this._isEnabled) return;
                this._activeTrigger.click = !this._activeTrigger.click;
                if (this._isShown()) {
                    this._leave();
                    return;
                }
                this._enter();
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                clearTimeout(this._timeout);
                $834ee70cc5b953d1$var$EventHandler.off(this._element.closest($834ee70cc5b953d1$var$SELECTOR_MODAL), $834ee70cc5b953d1$var$EVENT_MODAL_HIDE, this._hideModalHandler);
                if (this._element.getAttribute('data-bs-original-title')) this._element.setAttribute('title', this._element.getAttribute('data-bs-original-title'));
                this._disposePopper();
                (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(Tooltip.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "show",
            value: function show() {
                var _this = this;
                var _instance;
                if (this._element.style.display === 'none') throw new Error('Please use show on visible elements');
                if (!(this._isWithContent() && this._isEnabled)) return;
                var showEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, this.constructor.eventName($834ee70cc5b953d1$var$EVENT_SHOW$2));
                var shadowRoot = $834ee70cc5b953d1$var$findShadowRoot(this._element);
                var isInTheDom = (shadowRoot || this._element.ownerDocument.documentElement).contains(this._element);
                if (showEvent.defaultPrevented || !isInTheDom) return;
                // TODO: v6 remove this or make it optional
                this._disposePopper();
                var tip = this._getTipElement();
                this._element.setAttribute('aria-describedby', tip.getAttribute('id'));
                var container = this._config.container;
                if (!this._element.ownerDocument.documentElement.contains(this.tip)) {
                    container.append(tip);
                    $834ee70cc5b953d1$var$EventHandler.trigger(this._element, this.constructor.eventName($834ee70cc5b953d1$var$EVENT_INSERTED));
                }
                this._popper = this._createPopper(tip);
                tip.classList.add($834ee70cc5b953d1$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we add extra
                // empty mouseover listeners to the body's immediate children;
                // only needed because of broken event delegation on iOS
                // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $834ee70cc5b953d1$var$EventHandler.on(element, 'mouseover', $834ee70cc5b953d1$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var complete = function() {
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, _this.constructor.eventName($834ee70cc5b953d1$var$EVENT_SHOWN$2));
                    if (_this._isHovered === false) _this._leave();
                    _this._isHovered = false;
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                var _instance;
                if (!this._isShown()) return;
                var hideEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, this.constructor.eventName($834ee70cc5b953d1$var$EVENT_HIDE$2));
                if (hideEvent.defaultPrevented) return;
                var tip = this._getTipElement();
                tip.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOW$2);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                // If this is a touch-enabled device we remove the extra
                // empty mouseover listeners we added for iOS support
                if ('ontouchstart' in document.documentElement) try {
                    for(var _iterator = (_instance = []).concat.apply(_instance, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var element = _step.value;
                        $834ee70cc5b953d1$var$EventHandler.off(element, 'mouseover', $834ee70cc5b953d1$var$noop);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._activeTrigger[$834ee70cc5b953d1$var$TRIGGER_CLICK] = false;
                this._activeTrigger[$834ee70cc5b953d1$var$TRIGGER_FOCUS] = false;
                this._activeTrigger[$834ee70cc5b953d1$var$TRIGGER_HOVER] = false;
                this._isHovered = null; // it is a trick to support manual triggering
                var complete = function() {
                    if (_this._isWithActiveTrigger()) return;
                    if (!_this._isHovered) _this._disposePopper();
                    _this._element.removeAttribute('aria-describedby');
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, _this.constructor.eventName($834ee70cc5b953d1$var$EVENT_HIDDEN$2));
                };
                this._queueCallback(complete, this.tip, this._isAnimated());
            }
        },
        {
            key: "update",
            value: function update() {
                if (this._popper) this._popper.update();
            }
        },
        {
            // Protected
            key: "_isWithContent",
            value: function _isWithContent() {
                return Boolean(this._getTitle());
            }
        },
        {
            key: "_getTipElement",
            value: function _getTipElement() {
                if (!this.tip) this.tip = this._createTipElement(this._newContent || this._getContentForTemplate());
                return this.tip;
            }
        },
        {
            key: "_createTipElement",
            value: function _createTipElement(content) {
                var tip = this._getTemplateFactory(content).toHtml();
                // TODO: remove this check in v6
                if (!tip) return null;
                tip.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_FADE$2, $834ee70cc5b953d1$var$CLASS_NAME_SHOW$2);
                // TODO: v6 the following can be achieved with CSS only
                tip.classList.add("bs-".concat(this.constructor.NAME, "-auto"));
                var tipId = $834ee70cc5b953d1$var$getUID(this.constructor.NAME).toString();
                tip.setAttribute('id', tipId);
                if (this._isAnimated()) tip.classList.add($834ee70cc5b953d1$var$CLASS_NAME_FADE$2);
                return tip;
            }
        },
        {
            key: "setContent",
            value: function setContent(content) {
                this._newContent = content;
                if (this._isShown()) {
                    this._disposePopper();
                    this.show();
                }
            }
        },
        {
            key: "_getTemplateFactory",
            value: function _getTemplateFactory(content) {
                if (this._templateFactory) this._templateFactory.changeContent(content);
                else this._templateFactory = new $834ee70cc5b953d1$var$TemplateFactory((0, $234c1bbf5d6bbebf$export$71511d61b312f219)((0, $d33814db45cf8e23$export$71511d61b312f219)({}, this._config), {
                    // the `content` var has to be after `this._config`
                    // to override config.content in case of popover
                    content: content,
                    extraClass: this._resolvePossibleFunction(this._config.customClass)
                }));
                return this._templateFactory;
            }
        },
        {
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                return (0, $6194eebaf067e4d1$export$71511d61b312f219)({}, $834ee70cc5b953d1$var$SELECTOR_TOOLTIP_INNER, this._getTitle());
            }
        },
        {
            key: "_getTitle",
            value: function _getTitle() {
                return this._resolvePossibleFunction(this._config.title) || this._element.getAttribute('data-bs-original-title');
            }
        },
        {
            // Private
            key: "_initializeOnDelegatedTarget",
            value: function _initializeOnDelegatedTarget(event) {
                return this.constructor.getOrCreateInstance(event.delegateTarget, this._getDelegateConfig());
            }
        },
        {
            key: "_isAnimated",
            value: function _isAnimated() {
                return this._config.animation || this.tip && this.tip.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_FADE$2);
            }
        },
        {
            key: "_isShown",
            value: function _isShown() {
                return this.tip && this.tip.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_SHOW$2);
            }
        },
        {
            key: "_createPopper",
            value: function _createPopper(tip) {
                var placement = $834ee70cc5b953d1$var$execute(this._config.placement, [
                    this,
                    tip,
                    this._element
                ]);
                var attachment = $834ee70cc5b953d1$var$AttachmentMap[placement.toUpperCase()];
                return $d61ef8003b796318$exports.createPopper(this._element, tip, this._getPopperConfig(attachment));
            }
        },
        {
            key: "_getOffset",
            value: function _getOffset() {
                var _this = this;
                var offset = this._config.offset;
                if (typeof offset === 'string') return offset.split(',').map(function(value) {
                    return Number.parseInt(value, 10);
                });
                if (typeof offset === 'function') return function(popperData) {
                    return offset(popperData, _this._element);
                };
                return offset;
            }
        },
        {
            key: "_resolvePossibleFunction",
            value: function _resolvePossibleFunction(arg) {
                return $834ee70cc5b953d1$var$execute(arg, [
                    this._element
                ]);
            }
        },
        {
            key: "_getPopperConfig",
            value: function _getPopperConfig(attachment) {
                var _this = this;
                var defaultBsPopperConfig = {
                    placement: attachment,
                    modifiers: [
                        {
                            name: 'flip',
                            options: {
                                fallbackPlacements: this._config.fallbackPlacements
                            }
                        },
                        {
                            name: 'offset',
                            options: {
                                offset: this._getOffset()
                            }
                        },
                        {
                            name: 'preventOverflow',
                            options: {
                                boundary: this._config.boundary
                            }
                        },
                        {
                            name: 'arrow',
                            options: {
                                element: ".".concat(this.constructor.NAME, "-arrow")
                            }
                        },
                        {
                            name: 'preSetPlacement',
                            enabled: true,
                            phase: 'beforeMain',
                            fn: function(data) {
                                // Pre-set Popper's placement attribute in order to read the arrow sizes properly.
                                // Otherwise, Popper mixes up the width and height dimensions since the initial arrow style is for top placement
                                _this._getTipElement().setAttribute('data-popper-placement', data.state.placement);
                            }
                        }
                    ]
                };
                return (0, $d33814db45cf8e23$export$71511d61b312f219)({}, defaultBsPopperConfig, $834ee70cc5b953d1$var$execute(this._config.popperConfig, [
                    defaultBsPopperConfig
                ]));
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                var triggers = this._config.trigger.split(' ');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = triggers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var trigger = _step.value;
                        if (trigger === 'click') $834ee70cc5b953d1$var$EventHandler.on(this._element, this.constructor.eventName($834ee70cc5b953d1$var$EVENT_CLICK$1), this._config.selector, function(event) {
                            var context = _this._initializeOnDelegatedTarget(event);
                            context.toggle();
                        });
                        else if (trigger !== $834ee70cc5b953d1$var$TRIGGER_MANUAL) {
                            var eventIn = trigger === $834ee70cc5b953d1$var$TRIGGER_HOVER ? this.constructor.eventName($834ee70cc5b953d1$var$EVENT_MOUSEENTER) : this.constructor.eventName($834ee70cc5b953d1$var$EVENT_FOCUSIN$1);
                            var eventOut = trigger === $834ee70cc5b953d1$var$TRIGGER_HOVER ? this.constructor.eventName($834ee70cc5b953d1$var$EVENT_MOUSELEAVE) : this.constructor.eventName($834ee70cc5b953d1$var$EVENT_FOCUSOUT$1);
                            $834ee70cc5b953d1$var$EventHandler.on(this._element, eventIn, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusin' ? $834ee70cc5b953d1$var$TRIGGER_FOCUS : $834ee70cc5b953d1$var$TRIGGER_HOVER] = true;
                                context._enter();
                            });
                            $834ee70cc5b953d1$var$EventHandler.on(this._element, eventOut, this._config.selector, function(event) {
                                var context = _this._initializeOnDelegatedTarget(event);
                                context._activeTrigger[event.type === 'focusout' ? $834ee70cc5b953d1$var$TRIGGER_FOCUS : $834ee70cc5b953d1$var$TRIGGER_HOVER] = context._element.contains(event.relatedTarget);
                                context._leave();
                            });
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this._hideModalHandler = function() {
                    if (_this._element) _this.hide();
                };
                $834ee70cc5b953d1$var$EventHandler.on(this._element.closest($834ee70cc5b953d1$var$SELECTOR_MODAL), $834ee70cc5b953d1$var$EVENT_MODAL_HIDE, this._hideModalHandler);
            }
        },
        {
            key: "_fixTitle",
            value: function _fixTitle() {
                var title = this._element.getAttribute('title');
                if (!title) return;
                if (!this._element.getAttribute('aria-label') && !this._element.textContent.trim()) this._element.setAttribute('aria-label', title);
                this._element.setAttribute('data-bs-original-title', title); // DO NOT USE IT. Is only for backwards compatibility
                this._element.removeAttribute('title');
            }
        },
        {
            key: "_enter",
            value: function _enter() {
                var _this = this;
                if (this._isShown() || this._isHovered) {
                    this._isHovered = true;
                    return;
                }
                this._isHovered = true;
                this._setTimeout(function() {
                    if (_this._isHovered) _this.show();
                }, this._config.delay.show);
            }
        },
        {
            key: "_leave",
            value: function _leave() {
                var _this = this;
                if (this._isWithActiveTrigger()) return;
                this._isHovered = false;
                this._setTimeout(function() {
                    if (!_this._isHovered) _this.hide();
                }, this._config.delay.hide);
            }
        },
        {
            key: "_setTimeout",
            value: function _setTimeout(handler, timeout) {
                clearTimeout(this._timeout);
                this._timeout = setTimeout(handler, timeout);
            }
        },
        {
            key: "_isWithActiveTrigger",
            value: function _isWithActiveTrigger() {
                return Object.values(this._activeTrigger).includes(true);
            }
        },
        {
            key: "_getConfig",
            value: function _getConfig(config) {
                var dataAttributes = $834ee70cc5b953d1$var$Manipulator.getDataAttributes(this._element);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.keys(dataAttributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var dataAttribute = _step.value;
                        if ($834ee70cc5b953d1$var$DISALLOWED_ATTRIBUTES.has(dataAttribute)) delete dataAttributes[dataAttribute];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config = (0, $d33814db45cf8e23$export$71511d61b312f219)({}, dataAttributes, (typeof config === "undefined" ? "undefined" : (0, $dvYFb._)(config)) === 'object' && config ? config : {});
                config = this._mergeConfigObj(config);
                config = this._configAfterMerge(config);
                this._typeCheckConfig(config);
                return config;
            }
        },
        {
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                config.container = config.container === false ? document.body : $834ee70cc5b953d1$var$getElement(config.container);
                if (typeof config.delay === 'number') config.delay = {
                    show: config.delay,
                    hide: config.delay
                };
                if (typeof config.title === 'number') config.title = config.title.toString();
                if (typeof config.content === 'number') config.content = config.content.toString();
                return config;
            }
        },
        {
            key: "_getDelegateConfig",
            value: function _getDelegateConfig() {
                var config = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(this._config)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                        if (this.constructor.Default[key] !== value) config[key] = value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                config.selector = false;
                config.trigger = 'manual';
                // In the future can be replaced with:
                // const keysWithDifferentValues = Object.entries(this._config).filter(entry => this.constructor.Default[entry[0]] !== this._config[entry[0]])
                // `Object.fromEntries(keysWithDifferentValues)`
                return config;
            }
        },
        {
            key: "_disposePopper",
            value: function _disposePopper() {
                if (this._popper) {
                    this._popper.destroy();
                    this._popper = null;
                }
                if (this.tip) {
                    this.tip.remove();
                    this.tip = null;
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$3;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$3;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$4;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tooltip.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tooltip;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$28c660c63b792dea);
/**
 * --------------------------------------------------------------------------
 * Bootstrap popover.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$3 = 'popover';
var $834ee70cc5b953d1$var$SELECTOR_TITLE = '.popover-header';
var $834ee70cc5b953d1$var$SELECTOR_CONTENT = '.popover-body';
var $834ee70cc5b953d1$var$Default$2 = (0, $234c1bbf5d6bbebf$export$71511d61b312f219)((0, $d33814db45cf8e23$export$71511d61b312f219)({}, $834ee70cc5b953d1$export$28c660c63b792dea.Default), {
    content: '',
    offset: [
        0,
        8
    ],
    placement: 'right',
    template: '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
    trigger: 'click'
});
var $834ee70cc5b953d1$var$DefaultType$2 = (0, $234c1bbf5d6bbebf$export$71511d61b312f219)((0, $d33814db45cf8e23$export$71511d61b312f219)({}, $834ee70cc5b953d1$export$28c660c63b792dea.DefaultType), {
    content: '(null|string|element|function)'
});
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$5b6b19405a83ff9d = /*#__PURE__*/ function(Tooltip) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Popover, Tooltip);
    function Popover() {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Popover);
        return (0, $44950fec9206880e$export$71511d61b312f219)(this, Popover, arguments);
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Popover, [
        {
            // Overrides
            key: "_isWithContent",
            value: function _isWithContent() {
                return this._getTitle() || this._getContent();
            }
        },
        {
            // Private
            key: "_getContentForTemplate",
            value: function _getContentForTemplate() {
                var _obj;
                return _obj = {}, (0, $6194eebaf067e4d1$export$71511d61b312f219)(_obj, $834ee70cc5b953d1$var$SELECTOR_TITLE, this._getTitle()), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_obj, $834ee70cc5b953d1$var$SELECTOR_CONTENT, this._getContent()), _obj;
            }
        },
        {
            key: "_getContent",
            value: function _getContent() {
                return this._resolvePossibleFunction(this._config.content);
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$2;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$2;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$3;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Popover.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Popover;
}($834ee70cc5b953d1$export$28c660c63b792dea);
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$5b6b19405a83ff9d);
/**
 * --------------------------------------------------------------------------
 * Bootstrap scrollspy.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$2 = 'scrollspy';
var $834ee70cc5b953d1$var$DATA_KEY$2 = 'bs.scrollspy';
var $834ee70cc5b953d1$var$EVENT_KEY$2 = ".".concat($834ee70cc5b953d1$var$DATA_KEY$2);
var $834ee70cc5b953d1$var$DATA_API_KEY = '.data-api';
var $834ee70cc5b953d1$var$EVENT_ACTIVATE = "activate".concat($834ee70cc5b953d1$var$EVENT_KEY$2);
var $834ee70cc5b953d1$var$EVENT_CLICK = "click".concat($834ee70cc5b953d1$var$EVENT_KEY$2);
var $834ee70cc5b953d1$var$EVENT_LOAD_DATA_API$1 = "load".concat($834ee70cc5b953d1$var$EVENT_KEY$2).concat($834ee70cc5b953d1$var$DATA_API_KEY);
var $834ee70cc5b953d1$var$CLASS_NAME_DROPDOWN_ITEM = 'dropdown-item';
var $834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$1 = 'active';
var $834ee70cc5b953d1$var$SELECTOR_DATA_SPY = '[data-bs-spy="scroll"]';
var $834ee70cc5b953d1$var$SELECTOR_TARGET_LINKS = '[href]';
var $834ee70cc5b953d1$var$SELECTOR_NAV_LIST_GROUP = '.nav, .list-group';
var $834ee70cc5b953d1$var$SELECTOR_NAV_LINKS = '.nav-link';
var $834ee70cc5b953d1$var$SELECTOR_NAV_ITEMS = '.nav-item';
var $834ee70cc5b953d1$var$SELECTOR_LIST_ITEMS = '.list-group-item';
var $834ee70cc5b953d1$var$SELECTOR_LINK_ITEMS = "".concat($834ee70cc5b953d1$var$SELECTOR_NAV_LINKS, ", ").concat($834ee70cc5b953d1$var$SELECTOR_NAV_ITEMS, " > ").concat($834ee70cc5b953d1$var$SELECTOR_NAV_LINKS, ", ").concat($834ee70cc5b953d1$var$SELECTOR_LIST_ITEMS);
var $834ee70cc5b953d1$var$SELECTOR_DROPDOWN = '.dropdown';
var $834ee70cc5b953d1$var$SELECTOR_DROPDOWN_TOGGLE$1 = '.dropdown-toggle';
var $834ee70cc5b953d1$var$Default$1 = {
    offset: null,
    // TODO: v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: '0px 0px -25%',
    smoothScroll: false,
    target: null,
    threshold: [
        0.1,
        0.5,
        1
    ]
};
var $834ee70cc5b953d1$var$DefaultType$1 = {
    offset: '(number|null)',
    // TODO v6 @deprecated, keep it for backwards compatibility reasons
    rootMargin: 'string',
    smoothScroll: 'boolean',
    target: 'element',
    threshold: 'array'
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$a6472a5298a374be = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(ScrollSpy, BaseComponent);
    function ScrollSpy(element, config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, ScrollSpy);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ScrollSpy, [
            element,
            config
        ]);
        // this._element is the observablesContainer and config.target the menu links wrapper
        _this._targetLinks = new Map();
        _this._observableSections = new Map();
        _this._rootElement = getComputedStyle(_this._element).overflowY === 'visible' ? null : _this._element;
        _this._activeTarget = null;
        _this._observer = null;
        _this._previousScrollData = {
            visibleEntryTop: 0,
            parentScrollTop: 0
        };
        _this.refresh(); // initialize
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(ScrollSpy, [
        {
            // Public
            key: "refresh",
            value: function refresh() {
                this._initializeTargetsAndObservables();
                this._maybeEnableSmoothScroll();
                if (this._observer) this._observer.disconnect();
                else this._observer = this._getNewObserver();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._observableSections.values()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var section = _step.value;
                        this._observer.observe(section);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._observer.disconnect();
                (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(ScrollSpy.prototype), "dispose", this).call(this);
            }
        },
        {
            // Private
            key: "_configAfterMerge",
            value: function _configAfterMerge(config) {
                // TODO: on v6 target should be given explicitly & remove the {target: 'ss-target'} case
                config.target = $834ee70cc5b953d1$var$getElement(config.target) || document.body;
                // TODO: v6 Only for backwards compatibility reasons. Use rootMargin only
                config.rootMargin = config.offset ? "".concat(config.offset, "px 0px -30%") : config.rootMargin;
                if (typeof config.threshold === 'string') config.threshold = config.threshold.split(',').map(function(value) {
                    return Number.parseFloat(value);
                });
                return config;
            }
        },
        {
            key: "_maybeEnableSmoothScroll",
            value: function _maybeEnableSmoothScroll() {
                var _this = this;
                if (!this._config.smoothScroll) return;
                // unregister any previous listeners
                $834ee70cc5b953d1$var$EventHandler.off(this._config.target, $834ee70cc5b953d1$var$EVENT_CLICK);
                $834ee70cc5b953d1$var$EventHandler.on(this._config.target, $834ee70cc5b953d1$var$EVENT_CLICK, $834ee70cc5b953d1$var$SELECTOR_TARGET_LINKS, function(event) {
                    var observableSection = _this._observableSections.get(event.target.hash);
                    if (observableSection) {
                        event.preventDefault();
                        var root = _this._rootElement || window;
                        var height = observableSection.offsetTop - _this._element.offsetTop;
                        if (root.scrollTo) {
                            root.scrollTo({
                                top: height,
                                behavior: 'smooth'
                            });
                            return;
                        }
                        // Chrome 60 doesn't support `scrollTo`
                        root.scrollTop = height;
                    }
                });
            }
        },
        {
            key: "_getNewObserver",
            value: function _getNewObserver() {
                var _this = this;
                var options = {
                    root: this._rootElement,
                    threshold: this._config.threshold,
                    rootMargin: this._config.rootMargin
                };
                return new IntersectionObserver(function(entries) {
                    return _this._observerCallback(entries);
                }, options);
            }
        },
        {
            // The logic of selection
            key: "_observerCallback",
            value: function _observerCallback(entries) {
                var _this = this;
                var targetElement = function(entry) {
                    return _this._targetLinks.get("#".concat(entry.target.id));
                };
                var activate = function(entry) {
                    _this._previousScrollData.visibleEntryTop = entry.target.offsetTop;
                    _this._process(targetElement(entry));
                };
                var parentScrollTop = (this._rootElement || document.documentElement).scrollTop;
                var userScrollsDown = parentScrollTop >= this._previousScrollData.parentScrollTop;
                this._previousScrollData.parentScrollTop = parentScrollTop;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var entry = _step.value;
                        if (!entry.isIntersecting) {
                            this._activeTarget = null;
                            this._clearActiveClass(targetElement(entry));
                            continue;
                        }
                        var entryIsLowerThanPrevious = entry.target.offsetTop >= this._previousScrollData.visibleEntryTop;
                        // if we are scrolling down, pick the bigger offsetTop
                        if (userScrollsDown && entryIsLowerThanPrevious) {
                            activate(entry);
                            // if parent isn't scrolled, let's keep the first visible item, breaking the iteration
                            if (!parentScrollTop) return;
                            continue;
                        }
                        // if we are scrolling up, pick the smallest offsetTop
                        if (!userScrollsDown && !entryIsLowerThanPrevious) activate(entry);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_initializeTargetsAndObservables",
            value: function _initializeTargetsAndObservables() {
                this._targetLinks = new Map();
                this._observableSections = new Map();
                var targetLinks = $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$SELECTOR_TARGET_LINKS, this._config.target);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = targetLinks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var anchor = _step.value;
                        // ensure that the anchor has an id and is not disabled
                        if (!anchor.hash || $834ee70cc5b953d1$var$isDisabled(anchor)) continue;
                        var observableSection = $834ee70cc5b953d1$var$SelectorEngine.findOne(decodeURI(anchor.hash), this._element);
                        // ensure that the observableSection exists & is visible
                        if ($834ee70cc5b953d1$var$isVisible(observableSection)) {
                            this._targetLinks.set(decodeURI(anchor.hash), anchor);
                            this._observableSections.set(anchor.hash, observableSection);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_process",
            value: function _process(target) {
                if (this._activeTarget === target) return;
                this._clearActiveClass(this._config.target);
                this._activeTarget = target;
                target.classList.add($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$1);
                this._activateParents(target);
                $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_ACTIVATE, {
                    relatedTarget: target
                });
            }
        },
        {
            key: "_activateParents",
            value: function _activateParents(target) {
                // Activate dropdown parents
                if (target.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_DROPDOWN_ITEM)) {
                    $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$SELECTOR_DROPDOWN_TOGGLE$1, target.closest($834ee70cc5b953d1$var$SELECTOR_DROPDOWN)).classList.add($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$1);
                    return;
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = $834ee70cc5b953d1$var$SelectorEngine.parents(target, $834ee70cc5b953d1$var$SELECTOR_NAV_LIST_GROUP)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var listGroup = _step.value;
                        try {
                            // Set triggered links parents as active
                            // With both <ul> and <nav> markup a parent is the previous sibling of any nav ancestor
                            for(var _iterator1 = $834ee70cc5b953d1$var$SelectorEngine.prev(listGroup, $834ee70cc5b953d1$var$SELECTOR_LINK_ITEMS)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var item = _step1.value;
                                item.classList.add($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        },
        {
            key: "_clearActiveClass",
            value: function _clearActiveClass(parent) {
                parent.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$1);
                var activeNodes = $834ee70cc5b953d1$var$SelectorEngine.find("".concat($834ee70cc5b953d1$var$SELECTOR_TARGET_LINKS, ".").concat($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$1), parent);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = activeNodes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var node = _step.value;
                        node.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE$1);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default$1;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType$1;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME$2;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = ScrollSpy.getOrCreateInstance(this, config);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return ScrollSpy;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * Data API implementation
 */ $834ee70cc5b953d1$var$EventHandler.on(window, $834ee70cc5b953d1$var$EVENT_LOAD_DATA_API$1, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$SELECTOR_DATA_SPY)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var spy = _step.value;
            $834ee70cc5b953d1$export$a6472a5298a374be.getOrCreateInstance(spy);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$a6472a5298a374be);
/**
 * --------------------------------------------------------------------------
 * Bootstrap tab.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME$1 = 'tab';
var $834ee70cc5b953d1$var$DATA_KEY$1 = 'bs.tab';
var $834ee70cc5b953d1$var$EVENT_KEY$1 = ".".concat($834ee70cc5b953d1$var$DATA_KEY$1);
var $834ee70cc5b953d1$var$EVENT_HIDE$1 = "hide".concat($834ee70cc5b953d1$var$EVENT_KEY$1);
var $834ee70cc5b953d1$var$EVENT_HIDDEN$1 = "hidden".concat($834ee70cc5b953d1$var$EVENT_KEY$1);
var $834ee70cc5b953d1$var$EVENT_SHOW$1 = "show".concat($834ee70cc5b953d1$var$EVENT_KEY$1);
var $834ee70cc5b953d1$var$EVENT_SHOWN$1 = "shown".concat($834ee70cc5b953d1$var$EVENT_KEY$1);
var $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API = "click".concat($834ee70cc5b953d1$var$EVENT_KEY$1);
var $834ee70cc5b953d1$var$EVENT_KEYDOWN = "keydown".concat($834ee70cc5b953d1$var$EVENT_KEY$1);
var $834ee70cc5b953d1$var$EVENT_LOAD_DATA_API = "load".concat($834ee70cc5b953d1$var$EVENT_KEY$1);
var $834ee70cc5b953d1$var$ARROW_LEFT_KEY = 'ArrowLeft';
var $834ee70cc5b953d1$var$ARROW_RIGHT_KEY = 'ArrowRight';
var $834ee70cc5b953d1$var$ARROW_UP_KEY = 'ArrowUp';
var $834ee70cc5b953d1$var$ARROW_DOWN_KEY = 'ArrowDown';
var $834ee70cc5b953d1$var$HOME_KEY = 'Home';
var $834ee70cc5b953d1$var$END_KEY = 'End';
var $834ee70cc5b953d1$var$CLASS_NAME_ACTIVE = 'active';
var $834ee70cc5b953d1$var$CLASS_NAME_FADE$1 = 'fade';
var $834ee70cc5b953d1$var$CLASS_NAME_SHOW$1 = 'show';
var $834ee70cc5b953d1$var$CLASS_DROPDOWN = 'dropdown';
var $834ee70cc5b953d1$var$SELECTOR_DROPDOWN_TOGGLE = '.dropdown-toggle';
var $834ee70cc5b953d1$var$SELECTOR_DROPDOWN_MENU = '.dropdown-menu';
var $834ee70cc5b953d1$var$NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(".concat($834ee70cc5b953d1$var$SELECTOR_DROPDOWN_TOGGLE, ")");
var $834ee70cc5b953d1$var$SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
var $834ee70cc5b953d1$var$SELECTOR_OUTER = '.nav-item, .list-group-item';
var $834ee70cc5b953d1$var$SELECTOR_INNER = ".nav-link".concat($834ee70cc5b953d1$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ", .list-group-item").concat($834ee70cc5b953d1$var$NOT_SELECTOR_DROPDOWN_TOGGLE, ', [role="tab"]').concat($834ee70cc5b953d1$var$NOT_SELECTOR_DROPDOWN_TOGGLE);
var $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
var $834ee70cc5b953d1$var$SELECTOR_INNER_ELEM = "".concat($834ee70cc5b953d1$var$SELECTOR_INNER, ", ").concat($834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE);
var $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE_ACTIVE = ".".concat($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="tab"], .').concat($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="pill"], .').concat($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE, '[data-bs-toggle="list"]');
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$3e41faf802a29e71 = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Tab, BaseComponent);
    function Tab(element) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Tab);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Tab, [
            element
        ]);
        _this._parent = _this._element.closest($834ee70cc5b953d1$var$SELECTOR_TAB_PANEL);
        if (!_this._parent) return (0, $d463395515ae1209$export$71511d61b312f219)(_this);
        // Set up initial aria attributes
        _this._setInitialAttributes(_this._parent, _this._getChildren());
        $834ee70cc5b953d1$var$EventHandler.on(_this._element, $834ee70cc5b953d1$var$EVENT_KEYDOWN, function(event) {
            return _this._keydown(event);
        });
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Tab, [
        {
            // Public
            key: "show",
            value: function show() {
                // Shows this elem and deactivate the active sibling if exists
                var innerElem = this._element;
                if (this._elemIsActive(innerElem)) return;
                // Search for active tab on same parent to deactivate it
                var active = this._getActiveElem();
                var hideEvent = active ? $834ee70cc5b953d1$var$EventHandler.trigger(active, $834ee70cc5b953d1$var$EVENT_HIDE$1, {
                    relatedTarget: innerElem
                }) : null;
                var showEvent = $834ee70cc5b953d1$var$EventHandler.trigger(innerElem, $834ee70cc5b953d1$var$EVENT_SHOW$1, {
                    relatedTarget: active
                });
                if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
                this._deactivate(active, innerElem);
                this._activate(innerElem, active);
            }
        },
        {
            // Private
            key: "_activate",
            value: function _activate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE);
                this._activate($834ee70cc5b953d1$var$SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.removeAttribute('tabindex');
                    element.setAttribute('aria-selected', true);
                    _this._toggleDropDown(element, true);
                    $834ee70cc5b953d1$var$EventHandler.trigger(element, $834ee70cc5b953d1$var$EVENT_SHOWN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_deactivate",
            value: function _deactivate(element, relatedElem) {
                var _this = this;
                if (!element) return;
                element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE);
                element.blur();
                this._deactivate($834ee70cc5b953d1$var$SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
                var complete = function() {
                    if (element.getAttribute('role') !== 'tab') {
                        element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOW$1);
                        return;
                    }
                    element.setAttribute('aria-selected', false);
                    element.setAttribute('tabindex', '-1');
                    _this._toggleDropDown(element, false);
                    $834ee70cc5b953d1$var$EventHandler.trigger(element, $834ee70cc5b953d1$var$EVENT_HIDDEN$1, {
                        relatedTarget: relatedElem
                    });
                };
                this._queueCallback(complete, element, element.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_FADE$1));
            }
        },
        {
            key: "_keydown",
            value: function _keydown(event) {
                if (![
                    $834ee70cc5b953d1$var$ARROW_LEFT_KEY,
                    $834ee70cc5b953d1$var$ARROW_RIGHT_KEY,
                    $834ee70cc5b953d1$var$ARROW_UP_KEY,
                    $834ee70cc5b953d1$var$ARROW_DOWN_KEY,
                    $834ee70cc5b953d1$var$HOME_KEY,
                    $834ee70cc5b953d1$var$END_KEY
                ].includes(event.key)) return;
                event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
                event.preventDefault();
                var children = this._getChildren().filter(function(element) {
                    return !$834ee70cc5b953d1$var$isDisabled(element);
                });
                var nextActiveElement;
                if ([
                    $834ee70cc5b953d1$var$HOME_KEY,
                    $834ee70cc5b953d1$var$END_KEY
                ].includes(event.key)) nextActiveElement = children[event.key === $834ee70cc5b953d1$var$HOME_KEY ? 0 : children.length - 1];
                else {
                    var isNext = [
                        $834ee70cc5b953d1$var$ARROW_RIGHT_KEY,
                        $834ee70cc5b953d1$var$ARROW_DOWN_KEY
                    ].includes(event.key);
                    nextActiveElement = $834ee70cc5b953d1$var$getNextActiveElement(children, event.target, isNext, true);
                }
                if (nextActiveElement) {
                    nextActiveElement.focus({
                        preventScroll: true
                    });
                    Tab.getOrCreateInstance(nextActiveElement).show();
                }
            }
        },
        {
            key: "_getChildren",
            value: function _getChildren() {
                // collection of inner elements
                return $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$SELECTOR_INNER_ELEM, this._parent);
            }
        },
        {
            key: "_getActiveElem",
            value: function _getActiveElem() {
                var _this = this;
                return this._getChildren().find(function(child) {
                    return _this._elemIsActive(child);
                }) || null;
            }
        },
        {
            key: "_setInitialAttributes",
            value: function _setInitialAttributes(parent, children) {
                this._setAttributeIfNotExists(parent, 'role', 'tablist');
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var child = _step.value;
                        this._setInitialAttributesOnChild(child);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "_setInitialAttributesOnChild",
            value: function _setInitialAttributesOnChild(child) {
                child = this._getInnerElement(child);
                var isActive = this._elemIsActive(child);
                var outerElem = this._getOuterElement(child);
                child.setAttribute('aria-selected', isActive);
                if (outerElem !== child) this._setAttributeIfNotExists(outerElem, 'role', 'presentation');
                if (!isActive) child.setAttribute('tabindex', '-1');
                this._setAttributeIfNotExists(child, 'role', 'tab');
                // set attributes to the related panel too
                this._setInitialAttributesOnTargetPanel(child);
            }
        },
        {
            key: "_setInitialAttributesOnTargetPanel",
            value: function _setInitialAttributesOnTargetPanel(child) {
                var target = $834ee70cc5b953d1$var$SelectorEngine.getElementFromSelector(child);
                if (!target) return;
                this._setAttributeIfNotExists(target, 'role', 'tabpanel');
                if (child.id) this._setAttributeIfNotExists(target, 'aria-labelledby', "".concat(child.id));
            }
        },
        {
            key: "_toggleDropDown",
            value: function _toggleDropDown(element, open) {
                var outerElem = this._getOuterElement(element);
                if (!outerElem.classList.contains($834ee70cc5b953d1$var$CLASS_DROPDOWN)) return;
                var toggle = function(selector, className) {
                    var _$element = $834ee70cc5b953d1$var$SelectorEngine.findOne(selector, outerElem);
                    if (_$element) _$element.classList.toggle(className, open);
                };
                toggle($834ee70cc5b953d1$var$SELECTOR_DROPDOWN_TOGGLE, $834ee70cc5b953d1$var$CLASS_NAME_ACTIVE);
                toggle($834ee70cc5b953d1$var$SELECTOR_DROPDOWN_MENU, $834ee70cc5b953d1$var$CLASS_NAME_SHOW$1);
                outerElem.setAttribute('aria-expanded', open);
            }
        },
        {
            key: "_setAttributeIfNotExists",
            value: function _setAttributeIfNotExists(element, attribute, value) {
                if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
            }
        },
        {
            key: "_elemIsActive",
            value: function _elemIsActive(elem) {
                return elem.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_ACTIVE);
            }
        },
        {
            // Try to get the inner element (usually the .nav-link)
            key: "_getInnerElement",
            value: function _getInnerElement(elem) {
                return elem.matches($834ee70cc5b953d1$var$SELECTOR_INNER_ELEM) ? elem : $834ee70cc5b953d1$var$SelectorEngine.findOne($834ee70cc5b953d1$var$SELECTOR_INNER_ELEM, elem);
            }
        },
        {
            // Try to get the outer element (usually the .nav-item)
            key: "_getOuterElement",
            value: function _getOuterElement(elem) {
                return elem.closest($834ee70cc5b953d1$var$SELECTOR_OUTER) || elem;
            }
        }
    ], [
        {
            key: "NAME",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$NAME$1;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Tab.getOrCreateInstance(this);
                    if (typeof config !== 'string') return;
                    if (data[config] === undefined || config.startsWith('_') || config === 'constructor') throw new TypeError('No method named "'.concat(config, '"'));
                    data[config]();
                });
            }
        }
    ]);
    return Tab;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * Data API implementation
 */ $834ee70cc5b953d1$var$EventHandler.on(document, $834ee70cc5b953d1$var$EVENT_CLICK_DATA_API, $834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE, function(event) {
    if ([
        'A',
        'AREA'
    ].includes(this.tagName)) event.preventDefault();
    if ($834ee70cc5b953d1$var$isDisabled(this)) return;
    $834ee70cc5b953d1$export$3e41faf802a29e71.getOrCreateInstance(this).show();
});
/**
 * Initialize on focus
 */ $834ee70cc5b953d1$var$EventHandler.on(window, $834ee70cc5b953d1$var$EVENT_LOAD_DATA_API, function() {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $834ee70cc5b953d1$var$SelectorEngine.find($834ee70cc5b953d1$var$SELECTOR_DATA_TOGGLE_ACTIVE)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var element = _step.value;
            $834ee70cc5b953d1$export$3e41faf802a29e71.getOrCreateInstance(element);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
});
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$3e41faf802a29e71);
/**
 * --------------------------------------------------------------------------
 * Bootstrap toast.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 * --------------------------------------------------------------------------
 */ /**
 * Constants
 */ var $834ee70cc5b953d1$var$NAME = 'toast';
var $834ee70cc5b953d1$var$DATA_KEY = 'bs.toast';
var $834ee70cc5b953d1$var$EVENT_KEY = ".".concat($834ee70cc5b953d1$var$DATA_KEY);
var $834ee70cc5b953d1$var$EVENT_MOUSEOVER = "mouseover".concat($834ee70cc5b953d1$var$EVENT_KEY);
var $834ee70cc5b953d1$var$EVENT_MOUSEOUT = "mouseout".concat($834ee70cc5b953d1$var$EVENT_KEY);
var $834ee70cc5b953d1$var$EVENT_FOCUSIN = "focusin".concat($834ee70cc5b953d1$var$EVENT_KEY);
var $834ee70cc5b953d1$var$EVENT_FOCUSOUT = "focusout".concat($834ee70cc5b953d1$var$EVENT_KEY);
var $834ee70cc5b953d1$var$EVENT_HIDE = "hide".concat($834ee70cc5b953d1$var$EVENT_KEY);
var $834ee70cc5b953d1$var$EVENT_HIDDEN = "hidden".concat($834ee70cc5b953d1$var$EVENT_KEY);
var $834ee70cc5b953d1$var$EVENT_SHOW = "show".concat($834ee70cc5b953d1$var$EVENT_KEY);
var $834ee70cc5b953d1$var$EVENT_SHOWN = "shown".concat($834ee70cc5b953d1$var$EVENT_KEY);
var $834ee70cc5b953d1$var$CLASS_NAME_FADE = 'fade';
var $834ee70cc5b953d1$var$CLASS_NAME_HIDE = 'hide'; // @deprecated - kept here only for backwards compatibility
var $834ee70cc5b953d1$var$CLASS_NAME_SHOW = 'show';
var $834ee70cc5b953d1$var$CLASS_NAME_SHOWING = 'showing';
var $834ee70cc5b953d1$var$DefaultType = {
    animation: 'boolean',
    autohide: 'boolean',
    delay: 'number'
};
var $834ee70cc5b953d1$var$Default = {
    animation: true,
    autohide: true,
    delay: 5000
};
/**
 * Class definition
 */ var $834ee70cc5b953d1$export$8d8dc7d5f743331b = /*#__PURE__*/ function(BaseComponent) {
    "use strict";
    (0, $cdf6b0397ffac486$export$71511d61b312f219)(Toast, BaseComponent);
    function Toast(element, config) {
        (0, $7417b380464c38c1$export$71511d61b312f219)(this, Toast);
        var _this;
        _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Toast, [
            element,
            config
        ]);
        _this._timeout = null;
        _this._hasMouseInteraction = false;
        _this._hasKeyboardInteraction = false;
        _this._setListeners();
        return _this;
    }
    (0, $c546c01220e295dd$export$71511d61b312f219)(Toast, [
        {
            // Public
            key: "show",
            value: function show() {
                var _this = this;
                var showEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_SHOW);
                if (showEvent.defaultPrevented) return;
                this._clearTimeout();
                if (this._config.animation) this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_FADE);
                var complete = function() {
                    _this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOWING);
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, $834ee70cc5b953d1$var$EVENT_SHOWN);
                    _this._maybeScheduleHide();
                };
                this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_HIDE); // @deprecated
                $834ee70cc5b953d1$var$reflow(this._element);
                this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_SHOW, $834ee70cc5b953d1$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "hide",
            value: function hide() {
                var _this = this;
                if (!this.isShown()) return;
                var hideEvent = $834ee70cc5b953d1$var$EventHandler.trigger(this._element, $834ee70cc5b953d1$var$EVENT_HIDE);
                if (hideEvent.defaultPrevented) return;
                var complete = function() {
                    _this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_HIDE); // @deprecated
                    _this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOWING, $834ee70cc5b953d1$var$CLASS_NAME_SHOW);
                    $834ee70cc5b953d1$var$EventHandler.trigger(_this._element, $834ee70cc5b953d1$var$EVENT_HIDDEN);
                };
                this._element.classList.add($834ee70cc5b953d1$var$CLASS_NAME_SHOWING);
                this._queueCallback(complete, this._element, this._config.animation);
            }
        },
        {
            key: "dispose",
            value: function dispose() {
                this._clearTimeout();
                if (this.isShown()) this._element.classList.remove($834ee70cc5b953d1$var$CLASS_NAME_SHOW);
                (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(Toast.prototype), "dispose", this).call(this);
            }
        },
        {
            key: "isShown",
            value: function isShown() {
                return this._element.classList.contains($834ee70cc5b953d1$var$CLASS_NAME_SHOW);
            }
        },
        {
            // Private
            key: "_maybeScheduleHide",
            value: function _maybeScheduleHide() {
                var _this = this;
                if (!this._config.autohide) return;
                if (this._hasMouseInteraction || this._hasKeyboardInteraction) return;
                this._timeout = setTimeout(function() {
                    _this.hide();
                }, this._config.delay);
            }
        },
        {
            key: "_onInteraction",
            value: function _onInteraction(event, isInteracting) {
                switch(event.type){
                    case 'mouseover':
                    case 'mouseout':
                        this._hasMouseInteraction = isInteracting;
                        break;
                    case 'focusin':
                    case 'focusout':
                        this._hasKeyboardInteraction = isInteracting;
                        break;
                }
                if (isInteracting) {
                    this._clearTimeout();
                    return;
                }
                var nextElement = event.relatedTarget;
                if (this._element === nextElement || this._element.contains(nextElement)) return;
                this._maybeScheduleHide();
            }
        },
        {
            key: "_setListeners",
            value: function _setListeners() {
                var _this = this;
                $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_MOUSEOVER, function(event) {
                    return _this._onInteraction(event, true);
                });
                $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_MOUSEOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
                $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_FOCUSIN, function(event) {
                    return _this._onInteraction(event, true);
                });
                $834ee70cc5b953d1$var$EventHandler.on(this._element, $834ee70cc5b953d1$var$EVENT_FOCUSOUT, function(event) {
                    return _this._onInteraction(event, false);
                });
            }
        },
        {
            key: "_clearTimeout",
            value: function _clearTimeout() {
                clearTimeout(this._timeout);
                this._timeout = null;
            }
        }
    ], [
        {
            key: "Default",
            get: // Getters
            function get() {
                return $834ee70cc5b953d1$var$Default;
            }
        },
        {
            key: "DefaultType",
            get: function get() {
                return $834ee70cc5b953d1$var$DefaultType;
            }
        },
        {
            key: "NAME",
            get: function get() {
                return $834ee70cc5b953d1$var$NAME;
            }
        },
        {
            key: "jQueryInterface",
            value: // Static
            function jQueryInterface(config) {
                return this.each(function() {
                    var data = Toast.getOrCreateInstance(this, config);
                    if (typeof config === 'string') {
                        if (typeof data[config] === 'undefined') throw new TypeError('No method named "'.concat(config, '"'));
                        data[config](this);
                    }
                });
            }
        }
    ]);
    return Toast;
}($834ee70cc5b953d1$var$BaseComponent);
/**
 * Data API implementation
 */ $834ee70cc5b953d1$var$enableDismissTrigger($834ee70cc5b953d1$export$8d8dc7d5f743331b);
/**
 * jQuery
 */ $834ee70cc5b953d1$var$defineJQueryPlugin($834ee70cc5b953d1$export$8d8dc7d5f743331b);



var $3LkHX = parcelRequire("3LkHX");
var $dd7d96993f416d4a$exports = {};
/**
* jquery-match-height 0.7.2 by @liabru
* http://brm.io/jquery-match-height/
* License: MIT
*/ 
var $dvYFb = parcelRequire("dvYFb");

(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) // AMD
    define([
        'jquery'
    ], factory);
    else if ($dd7d96993f416d4a$exports) // CommonJS
    $dd7d96993f416d4a$exports = factory((parcelRequire("3LkHX")));
    else // Global
    factory(jQuery);
})(function($) {
    /*
    *  internal
    */ var _previousResizeWidth = -1, _updateTimeout = -1;
    /*
    *  _parse
    *  value parse utility function
    */ var _parse = function _parse(value) {
        // parse value and convert NaN to 0
        return parseFloat(value) || 0;
    };
    /*
    *  _rows
    *  utility function returns array of jQuery selections representing each row
    *  (as displayed after float wrapping applied by browser)
    */ var _rows = function _rows(elements) {
        var tolerance = 1, $elements = $(elements), lastTop = null, rows = [];
        // group elements by their top position
        $elements.each(function() {
            var $that = $(this), top = $that.offset().top - _parse($that.css('margin-top')), lastRow = rows.length > 0 ? rows[rows.length - 1] : null;
            if (lastRow === null) // first item on the row, so just push it
            rows.push($that);
            else // if the row top is the same, add to the row group
            if (Math.floor(Math.abs(lastTop - top)) <= tolerance) rows[rows.length - 1] = lastRow.add($that);
            else // otherwise start a new row group
            rows.push($that);
            // keep track of the last row top
            lastTop = top;
        });
        return rows;
    };
    /*
    *  _parseOptions
    *  handle plugin options
    */ var _parseOptions = function _parseOptions(options) {
        var opts = {
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        };
        if ((typeof options === "undefined" ? "undefined" : (0, $dvYFb._)(options)) === 'object') return $.extend(opts, options);
        if (typeof options === 'boolean') opts.byRow = options;
        else if (options === 'remove') opts.remove = true;
        return opts;
    };
    /*
    *  matchHeight
    *  plugin definition
    */ var matchHeight = $.fn.matchHeight = function matchHeight1(options) {
        var opts = _parseOptions(options);
        // handle remove
        if (opts.remove) {
            var that = this;
            // remove fixed height from all selected elements
            this.css(opts.property, '');
            // remove selected elements from all groups
            $.each(matchHeight._groups, function(key, group) {
                group.elements = group.elements.not(that);
            });
            // TODO: cleanup empty groups
            return this;
        }
        if (this.length <= 1 && !opts.target) return this;
        // keep track of this group so we can re-apply later on load and resize events
        matchHeight._groups.push({
            elements: this,
            options: opts
        });
        // match each element's height to the tallest element in the selection
        matchHeight._apply(this, opts);
        return this;
    };
    /*
    *  plugin global options
    */ matchHeight.version = '0.7.2';
    matchHeight._groups = [];
    matchHeight._throttle = 80;
    matchHeight._maintainScroll = false;
    matchHeight._beforeUpdate = null;
    matchHeight._afterUpdate = null;
    matchHeight._rows = _rows;
    matchHeight._parse = _parse;
    matchHeight._parseOptions = _parseOptions;
    /*
    *  matchHeight._apply
    *  apply matchHeight to given elements
    */ matchHeight._apply = function(elements, options) {
        var opts = _parseOptions(options), $elements = $(elements), rows = [
            $elements
        ];
        // take note of scroll position
        var scrollTop = $(window).scrollTop(), htmlHeight = $('html').outerHeight(true);
        // get hidden parents
        var $hiddenParents = $elements.parents().filter(':hidden');
        // cache the original inline style
        $hiddenParents.each(function() {
            var $that = $(this);
            $that.data('style-cache', $that.attr('style'));
        });
        // temporarily must force hidden parents visible
        $hiddenParents.css('display', 'block');
        // get rows if using byRow, otherwise assume one row
        if (opts.byRow && !opts.target) {
            // must first force an arbitrary equal height so floating elements break evenly
            $elements.each(function() {
                var $that = $(this), display = $that.css('display');
                // temporarily force a usable display value
                if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') display = 'block';
                // cache the original inline style
                $that.data('style-cache', $that.attr('style'));
                $that.css({
                    'display': display,
                    'padding-top': '0',
                    'padding-bottom': '0',
                    'margin-top': '0',
                    'margin-bottom': '0',
                    'border-top-width': '0',
                    'border-bottom-width': '0',
                    'height': '100px',
                    'overflow': 'hidden'
                });
            });
            // get the array of rows (based on element top position)
            rows = _rows($elements);
            // revert original inline styles
            $elements.each(function() {
                var $that = $(this);
                $that.attr('style', $that.data('style-cache') || '');
            });
        }
        $.each(rows, function(key, row) {
            var $row = $(row), targetHeight = 0;
            if (!opts.target) {
                // skip apply to rows with only one item
                if (opts.byRow && $row.length <= 1) {
                    $row.css(opts.property, '');
                    return;
                }
                // iterate the row and find the max height
                $row.each(function() {
                    var $that = $(this), style = $that.attr('style'), display = $that.css('display');
                    // temporarily force a usable display value
                    if (display !== 'inline-block' && display !== 'flex' && display !== 'inline-flex') display = 'block';
                    // ensure we get the correct actual height (and not a previously set height value)
                    var css = {
                        'display': display
                    };
                    css[opts.property] = '';
                    $that.css(css);
                    // find the max height (including padding, but not margin)
                    if ($that.outerHeight(false) > targetHeight) targetHeight = $that.outerHeight(false);
                    // revert styles
                    if (style) $that.attr('style', style);
                    else $that.css('display', '');
                });
            } else // if target set, use the height of the target element
            targetHeight = opts.target.outerHeight(false);
            // iterate the row and apply the height to all elements
            $row.each(function() {
                var $that = $(this), verticalPadding = 0;
                // don't apply to a target
                if (opts.target && $that.is(opts.target)) return;
                // handle padding and border correctly (required when not using border-box)
                if ($that.css('box-sizing') !== 'border-box') {
                    verticalPadding += _parse($that.css('border-top-width')) + _parse($that.css('border-bottom-width'));
                    verticalPadding += _parse($that.css('padding-top')) + _parse($that.css('padding-bottom'));
                }
                // set the height (accounting for padding and border)
                $that.css(opts.property, targetHeight - verticalPadding + 'px');
            });
        });
        // revert hidden parents
        $hiddenParents.each(function() {
            var $that = $(this);
            $that.attr('style', $that.data('style-cache') || null);
        });
        // restore scroll position if enabled
        if (matchHeight._maintainScroll) $(window).scrollTop(scrollTop / htmlHeight * $('html').outerHeight(true));
        return this;
    };
    /*
    *  matchHeight._applyDataApi
    *  applies matchHeight to all elements with a data-match-height attribute
    */ matchHeight._applyDataApi = function() {
        var groups = {};
        // generate groups by their groupId set by elements using data-match-height
        $('[data-match-height], [data-mh]').each(function() {
            var $this = $(this), groupId = $this.attr('data-mh') || $this.attr('data-match-height');
            if (groupId in groups) groups[groupId] = groups[groupId].add($this);
            else groups[groupId] = $this;
        });
        // apply matchHeight to each group
        $.each(groups, function() {
            this.matchHeight(true);
        });
    };
    /*
    *  matchHeight._update
    *  updates matchHeight on all current groups with their correct options
    */ var _update = function _update(event) {
        if (matchHeight._beforeUpdate) matchHeight._beforeUpdate(event, matchHeight._groups);
        $.each(matchHeight._groups, function() {
            matchHeight._apply(this.elements, this.options);
        });
        if (matchHeight._afterUpdate) matchHeight._afterUpdate(event, matchHeight._groups);
    };
    matchHeight._update = function(throttle, event) {
        // prevent update if fired from a resize event
        // where the viewport width hasn't actually changed
        // fixes an event looping bug in IE8
        if (event && event.type === 'resize') {
            var windowWidth = $(window).width();
            if (windowWidth === _previousResizeWidth) return;
            _previousResizeWidth = windowWidth;
        }
        // throttle updates
        if (!throttle) _update(event);
        else if (_updateTimeout === -1) _updateTimeout = setTimeout(function() {
            _update(event);
            _updateTimeout = -1;
        }, matchHeight._throttle);
    };
    /*
    *  bind events
    */ // apply on DOM ready event
    $(matchHeight._applyDataApi);
    // use on or bind where supported
    var on = $.fn.on ? 'on' : 'bind';
    // update heights on load and resize events
    $(window)[on]('load', function(event) {
        matchHeight._update(false, event);
    });
    // throttled update heights on resize events
    $(window)[on]('resize orientationchange', function(event) {
        matchHeight._update(true, event);
    });
});


var $f44405b77549bdaa$exports = {};




function $1b84e43f64f42d09$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $5ef16d409dbf6610$export$71511d61b312f219)()) $1b84e43f64f42d09$export$71511d61b312f219 = Reflect.construct;
    else $1b84e43f64f42d09$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $0b881900a1aeb6fe$export$71511d61b312f219)(instance, Class.prototype);
        return instance;
    };
    return $1b84e43f64f42d09$export$71511d61b312f219.apply(null, arguments);
}












function $94ee8f67fd9e95ae$export$71511d61b312f219(arr) {
    return (0, $3920012f9e49ab68$export$71511d61b312f219)(arr) || (0, $c7ccf52f37db4126$export$71511d61b312f219)(arr) || (0, $1f1189da1ae074e0$export$71511d61b312f219)(arr) || (0, $2442b555ac3dc2d8$export$71511d61b312f219)();
}




var $dvYFb = parcelRequire("dvYFb");


function $1af182b0b4420845$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $cdcde981a6d4bbcf$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $cdcde981a6d4bbcf$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $1af182b0b4420845$export$71511d61b312f219)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $1b84e43f64f42d09$export$71511d61b312f219)(Class, arguments, (0, $f35a8e455e15bfdc$export$71511d61b312f219)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $0b881900a1aeb6fe$export$71511d61b312f219)(Wrapper, Class);
    };
    return $cdcde981a6d4bbcf$export$71511d61b312f219(Class);
}


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $dvYFb = parcelRequire("dvYFb");
var $a8d2d094d9f0b05d$var$extendStatics = function extendStatics1(d, b) {
    $a8d2d094d9f0b05d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $a8d2d094d9f0b05d$var$extendStatics(d, b);
};
function $a8d2d094d9f0b05d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $a8d2d094d9f0b05d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $a8d2d094d9f0b05d$export$18ce0697a983be9b = function __assign1() {
    $a8d2d094d9f0b05d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $a8d2d094d9f0b05d$export$18ce0697a983be9b.apply(this, arguments);
};
function $a8d2d094d9f0b05d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $a8d2d094d9f0b05d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $dvYFb._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $a8d2d094d9f0b05d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $a8d2d094d9f0b05d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $dvYFb._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $a8d2d094d9f0b05d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $a8d2d094d9f0b05d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $dvYFb._)(x)) === "symbol" ? x : "".concat(x);
}
function $a8d2d094d9f0b05d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $dvYFb._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $a8d2d094d9f0b05d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $dvYFb._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $a8d2d094d9f0b05d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $a8d2d094d9f0b05d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $a8d2d094d9f0b05d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $a8d2d094d9f0b05d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $a8d2d094d9f0b05d$export$45d3717a4c69092e(o, m, p);
}
function $a8d2d094d9f0b05d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $a8d2d094d9f0b05d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $a8d2d094d9f0b05d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($a8d2d094d9f0b05d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $a8d2d094d9f0b05d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $a8d2d094d9f0b05d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $a8d2d094d9f0b05d$export$10c90e4f7922046c(v) {
    return this instanceof $a8d2d094d9f0b05d$export$10c90e4f7922046c ? (this.v = v, this) : new $a8d2d094d9f0b05d$export$10c90e4f7922046c(v);
}
function $a8d2d094d9f0b05d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $a8d2d094d9f0b05d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $a8d2d094d9f0b05d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $a8d2d094d9f0b05d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $a8d2d094d9f0b05d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $a8d2d094d9f0b05d$export$19a8beecd37a4c45 === "function" ? $a8d2d094d9f0b05d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $a8d2d094d9f0b05d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $a8d2d094d9f0b05d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $a8d2d094d9f0b05d$var$ownKeys = function ownKeys1(o) {
    $a8d2d094d9f0b05d$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $a8d2d094d9f0b05d$var$ownKeys(o);
};
function $a8d2d094d9f0b05d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $a8d2d094d9f0b05d$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $a8d2d094d9f0b05d$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $a8d2d094d9f0b05d$var$__setModuleDefault(result, mod);
    return result;
}
function $a8d2d094d9f0b05d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $a8d2d094d9f0b05d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $a8d2d094d9f0b05d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $a8d2d094d9f0b05d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $dvYFb._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $a8d2d094d9f0b05d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $dvYFb._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $a8d2d094d9f0b05d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $a8d2d094d9f0b05d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $a8d2d094d9f0b05d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $a8d2d094d9f0b05d$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $a8d2d094d9f0b05d$export$2e2bcd8739ae039 = {
    __extends: $a8d2d094d9f0b05d$export$a8ba968b8961cb8a,
    __assign: $a8d2d094d9f0b05d$export$18ce0697a983be9b,
    __rest: $a8d2d094d9f0b05d$export$3c9a16f847548506,
    __decorate: $a8d2d094d9f0b05d$export$29e00dfd3077644b,
    __param: $a8d2d094d9f0b05d$export$d5ad3fd78186038f,
    __esDecorate: $a8d2d094d9f0b05d$export$3a84e1ae4e97e9b0,
    __runInitializers: $a8d2d094d9f0b05d$export$d831c04e792af3d,
    __propKey: $a8d2d094d9f0b05d$export$6a2a36740a146cb8,
    __setFunctionName: $a8d2d094d9f0b05d$export$d1a06452d3489bc7,
    __metadata: $a8d2d094d9f0b05d$export$f1db080c865becb9,
    __awaiter: $a8d2d094d9f0b05d$export$1050f835b63b671e,
    __generator: $a8d2d094d9f0b05d$export$67ebef60e6f28a6,
    __createBinding: $a8d2d094d9f0b05d$export$45d3717a4c69092e,
    __exportStar: $a8d2d094d9f0b05d$export$f33643c0debef087,
    __values: $a8d2d094d9f0b05d$export$19a8beecd37a4c45,
    __read: $a8d2d094d9f0b05d$export$8d051b38c9118094,
    __spread: $a8d2d094d9f0b05d$export$afc72e2116322959,
    __spreadArrays: $a8d2d094d9f0b05d$export$6388937ca91ccae8,
    __spreadArray: $a8d2d094d9f0b05d$export$1216008129fb82ed,
    __await: $a8d2d094d9f0b05d$export$10c90e4f7922046c,
    __asyncGenerator: $a8d2d094d9f0b05d$export$e427f37a30a4de9b,
    __asyncDelegator: $a8d2d094d9f0b05d$export$bbd80228419bb833,
    __asyncValues: $a8d2d094d9f0b05d$export$e3b29a3d6162315f,
    __makeTemplateObject: $a8d2d094d9f0b05d$export$4fb47efe1390b86f,
    __importStar: $a8d2d094d9f0b05d$export$c21735bcef00d192,
    __importDefault: $a8d2d094d9f0b05d$export$da59b14a69baef04,
    __classPrivateFieldGet: $a8d2d094d9f0b05d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $a8d2d094d9f0b05d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $a8d2d094d9f0b05d$export$81fdc39f203e4e04,
    __addDisposableResource: $a8d2d094d9f0b05d$export$88ac25d8e944e405,
    __disposeResources: $a8d2d094d9f0b05d$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $a8d2d094d9f0b05d$export$889dfb5d17574b0b
};


/**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v5.15.0/LICENSE.txt
 */ (function(global, factory) {
    $f44405b77549bdaa$exports = factory();
})(undefined, function() {
    'use strict';
    /* eslint-disable */ var maplibregl = {};
    var modules = {};
    function define(moduleName, _dependencies, moduleFactory) {
        modules[moduleName] = moduleFactory;
        // to get the list of modules see generated dist/maplibre-gl-dev.js file (look for `define(` calls)
        if (moduleName !== 'index') return;
        // we assume that when an index module is initializing then other modules are loaded already
        var workerBundleString = 'var sharedModule = {}; (' + modules.shared + ')(sharedModule); (' + modules.worker + ')(sharedModule);';
        var sharedModule = {};
        // the order of arguments of a module factory depends on rollup (it decides who is whose dependency)
        // to check the correct order, see dist/maplibre-gl-dev.js file (look for `define(` calls)
        // we assume that for our 3 chunks it will generate 3 modules and their order is predefined like the following
        modules.shared(sharedModule);
        modules.index(maplibregl, sharedModule);
        if (typeof window !== 'undefined') maplibregl.setWorkerUrl(window.URL.createObjectURL(new Blob([
            workerBundleString
        ], {
            type: 'text/javascript'
        })));
        return maplibregl;
    }
    define("shared", [
        "exports"
    ], function(t) {
        "use strict";
        var _Math, _Math1;
        function e1(t, e1, r, n) {
            return new (r || (r = Promise))(function(i, s) {
                function a(t) {
                    try {
                        l(n.next(t));
                    } catch (t) {
                        s(t);
                    }
                }
                function o(t) {
                    try {
                        l(n.throw(t));
                    } catch (t) {
                        s(t);
                    }
                }
                function l(t) {
                    var _$e;
                    t.done ? i(t.value) : (_$e = t.value, _$e instanceof r ? _$e : new r(function(t) {
                        t(_$e);
                    })).then(a, o);
                }
                l((n = n.apply(t, e1 || [])).next());
            });
        }
        function r(t, e1) {
            this.x = t, this.y = e1;
        }
        function n(t) {
            return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        var i, s;
        "function" == typeof SuppressedError && SuppressedError, r.prototype = {
            clone: function() {
                return new r(this.x, this.y);
            },
            add: function(t) {
                return this.clone()._add(t);
            },
            sub: function(t) {
                return this.clone()._sub(t);
            },
            multByPoint: function(t) {
                return this.clone()._multByPoint(t);
            },
            divByPoint: function(t) {
                return this.clone()._divByPoint(t);
            },
            mult: function(t) {
                return this.clone()._mult(t);
            },
            div: function(t) {
                return this.clone()._div(t);
            },
            rotate: function(t) {
                return this.clone()._rotate(t);
            },
            rotateAround: function(t, e1) {
                return this.clone()._rotateAround(t, e1);
            },
            matMult: function(t) {
                return this.clone()._matMult(t);
            },
            unit: function() {
                return this.clone()._unit();
            },
            perp: function() {
                return this.clone()._perp();
            },
            round: function() {
                return this.clone()._round();
            },
            mag: function() {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals: function(t) {
                return this.x === t.x && this.y === t.y;
            },
            dist: function(t) {
                return Math.sqrt(this.distSqr(t));
            },
            distSqr: function(t) {
                var _$e = t.x - this.x, _$r = t.y - this.y;
                return _$e * _$e + _$r * _$r;
            },
            angle: function() {
                return Math.atan2(this.y, this.x);
            },
            angleTo: function(t) {
                return Math.atan2(this.y - t.y, this.x - t.x);
            },
            angleWith: function(t) {
                return this.angleWithSep(t.x, t.y);
            },
            angleWithSep: function(t, e1) {
                return Math.atan2(this.x * e1 - this.y * t, this.x * t + this.y * e1);
            },
            _matMult: function(t) {
                var _$e = t[2] * this.x + t[3] * this.y;
                return this.x = t[0] * this.x + t[1] * this.y, this.y = _$e, this;
            },
            _add: function(t) {
                return this.x += t.x, this.y += t.y, this;
            },
            _sub: function(t) {
                return this.x -= t.x, this.y -= t.y, this;
            },
            _mult: function(t) {
                return this.x *= t, this.y *= t, this;
            },
            _div: function(t) {
                return this.x /= t, this.y /= t, this;
            },
            _multByPoint: function(t) {
                return this.x *= t.x, this.y *= t.y, this;
            },
            _divByPoint: function(t) {
                return this.x /= t.x, this.y /= t.y, this;
            },
            _unit: function() {
                return this._div(this.mag()), this;
            },
            _perp: function() {
                var _$t = this.y;
                return this.y = this.x, this.x = -_$t, this;
            },
            _rotate: function(t) {
                var _$e = Math.cos(t), _$r = Math.sin(t), _$n = _$r * this.x + _$e * this.y;
                return this.x = _$e * this.x - _$r * this.y, this.y = _$n, this;
            },
            _rotateAround: function(t, e1) {
                var _$r = Math.cos(t), _$n = Math.sin(t), i = e1.y + _$n * (this.x - e1.x) + _$r * (this.y - e1.y);
                return this.x = e1.x + _$r * (this.x - e1.x) - _$n * (this.y - e1.y), this.y = i, this;
            },
            _round: function() {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            },
            constructor: r
        }, r.convert = function(t) {
            if (t instanceof r) return t;
            if (Array.isArray(t)) return new r(+t[0], +t[1]);
            if (void 0 !== t.x && void 0 !== t.y) return new r(+t.x, +t.y);
            throw new Error("Expected [x, y] or {x, y} point format");
        };
        var a = function() {
            if (s) return i;
            function t(t, e1, r, n) {
                this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e1, this.p2x = r, this.p2y = n;
            }
            return s = 1, i = t, t.prototype = {
                sampleCurveX: function sampleCurveX(t) {
                    return ((this.ax * t + this.bx) * t + this.cx) * t;
                },
                sampleCurveY: function sampleCurveY(t) {
                    return ((this.ay * t + this.by) * t + this.cy) * t;
                },
                sampleCurveDerivativeX: function sampleCurveDerivativeX(t) {
                    return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
                },
                solveCurveX: function solveCurveX(t, e1) {
                    if (void 0 === e1 && (e1 = 1e-6), t < 0) return 0;
                    if (t > 1) return 1;
                    for(var _$r = t, _$n = 0; _$n < 8; _$n++){
                        var i = this.sampleCurveX(_$r) - t;
                        if (Math.abs(i) < e1) return _$r;
                        var s = this.sampleCurveDerivativeX(_$r);
                        if (Math.abs(s) < 1e-6) break;
                        _$r -= i / s;
                    }
                    var a = 0, o = 1;
                    for(_$r = t, _$n = 0; _$n < 20 && (i = this.sampleCurveX(_$r), !(Math.abs(i - t) < e1)); _$n++)t > i ? a = _$r : o = _$r, _$r = .5 * (o - a) + a;
                    return _$r;
                },
                solve: function solve(t, e1) {
                    return this.sampleCurveY(this.solveCurveX(t, e1));
                }
            }, i;
        }(), o = n(a);
        var l, u;
        function c() {
            return null == l && (l = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), l;
        }
        function h() {
            if (null == u && (u = !1, c())) {
                var _$t = 5, _$e = new OffscreenCanvas(_$t, _$t).getContext("2d", {
                    willReadFrequently: !0
                });
                if (_$e) {
                    for(var _$r = 0; _$r < _$t * _$t; _$r++){
                        var _$n = 4 * _$r;
                        _$e.fillStyle = "rgb(".concat(_$n, ",").concat(_$n + 1, ",").concat(_$n + 2, ")"), _$e.fillRect(_$r % _$t, Math.floor(_$r / _$t), 1, 1);
                    }
                    var _$r1 = _$e.getImageData(0, 0, _$t, _$t).data;
                    for(var _$e1 = 0; _$e1 < _$t * _$t * 4; _$e1++)if (_$e1 % 4 != 3 && _$r1[_$e1] !== _$e1) {
                        u = !0;
                        break;
                    }
                }
            }
            return u || !1;
        }
        var p = 1e-6, f = "undefined" != typeof Float32Array ? Float32Array : Array;
        function d() {
            var _$t = new f(9);
            return f != Float32Array && (_$t[1] = 0, _$t[2] = 0, _$t[3] = 0, _$t[5] = 0, _$t[6] = 0, _$t[7] = 0), _$t[0] = 1, _$t[4] = 1, _$t[8] = 1, _$t;
        }
        function y(t) {
            return t[0] = 1, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = 1, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 1, t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }
        function m() {
            var _$t = new f(3);
            return f != Float32Array && (_$t[0] = 0, _$t[1] = 0, _$t[2] = 0), _$t;
        }
        function g(t) {
            var _$e = t[0], _$r = t[1], _$n = t[2];
            return Math.sqrt(_$e * _$e + _$r * _$r + _$n * _$n);
        }
        function x(t, e1, r) {
            var _$n = new f(3);
            return _$n[0] = t, _$n[1] = e1, _$n[2] = r, _$n;
        }
        function v(t, e1, r) {
            return t[0] = e1[0] + r[0], t[1] = e1[1] + r[1], t[2] = e1[2] + r[2], t;
        }
        function b(t, e1, r) {
            return t[0] = e1[0] * r, t[1] = e1[1] * r, t[2] = e1[2] * r, t;
        }
        function w(t, e1, r) {
            var _$n = e1[0], i = e1[1], s = e1[2], a = r[0], o = r[1], l = r[2];
            return t[0] = i * l - s * o, t[1] = s * a - _$n * l, t[2] = _$n * o - i * a, t;
        }
        var _, S = g;
        function A(t, e1, r) {
            var _$n = e1[0], i = e1[1], s = e1[2], a = e1[3];
            return t[0] = r[0] * _$n + r[4] * i + r[8] * s + r[12] * a, t[1] = r[1] * _$n + r[5] * i + r[9] * s + r[13] * a, t[2] = r[2] * _$n + r[6] * i + r[10] * s + r[14] * a, t[3] = r[3] * _$n + r[7] * i + r[11] * s + r[15] * a, t;
        }
        function k() {
            var _$t = new f(4);
            return f != Float32Array && (_$t[0] = 0, _$t[1] = 0, _$t[2] = 0), _$t[3] = 1, _$t;
        }
        function E(t, e1, r, n) {
            var i = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "zyx", s = Math.PI / 360;
            e1 *= s, n *= s, r *= s;
            var a = Math.sin(e1), o = Math.cos(e1), l = Math.sin(r), u = Math.cos(r), _$c = Math.sin(n), _$h = Math.cos(n);
            switch(i){
                case "xyz":
                    t[0] = a * u * _$h + o * l * _$c, t[1] = o * l * _$h - a * u * _$c, t[2] = o * u * _$c + a * l * _$h, t[3] = o * u * _$h - a * l * _$c;
                    break;
                case "xzy":
                    t[0] = a * u * _$h - o * l * _$c, t[1] = o * l * _$h - a * u * _$c, t[2] = o * u * _$c + a * l * _$h, t[3] = o * u * _$h + a * l * _$c;
                    break;
                case "yxz":
                    t[0] = a * u * _$h + o * l * _$c, t[1] = o * l * _$h - a * u * _$c, t[2] = o * u * _$c - a * l * _$h, t[3] = o * u * _$h + a * l * _$c;
                    break;
                case "yzx":
                    t[0] = a * u * _$h + o * l * _$c, t[1] = o * l * _$h + a * u * _$c, t[2] = o * u * _$c - a * l * _$h, t[3] = o * u * _$h - a * l * _$c;
                    break;
                case "zxy":
                    t[0] = a * u * _$h - o * l * _$c, t[1] = o * l * _$h + a * u * _$c, t[2] = o * u * _$c + a * l * _$h, t[3] = o * u * _$h - a * l * _$c;
                    break;
                case "zyx":
                    t[0] = a * u * _$h - o * l * _$c, t[1] = o * l * _$h + a * u * _$c, t[2] = o * u * _$c - a * l * _$h, t[3] = o * u * _$h + a * l * _$c;
                    break;
                default:
                    throw new Error("Unknown angle order " + i);
            }
            return t;
        }
        function T() {
            var _$t = new f(2);
            return f != Float32Array && (_$t[0] = 0, _$t[1] = 0), _$t;
        }
        function I(t, e1) {
            var _$r = new f(2);
            return _$r[0] = t, _$r[1] = e1, _$r;
        }
        m(), _ = new f(4), f != Float32Array && (_[0] = 0, _[1] = 0, _[2] = 0, _[3] = 0), m(), x(1, 0, 0), x(0, 1, 0), k(), k(), d(), T();
        var M = 8192;
        function F(t, e1, r) {
            return e1 * (M / (t.tileSize * Math.pow(2, r - t.tileID.overscaledZ)));
        }
        function D(t, e1) {
            return (t % e1 + e1) % e1;
        }
        function z(t, e1, r) {
            return t * (1 - r) + e1 * r;
        }
        function P(t) {
            if (t <= 0) return 0;
            if (t >= 1) return 1;
            var _$e = t * t, _$r = _$e * t;
            return 4 * (t < .5 ? _$r : 3 * (t - _$e) + _$r - .75);
        }
        function B(t, e1, r, n) {
            var i = new o(t, e1, r, n);
            return function(t) {
                return i.solve(t);
            };
        }
        var V = B(.25, .1, .25, 1);
        function C(t, e1, r) {
            return Math.min(r, Math.max(e1, t));
        }
        function L(t, e1, r) {
            var _$n = r - e1, i = ((t - e1) % _$n + _$n) % _$n + e1;
            return i === e1 ? r : i;
        }
        function O(t) {
            for(var _len = arguments.length, _$e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                _$e[_key - 1] = arguments[_key];
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _$e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$r = _step.value;
                    for(var _$e1 in _$r)t[_$e1] = _$r[_$e1];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return t;
        }
        var R = 1;
        function N(t, e1, r) {
            var _$n = {};
            for(var _$r in t)_$n[_$r] = e1.call(this, t[_$r], _$r, t);
            return _$n;
        }
        function $(t, e1, r) {
            var _$n = {};
            for(var _$r in t)e1.call(this, t[_$r], _$r, t) && (_$n[_$r] = t[_$r]);
            return _$n;
        }
        function U(t) {
            return Array.isArray(t) ? t.map(U) : "object" == (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t)) && t ? N(t, U) : t;
        }
        var q = {};
        function j(t) {
            q[t] || ("undefined" != typeof console && console.warn(t), q[t] = !0);
        }
        function G(t, e1, r) {
            return (r.y - t.y) * (e1.x - t.x) > (e1.y - t.y) * (r.x - t.x);
        }
        function X(t) {
            return "undefined" != typeof WorkerGlobalScope && void 0 !== t && t instanceof WorkerGlobalScope;
        }
        var Y = null;
        function Z(t) {
            return "undefined" != typeof ImageBitmap && t instanceof ImageBitmap;
        }
        var H = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
        function K(t, r, n, i, s) {
            return e1(this, void 0, void 0, function() {
                var _$e, a, o, l, _$t, _$e1;
                return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                            _$e = new VideoFrame(t, {
                                timestamp: 0
                            });
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                3,
                                4
                            ]);
                            a = null == _$e ? void 0 : _$e.format;
                            if (!a || !a.startsWith("BGR") && !a.startsWith("RGB")) throw new Error("Unrecognized format ".concat(a));
                            o = a.startsWith("BGR"), l = new Uint8ClampedArray(i * s * 4);
                            return [
                                4,
                                _$e.copyTo(l, function(t, e1, r, n, i) {
                                    var _$s = 4 * Math.max(-e1, 0), a = (Math.max(0, r) - r) * n * 4 + _$s, o = 4 * n, l = Math.max(0, e1), u = Math.max(0, r);
                                    return {
                                        rect: {
                                            x: l,
                                            y: u,
                                            width: Math.min(t.width, e1 + n) - l,
                                            height: Math.min(t.height, r + i) - u
                                        },
                                        layout: [
                                            {
                                                offset: a,
                                                stride: o
                                            }
                                        ]
                                    };
                                }(t, r, n, i, s))
                            ];
                        case 2:
                            if (_state.sent(), o) for(_$t = 0; _$t < l.length; _$t += 4){
                                _$e1 = l[_$t];
                                l[_$t] = l[_$t + 2], l[_$t + 2] = _$e1;
                            }
                            return [
                                2,
                                l
                            ];
                        case 3:
                            _$e.close();
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
        }
        var W, J;
        function Q(t, e1, r, n) {
            return t.addEventListener(e1, r, n), {
                unsubscribe: function() {
                    t.removeEventListener(e1, r, n);
                }
            };
        }
        function tt(t) {
            return t * Math.PI / 180;
        }
        function et(t) {
            return t / Math.PI * 180;
        }
        var rt = {
            touchstart: !0,
            touchmove: !0,
            touchmoveWindow: !0,
            touchend: !0,
            touchcancel: !0
        }, nt = {
            dblclick: !0,
            click: !0,
            mouseover: !0,
            mouseout: !0,
            mousedown: !0,
            mousemove: !0,
            mousemoveWindow: !0,
            mouseup: !0,
            mouseupWindow: !0,
            contextmenu: !0,
            wheel: !0
        }, it = "AbortError";
        var st = /*#__PURE__*/ function(Error1) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(st, Error1);
            function st() {
                var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : it;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, st);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, st, [
                    _$t instanceof Error ? _$t.message : _$t
                ]), _this.name = it, _$t instanceof Error && _$t.stack && (_this.stack = _$t.stack);
                return _this;
            }
            return st;
        }((0, $cdcde981a6d4bbcf$export$71511d61b312f219)(Error));
        function at(t) {
            return t.name === it;
        }
        var ot = {
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
            REGISTERED_PROTOCOLS: {},
            WORKER_URL: ""
        };
        function lt(t) {
            return ot.REGISTERED_PROTOCOLS[t.substring(0, t.indexOf("://"))];
        }
        var ut = "global-dispatcher";
        var ct = /*#__PURE__*/ function(Error1) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ct, Error1);
            function ct(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ct);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ct, [
                    "AJAXError: ".concat(e1, " (").concat(t, "): ").concat(r)
                ]), _this.status = t, _this.statusText = e1, _this.url = r, _this.body = n;
                return _this;
            }
            return ct;
        }((0, $cdcde981a6d4bbcf$export$71511d61b312f219)(Error));
        var ht = function() {
            return X(self) ? self.worker && self.worker.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href;
        }, pt = function pt(t, r) {
            if (/:\/\//.test(t.url) && !/^https?:|^file:/.test(t.url)) {
                var _$e = lt(t.url);
                if (_$e) return _$e(t, r);
                if (X(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                    type: "GR",
                    data: t,
                    targetMapId: ut
                }, r);
            }
            if (!(/^file:/.test(_$n = t.url) || /^file:/.test(ht()) && !/^\w+:/.test(_$n))) {
                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(t, r) {
                    return e1(this, void 0, void 0, function() {
                        var _$e, _$n, i, e1, _$e1, s;
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _$e = new Request(t.url, {
                                        method: t.method || "GET",
                                        body: t.body,
                                        credentials: t.credentials,
                                        headers: t.headers,
                                        cache: t.cache,
                                        referrer: ht(),
                                        signal: r.signal
                                    });
                                    "json" !== t.type || _$e.headers.has("Accept") || _$e.headers.set("Accept", "application/json");
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        ,
                                        4
                                    ]);
                                    return [
                                        4,
                                        fetch(_$e)
                                    ];
                                case 2:
                                    _$n = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 3:
                                    e1 = _state.sent();
                                    if (at(e1)) throw e1;
                                    throw new ct(0, e1.message, t.url, new Blob);
                                case 4:
                                    if (!!_$n.ok) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        _$n.blob()
                                    ];
                                case 5:
                                    _$e1 = _state.sent();
                                    throw new ct(_$n.status, _$n.statusText, t.url, _$e1);
                                case 6:
                                    i = "arrayBuffer" === t.type || "image" === t.type ? _$n.arrayBuffer() : "json" === t.type ? _$n.json() : _$n.text();
                                    return [
                                        4,
                                        i
                                    ];
                                case 7:
                                    s = _state.sent();
                                    return [
                                        2,
                                        (r.signal.throwIfAborted(), {
                                            data: s,
                                            cacheControl: _$n.headers.get("Cache-Control"),
                                            expires: _$n.headers.get("Expires")
                                        })
                                    ];
                            }
                        });
                    });
                }(t, r);
                if (X(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                    type: "GR",
                    data: t,
                    mustQueue: !0,
                    targetMapId: ut
                }, r);
            }
            var _$n;
            return function(t, e1) {
                return new Promise(function(r, n) {
                    var i;
                    var s = new XMLHttpRequest;
                    s.open(t.method || "GET", t.url, !0), "arrayBuffer" !== t.type && "image" !== t.type || (s.responseType = "arraybuffer");
                    for(var _$e in t.headers)s.setRequestHeader(_$e, t.headers[_$e]);
                    "json" === t.type && (s.responseType = "text", (null === (i = t.headers) || void 0 === i ? void 0 : i.Accept) || s.setRequestHeader("Accept", "application/json")), s.withCredentials = "include" === t.credentials, s.onerror = function() {
                        n(new Error(s.statusText));
                    }, s.onload = function() {
                        if (!e1.signal.aborted) {
                            if ((s.status >= 200 && s.status < 300 || 0 === s.status) && null !== s.response) {
                                var _$e = s.response;
                                if ("json" === t.type) try {
                                    _$e = JSON.parse(s.response);
                                } catch (t) {
                                    return void n(t);
                                }
                                r({
                                    data: _$e,
                                    cacheControl: s.getResponseHeader("Cache-Control"),
                                    expires: s.getResponseHeader("Expires")
                                });
                            } else {
                                var _$e1 = new Blob([
                                    s.response
                                ], {
                                    type: s.getResponseHeader("Content-Type")
                                });
                                n(new ct(s.status, s.statusText, t.url, _$e1));
                            }
                        }
                    }, e1.signal.addEventListener("abort", function() {
                        s.abort(), n(new st(e1.signal.reason));
                    }), s.send(t.body);
                });
            }(t, r);
        };
        function ft(t) {
            if (!t || t.indexOf("://") <= 0 || 0 === t.indexOf("data:image/") || 0 === t.indexOf("blob:")) return !0;
            var _$e = new URL(t), _$r = window.location;
            return _$e.protocol === _$r.protocol && _$e.host === _$r.host;
        }
        function dt(t, e1, r) {
            r[t] && -1 !== r[t].indexOf(e1) || (r[t] = r[t] || [], r[t].push(e1));
        }
        function yt(t, e1, r) {
            if (r && r[t]) {
                var _$n = r[t].indexOf(e1);
                -1 !== _$n && r[t].splice(_$n, 1);
            }
        }
        var mt = function mt(t) {
            var _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, mt);
            O(this, _$e), this.type = t;
        };
        var gt = /*#__PURE__*/ function(mt) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(gt, mt);
            function gt(t) {
                var _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, gt);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, gt, [
                    "error",
                    O({
                        error: t
                    }, _$e)
                ]);
            }
            return gt;
        }(mt);
        var xt = /*#__PURE__*/ function() {
            function xt() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, xt);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(xt, [
                {
                    key: "on",
                    value: function on(t, e1) {
                        var _this = this;
                        return this._listeners = this._listeners || {}, dt(t, e1, this._listeners), {
                            unsubscribe: function() {
                                _this.off(t, e1);
                            }
                        };
                    }
                },
                {
                    key: "off",
                    value: function off(t, e1) {
                        return yt(t, e1, this._listeners), yt(t, e1, this._oneTimeListeners), this;
                    }
                },
                {
                    key: "once",
                    value: function once(t, e1) {
                        var _this = this;
                        return e1 ? (this._oneTimeListeners = this._oneTimeListeners || {}, dt(t, e1, this._oneTimeListeners), this) : new Promise(function(e1) {
                            return _this.once(t, e1);
                        });
                    }
                },
                {
                    key: "fire",
                    value: function fire(t, e1) {
                        "string" == typeof t && (t = new mt(t, e1 || {}));
                        var _$r = t.type;
                        if (this.listens(_$r)) {
                            t.target = this;
                            var _$e = this._listeners && this._listeners[_$r] ? this._listeners[_$r].slice() : [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = _$e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$r1 = _step.value;
                                    _$r1.call(this, t);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            var _$n = this._oneTimeListeners && this._oneTimeListeners[_$r] ? this._oneTimeListeners[_$r].slice() : [];
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = _$n[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var _$e1 = _step1.value;
                                    yt(_$r, _$e1, this._oneTimeListeners), _$e1.call(this, t);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            var i = this._eventedParent;
                            i && (O(t, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), i.fire(t));
                        } else t instanceof gt && console.error(t.error);
                        return this;
                    }
                },
                {
                    key: "listens",
                    value: function listens(t) {
                        return this._listeners && this._listeners[t] && this._listeners[t].length > 0 || this._oneTimeListeners && this._oneTimeListeners[t] && this._oneTimeListeners[t].length > 0 || this._eventedParent && this._eventedParent.listens(t);
                    }
                },
                {
                    key: "setEventedParent",
                    value: function setEventedParent(t, e1) {
                        return this._eventedParent = t, this._eventedParentData = e1, this;
                    }
                }
            ]);
            return xt;
        }();
        var vt = {
            $version: 8,
            $root: {
                version: {
                    required: !0,
                    type: "enum",
                    values: [
                        8
                    ]
                },
                name: {
                    type: "string"
                },
                metadata: {
                    type: "*"
                },
                center: {
                    type: "array",
                    value: "number",
                    length: 2
                },
                centerAltitude: {
                    type: "number"
                },
                zoom: {
                    type: "number"
                },
                bearing: {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees"
                },
                pitch: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                roll: {
                    type: "number",
                    default: 0,
                    units: "degrees"
                },
                state: {
                    type: "state",
                    default: {}
                },
                light: {
                    type: "light"
                },
                sky: {
                    type: "sky"
                },
                projection: {
                    type: "projection"
                },
                terrain: {
                    type: "terrain"
                },
                sources: {
                    required: !0,
                    type: "sources"
                },
                sprite: {
                    type: "sprite"
                },
                glyphs: {
                    type: "string"
                },
                "font-faces": {
                    type: "fontFaces"
                },
                transition: {
                    type: "transition"
                },
                layers: {
                    required: !0,
                    type: "array",
                    value: "layer"
                }
            },
            sources: {
                "*": {
                    type: "source"
                }
            },
            source: [
                "source_vector",
                "source_raster",
                "source_raster_dem",
                "source_geojson",
                "source_video",
                "source_image"
            ],
            source_vector: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        vector: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                attribution: {
                    type: "string"
                },
                promoteId: {
                    type: "promoteId"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                encoding: {
                    type: "enum",
                    values: {
                        mvt: {},
                        mlt: {}
                    },
                    default: "mvt"
                },
                "*": {
                    type: "*"
                }
            },
            source_raster: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        raster: {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                scheme: {
                    type: "enum",
                    values: {
                        xyz: {},
                        tms: {}
                    },
                    default: "xyz"
                },
                attribution: {
                    type: "string"
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_raster_dem: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        "raster-dem": {}
                    }
                },
                url: {
                    type: "string"
                },
                tiles: {
                    type: "array",
                    value: "string"
                },
                bounds: {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        -180,
                        -85.051129,
                        180,
                        85.051129
                    ]
                },
                minzoom: {
                    type: "number",
                    default: 0
                },
                maxzoom: {
                    type: "number",
                    default: 22
                },
                tileSize: {
                    type: "number",
                    default: 512,
                    units: "pixels"
                },
                attribution: {
                    type: "string"
                },
                encoding: {
                    type: "enum",
                    values: {
                        terrarium: {},
                        mapbox: {},
                        custom: {}
                    },
                    default: "mapbox"
                },
                redFactor: {
                    type: "number",
                    default: 1
                },
                blueFactor: {
                    type: "number",
                    default: 1
                },
                greenFactor: {
                    type: "number",
                    default: 1
                },
                baseShift: {
                    type: "number",
                    default: 0
                },
                volatile: {
                    type: "boolean",
                    default: !1
                },
                "*": {
                    type: "*"
                }
            },
            source_geojson: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        geojson: {}
                    }
                },
                data: {
                    required: !0,
                    type: "*"
                },
                maxzoom: {
                    type: "number",
                    default: 18
                },
                attribution: {
                    type: "string"
                },
                buffer: {
                    type: "number",
                    default: 128,
                    maximum: 512,
                    minimum: 0
                },
                filter: {
                    type: "filter"
                },
                tolerance: {
                    type: "number",
                    default: .375
                },
                cluster: {
                    type: "boolean",
                    default: !1
                },
                clusterRadius: {
                    type: "number",
                    default: 50,
                    minimum: 0
                },
                clusterMaxZoom: {
                    type: "number"
                },
                clusterMinPoints: {
                    type: "number"
                },
                clusterProperties: {
                    type: "*"
                },
                lineMetrics: {
                    type: "boolean",
                    default: !1
                },
                generateId: {
                    type: "boolean",
                    default: !1
                },
                promoteId: {
                    type: "promoteId"
                }
            },
            source_video: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        video: {}
                    }
                },
                urls: {
                    required: !0,
                    type: "array",
                    value: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            source_image: {
                type: {
                    required: !0,
                    type: "enum",
                    values: {
                        image: {}
                    }
                },
                url: {
                    required: !0,
                    type: "string"
                },
                coordinates: {
                    required: !0,
                    type: "array",
                    length: 4,
                    value: {
                        type: "array",
                        length: 2,
                        value: "number"
                    }
                }
            },
            layer: {
                id: {
                    type: "string",
                    required: !0
                },
                type: {
                    type: "enum",
                    values: {
                        fill: {},
                        line: {},
                        symbol: {},
                        circle: {},
                        heatmap: {},
                        "fill-extrusion": {},
                        raster: {},
                        hillshade: {},
                        "color-relief": {},
                        background: {}
                    },
                    required: !0
                },
                metadata: {
                    type: "*"
                },
                source: {
                    type: "string"
                },
                "source-layer": {
                    type: "string"
                },
                minzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                maxzoom: {
                    type: "number",
                    minimum: 0,
                    maximum: 24
                },
                filter: {
                    type: "filter"
                },
                layout: {
                    type: "layout"
                },
                paint: {
                    type: "paint"
                }
            },
            layout: [
                "layout_fill",
                "layout_line",
                "layout_circle",
                "layout_heatmap",
                "layout_fill-extrusion",
                "layout_symbol",
                "layout_raster",
                "layout_hillshade",
                "layout_color-relief",
                "layout_background"
            ],
            layout_background: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_fill: {
                "fill-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_circle: {
                "circle-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_heatmap: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            "layout_fill-extrusion": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_line: {
                "line-cap": {
                    type: "enum",
                    values: {
                        butt: {},
                        round: {},
                        square: {}
                    },
                    default: "butt",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-join": {
                    type: "enum",
                    values: {
                        bevel: {},
                        round: {},
                        miter: {}
                    },
                    default: "miter",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-miter-limit": {
                    type: "number",
                    default: 2,
                    requires: [
                        {
                            "line-join": "miter"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-round-limit": {
                    type: "number",
                    default: 1.05,
                    requires: [
                        {
                            "line-join": "round"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_symbol: {
                "symbol-placement": {
                    type: "enum",
                    values: {
                        point: {},
                        line: {},
                        "line-center": {}
                    },
                    default: "point",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-spacing": {
                    type: "number",
                    default: 250,
                    minimum: 1,
                    units: "pixels",
                    requires: [
                        {
                            "symbol-placement": "line"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-avoid-edges": {
                    type: "boolean",
                    default: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "symbol-sort-key": {
                    type: "number",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "symbol-z-order": {
                    type: "enum",
                    values: {
                        auto: {},
                        "viewport-y": {},
                        source: {}
                    },
                    default: "auto",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "!": "icon-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-size": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    units: "factor of the original icon size",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-text-fit": {
                    type: "enum",
                    values: {
                        none: {},
                        width: {},
                        height: {},
                        both: {}
                    },
                    default: "none",
                    requires: [
                        "icon-image",
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-text-fit-padding": {
                    type: "array",
                    value: "number",
                    length: 4,
                    default: [
                        0,
                        0,
                        0,
                        0
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image",
                        "text-field",
                        {
                            "icon-text-fit": [
                                "both",
                                "width",
                                "height"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-image": {
                    type: "resolvedImage",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-padding": {
                    type: "padding",
                    default: [
                        2
                    ],
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-keep-upright": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "icon-image",
                        {
                            "icon-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-offset": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotation-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {},
                        "viewport-glyph": {},
                        auto: {}
                    },
                    default: "auto",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-field": {
                    type: "formatted",
                    default: "",
                    tokens: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-font": {
                    type: "array",
                    value: "string",
                    default: [
                        "Open Sans Regular",
                        "Arial Unicode MS Regular"
                    ],
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-size": {
                    type: "number",
                    default: 16,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-width": {
                    type: "number",
                    default: 10,
                    minimum: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-line-height": {
                    type: "number",
                    default: 1.2,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-letter-spacing": {
                    type: "number",
                    default: 0,
                    units: "ems",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-justify": {
                    type: "enum",
                    values: {
                        auto: {},
                        left: {},
                        center: {},
                        right: {}
                    },
                    default: "center",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-radial-offset": {
                    type: "number",
                    units: "ems",
                    default: 0,
                    requires: [
                        "text-field"
                    ],
                    "property-type": "data-driven",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    }
                },
                "text-variable-anchor": {
                    type: "array",
                    value: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-variable-anchor-offset": {
                    type: "variableAnchorOffsetCollection",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-anchor": {
                    type: "enum",
                    values: {
                        center: {},
                        left: {},
                        right: {},
                        top: {},
                        bottom: {},
                        "top-left": {},
                        "top-right": {},
                        "bottom-left": {},
                        "bottom-right": {}
                    },
                    default: "center",
                    requires: [
                        "text-field",
                        {
                            "!": "text-variable-anchor"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-max-angle": {
                    type: "number",
                    default: 45,
                    units: "degrees",
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-writing-mode": {
                    type: "array",
                    value: "enum",
                    values: {
                        horizontal: {},
                        vertical: {}
                    },
                    requires: [
                        "text-field",
                        {
                            "symbol-placement": [
                                "point"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    units: "degrees",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-padding": {
                    type: "number",
                    default: 2,
                    minimum: 0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-keep-upright": {
                    type: "boolean",
                    default: !0,
                    requires: [
                        "text-field",
                        {
                            "text-rotation-alignment": "map"
                        },
                        {
                            "symbol-placement": [
                                "line",
                                "line-center"
                            ]
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-transform": {
                    type: "enum",
                    values: {
                        none: {},
                        uppercase: {},
                        lowercase: {}
                    },
                    default: "none",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-offset": {
                    type: "array",
                    value: "number",
                    units: "ems",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    requires: [
                        "text-field",
                        {
                            "!": "text-radial-offset"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-allow-overlap": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        {
                            "!": "text-overlap"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-overlap": {
                    type: "enum",
                    values: {
                        never: {},
                        always: {},
                        cooperative: {}
                    },
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-ignore-placement": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-optional": {
                    type: "boolean",
                    default: !1,
                    requires: [
                        "text-field",
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_raster: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            layout_hillshade: {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            "layout_color-relief": {
                visibility: {
                    type: "enum",
                    values: {
                        visible: {},
                        none: {}
                    },
                    default: "visible",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "global-state"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            filter: {
                type: "boolean",
                expression: {
                    interpolated: !1,
                    parameters: [
                        "zoom",
                        "feature"
                    ]
                },
                "property-type": "data-driven"
            },
            filter_operator: {
                type: "enum",
                values: {
                    "==": {},
                    "!=": {},
                    ">": {},
                    ">=": {},
                    "<": {},
                    "<=": {},
                    in: {},
                    "!in": {},
                    all: {},
                    any: {},
                    none: {},
                    has: {},
                    "!has": {}
                }
            },
            geometry_type: {
                type: "enum",
                values: {
                    Point: {},
                    LineString: {},
                    Polygon: {}
                }
            },
            function: {
                expression: {
                    type: "expression"
                },
                stops: {
                    type: "array",
                    value: "function_stop"
                },
                base: {
                    type: "number",
                    default: 1,
                    minimum: 0
                },
                property: {
                    type: "string",
                    default: "$zoom"
                },
                type: {
                    type: "enum",
                    values: {
                        identity: {},
                        exponential: {},
                        interval: {},
                        categorical: {}
                    },
                    default: "exponential"
                },
                colorSpace: {
                    type: "enum",
                    values: {
                        rgb: {},
                        lab: {},
                        hcl: {}
                    },
                    default: "rgb"
                },
                default: {
                    type: "*",
                    required: !1
                }
            },
            function_stop: {
                type: "array",
                minimum: 0,
                maximum: 24,
                value: [
                    "number",
                    "color"
                ],
                length: 2
            },
            expression: {
                type: "array",
                value: "expression_name",
                minimum: 1
            },
            light: {
                anchor: {
                    type: "enum",
                    default: "viewport",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                position: {
                    type: "array",
                    default: [
                        1.15,
                        210,
                        30
                    ],
                    length: 3,
                    value: "number",
                    "property-type": "data-constant",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                },
                color: {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                intensity: {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            sky: {
                "sky-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#88C6FC",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "horizon-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "fog-color": {
                    type: "color",
                    "property-type": "data-constant",
                    default: "#ffffff",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "fog-ground-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "horizon-fog-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "sky-horizon-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                },
                "atmosphere-blend": {
                    type: "number",
                    "property-type": "data-constant",
                    default: .8,
                    minimum: 0,
                    maximum: 1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    transition: !0
                }
            },
            terrain: {
                source: {
                    type: "string",
                    required: !0
                },
                exaggeration: {
                    type: "number",
                    minimum: 0,
                    default: 1
                }
            },
            projection: {
                type: {
                    type: "projectionDefinition",
                    default: "mercator",
                    "property-type": "data-constant",
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    }
                }
            },
            paint: [
                "paint_fill",
                "paint_line",
                "paint_circle",
                "paint_heatmap",
                "paint_fill-extrusion",
                "paint_symbol",
                "paint_raster",
                "paint_hillshade",
                "paint_color-relief",
                "paint_background"
            ],
            paint_fill: {
                "fill-antialias": {
                    type: "boolean",
                    default: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-outline-color": {
                    type: "color",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-pattern"
                        },
                        {
                            "fill-antialias": !0
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                }
            },
            "paint_fill-extrusion": {
                "fill-extrusion-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "fill-extrusion-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "fill-extrusion-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "fill-extrusion-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "fill-extrusion-height": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-base": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "meters",
                    transition: !0,
                    requires: [
                        "fill-extrusion-height"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "fill-extrusion-vertical-gradient": {
                    type: "boolean",
                    default: !0,
                    transition: !1,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_line: {
                "line-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "line-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "line-width": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-gap-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-offset": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "line-dasharray": {
                    type: "array",
                    value: "number",
                    minimum: 0,
                    transition: !0,
                    units: "line widths",
                    requires: [
                        {
                            "!": "line-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "cross-faded-data-driven"
                },
                "line-gradient": {
                    type: "color",
                    transition: !1,
                    requires: [
                        {
                            "!": "line-dasharray"
                        },
                        {
                            "!": "line-pattern"
                        },
                        {
                            source: "geojson",
                            has: {
                                lineMetrics: !0
                            }
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "line-progress"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_circle: {
                "circle-radius": {
                    type: "number",
                    default: 5,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-blur": {
                    type: "number",
                    default: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "circle-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-scale": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-pitch-alignment": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "circle-stroke-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "circle-stroke-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                }
            },
            paint_heatmap: {
                "heatmap-radius": {
                    type: "number",
                    default: 30,
                    minimum: 1,
                    transition: !0,
                    units: "pixels",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-weight": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "heatmap-intensity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "heatmap-color": {
                    type: "color",
                    default: [
                        "interpolate",
                        [
                            "linear"
                        ],
                        [
                            "heatmap-density"
                        ],
                        0,
                        "rgba(0, 0, 255, 0)",
                        .1,
                        "royalblue",
                        .3,
                        "cyan",
                        .5,
                        "lime",
                        .7,
                        "yellow",
                        1,
                        "red"
                    ],
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "heatmap-density"
                        ]
                    },
                    "property-type": "color-ramp"
                },
                "heatmap-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_symbol: {
                "icon-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "icon-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "icon-image"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "icon-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "icon-image",
                        "icon-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    overridable: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-color": {
                    type: "color",
                    default: "rgba(0, 0, 0, 0)",
                    transition: !0,
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-width": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-halo-blur": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom",
                            "feature",
                            "feature-state"
                        ]
                    },
                    "property-type": "data-driven"
                },
                "text-translate": {
                    type: "array",
                    value: "number",
                    length: 2,
                    default: [
                        0,
                        0
                    ],
                    transition: !0,
                    units: "pixels",
                    requires: [
                        "text-field"
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "text-translate-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "map",
                    requires: [
                        "text-field",
                        "text-translate"
                    ],
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_raster: {
                "raster-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-hue-rotate": {
                    type: "number",
                    default: 0,
                    period: 360,
                    transition: !0,
                    units: "degrees",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-min": {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-brightness-max": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-saturation": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-contrast": {
                    type: "number",
                    default: 0,
                    minimum: -1,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-resampling": {
                    type: "enum",
                    values: {
                        linear: {},
                        nearest: {}
                    },
                    default: "linear",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "raster-fade-duration": {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    transition: !1,
                    units: "milliseconds",
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            paint_hillshade: {
                "hillshade-illumination-direction": {
                    type: "numberArray",
                    default: 335,
                    minimum: 0,
                    maximum: 359,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-altitude": {
                    type: "numberArray",
                    default: 45,
                    minimum: 0,
                    maximum: 90,
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-illumination-anchor": {
                    type: "enum",
                    values: {
                        map: {},
                        viewport: {}
                    },
                    default: "viewport",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-exaggeration": {
                    type: "number",
                    default: .5,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-shadow-color": {
                    type: "colorArray",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-highlight-color": {
                    type: "colorArray",
                    default: "#FFFFFF",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-accent-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "hillshade-method": {
                    type: "enum",
                    values: {
                        standard: {},
                        basic: {},
                        combined: {},
                        igor: {},
                        multidirectional: {}
                    },
                    default: "standard",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            "paint_color-relief": {
                "color-relief-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "color-relief-color": {
                    type: "color",
                    transition: !1,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "elevation"
                        ]
                    },
                    "property-type": "color-ramp"
                }
            },
            paint_background: {
                "background-color": {
                    type: "color",
                    default: "#000000",
                    transition: !0,
                    requires: [
                        {
                            "!": "background-pattern"
                        }
                    ],
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                },
                "background-pattern": {
                    type: "resolvedImage",
                    transition: !0,
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "cross-faded"
                },
                "background-opacity": {
                    type: "number",
                    default: 1,
                    minimum: 0,
                    maximum: 1,
                    transition: !0,
                    expression: {
                        interpolated: !0,
                        parameters: [
                            "zoom"
                        ]
                    },
                    "property-type": "data-constant"
                }
            },
            transition: {
                duration: {
                    type: "number",
                    default: 300,
                    minimum: 0,
                    units: "milliseconds"
                },
                delay: {
                    type: "number",
                    default: 0,
                    minimum: 0,
                    units: "milliseconds"
                }
            },
            "property-type": {
                "data-driven": {
                    type: "property-type"
                },
                "cross-faded": {
                    type: "property-type"
                },
                "cross-faded-data-driven": {
                    type: "property-type"
                },
                "color-ramp": {
                    type: "property-type"
                },
                "data-constant": {
                    type: "property-type"
                },
                constant: {
                    type: "property-type"
                }
            },
            promoteId: {
                "*": {
                    type: "string"
                }
            },
            interpolation: {
                type: "array",
                value: "interpolation_name",
                minimum: 1
            },
            interpolation_name: {
                type: "enum",
                values: {
                    linear: {
                        syntax: {
                            overloads: [
                                {
                                    parameters: [],
                                    "output-type": "interpolation"
                                }
                            ],
                            parameters: []
                        }
                    },
                    exponential: {
                        syntax: {
                            overloads: [
                                {
                                    parameters: [
                                        "base"
                                    ],
                                    "output-type": "interpolation"
                                }
                            ],
                            parameters: [
                                {
                                    name: "base",
                                    type: "number literal"
                                }
                            ]
                        }
                    },
                    "cubic-bezier": {
                        syntax: {
                            overloads: [
                                {
                                    parameters: [
                                        "x1",
                                        "y1",
                                        "x2",
                                        "y2"
                                    ],
                                    "output-type": "interpolation"
                                }
                            ],
                            parameters: [
                                {
                                    name: "x1",
                                    type: "number literal"
                                },
                                {
                                    name: "y1",
                                    type: "number literal"
                                },
                                {
                                    name: "x2",
                                    type: "number literal"
                                },
                                {
                                    name: "y2",
                                    type: "number literal"
                                }
                            ]
                        }
                    }
                }
            }
        };
        var bt = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ];
        function wt(t, e1) {
            var _$r = {};
            for(var _$e in t)"ref" !== _$e && (_$r[_$e] = t[_$e]);
            return bt.forEach(function(t) {
                t in e1 && (_$r[t] = e1[t]);
            }), _$r;
        }
        function _t(t, e1) {
            if (Array.isArray(t)) {
                if (!Array.isArray(e1) || t.length !== e1.length) return !1;
                for(var _$r = 0; _$r < t.length; _$r++)if (!_t(t[_$r], e1[_$r])) return !1;
                return !0;
            }
            if ("object" == (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t)) && null !== t && null !== e1) {
                if ("object" != (typeof e1 === "undefined" ? "undefined" : (0, $dvYFb._)(e1))) return !1;
                if (Object.keys(t).length !== Object.keys(e1).length) return !1;
                for(var _$r1 in t)if (!_t(t[_$r1], e1[_$r1])) return !1;
                return !0;
            }
            return t === e1;
        }
        function St(t, e1) {
            t.push(e1);
        }
        function At(t, e1, r) {
            St(r, {
                command: "addSource",
                args: [
                    t,
                    e1[t]
                ]
            });
        }
        function kt(t, e1, r) {
            St(e1, {
                command: "removeSource",
                args: [
                    t
                ]
            }), r[t] = !0;
        }
        function Et(t, e1, r, n) {
            kt(t, r, n), At(t, e1, r);
        }
        function Tt(t, e1, r) {
            var _$n;
            for(_$n in t[r])if (Object.prototype.hasOwnProperty.call(t[r], _$n) && "data" !== _$n && !_t(t[r][_$n], e1[r][_$n])) return !1;
            for(_$n in e1[r])if (Object.prototype.hasOwnProperty.call(e1[r], _$n) && "data" !== _$n && !_t(t[r][_$n], e1[r][_$n])) return !1;
            return !0;
        }
        function It(t, e1, r, n, i, s) {
            t = t || {}, e1 = e1 || {};
            for(var a in t)Object.prototype.hasOwnProperty.call(t, a) && (_t(t[a], e1[a]) || r.push({
                command: s,
                args: [
                    n,
                    a,
                    e1[a],
                    i
                ]
            }));
            for(var a1 in e1)Object.prototype.hasOwnProperty.call(e1, a1) && !Object.prototype.hasOwnProperty.call(t, a1) && (_t(t[a1], e1[a1]) || r.push({
                command: s,
                args: [
                    n,
                    a1,
                    e1[a1],
                    i
                ]
            }));
        }
        function Mt(t) {
            return t.id;
        }
        function Ft(t, e1) {
            return t[e1.id] = e1, t;
        }
        var Dt = function Dt(t, e1, r, n) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, Dt);
            this.message = (t ? "".concat(t, ": ") : "") + r, n && (this.identifier = n), null != e1 && e1.__line__ && (this.line = e1.__line__);
        };
        function zt(t) {
            for(var _len = arguments.length, _$e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                _$e[_key - 1] = arguments[_key];
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _$e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$r = _step.value;
                    for(var _$e1 in _$r)t[_$e1] = _$r[_$e1];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return t;
        }
        var Pt = /*#__PURE__*/ function(Error1) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Pt, Error1);
            function Pt(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Pt);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Pt, [
                    e1
                ]), _this.message = e1, _this.key = t;
                return _this;
            }
            return Pt;
        }((0, $cdcde981a6d4bbcf$export$71511d61b312f219)(Error));
        var Bt = /*#__PURE__*/ function() {
            function Bt(t) {
                var _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Bt);
                this.parent = t, this.bindings = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _$e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), _$t = _step_value[0], _$r = _step_value[1];
                        this.bindings[_$t] = _$r;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Bt, [
                {
                    key: "concat",
                    value: function concat(t) {
                        return new Bt(this, t);
                    }
                },
                {
                    key: "get",
                    value: function get(t) {
                        if (this.bindings[t]) return this.bindings[t];
                        if (this.parent) return this.parent.get(t);
                        throw new Error("".concat(t, " not found in scope."));
                    }
                },
                {
                    key: "has",
                    value: function has(t) {
                        return !!this.bindings[t] || !!this.parent && this.parent.has(t);
                    }
                }
            ]);
            return Bt;
        }();
        var Vt = {
            kind: "null"
        }, Ct = {
            kind: "number"
        }, Lt = {
            kind: "string"
        }, Ot = {
            kind: "boolean"
        }, Rt = {
            kind: "color"
        }, Nt = {
            kind: "projectionDefinition"
        }, $t = {
            kind: "object"
        }, Ut = {
            kind: "value"
        }, qt = {
            kind: "collator"
        }, jt = {
            kind: "formatted"
        }, Gt = {
            kind: "padding"
        }, Xt = {
            kind: "colorArray"
        }, Yt = {
            kind: "numberArray"
        }, Zt = {
            kind: "resolvedImage"
        }, Ht = {
            kind: "variableAnchorOffsetCollection"
        };
        function Kt(t, e1) {
            return {
                kind: "array",
                itemType: t,
                N: e1
            };
        }
        function Wt(t) {
            if ("array" === t.kind) {
                var _$e = Wt(t.itemType);
                return "number" == typeof t.N ? "array<".concat(_$e, ", ").concat(t.N, ">") : "value" === t.itemType.kind ? "array" : "array<".concat(_$e, ">");
            }
            return t.kind;
        }
        var Jt = [
            Vt,
            Ct,
            Lt,
            Ot,
            Rt,
            Nt,
            jt,
            $t,
            Kt(Ut),
            Gt,
            Yt,
            Xt,
            Zt,
            Ht
        ];
        function Qt(t, e1) {
            if ("error" === e1.kind) return null;
            if ("array" === t.kind) {
                if ("array" === e1.kind && (0 === e1.N && "value" === e1.itemType.kind || !Qt(t.itemType, e1.itemType)) && ("number" != typeof t.N || t.N === e1.N)) return null;
            } else {
                if (t.kind === e1.kind) return null;
                if ("value" === t.kind) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Jt[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step.value;
                            if (!Qt(_$t, e1)) return null;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
            return "Expected ".concat(Wt(t), " but found ").concat(Wt(e1), " instead.");
        }
        function te(t, e1) {
            return e1.some(function(e1) {
                return e1.kind === t.kind;
            });
        }
        function ee(t, e1) {
            return e1.some(function(e1) {
                return "null" === e1 ? null === t : "array" === e1 ? Array.isArray(t) : "object" === e1 ? t && !Array.isArray(t) && "object" == (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t)) : e1 === (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t));
            });
        }
        function re(t, e1) {
            return "array" === t.kind && "array" === e1.kind ? t.itemType.kind === e1.itemType.kind && "number" == typeof t.N : t.kind === e1.kind;
        }
        var ne = .96422, ie = .82521, se = 4 / 29, ae = 6 / 29, oe = 3 * ae * ae, le = ae * ae * ae, ue = Math.PI / 180, ce = 180 / Math.PI;
        function he(t) {
            return (t %= 360) < 0 && (t += 360), t;
        }
        function pe(param) {
            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 4), _$t = _param[0], _$e = _param[1], _$r = _param[2], _$n = _param[3];
            var i, s;
            var a = de((.2225045 * (_$t = fe(_$t)) + .7168786 * (_$e = fe(_$e)) + .0606169 * (_$r = fe(_$r))) / 1);
            _$t === _$e && _$e === _$r ? i = s = a : (i = de((.4360747 * _$t + .3850649 * _$e + .1430804 * _$r) / ne), s = de((.0139322 * _$t + .0971045 * _$e + .7141733 * _$r) / ie));
            var o = 116 * a - 16;
            return [
                o < 0 ? 0 : o,
                500 * (i - a),
                200 * (a - s),
                _$n
            ];
        }
        function fe(t) {
            return t <= .04045 ? t / 12.92 : Math.pow((t + .055) / 1.055, 2.4);
        }
        function de(t) {
            return t > le ? Math.pow(t, 1 / 3) : t / oe + se;
        }
        function ye(param) {
            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 4), _$t = _param[0], _$e = _param[1], _$r = _param[2], _$n = _param[3];
            var i = (_$t + 16) / 116, s = isNaN(_$e) ? i : i + _$e / 500, a = isNaN(_$r) ? i : i - _$r / 200;
            return i = 1 * ge(i), s = ne * ge(s), a = ie * ge(a), [
                me(3.1338561 * s - 1.6168667 * i - .4906146 * a),
                me(-0.9787684 * s + 1.9161415 * i + .033454 * a),
                me(.0719453 * s - .2289914 * i + 1.4052427 * a),
                _$n
            ];
        }
        function me(t) {
            return (t = t <= .00304 ? 12.92 * t : 1.055 * Math.pow(t, 1 / 2.4) - .055) < 0 ? 0 : t > 1 ? 1 : t;
        }
        function ge(t) {
            return t > ae ? t * t * t : oe * (t - se);
        }
        var xe = Object.hasOwn || function(t, e1) {
            return Object.prototype.hasOwnProperty.call(t, e1);
        };
        function ve(t, e1) {
            return xe(t, e1) ? t[e1] : void 0;
        }
        function be(t) {
            return parseInt(t.padEnd(2, t), 16) / 255;
        }
        function we(t, e1) {
            return _e(e1 ? t / 100 : t, 0, 1);
        }
        function _e(t, e1, r) {
            return Math.min(Math.max(e1, t), r);
        }
        function Se(t) {
            return !t.some(Number.isNaN);
        }
        var Ae = {
            aliceblue: [
                240,
                248,
                255
            ],
            antiquewhite: [
                250,
                235,
                215
            ],
            aqua: [
                0,
                255,
                255
            ],
            aquamarine: [
                127,
                255,
                212
            ],
            azure: [
                240,
                255,
                255
            ],
            beige: [
                245,
                245,
                220
            ],
            bisque: [
                255,
                228,
                196
            ],
            black: [
                0,
                0,
                0
            ],
            blanchedalmond: [
                255,
                235,
                205
            ],
            blue: [
                0,
                0,
                255
            ],
            blueviolet: [
                138,
                43,
                226
            ],
            brown: [
                165,
                42,
                42
            ],
            burlywood: [
                222,
                184,
                135
            ],
            cadetblue: [
                95,
                158,
                160
            ],
            chartreuse: [
                127,
                255,
                0
            ],
            chocolate: [
                210,
                105,
                30
            ],
            coral: [
                255,
                127,
                80
            ],
            cornflowerblue: [
                100,
                149,
                237
            ],
            cornsilk: [
                255,
                248,
                220
            ],
            crimson: [
                220,
                20,
                60
            ],
            cyan: [
                0,
                255,
                255
            ],
            darkblue: [
                0,
                0,
                139
            ],
            darkcyan: [
                0,
                139,
                139
            ],
            darkgoldenrod: [
                184,
                134,
                11
            ],
            darkgray: [
                169,
                169,
                169
            ],
            darkgreen: [
                0,
                100,
                0
            ],
            darkgrey: [
                169,
                169,
                169
            ],
            darkkhaki: [
                189,
                183,
                107
            ],
            darkmagenta: [
                139,
                0,
                139
            ],
            darkolivegreen: [
                85,
                107,
                47
            ],
            darkorange: [
                255,
                140,
                0
            ],
            darkorchid: [
                153,
                50,
                204
            ],
            darkred: [
                139,
                0,
                0
            ],
            darksalmon: [
                233,
                150,
                122
            ],
            darkseagreen: [
                143,
                188,
                143
            ],
            darkslateblue: [
                72,
                61,
                139
            ],
            darkslategray: [
                47,
                79,
                79
            ],
            darkslategrey: [
                47,
                79,
                79
            ],
            darkturquoise: [
                0,
                206,
                209
            ],
            darkviolet: [
                148,
                0,
                211
            ],
            deeppink: [
                255,
                20,
                147
            ],
            deepskyblue: [
                0,
                191,
                255
            ],
            dimgray: [
                105,
                105,
                105
            ],
            dimgrey: [
                105,
                105,
                105
            ],
            dodgerblue: [
                30,
                144,
                255
            ],
            firebrick: [
                178,
                34,
                34
            ],
            floralwhite: [
                255,
                250,
                240
            ],
            forestgreen: [
                34,
                139,
                34
            ],
            fuchsia: [
                255,
                0,
                255
            ],
            gainsboro: [
                220,
                220,
                220
            ],
            ghostwhite: [
                248,
                248,
                255
            ],
            gold: [
                255,
                215,
                0
            ],
            goldenrod: [
                218,
                165,
                32
            ],
            gray: [
                128,
                128,
                128
            ],
            green: [
                0,
                128,
                0
            ],
            greenyellow: [
                173,
                255,
                47
            ],
            grey: [
                128,
                128,
                128
            ],
            honeydew: [
                240,
                255,
                240
            ],
            hotpink: [
                255,
                105,
                180
            ],
            indianred: [
                205,
                92,
                92
            ],
            indigo: [
                75,
                0,
                130
            ],
            ivory: [
                255,
                255,
                240
            ],
            khaki: [
                240,
                230,
                140
            ],
            lavender: [
                230,
                230,
                250
            ],
            lavenderblush: [
                255,
                240,
                245
            ],
            lawngreen: [
                124,
                252,
                0
            ],
            lemonchiffon: [
                255,
                250,
                205
            ],
            lightblue: [
                173,
                216,
                230
            ],
            lightcoral: [
                240,
                128,
                128
            ],
            lightcyan: [
                224,
                255,
                255
            ],
            lightgoldenrodyellow: [
                250,
                250,
                210
            ],
            lightgray: [
                211,
                211,
                211
            ],
            lightgreen: [
                144,
                238,
                144
            ],
            lightgrey: [
                211,
                211,
                211
            ],
            lightpink: [
                255,
                182,
                193
            ],
            lightsalmon: [
                255,
                160,
                122
            ],
            lightseagreen: [
                32,
                178,
                170
            ],
            lightskyblue: [
                135,
                206,
                250
            ],
            lightslategray: [
                119,
                136,
                153
            ],
            lightslategrey: [
                119,
                136,
                153
            ],
            lightsteelblue: [
                176,
                196,
                222
            ],
            lightyellow: [
                255,
                255,
                224
            ],
            lime: [
                0,
                255,
                0
            ],
            limegreen: [
                50,
                205,
                50
            ],
            linen: [
                250,
                240,
                230
            ],
            magenta: [
                255,
                0,
                255
            ],
            maroon: [
                128,
                0,
                0
            ],
            mediumaquamarine: [
                102,
                205,
                170
            ],
            mediumblue: [
                0,
                0,
                205
            ],
            mediumorchid: [
                186,
                85,
                211
            ],
            mediumpurple: [
                147,
                112,
                219
            ],
            mediumseagreen: [
                60,
                179,
                113
            ],
            mediumslateblue: [
                123,
                104,
                238
            ],
            mediumspringgreen: [
                0,
                250,
                154
            ],
            mediumturquoise: [
                72,
                209,
                204
            ],
            mediumvioletred: [
                199,
                21,
                133
            ],
            midnightblue: [
                25,
                25,
                112
            ],
            mintcream: [
                245,
                255,
                250
            ],
            mistyrose: [
                255,
                228,
                225
            ],
            moccasin: [
                255,
                228,
                181
            ],
            navajowhite: [
                255,
                222,
                173
            ],
            navy: [
                0,
                0,
                128
            ],
            oldlace: [
                253,
                245,
                230
            ],
            olive: [
                128,
                128,
                0
            ],
            olivedrab: [
                107,
                142,
                35
            ],
            orange: [
                255,
                165,
                0
            ],
            orangered: [
                255,
                69,
                0
            ],
            orchid: [
                218,
                112,
                214
            ],
            palegoldenrod: [
                238,
                232,
                170
            ],
            palegreen: [
                152,
                251,
                152
            ],
            paleturquoise: [
                175,
                238,
                238
            ],
            palevioletred: [
                219,
                112,
                147
            ],
            papayawhip: [
                255,
                239,
                213
            ],
            peachpuff: [
                255,
                218,
                185
            ],
            peru: [
                205,
                133,
                63
            ],
            pink: [
                255,
                192,
                203
            ],
            plum: [
                221,
                160,
                221
            ],
            powderblue: [
                176,
                224,
                230
            ],
            purple: [
                128,
                0,
                128
            ],
            rebeccapurple: [
                102,
                51,
                153
            ],
            red: [
                255,
                0,
                0
            ],
            rosybrown: [
                188,
                143,
                143
            ],
            royalblue: [
                65,
                105,
                225
            ],
            saddlebrown: [
                139,
                69,
                19
            ],
            salmon: [
                250,
                128,
                114
            ],
            sandybrown: [
                244,
                164,
                96
            ],
            seagreen: [
                46,
                139,
                87
            ],
            seashell: [
                255,
                245,
                238
            ],
            sienna: [
                160,
                82,
                45
            ],
            silver: [
                192,
                192,
                192
            ],
            skyblue: [
                135,
                206,
                235
            ],
            slateblue: [
                106,
                90,
                205
            ],
            slategray: [
                112,
                128,
                144
            ],
            slategrey: [
                112,
                128,
                144
            ],
            snow: [
                255,
                250,
                250
            ],
            springgreen: [
                0,
                255,
                127
            ],
            steelblue: [
                70,
                130,
                180
            ],
            tan: [
                210,
                180,
                140
            ],
            teal: [
                0,
                128,
                128
            ],
            thistle: [
                216,
                191,
                216
            ],
            tomato: [
                255,
                99,
                71
            ],
            turquoise: [
                64,
                224,
                208
            ],
            violet: [
                238,
                130,
                238
            ],
            wheat: [
                245,
                222,
                179
            ],
            white: [
                255,
                255,
                255
            ],
            whitesmoke: [
                245,
                245,
                245
            ],
            yellow: [
                255,
                255,
                0
            ],
            yellowgreen: [
                154,
                205,
                50
            ]
        };
        function ke(t, e1, r) {
            return t + r * (e1 - t);
        }
        function Ee(t, e1, r) {
            return t.map(function(t, n) {
                return ke(t, e1[n], r);
            });
        }
        var Te = /*#__PURE__*/ function() {
            function Te(t, e1, r) {
                var _$n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !0;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Te);
                this.r = t, this.g = e1, this.b = r, this.a = _$n, i || (this.r *= _$n, this.g *= _$n, this.b *= _$n, _$n || this.overwriteGetter("rgb", [
                    t,
                    e1,
                    r,
                    _$n
                ]));
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Te, [
                {
                    key: "rgb",
                    get: function get() {
                        var _this = this, _$t = _this.r, _$e = _this.g, _$r = _this.b, _$n = _this.a, i = _$n || 1 / 0;
                        return this.overwriteGetter("rgb", [
                            _$t / i,
                            _$e / i,
                            _$r / i,
                            _$n
                        ]);
                    }
                },
                {
                    key: "hcl",
                    get: function get() {
                        return this.overwriteGetter("hcl", function(t) {
                            var _pe = (0, $db95b225ee8036d6$export$71511d61b312f219)(pe(t), 4), _$e = _pe[0], _$r = _pe[1], _$n = _pe[2], i = _pe[3], s = Math.sqrt(_$r * _$r + _$n * _$n);
                            return [
                                Math.round(1e4 * s) ? he(Math.atan2(_$n, _$r) * ce) : NaN,
                                s,
                                _$e,
                                i
                            ];
                        }(this.rgb));
                    }
                },
                {
                    key: "lab",
                    get: function get() {
                        return this.overwriteGetter("lab", pe(this.rgb));
                    }
                },
                {
                    key: "overwriteGetter",
                    value: function overwriteGetter(t, e1) {
                        return Object.defineProperty(this, t, {
                            value: e1
                        }), e1;
                    }
                },
                {
                    key: "toString",
                    value: function toString() {
                        var _this_rgb = (0, $db95b225ee8036d6$export$71511d61b312f219)(this.rgb, 4), _$t = _this_rgb[0], _$e = _this_rgb[1], _$r = _this_rgb[2], _$n = _this_rgb[3];
                        return "rgba(".concat([
                            _$t,
                            _$e,
                            _$r
                        ].map(function(t) {
                            return Math.round(255 * t);
                        }).join(","), ",").concat(_$n, ")");
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t) {
                        if (t instanceof Te) return t;
                        if ("string" != typeof t) return;
                        var _$e = function(t) {
                            if ("transparent" === (t = t.toLowerCase().trim())) return [
                                0,
                                0,
                                0,
                                0
                            ];
                            var _$e = ve(Ae, t);
                            if (_$e) {
                                var _$_e = (0, $db95b225ee8036d6$export$71511d61b312f219)(_$e, 3), _$t = _$_e[0], _$r = _$_e[1], _$n = _$_e[2];
                                return [
                                    _$t / 255,
                                    _$r / 255,
                                    _$n / 255,
                                    1
                                ];
                            }
                            if (t.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(t)) {
                                var _$e1 = t.length < 6 ? 1 : 2;
                                var _$r1 = 1;
                                return [
                                    be(t.slice(_$r1, _$r1 += _$e1)),
                                    be(t.slice(_$r1, _$r1 += _$e1)),
                                    be(t.slice(_$r1, _$r1 += _$e1)),
                                    be(t.slice(_$r1, _$r1 + _$e1) || "ff")
                                ];
                            }
                            if (t.startsWith("rgb")) {
                                var _$e2 = t.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                if (_$e2) {
                                    var _$_e1 = (0, $db95b225ee8036d6$export$71511d61b312f219)(_$e2, 12), _$t1 = _$_e1[0], _$r2 = _$_e1[1], _$n1 = _$_e1[2], i = _$_e1[3], s = _$_e1[4], a = _$_e1[5], o = _$_e1[6], l = _$_e1[7], u = _$_e1[8], _$c = _$_e1[9], _$h = _$_e1[10], p = _$_e1[11], f = [
                                        i || " ",
                                        o || " ",
                                        _$c
                                    ].join("");
                                    if ("  " === f || "  /" === f || ",," === f || ",,," === f) {
                                        var _$t2 = [
                                            _$n1,
                                            a,
                                            u
                                        ].join(""), _$e3 = "%%%" === _$t2 ? 100 : "" === _$t2 ? 255 : 0;
                                        if (_$e3) {
                                            var _$t3 = [
                                                _e(+_$r2 / _$e3, 0, 1),
                                                _e(+s / _$e3, 0, 1),
                                                _e(+l / _$e3, 0, 1),
                                                _$h ? we(+_$h, p) : 1
                                            ];
                                            if (Se(_$t3)) return _$t3;
                                        }
                                    }
                                    return;
                                }
                            }
                            var _$r3 = t.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                            if (_$r3) {
                                var _r = (0, $db95b225ee8036d6$export$71511d61b312f219)(_$r3, 9), _$t4 = _r[0], _$e4 = _r[1], _$n2 = _r[2], i1 = _r[3], s1 = _r[4], a1 = _r[5], o1 = _r[6], l1 = _r[7], u1 = _r[8], _$c1 = [
                                    _$n2 || " ",
                                    s1 || " ",
                                    o1
                                ].join("");
                                if ("  " === _$c1 || "  /" === _$c1 || ",," === _$c1 || ",,," === _$c1) {
                                    var _$t5 = [
                                        +_$e4,
                                        _e(+i1, 0, 100),
                                        _e(+a1, 0, 100),
                                        l1 ? we(+l1, u1) : 1
                                    ];
                                    if (Se(_$t5)) return function(param) {
                                        var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 4), _$t = _param[0], _$e = _param[1], _$r = _param[2], _$n = _param[3];
                                        function i(n) {
                                            var _$i = (n + _$t / 30) % 12, s = _$e * Math.min(_$r, 1 - _$r);
                                            return _$r - s * Math.max(-1, Math.min(_$i - 3, 9 - _$i, 1));
                                        }
                                        return _$t = he(_$t), _$e /= 100, _$r /= 100, [
                                            i(0),
                                            i(8),
                                            i(4),
                                            _$n
                                        ];
                                    }(_$t5);
                                }
                            }
                        }(t);
                        return _$e ? (0, $1b84e43f64f42d09$export$71511d61b312f219)(Te, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$e).concat([
                            !1
                        ])) : void 0;
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate(t, e1, r) {
                        var _$n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "rgb";
                        switch(_$n){
                            case "rgb":
                                {
                                    var _Ee = (0, $db95b225ee8036d6$export$71511d61b312f219)(Ee(t.rgb, e1.rgb, r), 4), _$n1 = _Ee[0], i = _Ee[1], s = _Ee[2], a = _Ee[3];
                                    return new Te(_$n1, i, s, a, !1);
                                }
                            case "hcl":
                                {
                                    var _t_hcl = (0, $db95b225ee8036d6$export$71511d61b312f219)(t.hcl, 4), _$n2 = _t_hcl[0], i1 = _t_hcl[1], s1 = _t_hcl[2], a1 = _t_hcl[3], _e_hcl = (0, $db95b225ee8036d6$export$71511d61b312f219)(e1.hcl, 4), o = _e_hcl[0], l = _e_hcl[1], u = _e_hcl[2], _$c = _e_hcl[3];
                                    var _$h, p;
                                    if (isNaN(_$n2) || isNaN(o)) isNaN(_$n2) ? isNaN(o) ? _$h = NaN : (_$h = o, 1 !== s1 && 0 !== s1 || (p = l)) : (_$h = _$n2, 1 !== u && 0 !== u || (p = i1));
                                    else {
                                        var _$t = o - _$n2;
                                        o > _$n2 && _$t > 180 ? _$t -= 360 : o < _$n2 && _$n2 - o > 180 && (_$t += 360), _$h = _$n2 + r * _$t;
                                    }
                                    var _ref = (0, $db95b225ee8036d6$export$71511d61b312f219)(function(param) {
                                        var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 4), _$t = _param[0], _$e = _param[1], _$r = _param[2], _$n = _param[3];
                                        return _$t = isNaN(_$t) ? 0 : _$t * ue, ye([
                                            _$r,
                                            Math.cos(_$t) * _$e,
                                            Math.sin(_$t) * _$e,
                                            _$n
                                        ]);
                                    }([
                                        _$h,
                                        null != p ? p : ke(i1, l, r),
                                        ke(s1, u, r),
                                        ke(a1, _$c, r)
                                    ]), 4), f = _ref[0], _$d = _ref[1], _$y = _ref[2], _$m = _ref[3];
                                    return new Te(f, _$d, _$y, _$m, !1);
                                }
                            case "lab":
                                {
                                    var _ye = (0, $db95b225ee8036d6$export$71511d61b312f219)(ye(Ee(t.lab, e1.lab, r)), 4), _$n3 = _ye[0], i2 = _ye[1], s2 = _ye[2], a2 = _ye[3];
                                    return new Te(_$n3, i2, s2, a2, !1);
                                }
                        }
                    }
                }
            ]);
            return Te;
        }();
        Te.black = new Te(0, 0, 0, 1), Te.white = new Te(1, 1, 1, 1), Te.transparent = new Te(0, 0, 0, 0), Te.red = new Te(1, 0, 0, 1);
        var Ie = /*#__PURE__*/ function() {
            function Ie(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ie);
                this.sensitivity = t ? e1 ? "variant" : "case" : e1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ie, [
                {
                    key: "compare",
                    value: function compare(t, e1) {
                        return this.collator.compare(t, e1);
                    }
                },
                {
                    key: "resolvedLocale",
                    value: function resolvedLocale() {
                        return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
                    }
                }
            ]);
            return Ie;
        }();
        var Me = [
            "bottom",
            "center",
            "top"
        ];
        var Fe = function Fe(t, e1, r, n, i, s) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, Fe);
            this.text = t, this.image = e1, this.scale = r, this.fontStack = n, this.textColor = i, this.verticalAlign = s;
        };
        var De = /*#__PURE__*/ function() {
            function De(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, De);
                this.sections = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(De, [
                {
                    key: "isEmpty",
                    value: function isEmpty() {
                        return 0 === this.sections.length || !this.sections.some(function(t) {
                            return 0 !== t.text.length || t.image && 0 !== t.image.name.length;
                        });
                    }
                },
                {
                    key: "toString",
                    value: function toString() {
                        return 0 === this.sections.length ? "" : this.sections.map(function(t) {
                            return t.text;
                        }).join("");
                    }
                }
            ], [
                {
                    key: "fromString",
                    value: function fromString(t) {
                        return new De([
                            new Fe(t, null, null, null, null, null)
                        ]);
                    }
                },
                {
                    key: "factory",
                    value: function factory(t) {
                        return t instanceof De ? t : De.fromString(t);
                    }
                }
            ]);
            return De;
        }();
        var ze = /*#__PURE__*/ function() {
            function ze(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ze);
                this.values = t.slice();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ze, [
                {
                    key: "toString",
                    value: function toString() {
                        return JSON.stringify(this.values);
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t) {
                        if (t instanceof ze) return t;
                        if ("number" == typeof t) return new ze([
                            t,
                            t,
                            t,
                            t
                        ]);
                        if (Array.isArray(t) && !(t.length < 1 || t.length > 4)) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    if ("number" != typeof _$e) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            switch(t.length){
                                case 1:
                                    t = [
                                        t[0],
                                        t[0],
                                        t[0],
                                        t[0]
                                    ];
                                    break;
                                case 2:
                                    t = [
                                        t[0],
                                        t[1],
                                        t[0],
                                        t[1]
                                    ];
                                    break;
                                case 3:
                                    t = [
                                        t[0],
                                        t[1],
                                        t[2],
                                        t[1]
                                    ];
                            }
                            return new ze(t);
                        }
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate(t, e1, r) {
                        return new ze(Ee(t.values, e1.values, r));
                    }
                }
            ]);
            return ze;
        }();
        var Pe = /*#__PURE__*/ function() {
            function Pe(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Pe);
                this.values = t.slice();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Pe, [
                {
                    key: "toString",
                    value: function toString() {
                        return JSON.stringify(this.values);
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t) {
                        if (t instanceof Pe) return t;
                        if ("number" == typeof t) return new Pe([
                            t
                        ]);
                        if (Array.isArray(t)) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    if ("number" != typeof _$e) return;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return new Pe(t);
                        }
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate(t, e1, r) {
                        return new Pe(Ee(t.values, e1.values, r));
                    }
                }
            ]);
            return Pe;
        }();
        var Be = /*#__PURE__*/ function() {
            function Be(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Be);
                this.values = t.slice();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Be, [
                {
                    key: "toString",
                    value: function toString() {
                        return JSON.stringify(this.values);
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t) {
                        if (t instanceof Be) return t;
                        if ("string" == typeof t) {
                            var _$e = Te.parse(t);
                            if (!_$e) return;
                            return new Be([
                                _$e
                            ]);
                        }
                        if (!Array.isArray(t)) return;
                        var _$e1 = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$r = _step.value;
                                if ("string" != typeof _$r) return;
                                var _$t = Te.parse(_$r);
                                if (!_$t) return;
                                _$e1.push(_$t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return new Be(_$e1);
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate(t, e1, r) {
                        var _$n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "rgb";
                        var i = [];
                        if (t.values.length != e1.values.length) throw new Error("colorArray: Arrays have mismatched length (".concat(t.values.length, " vs. ").concat(e1.values.length, "), cannot interpolate."));
                        for(var s = 0; s < t.values.length; s++)i.push(Te.interpolate(t.values[s], e1.values[s], r, _$n));
                        return new Be(i);
                    }
                }
            ]);
            return Be;
        }();
        var Ve = /*#__PURE__*/ function(Error1) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ve, Error1);
            function Ve(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ve);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Ve, [
                    t
                ]), _this.name = "RuntimeError";
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ve, [
                {
                    key: "toJSON",
                    value: function toJSON() {
                        return this.message;
                    }
                }
            ]);
            return Ve;
        }((0, $cdcde981a6d4bbcf$export$71511d61b312f219)(Error));
        var Ce = new Set([
            "center",
            "left",
            "right",
            "top",
            "bottom",
            "top-left",
            "top-right",
            "bottom-left",
            "bottom-right"
        ]);
        var Le = /*#__PURE__*/ function() {
            function Le(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Le);
                this.values = t.slice();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Le, [
                {
                    key: "toString",
                    value: function toString() {
                        return JSON.stringify(this.values);
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t) {
                        if (t instanceof Le) return t;
                        if (Array.isArray(t) && !(t.length < 1) && t.length % 2 == 0) {
                            for(var _$e = 0; _$e < t.length; _$e += 2){
                                var _$r = t[_$e], _$n = t[_$e + 1];
                                if ("string" != typeof _$r || !Ce.has(_$r)) return;
                                if (!Array.isArray(_$n) || 2 !== _$n.length || "number" != typeof _$n[0] || "number" != typeof _$n[1]) return;
                            }
                            return new Le(t);
                        }
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate(t, e1, r) {
                        var _$n = t.values, i = e1.values;
                        if (_$n.length !== i.length) throw new Ve("Cannot interpolate values of different length. from: ".concat(t.toString(), ", to: ").concat(e1.toString()));
                        var s = [];
                        for(var _$t = 0; _$t < _$n.length; _$t += 2){
                            if (_$n[_$t] !== i[_$t]) throw new Ve("Cannot interpolate values containing mismatched anchors. from[".concat(_$t, "]: ").concat(_$n[_$t], ", to[").concat(_$t, "]: ").concat(i[_$t]));
                            s.push(_$n[_$t]);
                            var _n_ = (0, $db95b225ee8036d6$export$71511d61b312f219)(_$n[_$t + 1], 2), _$e = _n_[0], a = _n_[1], _i_ = (0, $db95b225ee8036d6$export$71511d61b312f219)(i[_$t + 1], 2), o = _i_[0], l = _i_[1];
                            s.push([
                                ke(_$e, o, r),
                                ke(a, l, r)
                            ]);
                        }
                        return new Le(s);
                    }
                }
            ]);
            return Le;
        }();
        var Oe = /*#__PURE__*/ function() {
            function Oe(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Oe);
                this.name = t.name, this.available = t.available;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Oe, [
                {
                    key: "toString",
                    value: function toString() {
                        return this.name;
                    }
                }
            ], [
                {
                    key: "fromString",
                    value: function fromString(t) {
                        return t ? new Oe({
                            name: t,
                            available: !1
                        }) : null;
                    }
                }
            ]);
            return Oe;
        }();
        var Re = /*#__PURE__*/ function() {
            function Re(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Re);
                this.from = t, this.to = e1, this.transition = r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Re, null, [
                {
                    key: "interpolate",
                    value: function interpolate(t, e1, r) {
                        return new Re(t, e1, r);
                    }
                },
                {
                    key: "parse",
                    value: function parse(t) {
                        return t instanceof Re ? t : Array.isArray(t) && 3 === t.length && "string" == typeof t[0] && "string" == typeof t[1] && "number" == typeof t[2] ? new Re(t[0], t[1], t[2]) : "object" == (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t)) && "string" == typeof t.from && "string" == typeof t.to && "number" == typeof t.transition ? new Re(t.from, t.to, t.transition) : "string" == typeof t ? new Re(t, t, 1) : void 0;
                    }
                }
            ]);
            return Re;
        }();
        function Ne(t, e1, r, n) {
            return "number" == typeof t && t >= 0 && t <= 255 && "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : "Invalid rgba value [".concat([
                t,
                e1,
                r,
                n
            ].join(", "), "]: 'a' must be between 0 and 1.") : "Invalid rgba value [".concat(("number" == typeof n ? [
                t,
                e1,
                r,
                n
            ] : [
                t,
                e1,
                r
            ]).join(", "), "]: 'r', 'g', and 'b' must be between 0 and 255.");
        }
        function $e(t) {
            if (null === t || "string" == typeof t || "boolean" == typeof t || "number" == typeof t || t instanceof Re || t instanceof Te || t instanceof Ie || t instanceof De || t instanceof ze || t instanceof Pe || t instanceof Be || t instanceof Le || t instanceof Oe) return !0;
            if (Array.isArray(t)) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        if (!$e(_$e)) return !1;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !0;
            }
            if ("object" == (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t))) {
                for(var _$e1 in t)if (!$e(t[_$e1])) return !1;
                return !0;
            }
            return !1;
        }
        function Ue(t) {
            if (null === t) return Vt;
            if ("string" == typeof t) return Lt;
            if ("boolean" == typeof t) return Ot;
            if ("number" == typeof t) return Ct;
            if (t instanceof Te) return Rt;
            if (t instanceof Re) return Nt;
            if (t instanceof Ie) return qt;
            if (t instanceof De) return jt;
            if (t instanceof ze) return Gt;
            if (t instanceof Pe) return Yt;
            if (t instanceof Be) return Xt;
            if (t instanceof Le) return Ht;
            if (t instanceof Oe) return Zt;
            if (Array.isArray(t)) {
                var _$e = t.length;
                var _$r;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e1 = _step.value;
                        var _$t = Ue(_$e1);
                        if (_$r) {
                            if (_$r === _$t) continue;
                            _$r = Ut;
                            break;
                        }
                        _$r = _$t;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return Kt(_$r || Ut, _$e);
            }
            return $t;
        }
        function qe(t) {
            var _$e = typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t);
            return null === t ? "" : "string" === _$e || "number" === _$e || "boolean" === _$e ? String(t) : t instanceof Te || t instanceof Re || t instanceof De || t instanceof ze || t instanceof Pe || t instanceof Be || t instanceof Le || t instanceof Oe ? t.toString() : JSON.stringify(t);
        }
        var je = /*#__PURE__*/ function() {
            function je(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, je);
                this.type = t, this.value = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(je, [
                {
                    key: "evaluate",
                    value: function evaluate() {
                        return this.value;
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild() {}
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !0;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (2 !== t.length) return e1.error("'literal' expression requires exactly one argument, but found ".concat(t.length - 1, " instead."));
                        if (!$e(t[1])) return e1.error("invalid value");
                        var _$r = t[1];
                        var _$n = Ue(_$r);
                        var i = e1.expectedType;
                        return "array" !== _$n.kind || 0 !== _$n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (_$n = i), new je(_$n, _$r);
                    }
                }
            ]);
            return je;
        }();
        var Ge = {
            string: Lt,
            number: Ct,
            boolean: Ot,
            object: $t
        };
        var Xe = /*#__PURE__*/ function() {
            function Xe(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Xe);
                this.type = t, this.args = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Xe, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        for(var _$e = 0; _$e < this.args.length; _$e++){
                            var _$r = this.args[_$e].evaluate(t);
                            if (!Qt(this.type, Ue(_$r))) return _$r;
                            if (_$e === this.args.length - 1) throw new Ve("Expected value to be of type ".concat(Wt(this.type), ", but found ").concat(Wt(Ue(_$r)), " instead."));
                        }
                        throw new Error;
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        this.args.forEach(t);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return this.args.every(function(t) {
                            return t.outputDefined();
                        });
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (t.length < 2) return e1.error("Expected at least one argument.");
                        var _$r, _$n = 1;
                        var i = t[0];
                        if ("array" === i) {
                            var i1, s;
                            if (t.length > 2) {
                                var _$r1 = t[1];
                                if ("string" != typeof _$r1 || !(_$r1 in Ge) || "object" === _$r1) return e1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                                i1 = Ge[_$r1], _$n++;
                            } else i1 = Ut;
                            if (t.length > 3) {
                                if (null !== t[2] && ("number" != typeof t[2] || t[2] < 0 || t[2] !== Math.floor(t[2]))) return e1.error('The length argument to "array" must be a positive integer literal', 2);
                                s = t[2], _$n++;
                            }
                            _$r = Kt(i1, s);
                        } else {
                            if (!Ge[i]) throw new Error("Types doesn't contain name = ".concat(i));
                            _$r = Ge[i];
                        }
                        var s1 = [];
                        for(; _$n < t.length; _$n++){
                            var _$r2 = e1.parse(t[_$n], _$n, Ut);
                            if (!_$r2) return null;
                            s1.push(_$r2);
                        }
                        return new Xe(_$r, s1);
                    }
                }
            ]);
            return Xe;
        }();
        var Ye = {
            "to-boolean": Ot,
            "to-color": Rt,
            "to-number": Ct,
            "to-string": Lt
        };
        var Ze = /*#__PURE__*/ function() {
            function Ze(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ze);
                this.type = t, this.args = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ze, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        switch(this.type.kind){
                            case "boolean":
                                return Boolean(this.args[0].evaluate(t));
                            case "color":
                                {
                                    var _$e, _$r;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = this.args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _$n = _step.value;
                                            if (_$e = _$n.evaluate(t), _$r = null, _$e instanceof Te) return _$e;
                                            if ("string" == typeof _$e) {
                                                var _$r1 = t.parseColor(_$e);
                                                if (_$r1) return _$r1;
                                            } else if (Array.isArray(_$e) && (_$r = _$e.length < 3 || _$e.length > 4 ? "Invalid rgba value ".concat(JSON.stringify(_$e), ": expected an array containing either three or four numeric values.") : Ne(_$e[0], _$e[1], _$e[2], _$e[3]), !_$r)) return new Te(_$e[0] / 255, _$e[1] / 255, _$e[2] / 255, _$e[3]);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    throw new Ve(_$r || "Could not parse color from value '".concat("string" == typeof _$e ? _$e : JSON.stringify(_$e), "'"));
                                }
                            case "padding":
                                {
                                    var _$e1;
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = this.args[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var _$r2 = _step1.value;
                                            _$e1 = _$r2.evaluate(t);
                                            var _$n1 = ze.parse(_$e1);
                                            if (_$n1) return _$n1;
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                    throw new Ve("Could not parse padding from value '".concat("string" == typeof _$e1 ? _$e1 : JSON.stringify(_$e1), "'"));
                                }
                            case "numberArray":
                                {
                                    var _$e2;
                                    var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                    try {
                                        for(var _iterator2 = this.args[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                            var _$r3 = _step2.value;
                                            _$e2 = _$r3.evaluate(t);
                                            var _$n2 = Pe.parse(_$e2);
                                            if (_$n2) return _$n2;
                                        }
                                    } catch (err) {
                                        _didIteratorError2 = true;
                                        _iteratorError2 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                                _iterator2.return();
                                            }
                                        } finally{
                                            if (_didIteratorError2) {
                                                throw _iteratorError2;
                                            }
                                        }
                                    }
                                    throw new Ve("Could not parse numberArray from value '".concat("string" == typeof _$e2 ? _$e2 : JSON.stringify(_$e2), "'"));
                                }
                            case "colorArray":
                                {
                                    var _$e3;
                                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                    try {
                                        for(var _iterator3 = this.args[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                            var _$r4 = _step3.value;
                                            _$e3 = _$r4.evaluate(t);
                                            var _$n3 = Be.parse(_$e3);
                                            if (_$n3) return _$n3;
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                _iterator3.return();
                                            }
                                        } finally{
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                    throw new Ve("Could not parse colorArray from value '".concat("string" == typeof _$e3 ? _$e3 : JSON.stringify(_$e3), "'"));
                                }
                            case "variableAnchorOffsetCollection":
                                {
                                    var _$e4;
                                    var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                                    try {
                                        for(var _iterator4 = this.args[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                            var _$r5 = _step4.value;
                                            _$e4 = _$r5.evaluate(t);
                                            var _$n4 = Le.parse(_$e4);
                                            if (_$n4) return _$n4;
                                        }
                                    } catch (err) {
                                        _didIteratorError4 = true;
                                        _iteratorError4 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                                _iterator4.return();
                                            }
                                        } finally{
                                            if (_didIteratorError4) {
                                                throw _iteratorError4;
                                            }
                                        }
                                    }
                                    throw new Ve("Could not parse variableAnchorOffsetCollection from value '".concat("string" == typeof _$e4 ? _$e4 : JSON.stringify(_$e4), "'"));
                                }
                            case "number":
                                {
                                    var _$e5 = null;
                                    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                                    try {
                                        for(var _iterator5 = this.args[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                                            var _$r6 = _step5.value;
                                            if (_$e5 = _$r6.evaluate(t), null === _$e5) return 0;
                                            var _$n5 = Number(_$e5);
                                            if (!isNaN(_$n5)) return _$n5;
                                        }
                                    } catch (err) {
                                        _didIteratorError5 = true;
                                        _iteratorError5 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                                _iterator5.return();
                                            }
                                        } finally{
                                            if (_didIteratorError5) {
                                                throw _iteratorError5;
                                            }
                                        }
                                    }
                                    throw new Ve("Could not convert ".concat(JSON.stringify(_$e5), " to number."));
                                }
                            case "formatted":
                                return De.fromString(qe(this.args[0].evaluate(t)));
                            case "resolvedImage":
                                return Oe.fromString(qe(this.args[0].evaluate(t)));
                            case "projectionDefinition":
                                return this.args[0].evaluate(t);
                            default:
                                return qe(this.args[0].evaluate(t));
                        }
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        this.args.forEach(t);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return this.args.every(function(t) {
                            return t.outputDefined();
                        });
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (t.length < 2) return e1.error("Expected at least one argument.");
                        var _$r = t[0];
                        if (!Ye[_$r]) throw new Error("Can't parse ".concat(_$r, " as it is not part of the known types"));
                        if (("to-boolean" === _$r || "to-string" === _$r) && 2 !== t.length) return e1.error("Expected one argument.");
                        var _$n = Ye[_$r], i = [];
                        for(var _$r1 = 1; _$r1 < t.length; _$r1++){
                            var _$n1 = e1.parse(t[_$r1], _$r1, Ut);
                            if (!_$n1) return null;
                            i.push(_$n1);
                        }
                        return new Ze(_$n, i);
                    }
                }
            ]);
            return Ze;
        }();
        var He = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        var Ke = /*#__PURE__*/ function() {
            function Ke() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ke);
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = new Map, this.availableImages = null, this.canonical = null;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ke, [
                {
                    key: "id",
                    value: function id() {
                        return this.feature && "id" in this.feature ? this.feature.id : null;
                    }
                },
                {
                    key: "geometryType",
                    value: function geometryType() {
                        return this.feature ? "number" == typeof this.feature.type ? He[this.feature.type] : this.feature.type : null;
                    }
                },
                {
                    key: "geometry",
                    value: function geometry() {
                        return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
                    }
                },
                {
                    key: "canonicalID",
                    value: function canonicalID() {
                        return this.canonical;
                    }
                },
                {
                    key: "properties",
                    value: function properties() {
                        return this.feature && this.feature.properties || {};
                    }
                },
                {
                    key: "parseColor",
                    value: function parseColor(t) {
                        var _$e = this._parseColorCache.get(t);
                        return _$e || (_$e = Te.parse(t), this._parseColorCache.set(t, _$e)), _$e;
                    }
                }
            ]);
            return Ke;
        }();
        var We = /*#__PURE__*/ function() {
            function We(t, e1) {
                var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], _$n = arguments.length > 3 ? arguments[3] : void 0, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : new Bt, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : [];
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, We);
                this.registry = t, this.path = _$r, this.key = _$r.map(function(t) {
                    return "[".concat(t, "]");
                }).join(""), this.scope = i, this.errors = s, this.expectedType = _$n, this._isConstant = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(We, [
                {
                    key: "parse",
                    value: function parse(t, e1, r, n) {
                        var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                        return e1 ? this.concat(e1, r, n)._parse(t, i) : this._parse(t, i);
                    }
                },
                {
                    key: "_parse",
                    value: function _parse(t, e1) {
                        function r(t, e1, r) {
                            return "assert" === r ? new Xe(e1, [
                                t
                            ]) : "coerce" === r ? new Ze(e1, [
                                t
                            ]) : t;
                        }
                        if (null !== t && "string" != typeof t && "boolean" != typeof t && "number" != typeof t || (t = [
                            "literal",
                            t
                        ]), Array.isArray(t)) {
                            if (0 === t.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                            var _$n = t[0];
                            if ("string" != typeof _$n) return this.error("Expression name must be a string, but found ".concat(typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n), ' instead. If you wanted a literal array, use ["literal", [...]].'), 0), null;
                            var i = this.registry[_$n];
                            if (i) {
                                var _$n1 = i.parse(t, this);
                                if (!_$n1) return null;
                                if (this.expectedType) {
                                    var _$t = this.expectedType, i1 = _$n1.type;
                                    if ("string" !== _$t.kind && "number" !== _$t.kind && "boolean" !== _$t.kind && "object" !== _$t.kind && "array" !== _$t.kind || "value" !== i1.kind) {
                                        if ("projectionDefinition" === _$t.kind && [
                                            "string",
                                            "array"
                                        ].includes(i1.kind) || [
                                            "color",
                                            "formatted",
                                            "resolvedImage"
                                        ].includes(_$t.kind) && [
                                            "value",
                                            "string"
                                        ].includes(i1.kind) || [
                                            "padding",
                                            "numberArray"
                                        ].includes(_$t.kind) && [
                                            "value",
                                            "number",
                                            "array"
                                        ].includes(i1.kind) || "colorArray" === _$t.kind && [
                                            "value",
                                            "string",
                                            "array"
                                        ].includes(i1.kind) || "variableAnchorOffsetCollection" === _$t.kind && [
                                            "value",
                                            "array"
                                        ].includes(i1.kind)) _$n1 = r(_$n1, _$t, e1.typeAnnotation || "coerce");
                                        else if (this.checkSubtype(_$t, i1)) return null;
                                    } else _$n1 = r(_$n1, _$t, e1.typeAnnotation || "assert");
                                }
                                if (!(_$n1 instanceof je) && "resolvedImage" !== _$n1.type.kind && this._isConstant(_$n1)) {
                                    var _$t1 = new Ke;
                                    try {
                                        _$n1 = new je(_$n1.type, _$n1.evaluate(_$t1));
                                    } catch (t) {
                                        return this.error(t.message), null;
                                    }
                                }
                                return _$n1;
                            }
                            return this.error('Unknown expression "'.concat(_$n, '". If you wanted a literal array, use ["literal", [...]].'), 0);
                        }
                        return this.error(void 0 === t ? "'undefined' value invalid. Use null instead." : "object" == (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t)) ? 'Bare objects invalid. Use ["literal", {...}] instead.' : "Expected an array, but found ".concat(typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t), " instead."));
                    }
                },
                {
                    key: "concat",
                    value: function concat(t, e1, r) {
                        var _$n = "number" == typeof t ? this.path.concat(t) : this.path, i = r ? this.scope.concat(r) : this.scope;
                        return new We(this.registry, this._isConstant, _$n, e1 || null, i, this.errors);
                    }
                },
                {
                    key: "error",
                    value: function error(t) {
                        for(var _len = arguments.length, _$e = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                            _$e[_key - 1] = arguments[_key];
                        }
                        var _$r = "".concat(this.key).concat(_$e.map(function(t) {
                            return "[".concat(t, "]");
                        }).join(""));
                        this.errors.push(new Pt(_$r, t));
                    }
                },
                {
                    key: "checkSubtype",
                    value: function checkSubtype(t, e1) {
                        var _$r = Qt(t, e1);
                        return _$r && this.error(_$r), _$r;
                    }
                }
            ]);
            return We;
        }();
        var Je = /*#__PURE__*/ function() {
            function Je(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Je);
                this.type = e1.type, this.bindings = [].concat(t), this.result = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Je, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        return this.result.evaluate(t);
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.bindings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                t(_$e[1]);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        t(this.result);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return this.result.outputDefined();
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (t.length < 4) return e1.error("Expected at least 3 arguments, but found ".concat(t.length - 1, " instead."));
                        var _$r = [];
                        for(var _$n = 1; _$n < t.length - 1; _$n += 2){
                            var i = t[_$n];
                            if ("string" != typeof i) return e1.error("Expected string, but found ".concat(typeof i === "undefined" ? "undefined" : (0, $dvYFb._)(i), " instead."), _$n);
                            if (/[^a-zA-Z0-9_]/.test(i)) return e1.error("Variable names must contain only alphanumeric characters or '_'.", _$n);
                            var s = e1.parse(t[_$n + 1], _$n + 1);
                            if (!s) return null;
                            _$r.push([
                                i,
                                s
                            ]);
                        }
                        var _$n1 = e1.parse(t[t.length - 1], t.length - 1, e1.expectedType, _$r);
                        return _$n1 ? new Je(_$r, _$n1) : null;
                    }
                }
            ]);
            return Je;
        }();
        var Qe = /*#__PURE__*/ function() {
            function Qe(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Qe);
                this.type = e1.type, this.name = t, this.boundExpression = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Qe, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        return this.boundExpression.evaluate(t);
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild() {}
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (2 !== t.length || "string" != typeof t[1]) return e1.error("'var' expression requires exactly one string literal argument.");
                        var _$r = t[1];
                        return e1.scope.has(_$r) ? new Qe(_$r, e1.scope.get(_$r)) : e1.error('Unknown variable "'.concat(_$r, '". Make sure "').concat(_$r, '" has been bound in an enclosing "let" expression before using it.'), 1);
                    }
                }
            ]);
            return Qe;
        }();
        var tr = /*#__PURE__*/ function() {
            function tr(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, tr);
                this.type = t, this.index = e1, this.input = r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(tr, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e = this.index.evaluate(t), _$r = this.input.evaluate(t);
                        if (_$e < 0) throw new Ve("Array index out of bounds: ".concat(_$e, " < 0."));
                        if (_$e >= _$r.length) throw new Ve("Array index out of bounds: ".concat(_$e, " > ").concat(_$r.length - 1, "."));
                        if (_$e !== Math.floor(_$e)) throw new Ve("Array index must be an integer, but found ".concat(_$e, " instead."));
                        return _$r[_$e];
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.index), t(this.input);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (3 !== t.length) return e1.error("Expected 2 arguments, but found ".concat(t.length - 1, " instead."));
                        var _$r = e1.parse(t[1], 1, Ct), _$n = e1.parse(t[2], 2, Kt(e1.expectedType || Ut));
                        return _$r && _$n ? new tr(_$n.type.itemType, _$r, _$n) : null;
                    }
                }
            ]);
            return tr;
        }();
        var er = /*#__PURE__*/ function() {
            function er(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, er);
                this.type = Ot, this.needle = t, this.haystack = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(er, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e = this.needle.evaluate(t), _$r = this.haystack.evaluate(t);
                        if (!_$r) return !1;
                        if (!ee(_$e, [
                            "boolean",
                            "string",
                            "number",
                            "null"
                        ])) throw new Ve("Expected first argument to be of type boolean, string, number or null, but found ".concat(Wt(Ue(_$e)), " instead."));
                        if (!ee(_$r, [
                            "string",
                            "array"
                        ])) throw new Ve("Expected second argument to be of type array or string, but found ".concat(Wt(Ue(_$r)), " instead."));
                        return _$r.indexOf(_$e) >= 0;
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.needle), t(this.haystack);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !0;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (3 !== t.length) return e1.error("Expected 2 arguments, but found ".concat(t.length - 1, " instead."));
                        var _$r = e1.parse(t[1], 1, Ut), _$n = e1.parse(t[2], 2, Ut);
                        return _$r && _$n ? te(_$r.type, [
                            Ot,
                            Lt,
                            Ct,
                            Vt,
                            Ut
                        ]) ? new er(_$r, _$n) : e1.error("Expected first argument to be of type boolean, string, number or null, but found ".concat(Wt(_$r.type), " instead")) : null;
                    }
                }
            ]);
            return er;
        }();
        var rr = /*#__PURE__*/ function() {
            function rr(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, rr);
                this.type = Ct, this.needle = t, this.haystack = e1, this.fromIndex = r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(rr, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e = this.needle.evaluate(t), _$r = this.haystack.evaluate(t);
                        if (!ee(_$e, [
                            "boolean",
                            "string",
                            "number",
                            "null"
                        ])) throw new Ve("Expected first argument to be of type boolean, string, number or null, but found ".concat(Wt(Ue(_$e)), " instead."));
                        var _$n;
                        if (this.fromIndex && (_$n = this.fromIndex.evaluate(t)), ee(_$r, [
                            "string"
                        ])) {
                            var _$t = _$r.indexOf(_$e, _$n);
                            return -1 === _$t ? -1 : (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$r.slice(0, _$t)).length;
                        }
                        if (ee(_$r, [
                            "array"
                        ])) return _$r.indexOf(_$e, _$n);
                        throw new Ve("Expected second argument to be of type array or string, but found ".concat(Wt(Ue(_$r)), " instead."));
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.needle), t(this.haystack), this.fromIndex && t(this.fromIndex);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (t.length <= 2 || t.length >= 5) return e1.error("Expected 2 or 3 arguments, but found ".concat(t.length - 1, " instead."));
                        var _$r = e1.parse(t[1], 1, Ut), _$n = e1.parse(t[2], 2, Ut);
                        if (!_$r || !_$n) return null;
                        if (!te(_$r.type, [
                            Ot,
                            Lt,
                            Ct,
                            Vt,
                            Ut
                        ])) return e1.error("Expected first argument to be of type boolean, string, number or null, but found ".concat(Wt(_$r.type), " instead"));
                        if (4 === t.length) {
                            var i = e1.parse(t[3], 3, Ct);
                            return i ? new rr(_$r, _$n, i) : null;
                        }
                        return new rr(_$r, _$n);
                    }
                }
            ]);
            return rr;
        }();
        var nr = /*#__PURE__*/ function() {
            function nr(t, e1, r, n, i, s) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, nr);
                this.inputType = t, this.type = e1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(nr, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e = this.input.evaluate(t);
                        return (Ue(_$e) === this.inputType && this.outputs[this.cases[_$e]] || this.otherwise).evaluate(t);
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.input), this.outputs.forEach(t), t(this.otherwise);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return this.outputs.every(function(t) {
                            return t.outputDefined();
                        }) && this.otherwise.outputDefined();
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (t.length < 5) return e1.error("Expected at least 4 arguments, but found only ".concat(t.length - 1, "."));
                        if (t.length % 2 != 1) return e1.error("Expected an even number of arguments.");
                        var _$r, _$n;
                        e1.expectedType && "value" !== e1.expectedType.kind && (_$n = e1.expectedType);
                        var i = {}, s = [];
                        for(var a = 2; a < t.length - 1; a += 2){
                            var o = t[a];
                            var l = t[a + 1];
                            Array.isArray(o) || (o = [
                                o
                            ]);
                            var u = e1.concat(a);
                            if (0 === o.length) return u.error("Expected at least one branch label.");
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step.value;
                                    if ("number" != typeof _$t && "string" != typeof _$t) return u.error("Branch labels must be numbers or strings.");
                                    if ("number" == typeof _$t && Math.abs(_$t) > Number.MAX_SAFE_INTEGER) return u.error("Branch labels must be integers no larger than ".concat(Number.MAX_SAFE_INTEGER, "."));
                                    if ("number" == typeof _$t && Math.floor(_$t) !== _$t) return u.error("Numeric branch labels must be integer values.");
                                    if (_$r) {
                                        if (u.checkSubtype(_$r, Ue(_$t))) return null;
                                    } else _$r = Ue(_$t);
                                    if (void 0 !== i[String(_$t)]) return u.error("Branch labels must be unique.");
                                    i[String(_$t)] = s.length;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            var _$c = e1.parse(l, a, _$n);
                            if (!_$c) return null;
                            _$n = _$n || _$c.type, s.push(_$c);
                        }
                        var a1 = e1.parse(t[1], 1, Ut);
                        if (!a1) return null;
                        var o1 = e1.parse(t[t.length - 1], t.length - 1, _$n);
                        return o1 ? "value" !== a1.type.kind && e1.concat(1).checkSubtype(_$r, a1.type) ? null : new nr(_$r, _$n, a1, i, s, o1) : null;
                    }
                }
            ]);
            return nr;
        }();
        var ir = /*#__PURE__*/ function() {
            function ir(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ir);
                this.type = t, this.branches = e1, this.otherwise = r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ir, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.branches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), _$e = _step_value[0], _$r = _step_value[1];
                                if (_$e.evaluate(t)) return _$r.evaluate(t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return this.otherwise.evaluate(t);
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.branches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), _$e = _step_value[0], _$r = _step_value[1];
                                t(_$e), t(_$r);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        t(this.otherwise);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return this.branches.every(function(param) {
                            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$t = _param[0], _$e = _param[1];
                            return _$e.outputDefined();
                        }) && this.otherwise.outputDefined();
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (t.length < 4) return e1.error("Expected at least 3 arguments, but found only ".concat(t.length - 1, "."));
                        if (t.length % 2 != 0) return e1.error("Expected an odd number of arguments.");
                        var _$r;
                        e1.expectedType && "value" !== e1.expectedType.kind && (_$r = e1.expectedType);
                        var _$n = [];
                        for(var i = 1; i < t.length - 1; i += 2){
                            var s = e1.parse(t[i], i, Ot);
                            if (!s) return null;
                            var a = e1.parse(t[i + 1], i + 1, _$r);
                            if (!a) return null;
                            _$n.push([
                                s,
                                a
                            ]), _$r = _$r || a.type;
                        }
                        var i1 = e1.parse(t[t.length - 1], t.length - 1, _$r);
                        if (!i1) return null;
                        if (!_$r) throw new Error("Can't infer output type");
                        return new ir(_$r, _$n, i1);
                    }
                }
            ]);
            return ir;
        }();
        var sr = /*#__PURE__*/ function() {
            function sr(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, sr);
                this.type = t, this.input = e1, this.beginIndex = r, this.endIndex = n;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(sr, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e = this.input.evaluate(t), _$r = this.beginIndex.evaluate(t);
                        var _$n;
                        if (this.endIndex && (_$n = this.endIndex.evaluate(t)), ee(_$e, [
                            "string"
                        ])) return (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$e).slice(_$r, _$n).join("");
                        if (ee(_$e, [
                            "array"
                        ])) return _$e.slice(_$r, _$n);
                        throw new Ve("Expected first argument to be of type array or string, but found ".concat(Wt(Ue(_$e)), " instead."));
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.input), t(this.beginIndex), this.endIndex && t(this.endIndex);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (t.length <= 2 || t.length >= 5) return e1.error("Expected 2 or 3 arguments, but found ".concat(t.length - 1, " instead."));
                        var _$r = e1.parse(t[1], 1, Ut), _$n = e1.parse(t[2], 2, Ct);
                        if (!_$r || !_$n) return null;
                        if (!te(_$r.type, [
                            Kt(Ut),
                            Lt,
                            Ut
                        ])) return e1.error("Expected first argument to be of type array or string, but found ".concat(Wt(_$r.type), " instead"));
                        if (4 === t.length) {
                            var i = e1.parse(t[3], 3, Ct);
                            return i ? new sr(_$r.type, _$r, _$n, i) : null;
                        }
                        return new sr(_$r.type, _$r, _$n);
                    }
                }
            ]);
            return sr;
        }();
        function ar(t, e1) {
            var _$r = t.length - 1;
            var _$n, i, s = 0, a = _$r, o = 0;
            for(; s <= a;)if (o = Math.floor((s + a) / 2), _$n = t[o], i = t[o + 1], _$n <= e1) {
                if (o === _$r || e1 < i) return o;
                s = o + 1;
            } else {
                if (!(_$n > e1)) throw new Ve("Input is not a number.");
                a = o - 1;
            }
            return 0;
        }
        var or = /*#__PURE__*/ function() {
            function or(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, or);
                this.type = t, this.input = e1, this.labels = [], this.outputs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), _$t = _step_value[0], _$e = _step_value[1];
                        this.labels.push(_$t), this.outputs.push(_$e);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(or, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e = this.labels, _$r = this.outputs;
                        if (1 === _$e.length) return _$r[0].evaluate(t);
                        var _$n = this.input.evaluate(t);
                        if (_$n <= _$e[0]) return _$r[0].evaluate(t);
                        var i = _$e.length;
                        return _$n >= _$e[i - 1] ? _$r[i - 1].evaluate(t) : _$r[ar(_$e, _$n)].evaluate(t);
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.input);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.outputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                t(_$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return this.outputs.every(function(t) {
                            return t.outputDefined();
                        });
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (t.length - 1 < 4) return e1.error("Expected at least 4 arguments, but found only ".concat(t.length - 1, "."));
                        if ((t.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                        var _$r = e1.parse(t[1], 1, Ct);
                        if (!_$r) return null;
                        var _$n = [];
                        var i = null;
                        e1.expectedType && "value" !== e1.expectedType.kind && (i = e1.expectedType);
                        for(var _$r1 = 1; _$r1 < t.length; _$r1 += 2){
                            var s = 1 === _$r1 ? -1 / 0 : t[_$r1], a = t[_$r1 + 1], o = _$r1, l = _$r1 + 1;
                            if ("number" != typeof s) return e1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                            if (_$n.length && _$n[_$n.length - 1][0] >= s) return e1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                            var u = e1.parse(a, l, i);
                            if (!u) return null;
                            i = i || u.type, _$n.push([
                                s,
                                u
                            ]);
                        }
                        return new or(i, _$r, _$n);
                    }
                }
            ]);
            return or;
        }();
        function lr(t) {
            return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
        }
        var ur, cr, hr = function() {
            if (cr) return ur;
            function t(t, e1, r, n) {
                this.cx = 3 * t, this.bx = 3 * (r - t) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * e1, this.by = 3 * (n - e1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = t, this.p1y = e1, this.p2x = r, this.p2y = n;
            }
            return cr = 1, ur = t, t.prototype = {
                sampleCurveX: function sampleCurveX(t) {
                    return ((this.ax * t + this.bx) * t + this.cx) * t;
                },
                sampleCurveY: function sampleCurveY(t) {
                    return ((this.ay * t + this.by) * t + this.cy) * t;
                },
                sampleCurveDerivativeX: function sampleCurveDerivativeX(t) {
                    return (3 * this.ax * t + 2 * this.bx) * t + this.cx;
                },
                solveCurveX: function solveCurveX(t, e1) {
                    if (void 0 === e1 && (e1 = 1e-6), t < 0) return 0;
                    if (t > 1) return 1;
                    for(var _$r = t, _$n = 0; _$n < 8; _$n++){
                        var i = this.sampleCurveX(_$r) - t;
                        if (Math.abs(i) < e1) return _$r;
                        var s = this.sampleCurveDerivativeX(_$r);
                        if (Math.abs(s) < 1e-6) break;
                        _$r -= i / s;
                    }
                    var a = 0, o = 1;
                    for(_$r = t, _$n = 0; _$n < 20 && (i = this.sampleCurveX(_$r), !(Math.abs(i - t) < e1)); _$n++)t > i ? a = _$r : o = _$r, _$r = .5 * (o - a) + a;
                    return _$r;
                },
                solve: function solve(t, e1) {
                    return this.sampleCurveY(this.solveCurveX(t, e1));
                }
            }, ur;
        }(), pr = lr(hr);
        var fr = /*#__PURE__*/ function() {
            function fr(t, e1, r, n, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, fr);
                this.type = t, this.operator = e1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), _$t = _step_value[0], _$e = _step_value[1];
                        this.labels.push(_$t), this.outputs.push(_$e);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(fr, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e = this.labels, _$r = this.outputs;
                        if (1 === _$e.length) return _$r[0].evaluate(t);
                        var _$n = this.input.evaluate(t);
                        if (_$n <= _$e[0]) return _$r[0].evaluate(t);
                        var i = _$e.length;
                        if (_$n >= _$e[i - 1]) return _$r[i - 1].evaluate(t);
                        var s = ar(_$e, _$n), a = fr.interpolationFactor(this.interpolation, _$n, _$e[s], _$e[s + 1]), o = _$r[s].evaluate(t), l = _$r[s + 1].evaluate(t);
                        switch(this.operator){
                            case "interpolate":
                                switch(this.type.kind){
                                    case "number":
                                        return ke(o, l, a);
                                    case "color":
                                        return Te.interpolate(o, l, a);
                                    case "padding":
                                        return ze.interpolate(o, l, a);
                                    case "colorArray":
                                        return Be.interpolate(o, l, a);
                                    case "numberArray":
                                        return Pe.interpolate(o, l, a);
                                    case "variableAnchorOffsetCollection":
                                        return Le.interpolate(o, l, a);
                                    case "array":
                                        return Ee(o, l, a);
                                    case "projectionDefinition":
                                        return Re.interpolate(o, l, a);
                                }
                            case "interpolate-hcl":
                                switch(this.type.kind){
                                    case "color":
                                        return Te.interpolate(o, l, a, "hcl");
                                    case "colorArray":
                                        return Be.interpolate(o, l, a, "hcl");
                                }
                            case "interpolate-lab":
                                switch(this.type.kind){
                                    case "color":
                                        return Te.interpolate(o, l, a, "lab");
                                    case "colorArray":
                                        return Be.interpolate(o, l, a, "lab");
                                }
                        }
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.input);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.outputs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                t(_$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return this.outputs.every(function(t) {
                            return t.outputDefined();
                        });
                    }
                }
            ], [
                {
                    key: "interpolationFactor",
                    value: function interpolationFactor(t, e1, r, n) {
                        var i = 0;
                        if ("exponential" === t.name) i = dr(e1, t.base, r, n);
                        else if ("linear" === t.name) i = dr(e1, 1, r, n);
                        else if ("cubic-bezier" === t.name) {
                            var s = t.controlPoints;
                            i = new pr(s[0], s[1], s[2], s[3]).solve(dr(e1, 1, r, n));
                        }
                        return i;
                    }
                },
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        var _t = (0, $94ee8f67fd9e95ae$export$71511d61b312f219)(t), _$r = _t[0], _$n = _t[1], i = _t[2], s = _t.slice(3);
                        if (!Array.isArray(_$n) || 0 === _$n.length) return e1.error("Expected an interpolation type expression.", 1);
                        if ("linear" === _$n[0]) _$n = {
                            name: "linear"
                        };
                        else if ("exponential" === _$n[0]) {
                            var _$t = _$n[1];
                            if ("number" != typeof _$t) return e1.error("Exponential interpolation requires a numeric base.", 1, 1);
                            _$n = {
                                name: "exponential",
                                base: _$t
                            };
                        } else {
                            if ("cubic-bezier" !== _$n[0]) return e1.error("Unknown interpolation type ".concat(String(_$n[0])), 1, 0);
                            {
                                var _$t1 = _$n.slice(1);
                                if (4 !== _$t1.length || _$t1.some(function(t) {
                                    return "number" != typeof t || t < 0 || t > 1;
                                })) return e1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                                _$n = {
                                    name: "cubic-bezier",
                                    controlPoints: _$t1
                                };
                            }
                        }
                        if (t.length - 1 < 4) return e1.error("Expected at least 4 arguments, but found only ".concat(t.length - 1, "."));
                        if ((t.length - 1) % 2 != 0) return e1.error("Expected an even number of arguments.");
                        if (i = e1.parse(i, 2, Ct), !i) return null;
                        var a = [];
                        var o = null;
                        "interpolate-hcl" !== _$r && "interpolate-lab" !== _$r || e1.expectedType == Xt ? e1.expectedType && "value" !== e1.expectedType.kind && (o = e1.expectedType) : o = Rt;
                        for(var _$t2 = 0; _$t2 < s.length; _$t2 += 2){
                            var _$r1 = s[_$t2], _$n1 = s[_$t2 + 1], i1 = _$t2 + 3, l = _$t2 + 4;
                            if ("number" != typeof _$r1) return e1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i1);
                            if (a.length && a[a.length - 1][0] >= _$r1) return e1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i1);
                            var u = e1.parse(_$n1, l, o);
                            if (!u) return null;
                            o = o || u.type, a.push([
                                _$r1,
                                u
                            ]);
                        }
                        return re(o, Ct) || re(o, Nt) || re(o, Rt) || re(o, Gt) || re(o, Yt) || re(o, Xt) || re(o, Ht) || re(o, Kt(Ct)) ? new fr(o, _$r, _$n, i, a) : e1.error("Type ".concat(Wt(o), " is not interpolatable."));
                    }
                }
            ]);
            return fr;
        }();
        function dr(t, e1, r, n) {
            var i = n - r, s = t - r;
            return 0 === i ? 0 : 1 === e1 ? s / i : (Math.pow(e1, s) - 1) / (Math.pow(e1, i) - 1);
        }
        var yr = {
            color: Te.interpolate,
            number: ke,
            padding: ze.interpolate,
            numberArray: Pe.interpolate,
            colorArray: Be.interpolate,
            variableAnchorOffsetCollection: Le.interpolate,
            array: Ee
        };
        var mr = /*#__PURE__*/ function() {
            function mr(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, mr);
                this.type = t, this.args = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(mr, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e, _$r = null, _$n = 0;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                if (_$n++, _$r = i.evaluate(t), _$r && _$r instanceof Oe && !_$r.available && (_$e || (_$e = _$r.name), _$r = null, _$n === this.args.length && (_$r = _$e)), null !== _$r) break;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$r;
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        this.args.forEach(t);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return this.args.every(function(t) {
                            return t.outputDefined();
                        });
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (t.length < 2) return e1.error("Expected at least one argument.");
                        var _$r = null;
                        var _$n = e1.expectedType;
                        _$n && "value" !== _$n.kind && (_$r = _$n);
                        var i = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t.slice(1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$n1 = _step.value;
                                var _$t = e1.parse(_$n1, 1 + i.length, _$r, void 0, {
                                    typeAnnotation: "omit"
                                });
                                if (!_$t) return null;
                                _$r = _$r || _$t.type, i.push(_$t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (!_$r) throw new Error("No output type");
                        var s = _$n && i.some(function(t) {
                            return Qt(_$n, t.type);
                        });
                        return new mr(s ? Ut : _$r, i);
                    }
                }
            ]);
            return mr;
        }();
        function gr(t, e1) {
            return "==" === t || "!=" === t ? "boolean" === e1.kind || "string" === e1.kind || "number" === e1.kind || "null" === e1.kind || "value" === e1.kind : "string" === e1.kind || "number" === e1.kind || "value" === e1.kind;
        }
        function xr(t, e1, r, n) {
            return 0 === n.compare(e1, r);
        }
        function vr(t, e1, r) {
            var _$n = "==" !== t && "!=" !== t;
            return /*#__PURE__*/ function() {
                function i(t, e1, r) {
                    (0, $7417b380464c38c1$export$71511d61b312f219)(this, i);
                    this.type = Ot, this.lhs = t, this.rhs = e1, this.collator = r, this.hasUntypedArgument = "value" === t.type.kind || "value" === e1.type.kind;
                }
                (0, $c546c01220e295dd$export$71511d61b312f219)(i, [
                    {
                        key: "evaluate",
                        value: function evaluate(i) {
                            var s = this.lhs.evaluate(i), a = this.rhs.evaluate(i);
                            if (_$n && this.hasUntypedArgument) {
                                var _$e = Ue(s), _$r = Ue(a);
                                if (_$e.kind !== _$r.kind || "string" !== _$e.kind && "number" !== _$e.kind) throw new Ve('Expected arguments for "'.concat(t, '" to be (string, string) or (number, number), but found (').concat(_$e.kind, ", ").concat(_$r.kind, ") instead."));
                            }
                            if (this.collator && !_$n && this.hasUntypedArgument) {
                                var _$t = Ue(s), _$r1 = Ue(a);
                                if ("string" !== _$t.kind || "string" !== _$r1.kind) return e1(i, s, a);
                            }
                            return this.collator ? r(i, s, a, this.collator.evaluate(i)) : e1(i, s, a);
                        }
                    },
                    {
                        key: "eachChild",
                        value: function eachChild(t) {
                            t(this.lhs), t(this.rhs), this.collator && t(this.collator);
                        }
                    },
                    {
                        key: "outputDefined",
                        value: function outputDefined() {
                            return !0;
                        }
                    }
                ], [
                    {
                        key: "parse",
                        value: function parse(t, e1) {
                            if (3 !== t.length && 4 !== t.length) return e1.error("Expected two or three arguments.");
                            var _$r = t[0];
                            var s = e1.parse(t[1], 1, Ut);
                            if (!s) return null;
                            if (!gr(_$r, s.type)) return e1.concat(1).error('"'.concat(_$r, "\" comparisons are not supported for type '").concat(Wt(s.type), "'."));
                            var a = e1.parse(t[2], 2, Ut);
                            if (!a) return null;
                            if (!gr(_$r, a.type)) return e1.concat(2).error('"'.concat(_$r, "\" comparisons are not supported for type '").concat(Wt(a.type), "'."));
                            if (s.type.kind !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e1.error("Cannot compare types '".concat(Wt(s.type), "' and '").concat(Wt(a.type), "'."));
                            _$n && ("value" === s.type.kind && "value" !== a.type.kind ? s = new Xe(a.type, [
                                s
                            ]) : "value" !== s.type.kind && "value" === a.type.kind && (a = new Xe(s.type, [
                                a
                            ])));
                            var o = null;
                            if (4 === t.length) {
                                if ("string" !== s.type.kind && "string" !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return e1.error("Cannot use collator to compare non-string types.");
                                if (o = e1.parse(t[3], 3, qt), !o) return null;
                            }
                            return new i(s, a, o);
                        }
                    }
                ]);
                return i;
            }();
        }
        var br = vr("==", function(t, e1, r) {
            return e1 === r;
        }, xr), wr = vr("!=", function(t, e1, r) {
            return e1 !== r;
        }, function(t, e1, r, n) {
            return !xr(0, e1, r, n);
        }), _r = vr("<", function(t, e1, r) {
            return e1 < r;
        }, function(t, e1, r, n) {
            return n.compare(e1, r) < 0;
        }), Sr = vr(">", function(t, e1, r) {
            return e1 > r;
        }, function(t, e1, r, n) {
            return n.compare(e1, r) > 0;
        }), Ar = vr("<=", function(t, e1, r) {
            return e1 <= r;
        }, function(t, e1, r, n) {
            return n.compare(e1, r) <= 0;
        }), kr = vr(">=", function(t, e1, r) {
            return e1 >= r;
        }, function(t, e1, r, n) {
            return n.compare(e1, r) >= 0;
        });
        var Er = /*#__PURE__*/ function() {
            function Er(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Er);
                this.type = qt, this.locale = r, this.caseSensitive = t, this.diacriticSensitive = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Er, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        return new Ie(this.caseSensitive.evaluate(t), this.diacriticSensitive.evaluate(t), this.locale ? this.locale.evaluate(t) : null);
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.caseSensitive), t(this.diacriticSensitive), this.locale && t(this.locale);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (2 !== t.length) return e1.error("Expected one argument.");
                        var _$r = t[1];
                        if ("object" != (typeof _$r === "undefined" ? "undefined" : (0, $dvYFb._)(_$r)) || Array.isArray(_$r)) return e1.error("Collator options argument must be an object.");
                        var _$n = e1.parse(void 0 !== _$r["case-sensitive"] && _$r["case-sensitive"], 1, Ot);
                        if (!_$n) return null;
                        var i = e1.parse(void 0 !== _$r["diacritic-sensitive"] && _$r["diacritic-sensitive"], 1, Ot);
                        if (!i) return null;
                        var s = null;
                        return _$r.locale && (s = e1.parse(_$r.locale, 1, Lt), !s) ? null : new Er(_$n, i, s);
                    }
                }
            ]);
            return Er;
        }();
        var Tr = /*#__PURE__*/ function() {
            function Tr(t, e1, r, n, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Tr);
                this.type = Lt, this.number = t, this.locale = e1, this.currency = r, this.minFractionDigits = n, this.maxFractionDigits = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Tr, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        return new Intl.NumberFormat(this.locale ? this.locale.evaluate(t) : [], {
                            style: this.currency ? "currency" : "decimal",
                            currency: this.currency ? this.currency.evaluate(t) : void 0,
                            minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(t) : void 0,
                            maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(t) : void 0
                        }).format(this.number.evaluate(t));
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.number), this.locale && t(this.locale), this.currency && t(this.currency), this.minFractionDigits && t(this.minFractionDigits), this.maxFractionDigits && t(this.maxFractionDigits);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (3 !== t.length) return e1.error("Expected two arguments.");
                        var _$r = e1.parse(t[1], 1, Ct);
                        if (!_$r) return null;
                        var _$n = t[2];
                        if ("object" != (typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n)) || Array.isArray(_$n)) return e1.error("NumberFormat options argument must be an object.");
                        var i = null;
                        if (_$n.locale && (i = e1.parse(_$n.locale, 1, Lt), !i)) return null;
                        var s = null;
                        if (_$n.currency && (s = e1.parse(_$n.currency, 1, Lt), !s)) return null;
                        var a = null;
                        if (_$n["min-fraction-digits"] && (a = e1.parse(_$n["min-fraction-digits"], 1, Ct), !a)) return null;
                        var o = null;
                        return _$n["max-fraction-digits"] && (o = e1.parse(_$n["max-fraction-digits"], 1, Ct), !o) ? null : new Tr(_$r, i, s, a, o);
                    }
                }
            ]);
            return Tr;
        }();
        var Ir = /*#__PURE__*/ function() {
            function Ir(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ir);
                this.type = jt, this.sections = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ir, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        return new De(this.sections.map(function(e1) {
                            var _$r = e1.content.evaluate(t);
                            return Ue(_$r) === Zt ? new Fe("", _$r, null, null, null, e1.verticalAlign ? e1.verticalAlign.evaluate(t) : null) : new Fe(qe(_$r), null, e1.scale ? e1.scale.evaluate(t) : null, e1.font ? e1.font.evaluate(t).join(",") : null, e1.textColor ? e1.textColor.evaluate(t) : null, e1.verticalAlign ? e1.verticalAlign.evaluate(t) : null);
                        }));
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                t(_$e.content), _$e.scale && t(_$e.scale), _$e.font && t(_$e.font), _$e.textColor && t(_$e.textColor), _$e.verticalAlign && t(_$e.verticalAlign);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (t.length < 2) return e1.error("Expected at least one argument.");
                        var _$r = t[1];
                        if (!Array.isArray(_$r) && "object" == (typeof _$r === "undefined" ? "undefined" : (0, $dvYFb._)(_$r))) return e1.error("First argument must be an image or text section.");
                        var _$n = [];
                        var i = !1;
                        for(var _$r1 = 1; _$r1 <= t.length - 1; ++_$r1){
                            var s = t[_$r1];
                            if (i && "object" == (typeof s === "undefined" ? "undefined" : (0, $dvYFb._)(s)) && !Array.isArray(s)) {
                                i = !1;
                                var _$t = null;
                                if (s["font-scale"] && (_$t = e1.parse(s["font-scale"], 1, Ct), !_$t)) return null;
                                var _$r2 = null;
                                if (s["text-font"] && (_$r2 = e1.parse(s["text-font"], 1, Kt(Lt)), !_$r2)) return null;
                                var a = null;
                                if (s["text-color"] && (a = e1.parse(s["text-color"], 1, Rt), !a)) return null;
                                var o = null;
                                if (s["vertical-align"]) {
                                    if ("string" == typeof s["vertical-align"] && !Me.includes(s["vertical-align"])) return e1.error("'vertical-align' must be one of: 'bottom', 'center', 'top' but found '".concat(s["vertical-align"], "' instead."));
                                    if (o = e1.parse(s["vertical-align"], 1, Lt), !o) return null;
                                }
                                var l = _$n[_$n.length - 1];
                                l.scale = _$t, l.font = _$r2, l.textColor = a, l.verticalAlign = o;
                            } else {
                                var s1 = e1.parse(t[_$r1], 1, Ut);
                                if (!s1) return null;
                                var a1 = s1.type.kind;
                                if ("string" !== a1 && "value" !== a1 && "null" !== a1 && "resolvedImage" !== a1) return e1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                                i = !0, _$n.push({
                                    content: s1,
                                    scale: null,
                                    font: null,
                                    textColor: null,
                                    verticalAlign: null
                                });
                            }
                        }
                        return new Ir(_$n);
                    }
                }
            ]);
            return Ir;
        }();
        var Mr = /*#__PURE__*/ function() {
            function Mr(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Mr);
                this.type = Zt, this.input = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Mr, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e = this.input.evaluate(t), _$r = Oe.fromString(_$e);
                        return _$r && t.availableImages && (_$r.available = t.availableImages.indexOf(_$e) > -1), _$r;
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.input);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (2 !== t.length) return e1.error("Expected two arguments.");
                        var _$r = e1.parse(t[1], 1, Lt);
                        return _$r ? new Mr(_$r) : e1.error("No image name provided.");
                    }
                }
            ]);
            return Mr;
        }();
        var Fr = /*#__PURE__*/ function() {
            function Fr(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Fr);
                this.type = Ct, this.input = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Fr, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e = this.input.evaluate(t);
                        if ("string" == typeof _$e) return (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$e).length;
                        if (Array.isArray(_$e)) return _$e.length;
                        throw new Ve("Expected value to be of type string or array, but found ".concat(Wt(Ue(_$e)), " instead."));
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        t(this.input);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (2 !== t.length) return e1.error("Expected 1 argument, but found ".concat(t.length - 1, " instead."));
                        var _$r = e1.parse(t[1], 1);
                        return _$r ? "array" !== _$r.type.kind && "string" !== _$r.type.kind && "value" !== _$r.type.kind ? e1.error("Expected argument of type string or array, but found ".concat(Wt(_$r.type), " instead.")) : new Fr(_$r) : null;
                    }
                }
            ]);
            return Fr;
        }();
        var Dr = 8192;
        function zr(t, e1) {
            var _$r = (180 + t[0]) / 360, _$n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t[1] * Math.PI / 360))) / 360, i = Math.pow(2, e1.z);
            return [
                Math.round(_$r * i * Dr),
                Math.round(_$n * i * Dr)
            ];
        }
        function Pr(t, e1) {
            var _$r = Math.pow(2, e1.z);
            var _$n, i;
            return [
                (i = (t[0] / Dr + e1.x) / _$r, 360 * i - 180),
                (_$n = (t[1] / Dr + e1.y) / _$r, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * _$n) * Math.PI / 180)) - 90)
            ];
        }
        function Br(t, e1) {
            t[0] = Math.min(t[0], e1[0]), t[1] = Math.min(t[1], e1[1]), t[2] = Math.max(t[2], e1[0]), t[3] = Math.max(t[3], e1[1]);
        }
        function Vr(t, e1) {
            return !(t[0] <= e1[0] || t[2] >= e1[2] || t[1] <= e1[1] || t[3] >= e1[3]);
        }
        function Cr(t, e1, r) {
            var _$n = t[0] - e1[0], i = t[1] - e1[1], s = t[0] - r[0], a = t[1] - r[1];
            return _$n * a - s * i == 0 && _$n * s <= 0 && i * a <= 0;
        }
        function Lr(t, e1, r, n) {
            var i, s;
            return 0 != (i = [
                n[0] - r[0],
                n[1] - r[1]
            ])[0] * (s = [
                e1[0] - t[0],
                e1[1] - t[1]
            ])[1] - i[1] * s[0] && !(!qr(t, e1, r, n) || !qr(r, n, t, e1));
        }
        function Or(t, e1, r) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$n = _step.value;
                    for(var _$r = 0; _$r < _$n.length - 1; ++_$r)if (Lr(t, e1, _$n[_$r], _$n[_$r + 1])) return !0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !1;
        }
        function Rr(t, e1) {
            var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            var _$n = !1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var o = _step.value;
                    for(var _$e = 0; _$e < o.length - 1; _$e++){
                        if (Cr(t, o[_$e], o[_$e + 1])) return _$r;
                        (s = o[_$e])[1] > (i = t)[1] != (a = o[_$e + 1])[1] > i[1] && i[0] < (a[0] - s[0]) * (i[1] - s[1]) / (a[1] - s[1]) + s[0] && (_$n = !_$n);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var i, s, a;
            return _$n;
        }
        function Nr(t, e1) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$r = _step.value;
                    if (Rr(t, _$r)) return !0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !1;
        }
        function $r(t, e1) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$r = _step.value;
                    if (!Rr(_$r, e1)) return !1;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            for(var _$r1 = 0; _$r1 < t.length - 1; ++_$r1)if (Or(t[_$r1], t[_$r1 + 1], e1)) return !1;
            return !0;
        }
        function Ur(t, e1) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$r = _step.value;
                    if ($r(t, _$r)) return !0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !1;
        }
        function qr(t, e1, r, n) {
            var i = n[0] - r[0], s = n[1] - r[1], a = (t[0] - r[0]) * s - i * (t[1] - r[1]), o = (e1[0] - r[0]) * s - i * (e1[1] - r[1]);
            return a > 0 && o < 0 || a < 0 && o > 0;
        }
        function jr(t, e1, r) {
            var _$n = [];
            for(var i = 0; i < t.length; i++){
                var s = [];
                for(var _$n1 = 0; _$n1 < t[i].length; _$n1++){
                    var a = zr(t[i][_$n1], r);
                    Br(e1, a), s.push(a);
                }
                _$n.push(s);
            }
            return _$n;
        }
        function Gr(t, e1, r) {
            var _$n = [];
            for(var i = 0; i < t.length; i++){
                var s = jr(t[i], e1, r);
                _$n.push(s);
            }
            return _$n;
        }
        function Xr(t, e1, r, n) {
            if (t[0] < r[0] || t[0] > r[2]) {
                var _$e = .5 * n;
                var i = t[0] - r[0] > _$e ? -n : r[0] - t[0] > _$e ? n : 0;
                0 === i && (i = t[0] - r[2] > _$e ? -n : r[2] - t[0] > _$e ? n : 0), t[0] += i;
            }
            Br(e1, t);
        }
        function Yr(t, e1, r, n) {
            var i = Math.pow(2, n.z) * Dr, s = [
                n.x * Dr,
                n.y * Dr
            ], a = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                    var _$n = _step.value;
                    try {
                        for(var _iterator1 = _$n[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step1.value;
                            var _$n1 = [
                                _$t.x + s[0],
                                _$t.y + s[1]
                            ];
                            Xr(_$n1, e1, r, i), a.push(_$n1);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return a;
        }
        function Zr(t, e1, r, n) {
            var i = Math.pow(2, n.z) * Dr, s = [
                n.x * Dr,
                n.y * Dr
            ], a = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$r = _step.value;
                    var _$t = [];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = _$r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _$n = _step1.value;
                            var _$r1 = [
                                _$n.x + s[0],
                                _$n.y + s[1]
                            ];
                            Br(e1, _$r1), _$t.push(_$r1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    a.push(_$t);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (e1[2] - e1[0] <= i / 2) {
                (o = e1)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined, _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator2 = a[Symbol.iterator](), _step2; !(_iteratorNormalCompletion3 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion3 = true){
                        var _$t1 = _step2.value;
                        try {
                            for(var _iterator3 = _$t1[Symbol.iterator](), _step3; !(_iteratorNormalCompletion2 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion2 = true){
                                var _$n1 = _step3.value;
                                Xr(_$n1, e1, r, i);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            var o;
            return a;
        }
        var Hr = /*#__PURE__*/ function() {
            function Hr(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Hr);
                this.type = Ot, this.geojson = t, this.geometries = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Hr, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        if (null != t.geometry() && null != t.canonicalID()) {
                            if ("Point" === t.geometryType()) return function(t, e1) {
                                var _$r = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], _$n = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], i = t.canonicalID();
                                if ("Polygon" === e1.type) {
                                    var s = jr(e1.coordinates, _$n, i), a = Yr(t.geometry(), _$r, _$n, i);
                                    if (!Vr(_$r, _$n)) return !1;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _$t = _step.value;
                                            if (!Rr(_$t, s)) return !1;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                if ("MultiPolygon" === e1.type) {
                                    var s1 = Gr(e1.coordinates, _$n, i), a1 = Yr(t.geometry(), _$r, _$n, i);
                                    if (!Vr(_$r, _$n)) return !1;
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = a1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var _$t1 = _step1.value;
                                            if (!Nr(_$t1, s1)) return !1;
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                                return !0;
                            }(t, this.geometries);
                            if ("LineString" === t.geometryType()) return function(t, e1) {
                                var _$r = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], _$n = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ], i = t.canonicalID();
                                if ("Polygon" === e1.type) {
                                    var s = jr(e1.coordinates, _$n, i), a = Zr(t.geometry(), _$r, _$n, i);
                                    if (!Vr(_$r, _$n)) return !1;
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _$t = _step.value;
                                            if (!$r(_$t, s)) return !1;
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                }
                                if ("MultiPolygon" === e1.type) {
                                    var s1 = Gr(e1.coordinates, _$n, i), a1 = Zr(t.geometry(), _$r, _$n, i);
                                    if (!Vr(_$r, _$n)) return !1;
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = a1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var _$t1 = _step1.value;
                                            if (!Ur(_$t1, s1)) return !1;
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                                return !0;
                            }(t, this.geometries);
                        }
                        return !1;
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild() {}
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !0;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (2 !== t.length) return e1.error("'within' expression requires exactly one argument, but found ".concat(t.length - 1, " instead."));
                        if ($e(t[1])) {
                            var _$e = t[1];
                            if ("FeatureCollection" === _$e.type) {
                                var _$t = [];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = _$e.features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$r = _step.value;
                                        var _t;
                                        var _r_geometry = _$r.geometry, _$e1 = _r_geometry.type, _$n = _r_geometry.coordinates;
                                        "Polygon" === _$e1 && _$t.push(_$n), "MultiPolygon" === _$e1 && (_t = _$t).push.apply(_t, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$n));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (_$t.length) return new Hr(_$e, {
                                    type: "MultiPolygon",
                                    coordinates: _$t
                                });
                            } else if ("Feature" === _$e.type) {
                                var _$t1 = _$e.geometry.type;
                                if ("Polygon" === _$t1 || "MultiPolygon" === _$t1) return new Hr(_$e, _$e.geometry);
                            } else if ("Polygon" === _$e.type || "MultiPolygon" === _$e.type) return new Hr(_$e, _$e);
                        }
                        return e1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
                    }
                }
            ]);
            return Hr;
        }();
        var Kr = /*#__PURE__*/ function() {
            function Kr() {
                var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(t, e1) {
                    return t < e1 ? -1 : t > e1 ? 1 : 0;
                };
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Kr);
                if (this.data = _$t, this.length = this.data.length, this.compare = _$e, this.length > 0) for(var _$t1 = (this.length >> 1) - 1; _$t1 >= 0; _$t1--)this._down(_$t1);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Kr, [
                {
                    key: "push",
                    value: function push(t) {
                        this.data.push(t), this._up(this.length++);
                    }
                },
                {
                    key: "pop",
                    value: function pop() {
                        if (0 === this.length) return;
                        var _$t = this.data[0], _$e = this.data.pop();
                        return --this.length > 0 && (this.data[0] = _$e, this._down(0)), _$t;
                    }
                },
                {
                    key: "peek",
                    value: function peek() {
                        return this.data[0];
                    }
                },
                {
                    key: "_up",
                    value: function _up(t) {
                        var _this = this, _$e = _this.data, _$r = _this.compare, _$n = _$e[t];
                        for(; t > 0;){
                            var i = t - 1 >> 1, s = _$e[i];
                            if (_$r(_$n, s) >= 0) break;
                            _$e[t] = s, t = i;
                        }
                        _$e[t] = _$n;
                    }
                },
                {
                    key: "_down",
                    value: function _down(t) {
                        var _this = this, _$e = _this.data, _$r = _this.compare, _$n = this.length >> 1, i = _$e[t];
                        for(; t < _$n;){
                            var _$n1 = 1 + (t << 1);
                            var s = _$n1 + 1;
                            if (s < this.length && _$r(_$e[s], _$e[_$n1]) < 0 && (_$n1 = s), _$r(_$e[_$n1], i) >= 0) break;
                            _$e[t] = _$e[_$n1], t = _$n1;
                        }
                        _$e[t] = i;
                    }
                }
            ]);
            return Kr;
        }();
        function Wr(t, e1) {
            var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, _$n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : t.length - 1, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : Qr;
            for(; _$n > _$r;){
                if (_$n - _$r > 600) {
                    var s = _$n - _$r + 1, a = e1 - _$r + 1, o = Math.log(s), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (s - l) / s) * (a - s / 2 < 0 ? -1 : 1);
                    Wr(t, e1, Math.max(_$r, Math.floor(e1 - a * l / s + u)), Math.min(_$n, Math.floor(e1 + (s - a) * l / s + u)), i);
                }
                var s1 = t[e1];
                var a1 = _$r, o1 = _$n;
                for(Jr(t, _$r, e1), i(t[_$n], s1) > 0 && Jr(t, _$r, _$n); a1 < o1;){
                    for(Jr(t, a1, o1), a1++, o1--; i(t[a1], s1) < 0;)a1++;
                    for(; i(t[o1], s1) > 0;)o1--;
                }
                0 === i(t[_$r], s1) ? Jr(t, _$r, o1) : (o1++, Jr(t, o1, _$n)), o1 <= e1 && (_$r = o1 + 1), e1 <= o1 && (_$n = o1 - 1);
            }
        }
        function Jr(t, e1, r) {
            var _$n = t[e1];
            t[e1] = t[r], t[r] = _$n;
        }
        function Qr(t, e1) {
            return t < e1 ? -1 : t > e1 ? 1 : 0;
        }
        function tn(t, e1) {
            if (t.length <= 1) return [
                t
            ];
            var _$r = [];
            var _$n, i;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e = _step.value;
                    var _$t = rn(_$e);
                    0 !== _$t && (_$e.area = Math.abs(_$t), void 0 === i && (i = _$t < 0), i === _$t < 0 ? (_$n && _$r.push(_$n), _$n = [
                        _$e
                    ]) : _$n.push(_$e));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            if (_$n && _$r.push(_$n), e1 > 1) for(var _$t1 = 0; _$t1 < _$r.length; _$t1++)_$r[_$t1].length <= e1 || (Wr(_$r[_$t1], e1, 1, _$r[_$t1].length - 1, en), _$r[_$t1] = _$r[_$t1].slice(0, e1));
            return _$r;
        }
        function en(t, e1) {
            return e1.area - t.area;
        }
        function rn(t) {
            var _$e = 0;
            for(var _$r, _$n, i = 0, s = t.length, a = s - 1; i < s; a = i++)_$r = t[i], _$n = t[a], _$e += (_$n.x - _$r.x) * (_$r.y + _$n.y);
            return _$e;
        }
        var nn = 1 / 298.257223563, sn = nn * (2 - nn), an = Math.PI / 180;
        var on = /*#__PURE__*/ function() {
            function on(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, on);
                var _$e = 6378.137 * an * 1e3, _$r = Math.cos(t * an), _$n = 1 / (1 - sn * (1 - _$r * _$r)), i = Math.sqrt(_$n);
                this.kx = _$e * i * _$r, this.ky = _$e * i * _$n * (1 - sn);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(on, [
                {
                    key: "distance",
                    value: function distance(t, e1) {
                        var _$r = this.wrap(t[0] - e1[0]) * this.kx, _$n = (t[1] - e1[1]) * this.ky;
                        return Math.sqrt(_$r * _$r + _$n * _$n);
                    }
                },
                {
                    key: "pointOnLine",
                    value: function pointOnLine(t, e1) {
                        var _$r, _$n, i, s, a = 1 / 0;
                        for(var o = 0; o < t.length - 1; o++){
                            var l = t[o][0], u = t[o][1], _$c = this.wrap(t[o + 1][0] - l) * this.kx, _$h = (t[o + 1][1] - u) * this.ky, p = 0;
                            0 === _$c && 0 === _$h || (p = (this.wrap(e1[0] - l) * this.kx * _$c + (e1[1] - u) * this.ky * _$h) / (_$c * _$c + _$h * _$h), p > 1 ? (l = t[o + 1][0], u = t[o + 1][1]) : p > 0 && (l += _$c / this.kx * p, u += _$h / this.ky * p)), _$c = this.wrap(e1[0] - l) * this.kx, _$h = (e1[1] - u) * this.ky;
                            var f = _$c * _$c + _$h * _$h;
                            f < a && (a = f, _$r = l, _$n = u, i = o, s = p);
                        }
                        return {
                            point: [
                                _$r,
                                _$n
                            ],
                            index: i,
                            t: Math.max(0, Math.min(1, s))
                        };
                    }
                },
                {
                    key: "wrap",
                    value: function wrap(t) {
                        for(; t < -180;)t += 360;
                        for(; t > 180;)t -= 360;
                        return t;
                    }
                }
            ]);
            return on;
        }();
        function ln(t, e1) {
            return e1[0] - t[0];
        }
        function un(t) {
            return t[1] - t[0] + 1;
        }
        function cn(t, e1) {
            return t[1] >= t[0] && t[1] < e1;
        }
        function hn(t, e1) {
            if (t[0] > t[1]) return [
                null,
                null
            ];
            var _$r = un(t);
            if (e1) {
                if (2 === _$r) return [
                    t,
                    null
                ];
                var _$e = Math.floor(_$r / 2);
                return [
                    [
                        t[0],
                        t[0] + _$e
                    ],
                    [
                        t[0] + _$e,
                        t[1]
                    ]
                ];
            }
            if (1 === _$r) return [
                t,
                null
            ];
            var _$n = Math.floor(_$r / 2) - 1;
            return [
                [
                    t[0],
                    t[0] + _$n
                ],
                [
                    t[0] + _$n + 1,
                    t[1]
                ]
            ];
        }
        function pn(t, e1) {
            if (!cn(e1, t.length)) return [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            var _$r = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(var _$n = e1[0]; _$n <= e1[1]; ++_$n)Br(_$r, t[_$n]);
            return _$r;
        }
        function fn(t) {
            var _$e = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                    var _$r = _step.value;
                    try {
                        for(var _iterator1 = _$r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step1.value;
                            Br(_$e, _$t);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return _$e;
        }
        function dn(t) {
            return t[0] !== -1 / 0 && t[1] !== -1 / 0 && t[2] !== 1 / 0 && t[3] !== 1 / 0;
        }
        function yn(t, e1, r) {
            if (!dn(t) || !dn(e1)) return NaN;
            var _$n = 0, i = 0;
            return t[2] < e1[0] && (_$n = e1[0] - t[2]), t[0] > e1[2] && (_$n = t[0] - e1[2]), t[1] > e1[3] && (i = t[1] - e1[3]), t[3] < e1[1] && (i = e1[1] - t[3]), r.distance([
                0,
                0
            ], [
                _$n,
                i
            ]);
        }
        function mn(t, e1, r) {
            var _$n = r.pointOnLine(e1, t);
            return r.distance(t, _$n.point);
        }
        function gn(t, e1, r, n, i) {
            var s = Math.min(mn(t, [
                r,
                n
            ], i), mn(e1, [
                r,
                n
            ], i)), a = Math.min(mn(r, [
                t,
                e1
            ], i), mn(n, [
                t,
                e1
            ], i));
            return Math.min(s, a);
        }
        function xn(t, e1, r, n, i) {
            if (!cn(e1, t.length) || !cn(n, r.length)) return 1 / 0;
            var s = 1 / 0;
            for(var a = e1[0]; a < e1[1]; ++a){
                var _$e = t[a], o = t[a + 1];
                for(var _$t = n[0]; _$t < n[1]; ++_$t){
                    var _$n = r[_$t], a1 = r[_$t + 1];
                    if (Lr(_$e, o, _$n, a1)) return 0;
                    s = Math.min(s, gn(_$e, o, _$n, a1, i));
                }
            }
            return s;
        }
        function vn(t, e1, r, n, i) {
            if (!cn(e1, t.length) || !cn(n, r.length)) return NaN;
            var s = 1 / 0;
            for(var a = e1[0]; a <= e1[1]; ++a)for(var _$e = n[0]; _$e <= n[1]; ++_$e)if (s = Math.min(s, i.distance(t[a], r[_$e])), 0 === s) return s;
            return s;
        }
        function bn(t, e1, r) {
            if (Rr(t, e1, !0)) return 0;
            var _$n = 1 / 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    var _$e = i[0], s = i[i.length - 1];
                    if (_$e !== s && (_$n = Math.min(_$n, mn(t, [
                        s,
                        _$e
                    ], r)), 0 === _$n)) return _$n;
                    var a = r.pointOnLine(i, t);
                    if (_$n = Math.min(_$n, r.distance(t, a.point)), 0 === _$n) return _$n;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return _$n;
        }
        function wn(t, e1, r, n) {
            if (!cn(e1, t.length)) return NaN;
            for(var _$n = e1[0]; _$n <= e1[1]; ++_$n)if (Rr(t[_$n], r, !0)) return 0;
            var i = 1 / 0;
            for(var s = e1[0]; s < e1[1]; ++s){
                var _$e = t[s], a = t[s + 1];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t = _step.value;
                        for(var _$r = 0, s1 = _$t.length, o = s1 - 1; _$r < s1; o = _$r++){
                            var s2 = _$t[o], l = _$t[_$r];
                            if (Lr(_$e, a, s2, l)) return 0;
                            i = Math.min(i, gn(_$e, a, s2, l, n));
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return i;
        }
        function _n(t, e1) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                    var _$r = _step.value;
                    try {
                        for(var _iterator1 = _$r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step1.value;
                            if (Rr(_$t, e1, !0)) return !0;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return !1;
        }
        function Sn(t, e1, r) {
            var _$n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1 / 0;
            var i = fn(t), s = fn(e1);
            if (_$n !== 1 / 0 && yn(i, s, r) >= _$n) return _$n;
            if (Vr(i, s)) {
                if (_n(t, e1)) return 0;
            } else if (_n(e1, t)) return 0;
            var a = 1 / 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$n1 = _step.value;
                    for(var _$t = 0, i1 = _$n1.length, s1 = i1 - 1; _$t < i1; s1 = _$t++){
                        var i2 = _$n1[s1], o = _$n1[_$t];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = e1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$t1 = _step1.value;
                                for(var _$e = 0, _$n2 = _$t1.length, s2 = _$n2 - 1; _$e < _$n2; s2 = _$e++){
                                    var _$n3 = _$t1[s2], l = _$t1[_$e];
                                    if (Lr(i2, o, _$n3, l)) return 0;
                                    a = Math.min(a, gn(i2, o, _$n3, l, r));
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return a;
        }
        function An(t, e1, r, n, i, s) {
            if (!s) return;
            var a = yn(pn(n, s), i, r);
            a < e1 && t.push([
                a,
                s,
                [
                    0,
                    0
                ]
            ]);
        }
        function kn(t, e1, r, n, i, s, a) {
            if (!s || !a) return;
            var o = yn(pn(n, s), pn(i, a), r);
            o < e1 && t.push([
                o,
                s,
                a
            ]);
        }
        function En(t, e1, r, n) {
            var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1 / 0;
            var s = Math.min(n.distance(t[0], r[0][0]), i);
            if (0 === s) return s;
            var a = new Kr([
                [
                    0,
                    [
                        0,
                        t.length - 1
                    ],
                    [
                        0,
                        0
                    ]
                ]
            ], ln), o = fn(r);
            for(; a.length > 0;){
                var i1 = a.pop();
                if (i1[0] >= s) continue;
                var l = i1[1], u = e1 ? 50 : 100;
                if (un(l) <= u) {
                    if (!cn(l, t.length)) return NaN;
                    if (e1) {
                        var _$e = wn(t, l, r, n);
                        if (isNaN(_$e) || 0 === _$e) return _$e;
                        s = Math.min(s, _$e);
                    } else for(var _$e1 = l[0]; _$e1 <= l[1]; ++_$e1){
                        var i2 = bn(t[_$e1], r, n);
                        if (s = Math.min(s, i2), 0 === s) return 0;
                    }
                } else {
                    var _$r = hn(l, e1);
                    An(a, s, n, t, o, _$r[0]), An(a, s, n, t, o, _$r[1]);
                }
            }
            return s;
        }
        function Tn(t, e1, r, n, i) {
            var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1 / 0;
            var a = Math.min(s, i.distance(t[0], r[0]));
            if (0 === a) return a;
            var o = new Kr([
                [
                    0,
                    [
                        0,
                        t.length - 1
                    ],
                    [
                        0,
                        r.length - 1
                    ]
                ]
            ], ln);
            for(; o.length > 0;){
                var s1 = o.pop();
                if (s1[0] >= a) continue;
                var l = s1[1], u = s1[2], _$c = e1 ? 50 : 100, _$h = n ? 50 : 100;
                if (un(l) <= _$c && un(u) <= _$h) {
                    if (!cn(l, t.length) && cn(u, r.length)) return NaN;
                    var s2 = void 0;
                    if (e1 && n) s2 = xn(t, l, r, u, i), a = Math.min(a, s2);
                    else if (e1 && !n) {
                        var _$e = t.slice(l[0], l[1] + 1);
                        for(var _$t = u[0]; _$t <= u[1]; ++_$t)if (s2 = mn(r[_$t], _$e, i), a = Math.min(a, s2), 0 === a) return a;
                    } else if (!e1 && n) {
                        var _$e1 = r.slice(u[0], u[1] + 1);
                        for(var _$r = l[0]; _$r <= l[1]; ++_$r)if (s2 = mn(t[_$r], _$e1, i), a = Math.min(a, s2), 0 === a) return a;
                    } else s2 = vn(t, l, r, u, i), a = Math.min(a, s2);
                } else {
                    var s3 = hn(l, e1), _$c1 = hn(u, n);
                    kn(o, a, i, t, r, s3[0], _$c1[0]), kn(o, a, i, t, r, s3[0], _$c1[1]), kn(o, a, i, t, r, s3[1], _$c1[0]), kn(o, a, i, t, r, s3[1], _$c1[1]);
                }
            }
            return a;
        }
        function In(t) {
            return "MultiPolygon" === t.type ? t.coordinates.map(function(t) {
                return {
                    type: "Polygon",
                    coordinates: t
                };
            }) : "MultiLineString" === t.type ? t.coordinates.map(function(t) {
                return {
                    type: "LineString",
                    coordinates: t
                };
            }) : "MultiPoint" === t.type ? t.coordinates.map(function(t) {
                return {
                    type: "Point",
                    coordinates: t
                };
            }) : [
                t
            ];
        }
        var Mn = /*#__PURE__*/ function() {
            function Mn(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Mn);
                this.type = Ct, this.geojson = t, this.geometries = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Mn, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        if (null != t.geometry() && null != t.canonicalID()) {
                            if ("Point" === t.geometryType()) return function(t, e1) {
                                var _$r = t.geometry(), _$n = _$r.flat().map(function(e1) {
                                    return Pr([
                                        e1.x,
                                        e1.y
                                    ], t.canonical);
                                });
                                if (0 === _$r.length) return NaN;
                                var i = new on(_$n[0][1]);
                                var s = 1 / 0;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$t = _step.value;
                                        switch(_$t.type){
                                            case "Point":
                                                s = Math.min(s, Tn(_$n, !1, [
                                                    _$t.coordinates
                                                ], !1, i, s));
                                                break;
                                            case "LineString":
                                                s = Math.min(s, Tn(_$n, !1, _$t.coordinates, !0, i, s));
                                                break;
                                            case "Polygon":
                                                s = Math.min(s, En(_$n, !1, _$t.coordinates, i, s));
                                        }
                                        if (0 === s) return s;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return s;
                            }(t, this.geometries);
                            if ("LineString" === t.geometryType()) return function(t, e1) {
                                var _$r = t.geometry(), _$n = _$r.flat().map(function(e1) {
                                    return Pr([
                                        e1.x,
                                        e1.y
                                    ], t.canonical);
                                });
                                if (0 === _$r.length) return NaN;
                                var i = new on(_$n[0][1]);
                                var s = 1 / 0;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$t = _step.value;
                                        switch(_$t.type){
                                            case "Point":
                                                s = Math.min(s, Tn(_$n, !0, [
                                                    _$t.coordinates
                                                ], !1, i, s));
                                                break;
                                            case "LineString":
                                                s = Math.min(s, Tn(_$n, !0, _$t.coordinates, !0, i, s));
                                                break;
                                            case "Polygon":
                                                s = Math.min(s, En(_$n, !0, _$t.coordinates, i, s));
                                        }
                                        if (0 === s) return s;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return s;
                            }(t, this.geometries);
                            if ("Polygon" === t.geometryType()) return function(t, e1) {
                                var _$r = t.geometry();
                                if (0 === _$r.length || 0 === _$r[0].length) return NaN;
                                var _$n = tn(_$r, 0).map(function(e1) {
                                    return e1.map(function(e1) {
                                        return e1.map(function(e1) {
                                            return Pr([
                                                e1.x,
                                                e1.y
                                            ], t.canonical);
                                        });
                                    });
                                }), i = new on(_$n[0][0][0][1]);
                                var s = 1 / 0;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                        var _$t = _step.value;
                                        try {
                                            for(var _iterator1 = _$n[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                                var _$e = _step1.value;
                                                switch(_$t.type){
                                                    case "Point":
                                                        s = Math.min(s, En([
                                                            _$t.coordinates
                                                        ], !1, _$e, i, s));
                                                        break;
                                                    case "LineString":
                                                        s = Math.min(s, En(_$t.coordinates, !0, _$e, i, s));
                                                        break;
                                                    case "Polygon":
                                                        s = Math.min(s, Sn(_$e, _$t.coordinates, i, s));
                                                }
                                                if (0 === s) return s;
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                return s;
                            }(t, this.geometries);
                        }
                        return NaN;
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild() {}
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !0;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (2 !== t.length) return e1.error("'distance' expression requires exactly one argument, but found ".concat(t.length - 1, " instead."));
                        if ($e(t[1])) {
                            var _$e = t[1];
                            if ("FeatureCollection" === _$e.type) return new Mn(_$e, _$e.features.map(function(t) {
                                return In(t.geometry);
                            }).flat());
                            if ("Feature" === _$e.type) return new Mn(_$e, In(_$e.geometry));
                            if ("type" in _$e && "coordinates" in _$e) return new Mn(_$e, In(_$e));
                        }
                        return e1.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
                    }
                }
            ]);
            return Mn;
        }();
        var Fn = /*#__PURE__*/ function() {
            function Fn(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Fn);
                this.type = Ut, this.key = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Fn, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        var _$e;
                        var _$r = null === (_$e = t.globals) || void 0 === _$e ? void 0 : _$e.globalState;
                        return _$r && 0 !== Object.keys(_$r).length ? ve(_$r, this.key) : null;
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild() {}
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        if (2 !== t.length) return e1.error("Expected 1 argument, but found ".concat(t.length - 1, " instead."));
                        var _$r = t[1];
                        return null == _$r ? e1.error("Global state property must be defined.") : "string" != typeof _$r ? e1.error("Global state property must be string, but found ".concat((0, $dvYFb._)(t[1]), " instead.")) : new Fn(_$r);
                    }
                }
            ]);
            return Fn;
        }();
        var Dn = {
            "==": br,
            "!=": wr,
            ">": Sr,
            "<": _r,
            ">=": kr,
            "<=": Ar,
            array: Xe,
            at: tr,
            boolean: Xe,
            case: ir,
            coalesce: mr,
            collator: Er,
            format: Ir,
            image: Mr,
            in: er,
            "index-of": rr,
            interpolate: fr,
            "interpolate-hcl": fr,
            "interpolate-lab": fr,
            length: Fr,
            let: Je,
            literal: je,
            match: nr,
            number: Xe,
            "number-format": Tr,
            object: Xe,
            slice: sr,
            step: or,
            string: Xe,
            "to-boolean": Ze,
            "to-color": Ze,
            "to-number": Ze,
            "to-string": Ze,
            var: Qe,
            within: Hr,
            distance: Mn,
            "global-state": Fn
        };
        var zn = /*#__PURE__*/ function() {
            function zn(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, zn);
                this.name = t, this.type = e1, this._evaluate = r, this.args = n;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(zn, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        return this._evaluate(t, this.args);
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        this.args.forEach(t);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                }
            ], [
                {
                    key: "parse",
                    value: function parse(t, e1) {
                        var _e_errors;
                        var _$r = t[0], _$n = zn.definitions[_$r];
                        if (!_$n) return e1.error('Unknown expression "'.concat(_$r, '". If you wanted a literal array, use ["literal", [...]].'), 0);
                        var i = Array.isArray(_$n) ? _$n[0] : _$n.type, s = Array.isArray(_$n) ? [
                            [
                                _$n[1],
                                _$n[2]
                            ]
                        ] : _$n.overloads, a = s.filter(function(param) {
                            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                            return !Array.isArray(_$e) || _$e.length === t.length - 1;
                        });
                        var o = null;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), _$n1 = _step_value[0], s1 = _step_value[1];
                                o = new We(e1.registry, Ln, e1.path, null, e1.scope);
                                var a1 = [];
                                var l = !1;
                                for(var _$e = 1; _$e < t.length; _$e++){
                                    var _$r1 = t[_$e], i1 = Array.isArray(_$n1) ? _$n1[_$e - 1] : _$n1.type, s2 = o.parse(_$r1, 1 + a1.length, i1);
                                    if (!s2) {
                                        l = !0;
                                        break;
                                    }
                                    a1.push(s2);
                                }
                                if (!l) {
                                    if (Array.isArray(_$n1) && _$n1.length !== a1.length) o.error("Expected ".concat(_$n1.length, " arguments, but found ").concat(a1.length, " instead."));
                                    else {
                                        for(var _$t = 0; _$t < a1.length; _$t++){
                                            var _$e1 = Array.isArray(_$n1) ? _$n1[_$t] : _$n1.type, _$r2 = a1[_$t];
                                            o.concat(_$t + 1).checkSubtype(_$e1, _$r2.type);
                                        }
                                        if (0 === o.errors.length) return new zn(_$r, i, s1, a1);
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (1 === a.length) (_e_errors = e1.errors).push.apply(_e_errors, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(o.errors));
                        else {
                            var _$r3 = (a.length ? a : s).map(function(param) {
                                var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$t = _param[0];
                                var _$e;
                                return _$e = _$t, Array.isArray(_$e) ? "(".concat(_$e.map(Wt).join(", "), ")") : "(".concat(Wt(_$e.type), "...)");
                            }).join(" | "), _$n2 = [];
                            for(var _$r4 = 1; _$r4 < t.length; _$r4++){
                                var i2 = e1.parse(t[_$r4], 1 + _$n2.length);
                                if (!i2) return null;
                                _$n2.push(Wt(i2.type));
                            }
                            e1.error("Expected arguments of type ".concat(_$r3, ", but found (").concat(_$n2.join(", "), ") instead."));
                        }
                        return null;
                    }
                },
                {
                    key: "register",
                    value: function register(t, e1) {
                        zn.definitions = e1;
                        for(var _$r in e1)t[_$r] = zn;
                    }
                }
            ]);
            return zn;
        }();
        function Pn(t, param) {
            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 4), _$e = _param[0], _$r = _param[1], _$n = _param[2], i = _param[3];
            _$e = _$e.evaluate(t), _$r = _$r.evaluate(t), _$n = _$n.evaluate(t);
            var s = i ? i.evaluate(t) : 1, a = Ne(_$e, _$r, _$n, s);
            if (a) throw new Ve(a);
            return new Te(_$e / 255, _$r / 255, _$n / 255, s, !1);
        }
        function Bn(t, e1) {
            return t in e1;
        }
        function Vn(t, e1) {
            var _$r = e1[t];
            return void 0 === _$r ? null : _$r;
        }
        function Cn(t) {
            return {
                type: t
            };
        }
        function Ln(t) {
            if (t instanceof Qe) return Ln(t.boundExpression);
            if (t instanceof zn && "error" === t.name) return !1;
            if (t instanceof Er) return !1;
            if (t instanceof Hr) return !1;
            if (t instanceof Mn) return !1;
            if (t instanceof Fn) return !1;
            var _$e = t instanceof Ze || t instanceof Xe;
            var _$r = !0;
            return t.eachChild(function(t) {
                _$r = _$e ? _$r && Ln(t) : _$r && t instanceof je;
            }), !!_$r && On(t) && Nn(t, [
                "zoom",
                "heatmap-density",
                "elevation",
                "line-progress",
                "accumulated",
                "is-supported-script"
            ]);
        }
        function On(t) {
            if (t instanceof zn) {
                if ("get" === t.name && 1 === t.args.length) return !1;
                if ("feature-state" === t.name) return !1;
                if ("has" === t.name && 1 === t.args.length) return !1;
                if ("properties" === t.name || "geometry-type" === t.name || "id" === t.name) return !1;
                if (/^filter-/.test(t.name)) return !1;
            }
            if (t instanceof Hr) return !1;
            if (t instanceof Mn) return !1;
            var _$e = !0;
            return t.eachChild(function(t) {
                _$e && !On(t) && (_$e = !1);
            }), _$e;
        }
        function Rn(t) {
            if (t instanceof zn && "feature-state" === t.name) return !1;
            var _$e = !0;
            return t.eachChild(function(t) {
                _$e && !Rn(t) && (_$e = !1);
            }), _$e;
        }
        function Nn(t, e1) {
            if (t instanceof zn && e1.indexOf(t.name) >= 0) return !1;
            var _$r = !0;
            return t.eachChild(function(t) {
                _$r && !Nn(t, e1) && (_$r = !1);
            }), _$r;
        }
        function $n(t) {
            return {
                result: "success",
                value: t
            };
        }
        function Un(t) {
            return {
                result: "error",
                value: t
            };
        }
        function qn(t) {
            return "data-driven" === t["property-type"] || "cross-faded-data-driven" === t["property-type"];
        }
        function jn(t) {
            return !!t.expression && t.expression.parameters.indexOf("zoom") > -1;
        }
        function Gn(t) {
            return !!t.expression && t.expression.interpolated;
        }
        function Xn(t) {
            return t instanceof Number ? "number" : t instanceof String ? "string" : t instanceof Boolean ? "boolean" : Array.isArray(t) ? "array" : null === t ? "null" : typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t);
        }
        function Yn(t) {
            return "object" == (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t)) && null !== t && !Array.isArray(t) && Ue(t) === $t;
        }
        function Zn(t) {
            return t;
        }
        function Hn(t, e1) {
            var _$r = t.stops && "object" == (0, $dvYFb._)(t.stops[0][0]), _$n = _$r || !(_$r || void 0 !== t.property), i = t.type || (Gn(e1) ? "exponential" : "interval"), s = function(t) {
                switch(t.type){
                    case "color":
                        return Te.parse;
                    case "padding":
                        return ze.parse;
                    case "numberArray":
                        return Pe.parse;
                    case "colorArray":
                        return Be.parse;
                    default:
                        return null;
                }
            }(e1);
            if (s && ((t = zt({}, t)).stops && (t.stops = t.stops.map(function(t) {
                return [
                    t[0],
                    s(t[1])
                ];
            })), t.default = s(t.default ? t.default : e1.default)), t.colorSpace && "rgb" !== (a = t.colorSpace) && "hcl" !== a && "lab" !== a) throw new Error('Unknown color space: "'.concat(t.colorSpace, '"'));
            var a;
            var o = function(t) {
                switch(t){
                    case "exponential":
                        return Qn;
                    case "interval":
                        return Jn;
                    case "categorical":
                        return Wn;
                    case "identity":
                        return ti;
                    default:
                        throw new Error('Unknown function type "'.concat(t, '"'));
                }
            }(i);
            var l, u;
            if ("categorical" === i) {
                l = Object.create(null);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t.stops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        l[_$e[0]] = _$e[1];
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                u = (0, $dvYFb._)(t.stops[0][0]);
            }
            if (_$r) {
                var _$r1 = {}, _$n1 = [];
                for(var _$e1 = 0; _$e1 < t.stops.length; _$e1++){
                    var i1 = t.stops[_$e1], s1 = i1[0].zoom;
                    void 0 === _$r1[s1] && (_$r1[s1] = {
                        zoom: s1,
                        type: t.type,
                        property: t.property,
                        default: t.default,
                        stops: []
                    }, _$n1.push(s1)), _$r1[s1].stops.push([
                        i1[0].value,
                        i1[1]
                    ]);
                }
                var i2 = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = _$n1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _$t = _step1.value;
                        i2.push([
                            _$r1[_$t].zoom,
                            Hn(_$r1[_$t], e1)
                        ]);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var s2 = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s2,
                    interpolationFactor: fr.interpolationFactor.bind(void 0, s2),
                    zoomStops: i2.map(function(t) {
                        return t[0];
                    }),
                    evaluate: function(param, n) {
                        var _$r = param.zoom;
                        return Qn({
                            stops: i2,
                            base: t.base
                        }, e1, _$r).evaluate(_$r, n);
                    }
                };
            }
            if (_$n) {
                var _$r2 = "exponential" === i ? {
                    name: "exponential",
                    base: void 0 !== t.base ? t.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: _$r2,
                    interpolationFactor: fr.interpolationFactor.bind(void 0, _$r2),
                    zoomStops: t.stops.map(function(t) {
                        return t[0];
                    }),
                    evaluate: function(param) {
                        var _$r = param.zoom;
                        return o(t, e1, _$r, l, u);
                    }
                };
            }
            return {
                kind: "source",
                evaluate: function(r, n) {
                    var i = n && n.properties ? n.properties[t.property] : void 0;
                    return void 0 === i ? Kn(t.default, e1.default) : o(t, e1, i, l, u);
                }
            };
        }
        function Kn(t, e1, r) {
            return void 0 !== t ? t : void 0 !== e1 ? e1 : void 0 !== r ? r : void 0;
        }
        function Wn(t, e1, r, n, i) {
            return Kn((typeof r === "undefined" ? "undefined" : (0, $dvYFb._)(r)) === i ? n[r] : void 0, t.default, e1.default);
        }
        function Jn(t, e1, r) {
            if ("number" !== Xn(r)) return Kn(t.default, e1.default);
            var _$n = t.stops.length;
            if (1 === _$n) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[_$n - 1][0]) return t.stops[_$n - 1][1];
            var i = ar(t.stops.map(function(t) {
                return t[0];
            }), r);
            return t.stops[i][1];
        }
        function Qn(t, e1, r) {
            var _$n = void 0 !== t.base ? t.base : 1;
            if ("number" !== Xn(r)) return Kn(t.default, e1.default);
            var i = t.stops.length;
            if (1 === i) return t.stops[0][1];
            if (r <= t.stops[0][0]) return t.stops[0][1];
            if (r >= t.stops[i - 1][0]) return t.stops[i - 1][1];
            var s = ar(t.stops.map(function(t) {
                return t[0];
            }), r), a = function(t, e1, r, n) {
                var i = n - r, s = t - r;
                return 0 === i ? 0 : 1 === e1 ? s / i : (Math.pow(e1, s) - 1) / (Math.pow(e1, i) - 1);
            }(r, _$n, t.stops[s][0], t.stops[s + 1][0]), o = t.stops[s][1], l = t.stops[s + 1][1], u = yr[e1.type] || Zn;
            return "function" == typeof o.evaluate ? {
                evaluate: function() {
                    for(var _len = arguments.length, _$e = new Array(_len), _key = 0; _key < _len; _key++){
                        _$e[_key] = arguments[_key];
                    }
                    var _$r = o.evaluate.apply(void 0, _$e), _$n = l.evaluate.apply(void 0, _$e);
                    if (void 0 !== _$r && void 0 !== _$n) return u(_$r, _$n, a, t.colorSpace);
                }
            } : u(o, l, a, t.colorSpace);
        }
        function ti(t, e1, r) {
            switch(e1.type){
                case "color":
                    r = Te.parse(r);
                    break;
                case "formatted":
                    r = De.fromString(r.toString());
                    break;
                case "resolvedImage":
                    r = Oe.fromString(r.toString());
                    break;
                case "padding":
                    r = ze.parse(r);
                    break;
                case "colorArray":
                    r = Be.parse(r);
                    break;
                case "numberArray":
                    r = Pe.parse(r);
                    break;
                default:
                    Xn(r) === e1.type || "enum" === e1.type && e1.values[r] || (r = void 0);
            }
            return Kn(r, t.default, e1.default);
        }
        zn.register(Dn, {
            error: [
                {
                    kind: "error"
                },
                [
                    Lt
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    throw new Ve(_$e.evaluate(t));
                }
            ],
            typeof: [
                Lt,
                [
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Wt(Ue(_$e.evaluate(t)));
                }
            ],
            "to-rgba": [
                Kt(Ct, 4),
                [
                    Rt
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    var _e_evaluate_rgb = (0, $db95b225ee8036d6$export$71511d61b312f219)(_$e.evaluate(t).rgb, 4), _$r = _e_evaluate_rgb[0], _$n = _e_evaluate_rgb[1], i = _e_evaluate_rgb[2], s = _e_evaluate_rgb[3];
                    return [
                        255 * _$r,
                        255 * _$n,
                        255 * i,
                        s
                    ];
                }
            ],
            rgb: [
                Rt,
                [
                    Ct,
                    Ct,
                    Ct
                ],
                Pn
            ],
            rgba: [
                Rt,
                [
                    Ct,
                    Ct,
                    Ct,
                    Ct
                ],
                Pn
            ],
            has: {
                type: Ot,
                overloads: [
                    [
                        [
                            Lt
                        ],
                        function(t, param) {
                            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                            return Bn(_$e.evaluate(t), t.properties());
                        }
                    ],
                    [
                        [
                            Lt,
                            $t
                        ],
                        function(t, param) {
                            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                            return Bn(_$e.evaluate(t), _$r.evaluate(t));
                        }
                    ]
                ]
            },
            get: {
                type: Ut,
                overloads: [
                    [
                        [
                            Lt
                        ],
                        function(t, param) {
                            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                            return Vn(_$e.evaluate(t), t.properties());
                        }
                    ],
                    [
                        [
                            Lt,
                            $t
                        ],
                        function(t, param) {
                            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                            return Vn(_$e.evaluate(t), _$r.evaluate(t));
                        }
                    ]
                ]
            },
            "feature-state": [
                Ut,
                [
                    Lt
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Vn(_$e.evaluate(t), t.featureState || {});
                }
            ],
            properties: [
                $t,
                [],
                function(t) {
                    return t.properties();
                }
            ],
            "geometry-type": [
                Lt,
                [],
                function(t) {
                    return t.geometryType();
                }
            ],
            id: [
                Ut,
                [],
                function(t) {
                    return t.id();
                }
            ],
            zoom: [
                Ct,
                [],
                function(t) {
                    return t.globals.zoom;
                }
            ],
            "heatmap-density": [
                Ct,
                [],
                function(t) {
                    return t.globals.heatmapDensity || 0;
                }
            ],
            elevation: [
                Ct,
                [],
                function(t) {
                    return t.globals.elevation || 0;
                }
            ],
            "line-progress": [
                Ct,
                [],
                function(t) {
                    return t.globals.lineProgress || 0;
                }
            ],
            accumulated: [
                Ut,
                [],
                function(t) {
                    return void 0 === t.globals.accumulated ? null : t.globals.accumulated;
                }
            ],
            "+": [
                Ct,
                Cn(Ct),
                function(t, e1) {
                    var _$r = 0;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$n = _step.value;
                            _$r += _$n.evaluate(t);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _$r;
                }
            ],
            "*": [
                Ct,
                Cn(Ct),
                function(t, e1) {
                    var _$r = 1;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$n = _step.value;
                            _$r *= _$n.evaluate(t);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _$r;
                }
            ],
            "-": {
                type: Ct,
                overloads: [
                    [
                        [
                            Ct,
                            Ct
                        ],
                        function(t, param) {
                            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                            return _$e.evaluate(t) - _$r.evaluate(t);
                        }
                    ],
                    [
                        [
                            Ct
                        ],
                        function(t, param) {
                            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                            return -_$e.evaluate(t);
                        }
                    ]
                ]
            },
            "/": [
                Ct,
                [
                    Ct,
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                    return _$e.evaluate(t) / _$r.evaluate(t);
                }
            ],
            "%": [
                Ct,
                [
                    Ct,
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                    return _$e.evaluate(t) % _$r.evaluate(t);
                }
            ],
            ln2: [
                Ct,
                [],
                function() {
                    return Math.LN2;
                }
            ],
            pi: [
                Ct,
                [],
                function() {
                    return Math.PI;
                }
            ],
            e: [
                Ct,
                [],
                function() {
                    return Math.E;
                }
            ],
            "^": [
                Ct,
                [
                    Ct,
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                    return Math.pow(_$e.evaluate(t), _$r.evaluate(t));
                }
            ],
            sqrt: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.sqrt(_$e.evaluate(t));
                }
            ],
            log10: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.log(_$e.evaluate(t)) / Math.LN10;
                }
            ],
            ln: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.log(_$e.evaluate(t));
                }
            ],
            log2: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.log(_$e.evaluate(t)) / Math.LN2;
                }
            ],
            sin: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.sin(_$e.evaluate(t));
                }
            ],
            cos: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.cos(_$e.evaluate(t));
                }
            ],
            tan: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.tan(_$e.evaluate(t));
                }
            ],
            asin: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.asin(_$e.evaluate(t));
                }
            ],
            acos: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.acos(_$e.evaluate(t));
                }
            ],
            atan: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.atan(_$e.evaluate(t));
                }
            ],
            min: [
                Ct,
                Cn(Ct),
                function(t, e1) {
                    return (_Math = Math).min.apply(_Math, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(e1.map(function(e1) {
                        return e1.evaluate(t);
                    })));
                }
            ],
            max: [
                Ct,
                Cn(Ct),
                function(t, e1) {
                    return (_Math1 = Math).max.apply(_Math1, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(e1.map(function(e1) {
                        return e1.evaluate(t);
                    })));
                }
            ],
            abs: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.abs(_$e.evaluate(t));
                }
            ],
            round: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    var _$r = _$e.evaluate(t);
                    return _$r < 0 ? -Math.round(-_$r) : Math.round(_$r);
                }
            ],
            floor: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.floor(_$e.evaluate(t));
                }
            ],
            ceil: [
                Ct,
                [
                    Ct
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return Math.ceil(_$e.evaluate(t));
                }
            ],
            "filter-==": [
                Ot,
                [
                    Lt,
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                    return t.properties()[_$e.value] === _$r.value;
                }
            ],
            "filter-id-==": [
                Ot,
                [
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return t.id() === _$e.value;
                }
            ],
            "filter-type-==": [
                Ot,
                [
                    Lt
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return t.geometryType() === _$e.value;
                }
            ],
            "filter-<": [
                Ot,
                [
                    Lt,
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                    var _$n = t.properties()[_$e.value], i = _$r.value;
                    return (typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n)) == (typeof i === "undefined" ? "undefined" : (0, $dvYFb._)(i)) && _$n < i;
                }
            ],
            "filter-id-<": [
                Ot,
                [
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    var _$r = t.id(), _$n = _$e.value;
                    return (typeof _$r === "undefined" ? "undefined" : (0, $dvYFb._)(_$r)) == (typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n)) && _$r < _$n;
                }
            ],
            "filter->": [
                Ot,
                [
                    Lt,
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                    var _$n = t.properties()[_$e.value], i = _$r.value;
                    return (typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n)) == (typeof i === "undefined" ? "undefined" : (0, $dvYFb._)(i)) && _$n > i;
                }
            ],
            "filter-id->": [
                Ot,
                [
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    var _$r = t.id(), _$n = _$e.value;
                    return (typeof _$r === "undefined" ? "undefined" : (0, $dvYFb._)(_$r)) == (typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n)) && _$r > _$n;
                }
            ],
            "filter-<=": [
                Ot,
                [
                    Lt,
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                    var _$n = t.properties()[_$e.value], i = _$r.value;
                    return (typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n)) == (typeof i === "undefined" ? "undefined" : (0, $dvYFb._)(i)) && _$n <= i;
                }
            ],
            "filter-id-<=": [
                Ot,
                [
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    var _$r = t.id(), _$n = _$e.value;
                    return (typeof _$r === "undefined" ? "undefined" : (0, $dvYFb._)(_$r)) == (typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n)) && _$r <= _$n;
                }
            ],
            "filter->=": [
                Ot,
                [
                    Lt,
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                    var _$n = t.properties()[_$e.value], i = _$r.value;
                    return (typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n)) == (typeof i === "undefined" ? "undefined" : (0, $dvYFb._)(i)) && _$n >= i;
                }
            ],
            "filter-id->=": [
                Ot,
                [
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    var _$r = t.id(), _$n = _$e.value;
                    return (typeof _$r === "undefined" ? "undefined" : (0, $dvYFb._)(_$r)) == (typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n)) && _$r >= _$n;
                }
            ],
            "filter-has": [
                Ot,
                [
                    Ut
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return _$e.value in t.properties();
                }
            ],
            "filter-has-id": [
                Ot,
                [],
                function(t) {
                    return null !== t.id() && void 0 !== t.id();
                }
            ],
            "filter-type-in": [
                Ot,
                [
                    Kt(Lt)
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return _$e.value.indexOf(t.geometryType()) >= 0;
                }
            ],
            "filter-id-in": [
                Ot,
                [
                    Kt(Ut)
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return _$e.value.indexOf(t.id()) >= 0;
                }
            ],
            "filter-in-small": [
                Ot,
                [
                    Lt,
                    Kt(Ut)
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                    return _$r.value.indexOf(t.properties()[_$e.value]) >= 0;
                }
            ],
            "filter-in-large": [
                Ot,
                [
                    Lt,
                    Kt(Ut)
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                    return function(t, e1, r, n) {
                        for(; r <= n;){
                            var i = r + n >> 1;
                            if (e1[i] === t) return !0;
                            e1[i] > t ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    }(t.properties()[_$e.value], _$r.value, 0, _$r.value.length - 1);
                }
            ],
            all: {
                type: Ot,
                overloads: [
                    [
                        [
                            Ot,
                            Ot
                        ],
                        function(t, param) {
                            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                            return _$e.evaluate(t) && _$r.evaluate(t);
                        }
                    ],
                    [
                        Cn(Ot),
                        function(t, e1) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$r = _step.value;
                                    if (!_$r.evaluate(t)) return !1;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: Ot,
                overloads: [
                    [
                        [
                            Ot,
                            Ot
                        ],
                        function(t, param) {
                            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 2), _$e = _param[0], _$r = _param[1];
                            return _$e.evaluate(t) || _$r.evaluate(t);
                        }
                    ],
                    [
                        Cn(Ot),
                        function(t, e1) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$r = _step.value;
                                    if (_$r.evaluate(t)) return !0;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                Ot,
                [
                    Ot
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return !_$e.evaluate(t);
                }
            ],
            "is-supported-script": [
                Ot,
                [
                    Lt
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    var _$r = t.globals && t.globals.isSupportedScript;
                    return !_$r || _$r(_$e.evaluate(t));
                }
            ],
            upcase: [
                Lt,
                [
                    Lt
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return _$e.evaluate(t).toUpperCase();
                }
            ],
            downcase: [
                Lt,
                [
                    Lt
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return _$e.evaluate(t).toLowerCase();
                }
            ],
            concat: [
                Lt,
                Cn(Ut),
                function(t, e1) {
                    return e1.map(function(e1) {
                        return qe(e1.evaluate(t));
                    }).join("");
                }
            ],
            "resolved-locale": [
                Lt,
                [
                    qt
                ],
                function(t, param) {
                    var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 1), _$e = _param[0];
                    return _$e.evaluate(t).resolvedLocale();
                }
            ]
        });
        var ei = /*#__PURE__*/ function() {
            function ei(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ei);
                this.expression = t, this._warningHistory = {}, this._evaluator = new Ke, this._defaultValue = e1 ? function(t) {
                    if ("color" === t.type && Yn(t.default)) return new Te(0, 0, 0, 0);
                    switch(t.type){
                        case "color":
                            return Te.parse(t.default) || null;
                        case "padding":
                            return ze.parse(t.default) || null;
                        case "numberArray":
                            return Pe.parse(t.default) || null;
                        case "colorArray":
                            return Be.parse(t.default) || null;
                        case "variableAnchorOffsetCollection":
                            return Le.parse(t.default) || null;
                        case "projectionDefinition":
                            return Re.parse(t.default) || null;
                        default:
                            return void 0 === t.default ? null : t.default;
                    }
                }(e1) : null, this._enumValues = e1 && "enum" === e1.type ? e1.values : null, this._globalState = r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ei, [
                {
                    key: "evaluateWithoutErrorHandling",
                    value: function evaluateWithoutErrorHandling(t, e1, r, n, i, s) {
                        return this._globalState && (t = ci(t, this._globalState)), this._evaluator.globals = t, this._evaluator.feature = e1, this._evaluator.featureState = r, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this.expression.evaluate(this._evaluator);
                    }
                },
                {
                    key: "evaluate",
                    value: function evaluate(t, e1, r, n, i, s) {
                        this._globalState && (t = ci(t, this._globalState)), this._evaluator.globals = t, this._evaluator.feature = e1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null;
                        try {
                            var _$t = this.expression.evaluate(this._evaluator);
                            if (null == _$t || "number" == typeof _$t && _$t != _$t) return this._defaultValue;
                            if (this._enumValues && !(_$t in this._enumValues)) throw new Ve("Expected value to be one of ".concat(Object.keys(this._enumValues).map(function(t) {
                                return JSON.stringify(t);
                            }).join(", "), ", but found ").concat(JSON.stringify(_$t), " instead."));
                            return _$t;
                        } catch (t) {
                            return this._warningHistory[t.message] || (this._warningHistory[t.message] = !0, "undefined" != typeof console && console.warn(t.message)), this._defaultValue;
                        }
                    }
                }
            ]);
            return ei;
        }();
        function ri(t) {
            return Array.isArray(t) && t.length > 0 && "string" == typeof t[0] && t[0] in Dn;
        }
        function ni(t, e1, r) {
            var _$n = new We(Dn, Ln, [], e1 ? function(t) {
                var _$e = {
                    color: Rt,
                    string: Lt,
                    number: Ct,
                    enum: Lt,
                    boolean: Ot,
                    formatted: jt,
                    padding: Gt,
                    numberArray: Yt,
                    colorArray: Xt,
                    projectionDefinition: Nt,
                    resolvedImage: Zt,
                    variableAnchorOffsetCollection: Ht
                };
                return "array" === t.type ? Kt(_$e[t.value] || Ut, t.length) : _$e[t.type];
            }(e1) : void 0), i = _$n.parse(t, void 0, void 0, void 0, e1 && "string" === e1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return i ? $n(new ei(i, e1, r)) : Un(_$n.errors);
        }
        var ii = /*#__PURE__*/ function() {
            function ii(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ii);
                this.kind = t, this._styleExpression = e1, this.isStateDependent = "constant" !== t && !Rn(e1.expression), this.globalStateRefs = ui(e1.expression), this._globalState = r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ii, [
                {
                    key: "evaluateWithoutErrorHandling",
                    value: function evaluateWithoutErrorHandling(t, e1, r, n, i, s) {
                        return this._globalState && (t = ci(t, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(t, e1, r, n, i, s);
                    }
                },
                {
                    key: "evaluate",
                    value: function evaluate(t, e1, r, n, i, s) {
                        return this._globalState && (t = ci(t, this._globalState)), this._styleExpression.evaluate(t, e1, r, n, i, s);
                    }
                }
            ]);
            return ii;
        }();
        var si = /*#__PURE__*/ function() {
            function si(t, e1, r, n, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, si);
                this.kind = t, this.zoomStops = r, this._styleExpression = e1, this.isStateDependent = "camera" !== t && !Rn(e1.expression), this.globalStateRefs = ui(e1.expression), this.interpolationType = n, this._globalState = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(si, [
                {
                    key: "evaluateWithoutErrorHandling",
                    value: function evaluateWithoutErrorHandling(t, e1, r, n, i, s) {
                        return this._globalState && (t = ci(t, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(t, e1, r, n, i, s);
                    }
                },
                {
                    key: "evaluate",
                    value: function evaluate(t, e1, r, n, i, s) {
                        return this._globalState && (t = ci(t, this._globalState)), this._styleExpression.evaluate(t, e1, r, n, i, s);
                    }
                },
                {
                    key: "interpolationFactor",
                    value: function interpolationFactor(t, e1, r) {
                        return this.interpolationType ? fr.interpolationFactor(this.interpolationType, t, e1, r) : 0;
                    }
                }
            ]);
            return si;
        }();
        function ai(t, e1, r) {
            var _$n = ni(t, e1, r);
            if ("error" === _$n.result) return _$n;
            var i = _$n.value.expression, s = On(i);
            if (!s && !qn(e1)) return Un([
                new Pt("", "data expressions not supported")
            ]);
            var a = Nn(i, [
                "zoom"
            ]);
            if (!a && !jn(e1)) return Un([
                new Pt("", "zoom expressions not supported")
            ]);
            var o = li(i);
            return o || a ? o instanceof Pt ? Un([
                o
            ]) : o instanceof fr && !Gn(e1) ? Un([
                new Pt("", '"interpolate" expressions cannot be used with this property')
            ]) : $n(o ? new si(s ? "camera" : "composite", _$n.value, o.labels, o instanceof fr ? o.interpolation : void 0, r) : new ii(s ? "constant" : "source", _$n.value, r)) : Un([
                new Pt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
            ]);
        }
        var oi = /*#__PURE__*/ function() {
            function oi(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, oi);
                this._parameters = t, this._specification = e1, zt(this, Hn(this._parameters, this._specification));
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(oi, null, [
                {
                    key: "deserialize",
                    value: function deserialize(t) {
                        return new oi(t._parameters, t._specification);
                    }
                },
                {
                    key: "serialize",
                    value: function serialize(t) {
                        return {
                            _parameters: t._parameters,
                            _specification: t._specification
                        };
                    }
                }
            ]);
            return oi;
        }();
        function li(t) {
            var _$e = null;
            if (t instanceof Je) _$e = li(t.result);
            else if (t instanceof mr) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t.args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$r = _step.value;
                        if (_$e = li(_$r), _$e) break;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else (t instanceof or || t instanceof fr) && t.input instanceof zn && "zoom" === t.input.name && (_$e = t);
            return _$e instanceof Pt || t.eachChild(function(t) {
                var _$r = li(t);
                _$r instanceof Pt ? _$e = _$r : !_$e && _$r ? _$e = new Pt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : _$e && _$r && _$e !== _$r && (_$e = new Pt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), _$e;
        }
        function ui(t) {
            var _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Set;
            return t instanceof Fn && _$e.add(t.key), t.eachChild(function(t) {
                ui(t, _$e);
            }), _$e;
        }
        function ci(t, e1) {
            var _ref = null != t ? t : {}, _$r = _ref.zoom, _$n = _ref.heatmapDensity, i = _ref.elevation, s = _ref.lineProgress, a = _ref.isSupportedScript, o = _ref.accumulated;
            return {
                zoom: _$r,
                heatmapDensity: _$n,
                elevation: i,
                lineProgress: s,
                isSupportedScript: a,
                accumulated: o,
                globalState: e1
            };
        }
        function hi(t) {
            if (!0 === t || !1 === t) return !0;
            if (!Array.isArray(t) || 0 === t.length) return !1;
            switch(t[0]){
                case "has":
                    return t.length >= 2 && "$id" !== t[1] && "$type" !== t[1];
                case "in":
                    return t.length >= 3 && ("string" != typeof t[1] || Array.isArray(t[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== t.length || Array.isArray(t[1]) || Array.isArray(t[2]);
                case "any":
                case "all":
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = t.slice(1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            if (!hi(_$e) && "boolean" != typeof _$e) return !1;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return !0;
                default:
                    return !0;
            }
        }
        var pi = {
            type: "boolean",
            default: !1,
            transition: !1,
            "property-type": "data-driven",
            expression: {
                interpolated: !1,
                parameters: [
                    "zoom",
                    "feature"
                ]
            }
        };
        function fi(t, e1) {
            if (null == t) return {
                filter: function() {
                    return !0;
                },
                needGeometry: !1,
                getGlobalStateRefs: function() {
                    return new Set;
                }
            };
            hi(t) || (t = mi(t));
            var _$r = ni(t, pi, e1);
            if ("error" === _$r.result) throw new Error(_$r.value.map(function(t) {
                return "".concat(t.key, ": ").concat(t.message);
            }).join(", "));
            return {
                filter: function(t, e1, n) {
                    return _$r.value.evaluate(t, e1, {}, n);
                },
                needGeometry: yi(t),
                getGlobalStateRefs: function() {
                    return ui(_$r.value.expression);
                }
            };
        }
        function di(t, e1) {
            return t < e1 ? -1 : t > e1 ? 1 : 0;
        }
        function yi(t) {
            if (!Array.isArray(t)) return !1;
            if ("within" === t[0] || "distance" === t[0]) return !0;
            for(var _$e = 1; _$e < t.length; _$e++)if (yi(t[_$e])) return !0;
            return !1;
        }
        function mi(t) {
            if (!t) return !0;
            var _$e = t[0];
            var _$r;
            return t.length <= 1 ? "any" !== _$e : "==" === _$e ? gi(t[1], t[2], "==") : "!=" === _$e ? bi(gi(t[1], t[2], "==")) : "<" === _$e || ">" === _$e || "<=" === _$e || ">=" === _$e ? gi(t[1], t[2], _$e) : "any" === _$e ? (_$r = t.slice(1), [
                "any"
            ].concat(_$r.map(mi))) : "all" === _$e ? [
                "all"
            ].concat(t.slice(1).map(mi)) : "none" === _$e ? [
                "all"
            ].concat(t.slice(1).map(mi).map(bi)) : "in" === _$e ? xi(t[1], t.slice(2)) : "!in" === _$e ? bi(xi(t[1], t.slice(2))) : "has" === _$e ? vi(t[1]) : "!has" !== _$e || bi(vi(t[1]));
        }
        function gi(t, e1, r) {
            switch(t){
                case "$type":
                    return [
                        "filter-type-".concat(r),
                        e1
                    ];
                case "$id":
                    return [
                        "filter-id-".concat(r),
                        e1
                    ];
                default:
                    return [
                        "filter-".concat(r),
                        t,
                        e1
                    ];
            }
        }
        function xi(t, e1) {
            if (0 === e1.length) return !1;
            switch(t){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            e1
                        ]
                    ];
                default:
                    return e1.length > 200 && !e1.some(function(t) {
                        return (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t)) != (0, $dvYFb._)(e1[0]);
                    }) ? [
                        "filter-in-large",
                        t,
                        [
                            "literal",
                            e1.sort(di)
                        ]
                    ] : [
                        "filter-in-small",
                        t,
                        [
                            "literal",
                            e1
                        ]
                    ];
            }
        }
        function vi(t) {
            switch(t){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        t
                    ];
            }
        }
        function bi(t) {
            return [
                "!",
                t
            ];
        }
        function wi(t) {
            var _$e = typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t);
            if ("number" === _$e || "boolean" === _$e || "string" === _$e || null == t) return JSON.stringify(t);
            if (Array.isArray(t)) {
                var _$e1 = "[";
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$r = _step.value;
                        _$e1 += "".concat(wi(_$r), ",");
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return "".concat(_$e1, "]");
            }
            var _$r1 = Object.keys(t).sort();
            var _$n = "{";
            for(var _$e2 = 0; _$e2 < _$r1.length; _$e2++)_$n += "".concat(JSON.stringify(_$r1[_$e2]), ":").concat(wi(t[_$r1[_$e2]]), ",");
            return "".concat(_$n, "}");
        }
        function _i(t) {
            var _$e = "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = bt[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$r = _step.value;
                    _$e += "/".concat(wi(t[_$r]));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return _$e;
        }
        function Si(t) {
            var _$e = t.value;
            return _$e ? [
                new Dt(t.key, _$e, "constants have been deprecated as of v8")
            ] : [];
        }
        function Ai(t) {
            return t instanceof Number || t instanceof String || t instanceof Boolean ? t.valueOf() : t;
        }
        function ki(t) {
            if (Array.isArray(t)) return t.map(ki);
            if (t instanceof Object && !(t instanceof Number || t instanceof String || t instanceof Boolean)) {
                var _$e = {};
                for(var _$r in t)_$e[_$r] = ki(t[_$r]);
                return _$e;
            }
            return Ai(t);
        }
        function Ei(t) {
            var _$e = t.key, _$r = t.value, _$n = t.valueSpec || {}, i = t.objectElementValidators || {}, s = t.style, a = t.styleSpec, o = t.validateSpec;
            var l = [];
            var u = Xn(_$r);
            if ("object" !== u) return [
                new Dt(_$e, _$r, "object expected, ".concat(u, " found"))
            ];
            for(var _$t in _$r){
                var u1 = _$t.split(".")[0], _$c = ve(_$n, u1) || _$n["*"];
                var _$h = void 0;
                if (ve(i, u1)) _$h = i[u1];
                else if (ve(_$n, u1)) {
                    if (void 0 === _$r[_$t]) continue;
                    _$h = o;
                } else if (i["*"]) _$h = i["*"];
                else {
                    if (!_$n["*"]) {
                        l.push(new Dt(_$e, _$r[_$t], 'unknown property "'.concat(_$t, '"')));
                        continue;
                    }
                    _$h = o;
                }
                l = l.concat(_$h({
                    key: (_$e ? "".concat(_$e, ".") : _$e) + _$t,
                    value: _$r[_$t],
                    valueSpec: _$c,
                    style: s,
                    styleSpec: a,
                    object: _$r,
                    objectKey: _$t,
                    validateSpec: o
                }, _$r));
            }
            for(var _$t1 in _$n)i[_$t1] || _$n[_$t1].required && void 0 === _$n[_$t1].default && void 0 === _$r[_$t1] && l.push(new Dt(_$e, _$r, 'missing required property "'.concat(_$t1, '"')));
            return l;
        }
        function Ti(t) {
            var _$e = t.value, _$r = t.valueSpec, _$n = t.style, i = t.styleSpec, s = t.key, a = t.arrayElementValidator || t.validateSpec;
            if ("array" !== Xn(_$e)) return [
                new Dt(s, _$e, "array expected, ".concat(Xn(_$e), " found"))
            ];
            if (_$r.length && _$e.length !== _$r.length) return [
                new Dt(s, _$e, "array length ".concat(_$r.length, " expected, length ").concat(_$e.length, " found"))
            ];
            var o = {
                type: _$r.value,
                values: _$r.values
            };
            i.$version < 7 && (o.function = _$r.function), "object" === Xn(_$r.value) && (o = _$r.value);
            var l = [];
            for(var _$r1 = 0; _$r1 < _$e.length; _$r1++)l = l.concat(a({
                array: _$e,
                arrayIndex: _$r1,
                value: _$e[_$r1],
                valueSpec: o,
                validateSpec: t.validateSpec,
                style: _$n,
                styleSpec: i,
                key: "".concat(s, "[").concat(_$r1, "]")
            }));
            return l;
        }
        function Ii(t) {
            var _$e = t.key, _$r = t.value, _$n = t.valueSpec;
            var i = Xn(_$r);
            return "number" === i && _$r != _$r && (i = "NaN"), "number" !== i ? [
                new Dt(_$e, _$r, "number expected, ".concat(i, " found"))
            ] : "minimum" in _$n && _$r < _$n.minimum ? [
                new Dt(_$e, _$r, "".concat(_$r, " is less than the minimum value ").concat(_$n.minimum))
            ] : "maximum" in _$n && _$r > _$n.maximum ? [
                new Dt(_$e, _$r, "".concat(_$r, " is greater than the maximum value ").concat(_$n.maximum))
            ] : [];
        }
        function Mi(t) {
            var _$e = t.valueSpec, _$r = Ai(t.value.type);
            var _$n, i, s, a = {};
            var o = "categorical" !== _$r && void 0 === t.value.property, l = !o, u = "array" === Xn(t.value.stops) && "array" === Xn(t.value.stops[0]) && "object" === Xn(t.value.stops[0][0]), _$c = Ei({
                key: t.key,
                value: t.value,
                valueSpec: t.styleSpec.function,
                validateSpec: t.validateSpec,
                style: t.style,
                styleSpec: t.styleSpec,
                objectElementValidators: {
                    stops: function stops(t) {
                        if ("identity" === _$r) return [
                            new Dt(t.key, t.value, 'identity function may not have a "stops" property')
                        ];
                        var _$e = [];
                        var _$n = t.value;
                        return _$e = _$e.concat(Ti({
                            key: t.key,
                            value: _$n,
                            valueSpec: t.valueSpec,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            arrayElementValidator: h
                        })), "array" === Xn(_$n) && 0 === _$n.length && _$e.push(new Dt(t.key, _$n, "array must have at least one stop")), _$e;
                    },
                    default: function _default(t) {
                        return t.validateSpec({
                            key: t.key,
                            value: t.value,
                            valueSpec: _$e,
                            validateSpec: t.validateSpec,
                            style: t.style,
                            styleSpec: t.styleSpec
                        });
                    }
                }
            });
            return "identity" === _$r && o && _$c.push(new Dt(t.key, t.value, 'missing required property "property"')), "identity" === _$r || t.value.stops || _$c.push(new Dt(t.key, t.value, 'missing required property "stops"')), "exponential" === _$r && t.valueSpec.expression && !Gn(t.valueSpec) && _$c.push(new Dt(t.key, t.value, "exponential functions not supported")), t.styleSpec.$version >= 8 && (l && !qn(t.valueSpec) ? _$c.push(new Dt(t.key, t.value, "property functions not supported")) : o && !jn(t.valueSpec) && _$c.push(new Dt(t.key, t.value, "zoom functions not supported"))), "categorical" !== _$r && !u || void 0 !== t.value.property || _$c.push(new Dt(t.key, t.value, '"property" property is required')), _$c;
            function h(t) {
                var _$r = [];
                var _$n = t.value, o = t.key;
                if ("array" !== Xn(_$n)) return [
                    new Dt(o, _$n, "array expected, ".concat(Xn(_$n), " found"))
                ];
                if (2 !== _$n.length) return [
                    new Dt(o, _$n, "array length 2 expected, length ".concat(_$n.length, " found"))
                ];
                if (u) {
                    if ("object" !== Xn(_$n[0])) return [
                        new Dt(o, _$n, "object expected, ".concat(Xn(_$n[0]), " found"))
                    ];
                    if (void 0 === _$n[0].zoom) return [
                        new Dt(o, _$n, "object stop key must have zoom")
                    ];
                    if (void 0 === _$n[0].value) return [
                        new Dt(o, _$n, "object stop key must have value")
                    ];
                    if (s && s > Ai(_$n[0].zoom)) return [
                        new Dt(o, _$n[0].zoom, "stop zoom values must appear in ascending order")
                    ];
                    Ai(_$n[0].zoom) !== s && (s = Ai(_$n[0].zoom), i = void 0, a = {}), _$r = _$r.concat(Ei({
                        key: "".concat(o, "[0]"),
                        value: _$n[0],
                        valueSpec: {
                            zoom: {}
                        },
                        validateSpec: t.validateSpec,
                        style: t.style,
                        styleSpec: t.styleSpec,
                        objectElementValidators: {
                            zoom: Ii,
                            value: p
                        }
                    }));
                } else _$r = _$r.concat(p({
                    key: "".concat(o, "[0]"),
                    value: _$n[0],
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }, _$n));
                return ri(ki(_$n[1])) ? _$r.concat([
                    new Dt("".concat(o, "[1]"), _$n[1], "expressions are not allowed in function stops.")
                ]) : _$r.concat(t.validateSpec({
                    key: "".concat(o, "[1]"),
                    value: _$n[1],
                    valueSpec: _$e,
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: t.styleSpec
                }));
            }
            function p(t, s) {
                var o = Xn(t.value), l = Ai(t.value), u = null !== t.value ? t.value : s;
                if (_$n) {
                    if (o !== _$n) return [
                        new Dt(t.key, u, "".concat(o, " stop domain type must match previous stop domain type ").concat(_$n))
                    ];
                } else _$n = o;
                if ("number" !== o && "string" !== o && "boolean" !== o) return [
                    new Dt(t.key, u, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== _$r) {
                    var _$n1 = "number expected, ".concat(o, " found");
                    return qn(_$e) && void 0 === _$r && (_$n1 += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new Dt(t.key, u, _$n1)
                    ];
                }
                return "categorical" !== _$r || "number" !== o || isFinite(l) && Math.floor(l) === l ? "categorical" !== _$r && "number" === o && void 0 !== i && l < i ? [
                    new Dt(t.key, u, "stop domain values must appear in ascending order")
                ] : (i = l, "categorical" === _$r && l in a ? [
                    new Dt(t.key, u, "stop domain values must be unique")
                ] : (a[l] = !0, [])) : [
                    new Dt(t.key, u, "integer expected, found ".concat(l))
                ];
            }
        }
        function Fi(t) {
            var _$e = ("property" === t.expressionContext ? ai : ni)(ki(t.value), t.valueSpec);
            if ("error" === _$e.result) return _$e.value.map(function(e1) {
                return new Dt("".concat(t.key).concat(e1.key), t.value, e1.message);
            });
            var _$r = _$e.value.expression || _$e.value._styleExpression.expression;
            if ("property" === t.expressionContext && "text-font" === t.propertyKey && !_$r.outputDefined()) return [
                new Dt(t.key, t.value, 'Invalid data expression for "'.concat(t.propertyKey, '". Output values must be contained as literals within the expression.'))
            ];
            if ("property" === t.expressionContext && "layout" === t.propertyType && !Rn(_$r)) return [
                new Dt(t.key, t.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t.expressionContext && !Rn(_$r)) return [
                new Dt(t.key, t.value, '"feature-state" data expressions are not supported with filters.')
            ];
            if (t.expressionContext && 0 === t.expressionContext.indexOf("cluster")) {
                if (!Nn(_$r, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new Dt(t.key, t.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t.expressionContext && !On(_$r)) return [
                    new Dt(t.key, t.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function Di(t) {
            var _$e = t.key, _$r = t.value, _$n = Xn(_$r);
            return "string" !== _$n ? [
                new Dt(_$e, _$r, "color expected, ".concat(_$n, " found"))
            ] : Te.parse(String(_$r)) ? [] : [
                new Dt(_$e, _$r, 'color expected, "'.concat(_$r, '" found'))
            ];
        }
        function zi(t) {
            var _$e = t.key, _$r = t.value, _$n = t.valueSpec, i = [];
            return Array.isArray(_$n.values) ? -1 === _$n.values.indexOf(Ai(_$r)) && i.push(new Dt(_$e, _$r, "expected one of [".concat(_$n.values.join(", "), "], ").concat(JSON.stringify(_$r), " found"))) : -1 === Object.keys(_$n.values).indexOf(Ai(_$r)) && i.push(new Dt(_$e, _$r, "expected one of [".concat(Object.keys(_$n.values).join(", "), "], ").concat(JSON.stringify(_$r), " found"))), i;
        }
        function Pi(t) {
            return hi(ki(t.value)) ? Fi(zt({}, t, {
                expressionContext: "filter",
                valueSpec: {
                    value: "boolean"
                }
            })) : Bi(t);
        }
        function Bi(t) {
            var _$e = t.value, _$r = t.key;
            if ("array" !== Xn(_$e)) return [
                new Dt(_$r, _$e, "array expected, ".concat(Xn(_$e), " found"))
            ];
            var _$n = t.styleSpec;
            var i, s = [];
            if (_$e.length < 1) return [
                new Dt(_$r, _$e, "filter array must have at least 1 element")
            ];
            switch(s = s.concat(zi({
                key: "".concat(_$r, "[0]"),
                value: _$e[0],
                valueSpec: _$n.filter_operator,
                style: t.style,
                styleSpec: t.styleSpec
            })), Ai(_$e[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    _$e.length >= 2 && "$type" === Ai(_$e[1]) && s.push(new Dt(_$r, _$e, '"$type" cannot be use with operator "'.concat(_$e[0], '"')));
                case "==":
                case "!=":
                    3 !== _$e.length && s.push(new Dt(_$r, _$e, 'filter array for operator "'.concat(_$e[0], '" must have 3 elements')));
                case "in":
                case "!in":
                    _$e.length >= 2 && (i = Xn(_$e[1]), "string" !== i && s.push(new Dt("".concat(_$r, "[1]"), _$e[1], "string expected, ".concat(i, " found"))));
                    for(var a = 2; a < _$e.length; a++)i = Xn(_$e[a]), "$type" === Ai(_$e[1]) ? s = s.concat(zi({
                        key: "".concat(_$r, "[").concat(a, "]"),
                        value: _$e[a],
                        valueSpec: _$n.geometry_type,
                        style: t.style,
                        styleSpec: t.styleSpec
                    })) : "string" !== i && "number" !== i && "boolean" !== i && s.push(new Dt("".concat(_$r, "[").concat(a, "]"), _$e[a], "string, number, or boolean expected, ".concat(i, " found")));
                    break;
                case "any":
                case "all":
                case "none":
                    for(var _$n1 = 1; _$n1 < _$e.length; _$n1++)s = s.concat(Bi({
                        key: "".concat(_$r, "[").concat(_$n1, "]"),
                        value: _$e[_$n1],
                        style: t.style,
                        styleSpec: t.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    i = Xn(_$e[1]), 2 !== _$e.length ? s.push(new Dt(_$r, _$e, 'filter array for "'.concat(_$e[0], '" operator must have 2 elements'))) : "string" !== i && s.push(new Dt("".concat(_$r, "[1]"), _$e[1], "string expected, ".concat(i, " found")));
            }
            return s;
        }
        function Vi(t, e1) {
            var _$r = t.key, _$n = t.validateSpec, i = t.style, s = t.styleSpec, a = t.value, o = t.objectKey, l = s["".concat(e1, "_").concat(t.layerType)];
            if (!l) return [];
            var u = o.match(/^(.*)-transition$/);
            if ("paint" === e1 && u && l[u[1]] && l[u[1]].transition) return _$n({
                key: _$r,
                value: a,
                valueSpec: s.transition,
                style: i,
                styleSpec: s
            });
            var _$c = t.valueSpec || l[o];
            if (!_$c) return [
                new Dt(_$r, a, 'unknown property "'.concat(o, '"'))
            ];
            var _$h;
            if ("string" === Xn(a) && qn(_$c) && !_$c.tokens && (_$h = /^{([^}]+)}$/.exec(a))) return [
                new Dt(_$r, a, '"'.concat(o, '" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": ').concat(JSON.stringify(_$h[1]), " }`."))
            ];
            var p = [];
            return "symbol" === t.layerType && "text-font" === o && Yn(ki(a)) && "identity" === Ai(a.type) && p.push(new Dt(_$r, a, '"text-font" does not support identity functions')), p.concat(_$n({
                key: t.key,
                value: a,
                valueSpec: _$c,
                style: i,
                styleSpec: s,
                expressionContext: "property",
                propertyType: e1,
                propertyKey: o
            }));
        }
        function Ci(t) {
            return Vi(t, "paint");
        }
        function Li(t) {
            return Vi(t, "layout");
        }
        function Oi(t) {
            var _$e = [];
            var _$r = t.value, _$n = t.key, i = t.style, s = t.styleSpec;
            if ("object" !== Xn(_$r)) return [
                new Dt(_$n, _$r, "object expected, ".concat(Xn(_$r), " found"))
            ];
            _$r.type || _$r.ref || _$e.push(new Dt(_$n, _$r, 'either "type" or "ref" is required'));
            var a = Ai(_$r.type);
            var o = Ai(_$r.ref);
            if (_$r.id) {
                var s1 = Ai(_$r.id);
                for(var a1 = 0; a1 < t.arrayIndex; a1++){
                    var _$t = i.layers[a1];
                    Ai(_$t.id) === s1 && _$e.push(new Dt(_$n, _$r.id, 'duplicate layer id "'.concat(_$r.id, '", previously used at line ').concat(_$t.id.__line__)));
                }
            }
            if ("ref" in _$r) {
                var _$t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach(function(t) {
                    t in _$r && _$e.push(new Dt(_$n, _$r[t], '"'.concat(t, '" is prohibited for ref layers')));
                }), i.layers.forEach(function(e1) {
                    Ai(e1.id) === o && (_$t1 = e1);
                }), _$t1 ? _$t1.ref ? _$e.push(new Dt(_$n, _$r.ref, "ref cannot reference another ref layer")) : a = Ai(_$t1.type) : _$e.push(new Dt(_$n, _$r.ref, 'ref layer "'.concat(o, '" not found')));
            } else if ("background" !== a) {
                if (_$r.source) {
                    var _$t2 = i.sources && i.sources[_$r.source], s2 = _$t2 && Ai(_$t2.type);
                    _$t2 ? "vector" === s2 && "raster" === a ? _$e.push(new Dt(_$n, _$r.source, 'layer "'.concat(_$r.id, '" requires a raster source'))) : "raster-dem" !== s2 && "hillshade" === a || "raster-dem" !== s2 && "color-relief" === a ? _$e.push(new Dt(_$n, _$r.source, 'layer "'.concat(_$r.id, '" requires a raster-dem source'))) : "raster" === s2 && "raster" !== a ? _$e.push(new Dt(_$n, _$r.source, 'layer "'.concat(_$r.id, '" requires a vector source'))) : "vector" !== s2 || _$r["source-layer"] ? "raster-dem" === s2 && "hillshade" !== a && "color-relief" !== a ? _$e.push(new Dt(_$n, _$r.source, "raster-dem source can only be used with layer type 'hillshade' or 'color-relief'.")) : "line" !== a || !_$r.paint || !_$r.paint["line-gradient"] || "geojson" === s2 && _$t2.lineMetrics || _$e.push(new Dt(_$n, _$r, 'layer "'.concat(_$r.id, '" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.'))) : _$e.push(new Dt(_$n, _$r, 'layer "'.concat(_$r.id, '" must specify a "source-layer"'))) : _$e.push(new Dt(_$n, _$r.source, 'source "'.concat(_$r.source, '" not found')));
                } else _$e.push(new Dt(_$n, _$r, 'missing required property "source"'));
            }
            return _$e = _$e.concat(Ei({
                key: _$n,
                value: _$r,
                valueSpec: s.layer,
                style: t.style,
                styleSpec: t.styleSpec,
                validateSpec: t.validateSpec,
                objectElementValidators: {
                    "*": function() {
                        return [];
                    },
                    type: function() {
                        return t.validateSpec({
                            key: "".concat(_$n, ".type"),
                            value: _$r.type,
                            valueSpec: s.layer.type,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            object: _$r,
                            objectKey: "type"
                        });
                    },
                    filter: Pi,
                    layout: function(t) {
                        return Ei({
                            layer: _$r,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": function(t) {
                                    return Li(zt({
                                        layerType: a
                                    }, t));
                                }
                            }
                        });
                    },
                    paint: function(t) {
                        return Ei({
                            layer: _$r,
                            key: t.key,
                            value: t.value,
                            style: t.style,
                            styleSpec: t.styleSpec,
                            validateSpec: t.validateSpec,
                            objectElementValidators: {
                                "*": function(t) {
                                    return Ci(zt({
                                        layerType: a
                                    }, t));
                                }
                            }
                        });
                    }
                }
            })), _$e;
        }
        function Ri(t) {
            var _$e = t.value, _$r = t.key, _$n = Xn(_$e);
            return "string" !== _$n ? [
                new Dt(_$r, _$e, "string expected, ".concat(_$n, " found"))
            ] : [];
        }
        var Ni = {
            promoteId: function promoteId(param) {
                var _$t = param.key, _$e = param.value;
                if ("string" === Xn(_$e)) return Ri({
                    key: _$t,
                    value: _$e
                });
                {
                    var _r;
                    var _$r = [];
                    for(var _$n in _$e)(_r = _$r).push.apply(_r, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(Ri({
                        key: "".concat(_$t, ".").concat(_$n),
                        value: _$e[_$n]
                    })));
                    return _$r;
                }
            }
        };
        function $i(t) {
            var _$e = t.value, _$r = t.key, _$n = t.styleSpec, i = t.style, s = t.validateSpec;
            if (!_$e.type) return [
                new Dt(_$r, _$e, '"type" is required')
            ];
            var a = Ai(_$e.type);
            var o;
            switch(a){
                case "vector":
                case "raster":
                    return o = Ei({
                        key: _$r,
                        value: _$e,
                        valueSpec: _$n["source_".concat(a.replace("-", "_"))],
                        style: t.style,
                        styleSpec: _$n,
                        objectElementValidators: Ni,
                        validateSpec: s
                    }), o;
                case "raster-dem":
                    return o = function(t) {
                        var _$e;
                        var _$r = null !== (_$e = t.sourceName) && void 0 !== _$e ? _$e : "", _$n = t.value, i = t.styleSpec, s = i.source_raster_dem, a = t.style;
                        var o = [];
                        var l = Xn(_$n);
                        if (void 0 === _$n) return o;
                        if ("object" !== l) return o.push(new Dt("source_raster_dem", _$n, "object expected, ".concat(l, " found"))), o;
                        var u = "custom" === Ai(_$n.encoding), _$c = [
                            "redFactor",
                            "greenFactor",
                            "blueFactor",
                            "baseShift"
                        ], _$h = t.value.encoding ? '"'.concat(t.value.encoding, '"') : "Default";
                        for(var _$e1 in _$n)!u && _$c.includes(_$e1) ? o.push(new Dt(_$e1, _$n[_$e1], 'In "'.concat(_$r, '": "').concat(_$e1, '" is only valid when "encoding" is set to "custom". ').concat(_$h, " encoding found"))) : s[_$e1] ? o = o.concat(t.validateSpec({
                            key: _$e1,
                            value: _$n[_$e1],
                            valueSpec: s[_$e1],
                            validateSpec: t.validateSpec,
                            style: a,
                            styleSpec: i
                        })) : o.push(new Dt(_$e1, _$n[_$e1], 'unknown property "'.concat(_$e1, '"')));
                        return o;
                    }({
                        sourceName: _$r,
                        value: _$e,
                        style: t.style,
                        styleSpec: _$n,
                        validateSpec: s
                    }), o;
                case "geojson":
                    if (o = Ei({
                        key: _$r,
                        value: _$e,
                        valueSpec: _$n.source_geojson,
                        style: i,
                        styleSpec: _$n,
                        validateSpec: s,
                        objectElementValidators: Ni
                    }), _$e.cluster) for(var _$t in _$e.clusterProperties){
                        var _o, _o1;
                        var _e_clusterProperties_t = (0, $db95b225ee8036d6$export$71511d61b312f219)(_$e.clusterProperties[_$t], 2), _$n1 = _e_clusterProperties_t[0], i1 = _e_clusterProperties_t[1], s1 = "string" == typeof _$n1 ? [
                            _$n1,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                _$t
                            ]
                        ] : _$n1;
                        (_o = o).push.apply(_o, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(Fi({
                            key: "".concat(_$r, ".").concat(_$t, ".map"),
                            value: i1,
                            expressionContext: "cluster-map"
                        }))), (_o1 = o).push.apply(_o1, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(Fi({
                            key: "".concat(_$r, ".").concat(_$t, ".reduce"),
                            value: s1,
                            expressionContext: "cluster-reduce"
                        })));
                    }
                    return o;
                case "video":
                    return Ei({
                        key: _$r,
                        value: _$e,
                        valueSpec: _$n.source_video,
                        style: i,
                        validateSpec: s,
                        styleSpec: _$n
                    });
                case "image":
                    return Ei({
                        key: _$r,
                        value: _$e,
                        valueSpec: _$n.source_image,
                        style: i,
                        validateSpec: s,
                        styleSpec: _$n
                    });
                case "canvas":
                    return [
                        new Dt(_$r, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return zi({
                        key: "".concat(_$r, ".type"),
                        value: _$e.type,
                        valueSpec: {
                            values: [
                                "vector",
                                "raster",
                                "raster-dem",
                                "geojson",
                                "video",
                                "image"
                            ]
                        }
                    });
            }
        }
        function Ui(t) {
            var _$e = t.value, _$r = t.styleSpec, _$n = _$r.light, i = t.style;
            var s = [];
            var a = Xn(_$e);
            if (void 0 === _$e) return s;
            if ("object" !== a) return s = s.concat([
                new Dt("light", _$e, "object expected, ".concat(a, " found"))
            ]), s;
            for(var a1 in _$e){
                var o = a1.match(/^(.*)-transition$/);
                s = s.concat(o && _$n[o[1]] && _$n[o[1]].transition ? t.validateSpec({
                    key: a1,
                    value: _$e[a1],
                    valueSpec: _$r.transition,
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: _$r
                }) : _$n[a1] ? t.validateSpec({
                    key: a1,
                    value: _$e[a1],
                    valueSpec: _$n[a1],
                    validateSpec: t.validateSpec,
                    style: i,
                    styleSpec: _$r
                }) : [
                    new Dt(a1, _$e[a1], 'unknown property "'.concat(a1, '"'))
                ]);
            }
            return s;
        }
        function qi(t) {
            var _$e = t.value, _$r = t.styleSpec, _$n = _$r.sky, i = t.style, s = Xn(_$e);
            if (void 0 === _$e) return [];
            if ("object" !== s) return [
                new Dt("sky", _$e, "object expected, ".concat(s, " found"))
            ];
            var a = [];
            for(var s1 in _$e)a = a.concat(_$n[s1] ? t.validateSpec({
                key: s1,
                value: _$e[s1],
                valueSpec: _$n[s1],
                style: i,
                styleSpec: _$r
            }) : [
                new Dt(s1, _$e[s1], 'unknown property "'.concat(s1, '"'))
            ]);
            return a;
        }
        function ji(t) {
            var _$e = t.value, _$r = t.styleSpec, _$n = _$r.terrain, i = t.style;
            var s = [];
            var a = Xn(_$e);
            if (void 0 === _$e) return s;
            if ("object" !== a) return s = s.concat([
                new Dt("terrain", _$e, "object expected, ".concat(a, " found"))
            ]), s;
            for(var a1 in _$e)s = s.concat(_$n[a1] ? t.validateSpec({
                key: a1,
                value: _$e[a1],
                valueSpec: _$n[a1],
                validateSpec: t.validateSpec,
                style: i,
                styleSpec: _$r
            }) : [
                new Dt(a1, _$e[a1], 'unknown property "'.concat(a1, '"'))
            ]);
            return s;
        }
        function Gi(t) {
            var _$e = [];
            var _$r = t.value, _$n = t.key;
            if (Array.isArray(_$r)) {
                var i = [], s = [];
                for(var a in _$r)_$r[a].id && i.includes(_$r[a].id) && _$e.push(new Dt(_$n, _$r, "all the sprites' ids must be unique, but ".concat(_$r[a].id, " is duplicated"))), i.push(_$r[a].id), _$r[a].url && s.includes(_$r[a].url) && _$e.push(new Dt(_$n, _$r, "all the sprites' URLs must be unique, but ".concat(_$r[a].url, " is duplicated"))), s.push(_$r[a].url), _$e = _$e.concat(Ei({
                    key: "".concat(_$n, "[").concat(a, "]"),
                    value: _$r[a],
                    valueSpec: {
                        id: {
                            type: "string",
                            required: !0
                        },
                        url: {
                            type: "string",
                            required: !0
                        }
                    },
                    validateSpec: t.validateSpec
                }));
                return _$e;
            }
            return Ri({
                key: _$n,
                value: _$r
            });
        }
        function Xi(t) {
            return Boolean(t) && t.constructor === Object;
        }
        function Yi(t) {
            return Xi(t.value) ? [] : [
                new Dt(t.key, t.value, "object expected, ".concat(Xn(t.value), " found"))
            ];
        }
        var Zi = {
            "*": function() {
                return [];
            },
            array: Ti,
            boolean: function boolean(t) {
                var _$e = t.value, _$r = t.key, _$n = Xn(_$e);
                return "boolean" !== _$n ? [
                    new Dt(_$r, _$e, "boolean expected, ".concat(_$n, " found"))
                ] : [];
            },
            number: Ii,
            color: Di,
            constants: Si,
            enum: zi,
            filter: Pi,
            function: Mi,
            layer: Oi,
            object: Ei,
            source: $i,
            light: Ui,
            sky: qi,
            terrain: ji,
            projection: function projection(t) {
                var _$e = t.value, _$r = t.styleSpec, _$n = _$r.projection, i = t.style, s = Xn(_$e);
                if (void 0 === _$e) return [];
                if ("object" !== s) return [
                    new Dt("projection", _$e, "object expected, ".concat(s, " found"))
                ];
                var a = [];
                for(var s1 in _$e)a = a.concat(_$n[s1] ? t.validateSpec({
                    key: s1,
                    value: _$e[s1],
                    valueSpec: _$n[s1],
                    style: i,
                    styleSpec: _$r
                }) : [
                    new Dt(s1, _$e[s1], 'unknown property "'.concat(s1, '"'))
                ]);
                return a;
            },
            projectionDefinition: function projectionDefinition(t) {
                var _$e = t.key;
                var _$r = t.value;
                _$r = _$r instanceof String ? _$r.valueOf() : _$r;
                var _$n = Xn(_$r);
                return "array" !== _$n || function(t) {
                    return Array.isArray(t) && 3 === t.length && "string" == typeof t[0] && "string" == typeof t[1] && "number" == typeof t[2];
                }(_$r) || function(t) {
                    return !![
                        "interpolate",
                        "step",
                        "literal"
                    ].includes(t[0]);
                }(_$r) ? [
                    "array",
                    "string"
                ].includes(_$n) ? [] : [
                    new Dt(_$e, _$r, 'projection expected, invalid type "'.concat(_$n, '" found'))
                ] : [
                    new Dt(_$e, _$r, "projection expected, invalid array ".concat(JSON.stringify(_$r), " found"))
                ];
            },
            string: Ri,
            formatted: function formatted(t) {
                return 0 === Ri(t).length ? [] : Fi(t);
            },
            resolvedImage: function resolvedImage(t) {
                return 0 === Ri(t).length ? [] : Fi(t);
            },
            padding: function padding(t) {
                var _$e = t.key, _$r = t.value;
                if ("array" === Xn(_$r)) {
                    if (_$r.length < 1 || _$r.length > 4) return [
                        new Dt(_$e, _$r, "padding requires 1 to 4 values; ".concat(_$r.length, " values found"))
                    ];
                    var _$n = {
                        type: "number"
                    };
                    var i = [];
                    for(var s = 0; s < _$r.length; s++)i = i.concat(t.validateSpec({
                        key: "".concat(_$e, "[").concat(s, "]"),
                        value: _$r[s],
                        validateSpec: t.validateSpec,
                        valueSpec: _$n
                    }));
                    return i;
                }
                return Ii({
                    key: _$e,
                    value: _$r,
                    valueSpec: {}
                });
            },
            numberArray: function numberArray(t) {
                var _$e = t.key, _$r = t.value;
                if ("array" === Xn(_$r)) {
                    var _$n = {
                        type: "number"
                    };
                    if (_$r.length < 1) return [
                        new Dt(_$e, _$r, "array length at least 1 expected, length 0 found")
                    ];
                    var i = [];
                    for(var s = 0; s < _$r.length; s++)i = i.concat(t.validateSpec({
                        key: "".concat(_$e, "[").concat(s, "]"),
                        value: _$r[s],
                        validateSpec: t.validateSpec,
                        valueSpec: _$n
                    }));
                    return i;
                }
                return Ii({
                    key: _$e,
                    value: _$r,
                    valueSpec: {}
                });
            },
            colorArray: function colorArray(t) {
                var _$e = t.key, _$r = t.value;
                if ("array" === Xn(_$r)) {
                    if (_$r.length < 1) return [
                        new Dt(_$e, _$r, "array length at least 1 expected, length 0 found")
                    ];
                    var _$t = [];
                    for(var _$n = 0; _$n < _$r.length; _$n++)_$t = _$t.concat(Di({
                        key: "".concat(_$e, "[").concat(_$n, "]"),
                        value: _$r[_$n]
                    }));
                    return _$t;
                }
                return Di({
                    key: _$e,
                    value: _$r
                });
            },
            variableAnchorOffsetCollection: function variableAnchorOffsetCollection(t) {
                var _$e = t.key, _$r = t.value, _$n = Xn(_$r), i = t.styleSpec;
                if ("array" !== _$n || _$r.length < 1 || _$r.length % 2 != 0) return [
                    new Dt(_$e, _$r, "variableAnchorOffsetCollection requires a non-empty array of even length")
                ];
                var s = [];
                for(var _$n1 = 0; _$n1 < _$r.length; _$n1 += 2)s = s.concat(zi({
                    key: "".concat(_$e, "[").concat(_$n1, "]"),
                    value: _$r[_$n1],
                    valueSpec: i.layout_symbol["text-anchor"]
                })), s = s.concat(Ti({
                    key: "".concat(_$e, "[").concat(_$n1 + 1, "]"),
                    value: _$r[_$n1 + 1],
                    valueSpec: {
                        length: 2,
                        value: "number"
                    },
                    validateSpec: t.validateSpec,
                    style: t.style,
                    styleSpec: i
                }));
                return s;
            },
            sprite: Gi,
            state: Yi,
            fontFaces: function fontFaces(t) {
                var _$e = t.key, _$r = t.value, _$n = t.validateSpec, i = t.styleSpec, s = t.style;
                if (!Xi(_$r)) return [
                    new Dt(_$e, _$r, "object expected, ".concat(Xn(_$r), " found"))
                ];
                var a = [];
                for(var _$t in _$r){
                    var _a;
                    var o = _$r[_$t], l = Xn(o);
                    if ("string" === l) (_a = a).push.apply(_a, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(Ri({
                        key: "".concat(_$e, ".").concat(_$t),
                        value: o
                    })));
                    else if ("array" === l) {
                        var _a1;
                        var _$r1 = {
                            url: {
                                type: "string",
                                required: !0
                            },
                            "unicode-range": {
                                type: "array",
                                value: "string"
                            }
                        };
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = o.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), l1 = _step_value[0], u = _step_value[1];
                                (_a1 = a).push.apply(_a1, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(Ei({
                                    key: "".concat(_$e, ".").concat(_$t, "[").concat(l1, "]"),
                                    value: u,
                                    valueSpec: _$r1,
                                    styleSpec: i,
                                    style: s,
                                    validateSpec: _$n
                                })));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    } else a.push(new Dt("".concat(_$e, ".").concat(_$t), o, "string or array expected, ".concat(l, " found")));
                }
                return a;
            }
        };
        function Hi(t) {
            var _$e = t.value, _$r = t.valueSpec, _$n = t.styleSpec;
            return t.validateSpec = Hi, _$r.expression && Yn(Ai(_$e)) ? Mi(t) : _$r.expression && ri(ki(_$e)) ? Fi(t) : _$r.type && Zi[_$r.type] ? Zi[_$r.type](t) : Ei(zt({}, t, {
                valueSpec: _$r.type ? _$n[_$r.type] : _$r
            }));
        }
        function Ki(t) {
            var _$e = t.value, _$r = t.key, _$n = Ri(t);
            return _$n.length || (-1 === _$e.indexOf("{fontstack}") && _$n.push(new Dt(_$r, _$e, '"glyphs" url must include a "{fontstack}" token')), -1 === _$e.indexOf("{range}") && _$n.push(new Dt(_$r, _$e, '"glyphs" url must include a "{range}" token'))), _$n;
        }
        function Wi(t) {
            var _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : vt;
            var _$r = [];
            return _$r = _$r.concat(Hi({
                key: "",
                value: t,
                valueSpec: _$e.$root,
                styleSpec: _$e,
                style: t,
                validateSpec: Hi,
                objectElementValidators: {
                    glyphs: Ki,
                    "*": function() {
                        return [];
                    }
                }
            })), t.constants && (_$r = _$r.concat(Si({
                key: "constants",
                value: t.constants
            }))), Qi(_$r);
        }
        function Ji(t) {
            return function(e1) {
                return t(Object.assign({}, e1, {
                    validateSpec: Hi
                }));
            };
        }
        function Qi(t) {
            return [].concat(t).sort(function(t, e1) {
                return t.line - e1.line;
            });
        }
        function ts(t) {
            return function() {
                for(var _len = arguments.length, _$e = new Array(_len), _key = 0; _key < _len; _key++){
                    _$e[_key] = arguments[_key];
                }
                return Qi(t.apply(this, _$e));
            };
        }
        Wi.source = ts(Ji($i)), Wi.sprite = ts(Ji(Gi)), Wi.glyphs = ts(Ji(Ki)), Wi.light = ts(Ji(Ui)), Wi.sky = ts(Ji(qi)), Wi.terrain = ts(Ji(ji)), Wi.state = ts(Ji(Yi)), Wi.layer = ts(Ji(Oi)), Wi.filter = ts(Ji(Pi)), Wi.paintProperty = ts(Ji(Ci)), Wi.layoutProperty = ts(Ji(Li));
        var es = {
            type: "enum",
            "property-type": "data-constant",
            expression: {
                interpolated: !1,
                parameters: [
                    "global-state"
                ]
            },
            values: {
                visible: {},
                none: {}
            },
            transition: !1,
            default: "visible"
        };
        var rs = /*#__PURE__*/ function() {
            function rs(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, rs);
                this._globalState = e1, this.setValue(t);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(rs, [
                {
                    key: "evaluate",
                    value: function evaluate() {
                        var _$t;
                        return null !== (_$t = this._literalValue) && void 0 !== _$t ? _$t : this._compiledValue.evaluate({});
                    }
                },
                {
                    key: "setValue",
                    value: function setValue(t) {
                        if (null == t || "visible" === t || "none" === t) return this._literalValue = "none" === t ? "none" : "visible", this._compiledValue = void 0, void (this._globalStateRefs = new Set);
                        var _$e = ni(t, es, this._globalState);
                        if ("error" === _$e.result) throw this._literalValue = "visible", this._compiledValue = void 0, new Error(_$e.value.map(function(t) {
                            return "".concat(t.key, ": ").concat(t.message);
                        }).join(", "));
                        this._literalValue = void 0, this._compiledValue = _$e.value, this._globalStateRefs = ui(_$e.value.expression);
                    }
                },
                {
                    key: "getGlobalStateRefs",
                    value: function getGlobalStateRefs() {
                        return this._globalStateRefs;
                    }
                }
            ]);
            return rs;
        }();
        var ns = vt, is = Wi, ss = is.light, as = is.sky, os = is.paintProperty, ls = is.layoutProperty;
        function us(t, e1) {
            var _$r = !1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (e1 && e1.length) try {
                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$n = _step.value;
                    t.fire(new gt(new Error(_$n.message))), _$r = !0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return _$r;
        }
        var cs = /*#__PURE__*/ function() {
            function cs(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, cs);
                var _$n = this.cells = [];
                if (t instanceof ArrayBuffer) {
                    this.arrayBuffer = t;
                    var i = new Int32Array(this.arrayBuffer);
                    t = i[0], this.d = (e1 = i[1]) + 2 * (r = i[2]);
                    for(var _$t = 0; _$t < this.d * this.d; _$t++){
                        var _$e = i[3 + _$t], _$r = i[3 + _$t + 1];
                        _$n.push(_$e === _$r ? null : i.subarray(_$e, _$r));
                    }
                    var s = i[3 + _$n.length + 1];
                    this.keys = i.subarray(i[3 + _$n.length], s), this.bboxes = i.subarray(s), this.insert = this._insertReadonly;
                } else {
                    this.d = e1 + 2 * r;
                    for(var _$t1 = 0; _$t1 < this.d * this.d; _$t1++)_$n.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = e1, this.extent = t, this.padding = r, this.scale = e1 / t, this.uid = 0;
                var i1 = r / e1 * t;
                this.min = -i1, this.max = t + i1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(cs, [
                {
                    key: "insert",
                    value: function insert(t, e1, r, n, i) {
                        this._forEachCell(e1, r, n, i, this._insertCell, this.uid++, void 0, void 0), this.keys.push(t), this.bboxes.push(e1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
                    }
                },
                {
                    key: "_insertReadonly",
                    value: function _insertReadonly() {
                        throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
                    }
                },
                {
                    key: "_insertCell",
                    value: function _insertCell(t, e1, r, n, i, s) {
                        this.cells[i].push(s);
                    }
                },
                {
                    key: "query",
                    value: function query(t, e1, r, n, i) {
                        var s = this.min, a = this.max;
                        if (t <= s && e1 <= s && a <= r && a <= n && !i) return Array.prototype.slice.call(this.keys);
                        {
                            var s1 = [];
                            return this._forEachCell(t, e1, r, n, this._queryCell, s1, {}, i), s1;
                        }
                    }
                },
                {
                    key: "_queryCell",
                    value: function _queryCell(t, e1, r, n, i, s, a, o) {
                        var l = this.cells[i];
                        if (null !== l) {
                            var _$i = this.keys, u = this.bboxes;
                            for(var _$c = 0; _$c < l.length; _$c++){
                                var _$h = l[_$c];
                                if (void 0 === a[_$h]) {
                                    var l1 = 4 * _$h;
                                    (o ? o(u[l1 + 0], u[l1 + 1], u[l1 + 2], u[l1 + 3]) : t <= u[l1 + 2] && e1 <= u[l1 + 3] && r >= u[l1 + 0] && n >= u[l1 + 1]) ? (a[_$h] = !0, s.push(_$i[_$h])) : a[_$h] = !1;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_forEachCell",
                    value: function _forEachCell(t, e1, r, n, i, s, a, o) {
                        var l = this._convertToCellCoord(t), u = this._convertToCellCoord(e1), _$c = this._convertToCellCoord(r), _$h = this._convertToCellCoord(n);
                        for(var p = l; p <= _$c; p++)for(var l1 = u; l1 <= _$h; l1++){
                            var u1 = this.d * l1 + p;
                            if ((!o || o(this._convertFromCellCoord(p), this._convertFromCellCoord(l1), this._convertFromCellCoord(p + 1), this._convertFromCellCoord(l1 + 1))) && i.call(this, t, e1, r, n, u1, s, a, o)) return;
                        }
                    }
                },
                {
                    key: "_convertFromCellCoord",
                    value: function _convertFromCellCoord(t) {
                        return (t - this.padding) / this.scale;
                    }
                },
                {
                    key: "_convertToCellCoord",
                    value: function _convertToCellCoord(t) {
                        return Math.max(0, Math.min(this.d - 1, Math.floor(t * this.scale) + this.padding));
                    }
                },
                {
                    key: "toArrayBuffer",
                    value: function toArrayBuffer() {
                        if (this.arrayBuffer) return this.arrayBuffer;
                        var _$t = this.cells, _$e = 3 + this.cells.length + 1 + 1;
                        var _$r = 0;
                        for(var _$t1 = 0; _$t1 < this.cells.length; _$t1++)_$r += this.cells[_$t1].length;
                        var _$n = new Int32Array(_$e + _$r + this.keys.length + this.bboxes.length);
                        _$n[0] = this.extent, _$n[1] = this.n, _$n[2] = this.padding;
                        var i = _$e;
                        for(var _$e1 = 0; _$e1 < _$t.length; _$e1++){
                            var _$r1 = _$t[_$e1];
                            _$n[3 + _$e1] = i, _$n.set(_$r1, i), i += _$r1.length;
                        }
                        return _$n[3 + _$t.length] = i, _$n.set(this.keys, i), i += this.keys.length, _$n[3 + _$t.length + 1] = i, _$n.set(this.bboxes, i), i += this.bboxes.length, _$n.buffer;
                    }
                }
            ], [
                {
                    key: "serialize",
                    value: function serialize(t, e1) {
                        var _$r = t.toArrayBuffer();
                        return e1 && e1.push(_$r), {
                            buffer: _$r
                        };
                    }
                },
                {
                    key: "deserialize",
                    value: function deserialize(t) {
                        return new cs(t.buffer);
                    }
                }
            ]);
            return cs;
        }();
        var hs = {};
        function ps(t, e1) {
            var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
            if (hs[t]) throw new Error("".concat(t, " is already registered."));
            Object.defineProperty(e1, "_classRegistryKey", {
                value: t,
                writeable: !1
            }), hs[t] = {
                klass: e1,
                omit: _$r.omit || [],
                shallow: _$r.shallow || []
            };
        }
        ps("Object", Object), ps("Set", Set), ps("TransferableGridIndex", cs), ps("Color", Te), ps("Error", Error), ps("AJAXError", ct), ps("ResolvedImage", Oe), ps("StylePropertyFunction", oi), ps("StyleExpression", ei, {
            omit: [
                "_evaluator"
            ]
        }), ps("ZoomDependentExpression", si), ps("ZoomConstantExpression", ii), ps("CompoundExpression", zn, {
            omit: [
                "_evaluate"
            ]
        });
        for(var _$t in Dn)Dn[_$t]._classRegistryKey || ps("Expression_".concat(_$t), Dn[_$t]);
        function fs(t) {
            return t && "undefined" != typeof ArrayBuffer && (t instanceof ArrayBuffer || t.constructor && "ArrayBuffer" === t.constructor.name);
        }
        function ds(t) {
            return t.$name || t.constructor._classRegistryKey;
        }
        function ys(t) {
            return !function(t) {
                if (null === t || "object" != (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t))) return !1;
                var _$e = ds(t);
                return !(!_$e || "Object" === _$e);
            }(t) && (null == t || "boolean" == typeof t || "number" == typeof t || "string" == typeof t || t instanceof Boolean || t instanceof Number || t instanceof String || t instanceof Date || t instanceof RegExp || t instanceof Blob || t instanceof Error || fs(t) || Z(t) || ArrayBuffer.isView(t) || t instanceof ImageData);
        }
        function ms(t, e1) {
            if (ys(t)) return (fs(t) || Z(t)) && e1 && e1.push(t), ArrayBuffer.isView(t) && e1 && e1.push(t.buffer), t instanceof ImageData && e1 && e1.push(t.data.buffer), t;
            if (Array.isArray(t)) {
                var _$r = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$n = _step.value;
                        _$r.push(ms(_$n, e1));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return _$r;
            }
            if ("object" != (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t))) throw new Error("can't serialize object of type " + (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t)));
            var _$r1 = ds(t);
            if (!_$r1) throw new Error("can't serialize object of unregistered class ".concat(t.constructor.name));
            if (!hs[_$r1]) throw new Error("".concat(_$r1, " is not registered."));
            var _hs_r = hs[_$r1], _$n1 = _hs_r.klass, i = _$n1.serialize ? _$n1.serialize(t, e1) : {};
            if (_$n1.serialize) {
                if (e1 && i === e1[e1.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
            } else {
                for(var _$n2 in t){
                    if (!t.hasOwnProperty(_$n2)) continue;
                    if (hs[_$r1].omit.indexOf(_$n2) >= 0) continue;
                    var s = t[_$n2];
                    i[_$n2] = hs[_$r1].shallow.indexOf(_$n2) >= 0 ? s : ms(s, e1);
                }
                t instanceof Error && (i.message = t.message);
            }
            if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
            return "Object" !== _$r1 && (i.$name = _$r1), i;
        }
        function gs(t) {
            if (ys(t)) return t;
            if (Array.isArray(t)) return t.map(gs);
            if ("object" != (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t))) throw new Error("can't deserialize object of type " + (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t)));
            var _$e = ds(t) || "Object";
            if (!hs[_$e]) throw new Error("can't deserialize unregistered class ".concat(_$e));
            var _hs_e = hs[_$e], _$r = _hs_e.klass;
            if (!_$r) throw new Error("can't deserialize unregistered class ".concat(_$e));
            if (_$r.deserialize) return _$r.deserialize(t);
            var _$n = Object.create(_$r.prototype);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.keys(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$r1 = _step.value;
                    if ("$name" === _$r1) continue;
                    var i = t[_$r1];
                    _$n[_$r1] = hs[_$e].shallow.indexOf(_$r1) >= 0 ? i : gs(i);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return _$n;
        }
        var xs = /*#__PURE__*/ function() {
            function xs() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, xs);
                this.first = !0;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(xs, [
                {
                    key: "update",
                    value: function update(t, e1) {
                        var _$r = Math.floor(t);
                        return this.first ? (this.first = !1, this.lastIntegerZoom = _$r, this.lastIntegerZoomTime = 0, this.lastZoom = t, this.lastFloorZoom = _$r, !0) : (this.lastFloorZoom > _$r ? (this.lastIntegerZoom = _$r + 1, this.lastIntegerZoomTime = e1) : this.lastFloorZoom < _$r && (this.lastIntegerZoom = _$r, this.lastIntegerZoomTime = e1), t !== this.lastZoom && (this.lastZoom = t, this.lastFloorZoom = _$r, !0));
                    }
                }
            ]);
            return xs;
        }();
        function vs(t) {
            return /[\u02EA\u02EB\u2E80-\u2FDF\u2FF0-\u303F\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FD-\u30FF\u3105-\u312F\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(t));
        }
        function bs(t) {
            return /[\u02EA\u02EB\u1100-\u11FF\u1400-\u167F\u18B0-\u18F5\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u3007\u3012\u3013\u3020-\u302F\u3031-\u303F\u3041-\u3096\u309D-\u30FB\u30FD-\u30FF\u3105-\u312F\u3131-\u318E\u3190-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE48\uFE50-\uFE57\uFE5F-\uFE62\uFE67-\uFE6F\uFF00-\uFF07\uFF0A-\uFF0C\uFF0E-\uFF19\uFF1F-\uFF3A\uFF3C\uFF3E\uFF40-\uFF5A\uFFE0-\uFFE2\uFFE4-\uFFE7]|\uD802[\uDD80-\uDD9F]|\uD805[\uDD80-\uDDFF]|\uD806[\uDE00-\uDEBF]|\uD811[\uDC00-\uDE7F]|\uD81B[\uDFE0-\uDFE4\uDFF0-\uDFF6]|[\uD81C-\uD822\uD83D\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD30-\uDEFB]|\uD833[\uDEC0-\uDFCF]|\uD834[\uDC00-\uDDFF\uDEE0-\uDF7F]|\uD836[\uDC00-\uDEAF]|\uD83C[\uDC00-\uDE00\uDF00-\uDFFF]|\uD83E[\uDD00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(t));
        }
        function ws(t) {
            return RegExp("\\s", "u").test(String.fromCodePoint(t));
        }
        function _s(t) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e = _step.value;
                    if (bs(_$e.codePointAt(0))) return !0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !1;
        }
        function Ss(t) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e = _step.value;
                    if (!Es(_$e.codePointAt(0))) return !1;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !0;
        }
        function As(t) {
            var _$e = t.map(function(t) {
                try {
                    return new RegExp("\\p{sc=".concat(t, "}"), "u").source;
                } catch (t) {
                    return null;
                }
            }).filter(function(t) {
                return t;
            });
            return new RegExp(_$e.join("|"), "u");
        }
        var ks = As([
            "Arab",
            "Dupl",
            "Mong",
            "Ougr",
            "Syrc"
        ]);
        function Es(t) {
            return !ks.test(String.fromCodePoint(t));
        }
        function Ts(t) {
            var _$e;
            return !(bs(t) || (_$e = t, /[\xA7\xA9\xAE\xB1\xBC-\xBE\xD7\xF7\u2016\u2020\u2021\u2030\u2031\u203B\u203C\u2042\u2047-\u2049\u2051\u2100-\u218F\u221E\u2234\u2235\u2300-\u2307\u230C-\u231F\u2324-\u2328\u232B\u237D-\u239A\u23BE-\u23CD\u23CF\u23D1-\u23DB\u23E2-\u2422\u2424-\u24FF\u25A0-\u2619\u2620-\u2767\u2776-\u2793\u2B12-\u2B2F\u2B50-\u2B59\u2BB8-\u2BEB\u3000-\u303F\u30A0-\u30FF\uE000-\uF8FF\uFE30-\uFE6F\uFF00-\uFFEF\uFFFC\uFFFD]|[\uDB80-\uDBFF][\uDC00-\uDFFF]/gim.test(String.fromCodePoint(_$e))));
        }
        var Is = As([
            "Adlm",
            "Arab",
            "Armi",
            "Avst",
            "Chrs",
            "Cprt",
            "Egyp",
            "Elym",
            "Gara",
            "Hatr",
            "Hebr",
            "Hung",
            "Khar",
            "Lydi",
            "Mand",
            "Mani",
            "Mend",
            "Merc",
            "Mero",
            "Narb",
            "Nbat",
            "Nkoo",
            "Orkh",
            "Palm",
            "Phli",
            "Phlp",
            "Phnx",
            "Prti",
            "Rohg",
            "Samr",
            "Sarb",
            "Sogo",
            "Syrc",
            "Thaa",
            "Todr",
            "Yezi"
        ]);
        function Ms(t) {
            return Is.test(String.fromCodePoint(t));
        }
        function Fs(t, e1) {
            return !(!e1 && Ms(t) || /[\u0900-\u0DFF\u0F00-\u109F\u1780-\u17FF]/gim.test(String.fromCodePoint(t)));
        }
        function Ds(t) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e = _step.value;
                    if (Ms(_$e.codePointAt(0))) return !0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !1;
        }
        var zs = new (/*#__PURE__*/ function() {
            function _class() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null, this.loadScriptResolve = function() {};
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "setState",
                    value: function setState(t) {
                        this.pluginStatus = t.pluginStatus, this.pluginURL = t.pluginURL;
                    }
                },
                {
                    key: "getState",
                    value: function getState() {
                        return {
                            pluginStatus: this.pluginStatus,
                            pluginURL: this.pluginURL
                        };
                    }
                },
                {
                    key: "setMethods",
                    value: function setMethods(t) {
                        if (zs.isParsed()) throw new Error("RTL text plugin already registered.");
                        this.applyArabicShaping = t.applyArabicShaping, this.processBidirectionalText = t.processBidirectionalText, this.processStyledBidirectionalText = t.processStyledBidirectionalText, this.loadScriptResolve();
                    }
                },
                {
                    key: "isParsed",
                    value: function isParsed() {
                        return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
                    }
                },
                {
                    key: "getRTLTextPluginStatus",
                    value: function getRTLTextPluginStatus() {
                        return this.pluginStatus;
                    }
                },
                {
                    key: "syncState",
                    value: function syncState(t, r) {
                        return e1(this, void 0, void 0, function() {
                            var _this, _$e, _$n, i, _$t;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this = this;
                                        if (this.isParsed()) return [
                                            2,
                                            this.getState()
                                        ];
                                        if ("loading" !== t.pluginStatus) return [
                                            2,
                                            (this.setState(t), t)
                                        ];
                                        _$e = t.pluginURL, _$n = new Promise(function(t) {
                                            _this.loadScriptResolve = t;
                                        });
                                        r(_$e);
                                        i = new Promise(function(t) {
                                            return setTimeout(function() {
                                                return t();
                                            }, _this.TIMEOUT);
                                        });
                                        return [
                                            4,
                                            Promise.race([
                                                _$n,
                                                i
                                            ])
                                        ];
                                    case 1:
                                        if (_state.sent(), this.isParsed()) {
                                            _$t = {
                                                pluginStatus: "loaded",
                                                pluginURL: _$e
                                            };
                                            return [
                                                2,
                                                (this.setState(_$t), _$t)
                                            ];
                                        }
                                        throw this.setState({
                                            pluginStatus: "error",
                                            pluginURL: ""
                                        }), new Error("RTL Text Plugin failed to import scripts from ".concat(_$e));
                                }
                            });
                        });
                    }
                }
            ]);
            return _class;
        }());
        var Ps = /*#__PURE__*/ function() {
            function Ps(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ps);
                this.isSupportedScript = Bs, this.zoom = t, e1 ? (this.now = e1.now || 0, this.fadeDuration = e1.fadeDuration || 0, this.zoomHistory = e1.zoomHistory || new xs, this.transition = e1.transition || {}) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new xs, this.transition = {});
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ps, [
                {
                    key: "crossFadingFactor",
                    value: function crossFadingFactor() {
                        return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
                    }
                },
                {
                    key: "getCrossfadeParameters",
                    value: function getCrossfadeParameters() {
                        var _$t = this.zoom, _$e = _$t - Math.floor(_$t), _$r = this.crossFadingFactor();
                        return _$t > this.zoomHistory.lastIntegerZoom ? {
                            fromScale: 2,
                            toScale: 1,
                            t: _$e + (1 - _$e) * _$r
                        } : {
                            fromScale: .5,
                            toScale: 1,
                            t: 1 - (1 - _$r) * _$e
                        };
                    }
                }
            ]);
            return Ps;
        }();
        function Bs(t) {
            return function(t, e1) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$r = _step.value;
                        if (!Fs(_$r.codePointAt(0), e1)) return !1;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !0;
            }(t, "loaded" === zs.getRTLTextPluginStatus());
        }
        var Vs = "-transition";
        var Cs = /*#__PURE__*/ function() {
            function Cs(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Cs);
                this.property = t, this.value = e1, this.expression = function(t, e1, r) {
                    if (Yn(t)) return new oi(t, e1);
                    if (ri(t)) {
                        var _$n = ai(t, e1, r);
                        if ("error" === _$n.result) throw new Error(_$n.value.map(function(t) {
                            return "".concat(t.key, ": ").concat(t.message);
                        }).join(", "));
                        return _$n.value;
                    }
                    {
                        var _$r = t;
                        return "color" === e1.type && "string" == typeof t ? _$r = Te.parse(t) : "padding" !== e1.type || "number" != typeof t && !Array.isArray(t) ? "numberArray" !== e1.type || "number" != typeof t && !Array.isArray(t) ? "colorArray" !== e1.type || "string" != typeof t && !Array.isArray(t) ? "variableAnchorOffsetCollection" === e1.type && Array.isArray(t) ? _$r = Le.parse(t) : "projectionDefinition" === e1.type && "string" == typeof t && (_$r = Re.parse(t)) : _$r = Be.parse(t) : _$r = Pe.parse(t) : _$r = ze.parse(t), {
                            globalStateRefs: new Set,
                            _globalState: null,
                            kind: "constant",
                            evaluate: function() {
                                return _$r;
                            }
                        };
                    }
                }(void 0 === e1 ? t.specification.default : e1, t.specification, r);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Cs, [
                {
                    key: "isDataDriven",
                    value: function isDataDriven() {
                        return "source" === this.expression.kind || "composite" === this.expression.kind;
                    }
                },
                {
                    key: "getGlobalStateRefs",
                    value: function getGlobalStateRefs() {
                        return this.expression.globalStateRefs || new Set;
                    }
                },
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(t, e1, r) {
                        return this.property.possiblyEvaluate(this, t, e1, r);
                    }
                }
            ]);
            return Cs;
        }();
        var Ls = /*#__PURE__*/ function() {
            function Ls(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ls);
                this.property = t, this.value = new Cs(t, void 0, e1);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ls, [
                {
                    key: "transitioned",
                    value: function transitioned(t, e1) {
                        return new Rs(this.property, this.value, e1, O({}, t.transition, this.transition), t.now);
                    }
                },
                {
                    key: "untransitioned",
                    value: function untransitioned() {
                        return new Rs(this.property, this.value, null, {}, 0);
                    }
                }
            ]);
            return Ls;
        }();
        var Os = /*#__PURE__*/ function() {
            function Os(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Os);
                this._properties = t, this._values = Object.create(t.defaultTransitionablePropertyValues), this._globalState = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Os, [
                {
                    key: "getValue",
                    value: function getValue(t) {
                        return U(this._values[t].value.value);
                    }
                },
                {
                    key: "setValue",
                    value: function setValue(t, e1) {
                        Object.prototype.hasOwnProperty.call(this._values, t) || (this._values[t] = new Ls(this._values[t].property, this._globalState)), this._values[t].value = new Cs(this._values[t].property, null === e1 ? void 0 : U(e1), this._globalState);
                    }
                },
                {
                    key: "getTransition",
                    value: function getTransition(t) {
                        return U(this._values[t].transition);
                    }
                },
                {
                    key: "setTransition",
                    value: function setTransition(t, e1) {
                        Object.prototype.hasOwnProperty.call(this._values, t) || (this._values[t] = new Ls(this._values[t].property, this._globalState)), this._values[t].transition = U(e1) || void 0;
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        var _$t = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(this._values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                var _$r = this.getValue(_$e);
                                void 0 !== _$r && (_$t[_$e] = _$r);
                                var _$n = this.getTransition(_$e);
                                void 0 !== _$n && (_$t["".concat(_$e).concat(Vs)] = _$n);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$t;
                    }
                },
                {
                    key: "transitioned",
                    value: function transitioned(t, e1) {
                        var _$r = new Ns(this._properties);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(this._values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$n = _step.value;
                                _$r._values[_$n] = this._values[_$n].transitioned(t, e1._values[_$n]);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$r;
                    }
                },
                {
                    key: "untransitioned",
                    value: function untransitioned() {
                        var _$t = new Ns(this._properties);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(this._values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                _$t._values[_$e] = this._values[_$e].untransitioned();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$t;
                    }
                }
            ]);
            return Os;
        }();
        var Rs = /*#__PURE__*/ function() {
            function Rs(t, e1, r, n, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Rs);
                this.property = t, this.value = e1, this.begin = i + n.delay || 0, this.end = this.begin + n.duration || 0, t.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Rs, [
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(t, e1, r) {
                        var _$n = t.now || 0, i = this.value.possiblyEvaluate(t, e1, r), s = this.prior;
                        if (s) {
                            if (_$n > this.end) return this.prior = null, i;
                            if (this.value.isDataDriven()) return this.prior = null, i;
                            if (_$n < this.begin) return s.possiblyEvaluate(t, e1, r);
                            {
                                var a = (_$n - this.begin) / (this.end - this.begin);
                                return this.property.interpolate(s.possiblyEvaluate(t, e1, r), i, P(a));
                            }
                        }
                        return i;
                    }
                }
            ]);
            return Rs;
        }();
        var Ns = /*#__PURE__*/ function() {
            function Ns(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ns);
                this._properties = t, this._values = Object.create(t.defaultTransitioningPropertyValues);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ns, [
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(t, e1, r) {
                        var _$n = new qs(this._properties);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(this._values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                _$n._values[i] = this._values[i].possiblyEvaluate(t, e1, r);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$n;
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(this._values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                if (this._values[_$t].prior) return !0;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return !1;
                    }
                }
            ]);
            return Ns;
        }();
        var $s = /*#__PURE__*/ function() {
            function $s(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, $s);
                this._properties = t, this._values = Object.create(t.defaultPropertyValues), this._globalState = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)($s, [
                {
                    key: "hasValue",
                    value: function hasValue(t) {
                        return void 0 !== this._values[t].value;
                    }
                },
                {
                    key: "getValue",
                    value: function getValue(t) {
                        return U(this._values[t].value);
                    }
                },
                {
                    key: "setValue",
                    value: function setValue(t, e1) {
                        this._values[t] = new Cs(this._values[t].property, null === e1 ? void 0 : U(e1), this._globalState);
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        var _$t = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(this._values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                var _$r = this.getValue(_$e);
                                void 0 !== _$r && (_$t[_$e] = _$r);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$t;
                    }
                },
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(t, e1, r) {
                        var _$n = new qs(this._properties);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(this._values)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                _$n._values[i] = this._values[i].possiblyEvaluate(t, e1, r);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$n;
                    }
                }
            ]);
            return $s;
        }();
        var Us = /*#__PURE__*/ function() {
            function Us(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Us);
                this.property = t, this.value = e1, this.parameters = r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Us, [
                {
                    key: "isConstant",
                    value: function isConstant() {
                        return "constant" === this.value.kind;
                    }
                },
                {
                    key: "constantOr",
                    value: function constantOr(t) {
                        return "constant" === this.value.kind ? this.value.value : t;
                    }
                },
                {
                    key: "evaluate",
                    value: function evaluate(t, e1, r, n) {
                        return this.property.evaluate(this.value, this.parameters, t, e1, r, n);
                    }
                }
            ]);
            return Us;
        }();
        var qs = /*#__PURE__*/ function() {
            function qs(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, qs);
                this._properties = t, this._values = Object.create(t.defaultPossiblyEvaluatedValues);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(qs, [
                {
                    key: "get",
                    value: function get(t) {
                        return this._values[t];
                    }
                }
            ]);
            return qs;
        }();
        var js = /*#__PURE__*/ function() {
            function js(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, js);
                this.specification = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(js, [
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(t, e1) {
                        if (t.isDataDriven()) throw new Error("Value should not be data driven");
                        return t.expression.evaluate(e1);
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate(t, e1, r) {
                        var _$n = yr[this.specification.type];
                        return _$n ? _$n(t, e1, r) : t;
                    }
                }
            ]);
            return js;
        }();
        var Gs = /*#__PURE__*/ function() {
            function Gs(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Gs);
                this.specification = t, this.overrides = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Gs, [
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(t, e1, r, n) {
                        return new Us(this, "constant" === t.expression.kind || "camera" === t.expression.kind ? {
                            kind: "constant",
                            value: t.expression.evaluate(e1, null, {}, r, n)
                        } : t.expression, e1);
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate(t, e1, r) {
                        if ("constant" !== t.value.kind || "constant" !== e1.value.kind) return t;
                        if (void 0 === t.value.value || void 0 === e1.value.value) return new Us(this, {
                            kind: "constant",
                            value: void 0
                        }, t.parameters);
                        var _$n = yr[this.specification.type];
                        if (_$n) {
                            var i = _$n(t.value.value, e1.value.value, r);
                            return new Us(this, {
                                kind: "constant",
                                value: i
                            }, t.parameters);
                        }
                        return t;
                    }
                },
                {
                    key: "evaluate",
                    value: function evaluate(t, e1, r, n, i, s) {
                        return "constant" === t.kind ? t.value : t.evaluate(e1, r, n, i, s);
                    }
                }
            ]);
            return Gs;
        }();
        var Xs = /*#__PURE__*/ function(Gs) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Xs, Gs);
            function Xs() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Xs);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Xs, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Xs, [
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(t, e1, r, n) {
                        if (void 0 === t.value) return new Us(this, {
                            kind: "constant",
                            value: void 0
                        }, e1);
                        if ("constant" === t.expression.kind) {
                            var i = t.expression.evaluate(e1, null, {}, r, n), s = "resolvedImage" === t.property.specification.type && "string" != typeof i ? i.name : i, a = this._calculate(s, s, s, e1);
                            return new Us(this, {
                                kind: "constant",
                                value: a
                            }, e1);
                        }
                        if ("camera" === t.expression.kind) {
                            var _$r = this._calculate(t.expression.evaluate({
                                zoom: e1.zoom - 1
                            }), t.expression.evaluate({
                                zoom: e1.zoom
                            }), t.expression.evaluate({
                                zoom: e1.zoom + 1
                            }), e1);
                            return new Us(this, {
                                kind: "constant",
                                value: _$r
                            }, e1);
                        }
                        return new Us(this, t.expression, e1);
                    }
                },
                {
                    key: "evaluate",
                    value: function evaluate(t, e1, r, n, i, s) {
                        if ("source" === t.kind) {
                            var a = t.evaluate(e1, r, n, i, s);
                            return this._calculate(a, a, a, e1);
                        }
                        return "composite" === t.kind ? this._calculate(t.evaluate({
                            zoom: Math.floor(e1.zoom) - 1
                        }, r, n), t.evaluate({
                            zoom: Math.floor(e1.zoom)
                        }, r, n), t.evaluate({
                            zoom: Math.floor(e1.zoom) + 1
                        }, r, n), e1) : t.value;
                    }
                },
                {
                    key: "_calculate",
                    value: function _calculate(t, e1, r, n) {
                        return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                            from: t,
                            to: e1
                        } : {
                            from: r,
                            to: e1
                        };
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate(t) {
                        return t;
                    }
                }
            ]);
            return Xs;
        }(Gs);
        var Ys = /*#__PURE__*/ function() {
            function Ys(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ys);
                this.specification = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ys, [
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(t, e1, r, n) {
                        if (void 0 !== t.value) {
                            if ("constant" === t.expression.kind) {
                                var i = t.expression.evaluate(e1, null, {}, r, n);
                                return this._calculate(i, i, i, e1);
                            }
                            return this._calculate(t.expression.evaluate(new Ps(Math.floor(e1.zoom - 1), e1)), t.expression.evaluate(new Ps(Math.floor(e1.zoom), e1)), t.expression.evaluate(new Ps(Math.floor(e1.zoom + 1), e1)), e1);
                        }
                    }
                },
                {
                    key: "_calculate",
                    value: function _calculate(t, e1, r, n) {
                        return n.zoom > n.zoomHistory.lastIntegerZoom ? {
                            from: t,
                            to: e1
                        } : {
                            from: r,
                            to: e1
                        };
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate(t) {
                        return t;
                    }
                }
            ]);
            return Ys;
        }();
        var Zs = /*#__PURE__*/ function() {
            function Zs(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Zs);
                this.specification = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Zs, [
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(t, e1, r, n) {
                        return !!t.expression.evaluate(e1, null, {}, r, n);
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate() {
                        return !1;
                    }
                }
            ]);
            return Zs;
        }();
        var Hs = function Hs(t) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, Hs);
            this.properties = t, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
            for(var _$e in t){
                var _$r = t[_$e];
                _$r.specification.overridable && this.overridableProperties.push(_$e);
                var _$n = this.defaultPropertyValues[_$e] = new Cs(_$r, void 0, void 0), i = this.defaultTransitionablePropertyValues[_$e] = new Ls(_$r, void 0);
                this.defaultTransitioningPropertyValues[_$e] = i.untransitioned(), this.defaultPossiblyEvaluatedValues[_$e] = _$n.possiblyEvaluate({});
            }
        };
        ps("DataDrivenProperty", Gs), ps("DataConstantProperty", js), ps("CrossFadedDataDrivenProperty", Xs), ps("CrossFadedProperty", Ys), ps("ColorRampProperty", Zs);
        var Ks = /*#__PURE__*/ function(xt) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ks, xt);
            function Ks(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ks);
                var _this;
                if (_this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Ks), _this.id = t.id, _this.type = t.type, _this._globalState = r, _this._featureFilter = {
                    filter: function() {
                        return !0;
                    },
                    needGeometry: !1,
                    getGlobalStateRefs: function() {
                        return new Set;
                    }
                }, "custom" !== t.type && (_this.metadata = t.metadata, _this.minzoom = t.minzoom, _this.maxzoom = t.maxzoom, _this._visibilityExpression = function(t, e1) {
                    return new rs(t, e1);
                }(_this.visibility, r), "background" !== t.type && (_this.source = t.source, _this.sourceLayer = t["source-layer"], _this.filter = t.filter, _this._featureFilter = fi(t.filter, r)), e1.layout && (_this._unevaluatedLayout = new $s(e1.layout, r)), e1.paint)) {
                    _this._transitionablePaint = new Os(e1.paint, r);
                    for(var _$e in t.paint)_this.setPaintProperty(_$e, t.paint[_$e], {
                        validate: !1
                    });
                    for(var _$e1 in t.layout)_this.setLayoutProperty(_$e1, t.layout[_$e1], {
                        validate: !1
                    });
                    _this._transitioningPaint = _this._transitionablePaint.untransitioned(), _this.paint = new qs(e1.paint);
                }
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ks, [
                {
                    key: "setFilter",
                    value: function setFilter(t) {
                        this.filter = t, this._featureFilter = fi(t, this._globalState);
                    }
                },
                {
                    key: "getCrossfadeParameters",
                    value: function getCrossfadeParameters() {
                        return this._crossfadeParameters;
                    }
                },
                {
                    key: "getLayoutProperty",
                    value: function getLayoutProperty(t) {
                        return "visibility" === t ? this.visibility : this._unevaluatedLayout.getValue(t);
                    }
                },
                {
                    key: "getLayoutAffectingGlobalStateRefs",
                    value: function getLayoutAffectingGlobalStateRefs() {
                        var _$t = new Set;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._visibilityExpression.getGlobalStateRefs()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                _$t.add(_$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (this._unevaluatedLayout) for(var _$e1 in this._unevaluatedLayout._values){
                            var _$r = this._unevaluatedLayout._values[_$e1];
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = _$r.getGlobalStateRefs()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var _$e2 = _step1.value;
                                    _$t.add(_$e2);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = this._featureFilter.getGlobalStateRefs()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var _$e3 = _step2.value;
                                _$t.add(_$e3);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        return _$t;
                    }
                },
                {
                    key: "getPaintAffectingGlobalStateRefs",
                    value: function getPaintAffectingGlobalStateRefs() {
                        var _$t;
                        var _$e = new globalThis.Map;
                        if (this._transitionablePaint) for(var _$r in this._transitionablePaint._values){
                            var _$n = this._transitionablePaint._values[_$r].value;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = _$n.getGlobalStateRefs()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var i = _step.value;
                                    var s = null !== (_$t = _$e.get(i)) && void 0 !== _$t ? _$t : [];
                                    s.push({
                                        name: _$r,
                                        value: _$n.value
                                    }), _$e.set(i, s);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return _$e;
                    }
                },
                {
                    key: "getVisibilityAffectingGlobalStateRefs",
                    value: function getVisibilityAffectingGlobalStateRefs() {
                        return this._visibilityExpression.getGlobalStateRefs();
                    }
                },
                {
                    key: "setLayoutProperty",
                    value: function setLayoutProperty(t, e1) {
                        var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        if (null == e1 || !this._validate(ls, "layers.".concat(this.id, ".layout.").concat(t), t, e1, _$r)) return "visibility" === t ? (this.visibility = e1, this._visibilityExpression.setValue(e1), void this.recalculateVisibility()) : void this._unevaluatedLayout.setValue(t, e1);
                    }
                },
                {
                    key: "getPaintProperty",
                    value: function getPaintProperty(t) {
                        return t.endsWith(Vs) ? this._transitionablePaint.getTransition(t.slice(0, -11)) : this._transitionablePaint.getValue(t);
                    }
                },
                {
                    key: "setPaintProperty",
                    value: function setPaintProperty(t, e1) {
                        var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        if (null != e1 && this._validate(os, "layers.".concat(this.id, ".paint.").concat(t), t, e1, _$r)) return !1;
                        if (t.endsWith(Vs)) return this._transitionablePaint.setTransition(t.slice(0, -11), e1 || void 0), !1;
                        {
                            var _$r1 = this._transitionablePaint._values[t], _$n = "cross-faded-data-driven" === _$r1.property.specification["property-type"], i = _$r1.value.isDataDriven(), s = _$r1.value;
                            this._transitionablePaint.setValue(t, e1), this._handleSpecialPaintPropertyUpdate(t);
                            var a = this._transitionablePaint._values[t].value;
                            return a.isDataDriven() || i || _$n || this._handleOverridablePaintPropertyUpdate(t, s, a);
                        }
                    }
                },
                {
                    key: "_handleSpecialPaintPropertyUpdate",
                    value: function _handleSpecialPaintPropertyUpdate(t) {}
                },
                {
                    key: "_handleOverridablePaintPropertyUpdate",
                    value: function _handleOverridablePaintPropertyUpdate(t, e1, r) {
                        return !1;
                    }
                },
                {
                    key: "isHidden",
                    value: function isHidden() {
                        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.minzoom, _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                        return !!(this.minzoom && _$t < (_$e ? Math.floor(this.minzoom) : this.minzoom)) || !!(this.maxzoom && _$t >= this.maxzoom) || "none" === this._evaluatedVisibility;
                    }
                },
                {
                    key: "updateTransitions",
                    value: function updateTransitions(t) {
                        this._transitioningPaint = this._transitionablePaint.transitioned(t, this._transitioningPaint);
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return this._transitioningPaint.hasTransition();
                    }
                },
                {
                    key: "recalculateVisibility",
                    value: function recalculateVisibility() {
                        this._evaluatedVisibility = this._visibilityExpression.evaluate();
                    }
                },
                {
                    key: "recalculate",
                    value: function recalculate(t, e1) {
                        t.getCrossfadeParameters && (this._crossfadeParameters = t.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(t, void 0, e1)), this.paint = this._transitioningPaint.possiblyEvaluate(t, void 0, e1);
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        var _$t = {
                            id: this.id,
                            type: this.type,
                            source: this.source,
                            "source-layer": this.sourceLayer,
                            metadata: this.metadata,
                            minzoom: this.minzoom,
                            maxzoom: this.maxzoom,
                            filter: this.filter,
                            layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                            paint: this._transitionablePaint && this._transitionablePaint.serialize()
                        };
                        return this.visibility && (_$t.layout = _$t.layout || {}, _$t.layout.visibility = this.visibility), $(_$t, function(t, e1) {
                            return !(void 0 === t || "layout" === e1 && !Object.keys(t).length || "paint" === e1 && !Object.keys(t).length);
                        });
                    }
                },
                {
                    key: "_validate",
                    value: function _validate(t, e1, r, n) {
                        var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                        return (!i || !1 !== i.validate) && us(this, t.call(is, {
                            key: e1,
                            layerType: this.type,
                            objectKey: r,
                            value: n,
                            styleSpec: vt,
                            style: {
                                glyphs: !0,
                                sprite: !0
                            }
                        }));
                    }
                },
                {
                    key: "is3D",
                    value: function is3D() {
                        return !1;
                    }
                },
                {
                    key: "isTileClipped",
                    value: function isTileClipped() {
                        return !1;
                    }
                },
                {
                    key: "hasOffscreenPass",
                    value: function hasOffscreenPass() {
                        return !1;
                    }
                },
                {
                    key: "resize",
                    value: function resize() {}
                },
                {
                    key: "isStateDependent",
                    value: function isStateDependent() {
                        for(var _$t in this.paint._values){
                            var _$e = this.paint.get(_$t);
                            if (_$e instanceof Us && qn(_$e.property.specification) && ("source" === _$e.value.kind || "composite" === _$e.value.kind) && _$e.value.isStateDependent) return !0;
                        }
                        return !1;
                    }
                }
            ]);
            return Ks;
        }(xt);
        var Ws;
        var Js = {
            get paint () {
                return Ws = Ws || new Hs({
                    "raster-opacity": new js(vt.paint_raster["raster-opacity"]),
                    "raster-hue-rotate": new js(vt.paint_raster["raster-hue-rotate"]),
                    "raster-brightness-min": new js(vt.paint_raster["raster-brightness-min"]),
                    "raster-brightness-max": new js(vt.paint_raster["raster-brightness-max"]),
                    "raster-saturation": new js(vt.paint_raster["raster-saturation"]),
                    "raster-contrast": new js(vt.paint_raster["raster-contrast"]),
                    "raster-resampling": new js(vt.paint_raster["raster-resampling"]),
                    "raster-fade-duration": new js(vt.paint_raster["raster-fade-duration"])
                });
            }
        };
        var Qs = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Qs, Ks);
            function Qs(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Qs);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Qs, [
                    t,
                    Js,
                    e1
                ]);
            }
            return Qs;
        }(Ks);
        var ta = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        var ea = function ea(t, e1) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, ea);
            this._structArray = t, this._pos1 = e1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
        };
        var ra = /*#__PURE__*/ function() {
            function ra() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ra);
                this.isTransferred = !1, this.capacity = -1, this.resize(0);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ra, [
                {
                    key: "_trim",
                    value: function _trim() {
                        this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
                    }
                },
                {
                    key: "clear",
                    value: function clear() {
                        this.length = 0;
                    }
                },
                {
                    key: "resize",
                    value: function resize(t) {
                        this.reserve(t), this.length = t;
                    }
                },
                {
                    key: "reserve",
                    value: function reserve(t) {
                        if (t > this.capacity) {
                            this.capacity = Math.max(t, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                            var _$e = this.uint8;
                            this._refreshViews(), _$e && this.uint8.set(_$e);
                        }
                    }
                },
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
                    }
                }
            ], [
                {
                    key: "serialize",
                    value: function serialize(t, e1) {
                        return t._trim(), e1 && (t.isTransferred = !0, e1.push(t.arrayBuffer)), {
                            length: t.length,
                            arrayBuffer: t.arrayBuffer
                        };
                    }
                },
                {
                    key: "deserialize",
                    value: function deserialize(t) {
                        var _$e = Object.create(this.prototype);
                        return _$e.arrayBuffer = t.arrayBuffer, _$e.length = t.length, _$e.capacity = t.arrayBuffer.byteLength / _$e.bytesPerElement, _$e._refreshViews(), _$e;
                    }
                }
            ]);
            return ra;
        }();
        function na(t) {
            var _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            var _$r = 0, _$n = 0;
            return {
                members: t.map(function(t) {
                    var i = ta[t.type].BYTES_PER_ELEMENT, s = _$r = ia(_$r, Math.max(_$e, i)), a = t.components || 1;
                    return _$n = Math.max(_$n, i), _$r += i * a, {
                        name: t.name,
                        type: t.type,
                        components: a,
                        offset: s
                    };
                }),
                size: ia(_$r, Math.max(_$n, _$e)),
                alignment: _$e
            };
        }
        function ia(t, e1) {
            return Math.ceil(t / e1) * e1;
        }
        var sa = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(sa, ra);
            function sa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, sa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, sa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(sa, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1) {
                        var _$r = this.length;
                        return this.resize(_$r + 1), this.emplace(_$r, t, e1);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r) {
                        var _$n = 2 * t;
                        return this.int16[_$n + 0] = e1, this.int16[_$n + 1] = r, t;
                    }
                }
            ]);
            return sa;
        }(ra);
        sa.prototype.bytesPerElement = 4, ps("StructArrayLayout2i4", sa);
        var aa = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(aa, ra);
            function aa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, aa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, aa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(aa, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r) {
                        var _$n = this.length;
                        return this.resize(_$n + 1), this.emplace(_$n, t, e1, r);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n) {
                        var i = 3 * t;
                        return this.int16[i + 0] = e1, this.int16[i + 1] = r, this.int16[i + 2] = n, t;
                    }
                }
            ]);
            return aa;
        }(ra);
        aa.prototype.bytesPerElement = 6, ps("StructArrayLayout3i6", aa);
        var oa = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(oa, ra);
            function oa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, oa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, oa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(oa, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n) {
                        var i = this.length;
                        return this.resize(i + 1), this.emplace(i, t, e1, r, n);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i) {
                        var s = 4 * t;
                        return this.int16[s + 0] = e1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, t;
                    }
                }
            ]);
            return oa;
        }(ra);
        oa.prototype.bytesPerElement = 8, ps("StructArrayLayout4i8", oa);
        var la = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(la, ra);
            function la() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, la);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, la, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(la, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i, s) {
                        var a = this.length;
                        return this.resize(a + 1), this.emplace(a, t, e1, r, n, i, s);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s, a) {
                        var o = 6 * t;
                        return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, t;
                    }
                }
            ]);
            return la;
        }(ra);
        la.prototype.bytesPerElement = 12, ps("StructArrayLayout2i4i12", la);
        var ua = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ua, ra);
            function ua() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ua);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ua, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ua, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i, s) {
                        var a = this.length;
                        return this.resize(a + 1), this.emplace(a, t, e1, r, n, i, s);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s, a) {
                        var o = 4 * t, l = 8 * t;
                        return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.uint8[l + 4] = n, this.uint8[l + 5] = i, this.uint8[l + 6] = s, this.uint8[l + 7] = a, t;
                    }
                }
            ]);
            return ua;
        }(ra);
        ua.prototype.bytesPerElement = 8, ps("StructArrayLayout2i4ub8", ua);
        var ca = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ca, ra);
            function ca() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ca);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ca, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ca, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1) {
                        var _$r = this.length;
                        return this.resize(_$r + 1), this.emplace(_$r, t, e1);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r) {
                        var _$n = 2 * t;
                        return this.float32[_$n + 0] = e1, this.float32[_$n + 1] = r, t;
                    }
                }
            ]);
            return ca;
        }(ra);
        ca.prototype.bytesPerElement = 8, ps("StructArrayLayout2f8", ca);
        var ha = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ha, ra);
            function ha() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ha);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ha, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ha, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i, s, a, o, l, u) {
                        var _$c = this.length;
                        return this.resize(_$c + 1), this.emplace(_$c, t, e1, r, n, i, s, a, o, l, u);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s, a, o, l, u, c) {
                        var _$h = 10 * t;
                        return this.uint16[_$h + 0] = e1, this.uint16[_$h + 1] = r, this.uint16[_$h + 2] = n, this.uint16[_$h + 3] = i, this.uint16[_$h + 4] = s, this.uint16[_$h + 5] = a, this.uint16[_$h + 6] = o, this.uint16[_$h + 7] = l, this.uint16[_$h + 8] = u, this.uint16[_$h + 9] = c, t;
                    }
                }
            ]);
            return ha;
        }(ra);
        ha.prototype.bytesPerElement = 20, ps("StructArrayLayout10ui20", ha);
        var pa = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(pa, ra);
            function pa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, pa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, pa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(pa, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i, s, a, o) {
                        var l = this.length;
                        return this.resize(l + 1), this.emplace(l, t, e1, r, n, i, s, a, o);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s, a, o, l) {
                        var u = 8 * t;
                        return this.uint16[u + 0] = e1, this.uint16[u + 1] = r, this.uint16[u + 2] = n, this.uint16[u + 3] = i, this.uint16[u + 4] = s, this.uint16[u + 5] = a, this.uint16[u + 6] = o, this.uint16[u + 7] = l, t;
                    }
                }
            ]);
            return pa;
        }(ra);
        pa.prototype.bytesPerElement = 16, ps("StructArrayLayout8ui16", pa);
        var fa = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(fa, ra);
            function fa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, fa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, fa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(fa, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i, s, a, o, l, u, c, h) {
                        var p = this.length;
                        return this.resize(p + 1), this.emplace(p, t, e1, r, n, i, s, a, o, l, u, c, h);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s, a, o, l, u, c, h, p) {
                        var f = 12 * t;
                        return this.int16[f + 0] = e1, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.uint16[f + 4] = s, this.uint16[f + 5] = a, this.uint16[f + 6] = o, this.uint16[f + 7] = l, this.int16[f + 8] = u, this.int16[f + 9] = c, this.int16[f + 10] = h, this.int16[f + 11] = p, t;
                    }
                }
            ]);
            return fa;
        }(ra);
        fa.prototype.bytesPerElement = 24, ps("StructArrayLayout4i4ui4i24", fa);
        var da = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(da, ra);
            function da() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, da);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, da, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(da, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r) {
                        var _$n = this.length;
                        return this.resize(_$n + 1), this.emplace(_$n, t, e1, r);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n) {
                        var i = 3 * t;
                        return this.float32[i + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
                    }
                }
            ]);
            return da;
        }(ra);
        da.prototype.bytesPerElement = 12, ps("StructArrayLayout3f12", da);
        var ya = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ya, ra);
            function ya() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ya);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ya, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ya, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t) {
                        var _$e = this.length;
                        return this.resize(_$e + 1), this.emplace(_$e, t);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1) {
                        return this.uint32[1 * t + 0] = e1, t;
                    }
                }
            ]);
            return ya;
        }(ra);
        ya.prototype.bytesPerElement = 4, ps("StructArrayLayout1ul4", ya);
        var ma = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ma, ra);
            function ma() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ma);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ma, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ma, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i, s, a, o, l) {
                        var u = this.length;
                        return this.resize(u + 1), this.emplace(u, t, e1, r, n, i, s, a, o, l);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s, a, o, l, u) {
                        var _$c = 10 * t, _$h = 5 * t;
                        return this.int16[_$c + 0] = e1, this.int16[_$c + 1] = r, this.int16[_$c + 2] = n, this.int16[_$c + 3] = i, this.int16[_$c + 4] = s, this.int16[_$c + 5] = a, this.uint32[_$h + 3] = o, this.uint16[_$c + 8] = l, this.uint16[_$c + 9] = u, t;
                    }
                }
            ]);
            return ma;
        }(ra);
        ma.prototype.bytesPerElement = 20, ps("StructArrayLayout6i1ul2ui20", ma);
        var ga = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ga, ra);
            function ga() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ga);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ga, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ga, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i, s) {
                        var a = this.length;
                        return this.resize(a + 1), this.emplace(a, t, e1, r, n, i, s);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s, a) {
                        var o = 6 * t;
                        return this.int16[o + 0] = e1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, t;
                    }
                }
            ]);
            return ga;
        }(ra);
        ga.prototype.bytesPerElement = 12, ps("StructArrayLayout2i2i2i12", ga);
        var xa = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(xa, ra);
            function xa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, xa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, xa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(xa, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i) {
                        var s = this.length;
                        return this.resize(s + 1), this.emplace(s, t, e1, r, n, i);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s) {
                        var a = 4 * t, o = 8 * t;
                        return this.float32[a + 0] = e1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = s, t;
                    }
                }
            ]);
            return xa;
        }(ra);
        xa.prototype.bytesPerElement = 16, ps("StructArrayLayout2f1f2i16", xa);
        var va = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(va, ra);
            function va() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, va);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, va, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(va, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i, s) {
                        var a = this.length;
                        return this.resize(a + 1), this.emplace(a, t, e1, r, n, i, s);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s, a) {
                        var o = 16 * t, l = 4 * t, u = 8 * t;
                        return this.uint8[o + 0] = e1, this.uint8[o + 1] = r, this.float32[l + 1] = n, this.float32[l + 2] = i, this.int16[u + 6] = s, this.int16[u + 7] = a, t;
                    }
                }
            ]);
            return va;
        }(ra);
        va.prototype.bytesPerElement = 16, ps("StructArrayLayout2ub2f2i16", va);
        var ba = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ba, ra);
            function ba() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ba);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ba, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ba, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r) {
                        var _$n = this.length;
                        return this.resize(_$n + 1), this.emplace(_$n, t, e1, r);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n) {
                        var i = 3 * t;
                        return this.uint16[i + 0] = e1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, t;
                    }
                }
            ]);
            return ba;
        }(ra);
        ba.prototype.bytesPerElement = 6, ps("StructArrayLayout3ui6", ba);
        var wa = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(wa, ra);
            function wa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, wa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, wa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(wa, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m) {
                        var _$g = this.length;
                        return this.resize(_$g + 1), this.emplace(_$g, t, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g) {
                        var _$x = 24 * t, _$v = 12 * t, _$b = 48 * t;
                        return this.int16[_$x + 0] = e1, this.int16[_$x + 1] = r, this.uint16[_$x + 2] = n, this.uint16[_$x + 3] = i, this.uint32[_$v + 2] = s, this.uint32[_$v + 3] = a, this.uint32[_$v + 4] = o, this.uint16[_$x + 10] = l, this.uint16[_$x + 11] = u, this.uint16[_$x + 12] = c, this.float32[_$v + 7] = h, this.float32[_$v + 8] = p, this.uint8[_$b + 36] = f, this.uint8[_$b + 37] = d, this.uint8[_$b + 38] = y, this.uint32[_$v + 10] = m, this.int16[_$x + 22] = g, t;
                    }
                }
            ]);
            return wa;
        }(ra);
        wa.prototype.bytesPerElement = 48, ps("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", wa);
        var _a = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_a, ra);
            function _a() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _a);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, _a, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_a, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, k, E, T) {
                        var I = this.length;
                        return this.resize(I + 1), this.emplace(I, t, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, k, E, T);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, k, E, T, I) {
                        var M = 32 * t, _$F = 16 * t;
                        return this.int16[M + 0] = e1, this.int16[M + 1] = r, this.int16[M + 2] = n, this.int16[M + 3] = i, this.int16[M + 4] = s, this.int16[M + 5] = a, this.int16[M + 6] = o, this.int16[M + 7] = l, this.uint16[M + 8] = u, this.uint16[M + 9] = c, this.uint16[M + 10] = h, this.uint16[M + 11] = p, this.uint16[M + 12] = f, this.uint16[M + 13] = d, this.uint16[M + 14] = y, this.uint16[M + 15] = m, this.uint16[M + 16] = g, this.uint16[M + 17] = x, this.uint16[M + 18] = v, this.uint16[M + 19] = b, this.uint16[M + 20] = w, this.uint16[M + 21] = _, this.uint16[M + 22] = S, this.uint32[_$F + 12] = A, this.float32[_$F + 13] = k, this.float32[_$F + 14] = E, this.uint16[M + 30] = T, this.uint16[M + 31] = I, t;
                    }
                }
            ]);
            return _a;
        }(ra);
        _a.prototype.bytesPerElement = 64, ps("StructArrayLayout8i15ui1ul2f2ui64", _a);
        var Sa = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Sa, ra);
            function Sa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Sa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Sa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Sa, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t) {
                        var _$e = this.length;
                        return this.resize(_$e + 1), this.emplace(_$e, t);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1) {
                        return this.float32[1 * t + 0] = e1, t;
                    }
                }
            ]);
            return Sa;
        }(ra);
        Sa.prototype.bytesPerElement = 4, ps("StructArrayLayout1f4", Sa);
        var Aa = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Aa, ra);
            function Aa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Aa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Aa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Aa, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r) {
                        var _$n = this.length;
                        return this.resize(_$n + 1), this.emplace(_$n, t, e1, r);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n) {
                        var i = 3 * t;
                        return this.uint16[6 * t + 0] = e1, this.float32[i + 1] = r, this.float32[i + 2] = n, t;
                    }
                }
            ]);
            return Aa;
        }(ra);
        Aa.prototype.bytesPerElement = 12, ps("StructArrayLayout1ui2f12", Aa);
        var ka = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ka, ra);
            function ka() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ka);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ka, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ka, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r) {
                        var _$n = this.length;
                        return this.resize(_$n + 1), this.emplace(_$n, t, e1, r);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n) {
                        var i = 4 * t;
                        return this.uint32[2 * t + 0] = e1, this.uint16[i + 2] = r, this.uint16[i + 3] = n, t;
                    }
                }
            ]);
            return ka;
        }(ra);
        ka.prototype.bytesPerElement = 8, ps("StructArrayLayout1ul2ui8", ka);
        var Ea = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ea, ra);
            function Ea() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ea);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ea, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ea, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1) {
                        var _$r = this.length;
                        return this.resize(_$r + 1), this.emplace(_$r, t, e1);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r) {
                        var _$n = 2 * t;
                        return this.uint16[_$n + 0] = e1, this.uint16[_$n + 1] = r, t;
                    }
                }
            ]);
            return Ea;
        }(ra);
        Ea.prototype.bytesPerElement = 4, ps("StructArrayLayout2ui4", Ea);
        var Ta = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ta, ra);
            function Ta() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ta);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ta, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ta, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t) {
                        var _$e = this.length;
                        return this.resize(_$e + 1), this.emplace(_$e, t);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1) {
                        return this.uint16[1 * t + 0] = e1, t;
                    }
                }
            ]);
            return Ta;
        }(ra);
        Ta.prototype.bytesPerElement = 2, ps("StructArrayLayout1ui2", Ta);
        var Ia = /*#__PURE__*/ function(ra) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ia, ra);
            function Ia() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ia);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ia, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ia, [
                {
                    key: "_refreshViews",
                    value: function _refreshViews() {
                        this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                    }
                },
                {
                    key: "emplaceBack",
                    value: function emplaceBack(t, e1, r, n) {
                        var i = this.length;
                        return this.resize(i + 1), this.emplace(i, t, e1, r, n);
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n, i) {
                        var s = 4 * t;
                        return this.float32[s + 0] = e1, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, t;
                    }
                }
            ]);
            return Ia;
        }(ra);
        Ia.prototype.bytesPerElement = 16, ps("StructArrayLayout4f16", Ia);
        var Ma = /*#__PURE__*/ function(ea) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ma, ea);
            function Ma() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ma);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ma, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ma, [
                {
                    key: "anchorPointX",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 0];
                    }
                },
                {
                    key: "anchorPointY",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 1];
                    }
                },
                {
                    key: "x1",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 2];
                    }
                },
                {
                    key: "y1",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 3];
                    }
                },
                {
                    key: "x2",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 4];
                    }
                },
                {
                    key: "y2",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 5];
                    }
                },
                {
                    key: "featureIndex",
                    get: function get() {
                        return this._structArray.uint32[this._pos4 + 3];
                    }
                },
                {
                    key: "sourceLayerIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 8];
                    }
                },
                {
                    key: "bucketIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 9];
                    }
                },
                {
                    key: "anchorPoint",
                    get: function get() {
                        return new r(this.anchorPointX, this.anchorPointY);
                    }
                }
            ]);
            return Ma;
        }(ea);
        Ma.prototype.size = 20;
        var Fa = /*#__PURE__*/ function(ma) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Fa, ma);
            function Fa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Fa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Fa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Fa, [
                {
                    key: "get",
                    value: function get(t) {
                        return new Ma(this, t);
                    }
                }
            ]);
            return Fa;
        }(ma);
        ps("CollisionBoxArray", Fa);
        var Da = /*#__PURE__*/ function(ea) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Da, ea);
            function Da() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Da);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Da, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Da, [
                {
                    key: "anchorX",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 0];
                    }
                },
                {
                    key: "anchorY",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 1];
                    }
                },
                {
                    key: "glyphStartIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 2];
                    }
                },
                {
                    key: "numGlyphs",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 3];
                    }
                },
                {
                    key: "vertexStartIndex",
                    get: function get() {
                        return this._structArray.uint32[this._pos4 + 2];
                    }
                },
                {
                    key: "lineStartIndex",
                    get: function get() {
                        return this._structArray.uint32[this._pos4 + 3];
                    }
                },
                {
                    key: "lineLength",
                    get: function get() {
                        return this._structArray.uint32[this._pos4 + 4];
                    }
                },
                {
                    key: "segment",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 10];
                    }
                },
                {
                    key: "lowerSize",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 11];
                    }
                },
                {
                    key: "upperSize",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 12];
                    }
                },
                {
                    key: "lineOffsetX",
                    get: function get() {
                        return this._structArray.float32[this._pos4 + 7];
                    }
                },
                {
                    key: "lineOffsetY",
                    get: function get() {
                        return this._structArray.float32[this._pos4 + 8];
                    }
                },
                {
                    key: "writingMode",
                    get: function get() {
                        return this._structArray.uint8[this._pos1 + 36];
                    }
                },
                {
                    key: "placedOrientation",
                    get: function get() {
                        return this._structArray.uint8[this._pos1 + 37];
                    },
                    set: function set(t) {
                        this._structArray.uint8[this._pos1 + 37] = t;
                    }
                },
                {
                    key: "hidden",
                    get: function get() {
                        return this._structArray.uint8[this._pos1 + 38];
                    },
                    set: function set(t) {
                        this._structArray.uint8[this._pos1 + 38] = t;
                    }
                },
                {
                    key: "crossTileID",
                    get: function get() {
                        return this._structArray.uint32[this._pos4 + 10];
                    },
                    set: function set(t) {
                        this._structArray.uint32[this._pos4 + 10] = t;
                    }
                },
                {
                    key: "associatedIconIndex",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 22];
                    }
                }
            ]);
            return Da;
        }(ea);
        Da.prototype.size = 48;
        var za = /*#__PURE__*/ function(wa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(za, wa);
            function za() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, za);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, za, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(za, [
                {
                    key: "get",
                    value: function get(t) {
                        return new Da(this, t);
                    }
                }
            ]);
            return za;
        }(wa);
        ps("PlacedSymbolArray", za);
        var Pa = /*#__PURE__*/ function(ea) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Pa, ea);
            function Pa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Pa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Pa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Pa, [
                {
                    key: "anchorX",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 0];
                    }
                },
                {
                    key: "anchorY",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 1];
                    }
                },
                {
                    key: "rightJustifiedTextSymbolIndex",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 2];
                    }
                },
                {
                    key: "centerJustifiedTextSymbolIndex",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 3];
                    }
                },
                {
                    key: "leftJustifiedTextSymbolIndex",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 4];
                    }
                },
                {
                    key: "verticalPlacedTextSymbolIndex",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 5];
                    }
                },
                {
                    key: "placedIconSymbolIndex",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 6];
                    }
                },
                {
                    key: "verticalPlacedIconSymbolIndex",
                    get: function get() {
                        return this._structArray.int16[this._pos2 + 7];
                    }
                },
                {
                    key: "key",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 8];
                    }
                },
                {
                    key: "textBoxStartIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 9];
                    }
                },
                {
                    key: "textBoxEndIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 10];
                    }
                },
                {
                    key: "verticalTextBoxStartIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 11];
                    }
                },
                {
                    key: "verticalTextBoxEndIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 12];
                    }
                },
                {
                    key: "iconBoxStartIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 13];
                    }
                },
                {
                    key: "iconBoxEndIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 14];
                    }
                },
                {
                    key: "verticalIconBoxStartIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 15];
                    }
                },
                {
                    key: "verticalIconBoxEndIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 16];
                    }
                },
                {
                    key: "featureIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 17];
                    }
                },
                {
                    key: "numHorizontalGlyphVertices",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 18];
                    }
                },
                {
                    key: "numVerticalGlyphVertices",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 19];
                    }
                },
                {
                    key: "numIconVertices",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 20];
                    }
                },
                {
                    key: "numVerticalIconVertices",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 21];
                    }
                },
                {
                    key: "useRuntimeCollisionCircles",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 22];
                    }
                },
                {
                    key: "crossTileID",
                    get: function get() {
                        return this._structArray.uint32[this._pos4 + 12];
                    },
                    set: function set(t) {
                        this._structArray.uint32[this._pos4 + 12] = t;
                    }
                },
                {
                    key: "textBoxScale",
                    get: function get() {
                        return this._structArray.float32[this._pos4 + 13];
                    }
                },
                {
                    key: "collisionCircleDiameter",
                    get: function get() {
                        return this._structArray.float32[this._pos4 + 14];
                    }
                },
                {
                    key: "textAnchorOffsetStartIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 30];
                    }
                },
                {
                    key: "textAnchorOffsetEndIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 31];
                    }
                }
            ]);
            return Pa;
        }(ea);
        Pa.prototype.size = 64;
        var Ba = /*#__PURE__*/ function(_a) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ba, _a);
            function Ba() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ba);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ba, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ba, [
                {
                    key: "get",
                    value: function get(t) {
                        return new Pa(this, t);
                    }
                }
            ]);
            return Ba;
        }(_a);
        ps("SymbolInstanceArray", Ba);
        var Va = /*#__PURE__*/ function(Sa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Va, Sa);
            function Va() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Va);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Va, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Va, [
                {
                    key: "getoffsetX",
                    value: function getoffsetX(t) {
                        return this.float32[1 * t + 0];
                    }
                }
            ]);
            return Va;
        }(Sa);
        ps("GlyphOffsetArray", Va);
        var Ca = /*#__PURE__*/ function(aa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ca, aa);
            function Ca() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ca);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ca, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ca, [
                {
                    key: "getx",
                    value: function getx(t) {
                        return this.int16[3 * t + 0];
                    }
                },
                {
                    key: "gety",
                    value: function gety(t) {
                        return this.int16[3 * t + 1];
                    }
                },
                {
                    key: "gettileUnitDistanceFromAnchor",
                    value: function gettileUnitDistanceFromAnchor(t) {
                        return this.int16[3 * t + 2];
                    }
                }
            ]);
            return Ca;
        }(aa);
        ps("SymbolLineVertexArray", Ca);
        var La = /*#__PURE__*/ function(ea) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(La, ea);
            function La() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, La);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, La, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(La, [
                {
                    key: "textAnchor",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 0];
                    }
                },
                {
                    key: "textOffset0",
                    get: function get() {
                        return this._structArray.float32[this._pos4 + 1];
                    }
                },
                {
                    key: "textOffset1",
                    get: function get() {
                        return this._structArray.float32[this._pos4 + 2];
                    }
                }
            ]);
            return La;
        }(ea);
        La.prototype.size = 12;
        var Oa = /*#__PURE__*/ function(Aa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Oa, Aa);
            function Oa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Oa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Oa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Oa, [
                {
                    key: "get",
                    value: function get(t) {
                        return new La(this, t);
                    }
                }
            ]);
            return Oa;
        }(Aa);
        ps("TextAnchorOffsetArray", Oa);
        var Ra = /*#__PURE__*/ function(ea) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ra, ea);
            function Ra() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ra);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ra, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ra, [
                {
                    key: "featureIndex",
                    get: function get() {
                        return this._structArray.uint32[this._pos4 + 0];
                    }
                },
                {
                    key: "sourceLayerIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 2];
                    }
                },
                {
                    key: "bucketIndex",
                    get: function get() {
                        return this._structArray.uint16[this._pos2 + 3];
                    }
                }
            ]);
            return Ra;
        }(ea);
        Ra.prototype.size = 8;
        var Na = /*#__PURE__*/ function(ka) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Na, ka);
            function Na() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Na);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Na, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Na, [
                {
                    key: "get",
                    value: function get(t) {
                        return new Ra(this, t);
                    }
                }
            ]);
            return Na;
        }(ka);
        ps("FeatureIndexArray", Na);
        var $a = /*#__PURE__*/ function(sa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)($a, sa);
            function $a() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, $a);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, $a, arguments);
            }
            return $a;
        }(sa);
        var Ua = /*#__PURE__*/ function(sa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ua, sa);
            function Ua() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ua);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ua, arguments);
            }
            return Ua;
        }(sa);
        var qa = /*#__PURE__*/ function(sa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(qa, sa);
            function qa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, qa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, qa, arguments);
            }
            return qa;
        }(sa);
        var ja = /*#__PURE__*/ function(la) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ja, la);
            function ja() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ja);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ja, arguments);
            }
            return ja;
        }(la);
        var Ga = /*#__PURE__*/ function(ua) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ga, ua);
            function Ga() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ga);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ga, arguments);
            }
            return Ga;
        }(ua);
        var Xa = /*#__PURE__*/ function(ca) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Xa, ca);
            function Xa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Xa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Xa, arguments);
            }
            return Xa;
        }(ca);
        var Ya = /*#__PURE__*/ function(ha) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ya, ha);
            function Ya() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ya);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ya, arguments);
            }
            return Ya;
        }(ha);
        var Za = /*#__PURE__*/ function(pa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Za, pa);
            function Za() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Za);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Za, arguments);
            }
            return Za;
        }(pa);
        var Ha = /*#__PURE__*/ function(fa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ha, fa);
            function Ha() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ha);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ha, arguments);
            }
            return Ha;
        }(fa);
        var Ka = /*#__PURE__*/ function(da) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ka, da);
            function Ka() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ka);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ka, arguments);
            }
            return Ka;
        }(da);
        var Wa = /*#__PURE__*/ function(ya) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Wa, ya);
            function Wa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Wa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Wa, arguments);
            }
            return Wa;
        }(ya);
        var Ja = /*#__PURE__*/ function(ga) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ja, ga);
            function Ja() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ja);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ja, arguments);
            }
            return Ja;
        }(ga);
        var Qa = /*#__PURE__*/ function(va) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Qa, va);
            function Qa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Qa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Qa, arguments);
            }
            return Qa;
        }(va);
        var to = /*#__PURE__*/ function(ba) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(to, ba);
            function to() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, to);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, to, arguments);
            }
            return to;
        }(ba);
        var eo = /*#__PURE__*/ function(Ea) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(eo, Ea);
            function eo() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, eo);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, eo, arguments);
            }
            return eo;
        }(Ea);
        var ro = na([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), no = ro.members;
        var io = /*#__PURE__*/ function() {
            function io() {
                var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, io);
                this._forceNewSegmentOnNextPrepare = !1, this.segments = _$t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(io, [
                {
                    key: "prepareSegment",
                    value: function prepareSegment(t, e1, r, n) {
                        var i = this.segments[this.segments.length - 1];
                        return t > io.MAX_VERTEX_ARRAY_LENGTH && j("Max vertices per segment is ".concat(io.MAX_VERTEX_ARRAY_LENGTH, ": bucket requested ").concat(t, ". Consider using the `fillLargeMeshArrays` function if you require meshes with more than ").concat(io.MAX_VERTEX_ARRAY_LENGTH, " vertices.")), this._forceNewSegmentOnNextPrepare || !i || i.vertexLength + t > io.MAX_VERTEX_ARRAY_LENGTH || i.sortKey !== n ? this.createNewSegment(e1, r, n) : i;
                    }
                },
                {
                    key: "createNewSegment",
                    value: function createNewSegment(t, e1, r) {
                        var _$n = {
                            vertexOffset: t.length,
                            primitiveOffset: e1.length,
                            vertexLength: 0,
                            primitiveLength: 0,
                            vaos: {}
                        };
                        return void 0 !== r && (_$n.sortKey = r), this._forceNewSegmentOnNextPrepare = !1, this.segments.push(_$n), _$n;
                    }
                },
                {
                    key: "getOrCreateLatestSegment",
                    value: function getOrCreateLatestSegment(t, e1, r) {
                        return this.prepareSegment(0, t, e1, r);
                    }
                },
                {
                    key: "forceNewSegmentOnNextPrepare",
                    value: function forceNewSegmentOnNextPrepare() {
                        this._forceNewSegmentOnNextPrepare = !0;
                    }
                },
                {
                    key: "get",
                    value: function get() {
                        return this.segments;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.segments[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                for(var _$e in _$t.vaos)_$t.vaos[_$e].destroy();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
            ], [
                {
                    key: "simpleSegment",
                    value: function simpleSegment(t, e1, r, n) {
                        return new io([
                            {
                                vertexOffset: t,
                                primitiveOffset: e1,
                                vertexLength: r,
                                primitiveLength: n,
                                vaos: {},
                                sortKey: 0
                            }
                        ]);
                    }
                }
            ]);
            return io;
        }();
        function so(t, e1) {
            return 256 * (t = C(Math.floor(t), 0, 255)) + C(Math.floor(e1), 0, 255);
        }
        io.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, ps("SegmentVector", io);
        var ao = na([
            {
                name: "a_pattern_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pattern_to",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_from",
                components: 1,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio_to",
                components: 1,
                type: "Uint16"
            }
        ]), oo = na([
            {
                name: "a_dasharray_from",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_dasharray_to",
                components: 4,
                type: "Uint16"
            }
        ]);
        var lo, uo, co, ho = {
            exports: {}
        }, po = {
            exports: {}
        }, fo = {
            exports: {}
        }, yo = function() {
            if (co) return ho.exports;
            co = 1;
            var _$t = (lo || (lo = 1, po.exports = function(t, e1) {
                var _$r, _$n, i, s, a, o, l, u;
                for(_$n = t.length - (_$r = 3 & t.length), i = e1, a = 3432918353, o = 461845907, u = 0; u < _$n;)l = 255 & t.charCodeAt(u) | (255 & t.charCodeAt(++u)) << 8 | (255 & t.charCodeAt(++u)) << 16 | (255 & t.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (s >>> 16) & 65535) << 16);
                switch(l = 0, _$r){
                    case 3:
                        l ^= (255 & t.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & t.charCodeAt(u + 1)) << 8;
                    case 1:
                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & t.charCodeAt(u))) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
                }
                return i ^= t.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            }), po.exports), _$e = (uo || (uo = 1, fo.exports = function(t, e1) {
                for(var _$r, _$n = t.length, i = e1 ^ _$n, s = 0; _$n >= 4;)_$r = 1540483477 * (65535 & (_$r = 255 & t.charCodeAt(s) | (255 & t.charCodeAt(++s)) << 8 | (255 & t.charCodeAt(++s)) << 16 | (255 & t.charCodeAt(++s)) << 24)) + ((1540483477 * (_$r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (_$r = 1540483477 * (65535 & (_$r ^= _$r >>> 24)) + ((1540483477 * (_$r >>> 16) & 65535) << 16)), _$n -= 4, ++s;
                switch(_$n){
                    case 3:
                        i ^= (255 & t.charCodeAt(s + 2)) << 16;
                    case 2:
                        i ^= (255 & t.charCodeAt(s + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & t.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            }), fo.exports);
            return ho.exports = _$t, ho.exports.murmur3 = _$t, ho.exports.murmur2 = _$e, ho.exports;
        }(), mo = n(yo);
        var go = /*#__PURE__*/ function() {
            function go() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, go);
                this.ids = [], this.positions = [], this.indexed = !1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(go, [
                {
                    key: "add",
                    value: function add(t, e1, r, n) {
                        this.ids.push(xo(t)), this.positions.push(e1, r, n);
                    }
                },
                {
                    key: "getPositions",
                    value: function getPositions(t) {
                        if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                        var _$e = xo(t);
                        var _$r = 0, _$n = this.ids.length - 1;
                        for(; _$r < _$n;){
                            var _$t = _$r + _$n >> 1;
                            this.ids[_$t] >= _$e ? _$n = _$t : _$r = _$t + 1;
                        }
                        var i = [];
                        for(; this.ids[_$r] === _$e;)i.push({
                            index: this.positions[3 * _$r],
                            start: this.positions[3 * _$r + 1],
                            end: this.positions[3 * _$r + 2]
                        }), _$r++;
                        return i;
                    }
                }
            ], [
                {
                    key: "serialize",
                    value: function serialize(t, e1) {
                        var _$r = new Float64Array(t.ids), _$n = new Uint32Array(t.positions);
                        return vo(_$r, _$n, 0, _$r.length - 1), e1 && e1.push(_$r.buffer, _$n.buffer), {
                            ids: _$r,
                            positions: _$n
                        };
                    }
                },
                {
                    key: "deserialize",
                    value: function deserialize(t) {
                        var _$e = new go;
                        return _$e.ids = t.ids, _$e.positions = t.positions, _$e.indexed = !0, _$e;
                    }
                }
            ]);
            return go;
        }();
        function xo(t) {
            var _$e = +t;
            return !isNaN(_$e) && _$e <= Number.MAX_SAFE_INTEGER ? _$e : mo(String(t));
        }
        function vo(t, e1, r, n) {
            for(; r < n;){
                var i = t[r + n >> 1];
                var s = r - 1, a = n + 1;
                for(;;){
                    do s++;
                    while (t[s] < i);
                    do a--;
                    while (t[a] > i);
                    if (s >= a) break;
                    bo(t, s, a), bo(e1, 3 * s, 3 * a), bo(e1, 3 * s + 1, 3 * a + 1), bo(e1, 3 * s + 2, 3 * a + 2);
                }
                a - r < n - a ? (vo(t, e1, r, a), r = a + 1) : (vo(t, e1, a + 1, n), n = a);
            }
        }
        function bo(t, e1, r) {
            var _$n = t[e1];
            t[e1] = t[r], t[r] = _$n;
        }
        ps("FeaturePositionMap", go);
        var wo = function wo(t, e1) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, wo);
            this.gl = t.gl, this.location = e1;
        };
        var _o = /*#__PURE__*/ function(wo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_o, wo);
            function _o(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _o);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _o, [
                    t,
                    e1
                ]), _this.current = 0;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_o, [
                {
                    key: "set",
                    value: function set(t) {
                        this.current !== t && (this.current = t, this.gl.uniform1f(this.location, t));
                    }
                }
            ]);
            return _o;
        }(wo);
        var So = /*#__PURE__*/ function(wo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(So, wo);
            function So(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, So);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, So, [
                    t,
                    e1
                ]), _this.current = [
                    0,
                    0,
                    0,
                    0
                ];
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(So, [
                {
                    key: "set",
                    value: function set(t) {
                        t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] && t[3] === this.current[3] || (this.current = t, this.gl.uniform4f(this.location, t[0], t[1], t[2], t[3]));
                    }
                }
            ]);
            return So;
        }(wo);
        var Ao = /*#__PURE__*/ function(wo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ao, wo);
            function Ao(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ao);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Ao, [
                    t,
                    e1
                ]), _this.current = Te.transparent;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ao, [
                {
                    key: "set",
                    value: function set(t) {
                        t.r === this.current.r && t.g === this.current.g && t.b === this.current.b && t.a === this.current.a || (this.current = t, this.gl.uniform4f(this.location, t.r, t.g, t.b, t.a));
                    }
                }
            ]);
            return Ao;
        }(wo);
        var ko = new Float32Array(16);
        function Eo(t) {
            return [
                so(255 * t.r, 255 * t.g),
                so(255 * t.b, 255 * t.a)
            ];
        }
        var To = /*#__PURE__*/ function() {
            function To(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, To);
                this.value = t, this.uniformNames = e1.map(function(t) {
                    return "u_".concat(t);
                }), this.type = r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(To, [
                {
                    key: "setUniform",
                    value: function setUniform(t, e1, r) {
                        t.set(r.constantOr(this.value));
                    }
                },
                {
                    key: "getBinding",
                    value: function getBinding(t, e1, r) {
                        return "color" === this.type ? new Ao(t, e1) : new _o(t, e1);
                    }
                }
            ]);
            return To;
        }();
        var Io = /*#__PURE__*/ function() {
            function Io(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Io);
                this.uniformNames = e1.map(function(t) {
                    return "u_".concat(t);
                }), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Io, [
                {
                    key: "setConstantPatternPositions",
                    value: function setConstantPatternPositions(t, e1) {
                        this.pixelRatioFrom = e1.pixelRatio, this.pixelRatioTo = t.pixelRatio, this.patternFrom = e1.tlbr, this.patternTo = t.tlbr;
                    }
                },
                {
                    key: "setConstantDashPositions",
                    value: function setConstantDashPositions(t, e1) {
                        this.dashTo = [
                            0,
                            t.y,
                            t.height,
                            t.width
                        ], this.dashFrom = [
                            0,
                            e1.y,
                            e1.height,
                            e1.width
                        ];
                    }
                },
                {
                    key: "setUniform",
                    value: function setUniform(t, e1, r, n) {
                        var i = null;
                        "u_pattern_to" === n ? i = this.patternTo : "u_pattern_from" === n ? i = this.patternFrom : "u_dasharray_to" === n ? i = this.dashTo : "u_dasharray_from" === n ? i = this.dashFrom : "u_pixel_ratio_to" === n ? i = this.pixelRatioTo : "u_pixel_ratio_from" === n && (i = this.pixelRatioFrom), null !== i && t.set(i);
                    }
                },
                {
                    key: "getBinding",
                    value: function getBinding(t, e1, r) {
                        return "u_pattern" === r.substr(0, 9) || "u_dasharray_" === r.substr(0, 12) ? new So(t, e1) : new _o(t, e1);
                    }
                }
            ]);
            return Io;
        }();
        var Mo = /*#__PURE__*/ function() {
            function Mo(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Mo);
                this.expression = t, this.type = r, this.maxValue = 0, this.paintVertexAttributes = e1.map(function(t) {
                    return {
                        name: "a_".concat(t),
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    };
                }), this.paintVertexArray = new n;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Mo, [
                {
                    key: "populatePaintArray",
                    value: function populatePaintArray(t, e1, r) {
                        var _$n = this.paintVertexArray.length, i = this.expression.evaluate(new Ps(0, r), e1, {}, r.canonical, [], r.formattedSection);
                        this.paintVertexArray.resize(t), this._setPaintValue(_$n, t, i);
                    }
                },
                {
                    key: "updatePaintArray",
                    value: function updatePaintArray(t, e1, r, n, i) {
                        var s = this.expression.evaluate(new Ps(0, i), r, n);
                        this._setPaintValue(t, e1, s);
                    }
                },
                {
                    key: "_setPaintValue",
                    value: function _setPaintValue(t, e1, r) {
                        if ("color" === this.type) {
                            var _$n = Eo(r);
                            for(var _$r = t; _$r < e1; _$r++)this.paintVertexArray.emplace(_$r, _$n[0], _$n[1]);
                        } else {
                            for(var _$n1 = t; _$n1 < e1; _$n1++)this.paintVertexArray.emplace(_$n1, r);
                            this.maxValue = Math.max(this.maxValue, Math.abs(r));
                        }
                    }
                },
                {
                    key: "upload",
                    value: function upload(t) {
                        this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                    }
                }
            ]);
            return Mo;
        }();
        var Fo = /*#__PURE__*/ function() {
            function Fo(t, e1, r, n, i, s) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Fo);
                this.expression = t, this.uniformNames = e1.map(function(t) {
                    return "u_".concat(t, "_t");
                }), this.type = r, this.useIntegerZoom = n, this.zoom = i, this.maxValue = 0, this.paintVertexAttributes = e1.map(function(t) {
                    return {
                        name: "a_".concat(t),
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    };
                }), this.paintVertexArray = new s;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Fo, [
                {
                    key: "populatePaintArray",
                    value: function populatePaintArray(t, e1, r) {
                        var _$n = this.expression.evaluate(new Ps(this.zoom, r), e1, {}, r.canonical, [], r.formattedSection), i = this.expression.evaluate(new Ps(this.zoom + 1, r), e1, {}, r.canonical, [], r.formattedSection), s = this.paintVertexArray.length;
                        this.paintVertexArray.resize(t), this._setPaintValue(s, t, _$n, i);
                    }
                },
                {
                    key: "updatePaintArray",
                    value: function updatePaintArray(t, e1, r, n, i) {
                        var s = this.expression.evaluate(new Ps(this.zoom, i), r, n), a = this.expression.evaluate(new Ps(this.zoom + 1, i), r, n);
                        this._setPaintValue(t, e1, s, a);
                    }
                },
                {
                    key: "_setPaintValue",
                    value: function _setPaintValue(t, e1, r, n) {
                        if ("color" === this.type) {
                            var i = Eo(r), s = Eo(n);
                            for(var _$r = t; _$r < e1; _$r++)this.paintVertexArray.emplace(_$r, i[0], i[1], s[0], s[1]);
                        } else {
                            for(var i1 = t; i1 < e1; i1++)this.paintVertexArray.emplace(i1, r, n);
                            this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                        }
                    }
                },
                {
                    key: "upload",
                    value: function upload(t) {
                        this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = t.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                    }
                },
                {
                    key: "setUniform",
                    value: function setUniform(t, e1) {
                        var _$r = this.useIntegerZoom ? Math.floor(e1.zoom) : e1.zoom, _$n = C(this.expression.interpolationFactor(_$r, this.zoom, this.zoom + 1), 0, 1);
                        t.set(_$n);
                    }
                },
                {
                    key: "getBinding",
                    value: function getBinding(t, e1, r) {
                        return new _o(t, e1);
                    }
                }
            ]);
            return Fo;
        }();
        var Do = /*#__PURE__*/ function() {
            function Do(t, e1, r, n, i, s) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Do);
                this.expression = t, this.type = e1, this.useIntegerZoom = r, this.zoom = n, this.layerId = s, this.zoomInPaintVertexArray = new i, this.zoomOutPaintVertexArray = new i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Do, [
                {
                    key: "populatePaintArray",
                    value: function populatePaintArray(t, e1, r) {
                        var _$n = this.zoomInPaintVertexArray.length;
                        this.zoomInPaintVertexArray.resize(t), this.zoomOutPaintVertexArray.resize(t), this._setPaintValues(_$n, t, this.getPositionIds(e1), r);
                    }
                },
                {
                    key: "updatePaintArray",
                    value: function updatePaintArray(t, e1, r, n, i) {
                        this._setPaintValues(t, e1, this.getPositionIds(r), i);
                    }
                },
                {
                    key: "_setPaintValues",
                    value: function _setPaintValues(t, e1, r, n) {
                        var i = this.getPositions(n);
                        if (!i || !r) return;
                        var s = i[r.min], a = i[r.mid], o = i[r.max];
                        if (s && a && o) for(var _$r = t; _$r < e1; _$r++)this.emplace(this.zoomInPaintVertexArray, _$r, a, s), this.emplace(this.zoomOutPaintVertexArray, _$r, a, o);
                    }
                },
                {
                    key: "upload",
                    value: function upload(t) {
                        if (this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer) {
                            var _$e = this.getVertexAttributes();
                            this.zoomInPaintVertexBuffer = t.createVertexBuffer(this.zoomInPaintVertexArray, _$e, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = t.createVertexBuffer(this.zoomOutPaintVertexArray, _$e, this.expression.isStateDependent);
                        }
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
                    }
                }
            ]);
            return Do;
        }();
        var zo = /*#__PURE__*/ function(Do) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(zo, Do);
            function zo() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, zo);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, zo, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(zo, [
                {
                    key: "getPositions",
                    value: function getPositions(t) {
                        return t.imagePositions;
                    }
                },
                {
                    key: "getPositionIds",
                    value: function getPositionIds(t) {
                        return t.patterns && t.patterns[this.layerId];
                    }
                },
                {
                    key: "getVertexAttributes",
                    value: function getVertexAttributes() {
                        return ao.members;
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n) {
                        t.emplace(e1, r.tlbr[0], r.tlbr[1], r.tlbr[2], r.tlbr[3], n.tlbr[0], n.tlbr[1], n.tlbr[2], n.tlbr[3], r.pixelRatio, n.pixelRatio);
                    }
                }
            ]);
            return zo;
        }(Do);
        var Po = /*#__PURE__*/ function(Do) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Po, Do);
            function Po() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Po);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Po, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Po, [
                {
                    key: "getPositions",
                    value: function getPositions(t) {
                        return t.dashPositions;
                    }
                },
                {
                    key: "getPositionIds",
                    value: function getPositionIds(t) {
                        return t.dashes && t.dashes[this.layerId];
                    }
                },
                {
                    key: "getVertexAttributes",
                    value: function getVertexAttributes() {
                        return oo.members;
                    }
                },
                {
                    key: "emplace",
                    value: function emplace(t, e1, r, n) {
                        t.emplace(e1, 0, r.y, r.height, r.width, 0, n.y, n.height, n.width);
                    }
                }
            ]);
            return Po;
        }(Do);
        var Bo = /*#__PURE__*/ function() {
            function Bo(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Bo);
                this.binders = {}, this._buffers = [];
                var _$n = [];
                for(var i in t.paint._values){
                    if (!r(i)) continue;
                    var s = t.paint.get(i);
                    if (!(s instanceof Us && qn(s.property.specification))) continue;
                    var a = Co(i, t.type), o = s.value, l = s.property.specification.type, u = s.property.useIntegerZoom, _$c = s.property.specification["property-type"], _$h = "cross-faded" === _$c || "cross-faded-data-driven" === _$c;
                    if ("constant" === o.kind) this.binders[i] = _$h ? new Io(o.value, a) : new To(o.value, a, l), _$n.push("/u_".concat(i));
                    else if ("source" === o.kind || _$h) {
                        var _$r = Lo(i, l, "source");
                        this.binders[i] = _$h ? "line-dasharray" === i ? new Po(o, l, u, e1, _$r, t.id) : new zo(o, l, u, e1, _$r, t.id) : new Mo(o, a, l, _$r), _$n.push("/a_".concat(i));
                    } else {
                        var _$t = Lo(i, l, "composite");
                        this.binders[i] = new Fo(o, a, l, u, e1, _$t), _$n.push("/z_".concat(i));
                    }
                }
                this.cacheKey = _$n.sort().join("");
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Bo, [
                {
                    key: "getMaxValue",
                    value: function getMaxValue(t) {
                        var _$e = this.binders[t];
                        return _$e instanceof Mo || _$e instanceof Fo ? _$e.maxValue : 0;
                    }
                },
                {
                    key: "populatePaintArrays",
                    value: function populatePaintArrays(t, e1, r) {
                        for(var _$n in this.binders){
                            var i = this.binders[_$n];
                            (i instanceof Mo || i instanceof Fo || i instanceof Do) && i.populatePaintArray(t, e1, r);
                        }
                    }
                },
                {
                    key: "setConstantPatternPositions",
                    value: function setConstantPatternPositions(t, e1) {
                        for(var _$r in this.binders){
                            var _$n = this.binders[_$r];
                            _$n instanceof Io && _$n.setConstantPatternPositions(t, e1);
                        }
                    }
                },
                {
                    key: "setConstantDashPositions",
                    value: function setConstantDashPositions(t, e1) {
                        for(var _$r in this.binders){
                            var _$n = this.binders[_$r];
                            _$n instanceof Io && _$n.setConstantDashPositions(t, e1);
                        }
                    }
                },
                {
                    key: "updatePaintArrays",
                    value: function updatePaintArrays(t, e1, r, n, i) {
                        var s = !1;
                        for(var a in t){
                            var o = e1.getPositions(a);
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    var o1 = r.feature(_$e.index);
                                    for(var _$r in this.binders){
                                        var l = this.binders[_$r];
                                        if ((l instanceof Mo || l instanceof Fo || l instanceof Do) && !0 === l.expression.isStateDependent) {
                                            var u = n.paint.get(_$r);
                                            l.expression = u.value, l.updatePaintArray(_$e.start, _$e.end, o1, t[a], i), s = !0;
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return s;
                    }
                },
                {
                    key: "defines",
                    value: function defines() {
                        var _$t = [];
                        for(var _$e in this.binders){
                            var _t;
                            var _$r = this.binders[_$e];
                            (_$r instanceof To || _$r instanceof Io) && (_t = _$t).push.apply(_t, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$r.uniformNames.map(function(t) {
                                return "#define HAS_UNIFORM_".concat(t);
                            })));
                        }
                        return _$t;
                    }
                },
                {
                    key: "getBinderAttributes",
                    value: function getBinderAttributes() {
                        var _$t = [];
                        for(var _$e in this.binders){
                            var _$r = this.binders[_$e];
                            if (_$r instanceof Mo || _$r instanceof Fo) for(var _$e1 = 0; _$e1 < _$r.paintVertexAttributes.length; _$e1++)_$t.push(_$r.paintVertexAttributes[_$e1].name);
                            else if (_$r instanceof Do) {
                                var _$e2 = _$r.getVertexAttributes();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = _$e2[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$r1 = _step.value;
                                        _$t.push(_$r1.name);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        }
                        return _$t;
                    }
                },
                {
                    key: "getBinderUniforms",
                    value: function getBinderUniforms() {
                        var _$t = [];
                        for(var _$e in this.binders){
                            var _$r = this.binders[_$e];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (_$r instanceof To || _$r instanceof Io || _$r instanceof Fo) try {
                                for(var _iterator = _$r.uniformNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e1 = _step.value;
                                    _$t.push(_$e1);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return _$t;
                    }
                },
                {
                    key: "getPaintVertexBuffers",
                    value: function getPaintVertexBuffers() {
                        return this._buffers;
                    }
                },
                {
                    key: "getUniforms",
                    value: function getUniforms(t, e1) {
                        var _$r = [];
                        for(var _$n in this.binders){
                            var i = this.binders[_$n];
                            if (i instanceof To || i instanceof Io || i instanceof Fo) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = i.uniformNames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var s = _step.value;
                                        if (e1[s]) {
                                            var a = i.getBinding(t, e1[s], s);
                                            _$r.push({
                                                name: s,
                                                property: _$n,
                                                binding: a
                                            });
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        }
                        return _$r;
                    }
                },
                {
                    key: "setUniforms",
                    value: function setUniforms(t, e1, r, n) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, _$t = _step_value.name, i = _step_value.property, s = _step_value.binding;
                                this.binders[i].setUniform(s, n, r.get(i), _$t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "updatePaintBuffers",
                    value: function updatePaintBuffers(t) {
                        this._buffers = [];
                        for(var _$e in this.binders){
                            var _$r = this.binders[_$e];
                            if (t && _$r instanceof Do) {
                                var _$e1 = 2 === t.fromScale ? _$r.zoomInPaintVertexBuffer : _$r.zoomOutPaintVertexBuffer;
                                _$e1 && this._buffers.push(_$e1);
                            } else (_$r instanceof Mo || _$r instanceof Fo) && _$r.paintVertexBuffer && this._buffers.push(_$r.paintVertexBuffer);
                        }
                    }
                },
                {
                    key: "upload",
                    value: function upload(t) {
                        for(var _$e in this.binders){
                            var _$r = this.binders[_$e];
                            (_$r instanceof Mo || _$r instanceof Fo || _$r instanceof Do) && _$r.upload(t);
                        }
                        this.updatePaintBuffers();
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        for(var _$t in this.binders){
                            var _$e = this.binders[_$t];
                            (_$e instanceof Mo || _$e instanceof Fo || _$e instanceof Do) && _$e.destroy();
                        }
                    }
                }
            ]);
            return Bo;
        }();
        var Vo = /*#__PURE__*/ function() {
            function Vo(t, e1) {
                var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
                    return !0;
                };
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Vo);
                this.programConfigurations = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$n = _step.value;
                        this.programConfigurations[_$n.id] = new Bo(_$n, e1, _$r);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                this.needsUpload = !1, this._featureMap = new go, this._bufferOffset = 0;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Vo, [
                {
                    key: "populatePaintArrays",
                    value: function populatePaintArrays(t, e1, r, n) {
                        for(var _$r in this.programConfigurations)this.programConfigurations[_$r].populatePaintArrays(t, e1, n);
                        void 0 !== e1.id && this._featureMap.add(e1.id, r, this._bufferOffset, t), this._bufferOffset = t, this.needsUpload = !0;
                    }
                },
                {
                    key: "updatePaintArrays",
                    value: function updatePaintArrays(t, e1, r, n) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                this.needsUpload = this.programConfigurations[i.id].updatePaintArrays(t, this._featureMap, e1, i, n) || this.needsUpload;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "get",
                    value: function get(t) {
                        return this.programConfigurations[t];
                    }
                },
                {
                    key: "upload",
                    value: function upload(t) {
                        if (this.needsUpload) {
                            for(var _$e in this.programConfigurations)this.programConfigurations[_$e].upload(t);
                            this.needsUpload = !1;
                        }
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        for(var _$t in this.programConfigurations)this.programConfigurations[_$t].destroy();
                    }
                }
            ]);
            return Vo;
        }();
        function Co(t, e1) {
            return ({
                "text-opacity": [
                    "opacity"
                ],
                "icon-opacity": [
                    "opacity"
                ],
                "text-color": [
                    "fill_color"
                ],
                "icon-color": [
                    "fill_color"
                ],
                "text-halo-color": [
                    "halo_color"
                ],
                "icon-halo-color": [
                    "halo_color"
                ],
                "text-halo-blur": [
                    "halo_blur"
                ],
                "icon-halo-blur": [
                    "halo_blur"
                ],
                "text-halo-width": [
                    "halo_width"
                ],
                "icon-halo-width": [
                    "halo_width"
                ],
                "line-gap-width": [
                    "gapwidth"
                ],
                "line-dasharray": [
                    "dasharray_to",
                    "dasharray_from"
                ],
                "line-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ],
                "fill-extrusion-pattern": [
                    "pattern_to",
                    "pattern_from",
                    "pixel_ratio_to",
                    "pixel_ratio_from"
                ]
            })[t] || [
                t.replace("".concat(e1, "-"), "").replace(/-/g, "_")
            ];
        }
        function Lo(t, e1, r) {
            var _$n = {
                color: {
                    source: ca,
                    composite: Ia
                },
                number: {
                    source: Sa,
                    composite: ca
                }
            }, i = function(t) {
                return ({
                    "line-pattern": {
                        source: Ya,
                        composite: Ya
                    },
                    "fill-pattern": {
                        source: Ya,
                        composite: Ya
                    },
                    "fill-extrusion-pattern": {
                        source: Ya,
                        composite: Ya
                    },
                    "line-dasharray": {
                        source: Za,
                        composite: Za
                    }
                })[t];
            }(t);
            return i && i[r] || _$n[e1][r];
        }
        ps("ConstantBinder", To), ps("CrossFadedConstantBinder", Io), ps("SourceExpressionBinder", Mo), ps("CrossFadedPatternBinder", zo), ps("CrossFadedDasharrayBinder", Po), ps("CompositeExpressionBinder", Fo), ps("ProgramConfiguration", Bo, {
            omit: [
                "_buffers"
            ]
        }), ps("ProgramConfigurationSet", Vo);
        var Oo = Math.pow(2, 14) - 1, Ro = -Oo - 1;
        function No(t) {
            var _$e = M / t.extent, _$r = t.loadGeometry();
            for(var _$t = 0; _$t < _$r.length; _$t++){
                var _$n = _$r[_$t];
                for(var _$t1 = 0; _$t1 < _$n.length; _$t1++){
                    var _$r1 = _$n[_$t1], i = Math.round(_$r1.x * _$e), s = Math.round(_$r1.y * _$e);
                    _$r1.x = C(i, Ro, Oo), _$r1.y = C(s, Ro, Oo), (i < _$r1.x || i > _$r1.x + 1 || s < _$r1.y || s > _$r1.y + 1) && j("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                }
            }
            return _$r;
        }
        function $o(t, e1) {
            return {
                type: t.type,
                id: t.id,
                properties: t.properties,
                geometry: e1 ? No(t) : []
            };
        }
        var Uo = -32768;
        function qo(t, e1, r, n, i) {
            t.emplaceBack(Uo + 8 * e1 + n, Uo + 8 * r + i);
        }
        var jo = /*#__PURE__*/ function() {
            function jo(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, jo);
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function(t) {
                    return t.id;
                }), this.index = t.index, this.hasDependencies = !1, this.layoutVertexArray = new Ua, this.indexArray = new to, this.segments = new io, this.programConfigurations = new Vo(t.layers, t.zoom), this.stateDependentLayerIds = this.layers.filter(function(t) {
                    return t.isStateDependent();
                }).map(function(t) {
                    return t.id;
                });
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(jo, [
                {
                    key: "populate",
                    value: function populate(t, e1, r) {
                        var _$n = this.layers[0], i = [];
                        var s = null, a = !1, o = "heatmap" === _$n.type;
                        if ("circle" === _$n.type) {
                            var _$t = _$n;
                            s = _$t.layout.get("circle-sort-key"), a = !s.isConstant(), o = o || "map" === _$t.paint.get("circle-pitch-alignment");
                        }
                        var l = o ? e1.subdivisionGranularity.circle : 1;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, _$e = _step_value.feature, _$n1 = _step_value.id, o1 = _step_value.index, l1 = _step_value.sourceLayerIndex;
                                var _$t1 = this.layers[0]._featureFilter.needGeometry, u = $o(_$e, _$t1);
                                if (!this.layers[0]._featureFilter.filter(new Ps(this.zoom), u, r)) continue;
                                var _$c = a ? s.evaluate(u, {}, r) : void 0, _$h = {
                                    id: _$n1,
                                    properties: _$e.properties,
                                    type: _$e.type,
                                    sourceLayerIndex: l1,
                                    index: o1,
                                    geometry: _$t1 ? u.geometry : No(_$e),
                                    patterns: {},
                                    sortKey: _$c
                                };
                                i.push(_$h);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        a && i.sort(function(t, e1) {
                            return t.sortKey - e1.sortKey;
                        });
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = i[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$n2 = _step1.value;
                                var i1 = _$n2.geometry, s1 = _$n2.index, a1 = _$n2.sourceLayerIndex, o2 = t[s1].feature;
                                this.addFeature(_$n2, i1, s1, r, l), e1.featureIndex.insert(o2, i1, s1, a1, this.index);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                },
                {
                    key: "update",
                    value: function update(t, e1, r) {
                        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e1, this.stateDependentLayers, {
                            imagePositions: r
                        });
                    }
                },
                {
                    key: "isEmpty",
                    value: function isEmpty() {
                        return 0 === this.layoutVertexArray.length;
                    }
                },
                {
                    key: "uploadPending",
                    value: function uploadPending() {
                        return !this.uploaded || this.programConfigurations.needsUpload;
                    }
                },
                {
                    key: "upload",
                    value: function upload(t) {
                        this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, no), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                    }
                },
                {
                    key: "addFeature",
                    value: function addFeature(t, e1, r, n) {
                        var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1;
                        var s;
                        switch(i){
                            case 1:
                                s = [
                                    0,
                                    7
                                ];
                                break;
                            case 3:
                                s = [
                                    0,
                                    2,
                                    5,
                                    7
                                ];
                                break;
                            case 5:
                                s = [
                                    0,
                                    1,
                                    3,
                                    4,
                                    6,
                                    7
                                ];
                                break;
                            case 7:
                                s = [
                                    0,
                                    1,
                                    2,
                                    3,
                                    4,
                                    5,
                                    6,
                                    7
                                ];
                                break;
                            default:
                                throw new Error("Invalid circle bucket granularity: ".concat(i, "; valid values are 1, 3, 5, 7."));
                        }
                        var a = s.length;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                var _$r = _step.value;
                                try {
                                    for(var _iterator1 = _$r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                        var _$e = _step1.value;
                                        var _$r1 = _$e.x, _$n = _$e.y;
                                        if (_$r1 < 0 || _$r1 >= M || _$n < 0 || _$n >= M) continue;
                                        var i1 = this.segments.prepareSegment(a * a, this.layoutVertexArray, this.indexArray, t.sortKey), o = i1.vertexLength;
                                        for(var _$t = 0; _$t < a; _$t++)for(var _$e1 = 0; _$e1 < a; _$e1++)qo(this.layoutVertexArray, _$r1, _$n, s[_$e1], s[_$t]);
                                        for(var _$t1 = 0; _$t1 < a - 1; _$t1++)for(var _$e2 = 0; _$e2 < a - 1; _$e2++){
                                            var _$r2 = o + _$t1 * a + _$e2, _$n1 = o + (_$t1 + 1) * a + _$e2;
                                            this.indexArray.emplaceBack(_$r2, _$n1 + 1, _$r2 + 1), this.indexArray.emplaceBack(_$r2, _$n1, _$n1 + 1);
                                        }
                                        i1.vertexLength += a * a, i1.primitiveLength += (a - 1) * (a - 1) * 2;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, {
                            imagePositions: {},
                            canonical: n
                        });
                    }
                }
            ]);
            return jo;
        }();
        function Go(t, e1) {
            for(var _$r = 0; _$r < t.length; _$r++)if (tl(e1, t[_$r])) return !0;
            for(var _$r1 = 0; _$r1 < e1.length; _$r1++)if (tl(t, e1[_$r1])) return !0;
            return !!Ho(t, e1);
        }
        function Xo(t, e1, r) {
            return !!tl(t, e1) || !!Wo(e1, t, r);
        }
        function Yo(t, e1) {
            if (1 === t.length) return Qo(e1, t[0]);
            for(var _$r = 0; _$r < e1.length; _$r++){
                var _$n = e1[_$r];
                for(var _$e = 0; _$e < _$n.length; _$e++)if (tl(t, _$n[_$e])) return !0;
            }
            for(var _$r1 = 0; _$r1 < t.length; _$r1++)if (Qo(e1, t[_$r1])) return !0;
            for(var _$r2 = 0; _$r2 < e1.length; _$r2++)if (Ho(t, e1[_$r2])) return !0;
            return !1;
        }
        function Zo(t, e1, r) {
            if (t.length > 1) {
                if (Ho(t, e1)) return !0;
                for(var _$n = 0; _$n < e1.length; _$n++)if (Wo(e1[_$n], t, r)) return !0;
            }
            for(var _$n1 = 0; _$n1 < t.length; _$n1++)if (Wo(t[_$n1], e1, r)) return !0;
            return !1;
        }
        function Ho(t, e1) {
            if (0 === t.length || 0 === e1.length) return !1;
            for(var _$r = 0; _$r < t.length - 1; _$r++){
                var _$n = t[_$r], i = t[_$r + 1];
                for(var _$t = 0; _$t < e1.length - 1; _$t++)if (Ko(_$n, i, e1[_$t], e1[_$t + 1])) return !0;
            }
            return !1;
        }
        function Ko(t, e1, r, n) {
            return G(t, r, n) !== G(e1, r, n) && G(t, e1, r) !== G(t, e1, n);
        }
        function Wo(t, e1, r) {
            var _$n = r * r;
            if (1 === e1.length) return t.distSqr(e1[0]) < _$n;
            for(var _$r = 1; _$r < e1.length; _$r++)if (Jo(t, e1[_$r - 1], e1[_$r]) < _$n) return !0;
            return !1;
        }
        function Jo(t, e1, r) {
            var _$n = e1.distSqr(r);
            if (0 === _$n) return t.distSqr(e1);
            var i = ((t.x - e1.x) * (r.x - e1.x) + (t.y - e1.y) * (r.y - e1.y)) / _$n;
            return t.distSqr(i < 0 ? e1 : i > 1 ? r : r.sub(e1)._mult(i)._add(e1));
        }
        function Qo(t, e1) {
            var _$r, _$n, i, s = !1;
            for(var a = 0; a < t.length; a++){
                _$r = t[a];
                for(var _$t = 0, a1 = _$r.length - 1; _$t < _$r.length; a1 = _$t++)_$n = _$r[_$t], i = _$r[a1], _$n.y > e1.y != i.y > e1.y && e1.x < (i.x - _$n.x) * (e1.y - _$n.y) / (i.y - _$n.y) + _$n.x && (s = !s);
            }
            return s;
        }
        function tl(t, e1) {
            var _$r = !1;
            for(var _$n = 0, i = t.length - 1; _$n < t.length; i = _$n++){
                var s = t[_$n], a = t[i];
                s.y > e1.y != a.y > e1.y && e1.x < (a.x - s.x) * (e1.y - s.y) / (a.y - s.y) + s.x && (_$r = !_$r);
            }
            return _$r;
        }
        function el(t, e1, r) {
            var _$n = r[0], i = r[2];
            if (t.x < _$n.x && e1.x < _$n.x || t.x > i.x && e1.x > i.x || t.y < _$n.y && e1.y < _$n.y || t.y > i.y && e1.y > i.y) return !1;
            var s = G(t, e1, r[0]);
            return s !== G(t, e1, r[1]) || s !== G(t, e1, r[2]) || s !== G(t, e1, r[3]);
        }
        function rl(t, e1, r) {
            var _$n = e1.paint.get(t).value;
            return "constant" === _$n.kind ? _$n.value : r.programConfigurations.get(e1.id).getMaxValue(t);
        }
        function nl(t) {
            return Math.sqrt(t[0] * t[0] + t[1] * t[1]);
        }
        function il(t, e1, n, i, s) {
            if (!e1[0] && !e1[1]) return t;
            var a = r.convert(e1)._mult(s);
            "viewport" === n && a._rotate(-i);
            var o = [];
            for(var _$e = 0; _$e < t.length; _$e++)o.push(t[_$e].sub(a));
            return o;
        }
        function sl(t) {
            var _$e = [];
            for(var _$r = 0; _$r < t.length; _$r++){
                var _$n = t[_$r], i = _$e.at(-1);
                (0 === _$r || i && !_$n.equals(i)) && _$e.push(_$n);
            }
            return _$e;
        }
        function al(param, r) {
            var _$t = param.queryGeometry, _$e = param.size;
            return Xo(_$t, r, _$e);
        }
        function ol(param, s) {
            var _$t = param.queryGeometry, _$e = param.size, _$r = param.transform, _$n = param.unwrappedTileID, i = param.getElevation;
            return Xo(_$t, s, _$e * (_$r.projectTileCoordinates(s.x, s.y, _$n, i).signedDistanceFromCamera / _$r.cameraToCenterDistance));
        }
        function ll(param, s) {
            var _$t = param.queryGeometry, _$e = param.size, _$r = param.transform, _$n = param.unwrappedTileID, i = param.getElevation;
            var a = _$r.projectTileCoordinates(s.x, s.y, _$n, i).signedDistanceFromCamera, o = _$e * (_$r.cameraToCenterDistance / a);
            return Xo(_$t, hl(s, _$r, _$n, i), o);
        }
        function ul(param, s) {
            var _$t = param.queryGeometry, _$e = param.size, _$r = param.transform, _$n = param.unwrappedTileID, i = param.getElevation;
            return Xo(_$t, hl(s, _$r, _$n, i), _$e);
        }
        function cl(param, o) {
            var _$t = param.queryGeometry, _$e = param.size, _$r = param.transform, _$n = param.unwrappedTileID, i = param.getElevation, tmp = param.pitchAlignment, s = tmp === void 0 ? "map" : tmp, tmp1 = param.pitchScale, a = tmp1 === void 0 ? "map" : tmp1;
            var l = "map" === s ? "map" === a ? al : ol : "map" === a ? ll : ul, u = {
                queryGeometry: _$t,
                size: _$e,
                transform: _$r,
                unwrappedTileID: _$n,
                getElevation: i
            };
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                    var _$t1 = _step.value;
                    try {
                        for(var _iterator1 = _$t1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                            var _$e1 = _step1.value;
                            if (l(u, _$e1)) return !0;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return !1;
        }
        function hl(t, e1, n, i) {
            var s = e1.projectTileCoordinates(t.x, t.y, n, i).point;
            return new r((.5 * s.x + .5) * e1.width, (.5 * -s.y + .5) * e1.height);
        }
        var pl, fl;
        ps("CircleBucket", jo, {
            omit: [
                "layers"
            ]
        });
        var dl = {
            get paint () {
                return fl = fl || new Hs({
                    "circle-radius": new Gs(vt.paint_circle["circle-radius"]),
                    "circle-color": new Gs(vt.paint_circle["circle-color"]),
                    "circle-blur": new Gs(vt.paint_circle["circle-blur"]),
                    "circle-opacity": new Gs(vt.paint_circle["circle-opacity"]),
                    "circle-translate": new js(vt.paint_circle["circle-translate"]),
                    "circle-translate-anchor": new js(vt.paint_circle["circle-translate-anchor"]),
                    "circle-pitch-scale": new js(vt.paint_circle["circle-pitch-scale"]),
                    "circle-pitch-alignment": new js(vt.paint_circle["circle-pitch-alignment"]),
                    "circle-stroke-width": new Gs(vt.paint_circle["circle-stroke-width"]),
                    "circle-stroke-color": new Gs(vt.paint_circle["circle-stroke-color"]),
                    "circle-stroke-opacity": new Gs(vt.paint_circle["circle-stroke-opacity"])
                });
            },
            get layout () {
                return pl = pl || new Hs({
                    "circle-sort-key": new Gs(vt.layout_circle["circle-sort-key"])
                });
            }
        };
        var yl = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(yl, Ks);
            function yl(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, yl);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, yl, [
                    t,
                    dl,
                    e1
                ]);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(yl, [
                {
                    key: "createBucket",
                    value: function createBucket(t) {
                        return new jo(t);
                    }
                },
                {
                    key: "queryRadius",
                    value: function queryRadius(t) {
                        var _$e = t;
                        return rl("circle-radius", this, _$e) + rl("circle-stroke-width", this, _$e) + nl(this.paint.get("circle-translate"));
                    }
                },
                {
                    key: "queryIntersectsFeature",
                    value: function queryIntersectsFeature(param) {
                        var _$t = param.queryGeometry, _$e = param.feature, _$r = param.featureState, _$n = param.geometry, i = param.transform, s = param.pixelsToTileUnits, a = param.unwrappedTileID, o = param.getElevation;
                        var l = il(_$t, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), -i.bearingInRadians, s), u = this.paint.get("circle-radius").evaluate(_$e, _$r) + this.paint.get("circle-stroke-width").evaluate(_$e, _$r), _$c = this.paint.get("circle-pitch-scale"), _$h = this.paint.get("circle-pitch-alignment");
                        var p, f;
                        return "map" === _$h ? (p = l, f = u * s) : (p = function(t, e1, r, n) {
                            return t.map(function(t) {
                                return hl(t, e1, r, n);
                            });
                        }(l, i, a, o), f = u), cl({
                            queryGeometry: p,
                            size: f,
                            transform: i,
                            unwrappedTileID: a,
                            getElevation: o,
                            pitchAlignment: _$h,
                            pitchScale: _$c
                        }, _$n);
                    }
                }
            ]);
            return yl;
        }(Ks);
        var ml = /*#__PURE__*/ function(jo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ml, jo);
            function ml() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ml);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ml, arguments);
            }
            return ml;
        }(jo);
        var gl;
        ps("HeatmapBucket", ml, {
            omit: [
                "layers"
            ]
        });
        var xl = {
            get paint () {
                return gl = gl || new Hs({
                    "heatmap-radius": new Gs(vt.paint_heatmap["heatmap-radius"]),
                    "heatmap-weight": new Gs(vt.paint_heatmap["heatmap-weight"]),
                    "heatmap-intensity": new js(vt.paint_heatmap["heatmap-intensity"]),
                    "heatmap-color": new Zs(vt.paint_heatmap["heatmap-color"]),
                    "heatmap-opacity": new js(vt.paint_heatmap["heatmap-opacity"])
                });
            }
        };
        function vl(t, param, n, i) {
            var _$e = param.width, _$r = param.height;
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== _$e * _$r * n) throw new RangeError("mismatched image size. expected: ".concat(i.length, " but got: ").concat(_$e * _$r * n));
            } else i = new Uint8Array(_$e * _$r * n);
            return t.width = _$e, t.height = _$r, t.data = i, t;
        }
        function bl(t, param, n) {
            var _$e = param.width, _$r = param.height;
            if (_$e === t.width && _$r === t.height) return;
            var i = vl({}, {
                width: _$e,
                height: _$r
            }, n);
            wl(t, i, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(t.width, _$e),
                height: Math.min(t.height, _$r)
            }, n), t.width = _$e, t.height = _$r, t.data = i.data;
        }
        function wl(t, e1, r, n, i, s) {
            if (0 === i.width || 0 === i.height) return e1;
            if (i.width > t.width || i.height > t.height || r.x > t.width - i.width || r.y > t.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > e1.width || i.height > e1.height || n.x > e1.width - i.width || n.y > e1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            var a = t.data, o = e1.data;
            if (a === o) throw new Error("srcData equals dstData, so image is already copied");
            for(var l = 0; l < i.height; l++){
                var u = ((r.y + l) * t.width + r.x) * s, _$c = ((n.y + l) * e1.width + n.x) * s;
                for(var _$t = 0; _$t < i.width * s; _$t++)o[_$c + _$t] = a[u + _$t];
            }
            return e1;
        }
        var _l = /*#__PURE__*/ function() {
            function _l(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _l);
                vl(this, t, 1, e1);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_l, [
                {
                    key: "resize",
                    value: function resize(t) {
                        bl(this, t, 1);
                    }
                },
                {
                    key: "clone",
                    value: function clone() {
                        return new _l({
                            width: this.width,
                            height: this.height
                        }, new Uint8Array(this.data));
                    }
                }
            ], [
                {
                    key: "copy",
                    value: function copy(t, e1, r, n, i) {
                        wl(t, e1, r, n, i, 1);
                    }
                }
            ]);
            return _l;
        }();
        var Sl = /*#__PURE__*/ function() {
            function Sl(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Sl);
                vl(this, t, 4, e1);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Sl, [
                {
                    key: "resize",
                    value: function resize(t) {
                        bl(this, t, 4);
                    }
                },
                {
                    key: "replace",
                    value: function replace(t, e1) {
                        e1 ? this.data.set(t) : this.data = t instanceof Uint8ClampedArray ? new Uint8Array(t.buffer) : t;
                    }
                },
                {
                    key: "clone",
                    value: function clone() {
                        return new Sl({
                            width: this.width,
                            height: this.height
                        }, new Uint8Array(this.data));
                    }
                },
                {
                    key: "setPixel",
                    value: function setPixel(t, e1, r) {
                        var _$n = 4 * (t * this.width + e1);
                        this.data[_$n + 0] = Math.round(255 * r.r / r.a), this.data[_$n + 1] = Math.round(255 * r.g / r.a), this.data[_$n + 2] = Math.round(255 * r.b / r.a), this.data[_$n + 3] = Math.round(255 * r.a);
                    }
                }
            ], [
                {
                    key: "copy",
                    value: function copy(t, e1, r, n, i) {
                        wl(t, e1, r, n, i, 4);
                    }
                }
            ]);
            return Sl;
        }();
        function Al(t) {
            var _$e = {}, _$r = t.resolution || 256, _$n = t.clips ? t.clips.length : 1, i = t.image || new Sl({
                width: _$r,
                height: _$n
            });
            if (Math.log(_$r) / Math.LN2 % 1 != 0) throw new Error("width is not a power of 2 - ".concat(_$r));
            var s = function(n, s, a) {
                _$e[t.evaluationKey] = a;
                var o = t.expression.evaluate(_$e);
                i.setPixel(n / 4 / _$r, s / 4, o);
            };
            if (t.clips) for(var _$e1 = 0, i1 = 0; _$e1 < _$n; ++_$e1, i1 += 4 * _$r)for(var _$n1 = 0, a = 0; _$n1 < _$r; _$n1++, a += 4){
                var o = _$n1 / (_$r - 1), _t_clips_e = t.clips[_$e1], l = _t_clips_e.start, u = _t_clips_e.end;
                s(i1, a, l * (1 - o) + u * o);
            }
            else for(var _$t = 0, _$e2 = 0; _$t < _$r; _$t++, _$e2 += 4)s(0, _$e2, _$t / (_$r - 1));
            return i;
        }
        ps("AlphaImage", _l), ps("RGBAImage", Sl);
        var kl = "big-fb";
        var El = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(El, Ks);
            function El(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, El);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, El, [
                    t,
                    xl,
                    e1
                ]), _this.heatmapFbos = new Map, _this._updateColorRamp();
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(El, [
                {
                    key: "createBucket",
                    value: function createBucket(t) {
                        return new ml(t);
                    }
                },
                {
                    key: "_handleSpecialPaintPropertyUpdate",
                    value: function _handleSpecialPaintPropertyUpdate(t) {
                        "heatmap-color" === t && this._updateColorRamp();
                    }
                },
                {
                    key: "_updateColorRamp",
                    value: function _updateColorRamp() {
                        this.colorRamp = Al({
                            expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                            evaluationKey: "heatmapDensity",
                            image: this.colorRamp
                        }), this.colorRampTexture = null;
                    }
                },
                {
                    key: "resize",
                    value: function resize() {
                        this.heatmapFbos.has(kl) && this.heatmapFbos.delete(kl);
                    }
                },
                {
                    key: "queryRadius",
                    value: function queryRadius(t) {
                        return rl("heatmap-radius", this, t);
                    }
                },
                {
                    key: "queryIntersectsFeature",
                    value: function queryIntersectsFeature(param) {
                        var _$t = param.queryGeometry, _$e = param.feature, _$r = param.featureState, _$n = param.geometry, i = param.transform, s = param.pixelsToTileUnits, a = param.unwrappedTileID, o = param.getElevation;
                        return cl({
                            queryGeometry: _$t,
                            size: this.paint.get("heatmap-radius").evaluate(_$e, _$r) * s,
                            transform: i,
                            unwrappedTileID: a,
                            getElevation: o
                        }, _$n);
                    }
                },
                {
                    key: "hasOffscreenPass",
                    value: function hasOffscreenPass() {
                        return 0 !== this.paint.get("heatmap-opacity") && !this.isHidden();
                    }
                }
            ]);
            return El;
        }(Ks);
        var Tl;
        var Il = {
            get paint () {
                return Tl = Tl || new Hs({
                    "hillshade-illumination-direction": new js(vt.paint_hillshade["hillshade-illumination-direction"]),
                    "hillshade-illumination-altitude": new js(vt.paint_hillshade["hillshade-illumination-altitude"]),
                    "hillshade-illumination-anchor": new js(vt.paint_hillshade["hillshade-illumination-anchor"]),
                    "hillshade-exaggeration": new js(vt.paint_hillshade["hillshade-exaggeration"]),
                    "hillshade-shadow-color": new js(vt.paint_hillshade["hillshade-shadow-color"]),
                    "hillshade-highlight-color": new js(vt.paint_hillshade["hillshade-highlight-color"]),
                    "hillshade-accent-color": new js(vt.paint_hillshade["hillshade-accent-color"]),
                    "hillshade-method": new js(vt.paint_hillshade["hillshade-method"])
                });
            }
        };
        var Ml = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ml, Ks);
            function Ml(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ml);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Ml, [
                    t,
                    Il,
                    e1
                ]), _this.recalculate({
                    zoom: 0,
                    zoomHistory: {}
                }, void 0);
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ml, [
                {
                    key: "getIlluminationProperties",
                    value: function getIlluminationProperties() {
                        var _$t = this.paint.get("hillshade-illumination-direction").values, _$e = this.paint.get("hillshade-illumination-altitude").values, _$r = this.paint.get("hillshade-highlight-color").values, _$n = this.paint.get("hillshade-shadow-color").values;
                        var i = Math.max(_$t.length, _$e.length, _$r.length, _$n.length);
                        _$t = _$t.concat(Array(i - _$t.length).fill(_$t.at(-1))), _$e = _$e.concat(Array(i - _$e.length).fill(_$e.at(-1))), _$r = _$r.concat(Array(i - _$r.length).fill(_$r.at(-1))), _$n = _$n.concat(Array(i - _$n.length).fill(_$n.at(-1)));
                        var s = _$e.map(tt);
                        return {
                            directionRadians: _$t.map(tt),
                            altitudeRadians: s,
                            shadowColor: _$n,
                            highlightColor: _$r
                        };
                    }
                },
                {
                    key: "hasOffscreenPass",
                    value: function hasOffscreenPass() {
                        return 0 !== this.paint.get("hillshade-exaggeration") && !this.isHidden();
                    }
                }
            ]);
            return Ml;
        }(Ks);
        var Fl;
        var Dl = {
            get paint () {
                return Fl = Fl || new Hs({
                    "color-relief-opacity": new js(vt["paint_color-relief"]["color-relief-opacity"]),
                    "color-relief-color": new Zs(vt["paint_color-relief"]["color-relief-color"])
                });
            }
        };
        var zl = /*#__PURE__*/ function() {
            function zl(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, zl);
                this.context = t, this.format = r, this.texture = t.gl.createTexture(), this.update(e1, n);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(zl, [
                {
                    key: "update",
                    value: function update(t, e1, r) {
                        var _$n = t.width, i = t.height, s = !(this.size && this.size[0] === _$n && this.size[1] === i || r), _this = this, a = _this.context, o = a.gl;
                        if (this.useMipmap = Boolean(e1 && e1.useMipmap), o.bindTexture(o.TEXTURE_2D, this.texture), a.pixelStoreUnpackFlipY.set(!1), a.pixelStoreUnpack.set(1), a.pixelStoreUnpackPremultiplyAlpha.set(this.format === o.RGBA && (!e1 || !1 !== e1.premultiply)), s) this.size = [
                            _$n,
                            i
                        ], t instanceof HTMLImageElement || t instanceof HTMLCanvasElement || t instanceof HTMLVideoElement || t instanceof ImageData || Z(t) ? o.texImage2D(o.TEXTURE_2D, 0, this.format, this.format, o.UNSIGNED_BYTE, t) : o.texImage2D(o.TEXTURE_2D, 0, this.format, _$n, i, 0, this.format, o.UNSIGNED_BYTE, t.data);
                        else {
                            var _ref = r || {
                                x: 0,
                                y: 0
                            }, _$e = _ref.x, s1 = _ref.y;
                            t instanceof HTMLImageElement || t instanceof HTMLCanvasElement || t instanceof HTMLVideoElement || t instanceof ImageData || Z(t) ? o.texSubImage2D(o.TEXTURE_2D, 0, _$e, s1, o.RGBA, o.UNSIGNED_BYTE, t) : o.texSubImage2D(o.TEXTURE_2D, 0, _$e, s1, _$n, i, o.RGBA, o.UNSIGNED_BYTE, t.data);
                        }
                        this.useMipmap && this.isSizePowerOfTwo() && o.generateMipmap(o.TEXTURE_2D), a.pixelStoreUnpackFlipY.setDefault(), a.pixelStoreUnpack.setDefault(), a.pixelStoreUnpackPremultiplyAlpha.setDefault();
                    }
                },
                {
                    key: "bind",
                    value: function bind(t, e1, r) {
                        var _this = this, _$n = _this.context, i = _$n.gl;
                        i.bindTexture(i.TEXTURE_2D, this.texture), r !== i.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (r = i.LINEAR), t !== this.filter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, t), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, r || t), this.filter = t), e1 !== this.wrap && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, e1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, e1), this.wrap = e1);
                    }
                },
                {
                    key: "isSizePowerOfTwo",
                    value: function isSizePowerOfTwo() {
                        return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        var _this_context = this.context, _$t = _this_context.gl;
                        _$t.deleteTexture(this.texture), this.texture = null;
                    }
                }
            ]);
            return zl;
        }();
        var Pl = /*#__PURE__*/ function() {
            function Pl(t, e1, r) {
                var _$n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1, i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 1, s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : 1, a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Pl);
                if (this.uid = t, e1.height !== e1.width) throw new RangeError("DEM tiles must be square");
                if (r && ![
                    "mapbox",
                    "terrarium",
                    "custom"
                ].includes(r)) return void j('"'.concat(r, '" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".'));
                this.stride = e1.height;
                var o = this.dim = e1.height - 2;
                switch(this.data = new Uint32Array(e1.data.buffer), r){
                    case "terrarium":
                        this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                        break;
                    case "custom":
                        this.redFactor = _$n, this.greenFactor = i, this.blueFactor = s, this.baseShift = a;
                        break;
                    default:
                        this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                }
                for(var _$t = 0; _$t < o; _$t++)this.data[this._idx(-1, _$t)] = this.data[this._idx(0, _$t)], this.data[this._idx(o, _$t)] = this.data[this._idx(o - 1, _$t)], this.data[this._idx(_$t, -1)] = this.data[this._idx(_$t, 0)], this.data[this._idx(_$t, o)] = this.data[this._idx(_$t, o - 1)];
                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(o, -1)] = this.data[this._idx(o - 1, 0)], this.data[this._idx(-1, o)] = this.data[this._idx(0, o - 1)], this.data[this._idx(o, o)] = this.data[this._idx(o - 1, o - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                for(var _$t1 = 0; _$t1 < o; _$t1++)for(var _$e = 0; _$e < o; _$e++){
                    var _$r = this.get(_$t1, _$e);
                    _$r > this.max && (this.max = _$r), _$r < this.min && (this.min = _$r);
                }
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Pl, [
                {
                    key: "get",
                    value: function get(t, e1) {
                        var _$r = new Uint8Array(this.data.buffer), _$n = 4 * this._idx(t, e1);
                        return this.unpack(_$r[_$n], _$r[_$n + 1], _$r[_$n + 2]);
                    }
                },
                {
                    key: "getUnpackVector",
                    value: function getUnpackVector() {
                        return [
                            this.redFactor,
                            this.greenFactor,
                            this.blueFactor,
                            this.baseShift
                        ];
                    }
                },
                {
                    key: "_idx",
                    value: function _idx(t, e1) {
                        if (t < -1 || t >= this.dim + 1 || e1 < -1 || e1 >= this.dim + 1) throw new RangeError("Out of range source coordinates for DEM data. x: ".concat(t, ", y: ").concat(e1, ", dim: ").concat(this.dim));
                        return (e1 + 1) * this.stride + (t + 1);
                    }
                },
                {
                    key: "unpack",
                    value: function unpack(t, e1, r) {
                        return t * this.redFactor + e1 * this.greenFactor + r * this.blueFactor - this.baseShift;
                    }
                },
                {
                    key: "pack",
                    value: function pack(t) {
                        return Bl(t, this.getUnpackVector());
                    }
                },
                {
                    key: "getPixels",
                    value: function getPixels() {
                        return new Sl({
                            width: this.stride,
                            height: this.stride
                        }, new Uint8Array(this.data.buffer));
                    }
                },
                {
                    key: "backfillBorder",
                    value: function backfillBorder(t, e1, r) {
                        if (this.dim !== t.dim) throw new Error("dem dimension mismatch");
                        var _$n = e1 * this.dim, i = e1 * this.dim + this.dim, s = r * this.dim, a = r * this.dim + this.dim;
                        switch(e1){
                            case -1:
                                _$n = i - 1;
                                break;
                            case 1:
                                i = _$n + 1;
                        }
                        switch(r){
                            case -1:
                                s = a - 1;
                                break;
                            case 1:
                                a = s + 1;
                        }
                        var o = -e1 * this.dim, l = -r * this.dim;
                        for(var _$e = s; _$e < a; _$e++)for(var _$r = _$n; _$r < i; _$r++)this.data[this._idx(_$r, _$e)] = t.data[this._idx(_$r + o, _$e + l)];
                    }
                }
            ]);
            return Pl;
        }();
        function Bl(t, e1) {
            var _$r = e1[0], _$n = e1[1], i = e1[2], s = e1[3], a = Math.min(_$r, _$n, i), o = Math.round((t + s) / a);
            return {
                r: Math.floor(o * a / _$r) % 256,
                g: Math.floor(o * a / _$n) % 256,
                b: Math.floor(o * a / i) % 256
            };
        }
        ps("DEMData", Pl);
        var Vl = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Vl, Ks);
            function Vl(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Vl);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Vl, [
                    t,
                    Dl,
                    e1
                ]);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Vl, [
                {
                    key: "_createColorRamp",
                    value: function _createColorRamp(t) {
                        var _$e = {
                            elevationStops: [],
                            colorStops: []
                        }, _$r = this._transitionablePaint._values["color-relief-color"].value.expression;
                        if (_$r instanceof ii && _$r._styleExpression.expression instanceof fr) {
                            this.colorRampExpression = _$r;
                            var _$t = _$r._styleExpression.expression;
                            _$e.elevationStops = _$t.labels, _$e.colorStops = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = _$e.elevationStops[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$r1 = _step.value;
                                    _$e.colorStops.push(_$t.evaluate({
                                        globals: {
                                            elevation: _$r1
                                        }
                                    }));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (_$e.elevationStops.length < 1 && (_$e.elevationStops = [
                            0
                        ], _$e.colorStops = [
                            Te.transparent
                        ]), _$e.elevationStops.length < 2 && (_$e.elevationStops.push(_$e.elevationStops[0] + 1), _$e.colorStops.push(_$e.colorStops[0])), _$e.elevationStops.length <= t) return _$e;
                        var _$n = {
                            elevationStops: [],
                            colorStops: []
                        }, i = (_$e.elevationStops.length - 1) / (t - 1);
                        for(var _$t1 = 0; _$t1 < _$e.elevationStops.length - .5; _$t1 += i)_$n.elevationStops.push(_$e.elevationStops[Math.round(_$t1)]), _$n.colorStops.push(_$e.colorStops[Math.round(_$t1)]);
                        return j("Too many colors in specification of ".concat(this.id, " color-relief layer, may not render properly. Max possible colors: ").concat(t, ", provided: ").concat(_$e.elevationStops.length)), _$n;
                    }
                },
                {
                    key: "_colorRampChanged",
                    value: function _colorRampChanged() {
                        return this.colorRampExpression != this._transitionablePaint._values["color-relief-color"].value.expression;
                    }
                },
                {
                    key: "getColorRampTextures",
                    value: function getColorRampTextures(t, e1, r) {
                        if (this.colorRampTextures && !this._colorRampChanged()) return this.colorRampTextures;
                        var _$n = this._createColorRamp(e1), i = new Sl({
                            width: _$n.colorStops.length,
                            height: 1
                        }), s = new Sl({
                            width: _$n.colorStops.length,
                            height: 1
                        });
                        for(var _$t = 0; _$t < _$n.elevationStops.length; _$t++){
                            var _$e = Bl(_$n.elevationStops[_$t], r);
                            s.setPixel(0, _$t, new Te(_$e.r / 255, _$e.g / 255, _$e.b / 255, 1)), i.setPixel(0, _$t, _$n.colorStops[_$t]);
                        }
                        return this.colorRampTextures = {
                            elevationTexture: new zl(t, s, t.gl.RGBA),
                            colorTexture: new zl(t, i, t.gl.RGBA)
                        }, this.colorRampTextures;
                    }
                },
                {
                    key: "hasOffscreenPass",
                    value: function hasOffscreenPass() {
                        return !this.isHidden() && !!this.colorRampTextures;
                    }
                }
            ]);
            return Vl;
        }(Ks);
        var Cl = na([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), Ll = Cl.members;
        function Ol(t, e1, r) {
            var _$n = r.patternDependencies;
            var i = !1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$r = _step.value;
                    var _$e = _$r.paint.get("".concat(t, "-pattern"));
                    _$e.isConstant() || (i = !0);
                    var s = _$e.constantOr(null);
                    s && (i = !0, _$n[s.to] = !0, _$n[s.from] = !0);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return i;
        }
        function Rl(t, e1, r, n, i) {
            var s = n.zoom, a = i.patternDependencies;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$n = _step.value;
                    var _$e = _$n.paint.get("".concat(t, "-pattern")).value;
                    if ("constant" !== _$e.kind) {
                        var _$t = _$e.evaluate({
                            zoom: s - 1
                        }, r, {}, i.availableImages), o = _$e.evaluate({
                            zoom: s
                        }, r, {}, i.availableImages), l = _$e.evaluate({
                            zoom: s + 1
                        }, r, {}, i.availableImages);
                        _$t = _$t && _$t.name ? _$t.name : _$t, o = o && o.name ? o.name : o, l = l && l.name ? l.name : l, a[_$t] = !0, a[o] = !0, a[l] = !0, r.patterns[_$n.id] = {
                            min: _$t,
                            mid: o,
                            max: l
                        };
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return r;
        }
        function Nl(t, e1, r, n, i) {
            var s;
            if (i === function(t, e1, r, n) {
                var _$i = 0;
                for(var s = e1, a = r - n; s < r; s += n)_$i += (t[a] - t[s]) * (t[s + 1] + t[a + 1]), a = s;
                return _$i;
            }(t, e1, r, n) > 0) for(var _$i = e1; _$i < r; _$i += n)s = lu(_$i / n | 0, t[_$i], t[_$i + 1], s);
            else for(var _$i1 = r - n; _$i1 >= e1; _$i1 -= n)s = lu(_$i1 / n | 0, t[_$i1], t[_$i1 + 1], s);
            return s && ru(s, s.next) && (uu(s), s = s.next), s;
        }
        function $l(t, e1) {
            if (!t) return t;
            e1 || (e1 = t);
            var _$r, _$n = t;
            do if (_$r = !1, _$n.steiner || !ru(_$n, _$n.next) && 0 !== eu(_$n.prev, _$n, _$n.next)) _$n = _$n.next;
            else {
                if (uu(_$n), _$n = e1 = _$n.prev, _$n === _$n.next) break;
                _$r = !0;
            }
            while (_$r || _$n !== e1);
            return e1;
        }
        function Ul(t, e1, r, n, i, s, a) {
            if (!t) return;
            !a && s && function(t, e1, r, n) {
                var _$i = t;
                do 0 === _$i.z && (_$i.z = Kl(_$i.x, _$i.y, e1, r, n)), _$i.prevZ = _$i.prev, _$i.nextZ = _$i.next, _$i = _$i.next;
                while (_$i !== t);
                _$i.prevZ.nextZ = null, _$i.prevZ = null, function(t) {
                    var _$e, _$r = 1;
                    do {
                        var _$n = void 0, _$i = t;
                        t = null;
                        var _$s = null;
                        for(_$e = 0; _$i;){
                            _$e++;
                            var _$a = _$i, o = 0;
                            for(var _$t = 0; _$t < _$r && (o++, _$a = _$a.nextZ, _$a); _$t++);
                            var l = _$r;
                            for(; o > 0 || l > 0 && _$a;)0 !== o && (0 === l || !_$a || _$i.z <= _$a.z) ? (_$n = _$i, _$i = _$i.nextZ, o--) : (_$n = _$a, _$a = _$a.nextZ, l--), _$s ? _$s.nextZ = _$n : t = _$n, _$n.prevZ = _$s, _$s = _$n;
                            _$i = _$a;
                        }
                        _$s.nextZ = null, _$r *= 2;
                    }while (_$e > 1);
                }(_$i);
            }(t, n, i, s);
            var o = t;
            for(; t.prev !== t.next;){
                var l = t.prev, u = t.next;
                if (s ? jl(t, n, i, s) : ql(t)) e1.push(l.i, t.i, u.i), uu(t), t = u.next, o = u.next;
                else if ((t = u) === o) {
                    a ? 1 === a ? Ul(t = Gl($l(t), e1), e1, r, n, i, s, 2) : 2 === a && Xl(t, e1, r, n, i, s) : Ul($l(t), e1, r, n, i, s, 1);
                    break;
                }
            }
        }
        function ql(t) {
            var _$e = t.prev, _$r = t, _$n = t.next;
            if (eu(_$e, _$r, _$n) >= 0) return !1;
            var i = _$e.x, s = _$r.x, a = _$n.x, o = _$e.y, l = _$r.y, u = _$n.y, _$c = Math.min(i, s, a), _$h = Math.min(o, l, u), p = Math.max(i, s, a), f = Math.max(o, l, u);
            var _$d = _$n.next;
            for(; _$d !== _$e;){
                if (_$d.x >= _$c && _$d.x <= p && _$d.y >= _$h && _$d.y <= f && Ql(i, o, s, l, a, u, _$d.x, _$d.y) && eu(_$d.prev, _$d, _$d.next) >= 0) return !1;
                _$d = _$d.next;
            }
            return !0;
        }
        function jl(t, e1, r, n) {
            var i = t.prev, s = t, a = t.next;
            if (eu(i, s, a) >= 0) return !1;
            var o = i.x, l = s.x, u = a.x, _$c = i.y, _$h = s.y, p = a.y, f = Math.min(o, l, u), _$d = Math.min(_$c, _$h, p), _$y = Math.max(o, l, u), _$m = Math.max(_$c, _$h, p), _$g = Kl(f, _$d, e1, r, n), _$x = Kl(_$y, _$m, e1, r, n);
            var _$v = t.prevZ, _$b = t.nextZ;
            for(; _$v && _$v.z >= _$g && _$b && _$b.z <= _$x;){
                if (_$v.x >= f && _$v.x <= _$y && _$v.y >= _$d && _$v.y <= _$m && _$v !== i && _$v !== a && Ql(o, _$c, l, _$h, u, p, _$v.x, _$v.y) && eu(_$v.prev, _$v, _$v.next) >= 0) return !1;
                if (_$v = _$v.prevZ, _$b.x >= f && _$b.x <= _$y && _$b.y >= _$d && _$b.y <= _$m && _$b !== i && _$b !== a && Ql(o, _$c, l, _$h, u, p, _$b.x, _$b.y) && eu(_$b.prev, _$b, _$b.next) >= 0) return !1;
                _$b = _$b.nextZ;
            }
            for(; _$v && _$v.z >= _$g;){
                if (_$v.x >= f && _$v.x <= _$y && _$v.y >= _$d && _$v.y <= _$m && _$v !== i && _$v !== a && Ql(o, _$c, l, _$h, u, p, _$v.x, _$v.y) && eu(_$v.prev, _$v, _$v.next) >= 0) return !1;
                _$v = _$v.prevZ;
            }
            for(; _$b && _$b.z <= _$x;){
                if (_$b.x >= f && _$b.x <= _$y && _$b.y >= _$d && _$b.y <= _$m && _$b !== i && _$b !== a && Ql(o, _$c, l, _$h, u, p, _$b.x, _$b.y) && eu(_$b.prev, _$b, _$b.next) >= 0) return !1;
                _$b = _$b.nextZ;
            }
            return !0;
        }
        function Gl(t, e1) {
            var _$r = t;
            do {
                var _$n = _$r.prev, i = _$r.next.next;
                !ru(_$n, i) && nu(_$n, _$r, _$r.next, i) && au(_$n, i) && au(i, _$n) && (e1.push(_$n.i, _$r.i, i.i), uu(_$r), uu(_$r.next), _$r = t = i), _$r = _$r.next;
            }while (_$r !== t);
            return $l(_$r);
        }
        function Xl(t, e1, r, n, i, s) {
            var a = t;
            do {
                var _$t = a.next.next;
                for(; _$t !== a.prev;){
                    if (a.i !== _$t.i && tu(a, _$t)) {
                        var o = ou(a, _$t);
                        return a = $l(a, a.next), o = $l(o, o.next), Ul(a, e1, r, n, i, s, 0), void Ul(o, e1, r, n, i, s, 0);
                    }
                    _$t = _$t.next;
                }
                a = a.next;
            }while (a !== t);
        }
        function Yl(t, e1) {
            var _$r = t.x - e1.x;
            return 0 === _$r && (_$r = t.y - e1.y, 0 === _$r) && (_$r = (t.next.y - t.y) / (t.next.x - t.x) - (e1.next.y - e1.y) / (e1.next.x - e1.x)), _$r;
        }
        function Zl(t, e1) {
            var _$r = function(t, e1) {
                var _$r = e1;
                var _$n = t.x, i = t.y;
                var s, a = -1 / 0;
                if (ru(t, _$r)) return _$r;
                do {
                    if (ru(t, _$r.next)) return _$r.next;
                    if (i <= _$r.y && i >= _$r.next.y && _$r.next.y !== _$r.y) {
                        var _$t = _$r.x + (i - _$r.y) * (_$r.next.x - _$r.x) / (_$r.next.y - _$r.y);
                        if (_$t <= _$n && _$t > a && (a = _$t, s = _$r.x < _$r.next.x ? _$r : _$r.next, _$t === _$n)) return s;
                    }
                    _$r = _$r.next;
                }while (_$r !== e1);
                if (!s) return null;
                var o = s, l = s.x, u = s.y;
                var _$c = 1 / 0;
                _$r = s;
                do {
                    if (_$n >= _$r.x && _$r.x >= l && _$n !== _$r.x && Jl(i < u ? _$n : a, i, l, u, i < u ? a : _$n, i, _$r.x, _$r.y)) {
                        var _$e = Math.abs(i - _$r.y) / (_$n - _$r.x);
                        au(_$r, t) && (_$e < _$c || _$e === _$c && (_$r.x > s.x || _$r.x === s.x && Hl(s, _$r))) && (s = _$r, _$c = _$e);
                    }
                    _$r = _$r.next;
                }while (_$r !== o);
                return s;
            }(t, e1);
            if (!_$r) return e1;
            var _$n = ou(_$r, t);
            return $l(_$n, _$n.next), $l(_$r, _$r.next);
        }
        function Hl(t, e1) {
            return eu(t.prev, t, e1.prev) < 0 && eu(e1.next, t, t.next) < 0;
        }
        function Kl(t, e1, r, n, i) {
            return (t = 1431655765 & ((t = 858993459 & ((t = 252645135 & ((t = 16711935 & ((t = (t - r) * i | 0) | t << 8)) | t << 4)) | t << 2)) | t << 1)) | (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - n) * i | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) << 1;
        }
        function Wl(t) {
            var _$e = t, _$r = t;
            do (_$e.x < _$r.x || _$e.x === _$r.x && _$e.y < _$r.y) && (_$r = _$e), _$e = _$e.next;
            while (_$e !== t);
            return _$r;
        }
        function Jl(t, e1, r, n, i, s, a, o) {
            return (i - a) * (e1 - o) >= (t - a) * (s - o) && (t - a) * (n - o) >= (r - a) * (e1 - o) && (r - a) * (s - o) >= (i - a) * (n - o);
        }
        function Ql(t, e1, r, n, i, s, a, o) {
            return !(t === a && e1 === o) && Jl(t, e1, r, n, i, s, a, o);
        }
        function tu(t, e1) {
            return t.next.i !== e1.i && t.prev.i !== e1.i && !function(t, e1) {
                var _$r = t;
                do {
                    if (_$r.i !== t.i && _$r.next.i !== t.i && _$r.i !== e1.i && _$r.next.i !== e1.i && nu(_$r, _$r.next, t, e1)) return !0;
                    _$r = _$r.next;
                }while (_$r !== t);
                return !1;
            }(t, e1) && (au(t, e1) && au(e1, t) && function(t, e1) {
                var _$r = t, _$n = !1;
                var i = (t.x + e1.x) / 2, s = (t.y + e1.y) / 2;
                do _$r.y > s != _$r.next.y > s && _$r.next.y !== _$r.y && i < (_$r.next.x - _$r.x) * (s - _$r.y) / (_$r.next.y - _$r.y) + _$r.x && (_$n = !_$n), _$r = _$r.next;
                while (_$r !== t);
                return _$n;
            }(t, e1) && (eu(t.prev, t, e1.prev) || eu(t, e1.prev, e1)) || ru(t, e1) && eu(t.prev, t, t.next) > 0 && eu(e1.prev, e1, e1.next) > 0);
        }
        function eu(t, e1, r) {
            return (e1.y - t.y) * (r.x - e1.x) - (e1.x - t.x) * (r.y - e1.y);
        }
        function ru(t, e1) {
            return t.x === e1.x && t.y === e1.y;
        }
        function nu(t, e1, r, n) {
            var i = su(eu(t, e1, r)), s = su(eu(t, e1, n)), a = su(eu(r, n, t)), o = su(eu(r, n, e1));
            return i !== s && a !== o || !(0 !== i || !iu(t, r, e1)) || !(0 !== s || !iu(t, n, e1)) || !(0 !== a || !iu(r, t, n)) || !(0 !== o || !iu(r, e1, n));
        }
        function iu(t, e1, r) {
            return e1.x <= Math.max(t.x, r.x) && e1.x >= Math.min(t.x, r.x) && e1.y <= Math.max(t.y, r.y) && e1.y >= Math.min(t.y, r.y);
        }
        function su(t) {
            return t > 0 ? 1 : t < 0 ? -1 : 0;
        }
        function au(t, e1) {
            return eu(t.prev, t, t.next) < 0 ? eu(t, e1, t.next) >= 0 && eu(t, t.prev, e1) >= 0 : eu(t, e1, t.prev) < 0 || eu(t, t.next, e1) < 0;
        }
        function ou(t, e1) {
            var _$r = cu(t.i, t.x, t.y), _$n = cu(e1.i, e1.x, e1.y), i = t.next, s = e1.prev;
            return t.next = e1, e1.prev = t, _$r.next = i, i.prev = _$r, _$n.next = _$r, _$r.prev = _$n, s.next = _$n, _$n.prev = s, _$n;
        }
        function lu(t, e1, r, n) {
            var i = cu(t, e1, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function uu(t) {
            t.next.prev = t.prev, t.prev.next = t.next, t.prevZ && (t.prevZ.nextZ = t.nextZ), t.nextZ && (t.nextZ.prevZ = t.prevZ);
        }
        function cu(t, e1, r) {
            return {
                i: t,
                x: e1,
                y: r,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        var hu = /*#__PURE__*/ function() {
            function hu(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, hu);
                if (e1 > t) throw new Error("Min granularity must not be greater than base granularity.");
                this._baseZoomGranularity = t, this._minGranularity = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(hu, [
                {
                    key: "getGranularityForZoomLevel",
                    value: function getGranularityForZoomLevel(t) {
                        return Math.max(Math.floor(this._baseZoomGranularity / (1 << t)), this._minGranularity, 1);
                    }
                }
            ]);
            return hu;
        }();
        var pu = function pu(t) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, pu);
            this.fill = t.fill, this.line = t.line, this.tile = t.tile, this.stencil = t.stencil, this.circle = t.circle;
        };
        pu.noSubdivision = new pu({
            fill: new hu(0, 0),
            line: new hu(0, 0),
            tile: new hu(0, 0),
            stencil: new hu(0, 0),
            circle: 1
        }), ps("SubdivisionGranularityExpression", hu), ps("SubdivisionGranularitySetting", pu);
        var fu = -32768, du = 32767;
        var yu = /*#__PURE__*/ function() {
            function yu(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, yu);
                this._vertexBuffer = [], this._vertexDictionary = new Map, this._used = !1, this._granularity = t, this._granularityCellSize = M / t, this._canonical = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(yu, [
                {
                    key: "_getKey",
                    value: function _getKey(t, e1) {
                        return (t += 32768) << 16 | e1 + 32768;
                    }
                },
                {
                    key: "_vertexToIndex",
                    value: function _vertexToIndex(t, e1) {
                        if (t < -32768 || e1 < -32768 || t > 32767 || e1 > 32767) throw new Error("Vertex coordinates are out of signed 16 bit integer range.");
                        var _$r = 0 | Math.round(t), _$n = 0 | Math.round(e1), i = this._getKey(_$r, _$n);
                        if (this._vertexDictionary.has(i)) return this._vertexDictionary.get(i);
                        var s = this._vertexBuffer.length / 2;
                        return this._vertexDictionary.set(i, s), this._vertexBuffer.push(_$r, _$n), s;
                    }
                },
                {
                    key: "_subdivideTrianglesScanline",
                    value: function _subdivideTrianglesScanline(t) {
                        if (this._granularity < 2) return function(t, e1) {
                            var _$r = [];
                            for(var _$n = 0; _$n < e1.length; _$n += 3){
                                var i = e1[_$n], s = e1[_$n + 1], a = e1[_$n + 2], o = t[2 * i], l = t[2 * i + 1];
                                (t[2 * s] - o) * (t[2 * a + 1] - l) - (t[2 * s + 1] - l) * (t[2 * a] - o) > 0 ? (_$r.push(i), _$r.push(a), _$r.push(s)) : (_$r.push(i), _$r.push(s), _$r.push(a));
                            }
                            return _$r;
                        }(this._vertexBuffer, t);
                        var _$e = [], _$r = t.length;
                        for(var _$n = 0; _$n < _$r; _$n += 3){
                            var _e;
                            var _$r1 = [
                                t[_$n + 0],
                                t[_$n + 1],
                                t[_$n + 2]
                            ], i = [
                                this._vertexBuffer[2 * t[_$n + 0] + 0],
                                this._vertexBuffer[2 * t[_$n + 0] + 1],
                                this._vertexBuffer[2 * t[_$n + 1] + 0],
                                this._vertexBuffer[2 * t[_$n + 1] + 1],
                                this._vertexBuffer[2 * t[_$n + 2] + 0],
                                this._vertexBuffer[2 * t[_$n + 2] + 1]
                            ];
                            var s = 1 / 0, a = 1 / 0, o = -1 / 0, l = -1 / 0;
                            for(var _$t = 0; _$t < 3; _$t++){
                                var _$e1 = i[2 * _$t], _$r2 = i[2 * _$t + 1];
                                s = Math.min(s, _$e1), o = Math.max(o, _$e1), a = Math.min(a, _$r2), l = Math.max(l, _$r2);
                            }
                            if (s === o || a === l) continue;
                            var u = Math.floor(s / this._granularityCellSize), _$c = Math.ceil(o / this._granularityCellSize), _$h = Math.floor(a / this._granularityCellSize), p = Math.ceil(l / this._granularityCellSize);
                            if (u !== _$c || _$h !== p) for(var _$t1 = _$h; _$t1 < p; _$t1++){
                                var _$n1 = this._scanlineGenerateVertexRingForCellRow(_$t1, i, _$r1);
                                xu(this._vertexBuffer, _$n1, _$e);
                            }
                            else (_e = _$e).push.apply(_e, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$r1));
                        }
                        return _$e;
                    }
                },
                {
                    key: "_scanlineGenerateVertexRingForCellRow",
                    value: function _scanlineGenerateVertexRingForCellRow(t, e1, r) {
                        var _$n = t * this._granularityCellSize, i = _$n + this._granularityCellSize, s = [];
                        for(var _$t = 0; _$t < 3; _$t++){
                            var a = e1[2 * _$t], o = e1[2 * _$t + 1], l = e1[2 * (_$t + 1) % 6], u = e1[(2 * (_$t + 1) + 1) % 6], _$c = e1[2 * (_$t + 2) % 6], _$h = e1[(2 * (_$t + 2) + 1) % 6], p = l - a, f = u - o, _$d = 0 === p, _$y = 0 === f, _$m = (_$n - o) / f, _$g = (i - o) / f, _$x = Math.min(_$m, _$g), _$v = Math.max(_$m, _$g);
                            if (!_$y && (_$x >= 1 || _$v <= 0) || _$y && (o < _$n || o > i)) {
                                u >= _$n && u <= i && s.push(r[(_$t + 1) % 3]);
                                continue;
                            }
                            !_$y && _$x > 0 && s.push(this._vertexToIndex(a + p * _$x, o + f * _$x));
                            var _$b = a + p * Math.max(_$x, 0), _$w = a + p * Math.min(_$v, 1);
                            _$d || this._generateIntraEdgeVertices(s, a, o, l, u, _$b, _$w), !_$y && _$v < 1 && s.push(this._vertexToIndex(a + p * _$v, o + f * _$v)), (_$y || u >= _$n && u <= i) && s.push(r[(_$t + 1) % 3]), !_$y && (u <= _$n || u >= i) && this._generateInterEdgeVertices(s, a, o, l, u, _$c, _$h, _$w, _$n, i);
                        }
                        return s;
                    }
                },
                {
                    key: "_generateIntraEdgeVertices",
                    value: function _generateIntraEdgeVertices(t, e1, r, n, i, s, a) {
                        var o = n - e1, l = i - r, u = 0 === l, _$c = u ? Math.min(e1, n) : Math.min(s, a), _$h = u ? Math.max(e1, n) : Math.max(s, a), p = Math.floor(_$c / this._granularityCellSize) + 1, f = Math.ceil(_$h / this._granularityCellSize) - 1;
                        if (u ? e1 < n : s < a) for(var _$n = p; _$n <= f; _$n++){
                            var _$i = _$n * this._granularityCellSize;
                            t.push(this._vertexToIndex(_$i, r + l * (_$i - e1) / o));
                        }
                        else for(var _$n1 = f; _$n1 >= p; _$n1--){
                            var _$i1 = _$n1 * this._granularityCellSize;
                            t.push(this._vertexToIndex(_$i1, r + l * (_$i1 - e1) / o));
                        }
                    }
                },
                {
                    key: "_generateInterEdgeVertices",
                    value: function _generateInterEdgeVertices(t, e1, r, n, i, s, a, o, l, u) {
                        var _$c = i - r, _$h = s - n, p = a - i, f = (l - i) / p, _$d = (u - i) / p, _$y = Math.min(f, _$d), _$m = Math.max(f, _$d), _$g = n + _$h * _$y;
                        var _$x = Math.floor(Math.min(_$g, o) / this._granularityCellSize) + 1, _$v = Math.ceil(Math.max(_$g, o) / this._granularityCellSize) - 1, _$b = o < _$g;
                        var _$w = 0 === p;
                        if (_$w && (a === l || a === u)) return;
                        if (_$w || _$y >= 1 || _$m <= 0) {
                            var _$t = r - a, _$n = s + (e1 - s) * Math.min((l - a) / _$t, (u - a) / _$t);
                            _$x = Math.floor(Math.min(_$n, o) / this._granularityCellSize) + 1, _$v = Math.ceil(Math.max(_$n, o) / this._granularityCellSize) - 1, _$b = o < _$n;
                        }
                        var _ = _$c > 0 ? u : l;
                        if (_$b) for(var _$e = _$x; _$e <= _$v; _$e++)t.push(this._vertexToIndex(_$e * this._granularityCellSize, _));
                        else for(var _$e1 = _$v; _$e1 >= _$x; _$e1--)t.push(this._vertexToIndex(_$e1 * this._granularityCellSize, _));
                    }
                },
                {
                    key: "_generateOutline",
                    value: function _generateOutline(t) {
                        var _$e = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$r = _step.value;
                                var _$t = gu(_$r, this._granularity, !0), _$n = this._pointArrayToIndices(_$t), i = [];
                                for(var _$t1 = 1; _$t1 < _$n.length; _$t1++)i.push(_$n[_$t1 - 1]), i.push(_$n[_$t1]);
                                _$e.push(i);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$e;
                    }
                },
                {
                    key: "_handlePoles",
                    value: function _handlePoles(t) {
                        var _$e = !1, _$r = !1;
                        this._canonical && (0 === this._canonical.y && (_$e = !0), this._canonical.y === (1 << this._canonical.z) - 1 && (_$r = !0)), (_$e || _$r) && this._fillPoles(t, _$e, _$r);
                    }
                },
                {
                    key: "_ensureNoPoleVertices",
                    value: function _ensureNoPoleVertices() {
                        var _$t = this._vertexBuffer;
                        for(var _$e = 0; _$e < _$t.length; _$e += 2){
                            var _$r = _$t[_$e + 1];
                            _$r === fu && (_$t[_$e + 1] = -32767), _$r === du && (_$t[_$e + 1] = 32766);
                        }
                    }
                },
                {
                    key: "_generatePoleQuad",
                    value: function _generatePoleQuad(t, e1, r, n, i, s) {
                        n > i != (s === fu) ? (t.push(e1), t.push(r), t.push(this._vertexToIndex(n, s)), t.push(r), t.push(this._vertexToIndex(i, s)), t.push(this._vertexToIndex(n, s))) : (t.push(r), t.push(e1), t.push(this._vertexToIndex(n, s)), t.push(this._vertexToIndex(i, s)), t.push(r), t.push(this._vertexToIndex(n, s)));
                    }
                },
                {
                    key: "_fillPoles",
                    value: function _fillPoles(t, e1, r) {
                        var _$n = this._vertexBuffer, i = M, s = t.length;
                        for(var a = 2; a < s; a += 3){
                            var s1 = t[a - 2], o = t[a - 1], l = t[a], u = _$n[2 * s1], _$c = _$n[2 * s1 + 1], _$h = _$n[2 * o], p = _$n[2 * o + 1], f = _$n[2 * l], _$d = _$n[2 * l + 1];
                            e1 && (0 === _$c && 0 === p && this._generatePoleQuad(t, s1, o, u, _$h, fu), 0 === p && 0 === _$d && this._generatePoleQuad(t, o, l, _$h, f, fu), 0 === _$d && 0 === _$c && this._generatePoleQuad(t, l, s1, f, u, fu)), r && (_$c === i && p === i && this._generatePoleQuad(t, s1, o, u, _$h, du), p === i && _$d === i && this._generatePoleQuad(t, o, l, _$h, f, du), _$d === i && _$c === i && this._generatePoleQuad(t, l, s1, f, u, du));
                        }
                    }
                },
                {
                    key: "_initializeVertices",
                    value: function _initializeVertices(t) {
                        for(var _$e = 0; _$e < t.length; _$e += 2)this._vertexToIndex(t[_$e], t[_$e + 1]);
                    }
                },
                {
                    key: "subdividePolygonInternal",
                    value: function subdividePolygonInternal(t, e1) {
                        if (this._used) throw new Error("Subdivision: multiple use not allowed.");
                        this._used = !0;
                        var _ref = function(t) {
                            var _$e = [], _$r = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$n = _step.value;
                                    if (0 !== _$n.length) {
                                        _$n !== t[0] && _$e.push(_$r.length / 2);
                                        for(var _$t = 0; _$t < _$n.length; _$t++)_$r.push(_$n[_$t].x), _$r.push(_$n[_$t].y);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return {
                                flattened: _$r,
                                holeIndices: _$e
                            };
                        }(t), _$r = _ref.flattened, _$n = _ref.holeIndices;
                        var i;
                        this._initializeVertices(_$r);
                        try {
                            var _$t = function(t, e1) {
                                var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
                                var _$n = e1 && e1.length, i = _$n ? e1[0] * _$r : t.length;
                                var s = Nl(t, 0, i, _$r, !0);
                                var a = [];
                                if (!s || s.next === s.prev) return a;
                                var o, l, u;
                                if (_$n && (s = function(t, e1, r, n) {
                                    var i = [];
                                    for(var _$r = 0, s = e1.length; _$r < s; _$r++){
                                        var a = Nl(t, e1[_$r] * n, _$r < s - 1 ? e1[_$r + 1] * n : t.length, n, !1);
                                        a === a.next && (a.steiner = !0), i.push(Wl(a));
                                    }
                                    i.sort(Yl);
                                    for(var _$t = 0; _$t < i.length; _$t++)r = Zl(i[_$t], r);
                                    return r;
                                }(t, e1, s, _$r)), t.length > 80 * _$r) {
                                    o = t[0], l = t[1];
                                    var _$e = o, _$n1 = l;
                                    for(var s1 = _$r; s1 < i; s1 += _$r){
                                        var _$r1 = t[s1], i1 = t[s1 + 1];
                                        _$r1 < o && (o = _$r1), i1 < l && (l = i1), _$r1 > _$e && (_$e = _$r1), i1 > _$n1 && (_$n1 = i1);
                                    }
                                    u = Math.max(_$e - o, _$n1 - l), u = 0 !== u ? 32767 / u : 0;
                                }
                                return Ul(s, a, _$r, o, l, u, 0), a;
                            }(_$r, _$n), _$e = this._convertIndices(_$r, _$t);
                            i = this._subdivideTrianglesScanline(_$e);
                        } catch (t) {
                            console.error(t);
                        }
                        var s = [];
                        return e1 && (s = this._generateOutline(t)), this._ensureNoPoleVertices(), this._handlePoles(i), {
                            verticesFlattened: this._vertexBuffer,
                            indicesTriangles: i,
                            indicesLineList: s
                        };
                    }
                },
                {
                    key: "_convertIndices",
                    value: function _convertIndices(t, e1) {
                        var _$r = [];
                        for(var _$n = 0; _$n < e1.length; _$n++)_$r.push(this._vertexToIndex(t[2 * e1[_$n]], t[2 * e1[_$n] + 1]));
                        return _$r;
                    }
                },
                {
                    key: "_pointArrayToIndices",
                    value: function _pointArrayToIndices(t) {
                        var _$e = [];
                        for(var _$r = 0; _$r < t.length; _$r++){
                            var _$n = t[_$r];
                            _$e.push(this._vertexToIndex(_$n.x, _$n.y));
                        }
                        return _$e;
                    }
                }
            ]);
            return yu;
        }();
        function mu(t, e1, r) {
            var _$n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !0;
            return new yu(r, e1).subdividePolygonInternal(t, _$n);
        }
        function gu(t, e1) {
            var _$n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            if (!t || t.length < 1) return [];
            if (t.length < 2) return [];
            var i = t[0], s = t[t.length - 1], a = _$n && (i.x !== s.x || i.y !== s.y);
            if (e1 < 2) return a ? (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(t).concat([
                t[0]
            ]) : (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(t);
            var o = Math.floor(M / e1), l = [];
            l.push(new r(t[0].x, t[0].y));
            var u = t.length, _$c = a ? u : u - 1;
            for(var _$e = 0; _$e < _$c; _$e++){
                var _$n1 = t[_$e], i1 = _$e < u - 1 ? t[_$e + 1] : t[0], s1 = _$n1.x, a1 = _$n1.y, _$c1 = i1.x, _$h = i1.y, p = s1 !== _$c1, f = a1 !== _$h;
                if (!p && !f) continue;
                var _$d = _$c1 - s1, _$y = _$h - a1, _$m = Math.abs(_$d), _$g = Math.abs(_$y);
                var _$x = s1, _$v = a1;
                for(;;){
                    var _$t = _$d > 0 ? (Math.floor(_$x / o) + 1) * o : (Math.ceil(_$x / o) - 1) * o, _$e1 = _$y > 0 ? (Math.floor(_$v / o) + 1) * o : (Math.ceil(_$v / o) - 1) * o, _$n2 = Math.abs(_$x - _$t), i2 = Math.abs(_$v - _$e1), s2 = Math.abs(_$x - _$c1), a2 = Math.abs(_$v - _$h), u1 = p ? _$n2 / _$m : Number.POSITIVE_INFINITY, _$b = f ? i2 / _$g : Number.POSITIVE_INFINITY;
                    if ((s2 <= _$n2 || !p) && (a2 <= i2 || !f)) break;
                    if (u1 < _$b && p || !f) {
                        _$x = _$t, _$v += _$y * u1;
                        var _$e2 = new r(_$x, Math.round(_$v));
                        l[l.length - 1].x === _$e2.x && l[l.length - 1].y === _$e2.y || l.push(_$e2);
                    } else {
                        _$x += _$d * _$b, _$v = _$e1;
                        var _$t1 = new r(Math.round(_$x), _$v);
                        l[l.length - 1].x === _$t1.x && l[l.length - 1].y === _$t1.y || l.push(_$t1);
                    }
                }
                var _$b1 = new r(_$c1, _$h);
                l[l.length - 1].x === _$b1.x && l[l.length - 1].y === _$b1.y || l.push(_$b1);
            }
            return l;
        }
        function xu(t, e1, r) {
            if (0 === e1.length) throw new Error("Subdivision vertex ring is empty.");
            var _$n = 0, i = t[2 * e1[0]];
            for(var _$r = 1; _$r < e1.length; _$r++){
                var s = t[2 * e1[_$r]];
                s < i && (i = s, _$n = _$r);
            }
            var s1 = e1.length;
            var a = _$n, o = (a + 1) % s1;
            for(;;){
                var _$n1 = a - 1 >= 0 ? a - 1 : s1 - 1, i1 = (o + 1) % s1, l = t[2 * e1[_$n1]], u = t[2 * e1[i1]], _$c = t[2 * e1[a]], _$h = t[2 * e1[a] + 1], p = t[2 * e1[o] + 1];
                var f = !1;
                if (l < u) f = !0;
                else if (l > u) f = !1;
                else {
                    var _$r1 = p - _$h, s2 = -(t[2 * e1[o]] - _$c), a1 = _$h < p ? 1 : -1;
                    ((l - _$c) * _$r1 + (t[2 * e1[_$n1] + 1] - _$h) * s2) * a1 > ((u - _$c) * _$r1 + (t[2 * e1[i1] + 1] - _$h) * s2) * a1 && (f = !0);
                }
                if (f) {
                    var _$t = e1[_$n1], i2 = e1[a], l1 = e1[o];
                    _$t !== i2 && _$t !== l1 && i2 !== l1 && r.push(l1, i2, _$t), a--, a < 0 && (a = s1 - 1);
                } else {
                    var _$t1 = e1[i1], _$n2 = e1[a], l2 = e1[o];
                    _$t1 !== _$n2 && _$t1 !== l2 && _$n2 !== l2 && r.push(l2, _$n2, _$t1), o++, o >= s1 && (o = 0);
                }
                if (_$n1 === i1) break;
            }
        }
        function vu(t, e1, r, n, i, s, a, o, l) {
            var u = i.length / 2, _$c = a && o && l;
            if (u < io.MAX_VERTEX_ARRAY_LENGTH) {
                var _$h = e1.prepareSegment(u, r, n), p = _$h.vertexLength;
                for(var _$t = 0; _$t < s.length; _$t += 3)n.emplaceBack(p + s[_$t], p + s[_$t + 1], p + s[_$t + 2]);
                var f, _$d;
                _$h.vertexLength += u, _$h.primitiveLength += s.length / 3, _$c && (_$d = a.prepareSegment(u, r, o), f = _$d.vertexLength, _$d.vertexLength += u);
                for(var _$e = 0; _$e < i.length; _$e += 2)t(i[_$e], i[_$e + 1]);
                if (_$c) for(var _$t1 = 0; _$t1 < l.length; _$t1++){
                    var _$e1 = l[_$t1];
                    for(var _$t2 = 1; _$t2 < _$e1.length; _$t2 += 2)o.emplaceBack(f + _$e1[_$t2 - 1], f + _$e1[_$t2]);
                    _$d.primitiveLength += _$e1.length / 2;
                }
            } else !function(t, e1, r, n, i, s) {
                var _$a = [];
                for(var _$t = 0; _$t < n.length / 2; _$t++)_$a.push(-1);
                var _$o = {
                    count: 0
                };
                var _$l = 0, u = t.getOrCreateLatestSegment(e1, r), _$c = u.vertexLength;
                for(var _$h = 2; _$h < i.length; _$h += 3){
                    var p = i[_$h - 2], f = i[_$h - 1], _$d = i[_$h];
                    var _$y = _$a[p] < _$l, _$m = _$a[f] < _$l, _$g = _$a[_$d] < _$l;
                    u.vertexLength + ((_$y ? 1 : 0) + (_$m ? 1 : 0) + (_$g ? 1 : 0)) > io.MAX_VERTEX_ARRAY_LENGTH && (u = t.createNewSegment(e1, r), _$l = _$o.count, _$y = !0, _$m = !0, _$g = !0, _$c = 0);
                    var _$x = bu(_$a, n, s, _$o, p, _$y, u), _$v = bu(_$a, n, s, _$o, f, _$m, u), _$b = bu(_$a, n, s, _$o, _$d, _$g, u);
                    r.emplaceBack(_$c + _$x - _$l, _$c + _$v - _$l, _$c + _$b - _$l), u.primitiveLength++;
                }
            }(e1, r, n, i, s, t), _$c && function(t, e1, r, n, i, s) {
                var _$a = [];
                for(var _$t = 0; _$t < n.length / 2; _$t++)_$a.push(-1);
                var _$o = {
                    count: 0
                };
                var _$l = 0, u = t.getOrCreateLatestSegment(e1, r), _$c = u.vertexLength;
                for(var _$h = 0; _$h < i.length; _$h++){
                    var p = i[_$h];
                    for(var f = 1; f < i[_$h].length; f += 2){
                        var _$i = p[f - 1], _$h1 = p[f];
                        var _$d = _$a[_$i] < _$l, _$y = _$a[_$h1] < _$l;
                        u.vertexLength + ((_$d ? 1 : 0) + (_$y ? 1 : 0)) > io.MAX_VERTEX_ARRAY_LENGTH && (u = t.createNewSegment(e1, r), _$l = _$o.count, _$d = !0, _$y = !0, _$c = 0);
                        var _$m = bu(_$a, n, s, _$o, _$i, _$d, u), _$g = bu(_$a, n, s, _$o, _$h1, _$y, u);
                        r.emplaceBack(_$c + _$m - _$l, _$c + _$g - _$l), u.primitiveLength++;
                    }
                }
            }(a, r, o, i, l, t), e1.forceNewSegmentOnNextPrepare(), null == a || a.forceNewSegmentOnNextPrepare();
        }
        function bu(t, e1, r, n, i, s, a) {
            if (s) {
                var _$s = n.count;
                return r(e1[2 * i], e1[2 * i + 1]), t[i] = n.count, n.count++, a.vertexLength++, _$s;
            }
            return t[i];
        }
        var wu = /*#__PURE__*/ function() {
            function wu(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, wu);
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function(t) {
                    return t.id;
                }), this.index = t.index, this.hasDependencies = !1, this.patternFeatures = [], this.layoutVertexArray = new qa, this.indexArray = new to, this.indexArray2 = new eo, this.programConfigurations = new Vo(t.layers, t.zoom), this.segments = new io, this.segments2 = new io, this.stateDependentLayerIds = this.layers.filter(function(t) {
                    return t.isStateDependent();
                }).map(function(t) {
                    return t.id;
                });
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(wu, [
                {
                    key: "populate",
                    value: function populate(t, e1, r) {
                        this.hasDependencies = Ol("fill", this.layers, e1);
                        var _$n = this.layers[0].layout.get("fill-sort-key"), i = !_$n.isConstant(), s = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, a = _step_value.feature, o = _step_value.id, l = _step_value.index, u = _step_value.sourceLayerIndex;
                                var _$t = this.layers[0]._featureFilter.needGeometry, _$c = $o(a, _$t);
                                if (!this.layers[0]._featureFilter.filter(new Ps(this.zoom), _$c, r)) continue;
                                var _$h = i ? _$n.evaluate(_$c, {}, r, e1.availableImages) : void 0, p = {
                                    id: o,
                                    properties: a.properties,
                                    type: a.type,
                                    sourceLayerIndex: u,
                                    index: l,
                                    geometry: _$t ? _$c.geometry : No(a),
                                    patterns: {},
                                    sortKey: _$h
                                };
                                s.push(p);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        i && s.sort(function(t, e1) {
                            return t.sortKey - e1.sortKey;
                        });
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = s[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$n1 = _step1.value;
                                var i1 = _$n1.geometry, s1 = _$n1.index, a1 = _$n1.sourceLayerIndex;
                                if (this.hasDependencies) {
                                    var _$t1 = Rl("fill", this.layers, _$n1, {
                                        zoom: this.zoom
                                    }, e1);
                                    this.patternFeatures.push(_$t1);
                                } else this.addFeature(_$n1, i1, s1, r, {}, e1.subdivisionGranularity);
                                e1.featureIndex.insert(t[s1].feature, i1, s1, a1, this.index);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                },
                {
                    key: "update",
                    value: function update(t, e1, r) {
                        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e1, this.stateDependentLayers, {
                            imagePositions: r
                        });
                    }
                },
                {
                    key: "addFeatures",
                    value: function addFeatures(t, e1, r) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.patternFeatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$n = _step.value;
                                this.addFeature(_$n, _$n.geometry, _$n.index, e1, r, t.subdivisionGranularity);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "isEmpty",
                    value: function isEmpty() {
                        return 0 === this.layoutVertexArray.length;
                    }
                },
                {
                    key: "uploadPending",
                    value: function uploadPending() {
                        return !this.uploaded || this.programConfigurations.needsUpload;
                    }
                },
                {
                    key: "upload",
                    value: function upload(t) {
                        this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Ll), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.indexBuffer2 = t.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(t), this.uploaded = !0;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
                    }
                },
                {
                    key: "addFeature",
                    value: function addFeature(t, e1, r, n, i, s) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _this, _loop = function() {
                                var _$t = _step.value;
                                var _$e = mu(_$t, n, s.fill.getGranularityForZoomLevel(n.z)), _$r = _this.layoutVertexArray;
                                vu(function(t, e1) {
                                    _$r.emplaceBack(t, e1);
                                }, _this.segments, _this.layoutVertexArray, _this.indexArray, _$e.verticesFlattened, _$e.indicesTriangles, _this.segments2, _this.indexArray2, _$e.indicesLineList);
                            };
                            for(var _iterator = tn(e1, 500)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this = this, _loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, {
                            imagePositions: i,
                            canonical: n
                        });
                    }
                }
            ]);
            return wu;
        }();
        var _u, Su;
        ps("FillBucket", wu, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var Au = {
            get paint () {
                return Su = Su || new Hs({
                    "fill-antialias": new js(vt.paint_fill["fill-antialias"]),
                    "fill-opacity": new Gs(vt.paint_fill["fill-opacity"]),
                    "fill-color": new Gs(vt.paint_fill["fill-color"]),
                    "fill-outline-color": new Gs(vt.paint_fill["fill-outline-color"]),
                    "fill-translate": new js(vt.paint_fill["fill-translate"]),
                    "fill-translate-anchor": new js(vt.paint_fill["fill-translate-anchor"]),
                    "fill-pattern": new Xs(vt.paint_fill["fill-pattern"])
                });
            },
            get layout () {
                return _u = _u || new Hs({
                    "fill-sort-key": new Gs(vt.layout_fill["fill-sort-key"])
                });
            }
        };
        var ku = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ku, Ks);
            function ku(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ku);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ku, [
                    t,
                    Au,
                    e1
                ]);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ku, [
                {
                    key: "recalculate",
                    value: function recalculate(t, e1) {
                        (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(ku.prototype), "recalculate", this).call(this, t, e1);
                        var _$r = this.paint._values["fill-outline-color"];
                        "constant" === _$r.value.kind && void 0 === _$r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                    }
                },
                {
                    key: "createBucket",
                    value: function createBucket(t) {
                        return new wu(t);
                    }
                },
                {
                    key: "queryRadius",
                    value: function queryRadius() {
                        return nl(this.paint.get("fill-translate"));
                    }
                },
                {
                    key: "queryIntersectsFeature",
                    value: function queryIntersectsFeature(param) {
                        var _$t = param.queryGeometry, _$e = param.geometry, _$r = param.transform, _$n = param.pixelsToTileUnits;
                        return Yo(il(_$t, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), -_$r.bearingInRadians, _$n), _$e);
                    }
                },
                {
                    key: "isTileClipped",
                    value: function isTileClipped() {
                        return !0;
                    }
                }
            ]);
            return ku;
        }(Ks);
        var Eu = na([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_normal_ed",
                components: 4,
                type: "Int16"
            }
        ], 4), Tu = na([
            {
                name: "a_centroid",
                components: 2,
                type: "Int16"
            }
        ], 4), Iu = Eu.members;
        var Mu = /*#__PURE__*/ function() {
            function Mu(t, e1, r, n, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Mu);
                this.properties = {}, this.extent = r, this.type = 0, this.id = void 0, this._pbf = t, this._geometry = -1, this._keys = n, this._values = i, t.readFields(Fu, this, e1);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Mu, [
                {
                    key: "loadGeometry",
                    value: function loadGeometry() {
                        var _$t = this._pbf;
                        _$t.pos = this._geometry;
                        var _$e = _$t.readVarint() + _$t.pos, _$n = [];
                        var i, s = 1, a = 0, o = 0, l = 0;
                        for(; _$t.pos < _$e;){
                            if (a <= 0) {
                                var _$e1 = _$t.readVarint();
                                s = 7 & _$e1, a = _$e1 >> 3;
                            }
                            if (a--, 1 === s || 2 === s) o += _$t.readSVarint(), l += _$t.readSVarint(), 1 === s && (i && _$n.push(i), i = []), i && i.push(new r(o, l));
                            else {
                                if (7 !== s) throw new Error("unknown command ".concat(s));
                                i && i.push(i[0].clone());
                            }
                        }
                        return i && _$n.push(i), _$n;
                    }
                },
                {
                    key: "bbox",
                    value: function bbox() {
                        var _$t = this._pbf;
                        _$t.pos = this._geometry;
                        var _$e = _$t.readVarint() + _$t.pos;
                        var _$r = 1, _$n = 0, i = 0, s = 0, a = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0;
                        for(; _$t.pos < _$e;){
                            if (_$n <= 0) {
                                var _$e1 = _$t.readVarint();
                                _$r = 7 & _$e1, _$n = _$e1 >> 3;
                            }
                            if (_$n--, 1 === _$r || 2 === _$r) i += _$t.readSVarint(), s += _$t.readSVarint(), i < a && (a = i), i > o && (o = i), s < l && (l = s), s > u && (u = s);
                            else if (7 !== _$r) throw new Error("unknown command ".concat(_$r));
                        }
                        return [
                            a,
                            l,
                            o,
                            u
                        ];
                    }
                },
                {
                    key: "toGeoJSON",
                    value: function toGeoJSON(t, e1, r) {
                        var _$n = this.extent * Math.pow(2, r), i = this.extent * t, s = this.extent * e1, a = this.loadGeometry();
                        function o(t) {
                            return [
                                360 * (t.x + i) / _$n - 180,
                                360 / Math.PI * Math.atan(Math.exp((1 - 2 * (t.y + s) / _$n) * Math.PI)) - 90
                            ];
                        }
                        function l(t) {
                            return t.map(o);
                        }
                        var u;
                        if (1 === this.type) {
                            var _$t = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    _$t.push(_$e[0]);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            var _$e1 = l(_$t);
                            u = 1 === _$t.length ? {
                                type: "Point",
                                coordinates: _$e1[0]
                            } : {
                                type: "MultiPoint",
                                coordinates: _$e1
                            };
                        } else if (2 === this.type) {
                            var _$t1 = a.map(l);
                            u = 1 === _$t1.length ? {
                                type: "LineString",
                                coordinates: _$t1[0]
                            } : {
                                type: "MultiLineString",
                                coordinates: _$t1
                            };
                        } else {
                            if (3 !== this.type) throw new Error("unknown feature type");
                            {
                                var _$t2 = Du(a), _$e2 = [];
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = _$t2[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var _$r = _step1.value;
                                        _$e2.push(_$r.map(l));
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                u = 1 === _$e2.length ? {
                                    type: "Polygon",
                                    coordinates: _$e2[0]
                                } : {
                                    type: "MultiPolygon",
                                    coordinates: _$e2
                                };
                            }
                        }
                        var _$c = {
                            type: "Feature",
                            geometry: u,
                            properties: this.properties
                        };
                        return null != this.id && (_$c.id = this.id), _$c;
                    }
                }
            ]);
            return Mu;
        }();
        function Fu(t, e1, r) {
            1 === t ? e1.id = r.readVarint() : 2 === t ? function(t, e1) {
                var _$r = t.readVarint() + t.pos;
                for(; t.pos < _$r;){
                    var _$r1 = e1._keys[t.readVarint()], _$n = e1._values[t.readVarint()];
                    e1.properties[_$r1] = _$n;
                }
            }(r, e1) : 3 === t ? e1.type = r.readVarint() : 4 === t && (e1._geometry = r.pos);
        }
        function Du(t) {
            var _$e = t.length;
            if (_$e <= 1) return [
                t
            ];
            var _$r = [];
            var _$n, i;
            for(var s = 0; s < _$e; s++){
                var _$e1 = zu(t[s]);
                0 !== _$e1 && (void 0 === i && (i = _$e1 < 0), i === _$e1 < 0 ? (_$n && _$r.push(_$n), _$n = [
                    t[s]
                ]) : _$n && _$n.push(t[s]));
            }
            return _$n && _$r.push(_$n), _$r;
        }
        function zu(t) {
            var _$e = 0;
            for(var _$r, _$n, i = 0, s = t.length, a = s - 1; i < s; a = i++)_$r = t[i], _$n = t[a], _$e += (_$n.x - _$r.x) * (_$r.y + _$n.y);
            return _$e;
        }
        Mu.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        var Pu = /*#__PURE__*/ function() {
            function Pu(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Pu);
                this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = t, this._keys = [], this._values = [], this._features = [], t.readFields(Bu, this, e1), this.length = this._features.length;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Pu, [
                {
                    key: "feature",
                    value: function feature(t) {
                        if (t < 0 || t >= this._features.length) throw new Error("feature index out of bounds");
                        this._pbf.pos = this._features[t];
                        var _$e = this._pbf.readVarint() + this._pbf.pos;
                        return new Mu(this._pbf, _$e, this.extent, this._keys, this._values);
                    }
                }
            ]);
            return Pu;
        }();
        function Bu(t, e1, r) {
            15 === t ? e1.version = r.readVarint() : 1 === t ? e1.name = r.readString() : 5 === t ? e1.extent = r.readVarint() : 2 === t ? e1._features.push(r.pos) : 3 === t ? e1._keys.push(r.readString()) : 4 === t && e1._values.push(function(t) {
                var _$e = null;
                var _$r = t.readVarint() + t.pos;
                for(; t.pos < _$r;){
                    var _$r1 = t.readVarint() >> 3;
                    _$e = 1 === _$r1 ? t.readString() : 2 === _$r1 ? t.readFloat() : 3 === _$r1 ? t.readDouble() : 4 === _$r1 ? t.readVarint64() : 5 === _$r1 ? t.readVarint() : 6 === _$r1 ? t.readSVarint() : 7 === _$r1 ? t.readBoolean() : null;
                }
                if (null == _$e) throw new Error("unknown feature value");
                return _$e;
            }(r));
        }
        var Vu = function Vu(t, e1) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, Vu);
            this.layers = t.readFields(Cu, {}, e1);
        };
        function Cu(t, e1, r) {
            if (3 === t) {
                var _$t = new Pu(r, r.readVarint() + r.pos);
                _$t.length && (e1[_$t.name] = _$t);
            }
        }
        var Lu = Math.pow(2, 13);
        function Ou(t, e1, r, n, i, s, a, o) {
            t.emplaceBack(e1, r, 2 * Math.floor(n * Lu) + a, i * Lu * 2, s * Lu * 2, Math.round(o));
        }
        var Ru = /*#__PURE__*/ function() {
            function Ru(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ru);
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function(t) {
                    return t.id;
                }), this.index = t.index, this.hasDependencies = !1, this.layoutVertexArray = new ja, this.centroidVertexArray = new $a, this.indexArray = new to, this.programConfigurations = new Vo(t.layers, t.zoom), this.segments = new io, this.stateDependentLayerIds = this.layers.filter(function(t) {
                    return t.isStateDependent();
                }).map(function(t) {
                    return t.id;
                });
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ru, [
                {
                    key: "populate",
                    value: function populate(t, e1, r) {
                        this.features = [], this.hasDependencies = Ol("fill-extrusion", this.layers, e1);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, _$n = _step_value.feature, i = _step_value.id, s = _step_value.index, a = _step_value.sourceLayerIndex;
                                var _$t = this.layers[0]._featureFilter.needGeometry, o = $o(_$n, _$t);
                                if (!this.layers[0]._featureFilter.filter(new Ps(this.zoom), o, r)) continue;
                                var l = {
                                    id: i,
                                    sourceLayerIndex: a,
                                    index: s,
                                    geometry: _$t ? o.geometry : No(_$n),
                                    properties: _$n.properties,
                                    type: _$n.type,
                                    patterns: {}
                                };
                                this.hasDependencies ? this.features.push(Rl("fill-extrusion", this.layers, l, {
                                    zoom: this.zoom
                                }, e1)) : this.addFeature(l, l.geometry, s, r, {}, e1.subdivisionGranularity), e1.featureIndex.insert(_$n, l.geometry, s, a, this.index, !0);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "addFeatures",
                    value: function addFeatures(t, e1, r) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$n = _step.value;
                                var i = _$n.geometry;
                                this.addFeature(_$n, i, _$n.index, e1, r, t.subdivisionGranularity);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "update",
                    value: function update(t, e1, r) {
                        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e1, this.stateDependentLayers, {
                            imagePositions: r
                        });
                    }
                },
                {
                    key: "isEmpty",
                    value: function isEmpty() {
                        return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
                    }
                },
                {
                    key: "uploadPending",
                    value: function uploadPending() {
                        return !this.uploaded || this.programConfigurations.needsUpload;
                    }
                },
                {
                    key: "upload",
                    value: function upload(t) {
                        this.uploaded || (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Iu), this.centroidVertexBuffer = t.createVertexBuffer(this.centroidVertexArray, Tu.members, !0), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
                    }
                },
                {
                    key: "addFeature",
                    value: function addFeature(t, e1, r, n, i, s) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = tn(e1, 500)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$r = _step.value;
                                var _$e = {
                                    x: 0,
                                    y: 0,
                                    sampleCount: 0
                                }, _$i = this.layoutVertexArray.length;
                                this.processPolygon(_$e, n, t, _$r, s);
                                var a = this.layoutVertexArray.length - _$i, o = Math.floor(_$e.x / _$e.sampleCount), l = Math.floor(_$e.y / _$e.sampleCount);
                                for(var _$t = 0; _$t < a; _$t++)this.centroidVertexArray.emplaceBack(o, l);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, {
                            imagePositions: i,
                            canonical: n
                        });
                    }
                },
                {
                    key: "processPolygon",
                    value: function processPolygon(t, e1, r, n, i) {
                        if (n.length < 1) return;
                        if (Uu(n[0])) return;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                0 !== _$e.length && Nu(t, _$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var s = {
                            segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
                        }, a = i.fill.getGranularityForZoomLevel(e1.z), o = "Polygon" === Mu.types[r.type];
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = n[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$t = _step1.value;
                                if (0 === _$t.length) continue;
                                if (Uu(_$t)) continue;
                                var _$e1 = gu(_$t, a, o);
                                this._generateSideFaces(_$e1, s);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        if (!o) return;
                        var l = mu(n, e1, a, !1), u = this.layoutVertexArray;
                        vu(function(t, e1) {
                            Ou(u, t, e1, 0, 0, 1, 1, 0);
                        }, this.segments, this.layoutVertexArray, this.indexArray, l.verticesFlattened, l.indicesTriangles);
                    }
                },
                {
                    key: "_generateSideFaces",
                    value: function _generateSideFaces(t, e1) {
                        var _$r = 0;
                        for(var _$n = 1; _$n < t.length; _$n++){
                            var i = t[_$n], s = t[_$n - 1];
                            if ($u(i, s)) continue;
                            e1.segment.vertexLength + 4 > io.MAX_VERTEX_ARRAY_LENGTH && (e1.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                            var a = i.sub(s)._perp()._unit(), o = s.dist(i);
                            _$r + o > 32768 && (_$r = 0), Ou(this.layoutVertexArray, i.x, i.y, a.x, a.y, 0, 0, _$r), Ou(this.layoutVertexArray, i.x, i.y, a.x, a.y, 0, 1, _$r), _$r += o, Ou(this.layoutVertexArray, s.x, s.y, a.x, a.y, 0, 0, _$r), Ou(this.layoutVertexArray, s.x, s.y, a.x, a.y, 0, 1, _$r);
                            var l = e1.segment.vertexLength;
                            this.indexArray.emplaceBack(l, l + 2, l + 1), this.indexArray.emplaceBack(l + 1, l + 2, l + 3), e1.segment.vertexLength += 4, e1.segment.primitiveLength += 2;
                        }
                    }
                }
            ]);
            return Ru;
        }();
        function Nu(t, e1) {
            for(var _$r = 0; _$r < e1.length; _$r++){
                var _$n = e1[_$r];
                _$r === e1.length - 1 && e1[0].x === _$n.x && e1[0].y === _$n.y || (t.x += _$n.x, t.y += _$n.y, t.sampleCount++);
            }
        }
        function $u(t, e1) {
            return t.x === e1.x && (t.x < 0 || t.x > M) || t.y === e1.y && (t.y < 0 || t.y > M);
        }
        function Uu(t) {
            return t.every(function(t) {
                return t.x < 0;
            }) || t.every(function(t) {
                return t.x > M;
            }) || t.every(function(t) {
                return t.y < 0;
            }) || t.every(function(t) {
                return t.y > M;
            });
        }
        var qu;
        ps("FillExtrusionBucket", Ru, {
            omit: [
                "layers",
                "features"
            ]
        });
        var ju = {
            get paint () {
                return qu = qu || new Hs({
                    "fill-extrusion-opacity": new js(vt["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                    "fill-extrusion-color": new Gs(vt["paint_fill-extrusion"]["fill-extrusion-color"]),
                    "fill-extrusion-translate": new js(vt["paint_fill-extrusion"]["fill-extrusion-translate"]),
                    "fill-extrusion-translate-anchor": new js(vt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                    "fill-extrusion-pattern": new Xs(vt["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                    "fill-extrusion-height": new Gs(vt["paint_fill-extrusion"]["fill-extrusion-height"]),
                    "fill-extrusion-base": new Gs(vt["paint_fill-extrusion"]["fill-extrusion-base"]),
                    "fill-extrusion-vertical-gradient": new js(vt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                });
            }
        };
        var Gu = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Gu, Ks);
            function Gu(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Gu);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Gu, [
                    t,
                    ju,
                    e1
                ]);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Gu, [
                {
                    key: "createBucket",
                    value: function createBucket(t) {
                        return new Ru(t);
                    }
                },
                {
                    key: "queryRadius",
                    value: function queryRadius() {
                        return nl(this.paint.get("fill-extrusion-translate"));
                    }
                },
                {
                    key: "is3D",
                    value: function is3D() {
                        return !0;
                    }
                },
                {
                    key: "queryIntersectsFeature",
                    value: function queryIntersectsFeature(param) {
                        var _$t = param.queryGeometry, _$e = param.feature, _$n = param.featureState, i = param.geometry, s = param.transform, a = param.pixelsToTileUnits, o = param.pixelPosMatrix;
                        var l = il(_$t, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), -s.bearingInRadians, a), u = this.paint.get("fill-extrusion-height").evaluate(_$e, _$n), _$c = this.paint.get("fill-extrusion-base").evaluate(_$e, _$n), _$h = function(t, e1) {
                            var _$n = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var i = _step.value;
                                    var _$t = [
                                        i.x,
                                        i.y,
                                        0,
                                        1
                                    ];
                                    A(_$t, _$t, e1), _$n.push(new r(_$t[0] / _$t[3], _$t[1] / _$t[3]));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return _$n;
                        }(l, o), p = function(t, e1, n, i) {
                            var s = [], a = [], o = i[8] * e1, l = i[9] * e1, u = i[10] * e1, _$c = i[11] * e1, _$h = i[8] * n, p = i[9] * n, f = i[10] * n, _$d = i[11] * n;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    var _$t = [], _$n = [];
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = _$e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var s1 = _step1.value;
                                            var _$e1 = s1.x, a1 = s1.y, _$y = i[0] * _$e1 + i[4] * a1 + i[12], _$m = i[1] * _$e1 + i[5] * a1 + i[13], _$g = i[2] * _$e1 + i[6] * a1 + i[14], _$x = i[3] * _$e1 + i[7] * a1 + i[15], _$v = _$g + u, _$b = _$x + _$c, _$w = _$y + _$h, _ = _$m + p, S = _$g + f, _$A = _$x + _$d, _$k = new r((_$y + o) / _$b, (_$m + l) / _$b);
                                            _$k.z = _$v / _$b, _$t.push(_$k);
                                            var _$E = new r(_$w / _$A, _ / _$A);
                                            _$E.z = S / _$A, _$n.push(_$E);
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                    s.push(_$t), a.push(_$n);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                s,
                                a
                            ];
                        }(i, _$c, u, o);
                        return function(t, e1, r) {
                            var _$n = 1 / 0;
                            Yo(r, e1) && (_$n = Yu(r, e1[0]));
                            for(var i = 0; i < e1.length; i++){
                                var s = e1[i], a = t[i];
                                for(var _$t = 0; _$t < s.length - 1; _$t++){
                                    var _$e = s[_$t], i1 = [
                                        _$e,
                                        s[_$t + 1],
                                        a[_$t + 1],
                                        a[_$t],
                                        _$e
                                    ];
                                    Go(r, i1) && (_$n = Math.min(_$n, Yu(r, i1)));
                                }
                            }
                            return _$n !== 1 / 0 && _$n;
                        }(p[0], p[1], _$h);
                    }
                }
            ]);
            return Gu;
        }(Ks);
        function Xu(t, e1) {
            return t.x * e1.x + t.y * e1.y;
        }
        function Yu(t, e1) {
            if (1 === t.length) {
                var _$r = 0;
                var _$n = e1[_$r++];
                var i;
                for(; !i || _$n.equals(i);)if (i = e1[_$r++], !i) return 1 / 0;
                for(; _$r < e1.length; _$r++){
                    var s = e1[_$r], a = t[0], o = i.sub(_$n), l = s.sub(_$n), u = a.sub(_$n), _$c = Xu(o, o), _$h = Xu(o, l), p = Xu(l, l), f = Xu(u, o), _$d = Xu(u, l), _$y = _$c * p - _$h * _$h, _$m = (p * f - _$h * _$d) / _$y, _$g = (_$c * _$d - _$h * f) / _$y, _$x = _$n.z * (1 - _$m - _$g) + i.z * _$m + s.z * _$g;
                    if (isFinite(_$x)) return _$x;
                }
                return 1 / 0;
            }
            {
                var _$t = 1 / 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$r1 = _step.value;
                        _$t = Math.min(_$t, _$r1.z);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return _$t;
            }
        }
        var Zu = na([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            }
        ], 4), Hu = Zu.members, Ku = na([
            {
                name: "a_uv_x",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_split_index",
                components: 1,
                type: "Float32"
            }
        ]), Wu = Ku.members, Ju = Math.cos(Math.PI / 180 * 37.5), Qu = Math.pow(2, 14) / .5;
        var tc = /*#__PURE__*/ function() {
            function tc(t) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, tc);
                this.zoom = t.zoom, this.overscaling = t.overscaling, this.layers = t.layers, this.layerIds = this.layers.map(function(t) {
                    return t.id;
                }), this.index = t.index, this.hasDependencies = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach(function(t) {
                    _this.gradients[t.id] = {};
                }), this.layoutVertexArray = new Ga, this.layoutVertexArray2 = new Xa, this.indexArray = new to, this.programConfigurations = new Vo(t.layers, t.zoom), this.segments = new io, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter(function(t) {
                    return t.isStateDependent();
                }).map(function(t) {
                    return t.id;
                });
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(tc, [
                {
                    key: "populate",
                    value: function populate(t, e1, r) {
                        this.hasDependencies = Ol("line", this.layers, e1) || this.hasLineDasharray(this.layers);
                        var _$n = this.layers[0].layout.get("line-sort-key"), i = !_$n.isConstant(), s = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, _$e = _step_value.feature, a = _step_value.id, o = _step_value.index, l = _step_value.sourceLayerIndex;
                                var _$t = this.layers[0]._featureFilter.needGeometry, u = $o(_$e, _$t);
                                if (!this.layers[0]._featureFilter.filter(new Ps(this.zoom), u, r)) continue;
                                var _$c = i ? _$n.evaluate(u, {}, r) : void 0, _$h = {
                                    id: a,
                                    properties: _$e.properties,
                                    type: _$e.type,
                                    sourceLayerIndex: l,
                                    index: o,
                                    geometry: _$t ? u.geometry : No(_$e),
                                    patterns: {},
                                    dashes: {},
                                    sortKey: _$c
                                };
                                s.push(_$h);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        i && s.sort(function(t, e1) {
                            return t.sortKey - e1.sortKey;
                        });
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = s[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$n1 = _step1.value;
                                var i1 = _$n1.geometry, s1 = _$n1.index, a1 = _$n1.sourceLayerIndex;
                                this.hasDependencies ? (Ol("line", this.layers, e1) ? Rl("line", this.layers, _$n1, {
                                    zoom: this.zoom
                                }, e1) : this.hasLineDasharray(this.layers) && this.addLineDashDependencies(this.layers, _$n1, this.zoom, e1), this.patternFeatures.push(_$n1)) : this.addFeature(_$n1, i1, s1, r, {}, {}, e1.subdivisionGranularity), e1.featureIndex.insert(t[s1].feature, i1, s1, a1, this.index);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                },
                {
                    key: "update",
                    value: function update(t, e1, r, n) {
                        this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(t, e1, this.stateDependentLayers, {
                            imagePositions: r,
                            dashPositions: n
                        });
                    }
                },
                {
                    key: "addFeatures",
                    value: function addFeatures(t, e1, r, n) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.patternFeatures[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                this.addFeature(i, i.geometry, i.index, e1, r, n, t.subdivisionGranularity);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "isEmpty",
                    value: function isEmpty() {
                        return 0 === this.layoutVertexArray.length;
                    }
                },
                {
                    key: "uploadPending",
                    value: function uploadPending() {
                        return !this.uploaded || this.programConfigurations.needsUpload;
                    }
                },
                {
                    key: "upload",
                    value: function upload(t) {
                        this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = t.createVertexBuffer(this.layoutVertexArray2, Wu)), this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, Hu), this.indexBuffer = t.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(t), this.uploaded = !0;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                    }
                },
                {
                    key: "lineFeatureClips",
                    value: function lineFeatureClips(t) {
                        if (t.properties && Object.prototype.hasOwnProperty.call(t.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(t.properties, "mapbox_clip_end")) return {
                            start: +t.properties.mapbox_clip_start,
                            end: +t.properties.mapbox_clip_end
                        };
                    }
                },
                {
                    key: "addFeature",
                    value: function addFeature(t, e1, r, n, i, s, a) {
                        var o = this.layers[0].layout, l = o.get("line-join").evaluate(t, {}), u = o.get("line-cap"), _$c = o.get("line-miter-limit"), _$h = o.get("line-round-limit");
                        this.lineClips = this.lineFeatureClips(t);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$r = _step.value;
                                this.addLine(_$r, t, l, u, _$c, _$h, n, a);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t, r, {
                            imagePositions: i,
                            dashPositions: s,
                            canonical: n
                        });
                    }
                },
                {
                    key: "addLine",
                    value: function addLine(t, e1, r, n, i, s, a, o) {
                        if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, t = gu(t, a ? o.line.getGranularityForZoomLevel(a.z) : 1), this.lineClips) {
                            this.lineClipsArray.push(this.lineClips);
                            for(var _$e = 0; _$e < t.length - 1; _$e++)this.totalDistance += t[_$e].dist(t[_$e + 1]);
                            this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                        }
                        var l = "Polygon" === Mu.types[e1.type];
                        var u = t.length;
                        for(; u >= 2 && t[u - 1].equals(t[u - 2]);)u--;
                        var _$c = 0;
                        for(; _$c < u - 1 && t[_$c].equals(t[_$c + 1]);)_$c++;
                        if (u < (l ? 3 : 2)) return;
                        "bevel" === r && (i = 1.05);
                        var _$h = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, p = this.segments.prepareSegment(10 * u, this.layoutVertexArray, this.indexArray);
                        var f, _$d, _$y, _$m, _$g;
                        this.e1 = this.e2 = -1, l && (f = t[u - 2], _$g = t[_$c].sub(f)._unit()._perp());
                        for(var _$e1 = _$c; _$e1 < u; _$e1++){
                            if (_$y = _$e1 === u - 1 ? l ? t[_$c + 1] : void 0 : t[_$e1 + 1], _$y && t[_$e1].equals(_$y)) continue;
                            _$g && (_$m = _$g), f && (_$d = f), f = t[_$e1], _$g = _$y ? _$y.sub(f)._unit()._perp() : _$m, _$m = _$m || _$g;
                            var _$a = _$m.add(_$g);
                            0 === _$a.x && 0 === _$a.y || _$a._unit();
                            var _$o = _$m.x * _$g.x + _$m.y * _$g.y, _$x = _$a.x * _$g.x + _$a.y * _$g.y, _$v = 0 !== _$x ? 1 / _$x : 1 / 0, _$b = 2 * Math.sqrt(2 - 2 * _$x), _$w = _$x < Ju && _$d && _$y, _ = _$m.x * _$g.y - _$m.y * _$g.x > 0;
                            if (_$w && _$e1 > _$c) {
                                var _$t = f.dist(_$d);
                                if (_$t > 2 * _$h) {
                                    var _$e2 = f.sub(f.sub(_$d)._mult(_$h / _$t)._round());
                                    this.updateDistance(_$d, _$e2), this.addCurrentVertex(_$e2, _$m, 0, 0, p), _$d = _$e2;
                                }
                            }
                            var S = _$d && _$y;
                            var _$A = S ? r : l ? "butt" : n;
                            if (S && "round" === _$A && (_$v < s ? _$A = "miter" : _$v <= 2 && (_$A = "fakeround")), "miter" === _$A && _$v > i && (_$A = "bevel"), "bevel" === _$A && (_$v > 2 && (_$A = "flipbevel"), _$v < i && (_$A = "miter")), _$d && this.updateDistance(_$d, f), "miter" === _$A) _$a._mult(_$v), this.addCurrentVertex(f, _$a, 0, 0, p);
                            else if ("flipbevel" === _$A) {
                                if (_$v > 100) _$a = _$g.mult(-1);
                                else {
                                    var _$t1 = _$v * _$m.add(_$g).mag() / _$m.sub(_$g).mag();
                                    _$a._perp()._mult(_$t1 * (_ ? -1 : 1));
                                }
                                this.addCurrentVertex(f, _$a, 0, 0, p), this.addCurrentVertex(f, _$a.mult(-1), 0, 0, p);
                            } else if ("bevel" === _$A || "fakeround" === _$A) {
                                var _$t2 = -Math.sqrt(_$v * _$v - 1), _$e3 = _ ? _$t2 : 0, _$r = _ ? 0 : _$t2;
                                if (_$d && this.addCurrentVertex(f, _$m, _$e3, _$r, p), "fakeround" === _$A) {
                                    var _$t3 = Math.round(180 * _$b / Math.PI / 20);
                                    for(var _$e4 = 1; _$e4 < _$t3; _$e4++){
                                        var _$r1 = _$e4 / _$t3;
                                        if (.5 !== _$r1) {
                                            var _$t4 = _$r1 - .5;
                                            _$r1 += _$r1 * _$t4 * (_$r1 - 1) * ((1.0904 + _$o * (_$o * (3.55645 - 1.43519 * _$o) - 3.2452)) * _$t4 * _$t4 + (.848013 + _$o * (.215638 * _$o - 1.06021)));
                                        }
                                        var _$n = _$g.sub(_$m)._mult(_$r1)._add(_$m)._unit()._mult(_ ? -1 : 1);
                                        this.addHalfVertex(f, _$n.x, _$n.y, !1, _, 0, p);
                                    }
                                }
                                _$y && this.addCurrentVertex(f, _$g, -_$e3, -_$r, p);
                            } else if ("butt" === _$A) this.addCurrentVertex(f, _$a, 0, 0, p);
                            else if ("square" === _$A) {
                                var _$t5 = _$d ? 1 : -1;
                                this.addCurrentVertex(f, _$a, _$t5, _$t5, p);
                            } else "round" === _$A && (_$d && (this.addCurrentVertex(f, _$m, 0, 0, p), this.addCurrentVertex(f, _$m, 1, 1, p, !0)), _$y && (this.addCurrentVertex(f, _$g, -1, -1, p, !0), this.addCurrentVertex(f, _$g, 0, 0, p)));
                            if (_$w && _$e1 < u - 1) {
                                var _$t6 = f.dist(_$y);
                                if (_$t6 > 2 * _$h) {
                                    var _$e5 = f.add(_$y.sub(f)._mult(_$h / _$t6)._round());
                                    this.updateDistance(f, _$e5), this.addCurrentVertex(_$e5, _$g, 0, 0, p), f = _$e5;
                                }
                            }
                        }
                    }
                },
                {
                    key: "addCurrentVertex",
                    value: function addCurrentVertex(t, e1, r, n, i) {
                        var s = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : !1;
                        var a = e1.y * n - e1.x, o = -e1.y - e1.x * n;
                        this.addHalfVertex(t, e1.x + e1.y * r, e1.y - e1.x * r, s, !1, r, i), this.addHalfVertex(t, a, o, s, !0, -n, i), this.distance > Qu / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(t, e1, r, n, i, s));
                    }
                },
                {
                    key: "addHalfVertex",
                    value: function addHalfVertex(param, r, n, i, s, a, o) {
                        var _$t = param.x, _$e = param.y;
                        var l = .5 * (this.lineClips ? this.scaledDistance * (Qu - 1) : this.scaledDistance);
                        this.layoutVertexArray.emplaceBack((_$t << 1) + (i ? 1 : 0), (_$e << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1) | (63 & l) << 2, l >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                        var u = o.vertexLength++;
                        this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, u, this.e2), o.primitiveLength++), s ? this.e2 = u : this.e1 = u;
                    }
                },
                {
                    key: "updateScaledDistance",
                    value: function updateScaledDistance() {
                        this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
                    }
                },
                {
                    key: "updateDistance",
                    value: function updateDistance(t, e1) {
                        this.distance += t.dist(e1), this.updateScaledDistance();
                    }
                },
                {
                    key: "hasLineDasharray",
                    value: function hasLineDasharray(t) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                var _$t = _$e.paint.get("line-dasharray");
                                if (_$t && !_$t.isConstant()) return !0;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return !1;
                    }
                },
                {
                    key: "addLineDashDependencies",
                    value: function addLineDashDependencies(t, e1, r, n) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                var _$t = i.paint.get("line-dasharray");
                                if (!_$t || "constant" === _$t.value.kind) continue;
                                var s = "round" === i.layout.get("line-cap"), a = {
                                    dasharray: _$t.value.evaluate({
                                        zoom: r - 1
                                    }, e1, {}),
                                    round: s
                                }, o = {
                                    dasharray: _$t.value.evaluate({
                                        zoom: r
                                    }, e1, {}),
                                    round: s
                                }, l = {
                                    dasharray: _$t.value.evaluate({
                                        zoom: r + 1
                                    }, e1, {}),
                                    round: s
                                }, u = "".concat(a.dasharray.join(","), ",").concat(a.round), _$c = "".concat(o.dasharray.join(","), ",").concat(o.round), _$h = "".concat(l.dasharray.join(","), ",").concat(l.round);
                                n.dashDependencies[u] = a, n.dashDependencies[_$c] = o, n.dashDependencies[_$h] = l, e1.dashes[i.id] = {
                                    min: u,
                                    mid: _$c,
                                    max: _$h
                                };
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
            ]);
            return tc;
        }();
        var ec, rc;
        ps("LineBucket", tc, {
            omit: [
                "layers",
                "patternFeatures"
            ]
        });
        var nc = {
            get paint () {
                return rc = rc || new Hs({
                    "line-opacity": new Gs(vt.paint_line["line-opacity"]),
                    "line-color": new Gs(vt.paint_line["line-color"]),
                    "line-translate": new js(vt.paint_line["line-translate"]),
                    "line-translate-anchor": new js(vt.paint_line["line-translate-anchor"]),
                    "line-width": new Gs(vt.paint_line["line-width"]),
                    "line-gap-width": new Gs(vt.paint_line["line-gap-width"]),
                    "line-offset": new Gs(vt.paint_line["line-offset"]),
                    "line-blur": new Gs(vt.paint_line["line-blur"]),
                    "line-dasharray": new Xs(vt.paint_line["line-dasharray"]),
                    "line-pattern": new Xs(vt.paint_line["line-pattern"]),
                    "line-gradient": new Zs(vt.paint_line["line-gradient"])
                });
            },
            get layout () {
                return ec = ec || new Hs({
                    "line-cap": new js(vt.layout_line["line-cap"]),
                    "line-join": new Gs(vt.layout_line["line-join"]),
                    "line-miter-limit": new js(vt.layout_line["line-miter-limit"]),
                    "line-round-limit": new js(vt.layout_line["line-round-limit"]),
                    "line-sort-key": new Gs(vt.layout_line["line-sort-key"])
                });
            }
        };
        var ic = /*#__PURE__*/ function(Gs) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ic, Gs);
            function ic() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ic);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ic, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ic, [
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(t, e1) {
                        return e1 = new Ps(Math.floor(e1.zoom), {
                            now: e1.now,
                            fadeDuration: e1.fadeDuration,
                            zoomHistory: e1.zoomHistory,
                            transition: e1.transition
                        }), (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(ic.prototype), "possiblyEvaluate", this).call(this, t, e1);
                    }
                },
                {
                    key: "evaluate",
                    value: function evaluate(t, e1, r, n) {
                        return e1 = O({}, e1, {
                            zoom: Math.floor(e1.zoom)
                        }), (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(ic.prototype), "evaluate", this).call(this, t, e1, r, n);
                    }
                }
            ]);
            return ic;
        }(Gs);
        var sc;
        var ac = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ac, Ks);
            function ac(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ac);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ac, [
                    t,
                    nc,
                    e1
                ]), _this.gradientVersion = 0, sc || (sc = new ic(nc.paint.properties["line-width"].specification), sc.useIntegerZoom = !0);
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ac, [
                {
                    key: "_handleSpecialPaintPropertyUpdate",
                    value: function _handleSpecialPaintPropertyUpdate(t) {
                        if ("line-gradient" === t) {
                            var _$t = this.gradientExpression();
                            this.stepInterpolant = !!function(t) {
                                return void 0 !== t._styleExpression;
                            }(_$t) && _$t._styleExpression.expression instanceof or, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                        }
                    }
                },
                {
                    key: "gradientExpression",
                    value: function gradientExpression() {
                        return this._transitionablePaint._values["line-gradient"].value.expression;
                    }
                },
                {
                    key: "recalculate",
                    value: function recalculate(t, e1) {
                        (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(ac.prototype), "recalculate", this).call(this, t, e1), this.paint._values["line-floorwidth"] = sc.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, t);
                    }
                },
                {
                    key: "createBucket",
                    value: function createBucket(t) {
                        return new tc(t);
                    }
                },
                {
                    key: "queryRadius",
                    value: function queryRadius(t) {
                        var _$e = t, _$r = oc(rl("line-width", this, _$e), rl("line-gap-width", this, _$e)), _$n = rl("line-offset", this, _$e);
                        return _$r / 2 + Math.abs(_$n) + nl(this.paint.get("line-translate"));
                    }
                },
                {
                    key: "queryIntersectsFeature",
                    value: function queryIntersectsFeature(param) {
                        var _$t = param.queryGeometry, _$e = param.feature, _$n = param.featureState, i = param.geometry, s = param.transform, a = param.pixelsToTileUnits;
                        var o = il(_$t, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), -s.bearingInRadians, a), l = a / 2 * oc(this.paint.get("line-width").evaluate(_$e, _$n), this.paint.get("line-gap-width").evaluate(_$e, _$n)), u = this.paint.get("line-offset").evaluate(_$e, _$n);
                        return u && (i = function(t, e1) {
                            var _$n = [];
                            for(var i = 0; i < t.length; i++){
                                var s = sl(t[i]), a = [];
                                for(var _$t = 0; _$t < s.length; _$t++){
                                    var _$n1 = s[_$t], i1 = s[_$t - 1], o = s[_$t + 1], l = 0 === _$t ? new r(0, 0) : _$n1.sub(i1)._unit()._perp(), u = _$t === s.length - 1 ? new r(0, 0) : o.sub(_$n1)._unit()._perp(), _$c = l._add(u)._unit(), _$h = _$c.x * u.x + _$c.y * u.y;
                                    0 !== _$h && _$c._mult(1 / _$h), a.push(_$c._mult(e1)._add(_$n1));
                                }
                                _$n.push(a);
                            }
                            return _$n;
                        }(i, u * a)), function(t, e1, r) {
                            for(var _$n = 0; _$n < e1.length; _$n++){
                                var i = e1[_$n];
                                if (t.length >= 3) {
                                    for(var _$e = 0; _$e < i.length; _$e++)if (tl(t, i[_$e])) return !0;
                                }
                                if (Zo(t, i, r)) return !0;
                            }
                            return !1;
                        }(o, i, l);
                    }
                },
                {
                    key: "isTileClipped",
                    value: function isTileClipped() {
                        return !0;
                    }
                }
            ]);
            return ac;
        }(Ks);
        function oc(t, e1) {
            return e1 > 0 ? e1 + 2 * t : t;
        }
        var lc = na([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), uc = na([
            {
                name: "a_projected_pos",
                components: 3,
                type: "Float32"
            }
        ], 4);
        na([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        var cc = na([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_box_real",
                components: 2,
                type: "Int16"
            }
        ]);
        na([
            {
                type: "Int16",
                name: "anchorPointX"
            },
            {
                type: "Int16",
                name: "anchorPointY"
            },
            {
                type: "Int16",
                name: "x1"
            },
            {
                type: "Int16",
                name: "y1"
            },
            {
                type: "Int16",
                name: "x2"
            },
            {
                type: "Int16",
                name: "y2"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        var hc = na([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), pc = na([
            {
                name: "a_pos",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        function fc(t, e1, r) {
            return t.sections.forEach(function(t) {
                t.text = function(t, e1, r) {
                    var _$n = e1.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === _$n ? t = t.toLocaleUpperCase() : "lowercase" === _$n && (t = t.toLocaleLowerCase()), zs.applyArabicShaping && (t = zs.applyArabicShaping(t)), t;
                }(t.text, e1, r);
            }), t;
        }
        na([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), na([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            }
        ]), na([
            {
                type: "Int16",
                name: "anchorX"
            },
            {
                type: "Int16",
                name: "anchorY"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                name: "textBoxScale"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetStartIndex"
            },
            {
                type: "Uint16",
                name: "textAnchorOffsetEndIndex"
            }
        ]), na([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), na([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            },
            {
                type: "Int16",
                name: "tileUnitDistanceFromAnchor"
            }
        ]), na([
            {
                type: "Uint16",
                name: "textAnchor"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            }
        ]);
        var dc = 24;
        var yc = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u22EF": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42"
        }, mc = {
            10: !0,
            32: !0,
            38: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        }, gc = {
            40: !0
        };
        function xc(t, e1, r, n, i, s) {
            if ("fontStack" in e1) {
                var _$n = r[e1.fontStack], _$s = _$n && _$n[t];
                return _$s ? _$s.metrics.advance * e1.scale + i : 0;
            }
            {
                var _$t = n[e1.imageName];
                return _$t ? _$t.displaySize[0] * e1.scale * dc / s + i : 0;
            }
        }
        function vc(t, e1, r, n) {
            var i = Math.pow(t - e1, 2);
            return n ? t < e1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function bc(t, e1, r) {
            var _$n = 0;
            return 10 === t && (_$n -= 1e4), r && (_$n += 150), 40 !== t && 65288 !== t || (_$n += 50), 41 !== e1 && 65289 !== e1 || (_$n += 50), _$n;
        }
        function wc(t, e1, r, n, i, s) {
            var a = null, o = vc(e1, r, i, s);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$t = _step.value;
                    var _$n = vc(e1 - _$t.x, r, i, s) + _$t.badness;
                    _$n <= o && (a = _$t, o = _$n);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return {
                index: t,
                x: e1,
                priorBreak: a,
                badness: o
            };
        }
        function _c(t) {
            return t ? _c(t.priorBreak).concat(t.index) : [];
        }
        var Sc = /*#__PURE__*/ function() {
            function Sc() {
                var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Sc);
                this.text = _$t, this.sections = _$e, this.sectionIndex = _$r, this.imageSectionID = null;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Sc, [
                {
                    key: "length",
                    value: function length() {
                        return (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(this.text).length;
                    }
                },
                {
                    key: "getSection",
                    value: function getSection(t) {
                        return this.sections[this.sectionIndex[t]];
                    }
                },
                {
                    key: "getSectionIndex",
                    value: function getSectionIndex(t) {
                        return this.sectionIndex[t];
                    }
                },
                {
                    key: "verticalizePunctuation",
                    value: function verticalizePunctuation() {
                        this.text = function(t) {
                            var _$e = "", _$r = {
                                premature: !0,
                                value: void 0
                            };
                            var _$n = t[Symbol.iterator]();
                            var i = _$n.next();
                            var s = t[Symbol.iterator]();
                            s.next();
                            var a = s.next();
                            for(; !i.done;)_$e += !a.done && Ts(a.value.codePointAt(0)) && !yc[a.value] || !_$r.premature && Ts(_$r.value.codePointAt(0)) && !yc[_$r.value] || !yc[i.value] ? i.value : yc[i.value], _$r = {
                                value: i.value,
                                premature: !1
                            }, i = _$n.next(), a = s.next();
                            return _$e;
                        }(this.text);
                    }
                },
                {
                    key: "hasZeroWidthSpaces",
                    value: function hasZeroWidthSpaces() {
                        return this.text.includes("\u200B");
                    }
                },
                {
                    key: "trim",
                    value: function trim() {
                        var _$t = this.text.match(/^\s*/), _$e = _$t ? _$t[0].length : 0, _$r = this.text.match(/\S\s*$/), _$n = _$r ? _$r[0].length - 1 : 0;
                        this.text = this.text.substring(_$e, this.text.length - _$n), this.sectionIndex = this.sectionIndex.slice(_$e, this.sectionIndex.length - _$n);
                    }
                },
                {
                    key: "substring",
                    value: function substring(t, e1) {
                        var _$r = (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(this.text).slice(t, e1).join(""), _$n = this.sectionIndex.slice(t, e1);
                        return new Sc(_$r, this.sections, _$n);
                    }
                },
                {
                    key: "toCodeUnitIndex",
                    value: function toCodeUnitIndex(t) {
                        return (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(this.text).slice(0, t).join("").length;
                    }
                },
                {
                    key: "toString",
                    value: function toString() {
                        return this.text;
                    }
                },
                {
                    key: "getMaxScale",
                    value: function getMaxScale() {
                        var _this = this;
                        return this.sectionIndex.reduce(function(t, e1) {
                            return Math.max(t, _this.sections[e1].scale);
                        }, 0);
                    }
                },
                {
                    key: "getMaxImageSize",
                    value: function getMaxImageSize(t) {
                        var _$e = 0, _$r = 0;
                        for(var _$n = 0; _$n < this.length(); _$n++){
                            var i = this.getSection(_$n);
                            if ("imageName" in i) {
                                var _$n1 = t[i.imageName];
                                if (!_$n1) continue;
                                var s = _$n1.displaySize;
                                _$e = Math.max(_$e, s[0]), _$r = Math.max(_$r, s[1]);
                            }
                        }
                        return {
                            maxImageWidth: _$e,
                            maxImageHeight: _$r
                        };
                    }
                },
                {
                    key: "addTextSection",
                    value: function addTextSection(t, e1) {
                        var _this_sectionIndex;
                        this.text += t.text, this.sections.push({
                            scale: t.scale || 1,
                            verticalAlign: t.verticalAlign || "bottom",
                            fontStack: t.fontStack || e1
                        });
                        var _$r = this.sections.length - 1;
                        (_this_sectionIndex = this.sectionIndex).push.apply(_this_sectionIndex, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(t.text).map(function() {
                            return _$r;
                        })));
                    }
                },
                {
                    key: "addImageSection",
                    value: function addImageSection(t) {
                        var _$e = t.image ? t.image.name : "";
                        if (0 === _$e.length) return void j("Can't add FormattedSection with an empty image.");
                        var _$r = this.getNextImageSectionCharCode();
                        _$r ? (this.text += String.fromCharCode(_$r), this.sections.push({
                            scale: 1,
                            verticalAlign: t.verticalAlign || "bottom",
                            imageName: _$e
                        }), this.sectionIndex.push(this.sections.length - 1)) : j("Reached maximum number of images 6401");
                    }
                },
                {
                    key: "getNextImageSectionCharCode",
                    value: function getNextImageSectionCharCode() {
                        return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
                    }
                },
                {
                    key: "determineLineBreaks",
                    value: function determineLineBreaks(t, e1, r, n, i) {
                        var s = [], a = this.determineAverageLineWidth(t, e1, r, n, i), o = this.hasZeroWidthSpaces();
                        var l = 0, u = 0;
                        var _$c = this.text[Symbol.iterator]();
                        var _$h = _$c.next();
                        var p = this.text[Symbol.iterator]();
                        p.next();
                        var f = p.next();
                        var _$d = this.text[Symbol.iterator]();
                        _$d.next(), _$d.next();
                        var _$y = _$d.next();
                        for(; !_$h.done;){
                            var _$e = this.getSection(u), _$m = _$h.value.codePointAt(0);
                            if (ws(_$m) || (l += xc(_$m, _$e, r, n, t, i)), !f.done) {
                                var _$t = vs(_$m), _$r = f.value.codePointAt(0);
                                (mc[_$m] || _$t || "imageName" in _$e || !_$y.done && gc[_$r]) && s.push(wc(u + 1, l, a, s, bc(_$m, _$r, _$t && o), !1));
                            }
                            u++, _$h = _$c.next(), f = p.next(), _$y = _$d.next();
                        }
                        return _c(wc(this.length(), l, a, s, 0, !0));
                    }
                },
                {
                    key: "determineAverageLineWidth",
                    value: function determineAverageLineWidth(t, e1, r, n, i) {
                        var s = 0, a = 0;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.text[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                var o = this.getSection(a);
                                s += xc(_$e.codePointAt(0), o, r, n, t, i), a++;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return s / Math.max(1, Math.ceil(s / e1));
                    }
                }
            ], [
                {
                    key: "fromFeature",
                    value: function fromFeature(t, e1) {
                        var _$r = new Sc;
                        for(var _$n = 0; _$n < t.sections.length; _$n++){
                            var i = t.sections[_$n];
                            i.image ? _$r.addImageSection(i) : _$r.addTextSection(i, e1);
                        }
                        return _$r;
                    }
                }
            ]);
            return Sc;
        }();
        var Ac = 4294967296, kc = 1 / Ac, Ec = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
        var Tc = /*#__PURE__*/ function() {
            function Tc() {
                var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new Uint8Array(16);
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Tc);
                this.buf = ArrayBuffer.isView(_$t) ? _$t : new Uint8Array(_$t), this.dataView = new DataView(this.buf.buffer), this.pos = 0, this.type = 0, this.length = this.buf.length;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Tc, [
                {
                    key: "readFields",
                    value: function readFields(t, e1) {
                        var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this.length;
                        for(; this.pos < _$r;){
                            var _$r1 = this.readVarint(), _$n = _$r1 >> 3, i = this.pos;
                            this.type = 7 & _$r1, t(_$n, e1, this), this.pos === i && this.skip(_$r1);
                        }
                        return e1;
                    }
                },
                {
                    key: "readMessage",
                    value: function readMessage(t, e1) {
                        return this.readFields(t, e1, this.readVarint() + this.pos);
                    }
                },
                {
                    key: "readFixed32",
                    value: function readFixed32() {
                        var _$t = this.dataView.getUint32(this.pos, !0);
                        return this.pos += 4, _$t;
                    }
                },
                {
                    key: "readSFixed32",
                    value: function readSFixed32() {
                        var _$t = this.dataView.getInt32(this.pos, !0);
                        return this.pos += 4, _$t;
                    }
                },
                {
                    key: "readFixed64",
                    value: function readFixed64() {
                        var _$t = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * Ac;
                        return this.pos += 8, _$t;
                    }
                },
                {
                    key: "readSFixed64",
                    value: function readSFixed64() {
                        var _$t = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * Ac;
                        return this.pos += 8, _$t;
                    }
                },
                {
                    key: "readFloat",
                    value: function readFloat() {
                        var _$t = this.dataView.getFloat32(this.pos, !0);
                        return this.pos += 4, _$t;
                    }
                },
                {
                    key: "readDouble",
                    value: function readDouble() {
                        var _$t = this.dataView.getFloat64(this.pos, !0);
                        return this.pos += 8, _$t;
                    }
                },
                {
                    key: "readVarint",
                    value: function readVarint(t) {
                        var _$e = this.buf;
                        var _$r, _$n;
                        return _$n = _$e[this.pos++], _$r = 127 & _$n, _$n < 128 ? _$r : (_$n = _$e[this.pos++], _$r |= (127 & _$n) << 7, _$n < 128 ? _$r : (_$n = _$e[this.pos++], _$r |= (127 & _$n) << 14, _$n < 128 ? _$r : (_$n = _$e[this.pos++], _$r |= (127 & _$n) << 21, _$n < 128 ? _$r : (_$n = _$e[this.pos], _$r |= (15 & _$n) << 28, function(t, e1, r) {
                            var _$n = r.buf;
                            var i, s;
                            if (s = _$n[r.pos++], i = (112 & s) >> 4, s < 128) return Ic(t, i, e1);
                            if (s = _$n[r.pos++], i |= (127 & s) << 3, s < 128) return Ic(t, i, e1);
                            if (s = _$n[r.pos++], i |= (127 & s) << 10, s < 128) return Ic(t, i, e1);
                            if (s = _$n[r.pos++], i |= (127 & s) << 17, s < 128) return Ic(t, i, e1);
                            if (s = _$n[r.pos++], i |= (127 & s) << 24, s < 128) return Ic(t, i, e1);
                            if (s = _$n[r.pos++], i |= (1 & s) << 31, s < 128) return Ic(t, i, e1);
                            throw new Error("Expected varint not more than 10 bytes");
                        }(_$r, t, this)))));
                    }
                },
                {
                    key: "readVarint64",
                    value: function readVarint64() {
                        return this.readVarint(!0);
                    }
                },
                {
                    key: "readSVarint",
                    value: function readSVarint() {
                        var _$t = this.readVarint();
                        return _$t % 2 == 1 ? (_$t + 1) / -2 : _$t / 2;
                    }
                },
                {
                    key: "readBoolean",
                    value: function readBoolean() {
                        return Boolean(this.readVarint());
                    }
                },
                {
                    key: "readString",
                    value: function readString() {
                        var _$t = this.readVarint() + this.pos, _$e = this.pos;
                        return this.pos = _$t, _$t - _$e >= 12 && Ec ? Ec.decode(this.buf.subarray(_$e, _$t)) : function(t, e1, r) {
                            var _$n = "", i = e1;
                            for(; i < r;){
                                var _$e = t[i];
                                var s = void 0, a = void 0, o = void 0, l = null, u = _$e > 239 ? 4 : _$e > 223 ? 3 : _$e > 191 ? 2 : 1;
                                if (i + u > r) break;
                                1 === u ? _$e < 128 && (l = _$e) : 2 === u ? (s = t[i + 1], 128 == (192 & s) && (l = (31 & _$e) << 6 | 63 & s, l <= 127 && (l = null))) : 3 === u ? (s = t[i + 1], a = t[i + 2], 128 == (192 & s) && 128 == (192 & a) && (l = (15 & _$e) << 12 | (63 & s) << 6 | 63 & a, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === u && (s = t[i + 1], a = t[i + 2], o = t[i + 3], 128 == (192 & s) && 128 == (192 & a) && 128 == (192 & o) && (l = (15 & _$e) << 18 | (63 & s) << 12 | (63 & a) << 6 | 63 & o, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, u = 1) : l > 65535 && (l -= 65536, _$n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), _$n += String.fromCharCode(l), i += u;
                            }
                            return _$n;
                        }(this.buf, _$e, _$t);
                    }
                },
                {
                    key: "readBytes",
                    value: function readBytes() {
                        var _$t = this.readVarint() + this.pos, _$e = this.buf.subarray(this.pos, _$t);
                        return this.pos = _$t, _$e;
                    }
                },
                {
                    key: "readPackedVarint",
                    value: function readPackedVarint() {
                        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], _$e = arguments.length > 1 ? arguments[1] : void 0;
                        var _$r = this.readPackedEnd();
                        for(; this.pos < _$r;)_$t.push(this.readVarint(_$e));
                        return _$t;
                    }
                },
                {
                    key: "readPackedSVarint",
                    value: function readPackedSVarint() {
                        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                        var _$e = this.readPackedEnd();
                        for(; this.pos < _$e;)_$t.push(this.readSVarint());
                        return _$t;
                    }
                },
                {
                    key: "readPackedBoolean",
                    value: function readPackedBoolean() {
                        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                        var _$e = this.readPackedEnd();
                        for(; this.pos < _$e;)_$t.push(this.readBoolean());
                        return _$t;
                    }
                },
                {
                    key: "readPackedFloat",
                    value: function readPackedFloat() {
                        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                        var _$e = this.readPackedEnd();
                        for(; this.pos < _$e;)_$t.push(this.readFloat());
                        return _$t;
                    }
                },
                {
                    key: "readPackedDouble",
                    value: function readPackedDouble() {
                        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                        var _$e = this.readPackedEnd();
                        for(; this.pos < _$e;)_$t.push(this.readDouble());
                        return _$t;
                    }
                },
                {
                    key: "readPackedFixed32",
                    value: function readPackedFixed32() {
                        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                        var _$e = this.readPackedEnd();
                        for(; this.pos < _$e;)_$t.push(this.readFixed32());
                        return _$t;
                    }
                },
                {
                    key: "readPackedSFixed32",
                    value: function readPackedSFixed32() {
                        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                        var _$e = this.readPackedEnd();
                        for(; this.pos < _$e;)_$t.push(this.readSFixed32());
                        return _$t;
                    }
                },
                {
                    key: "readPackedFixed64",
                    value: function readPackedFixed64() {
                        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                        var _$e = this.readPackedEnd();
                        for(; this.pos < _$e;)_$t.push(this.readFixed64());
                        return _$t;
                    }
                },
                {
                    key: "readPackedSFixed64",
                    value: function readPackedSFixed64() {
                        var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
                        var _$e = this.readPackedEnd();
                        for(; this.pos < _$e;)_$t.push(this.readSFixed64());
                        return _$t;
                    }
                },
                {
                    key: "readPackedEnd",
                    value: function readPackedEnd() {
                        return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
                    }
                },
                {
                    key: "skip",
                    value: function skip(t) {
                        var _$e = 7 & t;
                        if (0 === _$e) for(; this.buf[this.pos++] > 127;);
                        else if (2 === _$e) this.pos = this.readVarint() + this.pos;
                        else if (5 === _$e) this.pos += 4;
                        else {
                            if (1 !== _$e) throw new Error("Unimplemented type: ".concat(_$e));
                            this.pos += 8;
                        }
                    }
                },
                {
                    key: "writeTag",
                    value: function writeTag(t, e1) {
                        this.writeVarint(t << 3 | e1);
                    }
                },
                {
                    key: "realloc",
                    value: function realloc(t) {
                        var _$e = this.length || 16;
                        for(; _$e < this.pos + t;)_$e *= 2;
                        if (_$e !== this.length) {
                            var _$t = new Uint8Array(_$e);
                            _$t.set(this.buf), this.buf = _$t, this.dataView = new DataView(_$t.buffer), this.length = _$e;
                        }
                    }
                },
                {
                    key: "finish",
                    value: function finish() {
                        return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                    }
                },
                {
                    key: "writeFixed32",
                    value: function writeFixed32(t) {
                        this.realloc(4), this.dataView.setInt32(this.pos, t, !0), this.pos += 4;
                    }
                },
                {
                    key: "writeSFixed32",
                    value: function writeSFixed32(t) {
                        this.realloc(4), this.dataView.setInt32(this.pos, t, !0), this.pos += 4;
                    }
                },
                {
                    key: "writeFixed64",
                    value: function writeFixed64(t) {
                        this.realloc(8), this.dataView.setInt32(this.pos, -1 & t, !0), this.dataView.setInt32(this.pos + 4, Math.floor(t * kc), !0), this.pos += 8;
                    }
                },
                {
                    key: "writeSFixed64",
                    value: function writeSFixed64(t) {
                        this.realloc(8), this.dataView.setInt32(this.pos, -1 & t, !0), this.dataView.setInt32(this.pos + 4, Math.floor(t * kc), !0), this.pos += 8;
                    }
                },
                {
                    key: "writeVarint",
                    value: function writeVarint(t) {
                        (t = +t || 0) > 268435455 || t < 0 ? function(t, e1) {
                            var _$r, _$n;
                            if (t >= 0 ? (_$r = t % 4294967296 | 0, _$n = t / 4294967296 | 0) : (_$r = ~(-t % 4294967296), _$n = ~(-t / 4294967296), 4294967295 ^ _$r ? _$r = _$r + 1 | 0 : (_$r = 0, _$n = _$n + 1 | 0)), t >= 0x10000000000000000 || t < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                            e1.realloc(10), function(t, e1, r) {
                                r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, t >>>= 7, r.buf[r.pos++] = 127 & t | 128, r.buf[r.pos] = 127 & (t >>>= 7);
                            }(_$r, 0, e1), function(t, e1) {
                                var _$r = (7 & t) << 4;
                                e1.buf[e1.pos++] |= _$r | ((t >>>= 3) ? 128 : 0), t && (e1.buf[e1.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e1.buf[e1.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e1.buf[e1.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e1.buf[e1.pos++] = 127 & t | ((t >>>= 7) ? 128 : 0), t && (e1.buf[e1.pos++] = 127 & t)))));
                            }(_$n, e1);
                        }(t, this) : (this.realloc(4), this.buf[this.pos++] = 127 & t | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = 127 & (t >>>= 7) | (t > 127 ? 128 : 0), t <= 127 || (this.buf[this.pos++] = t >>> 7 & 127))));
                    }
                },
                {
                    key: "writeSVarint",
                    value: function writeSVarint(t) {
                        this.writeVarint(t < 0 ? 2 * -t - 1 : 2 * t);
                    }
                },
                {
                    key: "writeBoolean",
                    value: function writeBoolean(t) {
                        this.writeVarint(+t);
                    }
                },
                {
                    key: "writeString",
                    value: function writeString(t) {
                        t = String(t), this.realloc(4 * t.length), this.pos++;
                        var _$e = this.pos;
                        this.pos = function(t, e1, r) {
                            for(var _$n, i, s = 0; s < e1.length; s++){
                                if (_$n = e1.charCodeAt(s), _$n > 55295 && _$n < 57344) {
                                    if (!i) {
                                        _$n > 56319 || s + 1 === e1.length ? (t[r++] = 239, t[r++] = 191, t[r++] = 189) : i = _$n;
                                        continue;
                                    }
                                    if (_$n < 56320) {
                                        t[r++] = 239, t[r++] = 191, t[r++] = 189, i = _$n;
                                        continue;
                                    }
                                    _$n = i - 55296 << 10 | _$n - 56320 | 65536, i = null;
                                } else i && (t[r++] = 239, t[r++] = 191, t[r++] = 189, i = null);
                                _$n < 128 ? t[r++] = _$n : (_$n < 2048 ? t[r++] = _$n >> 6 | 192 : (_$n < 65536 ? t[r++] = _$n >> 12 | 224 : (t[r++] = _$n >> 18 | 240, t[r++] = _$n >> 12 & 63 | 128), t[r++] = _$n >> 6 & 63 | 128), t[r++] = 63 & _$n | 128);
                            }
                            return r;
                        }(this.buf, t, this.pos);
                        var _$r = this.pos - _$e;
                        _$r >= 128 && Mc(_$e, _$r, this), this.pos = _$e - 1, this.writeVarint(_$r), this.pos += _$r;
                    }
                },
                {
                    key: "writeFloat",
                    value: function writeFloat(t) {
                        this.realloc(4), this.dataView.setFloat32(this.pos, t, !0), this.pos += 4;
                    }
                },
                {
                    key: "writeDouble",
                    value: function writeDouble(t) {
                        this.realloc(8), this.dataView.setFloat64(this.pos, t, !0), this.pos += 8;
                    }
                },
                {
                    key: "writeBytes",
                    value: function writeBytes(t) {
                        var _$e = t.length;
                        this.writeVarint(_$e), this.realloc(_$e);
                        for(var _$r = 0; _$r < _$e; _$r++)this.buf[this.pos++] = t[_$r];
                    }
                },
                {
                    key: "writeRawMessage",
                    value: function writeRawMessage(t, e1) {
                        this.pos++;
                        var _$r = this.pos;
                        t(e1, this);
                        var _$n = this.pos - _$r;
                        _$n >= 128 && Mc(_$r, _$n, this), this.pos = _$r - 1, this.writeVarint(_$n), this.pos += _$n;
                    }
                },
                {
                    key: "writeMessage",
                    value: function writeMessage(t, e1, r) {
                        this.writeTag(t, 2), this.writeRawMessage(e1, r);
                    }
                },
                {
                    key: "writePackedVarint",
                    value: function writePackedVarint(t, e1) {
                        e1.length && this.writeMessage(t, Fc, e1);
                    }
                },
                {
                    key: "writePackedSVarint",
                    value: function writePackedSVarint(t, e1) {
                        e1.length && this.writeMessage(t, Dc, e1);
                    }
                },
                {
                    key: "writePackedBoolean",
                    value: function writePackedBoolean(t, e1) {
                        e1.length && this.writeMessage(t, Bc, e1);
                    }
                },
                {
                    key: "writePackedFloat",
                    value: function writePackedFloat(t, e1) {
                        e1.length && this.writeMessage(t, zc, e1);
                    }
                },
                {
                    key: "writePackedDouble",
                    value: function writePackedDouble(t, e1) {
                        e1.length && this.writeMessage(t, Pc, e1);
                    }
                },
                {
                    key: "writePackedFixed32",
                    value: function writePackedFixed32(t, e1) {
                        e1.length && this.writeMessage(t, Vc, e1);
                    }
                },
                {
                    key: "writePackedSFixed32",
                    value: function writePackedSFixed32(t, e1) {
                        e1.length && this.writeMessage(t, Cc, e1);
                    }
                },
                {
                    key: "writePackedFixed64",
                    value: function writePackedFixed64(t, e1) {
                        e1.length && this.writeMessage(t, Lc, e1);
                    }
                },
                {
                    key: "writePackedSFixed64",
                    value: function writePackedSFixed64(t, e1) {
                        e1.length && this.writeMessage(t, Oc, e1);
                    }
                },
                {
                    key: "writeBytesField",
                    value: function writeBytesField(t, e1) {
                        this.writeTag(t, 2), this.writeBytes(e1);
                    }
                },
                {
                    key: "writeFixed32Field",
                    value: function writeFixed32Field(t, e1) {
                        this.writeTag(t, 5), this.writeFixed32(e1);
                    }
                },
                {
                    key: "writeSFixed32Field",
                    value: function writeSFixed32Field(t, e1) {
                        this.writeTag(t, 5), this.writeSFixed32(e1);
                    }
                },
                {
                    key: "writeFixed64Field",
                    value: function writeFixed64Field(t, e1) {
                        this.writeTag(t, 1), this.writeFixed64(e1);
                    }
                },
                {
                    key: "writeSFixed64Field",
                    value: function writeSFixed64Field(t, e1) {
                        this.writeTag(t, 1), this.writeSFixed64(e1);
                    }
                },
                {
                    key: "writeVarintField",
                    value: function writeVarintField(t, e1) {
                        this.writeTag(t, 0), this.writeVarint(e1);
                    }
                },
                {
                    key: "writeSVarintField",
                    value: function writeSVarintField(t, e1) {
                        this.writeTag(t, 0), this.writeSVarint(e1);
                    }
                },
                {
                    key: "writeStringField",
                    value: function writeStringField(t, e1) {
                        this.writeTag(t, 2), this.writeString(e1);
                    }
                },
                {
                    key: "writeFloatField",
                    value: function writeFloatField(t, e1) {
                        this.writeTag(t, 5), this.writeFloat(e1);
                    }
                },
                {
                    key: "writeDoubleField",
                    value: function writeDoubleField(t, e1) {
                        this.writeTag(t, 1), this.writeDouble(e1);
                    }
                },
                {
                    key: "writeBooleanField",
                    value: function writeBooleanField(t, e1) {
                        this.writeVarintField(t, +e1);
                    }
                }
            ]);
            return Tc;
        }();
        function Ic(t, e1, r) {
            return r ? 4294967296 * e1 + (t >>> 0) : 4294967296 * (e1 >>> 0) + (t >>> 0);
        }
        function Mc(t, e1, r) {
            var _$n = e1 <= 16383 ? 1 : e1 <= 2097151 ? 2 : e1 <= 268435455 ? 3 : Math.floor(Math.log(e1) / (7 * Math.LN2));
            r.realloc(_$n);
            for(var _$e = r.pos - 1; _$e >= t; _$e--)r.buf[_$e + _$n] = r.buf[_$e];
        }
        function Fc(t, e1) {
            for(var _$r = 0; _$r < t.length; _$r++)e1.writeVarint(t[_$r]);
        }
        function Dc(t, e1) {
            for(var _$r = 0; _$r < t.length; _$r++)e1.writeSVarint(t[_$r]);
        }
        function zc(t, e1) {
            for(var _$r = 0; _$r < t.length; _$r++)e1.writeFloat(t[_$r]);
        }
        function Pc(t, e1) {
            for(var _$r = 0; _$r < t.length; _$r++)e1.writeDouble(t[_$r]);
        }
        function Bc(t, e1) {
            for(var _$r = 0; _$r < t.length; _$r++)e1.writeBoolean(t[_$r]);
        }
        function Vc(t, e1) {
            for(var _$r = 0; _$r < t.length; _$r++)e1.writeFixed32(t[_$r]);
        }
        function Cc(t, e1) {
            for(var _$r = 0; _$r < t.length; _$r++)e1.writeSFixed32(t[_$r]);
        }
        function Lc(t, e1) {
            for(var _$r = 0; _$r < t.length; _$r++)e1.writeFixed64(t[_$r]);
        }
        function Oc(t, e1) {
            for(var _$r = 0; _$r < t.length; _$r++)e1.writeSFixed64(t[_$r]);
        }
        function Rc(t, e1, r) {
            1 === t && r.readMessage(Nc, e1);
        }
        function Nc(t, e1, r) {
            if (3 === t) {
                var _r_readMessage = r.readMessage($c, {}), _$t = _r_readMessage.id, _$n = _r_readMessage.bitmap, i = _r_readMessage.width, s = _r_readMessage.height, a = _r_readMessage.left, o = _r_readMessage.top, l = _r_readMessage.advance;
                e1.push({
                    id: _$t,
                    bitmap: new _l({
                        width: i + 6,
                        height: s + 6
                    }, _$n),
                    metrics: {
                        width: i,
                        height: s,
                        left: a,
                        top: o,
                        advance: l
                    }
                });
            }
        }
        function $c(t, e1, r) {
            1 === t ? e1.id = r.readVarint() : 2 === t ? e1.bitmap = r.readBytes() : 3 === t ? e1.width = r.readVarint() : 4 === t ? e1.height = r.readVarint() : 5 === t ? e1.left = r.readSVarint() : 6 === t ? e1.top = r.readSVarint() : 7 === t && (e1.advance = r.readVarint());
        }
        function Uc(t) {
            var _$e = 0, _$r = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$n = _step.value;
                    _$e += _$n.w * _$n.h, _$r = Math.max(_$r, _$n.w);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            t.sort(function(t, e1) {
                return e1.h - t.h;
            });
            var _$n1 = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(_$e / .95)), _$r),
                    h: 1 / 0
                }
            ];
            var i = 0, s = 0;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = t[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _$e1 = _step1.value;
                    for(var _$t = _$n1.length - 1; _$t >= 0; _$t--){
                        var _$r1 = _$n1[_$t];
                        if (!(_$e1.w > _$r1.w || _$e1.h > _$r1.h)) {
                            if (_$e1.x = _$r1.x, _$e1.y = _$r1.y, s = Math.max(s, _$e1.y + _$e1.h), i = Math.max(i, _$e1.x + _$e1.w), _$e1.w === _$r1.w && _$e1.h === _$r1.h) {
                                var _$e2 = _$n1.pop();
                                _$e2 && _$t < _$n1.length && (_$n1[_$t] = _$e2);
                            } else _$e1.h === _$r1.h ? (_$r1.x += _$e1.w, _$r1.w -= _$e1.w) : _$e1.w === _$r1.w ? (_$r1.y += _$e1.h, _$r1.h -= _$e1.h) : (_$n1.push({
                                x: _$r1.x + _$e1.w,
                                y: _$r1.y,
                                w: _$r1.w - _$e1.w,
                                h: _$e1.h
                            }), _$r1.y += _$e1.h, _$r1.h -= _$e1.h);
                            break;
                        }
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return {
                w: i,
                h: s,
                fill: _$e / (i * s) || 0
            };
        }
        var qc = /*#__PURE__*/ function() {
            function qc(t, param) {
                var _$e = param.pixelRatio, _$r = param.version, _$n = param.stretchX, i = param.stretchY, s = param.content, a = param.textFitWidth, o = param.textFitHeight;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, qc);
                this.paddedRect = t, this.pixelRatio = _$e, this.stretchX = _$n, this.stretchY = i, this.content = s, this.version = _$r, this.textFitWidth = a, this.textFitHeight = o;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(qc, [
                {
                    key: "tl",
                    get: function get() {
                        return [
                            this.paddedRect.x + 1,
                            this.paddedRect.y + 1
                        ];
                    }
                },
                {
                    key: "br",
                    get: function get() {
                        return [
                            this.paddedRect.x + this.paddedRect.w - 1,
                            this.paddedRect.y + this.paddedRect.h - 1
                        ];
                    }
                },
                {
                    key: "tlbr",
                    get: function get() {
                        return this.tl.concat(this.br);
                    }
                },
                {
                    key: "displaySize",
                    get: function get() {
                        return [
                            (this.paddedRect.w - 2) / this.pixelRatio,
                            (this.paddedRect.h - 2) / this.pixelRatio
                        ];
                    }
                }
            ]);
            return qc;
        }();
        var jc = /*#__PURE__*/ function() {
            function jc(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, jc);
                var _$r = {}, _$n = {};
                this.haveRenderCallbacks = [];
                var i = [];
                this.addImages(t, _$r, i), this.addImages(e1, _$n, i);
                var _Uc = Uc(i), s = _Uc.w, a = _Uc.h, o = new Sl({
                    width: s || 1,
                    height: a || 1
                });
                for(var _$e in t){
                    var _$n1 = t[_$e], i1 = _$r[_$e].paddedRect;
                    Sl.copy(_$n1.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: i1.x + 1,
                        y: i1.y + 1
                    }, _$n1.data);
                }
                for(var _$t in e1){
                    var _$r1 = e1[_$t], i2 = _$n[_$t].paddedRect, s1 = i2.x + 1, a1 = i2.y + 1, l = _$r1.data.width, u = _$r1.data.height;
                    Sl.copy(_$r1.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s1,
                        y: a1
                    }, _$r1.data), Sl.copy(_$r1.data, o, {
                        x: 0,
                        y: u - 1
                    }, {
                        x: s1,
                        y: a1 - 1
                    }, {
                        width: l,
                        height: 1
                    }), Sl.copy(_$r1.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s1,
                        y: a1 + u
                    }, {
                        width: l,
                        height: 1
                    }), Sl.copy(_$r1.data, o, {
                        x: l - 1,
                        y: 0
                    }, {
                        x: s1 - 1,
                        y: a1
                    }, {
                        width: 1,
                        height: u
                    }), Sl.copy(_$r1.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: s1 + l,
                        y: a1
                    }, {
                        width: 1,
                        height: u
                    });
                }
                this.image = o, this.iconPositions = _$r, this.patternPositions = _$n;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(jc, [
                {
                    key: "addImages",
                    value: function addImages(t, e1, r) {
                        for(var _$n in t){
                            var i = t[_$n], s = {
                                x: 0,
                                y: 0,
                                w: i.data.width + 2,
                                h: i.data.height + 2
                            };
                            r.push(s), e1[_$n] = new qc(s, i), i.hasRenderCallback && this.haveRenderCallbacks.push(_$n);
                        }
                    }
                },
                {
                    key: "patchUpdatedImages",
                    value: function patchUpdatedImages(t, e1) {
                        t.dispatchRenderCallbacks(this.haveRenderCallbacks);
                        for(var _$r in t.updatedImages)this.patchUpdatedImage(this.iconPositions[_$r], t.getImage(_$r), e1), this.patchUpdatedImage(this.patternPositions[_$r], t.getImage(_$r), e1);
                    }
                },
                {
                    key: "patchUpdatedImage",
                    value: function patchUpdatedImage(t, e1, r) {
                        if (!t || !e1) return;
                        if (t.version === e1.version) return;
                        t.version = e1.version;
                        var _t_tl = (0, $db95b225ee8036d6$export$71511d61b312f219)(t.tl, 2), _$n = _t_tl[0], i = _t_tl[1];
                        r.update(e1.data, void 0, {
                            x: _$n,
                            y: i
                        });
                    }
                }
            ]);
            return jc;
        }();
        var Gc;
        function Xc(e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y) {
            var _$m = Sc.fromFeature(e1, s);
            var _$g;
            p === t.az.vertical && _$m.verticalizePunctuation();
            var _$x = _$m.determineLineBreaks(c, a, r, i, d);
            var _$v = zs.processBidirectionalText, _$b = zs.processStyledBidirectionalText;
            if (_$v && 1 === _$m.sections.length) {
                _$g = [], _$x = _$x.map(function(t) {
                    return _$m.toCodeUnitIndex(t);
                });
                var _$t = _$v(_$m.toString(), _$x);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = _$t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        var _$t1 = (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$e).map(function() {
                            return 0;
                        });
                        _$g.push(new Sc(_$e, _$m.sections, _$t1));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            } else if (_$b) {
                var _e;
                _$g = [], _$x = _$x.map(function(t) {
                    return _$m.toCodeUnitIndex(t);
                });
                var _$t2 = 0;
                var _$e1 = [];
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = _$m.text[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _$r = _step1.value;
                        (_e = _$e1).push.apply(_e, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(Array(_$r.length).fill(_$m.sectionIndex[_$t2]))), _$t2++;
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var _$r1 = _$b(_$m.text, _$e1, _$x);
                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                try {
                    for(var _iterator2 = _$r1[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                        var _$t3 = _step2.value;
                        var _$e2 = [];
                        var _$r2 = "";
                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                        try {
                            for(var _iterator3 = _$t3[0][Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                var _$n = _step3.value;
                                _$e2.push(_$t3[1][_$r2.length]), _$r2 += _$n;
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                        _$g.push(new Sc(_$t3[0], _$m.sections, _$e2));
                    }
                } catch (err) {
                    _didIteratorError2 = true;
                    _iteratorError2 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError2) {
                            throw _iteratorError2;
                        }
                    }
                }
            } else _$g = function(t, e1) {
                var _$r = [];
                var _$n = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$i = _step.value;
                        _$r.push(t.substring(_$n, _$i)), _$n = _$i;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return _$n < t.length() && _$r.push(t.substring(_$n, t.length())), _$r;
            }(_$m, _$x);
            var _$w = [], _ = {
                positionedLines: _$w,
                text: _$m.toString(),
                top: h[1],
                bottom: h[1],
                left: h[0],
                right: h[0],
                writingMode: p,
                iconsInText: !1,
                verticalizable: !1
            };
            return function(t, e1, r, n, i, s, a, o, l, u, c, h) {
                var _$p = 0, _$f = 0, _$d = 0, _$y = 0;
                var _$m = "right" === o ? 1 : "left" === o ? 0 : .5, _$g = dc / h;
                var _$x = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$a = _step.value;
                        _$a.trim();
                        var _$i = _$a.getMaxScale(), _$o = {
                            positionedGlyphs: [],
                            lineOffset: 0
                        };
                        t.positionedLines[_$x] = _$o;
                        var _$h = _$o.positionedGlyphs;
                        var _$v = 0;
                        if (!_$a.length()) {
                            _$f += s, ++_$x;
                            continue;
                        }
                        var _$b = Zc(n, _$a, _$g);
                        var _$w = 0;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = _$a.text[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$s = _step1.value;
                                var _$o1 = _$a.getSection(_$w), _$d1 = _$s.codePointAt(0), _$y1 = Kc(l, c, _$d1), _$m1 = {
                                    glyph: _$d1,
                                    imageName: null,
                                    x: _$p,
                                    y: _$f + -17,
                                    vertical: _$y1,
                                    scale: 1,
                                    fontStack: "",
                                    sectionIndex: _$a.getSectionIndex(_$w),
                                    metrics: null,
                                    rect: null
                                };
                                var _$x1 = void 0;
                                if ("fontStack" in _$o1) {
                                    if (_$x1 = Wc(_$o1, _$d1, _$y1, _$b, e1, r), !_$x1) continue;
                                    _$m1.fontStack = _$o1.fontStack;
                                } else {
                                    if (t.iconsInText = !0, _$o1.scale *= _$g, _$x1 = Jc(_$o1, _$y1, _$i, _$b, n), !_$x1) continue;
                                    _$v = Math.max(_$v, _$x1.imageOffset), _$m1.imageName = _$o1.imageName;
                                }
                                var _ = _$x1.rect, S = _$x1.metrics, _$A = _$x1.baselineOffset;
                                _$m1.y += _$A, _$m1.scale = _$o1.scale, _$m1.metrics = S, _$m1.rect = _, _$h.push(_$m1), _$y1 ? (t.verticalizable = !0, _$p += ("imageName" in _$o1 ? S.advance : dc) * _$o1.scale + u) : _$p += S.advance * _$o1.scale + u, _$w++;
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        0 !== _$h.length && (_$d = Math.max(_$p - u, _$d), Qc(_$h, 0, _$h.length - 1, _$m)), _$p = 0, _$o.lineOffset = Math.max(_$v, (_$i - 1) * dc);
                        var _1 = s * _$i + _$v;
                        _$f += _1, _$y = Math.max(_1, _$y), ++_$x;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _Yc = Yc(a), _$v1 = _Yc.horizontalAlign, _$b1 = _Yc.verticalAlign;
                (function(t, e1, r, n, i, s, a, o, l) {
                    var _$u = (e1 - r) * i;
                    var _$c = 0;
                    _$c = s !== a ? -o * n - -17 : -n * l * a + .5 * a;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                            var _$e = _step.value;
                            try {
                                for(var _iterator1 = _$e.positionedGlyphs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step1.value;
                                    _$t.x += _$u, _$t.y += _$c;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                })(t.positionedLines, _$m, _$v1, _$b1, _$d, _$y, s, _$f, i.length), t.top += -_$b1 * _$f, t.bottom = t.top + _$f, t.left += -_$v1 * _$d, t.right = t.left + _$d;
            }(_, r, n, i, _$g, o, l, u, p, c, f, y), !function(t) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        if (0 !== _$e.positionedGlyphs.length) return !1;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return !0;
            }(_$w) && _;
        }
        function Yc(t) {
            var _$e = .5, _$r = .5;
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    _$e = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    _$e = 0;
            }
            switch(t){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    _$r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    _$r = 0;
            }
            return {
                horizontalAlign: _$e,
                verticalAlign: _$r
            };
        }
        function Zc(t, e1, r) {
            var _$n = e1.getMaxScale() * dc, _e_getMaxImageSize = e1.getMaxImageSize(t), i = _e_getMaxImageSize.maxImageWidth, s = _e_getMaxImageSize.maxImageHeight, a = Math.max(_$n, s * r);
            return {
                verticalLineContentWidth: Math.max(_$n, i * r),
                horizontalLineContentHeight: a
            };
        }
        function Hc(t) {
            switch(t){
                case "top":
                    return 0;
                case "center":
                    return .5;
                default:
                    return 1;
            }
        }
        function Kc(e1, r, n) {
            var i;
            return !(e1 === t.az.horizontal || !r && !bs(n) || r && (ws(n) || (i = n, RegExp("\\p{sc=Arab}", "u").test(String.fromCodePoint(i)))));
        }
        function Wc(t, e1, r, n, i, s) {
            var a = s[t.fontStack], o = function(t, e1, r, n) {
                if (t && t.rect) return t;
                var _$i = e1[r.fontStack], _$s = _$i && _$i[n];
                return _$s ? {
                    rect: null,
                    metrics: _$s.metrics
                } : null;
            }(a && a[e1], i, t, e1);
            if (null === o) return null;
            var l;
            if (r) l = n.verticalLineContentWidth - t.scale * dc;
            else {
                var _$e = Hc(t.verticalAlign);
                l = (n.horizontalLineContentHeight - t.scale * dc) * _$e;
            }
            return {
                rect: o.rect,
                metrics: o.metrics,
                baselineOffset: l
            };
        }
        function Jc(t, e1, r, n, i) {
            var s = i[t.imageName];
            if (!s) return null;
            var a = s.paddedRect, o = s.displaySize, l = {
                width: o[0],
                height: o[1],
                left: 1,
                top: -3,
                advance: e1 ? o[1] : o[0]
            };
            var u;
            if (e1) u = n.verticalLineContentWidth - o[1] * t.scale;
            else {
                var _$e = Hc(t.verticalAlign);
                u = (n.horizontalLineContentHeight - o[1] * t.scale) * _$e;
            }
            return {
                rect: a,
                metrics: l,
                baselineOffset: u,
                imageOffset: (e1 ? o[0] : o[1]) * t.scale - dc * r
            };
        }
        function Qc(t, e1, r, n) {
            if (0 === n) return;
            var i = t[r], s = (t[r].x + i.metrics.advance * i.scale) * n;
            for(var _$n = e1; _$n <= r; _$n++)t[_$n].x -= s;
        }
        function th(t, e1, r) {
            var _Yc = Yc(r), _$n = _Yc.horizontalAlign, i = _Yc.verticalAlign, s = e1[0] - t.displaySize[0] * _$n, a = e1[1] - t.displaySize[1] * i;
            return {
                image: t,
                top: a,
                bottom: a + t.displaySize[1],
                left: s,
                right: s + t.displaySize[0]
            };
        }
        function eh(t) {
            var _$e, _$r;
            var _$n = t.left, i = t.top, s = t.right - _$n, a = t.bottom - i;
            var o = null !== (_$e = t.image.textFitWidth) && void 0 !== _$e ? _$e : "stretchOrShrink", l = null !== (_$r = t.image.textFitHeight) && void 0 !== _$r ? _$r : "stretchOrShrink", u = (t.image.content[2] - t.image.content[0]) / (t.image.content[3] - t.image.content[1]);
            if ("proportional" === l) {
                if ("stretchOnly" === o && s / a < u || "proportional" === o) {
                    var _$t = Math.ceil(a * u);
                    _$n *= _$t / s, s = _$t;
                }
            } else if ("proportional" === o && "stretchOnly" === l && 0 !== u && s / a > u) {
                var _$t1 = Math.ceil(s / u);
                i *= _$t1 / a, a = _$t1;
            }
            return {
                x1: _$n,
                y1: i,
                x2: _$n + s,
                y2: i + a
            };
        }
        function rh(t, e1, r, n, i, s) {
            var a = t.image;
            var o;
            if (a.content) {
                var _$t = a.content, _$e = a.pixelRatio || 1;
                o = [
                    _$t[0] / _$e,
                    _$t[1] / _$e,
                    a.displaySize[0] - _$t[2] / _$e,
                    a.displaySize[1] - _$t[3] / _$e
                ];
            }
            var l = e1.left * s, u = e1.right * s;
            var _$c, _$h, p, f;
            "width" === r || "both" === r ? (f = i[0] + l - n[3], _$h = i[0] + u + n[1]) : (f = i[0] + (l + u - a.displaySize[0]) / 2, _$h = f + a.displaySize[0]);
            var _$d = e1.top * s, _$y = e1.bottom * s;
            return "height" === r || "both" === r ? (_$c = i[1] + _$d - n[0], p = i[1] + _$y + n[2]) : (_$c = i[1] + (_$d + _$y - a.displaySize[1]) / 2, p = _$c + a.displaySize[1]), {
                image: a,
                top: _$c,
                right: _$h,
                bottom: p,
                left: f,
                collisionPadding: o
            };
        }
        ps("ImagePosition", qc), ps("ImageAtlas", jc), t.az = void 0, (Gc = t.az || (t.az = {}))[Gc.none = 0] = "none", Gc[Gc.horizontal = 1] = "horizontal", Gc[Gc.vertical = 2] = "vertical", Gc[Gc.horizontalOnly = 3] = "horizontalOnly";
        var nh = 128, ih = 32640;
        function sh(t, e1) {
            var _$r = e1.expression;
            if ("constant" === _$r.kind) return {
                kind: "constant",
                layoutSize: _$r.evaluate(new Ps(t + 1))
            };
            if ("source" === _$r.kind) return {
                kind: "source"
            };
            {
                var _$e = _$r.zoomStops, _$n = _$r.interpolationType;
                var i = 0;
                for(; i < _$e.length && _$e[i] <= t;)i++;
                i = Math.max(0, i - 1);
                var s = i;
                for(; s < _$e.length && _$e[s] < t + 1;)s++;
                s = Math.min(_$e.length - 1, s);
                var a = _$e[i], o = _$e[s];
                return "composite" === _$r.kind ? {
                    kind: "composite",
                    minZoom: a,
                    maxZoom: o,
                    interpolationType: _$n
                } : {
                    kind: "camera",
                    minZoom: a,
                    maxZoom: o,
                    minSize: _$r.evaluate(new Ps(a)),
                    maxSize: _$r.evaluate(new Ps(o)),
                    interpolationType: _$n
                };
            }
        }
        function ah(t, e1, r) {
            var _$n = "never";
            var i = t.get(e1);
            return i ? _$n = i : t.get(r) && (_$n = "always"), _$n;
        }
        var oh = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function lh(t, e1, r, n, i, s, a, o, l, u, c, h, p) {
            var f = o ? Math.min(ih, Math.round(o[0])) : 0, _$d = o ? Math.min(ih, Math.round(o[1])) : 0;
            t.emplaceBack(e1, r, Math.round(32 * n), Math.round(32 * i), s, a, (f << 1) + (l ? 1 : 0), _$d, 16 * u, 16 * c, 256 * h, 256 * p);
        }
        function uh(t, e1, r) {
            t.emplaceBack(e1.x, e1.y, r), t.emplaceBack(e1.x, e1.y, r), t.emplaceBack(e1.x, e1.y, r), t.emplaceBack(e1.x, e1.y, r);
        }
        function ch(t) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t.sections[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e = _step.value;
                    if (Ds(_$e.text)) return !0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !1;
        }
        var hh = /*#__PURE__*/ function() {
            function hh(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, hh);
                this.layoutVertexArray = new Ha, this.indexArray = new to, this.programConfigurations = t, this.segments = new io, this.dynamicLayoutVertexArray = new Ka, this.opacityVertexArray = new Wa, this.hasVisibleVertices = !1, this.placedSymbolArray = new za;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(hh, [
                {
                    key: "isEmpty",
                    value: function isEmpty() {
                        return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
                    }
                },
                {
                    key: "upload",
                    value: function upload(t, e1, r, n) {
                        this.isEmpty() || (r && (this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, lc.members), this.indexBuffer = t.createIndexBuffer(this.indexArray, e1), this.dynamicLayoutVertexBuffer = t.createVertexBuffer(this.dynamicLayoutVertexArray, uc.members, !0), this.opacityVertexBuffer = t.createVertexBuffer(this.opacityVertexArray, oh, !0), this.opacityVertexBuffer.itemSize = 1), (r || n) && this.programConfigurations.upload(t));
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
                    }
                }
            ]);
            return hh;
        }();
        ps("SymbolBuffers", hh);
        var ph = /*#__PURE__*/ function() {
            function ph(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ph);
                this.layoutVertexArray = new t, this.layoutAttributes = e1, this.indexArray = new r, this.segments = new io, this.collisionVertexArray = new Qa;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ph, [
                {
                    key: "upload",
                    value: function upload(t) {
                        this.layoutVertexBuffer = t.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = t.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = t.createVertexBuffer(this.collisionVertexArray, cc.members, !0);
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
                    }
                }
            ]);
            return ph;
        }();
        ps("CollisionBuffers", ph);
        var fh = /*#__PURE__*/ function() {
            function fh(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, fh);
                this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map(function(t) {
                    return t.id;
                }), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasDependencies = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [];
                var _$r = this.layers[0]._unevaluatedLayout._values;
                this.textSizeData = sh(this.zoom, _$r["text-size"]), this.iconSizeData = sh(this.zoom, _$r["icon-size"]);
                var _$n = this.layers[0].layout, i = _$n.get("symbol-sort-key"), s = _$n.get("symbol-z-order");
                this.canOverlap = "never" !== ah(_$n, "text-overlap", "text-allow-overlap") || "never" !== ah(_$n, "icon-overlap", "icon-allow-overlap") || _$n.get("text-ignore-placement") || _$n.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== s && !i.isConstant(), this.sortFeaturesByY = ("viewport-y" === s || "auto" === s && !this.sortFeaturesByKey) && this.canOverlap, "point" === _$n.get("symbol-placement") && (this.writingModes = _$n.get("text-writing-mode").map(function(e1) {
                    return t.az[e1];
                })), this.stateDependentLayerIds = this.layers.filter(function(t) {
                    return t.isStateDependent();
                }).map(function(t) {
                    return t.id;
                }), this.sourceID = e1.sourceID;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(fh, [
                {
                    key: "createArrays",
                    value: function createArrays() {
                        this.text = new hh(new Vo(this.layers, this.zoom, function(t) {
                            return /^text/.test(t);
                        })), this.icon = new hh(new Vo(this.layers, this.zoom, function(t) {
                            return /^icon/.test(t);
                        })), this.glyphOffsetArray = new Va, this.lineVertexArray = new Ca, this.symbolInstances = new Ba, this.textAnchorOffsets = new Oa;
                    }
                },
                {
                    key: "calculateGlyphDependencies",
                    value: function calculateGlyphDependencies(t, e1, r, n, i) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var s = _step.value;
                                if (e1[s.codePointAt(0)] = !0, (r || n) && i) {
                                    var _$t = yc[s];
                                    _$t && (e1[_$t.codePointAt(0)] = !0);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "populate",
                    value: function populate(e1, r, n) {
                        var i = this.layers[0], s = i.layout, a = s.get("text-font"), o = s.get("text-field"), l = s.get("icon-image"), u = ("constant" !== o.value.kind || o.value.value instanceof De && !o.value.value.isEmpty() || o.value.value.toString().length > 0) && ("constant" !== a.value.kind || a.value.value.length > 0), _$c = "constant" !== l.value.kind || !!l.value.value || Object.keys(l.parameters).length > 0, _$h = s.get("symbol-sort-key");
                        if (this.features = [], !u && !_$c) return;
                        var p = r.iconDependencies, f = r.glyphDependencies, _$d = r.availableImages, _$y = new Ps(this.zoom);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, _$r = _step_value.feature, o1 = _step_value.id, l1 = _step_value.index, _$m = _step_value.sourceLayerIndex;
                                var _$e = i._featureFilter.needGeometry, _$g = $o(_$r, _$e);
                                if (!i._featureFilter.filter(_$y, _$g, n)) continue;
                                var _$x = void 0, _$v = void 0;
                                if (_$e || (_$g.geometry = No(_$r)), u) {
                                    var _$t = i.getValueAndResolveTokens("text-field", _$g, n, _$d), _$e1 = De.factory(_$t), _$r1 = this.hasRTLText = this.hasRTLText || ch(_$e1);
                                    (!_$r1 || "unavailable" === zs.getRTLTextPluginStatus() || _$r1 && zs.isParsed()) && (_$x = fc(_$e1, i, _$g));
                                }
                                if (_$c) {
                                    var _$t1 = i.getValueAndResolveTokens("icon-image", _$g, n, _$d);
                                    _$v = _$t1 instanceof Oe ? _$t1 : Oe.fromString(_$t1);
                                }
                                if (!_$x && !_$v) continue;
                                var _$b = this.sortFeaturesByKey ? _$h.evaluate(_$g, {}, n) : void 0;
                                if (this.features.push({
                                    id: o1,
                                    text: _$x,
                                    icon: _$v,
                                    index: l1,
                                    sourceLayerIndex: _$m,
                                    geometry: _$g.geometry,
                                    properties: _$r.properties,
                                    type: Mu.types[_$r.type],
                                    sortKey: _$b
                                }), _$v && (p[_$v.name] = !0), _$x) {
                                    var _$e2 = a.evaluate(_$g, {}, n).join(","), _$r2 = "viewport" !== s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement");
                                    this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(t.az.vertical) >= 0;
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = _$x.sections[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var _$t2 = _step1.value;
                                            if (_$t2.image) p[_$t2.image.name] = !0;
                                            else {
                                                var _$n = _s(_$x.toString()), i1 = _$t2.fontStack || _$e2, s1 = f[i1] = f[i1] || {};
                                                this.calculateGlyphDependencies(_$t2.text, s1, _$r2, this.allowVerticalPlacement, _$n);
                                            }
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        "line" === s.get("symbol-placement") && (this.features = function(t) {
                            var _$e = {}, _$r = {}, _$n = [];
                            var i = 0;
                            function s(e1) {
                                _$n.push(t[e1]), i++;
                            }
                            function a(t, e1, i) {
                                var _$s = _$r[t];
                                return delete _$r[t], _$r[e1] = _$s, _$n[_$s].geometry[0].pop(), _$n[_$s].geometry[0] = _$n[_$s].geometry[0].concat(i[0]), _$s;
                            }
                            function o(t, r, i) {
                                var _$s = _$e[r];
                                return delete _$e[r], _$e[t] = _$s, _$n[_$s].geometry[0].shift(), _$n[_$s].geometry[0] = i[0].concat(_$n[_$s].geometry[0]), _$s;
                            }
                            function l(t, e1, r) {
                                var _$n = r ? e1[0][e1[0].length - 1] : e1[0][0];
                                return "".concat(t, ":").concat(_$n.x, ":").concat(_$n.y);
                            }
                            for(var u = 0; u < t.length; u++){
                                var _$c = t[u], _$h = _$c.geometry, p = _$c.text ? _$c.text.toString() : null;
                                if (!p) {
                                    s(u);
                                    continue;
                                }
                                var f = l(p, _$h), _$d = l(p, _$h, !0);
                                if (f in _$r && _$d in _$e && _$r[f] !== _$e[_$d]) {
                                    var _$t = o(f, _$d, _$h), i1 = a(f, _$d, _$n[_$t].geometry);
                                    delete _$e[f], delete _$r[_$d], _$r[l(p, _$n[i1].geometry, !0)] = i1, _$n[_$t].geometry = null;
                                } else f in _$r ? a(f, _$d, _$h) : _$d in _$e ? o(f, _$d, _$h) : (s(u), _$e[f] = i - 1, _$r[_$d] = i - 1);
                            }
                            return _$n.filter(function(t) {
                                return t.geometry;
                            });
                        }(this.features)), this.sortFeaturesByKey && this.features.sort(function(t, e1) {
                            return t.sortKey - e1.sortKey;
                        });
                    }
                },
                {
                    key: "update",
                    value: function update(t, e1, r) {
                        this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(t, e1, this.layers, {
                            imagePositions: r
                        }), this.icon.programConfigurations.updatePaintArrays(t, e1, this.layers, {
                            imagePositions: r
                        }));
                    }
                },
                {
                    key: "isEmpty",
                    value: function isEmpty() {
                        return 0 === this.symbolInstances.length && !this.hasRTLText;
                    }
                },
                {
                    key: "uploadPending",
                    value: function uploadPending() {
                        return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
                    }
                },
                {
                    key: "upload",
                    value: function upload(t) {
                        !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(t), this.iconCollisionBox.upload(t)), this.text.upload(t, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(t, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
                    }
                },
                {
                    key: "destroyDebugData",
                    value: function destroyDebugData() {
                        this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
                    }
                },
                {
                    key: "addToLineVertexArray",
                    value: function addToLineVertexArray(t, e1) {
                        var _$r = this.lineVertexArray.length;
                        if (void 0 !== t.segment) {
                            var _$r1 = t.dist(e1[t.segment + 1]), _$n = t.dist(e1[t.segment]);
                            var i = {};
                            for(var _$n1 = t.segment + 1; _$n1 < e1.length; _$n1++)i[_$n1] = {
                                x: e1[_$n1].x,
                                y: e1[_$n1].y,
                                tileUnitDistanceFromAnchor: _$r1
                            }, _$n1 < e1.length - 1 && (_$r1 += e1[_$n1 + 1].dist(e1[_$n1]));
                            for(var _$r2 = t.segment || 0; _$r2 >= 0; _$r2--)i[_$r2] = {
                                x: e1[_$r2].x,
                                y: e1[_$r2].y,
                                tileUnitDistanceFromAnchor: _$n
                            }, _$r2 > 0 && (_$n += e1[_$r2 - 1].dist(e1[_$r2]));
                            for(var _$t = 0; _$t < e1.length; _$t++){
                                var _$e = i[_$t];
                                this.lineVertexArray.emplaceBack(_$e.x, _$e.y, _$e.tileUnitDistanceFromAnchor);
                            }
                        }
                        return {
                            lineStartIndex: _$r,
                            lineLength: this.lineVertexArray.length - _$r
                        };
                    }
                },
                {
                    key: "addSymbols",
                    value: function addSymbols(e1, r, n, i, s, a, o, l, u, c, h, p) {
                        var f = e1.indexArray, _$d = e1.layoutVertexArray, _$y = e1.segments.prepareSegment(4 * r.length, _$d, f, this.canOverlap ? a.sortKey : void 0), _$m = this.glyphOffsetArray.length, _$g = _$y.vertexLength, _$x = this.allowVerticalPlacement && o === t.az.vertical ? Math.PI / 2 : 0, _$v = a.text && a.text.sections;
                        for(var _$t = 0; _$t < r.length; _$t++){
                            var _r_t = r[_$t], _$i = _r_t.tl, s1 = _r_t.tr, _$o = _r_t.bl, _$u = _r_t.br, _$c = _r_t.tex, _$h = _r_t.pixelOffsetTL, _$m1 = _r_t.pixelOffsetBR, _$g1 = _r_t.minFontScaleX, _$b = _r_t.minFontScaleY, _$w = _r_t.glyphOffset, _ = _r_t.isSDF, S = _r_t.sectionIndex, _$A = _$y.vertexLength, _$k = _$w[1];
                            lh(_$d, l.x, l.y, _$i.x, _$k + _$i.y, _$c.x, _$c.y, n, _, _$h.x, _$h.y, _$g1, _$b), lh(_$d, l.x, l.y, s1.x, _$k + s1.y, _$c.x + _$c.w, _$c.y, n, _, _$m1.x, _$h.y, _$g1, _$b), lh(_$d, l.x, l.y, _$o.x, _$k + _$o.y, _$c.x, _$c.y + _$c.h, n, _, _$h.x, _$m1.y, _$g1, _$b), lh(_$d, l.x, l.y, _$u.x, _$k + _$u.y, _$c.x + _$c.w, _$c.y + _$c.h, n, _, _$m1.x, _$m1.y, _$g1, _$b), uh(e1.dynamicLayoutVertexArray, l, _$x), f.emplaceBack(_$A, _$A + 2, _$A + 1), f.emplaceBack(_$A + 1, _$A + 2, _$A + 3), _$y.vertexLength += 4, _$y.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(_$w[0]), _$t !== r.length - 1 && S === r[_$t + 1].sectionIndex || e1.programConfigurations.populatePaintArrays(_$d.length, a, a.index, {
                                imagePositions: {},
                                canonical: p,
                                formattedSection: _$v && _$v[S]
                            });
                        }
                        e1.placedSymbolArray.emplaceBack(l.x, l.y, _$m, this.glyphOffsetArray.length - _$m, _$g, u, c, l.segment, n ? n[0] : 0, n ? n[1] : 0, i[0], i[1], o, 0, !1, 0, h);
                    }
                },
                {
                    key: "_addCollisionDebugVertex",
                    value: function _addCollisionDebugVertex(t, e1, r, n, i, s) {
                        return e1.emplaceBack(0, 0), t.emplaceBack(r.x, r.y, n, i, Math.round(s.x), Math.round(s.y));
                    }
                },
                {
                    key: "addCollisionDebugVertices",
                    value: function addCollisionDebugVertices(t, e1, n, i, s, a, o) {
                        var l = s.segments.prepareSegment(4, s.layoutVertexArray, s.indexArray), u = l.vertexLength, _$c = s.layoutVertexArray, _$h = s.collisionVertexArray, p = o.anchorX, f = o.anchorY;
                        this._addCollisionDebugVertex(_$c, _$h, a, p, f, new r(t, e1)), this._addCollisionDebugVertex(_$c, _$h, a, p, f, new r(n, e1)), this._addCollisionDebugVertex(_$c, _$h, a, p, f, new r(n, i)), this._addCollisionDebugVertex(_$c, _$h, a, p, f, new r(t, i)), l.vertexLength += 4;
                        var _$d = s.indexArray;
                        _$d.emplaceBack(u, u + 1), _$d.emplaceBack(u + 1, u + 2), _$d.emplaceBack(u + 2, u + 3), _$d.emplaceBack(u + 3, u), l.primitiveLength += 4;
                    }
                },
                {
                    key: "addDebugCollisionBoxes",
                    value: function addDebugCollisionBoxes(t, e1, r, n) {
                        for(var i = t; i < e1; i++){
                            var _$t = this.collisionBoxArray.get(i);
                            this.addCollisionDebugVertices(_$t.x1, _$t.y1, _$t.x2, _$t.y2, n ? this.textCollisionBox : this.iconCollisionBox, _$t.anchorPoint, r);
                        }
                    }
                },
                {
                    key: "generateCollisionDebugBuffers",
                    value: function generateCollisionDebugBuffers() {
                        this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new ph(Ja, hc.members, eo), this.iconCollisionBox = new ph(Ja, hc.members, eo);
                        for(var _$t = 0; _$t < this.symbolInstances.length; _$t++){
                            var _$e = this.symbolInstances.get(_$t);
                            this.addDebugCollisionBoxes(_$e.textBoxStartIndex, _$e.textBoxEndIndex, _$e, !0), this.addDebugCollisionBoxes(_$e.verticalTextBoxStartIndex, _$e.verticalTextBoxEndIndex, _$e, !0), this.addDebugCollisionBoxes(_$e.iconBoxStartIndex, _$e.iconBoxEndIndex, _$e, !1), this.addDebugCollisionBoxes(_$e.verticalIconBoxStartIndex, _$e.verticalIconBoxEndIndex, _$e, !1);
                        }
                    }
                },
                {
                    key: "_deserializeCollisionBoxesForSymbol",
                    value: function _deserializeCollisionBoxesForSymbol(t, e1, r, n, i, s, a, o, l) {
                        var u = {};
                        for(var _$n = e1; _$n < r; _$n++){
                            var _$e = t.get(_$n);
                            u.textBox = {
                                x1: _$e.x1,
                                y1: _$e.y1,
                                x2: _$e.x2,
                                y2: _$e.y2,
                                anchorPointX: _$e.anchorPointX,
                                anchorPointY: _$e.anchorPointY
                            }, u.textFeatureIndex = _$e.featureIndex;
                            break;
                        }
                        for(var _$e1 = n; _$e1 < i; _$e1++){
                            var _$r = t.get(_$e1);
                            u.verticalTextBox = {
                                x1: _$r.x1,
                                y1: _$r.y1,
                                x2: _$r.x2,
                                y2: _$r.y2,
                                anchorPointX: _$r.anchorPointX,
                                anchorPointY: _$r.anchorPointY
                            }, u.verticalTextFeatureIndex = _$r.featureIndex;
                            break;
                        }
                        for(var _$e2 = s; _$e2 < a; _$e2++){
                            var _$r1 = t.get(_$e2);
                            u.iconBox = {
                                x1: _$r1.x1,
                                y1: _$r1.y1,
                                x2: _$r1.x2,
                                y2: _$r1.y2,
                                anchorPointX: _$r1.anchorPointX,
                                anchorPointY: _$r1.anchorPointY
                            }, u.iconFeatureIndex = _$r1.featureIndex;
                            break;
                        }
                        for(var _$e3 = o; _$e3 < l; _$e3++){
                            var _$r2 = t.get(_$e3);
                            u.verticalIconBox = {
                                x1: _$r2.x1,
                                y1: _$r2.y1,
                                x2: _$r2.x2,
                                y2: _$r2.y2,
                                anchorPointX: _$r2.anchorPointX,
                                anchorPointY: _$r2.anchorPointY
                            }, u.verticalIconFeatureIndex = _$r2.featureIndex;
                            break;
                        }
                        return u;
                    }
                },
                {
                    key: "deserializeCollisionBoxes",
                    value: function deserializeCollisionBoxes(t) {
                        this.collisionArrays = [];
                        for(var _$e = 0; _$e < this.symbolInstances.length; _$e++){
                            var _$r = this.symbolInstances.get(_$e);
                            this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t, _$r.textBoxStartIndex, _$r.textBoxEndIndex, _$r.verticalTextBoxStartIndex, _$r.verticalTextBoxEndIndex, _$r.iconBoxStartIndex, _$r.iconBoxEndIndex, _$r.verticalIconBoxStartIndex, _$r.verticalIconBoxEndIndex));
                        }
                    }
                },
                {
                    key: "hasTextData",
                    value: function hasTextData() {
                        return this.text.segments.get().length > 0;
                    }
                },
                {
                    key: "hasIconData",
                    value: function hasIconData() {
                        return this.icon.segments.get().length > 0;
                    }
                },
                {
                    key: "hasDebugData",
                    value: function hasDebugData() {
                        return this.textCollisionBox && this.iconCollisionBox;
                    }
                },
                {
                    key: "hasTextCollisionBoxData",
                    value: function hasTextCollisionBoxData() {
                        return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
                    }
                },
                {
                    key: "hasIconCollisionBoxData",
                    value: function hasIconCollisionBoxData() {
                        return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
                    }
                },
                {
                    key: "addIndicesForPlacedSymbol",
                    value: function addIndicesForPlacedSymbol(t, e1) {
                        var _$r = t.placedSymbolArray.get(e1), _$n = _$r.vertexStartIndex + 4 * _$r.numGlyphs;
                        for(var _$e = _$r.vertexStartIndex; _$e < _$n; _$e += 4)t.indexArray.emplaceBack(_$e, _$e + 2, _$e + 1), t.indexArray.emplaceBack(_$e + 1, _$e + 2, _$e + 3);
                    }
                },
                {
                    key: "getSortedSymbolIndexes",
                    value: function getSortedSymbolIndexes(t) {
                        if (this.sortedAngle === t && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                        var _$e = Math.sin(t), _$r = Math.cos(t), _$n = [], i = [], s = [];
                        for(var _$t = 0; _$t < this.symbolInstances.length; ++_$t){
                            s.push(_$t);
                            var a = this.symbolInstances.get(_$t);
                            _$n.push(0 | Math.round(_$e * a.anchorX + _$r * a.anchorY)), i.push(a.featureIndex);
                        }
                        return s.sort(function(t, e1) {
                            return _$n[t] - _$n[e1] || i[e1] - i[t];
                        }), s;
                    }
                },
                {
                    key: "addToSortKeyRanges",
                    value: function addToSortKeyRanges(t, e1) {
                        var _$r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                        _$r && _$r.sortKey === e1 ? _$r.symbolInstanceEnd = t + 1 : this.sortKeyRanges.push({
                            sortKey: e1,
                            symbolInstanceStart: t,
                            symbolInstanceEnd: t + 1
                        });
                    }
                },
                {
                    key: "sortFeatures",
                    value: function sortFeatures(t) {
                        var _this = this;
                        if (this.sortFeaturesByY && this.sortedAngle !== t && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                            this.symbolInstanceIndexes = this.getSortedSymbolIndexes(t), this.sortedAngle = t, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = this.symbolInstanceIndexes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step.value;
                                    var _$e = this.symbolInstances.get(_$t);
                                    this.featureSortOrder.push(_$e.featureIndex), [
                                        _$e.rightJustifiedTextSymbolIndex,
                                        _$e.centerJustifiedTextSymbolIndex,
                                        _$e.leftJustifiedTextSymbolIndex
                                    ].forEach(function(t, e1, r) {
                                        t >= 0 && r.indexOf(t) === e1 && _this.addIndicesForPlacedSymbol(_this.text, t);
                                    }), _$e.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, _$e.verticalPlacedTextSymbolIndex), _$e.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, _$e.placedIconSymbolIndex), _$e.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, _$e.verticalPlacedIconSymbolIndex);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                        }
                    }
                }
            ]);
            return fh;
        }();
        var dh, yh;
        ps("SymbolBucket", fh, {
            omit: [
                "layers",
                "collisionBoxArray",
                "features",
                "compareText"
            ]
        }), fh.MAX_GLYPHS = 65535, fh.addDynamicAttributes = uh;
        var mh = {
            get paint () {
                return yh = yh || new Hs({
                    "icon-opacity": new Gs(vt.paint_symbol["icon-opacity"]),
                    "icon-color": new Gs(vt.paint_symbol["icon-color"]),
                    "icon-halo-color": new Gs(vt.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new Gs(vt.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new Gs(vt.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new js(vt.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new js(vt.paint_symbol["icon-translate-anchor"]),
                    "text-opacity": new Gs(vt.paint_symbol["text-opacity"]),
                    "text-color": new Gs(vt.paint_symbol["text-color"], {
                        runtimeType: Rt,
                        getOverride: function(t) {
                            return t.textColor;
                        },
                        hasOverride: function(t) {
                            return !!t.textColor;
                        }
                    }),
                    "text-halo-color": new Gs(vt.paint_symbol["text-halo-color"]),
                    "text-halo-width": new Gs(vt.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new Gs(vt.paint_symbol["text-halo-blur"]),
                    "text-translate": new js(vt.paint_symbol["text-translate"]),
                    "text-translate-anchor": new js(vt.paint_symbol["text-translate-anchor"])
                });
            },
            get layout () {
                return dh = dh || new Hs({
                    "symbol-placement": new js(vt.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new js(vt.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new js(vt.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new Gs(vt.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new js(vt.layout_symbol["symbol-z-order"]),
                    "icon-allow-overlap": new js(vt.layout_symbol["icon-allow-overlap"]),
                    "icon-overlap": new js(vt.layout_symbol["icon-overlap"]),
                    "icon-ignore-placement": new js(vt.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new js(vt.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new js(vt.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new Gs(vt.layout_symbol["icon-size"]),
                    "icon-text-fit": new js(vt.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new js(vt.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new Gs(vt.layout_symbol["icon-image"]),
                    "icon-rotate": new Gs(vt.layout_symbol["icon-rotate"]),
                    "icon-padding": new Gs(vt.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new js(vt.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new Gs(vt.layout_symbol["icon-offset"]),
                    "icon-anchor": new Gs(vt.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new js(vt.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new js(vt.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new js(vt.layout_symbol["text-rotation-alignment"]),
                    "text-field": new Gs(vt.layout_symbol["text-field"]),
                    "text-font": new Gs(vt.layout_symbol["text-font"]),
                    "text-size": new Gs(vt.layout_symbol["text-size"]),
                    "text-max-width": new Gs(vt.layout_symbol["text-max-width"]),
                    "text-line-height": new js(vt.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new Gs(vt.layout_symbol["text-letter-spacing"]),
                    "text-justify": new Gs(vt.layout_symbol["text-justify"]),
                    "text-radial-offset": new Gs(vt.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new js(vt.layout_symbol["text-variable-anchor"]),
                    "text-variable-anchor-offset": new Gs(vt.layout_symbol["text-variable-anchor-offset"]),
                    "text-anchor": new Gs(vt.layout_symbol["text-anchor"]),
                    "text-max-angle": new js(vt.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new js(vt.layout_symbol["text-writing-mode"]),
                    "text-rotate": new Gs(vt.layout_symbol["text-rotate"]),
                    "text-padding": new js(vt.layout_symbol["text-padding"]),
                    "text-keep-upright": new js(vt.layout_symbol["text-keep-upright"]),
                    "text-transform": new Gs(vt.layout_symbol["text-transform"]),
                    "text-offset": new Gs(vt.layout_symbol["text-offset"]),
                    "text-allow-overlap": new js(vt.layout_symbol["text-allow-overlap"]),
                    "text-overlap": new js(vt.layout_symbol["text-overlap"]),
                    "text-ignore-placement": new js(vt.layout_symbol["text-ignore-placement"]),
                    "text-optional": new js(vt.layout_symbol["text-optional"])
                });
            }
        };
        var gh = /*#__PURE__*/ function() {
            function gh(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, gh);
                if (void 0 === t.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                this.type = t.property.overrides ? t.property.overrides.runtimeType : Vt, this.defaultValue = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(gh, [
                {
                    key: "evaluate",
                    value: function evaluate(t) {
                        if (t.formattedSection) {
                            var _$e = this.defaultValue.property.overrides;
                            if (_$e && _$e.hasOverride(t.formattedSection)) return _$e.getOverride(t.formattedSection);
                        }
                        return t.feature && t.featureState ? this.defaultValue.evaluate(t.feature, t.featureState) : this.defaultValue.property.specification.default;
                    }
                },
                {
                    key: "eachChild",
                    value: function eachChild(t) {
                        this.defaultValue.isConstant() || t(this.defaultValue.value._styleExpression.expression);
                    }
                },
                {
                    key: "outputDefined",
                    value: function outputDefined() {
                        return !1;
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        return null;
                    }
                }
            ]);
            return gh;
        }();
        ps("FormatSectionOverride", gh, {
            omit: [
                "defaultValue"
            ]
        });
        var xh = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(xh, Ks);
            function xh(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, xh);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, xh, [
                    t,
                    mh,
                    e1
                ]);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(xh, [
                {
                    key: "recalculate",
                    value: function recalculate(t, e1) {
                        if ((0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(xh.prototype), "recalculate", this).call(this, t, e1), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                            var _$t = this.layout.get("text-writing-mode");
                            if (_$t) {
                                var _$e = [];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = _$t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$r = _step.value;
                                        _$e.indexOf(_$r) < 0 && _$e.push(_$r);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                this.layout._values["text-writing-mode"] = _$e;
                            } else this.layout._values["text-writing-mode"] = [
                                "horizontal"
                            ];
                        }
                        this._setPaintOverrides();
                    }
                },
                {
                    key: "getValueAndResolveTokens",
                    value: function getValueAndResolveTokens(t, e1, r, n) {
                        var i = this.layout.get(t).evaluate(e1, {}, r, n), s = this._unevaluatedLayout._values[t];
                        return s.isDataDriven() || ri(s.value) || !i ? i : function(t, e1) {
                            return e1.replace(/{([^{}]+)}/g, function(e1, r) {
                                return t && r in t ? String(t[r]) : "";
                            });
                        }(e1.properties, i);
                    }
                },
                {
                    key: "createBucket",
                    value: function createBucket(t) {
                        return new fh(t);
                    }
                },
                {
                    key: "queryRadius",
                    value: function queryRadius() {
                        return 0;
                    }
                },
                {
                    key: "queryIntersectsFeature",
                    value: function queryIntersectsFeature() {
                        throw new Error("Should take a different path in FeatureIndex");
                    }
                },
                {
                    key: "_setPaintOverrides",
                    value: function _setPaintOverrides() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = mh.paint.overridableProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                if (!xh.hasPaintOverride(this.layout, _$t)) continue;
                                var _$e = this.paint.get(_$t), _$r = new gh(_$e), _$n = new ei(_$r, _$e.property.specification);
                                var i = null;
                                i = "constant" === _$e.value.kind || "source" === _$e.value.kind ? new ii("source", _$n) : new si("composite", _$n, _$e.value.zoomStops), this.paint._values[_$t] = new Us(_$e.property, i, _$e.parameters);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_handleOverridablePaintPropertyUpdate",
                    value: function _handleOverridablePaintPropertyUpdate(t, e1, r) {
                        return !(!this.layout || e1.isDataDriven() || r.isDataDriven()) && xh.hasPaintOverride(this.layout, t);
                    }
                }
            ], [
                {
                    key: "hasPaintOverride",
                    value: function hasPaintOverride(t, e1) {
                        var _$r = t.get("text-field"), _$n = mh.paint.properties[e1];
                        var i = !1;
                        var s = function(t) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    if (_$n.overrides && _$n.overrides.hasOverride(_$e)) return void (i = !0);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        };
                        if ("constant" === _$r.value.kind && _$r.value.value instanceof De) s(_$r.value.value.sections);
                        else if ("source" === _$r.value.kind || "composite" === _$r.value.kind) {
                            var _$t = function(e1) {
                                i || (e1 instanceof je && Ue(e1.value) === jt ? s(e1.value.sections) : e1 instanceof Ir ? s(e1.sections) : e1.eachChild(_$t));
                            }, _$e = _$r.value;
                            _$e._styleExpression && _$t(_$e._styleExpression.expression);
                        }
                        return i;
                    }
                }
            ]);
            return xh;
        }(Ks);
        var vh;
        var bh = {
            get paint () {
                return vh = vh || new Hs({
                    "background-color": new js(vt.paint_background["background-color"]),
                    "background-pattern": new Ys(vt.paint_background["background-pattern"]),
                    "background-opacity": new js(vt.paint_background["background-opacity"])
                });
            }
        };
        var wh = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(wh, Ks);
            function wh(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, wh);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, wh, [
                    t,
                    bh,
                    e1
                ]);
            }
            return wh;
        }(Ks);
        var _h = /*#__PURE__*/ function(Ks) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_h, Ks);
            function _h(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _h);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _h, [
                    t,
                    {},
                    e1
                ]), _this.onAdd = function(t) {
                    _this.implementation.onAdd && _this.implementation.onAdd(t, t.painter.context.gl);
                }, _this.onRemove = function(t) {
                    _this.implementation.onRemove && _this.implementation.onRemove(t, t.painter.context.gl);
                }, _this.implementation = t;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_h, [
                {
                    key: "is3D",
                    value: function is3D() {
                        return "3d" === this.implementation.renderingMode;
                    }
                },
                {
                    key: "hasOffscreenPass",
                    value: function hasOffscreenPass() {
                        return void 0 !== this.implementation.prerender;
                    }
                },
                {
                    key: "recalculate",
                    value: function recalculate() {}
                },
                {
                    key: "updateTransitions",
                    value: function updateTransitions() {}
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return !1;
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        throw new Error("Custom layers cannot be serialized");
                    }
                }
            ]);
            return _h;
        }(Ks);
        var Sh = /*#__PURE__*/ function() {
            function Sh(t) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Sh);
                this._methodToThrottle = t, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = function() {
                    _this._triggered = !1, _this._methodToThrottle();
                });
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Sh, [
                {
                    key: "trigger",
                    value: function trigger() {
                        var _this = this;
                        this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(function() {
                            _this._triggered = !1, _this._methodToThrottle();
                        }, 0));
                    }
                },
                {
                    key: "remove",
                    value: function remove() {
                        delete this._channel, this._methodToThrottle = function() {};
                    }
                }
            ]);
            return Sh;
        }();
        var Ah = {
            once: !0
        }, kh = 6371008.8;
        var Eh = /*#__PURE__*/ function() {
            function Eh(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Eh);
                if (isNaN(t) || isNaN(e1)) throw new Error("Invalid LngLat object: (".concat(t, ", ").concat(e1, ")"));
                if (this.lng = +t, this.lat = +e1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Eh, [
                {
                    key: "wrap",
                    value: function wrap() {
                        return new Eh(L(this.lng, -180, 180), this.lat);
                    }
                },
                {
                    key: "toArray",
                    value: function toArray() {
                        return [
                            this.lng,
                            this.lat
                        ];
                    }
                },
                {
                    key: "toString",
                    value: function toString() {
                        return "LngLat(".concat(this.lng, ", ").concat(this.lat, ")");
                    }
                },
                {
                    key: "distanceTo",
                    value: function distanceTo(t) {
                        var _$e = Math.PI / 180, _$r = this.lat * _$e, _$n = t.lat * _$e, i = Math.sin(_$r) * Math.sin(_$n) + Math.cos(_$r) * Math.cos(_$n) * Math.cos((t.lng - this.lng) * _$e);
                        return kh * Math.acos(Math.min(i, 1));
                    }
                }
            ], [
                {
                    key: "convert",
                    value: function convert(t) {
                        if (t instanceof Eh) return t;
                        if (Array.isArray(t) && (2 === t.length || 3 === t.length)) return new Eh(Number(t[0]), Number(t[1]));
                        if (!Array.isArray(t) && "object" == (typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t)) && null !== t) return new Eh(Number("lng" in t ? t.lng : t.lon), Number(t.lat));
                        throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
                    }
                }
            ]);
            return Eh;
        }();
        var Th = 2 * Math.PI * kh;
        function Ih(t) {
            return Th * Math.cos(t * Math.PI / 180);
        }
        function Mh(t) {
            return (180 + t) / 360;
        }
        function Fh(t) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + t * Math.PI / 360))) / 360;
        }
        function Dh(t, e1) {
            return t / Ih(e1);
        }
        function zh(t) {
            return 360 * t - 180;
        }
        function Ph(t) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * t) * Math.PI / 180)) - 90;
        }
        function Bh(t, e1) {
            return t * Ih(Ph(e1));
        }
        var Vh = /*#__PURE__*/ function() {
            function Vh(t, e1) {
                var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Vh);
                this.x = +t, this.y = +e1, this.z = +_$r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Vh, [
                {
                    key: "toLngLat",
                    value: function toLngLat() {
                        return new Eh(zh(this.x), Ph(this.y));
                    }
                },
                {
                    key: "toAltitude",
                    value: function toAltitude() {
                        return Bh(this.z, this.y);
                    }
                },
                {
                    key: "meterInMercatorCoordinateUnits",
                    value: function meterInMercatorCoordinateUnits() {
                        var _$t;
                        return 1 / Th * (_$t = Ph(this.y), 1 / Math.cos(_$t * Math.PI / 180));
                    }
                }
            ], [
                {
                    key: "fromLngLat",
                    value: function fromLngLat(t) {
                        var _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                        var _$r = Eh.convert(t);
                        return new Vh(Mh(_$r.lng), Fh(_$r.lat), Dh(_$e, _$r.lat));
                    }
                }
            ]);
            return Vh;
        }();
        function Ch(t, e1, r) {
            var _$n = 2 * Math.PI * 6378137 / 256 / Math.pow(2, r);
            return [
                t * _$n - 2 * Math.PI * 6378137 / 2,
                e1 * _$n - 2 * Math.PI * 6378137 / 2
            ];
        }
        var Lh = /*#__PURE__*/ function() {
            function Lh(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Lh);
                if (!function(t, e1, r) {
                    return !(t < 0 || t > 25 || r < 0 || r >= Math.pow(2, t) || e1 < 0 || e1 >= Math.pow(2, t));
                }(t, e1, r)) throw new Error("x=".concat(e1, ", y=").concat(r, ", z=").concat(t, " outside of bounds. 0<=x<").concat(Math.pow(2, t), ", 0<=y<").concat(Math.pow(2, t), " 0<=z<=25 "));
                this.z = t, this.x = e1, this.y = r, this.key = Nh(0, t, t, e1, r);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Lh, [
                {
                    key: "equals",
                    value: function equals(t) {
                        return this.z === t.z && this.x === t.x && this.y === t.y;
                    }
                },
                {
                    key: "url",
                    value: function url(t, e1, r) {
                        var _$n = function(t, e1, r) {
                            var _$n = Ch(256 * t, 256 * (e1 = Math.pow(2, r) - e1 - 1), r), i = Ch(256 * (t + 1), 256 * (e1 + 1), r);
                            return _$n[0] + "," + _$n[1] + "," + i[0] + "," + i[1];
                        }(this.x, this.y, this.z), i = function(t, e1, r) {
                            var _$n, i = "";
                            for(var s = t; s > 0; s--)_$n = 1 << s - 1, i += (e1 & _$n ? 1 : 0) + (r & _$n ? 2 : 0);
                            return i;
                        }(this.z, this.x, this.y);
                        return t[(this.x + this.y) % t.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === r ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, e1 > 1 ? "@2x" : "").replace(/{quadkey}/g, i).replace(/{bbox-epsg-3857}/g, _$n);
                    }
                },
                {
                    key: "isChildOf",
                    value: function isChildOf(t) {
                        var _$e = this.z - t.z;
                        return _$e > 0 && t.x === this.x >> _$e && t.y === this.y >> _$e;
                    }
                },
                {
                    key: "getTilePoint",
                    value: function getTilePoint(t) {
                        var _$e = Math.pow(2, this.z);
                        return new r((t.x * _$e - this.x) * M, (t.y * _$e - this.y) * M);
                    }
                },
                {
                    key: "toString",
                    value: function toString() {
                        return "".concat(this.z, "/").concat(this.x, "/").concat(this.y);
                    }
                }
            ]);
            return Lh;
        }();
        var Oh = function Oh(t, e1) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, Oh);
            this.wrap = t, this.canonical = e1, this.key = Nh(t, e1.z, e1.z, e1.x, e1.y);
        };
        var Rh = /*#__PURE__*/ function() {
            function Rh(t, e1, r, n, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Rh);
                if (this.terrainRttPosMatrix32f = null, t < r) throw new Error("overscaledZ should be >= z; overscaledZ = ".concat(t, "; z = ").concat(r));
                this.overscaledZ = t, this.wrap = e1, this.canonical = new Lh(r, +n, +i), this.key = Nh(e1, t, r, n, i);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Rh, [
                {
                    key: "clone",
                    value: function clone() {
                        return new Rh(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
                    }
                },
                {
                    key: "equals",
                    value: function equals(t) {
                        return this.overscaledZ === t.overscaledZ && this.wrap === t.wrap && this.canonical.equals(t.canonical);
                    }
                },
                {
                    key: "scaledTo",
                    value: function scaledTo(t) {
                        if (t > this.overscaledZ) throw new Error("targetZ > this.overscaledZ; targetZ = ".concat(t, "; overscaledZ = ").concat(this.overscaledZ));
                        var _$e = this.canonical.z - t;
                        return t > this.canonical.z ? new Rh(t, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Rh(t, this.wrap, t, this.canonical.x >> _$e, this.canonical.y >> _$e);
                    }
                },
                {
                    key: "isOverscaled",
                    value: function isOverscaled() {
                        return this.overscaledZ > this.canonical.z;
                    }
                },
                {
                    key: "calculateScaledKey",
                    value: function calculateScaledKey(t, e1) {
                        if (t > this.overscaledZ) throw new Error("targetZ > this.overscaledZ; targetZ = ".concat(t, "; overscaledZ = ").concat(this.overscaledZ));
                        var _$r = this.canonical.z - t;
                        return t > this.canonical.z ? Nh(this.wrap * +e1, t, this.canonical.z, this.canonical.x, this.canonical.y) : Nh(this.wrap * +e1, t, t, this.canonical.x >> _$r, this.canonical.y >> _$r);
                    }
                },
                {
                    key: "isChildOf",
                    value: function isChildOf(t) {
                        if (t.wrap !== this.wrap) return !1;
                        if (this.overscaledZ - t.overscaledZ <= 0) return !1;
                        if (0 === t.overscaledZ) return this.overscaledZ > 0;
                        var _$e = this.canonical.z - t.canonical.z;
                        return !(_$e < 0) && t.canonical.x === this.canonical.x >> _$e && t.canonical.y === this.canonical.y >> _$e;
                    }
                },
                {
                    key: "children",
                    value: function children(t) {
                        if (this.overscaledZ >= t) return [
                            new Rh(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                        ];
                        var _$e = this.canonical.z + 1, _$r = 2 * this.canonical.x, _$n = 2 * this.canonical.y;
                        return [
                            new Rh(_$e, this.wrap, _$e, _$r, _$n),
                            new Rh(_$e, this.wrap, _$e, _$r + 1, _$n),
                            new Rh(_$e, this.wrap, _$e, _$r, _$n + 1),
                            new Rh(_$e, this.wrap, _$e, _$r + 1, _$n + 1)
                        ];
                    }
                },
                {
                    key: "isLessThan",
                    value: function isLessThan(t) {
                        return this.wrap < t.wrap || !(this.wrap > t.wrap) && (this.overscaledZ < t.overscaledZ || !(this.overscaledZ > t.overscaledZ) && (this.canonical.x < t.canonical.x || !(this.canonical.x > t.canonical.x) && this.canonical.y < t.canonical.y));
                    }
                },
                {
                    key: "wrapped",
                    value: function wrapped() {
                        return new Rh(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
                    }
                },
                {
                    key: "unwrapTo",
                    value: function unwrapTo(t) {
                        return new Rh(this.overscaledZ, t, this.canonical.z, this.canonical.x, this.canonical.y);
                    }
                },
                {
                    key: "overscaleFactor",
                    value: function overscaleFactor() {
                        return Math.pow(2, this.overscaledZ - this.canonical.z);
                    }
                },
                {
                    key: "toUnwrapped",
                    value: function toUnwrapped() {
                        return new Oh(this.wrap, this.canonical);
                    }
                },
                {
                    key: "toString",
                    value: function toString() {
                        return "".concat(this.overscaledZ, "/").concat(this.canonical.x, "/").concat(this.canonical.y);
                    }
                },
                {
                    key: "getTilePoint",
                    value: function getTilePoint(t) {
                        return this.canonical.getTilePoint(new Vh(t.x - this.wrap, t.y));
                    }
                }
            ]);
            return Rh;
        }();
        function Nh(t, e1, r, n, i) {
            (t *= 2) < 0 && (t = -1 * t - 1);
            var s = 1 << r;
            return (s * s * t + s * i + n).toString(36) + r.toString(36) + e1.toString(36);
        }
        function $h(t, e1) {
            return e1 ? t.properties[e1] : t.id;
        }
        function Uh(t, e1) {
            var _$r = {
                id: t.id
            };
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (e1.removeAllProperties && (delete t.removeProperties, delete t.addOrUpdateProperties, delete e1.removeProperties), e1.removeProperties) try {
                var _loop = function() {
                    var _$r = _step.value;
                    var _$e = t.addOrUpdateProperties.findIndex(function(t) {
                        return t.key === _$r;
                    });
                    _$e > -1 && t.addOrUpdateProperties.splice(_$e, 1);
                };
                for(var _iterator = e1.removeProperties[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return (t.removeAllProperties || e1.removeAllProperties) && (_$r.removeAllProperties = !0), (t.removeProperties || e1.removeProperties) && (_$r.removeProperties = (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(t.removeProperties || []).concat((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(e1.removeProperties || []))), (t.addOrUpdateProperties || e1.addOrUpdateProperties) && (_$r.addOrUpdateProperties = (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(t.addOrUpdateProperties || []).concat((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(e1.addOrUpdateProperties || []))), (t.newGeometry || e1.newGeometry) && (_$r.newGeometry = e1.newGeometry || t.newGeometry), _$r;
        }
        function qh(t) {
            var _$e, _$r;
            if (!t) return {};
            var _$n = {};
            return _$n.removeAll = t.removeAll, _$n.remove = new Set(t.remove || []), _$n.add = new Map(null === (_$e = t.add) || void 0 === _$e ? void 0 : _$e.map(function(t) {
                return [
                    t.id,
                    t
                ];
            })), _$n.update = new Map(null === (_$r = t.update) || void 0 === _$r ? void 0 : _$r.map(function(t) {
                return [
                    t.id,
                    t
                ];
            })), _$n;
        }
        ps("CanonicalTileID", Lh), ps("OverscaledTileID", Rh, {
            omit: [
                "terrainRttPosMatrix32f"
            ]
        });
        var jh = /*#__PURE__*/ function() {
            function jh() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, jh);
                this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(jh, [
                {
                    key: "extend",
                    value: function extend(t) {
                        return this.minX = Math.min(this.minX, t.x), this.minY = Math.min(this.minY, t.y), this.maxX = Math.max(this.maxX, t.x), this.maxY = Math.max(this.maxY, t.y), this;
                    }
                },
                {
                    key: "expandBy",
                    value: function expandBy(t) {
                        return this.minX -= t, this.minY -= t, this.maxX += t, this.maxY += t, (this.minX > this.maxX || this.minY > this.maxY) && (this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0), this;
                    }
                },
                {
                    key: "shrinkBy",
                    value: function shrinkBy(t) {
                        return this.expandBy(-t);
                    }
                },
                {
                    key: "map",
                    value: function map(t) {
                        var _$e = new jh;
                        return _$e.extend(t(new r(this.minX, this.minY))), _$e.extend(t(new r(this.maxX, this.minY))), _$e.extend(t(new r(this.minX, this.maxY))), _$e.extend(t(new r(this.maxX, this.maxY))), _$e;
                    }
                },
                {
                    key: "contains",
                    value: function contains(t) {
                        return t.x >= this.minX && t.x <= this.maxX && t.y >= this.minY && t.y <= this.maxY;
                    }
                },
                {
                    key: "empty",
                    value: function empty() {
                        return this.minX > this.maxX;
                    }
                },
                {
                    key: "width",
                    value: function width() {
                        return this.maxX - this.minX;
                    }
                },
                {
                    key: "height",
                    value: function height() {
                        return this.maxY - this.minY;
                    }
                },
                {
                    key: "covers",
                    value: function covers(t) {
                        return !this.empty() && !t.empty() && t.minX >= this.minX && t.maxX <= this.maxX && t.minY >= this.minY && t.maxY <= this.maxY;
                    }
                },
                {
                    key: "intersects",
                    value: function intersects(t) {
                        return !this.empty() && !t.empty() && t.minX <= this.maxX && t.maxX >= this.minX && t.minY <= this.maxY && t.maxY >= this.minY;
                    }
                }
            ], [
                {
                    key: "fromPoints",
                    value: function fromPoints(t) {
                        var _$e = new jh;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$r = _step.value;
                                _$e.extend(_$r);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$e;
                    }
                }
            ]);
            return jh;
        }();
        var Gh = /*#__PURE__*/ function() {
            function Gh(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Gh);
                this._stringToNumber = {}, this._numberToString = [];
                for(var _$e = 0; _$e < t.length; _$e++){
                    var _$r = t[_$e];
                    this._stringToNumber[_$r] = _$e, this._numberToString[_$e] = _$r;
                }
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Gh, [
                {
                    key: "encode",
                    value: function encode(t) {
                        return this._stringToNumber[t];
                    }
                },
                {
                    key: "decode",
                    value: function decode(t) {
                        if (t >= this._numberToString.length) throw new Error("Out of bounds. Index requested n=".concat(t, " can't be >= this._numberToString.length ").concat(this._numberToString.length));
                        return this._numberToString[t];
                    }
                }
            ]);
            return Gh;
        }();
        var Xh = /*#__PURE__*/ function() {
            function Xh(t, e1, r, n, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Xh);
                this.type = "Feature", this._vectorTileFeature = t, this._x = r, this._y = n, this._z = e1, this.properties = t.properties, this.id = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Xh, [
                {
                    key: "projectPoint",
                    value: function projectPoint(t, e1, r, n) {
                        return [
                            360 * (t.x + e1) / n - 180,
                            360 / Math.PI * Math.atan(Math.exp((1 - 2 * (t.y + r) / n) * Math.PI)) - 90
                        ];
                    }
                },
                {
                    key: "projectLine",
                    value: function projectLine(t, e1, r, n) {
                        var _this = this;
                        return t.map(function(t) {
                            return _this.projectPoint(t, e1, r, n);
                        });
                    }
                },
                {
                    key: "geometry",
                    get: function get() {
                        var _this = this;
                        if (this._geometry) return this._geometry;
                        var _$t = this._vectorTileFeature, _$e = _$t.extent * Math.pow(2, this._z), _$r = _$t.extent * this._x, _$n = _$t.extent * this._y, i = _$t.loadGeometry();
                        switch(_$t.type){
                            case 1:
                                {
                                    var _$t1 = [];
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _$e1 = _step.value;
                                            _$t1.push(_$e1[0]);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    var s = this.projectLine(_$t1, _$r, _$n, _$e);
                                    this._geometry = 1 === _$t1.length ? {
                                        type: "Point",
                                        coordinates: s[0]
                                    } : {
                                        type: "MultiPoint",
                                        coordinates: s
                                    };
                                    break;
                                }
                            case 2:
                                {
                                    var _$t2 = i.map(function(t) {
                                        return _this.projectLine(t, _$r, _$n, _$e);
                                    });
                                    this._geometry = 1 === _$t2.length ? {
                                        type: "LineString",
                                        coordinates: _$t2[0]
                                    } : {
                                        type: "MultiLineString",
                                        coordinates: _$t2
                                    };
                                    break;
                                }
                            case 3:
                                {
                                    var _$t3 = Du(i), s1 = [];
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = _$t3[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var i1 = _step1.value;
                                            s1.push(i1.map(function(t) {
                                                return _this.projectLine(t, _$r, _$n, _$e);
                                            }));
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                    this._geometry = 1 === s1.length ? {
                                        type: "Polygon",
                                        coordinates: s1[0]
                                    } : {
                                        type: "MultiPolygon",
                                        coordinates: s1
                                    };
                                    break;
                                }
                            default:
                                throw new Error("unknown feature type: ".concat(_$t.type));
                        }
                        return this._geometry;
                    },
                    set: function set(t) {
                        this._geometry = t;
                    }
                },
                {
                    key: "toJSON",
                    value: function toJSON() {
                        var _$t = {
                            geometry: this.geometry
                        };
                        for(var _$e in this)"_geometry" !== _$e && "_vectorTileFeature" !== _$e && "_x" !== _$e && "_y" !== _$e && "_z" !== _$e && (_$t[_$e] = this[_$e]);
                        return _$t;
                    }
                }
            ]);
            return Xh;
        }();
        var Yh = /*#__PURE__*/ function() {
            function Yh(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Yh);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_name", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "dataBuffer", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "nullabilityBuffer", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_size", void 0);
                this._name = t, this.dataBuffer = e1, "number" == typeof r ? this._size = r : (this.nullabilityBuffer = r, this._size = r.size());
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Yh, [
                {
                    key: "getValue",
                    value: function getValue(t) {
                        return this.nullabilityBuffer && !this.nullabilityBuffer.get(t) ? null : this.getValueFromBuffer(t);
                    }
                },
                {
                    key: "has",
                    value: function has(t) {
                        return this.nullabilityBuffer && this.nullabilityBuffer.get(t) || !this.nullabilityBuffer;
                    }
                },
                {
                    key: "name",
                    get: function get() {
                        return this._name;
                    }
                },
                {
                    key: "size",
                    get: function get() {
                        return this._size;
                    }
                }
            ]);
            return Yh;
        }();
        var Zh = /*#__PURE__*/ function(Yh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Zh, Yh);
            function Zh() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Zh);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Zh, arguments);
            }
            return Zh;
        }(Yh);
        var Hh = /*#__PURE__*/ function(Zh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Hh, Zh);
            function Hh() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Hh);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Hh, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Hh, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        return this.dataBuffer[t];
                    }
                }
            ]);
            return Hh;
        }(Zh);
        var Kh = /*#__PURE__*/ function(Zh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Kh, Zh);
            function Kh() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Kh);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Kh, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Kh, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        return this.dataBuffer[t];
                    }
                }
            ]);
            return Kh;
        }(Zh);
        var Wh = /*#__PURE__*/ function(Yh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Wh, Yh);
            function Wh(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Wh);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Wh, [
                    t,
                    e1,
                    n
                ]), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "delta", void 0), _this.delta = r;
                return _this;
            }
            return Wh;
        }(Yh);
        var Jh = /*#__PURE__*/ function(Wh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Jh, Wh);
            function Jh(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Jh);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Jh, [
                    t,
                    Int32Array.of(e1),
                    r,
                    n
                ]);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Jh, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        return this.dataBuffer[0] + t * this.delta;
                    }
                }
            ]);
            return Jh;
        }(Wh);
        var Qh = /*#__PURE__*/ function(Yh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Qh, Yh);
            function Qh(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Qh);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Qh, [
                    t,
                    Int32Array.of(e1),
                    r
                ]);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Qh, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        return this.dataBuffer[0];
                    }
                }
            ]);
            return Qh;
        }(Yh);
        var tp = /*#__PURE__*/ function() {
            function tp(t, e1, r, n) {
                var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 4096;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, tp);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_name", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_geometryVector", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_idVector", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_propertyVectors", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_extent", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "propertyVectorsMap", void 0);
                this._name = t, this._geometryVector = e1, this._idVector = r, this._propertyVectors = n, this._extent = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(tp, [
                {
                    key: "name",
                    get: function get() {
                        return this._name;
                    }
                },
                {
                    key: "idVector",
                    get: function get() {
                        return this._idVector;
                    }
                },
                {
                    key: "geometryVector",
                    get: function get() {
                        return this._geometryVector;
                    }
                },
                {
                    key: "propertyVectors",
                    get: function get() {
                        return this._propertyVectors;
                    }
                },
                {
                    key: "getPropertyVector",
                    value: function getPropertyVector(t) {
                        return this.propertyVectorsMap || (this.propertyVectorsMap = new Map(this._propertyVectors.map(function(t) {
                            return [
                                t.name,
                                t
                            ];
                        }))), this.propertyVectorsMap.get(t);
                    }
                },
                {
                    key: Symbol.iterator,
                    value: function value() {
                        var _$t, _$e, _$r, _$n, i, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$t1, _$r1, _$n1;
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _$t = this.geometryVector[Symbol.iterator]();
                                    _$e = 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(_$e < this.numFeatures)) return [
                                        3,
                                        4
                                    ];
                                    _$r = void 0;
                                    this.idVector && (_$r = this.containsMaxSaveIntegerValues(this.idVector) ? Number(this.idVector.getValue(_$e)) : this.idVector.getValue(_$e));
                                    _$n = _$t === null || _$t === void 0 ? void 0 : _$t.next().value, i = {};
                                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(_iterator = this.propertyVectors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            _$t1 = _step.value;
                                            if (!_$t1) continue;
                                            _$r1 = _$t1.name, _$n1 = _$t1.getValue(_$e);
                                            null !== _$n1 && (i[_$r1] = _$n1);
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                    _$e++;
                                    return [
                                        4,
                                        {
                                            id: _$r,
                                            geometry: _$n,
                                            properties: i
                                        }
                                    ];
                                case 2:
                                    _state.sent();
                                    _state.label = 3;
                                case 3:
                                    return [
                                        3,
                                        1
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }
                },
                {
                    key: "numFeatures",
                    get: function get() {
                        return this.geometryVector.numGeometries;
                    }
                },
                {
                    key: "extent",
                    get: function get() {
                        return this._extent;
                    }
                },
                {
                    key: "getFeatures",
                    value: function getFeatures() {
                        var _$t = [], _$e = this.geometryVector.getGeometries();
                        for(var _$r = 0; _$r < this.numFeatures; _$r++){
                            var _$n = void 0;
                            this.idVector && (_$n = this.containsMaxSaveIntegerValues(this.idVector) ? Number(this.idVector.getValue(_$r)) : this.idVector.getValue(_$r));
                            var i = {
                                coordinates: _$e[_$r],
                                type: this.geometryVector.geometryType(_$r)
                            }, s = {};
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = this.propertyVectors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t1 = _step.value;
                                    if (!_$t1) continue;
                                    var _$e1 = _$t1.name, _$n1 = _$t1.getValue(_$r);
                                    null !== _$n1 && (s[_$e1] = _$n1);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            _$t.push({
                                id: _$n,
                                geometry: i,
                                properties: s
                            });
                        }
                        return _$t;
                    }
                },
                {
                    key: "containsMaxSaveIntegerValues",
                    value: function containsMaxSaveIntegerValues(t) {
                        return t instanceof Hh || t instanceof Qh && t instanceof Jh || t instanceof Kh;
                    }
                }
            ]);
            return tp;
        }();
        var ep = /*#__PURE__*/ function() {
            function ep(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ep);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "value", void 0);
                this.value = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ep, [
                {
                    key: "get",
                    value: function get() {
                        return this.value;
                    }
                },
                {
                    key: "set",
                    value: function set(t) {
                        this.value = t;
                    }
                },
                {
                    key: "increment",
                    value: function increment() {
                        return this.value++;
                    }
                },
                {
                    key: "add",
                    value: function add(t) {
                        this.value += t;
                    }
                }
            ]);
            return ep;
        }();
        var rp, np, ip, sp, ap, op, lp, up, cp, hp;
        function pp(t, e1, r) {
            var _$n = new Int32Array(r);
            var i = 0, s = e1.get();
            for(var _$e = 0; _$e < _$n.length; _$e++){
                var _$e1 = t[s++], _$r = 127 & _$e1;
                _$e1 < 128 || (_$e1 = t[s++], _$r |= (127 & _$e1) << 7, _$e1 < 128 || (_$e1 = t[s++], _$r |= (127 & _$e1) << 14, _$e1 < 128 || (_$e1 = t[s++], _$r |= (127 & _$e1) << 21, _$e1 < 128 || (_$e1 = t[s++], _$r |= (15 & _$e1) << 28)))), _$n[i++] = _$r;
            }
            return e1.set(s), _$n;
        }
        function fp(t, e1, r) {
            var _$n = new BigInt64Array(r);
            for(var _$r = 0; _$r < _$n.length; _$r++)_$n[_$r] = xp(t, e1);
            return _$n;
        }
        function dp(t, e1) {
            var _$r, _$n;
            return _$n = t[e1.get()], e1.increment(), _$r = 127 & _$n, _$n < 128 ? _$r : (_$n = t[e1.get()], e1.increment(), _$r |= (127 & _$n) << 7, _$n < 128 ? _$r : (_$n = t[e1.get()], e1.increment(), _$r |= (127 & _$n) << 14, _$n < 128 ? _$r : (_$n = t[e1.get()], e1.increment(), _$r |= (127 & _$n) << 21, _$n < 128 ? _$r : (_$n = t[e1.get()], _$r |= (15 & _$n) << 28, function(t, e1, r) {
                var _$n, i;
                if (i = e1[r.get()], r.increment(), _$n = (112 & i) >> 4, i < 128) return 4294967296 * _$n + (t >>> 0);
                if (i = e1[r.get()], r.increment(), _$n |= (127 & i) << 3, i < 128) return 4294967296 * _$n + (t >>> 0);
                if (i = e1[r.get()], r.increment(), _$n |= (127 & i) << 10, i < 128) return 4294967296 * _$n + (t >>> 0);
                if (i = e1[r.get()], r.increment(), _$n |= (127 & i) << 17, i < 128) return 4294967296 * _$n + (t >>> 0);
                if (i = e1[r.get()], r.increment(), _$n |= (127 & i) << 24, i < 128) return 4294967296 * _$n + (t >>> 0);
                if (i = e1[r.get()], r.increment(), _$n |= (1 & i) << 31, i < 128) return 4294967296 * _$n + (t >>> 0);
                throw new Error("Expected varint not more than 10 bytes");
            }(_$r, t, e1)))));
        }
        function yp(t, e1, r, n) {
            throw new Error("FastPFor is not implemented yet.");
        }
        function mp(t) {
            return t >>> 1 ^ -(1 & t);
        }
        function gp(t) {
            return t >> 1n ^ -(1n & t);
        }
        function xp(t, e1) {
            var _$r = 0n, _$n = 0, i = e1.get();
            for(; i < t.length;){
                var _$e = t[i++];
                if (_$r |= BigInt(127 & _$e) << BigInt(_$n), !(128 & _$e)) break;
                if (_$n += 7, _$n >= 64) throw new Error("Varint too long");
            }
            return e1.set(i), _$r;
        }
        function vp(t, e1, r) {
            var _$n = new Int32Array(r);
            var i = 0;
            for(var _$r = 0; _$r < e1; _$r++){
                var s = t[_$r];
                _$n.fill(t[_$r + e1], i, i + s), i += s;
            }
            return _$n;
        }
        function bp(t, e1, r) {
            var _$n = new BigInt64Array(r);
            var i = 0;
            for(var _$r = 0; _$r < e1; _$r++){
                var s = Number(t[_$r]);
                _$n.fill(t[_$r + e1], i, i + s), i += s;
            }
            return _$n;
        }
        function wp(t, e1, r) {
            var _$n = new Float64Array(r);
            var i = 0;
            for(var _$r = 0; _$r < e1; _$r++){
                var s = t[_$r];
                _$n.fill(t[_$r + e1], i, i + s), i += s;
            }
            return _$n;
        }
        function _p(t) {
            var _$e = t.length / 4 * 4;
            var _$r = 1;
            if (_$e >= 4) for(var _$n = t[0]; _$r < _$e - 4; _$r += 4)_$n = t[_$r] += _$n, _$n = t[_$r + 1] += _$n, _$n = t[_$r + 2] += _$n, _$n = t[_$r + 3] += _$n;
            for(; _$r != t.length;)t[_$r] += t[_$r - 1], ++_$r;
        }
        function Sp(t) {
            t[0] = t[0] >>> 1 ^ -(1 & t[0]), t[1] = t[1] >>> 1 ^ -(1 & t[1]);
            var _$e = t.length / 4 * 4;
            var _$r = 2;
            if (_$e >= 4) for(; _$r < _$e - 4; _$r += 4){
                var _$e1 = t[_$r], _$n = t[_$r + 1], i = t[_$r + 2], s = t[_$r + 3];
                t[_$r] = (_$e1 >>> 1 ^ -(1 & _$e1)) + t[_$r - 2], t[_$r + 1] = (_$n >>> 1 ^ -(1 & _$n)) + t[_$r - 1], t[_$r + 2] = (i >>> 1 ^ -(1 & i)) + t[_$r], t[_$r + 3] = (s >>> 1 ^ -(1 & s)) + t[_$r + 1];
            }
            for(; _$r != t.length; _$r += 2)t[_$r] = (t[_$r] >>> 1 ^ -(1 & t[_$r])) + t[_$r - 2], t[_$r + 1] = (t[_$r + 1] >>> 1 ^ -(1 & t[_$r + 1])) + t[_$r - 1];
        }
        !function(t) {
            t.NONE = "NONE", t.DELTA = "DELTA", t.COMPONENTWISE_DELTA = "COMPONENTWISE_DELTA", t.RLE = "RLE", t.MORTON = "MORTON", t.PDE = "PDE";
        }(rp || (rp = {})), function(t) {
            t.NONE = "NONE", t.FAST_PFOR = "FAST_PFOR", t.VARINT = "VARINT", t.ALP = "ALP";
        }(np || (np = {})), function(t) {
            t.PRESENT = "PRESENT", t.DATA = "DATA", t.OFFSET = "OFFSET", t.LENGTH = "LENGTH";
        }(ip || (ip = {}));
        var Ap = /*#__PURE__*/ function() {
            function Ap(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ap);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_dictionaryType", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_offsetType", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_lengthType", void 0);
                this._dictionaryType = t, this._offsetType = e1, this._lengthType = r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ap, [
                {
                    key: "dictionaryType",
                    get: function get() {
                        return this._dictionaryType;
                    }
                },
                {
                    key: "offsetType",
                    get: function get() {
                        return this._offsetType;
                    }
                },
                {
                    key: "lengthType",
                    get: function get() {
                        return this._lengthType;
                    }
                }
            ]);
            return Ap;
        }();
        function kp(t, e1) {
            var _$r = function(t, e1) {
                var _$r = t[e1.get()], _$n = Object.values(ip)[_$r >> 4];
                var i = null;
                switch(_$n){
                    case ip.DATA:
                        i = new Ap(Object.values(sp)[15 & _$r]);
                        break;
                    case ip.OFFSET:
                        i = new Ap(null, Object.values(ap)[15 & _$r]);
                        break;
                    case ip.LENGTH:
                        i = new Ap(null, null, Object.values(op)[15 & _$r]);
                }
                e1.increment();
                var s = t[e1.get()], a = Object.values(rp)[s >> 5], o = Object.values(rp)[s >> 2 & 7], l = Object.values(np)[3 & s];
                e1.increment();
                var u = pp(t, e1, 2), _$c = u[0];
                return {
                    physicalStreamType: _$n,
                    logicalStreamType: i,
                    logicalLevelTechnique1: a,
                    logicalLevelTechnique2: o,
                    physicalLevelTechnique: l,
                    numValues: _$c,
                    byteLength: u[1],
                    decompressedCount: _$c
                };
            }(t, e1);
            return _$r.logicalLevelTechnique1 === rp.MORTON ? function(t, e1, r) {
                var _$n = pp(e1, r, 2);
                return {
                    physicalStreamType: t.physicalStreamType,
                    logicalStreamType: t.logicalStreamType,
                    logicalLevelTechnique1: t.logicalLevelTechnique1,
                    logicalLevelTechnique2: t.logicalLevelTechnique2,
                    physicalLevelTechnique: t.physicalLevelTechnique,
                    numValues: t.numValues,
                    byteLength: t.byteLength,
                    decompressedCount: t.decompressedCount,
                    numBits: _$n[0],
                    coordinateShift: _$n[1]
                };
            }(_$r, t, e1) : rp.RLE !== _$r.logicalLevelTechnique1 && rp.RLE !== _$r.logicalLevelTechnique2 || np.NONE === _$r.physicalLevelTechnique ? _$r : function(t, e1, r) {
                var _$n = pp(e1, r, 2);
                return {
                    physicalStreamType: t.physicalStreamType,
                    logicalStreamType: t.logicalStreamType,
                    logicalLevelTechnique1: t.logicalLevelTechnique1,
                    logicalLevelTechnique2: t.logicalLevelTechnique2,
                    physicalLevelTechnique: t.physicalLevelTechnique,
                    numValues: t.numValues,
                    byteLength: t.byteLength,
                    decompressedCount: _$n[1],
                    runs: _$n[0],
                    numRleValues: _$n[1]
                };
            }(_$r, t, e1);
        }
        !function(t) {
            t.NONE = "NONE", t.SINGLE = "SINGLE", t.SHARED = "SHARED", t.VERTEX = "VERTEX", t.MORTON = "MORTON", t.FSST = "FSST";
        }(sp || (sp = {})), function(t) {
            t.VERTEX = "VERTEX", t.INDEX = "INDEX", t.STRING = "STRING", t.KEY = "KEY";
        }(ap || (ap = {})), function(t) {
            t.VAR_BINARY = "VAR_BINARY", t.GEOMETRIES = "GEOMETRIES", t.PARTS = "PARTS", t.RINGS = "RINGS", t.TRIANGLES = "TRIANGLES", t.SYMBOL = "SYMBOL", t.DICTIONARY = "DICTIONARY";
        }(op || (op = {})), function(t) {
            t[t.FLAT = 0] = "FLAT", t[t.CONST = 1] = "CONST", t[t.SEQUENCE = 2] = "SEQUENCE", t[t.DICTIONARY = 3] = "DICTIONARY", t[t.FSST_DICTIONARY = 4] = "FSST_DICTIONARY";
        }(lp || (lp = {}));
        var Ep = /*#__PURE__*/ function() {
            function Ep(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ep);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "values", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_size", void 0);
                this.values = t, this._size = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ep, [
                {
                    key: "get",
                    value: function get(t) {
                        var _$e = Math.floor(t / 8);
                        return 1 == (this.values[_$e] >> t % 8 & 1);
                    }
                },
                {
                    key: "set",
                    value: function set(t, e1) {
                        var _$r = Math.floor(t / 8);
                        this.values[_$r] = this.values[_$r] | (e1 ? 1 : 0) << t % 8;
                    }
                },
                {
                    key: "getInt",
                    value: function getInt(t) {
                        var _$e = Math.floor(t / 8);
                        return this.values[_$e] >> t % 8 & 1;
                    }
                },
                {
                    key: "size",
                    value: function size() {
                        return this._size;
                    }
                },
                {
                    key: "getBuffer",
                    value: function getBuffer() {
                        return this.values;
                    }
                }
            ]);
            return Ep;
        }();
        function Tp(t, e1, r, n, i) {
            return function(t, e1, r) {
                switch(e1.logicalLevelTechnique1){
                    case rp.DELTA:
                        return e1.logicalLevelTechnique2 === rp.RLE ? function(t, e1, r) {
                            var _$n = new Int32Array(r);
                            var i = 0, s = 0;
                            for(var _$r = 0; _$r < e1; _$r++){
                                var a = t[_$r], o = mp(t[_$r + e1]);
                                for(var _$t = 0; _$t < a; _$t++)s += o, _$n[i++] = s;
                            }
                            return _$n;
                        }(t, e1.runs, e1.numRleValues) : (function(t) {
                            t[0] = t[0] >>> 1 ^ -(1 & t[0]);
                            var _$e = t.length / 4 * 4;
                            var _$r = 1;
                            if (_$e >= 4) for(; _$r < _$e - 4; _$r += 4){
                                var _$e1 = t[_$r], _$n = t[_$r + 1], i = t[_$r + 2], s = t[_$r + 3];
                                t[_$r] = (_$e1 >>> 1 ^ -(1 & _$e1)) + t[_$r - 1], t[_$r + 1] = (_$n >>> 1 ^ -(1 & _$n)) + t[_$r], t[_$r + 2] = (i >>> 1 ^ -(1 & i)) + t[_$r + 1], t[_$r + 3] = (s >>> 1 ^ -(1 & s)) + t[_$r + 2];
                            }
                            for(; _$r != t.length; ++_$r)t[_$r] = (t[_$r] >>> 1 ^ -(1 & t[_$r])) + t[_$r - 1];
                        }(t), t);
                    case rp.RLE:
                        return function(t, e1, r) {
                            return r ? function(t, e1, r) {
                                var _$n = new Int32Array(r);
                                var i = 0;
                                for(var _$r = 0; _$r < e1; _$r++){
                                    var s = t[_$r];
                                    var a = t[_$r + e1];
                                    a = a >>> 1 ^ -(1 & a), _$n.fill(a, i, i + s), i += s;
                                }
                                return _$n;
                            }(t, e1.runs, e1.numRleValues) : vp(t, e1.runs, e1.numRleValues);
                        }(t, e1, r);
                    case rp.MORTON:
                        return _p(t), t;
                    case rp.COMPONENTWISE_DELTA:
                        return Sp(t), t;
                    case rp.NONE:
                        return r && function(t) {
                            for(var _$e = 0; _$e < t.length; _$e++){
                                var _$r = t[_$e];
                                t[_$e] = _$r >>> 1 ^ -(1 & _$r);
                            }
                        }(t), t;
                    default:
                        throw new Error("The specified Logical level technique is not supported: ".concat(e1.logicalLevelTechnique1));
                }
            }(Mp(t, e1, r), r, n);
        }
        function Ip(t, e1, r) {
            return function(t, e1) {
                if (e1.logicalLevelTechnique1 === rp.DELTA && e1.logicalLevelTechnique2 === rp.NONE) {
                    var _$e = function(t) {
                        var _$e = new Int32Array(t.length + 1);
                        _$e[0] = 0, _$e[1] = mp(t[0]);
                        var _$r = _$e[1], _$n = 2;
                        for(; _$n != _$e.length; ++_$n){
                            var i = t[_$n - 1];
                            _$r += i >>> 1 ^ -(1 & i), _$e[_$n] = _$e[_$n - 1] + _$r;
                        }
                        return _$e;
                    }(t);
                    return _$e;
                }
                if (e1.logicalLevelTechnique1 === rp.RLE && e1.logicalLevelTechnique2 === rp.NONE) {
                    var _$r = function(t, e1, r) {
                        var _$n = new Int32Array(r + 1);
                        _$n[0] = 0;
                        var i = 1, s = _$n[0];
                        for(var _$r = 0; _$r < e1; _$r++){
                            var a = t[_$r], o = t[_$r + e1];
                            for(var _$t = i; _$t < i + a; _$t++)_$n[_$t] = o + s, s = _$n[_$t];
                            i += a;
                        }
                        return _$n;
                    }(t, e1.runs, e1.numRleValues);
                    return _$r;
                }
                if (e1.logicalLevelTechnique1 === rp.NONE && e1.logicalLevelTechnique2 === rp.NONE) {
                    !function(t) {
                        var _$e = 0;
                        for(var _$r = 0; _$r < t.length; _$r++)t[_$r] += _$e, _$e = t[_$r];
                    }(t);
                    var _$r1 = new Int32Array(e1.numValues + 1);
                    return _$r1[0] = 0, _$r1.set(t, 1), _$r1;
                }
                if (e1.logicalLevelTechnique1 === rp.DELTA && e1.logicalLevelTechnique2 === rp.RLE) {
                    var _$r2 = function(t, e1, r) {
                        var _$n = new Int32Array(r + 1);
                        _$n[0] = 0;
                        var i = 1, s = _$n[0];
                        for(var _$r = 0; _$r < e1; _$r++){
                            var a = t[_$r];
                            var o = t[_$r + e1];
                            o = o >>> 1 ^ -(1 & o);
                            for(var _$t = i; _$t < i + a; _$t++)_$n[_$t] = o + s, s = _$n[_$t];
                            i += a;
                        }
                        return _$n;
                    }(t, e1.runs, e1.numRleValues);
                    return _p(_$r2), _$r2;
                }
                throw new Error("Only delta encoding is supported for transforming length to offset streams yet.");
            }(Mp(t, e1, r), r);
        }
        function Mp(t, e1, r) {
            var _$n = r.physicalLevelTechnique;
            if (_$n === np.FAST_PFOR) return yp();
            if (_$n === np.VARINT) return pp(t, e1, r.numValues);
            if (_$n === np.NONE) {
                var _$n1 = e1.get();
                e1.add(r.byteLength);
                var i = t.subarray(_$n1, e1.get());
                return new Int32Array(i);
            }
            throw new Error("Specified physicalLevelTechnique is not supported (yet).");
        }
        function Fp(t, e1, r, n) {
            var i = Mp(t, e1, r);
            if (1 === i.length) {
                var _$t = i[0];
                return n ? mp(_$t) : _$t;
            }
            return n ? function(t) {
                return mp(t[1]);
            }(i) : function(t) {
                return t[1];
            }(i);
        }
        function Dp(t, e1, r) {
            return function(t) {
                if (2 == t.length) {
                    var _$e = mp(t[1]);
                    return [
                        _$e,
                        _$e
                    ];
                }
                return [
                    mp(t[2]),
                    mp(t[3])
                ];
            }(Mp(t, e1, r));
        }
        function zp(t, e1, r) {
            return function(t) {
                if (2 == t.length) {
                    var _$e = gp(t[1]);
                    return [
                        _$e,
                        _$e
                    ];
                }
                return [
                    gp(t[2]),
                    gp(t[3])
                ];
            }(fp(t, e1, r.numValues));
        }
        function Pp(t, e1, r, n) {
            return function(t, e1, r) {
                switch(e1.logicalLevelTechnique1){
                    case rp.DELTA:
                        return e1.logicalLevelTechnique2 === rp.RLE ? function(t, e1, r) {
                            var _$n = new BigInt64Array(r);
                            var i = 0, s = 0n;
                            for(var _$r = 0; _$r < e1; _$r++){
                                var a = Number(t[_$r]), o = gp(t[_$r + e1]);
                                for(var _$t = 0; _$t < a; _$t++)s += o, _$n[i++] = s;
                            }
                            return _$n;
                        }(t, e1.runs, e1.numRleValues) : (function(t) {
                            t[0] = t[0] >> 1n ^ -(1n & t[0]);
                            var _$e = t.length / 4 * 4;
                            var _$r = 1;
                            if (_$e >= 4) for(; _$r < _$e - 4; _$r += 4){
                                var _$e1 = t[_$r], _$n = t[_$r + 1], i = t[_$r + 2], s = t[_$r + 3];
                                t[_$r] = (_$e1 >> 1n ^ -(1n & _$e1)) + t[_$r - 1], t[_$r + 1] = (_$n >> 1n ^ -(1n & _$n)) + t[_$r], t[_$r + 2] = (i >> 1n ^ -(1n & i)) + t[_$r + 1], t[_$r + 3] = (s >> 1n ^ -(1n & s)) + t[_$r + 2];
                            }
                            for(; _$r != t.length; ++_$r)t[_$r] = (t[_$r] >> 1n ^ -(1n & t[_$r])) + t[_$r - 1];
                        }(t), t);
                    case rp.RLE:
                        return function(t, e1, r) {
                            return r ? function(t, e1, r) {
                                var _$n = new BigInt64Array(r);
                                var i = 0;
                                for(var _$r = 0; _$r < e1; _$r++){
                                    var s = Number(t[_$r]);
                                    var a = t[_$r + e1];
                                    a = a >> 1n ^ -(1n & a), _$n.fill(a, i, i + s), i += s;
                                }
                                return _$n;
                            }(t, e1.runs, e1.numRleValues) : bp(t, e1.runs, e1.numRleValues);
                        }(t, e1, r);
                    case rp.NONE:
                        return r && function(t) {
                            for(var _$e = 0; _$e < t.length; _$e++){
                                var _$r = t[_$e];
                                t[_$e] = _$r >> 1n ^ -(1n & _$r);
                            }
                        }(t), t;
                    default:
                        throw new Error("The specified Logical level technique is not supported: ".concat(e1.logicalLevelTechnique1));
                }
            }(fp(t, e1, r.numValues), r, n);
        }
        function Bp(t, e1, r, n) {
            var i = fp(t, e1, r.numValues);
            if (1 === i.length) {
                var _$t = i[0];
                return n ? gp(_$t) : _$t;
            }
            return n ? function(t) {
                return gp(t[1]);
            }(i) : function(t) {
                return t[1];
            }(i);
        }
        function Vp(t, e1, r, n, i) {
            return function(t, e1, r, n) {
                switch(e1.logicalLevelTechnique1){
                    case rp.DELTA:
                        return e1.logicalLevelTechnique2 === rp.RLE && (t = vp(t, e1.runs, e1.numRleValues)), function(t, e1) {
                            var _$r = new Int32Array(t.size());
                            var _$n = 0;
                            t.get(0) ? (_$r[0] = t.get(0) ? e1[0] >>> 1 ^ -(1 & e1[0]) : 0, _$n = 1) : _$r[0] = 0;
                            var _$i = 1;
                            for(; _$i != _$r.length; ++_$i)_$r[_$i] = t.get(_$i) ? _$r[_$i - 1] + (e1[_$n] >>> 1 ^ -(1 & e1[_$n++])) : _$r[_$i - 1];
                            return _$r;
                        }(n, t);
                    case rp.RLE:
                        return function(t, e1, r, n) {
                            var _$i = e1;
                            return r ? function(t, e1, r) {
                                var _$n = new Int32Array(t.size());
                                var _$i = 0;
                                for(var s = 0; s < r; s++){
                                    var a = e1[s];
                                    var o = e1[s + r];
                                    o = o >>> 1 ^ -(1 & o);
                                    for(var _$e = _$i; _$e < _$i + a; _$e++)t.get(_$e) ? _$n[_$e] = o : (_$n[_$e] = 0, _$i++);
                                    _$i += a;
                                }
                                return _$n;
                            }(n, t, _$i.runs) : function(t, e1, r) {
                                var _$n = new Int32Array(t.size());
                                var _$i = 0;
                                for(var s = 0; s < r; s++){
                                    var a = e1[s], o = e1[s + r];
                                    for(var _$e = _$i; _$e < _$i + a; _$e++)t.get(_$e) ? _$n[_$e] = o : (_$n[_$e] = 0, _$i++);
                                    _$i += a;
                                }
                                return _$n;
                            }(n, t, _$i.runs);
                        }(t, e1, r, n);
                    case rp.MORTON:
                        return _p(t), t;
                    case rp.COMPONENTWISE_DELTA:
                        return Sp(t), t;
                    case rp.NONE:
                        return t = r ? function(t, e1) {
                            var _$r = new Int32Array(t.size());
                            var _$n = 0, _$i = 0;
                            for(; _$i != _$r.length; ++_$i)if (t.get(_$i)) {
                                var _$t = e1[_$n++];
                                _$r[_$i] = _$t >>> 1 ^ -(1 & _$t);
                            } else _$r[_$i] = 0;
                            return _$r;
                        }(n, t) : function(t, e1) {
                            var _$r = new Int32Array(t.size());
                            var _$n = 0, _$i = 0;
                            for(; _$i != _$r.length; ++_$i)_$r[_$i] = t.get(_$i) ? e1[_$n++] : 0;
                            return _$r;
                        }(n, t), t;
                    default:
                        throw new Error("The specified Logical level technique is not supported");
                }
            }(r.physicalLevelTechnique === np.FAST_PFOR ? yp() : pp(t, e1, r.numValues), r, n, i);
        }
        function Cp(t, e1, r, n) {
            var i = t.logicalLevelTechnique1;
            if (i === rp.RLE) return 1 === t.runs ? lp.CONST : lp.FLAT;
            var s = e1 instanceof Ep ? e1.size() : e1;
            if (i === rp.DELTA && t.logicalLevelTechnique2 === rp.RLE) {
                var _$e = t.runs, i1 = 2;
                if (t.numRleValues !== s) return lp.FLAT;
                if (1 === _$e) return lp.SEQUENCE;
                if (2 === _$e) {
                    var _$e1 = n.get();
                    var s1;
                    if (t.physicalLevelTechnique === np.VARINT) s1 = pp(r, n, 4);
                    else {
                        var _$t = n.get();
                        s1 = new Int32Array(r.buffer, r.byteOffset + _$t, 4);
                    }
                    if (n.set(_$e1), s1[2] === i1 && s1[3] === i1) return lp.SEQUENCE;
                }
            }
            return 1 === t.numValues ? lp.CONST : lp.FLAT;
        }
        var Lp = /*#__PURE__*/ function(Zh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Lp, Zh);
            function Lp() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Lp);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Lp, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Lp, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        return this.dataBuffer[t];
                    }
                }
            ]);
            return Lp;
        }(Zh);
        var Op = /*#__PURE__*/ function(Wh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Op, Wh);
            function Op(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Op);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Op, [
                    t,
                    BigInt64Array.of(e1),
                    r,
                    n
                ]);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Op, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        return this.dataBuffer[0] + BigInt(t) * this.delta;
                    }
                }
            ]);
            return Op;
        }(Wh);
        var Rp = /*#__PURE__*/ function() {
            function Rp(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Rp);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_geometryOffsets", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_partOffsets", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_ringOffsets", void 0);
                this._geometryOffsets = t, this._partOffsets = e1, this._ringOffsets = r;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Rp, [
                {
                    key: "geometryOffsets",
                    get: function get() {
                        return this._geometryOffsets;
                    }
                },
                {
                    key: "partOffsets",
                    get: function get() {
                        return this._partOffsets;
                    }
                },
                {
                    key: "ringOffsets",
                    get: function get() {
                        return this._ringOffsets;
                    }
                }
            ]);
            return Rp;
        }();
        function Np(t, e1, r) {
            return {
                x: $p(t, e1) - r,
                y: $p(t >> 1, e1) - r
            };
        }
        function $p(t, e1) {
            var _$r = 0;
            for(var _$n = 0; _$n < e1; _$n++)_$r |= (t & 1 << 2 * _$n) >> _$n;
            return _$r;
        }
        !function(t) {
            t[t.POINT = 0] = "POINT", t[t.LINESTRING = 1] = "LINESTRING", t[t.POLYGON = 2] = "POLYGON", t[t.MULTIPOINT = 3] = "MULTIPOINT", t[t.MULTILINESTRING = 4] = "MULTILINESTRING", t[t.MULTIPOLYGON = 5] = "MULTIPOLYGON";
        }(up || (up = {})), function(t) {
            t[t.POINT = 0] = "POINT", t[t.LINESTRING = 1] = "LINESTRING", t[t.POLYGON = 2] = "POLYGON";
        }(cp || (cp = {})), function(t) {
            t[t.MORTON = 0] = "MORTON", t[t.VEC_2 = 1] = "VEC_2", t[t.VEC_3 = 2] = "VEC_3";
        }(hp || (hp = {}));
        var Up = /*#__PURE__*/ function() {
            function Up() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Up);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Up, [
                {
                    key: "createPoint",
                    value: function createPoint(t) {
                        return [
                            [
                                t
                            ]
                        ];
                    }
                },
                {
                    key: "createMultiPoint",
                    value: function createMultiPoint(t) {
                        return t.map(function(t) {
                            return [
                                t
                            ];
                        });
                    }
                },
                {
                    key: "createLineString",
                    value: function createLineString(t) {
                        return [
                            t
                        ];
                    }
                },
                {
                    key: "createMultiLineString",
                    value: function createMultiLineString(t) {
                        return t;
                    }
                },
                {
                    key: "createPolygon",
                    value: function createPolygon(t, e1) {
                        return [
                            t
                        ].concat(e1);
                    }
                },
                {
                    key: "createMultiPolygon",
                    value: function createMultiPolygon(t) {
                        return t.flat();
                    }
                }
            ]);
            return Up;
        }();
        function qp(t) {
            var _$e = new Array(t.numGeometries);
            var _$n = 1, i = 1, s = 1, a = 0;
            var o = new Up;
            var l = 0, u = 0;
            var _$c = t.mortonSettings, _$h = t.topologyVector, p = _$h.geometryOffsets, f = _$h.partOffsets, _$d = _$h.ringOffsets, _$y = t.vertexOffsets, _$m = t.containsPolygonGeometry(), _$g = t.vertexBuffer;
            for(var _$h1 = 0; _$h1 < t.numGeometries; _$h1++){
                var _$x = t.geometryType(_$h1);
                if (_$x === up.POINT) {
                    if (_$y && 0 !== _$y.length) {
                        if (t.vertexBufferType === hp.VEC_2) {
                            var _$t = 2 * _$y[u++], _$n1 = new r(_$g[_$t], _$g[_$t + 1]);
                            _$e[a++] = o.createPoint(_$n1);
                        } else {
                            var _$t1 = Np(_$g[_$y[u++]], _$c.numBits, _$c.coordinateShift), _$n2 = new r(_$t1.x, _$t1.y);
                            _$e[a++] = o.createPoint(_$n2);
                        }
                    } else {
                        var _$t2 = new r(_$g[l++], _$g[l++]);
                        _$e[a++] = o.createPoint(_$t2);
                    }
                    p && s++, f && _$n++, _$d && i++;
                } else if (_$x === up.MULTIPOINT) {
                    var _$t3 = p[s] - p[s - 1];
                    s++;
                    var _$n3 = new Array(_$t3);
                    if (_$y && 0 !== _$y.length) {
                        for(var _$e1 = 0; _$e1 < _$t3; _$e1++){
                            var _$t4 = 2 * _$y[u++];
                            _$n3[_$e1] = new r(_$g[_$t4], _$g[_$t4 + 1]);
                        }
                        _$e[a++] = o.createMultiPoint(_$n3);
                    } else {
                        for(var _$e2 = 0; _$e2 < _$t3; _$e2++){
                            var _$t5 = _$g[l++], i1 = _$g[l++];
                            _$n3[_$e2] = new r(_$t5, i1);
                        }
                        _$e[a++] = o.createMultiPoint(_$n3);
                    }
                } else if (_$x === up.LINESTRING) {
                    var _$r = void 0, _$h2 = 0;
                    _$m ? (_$h2 = _$d[i] - _$d[i - 1], i++) : _$h2 = f[_$n] - f[_$n - 1], _$n++, _$y && 0 !== _$y.length ? (_$r = t.vertexBufferType === hp.VEC_2 ? Zp(_$g, _$y, u, _$h2, !1) : Hp(_$g, _$y, u, _$h2, !1, _$c), u += _$h2) : (_$r = Yp(_$g, l, _$h2, !1), l += 2 * _$h2), _$e[a++] = o.createLineString(_$r), p && s++;
                } else if (_$x === up.POLYGON) {
                    var _$r1 = f[_$n] - f[_$n - 1];
                    _$n++;
                    var _$h3 = new Array(_$r1 - 1);
                    var _$m1 = _$d[i] - _$d[i - 1];
                    if (i++, _$y && 0 !== _$y.length) {
                        var _$r2 = t.vertexBufferType === hp.VEC_2 ? Gp(_$g, _$y, u, _$m1) : Xp(_$g, _$y, u, _$m1, 0, _$c);
                        u += _$m1;
                        for(var _$e3 = 0; _$e3 < _$h3.length; _$e3++)_$m1 = _$d[i] - _$d[i - 1], i++, _$h3[_$e3] = t.vertexBufferType === hp.VEC_2 ? Gp(_$g, _$y, u, _$m1) : Xp(_$g, _$y, u, _$m1, 0, _$c), u += _$m1;
                        _$e[a++] = o.createPolygon(_$r2, _$h3);
                    } else {
                        var _$t6 = jp(_$g, l, _$m1);
                        l += 2 * _$m1;
                        for(var _$t7 = 0; _$t7 < _$h3.length; _$t7++)_$m1 = _$d[i] - _$d[i - 1], i++, _$h3[_$t7] = jp(_$g, l, _$m1), l += 2 * _$m1;
                        _$e[a++] = o.createPolygon(_$t6, _$h3);
                    }
                    p && s++;
                } else if (_$x === up.MULTILINESTRING) {
                    var _$r3 = p[s] - p[s - 1];
                    s++;
                    var _$h4 = new Array(_$r3);
                    if (_$y && 0 !== _$y.length) {
                        for(var _$e4 = 0; _$e4 < _$r3; _$e4++){
                            var _$r4 = 0;
                            _$m ? (_$r4 = _$d[i] - _$d[i - 1], i++) : _$r4 = f[_$n] - f[_$n - 1], _$n++;
                            var s1 = t.vertexBufferType === hp.VEC_2 ? Zp(_$g, _$y, u, _$r4, !1) : Hp(_$g, _$y, u, _$r4, !1, _$c);
                            _$h4[_$e4] = s1, u += _$r4;
                        }
                        _$e[a++] = o.createMultiLineString(_$h4);
                    } else {
                        for(var _$t8 = 0; _$t8 < _$r3; _$t8++){
                            var _$e5 = 0;
                            _$m ? (_$e5 = _$d[i] - _$d[i - 1], i++) : _$e5 = f[_$n] - f[_$n - 1], _$n++, _$h4[_$t8] = Yp(_$g, l, _$e5, !1), l += 2 * _$e5;
                        }
                        _$e[a++] = o.createMultiLineString(_$h4);
                    }
                } else {
                    if (_$x !== up.MULTIPOLYGON) throw new Error("The specified geometry type is currently not supported.");
                    {
                        var _$r5 = p[s] - p[s - 1];
                        s++;
                        var _$h5 = new Array(_$r5);
                        var _$m2 = 0;
                        if (_$y && 0 !== _$y.length) {
                            for(var _$e6 = 0; _$e6 < _$r5; _$e6++){
                                var _$r6 = f[_$n] - f[_$n - 1];
                                _$n++;
                                var s2 = new Array(_$r6 - 1);
                                _$m2 = _$d[i] - _$d[i - 1], i++;
                                var a1 = t.vertexBufferType === hp.VEC_2 ? Gp(_$g, _$y, u, _$m2) : Xp(_$g, _$y, u, _$m2, 0, _$c);
                                u += _$m2;
                                for(var _$e7 = 0; _$e7 < s2.length; _$e7++)_$m2 = _$d[i] - _$d[i - 1], i++, s2[_$e7] = t.vertexBufferType === hp.VEC_2 ? Gp(_$g, _$y, u, _$m2) : Xp(_$g, _$y, u, _$m2, 0, _$c), u += _$m2;
                                _$h5[_$e6] = o.createPolygon(a1, s2);
                            }
                            _$e[a++] = o.createMultiPolygon(_$h5);
                        } else {
                            for(var _$t9 = 0; _$t9 < _$r5; _$t9++){
                                var _$e8 = f[_$n] - f[_$n - 1];
                                _$n++;
                                var _$r7 = new Array(_$e8 - 1);
                                _$m2 = _$d[i] - _$d[i - 1], i++;
                                var s3 = jp(_$g, l, _$m2);
                                l += 2 * _$m2;
                                for(var _$t10 = 0; _$t10 < _$r7.length; _$t10++){
                                    var _$e9 = _$d[i] - _$d[i - 1];
                                    i++, _$r7[_$t10] = jp(_$g, l, _$e9), l += 2 * _$e9;
                                }
                                _$h5[_$t9] = o.createPolygon(s3, _$r7);
                            }
                            _$e[a++] = o.createMultiPolygon(_$h5);
                        }
                    }
                }
            }
            return _$e;
        }
        function jp(t, e1, r) {
            return Yp(t, e1, r, !0);
        }
        function Gp(t, e1, r, n) {
            return Zp(t, e1, r, n, !0);
        }
        function Xp(t, e1, r, n, i, s) {
            return Hp(t, e1, r, n, !0, s);
        }
        function Yp(t, e1, n, i) {
            var s = new Array(i ? n + 1 : n);
            for(var _$i = 0; _$i < 2 * n; _$i += 2)s[_$i / 2] = new r(t[e1 + _$i], t[e1 + _$i + 1]);
            return i && (s[s.length - 1] = s[0]), s;
        }
        function Zp(t, e1, n, i, s) {
            var a = new Array(s ? i + 1 : i);
            for(var _$s = 0; _$s < 2 * i; _$s += 2){
                var _$i = 2 * e1[n + _$s / 2];
                a[_$s / 2] = new r(t[_$i], t[_$i + 1]);
            }
            return s && (a[a.length - 1] = a[0]), a;
        }
        function Hp(t, e1, n, i, s, a) {
            var o = new Array(s ? i + 1 : i);
            for(var _$s = 0; _$s < i; _$s++){
                var _$i = Np(t[e1[n + _$s]], a.numBits, a.coordinateShift);
                o[_$s] = new r(_$i.x, _$i.y);
            }
            return s && (o[o.length - 1] = o[0]), o;
        }
        var Kp = /*#__PURE__*/ function() {
            function Kp(t, e1, r, n, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Kp);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_vertexBufferType", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_topologyVector", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_vertexOffsets", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_vertexBuffer", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_mortonSettings", void 0);
                this._vertexBufferType = t, this._topologyVector = e1, this._vertexOffsets = r, this._vertexBuffer = n, this._mortonSettings = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Kp, [
                {
                    key: "vertexBufferType",
                    get: function get() {
                        return this._vertexBufferType;
                    }
                },
                {
                    key: "topologyVector",
                    get: function get() {
                        return this._topologyVector;
                    }
                },
                {
                    key: "vertexOffsets",
                    get: function get() {
                        return this._vertexOffsets;
                    }
                },
                {
                    key: "vertexBuffer",
                    get: function get() {
                        return this._vertexBuffer;
                    }
                },
                {
                    key: Symbol.iterator,
                    value: function value() {
                        var _$t, _$e;
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _$t = qp(this);
                                    _$e = 0;
                                    _state.label = 1;
                                case 1:
                                    if (!(_$e < this.numGeometries)) return [
                                        3,
                                        4
                                    ];
                                    return [
                                        4,
                                        {
                                            coordinates: _$t[_$e],
                                            type: this.geometryType(_$e)
                                        }
                                    ];
                                case 2:
                                    _state.sent(), _$e++;
                                    _state.label = 3;
                                case 3:
                                    return [
                                        3,
                                        1
                                    ];
                                case 4:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }
                },
                {
                    key: "getSimpleEncodedVertex",
                    value: function getSimpleEncodedVertex(t) {
                        var _$e = this.vertexOffsets ? 2 * this.vertexOffsets[t] : 2 * t;
                        return [
                            this.vertexBuffer[_$e],
                            this.vertexBuffer[_$e + 1]
                        ];
                    }
                },
                {
                    key: "getVertex",
                    value: function getVertex(t) {
                        if (this.vertexOffsets && this.mortonSettings) {
                            var _$e = Np(this.vertexBuffer[this.vertexOffsets[t]], this.mortonSettings.numBits, this.mortonSettings.coordinateShift);
                            return [
                                _$e.x,
                                _$e.y
                            ];
                        }
                        var _$e1 = this.vertexOffsets ? 2 * this.vertexOffsets[t] : 2 * t;
                        return [
                            this.vertexBuffer[_$e1],
                            this.vertexBuffer[_$e1 + 1]
                        ];
                    }
                },
                {
                    key: "getGeometries",
                    value: function getGeometries() {
                        return qp(this);
                    }
                },
                {
                    key: "mortonSettings",
                    get: function get() {
                        return this._mortonSettings;
                    }
                }
            ]);
            return Kp;
        }();
        var Wp = /*#__PURE__*/ function(Kp) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Wp, Kp);
            function Wp(t, e1, r, n, i, s, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Wp);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Wp, [
                    r,
                    n,
                    i,
                    s,
                    a
                ]), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "_numGeometries", void 0), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "_geometryType", void 0), _this._numGeometries = t, _this._geometryType = e1;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Wp, [
                {
                    key: "geometryType",
                    value: function geometryType(t) {
                        return this._geometryType;
                    }
                },
                {
                    key: "numGeometries",
                    get: function get() {
                        return this._numGeometries;
                    }
                },
                {
                    key: "containsPolygonGeometry",
                    value: function containsPolygonGeometry() {
                        return this._geometryType === up.POLYGON || this._geometryType === up.MULTIPOLYGON;
                    }
                },
                {
                    key: "containsSingleGeometryType",
                    value: function containsSingleGeometryType() {
                        return !0;
                    }
                }
            ]);
            return Wp;
        }(Kp);
        var Jp = /*#__PURE__*/ function(Kp) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Jp, Kp);
            function Jp(t, e1, r, n, i, s) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Jp);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Jp, [
                    t,
                    r,
                    n,
                    i,
                    s
                ]), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "_geometryTypes", void 0), _this._geometryTypes = e1;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Jp, [
                {
                    key: "geometryType",
                    value: function geometryType(t) {
                        return this._geometryTypes[t];
                    }
                },
                {
                    key: "numGeometries",
                    get: function get() {
                        return this._geometryTypes.length;
                    }
                },
                {
                    key: "containsPolygonGeometry",
                    value: function containsPolygonGeometry() {
                        for(var _$t = 0; _$t < this.numGeometries; _$t++)if (this.geometryType(_$t) === up.POLYGON || this.geometryType(_$t) === up.MULTIPOLYGON) return !0;
                        return !1;
                    }
                },
                {
                    key: "containsSingleGeometryType",
                    value: function containsSingleGeometryType() {
                        return !1;
                    }
                }
            ]);
            return Jp;
        }(Kp);
        var Qp = /*#__PURE__*/ function() {
            function Qp(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Qp);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_triangleOffsets", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_indexBuffer", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_vertexBuffer", void 0);
                (0, $6194eebaf067e4d1$export$71511d61b312f219)(this, "_topologyVector", void 0);
                this._triangleOffsets = t, this._indexBuffer = e1, this._vertexBuffer = r, this._topologyVector = n;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Qp, [
                {
                    key: "triangleOffsets",
                    get: function get() {
                        return this._triangleOffsets;
                    }
                },
                {
                    key: "indexBuffer",
                    get: function get() {
                        return this._indexBuffer;
                    }
                },
                {
                    key: "vertexBuffer",
                    get: function get() {
                        return this._vertexBuffer;
                    }
                },
                {
                    key: "topologyVector",
                    get: function get() {
                        return this._topologyVector;
                    }
                },
                {
                    key: "getGeometries",
                    value: function getGeometries() {
                        if (!this._topologyVector) throw new Error("Cannot convert GpuVector to coordinates without topology information");
                        var _$t = new Array(this.numGeometries), _$e = this._topologyVector, _$n = _$e.partOffsets, i = _$e.ringOffsets, s = _$e.geometryOffsets;
                        var a = 0, o = 1, l = 1, u = 1;
                        for(var _$e1 = 0; _$e1 < this.numGeometries; _$e1++)switch(this.geometryType(_$e1)){
                            case up.POLYGON:
                                {
                                    var _$c = _$n[o] - _$n[o - 1];
                                    o++;
                                    var _$h = [];
                                    for(var _$t1 = 0; _$t1 < _$c; _$t1++){
                                        var _$t2 = i[l] - i[l - 1];
                                        l++;
                                        var _$e2 = [];
                                        for(var _$n1 = 0; _$n1 < _$t2; _$n1++){
                                            var _$t3 = this._vertexBuffer[a++], _$n2 = this._vertexBuffer[a++];
                                            _$e2.push(new r(_$t3, _$n2));
                                        }
                                        _$e2.length > 0 && _$e2.push(_$e2[0]), _$h.push(_$e2);
                                    }
                                    _$t[_$e1] = _$h, s && u++;
                                }
                                break;
                            case up.MULTIPOLYGON:
                                {
                                    var _$c1 = s[u] - s[u - 1];
                                    u++;
                                    var _$h1 = [];
                                    for(var _$t4 = 0; _$t4 < _$c1; _$t4++){
                                        var _$t5 = _$n[o] - _$n[o - 1];
                                        o++;
                                        for(var _$e3 = 0; _$e3 < _$t5; _$e3++){
                                            var _$t6 = i[l] - i[l - 1];
                                            l++;
                                            var _$e4 = [];
                                            for(var _$n3 = 0; _$n3 < _$t6; _$n3++){
                                                var _$t7 = this._vertexBuffer[a++], _$n4 = this._vertexBuffer[a++];
                                                _$e4.push(new r(_$t7, _$n4));
                                            }
                                            _$e4.length > 0 && _$e4.push(_$e4[0]), _$h1.push(_$e4);
                                        }
                                    }
                                    _$t[_$e1] = _$h1;
                                }
                        }
                        return _$t;
                    }
                },
                {
                    key: Symbol.iterator,
                    value: function value() {
                        return null;
                    }
                }
            ]);
            return Qp;
        }();
        function tf(t, e1, r, n, i, s) {
            return new ef(t, e1, r, n, i, s);
        }
        var ef = /*#__PURE__*/ function(Qp) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ef, Qp);
            function ef(t, e1, r, n, i, s) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ef);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ef, [
                    r,
                    n,
                    i,
                    s
                ]), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "_numGeometries", void 0), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "_geometryType", void 0), _this._numGeometries = t, _this._geometryType = e1;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ef, [
                {
                    key: "geometryType",
                    value: function geometryType(t) {
                        return this._geometryType;
                    }
                },
                {
                    key: "numGeometries",
                    get: function get() {
                        return this._numGeometries;
                    }
                },
                {
                    key: "containsSingleGeometryType",
                    value: function containsSingleGeometryType() {
                        return !0;
                    }
                }
            ]);
            return ef;
        }(Qp);
        function rf(t, e1, r, n, i) {
            return new nf(t, e1, r, n, i);
        }
        var nf = /*#__PURE__*/ function(Qp) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(nf, Qp);
            function nf(t, e1, r, n, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, nf);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, nf, [
                    e1,
                    r,
                    n,
                    i
                ]), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "_geometryTypes", void 0), _this._geometryTypes = t;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(nf, [
                {
                    key: "geometryType",
                    value: function geometryType(t) {
                        return this._geometryTypes[t];
                    }
                },
                {
                    key: "numGeometries",
                    get: function get() {
                        return this._geometryTypes.length;
                    }
                },
                {
                    key: "containsSingleGeometryType",
                    value: function containsSingleGeometryType() {
                        return !1;
                    }
                }
            ]);
            return nf;
        }(Qp);
        function sf(t, e1, r, n, i) {
            var s = kp(t, r);
            var a = null, o = null, l = null, u = null, _$c = null, _$h = null, p = null, f = null;
            if (Cp(s, n, t, r) === lp.CONST) {
                var i1 = Fp(t, r, s, !1);
                for(var _$n = 0; _$n < e1 - 1; _$n++){
                    var _$e = kp(t, r);
                    switch(_$e.physicalStreamType){
                        case ip.LENGTH:
                            switch(_$e.logicalStreamType.lengthType){
                                case op.GEOMETRIES:
                                    a = Ip(t, r, _$e);
                                    break;
                                case op.PARTS:
                                    o = Ip(t, r, _$e);
                                    break;
                                case op.RINGS:
                                    l = Ip(t, r, _$e);
                                    break;
                                case op.TRIANGLES:
                                    p = Ip(t, r, _$e);
                            }
                            break;
                        case ip.OFFSET:
                            switch(_$e.logicalStreamType.offsetType){
                                case ap.VERTEX:
                                    u = Tp(t, r, _$e, !1);
                                    break;
                                case ap.INDEX:
                                    f = Tp(t, r, _$e, !1);
                            }
                            break;
                        case ip.DATA:
                            sp.VERTEX === _$e.logicalStreamType.dictionaryType ? _$c = Tp(t, r, _$e, !0) : (_$h = {
                                numBits: _$e.numBits,
                                coordinateShift: _$e.coordinateShift
                            }, _$c = Tp(t, r, _$e, !1));
                    }
                }
                return null !== f ? null != a || null != o ? tf(n, i1, p, f, _$c, new Rp(a, o, l)) : tf(n, i1, p, f, _$c) : null === _$h ? function(t, e1, r, n, i) {
                    return new Wp(t, e1, hp.VEC_2, r, n, i);
                }(n, i1, new Rp(a, o, l), u, _$c) : function(t, e1, r, n, i, s) {
                    return new Wp(t, e1, hp.MORTON, r, n, i, s);
                }(n, i1, new Rp(a, o, l), u, _$c, _$h);
            }
            var _$d = Tp(t, r, s, !1);
            for(var _$n1 = 0; _$n1 < e1 - 1; _$n1++){
                var _$e1 = kp(t, r);
                switch(_$e1.physicalStreamType){
                    case ip.LENGTH:
                        switch(_$e1.logicalStreamType.lengthType){
                            case op.GEOMETRIES:
                                a = Tp(t, r, _$e1, !1);
                                break;
                            case op.PARTS:
                                o = Tp(t, r, _$e1, !1);
                                break;
                            case op.RINGS:
                                l = Tp(t, r, _$e1, !1);
                                break;
                            case op.TRIANGLES:
                                p = Ip(t, r, _$e1);
                        }
                        break;
                    case ip.OFFSET:
                        switch(_$e1.logicalStreamType.offsetType){
                            case ap.VERTEX:
                                u = Tp(t, r, _$e1, !1);
                                break;
                            case ap.INDEX:
                                f = Tp(t, r, _$e1, !1);
                        }
                        break;
                    case ip.DATA:
                        sp.VERTEX === _$e1.logicalStreamType.dictionaryType ? _$c = Tp(t, r, _$e1, !0) : (_$h = {
                            numBits: _$e1.numBits,
                            coordinateShift: _$e1.coordinateShift
                        }, _$c = Tp(t, r, _$e1, !1));
                }
            }
            return null !== f && null === o ? rf(_$d, p, f, _$c) : (null !== a ? (a = af(_$d, a, 2), null !== o && null !== l ? (o = of(_$d, a, o, !1), l = function(t, e1, r, n) {
                var i = new Int32Array(r[r.length - 1] + 1);
                var s = 0;
                i[0] = s;
                var a = 1, o = 1, l = 0;
                for(var u = 0; u < t.length; u++){
                    var _$c = t[u], _$h = e1[u + 1] - e1[u];
                    if (0 !== _$c && 3 !== _$c) for(var _$t = 0; _$t < _$h; _$t++){
                        var _$t1 = r[a] - r[a - 1];
                        a++;
                        for(var _$e = 0; _$e < _$t1; _$e++)s = i[o++] = s + n[l++];
                    }
                    else for(var _$t2 = 0; _$t2 < _$h; _$t2++)i[o++] = ++s, a++;
                }
                return i;
            }(_$d, a, o, l)) : null !== o && (o = function(t, e1, r) {
                var _$n = new Int32Array(e1[e1.length - 1] + 1);
                var i = 0;
                _$n[0] = i;
                var s = 1, a = 0;
                for(var o = 0; o < t.length; o++){
                    var l = t[o], u = e1[o + 1] - e1[o];
                    if (4 === l || 1 === l) for(var _$t = 0; _$t < u; _$t++)i = _$n[s++] = i + r[a++];
                    else for(var _$t1 = 0; _$t1 < u; _$t1++)_$n[s++] = ++i;
                }
                return _$n;
            }(_$d, a, o))) : null !== o && null !== l ? (o = af(_$d, o, 1), l = of(_$d, o, l, !0)) : null !== o && (o = af(_$d, o, 0)), null !== f ? rf(_$d, p, f, _$c, new Rp(a, o, l)) : null === _$h ? function(t, e1, r, n) {
                return new Jp(hp.VEC_2, t, e1, r, n);
            }(_$d, new Rp(a, o, l), u, _$c) : function(t, e1, r, n, i) {
                return new Jp(hp.MORTON, t, e1, r, n, i);
            }(_$d, new Rp(a, o, l), u, _$c, _$h));
        }
        function af(t, e1, r) {
            var _$n = new Int32Array(t.length + 1);
            var i = 0;
            _$n[0] = i;
            var s = 0;
            for(var a = 0; a < t.length; a++)i = _$n[a + 1] = i + (t[a] > r ? e1[s++] : 1);
            return _$n;
        }
        function of(t, e1, r, n) {
            var i = new Int32Array(e1[e1.length - 1] + 1);
            var s = 0;
            i[0] = s;
            var a = 1, o = 0;
            for(var l = 0; l < t.length; l++){
                var u = t[l], _$c = e1[l + 1] - e1[l];
                if (5 === u || 2 === u || n && (4 === u || 1 === u)) for(var _$t = 0; _$t < _$c; _$t++)s = i[a++] = s + r[o++];
                else for(var _$t1 = 0; _$t1 < _$c; _$t1++)i[a++] = ++s;
            }
            return i;
        }
        var lf = /*#__PURE__*/ function(Yh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(lf, Yh);
            function lf(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, lf);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, lf, [
                    t,
                    e1.getBuffer(),
                    r
                ]), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "dataVector", void 0), _this.dataVector = e1;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(lf, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        return this.dataVector.get(t);
                    }
                }
            ]);
            return lf;
        }(Yh);
        var uf = /*#__PURE__*/ function(Zh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(uf, Zh);
            function uf() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, uf);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, uf, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(uf, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        return this.dataBuffer[t];
                    }
                }
            ]);
            return uf;
        }(Zh);
        var cf = /*#__PURE__*/ function(Yh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(cf, Yh);
            function cf(t, e1, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, cf);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, cf, [
                    t,
                    BigInt64Array.of(e1),
                    r
                ]);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(cf, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        return this.dataBuffer[0];
                    }
                }
            ]);
            return cf;
        }(Yh);
        function hf(t, e1, r) {
            return pf(t, Math.ceil(e1 / 8), r);
        }
        function pf(t, e1, r) {
            var _$n = new Uint8Array(e1);
            var i = 0;
            for(; i < e1;){
                var _$e = t[r.increment()];
                if (_$e <= 127) {
                    var s = _$e + 3, a = t[r.increment()], o = i + s;
                    _$n.fill(a, i, o), i = o;
                } else {
                    var s1 = 256 - _$e;
                    for(var _$e1 = 0; _$e1 < s1; _$e1++)_$n[i++] = t[r.increment()];
                }
            }
            return _$n;
        }
        var ff = new TextDecoder;
        function df(t, e1, r) {
            return r - e1 >= 12 ? ff.decode(t.subarray(e1, r)) : function(t, e1, r) {
                var _$n = "", i = e1;
                for(; i < r;){
                    var _$e = t[i];
                    var s = void 0, a = void 0, o = void 0, l = null, u = _$e > 239 ? 4 : _$e > 223 ? 3 : _$e > 191 ? 2 : 1;
                    if (i + u > r) break;
                    1 === u ? _$e < 128 && (l = _$e) : 2 === u ? (s = t[i + 1], 128 == (192 & s) && (l = (31 & _$e) << 6 | 63 & s, l <= 127 && (l = null))) : 3 === u ? (s = t[i + 1], a = t[i + 2], 128 == (192 & s) && 128 == (192 & a) && (l = (15 & _$e) << 12 | (63 & s) << 6 | 63 & a, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === u && (s = t[i + 1], a = t[i + 2], o = t[i + 3], 128 == (192 & s) && 128 == (192 & a) && 128 == (192 & o) && (l = (15 & _$e) << 18 | (63 & s) << 12 | (63 & a) << 6 | 63 & o, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, u = 1) : l > 65535 && (l -= 65536, _$n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), _$n += String.fromCharCode(l), i += u;
                }
                return _$n;
            }(t, e1, r);
        }
        var yf = /*#__PURE__*/ function(Yh) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(yf, Yh);
            function yf(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, yf);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, yf, [
                    t,
                    r,
                    n
                ]), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "offsetBuffer", void 0), _this.offsetBuffer = e1;
                return _this;
            }
            return yf;
        }(Yh);
        var mf = /*#__PURE__*/ function(yf) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(mf, yf);
            function mf(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, mf);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, mf, [
                    t,
                    e1,
                    r,
                    n !== null && n !== void 0 ? n : e1.length - 1
                ]), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "textEncoder", void 0), _this.textEncoder = new TextEncoder;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(mf, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        return df(this.dataBuffer, this.offsetBuffer[t], this.offsetBuffer[t + 1]);
                    }
                }
            ]);
            return mf;
        }(yf);
        var gf = /*#__PURE__*/ function(yf) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(gf, yf);
            function gf(t, e1, r, n, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, gf);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, gf, [
                    t,
                    r,
                    n,
                    i !== null && i !== void 0 ? i : e1.length
                ]), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "indexBuffer", void 0), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "textEncoder", void 0), _this.indexBuffer = e1, _this.indexBuffer = e1, _this.textEncoder = new TextEncoder;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(gf, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        var _$e = this.indexBuffer[t];
                        return df(this.dataBuffer, this.offsetBuffer[_$e], this.offsetBuffer[_$e + 1]);
                    }
                }
            ]);
            return gf;
        }(yf);
        var xf = /*#__PURE__*/ function(yf) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(xf, yf);
            function xf(t, e1, r, n, i, s, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, xf);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, xf, [
                    t,
                    r,
                    n,
                    a
                ]), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "indexBuffer", void 0), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "symbolOffsetBuffer", void 0), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "symbolTableBuffer", void 0), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "textEncoder", void 0), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "symbolLengthBuffer", void 0), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "lengthBuffer", void 0), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_this, "decodedDictionary", void 0), _this.indexBuffer = e1, _this.symbolOffsetBuffer = i, _this.symbolTableBuffer = s, _this.textEncoder = new TextEncoder;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(xf, [
                {
                    key: "getValueFromBuffer",
                    value: function getValueFromBuffer(t) {
                        null == this.decodedDictionary && (null == this.symbolLengthBuffer && (this.symbolLengthBuffer = this.offsetToLengthBuffer(this.symbolOffsetBuffer), this.lengthBuffer = this.offsetToLengthBuffer(this.offsetBuffer)), this.decodedDictionary = function(t, e1, r) {
                            var _$n = [], i = new Array(e1.length).fill(0);
                            for(var _$t = 1; _$t < e1.length; _$t++)i[_$t] = i[_$t - 1] + e1[_$t - 1];
                            for(var s = 0; s < r.length; s++)if (255 === r[s]) _$n.push(r[++s]);
                            else {
                                var a = e1[r[s]], o = i[r[s]];
                                for(var _$e = 0; _$e < a; _$e++)_$n.push(t[o + _$e]);
                            }
                            return new Uint8Array(_$n);
                        }(this.symbolTableBuffer, this.symbolLengthBuffer, this.dataBuffer));
                        var _$e = this.indexBuffer[t];
                        return df(this.decodedDictionary, this.offsetBuffer[_$e], this.offsetBuffer[_$e + 1]);
                    }
                },
                {
                    key: "offsetToLengthBuffer",
                    value: function offsetToLengthBuffer(t) {
                        var _$e = new Uint32Array(t.length - 1);
                        var _$r = t[0];
                        for(var _$n = 1; _$n < t.length; _$n++){
                            var i = t[_$n];
                            _$e[_$n - 1] = i - _$r, _$r = i;
                        }
                        return _$e;
                    }
                }
            ]);
            return xf;
        }(yf);
        function vf(t, e1, r, n, i, s) {
            return "scalarType" === r.type ? function(t, e1, r, n, i, s) {
                var a = null, o = 0;
                if (0 === t) return null;
                if (s.nullable) {
                    var _$t = kp(e1, r);
                    o = _$t.numValues;
                    var _$n = r.get(), _$i = hf(e1, o, r);
                    r.set(_$n + _$t.byteLength), a = new Ep(_$i, _$t.numValues);
                }
                var l = a !== null && a !== void 0 ? a : n;
                switch(i.physicalType){
                    case 4:
                    case 3:
                        return function(t, e1, r, n, i) {
                            var _$s = kp(t, e1), a = Cp(_$s, i, t, e1), o = 3 === n.physicalType;
                            if (a === lp.FLAT) {
                                var _$n = bf(i) ? Vp(t, e1, _$s, o, i) : Tp(t, e1, _$s, o);
                                return new Hh(r.name, _$n, i);
                            }
                            if (a === lp.SEQUENCE) {
                                var _$n1 = Dp(t, e1, _$s);
                                return new Jh(r.name, _$n1[0], _$n1[1], _$s.numRleValues);
                            }
                            {
                                var _$n2 = Fp(t, e1, _$s, o);
                                return new Qh(r.name, _$n2, i);
                            }
                        }(e1, r, s, i, l);
                    case 9:
                        return function(t, e1, r, n, i) {
                            var _$s = null, a = null, o = null, l = null, u = null, _$c = null, _$h = null, p = null;
                            for(var _$t = 0; _$t < n; _$t++){
                                var _$t1 = kp(e1, r);
                                if (0 !== _$t1.byteLength) switch(_$t1.physicalStreamType){
                                    case ip.PRESENT:
                                        {
                                            var _$n = hf(e1, _$t1.numValues, r);
                                            _$c = new Ep(_$n, _$t1.numValues);
                                            break;
                                        }
                                    case ip.OFFSET:
                                        a = null != i || null != _$c ? Vp(e1, r, _$t1, !1, i !== null && i !== void 0 ? i : _$c) : Tp(e1, r, _$t1, !1);
                                        break;
                                    case ip.LENGTH:
                                        {
                                            var _$n1 = Ip(e1, r, _$t1);
                                            op.DICTIONARY === _$t1.logicalStreamType.lengthType ? _$s = _$n1 : op.SYMBOL === _$t1.logicalStreamType.lengthType ? l = _$n1 : _$h = _$n1;
                                            break;
                                        }
                                    case ip.DATA:
                                        {
                                            var _$n2 = e1.subarray(r.get(), r.get() + _$t1.byteLength);
                                            r.add(_$t1.byteLength);
                                            var _$i = _$t1.logicalStreamType.dictionaryType;
                                            sp.FSST === _$i ? u = _$n2 : sp.SINGLE === _$i || sp.SHARED === _$i ? o = _$n2 : sp.NONE === _$i && (p = _$n2);
                                            break;
                                        }
                                }
                            }
                            var _ref, _ref1;
                            return (_ref1 = (_ref = function(t, e1, r, n, i, s, a) {
                                return e1 ? new xf(t, r, n, i, s, e1, a) : null;
                            }(t, u, a, _$s, o, l, i !== null && i !== void 0 ? i : _$c)) !== null && _ref !== void 0 ? _ref : function(t, e1, r, n, i) {
                                return e1 ? i ? new gf(t, r, n, e1, i) : new gf(t, r, n, e1) : null;
                            }(t, o, a, _$s, i !== null && i !== void 0 ? i : _$c)) !== null && _ref1 !== void 0 ? _ref1 : function(t, e1, r, n, i) {
                                if (!e1 || !r) return null;
                                if (n) return i ? new gf(t, n, e1, r, i) : new gf(t, n, e1, r);
                                if (i && i.size() !== e1.length - 1) {
                                    var _$n = new Int32Array(i.size());
                                    var _$s = 0;
                                    for(var _$t = 0; _$t < i.size(); _$t++)_$n[_$t] = i.get(_$t) ? _$s++ : 0;
                                    return new gf(t, _$n, e1, r, i);
                                }
                                return i ? new mf(t, e1, r, i) : new mf(t, e1, r);
                            }(t, _$h, p, a, i !== null && i !== void 0 ? i : _$c);
                        }(s.name, e1, r, s.nullable ? t - 1 : t, a);
                    case 0:
                        return function(t, e1, r, n, i) {
                            var _$s = kp(t, e1), a = _$s.numValues, o = e1.get(), l = bf(i) ? function(t, e1, r, n) {
                                var _$i = pf(t, Math.ceil(e1 / 8), r), _$s = new Ep(_$i, e1), a = n.size(), o = new Ep(new Uint8Array(a), a);
                                var l = 0;
                                for(var _$t = 0; _$t < n.size(); _$t++){
                                    var _$e = !!n.get(_$t) && _$s.get(l++);
                                    o.set(_$t, _$e);
                                }
                                return o.getBuffer();
                            }(t, a, e1, i) : hf(t, a, e1);
                            e1.set(o + _$s.byteLength);
                            var u = new Ep(l, a);
                            return new lf(r.name, u, i);
                        }(e1, r, s, 0, l);
                    case 6:
                    case 5:
                        return function(t, e1, r, n, i) {
                            var _$s = kp(t, e1), a = Cp(_$s, n, t, e1), o = 5 === i.physicalType;
                            if (a === lp.FLAT) {
                                var _$i = bf(n) ? function(t, e1, r, n, i) {
                                    return function(t, e1, r, n) {
                                        switch(e1.logicalLevelTechnique1){
                                            case rp.DELTA:
                                                return e1.logicalLevelTechnique2 === rp.RLE && (t = bp(t, e1.runs, e1.numRleValues)), function(t, e1) {
                                                    var _$r = new BigInt64Array(t.size());
                                                    var _$n = 0;
                                                    t.get(0) ? (_$r[0] = t.get(0) ? e1[0] >> 1n ^ -(1n & e1[0]) : 0n, _$n = 1) : _$r[0] = 0n;
                                                    var _$i = 1;
                                                    for(; _$i != _$r.length; ++_$i)_$r[_$i] = t.get(_$i) ? _$r[_$i - 1] + (e1[_$n] >> 1n ^ -(1n & e1[_$n++])) : _$r[_$i - 1];
                                                    return _$r;
                                                }(n, t);
                                            case rp.RLE:
                                                return function(t, e1, r, n) {
                                                    var _$i = e1;
                                                    return r ? function(t, e1, r) {
                                                        var _$n = new BigInt64Array(t.size());
                                                        var _$i = 0;
                                                        for(var _$s = 0; _$s < r; _$s++){
                                                            var a = Number(e1[_$s]);
                                                            var o = e1[_$s + r];
                                                            o = o >> 1n ^ -(1n & o);
                                                            for(var _$e = _$i; _$e < _$i + a; _$e++)t.get(_$e) ? _$n[_$e] = o : (_$n[_$e] = 0n, _$i++);
                                                            _$i += a;
                                                        }
                                                        return _$n;
                                                    }(n, t, _$i.runs) : function(t, e1, r) {
                                                        var _$n = new BigInt64Array(t.size());
                                                        var _$i = 0;
                                                        for(var _$s = 0; _$s < r; _$s++){
                                                            var a = Number(e1[_$s]), o = e1[_$s + r];
                                                            for(var _$e = _$i; _$e < _$i + a; _$e++)t.get(_$e) ? _$n[_$e] = o : (_$n[_$e] = 0n, _$i++);
                                                            _$i += a;
                                                        }
                                                        return _$n;
                                                    }(n, t, _$i.runs);
                                                }(t, e1, r, n);
                                            case rp.NONE:
                                                return t = r ? function(t, e1) {
                                                    var _$r = new BigInt64Array(t.size());
                                                    var _$n = 0, _$i = 0;
                                                    for(; _$i != _$r.length; ++_$i)if (t.get(_$i)) {
                                                        var _$t = e1[_$n++];
                                                        _$r[_$i] = _$t >> 1n ^ -(1n & _$t);
                                                    } else _$r[_$i] = 0n;
                                                    return _$r;
                                                }(n, t) : function(t, e1) {
                                                    var _$r = new BigInt64Array(t.size());
                                                    var _$n = 0, _$i = 0;
                                                    for(; _$i != _$r.length; ++_$i)_$r[_$i] = t.get(_$i) ? e1[_$n++] : 0n;
                                                    return _$r;
                                                }(n, t), t;
                                            default:
                                                throw new Error("The specified Logical level technique is not supported");
                                        }
                                    }(fp(t, e1, r.numValues), r, n, i);
                                }(t, e1, _$s, o, n) : Pp(t, e1, _$s, o);
                                return new Lp(r.name, _$i, n);
                            }
                            if (a === lp.SEQUENCE) {
                                var _$n = zp(t, e1, _$s);
                                return new Op(r.name, _$n[0], _$n[1], _$s.numRleValues);
                            }
                            {
                                var _$i1 = Bp(t, e1, _$s, o);
                                return new cf(r.name, _$i1, n);
                            }
                        }(e1, r, s, l, i);
                    case 7:
                        return function(t, e1, r, n) {
                            var _$i = kp(t, e1), _$s = bf(n) ? function(t, e1, r, n) {
                                var _$i = e1.get(), _$s = _$i + n * Float32Array.BYTES_PER_ELEMENT, a = new Uint8Array(t.subarray(_$i, _$s)).buffer, o = new Float32Array(a);
                                e1.set(_$s);
                                var l = r.size(), u = new Float32Array(l);
                                var _$c = 0;
                                for(var _$t = 0; _$t < l; _$t++)u[_$t] = r.get(_$t) ? o[_$c++] : 0;
                                return u;
                            }(t, e1, n, _$i.numValues) : function(t, e1, r) {
                                var _$n = e1.get(), _$i = _$n + r * Float32Array.BYTES_PER_ELEMENT, _$s = new Uint8Array(t.subarray(_$n, _$i)).buffer, a = new Float32Array(_$s);
                                return e1.set(_$i), a;
                            }(t, e1, _$i.numValues);
                            return new uf(r.name, _$s, n);
                        }(e1, r, s, l);
                    case 8:
                        return function(t, e1, r, n) {
                            var _$i = kp(t, e1), _$s = bf(n) ? function(t, e1, r, n) {
                                var _$i = e1.get(), _$s = _$i + n * Float64Array.BYTES_PER_ELEMENT, a = new Uint8Array(t.subarray(_$i, _$s)).buffer, o = new Float64Array(a);
                                e1.set(_$s);
                                var l = r.size(), u = new Float64Array(l);
                                var _$c = 0;
                                for(var _$t = 0; _$t < l; _$t++)u[_$t] = r.get(_$t) ? o[_$c++] : 0;
                                return u;
                            }(t, e1, n, _$i.numValues) : function(t, e1, r) {
                                var _$n = e1.get(), _$i = _$n + r * Float64Array.BYTES_PER_ELEMENT, _$s = new Uint8Array(t.subarray(_$n, _$i)).buffer, a = new Float64Array(_$s);
                                return e1.set(_$i), a;
                            }(t, e1, _$i.numValues);
                            return new Kh(r.name, _$s, n);
                        }(e1, r, s, l);
                    default:
                        throw new Error("The specified data type for the field is currently not supported: ".concat(i));
                }
            }(n, t, e1, i, r.scalarType, r) : 1 != n ? null : function(t, e1, r, n) {
                var _$i = null, s = null, a = null, o = null, l = !1;
                for(; !l;){
                    var _$r = kp(t, e1);
                    switch(_$r.physicalStreamType){
                        case ip.LENGTH:
                            op.DICTIONARY === _$r.logicalStreamType.lengthType ? _$i = Ip(t, e1, _$r) : a = Ip(t, e1, _$r);
                            break;
                        case ip.DATA:
                            sp.SINGLE === _$r.logicalStreamType.dictionaryType || sp.SHARED === _$r.logicalStreamType.dictionaryType ? (s = t.subarray(e1.get(), e1.get() + _$r.byteLength), l = !0) : o = t.subarray(e1.get(), e1.get() + _$r.byteLength), e1.add(_$r.byteLength);
                    }
                }
                var u = r.complexType.children, _$c = [];
                var _$h = 0;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = u[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var l1 = _step.value;
                        var u1 = pp(t, e1, 1)[0];
                        if (0 == u1) continue;
                        var p = "".concat(r.name).concat("default" === l1.name ? "" : ":" + l1.name);
                        if (2 !== u1 || "scalarField" !== l1.type || 9 !== l1.scalarField.physicalType) throw new Error("Currently only optional string fields are implemented for a struct.");
                        var f = kp(t, e1), _$d = hf(t, f.numValues, e1), _$y = kp(t, e1), _$m = _$y.decompressedCount !== n ? Vp(t, e1, _$y, !1, new Ep(_$d, f.numValues)) : Tp(t, e1, _$y, !1);
                        _$c[_$h++] = o ? new xf(p, _$m, _$i, s, a, o, new Ep(_$d, f.numValues)) : new gf(p, _$m, _$i, s, new Ep(_$d, f.numValues));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return _$c;
            }(t, e1, r, i);
        }
        function bf(t) {
            return t instanceof Ep;
        }
        function wf(t) {
            if ("id" === t.name) return !1;
            if ("scalarType" === t.type) {
                var _$e = t.scalarType;
                if ("physicalType" === _$e.type) switch(_$e.physicalType){
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                    case 4:
                    case 5:
                    case 6:
                    case 7:
                    case 8:
                    default:
                        return !1;
                    case 9:
                        return !0;
                }
                else if ("logicalType" === _$e.type) return !1;
            } else if ("complexType" === t.type) {
                var _$e1 = t.complexType;
                if ("physicalType" === _$e1.type) switch(_$e1.physicalType){
                    case 0:
                    case 1:
                        return !0;
                    default:
                        return !1;
                }
            }
            return console.warn("Unexpected column type in hasStreamCount", t), !1;
        }
        var _f = new TextDecoder;
        function Sf(t, e1) {
            var _$r = pp(t, e1, 1)[0];
            if (0 === _$r) return "";
            var _$n = e1.get(), i = t.subarray(_$n, _$n + _$r);
            return e1.add(_$r), _f.decode(i);
        }
        function Af(t, e1) {
            var _$r = pp(t, e1, 1)[0] >>> 0, _$n = !!(4 & _$r), i = !!(2 & _$r), s = pp(t, e1, 1)[0] >>> 0, a = {};
            if (1 & _$r && (a.nullable = !0), i) {
                var i1 = {};
                if (_$n ? (i1.type = "logicalType", i1.logicalType = s) : (i1.type = "physicalType", i1.physicalType = s), 8 & _$r) {
                    var _$r1 = pp(t, e1, 1)[0] >>> 0;
                    i1.children = new Array(_$r1);
                    for(var _$n1 = 0; _$n1 < _$r1; _$n1++)i1.children[_$n1] = Af(t, e1);
                }
                a.type = "complexField", a.complexField = i1;
            } else {
                var _$t = {};
                _$n ? (_$t.type = "logicalType", _$t.logicalType = s) : (_$t.type = "physicalType", _$t.physicalType = s), a.type = "scalarField", a.scalarField = _$t;
            }
            return a;
        }
        function kf(t, e1) {
            var _$r = pp(t, e1, 1)[0] >>> 0, _$n = function(t) {
                switch(t){
                    case 0:
                    case 1:
                    case 2:
                    case 3:
                        {
                            var _$e = {};
                            _$e.nullable = !!(1 & t), _$e.columnScope = 0;
                            var _$r = {};
                            return _$r.physicalType = t > 1 ? 6 : 4, _$r.type = "physicalType", _$e.scalarType = _$r, _$e.type = "scalarType", _$e;
                        }
                    case 4:
                        {
                            var _$t = {
                                nullable: !1,
                                columnScope: 0
                            }, _$e1 = {
                                type: "physicalType",
                                physicalType: 0
                            };
                            return _$t.type = "complexType", _$t.complexType = _$e1, _$t;
                        }
                    case 30:
                        {
                            var _$t1 = {
                                nullable: !1,
                                columnScope: 0
                            }, _$e2 = {
                                type: "physicalType",
                                physicalType: 1
                            };
                            return _$t1.type = "complexType", _$t1.complexType = _$e2, _$t1;
                        }
                    default:
                        return function(t) {
                            var _$e = null;
                            switch(t){
                                case 10:
                                case 11:
                                    _$e = 0;
                                    break;
                                case 12:
                                case 13:
                                    _$e = 1;
                                    break;
                                case 14:
                                case 15:
                                    _$e = 2;
                                    break;
                                case 16:
                                case 17:
                                    _$e = 3;
                                    break;
                                case 18:
                                case 19:
                                    _$e = 4;
                                    break;
                                case 20:
                                case 21:
                                    _$e = 5;
                                    break;
                                case 22:
                                case 23:
                                    _$e = 6;
                                    break;
                                case 24:
                                case 25:
                                    _$e = 7;
                                    break;
                                case 26:
                                case 27:
                                    _$e = 8;
                                    break;
                                case 28:
                                case 29:
                                    _$e = 9;
                                    break;
                                default:
                                    return null;
                            }
                            var _$r = {};
                            _$r.nullable = !!(1 & t), _$r.columnScope = 0;
                            var _$n = {
                                type: "physicalType"
                            };
                            return _$n.physicalType = _$e, _$r.type = "scalarType", _$r.scalarType = _$n, _$r;
                        }(t);
                }
            }(_$r);
            if (!_$n) throw new Error("Unsupported column type code: ".concat(_$r));
            if (function(t) {
                return t >= 10;
            }(_$r) ? _$n.name = Sf(t, e1) : _$r >= 0 && _$r <= 3 ? _$n.name = "id" : 4 === _$r && (_$n.name = "geometry"), function(t) {
                return 30 === t;
            }(_$r)) {
                var _$r1 = pp(t, e1, 1)[0] >>> 0, i = _$n.complexType;
                i.children = new Array(_$r1);
                for(var _$n1 = 0; _$n1 < _$r1; _$n1++)i.children[_$n1] = Af(t, e1);
            }
            return _$n;
        }
        function Ef(t, e1) {
            var _$r = {
                featureTables: []
            }, _$n = {};
            _$n.name = Sf(t, e1);
            var i = pp(t, e1, 1)[0] >>> 0, s = pp(t, e1, 1)[0] >>> 0;
            _$n.columns = new Array(s);
            for(var _$r1 = 0; _$r1 < s; _$r1++)_$n.columns[_$r1] = kf(t, e1);
            return _$r.featureTables.push(_$n), [
                _$r,
                i
            ];
        }
        function Tf(t, e1, r, n, i, s) {
            var a = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : !1;
            var o = e1.scalarType.physicalType, l = Cp(i, s, t, r);
            if (4 === o) switch(l){
                case lp.FLAT:
                    {
                        var _$e = Tp(t, r, i, !1);
                        return new Hh(n, _$e, s);
                    }
                case lp.SEQUENCE:
                    {
                        var _$e1 = Dp(t, r, i);
                        return new Jh(n, _$e1[0], _$e1[1], i.numRleValues);
                    }
                case lp.CONST:
                    {
                        var _$e2 = Fp(t, r, i, !1);
                        return new Qh(n, _$e2, s);
                    }
            }
            else switch(l){
                case lp.FLAT:
                    {
                        if (a) {
                            var _$e3 = function(t, e1, r, n) {
                                var _$i = function(t, e1, r) {
                                    var _$n = new Float64Array(e1);
                                    for(var _$i = 0; _$i < e1; _$i++)_$n[_$i] = dp(t, r);
                                    return _$n;
                                }(t, r.numValues, e1);
                                return function(t, e1, r) {
                                    switch(e1.logicalLevelTechnique1){
                                        case rp.DELTA:
                                            return e1.logicalLevelTechnique2 === rp.RLE && (t = wp(t, e1.runs, e1.numRleValues)), function(t) {
                                                t[0] = t[0] % 2 == 1 ? (t[0] + 1) / -2 : t[0] / 2;
                                                var _$e = t.length / 4 * 4;
                                                var _$r = 1;
                                                if (_$e >= 4) for(; _$r < _$e - 4; _$r += 4){
                                                    var _$e1 = t[_$r], _$n = t[_$r + 1], _$i = t[_$r + 2], _$s = t[_$r + 3];
                                                    t[_$r] = (_$e1 % 2 == 1 ? (_$e1 + 1) / -2 : _$e1 / 2) + t[_$r - 1], t[_$r + 1] = (_$n % 2 == 1 ? (_$n + 1) / -2 : _$n / 2) + t[_$r], t[_$r + 2] = (_$i % 2 == 1 ? (_$i + 1) / -2 : _$i / 2) + t[_$r + 1], t[_$r + 3] = (_$s % 2 == 1 ? (_$s + 1) / -2 : _$s / 2) + t[_$r + 2];
                                                }
                                                for(; _$r != t.length; ++_$r)t[_$r] = (t[_$r] % 2 == 1 ? (t[_$r] + 1) / -2 : t[_$r] / 2) + t[_$r - 1];
                                            }(t), t;
                                        case rp.RLE:
                                            return function(t, e1, r) {
                                                return r ? function(t, e1, r) {
                                                    var _$n = new Float64Array(r);
                                                    var _$i = 0;
                                                    for(var _$r = 0; _$r < e1; _$r++){
                                                        var _$s = t[_$r];
                                                        var a = t[_$r + e1];
                                                        a = a % 2 == 1 ? (a + 1) / -2 : a / 2, _$n.fill(a, _$i, _$i + _$s), _$i += _$s;
                                                    }
                                                    return _$n;
                                                }(t, e1.runs, e1.numRleValues) : wp(t, e1.runs, e1.numRleValues);
                                            }(t, e1, r);
                                        case rp.NONE:
                                            return t;
                                        default:
                                            throw new Error("The specified Logical level technique is not supported: ".concat(e1.logicalLevelTechnique1));
                                    }
                                }(_$i, r, n);
                            }(t, r, i, !1);
                            return new Kh(n, _$e3, s);
                        }
                        var _$e4 = Pp(t, r, i, !1);
                        return new Lp(n, _$e4, s);
                    }
                case lp.SEQUENCE:
                    {
                        var _$e5 = zp(t, r, i);
                        return new Op(n, _$e5[0], _$e5[1], i.numRleValues);
                    }
                case lp.CONST:
                    {
                        var _$e6 = Bp(t, r, i, !1);
                        return new cf(n, _$e6, s);
                    }
            }
            throw new Error("Vector type not supported for id column.");
        }
        var If = /*#__PURE__*/ function() {
            function If(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, If);
                var _$r;
                switch(this._featureData = t, this.properties = this._featureData.properties || {}, null === (_$r = this._featureData.geometry) || void 0 === _$r ? void 0 : _$r.type){
                    case up.POINT:
                    case up.MULTIPOINT:
                        this.type = 1;
                        break;
                    case up.LINESTRING:
                    case up.MULTILINESTRING:
                        this.type = 2;
                        break;
                    case up.POLYGON:
                    case up.MULTIPOLYGON:
                        this.type = 3;
                        break;
                    default:
                        this.type = 0;
                }
                this.extent = e1, this.id = Number(this._featureData.id);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(If, [
                {
                    key: "loadGeometry",
                    value: function loadGeometry() {
                        var _$t = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._featureData.geometry.coordinates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                var _$n = [];
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = _$e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var _$t1 = _step1.value;
                                        _$n.push(new r(_$t1.x, _$t1.y));
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                _$t.push(_$n);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$t;
                    }
                }
            ]);
            return If;
        }();
        var Mf = /*#__PURE__*/ function() {
            function Mf(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Mf);
                this.features = [], this.featureTable = t, this.name = t.name, this.extent = t.extent, this.version = 2, this.features = t.getFeatures(), this.length = this.features.length;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Mf, [
                {
                    key: "feature",
                    value: function feature(t) {
                        return new If(this.features[t], this.extent);
                    }
                }
            ]);
            return Mf;
        }();
        var Ff = function Ff(t) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ff);
            this.layers = {};
            var _$e = function(t, e1) {
                var _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                var _$n = new ep(0), i = [];
                for(; _$n.get() < t.length;){
                    var _$e = pp(t, _$n, 1)[0] >>> 0, s = _$n.get() + _$e;
                    if (s > t.length) throw new Error("Block overruns tile: ".concat(s, " > ").concat(t.length));
                    if (1 != pp(t, _$n, 1)[0] >>> 0) {
                        _$n.set(s);
                        continue;
                    }
                    var a = Ef(t, _$n), o = a[1], l = a[0].featureTables[0];
                    var u = null, _$c = null;
                    var _$h = [];
                    var p = 0;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = l.columns[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e1 = _step.value;
                            var i1 = _$e1.name;
                            if ("id" === i1) {
                                var s1 = null;
                                if (_$e1.nullable) {
                                    var _$e2 = kp(t, _$n), _$r1 = _$n.get(), i2 = hf(t, _$e2.numValues, _$n);
                                    _$n.set(_$r1 + _$e2.byteLength), s1 = new Ep(i2, _$e2.numValues);
                                }
                                var a1 = kp(t, _$n);
                                p = a1.decompressedCount, u = Tf(t, _$e1, _$n, i1, a1, s1 !== null && s1 !== void 0 ? s1 : p, _$r);
                            } else if ("geometry" === i1) {
                                var _$e3 = pp(t, _$n, 1)[0];
                                if (0 === p) {
                                    var _$e4 = _$n.get();
                                    p = kp(t, _$n).decompressedCount, _$n.set(_$e4);
                                }
                                _$c = sf(t, _$e3, _$n, p);
                            } else {
                                var _$r2 = wf(_$e1) ? pp(t, _$n, 1)[0] : 1;
                                if (0 === _$r2 && "scalarType" === _$e1.type) continue;
                                var i3 = vf(t, _$n, _$e1, _$r2, p);
                                if (i3) {
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    if (Array.isArray(i3)) try {
                                        for(var _iterator1 = i3[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var _$t = _step1.value;
                                            _$h.push(_$t);
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                    else _$h.push(i3);
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var f = new tp(l.name, _$c, u, _$h, o);
                    i.push(f), _$n.set(s);
                }
                return i;
            }(new Uint8Array(t));
            this.layers = _$e.reduce(function(t, e1) {
                return Object.assign(Object.assign({}, t), (0, $6194eebaf067e4d1$export$71511d61b312f219)({}, e1.name, new Mf(e1)));
            }, {});
        };
        var Df = /*#__PURE__*/ function() {
            function Df(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Df);
                this.feature = t, this.type = t.type, this.properties = t.tags ? t.tags : {}, this.extent = e1, "id" in t && ("string" == typeof t.id ? this.id = parseInt(t.id, 10) : "number" != typeof t.id || isNaN(t.id) || (this.id = t.id));
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Df, [
                {
                    key: "loadGeometry",
                    value: function loadGeometry() {
                        var _$t = [], _$e = 1 === this.feature.type ? [
                            this.feature.geometry
                        ] : this.feature.geometry;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = _$e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$n = _step.value;
                                var _$e1 = [];
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = _$n[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var _$t1 = _step1.value;
                                        _$e1.push(new r(_$t1[0], _$t1[1]));
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                _$t.push(_$e1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$t;
                    }
                }
            ]);
            return Df;
        }();
        var zf = "_geojsonTileLayer";
        function Pf(t, e1) {
            e1.writeVarintField(15, t.version || 1), e1.writeStringField(1, t.name || ""), e1.writeVarintField(5, t.extent || 4096);
            var _$r = {
                keys: [],
                values: [],
                keycache: {},
                valuecache: {}
            };
            for(var _$n = 0; _$n < t.length; _$n++)_$r.feature = t.feature(_$n), e1.writeMessage(2, Bf, _$r);
            var _$n1 = _$r.keys;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _$n1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$t = _step.value;
                    e1.writeStringField(3, _$t);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var i = _$r.values;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = i[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _$t1 = _step1.value;
                    e1.writeMessage(4, Rf, _$t1);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        function Bf(t, e1) {
            if (!t.feature) return;
            var _$r = t.feature;
            void 0 !== _$r.id && e1.writeVarintField(1, _$r.id), e1.writeMessage(2, Vf, t), e1.writeVarintField(3, _$r.type), e1.writeMessage(4, Of, _$r);
        }
        function Vf(t, e1) {
            var _t_feature;
            for(var _$r in (_t_feature = t.feature) === null || _t_feature === void 0 ? void 0 : _t_feature.properties){
                var _$n = t.feature.properties[_$r], i = t.keycache[_$r];
                if (null == _$n) continue;
                void 0 === i && (t.keys.push(_$r), i = t.keys.length - 1, t.keycache[_$r] = i), e1.writeVarint(i), "string" != typeof _$n && "boolean" != typeof _$n && "number" != typeof _$n && (_$n = JSON.stringify(_$n));
                var s = (typeof _$n === "undefined" ? "undefined" : (0, $dvYFb._)(_$n)) + ":" + _$n;
                var a = t.valuecache[s];
                void 0 === a && (t.values.push(_$n), a = t.values.length - 1, t.valuecache[s] = a), e1.writeVarint(a);
            }
        }
        function Cf(t, e1) {
            return (e1 << 3) + (7 & t);
        }
        function Lf(t) {
            return t << 1 ^ t >> 31;
        }
        function Of(t, e1) {
            var _$r = t.loadGeometry(), _$n = t.type;
            var i = 0, s = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _$r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var a = _step.value;
                    var _$r1 = 1;
                    1 === _$n && (_$r1 = a.length), e1.writeVarint(Cf(1, _$r1));
                    var o = 3 === _$n ? a.length - 1 : a.length;
                    for(var _$t = 0; _$t < o; _$t++){
                        1 === _$t && 1 !== _$n && e1.writeVarint(Cf(2, o - 1));
                        var _$r2 = a[_$t].x - i, l = a[_$t].y - s;
                        e1.writeVarint(Lf(_$r2)), e1.writeVarint(Lf(l)), i += _$r2, s += l;
                    }
                    3 === t.type && e1.writeVarint(Cf(7, 1));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        function Rf(t, e1) {
            var _$r = typeof t === "undefined" ? "undefined" : (0, $dvYFb._)(t);
            "string" === _$r ? e1.writeStringField(1, t) : "boolean" === _$r ? e1.writeBooleanField(7, t) : "number" === _$r && (t % 1 != 0 ? e1.writeDoubleField(3, t) : t < 0 ? e1.writeSVarintField(6, t) : e1.writeVarintField(5, t));
        }
        var Nf = /*#__PURE__*/ function() {
            function Nf(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Nf);
                this.tileID = t, this.x = t.canonical.x, this.y = t.canonical.y, this.z = t.canonical.z, this.grid = new cs(M, 16, 0), this.grid3D = new cs(M, 16, 0), this.featureIndexArray = new Na, this.promoteId = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Nf, [
                {
                    key: "insert",
                    value: function insert(t, e1, r, n, i, s) {
                        var a = this.featureIndexArray.length;
                        this.featureIndexArray.emplaceBack(r, n, i);
                        var o = s ? this.grid3D : this.grid;
                        for(var _$t = 0; _$t < e1.length; _$t++){
                            var _$r = e1[_$t], _$n = [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ];
                            for(var _$t1 = 0; _$t1 < _$r.length; _$t1++){
                                var _$e = _$r[_$t1];
                                _$n[0] = Math.min(_$n[0], _$e.x), _$n[1] = Math.min(_$n[1], _$e.y), _$n[2] = Math.max(_$n[2], _$e.x), _$n[3] = Math.max(_$n[3], _$e.y);
                            }
                            _$n[0] < M && _$n[1] < M && _$n[2] >= 0 && _$n[3] >= 0 && o.insert(a, _$n[0], _$n[1], _$n[2], _$n[3]);
                        }
                    }
                },
                {
                    key: "loadVTLayers",
                    value: function loadVTLayers() {
                        return this.vtLayers || (this.vtLayers = "mlt" !== this.encoding ? new Vu(new Tc(this.rawTileData)).layers : new Ff(this.rawTileData).layers, this.sourceLayerCoder = new Gh(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                            zf
                        ])), this.vtLayers;
                    }
                },
                {
                    key: "query",
                    value: function query(t, e1, n, i) {
                        var _this, _loop = function(_$r) {
                            var u = _$h[_$r];
                            if (u === _$y) return "continue";
                            _$y = u;
                            var _$c = _this.featureIndexArray.get(u);
                            var p = null;
                            _this.loadMatchingFeature(_$d, _$c.bucketIndex, _$c.sourceLayerIndex, _$c.featureIndex, o, s.layers, s.availableImages, e1, n, i, function(e1, r, n) {
                                return p || (p = No(e1)), r.queryIntersectsFeature({
                                    queryGeometry: l,
                                    feature: e1,
                                    featureState: n,
                                    geometry: p,
                                    zoom: _this1.z,
                                    transform: t.transform,
                                    pixelsToTileUnits: a,
                                    pixelPosMatrix: t.pixelPosMatrix,
                                    unwrappedTileID: _this1.tileID.toUnwrapped(),
                                    getElevation: t.getElevation
                                });
                            });
                        };
                        var _this1 = this;
                        this.loadVTLayers();
                        var s = t.params, a = M / t.tileSize / t.scale, o = fi(s.filter, s.globalState), l = t.queryGeometry, u = t.queryPadding * a, _$c = jh.fromPoints(l), _$h = this.grid.query(_$c.minX - u, _$c.minY - u, _$c.maxX + u, _$c.maxY + u), p = jh.fromPoints(t.cameraQueryGeometry).expandBy(u), f = this.grid3D.query(p.minX, p.minY, p.maxX, p.maxY, function(e1, n, i, s) {
                            return function(t, e1, n, i, s) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$r = _step.value;
                                        if (e1 <= _$r.x && n <= _$r.y && i >= _$r.x && s >= _$r.y) return !0;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                var a = [
                                    new r(e1, n),
                                    new r(e1, s),
                                    new r(i, s),
                                    new r(i, n)
                                ];
                                if (t.length > 2) {
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = a[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var _$e = _step1.value;
                                            if (tl(t, _$e)) return !0;
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                                for(var _$e1 = 0; _$e1 < t.length - 1; _$e1++)if (el(t[_$e1], t[_$e1 + 1], a)) return !0;
                                return !1;
                            }(t.cameraQueryGeometry, e1 - u, n - u, i + u, s + u);
                        });
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = f[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                _$h.push(_$t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        _$h.sort(Uf);
                        var _$d = {};
                        var _$y;
                        for(var _$r = 0; _$r < _$h.length; _$r++)_this = this, _loop(_$r);
                        return _$d;
                    }
                },
                {
                    key: "loadMatchingFeature",
                    value: function loadMatchingFeature(t, e1, r, n, i, s, a, o, l, u, c) {
                        var _$h = this.bucketLayerIDs[e1];
                        if (s && !_$h.some(function(t) {
                            return s.has(t);
                        })) return;
                        var p = this.sourceLayerCoder.decode(r), f = this.vtLayers[p].feature(n);
                        if (i.needGeometry) {
                            var _$t = $o(f, !0);
                            if (!i.filter(new Ps(this.tileID.overscaledZ), _$t, this.tileID.canonical)) return;
                        } else if (!i.filter(new Ps(this.tileID.overscaledZ), f)) return;
                        var _$d = this.getId(f, p);
                        for(var _$e = 0; _$e < _$h.length; _$e++){
                            var _$r = _$h[_$e];
                            if (s && !s.has(_$r)) continue;
                            var _$i = o[_$r];
                            if (!_$i) continue;
                            var p1 = {};
                            _$d && u && (p1 = u.getState(_$i.sourceLayer || zf, _$d));
                            var _$y = O({}, l[_$r]);
                            _$y.paint = $f(_$y.paint, _$i.paint, f, p1, a), _$y.layout = $f(_$y.layout, _$i.layout, f, p1, a);
                            var _$m = !c || c(f, _$i, p1);
                            if (!_$m) continue;
                            var _$g = new Xh(f, this.z, this.x, this.y, _$d);
                            _$g.layer = _$y;
                            var _$x = t[_$r];
                            void 0 === _$x && (_$x = t[_$r] = []), _$x.push({
                                featureIndex: n,
                                feature: _$g,
                                intersectionZ: _$m
                            });
                        }
                    }
                },
                {
                    key: "lookupSymbolFeatures",
                    value: function lookupSymbolFeatures(t, e1, r, n, i, s, a, o) {
                        var l = {};
                        this.loadVTLayers();
                        var u = fi(i.filterSpec, i.globalState);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$i = _step.value;
                                this.loadMatchingFeature(l, r, n, _$i, u, s, a, o, e1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return l;
                    }
                },
                {
                    key: "hasLayer",
                    value: function hasLayer(t) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator = this.bucketLayerIDs[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                var _$e = _step.value;
                                try {
                                    for(var _iterator1 = _$e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                        var _$r = _step1.value;
                                        if (t === _$r) return !0;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        return !1;
                    }
                },
                {
                    key: "getId",
                    value: function getId(t, e1) {
                        var _$r;
                        var _$n = t.id;
                        return this.promoteId && (_$n = t.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[e1]], "boolean" == typeof _$n && (_$n = Number(_$n)), void 0 === _$n && (null === (_$r = t.properties) || void 0 === _$r ? void 0 : _$r.cluster) && this.promoteId && (_$n = Number(t.properties.cluster_id))), _$n;
                    }
                }
            ]);
            return Nf;
        }();
        function $f(t, e1, r, n, i) {
            return N(t, function(t, s) {
                var a = e1 instanceof qs ? e1.get(s) : null;
                return a && a.evaluate ? a.evaluate(r, n, i) : a;
            });
        }
        function Uf(t, e1) {
            return e1 - t;
        }
        function qf(t, e1, n, i, s) {
            var a = [];
            for(var o = 0; o < t.length; o++){
                var l = t[o];
                var u = void 0;
                for(var _$t = 0; _$t < l.length - 1; _$t++){
                    var o1 = l[_$t], _$c = l[_$t + 1];
                    o1.x < e1 && _$c.x < e1 || (o1.x < e1 ? o1 = new r(e1, o1.y + (e1 - o1.x) / (_$c.x - o1.x) * (_$c.y - o1.y))._round() : _$c.x < e1 && (_$c = new r(e1, o1.y + (e1 - o1.x) / (_$c.x - o1.x) * (_$c.y - o1.y))._round()), o1.y < n && _$c.y < n || (o1.y < n ? o1 = new r(o1.x + (n - o1.y) / (_$c.y - o1.y) * (_$c.x - o1.x), n)._round() : _$c.y < n && (_$c = new r(o1.x + (n - o1.y) / (_$c.y - o1.y) * (_$c.x - o1.x), n)._round()), o1.x >= i && _$c.x >= i || (o1.x >= i ? o1 = new r(i, o1.y + (i - o1.x) / (_$c.x - o1.x) * (_$c.y - o1.y))._round() : _$c.x >= i && (_$c = new r(i, o1.y + (i - o1.x) / (_$c.x - o1.x) * (_$c.y - o1.y))._round()), o1.y >= s && _$c.y >= s || (o1.y >= s ? o1 = new r(o1.x + (s - o1.y) / (_$c.y - o1.y) * (_$c.x - o1.x), s)._round() : _$c.y >= s && (_$c = new r(o1.x + (s - o1.y) / (_$c.y - o1.y) * (_$c.x - o1.x), s)._round()), u && o1.equals(u[u.length - 1]) || (u = [
                        o1
                    ], a.push(u)), u.push(_$c)))));
                }
            }
            return a;
        }
        function jf(t, e1, r, n, i) {
            switch(e1){
                case 1:
                    return function(t, e1, r, n) {
                        var _$i = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                var s = _step.value;
                                try {
                                    for(var _iterator1 = s[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                        var _$t = _step1.value;
                                        var s1 = 0 === n ? _$t.x : _$t.y;
                                        s1 >= e1 && s1 <= r && _$i.push([
                                            _$t
                                        ]);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        return _$i;
                    }(t, r, n, i);
                case 2:
                    return Xf(t, r, n, i, !1);
                case 3:
                    return Xf(t, r, n, i, !0);
            }
            return [];
        }
        function Gf(t, e1, n, i, s) {
            var a = 0 === i ? Yf : Zf;
            var o = [];
            var l = [];
            for(var _$r = 0; _$r < t.length - 1; _$r++){
                var u = t[_$r], _$c = t[_$r + 1], _$h = 0 === i ? u.x : u.y, p = 0 === i ? _$c.x : _$c.y;
                var f = !1;
                _$h < e1 ? p > e1 && o.push(a(u, _$c, e1)) : _$h > n ? p < n && o.push(a(u, _$c, n)) : o.push(u), p < e1 && _$h >= e1 && (o.push(a(u, _$c, e1)), f = !0), p > n && _$h <= n && (o.push(a(u, _$c, n)), f = !0), !s && f && (l.push(o), o = []);
            }
            var u1 = t.length - 1, _$c1 = 0 === i ? t[u1].x : t[u1].y;
            return _$c1 >= e1 && _$c1 <= n && o.push(t[u1]), s && o.length > 0 && !o[0].equals(o[o.length - 1]) && o.push(new r(o[0].x, o[0].y)), o.length > 0 && l.push(o), l;
        }
        function Xf(t, e1, r, n, i) {
            var s = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var a = _step.value;
                    var _s;
                    var _$t = Gf(a, e1, r, n, i);
                    _$t.length > 0 && (_s = s).push.apply(_s, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$t));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return s;
        }
        function Yf(t, e1, n) {
            return new r(n, t.y + (n - t.x) / (e1.x - t.x) * (e1.y - t.y));
        }
        function Zf(t, e1, n) {
            return new r(t.x + (n - t.y) / (e1.y - t.y) * (e1.x - t.x), n);
        }
        ps("FeatureIndex", Nf, {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        var Hf = /*#__PURE__*/ function(r) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Hf, r);
            function Hf(t, e1, r, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Hf);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Hf, [
                    t,
                    e1
                ]), _this.angle = r, void 0 !== n && (_this.segment = n);
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Hf, [
                {
                    key: "clone",
                    value: function clone() {
                        return new Hf(this.x, this.y, this.angle, this.segment);
                    }
                }
            ]);
            return Hf;
        }(r);
        function Kf(t, e1, r, n, i) {
            if (void 0 === e1.segment || 0 === r) return !0;
            var s = e1, a = e1.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (a--, a < 0) return !1;
                o -= t[a].dist(s), s = t[a];
            }
            o += t[a].dist(t[a + 1]), a++;
            var l = [];
            var u = 0;
            for(; o < r / 2;){
                var _$e = t[a], _$r = t[a + 1];
                if (!_$r) return !1;
                var s1 = t[a - 1].angleTo(_$e) - _$e.angleTo(_$r);
                for(s1 = Math.abs((s1 + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: s1
                }), u += s1; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                a++, o += _$e.dist(_$r);
            }
            return !0;
        }
        function Wf(t) {
            var _$e = 0;
            for(var _$r = 0; _$r < t.length - 1; _$r++)_$e += t[_$r].dist(t[_$r + 1]);
            return _$e;
        }
        function Jf(t, e1, r) {
            return t ? .6 * e1 * r : 0;
        }
        function Qf(t, e1) {
            return Math.max(t ? t.right - t.left : 0, e1 ? e1.right - e1.left : 0);
        }
        function td(t, e1, r, n, i, s) {
            var a = Jf(r, i, s), o = Qf(r, n) * s;
            var l = 0;
            var u = Wf(t) / 2;
            for(var _$r = 0; _$r < t.length - 1; _$r++){
                var _$n = t[_$r], _$i = t[_$r + 1], _$s = _$n.dist(_$i);
                if (l + _$s > u) {
                    var _$c = (u - l) / _$s, _$h = yr.number(_$n.x, _$i.x, _$c), p = yr.number(_$n.y, _$i.y, _$c), f = new Hf(_$h, p, _$i.angleTo(_$n), _$r);
                    return f._round(), !a || Kf(t, f, o, a, e1) ? f : void 0;
                }
                l += _$s;
            }
        }
        function ed(t, e1, r, n, i, s, a, o, l) {
            var u = Jf(n, s, a), _$c = Qf(n, i), _$h = _$c * a, p = 0 === t[0].x || t[0].x === l || 0 === t[0].y || t[0].y === l;
            return e1 - _$h < e1 / 4 && (e1 = _$h + e1 / 4), rd(t, p ? e1 / 2 * o % e1 : (_$c / 2 + 2 * s) * a * o % e1, e1, u, r, _$h, p, !1, l);
        }
        function rd(t, e1, r, n, i, s, a, o, l) {
            var u = s / 2, _$c = Wf(t);
            var _$h = 0, p = e1 - r, f = [];
            for(var _$e = 0; _$e < t.length - 1; _$e++){
                var _$a = t[_$e], _$o = t[_$e + 1], _$d = _$a.dist(_$o), _$y = _$o.angleTo(_$a);
                for(; p + r < _$h + _$d;){
                    p += r;
                    var _$m = (p - _$h) / _$d, _$g = yr.number(_$a.x, _$o.x, _$m), _$x = yr.number(_$a.y, _$o.y, _$m);
                    if (_$g >= 0 && _$g < l && _$x >= 0 && _$x < l && p - u >= 0 && p + u <= _$c) {
                        var _$r = new Hf(_$g, _$x, _$y, _$e);
                        _$r._round(), n && !Kf(t, _$r, s, n, i) || f.push(_$r);
                    }
                }
                _$h += _$d;
            }
            return o || f.length || a || (f = rd(t, _$h / 2, r, n, i, s, a, !0, l)), f;
        }
        function nd(t, e1, n, i) {
            var s = [], a = t.image, o = a.pixelRatio, l = a.paddedRect.w - 2, u = a.paddedRect.h - 2;
            var _$c = {
                x1: t.left,
                y1: t.top,
                x2: t.right,
                y2: t.bottom
            };
            var _$h = a.stretchX || [
                [
                    0,
                    l
                ]
            ], p = a.stretchY || [
                [
                    0,
                    u
                ]
            ], f = function(t, e1) {
                return t + e1[1] - e1[0];
            }, _$d = _$h.reduce(f, 0), _$y = p.reduce(f, 0), _$m = l - _$d, _$g = u - _$y;
            var _$x = 0, _$v = _$d, _$b = 0, _$w = _$y, _ = 0, S = _$m, _$A = 0, _$k = _$g;
            if (a.content && i) {
                var _$e = a.content, _$r = _$e[2] - _$e[0], _$n = _$e[3] - _$e[1];
                (a.textFitWidth || a.textFitHeight) && (_$c = eh(t)), _$x = id(_$h, 0, _$e[0]), _$b = id(p, 0, _$e[1]), _$v = id(_$h, _$e[0], _$e[2]), _$w = id(p, _$e[1], _$e[3]), _ = _$e[0] - _$x, _$A = _$e[1] - _$b, S = _$r - _$v, _$k = _$n - _$w;
            }
            var _$E = _$c.x1, _$T = _$c.y1, I = _$c.x2 - _$E, M = _$c.y2 - _$T, _$F = function(t, i, s, l) {
                var u = ad(t.stretch - _$x, _$v, I, _$E), _$c = od(t.fixed - _, S, t.stretch, _$d), _$h = ad(i.stretch - _$b, _$w, M, _$T), p = od(i.fixed - _$A, _$k, i.stretch, _$y), f = ad(s.stretch - _$x, _$v, I, _$E), _$m = od(s.fixed - _, S, s.stretch, _$d), _$g = ad(l.stretch - _$b, _$w, M, _$T), _$F = od(l.fixed - _$A, _$k, l.stretch, _$y), _$D = new r(u, _$h), _$z = new r(f, _$h), _$P = new r(f, _$g), _$B = new r(u, _$g), V = new r(_$c / o, p / o), _$C = new r(_$m / o, _$F / o), _$L = e1 * Math.PI / 180;
                if (_$L) {
                    var _$t = Math.sin(_$L), _$e = Math.cos(_$L), _$r = [
                        _$e,
                        -_$t,
                        _$t,
                        _$e
                    ];
                    _$D._matMult(_$r), _$z._matMult(_$r), _$B._matMult(_$r), _$P._matMult(_$r);
                }
                var _$O = t.stretch + t.fixed, R = i.stretch + i.fixed;
                return {
                    tl: _$D,
                    tr: _$z,
                    bl: _$B,
                    br: _$P,
                    tex: {
                        x: a.paddedRect.x + 1 + _$O,
                        y: a.paddedRect.y + 1 + R,
                        w: s.stretch + s.fixed - _$O,
                        h: l.stretch + l.fixed - R
                    },
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: V,
                    pixelOffsetBR: _$C,
                    minFontScaleX: S / o / I,
                    minFontScaleY: _$k / o / M,
                    isSDF: n
                };
            };
            if (i && (a.stretchX || a.stretchY)) {
                var _$t = sd(_$h, _$m, _$d), _$e1 = sd(p, _$g, _$y);
                for(var _$r1 = 0; _$r1 < _$t.length - 1; _$r1++){
                    var _$n1 = _$t[_$r1], _$i = _$t[_$r1 + 1];
                    for(var _$t1 = 0; _$t1 < _$e1.length - 1; _$t1++)s.push(_$F(_$n1, _$e1[_$t1], _$i, _$e1[_$t1 + 1]));
                }
            } else s.push(_$F({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return s;
        }
        function id(t, e1, r) {
            var _$n = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var i = _step.value;
                    _$n += Math.max(e1, Math.min(r, i[1])) - Math.max(e1, Math.min(r, i[0]));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return _$n;
        }
        function sd(t, e1, r) {
            var _$n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), _$e = _step_value[0], _$r = _step_value[1];
                    var _$t = _$n[_$n.length - 1];
                    _$n.push({
                        fixed: _$e - _$t.stretch,
                        stretch: _$t.stretch
                    }), _$n.push({
                        fixed: _$e - _$t.stretch,
                        stretch: _$t.stretch + (_$r - _$e)
                    });
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return _$n.push({
                fixed: e1 + 1,
                stretch: r
            }), _$n;
        }
        function ad(t, e1, r, n) {
            return t / e1 * r + n;
        }
        function od(t, e1, r, n) {
            return t - e1 * r / n;
        }
        ps("Anchor", Hf);
        var ld = function ld(t, e1, n, i, s, a, o, l, u, c) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, ld);
            var _$h;
            if (this.boxStartIndex = t.length, u) {
                var _$t = a.top, _$e = a.bottom;
                var _$r = a.collisionPadding;
                _$r && (_$t -= _$r[1], _$e += _$r[3]);
                var _$n = _$e - _$t;
                _$n > 0 && (_$n = Math.max(10, _$n), this.circleDiameter = _$n);
            } else {
                var _$u = (null === (_$h = a.image) || void 0 === _$h ? void 0 : _$h.content) && (a.image.textFitWidth || a.image.textFitHeight) ? eh(a) : {
                    x1: a.left,
                    y1: a.top,
                    x2: a.right,
                    y2: a.bottom
                };
                _$u.y1 = _$u.y1 * o - l[0], _$u.y2 = _$u.y2 * o + l[2], _$u.x1 = _$u.x1 * o - l[3], _$u.x2 = _$u.x2 * o + l[1];
                var p = a.collisionPadding;
                if (p && (_$u.x1 -= p[0] * o, _$u.y1 -= p[1] * o, _$u.x2 += p[2] * o, _$u.y2 += p[3] * o), c) {
                    var _$t1 = new r(_$u.x1, _$u.y1), _$e1 = new r(_$u.x2, _$u.y1), _$n1 = new r(_$u.x1, _$u.y2), _$i = new r(_$u.x2, _$u.y2), _$s = c * Math.PI / 180;
                    _$t1._rotate(_$s), _$e1._rotate(_$s), _$n1._rotate(_$s), _$i._rotate(_$s), _$u.x1 = Math.min(_$t1.x, _$e1.x, _$n1.x, _$i.x), _$u.x2 = Math.max(_$t1.x, _$e1.x, _$n1.x, _$i.x), _$u.y1 = Math.min(_$t1.y, _$e1.y, _$n1.y, _$i.y), _$u.y2 = Math.max(_$t1.y, _$e1.y, _$n1.y, _$i.y);
                }
                t.emplaceBack(e1.x, e1.y, _$u.x1, _$u.y1, _$u.x2, _$u.y2, n, i, s);
            }
            this.boxEndIndex = t.length;
        };
        var ud = /*#__PURE__*/ function() {
            function ud() {
                var _$t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(t, e1) {
                    return t < e1 ? -1 : t > e1 ? 1 : 0;
                };
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ud);
                if (this.data = _$t, this.length = this.data.length, this.compare = _$e, this.length > 0) for(var _$t1 = (this.length >> 1) - 1; _$t1 >= 0; _$t1--)this._down(_$t1);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ud, [
                {
                    key: "push",
                    value: function push(t) {
                        this.data.push(t), this._up(this.length++);
                    }
                },
                {
                    key: "pop",
                    value: function pop() {
                        if (0 === this.length) return;
                        var _$t = this.data[0], _$e = this.data.pop();
                        return --this.length > 0 && (this.data[0] = _$e, this._down(0)), _$t;
                    }
                },
                {
                    key: "peek",
                    value: function peek() {
                        return this.data[0];
                    }
                },
                {
                    key: "_up",
                    value: function _up(t) {
                        var _this = this, _$e = _this.data, _$r = _this.compare, _$n = _$e[t];
                        for(; t > 0;){
                            var i = t - 1 >> 1, s = _$e[i];
                            if (_$r(_$n, s) >= 0) break;
                            _$e[t] = s, t = i;
                        }
                        _$e[t] = _$n;
                    }
                },
                {
                    key: "_down",
                    value: function _down(t) {
                        var _this = this, _$e = _this.data, _$r = _this.compare, _$n = this.length >> 1, i = _$e[t];
                        for(; t < _$n;){
                            var _$n1 = 1 + (t << 1);
                            var s = _$n1 + 1;
                            if (s < this.length && _$r(_$e[s], _$e[_$n1]) < 0 && (_$n1 = s), _$r(_$e[_$n1], i) >= 0) break;
                            _$e[t] = _$e[_$n1], t = _$n1;
                        }
                        _$e[t] = i;
                    }
                }
            ]);
            return ud;
        }();
        function cd(t) {
            var _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, _$n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
            var i = jh.fromPoints(t[0]), s = Math.min(i.width(), i.height());
            var a = s / 2;
            var o = new ud([], hd), l = i.minX, u = i.minY, _$c = i.maxX, _$h = i.maxY;
            if (0 === s) return new r(l, u);
            for(var _$e1 = l; _$e1 < _$c; _$e1 += s)for(var _$r = u; _$r < _$h; _$r += s)o.push(new pd(_$e1 + a, _$r + a, a, t));
            var p = function(t) {
                var _$e = 0, _$r = 0, _$n = 0;
                var i = t[0];
                for(var _$t = 0, s = i.length, a = s - 1; _$t < s; a = _$t++){
                    var s1 = i[_$t], o = i[a], l = s1.x * o.y - o.x * s1.y;
                    _$r += (s1.x + o.x) * l, _$n += (s1.y + o.y) * l, _$e += 3 * l;
                }
                return new pd(_$r / _$e, _$n / _$e, 0, t);
            }(t), f = o.length;
            for(; o.length;){
                var _$r1 = o.pop();
                (_$r1.d > p.d || !p.d) && (p = _$r1, _$n && console.log("found best %d after %d probes", Math.round(1e4 * _$r1.d) / 1e4, f)), _$r1.max - p.d <= _$e || (a = _$r1.h / 2, o.push(new pd(_$r1.p.x - a, _$r1.p.y - a, a, t)), o.push(new pd(_$r1.p.x + a, _$r1.p.y - a, a, t)), o.push(new pd(_$r1.p.x - a, _$r1.p.y + a, a, t)), o.push(new pd(_$r1.p.x + a, _$r1.p.y + a, a, t)), f += 4);
            }
            return _$n && (console.log("num probes: ".concat(f)), console.log("best distance: ".concat(p.d))), p.p;
        }
        function hd(t, e1) {
            return e1.max - t.max;
        }
        function pd(t, e1, n, i) {
            this.p = new r(t, e1), this.h = n, this.d = function(t, e1) {
                var _$r = !1, _$n = 1 / 0;
                for(var _$i = 0; _$i < e1.length; _$i++){
                    var s = e1[_$i];
                    for(var _$e = 0, _$i1 = s.length, a = _$i1 - 1; _$e < _$i1; a = _$e++){
                        var _$i2 = s[_$e], o = s[a];
                        _$i2.y > t.y != o.y > t.y && t.x < (o.x - _$i2.x) * (t.y - _$i2.y) / (o.y - _$i2.y) + _$i2.x && (_$r = !_$r), _$n = Math.min(_$n, Jo(t, _$i2, o));
                    }
                }
                return (_$r ? 1 : -1) * Math.sqrt(_$n);
            }(this.p, i), this.max = this.d + this.h * Math.SQRT2;
        }
        var fd;
        t.aP = void 0, (fd = t.aP || (t.aP = {}))[fd.center = 1] = "center", fd[fd.left = 2] = "left", fd[fd.right = 3] = "right", fd[fd.top = 4] = "top", fd[fd.bottom = 5] = "bottom", fd[fd["top-left"] = 6] = "top-left", fd[fd["top-right"] = 7] = "top-right", fd[fd["bottom-left"] = 8] = "bottom-left", fd[fd["bottom-right"] = 9] = "bottom-right";
        var dd = Number.POSITIVE_INFINITY;
        function yd(t, e1) {
            return e1[1] !== dd ? function(t, e1, r) {
                var _$n = 0, i = 0;
                switch(e1 = Math.abs(e1), r = Math.abs(r), t){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        _$n = -e1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        _$n = e1;
                }
                return [
                    _$n,
                    i
                ];
            }(t, e1[0], e1[1]) : function(t, e1) {
                var _$r = 0, _$n = 0;
                e1 < 0 && (e1 = 0);
                var i = e1 / Math.SQRT2;
                switch(t){
                    case "top-right":
                    case "top-left":
                        _$n = i - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        _$n = 7 - i;
                        break;
                    case "bottom":
                        _$n = 7 - e1;
                        break;
                    case "top":
                        _$n = e1 - 7;
                }
                switch(t){
                    case "top-right":
                    case "bottom-right":
                        _$r = -i;
                        break;
                    case "top-left":
                    case "bottom-left":
                        _$r = i;
                        break;
                    case "left":
                        _$r = e1;
                        break;
                    case "right":
                        _$r = -e1;
                }
                return [
                    _$r,
                    _$n
                ];
            }(t, e1[0]);
        }
        function md(t, e1, r) {
            var _$n;
            var i = t.layout, s = null === (_$n = i.get("text-variable-anchor-offset")) || void 0 === _$n ? void 0 : _$n.evaluate(e1, {}, r);
            if (s) {
                var _$t = s.values, _$e = [];
                for(var _$r = 0; _$r < _$t.length; _$r += 2){
                    var _$n1 = _$e[_$r] = _$t[_$r], i1 = _$t[_$r + 1].map(function(t) {
                        return t * dc;
                    });
                    _$n1.startsWith("top") ? i1[1] -= 7 : _$n1.startsWith("bottom") && (i1[1] += 7), _$e[_$r + 1] = i1;
                }
                return new Le(_$e);
            }
            var a = i.get("text-variable-anchor");
            if (a) {
                var _$n2;
                _$n2 = void 0 !== t._unevaluatedLayout.getValue("text-radial-offset") ? [
                    i.get("text-radial-offset").evaluate(e1, {}, r) * dc,
                    dd
                ] : i.get("text-offset").evaluate(e1, {}, r).map(function(t) {
                    return t * dc;
                });
                var s1 = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t1 = _step.value;
                        s1.push(_$t1, yd(_$t1, _$n2));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return new Le(s1);
            }
            return null;
        }
        function gd(t) {
            switch(t){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function xd(e1, r, n, i, s, a, o, l, u, c, h, p) {
            var f = a.textMaxSize.evaluate(r, {});
            void 0 === f && (f = o);
            var _$d = e1.layers[0].layout, _$y = _$d.get("icon-offset").evaluate(r, {}, h), _$m = bd(n.horizontal), _$g = o / 24, _$x = e1.tilePixelRatio * _$g, _$v = e1.tilePixelRatio * f / 24, _$b = e1.tilePixelRatio * l, _$w = e1.tilePixelRatio * _$d.get("symbol-spacing"), _ = _$d.get("text-padding") * e1.tilePixelRatio, S = function(t, e1, r) {
                var _$n = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 1;
                var _$i = t.get("icon-padding").evaluate(e1, {}, r), s = _$i && _$i.values;
                return [
                    s[0] * _$n,
                    s[1] * _$n,
                    s[2] * _$n,
                    s[3] * _$n
                ];
            }(_$d, r, h, e1.tilePixelRatio), _$A = _$d.get("text-max-angle") / 180 * Math.PI, _$k = "viewport" !== _$d.get("text-rotation-alignment") && "point" !== _$d.get("symbol-placement"), _$E = "map" === _$d.get("icon-rotation-alignment") && "point" !== _$d.get("symbol-placement"), _$T = _$d.get("symbol-placement"), I = _$w / 2, _$F = _$d.get("icon-text-fit");
            var _$D;
            i && "none" !== _$F && (e1.allowVerticalPlacement && n.vertical && (_$D = rh(i, n.vertical, _$F, _$d.get("icon-text-fit-padding"), _$y, _$g)), _$m && (i = rh(i, _$m, _$F, _$d.get("icon-text-fit-padding"), _$y, _$g)));
            var _$z = h ? p.line.getGranularityForZoomLevel(h.z) : 1, _$P = function(l, p) {
                p.x < 0 || p.x >= M || p.y < 0 || p.y >= M || function(e1, r, n, i, s, a, o, l, u, c, h, p, f, d, y, m, g, x, v, b, w, _, S, A, k) {
                    var _$E = e1.addToLineVertexArray(r, n);
                    var _$T, I, M, _$F, _$D = 0, _$z = 0, _$P = 0, _$B = 0, V = -1, _$C = -1;
                    var _$L = {};
                    var _$O = mo("");
                    if (e1.allowVerticalPlacement && i.vertical) {
                        var _$t = l.layout.get("text-rotate").evaluate(w, {}, A) + 90;
                        M = new ld(u, r, c, h, p, i.vertical, f, d, y, _$t), o && (_$F = new ld(u, r, c, h, p, o, g, x, y, _$t));
                    }
                    if (s) {
                        var _$n = l.layout.get("icon-rotate").evaluate(w, {}), _$i = "none" !== l.layout.get("icon-text-fit"), _$a = nd(s, _$n, S, _$i), _$f = o ? nd(o, _$n, S, _$i) : void 0;
                        I = new ld(u, r, c, h, p, s, g, x, !1, _$n), _$D = 4 * _$a.length;
                        var _$d = e1.iconSizeData;
                        var _$y = null;
                        "source" === _$d.kind ? (_$y = [
                            nh * l.layout.get("icon-size").evaluate(w, {})
                        ], _$y[0] > ih && j("".concat(e1.layerIds[0], ': Value for "icon-size" is >= 255. Reduce your "icon-size".'))) : "composite" === _$d.kind && (_$y = [
                            nh * _.compositeIconSizes[0].evaluate(w, {}, A),
                            nh * _.compositeIconSizes[1].evaluate(w, {}, A)
                        ], (_$y[0] > ih || _$y[1] > ih) && j("".concat(e1.layerIds[0], ': Value for "icon-size" is >= 255. Reduce your "icon-size".'))), e1.addSymbols(e1.icon, _$a, _$y, b, v, w, t.az.none, r, _$E.lineStartIndex, _$E.lineLength, -1, A), V = e1.icon.placedSymbolArray.length - 1, _$f && (_$z = 4 * _$f.length, e1.addSymbols(e1.icon, _$f, _$y, b, v, w, t.az.vertical, r, _$E.lineStartIndex, _$E.lineLength, -1, A), _$C = e1.icon.placedSymbolArray.length - 1);
                    }
                    var R = Object.keys(i.horizontal);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = R[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$n1 = _step.value;
                            var _$s = i.horizontal[_$n1];
                            if (!_$T) {
                                _$O = mo(_$s.text);
                                var _$t1 = l.layout.get("text-rotate").evaluate(w, {}, A);
                                _$T = new ld(u, r, c, h, p, _$s, f, d, y, _$t1);
                            }
                            var _$o = 1 === _$s.positionedLines.length;
                            if (_$P += vd(e1, r, _$s, a, l, y, w, m, _$E, i.vertical ? t.az.horizontal : t.az.horizontalOnly, _$o ? R : [
                                _$n1
                            ], _$L, V, _, A), _$o) break;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    i.vertical && (_$B += vd(e1, r, i.vertical, a, l, y, w, m, _$E, t.az.vertical, [
                        "vertical"
                    ], _$L, _$C, _, A));
                    var _$N = _$T ? _$T.boxStartIndex : e1.collisionBoxArray.length, _$$ = _$T ? _$T.boxEndIndex : e1.collisionBoxArray.length, _$U = M ? M.boxStartIndex : e1.collisionBoxArray.length, q = M ? M.boxEndIndex : e1.collisionBoxArray.length, G = I ? I.boxStartIndex : e1.collisionBoxArray.length, _$X = I ? I.boxEndIndex : e1.collisionBoxArray.length, Y = _$F ? _$F.boxStartIndex : e1.collisionBoxArray.length, _$Z = _$F ? _$F.boxEndIndex : e1.collisionBoxArray.length;
                    var H = -1;
                    var _$K = function(t, e1) {
                        return t && t.circleDiameter ? Math.max(t.circleDiameter, e1) : e1;
                    };
                    H = _$K(_$T, H), H = _$K(M, H), H = _$K(I, H), H = _$K(_$F, H);
                    var W = H > -1 ? 1 : 0;
                    W && (H *= k / dc), e1.glyphOffsetArray.length >= fh.MAX_GLYPHS && j("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== w.sortKey && e1.addToSortKeyRanges(e1.symbolInstances.length, w.sortKey);
                    var J = md(l, w, A), _ref = (0, $db95b225ee8036d6$export$71511d61b312f219)(function(e1, r) {
                        var _$n = e1.length, _$i = null == r ? void 0 : r.values;
                        if ((null == _$i ? void 0 : _$i.length) > 0) for(var _$r = 0; _$r < _$i.length; _$r += 2){
                            var _$n1 = _$i[_$r + 1];
                            e1.emplaceBack(t.aP[_$i[_$r]], _$n1[0], _$n1[1]);
                        }
                        return [
                            _$n,
                            e1.length
                        ];
                    }(e1.textAnchorOffsets, J), 2), _$Q = _ref[0], _$tt = _ref[1];
                    e1.symbolInstances.emplaceBack(r.x, r.y, _$L.right >= 0 ? _$L.right : -1, _$L.center >= 0 ? _$L.center : -1, _$L.left >= 0 ? _$L.left : -1, _$L.vertical || -1, V, _$C, _$O, _$N, _$$, _$U, q, G, _$X, Y, _$Z, c, _$P, _$B, _$D, _$z, W, 0, f, H, _$Q, _$tt);
                }(e1, p, l, n, i, s, _$D, e1.layers[0], e1.collisionBoxArray, r.index, r.sourceLayerIndex, e1.index, _$x, [
                    _,
                    _,
                    _,
                    _
                ], _$k, u, _$b, S, _$E, _$y, r, a, c, h, o);
            };
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined, _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined, _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined, _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
            if ("line" === _$T) try {
                for(var _iterator = qf(r.geometry, 0, 0, M, M)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$t = _step.value;
                    var _$r = gu(_$t, _$z), s1 = ed(_$r, _$w, _$A, n.vertical || _$m, i, 24, _$v, e1.overscaling, M);
                    var _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                    try {
                        for(var _iterator1 = s1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion5 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion5 = true){
                            var _$t1 = _step1.value;
                            _$m && wd(e1, _$m.text, I, _$t1) || _$P(_$r, _$t1);
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else if ("line-center" === _$T) {
                var _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
                try {
                    for(var _iterator2 = r.geometry[Symbol.iterator](), _step2; !(_iteratorNormalCompletion6 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion6 = true){
                        var _$t2 = _step2.value;
                        if (_$t2.length > 1) {
                            var _$e = gu(_$t2, _$z), _$r1 = td(_$e, _$A, n.vertical || _$m, i, 24, _$v);
                            _$r1 && _$P(_$e, _$r1);
                        }
                    }
                } catch (err) {
                    _didIteratorError6 = true;
                    _iteratorError6 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion6 && _iterator2.return != null) {
                            _iterator2.return();
                        }
                    } finally{
                        if (_didIteratorError6) {
                            throw _iteratorError6;
                        }
                    }
                }
            } else if ("Polygon" === r.type) try {
                for(var _iterator3 = tn(r.geometry, 0)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion1 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion1 = true){
                    var _$t3 = _step3.value;
                    var _$e1 = cd(_$t3, 16);
                    _$P(gu(_$t3[0], _$z, !0), new Hf(_$e1.x, _$e1.y, 0));
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator3.return != null) {
                        _iterator3.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            else if ("LineString" === r.type) try {
                for(var _iterator4 = r.geometry[Symbol.iterator](), _step4; !(_iteratorNormalCompletion2 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion2 = true){
                    var _$t4 = _step4.value;
                    var _$e2 = gu(_$t4, _$z);
                    _$P(_$e2, new Hf(_$e2[0].x, _$e2[0].y, 0));
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator4.return != null) {
                        _iterator4.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            else if ("Point" === r.type) try {
                for(var _iterator5 = r.geometry[Symbol.iterator](), _step5; !(_iteratorNormalCompletion4 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion4 = true){
                    var _$t5 = _step5.value;
                    try {
                        for(var _iterator6 = _$t5[Symbol.iterator](), _step6; !(_iteratorNormalCompletion3 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion3 = true){
                            var _$e3 = _step6.value;
                            _$P([
                                _$e3
                            ], new Hf(_$e3.x, _$e3.y, 0));
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator6.return != null) {
                                _iterator6.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion4 && _iterator5.return != null) {
                        _iterator5.return();
                    }
                } finally{
                    if (_didIteratorError4) {
                        throw _iteratorError4;
                    }
                }
            }
        }
        function vd(t, e1, n, i, s, a, o, l, u, c, h, p, f, d, y) {
            var _$m = function(t, e1, n, i, s, a, o, l) {
                var _$u = i.layout.get("text-rotate").evaluate(a, {}) * Math.PI / 180, _$c = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = e1.positionedLines[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var _$t = _step.value;
                        try {
                            for(var _iterator1 = _$t.positionedGlyphs[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var _$i = _step1.value;
                                if (!_$i.rect) continue;
                                var _$a = _$i.rect || {};
                                var _$h = 4, _$p = !0, _$f = 1, _$d = 0;
                                var _$y = (s || l) && _$i.vertical, _$m = _$i.metrics.advance * _$i.scale / 2;
                                if (l && e1.verticalizable && (_$d = _$t.lineOffset / 2 - (_$i.imageName ? -(dc - _$i.metrics.width * _$i.scale) / 2 : (_$i.scale - 1) * dc)), _$i.imageName) {
                                    var _$t1 = o[_$i.imageName];
                                    _$p = _$t1.sdf, _$f = _$t1.pixelRatio, _$h = 1 / _$f;
                                }
                                var _$g = s ? [
                                    _$i.x + _$m,
                                    _$i.y
                                ] : [
                                    0,
                                    0
                                ];
                                var _$x = s ? [
                                    0,
                                    0
                                ] : [
                                    _$i.x + _$m + n[0],
                                    _$i.y + n[1] - _$d
                                ], _$v = [
                                    0,
                                    0
                                ];
                                _$y && (_$v = _$x, _$x = [
                                    0,
                                    0
                                ]);
                                var _$b = _$i.metrics.isDoubleResolution ? 2 : 1, _$w = (_$i.metrics.left - _$h) * _$i.scale - _$m + _$x[0], _ = (-_$i.metrics.top - _$h) * _$i.scale + _$x[1], S = _$w + _$a.w / _$b * _$i.scale / _$f, _$A = _ + _$a.h / _$b * _$i.scale / _$f, _$k = new r(_$w, _), _$E = new r(S, _), _$T = new r(_$w, _$A), I = new r(S, _$A);
                                if (_$y) {
                                    var _$t2 = new r(-_$m, _$m - -17), _$e = -Math.PI / 2, _$n = 12 - _$m, _$s = new r(22 - _$n, -(_$i.imageName ? _$n : 0)), _$a1 = (0, $1b84e43f64f42d09$export$71511d61b312f219)(r, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$v));
                                    _$k._rotateAround(_$e, _$t2)._add(_$s)._add(_$a1), _$E._rotateAround(_$e, _$t2)._add(_$s)._add(_$a1), _$T._rotateAround(_$e, _$t2)._add(_$s)._add(_$a1), I._rotateAround(_$e, _$t2)._add(_$s)._add(_$a1);
                                }
                                if (_$u) {
                                    var _$t3 = Math.sin(_$u), _$e1 = Math.cos(_$u), _$r = [
                                        _$e1,
                                        -_$t3,
                                        _$t3,
                                        _$e1
                                    ];
                                    _$k._matMult(_$r), _$E._matMult(_$r), _$T._matMult(_$r), I._matMult(_$r);
                                }
                                var M = new r(0, 0), _$F = new r(0, 0);
                                _$c.push({
                                    tl: _$k,
                                    tr: _$E,
                                    bl: _$T,
                                    br: I,
                                    tex: _$a,
                                    writingMode: e1.writingMode,
                                    glyphOffset: _$g,
                                    sectionIndex: _$i.sectionIndex,
                                    isSDF: _$p,
                                    pixelOffsetTL: M,
                                    pixelOffsetBR: _$F,
                                    minFontScaleX: 0,
                                    minFontScaleY: 0
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return _$c;
            }(0, n, l, s, a, o, i, t.allowVerticalPlacement), _$g = t.textSizeData;
            var _$x = null;
            "source" === _$g.kind ? (_$x = [
                nh * s.layout.get("text-size").evaluate(o, {})
            ], _$x[0] > ih && j("".concat(t.layerIds[0], ': Value for "text-size" is >= 255. Reduce your "text-size".'))) : "composite" === _$g.kind && (_$x = [
                nh * d.compositeTextSizes[0].evaluate(o, {}, y),
                nh * d.compositeTextSizes[1].evaluate(o, {}, y)
            ], (_$x[0] > ih || _$x[1] > ih) && j("".concat(t.layerIds[0], ': Value for "text-size" is >= 255. Reduce your "text-size".'))), t.addSymbols(t.text, _$m, _$x, l, a, o, c, e1, u.lineStartIndex, u.lineLength, f, y);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = h[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e = _step.value;
                    p[_$e] = t.text.placedSymbolArray.length - 1;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return 4 * _$m.length;
        }
        function bd(t) {
            for(var _$e in t)return t[_$e];
            return null;
        }
        function wd(t, e1, r, n) {
            var i = t.compareText;
            if (e1 in i) {
                var _$t = i[e1];
                for(var _$e = _$t.length - 1; _$e >= 0; _$e--)if (n.dist(_$t[_$e]) < r) return !0;
            } else i[e1] = [];
            return i[e1].push(n), !1;
        }
        var _d = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        var Sd = /*#__PURE__*/ function() {
            function Sd(t) {
                var _$e = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 64, _$r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : Float64Array, _$n = arguments.length > 3 ? arguments[3] : void 0;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Sd);
                if (isNaN(t) || t < 0) throw new Error("Unpexpected numItems value: ".concat(t, "."));
                this.numItems = +t, this.nodeSize = Math.min(Math.max(+_$e, 2), 65535), this.ArrayType = _$r, this.IndexArrayType = t < 65536 ? Uint16Array : Uint32Array;
                var i = _d.indexOf(this.ArrayType), s = 2 * t * this.ArrayType.BYTES_PER_ELEMENT, a = t * this.IndexArrayType.BYTES_PER_ELEMENT, o = (8 - a % 8) % 8;
                if (i < 0) throw new Error("Unexpected typed array class: ".concat(_$r, "."));
                _$n && _$n instanceof ArrayBuffer ? (this.data = _$n, this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * t), this._pos = 2 * t, this._finished = !0) : (this.data = new ArrayBuffer(8 + s + a + o), this.ids = new this.IndexArrayType(this.data, 8, t), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * t), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = _$e, new Uint32Array(this.data, 4, 1)[0] = t);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Sd, [
                {
                    key: "add",
                    value: function add(t, e1) {
                        var _$r = this._pos >> 1;
                        return this.ids[_$r] = _$r, this.coords[this._pos++] = t, this.coords[this._pos++] = e1, _$r;
                    }
                },
                {
                    key: "finish",
                    value: function finish() {
                        var _$t = this._pos >> 1;
                        if (_$t !== this.numItems) throw new Error("Added ".concat(_$t, " items when expected ").concat(this.numItems, "."));
                        return Ad(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
                    }
                },
                {
                    key: "range",
                    value: function range(t, e1, r, n) {
                        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                        var _this = this, i = _this.ids, s = _this.coords, a = _this.nodeSize, o = [
                            0,
                            i.length - 1,
                            0
                        ], l = [];
                        for(; o.length;){
                            var u = o.pop() || 0, _$c = o.pop() || 0, _$h = o.pop() || 0;
                            if (_$c - _$h <= a) {
                                for(var a1 = _$h; a1 <= _$c; a1++){
                                    var o1 = s[2 * a1], u1 = s[2 * a1 + 1];
                                    o1 >= t && o1 <= r && u1 >= e1 && u1 <= n && l.push(i[a1]);
                                }
                                continue;
                            }
                            var p = _$h + _$c >> 1, f = s[2 * p], _$d = s[2 * p + 1];
                            f >= t && f <= r && _$d >= e1 && _$d <= n && l.push(i[p]), (0 === u ? t <= f : e1 <= _$d) && (o.push(_$h), o.push(p - 1), o.push(1 - u)), (0 === u ? r >= f : n >= _$d) && (o.push(p + 1), o.push(_$c), o.push(1 - u));
                        }
                        return l;
                    }
                },
                {
                    key: "within",
                    value: function within(t, e1, r) {
                        if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                        var _this = this, _$n = _this.ids, i = _this.coords, s = _this.nodeSize, a = [
                            0,
                            _$n.length - 1,
                            0
                        ], o = [], l = r * r;
                        for(; a.length;){
                            var u = a.pop() || 0, _$c = a.pop() || 0, _$h = a.pop() || 0;
                            if (_$c - _$h <= s) {
                                for(var _$r = _$h; _$r <= _$c; _$r++)Id(i[2 * _$r], i[2 * _$r + 1], t, e1) <= l && o.push(_$n[_$r]);
                                continue;
                            }
                            var p = _$h + _$c >> 1, f = i[2 * p], _$d = i[2 * p + 1];
                            Id(f, _$d, t, e1) <= l && o.push(_$n[p]), (0 === u ? t - r <= f : e1 - r <= _$d) && (a.push(_$h), a.push(p - 1), a.push(1 - u)), (0 === u ? t + r >= f : e1 + r >= _$d) && (a.push(p + 1), a.push(_$c), a.push(1 - u));
                        }
                        return o;
                    }
                }
            ], [
                {
                    key: "from",
                    value: function from(t) {
                        if (!(t instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                        var _ref = (0, $db95b225ee8036d6$export$71511d61b312f219)(new Uint8Array(t, 0, 2), 2), _$e = _ref[0], _$r = _ref[1];
                        if (219 !== _$e) throw new Error("Data does not appear to be in a KDBush format.");
                        var _$n = _$r >> 4;
                        if (1 !== _$n) throw new Error("Got v".concat(_$n, " data when expected v1."));
                        var i = _d[15 & _$r];
                        if (!i) throw new Error("Unrecognized array type.");
                        var _ref1 = (0, $db95b225ee8036d6$export$71511d61b312f219)(new Uint16Array(t, 2, 1), 1), s = _ref1[0], _ref2 = (0, $db95b225ee8036d6$export$71511d61b312f219)(new Uint32Array(t, 4, 1), 1), a = _ref2[0];
                        return new Sd(a, s, i, t);
                    }
                }
            ]);
            return Sd;
        }();
        function Ad(t, e1, r, n, i, s) {
            if (i - n <= r) return;
            var a = n + i >> 1;
            kd(t, e1, a, n, i, s), Ad(t, e1, r, n, a - 1, 1 - s), Ad(t, e1, r, a + 1, i, 1 - s);
        }
        function kd(t, e1, r, n, i, s) {
            for(; i > n;){
                if (i - n > 600) {
                    var a = i - n + 1, o = r - n + 1, l = Math.log(a), u = .5 * Math.exp(2 * l / 3), _$c = .5 * Math.sqrt(l * u * (a - u) / a) * (o - a / 2 < 0 ? -1 : 1);
                    kd(t, e1, r, Math.max(n, Math.floor(r - o * u / a + _$c)), Math.min(i, Math.floor(r + (a - o) * u / a + _$c)), s);
                }
                var a1 = e1[2 * r + s];
                var o1 = n, l1 = i;
                for(Ed(t, e1, n, r), e1[2 * i + s] > a1 && Ed(t, e1, n, i); o1 < l1;){
                    for(Ed(t, e1, o1, l1), o1++, l1--; e1[2 * o1 + s] < a1;)o1++;
                    for(; e1[2 * l1 + s] > a1;)l1--;
                }
                e1[2 * n + s] === a1 ? Ed(t, e1, n, l1) : (l1++, Ed(t, e1, l1, i)), l1 <= r && (n = l1 + 1), r <= l1 && (i = l1 - 1);
            }
        }
        function Ed(t, e1, r, n) {
            Td(t, r, n), Td(e1, 2 * r, 2 * n), Td(e1, 2 * r + 1, 2 * n + 1);
        }
        function Td(t, e1, r) {
            var _$n = t[e1];
            t[e1] = t[r], t[r] = _$n;
        }
        function Id(t, e1, r, n) {
            var i = t - r, s = e1 - n;
            return i * i + s * s;
        }
        var Md;
        t.cH = void 0, (Md = t.cH || (t.cH = {})).create = "create", Md.load = "load", Md.fullLoad = "fullLoad";
        var Fd = null, Dd = [];
        var zd = 1e3 / 60, Pd = "loadTime", Bd = "fullLoadTime", Vd = {
            mark: function(t) {
                performance.mark(t);
            },
            frame: function(t) {
                var _$e = t;
                null != Fd && Dd.push(_$e - Fd), Fd = _$e;
            },
            clearMetrics: function() {
                Fd = null, Dd = [], performance.clearMeasures(Pd), performance.clearMeasures(Bd);
                for(var _$e in t.cH)performance.clearMarks(t.cH[_$e]);
            },
            getPerformanceMetrics: function() {
                performance.measure(Pd, t.cH.create, t.cH.load), performance.measure(Bd, t.cH.create, t.cH.fullLoad);
                var _$e = performance.getEntriesByName(Pd)[0].duration, _$r = performance.getEntriesByName(Bd)[0].duration, _$n = Dd.length, i = 1 / (Dd.reduce(function(t, e1) {
                    return t + e1;
                }, 0) / _$n / 1e3), s = Dd.filter(function(t) {
                    return t > zd;
                }).reduce(function(t, e1) {
                    return t + (e1 - zd) / zd;
                }, 0);
                return {
                    loadTime: _$e,
                    fullLoadTime: _$r,
                    fps: i,
                    percentDroppedFrames: s / (_$n + s) * 100,
                    totalFrames: _$n
                };
            }
        };
        t.$ = c, t.A = f, t.B = us, t.C = is, t.D = js, t.E = xt, t.F = function(param) {
            var _param = (0, $db95b225ee8036d6$export$71511d61b312f219)(param, 3), _$t = _param[0], _$e = _param[1], _$r = _param[2];
            return _$e += 90, _$e *= Math.PI / 180, _$r *= Math.PI / 180, {
                x: _$t * Math.cos(_$e) * Math.sin(_$r),
                y: _$t * Math.sin(_$e) * Math.sin(_$r),
                z: _$t * Math.cos(_$r)
            };
        }, t.G = yr, t.H = Ps, t.I = qc, t.J = as, t.K = function(t) {
            if (null == Y) {
                var _$e = t.navigator ? t.navigator.userAgent : null;
                Y = !!t.safari || !(!_$e || !(/\b(iPad|iPhone|iPod)\b/.test(_$e) || _$e.match("Safari") && !_$e.match("Chrome")));
            }
            return Y;
        }, t.L = /*#__PURE__*/ function() {
            function _class(t, e1) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this.target = t, this.mapId = e1, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new Sh(function() {
                    return _this.process();
                }), this.subscription = Q(this.target, "message", function(t) {
                    return _this.receive(t);
                }, !1), this.globalScope = X(self) ? t : window;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "registerMessageHandler",
                    value: function registerMessageHandler(t, e1) {
                        this.messageHandlers[t] = e1;
                    }
                },
                {
                    key: "unregisterMessageHandler",
                    value: function unregisterMessageHandler(t) {
                        delete this.messageHandlers[t];
                    }
                },
                {
                    key: "sendAsync",
                    value: function sendAsync(t, e1) {
                        var _this = this;
                        return new Promise(function(r, n) {
                            var i = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), s = e1 ? Q(e1.signal, "abort", function() {
                                null == s || s.unsubscribe(), delete _this.resolveRejects[i];
                                var _$e = {
                                    id: i,
                                    type: "<cancel>",
                                    origin: location.origin,
                                    targetMapId: t.targetMapId,
                                    sourceMapId: _this.mapId
                                };
                                _this.target.postMessage(_$e);
                            }, Ah) : null;
                            _this.resolveRejects[i] = {
                                resolve: function(t) {
                                    null == s || s.unsubscribe(), r(t);
                                },
                                reject: function(t) {
                                    null == s || s.unsubscribe(), n(t);
                                }
                            };
                            var a = [], o = Object.assign(Object.assign({}, t), {
                                id: i,
                                sourceMapId: _this.mapId,
                                origin: location.origin,
                                data: ms(t.data, a)
                            });
                            _this.target.postMessage(o, {
                                transfer: a
                            });
                        });
                    }
                },
                {
                    key: "receive",
                    value: function receive(t) {
                        var _$e = t.data, _$r = _$e.id;
                        if (!("file://" !== _$e.origin && "file://" !== location.origin && "resource://android" !== _$e.origin && "resource://android" !== location.origin && _$e.origin !== location.origin || _$e.targetMapId && this.mapId !== _$e.targetMapId)) {
                            if ("<cancel>" === _$e.type) {
                                delete this.tasks[_$r];
                                var _$t = this.abortControllers[_$r];
                                return delete this.abortControllers[_$r], void (_$t && _$t.abort());
                            }
                            if (X(self) || _$e.mustQueue) return this.tasks[_$r] = _$e, this.taskQueue.push(_$r), void this.invoker.trigger();
                            this.processTask(_$r, _$e);
                        }
                    }
                },
                {
                    key: "process",
                    value: function process() {
                        if (0 === this.taskQueue.length) return;
                        var _$t = this.taskQueue.shift(), _$e = this.tasks[_$t];
                        delete this.tasks[_$t], this.taskQueue.length > 0 && this.invoker.trigger(), _$e && this.processTask(_$t, _$e);
                    }
                },
                {
                    key: "processTask",
                    value: function processTask(t, r) {
                        return e1(this, void 0, void 0, function() {
                            var _$e, _$e1, _$n, i, e1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if ("<response>" === r.type) {
                                            _$e = this.resolveRejects[t];
                                            if (delete this.resolveRejects[t], !_$e) return [
                                                2
                                            ];
                                            return [
                                                2,
                                                void (r.error ? _$e.reject(gs(r.error)) : _$e.resolve(gs(r.data)))
                                            ];
                                        }
                                        if (!this.messageHandlers[r.type]) return [
                                            2,
                                            void this.completeTask(t, new Error("Could not find a registered handler for ".concat(r.type, ", map ID: ").concat(this.mapId, ", available handlers: ").concat(Object.keys(this.messageHandlers).join(", "))))
                                        ];
                                        _$e1 = gs(r.data), _$n = new AbortController;
                                        this.abortControllers[t] = _$n;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            this.messageHandlers[r.type](r.sourceMapId, _$e1, _$n)
                                        ];
                                    case 2:
                                        i = _state.sent();
                                        this.completeTask(t, null, i);
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        e1 = _state.sent();
                                        this.completeTask(t, e1);
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "completeTask",
                    value: function completeTask(t, e1, r) {
                        var _$n = [];
                        delete this.abortControllers[t];
                        var i = {
                            id: t,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            origin: location.origin,
                            error: e1 ? ms(e1) : null,
                            data: ms(r, _$n)
                        };
                        this.target.postMessage(i, {
                            transfer: _$n
                        });
                    }
                },
                {
                    key: "remove",
                    value: function remove() {
                        this.invoker.remove(), this.subscription.unsubscribe();
                    }
                }
            ]);
            return _class;
        }(), t.M = ut, t.N = function() {
            var _$t = new f(16);
            return f != Float32Array && (_$t[1] = 0, _$t[2] = 0, _$t[3] = 0, _$t[4] = 0, _$t[6] = 0, _$t[7] = 0, _$t[8] = 0, _$t[9] = 0, _$t[11] = 0, _$t[12] = 0, _$t[13] = 0, _$t[14] = 0), _$t[0] = 1, _$t[5] = 1, _$t[10] = 1, _$t[15] = 1, _$t;
        }, t.O = function(t, e1, r) {
            var _$n, i, s, a, o, l, u, _$c, _$h, p, f, _$d, _$y = r[0], _$m = r[1], _$g = r[2];
            return e1 === t ? (t[12] = e1[0] * _$y + e1[4] * _$m + e1[8] * _$g + e1[12], t[13] = e1[1] * _$y + e1[5] * _$m + e1[9] * _$g + e1[13], t[14] = e1[2] * _$y + e1[6] * _$m + e1[10] * _$g + e1[14], t[15] = e1[3] * _$y + e1[7] * _$m + e1[11] * _$g + e1[15]) : (i = e1[1], s = e1[2], a = e1[3], o = e1[4], l = e1[5], u = e1[6], _$c = e1[7], _$h = e1[8], p = e1[9], f = e1[10], _$d = e1[11], t[0] = _$n = e1[0], t[1] = i, t[2] = s, t[3] = a, t[4] = o, t[5] = l, t[6] = u, t[7] = _$c, t[8] = _$h, t[9] = p, t[10] = f, t[11] = _$d, t[12] = _$n * _$y + o * _$m + _$h * _$g + e1[12], t[13] = i * _$y + l * _$m + p * _$g + e1[13], t[14] = s * _$y + u * _$m + f * _$g + e1[14], t[15] = a * _$y + _$c * _$m + _$d * _$g + e1[15]), t;
        }, t.P = r, t.Q = function(t, e1, r) {
            var _$n = r[0], i = r[1], s = r[2];
            return t[0] = e1[0] * _$n, t[1] = e1[1] * _$n, t[2] = e1[2] * _$n, t[3] = e1[3] * _$n, t[4] = e1[4] * i, t[5] = e1[5] * i, t[6] = e1[6] * i, t[7] = e1[7] * i, t[8] = e1[8] * s, t[9] = e1[9] * s, t[10] = e1[10] * s, t[11] = e1[11] * s, t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15], t;
        }, t.R = Sl, t.S = function(t, e1, r) {
            var _$n = e1[0], i = e1[1], s = e1[2], a = e1[3], o = e1[4], l = e1[5], u = e1[6], _$c = e1[7], _$h = e1[8], p = e1[9], f = e1[10], _$d = e1[11], _$y = e1[12], _$m = e1[13], _$g = e1[14], _$x = e1[15], _$v = r[0], _$b = r[1], _$w = r[2], _ = r[3];
            return t[0] = _$v * _$n + _$b * o + _$w * _$h + _ * _$y, t[1] = _$v * i + _$b * l + _$w * p + _ * _$m, t[2] = _$v * s + _$b * u + _$w * f + _ * _$g, t[3] = _$v * a + _$b * _$c + _$w * _$d + _ * _$x, t[4] = (_$v = r[4]) * _$n + (_$b = r[5]) * o + (_$w = r[6]) * _$h + (_ = r[7]) * _$y, t[5] = _$v * i + _$b * l + _$w * p + _ * _$m, t[6] = _$v * s + _$b * u + _$w * f + _ * _$g, t[7] = _$v * a + _$b * _$c + _$w * _$d + _ * _$x, t[8] = (_$v = r[8]) * _$n + (_$b = r[9]) * o + (_$w = r[10]) * _$h + (_ = r[11]) * _$y, t[9] = _$v * i + _$b * l + _$w * p + _ * _$m, t[10] = _$v * s + _$b * u + _$w * f + _ * _$g, t[11] = _$v * a + _$b * _$c + _$w * _$d + _ * _$x, t[12] = (_$v = r[12]) * _$n + (_$b = r[13]) * o + (_$w = r[14]) * _$h + (_ = r[15]) * _$y, t[13] = _$v * i + _$b * l + _$w * p + _ * _$m, t[14] = _$v * s + _$b * u + _$w * f + _ * _$g, t[15] = _$v * a + _$b * _$c + _$w * _$d + _ * _$x, t;
        }, t.T = zl, t.U = function(t, e1) {
            var _$r = {};
            for(var _$n = 0; _$n < e1.length; _$n++){
                var i = e1[_$n];
                i in t && (_$r[i] = t[i]);
            }
            return _$r;
        }, t.V = Eh, t.W = L, t.X = Fh, t.Y = Mh, t.Z = at, t._ = e1, t.a = st, t.a$ = b, t.a0 = h, t.a1 = K, t.a2 = Rh, t.a3 = zh, t.a4 = Ph, t.a5 = M, t.a6 = function(t, e1, r) {
            if (!t) return e1 || {};
            if (!e1) return t || {};
            var _$n = qh(t), i = qh(e1);
            !function(t, e1) {
                e1.removeAll && (t.add.clear(), t.update.clear(), t.remove.clear(), e1.remove.clear());
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e1.remove[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$r = _step.value;
                        t.add.delete(_$r), t.update.delete(_$r);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = e1.update[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step1.value, 2), _$r1 = _step_value[0], _$n = _step_value[1];
                        var i = t.update.get(_$r1);
                        i && (e1.update.set(_$r1, Uh(i, _$n)), t.update.delete(_$r1));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }(_$n, i);
            var s = {};
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if ((_$n.removeAll || i.removeAll) && (s.removeAll = !0), s.remove = new Set((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$n.remove).concat((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(i.remove))), s.add = new Map((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$n.add).concat((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(i.add))), s.update = new Map((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$n.update).concat((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(i.update))), s.remove.size && s.add.size) try {
                for(var _iterator = s.add.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$t = _step.value;
                    s.remove.delete(_$t);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return function(t) {
                var _$e = {};
                return t.removeAll && (_$e.removeAll = t.removeAll), t.remove && (_$e.remove = Array.from(t.remove)), t.add && (_$e.add = Array.from(t.add.values())), t.update && (_$e.update = Array.from(t.update.values())), _$e;
            }(s);
        }, t.a7 = function(t, e1) {
            var _$r = new Map;
            if (null == t) return _$r;
            if (null == t.type) return _$r;
            if ("Feature" === t.type) {
                var _$n = $h(t, e1);
                if (null == _$n) return;
                return _$r.set(_$n, t), _$r;
            }
            if ("FeatureCollection" === t.type) {
                var _$n1 = new Set;
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t.features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var i = _step.value;
                        var _$t = $h(i, e1);
                        if (null == _$t) return;
                        if (_$n1.has(_$t)) return;
                        _$n1.add(_$t), _$r.set(_$t, i);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return _$r;
            }
        }, t.a8 = function(t, e1, r) {
            var _$n, i;
            var s = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (e1.removeAll) t.clear();
            else if (e1.remove) try {
                for(var _iterator = e1.remove[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$r = _step.value;
                    var _$e = t.get(_$r);
                    _$e && (s.push(_$e.geometry), t.delete(_$r));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (e1.add) try {
                for(var _iterator1 = e1.add[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _$n1 = _step1.value;
                    var _$e1 = $h(_$n1, r);
                    if (null == _$e1) continue;
                    var i1 = t.get(_$e1);
                    i1 && s.push(i1.geometry), s.push(_$n1.geometry), t.set(_$e1, _$n1);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
            if (e1.update) try {
                for(var _iterator2 = e1.update[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                    var _$r1 = _step2.value;
                    var _$e2 = t.get(_$r1.id);
                    if (!_$e2) continue;
                    var a = !!_$r1.newGeometry, o = _$r1.removeAllProperties || (null === (_$n = _$r1.removeProperties) || void 0 === _$n ? void 0 : _$n.length) > 0 || (null === (i = _$r1.addOrUpdateProperties) || void 0 === i ? void 0 : i.length) > 0;
                    if (!a && !o) continue;
                    s.push(_$e2.geometry);
                    var l = Object.assign({}, _$e2);
                    if (t.set(_$r1.id, l), a && (s.push(_$r1.newGeometry), l.geometry = _$r1.newGeometry), o) {
                        var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                        if (l.properties = _$r1.removeAllProperties ? {} : Object.assign({}, l.properties || {}), _$r1.removeProperties) try {
                            for(var _iterator3 = _$r1.removeProperties[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                var _$t = _step3.value;
                                delete l.properties[_$t];
                            }
                        } catch (err) {
                            _didIteratorError3 = true;
                            _iteratorError3 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                    _iterator3.return();
                                }
                            } finally{
                                if (_didIteratorError3) {
                                    throw _iteratorError3;
                                }
                            }
                        }
                        var _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                        if (_$r1.addOrUpdateProperties) try {
                            for(var _iterator4 = _$r1.addOrUpdateProperties[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                var _step_value = _step4.value, _$t1 = _step_value.key, _$e3 = _step_value.value;
                                l.properties[_$t1] = _$e3;
                            }
                        } catch (err) {
                            _didIteratorError4 = true;
                            _iteratorError4 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                    _iterator4.return();
                                }
                            } finally{
                                if (_didIteratorError4) {
                                    throw _iteratorError4;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                        _iterator2.return();
                    }
                } finally{
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }
            return s;
        }, t.a9 = Vh, t.aA = function(t, param, param1) {
            var _$e = param.uSize, _$r = param.uSizeT, _$n = param1.lowerSize, i = param1.upperSize;
            return "source" === t.kind ? _$n / nh : "composite" === t.kind ? yr.number(_$n / nh, i / nh, _$r) : _$e;
        }, t.aB = function(t, e1) {
            var _$r = e1[0], _$n = e1[1], i = e1[2], s = e1[3], a = e1[4], o = e1[5], l = e1[6], u = e1[7], _$c = e1[8], _$h = e1[9], p = e1[10], f = e1[11], _$d = e1[12], _$y = e1[13], _$m = e1[14], _$g = e1[15], _$x = _$r * o - _$n * a, _$v = _$r * l - i * a, _$b = _$r * u - s * a, _$w = _$n * l - i * o, _ = _$n * u - s * o, S = i * u - s * l, _$A = _$c * _$y - _$h * _$d, _$k = _$c * _$m - p * _$d, _$E = _$c * _$g - f * _$d, _$T = _$h * _$m - p * _$y, I = _$h * _$g - f * _$y, M = p * _$g - f * _$m, _$F = _$x * M - _$v * I + _$b * _$T + _$w * _$E - _ * _$k + S * _$A;
            return _$F ? (t[0] = (o * M - l * I + u * _$T) * (_$F = 1 / _$F), t[1] = (i * I - _$n * M - s * _$T) * _$F, t[2] = (_$y * S - _$m * _ + _$g * _$w) * _$F, t[3] = (p * _ - _$h * S - f * _$w) * _$F, t[4] = (l * _$E - a * M - u * _$k) * _$F, t[5] = (_$r * M - i * _$E + s * _$k) * _$F, t[6] = (_$m * _$b - _$d * S - _$g * _$v) * _$F, t[7] = (_$c * S - p * _$b + f * _$v) * _$F, t[8] = (a * I - o * _$E + u * _$A) * _$F, t[9] = (_$n * _$E - _$r * I - s * _$A) * _$F, t[10] = (_$d * _ - _$y * _$b + _$g * _$x) * _$F, t[11] = (_$h * _$b - _$c * _ - f * _$x) * _$F, t[12] = (o * _$k - a * _$T - l * _$A) * _$F, t[13] = (_$r * _$T - _$n * _$k + i * _$A) * _$F, t[14] = (_$y * _$v - _$d * _$w - _$m * _$x) * _$F, t[15] = (_$c * _$w - _$h * _$v + p * _$x) * _$F, t) : null;
        }, t.aC = T, t.aD = function(t) {
            var _$e = t[0], _$r = t[1];
            return Math.sqrt(_$e * _$e + _$r * _$r);
        }, t.aE = function(t) {
            return t[0] = 0, t[1] = 0, t;
        }, t.aF = function(t, e1, r) {
            return t[0] = e1[0] * r, t[1] = e1[1] * r, t;
        }, t.aG = uh, t.aH = A, t.aI = function(t, e1, n, i) {
            var s = e1.y - t.y, a = e1.x - t.x, o = i.y - n.y, l = i.x - n.x, u = o * a - l * s;
            if (0 === u) return null;
            var _$c = (l * (t.y - n.y) - o * (t.x - n.x)) / u;
            return new r(t.x + _$c * a, t.y + _$c * s);
        }, t.aJ = qf, t.aK = Go, t.aL = function(t) {
            var _$e = 1 / 0, _$r = 1 / 0, _$n = -1 / 0, i = -1 / 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var s = _step.value;
                    _$e = Math.min(_$e, s.x), _$r = Math.min(_$r, s.y), _$n = Math.max(_$n, s.x), i = Math.max(i, s.y);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return [
                _$e,
                _$r,
                _$n,
                i
            ];
        }, t.aM = dc, t.aN = F, t.aO = function(t, e1, r, n) {
            var i = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
            if (!r[0] && !r[1]) return [
                0,
                0
            ];
            var s = i ? "map" === n ? -t.bearingInRadians : 0 : "viewport" === n ? t.bearingInRadians : 0;
            if (s) {
                var _$t = Math.sin(s), _$e = Math.cos(s);
                r = [
                    r[0] * _$e - r[1] * _$t,
                    r[0] * _$t + r[1] * _$e
                ];
            }
            return [
                i ? r[0] : F(e1, r[0], t.zoom),
                i ? r[1] : F(e1, r[1], t.zoom)
            ];
        }, t.aQ = ah, t.aR = gd, t.aS = Yc, t.aT = Sd, t.aU = na, t.aV = pu, t.aW = $a, t.aX = io, t.aY = to, t.aZ = et, t.a_ = Bh, t.aa = jh, t.ab = 25, t.ac = Lh, t.ad = function(t) {
            var _$e = window.document.createElement("video");
            return _$e.muted = !0, new Promise(function(r) {
                _$e.onloadstart = function() {
                    r(_$e);
                };
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$r = _step.value;
                        var _$t = window.document.createElement("source");
                        ft(_$r) || (_$e.crossOrigin = "Anonymous"), _$t.src = _$r, _$e.appendChild(_$t);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }, t.ae = Dt, t.af = function() {
            return R++;
        }, t.ag = Fa, t.ah = fh, t.ai = zf, t.aj = fi, t.ak = $o, t.al = Xh, t.am = function(t) {
            var _$e = {};
            if (t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, function(t, r, n, i) {
                var s = n || i;
                return _$e[r] = !s || s.toLowerCase(), "";
            }), _$e["max-age"]) {
                var _$t = parseInt(_$e["max-age"], 10);
                isNaN(_$t) ? delete _$e["max-age"] : _$e["max-age"] = _$t;
            }
            return _$e;
        }, t.an = C, t.ao = 85.051129, t.ap = tt, t.aq = function(t) {
            return Math.pow(2, t);
        }, t.ar = y, t.as = Dh, t.at = function(t) {
            return Math.log(t) / Math.LN2;
        }, t.au = function(t) {
            var _$e = t[0], _$r = t[1];
            return _$e * _$e + _$r * _$r;
        }, t.av = function(t) {
            var _Math;
            if (!t.length) return new Set;
            var _$e = (_Math = Math).max.apply(_Math, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(t.map(function(t) {
                return t.canonical.z;
            })));
            var _$r = 1 / 0, _$n = -1 / 0, i = 1 / 0, s = -1 / 0;
            var a = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var o = _step.value;
                    var _o_canonical = o.canonical, _$t = _o_canonical.x, l = _o_canonical.y, u = _o_canonical.z, _$c = Math.pow(2, _$e - u), _$h = _$t * _$c, p = l * _$c;
                    a.push({
                        id: o,
                        x: _$h,
                        y: p
                    }), _$h < _$r && (_$r = _$h), _$h > _$n && (_$n = _$h), p < i && (i = p), p > s && (s = p);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var o1 = new Set;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = a[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _$t1 = _step1.value;
                    _$t1.x !== _$r && _$t1.x !== _$n && _$t1.y !== i && _$t1.y !== s || o1.add(_$t1.id);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return o1;
        }, t.aw = function(t, e1) {
            var _$r = Math.abs(2 * t.wrap) - +(t.wrap < 0), _$n = Math.abs(2 * e1.wrap) - +(e1.wrap < 0);
            return t.overscaledZ - e1.overscaledZ || _$n - _$r || e1.canonical.y - t.canonical.y || e1.canonical.x - t.canonical.x;
        }, t.ax = /*#__PURE__*/ function() {
            function _class(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this.max = t, this.onRemove = e1, this.reset();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "reset",
                    value: function reset() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        for(var _$t in this.data)try {
                            for(var _iterator = this.data[_$t][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                _$e.timeout && clearTimeout(_$e.timeout), this.onRemove(_$e.value);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return this.data = {}, this.order = [], this;
                    }
                },
                {
                    key: "add",
                    value: function add(t, e1, r) {
                        var _this = this;
                        var _$n = t.wrapped().key;
                        void 0 === this.data[_$n] && (this.data[_$n] = []);
                        var i = {
                            value: e1,
                            timeout: void 0
                        };
                        if (void 0 !== r && (i.timeout = setTimeout(function() {
                            _this.remove(t, i);
                        }, r)), this.data[_$n].push(i), this.order.push(_$n), this.order.length > this.max) {
                            var _$t = this._getAndRemoveByKey(this.order[0]);
                            _$t && this.onRemove(_$t);
                        }
                        return this;
                    }
                },
                {
                    key: "has",
                    value: function has(t) {
                        return t.wrapped().key in this.data;
                    }
                },
                {
                    key: "getAndRemove",
                    value: function getAndRemove(t) {
                        return this.has(t) ? this._getAndRemoveByKey(t.wrapped().key) : null;
                    }
                },
                {
                    key: "_getAndRemoveByKey",
                    value: function _getAndRemoveByKey(t) {
                        var _$e = this.data[t].shift();
                        return _$e.timeout && clearTimeout(_$e.timeout), 0 === this.data[t].length && delete this.data[t], this.order.splice(this.order.indexOf(t), 1), _$e.value;
                    }
                },
                {
                    key: "getByKey",
                    value: function getByKey(t) {
                        var _$e = this.data[t];
                        return _$e ? _$e[0].value : null;
                    }
                },
                {
                    key: "get",
                    value: function get(t) {
                        return this.has(t) ? this.data[t.wrapped().key][0].value : null;
                    }
                },
                {
                    key: "remove",
                    value: function remove(t, e1) {
                        if (!this.has(t)) return this;
                        var _$r = t.wrapped().key, _$n = void 0 === e1 ? 0 : this.data[_$r].indexOf(e1), i = this.data[_$r][_$n];
                        return this.data[_$r].splice(_$n, 1), i.timeout && clearTimeout(i.timeout), 0 === this.data[_$r].length && delete this.data[_$r], this.onRemove(i.value), this.order.splice(this.order.indexOf(_$r), 1), this;
                    }
                },
                {
                    key: "setMaxSize",
                    value: function setMaxSize(t) {
                        for(this.max = t; this.order.length > this.max;){
                            var _$t = this._getAndRemoveByKey(this.order[0]);
                            _$t && this.onRemove(_$t);
                        }
                        return this;
                    }
                },
                {
                    key: "filter",
                    value: function filter(t) {
                        var _$e = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        for(var _$r in this.data)try {
                            for(var _iterator = this.data[_$r][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$n = _step.value;
                                t(_$n.value) || _$e.push(_$n);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = _$e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$t = _step1.value;
                                this.remove(_$t.value.tileID, _$t);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                }
            ]);
            return _class;
        }(), t.ay = function(t, e1) {
            var _$r = 0, _$n = 0;
            if ("constant" === t.kind) _$n = t.layoutSize;
            else if ("source" !== t.kind) {
                var i = t.interpolationType, s = t.minZoom, a = t.maxZoom, o = i ? C(fr.interpolationFactor(i, e1, s, a), 0, 1) : 0;
                "camera" === t.kind ? _$n = yr.number(t.minSize, t.maxSize, o) : _$r = o;
            }
            return {
                uSizeT: _$r,
                uSize: _$n
            };
        }, t.b = Z, t.b$ = Ao, t.b0 = v, t.b1 = function(t) {
            var _$e = new f(3);
            return _$e[0] = t[0], _$e[1] = t[1], _$e[2] = t[2], _$e;
        }, t.b2 = function(t, e1, r) {
            return t[0] = e1[0] - r[0], t[1] = e1[1] - r[1], t[2] = e1[2] - r[2], t;
        }, t.b3 = function(t, e1) {
            var _$r = e1[0], _$n = e1[1], i = e1[2], s = _$r * _$r + _$n * _$n + i * i;
            return s > 0 && (s = 1 / Math.sqrt(s)), t[0] = e1[0] * s, t[1] = e1[1] * s, t[2] = e1[2] * s, t;
        }, t.b4 = w, t.b5 = function(t, e1) {
            return t[0] * e1[0] + t[1] * e1[1] + t[2] * e1[2];
        }, t.b6 = function(t, e1, r) {
            return t[0] = e1[0] * r[0], t[1] = e1[1] * r[1], t[2] = e1[2] * r[2], t[3] = e1[3] * r[3], t;
        }, t.b7 = g, t.b8 = function(t, e1, r) {
            var _$n = e1[0] * r[0] + e1[1] * r[1] + e1[2] * r[2];
            return 0 === _$n ? null : (-(t[0] * r[0] + t[1] * r[1] + t[2] * r[2]) - r[3]) / _$n;
        }, t.b9 = S, t.bA = function(t, e1, r, n) {
            return t[0] = e1[0] + r[0] * n, t[1] = e1[1] + r[1] * n, t[2] = e1[2] + r[2] * n, t;
        }, t.bB = E, t.bC = function(t, e1, r) {
            var _$n = r[0], i = r[1], s = r[2], a = r[3], o = e1[0], l = e1[1], u = e1[2], _$c = i * u - s * l, _$h = s * o - _$n * u, p = _$n * l - i * o;
            return t[0] = o + a * (_$c += _$c) + i * (p += p) - s * (_$h += _$h), t[1] = l + a * _$h + s * _$c - _$n * p, t[2] = u + a * p + _$n * _$h - i * _$c, t;
        }, t.bD = function(t, e1, r) {
            var _$n = function(t) {
                var _$e = t[3], _$r = t[4], _$n = t[5], i = t[6], s = t[7], a = t[8];
                return t[0] * (a * _$r - _$n * s) + t[1] * (-a * _$e + _$n * i) + t[2] * (s * _$e - _$r * i);
            }([
                t[0],
                t[1],
                t[2],
                e1[0],
                e1[1],
                e1[2],
                r[0],
                r[1],
                r[2]
            ]);
            if (0 === _$n) return null;
            var i = w([], [
                e1[0],
                e1[1],
                e1[2]
            ], [
                r[0],
                r[1],
                r[2]
            ]), s = w([], [
                r[0],
                r[1],
                r[2]
            ], [
                t[0],
                t[1],
                t[2]
            ]), a = w([], [
                t[0],
                t[1],
                t[2]
            ], [
                e1[0],
                e1[1],
                e1[2]
            ]), o = b([], i, -t[3]);
            return v(o, o, b([], s, -e1[3])), v(o, o, b([], a, -r[3])), b(o, o, 1 / _$n), o;
        }, t.bE = kh, t.bF = function() {
            return new Float64Array(4);
        }, t.bG = function(t, e1, r, n) {
            var i = [], s = [];
            return i[0] = e1[0] - r[0], i[1] = e1[1] - r[1], i[2] = e1[2] - r[2], s[0] = i[0] * Math.cos(n) - i[1] * Math.sin(n), s[1] = i[0] * Math.sin(n) + i[1] * Math.cos(n), s[2] = i[2], t[0] = s[0] + r[0], t[1] = s[1] + r[1], t[2] = s[2] + r[2], t;
        }, t.bH = function(t, e1, r, n) {
            var i = [], s = [];
            return i[0] = e1[0] - r[0], i[1] = e1[1] - r[1], i[2] = e1[2] - r[2], s[0] = i[0], s[1] = i[1] * Math.cos(n) - i[2] * Math.sin(n), s[2] = i[1] * Math.sin(n) + i[2] * Math.cos(n), t[0] = s[0] + r[0], t[1] = s[1] + r[1], t[2] = s[2] + r[2], t;
        }, t.bI = function(t, e1, r, n) {
            var i = [], s = [];
            return i[0] = e1[0] - r[0], i[1] = e1[1] - r[1], i[2] = e1[2] - r[2], s[0] = i[2] * Math.sin(n) + i[0] * Math.cos(n), s[1] = i[1], s[2] = i[2] * Math.cos(n) - i[0] * Math.sin(n), t[0] = s[0] + r[0], t[1] = s[1] + r[1], t[2] = s[2] + r[2], t;
        }, t.bJ = function(t, e1, r) {
            var _$n = Math.sin(r), i = Math.cos(r), s = e1[0], a = e1[1], o = e1[2], l = e1[3], u = e1[8], _$c = e1[9], _$h = e1[10], p = e1[11];
            return e1 !== t && (t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15]), t[0] = s * i - u * _$n, t[1] = a * i - _$c * _$n, t[2] = o * i - _$h * _$n, t[3] = l * i - p * _$n, t[8] = s * _$n + u * i, t[9] = a * _$n + _$c * i, t[10] = o * _$n + _$h * i, t[11] = l * _$n + p * i, t;
        }, t.bK = function(t, e1) {
            var _$r = D(t, 360), _$n = D(e1, 360), i = _$n - _$r, s = _$n > _$r ? i - 360 : i + 360;
            return Math.abs(i) < Math.abs(s) ? i : s;
        }, t.bL = function(t) {
            return t[0] = 0, t[1] = 0, t[2] = 0, t;
        }, t.bM = function(t, e1, r, n) {
            var i = Math.sqrt(t * t + e1 * e1), s = Math.sqrt(r * r + n * n);
            t /= i, e1 /= i, r /= s, n /= s;
            var a = Math.acos(t * r + e1 * n);
            return -e1 * r + t * n > 0 ? a : -a;
        }, t.bN = function(t, e1) {
            var _$r = D(t, 2 * Math.PI), _$n = D(e1, 2 * Math.PI);
            return Math.min(Math.abs(_$r - _$n), Math.abs(_$r - _$n + 2 * Math.PI), Math.abs(_$r - _$n - 2 * Math.PI));
        }, t.bO = function() {
            var _$t = {}, _$e = vt.$version;
            for(var _$r in vt.$root){
                var _$n = vt.$root[_$r];
                if (_$n.required) {
                    var i = null;
                    i = "version" === _$r ? _$e : "array" === _$n.type ? [] : {}, null != i && (_$t[_$r] = i);
                }
            }
            return _$t;
        }, t.bP = ht, t.bQ = xs, t.bR = function t(e1, r) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(r) || e1.length !== r.length) return !1;
                for(var _$n = 0; _$n < e1.length; _$n++)if (!t(e1[_$n], r[_$n])) return !1;
                return !0;
            }
            if ("object" == (typeof e1 === "undefined" ? "undefined" : (0, $dvYFb._)(e1)) && null !== e1 && null !== r) {
                if ("object" != (typeof r === "undefined" ? "undefined" : (0, $dvYFb._)(r))) return !1;
                if (Object.keys(e1).length !== Object.keys(r).length) return !1;
                for(var _$n1 in e1)if (!t(e1[_$n1], r[_$n1])) return !1;
                return !0;
            }
            return e1 === r;
        }, t.bS = function(t) {
            t = t.slice();
            var _$e = Object.create(null);
            for(var _$r = 0; _$r < t.length; _$r++)_$e[t[_$r].id] = t[_$r];
            for(var _$r1 = 0; _$r1 < t.length; _$r1++)"ref" in t[_$r1] && (t[_$r1] = wt(t[_$r1], _$e[t[_$r1].ref]));
            return t;
        }, t.bT = function(t, e1) {
            if ("custom" === t.type) return new _h(t, e1);
            switch(t.type){
                case "background":
                    return new wh(t, e1);
                case "circle":
                    return new yl(t, e1);
                case "color-relief":
                    return new Vl(t, e1);
                case "fill":
                    return new ku(t, e1);
                case "fill-extrusion":
                    return new Gu(t, e1);
                case "heatmap":
                    return new El(t, e1);
                case "hillshade":
                    return new Ml(t, e1);
                case "line":
                    return new ac(t, e1);
                case "raster":
                    return new Qs(t, e1);
                case "symbol":
                    return new xh(t, e1);
            }
        }, t.bU = function(t) {
            return "raster" === t.type;
        }, t.bV = U, t.bW = function(t, e1) {
            if (!t) return [
                {
                    command: "setStyle",
                    args: [
                        e1
                    ]
                }
            ];
            var _$r = [];
            try {
                if (!_t(t.version, e1.version)) return [
                    {
                        command: "setStyle",
                        args: [
                            e1
                        ]
                    }
                ];
                _t(t.center, e1.center) || _$r.push({
                    command: "setCenter",
                    args: [
                        e1.center
                    ]
                }), _t(t.state, e1.state) || _$r.push({
                    command: "setGlobalState",
                    args: [
                        e1.state
                    ]
                }), _t(t.centerAltitude, e1.centerAltitude) || _$r.push({
                    command: "setCenterAltitude",
                    args: [
                        e1.centerAltitude
                    ]
                }), _t(t.zoom, e1.zoom) || _$r.push({
                    command: "setZoom",
                    args: [
                        e1.zoom
                    ]
                }), _t(t.bearing, e1.bearing) || _$r.push({
                    command: "setBearing",
                    args: [
                        e1.bearing
                    ]
                }), _t(t.pitch, e1.pitch) || _$r.push({
                    command: "setPitch",
                    args: [
                        e1.pitch
                    ]
                }), _t(t.roll, e1.roll) || _$r.push({
                    command: "setRoll",
                    args: [
                        e1.roll
                    ]
                }), _t(t.sprite, e1.sprite) || _$r.push({
                    command: "setSprite",
                    args: [
                        e1.sprite
                    ]
                }), _t(t.glyphs, e1.glyphs) || _$r.push({
                    command: "setGlyphs",
                    args: [
                        e1.glyphs
                    ]
                }), _t(t.transition, e1.transition) || _$r.push({
                    command: "setTransition",
                    args: [
                        e1.transition
                    ]
                }), _t(t.light, e1.light) || _$r.push({
                    command: "setLight",
                    args: [
                        e1.light
                    ]
                }), _t(t.terrain, e1.terrain) || _$r.push({
                    command: "setTerrain",
                    args: [
                        e1.terrain
                    ]
                }), _t(t.sky, e1.sky) || _$r.push({
                    command: "setSky",
                    args: [
                        e1.sky
                    ]
                }), _t(t.projection, e1.projection) || _$r.push({
                    command: "setProjection",
                    args: [
                        e1.projection
                    ]
                });
                var _$n = {}, i = [];
                !function(t, e1, r, n) {
                    var i;
                    for(i in e1 = e1 || {}, t = t || {})Object.prototype.hasOwnProperty.call(t, i) && (Object.prototype.hasOwnProperty.call(e1, i) || kt(i, r, n));
                    for(i in e1)Object.prototype.hasOwnProperty.call(e1, i) && (Object.prototype.hasOwnProperty.call(t, i) ? _t(t[i], e1[i]) || ("geojson" === t[i].type && "geojson" === e1[i].type && Tt(t, e1, i) ? St(r, {
                        command: "setGeoJSONSourceData",
                        args: [
                            i,
                            e1[i].data
                        ]
                    }) : Et(i, e1, r, n)) : At(i, e1, r));
                }(t.sources, e1.sources, i, _$n);
                var s = [];
                t.layers && t.layers.forEach(function(t) {
                    "source" in t && _$n[t.source] ? _$r.push({
                        command: "removeLayer",
                        args: [
                            t.id
                        ]
                    }) : s.push(t);
                }), _$r = _$r.concat(i), function(t, e1, r) {
                    e1 = e1 || [];
                    var _$n = (t = t || []).map(Mt), i = e1.map(Mt), s = t.reduce(Ft, {}), a = e1.reduce(Ft, {}), o = _$n.slice(), l = Object.create(null);
                    var u, _$c, _$h, p, f;
                    for(var _$t = 0, _$e = 0; _$t < _$n.length; _$t++)u = _$n[_$t], Object.prototype.hasOwnProperty.call(a, u) ? _$e++ : (St(r, {
                        command: "removeLayer",
                        args: [
                            u
                        ]
                    }), o.splice(o.indexOf(u, _$e), 1));
                    for(var _$t1 = 0, _$e1 = 0; _$t1 < i.length; _$t1++)u = i[i.length - 1 - _$t1], o[o.length - 1 - _$t1] !== u && (Object.prototype.hasOwnProperty.call(s, u) ? (St(r, {
                        command: "removeLayer",
                        args: [
                            u
                        ]
                    }), o.splice(o.lastIndexOf(u, o.length - _$e1), 1)) : _$e1++, p = o[o.length - _$t1], St(r, {
                        command: "addLayer",
                        args: [
                            a[u],
                            p
                        ]
                    }), o.splice(o.length - _$t1, 0, u), l[u] = !0);
                    for(var _$t2 = 0; _$t2 < i.length; _$t2++)if (u = i[_$t2], _$c = s[u], _$h = a[u], !l[u] && !_t(_$c, _$h)) {
                        if (_t(_$c.source, _$h.source) && _t(_$c["source-layer"], _$h["source-layer"]) && _t(_$c.type, _$h.type)) {
                            for(f in It(_$c.layout, _$h.layout, r, u, null, "setLayoutProperty"), It(_$c.paint, _$h.paint, r, u, null, "setPaintProperty"), _t(_$c.filter, _$h.filter) || St(r, {
                                command: "setFilter",
                                args: [
                                    u,
                                    _$h.filter
                                ]
                            }), _t(_$c.minzoom, _$h.minzoom) && _t(_$c.maxzoom, _$h.maxzoom) || St(r, {
                                command: "setLayerZoomRange",
                                args: [
                                    u,
                                    _$h.minzoom,
                                    _$h.maxzoom
                                ]
                            }), _$c)Object.prototype.hasOwnProperty.call(_$c, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? It(_$c[f], _$h[f], r, u, f.slice(6), "setPaintProperty") : _t(_$c[f], _$h[f]) || St(r, {
                                command: "setLayerProperty",
                                args: [
                                    u,
                                    f,
                                    _$h[f]
                                ]
                            }));
                            for(f in _$h)Object.prototype.hasOwnProperty.call(_$h, f) && !Object.prototype.hasOwnProperty.call(_$c, f) && "layout" !== f && "paint" !== f && "filter" !== f && "metadata" !== f && "minzoom" !== f && "maxzoom" !== f && (0 === f.indexOf("paint.") ? It(_$c[f], _$h[f], r, u, f.slice(6), "setPaintProperty") : _t(_$c[f], _$h[f]) || St(r, {
                                command: "setLayerProperty",
                                args: [
                                    u,
                                    f,
                                    _$h[f]
                                ]
                            }));
                        } else St(r, {
                            command: "removeLayer",
                            args: [
                                u
                            ]
                        }), p = o[o.lastIndexOf(u) + 1], St(r, {
                            command: "addLayer",
                            args: [
                                _$h,
                                p
                            ]
                        });
                    }
                }(s, e1.layers, _$r);
            } catch (t) {
                console.warn("Unable to compute style diff:", t), _$r = [
                    {
                        command: "setStyle",
                        args: [
                            e1
                        ]
                    }
                ];
            }
            return _$r;
        }, t.bX = function(t) {
            var _$e = [], _$r = t.id;
            return void 0 === _$r && _$e.push({
                message: "layers.".concat(_$r, ': missing required property "id"')
            }), void 0 === t.render && _$e.push({
                message: "layers.".concat(_$r, ': missing required method "render"')
            }), t.renderingMode && "2d" !== t.renderingMode && "3d" !== t.renderingMode && _$e.push({
                message: "layers.".concat(_$r, ': property "renderingMode" must be either "2d" or "3d"')
            }), _$e;
        }, t.bY = N, t.bZ = $, t.b_ = /*#__PURE__*/ function(wo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, wo);
            function _class(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, [
                    t,
                    e1
                ]), _this.current = 0;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "set",
                    value: function set(t) {
                        this.current !== t && (this.current = t, this.gl.uniform1i(this.location, t));
                    }
                }
            ]);
            return _class;
        }(wo), t.ba = function(t, e1, r) {
            return t[0] = e1[0] * r, t[1] = e1[1] * r, t[2] = e1[2] * r, t[3] = e1[3] * r, t;
        }, t.bb = function(t, e1) {
            return t[0] * e1[0] + t[1] * e1[1] + t[2] * e1[2] + t[3];
        }, t.bc = Oh, t.bd = Nh, t.be = function(t, e1, r, n, i) {
            var s = 1 / Math.tan(e1 / 2);
            if (t[0] = s / r, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = s, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[11] = -1, t[12] = 0, t[13] = 0, t[15] = 0, null != i && i !== 1 / 0) {
                var a = 1 / (n - i);
                t[10] = (i + n) * a, t[14] = 2 * i * n * a;
            } else t[10] = -1, t[14] = -2 * n;
            return t;
        }, t.bf = function(t) {
            var _$e = new f(16);
            return _$e[0] = t[0], _$e[1] = t[1], _$e[2] = t[2], _$e[3] = t[3], _$e[4] = t[4], _$e[5] = t[5], _$e[6] = t[6], _$e[7] = t[7], _$e[8] = t[8], _$e[9] = t[9], _$e[10] = t[10], _$e[11] = t[11], _$e[12] = t[12], _$e[13] = t[13], _$e[14] = t[14], _$e[15] = t[15], _$e;
        }, t.bg = function(t, e1, r) {
            var _$n = Math.sin(r), i = Math.cos(r), s = e1[0], a = e1[1], o = e1[2], l = e1[3], u = e1[4], _$c = e1[5], _$h = e1[6], p = e1[7];
            return e1 !== t && (t[8] = e1[8], t[9] = e1[9], t[10] = e1[10], t[11] = e1[11], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15]), t[0] = s * i + u * _$n, t[1] = a * i + _$c * _$n, t[2] = o * i + _$h * _$n, t[3] = l * i + p * _$n, t[4] = u * i - s * _$n, t[5] = _$c * i - a * _$n, t[6] = _$h * i - o * _$n, t[7] = p * i - l * _$n, t;
        }, t.bh = function(t, e1, r) {
            var _$n = Math.sin(r), i = Math.cos(r), s = e1[4], a = e1[5], o = e1[6], l = e1[7], u = e1[8], _$c = e1[9], _$h = e1[10], p = e1[11];
            return e1 !== t && (t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15]), t[4] = s * i + u * _$n, t[5] = a * i + _$c * _$n, t[6] = o * i + _$h * _$n, t[7] = l * i + p * _$n, t[8] = u * i - s * _$n, t[9] = _$c * i - a * _$n, t[10] = _$h * i - o * _$n, t[11] = p * i - l * _$n, t;
        }, t.bi = function() {
            var _$t = new Float32Array(16);
            return y(_$t), _$t;
        }, t.bj = function() {
            var _$t = new Float64Array(16);
            return y(_$t), _$t;
        }, t.bk = function() {
            return new Float64Array(16);
        }, t.bl = function(t, e1, r) {
            var _$n = new Float64Array(4);
            return E(_$n, t, e1 - 90, r), _$n;
        }, t.bm = function(t, e1, r, n) {
            var i, s, a, o, l, u = e1[0], _$c = e1[1], _$h = e1[2], f = e1[3], _$d = r[0], _$y = r[1], _$m = r[2], _$g = r[3];
            return (s = u * _$d + _$c * _$y + _$h * _$m + f * _$g) < 0 && (s = -s, _$d = -_$d, _$y = -_$y, _$m = -_$m, _$g = -_$g), 1 - s > p ? (i = Math.acos(s), a = Math.sin(i), o = Math.sin((1 - n) * i) / a, l = Math.sin(n * i) / a) : (o = 1 - n, l = n), t[0] = o * u + l * _$d, t[1] = o * _$c + l * _$y, t[2] = o * _$h + l * _$m, t[3] = o * f + l * _$g, t;
        }, t.bn = function(t) {
            var _$e = new Float64Array(9);
            !function(t, e1) {
                var _$r = e1[0], _$n = e1[1], i = e1[2], s = e1[3], a = _$r + _$r, o = _$n + _$n, l = i + i, u = _$r * a, _$c = _$n * a, _$h = _$n * o, p = i * a, f = i * o, _$d = i * l, _$y = s * a, _$m = s * o, _$g = s * l;
                t[0] = 1 - _$h - _$d, t[3] = _$c - _$g, t[6] = p + _$m, t[1] = _$c + _$g, t[4] = 1 - u - _$d, t[7] = f - _$y, t[2] = p - _$m, t[5] = f + _$y, t[8] = 1 - u - _$h;
            }(_$e, t);
            var _$r = et(-Math.asin(C(_$e[2], -1, 1)));
            var _$n, i;
            return Math.hypot(_$e[5], _$e[8]) < .001 ? (_$n = 0, i = -et(Math.atan2(_$e[3], _$e[4]))) : (_$n = et(0 === _$e[5] && 0 === _$e[8] ? 0 : Math.atan2(_$e[5], _$e[8])), i = et(0 === _$e[1] && 0 === _$e[0] ? 0 : Math.atan2(_$e[1], _$e[0]))), {
                roll: _$n,
                pitch: _$r + 90,
                bearing: i
            };
        }, t.bo = function(t, e1) {
            return t.roll == e1.roll && t.pitch == e1.pitch && t.bearing == e1.bearing;
        }, t.bp = Te, t.bq = _o, t.br = fu, t.bs = du, t.bt = hu, t.bu = z, t.bv = P, t.bw = Re, t.bx = function(t, e1, r, n, i) {
            return z(n, i, C((t - e1) / (r - e1), 0, 1));
        }, t.by = D, t.bz = function() {
            return new Float64Array(3);
        }, t.c = ot, t.c$ = function(t, r, n, i, s) {
            return e1(this, void 0, void 0, function() {
                var t1;
                return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!h()) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                K(t, r, n, i, s)
                            ];
                        case 2:
                            return [
                                2,
                                _state.sent()
                            ];
                        case 3:
                            t1 = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2,
                                function(t, e1, r, n, i) {
                                    var _$s = t.width, a = t.height;
                                    W && J || (W = new OffscreenCanvas(_$s, a), J = W.getContext("2d", {
                                        willReadFrequently: !0
                                    })), W.width = _$s, W.height = a, J.drawImage(t, 0, 0, _$s, a);
                                    var o = J.getImageData(e1, r, n, i);
                                    return J.clearRect(0, 0, _$s, a), o.data;
                                }(t, r, n, i, s)
                            ];
                    }
                });
            });
        }, t.c0 = /*#__PURE__*/ function(wo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, wo);
            function _class(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, [
                    t,
                    e1
                ]), _this.current = ko;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "set",
                    value: function set(t) {
                        if (t[12] !== this.current[12] || t[0] !== this.current[0]) return this.current = t, void this.gl.uniformMatrix4fv(this.location, !1, t);
                        for(var _$e = 1; _$e < 16; _$e++)if (t[_$e] !== this.current[_$e]) {
                            this.current = t, this.gl.uniformMatrix4fv(this.location, !1, t);
                            break;
                        }
                    }
                }
            ]);
            return _class;
        }(wo), t.c1 = So, t.c2 = /*#__PURE__*/ function(wo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, wo);
            function _class(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, [
                    t,
                    e1
                ]), _this.current = [
                    0,
                    0,
                    0
                ];
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "set",
                    value: function set(t) {
                        t[0] === this.current[0] && t[1] === this.current[1] && t[2] === this.current[2] || (this.current = t, this.gl.uniform3f(this.location, t[0], t[1], t[2]));
                    }
                }
            ]);
            return _class;
        }(wo), t.c3 = /*#__PURE__*/ function(wo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, wo);
            function _class(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, [
                    t,
                    e1
                ]), _this.current = [
                    0,
                    0
                ];
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "set",
                    value: function set(t) {
                        t[0] === this.current[0] && t[1] === this.current[1] || (this.current = t, this.gl.uniform2f(this.location, t[0], t[1]));
                    }
                }
            ]);
            return _class;
        }(wo), t.c4 = d, t.c5 = function(t, e1) {
            var _$r = Math.sin(e1), _$n = Math.cos(e1);
            return t[0] = _$n, t[1] = _$r, t[2] = 0, t[3] = -_$r, t[4] = _$n, t[5] = 0, t[6] = 0, t[7] = 0, t[8] = 1, t;
        }, t.c6 = function(t, e1, r) {
            var _$n = e1[0], i = e1[1], s = e1[2];
            return t[0] = _$n * r[0] + i * r[3] + s * r[6], t[1] = _$n * r[1] + i * r[4] + s * r[7], t[2] = _$n * r[2] + i * r[5] + s * r[8], t;
        }, t.c7 = function(t, e1, r, n, i, s, a) {
            var o = 1 / (e1 - r), l = 1 / (n - i), u = 1 / (s - a);
            return t[0] = -2 * o, t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = -2 * l, t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = 2 * u, t[11] = 0, t[12] = (e1 + r) * o, t[13] = (i + n) * l, t[14] = (a + s) * u, t[15] = 1, t;
        }, t.c8 = /*#__PURE__*/ function(wo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, wo);
            function _class(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, [
                    t,
                    e1
                ]), _this.current = new Array;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "set",
                    value: function set(t) {
                        if (t != this.current) {
                            this.current = t;
                            var _$e = new Float32Array(4 * t.length);
                            for(var _$r = 0; _$r < t.length; _$r++)_$e[4 * _$r] = t[_$r].r, _$e[4 * _$r + 1] = t[_$r].g, _$e[4 * _$r + 2] = t[_$r].b, _$e[4 * _$r + 3] = t[_$r].a;
                            this.gl.uniform4fv(this.location, _$e);
                        }
                    }
                }
            ]);
            return _class;
        }(wo), t.c9 = /*#__PURE__*/ function(wo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, wo);
            function _class(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, [
                    t,
                    e1
                ]), _this.current = new Array;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "set",
                    value: function set(t) {
                        if (t != this.current) {
                            this.current = t;
                            var _$e = new Float32Array(t);
                            this.gl.uniform1fv(this.location, _$e);
                        }
                    }
                }
            ]);
            return _class;
        }(wo), t.cA = function(t, e1) {
            return rt[e1] && "touches" in t;
        }, t.cB = function(t) {
            return rt[t] || nt[t];
        }, t.cC = function(t, e1, r) {
            var _$n = e1[0], i = e1[1];
            return t[0] = r[0] * _$n + r[4] * i + r[12], t[1] = r[1] * _$n + r[5] * i + r[13], t;
        }, t.cD = function(t, e1) {
            var _Vh_fromLngLat = Vh.fromLngLat(e1), _$r = _Vh_fromLngLat.x, _$n = _Vh_fromLngLat.y;
            return !(t < 0 || t > 25 || _$n < 0 || _$n >= 1 || _$r < 0 || _$r >= 1);
        }, t.cE = function(t, e1) {
            return t[0] = e1[0], t[1] = 0, t[2] = 0, t[3] = 0, t[4] = 0, t[5] = e1[1], t[6] = 0, t[7] = 0, t[8] = 0, t[9] = 0, t[10] = e1[2], t[11] = 0, t[12] = 0, t[13] = 0, t[14] = 0, t[15] = 1, t;
        }, t.cF = /*#__PURE__*/ function(aa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, aa);
            function _class() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, arguments);
            }
            return _class;
        }(aa), t.cG = Vd, t.cI = ct, t.cJ = function(t, e1) {
            ot.REGISTERED_PROTOCOLS[t] = e1;
        }, t.cK = function(t) {
            delete ot.REGISTERED_PROTOCOLS[t];
        }, t.cL = function(t, e1) {
            var _$r = {};
            for(var _$n = 0; _$n < t.length; _$n++){
                var i = e1 && e1[t[_$n].id] || _i(t[_$n]);
                e1 && (e1[t[_$n].id] = i);
                var s = _$r[i];
                s || (s = _$r[i] = []), s.push(t[_$n]);
            }
            var _$n1 = [];
            for(var _$t in _$r)_$n1.push(_$r[_$t]);
            return _$n1;
        }, t.cM = ps, t.cN = Gh, t.cO = Nf, t.cP = jc, t.cQ = function(e1) {
            e1.bucket.createArrays(), e1.bucket.tilePixelRatio = M / (512 * e1.bucket.overscaling), e1.bucket.compareText = {}, e1.bucket.iconsNeedLinear = !1;
            var _$r = e1.bucket.layers[0], _$n = _$r.layout, i = _$r._unevaluatedLayout._values, s = {
                layoutIconSize: i["icon-size"].possiblyEvaluate(new Ps(e1.bucket.zoom + 1), e1.canonical),
                layoutTextSize: i["text-size"].possiblyEvaluate(new Ps(e1.bucket.zoom + 1), e1.canonical),
                textMaxSize: i["text-size"].possiblyEvaluate(new Ps(18))
            };
            if ("composite" === e1.bucket.textSizeData.kind) {
                var _e_bucket_textSizeData = e1.bucket.textSizeData, _$t = _e_bucket_textSizeData.minZoom, _$r1 = _e_bucket_textSizeData.maxZoom;
                s.compositeTextSizes = [
                    i["text-size"].possiblyEvaluate(new Ps(_$t), e1.canonical),
                    i["text-size"].possiblyEvaluate(new Ps(_$r1), e1.canonical)
                ];
            }
            if ("composite" === e1.bucket.iconSizeData.kind) {
                var _e_bucket_iconSizeData = e1.bucket.iconSizeData, _$t1 = _e_bucket_iconSizeData.minZoom, _$r2 = _e_bucket_iconSizeData.maxZoom;
                s.compositeIconSizes = [
                    i["icon-size"].possiblyEvaluate(new Ps(_$t1), e1.canonical),
                    i["icon-size"].possiblyEvaluate(new Ps(_$r2), e1.canonical)
                ];
            }
            var a = _$n.get("text-line-height") * dc, o = "viewport" !== _$n.get("text-rotation-alignment") && "point" !== _$n.get("symbol-placement"), l = _$n.get("text-keep-upright"), u = _$n.get("text-size");
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var i = _step.value;
                    var _$c = _$n.get("text-font").evaluate(i, {}, e1.canonical).join(","), _$h = u.evaluate(i, {}, e1.canonical), p = s.layoutTextSize.evaluate(i, {}, e1.canonical), f = s.layoutIconSize.evaluate(i, {}, e1.canonical), _$d = {
                        horizontal: {},
                        vertical: void 0
                    }, _$y = i.text;
                    var _$m = void 0, _$g = [
                        0,
                        0
                    ];
                    if (_$y) {
                        var s1 = _$y.toString(), u1 = _$n.get("text-letter-spacing").evaluate(i, {}, e1.canonical) * dc, f1 = Ss(s1) ? u1 : 0, _$m1 = _$n.get("text-anchor").evaluate(i, {}, e1.canonical), _$x = md(_$r, i, e1.canonical);
                        if (!_$x) {
                            var _$t = _$n.get("text-radial-offset").evaluate(i, {}, e1.canonical);
                            _$g = _$t ? yd(_$m1, [
                                _$t * dc,
                                dd
                            ]) : _$n.get("text-offset").evaluate(i, {}, e1.canonical).map(function(t) {
                                return t * dc;
                            });
                        }
                        var _$v = o ? "center" : _$n.get("text-justify").evaluate(i, {}, e1.canonical);
                        var _$b = "point" === _$n.get("symbol-placement") ? _$n.get("text-max-width").evaluate(i, {}, e1.canonical) * dc : 1 / 0, _$w = function() {
                            e1.bucket.allowVerticalPlacement && _s(s1) && (_$d.vertical = Xc(_$y, e1.glyphMap, e1.glyphPositions, e1.imagePositions, _$c, _$b, a, _$m1, "left", f1, _$g, t.az.vertical, !0, p, _$h));
                        };
                        if (!o && _$x) {
                            var _$r1 = new Set;
                            if ("auto" === _$v) for(var _$t1 = 0; _$t1 < _$x.values.length; _$t1 += 2)_$r1.add(gd(_$x.values[_$t1]));
                            else _$r1.add(_$v);
                            var _$n1 = !1;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = _$r1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var i1 = _step1.value;
                                    if (!_$d.horizontal[i1]) {
                                        if (_$n1) _$d.horizontal[i1] = _$d.horizontal[0];
                                        else {
                                            var _$r2 = Xc(_$y, e1.glyphMap, e1.glyphPositions, e1.imagePositions, _$c, _$b, a, "center", i1, f1, _$g, t.az.horizontal, !1, p, _$h);
                                            _$r2 && (_$d.horizontal[i1] = _$r2, _$n1 = 1 === _$r2.positionedLines.length);
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            _$w();
                        } else {
                            "auto" === _$v && (_$v = gd(_$m1));
                            var _$r3 = Xc(_$y, e1.glyphMap, e1.glyphPositions, e1.imagePositions, _$c, _$b, a, _$m1, _$v, f1, _$g, t.az.horizontal, !1, p, _$h);
                            _$r3 && (_$d.horizontal[_$v] = _$r3), _$w(), _s(s1) && o && l && (_$d.vertical = Xc(_$y, e1.glyphMap, e1.glyphPositions, e1.imagePositions, _$c, _$b, a, _$m1, _$v, f1, _$g, t.az.vertical, !1, p, _$h));
                        }
                    }
                    var _$x1 = !1;
                    if (i.icon && i.icon.name) {
                        var _$t2 = e1.imageMap[i.icon.name];
                        _$t2 && (_$m = th(e1.imagePositions[i.icon.name], _$n.get("icon-offset").evaluate(i, {}, e1.canonical), _$n.get("icon-anchor").evaluate(i, {}, e1.canonical)), _$x1 = !!_$t2.sdf, void 0 === e1.bucket.sdfIcons ? e1.bucket.sdfIcons = _$x1 : e1.bucket.sdfIcons !== _$x1 && j("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (_$t2.pixelRatio !== e1.bucket.pixelRatio || 0 !== _$n.get("icon-rotate").constantOr(1)) && (e1.bucket.iconsNeedLinear = !0));
                    }
                    var _$v1 = bd(_$d.horizontal) || _$d.vertical;
                    e1.bucket.iconsInText = !!_$v1 && _$v1.iconsInText, (_$v1 || _$m) && xd(e1.bucket, i, _$d, _$m, e1.imageMap, s, p, f, _$g, _$x1, e1.canonical, e1.subdivisionGranularity);
                };
                for(var _iterator = e1.bucket.features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            e1.showCollisionBoxes && e1.bucket.generateCollisionDebugBuffers();
        }, t.cR = wu, t.cS = Ru, t.cT = tc, t.cU = function(t) {
            var _$e = new Tc;
            return function(t, e1) {
                for(var _$r in t.layers)e1.writeMessage(3, Pf, t.layers[_$r]);
            }(t, _$e), _$e.finish();
        }, t.cV = function(t, e1, r, n, i, s) {
            var a = jf(t, e1, r, i, 0);
            return a = jf(a, e1, n, s, 1), a;
        }, t.cW = /*#__PURE__*/ function() {
            function _class(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this.maxEntries = t, this.map = new Map;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "get",
                    value: function get(t) {
                        var _$e = this.map.get(t);
                        return void 0 !== _$e && (this.map.delete(t), this.map.set(t, _$e)), _$e;
                    }
                },
                {
                    key: "set",
                    value: function set(t, e1) {
                        if (this.map.has(t)) this.map.delete(t);
                        else if (this.map.size >= this.maxEntries) {
                            var _$t = this.map.keys().next().value;
                            this.map.delete(_$t);
                        }
                        this.map.set(t, e1);
                    }
                },
                {
                    key: "clear",
                    value: function clear() {
                        this.map.clear();
                    }
                }
            ]);
            return _class;
        }(), t.cX = Vu, t.cY = Tc, t.cZ = Ff, t.c_ = /*#__PURE__*/ function() {
            function _class(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this._marks = {
                    start: [
                        t.url,
                        "start"
                    ].join("#"),
                    end: [
                        t.url,
                        "end"
                    ].join("#"),
                    measure: t.url.toString()
                }, performance.mark(this._marks.start);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "finish",
                    value: function finish() {
                        performance.mark(this._marks.end);
                        var _$t = performance.getEntriesByName(this._marks.measure);
                        return 0 === _$t.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), _$t = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), _$t;
                    }
                }
            ]);
            return _class;
        }(), t.ca = /*#__PURE__*/ function(xa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, xa);
            function _class() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, arguments);
            }
            return _class;
        }(xa), t.cb = pc, t.cc = /*#__PURE__*/ function(ba) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, ba);
            function _class() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, arguments);
            }
            return _class;
        }(ba), t.cd = kl, t.ce = function(t) {
            return t <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(t) / Math.LN2));
        }, t.cf = Al, t.cg = function(t, e1, r) {
            var _$n = e1[0], i = e1[1], s = e1[2], a = r[3] * _$n + r[7] * i + r[11] * s + r[15];
            return t[0] = (r[0] * _$n + r[4] * i + r[8] * s + r[12]) / (a = a || 1), t[1] = (r[1] * _$n + r[5] * i + r[9] * s + r[13]) / a, t[2] = (r[2] * _$n + r[6] * i + r[10] * s + r[14]) / a, t;
        }, t.ch = /*#__PURE__*/ function(oa) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, oa);
            function _class() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, arguments);
            }
            return _class;
        }(oa), t.ci = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, Ta);
            function _class() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, arguments);
            }
            return _class;
        }(Ta), t.cj = function(t, e1) {
            return t[0] === e1[0] && t[1] === e1[1] && t[2] === e1[2] && t[3] === e1[3] && t[4] === e1[4] && t[5] === e1[5] && t[6] === e1[6] && t[7] === e1[7] && t[8] === e1[8] && t[9] === e1[9] && t[10] === e1[10] && t[11] === e1[11] && t[12] === e1[12] && t[13] === e1[13] && t[14] === e1[14] && t[15] === e1[15];
        }, t.ck = function(t, e1) {
            var _$r = t[0], _$n = t[1], i = t[2], s = t[3], a = t[4], o = t[5], l = t[6], u = t[7], _$c = t[8], _$h = t[9], f = t[10], _$d = t[11], _$y = t[12], _$m = t[13], _$g = t[14], _$x = t[15], _$v = e1[0], _$b = e1[1], _$w = e1[2], _ = e1[3], S = e1[4], _$A = e1[5], _$k = e1[6], _$E = e1[7], _$T = e1[8], I = e1[9], M = e1[10], _$F = e1[11], _$D = e1[12], _$z = e1[13], _$P = e1[14], _$B = e1[15];
            return Math.abs(_$r - _$v) <= p * Math.max(1, Math.abs(_$r), Math.abs(_$v)) && Math.abs(_$n - _$b) <= p * Math.max(1, Math.abs(_$n), Math.abs(_$b)) && Math.abs(i - _$w) <= p * Math.max(1, Math.abs(i), Math.abs(_$w)) && Math.abs(s - _) <= p * Math.max(1, Math.abs(s), Math.abs(_)) && Math.abs(a - S) <= p * Math.max(1, Math.abs(a), Math.abs(S)) && Math.abs(o - _$A) <= p * Math.max(1, Math.abs(o), Math.abs(_$A)) && Math.abs(l - _$k) <= p * Math.max(1, Math.abs(l), Math.abs(_$k)) && Math.abs(u - _$E) <= p * Math.max(1, Math.abs(u), Math.abs(_$E)) && Math.abs(_$c - _$T) <= p * Math.max(1, Math.abs(_$c), Math.abs(_$T)) && Math.abs(_$h - I) <= p * Math.max(1, Math.abs(_$h), Math.abs(I)) && Math.abs(f - M) <= p * Math.max(1, Math.abs(f), Math.abs(M)) && Math.abs(_$d - _$F) <= p * Math.max(1, Math.abs(_$d), Math.abs(_$F)) && Math.abs(_$y - _$D) <= p * Math.max(1, Math.abs(_$y), Math.abs(_$D)) && Math.abs(_$m - _$z) <= p * Math.max(1, Math.abs(_$m), Math.abs(_$z)) && Math.abs(_$g - _$P) <= p * Math.max(1, Math.abs(_$g), Math.abs(_$P)) && Math.abs(_$x - _$B) <= p * Math.max(1, Math.abs(_$x), Math.abs(_$B));
        }, t.cl = function(t, e1) {
            return t[0] = e1[0], t[1] = e1[1], t[2] = e1[2], t[3] = e1[3], t[4] = e1[4], t[5] = e1[5], t[6] = e1[6], t[7] = e1[7], t[8] = e1[8], t[9] = e1[9], t[10] = e1[10], t[11] = e1[11], t[12] = e1[12], t[13] = e1[13], t[14] = e1[14], t[15] = e1[15], t;
        }, t.cm = function(t) {
            return "symbol" === t.type;
        }, t.cn = function(t) {
            return "circle" === t.type;
        }, t.co = function(t) {
            return "heatmap" === t.type;
        }, t.cp = function(t) {
            return "line" === t.type;
        }, t.cq = function(t) {
            return "fill" === t.type;
        }, t.cr = function(t) {
            return "fill-extrusion" === t.type;
        }, t.cs = function(t) {
            return "hillshade" === t.type;
        }, t.ct = function(t) {
            return "color-relief" === t.type;
        }, t.cu = function(t) {
            return "background" === t.type;
        }, t.cv = function(t) {
            return "custom" === t.type;
        }, t.cw = B, t.cx = function(t, e1, r) {
            var _$n = I(e1.x - r.x, e1.y - r.y), i = I(t.x - r.x, t.y - r.y), s = Math.atan2(_$n[0] * i[1] - _$n[1] * i[0], function(t, e1) {
                return t[0] * e1[0] + t[1] * e1[1];
            }(_$n, i));
            return et(s);
        }, t.cy = V, t.cz = function(t, e1) {
            return nt[e1] && (t instanceof MouseEvent || t instanceof WheelEvent);
        }, t.d = ft, t.d0 = Pl, t.d1 = n, t.d2 = /*#__PURE__*/ function() {
            function _class(t, e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this.layers = (0, $6194eebaf067e4d1$export$71511d61b312f219)({}, zf, this), this.name = zf, this.version = e1 ? e1.version : 1, this.extent = e1 ? e1.extent : 4096, this.length = t.length, this.features = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "feature",
                    value: function feature(t) {
                        return new Df(this.features[t], this.extent);
                    }
                }
            ]);
            return _class;
        }(), t.d3 = ni, t.d4 = zs, t.e = O, t.f = function(t) {
            return e1(void 0, void 0, void 0, function() {
                var _$e;
                return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                    if (0 === t.byteLength) return [
                        2,
                        createImageBitmap(new ImageData(1, 1))
                    ];
                    _$e = new Blob([
                        new Uint8Array(t)
                    ], {
                        type: "image/png"
                    });
                    try {
                        return [
                            2,
                            createImageBitmap(_$e)
                        ];
                    } catch (t) {
                        throw new Error("Could not load image because of ".concat(t.message, ". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    }
                    return [
                        2
                    ];
                });
            });
        }, t.g = lt, t.h = function(t) {
            return new Promise(function(e1, r) {
                var _$n = new Image;
                _$n.onload = function() {
                    e1(_$n), URL.revokeObjectURL(_$n.src), _$n.onload = null, window.requestAnimationFrame(function() {
                        _$n.src = H;
                    });
                }, _$n.onerror = function() {
                    return r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                };
                var i = new Blob([
                    new Uint8Array(t)
                ], {
                    type: "image/png"
                });
                _$n.src = t.byteLength ? URL.createObjectURL(i) : H;
            });
        }, t.i = X, t.j = function(t, e1) {
            return pt(O(t, {
                type: "json"
            }), e1);
        }, t.k = gt, t.l = mt, t.m = pt, t.n = function(t, e1) {
            return pt(O(t, {
                type: "arrayBuffer"
            }), e1);
        }, t.o = function(t) {
            return new Tc(t).readFields(Rc, []);
        }, t.p = Uc, t.q = function(t) {
            return /[\u02EA\u02EB\u1100-\u11FF\u2E80-\u2FDF\u3000-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(t));
        }, t.r = _l, t.s = Q, t.t = Hs, t.u = vt, t.v = ns, t.w = j, t.x = Os, t.y = ss, t.z = Vs;
    });
    define("worker", [
        "./shared"
    ], function(e1) {
        "use strict";
        var t = /*#__PURE__*/ function() {
            function t(e1, t1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, t);
                this.keyCache = {}, e1 && this.replace(e1, t1);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(t, [
                {
                    key: "replace",
                    value: function replace(e1, t) {
                        this._layerConfigs = {}, this._layers = {}, this.update(e1, [], t);
                    }
                },
                {
                    key: "update",
                    value: function update(t, o, i) {
                        var _this = this;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$o = _step.value;
                                this._layerConfigs[_$o.id] = _$o;
                                var _$t = this._layers[_$o.id] = e1.bT(_$o, i);
                                _$t._featureFilter = e1.aj(_$t.filter, i), this.keyCache[_$o.id] && delete this.keyCache[_$o.id];
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = o[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$e = _step1.value;
                                delete this.keyCache[_$e], delete this._layerConfigs[_$e], delete this._layers[_$e];
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        this.familiesBySource = {};
                        var s = e1.cL(Object.values(this._layerConfigs), this.keyCache);
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = s[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var _$t1 = _step2.value;
                                var _$o1 = _$t1.map(function(e1) {
                                    return _this._layers[e1.id];
                                }), _$i = _$o1[0];
                                if (_$i.isHidden()) continue;
                                var s1 = _$i.source || "";
                                var n = this.familiesBySource[s1];
                                n || (n = this.familiesBySource[s1] = {});
                                var r = _$i.sourceLayer || e1.ai;
                                var a = n[r];
                                a || (a = n[r] = []), a.push(_$o1);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                }
            ]);
            return t;
        }();
        var o = function o(t) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, o);
            var _$o = {}, i = [];
            for(var _$e in t){
                var s = t[_$e], n = _$o[_$e] = {};
                for(var _$e1 in s){
                    var _$t = s[+_$e1];
                    if (!_$t || 0 === _$t.bitmap.width || 0 === _$t.bitmap.height) continue;
                    var _$o1 = {
                        x: 0,
                        y: 0,
                        w: _$t.bitmap.width + 2,
                        h: _$t.bitmap.height + 2
                    };
                    i.push(_$o1), n[_$e1] = {
                        rect: _$o1,
                        metrics: _$t.metrics
                    };
                }
            }
            var _e_p = e1.p(i), s1 = _e_p.w, n1 = _e_p.h, r = new e1.r({
                width: s1 || 1,
                height: n1 || 1
            });
            for(var i1 in t){
                var s2 = t[i1];
                for(var _$t1 in s2){
                    var n2 = s2[+_$t1];
                    if (!n2 || 0 === n2.bitmap.width || 0 === n2.bitmap.height) continue;
                    var a = _$o[i1][_$t1].rect;
                    e1.r.copy(n2.bitmap, r, {
                        x: 0,
                        y: 0
                    }, {
                        x: a.x + 1,
                        y: a.y + 1
                    }, n2.bitmap);
                }
            }
            this.image = r, this.positions = _$o;
        };
        e1.cM("GlyphAtlas", o);
        var i = /*#__PURE__*/ function() {
            function i(t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, i);
                this.tileID = new e1.a2(t.tileID.overscaledZ, t.tileID.wrap, t.tileID.canonical.z, t.tileID.canonical.x, t.tileID.canonical.y), this.uid = t.uid, this.zoom = t.zoom, this.pixelRatio = t.pixelRatio, this.tileSize = t.tileSize, this.source = t.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = t.showCollisionBoxes, this.collectResourceTiming = !!t.collectResourceTiming, this.returnDependencies = !!t.returnDependencies, this.promoteId = t.promoteId, this.inFlightDependencies = [];
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(i, [
                {
                    key: "parse",
                    value: function parse(t, i, n, r, a) {
                        return e1._(this, void 0, void 0, function() {
                            var l, c, h, u, d, o1, _$i, _$r, _$a, _$e, _$t, _$s, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$t1, o2, g, f, _$e1, p, m, _$e2, y, v, _$e3, x, _, _$e4, _ref, w, S, b, M, I, P, _$t2, o3;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        this.status = "parsing", this.data = t, this.collisionBoxArray = new e1.ag;
                                        l = new e1.cN(Object.keys(t.layers).sort()), c = new e1.cO(this.tileID, this.promoteId);
                                        c.bucketLayerIDs = [];
                                        h = {}, u = {
                                            featureIndex: c,
                                            iconDependencies: {},
                                            patternDependencies: {},
                                            glyphDependencies: {},
                                            dashDependencies: {},
                                            availableImages: n,
                                            subdivisionGranularity: a
                                        }, d = i.familiesBySource[this.source];
                                        for(var o1 in d){
                                            _$i = t.layers[o1];
                                            if (!_$i) continue;
                                            1 === _$i.version && e1.w('Vector tile source "'.concat(this.source, '" layer "').concat(o1, '" does not use vector tile spec v2 and therefore may have some rendering errors.'));
                                            _$r = l.encode(o1), _$a = [];
                                            for(_$e = 0; _$e < _$i.length; _$e++){
                                                _$t = _$i.feature(_$e), _$s = c.getId(_$t, o1);
                                                _$a.push({
                                                    feature: _$t,
                                                    id: _$s,
                                                    index: _$e,
                                                    sourceLayerIndex: _$r
                                                });
                                            }
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = d[o1][Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    _$t1 = _step.value;
                                                    o2 = _$t1[0];
                                                    o2.source !== this.source && e1.w("layer.source = ".concat(o2.source, " does not equal this.source = ").concat(this.source)), o2.isHidden(this.zoom, !0) || (s(_$t1, this.zoom, n), (h[o2.id] = o2.createBucket({
                                                        index: c.bucketLayerIDs.length,
                                                        layers: _$t1,
                                                        zoom: this.zoom,
                                                        pixelRatio: this.pixelRatio,
                                                        overscaling: this.overscaling,
                                                        collisionBoxArray: this.collisionBoxArray,
                                                        sourceLayerIndex: _$r,
                                                        sourceID: this.source
                                                    })).populate(_$a, u, this.tileID.canonical), c.bucketLayerIDs.push(_$t1.map(function(e1) {
                                                        return e1.id;
                                                    })));
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        }
                                        g = e1.bY(u.glyphDependencies, function(e1) {
                                            return Object.keys(e1).map(Number);
                                        });
                                        this.inFlightDependencies.forEach(function(e1) {
                                            return null == e1 ? void 0 : e1.abort();
                                        }), this.inFlightDependencies = [];
                                        f = Promise.resolve({});
                                        if (Object.keys(g).length) {
                                            _$e1 = new AbortController;
                                            this.inFlightDependencies.push(_$e1), f = r.sendAsync({
                                                type: "GG",
                                                data: {
                                                    stacks: g,
                                                    source: this.source,
                                                    tileID: this.tileID,
                                                    type: "glyphs"
                                                }
                                            }, _$e1);
                                        }
                                        p = Object.keys(u.iconDependencies);
                                        m = Promise.resolve({});
                                        if (p.length) {
                                            _$e2 = new AbortController;
                                            this.inFlightDependencies.push(_$e2), m = r.sendAsync({
                                                type: "GI",
                                                data: {
                                                    icons: p,
                                                    source: this.source,
                                                    tileID: this.tileID,
                                                    type: "icons"
                                                }
                                            }, _$e2);
                                        }
                                        y = Object.keys(u.patternDependencies);
                                        v = Promise.resolve({});
                                        if (y.length) {
                                            _$e3 = new AbortController;
                                            this.inFlightDependencies.push(_$e3), v = r.sendAsync({
                                                type: "GI",
                                                data: {
                                                    icons: y,
                                                    source: this.source,
                                                    tileID: this.tileID,
                                                    type: "patterns"
                                                }
                                            }, _$e3);
                                        }
                                        x = u.dashDependencies;
                                        _ = Promise.resolve({});
                                        if (Object.keys(x).length) {
                                            _$e4 = new AbortController;
                                            this.inFlightDependencies.push(_$e4), _ = r.sendAsync({
                                                type: "GDA",
                                                data: {
                                                    dashes: x
                                                }
                                            }, _$e4);
                                        }
                                        return [
                                            4,
                                            Promise.all([
                                                f,
                                                m,
                                                v,
                                                _
                                            ])
                                        ];
                                    case 1:
                                        _ref = (0, $db95b225ee8036d6$export$71511d61b312f219).apply(void 0, [
                                            _state.sent(),
                                            4
                                        ]), w = _ref[0], S = _ref[1], b = _ref[2], M = _ref[3], I = new o(w), P = new e1.cP(S, b);
                                        for(var _$t2 in h){
                                            o3 = h[_$t2];
                                            o3 instanceof e1.ah ? (s(o3.layers, this.zoom, n), e1.cQ({
                                                bucket: o3,
                                                glyphMap: w,
                                                glyphPositions: I.positions,
                                                imageMap: S,
                                                imagePositions: P.iconPositions,
                                                showCollisionBoxes: this.showCollisionBoxes,
                                                canonical: this.tileID.canonical,
                                                subdivisionGranularity: u.subdivisionGranularity
                                            })) : o3.hasDependencies && (o3 instanceof e1.cR || o3 instanceof e1.cS || o3 instanceof e1.cT) && (s(o3.layers, this.zoom, n), o3.addFeatures(u, this.tileID.canonical, P.patternPositions, M));
                                        }
                                        return [
                                            2,
                                            (this.status = "done", {
                                                buckets: Object.values(h).filter(function(e1) {
                                                    return !e1.isEmpty();
                                                }),
                                                featureIndex: c,
                                                collisionBoxArray: this.collisionBoxArray,
                                                glyphAtlasImage: I.image,
                                                imageAtlas: P,
                                                dashPositions: M,
                                                glyphMap: this.returnDependencies ? w : null,
                                                iconMap: this.returnDependencies ? S : null,
                                                glyphPositions: this.returnDependencies ? I.positions : null
                                            })
                                        ];
                                }
                            });
                        });
                    }
                }
            ]);
            return i;
        }();
        function s(t, o, i) {
            var s = new e1.H(o);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e = _step.value;
                    _$e.recalculate(s, i);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var n = /*#__PURE__*/ function() {
            function n(e1, t, o, i, s) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, n);
                this.type = e1, this.properties = o || {}, this.extent = s, this.pointsArray = t, this.id = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(n, [
                {
                    key: "loadGeometry",
                    value: function loadGeometry() {
                        return this.pointsArray.map(function(t) {
                            return t.map(function(t) {
                                return new e1.P(t.x, t.y);
                            });
                        });
                    }
                }
            ]);
            return n;
        }();
        var r = /*#__PURE__*/ function() {
            function r(e1, t, o) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, r);
                this.version = 2, this._myFeatures = e1, this.name = t, this.length = e1.length, this.extent = o;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(r, [
                {
                    key: "feature",
                    value: function feature(e1) {
                        return this._myFeatures[e1];
                    }
                }
            ]);
            return r;
        }();
        var a = /*#__PURE__*/ function() {
            function a() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, a);
                this.layers = {};
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(a, [
                {
                    key: "addLayer",
                    value: function addLayer(e1) {
                        this.layers[e1.name] = e1;
                    }
                }
            ]);
            return a;
        }();
        function l(t) {
            var o = e1.cU(t);
            return 0 === o.byteOffset && o.byteLength === o.buffer.byteLength || (o = new Uint8Array(o)), {
                vectorTile: t,
                rawData: o.buffer
            };
        }
        function c(t, o, i) {
            var s = t.extent, a = Math.pow(2, i.z - o.z), l = (i.x - o.x * a) * s, c = (i.y - o.y * a) * s, h = [];
            for(var _$o = 0; _$o < t.length; _$o++){
                var _$i = t.feature(_$o);
                var r1 = _$i.loadGeometry();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator = r1[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                        var _$e = _step.value;
                        try {
                            for(var _iterator1 = _$e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step1.value;
                                _$t.x = _$t.x * a - l, _$t.y = _$t.y * a - c;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                var u = 128;
                r1 = e1.cV(r1, _$i.type, -u, -u, s + u, s + u), 0 !== r1.length && h.push(new n(_$i.type, r1, _$i.properties, _$i.id, s));
            }
            return new r(h, t.name, s);
        }
        var h = /*#__PURE__*/ function() {
            function h(t, o, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, h);
                this.actor = t, this.layerIndex = o, this.availableImages = i, this.fetching = {}, this.loading = {}, this.loaded = {}, this.overzoomedTileResultCache = new e1.cW(1e3);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(h, [
                {
                    key: "loadVectorTile",
                    value: function loadVectorTile(t, o) {
                        return e1._(this, void 0, void 0, function() {
                            var i, _$o, s;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            e1.n(t.request, o)
                                        ];
                                    case 1:
                                        i = _state.sent();
                                        try {
                                            return [
                                                2,
                                                {
                                                    vectorTile: "mlt" !== t.encoding ? new e1.cX(new e1.cY(i.data)) : new e1.cZ(i.data),
                                                    rawData: i.data,
                                                    cacheControl: i.cacheControl,
                                                    expires: i.expires
                                                }
                                            ];
                                        } catch (e1) {
                                            _$o = new Uint8Array(i.data);
                                            s = "Unable to parse the tile at ".concat(t.request.url, ", ");
                                            throw s += 31 === _$o[0] && 139 === _$o[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : "got error: ".concat(e1.message), new Error(s);
                                        }
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "loadTile",
                    value: function loadTile(t) {
                        return e1._(this, void 0, void 0, function() {
                            var o, s, n, r, a, i1, _$e, l, c, _$h, _$e1, u, o1, e2;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        o = t.uid, s = t.overzoomParameters;
                                        s && (t.request = s.overzoomRequest);
                                        n = !!(t && t.request && t.request.collectResourceTiming) && new e1.c_(t.request), r = new i(t);
                                        this.loading[o] = r;
                                        a = new AbortController;
                                        r.abort = a;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            7,
                                            ,
                                            8
                                        ]);
                                        return [
                                            4,
                                            this.loadVectorTile(t, a)
                                        ];
                                    case 2:
                                        i1 = _state.sent();
                                        if (delete this.loading[o], !i1) return [
                                            2,
                                            null
                                        ];
                                        if (s) {
                                            _$e = this._getOverzoomTile(t, i1.vectorTile);
                                            i1.rawData = _$e.rawData, i1.vectorTile = _$e.vectorTile;
                                        }
                                        l = i1.rawData, c = {};
                                        i1.expires && (c.expires = i1.expires), i1.cacheControl && (c.cacheControl = i1.cacheControl);
                                        _$h = {};
                                        if (n) {
                                            _$e1 = n.finish();
                                            _$e1 && (_$h.resourceTiming = JSON.parse(JSON.stringify(_$e1)));
                                        }
                                        r.vectorTile = i1.vectorTile;
                                        u = r.parse(i1.vectorTile, this.layerIndex, this.availableImages, this.actor, t.subdivisionGranularity);
                                        this.loaded[o] = r, this.fetching[o] = {
                                            rawTileData: l,
                                            cacheControl: c,
                                            resourceTiming: _$h
                                        };
                                        _state.label = 3;
                                    case 3:
                                        _state.trys.push([
                                            3,
                                            ,
                                            5,
                                            6
                                        ]);
                                        return [
                                            4,
                                            u
                                        ];
                                    case 4:
                                        o1 = _state.sent();
                                        return [
                                            2,
                                            e1.e({
                                                rawTileData: l.slice(0),
                                                encoding: t.encoding
                                            }, o1, c, _$h)
                                        ];
                                    case 5:
                                        delete this.fetching[o];
                                        return [
                                            7
                                        ];
                                    case 6:
                                        return [
                                            3,
                                            8
                                        ];
                                    case 7:
                                        e2 = _state.sent();
                                        throw delete this.loading[o], r.status = "done", this.loaded[o] = r, e2;
                                    case 8:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_getOverzoomTile",
                    value: function _getOverzoomTile(e1, t) {
                        var o = e1.tileID, i = e1.source, s = e1.overzoomParameters, n = s.maxZoomTileID, r = "".concat(n.key, "_").concat(o.key), _$h = this.overzoomedTileResultCache.get(r);
                        if (_$h) return _$h;
                        var u = new a, d = this.layerIndex.familiesBySource[i];
                        for(var _$e in d){
                            var i1 = t.layers[_$e];
                            if (!i1) continue;
                            var s1 = c(i1, n, o.canonical);
                            s1.length > 0 && u.addLayer(s1);
                        }
                        var g = l(u);
                        return this.overzoomedTileResultCache.set(r, g), g;
                    }
                },
                {
                    key: "reloadTile",
                    value: function reloadTile(t) {
                        return e1._(this, void 0, void 0, function() {
                            var o, i, s, n, _this_fetching_o, i1, r, a;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        o = t.uid;
                                        if (!this.loaded || !this.loaded[o]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                                        i = this.loaded[o];
                                        if (!(i.showCollisionBoxes = t.showCollisionBoxes, "parsing" === i.status)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            i.parse(i.vectorTile, this.layerIndex, this.availableImages, this.actor, t.subdivisionGranularity)
                                        ];
                                    case 1:
                                        s = _state.sent();
                                        if (this.fetching[o]) {
                                            _this_fetching_o = this.fetching[o], i1 = _this_fetching_o.rawTileData, r = _this_fetching_o.cacheControl, a = _this_fetching_o.resourceTiming;
                                            delete this.fetching[o], n = e1.e({
                                                rawTileData: i1.slice(0),
                                                encoding: t.encoding
                                            }, s, r, a);
                                        } else n = s;
                                        return [
                                            2,
                                            n
                                        ];
                                    case 2:
                                        if ("done" === i.status && i.vectorTile) return [
                                            2,
                                            i.parse(i.vectorTile, this.layerIndex, this.availableImages, this.actor, t.subdivisionGranularity)
                                        ];
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "abortTile",
                    value: function abortTile(t) {
                        return e1._(this, void 0, void 0, function() {
                            var _$e, o;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                _$e = this.loading, o = t.uid;
                                _$e && _$e[o] && _$e[o].abort && (_$e[o].abort.abort(), delete _$e[o]);
                                return [
                                    2
                                ];
                            });
                        });
                    }
                },
                {
                    key: "removeTile",
                    value: function removeTile(t) {
                        return e1._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                this.loaded && this.loaded[t.uid] && delete this.loaded[t.uid];
                                return [
                                    2
                                ];
                            });
                        });
                    }
                }
            ]);
            return h;
        }();
        var u = /*#__PURE__*/ function() {
            function u() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, u);
                this.loaded = {};
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(u, [
                {
                    key: "loadTile",
                    value: function loadTile(t) {
                        return e1._(this, void 0, void 0, function() {
                            var o, i, s, n, r, a, l, c, h, _$u, d, _tmp, _, _1, _tmp1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        o = t.uid, i = t.encoding, s = t.rawImageData, n = t.redFactor, r = t.greenFactor, a = t.blueFactor, l = t.baseShift, c = s.width + 2, h = s.height + 2;
                                        if (!e1.b(s)) return [
                                            3,
                                            2
                                        ];
                                        _1 = (_ = e1.R).bind;
                                        _tmp1 = [
                                            void 0,
                                            {
                                                width: c,
                                                height: h
                                            }
                                        ];
                                        return [
                                            4,
                                            e1.c$(s, -1, -1, c, h)
                                        ];
                                    case 1:
                                        _tmp = new (_1.apply(_, _tmp1.concat([
                                            _state.sent()
                                        ])));
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        _tmp = s;
                                        _state.label = 3;
                                    case 3:
                                        _$u = _tmp, d = new e1.d0(o, _$u, i, n, r, a, l);
                                        return [
                                            2,
                                            (this.loaded = this.loaded || {}, this.loaded[o] = d, d)
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "removeTile",
                    value: function removeTile(e1) {
                        var t = this.loaded, o = e1.uid;
                        t && t[o] && delete t[o];
                    }
                }
            ]);
            return u;
        }();
        var d, g, f = function() {
            if (g) return d;
            function e1(e1, o) {
                if (0 !== e1.length) {
                    t(e1[0], o);
                    for(var i = 1; i < e1.length; i++)t(e1[i], !o);
                }
            }
            function t(e1, t) {
                for(var o = 0, i = 0, s = 0, n = e1.length, r = n - 1; s < n; r = s++){
                    var a = (e1[s][0] - e1[r][0]) * (e1[r][1] + e1[s][1]), l = o + a;
                    i += Math.abs(o) >= Math.abs(a) ? o - l + a : a - l + o, o = l;
                }
                o + i >= 0 != !!t && e1.reverse();
            }
            return g = 1, d = function t(o, i) {
                var s, n = o && o.type;
                if ("FeatureCollection" === n) for(s = 0; s < o.features.length; s++)t(o.features[s], i);
                else if ("GeometryCollection" === n) for(s = 0; s < o.geometries.length; s++)t(o.geometries[s], i);
                else if ("Feature" === n) t(o.geometry, i);
                else if ("Polygon" === n) e1(o.coordinates, i);
                else if ("MultiPolygon" === n) for(s = 0; s < o.coordinates.length; s++)e1(o.coordinates[s], i);
                return o;
            };
        }(), p = e1.d1(f);
        var m = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: function(e1) {
                return e1;
            }
        }, y = Math.fround || (v = new Float32Array(1), function(e1) {
            return v[0] = +e1, v[0];
        });
        var v;
        var x = /*#__PURE__*/ function() {
            function x(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, x);
                this.options = Object.assign(Object.create(m), e1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(x, [
                {
                    key: "load",
                    value: function load(e1) {
                        var _this_options = this.options, t = _this_options.log, o = _this_options.minZoom, i = _this_options.maxZoom;
                        t && console.time("total time");
                        var s = "prepare ".concat(e1.length, " points");
                        t && console.time(s), this.points = e1;
                        var n = [];
                        for(var t1 = 0; t1 < e1.length; t1++){
                            var o1 = e1[t1];
                            if (!o1.geometry) continue;
                            var _o_geometry_coordinates = (0, $db95b225ee8036d6$export$71511d61b312f219)(o1.geometry.coordinates, 2), i1 = _o_geometry_coordinates[0], s1 = _o_geometry_coordinates[1], r = y(S(i1)), a = y(b(s1));
                            n.push(r, a, 1 / 0, t1, -1, 1), this.options.reduce && n.push(0);
                        }
                        var r1 = this.trees[i + 1] = this._createTree(n);
                        t && console.timeEnd(s);
                        for(var _$e = i; _$e >= o; _$e--){
                            var o2 = +Date.now();
                            r1 = this.trees[_$e] = this._createTree(this._cluster(r1, _$e)), t && console.log("z%d: %d clusters in %dms", _$e, r1.numItems, +Date.now() - o2);
                        }
                        return t && console.timeEnd("total time"), this;
                    }
                },
                {
                    key: "getClusters",
                    value: function getClusters(e1, t) {
                        var o = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                        var i = Math.max(-90, Math.min(90, e1[1]));
                        var s = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                        var n = Math.max(-90, Math.min(90, e1[3]));
                        if (e1[2] - e1[0] >= 360) o = -180, s = 180;
                        else if (o > s) {
                            var _$e = this.getClusters([
                                o,
                                i,
                                180,
                                n
                            ], t), r = this.getClusters([
                                -180,
                                i,
                                s,
                                n
                            ], t);
                            return _$e.concat(r);
                        }
                        var r1 = this.trees[this._limitZoom(t)], a = r1.range(S(o), b(n), S(s), b(i)), l = r1.data, c = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e1 = _step.value;
                                var _$t = this.stride * _$e1;
                                c.push(l[_$t + 5] > 1 ? _(l, _$t, this.clusterProps) : this.points[l[_$t + 3]]);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return c;
                    }
                },
                {
                    key: "getChildren",
                    value: function getChildren(e1) {
                        var t = this._getOriginId(e1), o = this._getOriginZoom(e1), i = "No cluster with the specified id.", s = this.trees[o];
                        if (!s) throw new Error(i);
                        var n = s.data;
                        if (t * this.stride >= n.length) throw new Error(i);
                        var r = this.options.radius / (this.options.extent * Math.pow(2, o - 1)), a = s.within(n[t * this.stride], n[t * this.stride + 1], r), l = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var t1 = _step.value;
                                var o1 = t1 * this.stride;
                                n[o1 + 4] === e1 && l.push(n[o1 + 5] > 1 ? _(n, o1, this.clusterProps) : this.points[n[o1 + 3]]);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (0 === l.length) throw new Error(i);
                        return l;
                    }
                },
                {
                    key: "getLeaves",
                    value: function getLeaves(e1, t, o) {
                        var i = [];
                        return this._appendLeaves(i, e1, t = t || 10, o = o || 0, 0), i;
                    }
                },
                {
                    key: "getTile",
                    value: function getTile(e1, t, o) {
                        var i = this.trees[this._limitZoom(e1)], s = Math.pow(2, e1), _this_options = this.options, n = _this_options.extent, r = _this_options.radius, a = r / n, l = (o - a) / s, c = (o + 1 + a) / s, h = {
                            features: []
                        };
                        return this._addTileFeatures(i.range((t - a) / s, l, (t + 1 + a) / s, c), i.data, t, o, s, h), 0 === t && this._addTileFeatures(i.range(1 - a / s, l, 1, c), i.data, s, o, s, h), t === s - 1 && this._addTileFeatures(i.range(0, l, a / s, c), i.data, -1, o, s, h), h.features.length ? h : null;
                    }
                },
                {
                    key: "getClusterExpansionZoom",
                    value: function getClusterExpansionZoom(e1) {
                        var t = this._getOriginZoom(e1) - 1;
                        for(; t <= this.options.maxZoom;){
                            var o = this.getChildren(e1);
                            if (t++, 1 !== o.length) break;
                            e1 = o[0].properties.cluster_id;
                        }
                        return t;
                    }
                },
                {
                    key: "_appendLeaves",
                    value: function _appendLeaves(e1, t, o, i, s) {
                        var n = this.getChildren(t);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = n[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                var n1 = _$t.properties;
                                if (n1 && n1.cluster ? s + n1.point_count <= i ? s += n1.point_count : s = this._appendLeaves(e1, n1.cluster_id, o, i, s) : s < i ? s++ : e1.push(_$t), e1.length === o) break;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return s;
                    }
                },
                {
                    key: "_createTree",
                    value: function _createTree(t) {
                        var o = new e1.aT(t.length / this.stride | 0, this.options.nodeSize, Float32Array);
                        for(var _$e = 0; _$e < t.length; _$e += this.stride)o.add(t[_$e], t[_$e + 1]);
                        return o.finish(), o.data = t, o;
                    }
                },
                {
                    key: "_addTileFeatures",
                    value: function _addTileFeatures(e1, t, o, i, s, n) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var r = _step.value;
                                var _$e = r * this.stride, a = t[_$e + 5] > 1;
                                var l = void 0, c = void 0, h = void 0;
                                if (a) l = w(t, _$e, this.clusterProps), c = t[_$e], h = t[_$e + 1];
                                else {
                                    var _$o = this.points[t[_$e + 3]];
                                    l = _$o.properties;
                                    var _o_geometry_coordinates = (0, $db95b225ee8036d6$export$71511d61b312f219)(_$o.geometry.coordinates, 2), _$i = _o_geometry_coordinates[0], _$s = _o_geometry_coordinates[1];
                                    c = S(_$i), h = b(_$s);
                                }
                                var u = {
                                    type: 1,
                                    geometry: [
                                        [
                                            Math.round(this.options.extent * (c * s - o)),
                                            Math.round(this.options.extent * (h * s - i))
                                        ]
                                    ],
                                    tags: l
                                };
                                var d = void 0;
                                d = a || this.options.generateId ? t[_$e + 3] : this.points[t[_$e + 3]].id, void 0 !== d && (u.id = d), n.features.push(u);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_limitZoom",
                    value: function _limitZoom(e1) {
                        return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
                    }
                },
                {
                    key: "_cluster",
                    value: function _cluster(e1, t) {
                        var _this_options = this.options, o = _this_options.radius, i = _this_options.extent, s = _this_options.reduce, n = _this_options.minPoints, r = o / (i * Math.pow(2, t)), a = e1.data, l = [], c = this.stride;
                        for(var o1 = 0; o1 < a.length; o1 += c){
                            if (a[o1 + 2] <= t) continue;
                            a[o1 + 2] = t;
                            var i1 = a[o1], h = a[o1 + 1], u = e1.within(a[o1], a[o1 + 1], r), d = a[o1 + 5];
                            var g = d;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = u[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    var o2 = _$e * c;
                                    a[o2 + 2] > t && (g += a[o2 + 5]);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            if (g > d && g >= n) {
                                var _$e1 = void 0, n1 = i1 * d, r1 = h * d, f = -1;
                                var p = (o1 / c << 5) + (t + 1) + this.points.length;
                                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                try {
                                    for(var _iterator1 = u[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        var i2 = _step1.value;
                                        var l1 = i2 * c;
                                        if (a[l1 + 2] <= t) continue;
                                        a[l1 + 2] = t;
                                        var h1 = a[l1 + 5];
                                        n1 += a[l1] * h1, r1 += a[l1 + 1] * h1, a[l1 + 4] = p, s && (_$e1 || (_$e1 = this._map(a, o1, !0), f = this.clusterProps.length, this.clusterProps.push(_$e1)), s(_$e1, this._map(a, l1)));
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                a[o1 + 4] = p, l.push(n1 / g, r1 / g, 1 / 0, p, -1, g), s && l.push(f);
                            } else {
                                for(var _$e2 = 0; _$e2 < c; _$e2++)l.push(a[o1 + _$e2]);
                                var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                                if (g > 1) try {
                                    for(var _iterator2 = u[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                        var _$e3 = _step2.value;
                                        var o3 = _$e3 * c;
                                        if (!(a[o3 + 2] <= t)) {
                                            a[o3 + 2] = t;
                                            for(var _$e4 = 0; _$e4 < c; _$e4++)l.push(a[o3 + _$e4]);
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError2 = true;
                                    _iteratorError2 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                            _iterator2.return();
                                        }
                                    } finally{
                                        if (_didIteratorError2) {
                                            throw _iteratorError2;
                                        }
                                    }
                                }
                            }
                        }
                        return l;
                    }
                },
                {
                    key: "_getOriginId",
                    value: function _getOriginId(e1) {
                        return e1 - this.points.length >> 5;
                    }
                },
                {
                    key: "_getOriginZoom",
                    value: function _getOriginZoom(e1) {
                        return (e1 - this.points.length) % 32;
                    }
                },
                {
                    key: "_map",
                    value: function _map(e1, t, o) {
                        if (e1[t + 5] > 1) {
                            var i = this.clusterProps[e1[t + 6]];
                            return o ? Object.assign({}, i) : i;
                        }
                        var i1 = this.points[e1[t + 3]].properties, s = this.options.map(i1);
                        return o && s === i1 ? Object.assign({}, s) : s;
                    }
                }
            ]);
            return x;
        }();
        function _(e1, t, o) {
            var i;
            return {
                type: "Feature",
                id: e1[t + 3],
                properties: w(e1, t, o),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e1[t], 360 * (i - .5)),
                        M(e1[t + 1])
                    ]
                }
            };
        }
        function w(e1, t, o) {
            var i = e1[t + 5], s = i >= 1e4 ? "".concat(Math.round(i / 1e3), "k") : i >= 1e3 ? Math.round(i / 100) / 10 + "k" : i, n = e1[t + 6], r = -1 === n ? {} : Object.assign({}, o[n]);
            return Object.assign(r, {
                cluster: !0,
                cluster_id: e1[t + 3],
                point_count: i,
                point_count_abbreviated: s
            });
        }
        function S(e1) {
            return e1 / 360 + .5;
        }
        function b(e1) {
            var t = Math.sin(e1 * Math.PI / 180), o = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function M(e1) {
            var t = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t)) / Math.PI - 90;
        }
        function I(e1, t, o, i) {
            var s = i;
            var n = t + (o - t >> 1);
            var r, a = o - t;
            var l = e1[t], c = e1[t + 1], h = e1[o], u = e1[o + 1];
            for(var _$i = t + 3; _$i < o; _$i += 3){
                var _$t = P(e1[_$i], e1[_$i + 1], l, c, h, u);
                if (_$t > s) r = _$i, s = _$t;
                else if (_$t === s) {
                    var _$e = Math.abs(_$i - n);
                    _$e < a && (r = _$i, a = _$e);
                }
            }
            s > i && (r - t > 3 && I(e1, t, r, i), e1[r + 2] = s, o - r > 3 && I(e1, r, o, i));
        }
        function P(e1, t, o, i, s, n) {
            var r = s - o, a = n - i;
            if (0 !== r || 0 !== a) {
                var l = ((e1 - o) * r + (t - i) * a) / (r * r + a * a);
                l > 1 ? (o = s, i = n) : l > 0 && (o += r * l, i += a * l);
            }
            return r = e1 - o, a = t - i, r * r + a * a;
        }
        function D(e1, t, o, i) {
            var s = {
                id: null == e1 ? null : e1,
                type: t,
                geometry: o,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if ("Point" === t || "MultiPoint" === t || "LineString" === t) T(s, o);
            else if ("Polygon" === t) T(s, o[0]);
            else if ("MultiLineString" === t) try {
                for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e = _step.value;
                    T(s, _$e);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else if ("MultiPolygon" === t) try {
                for(var _iterator1 = o[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _$e1 = _step1.value;
                    T(s, _$e1[0]);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            return s;
        }
        function T(e1, t) {
            for(var o = 0; o < t.length; o += 3)e1.minX = Math.min(e1.minX, t[o]), e1.minY = Math.min(e1.minY, t[o + 1]), e1.maxX = Math.max(e1.maxX, t[o]), e1.maxY = Math.max(e1.maxY, t[o + 1]);
        }
        function k(e1, t, o, i) {
            if (!t.geometry) return;
            var s = t.geometry.coordinates;
            if (s && 0 === s.length) return;
            var n = t.geometry.type, r = Math.pow(o.tolerance / ((1 << o.maxZoom) * o.extent), 2);
            var a = [], l = t.id;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (o.promoteId ? l = t.properties[o.promoteId] : o.generateId && (l = i || 0), "Point" === n) C(s, a);
            else if ("MultiPoint" === n) try {
                for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e = _step.value;
                    C(_$e, a);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else if ("LineString" === n) O(s, a, r, !1);
            else if ("MultiLineString" === n) {
                if (o.lineMetrics) {
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = s[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _$o = _step1.value;
                            a = [], O(_$o, a, r, !1), e1.push(D(l, "LineString", a, t.properties));
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return;
                }
                L(s, a, r, !1);
            } else if ("Polygon" === n) L(s, a, r, !0);
            else {
                if ("MultiPolygon" !== n) {
                    if ("GeometryCollection" === n) {
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = t.geometry.geometries[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var s1 = _step2.value;
                                k(e1, {
                                    id: l,
                                    geometry: s1,
                                    properties: t.properties
                                }, o, i);
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        return;
                    }
                    throw new Error("Input data is not a valid GeoJSON object.");
                }
                var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                try {
                    for(var _iterator3 = s[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                        var _$e1 = _step3.value;
                        var _$t = [];
                        L(_$e1, _$t, r, !0), a.push(_$t);
                    }
                } catch (err) {
                    _didIteratorError3 = true;
                    _iteratorError3 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                            _iterator3.return();
                        }
                    } finally{
                        if (_didIteratorError3) {
                            throw _iteratorError3;
                        }
                    }
                }
            }
            e1.push(D(l, n, a, t.properties));
        }
        function C(e1, t) {
            t.push(z(e1[0]), F(e1[1]), 0);
        }
        function O(e1, t, o, i) {
            var s, n, r = 0;
            for(var _$o = 0; _$o < e1.length; _$o++){
                var a = z(e1[_$o][0]), l = F(e1[_$o][1]);
                t.push(a, l, 0), _$o > 0 && (r += i ? (s * l - a * n) / 2 : Math.sqrt(Math.pow(a - s, 2) + Math.pow(l - n, 2))), s = a, n = l;
            }
            var a1 = t.length - 3;
            t[2] = 1, I(t, 0, a1, o), t[a1 + 2] = 1, t.size = Math.abs(r), t.start = 0, t.end = t.size;
        }
        function L(e1, t, o, i) {
            for(var s = 0; s < e1.length; s++){
                var n = [];
                O(e1[s], n, o, i), t.push(n);
            }
        }
        function z(e1) {
            return e1 / 360 + .5;
        }
        function F(e1) {
            var t = Math.sin(e1 * Math.PI / 180), o = .5 - .25 * Math.log((1 + t) / (1 - t)) / Math.PI;
            return o < 0 ? 0 : o > 1 ? 1 : o;
        }
        function G(e1, t, o, i, s, n, r, a) {
            if (i /= t, n >= (o /= t) && r < i) return e1;
            if (r < o || n >= i) return null;
            var l = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$t = _step.value;
                    var _$e = _$t.geometry;
                    var _$n = _$t.type;
                    var _$r = 0 === s ? _$t.minX : _$t.minY, c = 0 === s ? _$t.maxX : _$t.maxY;
                    if (_$r >= o && c < i) {
                        l.push(_$t);
                        continue;
                    }
                    if (c < o || _$r >= i) continue;
                    var h = [];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    if ("Point" === _$n || "MultiPoint" === _$n) A(_$e, h, o, i, s);
                    else if ("LineString" === _$n) Z(_$e, h, o, i, s, !1, a.lineMetrics);
                    else if ("MultiLineString" === _$n) E(_$e, h, o, i, s, !1);
                    else if ("Polygon" === _$n) E(_$e, h, o, i, s, !0);
                    else if ("MultiPolygon" === _$n) try {
                        for(var _iterator1 = _$e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _$t1 = _step1.value;
                            var _$e1 = [];
                            E(_$t1, _$e1, o, i, s, !0), _$e1.length && h.push(_$e1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    if (h.length) {
                        if (a.lineMetrics && "LineString" === _$n) {
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = h[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var _$e2 = _step2.value;
                                    l.push(D(_$t.id, _$n, _$e2, _$t.tags));
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            continue;
                        }
                        "LineString" !== _$n && "MultiLineString" !== _$n || (1 === h.length ? (_$n = "LineString", h = h[0]) : _$n = "MultiLineString"), "Point" !== _$n && "MultiPoint" !== _$n || (_$n = 3 === h.length ? "Point" : "MultiPoint"), l.push(D(_$t.id, _$n, h, _$t.tags));
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return l.length ? l : null;
        }
        function A(e1, t, o, i, s) {
            for(var n = 0; n < e1.length; n += 3){
                var r = e1[n + s];
                r >= o && r <= i && j(t, e1[n], e1[n + 1], e1[n + 2]);
            }
        }
        function Z(e1, t, o, i, s, n, r) {
            var a = R(e1);
            var l = 0 === s ? N : W;
            var c, h, u = e1.start;
            for(var d = 0; d < e1.length - 3; d += 3){
                var g = e1[d], f = e1[d + 1], p = e1[d + 2], m = e1[d + 3], y = e1[d + 4], v = 0 === s ? g : f, x = 0 === s ? m : y;
                var _ = !1;
                r && (c = Math.sqrt(Math.pow(g - m, 2) + Math.pow(f - y, 2))), v < o ? x > o && (h = l(a, g, f, m, y, o), r && (a.start = u + c * h)) : v > i ? x < i && (h = l(a, g, f, m, y, i), r && (a.start = u + c * h)) : j(a, g, f, p), x < o && v >= o && (h = l(a, g, f, m, y, o), _ = !0), x > i && v <= i && (h = l(a, g, f, m, y, i), _ = !0), !n && _ && (r && (a.end = u + c * h), t.push(a), a = R(e1)), r && (u += c);
            }
            var d1 = e1.length - 3;
            var g1 = e1[d1], f1 = e1[d1 + 1], p1 = 0 === s ? g1 : f1;
            p1 >= o && p1 <= i && j(a, g1, f1, e1[d1 + 2]), d1 = a.length - 3, n && d1 >= 3 && (a[d1] !== a[0] || a[d1 + 1] !== a[1]) && j(a, a[0], a[1], a[2]), a.length && t.push(a);
        }
        function R(e1) {
            var t = [];
            return t.size = e1.size, t.start = e1.start, t.end = e1.end, t;
        }
        function E(e1, t, o, i, s, n) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var r = _step.value;
                    Z(r, t, o, i, s, n, !1);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        function j(e1, t, o, i) {
            e1.push(t, o, i);
        }
        function N(e1, t, o, i, s, n) {
            var r = (n - t) / (i - t);
            return j(e1, n, o + (s - o) * r, 1), r;
        }
        function W(e1, t, o, i, s, n) {
            var r = (n - o) / (s - o);
            return j(e1, t + (i - t) * r, n, 1), r;
        }
        function J(e1, t) {
            var o = [];
            for(var i = 0; i < e1.length; i++){
                var s = e1[i], n = s.type;
                var r = void 0;
                if ("Point" === n || "MultiPoint" === n || "LineString" === n) r = Y(s.geometry, t);
                else if ("MultiLineString" === n || "Polygon" === n) {
                    r = [];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = s.geometry[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            r.push(Y(_$e, t));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                } else if ("MultiPolygon" === n) {
                    r = [];
                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator1 = s.geometry[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            var _$e1 = _step1.value;
                            var o1 = [];
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = _$e1[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var i1 = _step2.value;
                                    o1.push(Y(i1, t));
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            r.push(o1);
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                }
                o.push(D(s.id, n, r, s.tags));
            }
            return o;
        }
        function Y(e1, t) {
            var o = [];
            o.size = e1.size, void 0 !== e1.start && (o.start = e1.start, o.end = e1.end);
            for(var i = 0; i < e1.length; i += 3)o.push(e1[i] + t, e1[i + 1], e1[i + 2]);
            return o;
        }
        function q(e1, t) {
            if (e1.transformed) return e1;
            var o = 1 << e1.z, i = e1.x, s = e1.y;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e1.features[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    var _$e = n.geometry, r = n.type;
                    if (n.geometry = [], 1 === r) for(var r1 = 0; r1 < _$e.length; r1 += 2)n.geometry.push(H(_$e[r1], _$e[r1 + 1], t, o, i, s));
                    else for(var r2 = 0; r2 < _$e.length; r2++){
                        var a = [];
                        for(var n1 = 0; n1 < _$e[r2].length; n1 += 2)a.push(H(_$e[r2][n1], _$e[r2][n1 + 1], t, o, i, s));
                        n.geometry.push(a);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return e1.transformed = !0, e1;
        }
        function H(e1, t, o, i, s, n) {
            return [
                Math.round(o * (e1 * i - s)),
                Math.round(o * (t * i - n))
            ];
        }
        function X(e1, t, o, i, s) {
            var n = t === s.maxZoom ? 0 : s.tolerance / ((1 << t) * s.extent), r = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e1.length,
                source: null,
                x: o,
                y: i,
                z: t,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            };
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$t = _step.value;
                    B(r, _$t, n, s);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return r;
        }
        function B(e1, t, o, i) {
            var s = t.geometry, n = t.type, r = [];
            if (e1.minX = Math.min(e1.minX, t.minX), e1.minY = Math.min(e1.minY, t.minY), e1.maxX = Math.max(e1.maxX, t.maxX), e1.maxY = Math.max(e1.maxY, t.maxY), "Point" === n || "MultiPoint" === n) for(var _$t = 0; _$t < s.length; _$t += 3)r.push(s[_$t], s[_$t + 1]), e1.numPoints++, e1.numSimplified++;
            else if ("LineString" === n) $(r, s, e1, o, !1, !1);
            else if ("MultiLineString" === n || "Polygon" === n) for(var _$t1 = 0; _$t1 < s.length; _$t1++)$(r, s[_$t1], e1, o, "Polygon" === n, 0 === _$t1);
            else if ("MultiPolygon" === n) for(var _$t2 = 0; _$t2 < s.length; _$t2++){
                var _$i = s[_$t2];
                for(var _$t3 = 0; _$t3 < _$i.length; _$t3++)$(r, _$i[_$t3], e1, o, !0, 0 === _$t3);
            }
            if (r.length) {
                var _$o = t.tags || null;
                if ("LineString" === n && i.lineMetrics) {
                    _$o = {};
                    for(var _$e in t.tags)_$o[_$e] = t.tags[_$e];
                    _$o.mapbox_clip_start = s.start / s.size, _$o.mapbox_clip_end = s.end / s.size;
                }
                var a = {
                    geometry: r,
                    type: "Polygon" === n || "MultiPolygon" === n ? 3 : "LineString" === n || "MultiLineString" === n ? 2 : 1,
                    tags: _$o
                };
                null !== t.id && (a.id = t.id), e1.features.push(a);
            }
        }
        function $(e1, t, o, i, s, n) {
            var r = i * i;
            if (i > 0 && t.size < (s ? r : i)) return void (o.numPoints += t.length / 3);
            var a = [];
            for(var _$e = 0; _$e < t.length; _$e += 3)(0 === i || t[_$e + 2] > r) && (o.numSimplified++, a.push(t[_$e], t[_$e + 1])), o.numPoints++;
            s && function(e1, t) {
                var _$o = 0;
                for(var _$t = 0, _$i = e1.length, _$s = _$i - 2; _$t < _$i; _$s = _$t, _$t += 2)_$o += (e1[_$t] - e1[_$s]) * (e1[_$t + 1] + e1[_$s + 1]);
                if (_$o > 0 === t) for(var _$t1 = 0, _$o1 = e1.length; _$t1 < _$o1 / 2; _$t1 += 2){
                    var _$i1 = e1[_$t1], _$s1 = e1[_$t1 + 1];
                    e1[_$t1] = e1[_$o1 - 2 - _$t1], e1[_$t1 + 1] = e1[_$o1 - 1 - _$t1], e1[_$o1 - 2 - _$t1] = _$i1, e1[_$o1 - 1 - _$t1] = _$s1;
                }
            }(a, n), e1.push(a);
        }
        var U = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        var V = /*#__PURE__*/ function() {
            function V(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, V);
                var o = (t = this.options = function(e1, t) {
                    for(var o in t)e1[o] = t[o];
                    return e1;
                }(Object.create(U), t)).debug;
                if (o && console.time("preprocess data"), t.maxZoom < 0 || t.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t.promoteId && t.generateId) throw new Error("promoteId and generateId cannot be used together.");
                var i = function(e1, t) {
                    var o = [];
                    if ("FeatureCollection" === e1.type) for(var i = 0; i < e1.features.length; i++)k(o, e1.features[i], t, i);
                    else k(o, "Feature" === e1.type ? e1 : {
                        geometry: e1
                    }, t);
                    return o;
                }(e1, t);
                this.tiles = {}, this.tileCoords = [], o && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t.indexMaxZoom, t.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i = function(e1, t) {
                    var o = t.buffer / t.extent;
                    var i = e1;
                    var s = G(e1, 1, -1 - o, o, 0, -1, 2, t), n = G(e1, 1, 1 - o, 2 + o, 0, -1, 2, t);
                    return (s || n) && (i = G(e1, 1, -o, 1 + o, 0, -1, 2, t) || [], s && (i = J(s, 1).concat(i)), n && (i = i.concat(J(n, -1)))), i;
                }(i, t), i.length && this.splitTile(i, 0, 0, 0), o && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(V, [
                {
                    key: "splitTile",
                    value: function splitTile(e1, t, o, i, s, n, r) {
                        var a = [
                            e1,
                            t,
                            o,
                            i
                        ], l = this.options, c = l.debug;
                        for(; a.length;){
                            i = a.pop(), o = a.pop(), t = a.pop(), e1 = a.pop();
                            var h = 1 << t, u = K(t, o, i);
                            var d = this.tiles[u];
                            if (!d && (c > 1 && console.time("creation"), d = this.tiles[u] = X(e1, t, o, i, l), this.tileCoords.push({
                                z: t,
                                x: o,
                                y: i
                            }), c)) {
                                c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t, o, i, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                                var _$e = "z".concat(t);
                                this.stats[_$e] = (this.stats[_$e] || 0) + 1, this.total++;
                            }
                            if (d.source = e1, null == s) {
                                if (t === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                            } else {
                                if (t === l.maxZoom || t === s) continue;
                                if (null != s) {
                                    var _$e1 = s - t;
                                    if (o !== n >> _$e1 || i !== r >> _$e1) continue;
                                }
                            }
                            if (d.source = null, 0 === e1.length) continue;
                            c > 1 && console.time("clipping");
                            var g = .5 * l.buffer / l.extent, f = .5 - g, p = .5 + g, m = 1 + g;
                            var y = null, v = null, x = null, _ = null, w = G(e1, h, o - g, o + p, 0, d.minX, d.maxX, l), S = G(e1, h, o + f, o + m, 0, d.minX, d.maxX, l);
                            e1 = null, w && (y = G(w, h, i - g, i + p, 1, d.minY, d.maxY, l), v = G(w, h, i + f, i + m, 1, d.minY, d.maxY, l), w = null), S && (x = G(S, h, i - g, i + p, 1, d.minY, d.maxY, l), _ = G(S, h, i + f, i + m, 1, d.minY, d.maxY, l), S = null), c > 1 && console.timeEnd("clipping"), a.push(y || [], t + 1, 2 * o, 2 * i), a.push(v || [], t + 1, 2 * o, 2 * i + 1), a.push(x || [], t + 1, 2 * o + 1, 2 * i), a.push(_ || [], t + 1, 2 * o + 1, 2 * i + 1);
                        }
                    }
                },
                {
                    key: "getTile",
                    value: function getTile(e1, t, o) {
                        e1 = +e1, t = +t, o = +o;
                        var i = this.options, s = i.extent, n = i.debug;
                        if (e1 < 0 || e1 > 24) return null;
                        var r = 1 << e1, a = K(e1, t = t + r & r - 1, o);
                        if (this.tiles[a]) return q(this.tiles[a], s);
                        n > 1 && console.log("drilling down to z%d-%d-%d", e1, t, o);
                        var l, c = e1, h = t, u = o;
                        for(; !l && c > 0;)c--, h >>= 1, u >>= 1, l = this.tiles[K(c, h, u)];
                        return l && l.source ? (n > 1 && (console.log("found parent tile z%d-%d-%d", c, h, u), console.time("drilling down")), this.splitTile(l.source, c, h, u, e1, t, o), n > 1 && console.timeEnd("drilling down"), this.tiles[a] ? q(this.tiles[a], s) : null) : null;
                    }
                }
            ]);
            return V;
        }();
        function K(e1, t, o) {
            return 32 * ((1 << e1) * o + t) + e1;
        }
        var Q = /*#__PURE__*/ function(h) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Q, h);
            function Q(e1, t, o) {
                var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : ee;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Q);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Q, [
                    e1,
                    t,
                    o
                ]), _this._dataUpdateable = new Map, _this._createGeoJSONIndex = i;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Q, [
                {
                    key: "loadVectorTile",
                    value: function loadVectorTile(t, o) {
                        return e1._(this, void 0, void 0, function() {
                            var o, i;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                o = t.tileID.canonical;
                                if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                                i = this._geoJSONIndex.getTile(o.z, o.x, o.y);
                                return [
                                    2,
                                    i ? l(new e1.d2(i.features, {
                                        version: 2,
                                        extent: e1.a5
                                    })) : null
                                ];
                            });
                        });
                    }
                },
                {
                    key: "loadData",
                    value: function loadData(t) {
                        return e1._(this, void 0, void 0, function() {
                            var o, i, _$e, o1, t1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        null === (o = this._pendingRequest) || void 0 === o || o.abort();
                                        i = this._startPerformance(t);
                                        this._pendingRequest = new AbortController;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        (!this._pendingData || t.request || t.data || t.dataDiff) && (this._pendingData = this.loadAndProcessGeoJSON(t, this._pendingRequest));
                                        return [
                                            4,
                                            this._pendingData
                                        ];
                                    case 2:
                                        _$e = _state.sent();
                                        this._geoJSONIndex = this._createGeoJSONIndex(_$e, t), this.loaded = {};
                                        o1 = {};
                                        return [
                                            2,
                                            (t.request && (o1.data = _$e), this._finishPerformance(i, t, o1), o1)
                                        ];
                                    case 3:
                                        t1 = _state.sent();
                                        if (delete this._pendingRequest, e1.Z(t1)) return [
                                            2,
                                            {
                                                abandoned: !0
                                            }
                                        ];
                                        throw t1;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_startPerformance",
                    value: function _startPerformance(t) {
                        var o;
                        if (null === (o = null == t ? void 0 : t.request) || void 0 === o ? void 0 : o.collectResourceTiming) return new e1.c_(t.request);
                    }
                },
                {
                    key: "_finishPerformance",
                    value: function _finishPerformance(e1, t, o) {
                        if (!e1) return;
                        var i = e1.finish();
                        i && (o.resourceTiming = {}, o.resourceTiming[t.source] = JSON.parse(JSON.stringify(i)));
                    }
                },
                {
                    key: "getData",
                    value: function getData() {
                        return e1._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                return [
                                    2,
                                    this._pendingData
                                ];
                            });
                        });
                    }
                },
                {
                    key: "reloadTile",
                    value: function reloadTile(e1) {
                        var t = this.loaded;
                        return t && t[e1.uid] ? (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(Q.prototype), "reloadTile", this).call(this, e1) : this.loadTile(e1);
                    }
                },
                {
                    key: "loadAndProcessGeoJSON",
                    value: function loadAndProcessGeoJSON(t, o) {
                        return e1._(this, void 0, void 0, function() {
                            var _$e, _tmp;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!t.request) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            this.loadGeoJSONFromUrl(t.request, t.promoteId, o)
                                        ];
                                    case 1:
                                        _tmp = _$e = _state.sent();
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        _tmp = t.data ? _$e = this._loadGeoJSONFromObject(t.data, t.promoteId) : t.dataDiff && (_$e = this._loadGeoJSONFromDiff(t.dataDiff, t.promoteId, t.source));
                                        _state.label = 3;
                                    case 3:
                                        if (_tmp, delete this._pendingRequest, "object" != (typeof _$e === "undefined" ? "undefined" : (0, $dvYFb._)(_$e))) throw new Error("Input data given to '".concat(t.source, "' is not a valid GeoJSON object."));
                                        return [
                                            2,
                                            (p(_$e, !0), t.filter && (_$e = this._filterGeoJSON(_$e, t.filter)), _$e)
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "loadGeoJSONFromUrl",
                    value: function loadGeoJSONFromUrl(t, o, i) {
                        return e1._(this, void 0, void 0, function() {
                            var s;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            e1.j(t, i)
                                        ];
                                    case 1:
                                        s = _state.sent();
                                        return [
                                            2,
                                            (this._dataUpdateable = e1.a7(s.data, o), s.data)
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_loadGeoJSONFromObject",
                    value: function _loadGeoJSONFromObject(t, o) {
                        return this._dataUpdateable = e1.a7(t, o), t;
                    }
                },
                {
                    key: "_loadGeoJSONFromDiff",
                    value: function _loadGeoJSONFromDiff(t, o, i) {
                        if (!this._dataUpdateable) throw new Error("Cannot update existing geojson data in ".concat(i));
                        e1.a8(this._dataUpdateable, t, o);
                        var s = Array.from(this._dataUpdateable.values());
                        return this._toFeatureCollection(s);
                    }
                },
                {
                    key: "_filterGeoJSON",
                    value: function _filterGeoJSON(t, o) {
                        var i = e1.d3(o, {
                            type: "boolean",
                            "property-type": "data-driven",
                            overridable: !1,
                            transition: !1
                        });
                        if ("error" === i.result) throw new Error(i.value.map(function(e1) {
                            return "".concat(e1.key, ": ").concat(e1.message);
                        }).join(", "));
                        var s = t.features.filter(function(e1) {
                            return i.value.evaluate({
                                zoom: 0
                            }, e1);
                        });
                        return this._toFeatureCollection(s);
                    }
                },
                {
                    key: "_toFeatureCollection",
                    value: function _toFeatureCollection(e1) {
                        return {
                            type: "FeatureCollection",
                            features: e1
                        };
                    }
                },
                {
                    key: "removeSource",
                    value: function removeSource(t) {
                        return e1._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                this._pendingRequest && this._pendingRequest.abort();
                                return [
                                    2
                                ];
                            });
                        });
                    }
                },
                {
                    key: "getClusterExpansionZoom",
                    value: function getClusterExpansionZoom(e1) {
                        return this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId);
                    }
                },
                {
                    key: "getClusterChildren",
                    value: function getClusterChildren(e1) {
                        return this._geoJSONIndex.getChildren(e1.clusterId);
                    }
                },
                {
                    key: "getClusterLeaves",
                    value: function getClusterLeaves(e1) {
                        return this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset);
                    }
                }
            ]);
            return Q;
        }(h);
        function ee(t, o) {
            return o.cluster ? new x(function(param) {
                var _$t = param.superclusterOptions, _$o = param.clusterProperties;
                if (!_$o || !_$t) return _$t;
                var i = {}, s = {}, n = {
                    accumulated: null,
                    zoom: 0
                }, r = {
                    properties: null
                }, a = Object.keys(_$o);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$t1 = _step.value;
                        var _o_t = (0, $db95b225ee8036d6$export$71511d61b312f219)(_$o[_$t1], 2), n1 = _o_t[0], r1 = _o_t[1], a1 = e1.d3(r1), l = e1.d3("string" == typeof n1 ? [
                            n1,
                            [
                                "accumulated"
                            ],
                            [
                                "get",
                                _$t1
                            ]
                        ] : n1);
                        i[_$t1] = a1.value, s[_$t1] = l.value;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return _$t.map = function(e1) {
                    r.properties = e1;
                    var _$t = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            _$t[_$e] = i[_$e].evaluate(n, r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return _$t;
                }, _$t.reduce = function(e1, t) {
                    r.properties = t;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$t = _step.value;
                            n.accumulated = e1[_$t], e1[_$t] = s[_$t].evaluate(n, r);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }, _$t;
            }(o)).load(t.features) : function(e1, t) {
                return new V(e1, t);
            }(t, o.geojsonVtOptions);
        }
        var te = /*#__PURE__*/ function() {
            function te(t) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, te);
                this.self = t, this.actor = new e1.L(t), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.globalStates = new Map, this.self.registerWorkerSource = function(e1, t) {
                    if (_this.externalWorkerSourceTypes[e1]) throw new Error('Worker source with name "'.concat(e1, '" already registered.'));
                    _this.externalWorkerSourceTypes[e1] = t;
                }, this.self.addProtocol = e1.cJ, this.self.removeProtocol = e1.cK, this.self.registerRTLTextPlugin = function(t) {
                    e1.d4.setMethods(t);
                }, this.actor.registerMessageHandler("LDT", function(e1, t) {
                    return _this._getDEMWorkerSource(e1, t.source).loadTile(t);
                }), this.actor.registerMessageHandler("RDT", function(t, o) {
                    return e1._(_this, void 0, void 0, function() {
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            this._getDEMWorkerSource(t, o.source).removeTile(o);
                            return [
                                2
                            ];
                        });
                    });
                }), this.actor.registerMessageHandler("GCEZ", function(t, o) {
                    return e1._(_this, void 0, void 0, function() {
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            return [
                                2,
                                this._getWorkerSource(t, o.type, o.source).getClusterExpansionZoom(o)
                            ];
                        });
                    });
                }), this.actor.registerMessageHandler("GCC", function(t, o) {
                    return e1._(_this, void 0, void 0, function() {
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            return [
                                2,
                                this._getWorkerSource(t, o.type, o.source).getClusterChildren(o)
                            ];
                        });
                    });
                }), this.actor.registerMessageHandler("GCL", function(t, o) {
                    return e1._(_this, void 0, void 0, function() {
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            return [
                                2,
                                this._getWorkerSource(t, o.type, o.source).getClusterLeaves(o)
                            ];
                        });
                    });
                }), this.actor.registerMessageHandler("LD", function(e1, t) {
                    return _this._getWorkerSource(e1, t.type, t.source).loadData(t);
                }), this.actor.registerMessageHandler("GD", function(e1, t) {
                    return _this._getWorkerSource(e1, t.type, t.source).getData();
                }), this.actor.registerMessageHandler("LT", function(e1, t) {
                    return _this._getWorkerSource(e1, t.type, t.source).loadTile(t);
                }), this.actor.registerMessageHandler("RT", function(e1, t) {
                    return _this._getWorkerSource(e1, t.type, t.source).reloadTile(t);
                }), this.actor.registerMessageHandler("AT", function(e1, t) {
                    return _this._getWorkerSource(e1, t.type, t.source).abortTile(t);
                }), this.actor.registerMessageHandler("RMT", function(e1, t) {
                    return _this._getWorkerSource(e1, t.type, t.source).removeTile(t);
                }), this.actor.registerMessageHandler("RS", function(t, o) {
                    return e1._(_this, void 0, void 0, function() {
                        var _$e;
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            if (!this.workerSources[t] || !this.workerSources[t][o.type] || !this.workerSources[t][o.type][o.source]) return [
                                2
                            ];
                            _$e = this.workerSources[t][o.type][o.source];
                            delete this.workerSources[t][o.type][o.source], void 0 !== _$e.removeSource && _$e.removeSource(o);
                            return [
                                2
                            ];
                        });
                    });
                }), this.actor.registerMessageHandler("RM", function(t) {
                    return e1._(_this, void 0, void 0, function() {
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            delete this.layerIndexes[t], delete this.availableImages[t], delete this.workerSources[t], delete this.demWorkerSources[t], this.globalStates.delete(t);
                            return [
                                2
                            ];
                        });
                    });
                }), this.actor.registerMessageHandler("SR", function(t, o) {
                    return e1._(_this, void 0, void 0, function() {
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            this.referrer = o;
                            return [
                                2
                            ];
                        });
                    });
                }), this.actor.registerMessageHandler("SRPS", function(e1, t) {
                    return _this._syncRTLPluginState(e1, t);
                }), this.actor.registerMessageHandler("IS", function(t, o) {
                    return e1._(_this, void 0, void 0, function() {
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            this.self.importScripts(o);
                            return [
                                2
                            ];
                        });
                    });
                }), this.actor.registerMessageHandler("SI", function(e1, t) {
                    return _this._setImages(e1, t);
                }), this.actor.registerMessageHandler("UL", function(t, o) {
                    return e1._(_this, void 0, void 0, function() {
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            this._getLayerIndex(t).update(o.layers, o.removedIds, this._getGlobalState(t));
                            return [
                                2
                            ];
                        });
                    });
                }), this.actor.registerMessageHandler("UGS", function(t, o) {
                    return e1._(_this, void 0, void 0, function() {
                        var _$e, _$t;
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            _$e = this._getGlobalState(t);
                            for(var _$t in o)_$e[_$t] = o[_$t];
                            return [
                                2
                            ];
                        });
                    });
                }), this.actor.registerMessageHandler("SL", function(t, o) {
                    return e1._(_this, void 0, void 0, function() {
                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                            this._getLayerIndex(t).replace(o, this._getGlobalState(t));
                            return [
                                2
                            ];
                        });
                    });
                });
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(te, [
                {
                    key: "_getGlobalState",
                    value: function _getGlobalState(e1) {
                        var t = this.globalStates.get(e1);
                        return t || (t = {}, this.globalStates.set(e1, t)), t;
                    }
                },
                {
                    key: "_setImages",
                    value: function _setImages(t, o) {
                        return e1._(this, void 0, void 0, function() {
                            var _$e, i, _$e1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                this.availableImages[t] = o;
                                for(var _$e in this.workerSources[t]){
                                    i = this.workerSources[t][_$e];
                                    for(var _$e1 in i)i[_$e1].availableImages = o;
                                }
                                return [
                                    2
                                ];
                            });
                        });
                    }
                },
                {
                    key: "_syncRTLPluginState",
                    value: function _syncRTLPluginState(t, o) {
                        return e1._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            e1.d4.syncState(o, this.self.importScripts)
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            _state.sent()
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_getAvailableImages",
                    value: function _getAvailableImages(e1) {
                        var t = this.availableImages[e1];
                        return t || (t = []), t;
                    }
                },
                {
                    key: "_getLayerIndex",
                    value: function _getLayerIndex(e1) {
                        var o = this.layerIndexes[e1];
                        return o || (o = this.layerIndexes[e1] = new t), o;
                    }
                },
                {
                    key: "_getWorkerSource",
                    value: function _getWorkerSource(e1, t, o) {
                        var _this = this;
                        if (this.workerSources[e1] || (this.workerSources[e1] = {}), this.workerSources[e1][t] || (this.workerSources[e1][t] = {}), !this.workerSources[e1][t][o]) {
                            var i = {
                                sendAsync: function(t, o) {
                                    return t.targetMapId = e1, _this.actor.sendAsync(t, o);
                                }
                            };
                            switch(t){
                                case "vector":
                                    this.workerSources[e1][t][o] = new h(i, this._getLayerIndex(e1), this._getAvailableImages(e1));
                                    break;
                                case "geojson":
                                    this.workerSources[e1][t][o] = new Q(i, this._getLayerIndex(e1), this._getAvailableImages(e1));
                                    break;
                                default:
                                    this.workerSources[e1][t][o] = new this.externalWorkerSourceTypes[t](i, this._getLayerIndex(e1), this._getAvailableImages(e1));
                            }
                        }
                        return this.workerSources[e1][t][o];
                    }
                },
                {
                    key: "_getDEMWorkerSource",
                    value: function _getDEMWorkerSource(e1, t) {
                        return this.demWorkerSources[e1] || (this.demWorkerSources[e1] = {}), this.demWorkerSources[e1][t] || (this.demWorkerSources[e1][t] = new u), this.demWorkerSources[e1][t];
                    }
                }
            ]);
            return te;
        }();
        return e1.i(self) && (self.worker = new te(self)), te;
    });
    define("index", [
        "exports",
        "./shared"
    ], function(e1, t) {
        "use strict";
        var i = "5.15.0";
        function a() {
            var _$e = new t.A(4);
            return t.A != Float32Array && (_$e[1] = 0, _$e[2] = 0), _$e[0] = 1, _$e[3] = 1, _$e;
        }
        var r, o, s;
        var n = {
            frame: function(e1, i, a) {
                var r = requestAnimationFrame(function(e1) {
                    o(), i(e1);
                }), _t_s = t.s(e1.signal, "abort", function() {
                    o(), cancelAnimationFrame(r), a(new t.a(e1.signal.reason));
                }, !1), o = _t_s.unsubscribe;
            },
            frameAsync: function(e1) {
                var _this = this;
                return new Promise(function(t, i) {
                    _this.frame(e1, t, i);
                });
            },
            getImageData: function(e1) {
                var _$t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                return this.getImageCanvasContext(e1).getImageData(-_$t, -_$t, e1.width + 2 * _$t, e1.height + 2 * _$t);
            },
            getImageCanvasContext: function(e1) {
                var _$t = window.document.createElement("canvas"), i = _$t.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!i) throw new Error("failed to create canvas 2d context");
                return _$t.width = e1.width, _$t.height = e1.height, i.drawImage(e1, 0, 0, e1.width, e1.height), i;
            },
            resolveURL: function(e1) {
                return r || (r = document.createElement("a")), r.href = e1, r.href;
            },
            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
            get prefersReducedMotion () {
                return void 0 !== s ? s : !!matchMedia && (null == o && (o = matchMedia("(prefers-reduced-motion: reduce)")), o.matches);
            },
            set prefersReducedMotion (e){
                s = e;
            }
        }, l = new (/*#__PURE__*/ function() {
            function _class() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this._realTime = "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date), this._frozenAt = null;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "getCurrentTime",
                    value: function getCurrentTime() {
                        return null !== this._frozenAt ? this._frozenAt : this._realTime();
                    }
                },
                {
                    key: "setNow",
                    value: function setNow(e1) {
                        this._frozenAt = e1;
                    }
                },
                {
                    key: "restoreNow",
                    value: function restoreNow() {
                        this._frozenAt = null;
                    }
                },
                {
                    key: "isFrozen",
                    value: function isFrozen() {
                        return null !== this._frozenAt;
                    }
                }
            ]);
            return _class;
        }());
        function c() {
            return l.getCurrentTime();
        }
        var h = /*#__PURE__*/ function() {
            function h() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, h);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(h, null, [
                {
                    key: "testProp",
                    value: function testProp(e1) {
                        if (!h.docStyle) return e1[0];
                        for(var _$t = 0; _$t < e1.length; _$t++)if (e1[_$t] in h.docStyle) return e1[_$t];
                        return e1[0];
                    }
                },
                {
                    key: "create",
                    value: function create(e1, t, i) {
                        var a = window.document.createElement(e1);
                        return void 0 !== t && (a.className = t), i && i.appendChild(a), a;
                    }
                },
                {
                    key: "createNS",
                    value: function createNS(e1, t) {
                        return window.document.createElementNS(e1, t);
                    }
                },
                {
                    key: "disableDrag",
                    value: function disableDrag() {
                        h.docStyle && h.selectProp && (h.userSelect = h.docStyle[h.selectProp], h.docStyle[h.selectProp] = "none");
                    }
                },
                {
                    key: "enableDrag",
                    value: function enableDrag() {
                        h.docStyle && h.selectProp && (h.docStyle[h.selectProp] = h.userSelect);
                    }
                },
                {
                    key: "setTransform",
                    value: function setTransform(e1, t) {
                        e1.style[h.transformProp] = t;
                    }
                },
                {
                    key: "addEventListener",
                    value: function addEventListener1(e1, t, i) {
                        var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                        e1.addEventListener(t, i, "passive" in a ? a : a.capture);
                    }
                },
                {
                    key: "removeEventListener",
                    value: function removeEventListener1(e1, t, i) {
                        var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                        e1.removeEventListener(t, i, "passive" in a ? a : a.capture);
                    }
                },
                {
                    key: "suppressClickInternal",
                    value: function suppressClickInternal(e1) {
                        e1.preventDefault(), e1.stopPropagation(), window.removeEventListener("click", h.suppressClickInternal, !0);
                    }
                },
                {
                    key: "suppressClick",
                    value: function suppressClick() {
                        window.addEventListener("click", h.suppressClickInternal, !0), window.setTimeout(function() {
                            window.removeEventListener("click", h.suppressClickInternal, !0);
                        }, 0);
                    }
                },
                {
                    key: "getScale",
                    value: function getScale(e1) {
                        var _$t = e1.getBoundingClientRect();
                        return {
                            x: _$t.width / e1.offsetWidth || 1,
                            y: _$t.height / e1.offsetHeight || 1,
                            boundingClientRect: _$t
                        };
                    }
                },
                {
                    key: "getPoint",
                    value: function getPoint(e1, i, a) {
                        var r = i.boundingClientRect;
                        return new t.P((a.clientX - r.left) / i.x - e1.clientLeft, (a.clientY - r.top) / i.y - e1.clientTop);
                    }
                },
                {
                    key: "mousePos",
                    value: function mousePos(e1, t) {
                        var i = h.getScale(e1);
                        return h.getPoint(e1, i, t);
                    }
                },
                {
                    key: "touchPos",
                    value: function touchPos(e1, t) {
                        var i = [], a = h.getScale(e1);
                        for(var r = 0; r < t.length; r++)i.push(h.getPoint(e1, a, t[r]));
                        return i;
                    }
                },
                {
                    key: "mouseButton",
                    value: function mouseButton(e1) {
                        return e1.button;
                    }
                },
                {
                    key: "remove",
                    value: function remove(e1) {
                        e1.parentNode && e1.parentNode.removeChild(e1);
                    }
                },
                {
                    key: "sanitize",
                    value: function sanitize(e1) {
                        var _$t = (new DOMParser).parseFromString(e1, "text/html").body || document.createElement("body"), i = _$t.querySelectorAll("script");
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                _$e.remove();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return h.clean(_$t), _$t.innerHTML;
                    }
                },
                {
                    key: "isPossiblyDangerous",
                    value: function isPossiblyDangerous(e1, t) {
                        var i = t.replace(/\s+/g, "").toLowerCase();
                        return !(![
                            "src",
                            "href",
                            "xlink:href"
                        ].includes(e1) || !i.includes("javascript:") && !i.includes("data:")) || !!e1.startsWith("on") || void 0;
                    }
                },
                {
                    key: "clean",
                    value: function clean(e1) {
                        var _$t = e1.children;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = _$t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                h.removeAttributes(_$e), h.clean(_$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "removeAttributes",
                    value: function removeAttributes(e1) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1.attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, _$t = _step_value.name, i = _step_value.value;
                                h.isPossiblyDangerous(_$t, i) && e1.removeAttribute(_$t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
            ]);
            return h;
        }();
        h.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, h.selectProp = h.testProp([
            "userSelect",
            "MozUserSelect",
            "WebkitUserSelect",
            "msUserSelect"
        ]), h.transformProp = h.testProp([
            "transform",
            "WebkitTransform"
        ]);
        var u = {
            supported: !1,
            testSupport: function testSupport(e1) {
                !p && _ && (m ? f(e1) : d = e1);
            }
        };
        var d, _, p = !1, m = !1;
        function f(e1) {
            var _$t = e1.createTexture();
            e1.bindTexture(e1.TEXTURE_2D, _$t);
            try {
                if (e1.texImage2D(e1.TEXTURE_2D, 0, e1.RGBA, e1.RGBA, e1.UNSIGNED_BYTE, _), e1.isContextLost()) return;
                u.supported = !0;
            } catch (e1) {}
            e1.deleteTexture(_$t), p = !0;
        }
        var g;
        "undefined" != typeof document && (_ = document.createElement("img"), _.onload = function() {
            d && f(d), d = null, m = !0;
        }, _.onerror = function() {
            p = !0, d = null;
        }, _.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(e1) {
            var _this = this;
            var i, a, r, o;
            e1.resetRequestQueue = function() {
                i = [], a = 0, r = 0, o = {};
            }, e1.addThrottleControl = function(e1) {
                var _$t = r++;
                return o[_$t] = e1, _$t;
            }, e1.removeThrottleControl = function(e1) {
                delete o[e1], n();
            }, e1.getImage = function(e1, a) {
                var r = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                return new Promise(function(o, s) {
                    u.supported && (e1.headers || (e1.headers = {}), e1.headers.accept = "image/webp,*/*"), t.e(e1, {
                        type: "image"
                    }), i.push({
                        abortController: a,
                        requestParameters: e1,
                        supportImageRefresh: r,
                        state: "queued",
                        onError: function(e1) {
                            s(e1);
                        },
                        onSuccess: function(e1) {
                            o(e1);
                        }
                    }), n();
                });
            };
            var s = function(e1) {
                return t._(_this, void 0, void 0, function() {
                    var i, r, o, s, _$c, h, u, i1, _tmp, _tmp1, _tmp2, t1, d;
                    return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                e1.state = "running";
                                i = e1.requestParameters, r = e1.supportImageRefresh, o = e1.onError, s = e1.onSuccess, _$c = e1.abortController, h = !1 === r && !t.i(self) && !t.g(i.url) && (!i.headers || Object.keys(i.headers).reduce(function(e1, t) {
                                    return e1 && "accept" === t;
                                }, !0));
                                a++;
                                u = h ? l(i, _$c) : t.m(i, _$c);
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    7,
                                    8,
                                    9
                                ]);
                                return [
                                    4,
                                    u
                                ];
                            case 2:
                                i1 = _state.sent();
                                delete e1.abortController, e1.state = "completed";
                                if (!(i1.data instanceof HTMLImageElement || t.b(i1.data))) return [
                                    3,
                                    3
                                ];
                                _tmp = s(i1);
                                return [
                                    3,
                                    6
                                ];
                            case 3:
                                _tmp1 = i1.data;
                                if (!_tmp1) return [
                                    3,
                                    5
                                ];
                                _tmp2 = {};
                                return [
                                    4,
                                    (d = i1.data, "function" == typeof createImageBitmap ? t.f(d) : t.h(d))
                                ];
                            case 4:
                                _tmp1 = s.apply(void 0, [
                                    (_tmp2.data = _state.sent(), _tmp2.cacheControl = i1.cacheControl, _tmp2.expires = i1.expires, _tmp2)
                                ]);
                                _state.label = 5;
                            case 5:
                                _tmp = _tmp1;
                                _state.label = 6;
                            case 6:
                                _tmp;
                                return [
                                    3,
                                    9
                                ];
                            case 7:
                                t1 = _state.sent();
                                delete e1.abortController, o(t1);
                                return [
                                    3,
                                    9
                                ];
                            case 8:
                                a--, n();
                                return [
                                    7
                                ];
                            case 9:
                                return [
                                    2
                                ];
                        }
                    });
                });
            }, n = function() {
                var _$e = function() {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.keys(o)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            if (o[_$e]()) return !0;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return !1;
                }() ? t.c.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : t.c.MAX_PARALLEL_IMAGE_REQUESTS;
                for(var _$t = a; _$t < _$e && i.length > 0; _$t++){
                    var _$e1 = i.shift();
                    _$e1.abortController.signal.aborted ? _$t-- : s(_$e1);
                }
            }, l = function(e1, i) {
                return new Promise(function(a, r) {
                    var o = new Image, s = e1.url, n = e1.credentials;
                    n && "include" === n ? o.crossOrigin = "use-credentials" : (n && "same-origin" === n || !t.d(s)) && (o.crossOrigin = "anonymous"), i.signal.addEventListener("abort", function() {
                        o.src = "", r(new t.a(i.signal.reason));
                    }), o.fetchPriority = "high", o.onload = function() {
                        o.onerror = o.onload = null, a({
                            data: o
                        });
                    }, o.onerror = function() {
                        o.onerror = o.onload = null, i.signal.aborted || r(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                    }, o.src = s;
                });
            };
        }(g || (g = {})), g.resetRequestQueue();
        var v = /*#__PURE__*/ function() {
            function v(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, v);
                this._transformRequestFn = null != e1 ? e1 : null;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(v, [
                {
                    key: "transformRequest",
                    value: function transformRequest(e1, t) {
                        return this._transformRequestFn && this._transformRequestFn(e1, t) || {
                            url: e1
                        };
                    }
                },
                {
                    key: "setTransformRequest",
                    value: function setTransformRequest(e1) {
                        this._transformRequestFn = e1;
                    }
                }
            ]);
            return v;
        }();
        function x(e1) {
            var _$t = [];
            if ("string" == typeof e1) _$t.push({
                id: "default",
                url: e1
            });
            else if (e1 && e1.length > 0) {
                var i = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = _step.value, a = _step_value.id, r = _step_value.url;
                        var _$e = "".concat(a).concat(r);
                        -1 === i.indexOf(_$e) && (i.push(_$e), _$t.push({
                            id: a,
                            url: r
                        }));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            return _$t;
        }
        function b(e1, t, i) {
            try {
                var a = new URL(e1);
                return a.pathname += "".concat(t).concat(i), a.toString();
            } catch (t) {
                throw new Error('Invalid sprite URL "'.concat(e1, '", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically'));
            }
        }
        function y(e1) {
            var _$t = e1.userImage;
            return !!(_$t && _$t.render && _$t.render()) && (e1.data.replace(new Uint8Array(_$t.data.buffer)), !0);
        }
        var w = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(w, _t_E);
            function w() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, w);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, w), _this.images = {}, _this.updatedImages = {}, _this.callbackDispatchedThisFrame = {}, _this.loaded = !1, _this.requestors = [], _this.patterns = {}, _this.atlasImage = new t.R({
                    width: 1,
                    height: 1
                }), _this.dirty = !0;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(w, [
                {
                    key: "destroy",
                    value: function destroy() {
                        this.atlasTexture && (this.atlasTexture.destroy(), this.atlasTexture = null);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.keys(this.images)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                this.removeImage(_$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this.patterns = {}, this.atlasImage = new t.R({
                            width: 1,
                            height: 1
                        }), this.dirty = !0;
                    }
                },
                {
                    key: "isLoaded",
                    value: function isLoaded() {
                        return this.loaded;
                    }
                },
                {
                    key: "setLoaded",
                    value: function setLoaded(e1) {
                        if (this.loaded !== e1 && (this.loaded = e1, e1)) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = this.requestors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _step_value = _step.value, _$e = _step_value.ids, _$t = _step_value.promiseResolve;
                                    _$t(this._getImagesForIds(_$e));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            this.requestors = [];
                        }
                    }
                },
                {
                    key: "getImage",
                    value: function getImage(e1) {
                        var i = this.images[e1];
                        if (i && !i.data && i.spriteData) {
                            var _$e = i.spriteData;
                            i.data = new t.R({
                                width: _$e.width,
                                height: _$e.height
                            }, _$e.context.getImageData(_$e.x, _$e.y, _$e.width, _$e.height).data), i.spriteData = null;
                        }
                        return i;
                    }
                },
                {
                    key: "addImage",
                    value: function addImage(e1, t) {
                        if (this.images[e1]) throw new Error("Image id ".concat(e1, " already exist, use updateImage instead"));
                        this._validate(e1, t) && (this.images[e1] = t);
                    }
                },
                {
                    key: "_validate",
                    value: function _validate(e1, i) {
                        var a = !0;
                        var r = i.data || i.spriteData;
                        return this._validateStretch(i.stretchX, r && r.width) || (this.fire(new t.k(new Error('Image "'.concat(e1, '" has invalid "stretchX" value')))), a = !1), this._validateStretch(i.stretchY, r && r.height) || (this.fire(new t.k(new Error('Image "'.concat(e1, '" has invalid "stretchY" value')))), a = !1), this._validateContent(i.content, i) || (this.fire(new t.k(new Error('Image "'.concat(e1, '" has invalid "content" value')))), a = !1), a;
                    }
                },
                {
                    key: "_validateStretch",
                    value: function _validateStretch(e1, t) {
                        if (!e1) return !0;
                        var i = 0;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var a = _step.value;
                                if (a[0] < i || a[1] < a[0] || t < a[1]) return !1;
                                i = a[1];
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return !0;
                    }
                },
                {
                    key: "_validateContent",
                    value: function _validateContent(e1, t) {
                        if (!e1) return !0;
                        if (4 !== e1.length) return !1;
                        var i = t.spriteData, a = i && i.width || t.data.width, r = i && i.height || t.data.height;
                        return !(e1[0] < 0 || a < e1[0] || e1[1] < 0 || r < e1[1] || e1[2] < 0 || a < e1[2] || e1[3] < 0 || r < e1[3] || e1[2] < e1[0] || e1[3] < e1[1]);
                    }
                },
                {
                    key: "updateImage",
                    value: function updateImage(e1, t) {
                        var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                        var a = this.getImage(e1);
                        if (i && (a.data.width !== t.data.width || a.data.height !== t.data.height)) throw new Error("size mismatch between old image (".concat(a.data.width, "x").concat(a.data.height, ") and new image (").concat(t.data.width, "x").concat(t.data.height, ")."));
                        t.version = a.version + 1, this.images[e1] = t, this.updatedImages[e1] = !0;
                    }
                },
                {
                    key: "removeImage",
                    value: function removeImage(e1) {
                        var _$t = this.images[e1];
                        delete this.images[e1], delete this.patterns[e1], _$t.userImage && _$t.userImage.onRemove && _$t.userImage.onRemove();
                    }
                },
                {
                    key: "listImages",
                    value: function listImages() {
                        return Object.keys(this.images);
                    }
                },
                {
                    key: "getImages",
                    value: function getImages(e1) {
                        var _this = this;
                        return new Promise(function(t, i) {
                            var a = !0;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (!_this.isLoaded()) try {
                                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step.value;
                                    _this.images[_$t] || (a = !1);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            _this.isLoaded() || a ? t(_this._getImagesForIds(e1)) : _this.requestors.push({
                                ids: e1,
                                promiseResolve: t
                            });
                        });
                    }
                },
                {
                    key: "_getImagesForIds",
                    value: function _getImagesForIds(e1) {
                        var i = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var a = _step.value;
                                var _$e = this.getImage(a);
                                _$e || (this.fire(new t.l("styleimagemissing", {
                                    id: a
                                })), _$e = this.getImage(a)), _$e ? i[a] = {
                                    data: _$e.data.clone(),
                                    pixelRatio: _$e.pixelRatio,
                                    sdf: _$e.sdf,
                                    version: _$e.version,
                                    stretchX: _$e.stretchX,
                                    stretchY: _$e.stretchY,
                                    content: _$e.content,
                                    textFitWidth: _$e.textFitWidth,
                                    textFitHeight: _$e.textFitHeight,
                                    hasRenderCallback: Boolean(_$e.userImage && _$e.userImage.render)
                                } : t.w('Image "'.concat(a, '" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.'));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return i;
                    }
                },
                {
                    key: "getPixelSize",
                    value: function getPixelSize() {
                        var _this_atlasImage = this.atlasImage, _$e = _this_atlasImage.width, _$t = _this_atlasImage.height;
                        return {
                            width: _$e,
                            height: _$t
                        };
                    }
                },
                {
                    key: "getPattern",
                    value: function getPattern(e1) {
                        var i = this.patterns[e1], a = this.getImage(e1);
                        if (!a) return null;
                        if (i && i.position.version === a.version) return i.position;
                        if (i) i.position.version = a.version;
                        else {
                            var i1 = {
                                w: a.data.width + 2,
                                h: a.data.height + 2,
                                x: 0,
                                y: 0
                            }, r = new t.I(i1, a);
                            this.patterns[e1] = {
                                bin: i1,
                                position: r
                            };
                        }
                        return this._updatePatternAtlas(), this.patterns[e1].position;
                    }
                },
                {
                    key: "bind",
                    value: function bind(e1) {
                        var i = e1.gl;
                        this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new t.T(e1, this.atlasImage, i.RGBA), this.atlasTexture.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                    }
                },
                {
                    key: "_updatePatternAtlas",
                    value: function _updatePatternAtlas() {
                        var _$e = [];
                        for(var _$t in this.patterns)_$e.push(this.patterns[_$t].bin);
                        var _t_p = t.p(_$e), i = _t_p.w, a = _t_p.h, r = this.atlasImage;
                        r.resize({
                            width: i || 1,
                            height: a || 1
                        });
                        for(var _$e1 in this.patterns){
                            var _this_patterns_e = this.patterns[_$e1], i1 = _this_patterns_e.bin, a1 = i1.x + 1, o = i1.y + 1, s = this.getImage(_$e1).data, n = s.width, l = s.height;
                            t.R.copy(s, r, {
                                x: 0,
                                y: 0
                            }, {
                                x: a1,
                                y: o
                            }, {
                                width: n,
                                height: l
                            }), t.R.copy(s, r, {
                                x: 0,
                                y: l - 1
                            }, {
                                x: a1,
                                y: o - 1
                            }, {
                                width: n,
                                height: 1
                            }), t.R.copy(s, r, {
                                x: 0,
                                y: 0
                            }, {
                                x: a1,
                                y: o + l
                            }, {
                                width: n,
                                height: 1
                            }), t.R.copy(s, r, {
                                x: n - 1,
                                y: 0
                            }, {
                                x: a1 - 1,
                                y: o
                            }, {
                                width: 1,
                                height: l
                            }), t.R.copy(s, r, {
                                x: 0,
                                y: 0
                            }, {
                                x: a1 + n,
                                y: o
                            }, {
                                width: 1,
                                height: l
                            });
                        }
                        this.dirty = !0;
                    }
                },
                {
                    key: "beginFrame",
                    value: function beginFrame() {
                        this.callbackDispatchedThisFrame = {};
                    }
                },
                {
                    key: "dispatchRenderCallbacks",
                    value: function dispatchRenderCallbacks(e1) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                if (this.callbackDispatchedThisFrame[i]) continue;
                                this.callbackDispatchedThisFrame[i] = !0;
                                var _$e = this.getImage(i);
                                _$e || t.w('Image with ID: "'.concat(i, '" was not found')), y(_$e) && this.updateImage(i, _$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "cloneImages",
                    value: function cloneImages() {
                        var _$e = {};
                        for(var _$t in this.images){
                            var i = this.images[_$t];
                            _$e[_$t] = Object.assign(Object.assign({}, i), {
                                data: i.data ? i.data.clone() : null
                            });
                        }
                        return _$e;
                    }
                }
            ]);
            return w;
        }(t.E);
        var T = 1e20;
        function P(e1, t, i, a, r, o, s, n, l) {
            for(var _$c = t; _$c < t + a; _$c++)C(e1, i * o + _$c, o, r, s, n, l);
            for(var _$c1 = i; _$c1 < i + r; _$c1++)C(e1, _$c1 * o + t, 1, a, s, n, l);
        }
        function C(e1, t, i, a, r, o, s) {
            o[0] = 0, s[0] = -T, s[1] = T, r[0] = e1[t];
            for(var n = 1, l = 0, _$c = 0; n < a; n++){
                r[n] = e1[t + n * i];
                var _$a = n * n;
                do {
                    var _$e = o[l];
                    _$c = (r[n] - r[_$e] + _$a - _$e * _$e) / (n - _$e) / 2;
                }while (_$c <= s[l] && --l > -1);
                l++, o[l] = n, s[l] = _$c, s[l + 1] = T;
            }
            for(var n1 = 0, l1 = 0; n1 < a; n1++){
                for(; s[l1 + 1] < n1;)l1++;
                var _$a1 = o[l1], _$c1 = n1 - _$a1;
                e1[t + n1 * i] = r[_$a1] + _$c1 * _$c1;
            }
        }
        var I = t.v.layout_symbol["text-font"].default.join(",");
        var M = /*#__PURE__*/ function() {
            function M(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, M);
                this.requestManager = e1, this.localIdeographFontFamily = t, this.entries = {}, this.lang = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(M, [
                {
                    key: "setURL",
                    value: function setURL(e1) {
                        this.url = e1;
                    }
                },
                {
                    key: "getGlyphs",
                    value: function getGlyphs(e1) {
                        return t._(this, void 0, void 0, function() {
                            var _$t, _iteratorNormalCompletion, _didIteratorError, _iteratorError, i, _iterator, _step, a, i1, a1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _step_value, _$e, _$t1, r;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _$t = [];
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        for(var i in e1)try {
                                            for(_iterator = e1[i][Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                a = _step.value;
                                                _$t.push(this._getAndCacheGlyphsPromise(i, a));
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        return [
                                            4,
                                            Promise.all(_$t)
                                        ];
                                    case 1:
                                        i1 = _state.sent(), a1 = {};
                                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        try {
                                            for(_iterator1 = i1[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                _step_value = _step1.value, _$e = _step_value.stack, _$t1 = _step_value.id, r = _step_value.glyph;
                                                a1[_$e] || (a1[_$e] = {}), a1[_$e][_$t1] = r && {
                                                    id: r.id,
                                                    bitmap: r.bitmap.clone(),
                                                    metrics: r.metrics
                                                };
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                        return [
                                            2,
                                            a1
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_getAndCacheGlyphsPromise",
                    value: function _getAndCacheGlyphsPromise(e1, i) {
                        return t._(this, void 0, void 0, function() {
                            var _$t, a, _tmp, _tmp1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _$t = this.entries[e1];
                                        _$t || (_$t = this.entries[e1] = {
                                            glyphs: {},
                                            requests: {},
                                            ranges: {}
                                        });
                                        a = _$t.glyphs[i];
                                        if (!(void 0 !== a)) return [
                                            3,
                                            1
                                        ];
                                        _tmp = {
                                            stack: e1,
                                            id: i,
                                            glyph: a
                                        };
                                        return [
                                            3,
                                            5
                                        ];
                                    case 1:
                                        if (!(!this.url || this._charUsesLocalIdeographFontFamily(i))) return [
                                            3,
                                            2
                                        ];
                                        _tmp1 = (a = _$t.glyphs[i] = this._drawGlyph(_$t, e1, i), {
                                            stack: e1,
                                            id: i,
                                            glyph: a
                                        });
                                        return [
                                            3,
                                            4
                                        ];
                                    case 2:
                                        return [
                                            4,
                                            this._downloadAndCacheRangePromise(e1, i)
                                        ];
                                    case 3:
                                        _tmp1 = _state.sent();
                                        _state.label = 4;
                                    case 4:
                                        _tmp = _tmp1;
                                        _state.label = 5;
                                    case 5:
                                        return [
                                            2,
                                            _tmp
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_downloadAndCacheRangePromise",
                    value: function _downloadAndCacheRangePromise(e1, i) {
                        return t._(this, void 0, void 0, function() {
                            var _$t, a, _$i, _$r, _$e, r, o;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _$t = this.entries[e1], a = Math.floor(i / 256);
                                        if (_$t.ranges[a]) return [
                                            2,
                                            {
                                                stack: e1,
                                                id: i,
                                                glyph: null
                                            }
                                        ];
                                        if (!_$t.requests[a]) {
                                            _$i = M.loadGlyphRange(e1, a, this.url, this.requestManager);
                                            _$t.requests[a] = _$i;
                                        }
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            _$t.requests[a]
                                        ];
                                    case 2:
                                        _$r = _state.sent();
                                        for(var _$e in _$r)_$t.glyphs[+_$e] = _$r[+_$e];
                                        return [
                                            2,
                                            (_$t.ranges[a] = !0, {
                                                stack: e1,
                                                id: i,
                                                glyph: _$r[i] || null
                                            })
                                        ];
                                    case 3:
                                        r = _state.sent();
                                        o = _$t.glyphs[i] = this._drawGlyph(_$t, e1, i);
                                        return [
                                            2,
                                            (this._warnOnMissingGlyphRange(o, a, i, r), {
                                                stack: e1,
                                                id: i,
                                                glyph: o
                                            })
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_warnOnMissingGlyphRange",
                    value: function _warnOnMissingGlyphRange(e1, i, a, r) {
                        var o = 256 * i, s = o + 255, n = a.toString(16).padStart(4, "0").toUpperCase();
                        t.w("Unable to load glyph range ".concat(i, ", ").concat(o, "-").concat(s, ". Rendering codepoint U+").concat(n, " locally instead. ").concat(r));
                    }
                },
                {
                    key: "_charUsesLocalIdeographFontFamily",
                    value: function _charUsesLocalIdeographFontFamily(e1) {
                        return !!this.localIdeographFontFamily && t.q(e1);
                    }
                },
                {
                    key: "_drawGlyph",
                    value: function _drawGlyph(e1, i, a) {
                        var r = i === I && "" !== this.localIdeographFontFamily && this._charUsesLocalIdeographFontFamily(a), o = r ? "ideographTinySDF" : "tinySDF";
                        e1[o] || (e1[o] = this._createTinySDF(r ? this.localIdeographFontFamily : i));
                        var s = e1[o].draw(String.fromCodePoint(a));
                        return {
                            id: a,
                            bitmap: new t.r({
                                width: s.width || 60,
                                height: s.height || 60
                            }, s.data),
                            metrics: {
                                width: s.glyphWidth / 2 || 24,
                                height: s.glyphHeight / 2 || 24,
                                left: s.glyphLeft / 2 + .5 || 0,
                                top: s.glyphTop / 2 - 27.5 || -8,
                                advance: s.glyphAdvance / 2 || 24,
                                isDoubleResolution: !0
                            }
                        };
                    }
                },
                {
                    key: "_createTinySDF",
                    value: function _createTinySDF(e1) {
                        var _$t = e1 ? e1.split(",") : [];
                        _$t.push("sans-serif");
                        var i = _$t.map(function(e1) {
                            return /[-\w]+/.test(e1) ? e1 : "'".concat(CSS.escape(e1), "'");
                        }).join(",");
                        return new M.TinySDF({
                            fontSize: 48,
                            buffer: 6,
                            radius: 16,
                            cutoff: .25,
                            fontFamily: i,
                            fontWeight: this._fontWeight(_$t[0]),
                            fontStyle: this._fontStyle(_$t[0]),
                            lang: this.lang
                        });
                    }
                },
                {
                    key: "_fontStyle",
                    value: function _fontStyle(e1) {
                        return /italic/i.test(e1) ? "italic" : /oblique/i.test(e1) ? "oblique" : "normal";
                    }
                },
                {
                    key: "_fontWeight",
                    value: function _fontWeight(e1) {
                        var _$t = {
                            thin: 100,
                            hairline: 100,
                            "extra light": 200,
                            "ultra light": 200,
                            light: 300,
                            normal: 400,
                            regular: 400,
                            medium: 500,
                            semibold: 600,
                            demibold: 600,
                            bold: 700,
                            "extra bold": 800,
                            "ultra bold": 800,
                            black: 900,
                            heavy: 900,
                            "extra black": 950,
                            "ultra black": 950
                        };
                        var i;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.entries(_$t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), a = _step_value[0], r = _step_value[1];
                                new RegExp("\\b".concat(a, "\\b"), "i").test(e1) && (i = "".concat(r));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return i;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        for(var _$e in this.entries){
                            var _$t = this.entries[_$e];
                            _$t.tinySDF && (_$t.tinySDF = null), _$t.ideographTinySDF && (_$t.ideographTinySDF = null), _$t.glyphs = {}, _$t.requests = {}, _$t.ranges = {};
                        }
                        this.entries = {};
                    }
                }
            ]);
            return M;
        }();
        M.loadGlyphRange = function(e1, i, a, r) {
            return t._(this, void 0, void 0, function() {
                var o, s, n, l, _$c, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$e;
                return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            o = 256 * i, s = o + 255, n = r.transformRequest(a.replace("{fontstack}", e1).replace("{range}", "".concat(o, "-").concat(s)), "Glyphs");
                            return [
                                4,
                                t.n(n, new AbortController)
                            ];
                        case 1:
                            l = _state.sent();
                            if (!l || !l.data) throw new Error("Could not load glyph range. range: ".concat(i, ", ").concat(o, "-").concat(s));
                            _$c = {};
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = t.o(l.data)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    _$e = _step.value;
                                    _$c[_$e.id] = _$e;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                2,
                                _$c
                            ];
                    }
                });
            });
        }, M.TinySDF = /*#__PURE__*/ function() {
            function _class() {
                var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, tmp = _ref.fontSize, _$e = tmp === void 0 ? 24 : tmp, tmp1 = _ref.buffer, _$t = tmp1 === void 0 ? 3 : tmp1, tmp2 = _ref.radius, i = tmp2 === void 0 ? 8 : tmp2, tmp3 = _ref.cutoff, a = tmp3 === void 0 ? .25 : tmp3, tmp4 = _ref.fontFamily, r = tmp4 === void 0 ? "sans-serif" : tmp4, tmp5 = _ref.fontWeight, o = tmp5 === void 0 ? "normal" : tmp5, tmp6 = _ref.fontStyle, s = tmp6 === void 0 ? "normal" : tmp6, tmp7 = _ref.lang, n = tmp7 === void 0 ? null : tmp7;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this.buffer = _$t, this.cutoff = a, this.radius = i, this.lang = n;
                var l = this.size = _$e + 4 * _$t, _$c = this._createCanvas(l), h = this.ctx = _$c.getContext("2d", {
                    willReadFrequently: !0
                });
                h.font = "".concat(s, " ").concat(o, " ").concat(_$e, "px ").concat(r), h.textBaseline = "alphabetic", h.textAlign = "left", h.fillStyle = "black", this.gridOuter = new Float64Array(l * l), this.gridInner = new Float64Array(l * l), this.f = new Float64Array(l), this.z = new Float64Array(l + 1), this.v = new Uint16Array(l);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "_createCanvas",
                    value: function _createCanvas(e1) {
                        var _$t = document.createElement("canvas");
                        return _$t.width = _$t.height = e1, _$t;
                    }
                },
                {
                    key: "draw",
                    value: function draw(e1) {
                        var _this_ctx_measureText = this.ctx.measureText(e1), _$t = _this_ctx_measureText.width, i = _this_ctx_measureText.actualBoundingBoxAscent, a = _this_ctx_measureText.actualBoundingBoxDescent, r = _this_ctx_measureText.actualBoundingBoxLeft, o = _this_ctx_measureText.actualBoundingBoxRight, s = Math.ceil(i), n = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(o - r))), l = Math.min(this.size - this.buffer, s + Math.ceil(a)), _$c = n + 2 * this.buffer, h = l + 2 * this.buffer, u = Math.max(_$c * h, 0), d = new Uint8ClampedArray(u), _ = {
                            data: d,
                            width: _$c,
                            height: h,
                            glyphWidth: n,
                            glyphHeight: l,
                            glyphTop: s,
                            glyphLeft: 0,
                            glyphAdvance: _$t
                        };
                        if (0 === n || 0 === l) return _;
                        var _this = this, p = _this.ctx, m = _this.buffer, f = _this.gridInner, g = _this.gridOuter;
                        this.lang && (p.lang = this.lang), p.clearRect(m, m, n, l), p.fillText(e1, m, m + s);
                        var v = p.getImageData(m, m, n, l);
                        g.fill(T, 0, u), f.fill(0, 0, u);
                        for(var _$e = 0; _$e < l; _$e++)for(var _$t1 = 0; _$t1 < n; _$t1++){
                            var i1 = v.data[4 * (_$e * n + _$t1) + 3] / 255;
                            if (0 === i1) continue;
                            var a1 = (_$e + m) * _$c + _$t1 + m;
                            if (1 === i1) g[a1] = 0, f[a1] = T;
                            else {
                                var _$e1 = .5 - i1;
                                g[a1] = _$e1 > 0 ? _$e1 * _$e1 : 0, f[a1] = _$e1 < 0 ? _$e1 * _$e1 : 0;
                            }
                        }
                        P(g, 0, 0, _$c, h, _$c, this.f, this.v, this.z), P(f, m, m, n, l, _$c, this.f, this.v, this.z);
                        for(var _$e2 = 0; _$e2 < u; _$e2++){
                            var _$t2 = Math.sqrt(g[_$e2]) - Math.sqrt(f[_$e2]);
                            d[_$e2] = Math.round(255 - 255 * (_$t2 / this.radius + this.cutoff));
                        }
                        return _;
                    }
                }
            ]);
            return _class;
        }();
        var E = /*#__PURE__*/ function() {
            function E() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, E);
                this.specification = t.u.light.position;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(E, [
                {
                    key: "possiblyEvaluate",
                    value: function possiblyEvaluate(e1, i) {
                        return t.F(e1.expression.evaluate(i));
                    }
                },
                {
                    key: "interpolate",
                    value: function interpolate(e1, i, a) {
                        return {
                            x: t.G.number(e1.x, i.x, a),
                            y: t.G.number(e1.y, i.y, a),
                            z: t.G.number(e1.z, i.z, a)
                        };
                    }
                }
            ]);
            return E;
        }();
        var S;
        var R = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(R, _t_E);
            function R(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, R);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, R), S = S || new t.t({
                    anchor: new t.D(t.u.light.anchor),
                    position: new E,
                    color: new t.D(t.u.light.color),
                    intensity: new t.D(t.u.light.intensity)
                }), _this._transitionable = new t.x(S, void 0), _this.setLight(e1), _this._transitioning = _this._transitionable.untransitioned();
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(R, [
                {
                    key: "getLight",
                    value: function getLight() {
                        return this._transitionable.serialize();
                    }
                },
                {
                    key: "setLight",
                    value: function setLight(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        if (!this._validate(t.y, e1, i)) for(var i1 in e1){
                            var a = e1[i1];
                            i1.endsWith(t.z) ? this._transitionable.setTransition(i1.slice(0, -t.z.length), a) : this._transitionable.setValue(i1, a);
                        }
                    }
                },
                {
                    key: "updateTransitions",
                    value: function updateTransitions(e1) {
                        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return this._transitioning.hasTransition();
                    }
                },
                {
                    key: "recalculate",
                    value: function recalculate(e1) {
                        this.properties = this._transitioning.possiblyEvaluate(e1);
                    }
                },
                {
                    key: "_validate",
                    value: function _validate(e1, i, a) {
                        return (!a || !1 !== a.validate) && t.B(this, e1.call(t.C, {
                            value: i,
                            style: {
                                glyphs: !0,
                                sprite: !0
                            },
                            styleSpec: t.u
                        }));
                    }
                }
            ]);
            return R;
        }(t.E);
        var z = new t.t({
            "sky-color": new t.D(t.u.sky["sky-color"]),
            "horizon-color": new t.D(t.u.sky["horizon-color"]),
            "fog-color": new t.D(t.u.sky["fog-color"]),
            "fog-ground-blend": new t.D(t.u.sky["fog-ground-blend"]),
            "horizon-fog-blend": new t.D(t.u.sky["horizon-fog-blend"]),
            "sky-horizon-blend": new t.D(t.u.sky["sky-horizon-blend"]),
            "atmosphere-blend": new t.D(t.u.sky["atmosphere-blend"])
        });
        var D = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(D, _t_E);
            function D(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, D);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, D), _this._transitionable = new t.x(z, void 0), _this.setSky(e1), _this._transitioning = _this._transitionable.untransitioned(), _this.recalculate(new t.H(0));
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(D, [
                {
                    key: "setSky",
                    value: function setSky(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        if (!this._validate(t.J, e1, i)) {
                            e1 || (e1 = {
                                "sky-color": "transparent",
                                "horizon-color": "transparent",
                                "fog-color": "transparent",
                                "fog-ground-blend": 1,
                                "atmosphere-blend": 0
                            });
                            for(var i1 in e1){
                                var a = e1[i1];
                                i1.endsWith(t.z) ? this._transitionable.setTransition(i1.slice(0, -t.z.length), a) : this._transitionable.setValue(i1, a);
                            }
                        }
                    }
                },
                {
                    key: "getSky",
                    value: function getSky() {
                        return this._transitionable.serialize();
                    }
                },
                {
                    key: "updateTransitions",
                    value: function updateTransitions(e1) {
                        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return this._transitioning.hasTransition();
                    }
                },
                {
                    key: "recalculate",
                    value: function recalculate(e1) {
                        this.properties = this._transitioning.possiblyEvaluate(e1);
                    }
                },
                {
                    key: "_validate",
                    value: function _validate(e1, i) {
                        var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        return !1 !== (null == a ? void 0 : a.validate) && t.B(this, e1.call(t.C, t.e({
                            value: i,
                            style: {
                                glyphs: !0,
                                sprite: !0
                            },
                            styleSpec: t.u
                        })));
                    }
                },
                {
                    key: "calculateFogBlendOpacity",
                    value: function calculateFogBlendOpacity(e1) {
                        return e1 < 60 ? 0 : e1 < 70 ? (e1 - 60) / 10 : 1;
                    }
                }
            ]);
            return D;
        }(t.E);
        var A = /*#__PURE__*/ function() {
            function A(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, A);
                this.width = e1, this.height = t, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(A, [
                {
                    key: "getDash",
                    value: function getDash(e1, t) {
                        var i = e1.join(",") + String(t);
                        return this.dashEntry[i] || (this.dashEntry[i] = this.addDash(e1, t)), this.dashEntry[i];
                    }
                },
                {
                    key: "getDashRanges",
                    value: function getDashRanges(e1, t, i) {
                        var a = [];
                        var r = e1.length % 2 == 1 ? -e1[e1.length - 1] * i : 0, o = e1[0] * i, s = !0;
                        a.push({
                            left: r,
                            right: o,
                            isDash: s,
                            zeroLength: 0 === e1[0]
                        });
                        var n = e1[0];
                        for(var _$t = 1; _$t < e1.length; _$t++){
                            s = !s;
                            var l = e1[_$t];
                            r = n * i, n += l, o = n * i, a.push({
                                left: r,
                                right: o,
                                isDash: s,
                                zeroLength: 0 === l
                            });
                        }
                        return a;
                    }
                },
                {
                    key: "addRoundDash",
                    value: function addRoundDash(e1, t, i) {
                        var a = t / 2;
                        for(var _$t = -i; _$t <= i; _$t++){
                            var r = this.width * (this.nextRow + i + _$t);
                            var o = 0, s = e1[o];
                            for(var n = 0; n < this.width; n++){
                                n / s.right > 1 && (s = e1[++o]);
                                var l = Math.abs(n - s.left), _$c = Math.abs(n - s.right), h = Math.min(l, _$c);
                                var u = void 0;
                                var d = _$t / i * (a + 1);
                                if (s.isDash) {
                                    var _$e = a - Math.abs(d);
                                    u = Math.sqrt(h * h + _$e * _$e);
                                } else u = a - Math.sqrt(h * h + d * d);
                                this.data[r + n] = Math.max(0, Math.min(255, u + 128));
                            }
                        }
                    }
                },
                {
                    key: "addRegularDash",
                    value: function addRegularDash(e1) {
                        for(var _$t = e1.length - 1; _$t >= 0; --_$t){
                            var i = e1[_$t], a = e1[_$t + 1];
                            i.zeroLength ? e1.splice(_$t, 1) : a && a.isDash === i.isDash && (a.left = i.left, e1.splice(_$t, 1));
                        }
                        var _$t1 = e1[0], i1 = e1[e1.length - 1];
                        _$t1.isDash === i1.isDash && (_$t1.left = i1.left - this.width, i1.right = _$t1.right + this.width);
                        var a1 = this.width * this.nextRow;
                        var r = 0, o = e1[r];
                        for(var _$t2 = 0; _$t2 < this.width; _$t2++){
                            _$t2 / o.right > 1 && (o = e1[++r]);
                            var i2 = Math.abs(_$t2 - o.left), s = Math.abs(_$t2 - o.right), n = Math.min(i2, s);
                            this.data[a1 + _$t2] = Math.max(0, Math.min(255, (o.isDash ? n : -n) + 128));
                        }
                    }
                },
                {
                    key: "addDash",
                    value: function addDash(e1, i) {
                        var a = i ? 7 : 0, r = 2 * a + 1;
                        if (this.nextRow + r > this.height) return t.w("LineAtlas out of space"), null;
                        var o = 0;
                        for(var _$t = 0; _$t < e1.length; _$t++)o += e1[_$t];
                        if (0 !== o) {
                            var _$t1 = this.width / o, r1 = this.getDashRanges(e1, this.width, _$t1);
                            i ? this.addRoundDash(r1, _$t1, a) : this.addRegularDash(r1);
                        }
                        var s = {
                            y: this.nextRow + a,
                            height: 2 * a,
                            width: o
                        };
                        return this.nextRow += r, this.dirty = !0, s;
                    }
                },
                {
                    key: "bind",
                    value: function bind(e1) {
                        var _$t = e1.gl;
                        this.texture ? (_$t.bindTexture(_$t.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, _$t.texSubImage2D(_$t.TEXTURE_2D, 0, 0, 0, this.width, this.height, _$t.ALPHA, _$t.UNSIGNED_BYTE, this.data))) : (this.texture = _$t.createTexture(), _$t.bindTexture(_$t.TEXTURE_2D, this.texture), _$t.texParameteri(_$t.TEXTURE_2D, _$t.TEXTURE_WRAP_S, _$t.REPEAT), _$t.texParameteri(_$t.TEXTURE_2D, _$t.TEXTURE_WRAP_T, _$t.REPEAT), _$t.texParameteri(_$t.TEXTURE_2D, _$t.TEXTURE_MIN_FILTER, _$t.LINEAR), _$t.texParameteri(_$t.TEXTURE_2D, _$t.TEXTURE_MAG_FILTER, _$t.LINEAR), _$t.texImage2D(_$t.TEXTURE_2D, 0, _$t.ALPHA, this.width, this.height, 0, _$t.ALPHA, _$t.UNSIGNED_BYTE, this.data));
                    }
                }
            ]);
            return A;
        }();
        var L = "maplibre_preloaded_worker_pool";
        var k = /*#__PURE__*/ function() {
            function k() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, k);
                this.active = {};
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(k, [
                {
                    key: "acquire",
                    value: function acquire(e1) {
                        if (!this.workers) for(this.workers = []; this.workers.length < k.workerCount;)this.workers.push(new Worker(t.c.WORKER_URL));
                        return this.active[e1] = !0, this.workers.slice();
                    }
                },
                {
                    key: "release",
                    value: function release(e1) {
                        delete this.active[e1], 0 === this.numActive() && (this.workers.forEach(function(e1) {
                            e1.terminate();
                        }), this.workers = null);
                    }
                },
                {
                    key: "isPreloaded",
                    value: function isPreloaded() {
                        return !!this.active[L];
                    }
                },
                {
                    key: "numActive",
                    value: function numActive() {
                        return Object.keys(this.active).length;
                    }
                }
            ]);
            return k;
        }();
        var F = Math.floor(n.hardwareConcurrency / 2);
        var B, O;
        function j() {
            return B || (B = new k), B;
        }
        k.workerCount = t.K(globalThis) ? Math.max(Math.min(F, 3), 1) : 1;
        var N = /*#__PURE__*/ function() {
            function N(e1, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, N);
                this.workerPool = e1, this.actors = [], this.currentActor = 0, this.id = i;
                var a = this.workerPool.acquire(i);
                for(var _$e = 0; _$e < a.length; _$e++){
                    var r = new t.L(a[_$e], i);
                    r.name = "Worker ".concat(_$e), this.actors.push(r);
                }
                if (!this.actors.length) throw new Error("No actors found");
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(N, [
                {
                    key: "broadcast",
                    value: function broadcast(e1, t) {
                        var i = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.actors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var a = _step.value;
                                i.push(a.sendAsync({
                                    type: e1,
                                    data: t
                                }));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return Promise.all(i);
                    }
                },
                {
                    key: "getActor",
                    value: function getActor() {
                        return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
                    }
                },
                {
                    key: "remove",
                    value: function remove() {
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                        this.actors.forEach(function(e1) {
                            e1.remove();
                        }), this.actors = [], _$e && this.workerPool.release(this.id);
                    }
                },
                {
                    key: "registerMessageHandler",
                    value: function registerMessageHandler(e1, t) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.actors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                i.registerMessageHandler(e1, t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "unregisterMessageHandler",
                    value: function unregisterMessageHandler(e1) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.actors[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                _$t.unregisterMessageHandler(e1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
            ]);
            return N;
        }();
        function Z() {
            return O || (O = new N(j(), t.M), O.registerMessageHandler("GR", function(e1, i, a) {
                return t.m(i, a);
            })), O;
        }
        function G(e1, i) {
            var a = t.N();
            return t.O(a, a, [
                1,
                1,
                0
            ]), t.Q(a, a, [
                .5 * e1.width,
                .5 * e1.height,
                1
            ]), e1.calculatePosMatrix ? t.S(a, a, e1.calculatePosMatrix(i.toUnwrapped())) : a;
        }
        function U(e1, t, i, a, r, o, s) {
            var n;
            var l = function(e1, t, i) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (e1) try {
                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$a = _step.value;
                        var _$e = t[_$a];
                        if (_$e && _$e.source === i && "fill-extrusion" === _$e.type) return !0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                else for(var _$e1 in t){
                    var _$a1 = t[_$e1];
                    if (_$a1.source === i && "fill-extrusion" === _$a1.type) return !0;
                }
                return !1;
            }(null !== (n = null == r ? void 0 : r.layers) && void 0 !== n ? n : null, t, e1.id), _$c = o.maxPitchScaleFactor(), h = e1.tilesIn(a, _$c, l);
            h.sort(V);
            var u = [];
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var _$a = _step.value;
                    u.push({
                        wrappedTileID: _$a.tileID.wrapped().key,
                        queryResults: _$a.tile.queryRenderedFeatures(t, i, e1.getState(), _$a.queryGeometry, _$a.cameraQueryGeometry, _$a.scale, r, o, _$c, G(o, _$a.tileID), s ? function(e1, t) {
                            return s(_$a.tileID, e1, t);
                        } : void 0)
                    });
                };
                for(var _iterator = h[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return function(e1, t) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                for(var _$i in e1)try {
                    for(var _iterator = e1[_$i][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$a = _step.value;
                        q(_$a, t);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return e1;
            }(function(e1) {
                var _$t = {}, _$i = {};
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$a = _step.value;
                        var _$e = _$a.queryResults, _$r = _$a.wrappedTileID, _$o = _$i[_$r] = _$i[_$r] || {};
                        for(var _$i1 in _$e){
                            var _$a1 = _$e[_$i1], _$r1 = _$o[_$i1] = _$o[_$i1] || {}, _$s = _$t[_$i1] = _$t[_$i1] || [];
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = _$a1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var _$e1 = _step1.value;
                                    _$r1[_$e1.featureIndex] || (_$r1[_$e1.featureIndex] = !0, _$s.push(_$e1));
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return _$t;
            }(u), e1);
        }
        function V(e1, t) {
            var i = e1.tileID, a = t.tileID;
            return i.overscaledZ - a.overscaledZ || i.canonical.y - a.canonical.y || i.wrap - a.wrap || i.canonical.x - a.canonical.x;
        }
        function q(e1, t) {
            var i = e1.feature, a = t.getFeatureState(i.layer["source-layer"], i.id);
            i.source = i.layer.source, i.layer["source-layer"] && (i.sourceLayer = i.layer["source-layer"]), i.state = a;
        }
        function W(e1, i, a) {
            return t._(this, void 0, void 0, function() {
                var r, _tmp, o;
                return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            r = e1;
                            if (!e1.url) return [
                                3,
                                2
                            ];
                            return [
                                4,
                                t.j(i.transformRequest(e1.url, "Source"), a)
                            ];
                        case 1:
                            _tmp = r = _state.sent().data;
                            return [
                                3,
                                4
                            ];
                        case 2:
                            return [
                                4,
                                n.frameAsync(a)
                            ];
                        case 3:
                            _tmp = _state.sent();
                            _state.label = 4;
                        case 4:
                            if (_tmp, !r) return [
                                2,
                                null
                            ];
                            o = t.U(t.e(r, e1), [
                                "tiles",
                                "minzoom",
                                "maxzoom",
                                "attribution",
                                "bounds",
                                "scheme",
                                "tileSize",
                                "encoding"
                            ]);
                            return [
                                2,
                                ("vector_layers" in r && r.vector_layers && (o.vectorLayerIds = r.vector_layers.map(function(e1) {
                                    return e1.id;
                                })), o)
                            ];
                    }
                });
            });
        }
        var $ = /*#__PURE__*/ function() {
            function $(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, $);
                e1 && (t ? this.setSouthWest(e1).setNorthEast(t) : Array.isArray(e1) && (4 === e1.length ? this.setSouthWest([
                    e1[0],
                    e1[1]
                ]).setNorthEast([
                    e1[2],
                    e1[3]
                ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1])));
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)($, [
                {
                    key: "setNorthEast",
                    value: function setNorthEast(e1) {
                        return this._ne = e1 instanceof t.V ? new t.V(e1.lng, e1.lat) : t.V.convert(e1), this;
                    }
                },
                {
                    key: "setSouthWest",
                    value: function setSouthWest(e1) {
                        return this._sw = e1 instanceof t.V ? new t.V(e1.lng, e1.lat) : t.V.convert(e1), this;
                    }
                },
                {
                    key: "extend",
                    value: function extend(e1) {
                        var i = this._sw, a = this._ne;
                        var r, o;
                        if (e1 instanceof t.V) r = e1, o = e1;
                        else {
                            if (!(e1 instanceof $)) return Array.isArray(e1) ? 4 === e1.length || e1.every(Array.isArray) ? this.extend($.convert(e1)) : this.extend(t.V.convert(e1)) : e1 && ("lng" in e1 || "lon" in e1) && "lat" in e1 ? this.extend(t.V.convert(e1)) : this;
                            if (r = e1._sw, o = e1._ne, !r || !o) return this;
                        }
                        return i || a ? (i.lng = Math.min(r.lng, i.lng), i.lat = Math.min(r.lat, i.lat), a.lng = Math.max(o.lng, a.lng), a.lat = Math.max(o.lat, a.lat)) : (this._sw = new t.V(r.lng, r.lat), this._ne = new t.V(o.lng, o.lat)), this;
                    }
                },
                {
                    key: "getCenter",
                    value: function getCenter() {
                        return new t.V((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
                    }
                },
                {
                    key: "getSouthWest",
                    value: function getSouthWest() {
                        return this._sw;
                    }
                },
                {
                    key: "getNorthEast",
                    value: function getNorthEast() {
                        return this._ne;
                    }
                },
                {
                    key: "getNorthWest",
                    value: function getNorthWest() {
                        return new t.V(this.getWest(), this.getNorth());
                    }
                },
                {
                    key: "getSouthEast",
                    value: function getSouthEast() {
                        return new t.V(this.getEast(), this.getSouth());
                    }
                },
                {
                    key: "getWest",
                    value: function getWest() {
                        return this._sw.lng;
                    }
                },
                {
                    key: "getSouth",
                    value: function getSouth() {
                        return this._sw.lat;
                    }
                },
                {
                    key: "getEast",
                    value: function getEast() {
                        return this._ne.lng;
                    }
                },
                {
                    key: "getNorth",
                    value: function getNorth() {
                        return this._ne.lat;
                    }
                },
                {
                    key: "toArray",
                    value: function toArray() {
                        return [
                            this._sw.toArray(),
                            this._ne.toArray()
                        ];
                    }
                },
                {
                    key: "toString",
                    value: function toString() {
                        return "LngLatBounds(".concat(this._sw.toString(), ", ").concat(this._ne.toString(), ")");
                    }
                },
                {
                    key: "isEmpty",
                    value: function isEmpty() {
                        return !(this._sw && this._ne);
                    }
                },
                {
                    key: "contains",
                    value: function contains(e1) {
                        var _t_V_convert = t.V.convert(e1), i = _t_V_convert.lng, a = _t_V_convert.lat;
                        var r = this._sw.lng <= i && i <= this._ne.lng;
                        return this._sw.lng > this._ne.lng && (r = this._sw.lng >= i && i >= this._ne.lng), this._sw.lat <= a && a <= this._ne.lat && r;
                    }
                },
                {
                    key: "intersects",
                    value: function intersects(e1) {
                        if (!((e1 = $.convert(e1)).getNorth() >= this.getSouth() && e1.getSouth() <= this.getNorth())) return !1;
                        var i = Math.abs(this.getEast() - this.getWest()), a = Math.abs(e1.getEast() - e1.getWest());
                        if (i >= 360 || a >= 360) return !0;
                        var r = t.W(this.getWest(), -180, 180), o = t.W(this.getEast(), -180, 180), s = t.W(e1.getWest(), -180, 180), n = t.W(e1.getEast(), -180, 180), l = r >= o, _$c = s >= n;
                        return !(!l || !_$c) || (l ? n >= r || s <= o : _$c ? o >= s || r <= n : s <= o && n >= r);
                    }
                },
                {
                    key: "adjustAntiMeridian",
                    value: function adjustAntiMeridian() {
                        var _$e = new t.V(this._sw.lng, this._sw.lat), i = new t.V(this._ne.lng, this._ne.lat);
                        return new $(_$e, _$e.lng > i.lng ? new t.V(i.lng + 360, i.lat) : i);
                    }
                }
            ], [
                {
                    key: "convert",
                    value: function convert(e1) {
                        return e1 instanceof $ ? e1 : e1 ? new $(e1) : e1;
                    }
                },
                {
                    key: "fromLngLat",
                    value: function fromLngLat(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                        var a = 360 * i / 40075017, r = a / Math.cos(Math.PI / 180 * e1.lat);
                        return new $(new t.V(e1.lng - r, e1.lat - a), new t.V(e1.lng + r, e1.lat + a));
                    }
                }
            ]);
            return $;
        }();
        var H = /*#__PURE__*/ function() {
            function H(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, H);
                this.bounds = $.convert(this.validateBounds(e1)), this.minzoom = t || 0, this.maxzoom = i || 24;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(H, [
                {
                    key: "validateBounds",
                    value: function validateBounds(e1) {
                        return Array.isArray(e1) && 4 === e1.length ? [
                            Math.max(-180, e1[0]),
                            Math.max(-90, e1[1]),
                            Math.min(180, e1[2]),
                            Math.min(90, e1[3])
                        ] : [
                            -180,
                            -90,
                            180,
                            90
                        ];
                    }
                },
                {
                    key: "contains",
                    value: function contains(e1) {
                        var i = Math.pow(2, e1.z), a = Math.floor(t.Y(this.bounds.getWest()) * i), r = Math.floor(t.X(this.bounds.getNorth()) * i), o = Math.ceil(t.Y(this.bounds.getEast()) * i), s = Math.ceil(t.X(this.bounds.getSouth()) * i);
                        return e1.x >= a && e1.x < o && e1.y >= r && e1.y < s;
                    }
                }
            ]);
            return H;
        }();
        var X = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(X, _t_E);
            function X(e1, i, a, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, X);
                var _this;
                if (_this = (0, $44950fec9206880e$export$71511d61b312f219)(this, X), _this.id = e1, _this.dispatcher = a, _this.type = "vector", _this.minzoom = 0, _this.maxzoom = 22, _this.scheme = "xyz", _this.tileSize = 512, _this.reparseOverscaled = !0, _this.isTileClipped = !0, _this._loaded = !1, t.e(_this, t.U(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId",
                    "encoding"
                ])), _this._options = t.e({
                    type: "vector"
                }, i), _this._collectResourceTiming = i.collectResourceTiming, 512 !== _this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                _this.setEventedParent(r);
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(X, [
                {
                    key: "load",
                    value: function load() {
                        return t._(this, void 0, void 0, function() {
                            var _$e, e1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        this._loaded = !1, this.fire(new t.l("dataloading", {
                                            dataType: "source"
                                        })), this._tileJSONRequest = new AbortController;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            W(this._options, this.map._requestManager, this._tileJSONRequest)
                                        ];
                                    case 2:
                                        _$e = _state.sent();
                                        this._tileJSONRequest = null, this._loaded = !0, this.map.style.tileManagers[this.id].clearTiles(), _$e && (t.e(this, _$e), _$e.bounds && (this.tileBounds = new H(_$e.bounds, this.minzoom, this.maxzoom)), this.fire(new t.l("data", {
                                            dataType: "source",
                                            sourceDataType: "metadata"
                                        })), this.fire(new t.l("data", {
                                            dataType: "source",
                                            sourceDataType: "content"
                                        })));
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        e1 = _state.sent();
                                        this._tileJSONRequest = null, this._loaded = !0, t.Z(e1) || this.fire(new t.k(e1));
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "loaded",
                    value: function loaded() {
                        return this._loaded;
                    }
                },
                {
                    key: "hasTile",
                    value: function hasTile(e1) {
                        return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                    }
                },
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        this.map = e1, this.load();
                    }
                },
                {
                    key: "setSourceProperty",
                    value: function setSourceProperty(e1) {
                        this._tileJSONRequest && this._tileJSONRequest.abort(), e1(), this.load();
                    }
                },
                {
                    key: "setTiles",
                    value: function setTiles(e1) {
                        var _this = this;
                        return this.setSourceProperty(function() {
                            _this._options.tiles = e1;
                        }), this;
                    }
                },
                {
                    key: "setUrl",
                    value: function setUrl(e1) {
                        var _this = this;
                        return this.setSourceProperty(function() {
                            _this.url = e1, _this._options.url = e1;
                        }), this;
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        return t.e({}, this._options);
                    }
                },
                {
                    key: "loadTile",
                    value: function loadTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            var _$t, i, a, _$t1, t;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _$t = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), i = {
                                            request: this.map._requestManager.transformRequest(_$t, "Tile"),
                                            uid: e1.uid,
                                            tileID: e1.tileID,
                                            zoom: e1.tileID.overscaledZ,
                                            tileSize: this.tileSize * e1.tileID.overscaleFactor(),
                                            type: this.type,
                                            source: this.id,
                                            pixelRatio: this.map.getPixelRatio(),
                                            showCollisionBoxes: this.map.showCollisionBoxes,
                                            promoteId: this.promoteId,
                                            subdivisionGranularity: this.map.style.projection.subdivisionGranularity,
                                            encoding: this.encoding,
                                            overzoomParameters: this._getOverzoomParameters(e1)
                                        };
                                        i.request.collectResourceTiming = this._collectResourceTiming;
                                        a = "RT";
                                        if (e1.actor && "expired" !== e1.state) {
                                            if ("loading" === e1.state) return [
                                                2,
                                                new Promise(function(t, i) {
                                                    e1.reloadPromise = {
                                                        resolve: t,
                                                        reject: i
                                                    };
                                                })
                                            ];
                                        } else e1.actor = this.dispatcher.getActor(), a = "LT";
                                        e1.abortController = new AbortController;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            e1.actor.sendAsync({
                                                type: a,
                                                data: i
                                            }, e1.abortController)
                                        ];
                                    case 2:
                                        _$t1 = _state.sent();
                                        if (delete e1.abortController, e1.aborted) return [
                                            2
                                        ];
                                        this._afterTileLoadWorkerResponse(e1, _$t1);
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        t = _state.sent();
                                        if (delete e1.abortController, e1.aborted) return [
                                            2
                                        ];
                                        if (t && 404 !== t.status) throw t;
                                        this._afterTileLoadWorkerResponse(e1, null);
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_getOverzoomParameters",
                    value: function _getOverzoomParameters(e1) {
                        if (e1.tileID.canonical.z <= this.maxzoom) return;
                        if (void 0 === this.map._zoomLevelsToOverscale) return;
                        var _$t = e1.tileID.scaledTo(this.maxzoom).canonical, i = _$t.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                        return {
                            maxZoomTileID: _$t,
                            overzoomRequest: this.map._requestManager.transformRequest(i, "Tile")
                        };
                    }
                },
                {
                    key: "_afterTileLoadWorkerResponse",
                    value: function _afterTileLoadWorkerResponse(e1, t) {
                        if (t && t.resourceTiming && (e1.resourceTiming = t.resourceTiming), t && this.map._refreshExpiredTiles && e1.setExpiryData(t), e1.loadVectorData(t, this.map.painter), e1.reloadPromise) {
                            var _$t = e1.reloadPromise;
                            e1.reloadPromise = null, this.loadTile(e1).then(_$t.resolve).catch(_$t.reject);
                        }
                    }
                },
                {
                    key: "abortTile",
                    value: function abortTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            var _tmp;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e1.abortController && (e1.abortController.abort(), delete e1.abortController);
                                        _tmp = e1.actor;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            e1.actor.sendAsync({
                                                type: "AT",
                                                data: {
                                                    uid: e1.uid,
                                                    type: this.type,
                                                    source: this.id
                                                }
                                            })
                                        ];
                                    case 1:
                                        _tmp = _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        _tmp;
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "unloadTile",
                    value: function unloadTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            var _tmp;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e1.unloadVectorData();
                                        _tmp = e1.actor;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            e1.actor.sendAsync({
                                                type: "RMT",
                                                data: {
                                                    uid: e1.uid,
                                                    type: this.type,
                                                    source: this.id
                                                }
                                            })
                                        ];
                                    case 1:
                                        _tmp = _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        _tmp;
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return !1;
                    }
                }
            ]);
            return X;
        }(t.E);
        var K = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(K, _t_E);
            function K(e1, i, a, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, K);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, K), _this.id = e1, _this.dispatcher = a, _this.setEventedParent(r), _this.type = "raster", _this.minzoom = 0, _this.maxzoom = 22, _this.roundZoom = !0, _this.scheme = "xyz", _this.tileSize = 512, _this._loaded = !1, _this._options = t.e({
                    type: "raster"
                }, i), t.e(_this, t.U(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(K, [
                {
                    key: "load",
                    value: function load() {
                        return t._(this, arguments, void 0, function() {
                            var _$e, i, e1;
                            var _arguments = arguments;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _$e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : !1;
                                        this._loaded = !1, this.fire(new t.l("dataloading", {
                                            dataType: "source"
                                        })), this._tileJSONRequest = new AbortController;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            W(this._options, this.map._requestManager, this._tileJSONRequest)
                                        ];
                                    case 2:
                                        i = _state.sent();
                                        this._tileJSONRequest = null, this._loaded = !0, i && (t.e(this, i), i.bounds && (this.tileBounds = new H(i.bounds, this.minzoom, this.maxzoom)), this.fire(new t.l("data", {
                                            dataType: "source",
                                            sourceDataType: "metadata"
                                        })), this.fire(new t.l("data", {
                                            dataType: "source",
                                            sourceDataType: "content",
                                            sourceDataChanged: _$e
                                        })));
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        e1 = _state.sent();
                                        this._tileJSONRequest = null, this._loaded = !0, t.Z(e1) || this.fire(new t.k(e1));
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "loaded",
                    value: function loaded() {
                        return this._loaded;
                    }
                },
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        this.map = e1, this.load();
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
                    }
                },
                {
                    key: "setSourceProperty",
                    value: function setSourceProperty(e1) {
                        this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null), e1(), this.load(!0);
                    }
                },
                {
                    key: "setTiles",
                    value: function setTiles(e1) {
                        var _this = this;
                        return this.setSourceProperty(function() {
                            _this._options.tiles = e1;
                        }), this;
                    }
                },
                {
                    key: "setUrl",
                    value: function setUrl(e1) {
                        var _this = this;
                        return this.setSourceProperty(function() {
                            _this.url = e1, _this._options.url = e1;
                        }), this;
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        return t.e({}, this._options);
                    }
                },
                {
                    key: "hasTile",
                    value: function hasTile(e1) {
                        return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                    }
                },
                {
                    key: "loadTile",
                    value: function loadTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            var i, a, i1, r, o, t1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        i = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                                        e1.abortController = new AbortController;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            g.getImage(this.map._requestManager.transformRequest(i, "Tile"), e1.abortController, this.map._refreshExpiredTiles)
                                        ];
                                    case 2:
                                        a = _state.sent();
                                        if (delete e1.abortController, e1.aborted) return [
                                            2,
                                            void (e1.state = "unloaded")
                                        ];
                                        if (a && a.data) {
                                            this.map._refreshExpiredTiles && (a.cacheControl || a.expires) && e1.setExpiryData({
                                                cacheControl: a.cacheControl,
                                                expires: a.expires
                                            });
                                            i1 = this.map.painter.context, r = i1.gl, o = a.data;
                                            e1.texture = this.map.painter.getTileTexture(o.width), e1.texture ? e1.texture.update(o, {
                                                useMipmap: !0
                                            }) : (e1.texture = new t.T(i1, o, r.RGBA, {
                                                useMipmap: !0
                                            }), e1.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE, r.LINEAR_MIPMAP_NEAREST)), e1.state = "loaded";
                                        }
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        t1 = _state.sent();
                                        if (delete e1.abortController, e1.aborted) e1.state = "unloaded";
                                        else if (t1) throw e1.state = "errored", t1;
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "abortTile",
                    value: function abortTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                e1.abortController && (e1.abortController.abort(), delete e1.abortController);
                                return [
                                    2
                                ];
                            });
                        });
                    }
                },
                {
                    key: "unloadTile",
                    value: function unloadTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                e1.texture && this.map.painter.saveTileTexture(e1.texture);
                                return [
                                    2
                                ];
                            });
                        });
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return !1;
                    }
                }
            ]);
            return K;
        }(t.E);
        var Y = /*#__PURE__*/ function(K) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Y, K);
            function Y(e1, i, a, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Y);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Y, [
                    e1,
                    i,
                    a,
                    r
                ]), _this.type = "raster-dem", _this.maxzoom = 22, _this._options = t.e({
                    type: "raster-dem"
                }, i), _this.encoding = i.encoding || "mapbox", _this.redFactor = i.redFactor, _this.greenFactor = i.greenFactor, _this.blueFactor = i.blueFactor, _this.baseShift = i.baseShift;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Y, [
                {
                    key: "loadTile",
                    value: function loadTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            var i, a, i1, a1, r, o, _tmp, _$t, t1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        i = e1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), a = this.map._requestManager.transformRequest(i, "Tile");
                                        e1.neighboringTiles = this._getNeighboringTiles(e1.tileID), e1.abortController = new AbortController;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            8,
                                            ,
                                            9
                                        ]);
                                        return [
                                            4,
                                            g.getImage(a, e1.abortController, this.map._refreshExpiredTiles)
                                        ];
                                    case 2:
                                        i1 = _state.sent();
                                        if (delete e1.abortController, e1.aborted) return [
                                            2,
                                            void (e1.state = "unloaded")
                                        ];
                                        if (!(i1 && i1.data)) return [
                                            3,
                                            7
                                        ];
                                        a1 = i1.data;
                                        this.map._refreshExpiredTiles && (i1.cacheControl || i1.expires) && e1.setExpiryData({
                                            cacheControl: i1.cacheControl,
                                            expires: i1.expires
                                        });
                                        if (!(t.b(a1) && t.$())) return [
                                            3,
                                            3
                                        ];
                                        _tmp = a1;
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        return [
                                            4,
                                            this.readImageNow(a1)
                                        ];
                                    case 4:
                                        _tmp = _state.sent();
                                        _state.label = 5;
                                    case 5:
                                        r = _tmp, o = {
                                            type: this.type,
                                            uid: e1.uid,
                                            source: this.id,
                                            rawImageData: r,
                                            encoding: this.encoding,
                                            redFactor: this.redFactor,
                                            greenFactor: this.greenFactor,
                                            blueFactor: this.blueFactor,
                                            baseShift: this.baseShift
                                        };
                                        if (!(!e1.actor || "expired" === e1.state)) return [
                                            3,
                                            7
                                        ];
                                        e1.actor = this.dispatcher.getActor();
                                        return [
                                            4,
                                            e1.actor.sendAsync({
                                                type: "LDT",
                                                data: o
                                            })
                                        ];
                                    case 6:
                                        _$t = _state.sent();
                                        e1.dem = _$t, e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0, e1.state = "loaded";
                                        _state.label = 7;
                                    case 7:
                                        return [
                                            3,
                                            9
                                        ];
                                    case 8:
                                        t1 = _state.sent();
                                        if (delete e1.abortController, e1.aborted) e1.state = "unloaded";
                                        else if (t1) throw e1.state = "errored", t1;
                                        return [
                                            3,
                                            9
                                        ];
                                    case 9:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "readImageNow",
                    value: function readImageNow(e1) {
                        return t._(this, void 0, void 0, function() {
                            var i, a, _, _1, _tmp, e2;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (!("undefined" != typeof VideoFrame && t.a0())) return [
                                            3,
                                            4
                                        ];
                                        i = e1.width + 2, a = e1.height + 2;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        _1 = (_ = t.R).bind;
                                        _tmp = [
                                            void 0,
                                            {
                                                width: i,
                                                height: a
                                            }
                                        ];
                                        return [
                                            4,
                                            t.a1(e1, -1, -1, i, a)
                                        ];
                                    case 2:
                                        return [
                                            2,
                                            new (_1.apply(_, _tmp.concat([
                                                _state.sent()
                                            ])))
                                        ];
                                    case 3:
                                        e2 = _state.sent();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2,
                                            n.getImageData(e1, 1)
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_getNeighboringTiles",
                    value: function _getNeighboringTiles(e1) {
                        var i = e1.canonical, a = Math.pow(2, i.z), r = (i.x - 1 + a) % a, o = 0 === i.x ? e1.wrap - 1 : e1.wrap, s = (i.x + 1 + a) % a, n = i.x + 1 === a ? e1.wrap + 1 : e1.wrap, l = {};
                        return l[new t.a2(e1.overscaledZ, o, i.z, r, i.y).key] = {
                            backfilled: !1
                        }, l[new t.a2(e1.overscaledZ, n, i.z, s, i.y).key] = {
                            backfilled: !1
                        }, i.y > 0 && (l[new t.a2(e1.overscaledZ, o, i.z, r, i.y - 1).key] = {
                            backfilled: !1
                        }, l[new t.a2(e1.overscaledZ, e1.wrap, i.z, i.x, i.y - 1).key] = {
                            backfilled: !1
                        }, l[new t.a2(e1.overscaledZ, n, i.z, s, i.y - 1).key] = {
                            backfilled: !1
                        }), i.y + 1 < a && (l[new t.a2(e1.overscaledZ, o, i.z, r, i.y + 1).key] = {
                            backfilled: !1
                        }, l[new t.a2(e1.overscaledZ, e1.wrap, i.z, i.x, i.y + 1).key] = {
                            backfilled: !1
                        }, l[new t.a2(e1.overscaledZ, n, i.z, s, i.y + 1).key] = {
                            backfilled: !1
                        }), l;
                    }
                },
                {
                    key: "unloadTile",
                    value: function unloadTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            var _tmp;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e1.demTexture && this.map.painter.saveTileTexture(e1.demTexture), e1.fbo && (e1.fbo.destroy(), delete e1.fbo), e1.dem && delete e1.dem, delete e1.neighboringTiles, e1.state = "unloaded";
                                        _tmp = e1.actor;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            e1.actor.sendAsync({
                                                type: "RDT",
                                                data: {
                                                    type: this.type,
                                                    uid: e1.uid,
                                                    source: this.id
                                                }
                                            })
                                        ];
                                    case 1:
                                        _tmp = _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        _tmp;
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                }
            ]);
            return Y;
        }(K);
        function Q(e1) {
            return "GeometryCollection" === e1.type ? e1.geometries.map(function(e1) {
                return e1.coordinates;
            }).flat(1 / 0) : e1.coordinates.flat(1 / 0);
        }
        function J(e1) {
            var _$t = new $;
            var i;
            switch(e1.type){
                case "FeatureCollection":
                    i = e1.features.map(function(e1) {
                        return Q(e1.geometry);
                    }).flat(1 / 0);
                    break;
                case "Feature":
                    i = Q(e1.geometry);
                    break;
                default:
                    i = Q(e1);
            }
            if (0 == i.length) return _$t;
            for(var _$e = 0; _$e < i.length - 1; _$e += 2)_$t.extend([
                i[_$e],
                i[_$e + 1]
            ]);
            return _$t;
        }
        var ee = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ee, _t_E);
            function ee(e1, i, a, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ee);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ee), _this.id = e1, _this.type = "geojson", _this.minzoom = 0, _this.maxzoom = 18, _this.tileSize = 512, _this.isTileClipped = !0, _this.reparseOverscaled = !0, _this._removed = !1, _this._isUpdatingWorker = !1, _this._pendingWorkerUpdate = {
                    data: i.data
                }, _this.actor = a.getActor(), _this.setEventedParent(r), _this._data = "string" == typeof i.data ? {
                    url: i.data
                } : {
                    geojson: i.data
                }, _this._options = t.e({}, i), _this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (_this.maxzoom = i.maxzoom), i.type && (_this.type = i.type), i.attribution && (_this.attribution = i.attribution), _this.promoteId = i.promoteId, void 0 !== i.clusterMaxZoom && _this.maxzoom <= i.clusterMaxZoom && t.w('The maxzoom value "'.concat(_this.maxzoom, '" is expected to be greater than the clusterMaxZoom value "').concat(i.clusterMaxZoom, '".')), _this.workerOptions = t.e({
                    source: _this.id,
                    cluster: i.cluster || !1,
                    geojsonVtOptions: {
                        buffer: _this._pixelsToTileUnits(void 0 !== i.buffer ? i.buffer : 128),
                        tolerance: _this._pixelsToTileUnits(void 0 !== i.tolerance ? i.tolerance : .375),
                        extent: t.a5,
                        maxZoom: _this.maxzoom,
                        lineMetrics: i.lineMetrics || !1,
                        generateId: i.generateId || !1
                    },
                    superclusterOptions: {
                        maxZoom: _this._getClusterMaxZoom(i.clusterMaxZoom),
                        minPoints: Math.max(2, i.clusterMinPoints || 2),
                        extent: t.a5,
                        radius: _this._pixelsToTileUnits(i.clusterRadius || 50),
                        log: !1,
                        generateId: i.generateId || !1
                    },
                    clusterProperties: i.clusterProperties,
                    filter: i.filter
                }, i.workerOptions), "string" == typeof _this.promoteId && (_this.workerOptions.promoteId = _this.promoteId);
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ee, [
                {
                    key: "_hasPendingWorkerUpdate",
                    value: function _hasPendingWorkerUpdate() {
                        return void 0 !== this._pendingWorkerUpdate.data || void 0 !== this._pendingWorkerUpdate.diff || this._pendingWorkerUpdate.optionsChanged;
                    }
                },
                {
                    key: "_pixelsToTileUnits",
                    value: function _pixelsToTileUnits(e1) {
                        return e1 * (t.a5 / this.tileSize);
                    }
                },
                {
                    key: "_getClusterMaxZoom",
                    value: function _getClusterMaxZoom(e1) {
                        var i = e1 ? Math.round(e1) : this.maxzoom - 1;
                        return Number.isInteger(e1) || void 0 === e1 || t.w("Integer expected for option 'clusterMaxZoom': provided value \"".concat(e1, '" rounded to "').concat(i, '"')), i;
                    }
                },
                {
                    key: "load",
                    value: function load() {
                        return t._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            this._updateWorkerData()
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        this.map = e1, this.load();
                    }
                },
                {
                    key: "setData",
                    value: function setData(e1, t) {
                        this._data = "string" == typeof e1 ? {
                            url: e1
                        } : {
                            geojson: e1
                        }, this._pendingWorkerUpdate = {
                            data: e1
                        };
                        var i = this._updateWorkerData();
                        return t ? i : this;
                    }
                },
                {
                    key: "updateData",
                    value: function updateData(e1, i) {
                        this._pendingWorkerUpdate.diff = t.a6(this._pendingWorkerUpdate.diff, e1);
                        var a = this._updateWorkerData();
                        return i ? a : this;
                    }
                },
                {
                    key: "getData",
                    value: function getData() {
                        return t._(this, void 0, void 0, function() {
                            var _$e;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                _$e = t.e({
                                    type: this.type
                                }, this.workerOptions);
                                return [
                                    2,
                                    this.actor.sendAsync({
                                        type: "GD",
                                        data: _$e
                                    })
                                ];
                            });
                        });
                    }
                },
                {
                    key: "getBounds",
                    value: function getBounds() {
                        return t._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            this.getData()
                                        ];
                                    case 1:
                                        return [
                                            2,
                                            J.apply(void 0, [
                                                _state.sent()
                                            ])
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "setClusterOptions",
                    value: function setClusterOptions(e1) {
                        return this.workerOptions.cluster = e1.cluster, void 0 !== e1.clusterRadius && (this.workerOptions.superclusterOptions.radius = this._pixelsToTileUnits(e1.clusterRadius)), void 0 !== e1.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = this._getClusterMaxZoom(e1.clusterMaxZoom)), this._pendingWorkerUpdate.optionsChanged = !0, this._updateWorkerData(), this;
                    }
                },
                {
                    key: "getClusterExpansionZoom",
                    value: function getClusterExpansionZoom(e1) {
                        return this.actor.sendAsync({
                            type: "GCEZ",
                            data: {
                                type: this.type,
                                clusterId: e1,
                                source: this.id
                            }
                        });
                    }
                },
                {
                    key: "getClusterChildren",
                    value: function getClusterChildren(e1) {
                        return this.actor.sendAsync({
                            type: "GCC",
                            data: {
                                type: this.type,
                                clusterId: e1,
                                source: this.id
                            }
                        });
                    }
                },
                {
                    key: "getClusterLeaves",
                    value: function getClusterLeaves(e1, t, i) {
                        return this.actor.sendAsync({
                            type: "GCL",
                            data: {
                                type: this.type,
                                source: this.id,
                                clusterId: e1,
                                limit: t,
                                offset: i
                            }
                        });
                    }
                },
                {
                    key: "_updateWorkerData",
                    value: function _updateWorkerData() {
                        return t._(this, void 0, void 0, function() {
                            var _this__pendingWorkerUpdate, _$e, i, a, _$e1, r, o, s, n1, e1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (this._isUpdatingWorker) return [
                                            2
                                        ];
                                        if (!this._hasPendingWorkerUpdate()) return [
                                            2,
                                            void t.w("No pending worker updates for GeoJSONSource ".concat(this.id, "."))
                                        ];
                                        _this__pendingWorkerUpdate = this._pendingWorkerUpdate, _$e = _this__pendingWorkerUpdate.data, i = _this__pendingWorkerUpdate.diff, a = t.e({
                                            type: this.type
                                        }, this.workerOptions);
                                        void 0 !== _$e ? ("string" == typeof _$e ? (a.request = this.map._requestManager.transformRequest(n.resolveURL(_$e), "Source"), a.request.collectResourceTiming = this._collectResourceTiming) : a.data = _$e, this._pendingWorkerUpdate.data = void 0) : i && (a.dataDiff = i, this._pendingWorkerUpdate.diff = void 0), this._pendingWorkerUpdate.optionsChanged = void 0, this._isUpdatingWorker = !0, this.fire(new t.l("dataloading", {
                                            dataType: "source"
                                        }));
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            4,
                                            5
                                        ]);
                                        return [
                                            4,
                                            this.actor.sendAsync({
                                                type: "LD",
                                                data: a
                                            })
                                        ];
                                    case 2:
                                        _$e1 = _state.sent();
                                        if (this._isUpdatingWorker = !1, this._removed || _$e1.abandoned) return [
                                            2,
                                            void this.fire(new t.l("dataabort", {
                                                dataType: "source"
                                            }))
                                        ];
                                        _$e1.data && (this._data = {
                                            geojson: _$e1.data
                                        });
                                        r = this._applyDiffToSource(i), o = this._getShouldReloadTileOptions(r);
                                        s = null;
                                        _$e1.resourceTiming && _$e1.resourceTiming[this.id] && (s = _$e1.resourceTiming[this.id].slice(0));
                                        n1 = {
                                            dataType: "source"
                                        };
                                        this._collectResourceTiming && s && s.length > 0 && t.e(n1, {
                                            resourceTiming: s
                                        }), this.fire(new t.l("data", Object.assign(Object.assign({}, n1), {
                                            sourceDataType: "metadata"
                                        }))), this.fire(new t.l("data", Object.assign(Object.assign({}, n1), {
                                            sourceDataType: "content",
                                            shouldReloadTileOptions: o
                                        })));
                                        return [
                                            3,
                                            5
                                        ];
                                    case 3:
                                        e1 = _state.sent();
                                        if (this._isUpdatingWorker = !1, this._removed) return [
                                            2,
                                            void this.fire(new t.l("dataabort", {
                                                dataType: "source"
                                            }))
                                        ];
                                        this.fire(new t.k(e1));
                                        return [
                                            3,
                                            5
                                        ];
                                    case 4:
                                        this._hasPendingWorkerUpdate() && this._updateWorkerData();
                                        return [
                                            7
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_applyDiffToSource",
                    value: function _applyDiffToSource(e1) {
                        if (!e1) return;
                        var i = "string" == typeof this.promoteId ? this.promoteId : void 0;
                        if (!this._data.url && !this._data.updateable) {
                            var _$e = t.a7(this._data.geojson, i);
                            if (!_$e) throw new Error('GeoJSONSource "'.concat(this.id, '": GeoJSON data is not compatible with updateData'));
                            this._data = {
                                updateable: _$e
                            };
                        }
                        if (!this._data.updateable) return;
                        var a = t.a8(this._data.updateable, e1, i);
                        return e1.removeAll || this._options.cluster ? void 0 : a;
                    }
                },
                {
                    key: "_getShouldReloadTileOptions",
                    value: function _getShouldReloadTileOptions(e1) {
                        if (e1) return {
                            affectedBounds: e1.filter(Boolean).map(function(e1) {
                                return J(e1);
                            })
                        };
                    }
                },
                {
                    key: "shouldReloadTile",
                    value: function shouldReloadTile(e1, param) {
                        var i = param.affectedBounds;
                        if ("loading" === e1.state) return !0;
                        if ("unloaded" === e1.state) return !1;
                        var _this_workerOptions_geojsonVtOptions = this.workerOptions.geojsonVtOptions, a = _this_workerOptions_geojsonVtOptions.buffer, r = _this_workerOptions_geojsonVtOptions.extent, o = function(param) {
                            var _$e = param.x, i = param.y, a = param.z, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
                            var o = t.a3((_$e - r) / Math.pow(2, a)), s = t.a4((i + 1 + r) / Math.pow(2, a)), n = t.a3((_$e + 1 + r) / Math.pow(2, a)), l = t.a4((i - r) / Math.pow(2, a));
                            return new $([
                                o,
                                s
                            ], [
                                n,
                                l
                            ]);
                        }(e1.tileID.canonical, a / r);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                if (o.intersects(_$e)) return !0;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return !1;
                    }
                },
                {
                    key: "loaded",
                    value: function loaded() {
                        return !this._isUpdatingWorker && !this._hasPendingWorkerUpdate();
                    }
                },
                {
                    key: "loadTile",
                    value: function loadTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            var _$t, i, a;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _$t = e1.actor ? "RT" : "LT";
                                        e1.actor = this.actor;
                                        i = {
                                            type: this.type,
                                            uid: e1.uid,
                                            tileID: e1.tileID,
                                            zoom: e1.tileID.overscaledZ,
                                            maxZoom: this.maxzoom,
                                            tileSize: this.tileSize,
                                            source: this.id,
                                            pixelRatio: this.map.getPixelRatio(),
                                            showCollisionBoxes: this.map.showCollisionBoxes,
                                            promoteId: this.promoteId,
                                            subdivisionGranularity: this.map.style.projection.subdivisionGranularity
                                        };
                                        e1.abortController = new AbortController;
                                        return [
                                            4,
                                            this.actor.sendAsync({
                                                type: _$t,
                                                data: i
                                            }, e1.abortController)
                                        ];
                                    case 1:
                                        a = _state.sent();
                                        delete e1.abortController, e1.unloadVectorData(), e1.aborted || e1.loadVectorData(a, this.map.painter, "RT" === _$t);
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "abortTile",
                    value: function abortTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                e1.abortController && (e1.abortController.abort(), delete e1.abortController), e1.aborted = !0;
                                return [
                                    2
                                ];
                            });
                        });
                    }
                },
                {
                    key: "unloadTile",
                    value: function unloadTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        e1.unloadVectorData();
                                        return [
                                            4,
                                            this.actor.sendAsync({
                                                type: "RMT",
                                                data: {
                                                    uid: e1.uid,
                                                    type: this.type,
                                                    source: this.id
                                                }
                                            })
                                        ];
                                    case 1:
                                        _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        this._removed = !0, this.actor.sendAsync({
                            type: "RS",
                            data: {
                                type: this.type,
                                source: this.id
                            }
                        });
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        return t.e({}, this._options, {
                            type: this.type,
                            data: this._data.updateable ? {
                                type: "FeatureCollection",
                                features: Array.from(this._data.updateable.values())
                            } : this._data.url || this._data.geojson
                        });
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return !1;
                    }
                }
            ]);
            return ee;
        }(t.E);
        var te = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(te, _t_E);
            function te(e1, t, i, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, te);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, te), _this.flippedWindingOrder = !1, _this.id = e1, _this.dispatcher = i, _this.coordinates = t.coordinates, _this.type = "image", _this.minzoom = 0, _this.maxzoom = 22, _this.tileSize = 512, _this.tiles = {}, _this._loaded = !1, _this.setEventedParent(a), _this.options = t;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(te, [
                {
                    key: "load",
                    value: function load(e1) {
                        return t._(this, void 0, void 0, function() {
                            var _$t, e2;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        this._loaded = !1, this.fire(new t.l("dataloading", {
                                            dataType: "source"
                                        })), this.url = this.options.url, this._request = new AbortController;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            g.getImage(this.map._requestManager.transformRequest(this.url, "Image"), this._request)
                                        ];
                                    case 2:
                                        _$t = _state.sent();
                                        this._request = null, this._loaded = !0, _$t && _$t.data && (this.image = _$t.data, e1 && (this.coordinates = e1), this._finishLoading());
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        e2 = _state.sent();
                                        this._request = null, this._loaded = !0, t.Z(e2) || this.fire(new t.k(e2));
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "loaded",
                    value: function loaded() {
                        return this._loaded;
                    }
                },
                {
                    key: "updateImage",
                    value: function updateImage(e1) {
                        var _this = this;
                        return e1.url ? (this._request && (this._request.abort(), this._request = null), this.options.url = e1.url, this.load(e1.coordinates).finally(function() {
                            _this.texture = null;
                        }), this) : this;
                    }
                },
                {
                    key: "_finishLoading",
                    value: function _finishLoading() {
                        this.map && (this.setCoordinates(this.coordinates), this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })));
                    }
                },
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        this.map = e1, this.load();
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        this._request && (this._request.abort(), this._request = null);
                    }
                },
                {
                    key: "setCoordinates",
                    value: function setCoordinates(e1) {
                        var _this = this;
                        this.coordinates = e1;
                        var i = e1.map(t.a9.fromLngLat);
                        var a;
                        return this.tileID = function(e1) {
                            var i = t.aa.fromPoints(e1), a = i.width(), r = i.height(), o = Math.max(a, r), s = Math.max(0, Math.floor(-Math.log(o) / Math.LN2)), n = Math.pow(2, s);
                            return new t.ac(s, Math.floor((i.minX + i.maxX) / 2 * n), Math.floor((i.minY + i.maxY) / 2 * n));
                        }(i), this.terrainTileRanges = this._getOverlappingTileRanges(i), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = i.map(function(e1) {
                            return _this.tileID.getTilePoint(e1)._round();
                        }), this.flippedWindingOrder = ((a = this.tileCoords)[1].x - a[0].x) * (a[2].y - a[0].y) - (a[1].y - a[0].y) * (a[2].x - a[0].x) < 0, this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        })), this;
                    }
                },
                {
                    key: "prepare",
                    value: function prepare() {
                        if (0 === Object.keys(this.tiles).length || !this.image) return;
                        var _$e = this.map.painter.context, i = _$e.gl;
                        this.texture || (this.texture = new t.T(_$e, this.image, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                        var a = !1;
                        for(var _$e1 in this.tiles){
                            var _$t = this.tiles[_$e1];
                            "loaded" !== _$t.state && (_$t.state = "loaded", _$t.texture = this.texture, a = !0);
                        }
                        a && this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "idle",
                            sourceId: this.id
                        }));
                    }
                },
                {
                    key: "loadTile",
                    value: function loadTile(e1) {
                        return t._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                this.tileID && this.tileID.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}) : e1.state = "errored";
                                return [
                                    2
                                ];
                            });
                        });
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        return {
                            type: "image",
                            url: this.options.url,
                            coordinates: this.coordinates
                        };
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return !1;
                    }
                },
                {
                    key: "_getOverlappingTileRanges",
                    value: function _getOverlappingTileRanges(e1) {
                        var _t_aa_fromPoints = t.aa.fromPoints(e1), i = _t_aa_fromPoints.minX, a = _t_aa_fromPoints.minY, r = _t_aa_fromPoints.maxX, o = _t_aa_fromPoints.maxY, s = {};
                        for(var _$e = 0; _$e <= t.ab; _$e++){
                            var _$t = Math.pow(2, _$e), n = Math.floor(i * _$t), l = Math.floor(a * _$t), _$c = Math.floor(r * _$t), h = Math.floor(o * _$t);
                            s[_$e] = {
                                minTileX: n,
                                minTileY: l,
                                maxTileX: _$c,
                                maxTileY: h
                            };
                        }
                        return s;
                    }
                }
            ]);
            return te;
        }(t.E);
        var ie = /*#__PURE__*/ function(te) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ie, te);
            function ie(e1, t, i, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ie);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ie, [
                    e1,
                    t,
                    i,
                    a
                ]), _this.roundZoom = !0, _this.type = "video", _this.options = t;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ie, [
                {
                    key: "load",
                    value: function load() {
                        return t._(this, void 0, void 0, function() {
                            var _this, _$e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _$t, _$e1, e1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _this = this;
                                        this._loaded = !1;
                                        _$e = this.options;
                                        this.urls = [];
                                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(_iterator = _$e.urls[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                _$t = _step.value;
                                                this.urls.push(this.map._requestManager.transformRequest(_$t, "Source").url);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            t.ad(this.urls)
                                        ];
                                    case 2:
                                        _$e1 = _state.sent();
                                        if (this._loaded = !0, !_$e1) return [
                                            2
                                        ];
                                        this.video = _$e1, this.video.loop = !0, this.video.addEventListener("playing", function() {
                                            _this.map.triggerRepaint();
                                        }), this.map && this.video.play(), this._finishLoading();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        e1 = _state.sent();
                                        this.fire(new t.k(e1));
                                        return [
                                            3,
                                            4
                                        ];
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "pause",
                    value: function pause() {
                        this.video && this.video.pause();
                    }
                },
                {
                    key: "play",
                    value: function play() {
                        this.video && this.video.play();
                    }
                },
                {
                    key: "seek",
                    value: function seek(e1) {
                        if (this.video) {
                            var i = this.video.seekable;
                            e1 < i.start(0) || e1 > i.end(0) ? this.fire(new t.k(new t.ae("sources.".concat(this.id), null, "Playback for this video can be set only between the ".concat(i.start(0), " and ").concat(i.end(0), "-second mark.")))) : this.video.currentTime = e1;
                        }
                    }
                },
                {
                    key: "getVideo",
                    value: function getVideo() {
                        return this.video;
                    }
                },
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                    }
                },
                {
                    key: "prepare",
                    value: function prepare() {
                        if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                        var _$e = this.map.painter.context, i = _$e.gl;
                        this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new t.T(_$e, this.video, i.RGBA), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE));
                        var a = !1;
                        for(var _$e1 in this.tiles){
                            var _$t = this.tiles[_$e1];
                            "loaded" !== _$t.state && (_$t.state = "loaded", _$t.texture = this.texture, a = !0);
                        }
                        a && this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "idle",
                            sourceId: this.id
                        }));
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        return {
                            type: "video",
                            urls: this.urls,
                            coordinates: this.coordinates
                        };
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return this.video && !this.video.paused;
                    }
                }
            ]);
            return ie;
        }(te);
        var ae = /*#__PURE__*/ function(te) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ae, te);
            function ae(e1, i, a, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ae);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ae, [
                    e1,
                    i,
                    a,
                    r
                ]), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some(function(e1) {
                    return !Array.isArray(e1) || 2 !== e1.length || e1.some(function(e1) {
                        return "number" != typeof e1;
                    });
                }) || _this.fire(new t.k(new t.ae("sources.".concat(e1), null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : _this.fire(new t.k(new t.ae("sources.".concat(e1), null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && _this.fire(new t.k(new t.ae("sources.".concat(e1), null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || _this.fire(new t.k(new t.ae("sources.".concat(e1), null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : _this.fire(new t.k(new t.ae("sources.".concat(e1), null, 'missing required property "canvas"'))), _this.options = i, _this.animate = void 0 === i.animate || i.animate;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ae, [
                {
                    key: "load",
                    value: function load() {
                        return t._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new t.k(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                                    this._playing = !0, this.map.triggerRepaint();
                                }, this.pause = function() {
                                    this._playing && (this.prepare(), this._playing = !1);
                                }, this._finishLoading());
                                return [
                                    2
                                ];
                            });
                        });
                    }
                },
                {
                    key: "getCanvas",
                    value: function getCanvas() {
                        return this.canvas;
                    }
                },
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        this.map = e1, this.load(), this.canvas && this.animate && this.play();
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        this.pause();
                    }
                },
                {
                    key: "prepare",
                    value: function prepare() {
                        var _$e = !1;
                        if (this.canvas.width !== this.width && (this.width = this.canvas.width, _$e = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, _$e = !0), this._hasInvalidDimensions()) return;
                        if (0 === Object.keys(this.tiles).length) return;
                        var i = this.map.painter.context, a = i.gl;
                        this.texture ? (_$e || this._playing) && this.texture.update(this.canvas, {
                            premultiply: !0
                        }) : (this.texture = new t.T(i, this.canvas, a.RGBA, {
                            premultiply: !0
                        }), this.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE));
                        var r = !1;
                        for(var _$e1 in this.tiles){
                            var _$t = this.tiles[_$e1];
                            "loaded" !== _$t.state && (_$t.state = "loaded", _$t.texture = this.texture, r = !0);
                        }
                        r && this.fire(new t.l("data", {
                            dataType: "source",
                            sourceDataType: "idle",
                            sourceId: this.id
                        }));
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        return {
                            type: "canvas",
                            animate: this.animate,
                            canvas: this.options.canvas,
                            coordinates: this.coordinates
                        };
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return this._playing;
                    }
                },
                {
                    key: "_hasInvalidDimensions",
                    value: function _hasInvalidDimensions() {
                        for(var _i = 0, _iter = [
                            this.canvas.width,
                            this.canvas.height
                        ]; _i < _iter.length; _i++){
                            var _$e = _iter[_i];
                            if (isNaN(_$e) || _$e <= 0) return !0;
                        }
                        return !1;
                    }
                }
            ]);
            return ae;
        }(te);
        var re = {}, oe = function(e1) {
            switch(e1){
                case "geojson":
                    return ee;
                case "image":
                    return te;
                case "raster":
                    return K;
                case "raster-dem":
                    return Y;
                case "vector":
                    return X;
                case "video":
                    return ie;
                case "canvas":
                    return ae;
            }
            return re[e1];
        }, se = "RTLPluginLoaded";
        var ne = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ne, _t_E);
            function ne() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ne);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ne, arguments), _this.status = "unavailable", _this.url = null, _this.dispatcher = Z();
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ne, [
                {
                    key: "_syncState",
                    value: function _syncState(e1) {
                        var _this = this;
                        return this.status = e1, this.dispatcher.broadcast("SRPS", {
                            pluginStatus: e1,
                            pluginURL: this.url
                        }).catch(function(e1) {
                            throw _this.status = "error", e1;
                        });
                    }
                },
                {
                    key: "getRTLTextPluginStatus",
                    value: function getRTLTextPluginStatus() {
                        return this.status;
                    }
                },
                {
                    key: "clearRTLTextPlugin",
                    value: function clearRTLTextPlugin() {
                        this.status = "unavailable", this.url = null;
                    }
                },
                {
                    key: "setRTLTextPlugin",
                    value: function setRTLTextPlugin(e1) {
                        return t._(this, arguments, void 0, function(e1) {
                            var _$t;
                            var _arguments = arguments;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                _$t = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : !1;
                                if (this.url) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                                if (this.url = n.resolveURL(e1), !this.url) throw new Error("requested url ".concat(e1, " is invalid"));
                                if ("unavailable" === this.status) {
                                    if (!_$t) return [
                                        2,
                                        this._requestImport()
                                    ];
                                    this.status = "deferred", this._syncState(this.status);
                                } else if ("requested" === this.status) return [
                                    2,
                                    this._requestImport()
                                ];
                                return [
                                    2
                                ];
                            });
                        });
                    }
                },
                {
                    key: "_requestImport",
                    value: function _requestImport() {
                        return t._(this, void 0, void 0, function() {
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            this._syncState("loading")
                                        ];
                                    case 1:
                                        _state.sent(), this.status = "loaded", this.fire(new t.l(se));
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "lazyLoad",
                    value: function lazyLoad() {
                        "unavailable" === this.status ? this.status = "requested" : "deferred" === this.status && this._requestImport();
                    }
                }
            ]);
            return ne;
        }(t.E);
        var le = null;
        function ce() {
            return le || (le = new ne), le;
        }
        var he, ue;
        !function(e1) {
            e1[e1.Base = 0] = "Base", e1[e1.Parent = 1] = "Parent";
        }(he || (he = {})), function(e1) {
            e1[e1.Departing = 0] = "Departing", e1[e1.Incoming = 1] = "Incoming";
        }(ue || (ue = {}));
        var de = /*#__PURE__*/ function() {
            function de(e1, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, de);
                this.timeAdded = 0, this.fadeEndTime = 0, this.fadeOpacity = 1, this.tileID = e1, this.uid = t.af(), this.uses = 0, this.tileSize = i, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(de, [
                {
                    key: "isRenderable",
                    value: function isRenderable(e1) {
                        return this.hasData() && (!this.fadeEndTime || this.fadeOpacity > 0) && (e1 || !this.holdingForSymbolFade());
                    }
                },
                {
                    key: "setCrossFadeLogic",
                    value: function setCrossFadeLogic(param) {
                        var _$e = param.fadingRole, _$t = param.fadingDirection, i = param.fadingParentID, a = param.fadeEndTime;
                        this.resetFadeLogic(), this.fadingRole = _$e, this.fadingDirection = _$t, this.fadingParentID = i, this.fadeEndTime = a;
                    }
                },
                {
                    key: "setSelfFadeLogic",
                    value: function setSelfFadeLogic(e1) {
                        this.resetFadeLogic(), this.selfFading = !0, this.fadeEndTime = e1;
                    }
                },
                {
                    key: "resetFadeLogic",
                    value: function resetFadeLogic() {
                        this.fadingRole = null, this.fadingDirection = null, this.fadingParentID = null, this.selfFading = !1, this.timeAdded = c(), this.fadeEndTime = 0, this.fadeOpacity = 1;
                    }
                },
                {
                    key: "wasRequested",
                    value: function wasRequested() {
                        return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
                    }
                },
                {
                    key: "clearTextures",
                    value: function clearTextures(e1) {
                        this.demTexture && e1.saveTileTexture(this.demTexture), this.demTexture = null;
                    }
                },
                {
                    key: "loadVectorData",
                    value: function loadVectorData(e1, i, a) {
                        if (this.hasData() && this.unloadVectorData(), this.state = "loaded", e1) {
                            e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestFeatureIndex.rawTileData = e1.rawTileData, this.latestFeatureIndex.encoding = e1.encoding) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData, this.latestFeatureIndex.encoding = this.latestEncoding)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = function(e1, t) {
                                var _$i = {};
                                if (!t) return _$i;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    var _loop = function() {
                                        var _$a = _step.value;
                                        var _$e = _$a.layerIds.map(function(e1) {
                                            return t.getLayer(e1);
                                        }).filter(Boolean);
                                        if (0 !== _$e.length) {
                                            _$a.layers = _$e, _$a.stateDependentLayerIds && (_$a.stateDependentLayers = _$a.stateDependentLayerIds.map(function(t) {
                                                return _$e.filter(function(e1) {
                                                    return e1.id === t;
                                                })[0];
                                            }));
                                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(var _iterator = _$e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    var _$t = _step1.value;
                                                    _$i[_$t.id] = _$a;
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                        }
                                    };
                                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return _$i;
                            }(e1.buckets, null == i ? void 0 : i.style), this.hasSymbolBuckets = !1;
                            for(var _$e in this.buckets){
                                var _$i = this.buckets[_$e];
                                if (_$i instanceof t.ah) {
                                    if (this.hasSymbolBuckets = !0, !a) break;
                                    _$i.justReloaded = !0;
                                }
                            }
                            if (this.hasRTLText = !1, this.hasSymbolBuckets) for(var _$e1 in this.buckets){
                                var _$i1 = this.buckets[_$e1];
                                if (_$i1 instanceof t.ah && _$i1.hasRTLText) {
                                    this.hasRTLText = !0, ce().lazyLoad();
                                    break;
                                }
                            }
                            this.queryPadding = 0;
                            for(var _$e2 in this.buckets){
                                var _$t = this.buckets[_$e2];
                                this.queryPadding = Math.max(this.queryPadding, i.style.getLayer(_$e2).queryRadius(_$t));
                            }
                            e1.imageAtlas && (this.imageAtlas = e1.imageAtlas), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage), this.dashPositions = e1.dashPositions;
                        } else this.collisionBoxArray = new t.ag;
                    }
                },
                {
                    key: "unloadVectorData",
                    value: function unloadVectorData() {
                        for(var _$e in this.buckets)this.buckets[_$e].destroy();
                        this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.dashPositions && (this.dashPositions = null), this.latestFeatureIndex = null, this.state = "unloaded";
                    }
                },
                {
                    key: "getBucket",
                    value: function getBucket(e1) {
                        return this.buckets[e1.id];
                    }
                },
                {
                    key: "upload",
                    value: function upload(e1) {
                        for(var _$t in this.buckets){
                            var i = this.buckets[_$t];
                            i.uploadPending() && i.upload(e1);
                        }
                        var i1 = e1.gl;
                        this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new t.T(e1, this.imageAtlas.image, i1.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new t.T(e1, this.glyphAtlasImage, i1.ALPHA), this.glyphAtlasImage = null);
                    }
                },
                {
                    key: "prepare",
                    value: function prepare(e1) {
                        this.imageAtlas && this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture);
                    }
                },
                {
                    key: "queryRenderedFeatures",
                    value: function queryRenderedFeatures(e1, t, i, a, r, o, s, n, l, c, h) {
                        return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                            queryGeometry: a,
                            cameraQueryGeometry: r,
                            scale: o,
                            tileSize: this.tileSize,
                            pixelPosMatrix: c,
                            transform: n,
                            params: s,
                            queryPadding: this.queryPadding * l,
                            getElevation: h
                        }, e1, t, i) : {};
                    }
                },
                {
                    key: "querySourceFeatures",
                    value: function querySourceFeatures(e1, i) {
                        var a = this.latestFeatureIndex;
                        if (!a || !a.rawTileData) return;
                        var r = a.loadVTLayers(), o = i && i.sourceLayer ? i.sourceLayer : "", s = r[t.ai] || r[o];
                        if (!s) return;
                        var n = t.aj(null == i ? void 0 : i.filter, null == i ? void 0 : i.globalState), _this_tileID_canonical = this.tileID.canonical, l = _this_tileID_canonical.z, _$c = _this_tileID_canonical.x, h = _this_tileID_canonical.y, u = {
                            z: l,
                            x: _$c,
                            y: h
                        };
                        for(var _$i = 0; _$i < s.length; _$i++){
                            var r1 = s.feature(_$i);
                            if (n.needGeometry) {
                                var _$e = t.ak(r1, !0);
                                if (!n.filter(new t.H(this.tileID.overscaledZ), _$e, this.tileID.canonical)) continue;
                            } else if (!n.filter(new t.H(this.tileID.overscaledZ), r1)) continue;
                            var d = a.getId(r1, o), _ = new t.al(r1, l, _$c, h, d);
                            _.tile = u, e1.push(_);
                        }
                    }
                },
                {
                    key: "hasData",
                    value: function hasData() {
                        return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
                    }
                },
                {
                    key: "patternsLoaded",
                    value: function patternsLoaded() {
                        return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
                    }
                },
                {
                    key: "setExpiryData",
                    value: function setExpiryData(e1) {
                        var i = this.expirationTime;
                        if (e1.cacheControl) {
                            var i1 = t.am(e1.cacheControl);
                            i1["max-age"] && (this.expirationTime = Date.now() + 1e3 * i1["max-age"]);
                        } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
                        if (this.expirationTime) {
                            var _$e = Date.now();
                            var _$t = !1;
                            if (this.expirationTime > _$e) _$t = !1;
                            else if (i) {
                                if (this.expirationTime < i) _$t = !0;
                                else {
                                    var a = this.expirationTime - i;
                                    a ? this.expirationTime = _$e + Math.max(a, 3e4) : _$t = !0;
                                }
                            } else _$t = !0;
                            _$t ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                        }
                    }
                },
                {
                    key: "getExpiryTimeout",
                    value: function getExpiryTimeout() {
                        if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
                    }
                },
                {
                    key: "setFeatureState",
                    value: function setFeatureState(e1, i) {
                        if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(e1).length) return;
                        var a = this.latestFeatureIndex.loadVTLayers();
                        for(var r in this.buckets){
                            if (!i.style.hasLayer(r)) continue;
                            var o = this.buckets[r], s = o.layers[0].sourceLayer || t.ai, n = a[s], l = e1[s];
                            if (!n || !l || 0 === Object.keys(l).length) continue;
                            o.update(l, n, this.imageAtlas && this.imageAtlas.patternPositions || {}, this.dashPositions || {});
                            var _$c = i && i.style && i.style.getLayer(r);
                            _$c && (this.queryPadding = Math.max(this.queryPadding, _$c.queryRadius(o)));
                        }
                    }
                },
                {
                    key: "holdingForSymbolFade",
                    value: function holdingForSymbolFade() {
                        return void 0 !== this.symbolFadeHoldUntil;
                    }
                },
                {
                    key: "symbolFadeFinished",
                    value: function symbolFadeFinished() {
                        return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < c();
                    }
                },
                {
                    key: "clearSymbolFadeHold",
                    value: function clearSymbolFadeHold() {
                        this.symbolFadeHoldUntil = void 0;
                    }
                },
                {
                    key: "setSymbolHoldDuration",
                    value: function setSymbolHoldDuration(e1) {
                        this.symbolFadeHoldUntil = c() + e1;
                    }
                },
                {
                    key: "setDependencies",
                    value: function setDependencies(e1, t) {
                        var i = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                i[_$e] = !0;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this.dependencies[e1] = i;
                    }
                },
                {
                    key: "hasDependency",
                    value: function hasDependency(e1, t) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                var _$e = this.dependencies[i];
                                if (_$e) {
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    try {
                                        for(var _iterator1 = t[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var i1 = _step1.value;
                                            if (_$e[i1]) return !0;
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return !1;
                    }
                }
            ]);
            return de;
        }();
        var _e = /*#__PURE__*/ function() {
            function _e() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _e);
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_e, [
                {
                    key: "updateState",
                    value: function updateState(e1, i, a) {
                        var r = String(i);
                        if (this.stateChanges[e1] = this.stateChanges[e1] || {}, this.stateChanges[e1][r] = this.stateChanges[e1][r] || {}, t.e(this.stateChanges[e1][r], a), null === this.deletedStates[e1]) {
                            this.deletedStates[e1] = {};
                            for(var _$t in this.state[e1])_$t !== r && (this.deletedStates[e1][_$t] = null);
                        } else if (this.deletedStates[e1] && null === this.deletedStates[e1][r]) {
                            this.deletedStates[e1][r] = {};
                            for(var _$t1 in this.state[e1][r])a[_$t1] || (this.deletedStates[e1][r][_$t1] = null);
                        } else for(var _$t2 in a)this.deletedStates[e1] && this.deletedStates[e1][r] && null === this.deletedStates[e1][r][_$t2] && delete this.deletedStates[e1][r][_$t2];
                    }
                },
                {
                    key: "removeFeatureState",
                    value: function removeFeatureState(e1, t, i) {
                        if (null === this.deletedStates[e1]) return;
                        var a = String(t);
                        if (this.deletedStates[e1] = this.deletedStates[e1] || {}, i && void 0 !== t) null !== this.deletedStates[e1][a] && (this.deletedStates[e1][a] = this.deletedStates[e1][a] || {}, this.deletedStates[e1][a][i] = null);
                        else if (void 0 !== t) {
                            if (this.stateChanges[e1] && this.stateChanges[e1][a]) for(i in this.deletedStates[e1][a] = {}, this.stateChanges[e1][a])this.deletedStates[e1][a][i] = null;
                            else this.deletedStates[e1][a] = null;
                        } else this.deletedStates[e1] = null;
                    }
                },
                {
                    key: "getState",
                    value: function getState(e1, i) {
                        var a = String(i), r = t.e({}, (this.state[e1] || {})[a], (this.stateChanges[e1] || {})[a]);
                        if (null === this.deletedStates[e1]) return {};
                        if (this.deletedStates[e1]) {
                            var _$t = this.deletedStates[e1][i];
                            if (null === _$t) return {};
                            for(var _$e in _$t)delete r[_$e];
                        }
                        return r;
                    }
                },
                {
                    key: "initializeTileState",
                    value: function initializeTileState(e1, t) {
                        e1.setFeatureState(this.state, t);
                    }
                },
                {
                    key: "coalesceChanges",
                    value: function coalesceChanges(e1, i) {
                        var a = {};
                        for(var _$e in this.stateChanges){
                            this.state[_$e] = this.state[_$e] || {};
                            var _$i = {};
                            for(var a1 in this.stateChanges[_$e])this.state[_$e][a1] || (this.state[_$e][a1] = {}), t.e(this.state[_$e][a1], this.stateChanges[_$e][a1]), _$i[a1] = this.state[_$e][a1];
                            a[_$e] = _$i;
                        }
                        for(var _$e1 in this.deletedStates){
                            this.state[_$e1] = this.state[_$e1] || {};
                            var _$i1 = {};
                            if (null === this.deletedStates[_$e1]) for(var _$t in this.state[_$e1])_$i1[_$t] = {}, this.state[_$e1][_$t] = {};
                            else for(var _$t1 in this.deletedStates[_$e1]){
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (null === this.deletedStates[_$e1][_$t1]) this.state[_$e1][_$t1] = {};
                                else try {
                                    for(var _iterator = Object.keys(this.deletedStates[_$e1][_$t1])[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$i2 = _step.value;
                                        delete this.state[_$e1][_$t1][_$i2];
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _$i1[_$t1] = this.state[_$e1][_$t1];
                            }
                            a[_$e1] = a[_$e1] || {}, t.e(a[_$e1], _$i1);
                        }
                        this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(a).length && e1.setFeatureState(a, i);
                    }
                }
            ]);
            return _e;
        }();
        var pe = 89.25;
        function me(e1, i) {
            var a = t.an(i.lat, -t.ao, t.ao);
            return new t.P(t.Y(i.lng) * e1, t.X(a) * e1);
        }
        function fe(e1, i) {
            return new t.a9(i.x / e1, i.y / e1).toLngLat();
        }
        function ge(e1) {
            return e1.cameraToCenterDistance * Math.min(.85 * Math.tan(t.ap(90 - e1.pitch)), Math.tan(t.ap(pe - e1.pitch)));
        }
        function ve(e1, i) {
            var a = e1.canonical, r = i / t.aq(a.z), o = a.x + Math.pow(2, a.z) * e1.wrap, s = t.ar(new Float64Array(16));
            return t.O(s, s, [
                o * r,
                a.y * r,
                0
            ]), t.Q(s, s, [
                r / t.a5,
                r / t.a5,
                1
            ]), s;
        }
        function xe(e1, i, a, r, o) {
            var s = t.a9.fromLngLat(e1, i), n = o * t.as(1, e1.lat), _be = be(a, r), l = _be.x, _$c = _be.y, h = _be.z;
            return new t.a9(s.x + n * -l, s.y + n * -_$c, s.z + n * -h);
        }
        function be(e1, i) {
            var a = t.ap(e1), r = t.ap(i), o = Math.cos(-a), s = Math.sin(a);
            return {
                x: s * Math.sin(r),
                y: -s * Math.cos(r),
                z: o
            };
        }
        function ye(e1, t, i) {
            var a = t.intersectsFrustum(e1);
            if (!i || 0 === a) return a;
            var r = t.intersectsPlane(i);
            return 0 === r ? 0 : 2 === a && 2 === r ? 2 : 1;
        }
        function we(e1, t, i) {
            var a = 0;
            var r = (i - t) / 10;
            for(var o = 0; o < 10; o++)a += r * Math.pow(Math.cos(t + (o + .5) / 10 * (i - t)), e1);
            return a;
        }
        function Te(e1, i) {
            return function(a, r, o, s, n) {
                var l = 2 * ((e1 - 1) / t.at(Math.cos(t.ap(pe - n)) / Math.cos(t.ap(pe))) - 1), _$c = Math.acos(o / s), h = 2 * we(l - 1, 0, t.ap(n / 2)), u = Math.min(t.ap(pe), _$c + t.ap(n / 2)), d = we(l - 1, Math.min(u, _$c - t.ap(n / 2)), u), _ = Math.atan(r / o), p = Math.hypot(r, o);
                var m = a;
                return m += t.at(s / p / Math.max(.5, Math.cos(t.ap(n / 2)))), m += l * t.at(Math.cos(_)) / 2, m -= t.at(Math.max(1, d / h / i)) / 2, m;
            };
        }
        var Pe = Te(9.314, 3);
        function Ce(e1, i) {
            var a = (i.roundZoom ? Math.round : Math.floor)(e1.zoom + t.at(e1.tileSize / i.tileSize));
            return Math.max(0, a);
        }
        function Ie(e1, i) {
            var a = e1.getCameraFrustum(), r = e1.getClippingPlane(), o = e1.screenPointToMercatorCoordinate(e1.getCameraPoint()), s = t.a9.fromLngLat(e1.center, e1.elevation);
            o.z = s.z + Math.cos(e1.pitchInRadians) * e1.cameraToCenterDistance / e1.worldSize;
            var n = e1.getCoveringTilesDetailsProvider(), l = n.allowVariableZoom(e1, i), _$c = Ce(e1, i), h = i.minzoom || 0, u = void 0 !== i.maxzoom ? i.maxzoom : e1.maxZoom, d = Math.min(Math.max(0, _$c), u), _ = Math.pow(2, d), p = [
                _ * o.x,
                _ * o.y,
                0
            ], m = [
                _ * s.x,
                _ * s.y,
                0
            ], f = Math.hypot(s.x - o.x, s.y - o.y), g = Math.abs(s.z - o.z), v = Math.hypot(f, g), x = function(e1) {
                return {
                    zoom: 0,
                    x: 0,
                    y: 0,
                    wrap: e1,
                    fullyVisible: !1
                };
            }, b = [], y = [];
            if (e1.renderWorldCopies && n.allowWorldCopies()) for(var _$e = 1; _$e <= 3; _$e++)b.push(x(-_$e)), b.push(x(_$e));
            for(b.push(x(0)); b.length > 0;){
                var _1 = b.pop(), f1 = _1.x, x1 = _1.y;
                var w = _1.fullyVisible;
                var T = {
                    x: f1,
                    y: x1,
                    z: _1.zoom
                }, P = n.getTileBoundingVolume(T, _1.wrap, e1.elevation, i);
                if (!w) {
                    var _$e1 = ye(a, P, r);
                    if (0 === _$e1) continue;
                    w = 2 === _$e1;
                }
                var C = n.distanceToTile2d(o.x, o.y, T, P);
                var I = _$c;
                l && (I = (i.calculateTileZoom || Pe)(e1.zoom + t.at(e1.tileSize / i.tileSize), C, g, v, e1.fov)), I = (i.roundZoom ? Math.round : Math.floor)(I), I = Math.max(0, I);
                var M = Math.min(I, u);
                if (_1.wrap = n.getWrap(s, T, _1.wrap), _1.zoom >= M) {
                    if (_1.zoom < h) continue;
                    var _$e2 = d - _1.zoom, a1 = p[0] - .5 - (f1 << _$e2), r1 = p[1] - .5 - (x1 << _$e2), o1 = i.reparseOverscaled ? Math.max(_1.zoom, I) : _1.zoom;
                    y.push({
                        tileID: new t.a2(_1.zoom === u ? o1 : _1.zoom, _1.wrap, _1.zoom, f1, x1),
                        distanceSq: t.au([
                            m[0] - .5 - f1,
                            m[1] - .5 - x1
                        ]),
                        tileDistanceToCamera: Math.sqrt(a1 * a1 + r1 * r1)
                    });
                } else for(var _$e3 = 0; _$e3 < 4; _$e3++)b.push({
                    zoom: _1.zoom + 1,
                    x: (f1 << 1) + _$e3 % 2,
                    y: (x1 << 1) + (_$e3 >> 1),
                    wrap: _1.wrap,
                    fullyVisible: w
                });
            }
            return y.sort(function(e1, t) {
                return e1.distanceSq - t.distanceSq;
            }).map(function(e1) {
                return e1.tileID;
            });
        }
        var Me = t.aa.fromPoints([
            new t.P(0, 0),
            new t.P(t.a5, t.a5)
        ]);
        function Ee(e1) {
            return "raster" === e1 || "image" === e1 || "video" === e1;
        }
        function Se(e1, t, i, a, r, o, s) {
            if (!t.hasData()) return !1;
            var n = t.tileID, l = t.fadingRole, _$c = t.fadingDirection, h = t.fadingParentID;
            if (l === he.Base && _$c === ue.Incoming && h) return i[h.key] = h, !0;
            var u = Math.max(n.overscaledZ - r, o);
            for(var _$r = n.overscaledZ - 1; _$r >= u; _$r--){
                var _$o = n.scaledTo(_$r), l1 = e1.getLoadedTile(_$o);
                if (l1) return t.setCrossFadeLogic({
                    fadingRole: he.Base,
                    fadingDirection: ue.Incoming,
                    fadingParentID: l1.tileID,
                    fadeEndTime: a + s
                }), l1.setCrossFadeLogic({
                    fadingRole: he.Parent,
                    fadingDirection: ue.Departing,
                    fadeEndTime: a + s
                }), i[_$o.key] = _$o, !0;
            }
            return !1;
        }
        function Re(e1, t, i, a, r, o) {
            if (!t.hasData()) return !1;
            var s = t.tileID.children(r);
            var n = ze(e1, t, s, i, a, r, o);
            if (n) return !0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var l = _step.value;
                    ze(e1, t, l.children(r), i, a, r, o) && (n = !0);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return n;
        }
        function ze(e1, t, i, a, r, o, s) {
            if (i[0].overscaledZ >= o) return !1;
            var n = !1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$o = _step.value;
                    var _$i = e1.getLoadedTile(_$o);
                    if (!_$i) continue;
                    var l = _$i.fadingRole, _$c = _$i.fadingDirection, h = _$i.fadingParentID;
                    l === he.Base && _$c === ue.Departing && h || (_$i.setCrossFadeLogic({
                        fadingRole: he.Base,
                        fadingDirection: ue.Departing,
                        fadingParentID: t.tileID,
                        fadeEndTime: r + s
                    }), t.setCrossFadeLogic({
                        fadingRole: he.Parent,
                        fadingDirection: ue.Incoming,
                        fadeEndTime: r + s
                    })), a[_$o.key] = _$o, n = !0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return n;
        }
        function De(e1, t, i, a) {
            var r = e1.tileID;
            return !!e1.selfFading || !e1.hasData() && !!t.has(r) && (e1.setSelfFadeLogic(i + a), !0);
        }
        function Ae(e1, t) {
            var i;
            e1.needsHillshadePrepare = !0, e1.needsTerrainPrepare = !0;
            var a = t.tileID.canonical.x - e1.tileID.canonical.x;
            var r = t.tileID.canonical.y - e1.tileID.canonical.y, o = Math.pow(2, e1.tileID.canonical.z), s = t.tileID.key;
            0 === a && 0 === r || Math.abs(r) > 1 || (Math.abs(a) > 1 && (1 === Math.abs(a + o) ? a += o : 1 === Math.abs(a - o) && (a -= o)), t.dem && e1.dem && (e1.dem.backfillBorder(t.dem, a, r), (null === (i = e1.neighboringTiles) || void 0 === i ? void 0 : i[s]) && (e1.neighboringTiles[s].backfilled = !0)));
        }
        var Le = /*#__PURE__*/ function() {
            function Le() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Le);
                this._tiles = {};
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Le, [
                {
                    key: "handleWrapJump",
                    value: function handleWrapJump(e1) {
                        var _$t = {};
                        for(var i in this._tiles){
                            var a = this._tiles[i];
                            a.tileID = a.tileID.unwrapTo(a.tileID.wrap + e1), _$t[a.tileID.key] = a;
                        }
                        this._tiles = _$t;
                    }
                },
                {
                    key: "setFeatureState",
                    value: function setFeatureState(e1, t) {
                        for(var i in this._tiles)this._tiles[i].setFeatureState(e1, t);
                    }
                },
                {
                    key: "getAllTiles",
                    value: function getAllTiles() {
                        return Object.values(this._tiles);
                    }
                },
                {
                    key: "getAllIds",
                    value: function getAllIds() {
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                        return _$e ? Object.values(this._tiles).map(function(e1) {
                            return e1.tileID;
                        }).sort(t.aw).map(function(e1) {
                            return e1.key;
                        }) : Object.keys(this._tiles);
                    }
                },
                {
                    key: "getTileById",
                    value: function getTileById(e1) {
                        return this._tiles[e1];
                    }
                },
                {
                    key: "setTile",
                    value: function setTile(e1, t) {
                        this._tiles[e1] = t;
                    }
                },
                {
                    key: "deleteTileById",
                    value: function deleteTileById(e1) {
                        delete this._tiles[e1];
                    }
                },
                {
                    key: "getLoadedTile",
                    value: function getLoadedTile(e1) {
                        var _$t = this.getTileById(e1.key);
                        return (null == _$t ? void 0 : _$t.hasData()) ? _$t : null;
                    }
                },
                {
                    key: "isIdRenderable",
                    value: function isIdRenderable(e1) {
                        var _$t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                        var i;
                        return null === (i = this.getTileById(e1)) || void 0 === i ? void 0 : i.isRenderable(_$t);
                    }
                },
                {
                    key: "getRenderableIds",
                    value: function getRenderableIds() {
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, i = arguments.length > 1 ? arguments[1] : void 0;
                        var a = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this.getAllIds()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e1 = _step.value;
                                this.isIdRenderable(_$e1, i) && a.push(this.getTileById(_$e1));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return i ? a.sort(function(i, a) {
                            var r = i.tileID, o = a.tileID, s = new t.P(r.canonical.x, r.canonical.y)._rotate(-_$e), n = new t.P(o.canonical.x, o.canonical.y)._rotate(-_$e);
                            return r.overscaledZ - o.overscaledZ || n.y - s.y || n.x - s.x;
                        }).map(function(e1) {
                            return e1.tileID.key;
                        }) : a.map(function(e1) {
                            return e1.tileID;
                        }).sort(t.aw).map(function(e1) {
                            return e1.key;
                        });
                    }
                }
            ]);
            return Le;
        }();
        var ke = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ke, _t_E);
            function ke(e1, i, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ke);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ke), _this.id = e1, _this.dispatcher = a, _this.on("data", function(e1) {
                    return _this._dataHandler(e1);
                }), _this.on("dataloading", function() {
                    _this._sourceErrored = !1;
                }), _this.on("error", function() {
                    _this._sourceErrored = _this._source.loaded();
                }), _this._source = function(e1, t, i, a) {
                    var r = new (oe(t.type))(e1, t, i, a);
                    if (r.id !== e1) throw new Error("Expected Source id to be ".concat(e1, " instead of ").concat(r.id));
                    return r;
                }(e1, i, a, _this), _this._inViewTiles = new Le, _this._outOfViewCache = new t.ax(0, function(e1) {
                    return _this._unloadTile(e1);
                }), _this._timers = {}, _this._maxTileCacheSize = null, _this._maxTileCacheZoomLevels = null, _this._rasterFadeDuration = 0, _this._maxFadingAncestorLevels = 5, _this._state = new _e, _this._didEmitContent = !1, _this._updated = !1;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ke, [
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        this.map = e1, this._maxTileCacheSize = e1 ? e1._maxTileCacheSize : null, this._maxTileCacheZoomLevels = e1 ? e1._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(e1);
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove(e1) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllTiles()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                _$e.unloadVectorData();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(e1), this._inViewTiles = new Le;
                    }
                },
                {
                    key: "loaded",
                    value: function loaded() {
                        if (this._sourceErrored) return !0;
                        if (!this._sourceLoaded) return !1;
                        if (!this._source.loaded()) return !1;
                        if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                        if (!this._updated) return !1;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllTiles()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                if ("loaded" !== _$e.state && "errored" !== _$e.state) return !1;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return !0;
                    }
                },
                {
                    key: "getSource",
                    value: function getSource() {
                        return this._source;
                    }
                },
                {
                    key: "getState",
                    value: function getState() {
                        return this._state;
                    }
                },
                {
                    key: "pause",
                    value: function pause() {
                        this._paused = !0;
                    }
                },
                {
                    key: "resume",
                    value: function resume() {
                        if (!this._paused) return;
                        var _$e = this._shouldReloadOnResume;
                        this._paused = !1, this._shouldReloadOnResume = !1, _$e && this.reload(), this.transform && this.update(this.transform, this.terrain);
                    }
                },
                {
                    key: "_loadTile",
                    value: function _loadTile(e1, i, a) {
                        return t._(this, void 0, void 0, function() {
                            var i1;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _state.trys.push([
                                            0,
                                            2,
                                            ,
                                            3
                                        ]);
                                        return [
                                            4,
                                            this._source.loadTile(e1)
                                        ];
                                    case 1:
                                        _state.sent(), this._tileLoaded(e1, i, a);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 2:
                                        i1 = _state.sent();
                                        e1.state = "errored", 404 !== i1.status ? this._source.fire(new t.k(i1, {
                                            tile: e1
                                        })) : this.update(this.transform, this.terrain);
                                        return [
                                            3,
                                            3
                                        ];
                                    case 3:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_unloadTile",
                    value: function _unloadTile(e1) {
                        this._source.unloadTile && this._source.unloadTile(e1);
                    }
                },
                {
                    key: "_abortTile",
                    value: function _abortTile(e1) {
                        this._source.abortTile && this._source.abortTile(e1), this._source.fire(new t.l("dataabort", {
                            tile: e1,
                            coord: e1.tileID,
                            dataType: "source"
                        }));
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        return this._source.serialize();
                    }
                },
                {
                    key: "prepare",
                    value: function prepare(e1) {
                        this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._inViewTiles, this.map ? this.map.painter : null);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllTiles()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                _$t.upload(e1), _$t.prepare(this.map.style.imageManager);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "getIds",
                    value: function getIds() {
                        return this._inViewTiles.getAllIds(!0);
                    }
                },
                {
                    key: "getRenderableIds",
                    value: function getRenderableIds(e1) {
                        var _$t;
                        return this._inViewTiles.getRenderableIds(null === (_$t = this.transform) || void 0 === _$t ? void 0 : _$t.bearingInRadians, e1);
                    }
                },
                {
                    key: "hasRenderableParent",
                    value: function hasRenderableParent(e1) {
                        var _$t = e1.overscaledZ - 1;
                        if (_$t >= this._source.minzoom) {
                            var i = this.getLoadedTile(e1.scaledTo(_$t));
                            if (i) return this._inViewTiles.isIdRenderable(i.tileID.key);
                        }
                        return !1;
                    }
                },
                {
                    key: "reload",
                    value: function reload(e1, t) {
                        if (this._paused) this._shouldReloadOnResume = !0;
                        else {
                            this._outOfViewCache.reset();
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = this._inViewTiles.getAllIds()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var i = _step.value;
                                    var a = this._inViewTiles.getTileById(i);
                                    t && !this._source.shouldReloadTile(a, t) || (e1 ? this._reloadTile(i, "expired") : "errored" !== a.state && this._reloadTile(i, "reloading"));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    key: "_reloadTile",
                    value: function _reloadTile(e1, i) {
                        return t._(this, void 0, void 0, function() {
                            var _$t, _tmp;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _$t = this._inViewTiles.getTileById(e1);
                                        _tmp = _$t;
                                        if (!_tmp) return [
                                            3,
                                            2
                                        ];
                                        "loading" !== _$t.state && (_$t.state = i);
                                        return [
                                            4,
                                            this._loadTile(_$t, e1, i)
                                        ];
                                    case 1:
                                        _tmp = _state.sent();
                                        _state.label = 2;
                                    case 2:
                                        _tmp;
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "_tileLoaded",
                    value: function _tileLoaded(e1, i, a) {
                        e1.timeAdded = c(), e1.selfFading && (e1.fadeEndTime = e1.timeAdded + this._rasterFadeDuration), "expired" === a && (e1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, e1), "raster-dem" === this.getSource().type && e1.dem && function(e1, t) {
                            var _$i, _$a;
                            var r = t.getRenderableIds();
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var o = _step.value;
                                    if (!e1.neighboringTiles || !e1.neighboringTiles[o]) continue;
                                    var r1 = t.getTileById(o);
                                    e1.neighboringTiles[o].backfilled || Ae(e1, r1), (null === (_$a = null === (_$i = r1.neighboringTiles) || void 0 === _$i ? void 0 : _$i[e1.tileID.key]) || void 0 === _$a ? void 0 : _$a.backfilled) || Ae(r1, e1);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }(e1, this._inViewTiles), this._state.initializeTileState(e1, this.map ? this.map.painter : null), e1.aborted || this._source.fire(new t.l("data", {
                            dataType: "source",
                            tile: e1,
                            coord: e1.tileID
                        }));
                    }
                },
                {
                    key: "getTile",
                    value: function getTile(e1) {
                        return this.getTileByID(e1.key);
                    }
                },
                {
                    key: "getTileByID",
                    value: function getTileByID(e1) {
                        return this._inViewTiles.getTileById(e1);
                    }
                },
                {
                    key: "_retainLoadedChildren",
                    value: function _retainLoadedChildren(e1, t) {
                        var i = this._getLoadedDescendents(t), a = new Set;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _this, _loop = function() {
                                var r = _step.value;
                                var _Math;
                                var _$t = i[r.key];
                                if (!(null == _$t ? void 0 : _$t.length)) {
                                    a.add(r);
                                    return "continue";
                                }
                                var o = r.overscaledZ + ke.maxOverzooming, s = _$t.filter(function(e1) {
                                    return e1.tileID.overscaledZ <= o;
                                });
                                if (!s.length) {
                                    a.add(r);
                                    return "continue";
                                }
                                var n = (_Math = Math).min.apply(_Math, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(s.map(function(e1) {
                                    return e1.tileID.overscaledZ;
                                }))), l = s.filter(function(e1) {
                                    return e1.tileID.overscaledZ === n;
                                }).map(function(e1) {
                                    return e1.tileID;
                                });
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = l[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$t1 = _step1.value;
                                        e1[_$t1.key] = _$t1;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                _this._areDescendentsComplete(l, n, r.overscaledZ) || a.add(r);
                            };
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this = this, _loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return a;
                    }
                },
                {
                    key: "_getLoadedDescendents",
                    value: function _getLoadedDescendents(e1) {
                        var _$t;
                        var i = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllTiles().filter(function(e1) {
                                return e1.hasData();
                            })[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                var a = _step.value;
                                try {
                                    for(var _iterator1 = e1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                        var r = _step1.value;
                                        a.tileID.isChildOf(r) && (i[_$t = r.key] || (i[_$t] = [])).push(a);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        return i;
                    }
                },
                {
                    key: "_areDescendentsComplete",
                    value: function _areDescendentsComplete(e1, t, i) {
                        return 1 === e1.length && e1[0].isOverscaled() ? e1[0].overscaledZ === t : Math.pow(4, t - i) === e1.length;
                    }
                },
                {
                    key: "getLoadedTile",
                    value: function getLoadedTile(e1) {
                        return this._inViewTiles.getLoadedTile(e1);
                    }
                },
                {
                    key: "updateCacheSize",
                    value: function updateCacheSize(e1) {
                        var i = Math.ceil(e1.width / this._source.tileSize) + 1, a = Math.ceil(e1.height / this._source.tileSize) + 1, r = Math.floor(i * a * (null === this._maxTileCacheZoomLevels ? t.c.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), o = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, r) : r;
                        this._outOfViewCache.setMaxSize(o);
                    }
                },
                {
                    key: "handleWrapJump",
                    value: function handleWrapJump(e1) {
                        var _$t = Math.round((e1 - (void 0 === this._prevLng ? e1 : this._prevLng)) / 360);
                        this._prevLng = e1, _$t && (this._inViewTiles.handleWrapJump(_$t), this._resetTileReloadTimers());
                    }
                },
                {
                    key: "update",
                    value: function update(e1, i) {
                        var _this = this;
                        if (!this._sourceLoaded || this._paused) return;
                        var a;
                        this.transform = e1, this.terrain = i, this.updateCacheSize(e1), this.handleWrapJump(this.transform.center.lng), this.used || this.usedForTerrain ? this._source.tileID ? a = e1.getVisibleUnwrappedCoordinates(this._source.tileID).map(function(e1) {
                            return new t.a2(e1.canonical.z, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y);
                        }) : (a = Ie(e1, {
                            tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                            minzoom: this._source.minzoom,
                            maxzoom: "vector" === this._source.type && void 0 !== this.map._zoomLevelsToOverscale ? e1.maxZoom - this.map._zoomLevelsToOverscale : this._source.maxzoom,
                            roundZoom: !this.usedForTerrain && this._source.roundZoom,
                            reparseOverscaled: this._source.reparseOverscaled,
                            terrain: i,
                            calculateTileZoom: this._source.calculateTileZoom
                        }), this._source.hasTile && (a = a.filter(function(e1) {
                            return _this._source.hasTile(e1);
                        }))) : a = [], this.usedForTerrain && (a = this._addTerrainIdealTiles(a));
                        var r = 0 === a.length && !this._updated && this._didEmitContent;
                        this._updated = !0, r && this.fire(new t.l("data", {
                            sourceDataType: "idle",
                            dataType: "source",
                            sourceId: this.id
                        }));
                        var o = Ce(e1, this._source), s = this._updateRetainedTiles(a, o), n = Ee(this._source.type);
                        n && this._rasterFadeDuration > 0 && !i && function(e1, i, a, r, o, s, n) {
                            var l = c(), h = t.av(i);
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step.value;
                                    var _$i = e1.getTileById(_$t.key);
                                    _$i.fadingDirection !== ue.Departing && 0 !== _$i.fadeOpacity || _$i.resetFadeLogic(), Se(e1, _$i, a, l, r, o, n) || Re(e1, _$i, a, l, s, n) || De(_$i, h, l, n) || _$i.resetFadeLogic();
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }(this._inViewTiles, a, s, this._maxFadingAncestorLevels, this._source.minzoom, this._source.maxzoom, this._rasterFadeDuration), n ? this._cleanUpRasterTiles(s) : this._cleanUpVectorTiles(s);
                    }
                },
                {
                    key: "_cleanUpRasterTiles",
                    value: function _cleanUpRasterTiles(e1) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllIds()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                e1[_$t] || this._removeTile(_$t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_cleanUpVectorTiles",
                    value: function _cleanUpVectorTiles(e1) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllIds()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                var i = this._inViewTiles.getTileById(_$t);
                                e1[_$t] ? i.clearSymbolFadeHold() : i.hasSymbolBuckets ? i.holdingForSymbolFade() ? i.symbolFadeFinished() && this._removeTile(_$t) : i.setSymbolHoldDuration(this.map._fadeDuration) : this._removeTile(_$t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_addTerrainIdealTiles",
                    value: function _addTerrainIdealTiles(e1) {
                        var _$t = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                if (i.canonical.z > this._source.minzoom) {
                                    var _$e = i.scaledTo(i.canonical.z - 1);
                                    _$t.push(_$e);
                                    var a = i.scaledTo(Math.max(this._source.minzoom, Math.min(i.canonical.z, 5)));
                                    _$t.push(a);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return e1.concat(_$t);
                    }
                },
                {
                    key: "releaseSymbolFadeTiles",
                    value: function releaseSymbolFadeTiles() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllIds()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                this._inViewTiles.getTileById(_$e).holdingForSymbolFade() && this._removeTile(_$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_updateRetainedTiles",
                    value: function _updateRetainedTiles(e1, t) {
                        var i;
                        var a = new Set;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                this._addTile(_$t).hasData() || a.add(_$t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var r = e1.reduce(function(e1, t) {
                            return e1[t.key] = t, e1;
                        }, {}), o = this._retainLoadedChildren(r, a), s = {}, n = Math.max(t - ke.maxUnderzooming, this._source.minzoom);
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = o[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$e = _step1.value;
                                var _$t1 = this._inViewTiles.getTileById(_$e.key), a1 = null == _$t1 ? void 0 : _$t1.wasRequested();
                                for(var o1 = _$e.overscaledZ - 1; o1 >= n; --o1){
                                    var n1 = _$e.scaledTo(o1);
                                    if (s[n1.key]) break;
                                    if (s[n1.key] = !0, _$t1 = this.getTile(n1), !_$t1 && a1 && (_$t1 = this._addTile(n1)), _$t1) {
                                        var _$e1 = _$t1.hasData();
                                        if ((_$e1 || !(null === (i = this.map) || void 0 === i ? void 0 : i.cancelPendingTileRequestsWhileZooming) || a1) && (r[n1.key] = n1), a1 = _$t1.wasRequested(), _$e1) break;
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        return r;
                    }
                },
                {
                    key: "_addTile",
                    value: function _addTile(e1) {
                        var i = this._inViewTiles.getTileById(e1.key);
                        if (i) return i;
                        i = this._outOfViewCache.getAndRemove(e1), i && (i.resetFadeLogic(), this._setTileReloadTimer(e1.key, i), i.tileID = e1, this._state.initializeTileState(i, this.map ? this.map.painter : null));
                        var a = i;
                        return i || (i = new de(e1, this._source.tileSize * e1.overscaleFactor()), this._loadTile(i, e1.key, i.state)), i.uses++, this._inViewTiles.setTile(e1.key, i), a || this._source.fire(new t.l("dataloading", {
                            tile: i,
                            coord: i.tileID,
                            dataType: "source"
                        })), i;
                    }
                },
                {
                    key: "_setTileReloadTimer",
                    value: function _setTileReloadTimer(e1, t) {
                        var _this = this;
                        this._clearTileReloadTimer(e1);
                        var i = t.getExpiryTimeout();
                        i && (this._timers[e1] = setTimeout(function() {
                            _this._reloadTile(e1, "expired"), delete _this._timers[e1];
                        }, i));
                    }
                },
                {
                    key: "_clearTileReloadTimer",
                    value: function _clearTileReloadTimer(e1) {
                        var _$t = this._timers[e1];
                        _$t && (clearTimeout(_$t), delete this._timers[e1]);
                    }
                },
                {
                    key: "_resetTileReloadTimers",
                    value: function _resetTileReloadTimers() {
                        for(var _$e in this._timers)clearTimeout(this._timers[_$e]), delete this._timers[_$e];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllIds()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e1 = _step.value;
                                var _$t = this._inViewTiles.getTileById(_$e1);
                                this._setTileReloadTimer(_$e1, _$t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "refreshTiles",
                    value: function refreshTiles(e1) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _this, _loop = function() {
                                var _$t = _step.value;
                                var i = _this._inViewTiles.getTileById(_$t);
                                (_this._inViewTiles.isIdRenderable(_$t) || "errored" == i.state) && e1.some(function(e1) {
                                    return e1.equals(i.tileID.canonical);
                                }) && _this._reloadTile(_$t, "expired");
                            };
                            for(var _iterator = this._inViewTiles.getAllIds()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this = this, _loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_removeTile",
                    value: function _removeTile(e1) {
                        var _$t = this._inViewTiles.getTileById(e1);
                        _$t && (_$t.uses--, this._inViewTiles.deleteTileById(e1), this._clearTileReloadTimer(e1), _$t.uses > 0 || (_$t.hasData() && "reloading" !== _$t.state ? this._outOfViewCache.add(_$t.tileID, _$t, _$t.getExpiryTimeout()) : (_$t.aborted = !0, this._abortTile(_$t), this._unloadTile(_$t))));
                    }
                },
                {
                    key: "_dataHandler",
                    value: function _dataHandler(e1) {
                        "source" === e1.dataType && ("metadata" !== e1.sourceDataType ? "content" === e1.sourceDataType && this._sourceLoaded && !this._paused && (this.reload(e1.sourceDataChanged, e1.shouldReloadTileOptions), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0) : this._sourceLoaded = !0);
                    }
                },
                {
                    key: "clearTiles",
                    value: function clearTiles() {
                        this._shouldReloadOnResume = !1, this._paused = !1;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllIds()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                this._removeTile(_$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._outOfViewCache.reset();
                    }
                },
                {
                    key: "tilesIn",
                    value: function tilesIn(e1, i, a) {
                        var _this = this;
                        var r = [], o = this.transform;
                        if (!o) return r;
                        var s = o.getCoveringTilesDetailsProvider().allowWorldCopies(), n = a ? o.getCameraQueryGeometry(e1) : e1, l = function(e1) {
                            return o.screenPointToMercatorCoordinate(e1, _this.terrain);
                        }, _$c = this.transformBbox(e1, l, !s), h = this.transformBbox(n, l, !s), u = this.getIds(), d = t.aa.fromPoints(h);
                        for(var _$e = 0; _$e < u.length; _$e++){
                            var _$a = this._inViewTiles.getTileById(u[_$e]);
                            if (_$a.holdingForSymbolFade()) continue;
                            var n1 = s ? [
                                _$a.tileID
                            ] : [
                                _$a.tileID.unwrapTo(-1),
                                _$a.tileID.unwrapTo(0)
                            ], l1 = Math.pow(2, o.zoom - _$a.tileID.overscaledZ), _ = i * _$a.queryPadding * t.a5 / _$a.tileSize / l1;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                var _loop = function() {
                                    var _$e = _step.value;
                                    var _$i = d.map(function(i) {
                                        return _$e.getTilePoint(new t.a9(i.x, i.y));
                                    });
                                    if (_$i.expandBy(_), _$i.intersects(Me)) {
                                        var _$t = _$c.map(function(t) {
                                            return _$e.getTilePoint(t);
                                        }), _$i1 = h.map(function(t) {
                                            return _$e.getTilePoint(t);
                                        });
                                        r.push({
                                            tile: _$a,
                                            tileID: s ? _$e : _$e.unwrapTo(0),
                                            queryGeometry: _$t,
                                            cameraQueryGeometry: _$i1,
                                            scale: l1
                                        });
                                    }
                                };
                                for(var _iterator = n1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return r;
                    }
                },
                {
                    key: "transformBbox",
                    value: function transformBbox(e1, i, a) {
                        var r = e1.map(i);
                        if (a) {
                            var _$a = t.aa.fromPoints(e1);
                            _$a.shrinkBy(.001 * Math.min(_$a.width(), _$a.height()));
                            var o = _$a.map(i);
                            t.aa.fromPoints(r).covers(o) || (r = r.map(function(e1) {
                                return e1.x > .5 ? new t.a9(e1.x - 1, e1.y, e1.z) : e1;
                            }));
                        }
                        return r;
                    }
                },
                {
                    key: "getVisibleCoordinates",
                    value: function getVisibleCoordinates(e1) {
                        var _this = this;
                        var _$t = this.getRenderableIds(e1).map(function(e1) {
                            return _this._inViewTiles.getTileById(e1).tileID;
                        });
                        return this.transform && this.transform.populateCache(_$t), _$t;
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return !!this._source.hasTransition() || !(!Ee(this._source.type) || !function(e1, t) {
                            if (t <= 0) return !1;
                            var i = c();
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = e1.getAllTiles()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step.value;
                                    if (_$t.fadeEndTime >= i) return !0;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return !1;
                        }(this._inViewTiles, this._rasterFadeDuration));
                    }
                },
                {
                    key: "setRasterFadeDuration",
                    value: function setRasterFadeDuration(e1) {
                        this._rasterFadeDuration = e1;
                    }
                },
                {
                    key: "setFeatureState",
                    value: function setFeatureState(e1, i, a) {
                        this._state.updateState(e1 = e1 || t.ai, i, a);
                    }
                },
                {
                    key: "removeFeatureState",
                    value: function removeFeatureState(e1, i, a) {
                        this._state.removeFeatureState(e1 = e1 || t.ai, i, a);
                    }
                },
                {
                    key: "getFeatureState",
                    value: function getFeatureState(e1, i) {
                        return this._state.getState(e1 = e1 || t.ai, i);
                    }
                },
                {
                    key: "setDependencies",
                    value: function setDependencies(e1, t, i) {
                        var a = this._inViewTiles.getTileById(e1);
                        a && a.setDependencies(t, i);
                    }
                },
                {
                    key: "reloadTilesForDependencies",
                    value: function reloadTilesForDependencies(e1, t) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllIds()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                this._inViewTiles.getTileById(i).hasDependency(e1, t) && this._reloadTile(i, "reloading");
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._outOfViewCache.filter(function(i) {
                            return !i.hasDependency(e1, t);
                        });
                    }
                },
                {
                    key: "areTilesLoaded",
                    value: function areTilesLoaded() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inViewTiles.getAllTiles()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                if ("loaded" !== _$e.state && "errored" !== _$e.state) return !1;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return !0;
                    }
                }
            ]);
            return ke;
        }(t.E);
        ke.maxUnderzooming = 10, ke.maxOverzooming = 3;
        var Fe = /*#__PURE__*/ function() {
            function Fe(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Fe);
                this.reset(e1, t);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Fe, [
                {
                    key: "reset",
                    value: function reset(e1, t) {
                        this.points = e1 || [], this._distances = [
                            0
                        ];
                        for(var _$e = 1; _$e < this.points.length; _$e++)this._distances[_$e] = this._distances[_$e - 1] + this.points[_$e].dist(this.points[_$e - 1]);
                        this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
                    }
                },
                {
                    key: "lerp",
                    value: function lerp(e1) {
                        if (1 === this.points.length) return this.points[0];
                        e1 = t.an(e1, 0, 1);
                        var i = 1, a = this._distances[i];
                        var r = e1 * this.paddedLength + this.padding;
                        for(; a < r && i < this._distances.length;)a = this._distances[++i];
                        var o = i - 1, s = this._distances[o], n = a - s, l = n > 0 ? (r - s) / n : 0;
                        return this.points[o].mult(1 - l).add(this.points[i].mult(l));
                    }
                }
            ]);
            return Fe;
        }();
        function Be(e1, t) {
            var i = !0;
            return "always" === e1 || "never" !== e1 && "never" !== t || (i = !1), i;
        }
        var Oe = /*#__PURE__*/ function() {
            function Oe(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Oe);
                var a = this.boxCells = [], r = this.circleCells = [];
                this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t / i);
                for(var _$e = 0; _$e < this.xCellCount * this.yCellCount; _$e++)a.push([]), r.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t, this.boxUid = 0, this.circleUid = 0;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Oe, [
                {
                    key: "keysLength",
                    value: function keysLength() {
                        return this.boxKeys.length + this.circleKeys.length;
                    }
                },
                {
                    key: "insert",
                    value: function insert(e1, t, i, a, r) {
                        this._forEachCell(t, i, a, r, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t), this.bboxes.push(i), this.bboxes.push(a), this.bboxes.push(r);
                    }
                },
                {
                    key: "insertCircle",
                    value: function insertCircle(e1, t, i, a) {
                        this._forEachCell(t - a, i - a, t + a, i + a, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t), this.circles.push(i), this.circles.push(a);
                    }
                },
                {
                    key: "_insertBoxCell",
                    value: function _insertBoxCell(e1, t, i, a, r, o) {
                        this.boxCells[r].push(o);
                    }
                },
                {
                    key: "_insertCircleCell",
                    value: function _insertCircleCell(e1, t, i, a, r, o) {
                        this.circleCells[r].push(o);
                    }
                },
                {
                    key: "_query",
                    value: function _query(e1, t, i, a, r, o, s) {
                        if (i < 0 || e1 > this.width || a < 0 || t > this.height) return [];
                        var n = [];
                        if (e1 <= 0 && t <= 0 && this.width <= i && this.height <= a) {
                            if (r) return [
                                {
                                    key: null,
                                    x1: e1,
                                    y1: t,
                                    x2: i,
                                    y2: a
                                }
                            ];
                            for(var _$e = 0; _$e < this.boxKeys.length; _$e++)n.push({
                                key: this.boxKeys[_$e],
                                x1: this.bboxes[4 * _$e],
                                y1: this.bboxes[4 * _$e + 1],
                                x2: this.bboxes[4 * _$e + 2],
                                y2: this.bboxes[4 * _$e + 3]
                            });
                            for(var _$e1 = 0; _$e1 < this.circleKeys.length; _$e1++){
                                var _$t = this.circles[3 * _$e1], _$i = this.circles[3 * _$e1 + 1], _$a = this.circles[3 * _$e1 + 2];
                                n.push({
                                    key: this.circleKeys[_$e1],
                                    x1: _$t - _$a,
                                    y1: _$i - _$a,
                                    x2: _$t + _$a,
                                    y2: _$i + _$a
                                });
                            }
                        } else this._forEachCell(e1, t, i, a, this._queryCell, n, {
                            hitTest: r,
                            overlapMode: o,
                            seenUids: {
                                box: {},
                                circle: {}
                            }
                        }, s);
                        return n;
                    }
                },
                {
                    key: "query",
                    value: function query(e1, t, i, a) {
                        return this._query(e1, t, i, a, !1, null);
                    }
                },
                {
                    key: "hitTest",
                    value: function hitTest(e1, t, i, a, r, o) {
                        return this._query(e1, t, i, a, !0, r, o).length > 0;
                    }
                },
                {
                    key: "hitTestCircle",
                    value: function hitTestCircle(e1, t, i, a, r) {
                        var o = e1 - i, s = e1 + i, n = t - i, l = t + i;
                        if (s < 0 || o > this.width || l < 0 || n > this.height) return !1;
                        var _$c = [];
                        return this._forEachCell(o, n, s, l, this._queryCellCircle, _$c, {
                            hitTest: !0,
                            overlapMode: a,
                            circle: {
                                x: e1,
                                y: t,
                                radius: i
                            },
                            seenUids: {
                                box: {},
                                circle: {}
                            }
                        }, r), _$c.length > 0;
                    }
                },
                {
                    key: "_queryCell",
                    value: function _queryCell(e1, t, i, a, r, o, s, n) {
                        var l = s.seenUids, _$c = s.hitTest, h = s.overlapMode, u = this.boxCells[r];
                        if (null !== u) {
                            var _$r = this.bboxes;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = u[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$s = _step.value;
                                    if (!l.box[_$s]) {
                                        l.box[_$s] = !0;
                                        var u1 = 4 * _$s, d = this.boxKeys[_$s];
                                        if (e1 <= _$r[u1 + 2] && t <= _$r[u1 + 3] && i >= _$r[u1 + 0] && a >= _$r[u1 + 1] && (!n || n(d)) && (!_$c || !Be(h, d.overlapMode)) && (o.push({
                                            key: d,
                                            x1: _$r[u1],
                                            y1: _$r[u1 + 1],
                                            x2: _$r[u1 + 2],
                                            y2: _$r[u1 + 3]
                                        }), _$c)) return !0;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        var d1 = this.circleCells[r];
                        if (null !== d1) {
                            var _$r1 = this.circles;
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = d1[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var _$s1 = _step1.value;
                                    if (!l.circle[_$s1]) {
                                        l.circle[_$s1] = !0;
                                        var u2 = 3 * _$s1, d2 = this.circleKeys[_$s1];
                                        if (this._circleAndRectCollide(_$r1[u2], _$r1[u2 + 1], _$r1[u2 + 2], e1, t, i, a) && (!n || n(d2)) && (!_$c || !Be(h, d2.overlapMode))) {
                                            var _$e = _$r1[u2], _$t = _$r1[u2 + 1], _$i = _$r1[u2 + 2];
                                            if (o.push({
                                                key: d2,
                                                x1: _$e - _$i,
                                                y1: _$t - _$i,
                                                x2: _$e + _$i,
                                                y2: _$t + _$i
                                            }), _$c) return !0;
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                        return !1;
                    }
                },
                {
                    key: "_queryCellCircle",
                    value: function _queryCellCircle(e1, t, i, a, r, o, s, n) {
                        var l = s.circle, _$c = s.seenUids, h = s.overlapMode, u = this.boxCells[r];
                        if (null !== u) {
                            var _$e = this.bboxes;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = u[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step.value;
                                    if (!_$c.box[_$t]) {
                                        _$c.box[_$t] = !0;
                                        var i1 = 4 * _$t, a1 = this.boxKeys[_$t];
                                        if (this._circleAndRectCollide(l.x, l.y, l.radius, _$e[i1 + 0], _$e[i1 + 1], _$e[i1 + 2], _$e[i1 + 3]) && (!n || n(a1)) && !Be(h, a1.overlapMode)) return o.push(!0), !0;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        var d = this.circleCells[r];
                        if (null !== d) {
                            var _$e1 = this.circles;
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = d[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var _$t1 = _step1.value;
                                    if (!_$c.circle[_$t1]) {
                                        _$c.circle[_$t1] = !0;
                                        var i2 = 3 * _$t1, a2 = this.circleKeys[_$t1];
                                        if (this._circlesCollide(_$e1[i2], _$e1[i2 + 1], _$e1[i2 + 2], l.x, l.y, l.radius) && (!n || n(a2)) && !Be(h, a2.overlapMode)) return o.push(!0), !0;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }
                    }
                },
                {
                    key: "_forEachCell",
                    value: function _forEachCell(e1, t, i, a, r, o, s, n) {
                        var l = this._convertToXCellCoord(e1), _$c = this._convertToYCellCoord(t), h = this._convertToXCellCoord(i), u = this._convertToYCellCoord(a);
                        for(var d = l; d <= h; d++)for(var l1 = _$c; l1 <= u; l1++)if (r.call(this, e1, t, i, a, this.xCellCount * l1 + d, o, s, n)) return;
                    }
                },
                {
                    key: "_convertToXCellCoord",
                    value: function _convertToXCellCoord(e1) {
                        return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
                    }
                },
                {
                    key: "_convertToYCellCoord",
                    value: function _convertToYCellCoord(e1) {
                        return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
                    }
                },
                {
                    key: "_circlesCollide",
                    value: function _circlesCollide(e1, t, i, a, r, o) {
                        var s = a - e1, n = r - t, l = i + o;
                        return l * l > s * s + n * n;
                    }
                },
                {
                    key: "_circleAndRectCollide",
                    value: function _circleAndRectCollide(e1, t, i, a, r, o, s) {
                        var n = (o - a) / 2, l = Math.abs(e1 - (a + n));
                        if (l > n + i) return !1;
                        var _$c = (s - r) / 2, h = Math.abs(t - (r + _$c));
                        if (h > _$c + i) return !1;
                        if (l <= n || h <= _$c) return !0;
                        var u = l - n, d = h - _$c;
                        return u * u + d * d <= i * i;
                    }
                }
            ]);
            return Oe;
        }();
        function je(e1, i, r) {
            var o = t.N();
            if (!e1) {
                var _Ze = Ze(i), _$e = _Ze.vecSouth, _$t = _Ze.vecEast, _$r = a();
                _$r[0] = _$t[0], _$r[1] = _$t[1], _$r[2] = _$e[0], _$r[3] = _$e[1], s = _$r, (d = (l = (n = _$r)[0]) * (u = n[3]) - (h = n[2]) * (_$c = n[1])) && (s[0] = u * (d = 1 / d), s[1] = -_$c * d, s[2] = -h * d, s[3] = l * d), o[0] = _$r[0], o[1] = _$r[1], o[4] = _$r[2], o[5] = _$r[3];
            }
            var s, n, l, _$c, h, u, d;
            return t.Q(o, o, [
                1 / r,
                1 / r,
                1
            ]), o;
        }
        function Ne(e1, i, a, r) {
            if (e1) {
                var _$e = t.N();
                if (!i) {
                    var _Ze = Ze(a), _$t = _Ze.vecSouth, _$i = _Ze.vecEast;
                    _$e[0] = _$i[0], _$e[1] = _$i[1], _$e[4] = _$t[0], _$e[5] = _$t[1];
                }
                return t.Q(_$e, _$e, [
                    r,
                    r,
                    1
                ]), _$e;
            }
            return a.pixelsToClipSpaceMatrix;
        }
        function Ze(e1) {
            var i = Math.cos(e1.rollInRadians), a = Math.sin(e1.rollInRadians), r = Math.cos(e1.pitchInRadians), o = Math.cos(e1.bearingInRadians), s = Math.sin(e1.bearingInRadians), n = t.aC();
            n[0] = -o * r * a - s * i, n[1] = -s * r * a + o * i;
            var l = t.aD(n);
            l < 1e-9 ? t.aE(n) : t.aF(n, n, 1 / l);
            var _$c = t.aC();
            _$c[0] = o * r * i - s * a, _$c[1] = s * r * i + o * a;
            var h = t.aD(_$c);
            return h < 1e-9 ? t.aE(_$c) : t.aF(_$c, _$c, 1 / h), {
                vecEast: _$c,
                vecSouth: n
            };
        }
        function Ge(e1, i, a, r) {
            var o;
            r ? (o = [
                e1,
                i,
                r(e1, i),
                1
            ], t.aH(o, o, a)) : (o = [
                e1,
                i,
                0,
                1
            ], ot(o, o, a));
            var s = o[3];
            return {
                point: new t.P(o[0] / s, o[1] / s),
                signedDistanceFromCamera: s,
                isOccluded: !1
            };
        }
        function Ue(e1, t) {
            return .5 + e1 / t * .5;
        }
        function Ve(e1, t) {
            return e1.x >= -t[0] && e1.x <= t[0] && e1.y >= -t[1] && e1.y <= t[1];
        }
        function qe(e1, i, a, r, o, s, n, l, c, h, u, d, _) {
            var p = a ? e1.textSizeData : e1.iconSizeData, m = t.ay(p, i.transform.zoom), f = [
                256 / i.width * 2 + 1,
                256 / i.height * 2 + 1
            ], g = a ? e1.text.dynamicLayoutVertexArray : e1.icon.dynamicLayoutVertexArray;
            g.clear();
            var v = e1.lineVertexArray, x = a ? e1.text.placedSymbolArray : e1.icon.placedSymbolArray, b = i.transform.width / i.transform.height;
            var y = !1;
            for(var _$a = 0; _$a < x.length; _$a++){
                var w = x.get(_$a);
                if (w.hidden || w.writingMode === t.az.vertical && !y) {
                    rt(w.numGlyphs, g);
                    continue;
                }
                y = !1;
                var T = new t.P(w.anchorX, w.anchorY), P = {
                    getElevation: _,
                    pitchedLabelPlaneMatrix: r,
                    lineVertexArray: v,
                    pitchWithMap: s,
                    projectionCache: {
                        projections: {},
                        offsets: {},
                        cachedAnchorPoint: void 0,
                        anyProjectionOccluded: !1
                    },
                    transform: i.transform,
                    tileAnchorPoint: T,
                    unwrappedTileID: c,
                    width: h,
                    height: u,
                    translation: d
                }, C = Je(w.anchorX, w.anchorY, P);
                if (!Ve(C.point, f)) {
                    rt(w.numGlyphs, g);
                    continue;
                }
                var I = Ue(i.transform.cameraToCenterDistance, C.signedDistanceFromCamera), M = t.aA(p, m, w), E = s ? M * i.transform.getPitchedTextCorrection(w.anchorX, w.anchorY, c) / I : M * I, S = He({
                    projectionContext: P,
                    pitchedLabelPlaneMatrixInverse: o,
                    symbol: w,
                    fontSize: E,
                    flip: !1,
                    keepUpright: n,
                    glyphOffsetArray: e1.glyphOffsetArray,
                    dynamicLayoutVertexArray: g,
                    aspectRatio: b,
                    rotateToLine: l
                });
                y = S.useVertical, (S.notEnoughRoom || y || S.needsFlipping && He({
                    projectionContext: P,
                    pitchedLabelPlaneMatrixInverse: o,
                    symbol: w,
                    fontSize: E,
                    flip: !0,
                    keepUpright: n,
                    glyphOffsetArray: e1.glyphOffsetArray,
                    dynamicLayoutVertexArray: g,
                    aspectRatio: b,
                    rotateToLine: l
                }).notEnoughRoom) && rt(w.numGlyphs, g);
            }
            a ? e1.text.dynamicLayoutVertexBuffer.updateData(g) : e1.icon.dynamicLayoutVertexBuffer.updateData(g);
        }
        function We(e1, t, i, a, r, o, s, n) {
            var l = o.glyphStartIndex + o.numGlyphs, _$c = o.lineStartIndex, h = o.lineStartIndex + o.lineLength, u = t.getoffsetX(o.glyphStartIndex), d = t.getoffsetX(l - 1), _ = it(e1 * u, i, a, r, o.segment, _$c, h, n, s);
            if (!_) return null;
            var p = it(e1 * d, i, a, r, o.segment, _$c, h, n, s);
            return p ? n.projectionCache.anyProjectionOccluded ? null : {
                first: _,
                last: p
            } : null;
        }
        function $e(e1, i, a, r) {
            return e1 === t.az.horizontal && Math.abs(a.y - i.y) > Math.abs(a.x - i.x) * r ? {
                useVertical: !0
            } : (e1 === t.az.vertical ? i.y < a.y : i.x > a.x) ? {
                needsFlipping: !0
            } : null;
        }
        function He(e1) {
            var i = e1.projectionContext, a = e1.pitchedLabelPlaneMatrixInverse, r = e1.symbol, o = e1.fontSize, s = e1.flip, n = e1.keepUpright, l = e1.glyphOffsetArray, _$c = e1.dynamicLayoutVertexArray, h = e1.aspectRatio, u = e1.rotateToLine, d = o / 24, _ = r.lineOffsetX * d, p = r.lineOffsetY * d;
            var m;
            if (r.numGlyphs > 1) {
                var _$e = r.glyphStartIndex + r.numGlyphs, _$t = r.lineStartIndex, o1 = r.lineStartIndex + r.lineLength, _$c1 = We(d, l, _, p, s, r, u, i);
                if (!_$c1) return {
                    notEnoughRoom: !0
                };
                var f = Qe(_$c1.first.point.x, _$c1.first.point.y, i, a), g = Qe(_$c1.last.point.x, _$c1.last.point.y, i, a);
                if (n && !s) {
                    var _$e1 = $e(r.writingMode, f, g, h);
                    if (_$e1) return _$e1;
                }
                m = [
                    _$c1.first
                ];
                for(var a1 = r.glyphStartIndex + 1; a1 < _$e - 1; a1++){
                    var _$e2 = it(d * l.getoffsetX(a1), _, p, s, r.segment, _$t, o1, i, u);
                    if (!_$e2) return {
                        notEnoughRoom: !0
                    };
                    m.push(_$e2);
                }
                m.push(_$c1.last);
            } else {
                if (n && !s) {
                    var _$e3 = Ye(i.tileAnchorPoint.x, i.tileAnchorPoint.y, i).point, o2 = r.lineStartIndex + r.segment + 1, s1 = new t.P(i.lineVertexArray.getx(o2), i.lineVertexArray.gety(o2)), n1 = Ye(s1.x, s1.y, i), l1 = n1.signedDistanceFromCamera > 0 ? n1.point : Xe(i.tileAnchorPoint, s1, _$e3, 1, i), _$c2 = Qe(_$e3.x, _$e3.y, i, a), u1 = Qe(l1.x, l1.y, i, a), d1 = $e(r.writingMode, _$c2, u1, h);
                    if (d1) return d1;
                }
                var _$e4 = it(d * l.getoffsetX(r.glyphStartIndex), _, p, s, r.segment, r.lineStartIndex, r.lineStartIndex + r.lineLength, i, u);
                if (!_$e4 || i.projectionCache.anyProjectionOccluded) return {
                    notEnoughRoom: !0
                };
                m = [
                    _$e4
                ];
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = m[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e5 = _step.value;
                    t.aG(_$c, _$e5.point, _$e5.angle);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return {};
        }
        function Xe(e1, t, i, a, r) {
            var o = e1.add(e1.sub(t)._unit()), s = Ye(o.x, o.y, r).point, n = i.sub(s);
            return i.add(n._mult(a / n.mag()));
        }
        function Ke(e1, i, a) {
            var r = i.projectionCache;
            if (r.projections[e1]) return r.projections[e1];
            var o = new t.P(i.lineVertexArray.getx(e1), i.lineVertexArray.gety(e1)), s = Ye(o.x, o.y, i);
            if (s.signedDistanceFromCamera > 0) return r.projections[e1] = s.point, r.anyProjectionOccluded = r.anyProjectionOccluded || s.isOccluded, s.point;
            var n = e1 - a.direction;
            return Xe(0 === a.distanceFromAnchor ? i.tileAnchorPoint : new t.P(i.lineVertexArray.getx(n), i.lineVertexArray.gety(n)), o, a.previousVertex, a.absOffsetX - a.distanceFromAnchor + 1, i);
        }
        function Ye(e1, t, i) {
            var a = e1 + i.translation[0], r = t + i.translation[1];
            var o;
            return i.pitchWithMap ? (o = Ge(a, r, i.pitchedLabelPlaneMatrix, i.getElevation), o.isOccluded = !1) : (o = i.transform.projectTileCoordinates(a, r, i.unwrappedTileID, i.getElevation), o.point.x = (.5 * o.point.x + .5) * i.width, o.point.y = (.5 * -o.point.y + .5) * i.height), o;
        }
        function Qe(e1, i, a, r) {
            if (a.pitchWithMap) {
                var o = [
                    e1,
                    i,
                    0,
                    1
                ];
                return t.aH(o, o, r), a.transform.projectTileCoordinates(o[0] / o[3], o[1] / o[3], a.unwrappedTileID, a.getElevation).point;
            }
            return {
                x: e1 / a.width * 2 - 1,
                y: 1 - i / a.height * 2
            };
        }
        function Je(e1, t, i) {
            return i.transform.projectTileCoordinates(e1, t, i.unwrappedTileID, i.getElevation);
        }
        function et(e1, t, i) {
            return e1._unit()._perp()._mult(t * i);
        }
        function tt(e1, i, a, r, o, s, n, l, c) {
            if (l.projectionCache.offsets[e1]) return l.projectionCache.offsets[e1];
            var h = a.add(i);
            if (e1 + c.direction < r || e1 + c.direction >= o) return l.projectionCache.offsets[e1] = h, h;
            var u = Ke(e1 + c.direction, l, c), d = et(u.sub(a), n, c.direction), _ = a.add(d), p = u.add(d);
            return l.projectionCache.offsets[e1] = t.aI(s, h, _, p) || h, l.projectionCache.offsets[e1];
        }
        function it(e1, t, i, a, r, o, s, n, l) {
            var _$c = a ? e1 - t : e1 + t;
            var h = _$c > 0 ? 1 : -1, u = 0;
            a && (h *= -1, u = Math.PI), h < 0 && (u += Math.PI);
            var d, _ = h > 0 ? o + r : o + r + 1;
            n.projectionCache.cachedAnchorPoint ? d = n.projectionCache.cachedAnchorPoint : (d = Ye(n.tileAnchorPoint.x, n.tileAnchorPoint.y, n).point, n.projectionCache.cachedAnchorPoint = d);
            var p, m, f = d, g = d, v = 0, x = 0;
            var b = Math.abs(_$c), y = [];
            var w;
            for(; v + x <= b;){
                if (_ += h, _ < o || _ >= s) return null;
                v += x, g = f, m = p;
                var _$e = {
                    absOffsetX: b,
                    direction: h,
                    distanceFromAnchor: v,
                    previousVertex: g
                };
                if (f = Ke(_, n, _$e), 0 === i) y.push(g), w = f.sub(g);
                else {
                    var _$t = void 0;
                    var _$a = f.sub(g);
                    _$t = 0 === _$a.mag() ? et(Ke(_ + h, n, _$e).sub(f), i, h) : et(_$a, i, h), m || (m = g.add(_$t)), p = tt(_, _$t, f, o, s, m, i, n, _$e), y.push(m), w = p.sub(m);
                }
                x = w.mag();
            }
            var T = w._mult((b - v) / x)._add(m || g), P = u + Math.atan2(f.y - g.y, f.x - g.x);
            return y.push(T), {
                point: T,
                angle: l ? P : 0,
                path: y
            };
        }
        var at = new Float32Array([
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0,
            -1 / 0,
            -1 / 0,
            0
        ]);
        function rt(e1, t) {
            for(var i = 0; i < e1; i++){
                var _$e = t.length;
                t.resize(_$e + 4), t.float32.set(at, 3 * _$e);
            }
        }
        function ot(e1, t, i) {
            var a = t[0], r = t[1];
            return e1[0] = i[0] * a + i[4] * r + i[12], e1[1] = i[1] * a + i[5] * r + i[13], e1[3] = i[3] * a + i[7] * r + i[15], e1;
        }
        var st = 100;
        var nt = /*#__PURE__*/ function() {
            function nt(e1) {
                var _$t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new Oe(e1.width + 200, e1.height + 200, 25), i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : new Oe(e1.width + 200, e1.height + 200, 25);
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, nt);
                this.transform = e1, this.grid = _$t, this.ignoredGrid = i, this.pitchFactor = Math.cos(e1.pitch * Math.PI / 180) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + st, this.screenBottomBoundary = e1.height + st, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.perspectiveRatioCutoff = .6;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(nt, [
                {
                    key: "placeCollisionBox",
                    value: function placeCollisionBox(e1, t, i, a, r, o, s, n, l, c, h, u) {
                        var d = this.projectAndGetPerspectiveRatio(e1.anchorPointX + n[0], e1.anchorPointY + n[1], r, c, u), _ = i * d.perspectiveRatio;
                        var p;
                        if (o || s) p = this._projectCollisionBox(e1, _, a, r, o, s, n, d, c, h, u);
                        else {
                            var _$t = d.x + (h ? h.x * _ : 0), _$i = d.y + (h ? h.y * _ : 0);
                            p = {
                                allPointsOccluded: !1,
                                box: [
                                    _$t + e1.x1 * _,
                                    _$i + e1.y1 * _,
                                    _$t + e1.x2 * _,
                                    _$i + e1.y2 * _
                                ]
                            };
                        }
                        var _p_box = (0, $db95b225ee8036d6$export$71511d61b312f219)(p.box, 4), m = _p_box[0], f = _p_box[1], g = _p_box[2], v = _p_box[3], x = o ? p.allPointsOccluded : d.isOccluded;
                        var b = x;
                        return b || (b = d.perspectiveRatio < this.perspectiveRatioCutoff), b || (b = !this.isInsideGrid(m, f, g, v)), b || "always" !== t && this.grid.hitTest(m, f, g, v, t, l) ? {
                            box: [
                                m,
                                f,
                                g,
                                v
                            ],
                            placeable: !1,
                            offscreen: !1,
                            occluded: x
                        } : {
                            box: [
                                m,
                                f,
                                g,
                                v
                            ],
                            placeable: !0,
                            offscreen: this.isOffscreen(m, f, g, v),
                            occluded: x
                        };
                    }
                },
                {
                    key: "placeCollisionCircles",
                    value: function placeCollisionCircles(e1, i, a, r, o, s, n, l, c, h, u, d, _, p) {
                        var m = [], f = new t.P(i.anchorX, i.anchorY), g = this.getPerspectiveRatio(f.x, f.y, s, p), v = (c ? o * this.transform.getPitchedTextCorrection(i.anchorX, i.anchorY, s) / g : o * g) / t.aM, x = {
                            getElevation: p,
                            pitchedLabelPlaneMatrix: n,
                            lineVertexArray: a,
                            pitchWithMap: c,
                            projectionCache: {
                                projections: {},
                                offsets: {},
                                cachedAnchorPoint: void 0,
                                anyProjectionOccluded: !1
                            },
                            transform: this.transform,
                            tileAnchorPoint: f,
                            unwrappedTileID: s,
                            width: this.transform.width,
                            height: this.transform.height,
                            translation: _
                        }, b = We(v, r, i.lineOffsetX * v, i.lineOffsetY * v, !1, i, !1, x);
                        var y = !1, w = !1, T = !0;
                        if (b) {
                            var _$i = .5 * u * g + d, _$a = new t.P(-100, -100), _$r = new t.P(this.screenRightBoundary, this.screenBottomBoundary), _$o = new Fe, _$s = b.first, _$n = b.last;
                            var _$_ = [];
                            for(var _$e = _$s.path.length - 1; _$e >= 1; _$e--)_$_.push(_$s.path[_$e]);
                            for(var _$e1 = 1; _$e1 < _$n.path.length; _$e1++)_$_.push(_$n.path[_$e1]);
                            var _$p = 2.5 * _$i;
                            if (c) {
                                var _$e2 = this.projectPathToScreenSpace(_$_, x);
                                _$_ = _$e2.some(function(e1) {
                                    return e1.signedDistanceFromCamera <= 0;
                                }) ? [] : _$e2.map(function(e1) {
                                    return e1.point;
                                });
                            }
                            var f1 = [];
                            if (_$_.length > 0) {
                                var _$e3 = _$_[0].clone(), _$i1 = _$_[0].clone();
                                for(var _$t = 1; _$t < _$_.length; _$t++)_$e3.x = Math.min(_$e3.x, _$_[_$t].x), _$e3.y = Math.min(_$e3.y, _$_[_$t].y), _$i1.x = Math.max(_$i1.x, _$_[_$t].x), _$i1.y = Math.max(_$i1.y, _$_[_$t].y);
                                f1 = _$e3.x >= _$a.x && _$i1.x <= _$r.x && _$e3.y >= _$a.y && _$i1.y <= _$r.y ? [
                                    _$_
                                ] : _$i1.x < _$a.x || _$e3.x > _$r.x || _$i1.y < _$a.y || _$e3.y > _$r.y ? [] : t.aJ([
                                    _$_
                                ], _$a.x, _$a.y, _$r.x, _$r.y);
                            }
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = f1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t1 = _step.value;
                                    _$o.reset(_$t1, .25 * _$i);
                                    var _$a1 = 0;
                                    _$a1 = _$o.length <= .5 * _$i ? 1 : Math.ceil(_$o.paddedLength / _$p) + 1;
                                    for(var _$t2 = 0; _$t2 < _$a1; _$t2++){
                                        var _$r1 = _$t2 / Math.max(_$a1 - 1, 1), _$s1 = _$o.lerp(_$r1), _$n1 = _$s1.x + st, _$c = _$s1.y + st;
                                        m.push(_$n1, _$c, _$i, 0);
                                        var _$u = _$n1 - _$i, _$d = _$c - _$i, _$_1 = _$n1 + _$i, _$p1 = _$c + _$i;
                                        if (T = T && this.isOffscreen(_$u, _$d, _$_1, _$p1), w = w || this.isInsideGrid(_$u, _$d, _$_1, _$p1), "always" !== e1 && this.grid.hitTestCircle(_$n1, _$c, _$i, e1, h) && (y = !0, !l)) return {
                                            circles: [],
                                            offscreen: !1,
                                            collisionDetected: y
                                        };
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        return {
                            circles: !l && y || !w || g < this.perspectiveRatioCutoff ? [] : m,
                            offscreen: T,
                            collisionDetected: y
                        };
                    }
                },
                {
                    key: "projectPathToScreenSpace",
                    value: function projectPathToScreenSpace(e1, i) {
                        var a = function(e1, i) {
                            var a = t.N();
                            return t.aB(a, i.pitchedLabelPlaneMatrix), e1.map(function(e1) {
                                var _$t = Ge(e1.x, e1.y, a, i.getElevation), r = i.transform.projectTileCoordinates(_$t.point.x, _$t.point.y, i.unwrappedTileID, i.getElevation);
                                return r.point.x = (.5 * r.point.x + .5) * i.width, r.point.y = (.5 * -r.point.y + .5) * i.height, r;
                            });
                        }(e1, i);
                        return function(e1) {
                            var _$t = 0, _$i = 0, a = 0, r = 0;
                            for(var o = 0; o < e1.length; o++)e1[o].isOccluded ? (a = o + 1, r = 0) : (r++, r > _$i && (_$i = r, _$t = a));
                            return e1.slice(_$t, _$t + _$i);
                        }(a);
                    }
                },
                {
                    key: "queryRenderedSymbols",
                    value: function queryRenderedSymbols(e1) {
                        if (0 === e1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                        var i = [], a = new t.aa;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var r = _step.value;
                                var _$e = new t.P(r.x + st, r.y + st);
                                a.extend(_$e), i.push(_$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var r1 = a.minX, o = a.minY, s = a.maxX, n = a.maxY, l = this.grid.query(r1, o, s, n).concat(this.ignoredGrid.query(r1, o, s, n)), _$c = {}, h = {};
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = l[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$e1 = _step1.value;
                                var a1 = _$e1.key;
                                if (void 0 === _$c[a1.bucketInstanceId] && (_$c[a1.bucketInstanceId] = {}), _$c[a1.bucketInstanceId][a1.featureIndex]) continue;
                                var r2 = [
                                    new t.P(_$e1.x1, _$e1.y1),
                                    new t.P(_$e1.x2, _$e1.y1),
                                    new t.P(_$e1.x2, _$e1.y2),
                                    new t.P(_$e1.x1, _$e1.y2)
                                ];
                                t.aK(i, r2) && (_$c[a1.bucketInstanceId][a1.featureIndex] = !0, void 0 === h[a1.bucketInstanceId] && (h[a1.bucketInstanceId] = []), h[a1.bucketInstanceId].push(a1.featureIndex));
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        return h;
                    }
                },
                {
                    key: "insertCollisionBox",
                    value: function insertCollisionBox(e1, t, i, a, r, o) {
                        (i ? this.ignoredGrid : this.grid).insert({
                            bucketInstanceId: a,
                            featureIndex: r,
                            collisionGroupID: o,
                            overlapMode: t
                        }, e1[0], e1[1], e1[2], e1[3]);
                    }
                },
                {
                    key: "insertCollisionCircles",
                    value: function insertCollisionCircles(e1, t, i, a, r, o) {
                        var s = i ? this.ignoredGrid : this.grid, n = {
                            bucketInstanceId: a,
                            featureIndex: r,
                            collisionGroupID: o,
                            overlapMode: t
                        };
                        for(var _$t = 0; _$t < e1.length; _$t += 4)s.insertCircle(n, e1[_$t], e1[_$t + 1], e1[_$t + 2]);
                    }
                },
                {
                    key: "projectAndGetPerspectiveRatio",
                    value: function projectAndGetPerspectiveRatio(e1, i, a, r, o) {
                        if (o) {
                            var _$a;
                            r ? (_$a = [
                                e1,
                                i,
                                r(e1, i),
                                1
                            ], t.aH(_$a, _$a, o)) : (_$a = [
                                e1,
                                i,
                                0,
                                1
                            ], ot(_$a, _$a, o));
                            var s = _$a[3];
                            return {
                                x: (_$a[0] / s + 1) / 2 * this.transform.width + st,
                                y: (-_$a[1] / s + 1) / 2 * this.transform.height + st,
                                perspectiveRatio: .5 + this.transform.cameraToCenterDistance / s * .5,
                                isOccluded: !1,
                                signedDistanceFromCamera: s
                            };
                        }
                        {
                            var _$t = this.transform.projectTileCoordinates(e1, i, a, r);
                            return {
                                x: (_$t.point.x + 1) / 2 * this.transform.width + st,
                                y: (1 - _$t.point.y) / 2 * this.transform.height + st,
                                perspectiveRatio: .5 + this.transform.cameraToCenterDistance / _$t.signedDistanceFromCamera * .5,
                                isOccluded: _$t.isOccluded,
                                signedDistanceFromCamera: _$t.signedDistanceFromCamera
                            };
                        }
                    }
                },
                {
                    key: "getPerspectiveRatio",
                    value: function getPerspectiveRatio(e1, t, i, a) {
                        var r = this.transform.projectTileCoordinates(e1, t, i, a);
                        return .5 + this.transform.cameraToCenterDistance / r.signedDistanceFromCamera * .5;
                    }
                },
                {
                    key: "isOffscreen",
                    value: function isOffscreen(e1, t, i, a) {
                        return i < st || e1 >= this.screenRightBoundary || a < st || t > this.screenBottomBoundary;
                    }
                },
                {
                    key: "isInsideGrid",
                    value: function isInsideGrid(e1, t, i, a) {
                        return i >= 0 && e1 < this.gridRightBoundary && a >= 0 && t < this.gridBottomBoundary;
                    }
                },
                {
                    key: "getViewportMatrix",
                    value: function getViewportMatrix() {
                        var _$e = t.ar([]);
                        return t.O(_$e, _$e, [
                            -100,
                            -100,
                            0
                        ]), _$e;
                    }
                },
                {
                    key: "_projectCollisionBox",
                    value: function _projectCollisionBox(e1, i, a, r, o, s, n, l, c, h, u) {
                        var _this = this;
                        var d = 1, _ = 0, p = 0, m = 1;
                        var f = e1.anchorPointX + n[0], g = e1.anchorPointY + n[1];
                        if (s && !o) {
                            var _$e = this.projectAndGetPerspectiveRatio(f + 1, g, r, c, u), _$t = _$e.x - l.x, _$i = Math.atan((_$e.y - l.y) / _$t) + (_$t < 0 ? Math.PI : 0), _$a = Math.sin(_$i), _$o = Math.cos(_$i);
                            d = _$o, _ = _$a, p = -_$a, m = _$o;
                        } else if (!s && o) {
                            var _$e1 = Ze(this.transform);
                            d = _$e1.vecEast[0], _ = _$e1.vecEast[1], p = _$e1.vecSouth[0], m = _$e1.vecSouth[1];
                        }
                        var v = l.x, x = l.y, b = i;
                        o && (v = f, x = g, b = Math.pow(2, -(this.transform.zoom - a.overscaledZ)), b *= this.transform.getPitchedTextCorrection(f, g, r), h || (b *= t.an(.5 + l.signedDistanceFromCamera / this.transform.cameraToCenterDistance * .5, 0, 4))), h && (v += d * h.x * b + p * h.y * b, x += _ * h.x * b + m * h.y * b);
                        var y = e1.x1 * b, w = e1.x2 * b, T = (y + w) / 2, P = e1.y1 * b, C = e1.y2 * b, I = (P + C) / 2, M = [
                            {
                                offsetX: y,
                                offsetY: P
                            },
                            {
                                offsetX: T,
                                offsetY: P
                            },
                            {
                                offsetX: w,
                                offsetY: P
                            },
                            {
                                offsetX: w,
                                offsetY: I
                            },
                            {
                                offsetX: w,
                                offsetY: C
                            },
                            {
                                offsetX: T,
                                offsetY: C
                            },
                            {
                                offsetX: y,
                                offsetY: C
                            },
                            {
                                offsetX: y,
                                offsetY: I
                            }
                        ];
                        var E = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = M[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, _$e2 = _step_value.offsetX, _$i1 = _step_value.offsetY;
                                E.push(new t.P(v + d * _$e2 + p * _$i1, x + _ * _$e2 + m * _$i1));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var S = !1;
                        if (o) {
                            var _$e3 = E.map(function(e1) {
                                return _this.projectAndGetPerspectiveRatio(e1.x, e1.y, r, c, u);
                            });
                            S = _$e3.some(function(e1) {
                                return !e1.isOccluded;
                            }), E = _$e3.map(function(e1) {
                                return new t.P(e1.x, e1.y);
                            });
                        } else S = !0;
                        return {
                            box: t.aL(E),
                            allPointsOccluded: !S
                        };
                    }
                }
            ]);
            return nt;
        }();
        var lt = /*#__PURE__*/ function() {
            function lt(e1, t, i, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, lt);
                this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t : -t))) : a && i ? 1 : 0, this.placed = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(lt, [
                {
                    key: "isHidden",
                    value: function isHidden() {
                        return 0 === this.opacity && !this.placed;
                    }
                }
            ]);
            return lt;
        }();
        var ct = /*#__PURE__*/ function() {
            function ct(e1, t, i, a, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ct);
                this.text = new lt(e1 ? e1.text : null, t, i, r), this.icon = new lt(e1 ? e1.icon : null, t, a, r);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ct, [
                {
                    key: "isHidden",
                    value: function isHidden() {
                        return this.text.isHidden() && this.icon.isHidden();
                    }
                }
            ]);
            return ct;
        }();
        var ht = function ht(e1, t, i) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, ht);
            this.text = e1, this.icon = t, this.skipFade = i;
        };
        var ut = function ut(e1, t, i, a, r) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, ut);
            this.bucketInstanceId = e1, this.featureIndex = t, this.sourceLayerIndex = i, this.bucketIndex = a, this.tileID = r;
        };
        var dt = /*#__PURE__*/ function() {
            function dt(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, dt);
                this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(dt, [
                {
                    key: "get",
                    value: function get(e1) {
                        if (this.crossSourceCollisions) return {
                            ID: 0,
                            predicate: null
                        };
                        if (!this.collisionGroups[e1]) {
                            var _$t = ++this.maxGroupID;
                            this.collisionGroups[e1] = {
                                ID: _$t,
                                predicate: function(e1) {
                                    return e1.collisionGroupID === _$t;
                                }
                            };
                        }
                        return this.collisionGroups[e1];
                    }
                }
            ]);
            return dt;
        }();
        function _t(e1, i, a, r, o) {
            var _t_aS = t.aS(e1), s = _t_aS.horizontalAlign, n = _t_aS.verticalAlign;
            return new t.P(-(s - .5) * i + r[0] * o, -(n - .5) * a + r[1] * o);
        }
        var pt = /*#__PURE__*/ function() {
            function pt(e1, t, i, a, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, pt);
                this.transform = e1.clone(), this.terrain = t, this.collisionIndex = new nt(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = i, this.retainedQueryData = {}, this.collisionGroups = new dt(a), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = r, r && (r.prevPlacement = void 0), this.placedOrientations = {};
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(pt, [
                {
                    key: "_getTerrainElevationFunc",
                    value: function _getTerrainElevationFunc(e1) {
                        var _$t = this.terrain;
                        return _$t ? function(i, a) {
                            return _$t.getElevation(e1, i, a);
                        } : null;
                    }
                },
                {
                    key: "getBucketParts",
                    value: function getBucketParts(e1, i, a, r) {
                        var o = a.getBucket(i), s = a.latestFeatureIndex;
                        if (!o || !s || i.id !== o.layerIds[0]) return;
                        var n = a.collisionBoxArray, l = o.layers[0].layout, _$c = o.layers[0].paint, h = Math.pow(2, this.transform.zoom - a.tileID.overscaledZ), u = a.tileSize / t.a5, d = a.tileID.toUnwrapped(), _ = "map" === l.get("text-rotation-alignment"), p = t.aN(a, 1, this.transform.zoom), m = t.aO(this.collisionIndex.transform, a, _$c.get("text-translate"), _$c.get("text-translate-anchor")), f = t.aO(this.collisionIndex.transform, a, _$c.get("icon-translate"), _$c.get("icon-translate-anchor")), g = je(_, this.transform, p);
                        this.retainedQueryData[o.bucketInstanceId] = new ut(o.bucketInstanceId, s, o.sourceLayerIndex, o.index, a.tileID);
                        var v = {
                            bucket: o,
                            layout: l,
                            translationText: m,
                            translationIcon: f,
                            unwrappedTileID: d,
                            pitchedLabelPlaneMatrix: g,
                            scale: h,
                            textPixelRatio: u,
                            holdingForFade: a.holdingForSymbolFade(),
                            collisionBoxArray: n,
                            partiallyEvaluatedTextSize: t.ay(o.textSizeData, this.transform.zoom),
                            collisionGroup: this.collisionGroups.get(o.sourceID)
                        };
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (r) try {
                            for(var _iterator = o.sortKeyRanges[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                var _$i = _$t.sortKey, _$a = _$t.symbolInstanceStart, _$r = _$t.symbolInstanceEnd;
                                e1.push({
                                    sortKey: _$i,
                                    symbolInstanceStart: _$a,
                                    symbolInstanceEnd: _$r,
                                    parameters: v
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        else e1.push({
                            symbolInstanceStart: 0,
                            symbolInstanceEnd: o.symbolInstances.length,
                            parameters: v
                        });
                    }
                },
                {
                    key: "attemptAnchorPlacement",
                    value: function attemptAnchorPlacement(e1, i, a, r, o, s, n, l, c, h, u, d, _, p, m, f, g, v, x, b) {
                        var y = t.aP[e1.textAnchor], w = [
                            e1.textOffset0,
                            e1.textOffset1
                        ], T = _t(y, a, r, w, o), P = this.collisionIndex.placeCollisionBox(i, d, l, c, h, n, s, f, u.predicate, x, T, b);
                        if ((!v || this.collisionIndex.placeCollisionBox(v, d, l, c, h, n, s, g, u.predicate, x, T, b).placeable) && P.placeable) {
                            var _$e;
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[_.crossTileID] && this.prevPlacement.placements[_.crossTileID] && this.prevPlacement.placements[_.crossTileID].text && (_$e = this.prevPlacement.variableOffsets[_.crossTileID].anchor), 0 === _.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                            return this.variableOffsets[_.crossTileID] = {
                                textOffset: w,
                                width: a,
                                height: r,
                                anchor: y,
                                textBoxScale: o,
                                prevAnchor: _$e
                            }, this.markUsedJustification(p, y, _, m), p.allowVerticalPlacement && (this.markUsedOrientation(p, m, _), this.placedOrientations[_.crossTileID] = m), {
                                shift: T,
                                placedGlyphBoxes: P
                            };
                        }
                    }
                },
                {
                    key: "placeLayerBucketPart",
                    value: function placeLayerBucketPart(e1, i, a) {
                        var _this = this;
                        var _e_parameters = e1.parameters, r = _e_parameters.bucket, o = _e_parameters.layout, s = _e_parameters.translationText, n = _e_parameters.translationIcon, l = _e_parameters.unwrappedTileID, _$c = _e_parameters.pitchedLabelPlaneMatrix, h = _e_parameters.textPixelRatio, u = _e_parameters.holdingForFade, d = _e_parameters.collisionBoxArray, _ = _e_parameters.partiallyEvaluatedTextSize, p = _e_parameters.collisionGroup, m = o.get("text-optional"), f = o.get("icon-optional"), g = t.aQ(o, "text-overlap", "text-allow-overlap"), v = "always" === g, x = t.aQ(o, "icon-overlap", "icon-allow-overlap"), b = "always" === x, y = "map" === o.get("text-rotation-alignment"), w = "map" === o.get("text-pitch-alignment"), T = "none" !== o.get("icon-text-fit"), P = "viewport-y" === o.get("symbol-z-order"), C = v && (b || !r.hasIconData() || f), I = b && (v || !r.hasTextData() || m);
                        !r.collisionArrays && d && r.deserializeCollisionBoxes(d);
                        var M = this.retainedQueryData[r.bucketInstanceId].tileID, E = this._getTerrainElevationFunc(M), S = this.transform.getFastPathSimpleProjectionMatrix(M), R = function(e1, d, b) {
                            var P, R;
                            if (i[e1.crossTileID]) return;
                            if (u) return void (_this.placements[e1.crossTileID] = new ht(!1, !1, !1));
                            var z = !1, D = !1, A = !0, L = null, k = {
                                box: null,
                                placeable: !1,
                                offscreen: null,
                                occluded: !1
                            }, F = {
                                placeable: !1
                            }, B = null, O = null, j = null, N = 0, Z = 0, G = 0;
                            d.textFeatureIndex ? N = d.textFeatureIndex : e1.useRuntimeCollisionCircles && (N = e1.featureIndex), d.verticalTextFeatureIndex && (Z = d.verticalTextFeatureIndex);
                            var U = d.textBox;
                            if (U) {
                                var _$i = function(i) {
                                    var _$a = t.az.horizontal;
                                    if (r.allowVerticalPlacement && !i && _this.prevPlacement) {
                                        var _$t = _this.prevPlacement.placedOrientations[e1.crossTileID];
                                        _$t && (_this.placedOrientations[e1.crossTileID] = _$t, _$a = _$t, _this.markUsedOrientation(r, _$a, e1));
                                    }
                                    return _$a;
                                }, o1 = function(i, a) {
                                    if (r.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && d.verticalTextBox) {
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = r.writingModes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var _$e = _step.value;
                                                if (_$e === t.az.vertical ? (k = a(), F = k) : k = i(), k && k.placeable) break;
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    } else k = i();
                                }, _$c1 = e1.textAnchorOffsetStartIndex, u1 = e1.textAnchorOffsetEndIndex;
                                if (u1 === _$c1) {
                                    var _$a = function(t, i) {
                                        var _$a = _this.collisionIndex.placeCollisionBox(t, g, h, M, l, w, y, s, p.predicate, E, void 0, S);
                                        return _$a && _$a.placeable && (_this.markUsedOrientation(r, i, e1), _this.placedOrientations[e1.crossTileID] = i), _$a;
                                    };
                                    o1(function() {
                                        return _$a(U, t.az.horizontal);
                                    }, function() {
                                        var _$i = d.verticalTextBox;
                                        return r.allowVerticalPlacement && e1.numVerticalGlyphVertices > 0 && _$i ? _$a(_$i, t.az.vertical) : {
                                            box: null,
                                            offscreen: null
                                        };
                                    }), _$i(k && k.placeable);
                                } else {
                                    var _1 = t.aP[null === (R = null === (P = _this.prevPlacement) || void 0 === P ? void 0 : P.variableOffsets[e1.crossTileID]) || void 0 === R ? void 0 : R.anchor];
                                    var m1 = function(t, i, o) {
                                        var _$d = t.x2 - t.x1, m = t.y2 - t.y1, f = e1.textBoxScale, v = T && "never" === x ? i : null;
                                        var _$b = null, P = "never" === g ? 1 : 2, C = "never";
                                        _1 && P++;
                                        for(var _$i = 0; _$i < P; _$i++){
                                            for(var _$i1 = _$c1; _$i1 < u1; _$i1++){
                                                var _$a = r.textAnchorOffsets.get(_$i1);
                                                if (_1 && _$a.textAnchor !== _1) continue;
                                                var _$c = _this.attemptAnchorPlacement(_$a, t, _$d, m, f, y, w, h, M, l, p, C, e1, r, o, s, n, v, E);
                                                if (_$c && (_$b = _$c.placedGlyphBoxes, _$b && _$b.placeable)) return z = !0, L = _$c.shift, _$b;
                                            }
                                            _1 ? _1 = null : C = g;
                                        }
                                        return a && !_$b && (_$b = {
                                            box: _this.collisionIndex.placeCollisionBox(U, "always", h, M, l, w, y, s, p.predicate, E, void 0, S).box,
                                            offscreen: !1,
                                            placeable: !1,
                                            occluded: !1
                                        }), _$b;
                                    };
                                    o1(function() {
                                        return m1(U, d.iconBox, t.az.horizontal);
                                    }, function() {
                                        var _$i = d.verticalTextBox;
                                        return r.allowVerticalPlacement && (!k || !k.placeable) && e1.numVerticalGlyphVertices > 0 && _$i ? m1(_$i, d.verticalIconBox, t.az.vertical) : {
                                            box: null,
                                            occluded: !0,
                                            offscreen: null
                                        };
                                    }), k && (z = k.placeable, A = k.offscreen);
                                    var f1 = _$i(k && k.placeable);
                                    if (!z && _this.prevPlacement) {
                                        var _$t = _this.prevPlacement.variableOffsets[e1.crossTileID];
                                        _$t && (_this.variableOffsets[e1.crossTileID] = _$t, _this.markUsedJustification(r, _$t.anchor, e1, f1));
                                    }
                                }
                            }
                            if (B = k, z = B && B.placeable, A = B && B.offscreen, e1.useRuntimeCollisionCircles && e1.centerJustifiedTextSymbolIndex >= 0) {
                                var _$i1 = r.text.placedSymbolArray.get(e1.centerJustifiedTextSymbolIndex), n1 = t.aA(r.textSizeData, _, _$i1), h1 = o.get("text-padding");
                                O = _this.collisionIndex.placeCollisionCircles(g, _$i1, r.lineVertexArray, r.glyphOffsetArray, n1, l, _$c, a, w, p.predicate, e1.collisionCircleDiameter, h1, s, E), O.circles.length && O.collisionDetected && !a && t.w("Collisions detected, but collision boxes are not shown"), z = v || O.circles.length > 0 && !O.collisionDetected, A = A && O.offscreen;
                            }
                            if (d.iconFeatureIndex && (G = d.iconFeatureIndex), d.iconBox) {
                                var _$e = function(e1) {
                                    return _this.collisionIndex.placeCollisionBox(e1, x, h, M, l, w, y, n, p.predicate, E, T && L ? L : void 0, S);
                                };
                                F && F.placeable && d.verticalIconBox ? (j = _$e(d.verticalIconBox), D = j.placeable) : (j = _$e(d.iconBox), D = j.placeable), A = A && j.offscreen;
                            }
                            var V = m || 0 === e1.numHorizontalGlyphVertices && 0 === e1.numVerticalGlyphVertices, q = f || 0 === e1.numIconVertices;
                            V || q ? q ? V || (D = D && z) : z = D && z : D = z = D && z;
                            var W = D && j.placeable;
                            if (z && B.placeable && _this.collisionIndex.insertCollisionBox(B.box, g, o.get("text-ignore-placement"), r.bucketInstanceId, F && F.placeable && Z ? Z : N, p.ID), W && _this.collisionIndex.insertCollisionBox(j.box, x, o.get("icon-ignore-placement"), r.bucketInstanceId, G, p.ID), O && z && _this.collisionIndex.insertCollisionCircles(O.circles, g, o.get("text-ignore-placement"), r.bucketInstanceId, N, p.ID), a && _this.storeCollisionData(r.bucketInstanceId, b, d, B, j, O), 0 === e1.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                            if (0 === r.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                            _this.placements[e1.crossTileID] = new ht((z || C) && !(null == B ? void 0 : B.occluded), (D || I) && !(null == j ? void 0 : j.occluded), A || r.justReloaded), i[e1.crossTileID] = !0;
                        };
                        if (P) {
                            if (0 !== e1.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                            var _$t = r.getSortedSymbolIndexes(-this.transform.bearingInRadians);
                            for(var _$e = _$t.length - 1; _$e >= 0; --_$e){
                                var i1 = _$t[_$e];
                                R(r.symbolInstances.get(i1), r.collisionArrays[i1], i1);
                            }
                        } else for(var _$t1 = e1.symbolInstanceStart; _$t1 < e1.symbolInstanceEnd; _$t1++)R(r.symbolInstances.get(_$t1), r.collisionArrays[_$t1], _$t1);
                        r.justReloaded = !1;
                    }
                },
                {
                    key: "storeCollisionData",
                    value: function storeCollisionData(e1, t, i, a, r, o) {
                        if (i.textBox || i.iconBox) {
                            var _$o, s;
                            this.collisionBoxArrays.has(e1) ? _$o = this.collisionBoxArrays.get(e1) : (_$o = new Map, this.collisionBoxArrays.set(e1, _$o)), _$o.has(t) ? s = _$o.get(t) : (s = {
                                text: null,
                                icon: null
                            }, _$o.set(t, s)), i.textBox && (s.text = a.box), i.iconBox && (s.icon = r.box);
                        }
                        if (o) {
                            var _$t = this.collisionCircleArrays[e1];
                            void 0 === _$t && (_$t = this.collisionCircleArrays[e1] = []);
                            for(var _$e = 0; _$e < o.circles.length; _$e += 4)_$t.push(o.circles[_$e + 0] - st), _$t.push(o.circles[_$e + 1] - st), _$t.push(o.circles[_$e + 2]), _$t.push(o.collisionDetected ? 1 : 0);
                        }
                    }
                },
                {
                    key: "markUsedJustification",
                    value: function markUsedJustification(e1, i, a, r) {
                        var o;
                        o = r === t.az.vertical ? a.verticalPlacedTextSymbolIndex : ({
                            left: a.leftJustifiedTextSymbolIndex,
                            center: a.centerJustifiedTextSymbolIndex,
                            right: a.rightJustifiedTextSymbolIndex
                        })[t.aR(i)];
                        var s = [
                            a.leftJustifiedTextSymbolIndex,
                            a.centerJustifiedTextSymbolIndex,
                            a.rightJustifiedTextSymbolIndex,
                            a.verticalPlacedTextSymbolIndex
                        ];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                _$t >= 0 && (e1.text.placedSymbolArray.get(_$t).crossTileID = o >= 0 && _$t !== o ? 0 : a.crossTileID);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "markUsedOrientation",
                    value: function markUsedOrientation(e1, i, a) {
                        var r = i === t.az.horizontal || i === t.az.horizontalOnly ? i : 0, o = i === t.az.vertical ? i : 0, s = [
                            a.leftJustifiedTextSymbolIndex,
                            a.centerJustifiedTextSymbolIndex,
                            a.rightJustifiedTextSymbolIndex
                        ];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                e1.text.placedSymbolArray.get(_$t).placedOrientation = r;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        a.verticalPlacedTextSymbolIndex && (e1.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).placedOrientation = o);
                    }
                },
                {
                    key: "commit",
                    value: function commit(e1) {
                        this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                        var _$t = this.prevPlacement;
                        var i = !1;
                        this.prevZoomAdjustment = _$t ? _$t.zoomAdjustment(this.transform.zoom) : 0;
                        var a = _$t ? _$t.symbolFadeChange(e1) : 1, r = _$t ? _$t.opacities : {}, o = _$t ? _$t.variableOffsets : {}, s = _$t ? _$t.placedOrientations : {};
                        for(var _$e in this.placements){
                            var _$t1 = this.placements[_$e], o1 = r[_$e];
                            o1 ? (this.opacities[_$e] = new ct(o1, a, _$t1.text, _$t1.icon), i = i || _$t1.text !== o1.text.placed || _$t1.icon !== o1.icon.placed) : (this.opacities[_$e] = new ct(null, a, _$t1.text, _$t1.icon, _$t1.skipFade), i = i || _$t1.text || _$t1.icon);
                        }
                        for(var _$e1 in r){
                            var _$t2 = r[_$e1];
                            if (!this.opacities[_$e1]) {
                                var r1 = new ct(_$t2, a, !1, !1);
                                r1.isHidden() || (this.opacities[_$e1] = r1, i = i || _$t2.text.placed || _$t2.icon.placed);
                            }
                        }
                        for(var _$e2 in o)this.variableOffsets[_$e2] || !this.opacities[_$e2] || this.opacities[_$e2].isHidden() || (this.variableOffsets[_$e2] = o[_$e2]);
                        for(var _$e3 in s)this.placedOrientations[_$e3] || !this.opacities[_$e3] || this.opacities[_$e3].isHidden() || (this.placedOrientations[_$e3] = s[_$e3]);
                        if (_$t && void 0 === _$t.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                        i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = _$t ? _$t.lastPlacementChangeTime : e1);
                    }
                },
                {
                    key: "updateLayerOpacities",
                    value: function updateLayerOpacities(e1, t) {
                        var i = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var a = _step.value;
                                var _$t = a.getBucket(e1);
                                _$t && a.latestFeatureIndex && e1.id === _$t.layerIds[0] && this.updateBucketOpacities(_$t, a.tileID, i, a.collisionBoxArray);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "updateBucketOpacities",
                    value: function updateBucketOpacities(e1, i, a, r) {
                        var _this, _loop = function(i1) {
                            var _$r = e1.symbolInstances.get(i1), o = _$r.numHorizontalGlyphVertices, s = _$r.numVerticalGlyphVertices, l = _$r.crossTileID;
                            var _$c = _this.opacities[l];
                            a[l] ? _$c = n : _$c || (_$c = p, _this.opacities[l] = _$c), a[l] = !0;
                            var g = _$r.numIconVertices > 0, v = _this.placedOrientations[_$r.crossTileID], x = v === t.az.vertical, b = v === t.az.horizontal || v === t.az.horizontalOnly;
                            if (o > 0 || s > 0) {
                                var _$t = Tt(_$c.text);
                                m(e1.text, o, x ? Pt : _$t), m(e1.text, s, b ? Pt : _$t);
                                var i = _$c.text.isHidden();
                                [
                                    _$r.rightJustifiedTextSymbolIndex,
                                    _$r.centerJustifiedTextSymbolIndex,
                                    _$r.leftJustifiedTextSymbolIndex
                                ].forEach(function(t) {
                                    t >= 0 && (e1.text.placedSymbolArray.get(t).hidden = i || x ? 1 : 0);
                                }), _$r.verticalPlacedTextSymbolIndex >= 0 && (e1.text.placedSymbolArray.get(_$r.verticalPlacedTextSymbolIndex).hidden = i || b ? 1 : 0);
                                var _$a = _this.variableOffsets[_$r.crossTileID];
                                _$a && _this.markUsedJustification(e1, _$a.anchor, _$r, v);
                                var n1 = _this.placedOrientations[_$r.crossTileID];
                                n1 && (_this.markUsedJustification(e1, "left", _$r, n1), _this.markUsedOrientation(e1, n1, _$r));
                            }
                            if (g) {
                                var _$t1 = Tt(_$c.icon), i2 = !(_ && _$r.verticalPlacedIconSymbolIndex && x);
                                _$r.placedIconSymbolIndex >= 0 && (m(e1.icon, _$r.numIconVertices, i2 ? _$t1 : Pt), e1.icon.placedSymbolArray.get(_$r.placedIconSymbolIndex).hidden = _$c.icon.isHidden()), _$r.verticalPlacedIconSymbolIndex >= 0 && (m(e1.icon, _$r.numVerticalIconVertices, i2 ? Pt : _$t1), e1.icon.placedSymbolArray.get(_$r.verticalPlacedIconSymbolIndex).hidden = _$c.icon.isHidden());
                            }
                            var y = f && f.has(i1) ? f.get(i1) : {
                                text: null,
                                icon: null
                            };
                            if (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) {
                                var _$a1 = e1.collisionArrays[i1];
                                if (_$a1) {
                                    var i3 = new t.P(0, 0);
                                    if (_$a1.textBox || _$a1.verticalTextBox) {
                                        var _$t2 = !0;
                                        if (h) {
                                            var _$e = _this.variableOffsets[l];
                                            _$e ? (i3 = _t(_$e.anchor, _$e.width, _$e.height, _$e.textOffset, _$e.textBoxScale), u && i3._rotate(d ? -_this.transform.bearingInRadians : _this.transform.bearingInRadians)) : _$t2 = !1;
                                        }
                                        if (_$a1.textBox || _$a1.verticalTextBox) {
                                            var _$r1 = void 0;
                                            _$a1.textBox && (_$r1 = x), _$a1.verticalTextBox && (_$r1 = b), mt(e1.textCollisionBox.collisionVertexArray, _$c.text.placed, !_$t2 || _$r1, y.text, i3.x, i3.y);
                                        }
                                    }
                                    if (_$a1.iconBox || _$a1.verticalIconBox) {
                                        var _$t3 = Boolean(!b && _$a1.verticalIconBox);
                                        var _$r2 = void 0;
                                        _$a1.iconBox && (_$r2 = _$t3), _$a1.verticalIconBox && (_$r2 = !_$t3), mt(e1.iconCollisionBox.collisionVertexArray, _$c.icon.placed, _$r2, y.icon, _ ? i3.x : 0, _ ? i3.y : 0);
                                    }
                                }
                            }
                        };
                        e1.hasTextData() && (e1.text.opacityVertexArray.clear(), e1.text.hasVisibleVertices = !1), e1.hasIconData() && (e1.icon.opacityVertexArray.clear(), e1.icon.hasVisibleVertices = !1), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexArray.clear(), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexArray.clear();
                        var o = e1.layers[0], s = o.layout, n = new ct(null, 0, !1, !1, !0), l = s.get("text-allow-overlap"), _$c = s.get("icon-allow-overlap"), h = o._unevaluatedLayout.hasValue("text-variable-anchor") || o._unevaluatedLayout.hasValue("text-variable-anchor-offset"), u = "map" === s.get("text-rotation-alignment"), d = "map" === s.get("text-pitch-alignment"), _ = "none" !== s.get("icon-text-fit"), p = new ct(null, 0, l && (_$c || !e1.hasIconData() || s.get("icon-optional")), _$c && (l || !e1.hasTextData() || s.get("text-optional")), !0);
                        !e1.collisionArrays && r && (e1.hasIconCollisionBoxData() || e1.hasTextCollisionBoxData()) && e1.deserializeCollisionBoxes(r);
                        var m = function(e1, t, i) {
                            for(var _$a = 0; _$a < t / 4; _$a++)e1.opacityVertexArray.emplaceBack(i);
                            e1.hasVisibleVertices = e1.hasVisibleVertices || i !== Pt;
                        }, f = this.collisionBoxArrays.get(e1.bucketInstanceId);
                        for(var i1 = 0; i1 < e1.symbolInstances.length; i1++)_this = this, _loop(i1);
                        if (e1.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[e1.bucketInstanceId] && (this.retainedQueryData[e1.bucketInstanceId].featureSortOrder = e1.featureSortOrder), e1.hasTextData() && e1.text.opacityVertexBuffer && e1.text.opacityVertexBuffer.updateData(e1.text.opacityVertexArray), e1.hasIconData() && e1.icon.opacityVertexBuffer && e1.icon.opacityVertexBuffer.updateData(e1.icon.opacityVertexArray), e1.hasIconCollisionBoxData() && e1.iconCollisionBox.collisionVertexBuffer && e1.iconCollisionBox.collisionVertexBuffer.updateData(e1.iconCollisionBox.collisionVertexArray), e1.hasTextCollisionBoxData() && e1.textCollisionBox.collisionVertexBuffer && e1.textCollisionBox.collisionVertexBuffer.updateData(e1.textCollisionBox.collisionVertexArray), e1.text.opacityVertexArray.length !== e1.text.layoutVertexArray.length / 4) throw new Error("bucket.text.opacityVertexArray.length (= ".concat(e1.text.opacityVertexArray.length, ") !== bucket.text.layoutVertexArray.length (= ").concat(e1.text.layoutVertexArray.length, ") / 4"));
                        if (e1.icon.opacityVertexArray.length !== e1.icon.layoutVertexArray.length / 4) throw new Error("bucket.icon.opacityVertexArray.length (= ".concat(e1.icon.opacityVertexArray.length, ") !== bucket.icon.layoutVertexArray.length (= ").concat(e1.icon.layoutVertexArray.length, ") / 4"));
                        e1.bucketInstanceId in this.collisionCircleArrays && (e1.collisionCircleArray = this.collisionCircleArrays[e1.bucketInstanceId], delete this.collisionCircleArrays[e1.bucketInstanceId]);
                    }
                },
                {
                    key: "symbolFadeChange",
                    value: function symbolFadeChange(e1) {
                        return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
                    }
                },
                {
                    key: "zoomAdjustment",
                    value: function zoomAdjustment(e1) {
                        return Math.max(0, (this.transform.zoom - e1) / 1.5);
                    }
                },
                {
                    key: "hasTransitions",
                    value: function hasTransitions(e1) {
                        return this.stale || e1 - this.lastPlacementChangeTime < this.fadeDuration;
                    }
                },
                {
                    key: "stillRecent",
                    value: function stillRecent(e1, t) {
                        var i = this.zoomAtLastRecencyCheck === t ? 1 - this.zoomAdjustment(t) : 1;
                        return this.zoomAtLastRecencyCheck = t, this.commitTime + this.fadeDuration * i > e1;
                    }
                },
                {
                    key: "setStale",
                    value: function setStale() {
                        this.stale = !0;
                    }
                }
            ]);
            return pt;
        }();
        function mt(e1, t, i, a, r, o) {
            a && 0 !== a.length || (a = [
                0,
                0,
                0,
                0
            ]);
            var s = a[0] - st, n = a[1] - st, l = a[2] - st, _$c = a[3] - st;
            e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, o || 0, s, n), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, o || 0, l, n), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, o || 0, l, _$c), e1.emplaceBack(t ? 1 : 0, i ? 1 : 0, r || 0, o || 0, s, _$c);
        }
        var ft = Math.pow(2, 25), gt = Math.pow(2, 24), vt = Math.pow(2, 17), xt = Math.pow(2, 16), bt = Math.pow(2, 9), yt = Math.pow(2, 8), wt = Math.pow(2, 1);
        function Tt(e1) {
            if (0 === e1.opacity && !e1.placed) return 0;
            if (1 === e1.opacity && e1.placed) return 4294967295;
            var _$t = e1.placed ? 1 : 0, i = Math.floor(127 * e1.opacity);
            return i * ft + _$t * gt + i * vt + _$t * xt + i * bt + _$t * yt + i * wt + _$t;
        }
        var Pt = 0;
        var Ct = /*#__PURE__*/ function() {
            function Ct(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ct);
                this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && !e1.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ct, [
                {
                    key: "continuePlacement",
                    value: function continuePlacement(e1, t, i, a, r) {
                        var o = this._bucketParts;
                        for(; this._currentTileIndex < e1.length;)if (t.getBucketParts(o, a, e1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, r()) return !0;
                        for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, o.sort(function(e1, t) {
                            return e1.sortKey - t.sortKey;
                        })); this._currentPartIndex < o.length;)if (t.placeLayerBucketPart(o[this._currentPartIndex], this._seenCrossTileIDs, i), this._currentPartIndex++, r()) return !0;
                        return !1;
                    }
                }
            ]);
            return Ct;
        }();
        var It = /*#__PURE__*/ function() {
            function It(e1, t, i, a, r, o, s, n) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, It);
                this.placement = new pt(e1, t, o, s, n), this._currentPlacementIndex = i.length - 1, this._forceFullPlacement = a, this._showCollisionBoxes = r, this._done = !1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(It, [
                {
                    key: "isDone",
                    value: function isDone() {
                        return this._done;
                    }
                },
                {
                    key: "continuePlacement",
                    value: function continuePlacement(e1, t, i) {
                        var _this = this;
                        var a = c(), r = function() {
                            return !_this._forceFullPlacement && c() - a > 2;
                        };
                        for(; this._currentPlacementIndex >= 0;){
                            var a1 = t[e1[this._currentPlacementIndex]], o = this.placement.collisionIndex.transform.zoom;
                            if ("symbol" === a1.type && (!a1.minzoom || a1.minzoom <= o) && (!a1.maxzoom || a1.maxzoom > o)) {
                                if (this._inProgressLayer || (this._inProgressLayer = new Ct(a1)), this._inProgressLayer.continuePlacement(i[a1.source], this.placement, this._showCollisionBoxes, a1, r)) return;
                                delete this._inProgressLayer;
                            }
                            this._currentPlacementIndex--;
                        }
                        this._done = !0;
                    }
                },
                {
                    key: "commit",
                    value: function commit(e1) {
                        return this.placement.commit(e1), this.placement;
                    }
                }
            ]);
            return It;
        }();
        var Mt = 512 / t.a5 / 2;
        var Et = /*#__PURE__*/ function() {
            function Et(e1, i, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Et);
                this.tileID = e1, this.bucketInstanceId = a, this._symbolsByKey = {};
                var r = new Map;
                for(var _$e = 0; _$e < i.length; _$e++){
                    var _$t = i.get(_$e), _$a = _$t.key, o = r.get(_$a);
                    o ? o.push(_$t) : r.set(_$a, [
                        _$t
                    ]);
                }
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), _$e1 = _step_value[0], _$i = _step_value[1];
                        var _$a1 = {
                            positions: _$i.map(function(e1) {
                                return {
                                    x: Math.floor(e1.anchorX * Mt),
                                    y: Math.floor(e1.anchorY * Mt)
                                };
                            }),
                            crossTileIDs: _$i.map(function(e1) {
                                return e1.crossTileID;
                            })
                        };
                        if (_$a1.positions.length > 128) {
                            var _$e2 = new t.aT(_$a1.positions.length, 16, Uint16Array);
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = _$a1.positions[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var _step_value1 = _step1.value, _$t1 = _step_value1.x, _$i1 = _step_value1.y;
                                    _$e2.add(_$t1, _$i1);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            _$e2.finish(), delete _$a1.positions, _$a1.index = _$e2;
                        }
                        this._symbolsByKey[_$e1] = _$a1;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Et, [
                {
                    key: "getScaledCoordinates",
                    value: function getScaledCoordinates(e1, i) {
                        var _this_tileID_canonical = this.tileID.canonical, a = _this_tileID_canonical.x, r = _this_tileID_canonical.y, o = _this_tileID_canonical.z, _i_canonical = i.canonical, s = _i_canonical.x, n = _i_canonical.y, l = _i_canonical.z, _$c = Mt / Math.pow(2, l - o), h = (n * t.a5 + e1.anchorY) * _$c, u = r * t.a5 * Mt;
                        return {
                            x: Math.floor((s * t.a5 + e1.anchorX) * _$c - a * t.a5 * Mt),
                            y: Math.floor(h - u)
                        };
                    }
                },
                {
                    key: "findMatches",
                    value: function findMatches(e1, t, i) {
                        var a = this.tileID.canonical.z < t.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - t.canonical.z);
                        for(var r = 0; r < e1.length; r++){
                            var o = e1.get(r);
                            if (o.crossTileID) continue;
                            var s = this._symbolsByKey[o.key];
                            if (!s) continue;
                            var n = this.getScaledCoordinates(o, t);
                            if (s.index) {
                                var _$e = s.index.range(n.x - a, n.y - a, n.x + a, n.y + a).sort();
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = _$e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$t = _step.value;
                                        var _$e1 = s.crossTileIDs[_$t];
                                        if (!i[_$e1]) {
                                            i[_$e1] = !0, o.crossTileID = _$e1;
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            } else if (s.positions) for(var _$e2 = 0; _$e2 < s.positions.length; _$e2++){
                                var _$t1 = s.positions[_$e2], r1 = s.crossTileIDs[_$e2];
                                if (Math.abs(_$t1.x - n.x) <= a && Math.abs(_$t1.y - n.y) <= a && !i[r1]) {
                                    i[r1] = !0, o.crossTileID = r1;
                                    break;
                                }
                            }
                        }
                    }
                },
                {
                    key: "getCrossTileIDsLists",
                    value: function getCrossTileIDsLists() {
                        return Object.values(this._symbolsByKey).map(function(param) {
                            var _$e = param.crossTileIDs;
                            return _$e;
                        });
                    }
                }
            ]);
            return Et;
        }();
        var St = /*#__PURE__*/ function() {
            function St() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, St);
                this.maxCrossTileID = 0;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(St, [
                {
                    key: "generate",
                    value: function generate() {
                        return ++this.maxCrossTileID;
                    }
                }
            ]);
            return St;
        }();
        var Rt = /*#__PURE__*/ function() {
            function Rt() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Rt);
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Rt, [
                {
                    key: "handleWrapJump",
                    value: function handleWrapJump(e1) {
                        var _$t = Math.round((e1 - this.lng) / 360);
                        if (0 !== _$t) for(var _$e in this.indexes){
                            var i = this.indexes[_$e], a = {};
                            for(var _$e1 in i){
                                var r = i[_$e1];
                                r.tileID = r.tileID.unwrapTo(r.tileID.wrap + _$t), a[r.tileID.key] = r;
                            }
                            this.indexes[_$e] = a;
                        }
                        this.lng = e1;
                    }
                },
                {
                    key: "addBucket",
                    value: function addBucket(e1, t, i) {
                        if (this.indexes[e1.overscaledZ] && this.indexes[e1.overscaledZ][e1.key]) {
                            if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t.bucketInstanceId) return !1;
                            this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
                        }
                        for(var _$e = 0; _$e < t.symbolInstances.length; _$e++)t.symbolInstances.get(_$e).crossTileID = 0;
                        this.usedCrossTileIDs[e1.overscaledZ] || (this.usedCrossTileIDs[e1.overscaledZ] = {});
                        var a = this.usedCrossTileIDs[e1.overscaledZ];
                        for(var _$i in this.indexes){
                            var r = this.indexes[_$i];
                            if (Number(_$i) > e1.overscaledZ) for(var _$i1 in r){
                                var o = r[_$i1];
                                o.tileID.isChildOf(e1) && o.findMatches(t.symbolInstances, e1, a);
                            }
                            else {
                                var o1 = r[e1.scaledTo(Number(_$i)).key];
                                o1 && o1.findMatches(t.symbolInstances, e1, a);
                            }
                        }
                        for(var _$e1 = 0; _$e1 < t.symbolInstances.length; _$e1++){
                            var r1 = t.symbolInstances.get(_$e1);
                            r1.crossTileID || (r1.crossTileID = i.generate(), a[r1.crossTileID] = !0);
                        }
                        return void 0 === this.indexes[e1.overscaledZ] && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new Et(e1, t.symbolInstances, t.bucketInstanceId), !0;
                    }
                },
                {
                    key: "removeBucketCrossTileIDs",
                    value: function removeBucketCrossTileIDs(e1, t) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator = t.getCrossTileIDsLists()[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                                var i = _step.value;
                                try {
                                    for(var _iterator1 = i[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                        var _$t = _step1.value;
                                        delete this.usedCrossTileIDs[e1][_$t];
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                    }
                },
                {
                    key: "removeStaleBuckets",
                    value: function removeStaleBuckets(e1) {
                        var _$t = !1;
                        for(var i in this.indexes){
                            var a = this.indexes[i];
                            for(var r in a)e1[a[r].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, a[r]), delete a[r], _$t = !0);
                        }
                        return _$t;
                    }
                }
            ]);
            return Rt;
        }();
        var zt = /*#__PURE__*/ function() {
            function zt() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, zt);
                this.layerIndexes = {}, this.crossTileIDs = new St, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(zt, [
                {
                    key: "addLayer",
                    value: function addLayer(e1, t, i) {
                        var a = this.layerIndexes[e1.id];
                        void 0 === a && (a = this.layerIndexes[e1.id] = new Rt);
                        var r = !1;
                        var o = {};
                        a.handleWrapJump(i);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$i = _step.value;
                                var _$t = _$i.getBucket(e1);
                                _$t && e1.id === _$t.layerIds[0] && (_$t.bucketInstanceId || (_$t.bucketInstanceId = ++this.maxBucketInstanceId), a.addBucket(_$i.tileID, _$t, this.crossTileIDs) && (r = !0), o[_$t.bucketInstanceId] = !0);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return a.removeStaleBuckets(o) && (r = !0), r;
                    }
                },
                {
                    key: "pruneUnusedLayers",
                    value: function pruneUnusedLayers(e1) {
                        var _$t = {};
                        e1.forEach(function(e1) {
                            _$t[e1] = !0;
                        });
                        for(var _$e in this.layerIndexes)_$t[_$e] || delete this.layerIndexes[_$e];
                    }
                }
            ]);
            return zt;
        }();
        var Dt = "void main() {fragColor=vec4(1.0);}";
        var At = {
            prelude: Lt("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nout highp vec4 fragColor;", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c\n);}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\n#ifdef GLOBE\nif ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}\n#endif\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}const float PI=3.141592653589793;uniform mat4 u_projection_matrix;"),
            projectionMercator: Lt("", "float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}"),
            projectionGlobe: Lt("", "#define GLOBE_RADIUS 6371008.8\nuniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos\n);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float spherical_y=2.0*atan(exp(PI-(mercator_pos_y*PI*2.0)))-PI*0.5;return cos(spherical_y);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY); \nif (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;vec2 spherical;spherical.x=mercator_pos.x*PI*2.0+PI;spherical.y=2.0*atan(exp(PI-(mercator_pos.y*PI*2.0)))-PI*0.5;float len=cos(spherical.y);vec3 pos=vec3(sin(spherical.x)*len,sin(spherical.y),cos(spherical.x)*len\n);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}"),
            background: Lt("uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
            backgroundPattern: Lt("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
            circle: Lt("in vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;uniform vec2 u_translate;in vec2 a_pos;out vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 pos_raw=a_pos+32768.0;vec2 extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);vec2 circle_center=floor(pos_raw/8.0)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {\n#ifdef GLOBE\nvec3 center_vector=projectToSphere(circle_center);\n#endif\nfloat angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {\n#ifdef GLOBE\nvec4 projected_center=interpolateProjection(circle_center,center_vector,ele);\n#else\nvec4 projected_center=projectTileWithElevation(circle_center,ele);\n#endif\ncorner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}\n#ifdef GLOBE\nvec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);\n#else\ngl_Position=projectTileWithElevation(corner_position,ele);\n#endif\n} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
            clippingMask: Lt(Dt, "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
            heatmap: Lt("uniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;in vec2 a_pos;out vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 pos_raw=a_pos+32768.0;vec2 unscaled_extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=floor(pos_raw/8.0);\n#ifdef GLOBE\nvec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);\n#else\ngl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));\n#endif\n}"),
            heatmapTexture: Lt("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
            collisionBox: Lt("in float v_placed;in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}", "in vec2 a_anchor_pos;in vec2 a_placed;in vec2 a_box_real;uniform vec2 u_pixel_extrude_scale;out float v_placed;out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
            collisionCircle: Lt("in float v_radius;in vec2 v_extrude;in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}", "in vec2 a_pos;in float a_radius;in vec2 a_flags;uniform vec2 u_viewport_size;out float v_radius;out vec2 v_extrude;out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            colorRelief: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;uniform vec4 u_unpack;uniform sampler2D u_elevation_stops;uniform sampler2D u_color_stops;uniform int u_color_ramp_size;uniform float u_opacity;in vec2 v_pos;float getElevation(vec2 coord) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}float getElevationStop(int stop) {float x=(float(stop)+0.5)/float(u_color_ramp_size);vec4 data=texture(u_elevation_stops,vec2(x,0))*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {float el=getElevation(v_pos);int r=(u_color_ramp_size-1);int l=0;float el_l=getElevationStop(l);float el_r=getElevationStop(r);while(r-l > 1){int m=(r+l)/2;float el_m=getElevationStop(m);if(el < el_m){r=m;el_r=el_m;}else\n{l=m;el_l=el_m;}}float x=(float(l)+(el-el_l)/(el_r-el_l)+0.5)/float(u_color_ramp_size);fragColor=u_opacity*texture(u_color_stops,vec2(x,0));\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_dimension;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_pos/8192.0)*scale+epsilon;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
            debug: Lt("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}", "in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}"),
            depth: Lt(Dt, "in vec2 a_pos;void main() {\n#ifdef GLOBE\ngl_Position=projectTileFor3D(a_pos,0.0);\n#else\ngl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);\n#endif\n}"),
            fill: Lt("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nfragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_fill_translate;in vec2 a_pos;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);}"),
            fillOutline: Lt("in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
            fillOutlinePattern: Lt("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
            fillPattern: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
            fillExtrusion: Lt("in vec4 v_color;void main() {fragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\nout vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nfloat colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);\n#ifdef GLOBE\nmat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);\n#endif\ndirectional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
            fillExtrusionPattern: Lt("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\n#ifdef GLOBE\nout vec3 v_sphere_pos;\n#endif\nout vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nvec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
            hillshadePrepare: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {vec2 epsilon=1.0/u_dimension;float tileSize=u_dimension.x-2.0;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))*tileSize/pow(2.0,exaggeration+(28.2562-u_zoom));fragColor=clamp(vec4(deriv.x/8.0+0.5,deriv.y/8.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
            hillshade: Lt("uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform float u_exaggeration;uniform vec4 u_accent;uniform int u_method;uniform float u_altitudes[NUM_ILLUMINATION_SOURCES];uniform float u_azimuths[NUM_ILLUMINATION_SOURCES];uniform vec4 u_shadows[NUM_ILLUMINATION_SOURCES];uniform vec4 u_highlights[NUM_ILLUMINATION_SOURCES];\n#define PI 3.141592653589793\n#define STANDARD 0\n#define COMBINED 1\n#define IGOR 2\n#define MULTIDIRECTIONAL 3\n#define BASIC 4\nfloat get_aspect(vec2 deriv){return deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);}void igor_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float aspect=get_aspect(deriv);float azimuth=u_azimuths[0]+PI;float slope_stength=atan(length(deriv))*2.0/PI;float aspect_strength=1.0-abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);float shadow_strength=slope_stength*aspect_strength;float highlight_strength=slope_stength*(1.0-aspect_strength);fragColor=u_shadows[0]*shadow_strength+u_highlights[0]*highlight_strength;}void standard_hillshade(vec2 deriv){float azimuth=u_azimuths[0]+PI;float slope=atan(0.625*length(deriv));float aspect=get_aspect(deriv);float intensity=u_exaggeration;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadows[0],u_highlights[0],shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;}void basic_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor=u_highlights[0]*(2.0*shade-1.0);}else\n{fragColor=u_shadows[0]*(1.0-2.0*shade);}}void multidirectional_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;fragColor=vec4(0,0,0,0);for(int i=0; i < NUM_ILLUMINATION_SOURCES; i++){float cos_alt=cos(u_altitudes[i]);float sin_alt=sin(u_altitudes[i]);float cos_az=-cos(u_azimuths[i]);float sin_az=-sin(u_azimuths[i]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor+=u_highlights[i]*(2.0*shade-1.0)/float(NUM_ILLUMINATION_SOURCES);}else\n{fragColor+=u_shadows[i]*(1.0-2.0*shade)/float(NUM_ILLUMINATION_SOURCES);}}}void combined_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=acos((sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv)));cang=clamp(cang,0.0,PI/2.0);float shade=cang*atan(length(deriv))*4.0/PI/PI;float highlight=(PI/2.0-cang)*atan(length(deriv))*4.0/PI/PI;fragColor=u_shadows[0]*shade+u_highlights[0]*highlight;}void main() {vec4 pixel=texture(u_image,v_pos);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));vec2 deriv=((pixel.rg*8.0)-4.0)/scaleFactor;if (u_method==BASIC) {basic_hillshade(deriv);} else if (u_method==COMBINED) {combined_hillshade(deriv);} else if (u_method==IGOR) {igor_hillshade(deriv);} else if (u_method==MULTIDIRECTIONAL) {multidirectional_hillshade(deriv);} else if (u_method==STANDARD) {standard_hillshade(deriv);} else {standard_hillshade(deriv);}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
            line: Lt("uniform lowp float u_device_pixel_ratio;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            lineGradient: Lt("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
            linePattern: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
            lineSDF: Lt("uniform lowp float u_device_pixel_ratio;uniform lowp float u_lineatlas_width;uniform sampler2D u_image;uniform float u_mix;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0/u_device_pixel_ratio)/min(dasharray_from.w,dasharray_to.w);alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"),
            lineGradientSDF: Lt("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform sampler2D u_image_dash;uniform float u_mix;uniform lowp float u_lineatlas_width;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);float sdfdist_a=texture(u_image_dash,v_tex_a).a;float sdfdist_b=texture(u_image_dash,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0)/min(dasharray_from.w,dasharray_to.w);float dash_alpha=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*dash_alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;out vec2 v_tex_a;out vec2 v_tex_b;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;float texel_height=1.0/u_image_height;float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"),
            raster: Lt("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec2 v_pos0;in vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0);vec4 color1=texture(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;in vec2 a_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 position=mix(mix(u_coords_top.xy,u_coords_top.zw,fractionalPos.x),mix(u_coords_bottom.xy,u_coords_bottom.zw,fractionalPos.x),fractionalPos.y);gl_Position=projectTile(position,position);v_pos0=((fractionalPos-0.5)/u_buffer_scale)+0.5;\n#ifdef GLOBE\nif (a_pos.y <-32767.5) {v_pos0.y=0.0;}if (a_pos.y > 32766.5) {v_pos0.y=1.0;}\n#endif\nv_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
            symbolIcon: Lt("uniform sampler2D u_texture;in vec2 v_tex;in float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;fragColor=texture(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_tex;out float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
            symbolSDF: Lt("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
            symbolTextAndIcon: Lt("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;fragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
            terrain: Lt("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}", "in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,get_elevation(a_pos3d.xy)-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"),
            terrainDepth: Lt("in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}", "in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}"),
            terrainCoords: Lt("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;in vec2 v_texture_pos;void main() {vec4 rgba=texture(u_texture,v_texture_pos);fragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", "in vec3 a_pos3d;uniform float u_ele_delta;out vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);}"),
            projectionErrorMeasurement: Lt("in vec4 v_output_error_encoded;void main() {fragColor=v_output_error_encoded;}", "in vec2 a_pos;uniform highp float u_input;uniform highp float u_output_expected;out vec4 v_output_error_encoded;void main() {float real_output=2.0*atan(exp(PI-(u_input*PI*2.0)))-PI*0.5;float error=real_output-u_output_expected;float abs_error=abs(error)*128.0;v_output_error_encoded.x=min(floor(abs_error*256.0),255.0)/255.0;abs_error-=v_output_error_encoded.x;v_output_error_encoded.y=min(floor(abs_error*65536.0),255.0)/255.0;abs_error-=v_output_error_encoded.x/255.0;v_output_error_encoded.z=min(floor(abs_error*16777216.0),255.0)/255.0;v_output_error_encoded.w=error >=0.0 ? 1.0 : 0.0;gl_Position=vec4(a_pos,0.0,1.0);}"),
            atmosphere: Lt("in vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758\n);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}", "in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}"),
            sky: Lt("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor=mix(fragColor,vec4(vec3(0.0),0.0),u_sky_blend);}", "in vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}")
        };
        function Lt(e1, t) {
            var i = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, a = t.match(/in ([\w]+) ([\w]+)/g), r = e1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), o = t.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), s = o ? o.concat(r) : r, n = {};
            return {
                fragmentSource: e1 = e1.replace(i, function(e1, t, i, a, r) {
                    return n[r] = !0, "define" === t ? "\n#ifndef HAS_UNIFORM_u_".concat(r, "\nin ").concat(i, " ").concat(a, " ").concat(r, ";\n#else\nuniform ").concat(i, " ").concat(a, " u_").concat(r, ";\n#endif\n") : "\n#ifdef HAS_UNIFORM_u_".concat(r, "\n    ").concat(i, " ").concat(a, " ").concat(r, " = u_").concat(r, ";\n#endif\n");
                }),
                vertexSource: t = t.replace(i, function(e1, t, i, a, r) {
                    var o = "float" === a ? "vec2" : "vec4", s = r.match(/color/) ? "color" : o;
                    return n[r] ? "define" === t ? "\n#ifndef HAS_UNIFORM_u_".concat(r, "\nuniform lowp float u_").concat(r, "_t;\nin ").concat(i, " ").concat(o, " a_").concat(r, ";\nout ").concat(i, " ").concat(a, " ").concat(r, ";\n#else\nuniform ").concat(i, " ").concat(a, " u_").concat(r, ";\n#endif\n") : "vec4" === s ? "\n#ifndef HAS_UNIFORM_u_".concat(r, "\n    ").concat(r, " = a_").concat(r, ";\n#else\n    ").concat(i, " ").concat(a, " ").concat(r, " = u_").concat(r, ";\n#endif\n") : "\n#ifndef HAS_UNIFORM_u_".concat(r, "\n    ").concat(r, " = unpack_mix_").concat(s, "(a_").concat(r, ", u_").concat(r, "_t);\n#else\n    ").concat(i, " ").concat(a, " ").concat(r, " = u_").concat(r, ";\n#endif\n") : "define" === t ? "\n#ifndef HAS_UNIFORM_u_".concat(r, "\nuniform lowp float u_").concat(r, "_t;\nin ").concat(i, " ").concat(o, " a_").concat(r, ";\n#else\nuniform ").concat(i, " ").concat(a, " u_").concat(r, ";\n#endif\n") : "vec4" === s ? "\n#ifndef HAS_UNIFORM_u_".concat(r, "\n    ").concat(i, " ").concat(a, " ").concat(r, " = a_").concat(r, ";\n#else\n    ").concat(i, " ").concat(a, " ").concat(r, " = u_").concat(r, ";\n#endif\n") : "\n#ifndef HAS_UNIFORM_u_".concat(r, "\n    ").concat(i, " ").concat(a, " ").concat(r, " = unpack_mix_").concat(s, "(a_").concat(r, ", u_").concat(r, "_t);\n#else\n    ").concat(i, " ").concat(a, " ").concat(r, " = u_").concat(r, ";\n#endif\n");
                }),
                staticAttributes: a,
                staticUniforms: s
            };
        }
        var kt = /*#__PURE__*/ function() {
            function kt(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, kt);
                this.vertexBuffer = e1, this.indexBuffer = t, this.segments = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(kt, [
                {
                    key: "destroy",
                    value: function destroy() {
                        this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
                    }
                }
            ]);
            return kt;
        }();
        var Ft = t.aU([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        var Bt = "#define PROJECTION_MERCATOR", Ot = "mercator";
        var jt = /*#__PURE__*/ function() {
            function jt() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, jt);
                this._cachedMesh = null;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(jt, [
                {
                    key: "name",
                    get: function get() {
                        return "mercator";
                    }
                },
                {
                    key: "useSubdivision",
                    get: function get() {
                        return !1;
                    }
                },
                {
                    key: "shaderVariantName",
                    get: function get() {
                        return Ot;
                    }
                },
                {
                    key: "shaderDefine",
                    get: function get() {
                        return Bt;
                    }
                },
                {
                    key: "shaderPreludeCode",
                    get: function get() {
                        return At.projectionMercator;
                    }
                },
                {
                    key: "vertexShaderPreludeCode",
                    get: function get() {
                        return At.projectionMercator.vertexSource;
                    }
                },
                {
                    key: "subdivisionGranularity",
                    get: function get() {
                        return t.aV.noSubdivision;
                    }
                },
                {
                    key: "useGlobeControls",
                    get: function get() {
                        return !1;
                    }
                },
                {
                    key: "transitionState",
                    get: function get() {
                        return 0;
                    }
                },
                {
                    key: "latitudeErrorCorrectionRadians",
                    get: function get() {
                        return 0;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {}
                },
                {
                    key: "updateGPUdependent",
                    value: function updateGPUdependent(e1) {}
                },
                {
                    key: "getMeshFromTileID",
                    value: function getMeshFromTileID(e1, i, a, r, o) {
                        if (this._cachedMesh) return this._cachedMesh;
                        var s = new t.aW;
                        s.emplaceBack(0, 0), s.emplaceBack(t.a5, 0), s.emplaceBack(0, t.a5), s.emplaceBack(t.a5, t.a5);
                        var n = e1.createVertexBuffer(s, Ft.members), l = t.aX.simpleSegment(0, 0, 4, 2), _$c = new t.aY;
                        _$c.emplaceBack(1, 0, 2), _$c.emplaceBack(1, 2, 3);
                        var h = e1.createIndexBuffer(_$c);
                        return this._cachedMesh = new kt(n, h, l), this._cachedMesh;
                    }
                },
                {
                    key: "recalculate",
                    value: function recalculate() {}
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return !1;
                    }
                },
                {
                    key: "setErrorQueryLatitudeDegrees",
                    value: function setErrorQueryLatitudeDegrees(e1) {}
                }
            ]);
            return jt;
        }();
        var Nt = /*#__PURE__*/ function() {
            function Nt() {
                var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, _$t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Nt);
                if (isNaN(_$e) || _$e < 0 || isNaN(_$t) || _$t < 0 || isNaN(i) || i < 0 || isNaN(a) || a < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = _$e, this.bottom = _$t, this.left = i, this.right = a;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Nt, [
                {
                    key: "interpolate",
                    value: function interpolate(e1, i, a) {
                        return null != i.top && null != e1.top && (this.top = t.G.number(e1.top, i.top, a)), null != i.bottom && null != e1.bottom && (this.bottom = t.G.number(e1.bottom, i.bottom, a)), null != i.left && null != e1.left && (this.left = t.G.number(e1.left, i.left, a)), null != i.right && null != e1.right && (this.right = t.G.number(e1.right, i.right, a)), this;
                    }
                },
                {
                    key: "getCenter",
                    value: function getCenter(e1, i) {
                        var a = t.an((this.left + e1 - this.right) / 2, 0, e1), r = t.an((this.top + i - this.bottom) / 2, 0, i);
                        return new t.P(a, r);
                    }
                },
                {
                    key: "equals",
                    value: function equals(e1) {
                        return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
                    }
                },
                {
                    key: "clone",
                    value: function clone() {
                        return new Nt(this.top, this.bottom, this.left, this.right);
                    }
                },
                {
                    key: "toJSON",
                    value: function toJSON() {
                        return {
                            top: this.top,
                            bottom: this.bottom,
                            left: this.left,
                            right: this.right
                        };
                    }
                }
            ]);
            return Nt;
        }();
        function Zt(e1, t) {
            if (!e1.renderWorldCopies || e1.lngRange) return;
            var i = t.lng - e1.center.lng;
            t.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
        }
        function Gt(e1) {
            return Math.max(0, Math.floor(e1));
        }
        var Ut = /*#__PURE__*/ function() {
            function Ut(e1, i) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ut);
                var a;
                this.applyConstrain = function(e1, t) {
                    return null !== _this._constrainOverride ? _this._constrainOverride(e1, t) : _this._callbacks.defaultConstrain(e1, t);
                }, this._callbacks = e1, this._tileSize = 512, this._renderWorldCopies = void 0 === (null == i ? void 0 : i.renderWorldCopies) || !!(null == i ? void 0 : i.renderWorldCopies), this._minZoom = (null == i ? void 0 : i.minZoom) || 0, this._maxZoom = (null == i ? void 0 : i.maxZoom) || 22, this._minPitch = null == (null == i ? void 0 : i.minPitch) ? 0 : null == i ? void 0 : i.minPitch, this._maxPitch = null == (null == i ? void 0 : i.maxPitch) ? 60 : null == i ? void 0 : i.maxPitch, this._constrainOverride = null !== (a = null == i ? void 0 : i.constrainOverride) && void 0 !== a ? a : null, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new t.V(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = Gt(this._zoom), this._scale = t.aq(this._zoom), this._bearingInRadians = 0, this._fovInRadians = .6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = !0, this._edgeInsets = new Nt, this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = !0;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ut, [
                {
                    key: "apply",
                    value: function apply(e1, i, a) {
                        this._constrainOverride = e1.constrainOverride, this._latRange = e1.latRange, this._lngRange = e1.lngRange, this._width = e1.width, this._height = e1.height, this._center = e1.center, this._elevation = e1.elevation, this._minElevationForCurrentTile = e1.minElevationForCurrentTile, this._zoom = e1.zoom, this._tileZoom = Gt(this._zoom), this._scale = t.aq(this._zoom), this._bearingInRadians = e1.bearingInRadians, this._fovInRadians = e1.fovInRadians, this._pitchInRadians = e1.pitchInRadians, this._rollInRadians = e1.rollInRadians, this._unmodified = e1.unmodified, this._edgeInsets = new Nt(e1.padding.top, e1.padding.bottom, e1.padding.left, e1.padding.right), this._minZoom = e1.minZoom, this._maxZoom = e1.maxZoom, this._minPitch = e1.minPitch, this._maxPitch = e1.maxPitch, this._renderWorldCopies = e1.renderWorldCopies, this._cameraToCenterDistance = e1.cameraToCenterDistance, this._nearZ = e1.nearZ, this._farZ = e1.farZ, this._autoCalculateNearFarZ = !a && e1.autoCalculateNearFarZ, i && this.constrainInternal(), this._calcMatrices();
                    }
                },
                {
                    key: "pixelsToClipSpaceMatrix",
                    get: function get() {
                        return this._pixelsToClipSpaceMatrix;
                    }
                },
                {
                    key: "clipSpaceToPixelsMatrix",
                    get: function get() {
                        return this._clipSpaceToPixelsMatrix;
                    }
                },
                {
                    key: "minElevationForCurrentTile",
                    get: function get() {
                        return this._minElevationForCurrentTile;
                    }
                },
                {
                    key: "setMinElevationForCurrentTile",
                    value: function setMinElevationForCurrentTile(e1) {
                        this._minElevationForCurrentTile = e1;
                    }
                },
                {
                    key: "tileSize",
                    get: function get() {
                        return this._tileSize;
                    }
                },
                {
                    key: "tileZoom",
                    get: function get() {
                        return this._tileZoom;
                    }
                },
                {
                    key: "scale",
                    get: function get() {
                        return this._scale;
                    }
                },
                {
                    key: "width",
                    get: function get() {
                        return this._width;
                    }
                },
                {
                    key: "height",
                    get: function get() {
                        return this._height;
                    }
                },
                {
                    key: "bearingInRadians",
                    get: function get() {
                        return this._bearingInRadians;
                    }
                },
                {
                    key: "lngRange",
                    get: function get() {
                        return this._lngRange;
                    }
                },
                {
                    key: "latRange",
                    get: function get() {
                        return this._latRange;
                    }
                },
                {
                    key: "pixelsToGLUnits",
                    get: function get() {
                        return this._pixelsToGLUnits;
                    }
                },
                {
                    key: "minZoom",
                    get: function get() {
                        return this._minZoom;
                    }
                },
                {
                    key: "setMinZoom",
                    value: function setMinZoom(e1) {
                        this._minZoom !== e1 && (this._minZoom = e1, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
                    }
                },
                {
                    key: "maxZoom",
                    get: function get() {
                        return this._maxZoom;
                    }
                },
                {
                    key: "setMaxZoom",
                    value: function setMaxZoom(e1) {
                        this._maxZoom !== e1 && (this._maxZoom = e1, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
                    }
                },
                {
                    key: "minPitch",
                    get: function get() {
                        return this._minPitch;
                    }
                },
                {
                    key: "setMinPitch",
                    value: function setMinPitch(e1) {
                        this._minPitch !== e1 && (this._minPitch = e1, this.setPitch(Math.max(this.pitch, e1)));
                    }
                },
                {
                    key: "maxPitch",
                    get: function get() {
                        return this._maxPitch;
                    }
                },
                {
                    key: "setMaxPitch",
                    value: function setMaxPitch(e1) {
                        this._maxPitch !== e1 && (this._maxPitch = e1, this.setPitch(Math.min(this.pitch, e1)));
                    }
                },
                {
                    key: "renderWorldCopies",
                    get: function get() {
                        return this._renderWorldCopies;
                    }
                },
                {
                    key: "setRenderWorldCopies",
                    value: function setRenderWorldCopies(e1) {
                        void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
                    }
                },
                {
                    key: "constrainOverride",
                    get: function get() {
                        return this._constrainOverride;
                    }
                },
                {
                    key: "setConstrainOverride",
                    value: function setConstrainOverride(e1) {
                        void 0 === e1 && (e1 = null), this._constrainOverride !== e1 && (this._constrainOverride = e1, this.constrainInternal(), this._calcMatrices());
                    }
                },
                {
                    key: "worldSize",
                    get: function get() {
                        return this._tileSize * this._scale;
                    }
                },
                {
                    key: "centerOffset",
                    get: function get() {
                        return this.centerPoint._sub(this.size._div(2));
                    }
                },
                {
                    key: "size",
                    get: function get() {
                        return new t.P(this._width, this._height);
                    }
                },
                {
                    key: "bearing",
                    get: function get() {
                        return this._bearingInRadians / Math.PI * 180;
                    }
                },
                {
                    key: "setBearing",
                    value: function setBearing(e1) {
                        var i = t.W(e1, -180, 180) * Math.PI / 180;
                        var r, o, s, n, l, _$c, h, u, d;
                        this._bearingInRadians !== i && (this._unmodified = !1, this._bearingInRadians = i, this._calcMatrices(), this._rotationMatrix = a(), r = this._rotationMatrix, s = -this._bearingInRadians, n = (o = this._rotationMatrix)[0], l = o[1], _$c = o[2], h = o[3], u = Math.sin(s), d = Math.cos(s), r[0] = n * d + _$c * u, r[1] = l * d + h * u, r[2] = n * -u + _$c * d, r[3] = l * -u + h * d);
                    }
                },
                {
                    key: "rotationMatrix",
                    get: function get() {
                        return this._rotationMatrix;
                    }
                },
                {
                    key: "pitchInRadians",
                    get: function get() {
                        return this._pitchInRadians;
                    }
                },
                {
                    key: "pitch",
                    get: function get() {
                        return this._pitchInRadians / Math.PI * 180;
                    }
                },
                {
                    key: "setPitch",
                    value: function setPitch(e1) {
                        var i = t.an(e1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                        this._pitchInRadians !== i && (this._unmodified = !1, this._pitchInRadians = i, this._calcMatrices());
                    }
                },
                {
                    key: "rollInRadians",
                    get: function get() {
                        return this._rollInRadians;
                    }
                },
                {
                    key: "roll",
                    get: function get() {
                        return this._rollInRadians / Math.PI * 180;
                    }
                },
                {
                    key: "setRoll",
                    value: function setRoll(e1) {
                        var _$t = e1 / 180 * Math.PI;
                        this._rollInRadians !== _$t && (this._unmodified = !1, this._rollInRadians = _$t, this._calcMatrices());
                    }
                },
                {
                    key: "fovInRadians",
                    get: function get() {
                        return this._fovInRadians;
                    }
                },
                {
                    key: "fov",
                    get: function get() {
                        return t.aZ(this._fovInRadians);
                    }
                },
                {
                    key: "setFov",
                    value: function setFov(e1) {
                        e1 = t.an(e1, .1, 150), this.fov !== e1 && (this._unmodified = !1, this._fovInRadians = t.ap(e1), this._calcMatrices());
                    }
                },
                {
                    key: "zoom",
                    get: function get() {
                        return this._zoom;
                    }
                },
                {
                    key: "setZoom",
                    value: function setZoom(e1) {
                        var i = this.applyConstrain(this._center, e1).zoom;
                        this._zoom !== i && (this._unmodified = !1, this._zoom = i, this._tileZoom = Math.max(0, Math.floor(i)), this._scale = t.aq(i), this.constrainInternal(), this._calcMatrices());
                    }
                },
                {
                    key: "center",
                    get: function get() {
                        return this._center;
                    }
                },
                {
                    key: "setCenter",
                    value: function setCenter(e1) {
                        e1.lat === this._center.lat && e1.lng === this._center.lng || (this._unmodified = !1, this._center = e1, this.constrainInternal(), this._calcMatrices());
                    }
                },
                {
                    key: "elevation",
                    get: function get() {
                        return this._elevation;
                    }
                },
                {
                    key: "setElevation",
                    value: function setElevation(e1) {
                        e1 !== this._elevation && (this._elevation = e1, this.constrainInternal(), this._calcMatrices());
                    }
                },
                {
                    key: "padding",
                    get: function get() {
                        return this._edgeInsets.toJSON();
                    }
                },
                {
                    key: "setPadding",
                    value: function setPadding(e1) {
                        this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
                    }
                },
                {
                    key: "centerPoint",
                    get: function get() {
                        return this._edgeInsets.getCenter(this._width, this._height);
                    }
                },
                {
                    key: "pixelsPerMeter",
                    get: function get() {
                        return this._pixelPerMeter;
                    }
                },
                {
                    key: "unmodified",
                    get: function get() {
                        return this._unmodified;
                    }
                },
                {
                    key: "cameraToCenterDistance",
                    get: function get() {
                        return this._cameraToCenterDistance;
                    }
                },
                {
                    key: "nearZ",
                    get: function get() {
                        return this._nearZ;
                    }
                },
                {
                    key: "farZ",
                    get: function get() {
                        return this._farZ;
                    }
                },
                {
                    key: "autoCalculateNearFarZ",
                    get: function get() {
                        return this._autoCalculateNearFarZ;
                    }
                },
                {
                    key: "overrideNearFarZ",
                    value: function overrideNearFarZ(e1, t) {
                        this._autoCalculateNearFarZ = !1, this._nearZ = e1, this._farZ = t, this._calcMatrices();
                    }
                },
                {
                    key: "clearNearFarZOverride",
                    value: function clearNearFarZOverride() {
                        this._autoCalculateNearFarZ = !0, this._calcMatrices();
                    }
                },
                {
                    key: "isPaddingEqual",
                    value: function isPaddingEqual(e1) {
                        return this._edgeInsets.equals(e1);
                    }
                },
                {
                    key: "interpolatePadding",
                    value: function interpolatePadding(e1, t, i) {
                        this._unmodified = !1, this._edgeInsets.interpolate(e1, t, i), this.constrainInternal(), this._calcMatrices();
                    }
                },
                {
                    key: "resize",
                    value: function resize(e1, t) {
                        var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                        this._width = e1, this._height = t, i && this.constrainInternal(), this._calcMatrices();
                    }
                },
                {
                    key: "getMaxBounds",
                    value: function getMaxBounds() {
                        return this._latRange && 2 === this._latRange.length && this._lngRange && 2 === this._lngRange.length ? new $([
                            this._lngRange[0],
                            this._latRange[0]
                        ], [
                            this._lngRange[1],
                            this._latRange[1]
                        ]) : null;
                    }
                },
                {
                    key: "setMaxBounds",
                    value: function setMaxBounds(e1) {
                        e1 ? (this._lngRange = [
                            e1.getWest(),
                            e1.getEast()
                        ], this._latRange = [
                            e1.getSouth(),
                            e1.getNorth()
                        ], this.constrainInternal()) : (this._lngRange = null, this._latRange = [
                            -t.ao,
                            t.ao
                        ]);
                    }
                },
                {
                    key: "getCameraQueryGeometry",
                    value: function getCameraQueryGeometry(e1, i) {
                        if (1 === i.length) return [
                            i[0],
                            e1
                        ];
                        {
                            var _t_aa_fromPoints_extend = t.aa.fromPoints(i).extend(e1), a = _t_aa_fromPoints_extend.minX, r = _t_aa_fromPoints_extend.minY, o = _t_aa_fromPoints_extend.maxX, s = _t_aa_fromPoints_extend.maxY;
                            return [
                                new t.P(a, r),
                                new t.P(o, r),
                                new t.P(o, s),
                                new t.P(a, s),
                                new t.P(a, r)
                            ];
                        }
                    }
                },
                {
                    key: "constrainInternal",
                    value: function constrainInternal() {
                        if (!this.center || !this._width || !this._height || this._constraining) return;
                        this._constraining = !0;
                        var _$e = this._unmodified, _this_applyConstrain = this.applyConstrain(this.center, this.zoom), _$t = _this_applyConstrain.center, i = _this_applyConstrain.zoom;
                        this.setCenter(_$t), this.setZoom(i), this._unmodified = _$e, this._constraining = !1;
                    }
                },
                {
                    key: "_calcMatrices",
                    value: function _calcMatrices() {
                        if (this._width && this._height) {
                            this._pixelsToGLUnits = [
                                2 / this._width,
                                -2 / this._height
                            ];
                            var _$e = t.ar(new Float64Array(16));
                            t.Q(_$e, _$e, [
                                this._width / 2,
                                -this._height / 2,
                                1
                            ]), t.O(_$e, _$e, [
                                1,
                                -1,
                                0
                            ]), this._clipSpaceToPixelsMatrix = _$e, _$e = t.ar(new Float64Array(16)), t.Q(_$e, _$e, [
                                1,
                                -1,
                                1
                            ]), t.O(_$e, _$e, [
                                -1,
                                -1,
                                0
                            ]), t.Q(_$e, _$e, [
                                2 / this._width,
                                2 / this._height,
                                1
                            ]), this._pixelsToClipSpaceMatrix = _$e, this._cameraToCenterDistance = .5 / Math.tan(this.fovInRadians / 2) * this._height;
                        }
                        this._callbacks.calcMatrices();
                    }
                },
                {
                    key: "calculateCenterFromCameraLngLatAlt",
                    value: function calculateCenterFromCameraLngLatAlt(e1, i, a, r) {
                        var o = void 0 !== a ? a : this.bearing, s = r = void 0 !== r ? r : this.pitch, _this__distanceToCenterFromAltElevationPitch = this._distanceToCenterFromAltElevationPitch(i, this.elevation, s), n = _this__distanceToCenterFromAltElevationPitch.distanceToCenter, l = _this__distanceToCenterFromAltElevationPitch.clampedElevation, _be = be(s, o), _$c = _be.x, h = _be.y, u = t.a9.fromLngLat(e1, i);
                        var d, _, p = t.a_(1, u.y), m = 0;
                        do {
                            if (m += 1, m > 10) break;
                            _ = n / p, d = new t.a9(u.x + _$c * _, u.y + h * _), p = 1 / d.meterInMercatorCoordinateUnits();
                        }while (Math.abs(n - _ * p) > 1e-12);
                        return {
                            center: d.toLngLat(),
                            elevation: l,
                            zoom: t.at(this.height / 2 / Math.tan(this.fovInRadians / 2) / _ / this.tileSize)
                        };
                    }
                },
                {
                    key: "recalculateZoomAndCenter",
                    value: function recalculateZoomAndCenter(e1) {
                        if (this.elevation - e1 == 0) return;
                        var i = 1 / this.worldSize, a = t.as(1, this.center.lat) * this.worldSize, r = t.a9.fromLngLat(this.center, this.elevation), o = r.x / i, s = r.y / i, n = r.z / i, l = this.pitch, _$c = this.bearing, _be = be(l, _$c), h = _be.x, u = _be.y, d = _be.z, _ = this.cameraToCenterDistance, p = o + _ * -h, m = s + _ * -u, f = n + _ * d, _this__distanceToCenterFromAltElevationPitch = this._distanceToCenterFromAltElevationPitch(f / a, e1, l), g = _this__distanceToCenterFromAltElevationPitch.distanceToCenter, v = _this__distanceToCenterFromAltElevationPitch.clampedElevation, x = g * a, b = new t.a9((p + h * x) * i, (m + u * x) * i, 0).toLngLat(), y = t.as(1, b.lat), w = t.at(this.height / 2 / Math.tan(this.fovInRadians / 2) / g / y / this.tileSize);
                        this._elevation = v, this._center = b, this.setZoom(w);
                    }
                },
                {
                    key: "_distanceToCenterFromAltElevationPitch",
                    value: function _distanceToCenterFromAltElevationPitch(e1, i, a) {
                        var r = -Math.cos(t.ap(a)), o = e1 - i;
                        var s, n = i;
                        return r * o >= 0 || Math.abs(r) < .1 ? (s = 1e4, n = e1 + s * r) : s = -o / r, {
                            distanceToCenter: s,
                            clampedElevation: n
                        };
                    }
                },
                {
                    key: "getCameraPoint",
                    value: function getCameraPoint() {
                        var _$e = Math.tan(this.pitchInRadians) * (this.cameraToCenterDistance || 1);
                        return this.centerPoint.add(new t.P(_$e * Math.sin(this.rollInRadians), _$e * Math.cos(this.rollInRadians)));
                    }
                },
                {
                    key: "getCameraAltitude",
                    value: function getCameraAltitude() {
                        return Math.cos(this.pitchInRadians) * this._cameraToCenterDistance / this._pixelPerMeter + this.elevation;
                    }
                },
                {
                    key: "getCameraLngLat",
                    value: function getCameraLngLat() {
                        var _$e = t.as(1, this.center.lat) * this.worldSize;
                        return xe(this.center, this.elevation, this.pitch, this.bearing, this.cameraToCenterDistance / _$e).toLngLat();
                    }
                },
                {
                    key: "getMercatorTileCoordinates",
                    value: function getMercatorTileCoordinates(e1) {
                        if (!e1) return [
                            0,
                            0,
                            1,
                            1
                        ];
                        var i = e1.canonical.z >= 0 ? 1 << e1.canonical.z : Math.pow(2, e1.canonical.z);
                        return [
                            e1.canonical.x / i,
                            e1.canonical.y / i,
                            1 / i / t.a5,
                            1 / i / t.a5
                        ];
                    }
                }
            ]);
            return Ut;
        }();
        var Vt = /*#__PURE__*/ function() {
            function Vt(e1, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Vt);
                this.min = e1, this.max = i, this.center = t.a$([], t.b0([], this.min, this.max), .5);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Vt, [
                {
                    key: "quadrant",
                    value: function quadrant(e1) {
                        var i = [
                            e1 % 2 == 0,
                            e1 < 2
                        ], a = t.b1(this.min), r = t.b1(this.max);
                        for(var _$e = 0; _$e < i.length; _$e++)a[_$e] = i[_$e] ? this.min[_$e] : this.center[_$e], r[_$e] = i[_$e] ? this.center[_$e] : this.max[_$e];
                        return r[2] = this.max[2], new Vt(a, r);
                    }
                },
                {
                    key: "distanceX",
                    value: function distanceX(e1) {
                        return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
                    }
                },
                {
                    key: "distanceY",
                    value: function distanceY(e1) {
                        return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
                    }
                },
                {
                    key: "intersectsFrustum",
                    value: function intersectsFrustum(e1) {
                        var _$t = !0;
                        for(var i = 0; i < e1.planes.length; i++){
                            var a = this.intersectsPlane(e1.planes[i]);
                            if (0 === a) return 0;
                            1 === a && (_$t = !1);
                        }
                        return _$t ? 2 : e1.aabb.min[0] > this.max[0] || e1.aabb.min[1] > this.max[1] || e1.aabb.min[2] > this.max[2] || e1.aabb.max[0] < this.min[0] || e1.aabb.max[1] < this.min[1] || e1.aabb.max[2] < this.min[2] ? 0 : 1;
                    }
                },
                {
                    key: "intersectsPlane",
                    value: function intersectsPlane(e1) {
                        var _$t = e1[3], i = e1[3];
                        for(var a = 0; a < 3; a++)e1[a] > 0 ? (_$t += e1[a] * this.min[a], i += e1[a] * this.max[a]) : (i += e1[a] * this.min[a], _$t += e1[a] * this.max[a]);
                        return _$t >= 0 ? 2 : i < 0 ? 0 : 1;
                    }
                }
            ]);
            return Vt;
        }();
        var qt = /*#__PURE__*/ function() {
            function qt() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, qt);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(qt, [
                {
                    key: "distanceToTile2d",
                    value: function distanceToTile2d(e1, t, i, a) {
                        var r = a.distanceX([
                            e1,
                            t
                        ]), o = a.distanceY([
                            e1,
                            t
                        ]);
                        return Math.hypot(r, o);
                    }
                },
                {
                    key: "getWrap",
                    value: function getWrap(e1, t, i) {
                        return i;
                    }
                },
                {
                    key: "getTileBoundingVolume",
                    value: function getTileBoundingVolume(e1, i, a, r) {
                        var o, s;
                        var n = 0, l = 0;
                        if (null == r ? void 0 : r.terrain) {
                            var _$c = new t.a2(e1.z, i, e1.z, e1.x, e1.y), h = r.terrain.getMinMaxElevation(_$c);
                            n = null !== (o = h.minElevation) && void 0 !== o ? o : Math.min(0, a), l = null !== (s = h.maxElevation) && void 0 !== s ? s : Math.max(0, a);
                        }
                        var _$c1 = 1 << e1.z;
                        return new Vt([
                            i + e1.x / _$c1,
                            e1.y / _$c1,
                            n
                        ], [
                            i + (e1.x + 1) / _$c1,
                            (e1.y + 1) / _$c1,
                            l
                        ]);
                    }
                },
                {
                    key: "allowVariableZoom",
                    value: function allowVariableZoom(e1, i) {
                        var a = e1.fov * (Math.abs(Math.cos(e1.rollInRadians)) * e1.height + Math.abs(Math.sin(e1.rollInRadians)) * e1.width) / e1.height, r = t.an(78.5 - a / 2, 0, 60);
                        return !!i.terrain || e1.pitch > r;
                    }
                },
                {
                    key: "allowWorldCopies",
                    value: function allowWorldCopies() {
                        return !0;
                    }
                },
                {
                    key: "prepareNextFrame",
                    value: function prepareNextFrame() {}
                }
            ]);
            return qt;
        }();
        var Wt = /*#__PURE__*/ function() {
            function Wt(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Wt);
                this.points = e1, this.planes = t, this.aabb = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Wt, null, [
                {
                    key: "fromInvProjectionMatrix",
                    value: function fromInvProjectionMatrix(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, r = arguments.length > 3 ? arguments[3] : void 0, o = arguments.length > 4 ? arguments[4] : void 0;
                        var s = o ? [
                            [
                                6,
                                5,
                                4
                            ],
                            [
                                0,
                                1,
                                2
                            ],
                            [
                                0,
                                3,
                                7
                            ],
                            [
                                2,
                                1,
                                5
                            ],
                            [
                                3,
                                2,
                                6
                            ],
                            [
                                0,
                                4,
                                5
                            ]
                        ] : [
                            [
                                0,
                                1,
                                2
                            ],
                            [
                                6,
                                5,
                                4
                            ],
                            [
                                0,
                                3,
                                7
                            ],
                            [
                                2,
                                1,
                                5
                            ],
                            [
                                3,
                                2,
                                6
                            ],
                            [
                                0,
                                4,
                                5
                            ]
                        ], n = Math.pow(2, a), l = [
                            [
                                -1,
                                1,
                                -1,
                                1
                            ],
                            [
                                1,
                                1,
                                -1,
                                1
                            ],
                            [
                                1,
                                -1,
                                -1,
                                1
                            ],
                            [
                                -1,
                                -1,
                                -1,
                                1
                            ],
                            [
                                -1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                1,
                                1,
                                1
                            ],
                            [
                                1,
                                -1,
                                1,
                                1
                            ],
                            [
                                -1,
                                -1,
                                1,
                                1
                            ]
                        ].map(function(a) {
                            return function(e1, i, a, r) {
                                var o = t.aH([], e1, i), s = 1 / o[3] / a * r;
                                return t.b6(o, o, [
                                    s,
                                    s,
                                    1 / o[3],
                                    s
                                ]);
                            }(a, e1, i, n);
                        });
                        r && function(e1, i, a, r) {
                            var o = r ? 4 : 0, s = r ? 0 : 4;
                            var n = 0;
                            var l = [], _$c = [];
                            for(var _$i = 0; _$i < 4; _$i++){
                                var _$a = t.b2([], e1[_$i + s], e1[_$i + o]), _$r = t.b7(_$a);
                                t.a$(_$a, _$a, 1 / _$r), l.push(_$r), _$c.push(_$a);
                            }
                            for(var _$i1 = 0; _$i1 < 4; _$i1++){
                                var _$r1 = t.b8(e1[_$i1 + o], _$c[_$i1], a);
                                n = null !== _$r1 && _$r1 >= 0 ? Math.max(n, _$r1) : Math.max(n, l[_$i1]);
                            }
                            var h = function(e1, i) {
                                var _$a = t.b2([], e1[i[0]], e1[i[1]]), _$r = t.b2([], e1[i[2]], e1[i[1]]), o = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                return t.b3(o, t.b4([], _$a, _$r)), o[3] = -t.b5(o, e1[i[0]]), o;
                            }(e1, i), u = function(e1, i) {
                                var _$a = t.b9(e1), _$r = t.ba([], e1, 1 / _$a), o = t.b2([], i, t.a$([], _$r, t.b5(i, _$r))), s = t.b9(o);
                                if (s > 0) {
                                    var _$e = Math.sqrt(1 - _$r[3] * _$r[3]), _$a1 = t.a$([], _$r, -_$r[3]), n = t.b0([], _$a1, t.a$([], o, _$e / s));
                                    return t.bb(i, n);
                                }
                                return null;
                            }(a, h);
                            if (null !== u) {
                                var _$e = u / t.b5(_$c[0], h);
                                n = Math.min(n, _$e);
                            }
                            for(var _$t = 0; _$t < 4; _$t++){
                                var _$i2 = Math.min(n, l[_$t]);
                                e1[_$t + s] = [
                                    e1[_$t + o][0] + _$c[_$t][0] * _$i2,
                                    e1[_$t + o][1] + _$c[_$t][1] * _$i2,
                                    e1[_$t + o][2] + _$c[_$t][2] * _$i2,
                                    1
                                ];
                            }
                        }(l, s[0], r, o);
                        var _$c = s.map(function(e1) {
                            var i = t.b2([], l[e1[0]], l[e1[1]]), a = t.b2([], l[e1[2]], l[e1[1]]), r = t.b3([], t.b4([], i, a)), o = -t.b5(r, l[e1[1]]);
                            return r.concat(o);
                        }), h = [
                            Number.POSITIVE_INFINITY,
                            Number.POSITIVE_INFINITY,
                            Number.POSITIVE_INFINITY
                        ], u = [
                            Number.NEGATIVE_INFINITY,
                            Number.NEGATIVE_INFINITY,
                            Number.NEGATIVE_INFINITY
                        ];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = l[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                for(var _$t = 0; _$t < 3; _$t++)h[_$t] = Math.min(h[_$t], _$e[_$t]), u[_$t] = Math.max(u[_$t], _$e[_$t]);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return new Wt(l, _$c, new Vt(h, u));
                    }
                }
            ]);
            return Wt;
        }();
        var $t = /*#__PURE__*/ function() {
            function $t(e1) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, $t);
                this._posMatrixCache = new Map, this._alignedPosMatrixCache = new Map, this._fogMatrixCacheF32 = new Map, this.defaultConstrain = function(e1, i) {
                    i = t.an(+i, _this.minZoom, _this.maxZoom);
                    var a = {
                        center: new t.V(e1.lng, e1.lat),
                        zoom: i
                    };
                    var r = _this._helper._lngRange;
                    if (!_this._helper._renderWorldCopies && null === r) {
                        var _$e = 180 - 1e-10;
                        r = [
                            -_$e,
                            _$e
                        ];
                    }
                    var o = _this.tileSize * t.aq(a.zoom);
                    var s = 0, n = o, l = 0, _$c = o, h = 0, u = 0;
                    var _this_size = _this.size, d = _this_size.x, _ = _this_size.y;
                    if (_this._helper._latRange) {
                        var _$e1 = _this._helper._latRange;
                        s = t.X(_$e1[1]) * o, n = t.X(_$e1[0]) * o, n - s < _ && (h = _ / (n - s));
                    }
                    r && (l = t.W(t.Y(r[0]) * o, 0, o), _$c = t.W(t.Y(r[1]) * o, 0, o), _$c < l && (_$c += o), _$c - l < d && (u = d / (_$c - l)));
                    var _me = me(o, e1), p = _me.x, m = _me.y;
                    var f, g;
                    var v = Math.max(u || 0, h || 0);
                    if (v) {
                        var _$e2 = new t.P(u ? (_$c + l) / 2 : p, h ? (n + s) / 2 : m);
                        return a.center = fe(o, _$e2).wrap(), a.zoom += t.at(v), a;
                    }
                    if (_this._helper._latRange) {
                        var _$e3 = _ / 2;
                        m - _$e3 < s && (g = s + _$e3), m + _$e3 > n && (g = n - _$e3);
                    }
                    if (r) {
                        var _$e4 = (l + _$c) / 2;
                        var _$i = p;
                        _this._helper._renderWorldCopies && (_$i = t.W(p, _$e4 - o / 2, _$e4 + o / 2));
                        var a1 = d / 2;
                        _$i - a1 < l && (f = l + a1), _$i + a1 > _$c && (f = _$c - a1);
                    }
                    if (void 0 !== f || void 0 !== g) {
                        var _$e5 = new t.P(null != f ? f : p, null != g ? g : m);
                        a.center = fe(o, _$e5).wrap();
                    }
                    return a;
                }, this.applyConstrain = function(e1, t) {
                    return _this._helper.applyConstrain(e1, t);
                }, this._helper = new Ut({
                    calcMatrices: function() {
                        _this._calcMatrices();
                    },
                    defaultConstrain: function(e1, t) {
                        return _this.defaultConstrain(e1, t);
                    }
                }, e1), this._coveringTilesDetailsProvider = new qt;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)($t, [
                {
                    key: "pixelsToClipSpaceMatrix",
                    get: function get() {
                        return this._helper.pixelsToClipSpaceMatrix;
                    }
                },
                {
                    key: "clipSpaceToPixelsMatrix",
                    get: function get() {
                        return this._helper.clipSpaceToPixelsMatrix;
                    }
                },
                {
                    key: "pixelsToGLUnits",
                    get: function get() {
                        return this._helper.pixelsToGLUnits;
                    }
                },
                {
                    key: "centerOffset",
                    get: function get() {
                        return this._helper.centerOffset;
                    }
                },
                {
                    key: "size",
                    get: function get() {
                        return this._helper.size;
                    }
                },
                {
                    key: "rotationMatrix",
                    get: function get() {
                        return this._helper.rotationMatrix;
                    }
                },
                {
                    key: "centerPoint",
                    get: function get() {
                        return this._helper.centerPoint;
                    }
                },
                {
                    key: "pixelsPerMeter",
                    get: function get() {
                        return this._helper.pixelsPerMeter;
                    }
                },
                {
                    key: "setMinZoom",
                    value: function setMinZoom(e1) {
                        this._helper.setMinZoom(e1);
                    }
                },
                {
                    key: "setMaxZoom",
                    value: function setMaxZoom(e1) {
                        this._helper.setMaxZoom(e1);
                    }
                },
                {
                    key: "setMinPitch",
                    value: function setMinPitch(e1) {
                        this._helper.setMinPitch(e1);
                    }
                },
                {
                    key: "setMaxPitch",
                    value: function setMaxPitch(e1) {
                        this._helper.setMaxPitch(e1);
                    }
                },
                {
                    key: "setRenderWorldCopies",
                    value: function setRenderWorldCopies(e1) {
                        this._helper.setRenderWorldCopies(e1);
                    }
                },
                {
                    key: "setBearing",
                    value: function setBearing(e1) {
                        this._helper.setBearing(e1);
                    }
                },
                {
                    key: "setPitch",
                    value: function setPitch(e1) {
                        this._helper.setPitch(e1);
                    }
                },
                {
                    key: "setRoll",
                    value: function setRoll(e1) {
                        this._helper.setRoll(e1);
                    }
                },
                {
                    key: "setFov",
                    value: function setFov(e1) {
                        this._helper.setFov(e1);
                    }
                },
                {
                    key: "setZoom",
                    value: function setZoom(e1) {
                        this._helper.setZoom(e1);
                    }
                },
                {
                    key: "setCenter",
                    value: function setCenter(e1) {
                        this._helper.setCenter(e1);
                    }
                },
                {
                    key: "setElevation",
                    value: function setElevation(e1) {
                        this._helper.setElevation(e1);
                    }
                },
                {
                    key: "setMinElevationForCurrentTile",
                    value: function setMinElevationForCurrentTile(e1) {
                        this._helper.setMinElevationForCurrentTile(e1);
                    }
                },
                {
                    key: "setPadding",
                    value: function setPadding(e1) {
                        this._helper.setPadding(e1);
                    }
                },
                {
                    key: "interpolatePadding",
                    value: function interpolatePadding(e1, t, i) {
                        return this._helper.interpolatePadding(e1, t, i);
                    }
                },
                {
                    key: "isPaddingEqual",
                    value: function isPaddingEqual(e1) {
                        return this._helper.isPaddingEqual(e1);
                    }
                },
                {
                    key: "resize",
                    value: function resize(e1, t) {
                        var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                        this._helper.resize(e1, t, i);
                    }
                },
                {
                    key: "getMaxBounds",
                    value: function getMaxBounds() {
                        return this._helper.getMaxBounds();
                    }
                },
                {
                    key: "setMaxBounds",
                    value: function setMaxBounds(e1) {
                        this._helper.setMaxBounds(e1);
                    }
                },
                {
                    key: "setConstrainOverride",
                    value: function setConstrainOverride(e1) {
                        this._helper.setConstrainOverride(e1);
                    }
                },
                {
                    key: "overrideNearFarZ",
                    value: function overrideNearFarZ(e1, t) {
                        this._helper.overrideNearFarZ(e1, t);
                    }
                },
                {
                    key: "clearNearFarZOverride",
                    value: function clearNearFarZOverride() {
                        this._helper.clearNearFarZOverride();
                    }
                },
                {
                    key: "getCameraQueryGeometry",
                    value: function getCameraQueryGeometry(e1) {
                        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
                    }
                },
                {
                    key: "tileSize",
                    get: function get() {
                        return this._helper.tileSize;
                    }
                },
                {
                    key: "tileZoom",
                    get: function get() {
                        return this._helper.tileZoom;
                    }
                },
                {
                    key: "scale",
                    get: function get() {
                        return this._helper.scale;
                    }
                },
                {
                    key: "worldSize",
                    get: function get() {
                        return this._helper.worldSize;
                    }
                },
                {
                    key: "width",
                    get: function get() {
                        return this._helper.width;
                    }
                },
                {
                    key: "height",
                    get: function get() {
                        return this._helper.height;
                    }
                },
                {
                    key: "lngRange",
                    get: function get() {
                        return this._helper.lngRange;
                    }
                },
                {
                    key: "latRange",
                    get: function get() {
                        return this._helper.latRange;
                    }
                },
                {
                    key: "minZoom",
                    get: function get() {
                        return this._helper.minZoom;
                    }
                },
                {
                    key: "maxZoom",
                    get: function get() {
                        return this._helper.maxZoom;
                    }
                },
                {
                    key: "zoom",
                    get: function get() {
                        return this._helper.zoom;
                    }
                },
                {
                    key: "center",
                    get: function get() {
                        return this._helper.center;
                    }
                },
                {
                    key: "minPitch",
                    get: function get() {
                        return this._helper.minPitch;
                    }
                },
                {
                    key: "maxPitch",
                    get: function get() {
                        return this._helper.maxPitch;
                    }
                },
                {
                    key: "pitch",
                    get: function get() {
                        return this._helper.pitch;
                    }
                },
                {
                    key: "pitchInRadians",
                    get: function get() {
                        return this._helper.pitchInRadians;
                    }
                },
                {
                    key: "roll",
                    get: function get() {
                        return this._helper.roll;
                    }
                },
                {
                    key: "rollInRadians",
                    get: function get() {
                        return this._helper.rollInRadians;
                    }
                },
                {
                    key: "bearing",
                    get: function get() {
                        return this._helper.bearing;
                    }
                },
                {
                    key: "bearingInRadians",
                    get: function get() {
                        return this._helper.bearingInRadians;
                    }
                },
                {
                    key: "fov",
                    get: function get() {
                        return this._helper.fov;
                    }
                },
                {
                    key: "fovInRadians",
                    get: function get() {
                        return this._helper.fovInRadians;
                    }
                },
                {
                    key: "elevation",
                    get: function get() {
                        return this._helper.elevation;
                    }
                },
                {
                    key: "minElevationForCurrentTile",
                    get: function get() {
                        return this._helper.minElevationForCurrentTile;
                    }
                },
                {
                    key: "padding",
                    get: function get() {
                        return this._helper.padding;
                    }
                },
                {
                    key: "unmodified",
                    get: function get() {
                        return this._helper.unmodified;
                    }
                },
                {
                    key: "renderWorldCopies",
                    get: function get() {
                        return this._helper.renderWorldCopies;
                    }
                },
                {
                    key: "cameraToCenterDistance",
                    get: function get() {
                        return this._helper.cameraToCenterDistance;
                    }
                },
                {
                    key: "constrainOverride",
                    get: function get() {
                        return this._helper.constrainOverride;
                    }
                },
                {
                    key: "nearZ",
                    get: function get() {
                        return this._helper.nearZ;
                    }
                },
                {
                    key: "farZ",
                    get: function get() {
                        return this._helper.farZ;
                    }
                },
                {
                    key: "autoCalculateNearFarZ",
                    get: function get() {
                        return this._helper.autoCalculateNearFarZ;
                    }
                },
                {
                    key: "setTransitionState",
                    value: function setTransitionState(e1, t) {}
                },
                {
                    key: "clone",
                    value: function clone() {
                        var _$e = new $t;
                        return _$e.apply(this), _$e;
                    }
                },
                {
                    key: "apply",
                    value: function apply(e1, t, i) {
                        this._helper.apply(e1, t, i);
                    }
                },
                {
                    key: "cameraPosition",
                    get: function get() {
                        return this._cameraPosition;
                    }
                },
                {
                    key: "projectionMatrix",
                    get: function get() {
                        return this._projectionMatrix;
                    }
                },
                {
                    key: "modelViewProjectionMatrix",
                    get: function get() {
                        return this._viewProjMatrix;
                    }
                },
                {
                    key: "inverseProjectionMatrix",
                    get: function get() {
                        return this._invProjMatrix;
                    }
                },
                {
                    key: "mercatorMatrix",
                    get: function get() {
                        return this._mercatorMatrix;
                    }
                },
                {
                    key: "getVisibleUnwrappedCoordinates",
                    value: function getVisibleUnwrappedCoordinates(e1) {
                        var i = [
                            new t.bc(0, e1)
                        ];
                        if (this._helper._renderWorldCopies) {
                            var a = this.screenPointToMercatorCoordinate(new t.P(0, 0)), r = this.screenPointToMercatorCoordinate(new t.P(this._helper._width, 0)), o = this.screenPointToMercatorCoordinate(new t.P(this._helper._width, this._helper._height)), s = this.screenPointToMercatorCoordinate(new t.P(0, this._helper._height)), n = Math.floor(Math.min(a.x, r.x, o.x, s.x)), l = Math.floor(Math.max(a.x, r.x, o.x, s.x)), _$c = 1;
                            for(var a1 = n - _$c; a1 <= l + _$c; a1++)0 !== a1 && i.push(new t.bc(a1, e1));
                        }
                        return i;
                    }
                },
                {
                    key: "getCameraFrustum",
                    value: function getCameraFrustum() {
                        return Wt.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
                    }
                },
                {
                    key: "getClippingPlane",
                    value: function getClippingPlane() {
                        return null;
                    }
                },
                {
                    key: "getCoveringTilesDetailsProvider",
                    value: function getCoveringTilesDetailsProvider() {
                        return this._coveringTilesDetailsProvider;
                    }
                },
                {
                    key: "recalculateZoomAndCenter",
                    value: function recalculateZoomAndCenter(e1) {
                        var _$t = this.screenPointToLocation(this.centerPoint, e1), i = e1 ? e1.getElevationForLngLatZoom(_$t, this._helper._tileZoom) : 0;
                        this._helper.recalculateZoomAndCenter(i);
                    }
                },
                {
                    key: "setLocationAtPoint",
                    value: function setLocationAtPoint(e1, i) {
                        var a = t.as(this.elevation, this.center.lat), r = this.screenPointToMercatorCoordinateAtZ(i, a), o = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, a), s = t.a9.fromLngLat(e1), n = new t.a9(s.x - (r.x - o.x), s.y - (r.y - o.y));
                        this.setCenter(null == n ? void 0 : n.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
                    }
                },
                {
                    key: "locationToScreenPoint",
                    value: function locationToScreenPoint(e1, i) {
                        return i ? this.coordinatePoint(t.a9.fromLngLat(e1), i.getElevationForLngLat(e1, this), this._pixelMatrix3D) : this.coordinatePoint(t.a9.fromLngLat(e1));
                    }
                },
                {
                    key: "screenPointToLocation",
                    value: function screenPointToLocation(e1, t) {
                        var i;
                        return null === (i = this.screenPointToMercatorCoordinate(e1, t)) || void 0 === i ? void 0 : i.toLngLat();
                    }
                },
                {
                    key: "screenPointToMercatorCoordinate",
                    value: function screenPointToMercatorCoordinate(e1, t) {
                        if (t) {
                            var i = t.pointCoordinate(e1);
                            if (null != i) return i;
                        }
                        return this.screenPointToMercatorCoordinateAtZ(e1);
                    }
                },
                {
                    key: "screenPointToMercatorCoordinateAtZ",
                    value: function screenPointToMercatorCoordinateAtZ(e1, i) {
                        var a = i || 0, r = [
                            e1.x,
                            e1.y,
                            0,
                            1
                        ], o = [
                            e1.x,
                            e1.y,
                            1,
                            1
                        ];
                        t.aH(r, r, this._pixelMatrixInverse), t.aH(o, o, this._pixelMatrixInverse);
                        var s = r[3], n = o[3], l = r[1] / s, _$c = o[1] / n, h = r[2] / s, u = o[2] / n, d = h === u ? 0 : (a - h) / (u - h);
                        return new t.a9(t.G.number(r[0] / s, o[0] / n, d) / this.worldSize, t.G.number(l, _$c, d) / this.worldSize, a);
                    }
                },
                {
                    key: "coordinatePoint",
                    value: function coordinatePoint(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : this._pixelMatrix;
                        var r = [
                            e1.x * this.worldSize,
                            e1.y * this.worldSize,
                            i,
                            1
                        ];
                        return t.aH(r, r, a), new t.P(r[0] / r[3], r[1] / r[3]);
                    }
                },
                {
                    key: "getBounds",
                    value: function getBounds() {
                        var _$e = Math.max(0, this._helper._height / 2 - ge(this));
                        return (new $).extend(this.screenPointToLocation(new t.P(0, _$e))).extend(this.screenPointToLocation(new t.P(this._helper._width, _$e))).extend(this.screenPointToLocation(new t.P(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new t.P(0, this._helper._height)));
                    }
                },
                {
                    key: "isPointOnMapSurface",
                    value: function isPointOnMapSurface(e1, t) {
                        return t ? null != t.pointCoordinate(e1) : e1.y > this.height / 2 - ge(this);
                    }
                },
                {
                    key: "calculatePosMatrix",
                    value: function calculatePosMatrix(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = arguments.length > 2 ? arguments[2] : void 0;
                        var r;
                        var o = null !== (r = e1.key) && void 0 !== r ? r : t.bd(e1.wrap, e1.canonical.z, e1.canonical.z, e1.canonical.x, e1.canonical.y), s = i ? this._alignedPosMatrixCache : this._posMatrixCache;
                        if (s.has(o)) {
                            var _$e = s.get(o);
                            return a ? _$e.f32 : _$e.f64;
                        }
                        var n = ve(e1, this.worldSize);
                        t.S(n, i ? this._alignedProjMatrix : this._viewProjMatrix, n);
                        var l = {
                            f64: n,
                            f32: new Float32Array(n)
                        };
                        return s.set(o, l), a ? l.f32 : l.f64;
                    }
                },
                {
                    key: "calculateFogMatrix",
                    value: function calculateFogMatrix(e1) {
                        var i = e1.key, a = this._fogMatrixCacheF32;
                        if (a.has(i)) return a.get(i);
                        var r = ve(e1, this.worldSize);
                        return t.S(r, this._fogMatrix, r), a.set(i, new Float32Array(r)), a.get(i);
                    }
                },
                {
                    key: "calculateCenterFromCameraLngLatAlt",
                    value: function calculateCenterFromCameraLngLatAlt(e1, t, i, a) {
                        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, a);
                    }
                },
                {
                    key: "_calculateNearFarZIfNeeded",
                    value: function _calculateNearFarZIfNeeded(e1, i, a) {
                        if (!this._helper.autoCalculateNearFarZ) return;
                        var r = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), o = e1 - r * this._helper._pixelPerMeter / Math.cos(i), s = r < 0 ? o : e1, n = Math.PI / 2 + this.pitchInRadians, l = t.ap(this.fov) * (Math.abs(Math.cos(t.ap(this.roll))) * this.height + Math.abs(Math.sin(t.ap(this.roll))) * this.width) / this.height * (.5 + a.y / this.height), _$c = Math.sin(l) * s / Math.sin(t.an(Math.PI - n - l, .01, Math.PI - .01)), h = ge(this), u = Math.atan(h / this._helper.cameraToCenterDistance), d = t.ap(.75), _ = u > d ? 2 * u * (.5 + a.y / (2 * h)) : d, p = Math.sin(_) * s / Math.sin(t.an(Math.PI - n - _, .01, Math.PI - .01)), m = Math.min(_$c, p);
                        this._helper._farZ = 1.01 * (Math.cos(Math.PI / 2 - i) * m + s), this._helper._nearZ = this._helper._height / 50;
                    }
                },
                {
                    key: "_calcMatrices",
                    value: function _calcMatrices() {
                        if (!this._helper._height) return;
                        var _$e = this.centerOffset, i = me(this.worldSize, this.center), a = i.x, r = i.y;
                        this._helper._pixelPerMeter = t.as(1, this.center.lat) * this.worldSize;
                        var o = t.ap(Math.min(this.pitch, pe)), s = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(o));
                        var n;
                        this._calculateNearFarZIfNeeded(s, o, _$e), n = new Float64Array(16), t.be(n, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = new Float64Array(16), t.aB(this._invProjMatrix, n), n[8] = 2 * -_$e.x / this._helper._width, n[9] = 2 * _$e.y / this._helper._height, this._projectionMatrix = t.bf(n), t.Q(n, n, [
                            1,
                            -1,
                            1
                        ]), t.O(n, n, [
                            0,
                            0,
                            -this._helper.cameraToCenterDistance
                        ]), t.bg(n, n, -this.rollInRadians), t.bh(n, n, this.pitchInRadians), t.bg(n, n, -this.bearingInRadians), t.O(n, n, [
                            -a,
                            -r,
                            0
                        ]), this._mercatorMatrix = t.Q([], n, [
                            this.worldSize,
                            this.worldSize,
                            this.worldSize
                        ]), t.Q(n, n, [
                            1,
                            1,
                            this._helper._pixelPerMeter
                        ]), this._pixelMatrix = t.S(new Float64Array(16), this.clipSpaceToPixelsMatrix, n), t.O(n, n, [
                            0,
                            0,
                            -this.elevation
                        ]), this._viewProjMatrix = n, this._invViewProjMatrix = t.aB([], n);
                        var l = [
                            0,
                            0,
                            -1,
                            1
                        ];
                        t.aH(l, l, this._invViewProjMatrix), this._cameraPosition = [
                            l[0] / l[3],
                            l[1] / l[3],
                            l[2] / l[3]
                        ], this._fogMatrix = new Float64Array(16), t.be(this._fogMatrix, this.fovInRadians, this.width / this.height, s, this._helper._farZ), this._fogMatrix[8] = 2 * -_$e.x / this.width, this._fogMatrix[9] = 2 * _$e.y / this.height, t.Q(this._fogMatrix, this._fogMatrix, [
                            1,
                            -1,
                            1
                        ]), t.O(this._fogMatrix, this._fogMatrix, [
                            0,
                            0,
                            -this.cameraToCenterDistance
                        ]), t.bg(this._fogMatrix, this._fogMatrix, -this.rollInRadians), t.bh(this._fogMatrix, this._fogMatrix, this.pitchInRadians), t.bg(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), t.O(this._fogMatrix, this._fogMatrix, [
                            -a,
                            -r,
                            0
                        ]), t.Q(this._fogMatrix, this._fogMatrix, [
                            1,
                            1,
                            this._helper._pixelPerMeter
                        ]), t.O(this._fogMatrix, this._fogMatrix, [
                            0,
                            0,
                            -this.elevation
                        ]), this._pixelMatrix3D = t.S(new Float64Array(16), this.clipSpaceToPixelsMatrix, n);
                        var _$c = this._helper._width % 2 / 2, h = this._helper._height % 2 / 2, u = Math.cos(this.bearingInRadians), d = Math.sin(-this.bearingInRadians), _ = a - Math.round(a) + u * _$c + d * h, p = r - Math.round(r) + u * h + d * _$c, m = new Float64Array(n);
                        if (t.O(m, m, [
                            _ > .5 ? _ - 1 : _,
                            p > .5 ? p - 1 : p,
                            0
                        ]), this._alignedProjMatrix = m, n = t.aB(new Float64Array(16), this._pixelMatrix), !n) throw new Error("failed to invert matrix");
                        this._pixelMatrixInverse = n, this._clearMatrixCaches();
                    }
                },
                {
                    key: "_clearMatrixCaches",
                    value: function _clearMatrixCaches() {
                        this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
                    }
                },
                {
                    key: "maxPitchScaleFactor",
                    value: function maxPitchScaleFactor() {
                        if (!this._pixelMatrixInverse) return 1;
                        var _$e = this.screenPointToMercatorCoordinate(new t.P(0, 0)), i = [
                            _$e.x * this.worldSize,
                            _$e.y * this.worldSize,
                            0,
                            1
                        ];
                        return t.aH(i, i, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
                    }
                },
                {
                    key: "getCameraPoint",
                    value: function getCameraPoint() {
                        return this._helper.getCameraPoint();
                    }
                },
                {
                    key: "getCameraAltitude",
                    value: function getCameraAltitude() {
                        return this._helper.getCameraAltitude();
                    }
                },
                {
                    key: "getCameraLngLat",
                    value: function getCameraLngLat() {
                        var _$e = t.as(1, this.center.lat) * this.worldSize;
                        return xe(this.center, this.elevation, this.pitch, this.bearing, this._helper.cameraToCenterDistance / _$e).toLngLat();
                    }
                },
                {
                    key: "lngLatToCameraDepth",
                    value: function lngLatToCameraDepth(e1, i) {
                        var a = t.a9.fromLngLat(e1), r = [
                            a.x * this.worldSize,
                            a.y * this.worldSize,
                            i,
                            1
                        ];
                        return t.aH(r, r, this._viewProjMatrix), r[2] / r[3];
                    }
                },
                {
                    key: "getProjectionData",
                    value: function getProjectionData(e1) {
                        var i = e1.overscaledTileID, a = e1.aligned, r = e1.applyTerrainMatrix, o = this._helper.getMercatorTileCoordinates(i), s = i ? this.calculatePosMatrix(i, a, !0) : null;
                        var n;
                        return n = i && i.terrainRttPosMatrix32f && r ? i.terrainRttPosMatrix32f : s || t.bi(), {
                            mainMatrix: n,
                            tileMercatorCoords: o,
                            clippingPlane: [
                                0,
                                0,
                                0,
                                0
                            ],
                            projectionTransition: 0,
                            fallbackMatrix: n
                        };
                    }
                },
                {
                    key: "isLocationOccluded",
                    value: function isLocationOccluded(e1) {
                        return !1;
                    }
                },
                {
                    key: "getPixelScale",
                    value: function getPixelScale() {
                        return 1;
                    }
                },
                {
                    key: "getCircleRadiusCorrection",
                    value: function getCircleRadiusCorrection() {
                        return 1;
                    }
                },
                {
                    key: "getPitchedTextCorrection",
                    value: function getPitchedTextCorrection(e1, t, i) {
                        return 1;
                    }
                },
                {
                    key: "transformLightDirection",
                    value: function transformLightDirection(e1) {
                        return t.b1(e1);
                    }
                },
                {
                    key: "getRayDirectionFromPixel",
                    value: function getRayDirectionFromPixel(e1) {
                        throw new Error("Not implemented.");
                    }
                },
                {
                    key: "projectTileCoordinates",
                    value: function projectTileCoordinates(e1, i, a, r) {
                        var o = this.calculatePosMatrix(a);
                        var s;
                        r ? (s = [
                            e1,
                            i,
                            r(e1, i),
                            1
                        ], t.aH(s, s, o)) : (s = [
                            e1,
                            i,
                            0,
                            1
                        ], ot(s, s, o));
                        var n = s[3];
                        return {
                            point: new t.P(s[0] / n, s[1] / n),
                            signedDistanceFromCamera: n,
                            isOccluded: !1
                        };
                    }
                },
                {
                    key: "populateCache",
                    value: function populateCache(e1) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                this.calculatePosMatrix(_$t);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "getMatrixForModel",
                    value: function getMatrixForModel(e1, i) {
                        var a = t.a9.fromLngLat(e1, i), r = a.meterInMercatorCoordinateUnits(), o = t.bj();
                        return t.O(o, o, [
                            a.x,
                            a.y,
                            a.z
                        ]), t.bg(o, o, Math.PI), t.bh(o, o, Math.PI / 2), t.Q(o, o, [
                            -r,
                            r,
                            r
                        ]), o;
                    }
                },
                {
                    key: "getProjectionDataForCustomLayer",
                    value: function getProjectionDataForCustomLayer() {
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                        var i = new t.a2(0, 0, 0, 0, 0), a = this.getProjectionData({
                            overscaledTileID: i,
                            applyGlobeMatrix: _$e
                        }), r = ve(i, this.worldSize);
                        t.S(r, this._viewProjMatrix, r), a.tileMercatorCoords = [
                            0,
                            0,
                            1,
                            1
                        ];
                        var o = [
                            t.a5,
                            t.a5,
                            this.worldSize / this._helper.pixelsPerMeter
                        ], s = t.bk();
                        return t.Q(s, r, o), a.fallbackMatrix = s, a.mainMatrix = s, a;
                    }
                },
                {
                    key: "getFastPathSimpleProjectionMatrix",
                    value: function getFastPathSimpleProjectionMatrix(e1) {
                        return this.calculatePosMatrix(e1);
                    }
                }
            ]);
            return $t;
        }();
        function Ht() {
            t.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
        }
        function Xt(e1) {
            if (e1.useSlerp) {
                if (e1.k < 1) {
                    var i = t.bl(e1.startEulerAngles.roll, e1.startEulerAngles.pitch, e1.startEulerAngles.bearing), a = t.bl(e1.endEulerAngles.roll, e1.endEulerAngles.pitch, e1.endEulerAngles.bearing), r = new Float64Array(4);
                    t.bm(r, i, a, e1.k);
                    var o = t.bn(r);
                    e1.tr.setRoll(o.roll), e1.tr.setPitch(o.pitch), e1.tr.setBearing(o.bearing);
                } else e1.tr.setRoll(e1.endEulerAngles.roll), e1.tr.setPitch(e1.endEulerAngles.pitch), e1.tr.setBearing(e1.endEulerAngles.bearing);
            } else e1.tr.setRoll(t.G.number(e1.startEulerAngles.roll, e1.endEulerAngles.roll, e1.k)), e1.tr.setPitch(t.G.number(e1.startEulerAngles.pitch, e1.endEulerAngles.pitch, e1.k)), e1.tr.setBearing(t.G.number(e1.startEulerAngles.bearing, e1.endEulerAngles.bearing, e1.k));
        }
        function Kt(e1, i, a, r, o) {
            var s = o.padding, n = me(o.worldSize, a.getNorthWest()), l = me(o.worldSize, a.getNorthEast()), _$c = me(o.worldSize, a.getSouthEast()), h = me(o.worldSize, a.getSouthWest()), u = t.ap(-r), d = n.rotate(u), _ = l.rotate(u), p = _$c.rotate(u), m = h.rotate(u), f = new t.P(Math.max(d.x, _.x, m.x, p.x), Math.max(d.y, _.y, m.y, p.y)), g = new t.P(Math.min(d.x, _.x, m.x, p.x), Math.min(d.y, _.y, m.y, p.y)), v = f.sub(g), x = (o.width - (s.left + s.right + i.left + i.right)) / v.x, b = (o.height - (s.top + s.bottom + i.top + i.bottom)) / v.y;
            if (b < 0 || x < 0) return void Ht();
            var y = Math.min(t.at(o.scale * Math.min(x, b)), e1.maxZoom), w = t.P.convert(e1.offset), T = new t.P((i.left - i.right) / 2, (i.top - i.bottom) / 2).rotate(t.ap(r)), P = w.add(T).mult(o.scale / t.aq(y));
            return {
                center: fe(o.worldSize, n.add(_$c).div(2).sub(P)),
                zoom: y,
                bearing: r
            };
        }
        var Yt = /*#__PURE__*/ function() {
            function Yt() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Yt);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Yt, [
                {
                    key: "useGlobeControls",
                    get: function get() {
                        return !1;
                    }
                },
                {
                    key: "handlePanInertia",
                    value: function handlePanInertia(e1, t) {
                        var i = e1.mag(), a = Math.abs(ge(t));
                        return {
                            easingOffset: e1.mult(Math.min(.75 * a / i, 1)),
                            easingCenter: t.center
                        };
                    }
                },
                {
                    key: "handleMapControlsRollPitchBearingZoom",
                    value: function handleMapControlsRollPitchBearingZoom(e1, t) {
                        e1.bearingDelta && t.setBearing(t.bearing + e1.bearingDelta), e1.pitchDelta && t.setPitch(t.pitch + e1.pitchDelta), e1.rollDelta && t.setRoll(t.roll + e1.rollDelta), e1.zoomDelta && t.setZoom(t.zoom + e1.zoomDelta);
                    }
                },
                {
                    key: "handleMapControlsPan",
                    value: function handleMapControlsPan(e1, t, i) {
                        e1.around.distSqr(t.centerPoint) < .01 || t.setLocationAtPoint(i, e1.around);
                    }
                },
                {
                    key: "cameraForBoxAndBearing",
                    value: function cameraForBoxAndBearing(e1, t, i, a, r) {
                        return Kt(e1, t, i, a, r);
                    }
                },
                {
                    key: "handleJumpToCenterZoom",
                    value: function handleJumpToCenterZoom(e1, i) {
                        e1.zoom !== (void 0 !== i.zoom ? +i.zoom : e1.zoom) && e1.setZoom(+i.zoom), void 0 !== i.center && e1.setCenter(t.V.convert(i.center));
                    }
                },
                {
                    key: "handleEaseTo",
                    value: function handleEaseTo(e1, i) {
                        var a = e1.zoom, r = e1.padding, o = {
                            roll: e1.roll,
                            pitch: e1.pitch,
                            bearing: e1.bearing
                        }, s = {
                            roll: void 0 === i.roll ? e1.roll : i.roll,
                            pitch: void 0 === i.pitch ? e1.pitch : i.pitch,
                            bearing: void 0 === i.bearing ? e1.bearing : i.bearing
                        }, n = void 0 !== i.zoom, l = !e1.isPaddingEqual(i.padding);
                        var _$c = !1;
                        var h = n ? +i.zoom : e1.zoom;
                        var u = e1.centerPoint.add(i.offsetAsPoint);
                        var d = e1.screenPointToLocation(u), _e_applyConstrain = e1.applyConstrain(t.V.convert(i.center || d), null != h ? h : a), _ = _e_applyConstrain.center, p = _e_applyConstrain.zoom;
                        Zt(e1, _);
                        var m = me(e1.worldSize, d), f = me(e1.worldSize, _).sub(m), g = t.aq(p - a);
                        return _$c = p !== a, {
                            easeFunc: function(n) {
                                if (_$c && e1.setZoom(t.G.number(a, p, n)), t.bo(o, s) || Xt({
                                    startEulerAngles: o,
                                    endEulerAngles: s,
                                    tr: e1,
                                    k: n,
                                    useSlerp: o.roll != s.roll
                                }), l && (e1.interpolatePadding(r, i.padding, n), u = e1.centerPoint.add(i.offsetAsPoint)), i.around) e1.setLocationAtPoint(i.around, i.aroundPoint);
                                else {
                                    var _$i = t.aq(e1.zoom - a), r1 = p > a ? Math.min(2, g) : Math.max(.5, g), o1 = Math.pow(r1, 1 - n), s1 = fe(e1.worldSize, m.add(f.mult(n * o1)).mult(_$i));
                                    e1.setLocationAtPoint(e1.renderWorldCopies ? s1.wrap() : s1, u);
                                }
                            },
                            isZooming: _$c,
                            elevationCenter: _
                        };
                    }
                },
                {
                    key: "handleFlyTo",
                    value: function handleFlyTo(e1, i) {
                        var a = void 0 !== i.zoom, r = e1.zoom, o = e1.applyConstrain(t.V.convert(i.center || i.locationAtOffset), a ? +i.zoom : r), s = o.center, n = o.zoom;
                        Zt(e1, s);
                        var l = me(e1.worldSize, i.locationAtOffset), _$c = me(e1.worldSize, s).sub(l), h = _$c.mag(), u = t.aq(n - r);
                        var d;
                        if (void 0 !== i.minZoom) {
                            var a1 = Math.min(+i.minZoom, r, n), o1 = e1.applyConstrain(s, a1).zoom;
                            d = t.aq(o1 - r);
                        }
                        return {
                            easeFunc: function(i, a, o, h) {
                                e1.setZoom(1 === i ? n : r + t.at(a));
                                var u = 1 === i ? s : fe(e1.worldSize, l.add(_$c.mult(o)).mult(a));
                                e1.setLocationAtPoint(e1.renderWorldCopies ? u.wrap() : u, h);
                            },
                            scaleOfZoom: u,
                            targetCenter: s,
                            scaleOfMinZoom: d,
                            pixelPathLength: h
                        };
                    }
                }
            ]);
            return Yt;
        }();
        var Qt = function Qt(e1, t, i) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, Qt);
            this.blendFunction = e1, this.blendColor = t, this.mask = i;
        };
        Qt.Replace = [
            1,
            0
        ], Qt.disabled = new Qt(Qt.Replace, t.bp.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Qt.unblended = new Qt(Qt.Replace, t.bp.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Qt.alphaBlended = new Qt([
            1,
            771
        ], t.bp.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        var Jt = 2305;
        var ei = function ei(e1, t, i) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, ei);
            this.enable = e1, this.mode = t, this.frontFace = i;
        };
        ei.disabled = new ei(!1, 1029, Jt), ei.backCCW = new ei(!0, 1029, Jt), ei.frontCCW = new ei(!0, 1028, Jt);
        var ti = function ti(e1, t, i) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, ti);
            this.func = e1, this.mask = t, this.range = i;
        };
        ti.ReadOnly = !1, ti.ReadWrite = !0, ti.disabled = new ti(519, ti.ReadOnly, [
            0,
            1
        ]);
        var ii = 7680;
        var ai = function ai(e1, t, i, a, r, o) {
            (0, $7417b380464c38c1$export$71511d61b312f219)(this, ai);
            this.test = e1, this.ref = t, this.mask = i, this.fail = a, this.depthFail = r, this.pass = o;
        };
        ai.disabled = new ai({
            func: 519,
            mask: 0
        }, 0, 0, ii, ii, ii);
        var ri = new WeakMap;
        function oi(e1) {
            var _$t;
            if (ri.has(e1)) return ri.get(e1);
            {
                var i = null === (_$t = e1.getParameter(e1.VERSION)) || void 0 === _$t ? void 0 : _$t.startsWith("WebGL 2.0");
                return ri.set(e1, i), i;
            }
        }
        var si = /*#__PURE__*/ function() {
            function si(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, si);
                this._readbackWaitFrames = 4, this._measureWaitFrames = 6, this._texWidth = 1, this._texHeight = 1, this._measuredError = 0, this._updateCount = 0, this._lastReadbackFrame = -1000, this._readbackQueue = null, this._cachedRenderContext = e1;
                var i = e1.context, a = i.gl;
                this._texFormat = a.RGBA, this._texType = a.UNSIGNED_BYTE;
                var r = new t.aW;
                r.emplaceBack(-1, -1), r.emplaceBack(2, -1), r.emplaceBack(-1, 2);
                var o = new t.aY;
                o.emplaceBack(0, 1, 2), this._fullscreenTriangle = new kt(i.createVertexBuffer(r, Ft.members), i.createIndexBuffer(o), t.aX.simpleSegment(0, 0, r.length, o.length)), this._resultBuffer = new Uint8Array(4), i.activeTexture.set(a.TEXTURE1);
                var s = a.createTexture();
                a.bindTexture(a.TEXTURE_2D, s), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, a.CLAMP_TO_EDGE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, a.NEAREST), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, a.NEAREST), a.texImage2D(a.TEXTURE_2D, 0, this._texFormat, this._texWidth, this._texHeight, 0, this._texFormat, this._texType, null), this._fbo = i.createFramebuffer(this._texWidth, this._texHeight, !1, !1), this._fbo.colorAttachment.set(s), oi(a) && (this._pbo = a.createBuffer(), a.bindBuffer(a.PIXEL_PACK_BUFFER, this._pbo), a.bufferData(a.PIXEL_PACK_BUFFER, 4, a.STREAM_READ), a.bindBuffer(a.PIXEL_PACK_BUFFER, null));
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(si, [
                {
                    key: "awaitingQuery",
                    get: function get() {
                        return !!this._readbackQueue;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        var _$e = this._cachedRenderContext.context.gl;
                        this._fullscreenTriangle.destroy(), this._fbo.destroy(), _$e.deleteBuffer(this._pbo), this._fullscreenTriangle = null, this._fbo = null, this._pbo = null, this._resultBuffer = null;
                    }
                },
                {
                    key: "updateErrorLoop",
                    value: function updateErrorLoop(e1, t) {
                        var i = this._updateCount;
                        return this._readbackQueue ? i >= this._readbackQueue.frameNumberIssued + this._readbackWaitFrames && this._tryReadback() : i >= this._lastReadbackFrame + this._measureWaitFrames && this._renderErrorTexture(e1, t), this._updateCount++, this._measuredError;
                    }
                },
                {
                    key: "_bindFramebuffer",
                    value: function _bindFramebuffer() {
                        var _$e = this._cachedRenderContext.context, _$t = _$e.gl;
                        _$e.activeTexture.set(_$t.TEXTURE1), _$t.bindTexture(_$t.TEXTURE_2D, this._fbo.colorAttachment.get()), _$e.bindFramebuffer.set(this._fbo.framebuffer);
                    }
                },
                {
                    key: "_renderErrorTexture",
                    value: function _renderErrorTexture(e1, i) {
                        var a = this._cachedRenderContext.context, r = a.gl;
                        if (this._bindFramebuffer(), a.viewport.set([
                            0,
                            0,
                            this._texWidth,
                            this._texHeight
                        ]), a.clear({
                            color: t.bp.transparent
                        }), this._cachedRenderContext.useProgram("projectionErrorMeasurement").draw(a, r.TRIANGLES, ti.disabled, ai.disabled, Qt.unblended, ei.disabled, function(e1, t) {
                            return {
                                u_input: e1,
                                u_output_expected: t
                            };
                        }(e1, i), null, null, "$clipping", this._fullscreenTriangle.vertexBuffer, this._fullscreenTriangle.indexBuffer, this._fullscreenTriangle.segments), this._pbo && oi(r)) {
                            r.bindBuffer(r.PIXEL_PACK_BUFFER, this._pbo), r.readBuffer(r.COLOR_ATTACHMENT0), r.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, 0), r.bindBuffer(r.PIXEL_PACK_BUFFER, null);
                            var _$e = r.fenceSync(r.SYNC_GPU_COMMANDS_COMPLETE, 0);
                            r.flush(), this._readbackQueue = {
                                frameNumberIssued: this._updateCount,
                                sync: _$e
                            };
                        } else this._readbackQueue = {
                            frameNumberIssued: this._updateCount,
                            sync: null
                        };
                    }
                },
                {
                    key: "_tryReadback",
                    value: function _tryReadback() {
                        var _$e = this._cachedRenderContext.context.gl;
                        if (this._pbo && this._readbackQueue && oi(_$e)) {
                            var i = _$e.clientWaitSync(this._readbackQueue.sync, 0, 0);
                            if (i === _$e.WAIT_FAILED) return t.w("WebGL2 clientWaitSync failed."), this._readbackQueue = null, void (this._lastReadbackFrame = this._updateCount);
                            if (i === _$e.TIMEOUT_EXPIRED) return;
                            _$e.bindBuffer(_$e.PIXEL_PACK_BUFFER, this._pbo), _$e.getBufferSubData(_$e.PIXEL_PACK_BUFFER, 0, this._resultBuffer, 0, 4), _$e.bindBuffer(_$e.PIXEL_PACK_BUFFER, null);
                        } else this._bindFramebuffer(), _$e.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, this._resultBuffer);
                        this._readbackQueue = null, this._measuredError = si._parseRGBA8float(this._resultBuffer), this._lastReadbackFrame = this._updateCount;
                    }
                }
            ], [
                {
                    key: "_parseRGBA8float",
                    value: function _parseRGBA8float(e1) {
                        var _$t = 0;
                        return _$t += e1[0] / 256, _$t += e1[1] / 65536, _$t += e1[2] / 16777216, e1[3] < 127 && (_$t = -_$t), _$t / 128;
                    }
                }
            ]);
            return si;
        }();
        var ni = t.a5 / 128;
        function li(e1, i) {
            var a = void 0 !== e1.granularity ? Math.max(e1.granularity, 1) : 1, r = a + (e1.generateBorders ? 2 : 0), o = a + (e1.extendToNorthPole || e1.generateBorders ? 1 : 0) + (e1.extendToSouthPole || e1.generateBorders ? 1 : 0), s = r + 1, n = o + 1, l = e1.generateBorders ? -1 : 0, _$c = e1.generateBorders || e1.extendToNorthPole ? -1 : 0, h = a + (e1.generateBorders ? 1 : 0), u = a + (e1.generateBorders || e1.extendToSouthPole ? 1 : 0), d = s * n, _ = r * o * 6, p = s * n > 65536;
            if (p && "16bit" === i) throw new Error("Granularity is too large and meshes would not fit inside 16 bit vertex indices.");
            var m = p || "32bit" === i, f = new Int16Array(2 * d);
            var g = 0;
            for(var _$i = _$c; _$i <= u; _$i++)for(var r1 = l; r1 <= h; r1++){
                var o1 = r1 / a * t.a5;
                -1 === r1 && (o1 = -ni), r1 === a + 1 && (o1 = t.a5 + ni);
                var s1 = _$i / a * t.a5;
                -1 === _$i && (s1 = e1.extendToNorthPole ? t.br : -ni), _$i === a + 1 && (s1 = e1.extendToSouthPole ? t.bs : t.a5 + ni), f[g++] = o1, f[g++] = s1;
            }
            var v = m ? new Uint32Array(_) : new Uint16Array(_);
            var x = 0;
            for(var _$e = 0; _$e < o; _$e++)for(var _$t = 0; _$t < r; _$t++){
                var _$i1 = _$t + 1 + _$e * s, a1 = _$t + (_$e + 1) * s, r2 = _$t + 1 + (_$e + 1) * s;
                v[x++] = _$t + _$e * s, v[x++] = a1, v[x++] = _$i1, v[x++] = _$i1, v[x++] = a1, v[x++] = r2;
            }
            return {
                vertices: f.buffer.slice(0),
                indices: v.buffer.slice(0),
                uses32bitIndices: m
            };
        }
        var ci = new t.aV({
            fill: new t.bt(128, 2),
            line: new t.bt(512, 0),
            tile: new t.bt(128, 32),
            stencil: new t.bt(128, 1),
            circle: 3
        });
        var hi = /*#__PURE__*/ function() {
            function hi() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, hi);
                this._tileMeshCache = {}, this._errorCorrectionUsable = 0, this._errorMeasurementLastValue = 0, this._errorCorrectionPreviousValue = 0, this._errorMeasurementLastChangeTime = -1000;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(hi, [
                {
                    key: "name",
                    get: function get() {
                        return "vertical-perspective";
                    }
                },
                {
                    key: "transitionState",
                    get: function get() {
                        return 1;
                    }
                },
                {
                    key: "useSubdivision",
                    get: function get() {
                        return !0;
                    }
                },
                {
                    key: "shaderVariantName",
                    get: function get() {
                        return "globe";
                    }
                },
                {
                    key: "shaderDefine",
                    get: function get() {
                        return "#define GLOBE";
                    }
                },
                {
                    key: "shaderPreludeCode",
                    get: function get() {
                        return At.projectionGlobe;
                    }
                },
                {
                    key: "vertexShaderPreludeCode",
                    get: function get() {
                        return At.projectionMercator.vertexSource;
                    }
                },
                {
                    key: "subdivisionGranularity",
                    get: function get() {
                        return ci;
                    }
                },
                {
                    key: "useGlobeControls",
                    get: function get() {
                        return !0;
                    }
                },
                {
                    key: "latitudeErrorCorrectionRadians",
                    get: function get() {
                        return this._errorCorrectionUsable;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this._errorMeasurement && this._errorMeasurement.destroy();
                    }
                },
                {
                    key: "updateGPUdependent",
                    value: function updateGPUdependent(e1) {
                        this._errorMeasurement || (this._errorMeasurement = new si(e1));
                        var i = t.X(this._errorQueryLatitudeDegrees), a = 2 * Math.atan(Math.exp(Math.PI - i * Math.PI * 2)) - .5 * Math.PI, r = this._errorMeasurement.updateErrorLoop(i, a), o = c();
                        r !== this._errorMeasurementLastValue && (this._errorCorrectionPreviousValue = this._errorCorrectionUsable, this._errorMeasurementLastValue = r, this._errorMeasurementLastChangeTime = o);
                        var s = Math.min(Math.max((o - this._errorMeasurementLastChangeTime) / 1e3 / .5, 0), 1);
                        this._errorCorrectionUsable = t.bu(this._errorCorrectionPreviousValue, -this._errorMeasurementLastValue, t.bv(s));
                    }
                },
                {
                    key: "_getMeshKey",
                    value: function _getMeshKey(e1) {
                        return "".concat(e1.granularity.toString(36), "_").concat(e1.generateBorders ? "b" : "").concat(e1.extendToNorthPole ? "n" : "").concat(e1.extendToSouthPole ? "s" : "");
                    }
                },
                {
                    key: "getMeshFromTileID",
                    value: function getMeshFromTileID(e1, t, i, a, r) {
                        var o = ("stencil" === r ? ci.stencil : ci.tile).getGranularityForZoomLevel(t.z);
                        return this._getMesh(e1, {
                            granularity: o,
                            generateBorders: i,
                            extendToNorthPole: 0 === t.y && a,
                            extendToSouthPole: t.y === (1 << t.z) - 1 && a
                        });
                    }
                },
                {
                    key: "_getMesh",
                    value: function _getMesh(e1, i) {
                        var a = this._getMeshKey(i);
                        if (a in this._tileMeshCache) return this._tileMeshCache[a];
                        var r = function(e1, i) {
                            var a = li(i, "16bit"), r = t.aW.deserialize({
                                arrayBuffer: a.vertices,
                                length: a.vertices.byteLength / 2 / 2
                            }), o = t.aY.deserialize({
                                arrayBuffer: a.indices,
                                length: a.indices.byteLength / 2 / 3
                            });
                            return new kt(e1.createVertexBuffer(r, Ft.members), e1.createIndexBuffer(o), t.aX.simpleSegment(0, 0, r.length, o.length));
                        }(e1, i);
                        return this._tileMeshCache[a] = r, r;
                    }
                },
                {
                    key: "recalculate",
                    value: function recalculate(e1) {}
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        var _$e = c();
                        var _$t = !1;
                        return _$t = _$t || (_$e - this._errorMeasurementLastChangeTime) / 1e3 < .7, _$t = _$t || this._errorMeasurement && this._errorMeasurement.awaitingQuery, _$t;
                    }
                },
                {
                    key: "setErrorQueryLatitudeDegrees",
                    value: function setErrorQueryLatitudeDegrees(e1) {
                        this._errorQueryLatitudeDegrees = e1;
                    }
                }
            ]);
            return hi;
        }();
        var ui = new t.t({
            type: new t.D(t.u.projection.type)
        });
        var di = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(di, _t_E);
            function di(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, di);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, di), _this._transitionable = new t.x(ui, void 0), _this.setProjection(e1), _this._transitioning = _this._transitionable.untransitioned(), _this.recalculate(new t.H(0)), _this._mercatorProjection = new jt, _this._verticalPerspectiveProjection = new hi;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(di, [
                {
                    key: "transitionState",
                    get: function get() {
                        var _$e = this.properties.get("type");
                        if ("string" == typeof _$e && "mercator" === _$e) return 0;
                        if ("string" == typeof _$e && "vertical-perspective" === _$e) return 1;
                        if (_$e instanceof t.bw) {
                            if ("vertical-perspective" === _$e.from && "mercator" === _$e.to) return 1 - _$e.transition;
                            if ("mercator" === _$e.from && "vertical-perspective" === _$e.to) return _$e.transition;
                        }
                        return 1;
                    }
                },
                {
                    key: "useGlobeRendering",
                    get: function get() {
                        return this.transitionState > 0;
                    }
                },
                {
                    key: "latitudeErrorCorrectionRadians",
                    get: function get() {
                        return this._verticalPerspectiveProjection.latitudeErrorCorrectionRadians;
                    }
                },
                {
                    key: "currentProjection",
                    get: function get() {
                        return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
                    }
                },
                {
                    key: "name",
                    get: function get() {
                        return "globe";
                    }
                },
                {
                    key: "useSubdivision",
                    get: function get() {
                        return this.currentProjection.useSubdivision;
                    }
                },
                {
                    key: "shaderVariantName",
                    get: function get() {
                        return this.currentProjection.shaderVariantName;
                    }
                },
                {
                    key: "shaderDefine",
                    get: function get() {
                        return this.currentProjection.shaderDefine;
                    }
                },
                {
                    key: "shaderPreludeCode",
                    get: function get() {
                        return this.currentProjection.shaderPreludeCode;
                    }
                },
                {
                    key: "vertexShaderPreludeCode",
                    get: function get() {
                        return this.currentProjection.vertexShaderPreludeCode;
                    }
                },
                {
                    key: "subdivisionGranularity",
                    get: function get() {
                        return this.currentProjection.subdivisionGranularity;
                    }
                },
                {
                    key: "useGlobeControls",
                    get: function get() {
                        return this.transitionState > 0;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
                    }
                },
                {
                    key: "updateGPUdependent",
                    value: function updateGPUdependent(e1) {
                        this._mercatorProjection.updateGPUdependent(e1), this._verticalPerspectiveProjection.updateGPUdependent(e1);
                    }
                },
                {
                    key: "getMeshFromTileID",
                    value: function getMeshFromTileID(e1, t, i, a, r) {
                        return this.currentProjection.getMeshFromTileID(e1, t, i, a, r);
                    }
                },
                {
                    key: "setProjection",
                    value: function setProjection(e1) {
                        this._transitionable.setValue("type", (null == e1 ? void 0 : e1.type) || "mercator");
                    }
                },
                {
                    key: "updateTransitions",
                    value: function updateTransitions(e1) {
                        this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
                    }
                },
                {
                    key: "hasTransition",
                    value: function hasTransition() {
                        return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
                    }
                },
                {
                    key: "recalculate",
                    value: function recalculate(e1) {
                        this.properties = this._transitioning.possiblyEvaluate(e1);
                    }
                },
                {
                    key: "setErrorQueryLatitudeDegrees",
                    value: function setErrorQueryLatitudeDegrees(e1) {
                        this._verticalPerspectiveProjection.setErrorQueryLatitudeDegrees(e1), this._mercatorProjection.setErrorQueryLatitudeDegrees(e1);
                    }
                }
            ]);
            return di;
        }(t.E);
        function _i(e1) {
            var _$t = fi(e1.worldSize, e1.center.lat);
            return 2 * Math.PI * _$t;
        }
        function pi(e1, i, a, r, o) {
            var s = 1 / (1 << o), n = i / t.a5 * s + r * s, l = t.by((e1 / t.a5 * s + a * s) * Math.PI * 2 + Math.PI, 2 * Math.PI), _$c = 2 * Math.atan(Math.exp(Math.PI - n * Math.PI * 2)) - .5 * Math.PI, h = Math.cos(_$c), u = new Float64Array(3);
            return u[0] = Math.sin(l) * h, u[1] = Math.sin(_$c), u[2] = Math.cos(l) * h, u;
        }
        function mi(e1) {
            return function(e1, t) {
                var i = Math.cos(t), a = new Float64Array(3);
                return a[0] = Math.sin(e1) * i, a[1] = Math.sin(t), a[2] = Math.cos(e1) * i, a;
            }(e1.lng * Math.PI / 180, e1.lat * Math.PI / 180);
        }
        function fi(e1, t) {
            return e1 / (2 * Math.PI) / Math.cos(t * Math.PI / 180);
        }
        function gi(e1) {
            var i = Math.asin(e1[1]) / Math.PI * 180, a = Math.sqrt(e1[0] * e1[0] + e1[2] * e1[2]);
            if (a > 1e-6) {
                var r = e1[0] / a, o = Math.acos(e1[2] / a), s = (r > 0 ? o : -o) / Math.PI * 180;
                return new t.V(t.W(s, -180, 180), i);
            }
            return new t.V(0, i);
        }
        function vi(e1) {
            return Math.cos(e1 * Math.PI / 180);
        }
        function xi(e1, i) {
            var a = vi(e1), r = vi(i);
            return t.at(r / a);
        }
        function bi(e1, i) {
            var a = e1.rotate(i.bearingInRadians), r = i.zoom + xi(i.center.lat, 0), o = t.bu(1 / vi(i.center.lat), 1 / vi(Math.min(Math.abs(i.center.lat), 60)), t.bx(r, 7, 3, 0, 1)), s = 360 / _i({
                worldSize: i.worldSize,
                center: {
                    lat: i.center.lat
                }
            });
            return new t.V(i.center.lng - a.x * s * o, t.an(i.center.lat + a.y * s, -t.ao, t.ao));
        }
        function yi(e1) {
            var _$t = .5 * e1, i = Math.sin(_$t), a = Math.cos(_$t);
            return Math.log(i + a) - Math.log(a - i);
        }
        function wi(e1, i, a, r) {
            var o = e1.lat + a * r;
            if (Math.abs(a) > 1) {
                var s = (Math.sign(e1.lat + a) !== Math.sign(e1.lat) ? -Math.abs(e1.lat) : Math.abs(e1.lat)) * Math.PI / 180, n = Math.abs(e1.lat + a) * Math.PI / 180, l = yi(s + r * (n - s)), _$c = yi(s), h = yi(n);
                return new t.V(e1.lng + i * ((l - _$c) / (h - _$c)), o);
            }
            return new t.V(e1.lng + i * r, o);
        }
        var Ti = /*#__PURE__*/ function() {
            function Ti(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ti);
                this._cachePrevious = new Map, this._cache = new Map, this._hadAnyChanges = !1, this._boundingVolumeFactory = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ti, [
                {
                    key: "swapBuffers",
                    value: function swapBuffers() {
                        if (!this._hadAnyChanges) return;
                        var _$e = this._cachePrevious;
                        this._cachePrevious = this._cache, this._cache = _$e, this._cache.clear(), this._hadAnyChanges = !1;
                    }
                },
                {
                    key: "getTileBoundingVolume",
                    value: function getTileBoundingVolume(e1, t, i, a) {
                        var r = "".concat(e1.z, "_").concat(e1.x, "_").concat(e1.y, "_").concat((null == a ? void 0 : a.terrain) ? "t" : ""), o = this._cache.get(r);
                        if (o) return o;
                        var s = this._cachePrevious.get(r);
                        if (s) return this._cache.set(r, s), s;
                        var n = this._boundingVolumeFactory(e1, t, i, a);
                        return this._cache.set(r, n), this._hadAnyChanges = !0, n;
                    }
                }
            ]);
            return Ti;
        }();
        var Pi = /*#__PURE__*/ function() {
            function Pi(e1, t, i, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Pi);
                this.min = i, this.max = a, this.points = e1, this.planes = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Pi, [
                {
                    key: "intersectsFrustum",
                    value: function intersectsFrustum(e1) {
                        var _$t = !0;
                        var i = this.points.length, a = this.planes.length, r = e1.planes.length, o = e1.points.length;
                        for(var a1 = 0; a1 < r; a1++){
                            var r1 = e1.planes[a1];
                            var o1 = 0;
                            for(var _$e = 0; _$e < i; _$e++){
                                var _$t1 = this.points[_$e];
                                r1[0] * _$t1[0] + r1[1] * _$t1[1] + r1[2] * _$t1[2] + r1[3] >= 0 && o1++;
                            }
                            if (0 === o1) return 0;
                            o1 < i && (_$t = !1);
                        }
                        if (_$t) return 2;
                        for(var _$t2 = 0; _$t2 < a; _$t2++){
                            var i1 = this.planes[_$t2];
                            var a2 = 0;
                            for(var _$t3 = 0; _$t3 < o; _$t3++){
                                var r2 = e1.points[_$t3];
                                i1[0] * r2[0] + i1[1] * r2[1] + i1[2] * r2[2] + i1[3] >= 0 && a2++;
                            }
                            if (0 === a2) return 0;
                        }
                        return 1;
                    }
                },
                {
                    key: "intersectsPlane",
                    value: function intersectsPlane(e1) {
                        var _$t = this.points.length;
                        var i = 0;
                        for(var a = 0; a < _$t; a++){
                            var _$t1 = this.points[a];
                            e1[0] * _$t1[0] + e1[1] * _$t1[1] + e1[2] * _$t1[2] + e1[3] >= 0 && i++;
                        }
                        return i === _$t ? 2 : 0 === i ? 0 : 1;
                    }
                }
            ], [
                {
                    key: "fromAabb",
                    value: function fromAabb(e1, t) {
                        var i = [];
                        for(var a = 0; a < 8; a++)i.push([
                            1 & ~a ? e1[0] : t[0],
                            1 == (a >> 1 & 1) ? t[1] : e1[1],
                            1 == (a >> 2 & 1) ? t[2] : e1[2]
                        ]);
                        return new Pi(i, [
                            [
                                -1,
                                0,
                                0,
                                t[0]
                            ],
                            [
                                1,
                                0,
                                0,
                                -e1[0]
                            ],
                            [
                                0,
                                -1,
                                0,
                                t[1]
                            ],
                            [
                                0,
                                1,
                                0,
                                -e1[1]
                            ],
                            [
                                0,
                                0,
                                -1,
                                t[2]
                            ],
                            [
                                0,
                                0,
                                1,
                                -e1[2]
                            ]
                        ], e1, t);
                    }
                },
                {
                    key: "fromCenterSizeAngles",
                    value: function fromCenterSizeAngles(e1, i, a) {
                        var r = t.bB([], a[0], a[1], a[2]), o = t.bC([], [
                            i[0],
                            0,
                            0
                        ], r), s = t.bC([], [
                            0,
                            i[1],
                            0
                        ], r), n = t.bC([], [
                            0,
                            0,
                            i[2]
                        ], r), l = (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(e1), _$c = (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(e1);
                        for(var _$t = 0; _$t < 8; _$t++)for(var _$i = 0; _$i < 3; _$i++){
                            var _$a = e1[_$i] + o[_$i] * (1 & ~_$t ? -1 : 1) + s[_$i] * (1 == (_$t >> 1 & 1) ? 1 : -1) + n[_$i] * (1 == (_$t >> 2 & 1) ? 1 : -1);
                            l[_$i] = Math.min(l[_$i], _$a), _$c[_$i] = Math.max(_$c[_$i], _$a);
                        }
                        var h = [];
                        for(var _$i1 = 0; _$i1 < 8; _$i1++){
                            var _$a1 = (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(e1);
                            t.b0(_$a1, _$a1, t.a$([], o, 1 & ~_$i1 ? -1 : 1)), t.b0(_$a1, _$a1, t.a$([], s, 1 == (_$i1 >> 1 & 1) ? 1 : -1)), t.b0(_$a1, _$a1, t.a$([], n, 1 == (_$i1 >> 2 & 1) ? 1 : -1)), h.push(_$a1);
                        }
                        return new Pi(h, [
                            (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(o).concat([
                                -t.b5(o, h[0])
                            ]),
                            (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(s).concat([
                                -t.b5(s, h[0])
                            ]),
                            (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(n).concat([
                                -t.b5(n, h[0])
                            ]),
                            [
                                -o[0],
                                -o[1],
                                -o[2],
                                -t.b5(o, h[7])
                            ],
                            [
                                -s[0],
                                -s[1],
                                -s[2],
                                -t.b5(s, h[7])
                            ],
                            [
                                -n[0],
                                -n[1],
                                -n[2],
                                -t.b5(n, h[7])
                            ]
                        ], l, _$c);
                    }
                }
            ]);
            return Pi;
        }();
        function Ci(e1, t, i) {
            var a = e1 - t;
            return a < 0 ? -a : Math.max(0, a - i);
        }
        function Ii(e1, t, i, a, r) {
            var o = e1 - i;
            var s;
            return s = o < 0 ? Math.min(-o, 1 + o - r) : o > 1 ? Math.min(Math.max(o - r, 0), 1 - o) : 0, Math.max(s, Ci(t, a, r));
        }
        var Mi = /*#__PURE__*/ function() {
            function Mi() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Mi);
                this._boundingVolumeCache = new Ti(this._computeTileBoundingVolume);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Mi, [
                {
                    key: "prepareNextFrame",
                    value: function prepareNextFrame() {
                        this._boundingVolumeCache.swapBuffers();
                    }
                },
                {
                    key: "distanceToTile2d",
                    value: function distanceToTile2d(e1, t, i, a) {
                        var r = 1 << i.z, o = 1 / r, s = i.x / r, n = i.y / r;
                        var l = 2;
                        return l = Math.min(l, Ii(e1, t, s, n, o)), l = Math.min(l, Ii(e1, t, s + .5, -n - o, o)), l = Math.min(l, Ii(e1, t, s + .5, 2 - n - o, o)), l;
                    }
                },
                {
                    key: "getWrap",
                    value: function getWrap(e1, t, i) {
                        var a = 1 << t.z, r = 1 / a, o = t.x / a, s = Ci(e1.x, o, r), n = Ci(e1.x, o - 1, r), l = Ci(e1.x, o + 1, r), _$c = Math.min(s, n, l);
                        return _$c === l ? 1 : _$c === n ? -1 : 0;
                    }
                },
                {
                    key: "allowVariableZoom",
                    value: function allowVariableZoom(e1, t) {
                        return Ce(e1, t) > 4;
                    }
                },
                {
                    key: "allowWorldCopies",
                    value: function allowWorldCopies() {
                        return !1;
                    }
                },
                {
                    key: "getTileBoundingVolume",
                    value: function getTileBoundingVolume(e1, t, i, a) {
                        return this._boundingVolumeCache.getTileBoundingVolume(e1, t, i, a);
                    }
                },
                {
                    key: "_computeTileBoundingVolume",
                    value: function _computeTileBoundingVolume(e1, i, a, r) {
                        var o, s;
                        var n = 0, l = 0;
                        if (null == r ? void 0 : r.terrain) {
                            var _$c = new t.a2(e1.z, i, e1.z, e1.x, e1.y), h = r.terrain.getMinMaxElevation(_$c);
                            n = null !== (o = h.minElevation) && void 0 !== o ? o : Math.min(0, a), l = null !== (s = h.maxElevation) && void 0 !== s ? s : Math.max(0, a);
                        }
                        if (n /= t.bE, l /= t.bE, n += 1, l += 1, e1.z <= 0) return Pi.fromAabb([
                            -l,
                            -l,
                            -l
                        ], [
                            l,
                            l,
                            l
                        ]);
                        if (1 === e1.z) return Pi.fromAabb([
                            0 === e1.x ? -l : 0,
                            0 === e1.y ? 0 : -l,
                            -l
                        ], [
                            0 === e1.x ? 0 : l,
                            0 === e1.y ? l : 0,
                            l
                        ]);
                        {
                            var _$i = [
                                pi(0, 0, e1.x, e1.y, e1.z),
                                pi(t.a5, 0, e1.x, e1.y, e1.z),
                                pi(t.a5, t.a5, e1.x, e1.y, e1.z),
                                pi(0, t.a5, e1.x, e1.y, e1.z)
                            ], _$a = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = _$i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    _$a.push(t.a$([], _$e, l));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            if (l !== n) try {
                                for(var _iterator1 = _$i[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var _$e1 = _step1.value;
                                    _$a.push(t.a$([], _$e1, n));
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            0 === e1.y && _$a.push([
                                0,
                                1,
                                0
                            ]), e1.y === (1 << e1.z) - 1 && _$a.push([
                                0,
                                -1,
                                0
                            ]);
                            var _$r = [
                                1,
                                1,
                                1
                            ], o1 = [
                                -1,
                                -1,
                                -1
                            ];
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(var _iterator2 = _$a[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var _$e2 = _step2.value;
                                    for(var _$t = 0; _$t < 3; _$t++)_$r[_$t] = Math.min(_$r[_$t], _$e2[_$t]), o1[_$t] = Math.max(o1[_$t], _$e2[_$t]);
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                            var s1 = pi(t.a5 / 2, t.a5 / 2, e1.x, e1.y, e1.z), _$c1 = t.b4([], [
                                0,
                                1,
                                0
                            ], s1);
                            t.b3(_$c1, _$c1);
                            var h1 = t.b4([], s1, _$c1);
                            t.b3(h1, h1);
                            var u = t.b4([], _$i[2], _$i[1]);
                            t.b3(u, u);
                            var d = t.b4([], _$i[0], _$i[3]);
                            t.b3(d, d), _$a.push(t.a$([], s1, l)), e1.y >= (1 << e1.z) / 2 && _$a.push(t.a$([], pi(t.a5 / 2, 0, e1.x, e1.y, e1.z), l)), e1.y < (1 << e1.z) / 2 && _$a.push(t.a$([], pi(t.a5 / 2, t.a5, e1.x, e1.y, e1.z), l));
                            var _ = Ei(s1, _$a), p = Ei(h1, _$a), m = [
                                -s1[0],
                                -s1[1],
                                -s1[2],
                                _.max
                            ], f = [
                                s1[0],
                                s1[1],
                                s1[2],
                                -_.min
                            ], g = [
                                -h1[0],
                                -h1[1],
                                -h1[2],
                                p.max
                            ], v = [
                                h1[0],
                                h1[1],
                                h1[2],
                                -p.min
                            ], x = (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(u).concat([
                                0
                            ]), b = (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(d).concat([
                                0
                            ]), y = [];
                            return 0 === e1.y ? y.push(t.bD(b, x, m), t.bD(b, x, f)) : y.push(t.bD(g, x, m), t.bD(g, x, f), t.bD(g, b, m), t.bD(g, b, f)), e1.y === (1 << e1.z) - 1 ? y.push(t.bD(b, x, m), t.bD(b, x, f)) : y.push(t.bD(v, x, m), t.bD(v, x, f), t.bD(v, b, m), t.bD(v, b, f)), new Pi(y, [
                                m,
                                f,
                                g,
                                v,
                                x,
                                b
                            ], _$r, o1);
                        }
                    }
                }
            ]);
            return Mi;
        }();
        function Ei(e1, i) {
            var a = 1 / 0, r = -1 / 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var o = _step.value;
                    var _$i = t.b5(e1, o);
                    a = Math.min(a, _$i), r = Math.max(r, _$i);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return {
                min: a,
                max: r
            };
        }
        var Si = /*#__PURE__*/ function() {
            function Si(e1) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Si);
                this._cachedClippingPlane = t.bF(), this._projectionMatrix = t.bj(), this._globeViewProjMatrix32f = t.bi(), this._globeViewProjMatrixNoCorrection = t.bj(), this._globeViewProjMatrixNoCorrectionInverted = t.bj(), this._globeProjMatrixInverted = t.bj(), this._cameraPosition = t.bz(), this._globeLatitudeErrorCorrectionRadians = 0, this.defaultConstrain = function(e1, i) {
                    var a = t.an(e1.lat, -t.ao, t.ao), r = t.an(+i, _this.minZoom + xi(0, a), _this.maxZoom);
                    return {
                        center: new t.V(e1.lng, a),
                        zoom: r
                    };
                }, this.applyConstrain = function(e1, t) {
                    return _this._helper.applyConstrain(e1, t);
                }, this._helper = new Ut({
                    calcMatrices: function() {
                        _this._calcMatrices();
                    },
                    defaultConstrain: function(e1, t) {
                        return _this.defaultConstrain(e1, t);
                    }
                }, e1), this._coveringTilesDetailsProvider = new Mi;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Si, [
                {
                    key: "pixelsToClipSpaceMatrix",
                    get: function get() {
                        return this._helper.pixelsToClipSpaceMatrix;
                    }
                },
                {
                    key: "clipSpaceToPixelsMatrix",
                    get: function get() {
                        return this._helper.clipSpaceToPixelsMatrix;
                    }
                },
                {
                    key: "pixelsToGLUnits",
                    get: function get() {
                        return this._helper.pixelsToGLUnits;
                    }
                },
                {
                    key: "centerOffset",
                    get: function get() {
                        return this._helper.centerOffset;
                    }
                },
                {
                    key: "size",
                    get: function get() {
                        return this._helper.size;
                    }
                },
                {
                    key: "rotationMatrix",
                    get: function get() {
                        return this._helper.rotationMatrix;
                    }
                },
                {
                    key: "centerPoint",
                    get: function get() {
                        return this._helper.centerPoint;
                    }
                },
                {
                    key: "pixelsPerMeter",
                    get: function get() {
                        return this._helper.pixelsPerMeter;
                    }
                },
                {
                    key: "setMinZoom",
                    value: function setMinZoom(e1) {
                        this._helper.setMinZoom(e1);
                    }
                },
                {
                    key: "setMaxZoom",
                    value: function setMaxZoom(e1) {
                        this._helper.setMaxZoom(e1);
                    }
                },
                {
                    key: "setMinPitch",
                    value: function setMinPitch(e1) {
                        this._helper.setMinPitch(e1);
                    }
                },
                {
                    key: "setMaxPitch",
                    value: function setMaxPitch(e1) {
                        this._helper.setMaxPitch(e1);
                    }
                },
                {
                    key: "setRenderWorldCopies",
                    value: function setRenderWorldCopies(e1) {
                        this._helper.setRenderWorldCopies(e1);
                    }
                },
                {
                    key: "setBearing",
                    value: function setBearing(e1) {
                        this._helper.setBearing(e1);
                    }
                },
                {
                    key: "setPitch",
                    value: function setPitch(e1) {
                        this._helper.setPitch(e1);
                    }
                },
                {
                    key: "setRoll",
                    value: function setRoll(e1) {
                        this._helper.setRoll(e1);
                    }
                },
                {
                    key: "setFov",
                    value: function setFov(e1) {
                        this._helper.setFov(e1);
                    }
                },
                {
                    key: "setZoom",
                    value: function setZoom(e1) {
                        this._helper.setZoom(e1);
                    }
                },
                {
                    key: "setCenter",
                    value: function setCenter(e1) {
                        this._helper.setCenter(e1);
                    }
                },
                {
                    key: "setElevation",
                    value: function setElevation(e1) {
                        this._helper.setElevation(e1);
                    }
                },
                {
                    key: "setMinElevationForCurrentTile",
                    value: function setMinElevationForCurrentTile(e1) {
                        this._helper.setMinElevationForCurrentTile(e1);
                    }
                },
                {
                    key: "setPadding",
                    value: function setPadding(e1) {
                        this._helper.setPadding(e1);
                    }
                },
                {
                    key: "interpolatePadding",
                    value: function interpolatePadding(e1, t, i) {
                        return this._helper.interpolatePadding(e1, t, i);
                    }
                },
                {
                    key: "isPaddingEqual",
                    value: function isPaddingEqual(e1) {
                        return this._helper.isPaddingEqual(e1);
                    }
                },
                {
                    key: "resize",
                    value: function resize(e1, t) {
                        this._helper.resize(e1, t);
                    }
                },
                {
                    key: "getMaxBounds",
                    value: function getMaxBounds() {
                        return this._helper.getMaxBounds();
                    }
                },
                {
                    key: "setMaxBounds",
                    value: function setMaxBounds(e1) {
                        this._helper.setMaxBounds(e1);
                    }
                },
                {
                    key: "setConstrainOverride",
                    value: function setConstrainOverride(e1) {
                        this._helper.setConstrainOverride(e1);
                    }
                },
                {
                    key: "overrideNearFarZ",
                    value: function overrideNearFarZ(e1, t) {
                        this._helper.overrideNearFarZ(e1, t);
                    }
                },
                {
                    key: "clearNearFarZOverride",
                    value: function clearNearFarZOverride() {
                        this._helper.clearNearFarZOverride();
                    }
                },
                {
                    key: "getCameraQueryGeometry",
                    value: function getCameraQueryGeometry(e1) {
                        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
                    }
                },
                {
                    key: "tileSize",
                    get: function get() {
                        return this._helper.tileSize;
                    }
                },
                {
                    key: "tileZoom",
                    get: function get() {
                        return this._helper.tileZoom;
                    }
                },
                {
                    key: "scale",
                    get: function get() {
                        return this._helper.scale;
                    }
                },
                {
                    key: "worldSize",
                    get: function get() {
                        return this._helper.worldSize;
                    }
                },
                {
                    key: "width",
                    get: function get() {
                        return this._helper.width;
                    }
                },
                {
                    key: "height",
                    get: function get() {
                        return this._helper.height;
                    }
                },
                {
                    key: "lngRange",
                    get: function get() {
                        return this._helper.lngRange;
                    }
                },
                {
                    key: "latRange",
                    get: function get() {
                        return this._helper.latRange;
                    }
                },
                {
                    key: "minZoom",
                    get: function get() {
                        return this._helper.minZoom;
                    }
                },
                {
                    key: "maxZoom",
                    get: function get() {
                        return this._helper.maxZoom;
                    }
                },
                {
                    key: "zoom",
                    get: function get() {
                        return this._helper.zoom;
                    }
                },
                {
                    key: "center",
                    get: function get() {
                        return this._helper.center;
                    }
                },
                {
                    key: "minPitch",
                    get: function get() {
                        return this._helper.minPitch;
                    }
                },
                {
                    key: "maxPitch",
                    get: function get() {
                        return this._helper.maxPitch;
                    }
                },
                {
                    key: "pitch",
                    get: function get() {
                        return this._helper.pitch;
                    }
                },
                {
                    key: "pitchInRadians",
                    get: function get() {
                        return this._helper.pitchInRadians;
                    }
                },
                {
                    key: "roll",
                    get: function get() {
                        return this._helper.roll;
                    }
                },
                {
                    key: "rollInRadians",
                    get: function get() {
                        return this._helper.rollInRadians;
                    }
                },
                {
                    key: "bearing",
                    get: function get() {
                        return this._helper.bearing;
                    }
                },
                {
                    key: "bearingInRadians",
                    get: function get() {
                        return this._helper.bearingInRadians;
                    }
                },
                {
                    key: "fov",
                    get: function get() {
                        return this._helper.fov;
                    }
                },
                {
                    key: "fovInRadians",
                    get: function get() {
                        return this._helper.fovInRadians;
                    }
                },
                {
                    key: "elevation",
                    get: function get() {
                        return this._helper.elevation;
                    }
                },
                {
                    key: "minElevationForCurrentTile",
                    get: function get() {
                        return this._helper.minElevationForCurrentTile;
                    }
                },
                {
                    key: "padding",
                    get: function get() {
                        return this._helper.padding;
                    }
                },
                {
                    key: "unmodified",
                    get: function get() {
                        return this._helper.unmodified;
                    }
                },
                {
                    key: "renderWorldCopies",
                    get: function get() {
                        return this._helper.renderWorldCopies;
                    }
                },
                {
                    key: "constrainOverride",
                    get: function get() {
                        return this._helper.constrainOverride;
                    }
                },
                {
                    key: "nearZ",
                    get: function get() {
                        return this._helper.nearZ;
                    }
                },
                {
                    key: "farZ",
                    get: function get() {
                        return this._helper.farZ;
                    }
                },
                {
                    key: "autoCalculateNearFarZ",
                    get: function get() {
                        return this._helper.autoCalculateNearFarZ;
                    }
                },
                {
                    key: "setTransitionState",
                    value: function setTransitionState(e1) {}
                },
                {
                    key: "clone",
                    value: function clone() {
                        var _$e = new Si;
                        return _$e.apply(this), _$e;
                    }
                },
                {
                    key: "apply",
                    value: function apply(e1, t) {
                        this._globeLatitudeErrorCorrectionRadians = t || 0, this._helper.apply(e1);
                    }
                },
                {
                    key: "projectionMatrix",
                    get: function get() {
                        return this._projectionMatrix;
                    }
                },
                {
                    key: "modelViewProjectionMatrix",
                    get: function get() {
                        return this._globeViewProjMatrixNoCorrection;
                    }
                },
                {
                    key: "inverseProjectionMatrix",
                    get: function get() {
                        return this._globeProjMatrixInverted;
                    }
                },
                {
                    key: "cameraPosition",
                    get: function get() {
                        var _$e = t.bz();
                        return _$e[0] = this._cameraPosition[0], _$e[1] = this._cameraPosition[1], _$e[2] = this._cameraPosition[2], _$e;
                    }
                },
                {
                    key: "cameraToCenterDistance",
                    get: function get() {
                        return this._helper.cameraToCenterDistance;
                    }
                },
                {
                    key: "getProjectionData",
                    value: function getProjectionData(e1) {
                        var _$t = e1.overscaledTileID, i = e1.applyGlobeMatrix, a = this._helper.getMercatorTileCoordinates(_$t);
                        return {
                            mainMatrix: this._globeViewProjMatrix32f,
                            tileMercatorCoords: a,
                            clippingPlane: this._cachedClippingPlane,
                            projectionTransition: i ? 1 : 0,
                            fallbackMatrix: this._globeViewProjMatrix32f
                        };
                    }
                },
                {
                    key: "_computeClippingPlane",
                    value: function _computeClippingPlane(e1) {
                        var i = this.pitchInRadians, a = this.cameraToCenterDistance / e1, r = Math.sin(i) * a, o = Math.cos(i) * a + 1, s = 1 / Math.sqrt(r * r + o * o) * 1;
                        var n = -r, l = o;
                        var _$c = Math.sqrt(n * n + l * l);
                        n /= _$c, l /= _$c;
                        var h = [
                            0,
                            n,
                            l
                        ];
                        t.bG(h, h, [
                            0,
                            0,
                            0
                        ], -this.bearingInRadians), t.bH(h, h, [
                            0,
                            0,
                            0
                        ], -1 * this.center.lat * Math.PI / 180), t.bI(h, h, [
                            0,
                            0,
                            0
                        ], this.center.lng * Math.PI / 180);
                        var u = 1 / t.b7(h);
                        return t.a$(h, h, u), (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(h).concat([
                            -s * u
                        ]);
                    }
                },
                {
                    key: "isLocationOccluded",
                    value: function isLocationOccluded(e1) {
                        return !this.isSurfacePointVisible(mi(e1));
                    }
                },
                {
                    key: "transformLightDirection",
                    value: function transformLightDirection(e1) {
                        var i = this._helper._center.lng * Math.PI / 180, a = this._helper._center.lat * Math.PI / 180, r = Math.cos(a), o = [
                            Math.sin(i) * r,
                            Math.sin(a),
                            Math.cos(i) * r
                        ], s = [
                            o[2],
                            0,
                            -o[0]
                        ], n = [
                            0,
                            0,
                            0
                        ];
                        t.b4(n, s, o), t.b3(s, s), t.b3(n, n);
                        var l = [
                            0,
                            0,
                            0
                        ];
                        return t.b3(l, [
                            s[0] * e1[0] + n[0] * e1[1] + o[0] * e1[2],
                            s[1] * e1[0] + n[1] * e1[1] + o[1] * e1[2],
                            s[2] * e1[0] + n[2] * e1[1] + o[2] * e1[2]
                        ]), l;
                    }
                },
                {
                    key: "getPixelScale",
                    value: function getPixelScale() {
                        return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
                    }
                },
                {
                    key: "getCircleRadiusCorrection",
                    value: function getCircleRadiusCorrection() {
                        return Math.cos(this._helper._center.lat * Math.PI / 180);
                    }
                },
                {
                    key: "getPitchedTextCorrection",
                    value: function getPitchedTextCorrection(e1, i, a) {
                        var r = function(e1, i, a) {
                            var r = 1 / (1 << a.z);
                            return new t.a9(e1 / t.a5 * r + a.x * r, i / t.a5 * r + a.y * r);
                        }(e1, i, a.canonical), o = (s = r.y, [
                            t.by(r.x * Math.PI * 2 + Math.PI, 2 * Math.PI),
                            2 * Math.atan(Math.exp(Math.PI - s * Math.PI * 2)) - .5 * Math.PI
                        ]);
                        var s;
                        return this.getCircleRadiusCorrection() / Math.cos(o[1]);
                    }
                },
                {
                    key: "projectTileCoordinates",
                    value: function projectTileCoordinates(e1, i, a, r) {
                        var o = a.canonical, s = pi(e1, i, o.x, o.y, o.z), n = 1 + (r ? r(e1, i) : 0) / t.bE, l = [
                            s[0] * n,
                            s[1] * n,
                            s[2] * n,
                            1
                        ];
                        t.aH(l, l, this._globeViewProjMatrixNoCorrection);
                        var _$c = this._cachedClippingPlane, h = _$c[0] * s[0] + _$c[1] * s[1] + _$c[2] * s[2] + _$c[3] < 0;
                        return {
                            point: new t.P(l[0] / l[3], l[1] / l[3]),
                            signedDistanceFromCamera: l[3],
                            isOccluded: h
                        };
                    }
                },
                {
                    key: "_calcMatrices",
                    value: function _calcMatrices() {
                        if (!this._helper._width || !this._helper._height) return;
                        var _$e = fi(this.worldSize, this.center.lat), i = t.bk(), a = t.bk();
                        this._helper.autoCalculateNearFarZ && (this._helper._nearZ = .5, this._helper._farZ = this.cameraToCenterDistance + 2 * _$e), t.be(i, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
                        var r = this.centerOffset;
                        i[8] = 2 * -r.x / this._helper._width, i[9] = 2 * r.y / this._helper._height, this._projectionMatrix = t.bf(i), this._globeProjMatrixInverted = t.bk(), t.aB(this._globeProjMatrixInverted, i), t.O(i, i, [
                            0,
                            0,
                            -this.cameraToCenterDistance
                        ]), t.bg(i, i, this.rollInRadians), t.bh(i, i, -this.pitchInRadians), t.bg(i, i, this.bearingInRadians), t.O(i, i, [
                            0,
                            0,
                            -_$e
                        ]);
                        var o = t.bz();
                        o[0] = _$e, o[1] = _$e, o[2] = _$e, t.bh(a, i, this.center.lat * Math.PI / 180), t.bJ(a, a, -this.center.lng * Math.PI / 180), t.Q(a, a, o), this._globeViewProjMatrixNoCorrection = a, t.bh(i, i, this.center.lat * Math.PI / 180 - this._globeLatitudeErrorCorrectionRadians), t.bJ(i, i, -this.center.lng * Math.PI / 180), t.Q(i, i, o), this._globeViewProjMatrix32f = new Float32Array(i), this._globeViewProjMatrixNoCorrectionInverted = t.bk(), t.aB(this._globeViewProjMatrixNoCorrectionInverted, a);
                        var s = t.bz();
                        this._cameraPosition = t.bz(), this._cameraPosition[2] = this.cameraToCenterDistance / _$e, t.bG(this._cameraPosition, this._cameraPosition, s, -this.rollInRadians), t.bH(this._cameraPosition, this._cameraPosition, s, this.pitchInRadians), t.bG(this._cameraPosition, this._cameraPosition, s, -this.bearingInRadians), t.b0(this._cameraPosition, this._cameraPosition, [
                            0,
                            0,
                            1
                        ]), t.bH(this._cameraPosition, this._cameraPosition, s, -this.center.lat * Math.PI / 180), t.bI(this._cameraPosition, this._cameraPosition, s, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(_$e);
                        var n = t.bf(this._globeViewProjMatrixNoCorrectionInverted);
                        t.Q(n, n, [
                            1,
                            1,
                            -1
                        ]), this._cachedFrustum = Wt.fromInvProjectionMatrix(n, 1, 0, this._cachedClippingPlane, !0);
                    }
                },
                {
                    key: "calculateFogMatrix",
                    value: function calculateFogMatrix(e1) {
                        t.w("calculateFogMatrix is not supported on globe projection.");
                        var i = t.bk();
                        return t.ar(i), i;
                    }
                },
                {
                    key: "getVisibleUnwrappedCoordinates",
                    value: function getVisibleUnwrappedCoordinates(e1) {
                        return [
                            new t.bc(0, e1)
                        ];
                    }
                },
                {
                    key: "getCameraFrustum",
                    value: function getCameraFrustum() {
                        return this._cachedFrustum;
                    }
                },
                {
                    key: "getClippingPlane",
                    value: function getClippingPlane() {
                        return this._cachedClippingPlane;
                    }
                },
                {
                    key: "getCoveringTilesDetailsProvider",
                    value: function getCoveringTilesDetailsProvider() {
                        return this._coveringTilesDetailsProvider;
                    }
                },
                {
                    key: "recalculateZoomAndCenter",
                    value: function recalculateZoomAndCenter(e1) {
                        e1 && t.w("terrain is not fully supported on vertical perspective projection."), this._helper.recalculateZoomAndCenter(0);
                    }
                },
                {
                    key: "maxPitchScaleFactor",
                    value: function maxPitchScaleFactor() {
                        return 1;
                    }
                },
                {
                    key: "getCameraPoint",
                    value: function getCameraPoint() {
                        return this._helper.getCameraPoint();
                    }
                },
                {
                    key: "getCameraAltitude",
                    value: function getCameraAltitude() {
                        return this._helper.getCameraAltitude();
                    }
                },
                {
                    key: "getCameraLngLat",
                    value: function getCameraLngLat() {
                        return this._helper.getCameraLngLat();
                    }
                },
                {
                    key: "lngLatToCameraDepth",
                    value: function lngLatToCameraDepth(e1, i) {
                        if (!this._globeViewProjMatrixNoCorrection) return 1;
                        var a = mi(e1);
                        t.a$(a, a, 1 + i / t.bE);
                        var r = t.bF();
                        return t.aH(r, [
                            a[0],
                            a[1],
                            a[2],
                            1
                        ], this._globeViewProjMatrixNoCorrection), r[2] / r[3];
                    }
                },
                {
                    key: "populateCache",
                    value: function populateCache(e1) {}
                },
                {
                    key: "getBounds",
                    value: function getBounds() {
                        var _$e = .5 * this.width, i = .5 * this.height, a = [
                            new t.P(0, 0),
                            new t.P(_$e, 0),
                            new t.P(this.width, 0),
                            new t.P(this.width, i),
                            new t.P(this.width, this.height),
                            new t.P(_$e, this.height),
                            new t.P(0, this.height),
                            new t.P(0, i)
                        ], r = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e1 = _step.value;
                                r.push(this.unprojectScreenPoint(_$e1));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var o = 0, s = 0, n = 0, l = 0;
                        var _$c = this.center;
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = r[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$e2 = _step1.value;
                                var i1 = t.bK(_$c.lng, _$e2.lng), a1 = t.bK(_$c.lat, _$e2.lat);
                                i1 < s && (s = i1), i1 > o && (o = i1), a1 < l && (l = a1), a1 > n && (n = a1);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        var h = [
                            _$c.lng + s,
                            _$c.lat + l,
                            _$c.lng + o,
                            _$c.lat + n
                        ];
                        return this.isSurfacePointOnScreen([
                            0,
                            1,
                            0
                        ]) && (h[3] = 90, h[0] = -180, h[2] = 180), this.isSurfacePointOnScreen([
                            0,
                            -1,
                            0
                        ]) && (h[1] = -90, h[0] = -180, h[2] = 180), new $(h);
                    }
                },
                {
                    key: "calculateCenterFromCameraLngLatAlt",
                    value: function calculateCenterFromCameraLngLatAlt(e1, t, i, a) {
                        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, a);
                    }
                },
                {
                    key: "setLocationAtPoint",
                    value: function setLocationAtPoint(e1, i) {
                        var a = mi(this.unprojectScreenPoint(i)), r = mi(e1), o = t.bz();
                        t.bL(o);
                        var s = t.bz();
                        t.bI(s, a, o, -this.center.lng * Math.PI / 180), t.bH(s, s, o, this.center.lat * Math.PI / 180);
                        var n = r[0] * r[0] + r[2] * r[2], l = s[0] * s[0];
                        if (n < l) return;
                        var _$c = Math.sqrt(n - l), h = -_$c, u = t.bM(r[0], r[2], s[0], _$c), d = t.bM(r[0], r[2], s[0], h), _ = t.bz();
                        t.bI(_, r, o, -u);
                        var p = t.bM(_[1], _[2], s[1], s[2]), m = t.bz();
                        t.bI(m, r, o, -d);
                        var f = t.bM(m[1], m[2], s[1], s[2]), g = .5 * Math.PI, v = p >= -g && p <= g, x = f >= -g && f <= g;
                        var b, y;
                        if (v && x) {
                            var _$e = this.center.lng * Math.PI / 180, _$i = this.center.lat * Math.PI / 180;
                            t.bN(u, _$e) + t.bN(p, _$i) < t.bN(d, _$e) + t.bN(f, _$i) ? (b = u, y = p) : (b = d, y = f);
                        } else if (v) b = u, y = p;
                        else {
                            if (!x) return;
                            b = d, y = f;
                        }
                        var w = b / Math.PI * 180, T = y / Math.PI * 180, P = this.center.lat;
                        this.setCenter(new t.V(w, t.an(T, -90, 90))), this.setZoom(this.zoom + xi(P, this.center.lat));
                    }
                },
                {
                    key: "locationToScreenPoint",
                    value: function locationToScreenPoint(e1, i) {
                        var a = mi(e1);
                        if (i) {
                            var r = i.getElevationForLngLatZoom(e1, this._helper._tileZoom);
                            t.a$(a, a, 1 + r / t.bE);
                        }
                        return this._projectSurfacePointToScreen(a);
                    }
                },
                {
                    key: "_projectSurfacePointToScreen",
                    value: function _projectSurfacePointToScreen(e1) {
                        var i = t.bF();
                        return t.aH(i, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(e1).concat([
                            1
                        ]), this._globeViewProjMatrixNoCorrection), i[0] /= i[3], i[1] /= i[3], new t.P((.5 * i[0] + .5) * this.width, (.5 * -i[1] + .5) * this.height);
                    }
                },
                {
                    key: "screenPointToMercatorCoordinate",
                    value: function screenPointToMercatorCoordinate(e1, i) {
                        if (i) {
                            var _$t = i.pointCoordinate(e1);
                            if (_$t) return _$t;
                        }
                        return t.a9.fromLngLat(this.unprojectScreenPoint(e1));
                    }
                },
                {
                    key: "screenPointToLocation",
                    value: function screenPointToLocation(e1, t) {
                        var i;
                        return null === (i = this.screenPointToMercatorCoordinate(e1, t)) || void 0 === i ? void 0 : i.toLngLat();
                    }
                },
                {
                    key: "isPointOnMapSurface",
                    value: function isPointOnMapSurface(e1, t) {
                        var i = this._cameraPosition, a = this.getRayDirectionFromPixel(e1);
                        return !!this.rayPlanetIntersection(i, a);
                    }
                },
                {
                    key: "getRayDirectionFromPixel",
                    value: function getRayDirectionFromPixel(e1) {
                        var i = t.bF();
                        i[0] = e1.x / this.width * 2 - 1, i[1] = -1 * (e1.y / this.height * 2 - 1), i[2] = 1, i[3] = 1, t.aH(i, i, this._globeViewProjMatrixNoCorrectionInverted), i[0] /= i[3], i[1] /= i[3], i[2] /= i[3];
                        var a = t.bz();
                        a[0] = i[0] - this._cameraPosition[0], a[1] = i[1] - this._cameraPosition[1], a[2] = i[2] - this._cameraPosition[2];
                        var r = t.bz();
                        return t.b3(r, a), r;
                    }
                },
                {
                    key: "isSurfacePointVisible",
                    value: function isSurfacePointVisible(e1) {
                        var _$t = this._cachedClippingPlane;
                        return _$t[0] * e1[0] + _$t[1] * e1[1] + _$t[2] * e1[2] + _$t[3] >= 0;
                    }
                },
                {
                    key: "isSurfacePointOnScreen",
                    value: function isSurfacePointOnScreen(e1) {
                        if (!this.isSurfacePointVisible(e1)) return !1;
                        var i = t.bF();
                        return t.aH(i, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(e1).concat([
                            1
                        ]), this._globeViewProjMatrixNoCorrection), i[0] /= i[3], i[1] /= i[3], i[2] /= i[3], i[0] > -1 && i[0] < 1 && i[1] > -1 && i[1] < 1 && i[2] > -1 && i[2] < 1;
                    }
                },
                {
                    key: "rayPlanetIntersection",
                    value: function rayPlanetIntersection(e1, i) {
                        var a = t.b5(e1, i), r = t.bz(), o = t.bz();
                        t.a$(o, i, a), t.b2(r, e1, o);
                        var s = 1 - t.b5(r, r);
                        if (s < 0) return null;
                        var n = t.b5(e1, e1) - 1, l = -a + (a < 0 ? 1 : -1) * Math.sqrt(s), _$c = n / l, h = l;
                        return {
                            tMin: Math.min(_$c, h),
                            tMax: Math.max(_$c, h)
                        };
                    }
                },
                {
                    key: "unprojectScreenPoint",
                    value: function unprojectScreenPoint(e1) {
                        var i = this._cameraPosition, a = this.getRayDirectionFromPixel(e1), r = this.rayPlanetIntersection(i, a);
                        if (r) {
                            var _$e = t.bz();
                            t.b0(_$e, i, [
                                a[0] * r.tMin,
                                a[1] * r.tMin,
                                a[2] * r.tMin
                            ]);
                            var o = t.bz();
                            return t.b3(o, _$e), gi(o);
                        }
                        var o1 = this._cachedClippingPlane, s = o1[0] * a[0] + o1[1] * a[1] + o1[2] * a[2], n = -t.bb(o1, i) / s, l = t.bz();
                        if (n > 0) t.b0(l, i, [
                            a[0] * n,
                            a[1] * n,
                            a[2] * n
                        ]);
                        else {
                            var _$e1 = t.bz();
                            t.b0(_$e1, i, [
                                2 * a[0],
                                2 * a[1],
                                2 * a[2]
                            ]);
                            var r1 = t.bb(this._cachedClippingPlane, _$e1);
                            t.b2(l, _$e1, [
                                this._cachedClippingPlane[0] * r1,
                                this._cachedClippingPlane[1] * r1,
                                this._cachedClippingPlane[2] * r1
                            ]);
                        }
                        var _$c = function(e1) {
                            var i = t.bz();
                            return i[0] = e1[0] * -e1[3], i[1] = e1[1] * -e1[3], i[2] = e1[2] * -e1[3], {
                                center: i,
                                radius: Math.sqrt(1 - e1[3] * e1[3])
                            };
                        }(o1);
                        return gi(function(e1, i, a) {
                            var r = t.bz();
                            t.b2(r, a, e1);
                            var o = t.bz();
                            return t.bA(o, e1, r, i / t.b9(r)), o;
                        }(_$c.center, _$c.radius, l));
                    }
                },
                {
                    key: "getMatrixForModel",
                    value: function getMatrixForModel(e1, i) {
                        var a = t.V.convert(e1), r = 1 / t.bE, o = t.bj();
                        return t.bJ(o, o, a.lng / 180 * Math.PI), t.bh(o, o, -a.lat / 180 * Math.PI), t.O(o, o, [
                            0,
                            0,
                            1 + i / t.bE
                        ]), t.bh(o, o, .5 * Math.PI), t.Q(o, o, [
                            r,
                            r,
                            r
                        ]), o;
                    }
                },
                {
                    key: "getProjectionDataForCustomLayer",
                    value: function getProjectionDataForCustomLayer() {
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                        var i = this.getProjectionData({
                            overscaledTileID: new t.a2(0, 0, 0, 0, 0),
                            applyGlobeMatrix: _$e
                        });
                        return i.tileMercatorCoords = [
                            0,
                            0,
                            1,
                            1
                        ], i;
                    }
                },
                {
                    key: "getFastPathSimpleProjectionMatrix",
                    value: function getFastPathSimpleProjectionMatrix(e1) {}
                }
            ]);
            return Si;
        }();
        var Ri = /*#__PURE__*/ function() {
            function Ri(e1) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ri);
                this._globeLatitudeErrorCorrectionRadians = 0, this._globeness = 1, this.defaultConstrain = function(e1, t) {
                    return _this.currentTransform.defaultConstrain(e1, t);
                }, this.applyConstrain = function(e1, t) {
                    return _this._helper.applyConstrain(e1, t);
                }, this._helper = new Ut({
                    calcMatrices: function() {
                        _this._calcMatrices();
                    },
                    defaultConstrain: function(e1, t) {
                        return _this.defaultConstrain(e1, t);
                    }
                }, e1), this._globeness = 1, this._mercatorTransform = new $t, this._verticalPerspectiveTransform = new Si;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ri, [
                {
                    key: "pixelsToClipSpaceMatrix",
                    get: function get() {
                        return this._helper.pixelsToClipSpaceMatrix;
                    }
                },
                {
                    key: "clipSpaceToPixelsMatrix",
                    get: function get() {
                        return this._helper.clipSpaceToPixelsMatrix;
                    }
                },
                {
                    key: "pixelsToGLUnits",
                    get: function get() {
                        return this._helper.pixelsToGLUnits;
                    }
                },
                {
                    key: "centerOffset",
                    get: function get() {
                        return this._helper.centerOffset;
                    }
                },
                {
                    key: "size",
                    get: function get() {
                        return this._helper.size;
                    }
                },
                {
                    key: "rotationMatrix",
                    get: function get() {
                        return this._helper.rotationMatrix;
                    }
                },
                {
                    key: "centerPoint",
                    get: function get() {
                        return this._helper.centerPoint;
                    }
                },
                {
                    key: "pixelsPerMeter",
                    get: function get() {
                        return this._helper.pixelsPerMeter;
                    }
                },
                {
                    key: "setMinZoom",
                    value: function setMinZoom(e1) {
                        this._helper.setMinZoom(e1);
                    }
                },
                {
                    key: "setMaxZoom",
                    value: function setMaxZoom(e1) {
                        this._helper.setMaxZoom(e1);
                    }
                },
                {
                    key: "setMinPitch",
                    value: function setMinPitch(e1) {
                        this._helper.setMinPitch(e1);
                    }
                },
                {
                    key: "setMaxPitch",
                    value: function setMaxPitch(e1) {
                        this._helper.setMaxPitch(e1);
                    }
                },
                {
                    key: "setRenderWorldCopies",
                    value: function setRenderWorldCopies(e1) {
                        this._helper.setRenderWorldCopies(e1);
                    }
                },
                {
                    key: "setBearing",
                    value: function setBearing(e1) {
                        this._helper.setBearing(e1);
                    }
                },
                {
                    key: "setPitch",
                    value: function setPitch(e1) {
                        this._helper.setPitch(e1);
                    }
                },
                {
                    key: "setRoll",
                    value: function setRoll(e1) {
                        this._helper.setRoll(e1);
                    }
                },
                {
                    key: "setFov",
                    value: function setFov(e1) {
                        this._helper.setFov(e1);
                    }
                },
                {
                    key: "setZoom",
                    value: function setZoom(e1) {
                        this._helper.setZoom(e1);
                    }
                },
                {
                    key: "setCenter",
                    value: function setCenter(e1) {
                        this._helper.setCenter(e1);
                    }
                },
                {
                    key: "setElevation",
                    value: function setElevation(e1) {
                        this._helper.setElevation(e1);
                    }
                },
                {
                    key: "setMinElevationForCurrentTile",
                    value: function setMinElevationForCurrentTile(e1) {
                        this._helper.setMinElevationForCurrentTile(e1);
                    }
                },
                {
                    key: "setPadding",
                    value: function setPadding(e1) {
                        this._helper.setPadding(e1);
                    }
                },
                {
                    key: "interpolatePadding",
                    value: function interpolatePadding(e1, t, i) {
                        return this._helper.interpolatePadding(e1, t, i);
                    }
                },
                {
                    key: "isPaddingEqual",
                    value: function isPaddingEqual(e1) {
                        return this._helper.isPaddingEqual(e1);
                    }
                },
                {
                    key: "resize",
                    value: function resize(e1, t) {
                        var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
                        this._helper.resize(e1, t, i);
                    }
                },
                {
                    key: "getMaxBounds",
                    value: function getMaxBounds() {
                        return this._helper.getMaxBounds();
                    }
                },
                {
                    key: "setMaxBounds",
                    value: function setMaxBounds(e1) {
                        this._helper.setMaxBounds(e1);
                    }
                },
                {
                    key: "setConstrainOverride",
                    value: function setConstrainOverride(e1) {
                        this._helper.setConstrainOverride(e1);
                    }
                },
                {
                    key: "overrideNearFarZ",
                    value: function overrideNearFarZ(e1, t) {
                        this._helper.overrideNearFarZ(e1, t);
                    }
                },
                {
                    key: "clearNearFarZOverride",
                    value: function clearNearFarZOverride() {
                        this._helper.clearNearFarZOverride();
                    }
                },
                {
                    key: "getCameraQueryGeometry",
                    value: function getCameraQueryGeometry(e1) {
                        return this._helper.getCameraQueryGeometry(this.getCameraPoint(), e1);
                    }
                },
                {
                    key: "tileSize",
                    get: function get() {
                        return this._helper.tileSize;
                    }
                },
                {
                    key: "tileZoom",
                    get: function get() {
                        return this._helper.tileZoom;
                    }
                },
                {
                    key: "scale",
                    get: function get() {
                        return this._helper.scale;
                    }
                },
                {
                    key: "worldSize",
                    get: function get() {
                        return this._helper.worldSize;
                    }
                },
                {
                    key: "width",
                    get: function get() {
                        return this._helper.width;
                    }
                },
                {
                    key: "height",
                    get: function get() {
                        return this._helper.height;
                    }
                },
                {
                    key: "lngRange",
                    get: function get() {
                        return this._helper.lngRange;
                    }
                },
                {
                    key: "latRange",
                    get: function get() {
                        return this._helper.latRange;
                    }
                },
                {
                    key: "minZoom",
                    get: function get() {
                        return this._helper.minZoom;
                    }
                },
                {
                    key: "maxZoom",
                    get: function get() {
                        return this._helper.maxZoom;
                    }
                },
                {
                    key: "zoom",
                    get: function get() {
                        return this._helper.zoom;
                    }
                },
                {
                    key: "center",
                    get: function get() {
                        return this._helper.center;
                    }
                },
                {
                    key: "minPitch",
                    get: function get() {
                        return this._helper.minPitch;
                    }
                },
                {
                    key: "maxPitch",
                    get: function get() {
                        return this._helper.maxPitch;
                    }
                },
                {
                    key: "pitch",
                    get: function get() {
                        return this._helper.pitch;
                    }
                },
                {
                    key: "pitchInRadians",
                    get: function get() {
                        return this._helper.pitchInRadians;
                    }
                },
                {
                    key: "roll",
                    get: function get() {
                        return this._helper.roll;
                    }
                },
                {
                    key: "rollInRadians",
                    get: function get() {
                        return this._helper.rollInRadians;
                    }
                },
                {
                    key: "bearing",
                    get: function get() {
                        return this._helper.bearing;
                    }
                },
                {
                    key: "bearingInRadians",
                    get: function get() {
                        return this._helper.bearingInRadians;
                    }
                },
                {
                    key: "fov",
                    get: function get() {
                        return this._helper.fov;
                    }
                },
                {
                    key: "fovInRadians",
                    get: function get() {
                        return this._helper.fovInRadians;
                    }
                },
                {
                    key: "elevation",
                    get: function get() {
                        return this._helper.elevation;
                    }
                },
                {
                    key: "minElevationForCurrentTile",
                    get: function get() {
                        return this._helper.minElevationForCurrentTile;
                    }
                },
                {
                    key: "padding",
                    get: function get() {
                        return this._helper.padding;
                    }
                },
                {
                    key: "unmodified",
                    get: function get() {
                        return this._helper.unmodified;
                    }
                },
                {
                    key: "renderWorldCopies",
                    get: function get() {
                        return this._helper.renderWorldCopies;
                    }
                },
                {
                    key: "cameraToCenterDistance",
                    get: function get() {
                        return this._helper.cameraToCenterDistance;
                    }
                },
                {
                    key: "constrainOverride",
                    get: function get() {
                        return this._helper.constrainOverride;
                    }
                },
                {
                    key: "nearZ",
                    get: function get() {
                        return this._helper.nearZ;
                    }
                },
                {
                    key: "farZ",
                    get: function get() {
                        return this._helper.farZ;
                    }
                },
                {
                    key: "autoCalculateNearFarZ",
                    get: function get() {
                        return this._helper.autoCalculateNearFarZ;
                    }
                },
                {
                    key: "isGlobeRendering",
                    get: function get() {
                        return this._globeness > 0;
                    }
                },
                {
                    key: "setTransitionState",
                    value: function setTransitionState(e1, t) {
                        this._globeness = e1, this._globeLatitudeErrorCorrectionRadians = t, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().prepareNextFrame(), this._mercatorTransform.getCoveringTilesDetailsProvider().prepareNextFrame();
                    }
                },
                {
                    key: "currentTransform",
                    get: function get() {
                        return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
                    }
                },
                {
                    key: "clone",
                    value: function clone() {
                        var _$e = new Ri;
                        return _$e._globeness = this._globeness, _$e._globeLatitudeErrorCorrectionRadians = this._globeLatitudeErrorCorrectionRadians, _$e.apply(this), _$e;
                    }
                },
                {
                    key: "apply",
                    value: function apply(e1) {
                        this._helper.apply(e1), this._mercatorTransform.apply(this), this._verticalPerspectiveTransform.apply(this, this._globeLatitudeErrorCorrectionRadians);
                    }
                },
                {
                    key: "projectionMatrix",
                    get: function get() {
                        return this.currentTransform.projectionMatrix;
                    }
                },
                {
                    key: "modelViewProjectionMatrix",
                    get: function get() {
                        return this.currentTransform.modelViewProjectionMatrix;
                    }
                },
                {
                    key: "inverseProjectionMatrix",
                    get: function get() {
                        return this.currentTransform.inverseProjectionMatrix;
                    }
                },
                {
                    key: "cameraPosition",
                    get: function get() {
                        return this.currentTransform.cameraPosition;
                    }
                },
                {
                    key: "getProjectionData",
                    value: function getProjectionData(e1) {
                        var _$t = this._mercatorTransform.getProjectionData(e1), i = this._verticalPerspectiveTransform.getProjectionData(e1);
                        return {
                            mainMatrix: this.isGlobeRendering ? i.mainMatrix : _$t.mainMatrix,
                            clippingPlane: i.clippingPlane,
                            tileMercatorCoords: i.tileMercatorCoords,
                            projectionTransition: e1.applyGlobeMatrix ? this._globeness : 0,
                            fallbackMatrix: _$t.fallbackMatrix
                        };
                    }
                },
                {
                    key: "isLocationOccluded",
                    value: function isLocationOccluded(e1) {
                        return this.currentTransform.isLocationOccluded(e1);
                    }
                },
                {
                    key: "transformLightDirection",
                    value: function transformLightDirection(e1) {
                        return this.currentTransform.transformLightDirection(e1);
                    }
                },
                {
                    key: "getPixelScale",
                    value: function getPixelScale() {
                        return t.bu(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
                    }
                },
                {
                    key: "getCircleRadiusCorrection",
                    value: function getCircleRadiusCorrection() {
                        return t.bu(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
                    }
                },
                {
                    key: "getPitchedTextCorrection",
                    value: function getPitchedTextCorrection(e1, i, a) {
                        var r = this._mercatorTransform.getPitchedTextCorrection(e1, i, a), o = this._verticalPerspectiveTransform.getPitchedTextCorrection(e1, i, a);
                        return t.bu(r, o, this._globeness);
                    }
                },
                {
                    key: "projectTileCoordinates",
                    value: function projectTileCoordinates(e1, t, i, a) {
                        return this.currentTransform.projectTileCoordinates(e1, t, i, a);
                    }
                },
                {
                    key: "_calcMatrices",
                    value: function _calcMatrices() {
                        this._helper._width && this._helper._height && (this._verticalPerspectiveTransform.apply(this, this._globeLatitudeErrorCorrectionRadians), this._helper._nearZ = this._verticalPerspectiveTransform.nearZ, this._helper._farZ = this._verticalPerspectiveTransform.farZ, this._mercatorTransform.apply(this, !0, this.isGlobeRendering), this._helper._nearZ = this._mercatorTransform.nearZ, this._helper._farZ = this._mercatorTransform.farZ);
                    }
                },
                {
                    key: "calculateFogMatrix",
                    value: function calculateFogMatrix(e1) {
                        return this.currentTransform.calculateFogMatrix(e1);
                    }
                },
                {
                    key: "getVisibleUnwrappedCoordinates",
                    value: function getVisibleUnwrappedCoordinates(e1) {
                        return this.currentTransform.getVisibleUnwrappedCoordinates(e1);
                    }
                },
                {
                    key: "getCameraFrustum",
                    value: function getCameraFrustum() {
                        return this.currentTransform.getCameraFrustum();
                    }
                },
                {
                    key: "getClippingPlane",
                    value: function getClippingPlane() {
                        return this.currentTransform.getClippingPlane();
                    }
                },
                {
                    key: "getCoveringTilesDetailsProvider",
                    value: function getCoveringTilesDetailsProvider() {
                        return this.currentTransform.getCoveringTilesDetailsProvider();
                    }
                },
                {
                    key: "recalculateZoomAndCenter",
                    value: function recalculateZoomAndCenter(e1) {
                        this._mercatorTransform.recalculateZoomAndCenter(e1), this._verticalPerspectiveTransform.recalculateZoomAndCenter(e1);
                    }
                },
                {
                    key: "maxPitchScaleFactor",
                    value: function maxPitchScaleFactor() {
                        return this._mercatorTransform.maxPitchScaleFactor();
                    }
                },
                {
                    key: "getCameraPoint",
                    value: function getCameraPoint() {
                        return this._helper.getCameraPoint();
                    }
                },
                {
                    key: "getCameraAltitude",
                    value: function getCameraAltitude() {
                        return this._helper.getCameraAltitude();
                    }
                },
                {
                    key: "getCameraLngLat",
                    value: function getCameraLngLat() {
                        return this._helper.getCameraLngLat();
                    }
                },
                {
                    key: "lngLatToCameraDepth",
                    value: function lngLatToCameraDepth(e1, t) {
                        return this.currentTransform.lngLatToCameraDepth(e1, t);
                    }
                },
                {
                    key: "populateCache",
                    value: function populateCache(e1) {
                        this._mercatorTransform.populateCache(e1), this._verticalPerspectiveTransform.populateCache(e1);
                    }
                },
                {
                    key: "getBounds",
                    value: function getBounds() {
                        return this.currentTransform.getBounds();
                    }
                },
                {
                    key: "calculateCenterFromCameraLngLatAlt",
                    value: function calculateCenterFromCameraLngLatAlt(e1, t, i, a) {
                        return this._helper.calculateCenterFromCameraLngLatAlt(e1, t, i, a);
                    }
                },
                {
                    key: "setLocationAtPoint",
                    value: function setLocationAtPoint(e1, t) {
                        if (!this.isGlobeRendering) return this._mercatorTransform.setLocationAtPoint(e1, t), void this.apply(this._mercatorTransform);
                        this._verticalPerspectiveTransform.setLocationAtPoint(e1, t), this.apply(this._verticalPerspectiveTransform);
                    }
                },
                {
                    key: "locationToScreenPoint",
                    value: function locationToScreenPoint(e1, t) {
                        return this.currentTransform.locationToScreenPoint(e1, t);
                    }
                },
                {
                    key: "screenPointToMercatorCoordinate",
                    value: function screenPointToMercatorCoordinate(e1, t) {
                        return this.currentTransform.screenPointToMercatorCoordinate(e1, t);
                    }
                },
                {
                    key: "screenPointToLocation",
                    value: function screenPointToLocation(e1, t) {
                        return this.currentTransform.screenPointToLocation(e1, t);
                    }
                },
                {
                    key: "isPointOnMapSurface",
                    value: function isPointOnMapSurface(e1, t) {
                        return this.currentTransform.isPointOnMapSurface(e1, t);
                    }
                },
                {
                    key: "getRayDirectionFromPixel",
                    value: function getRayDirectionFromPixel(e1) {
                        return this._verticalPerspectiveTransform.getRayDirectionFromPixel(e1);
                    }
                },
                {
                    key: "getMatrixForModel",
                    value: function getMatrixForModel(e1, t) {
                        return this.currentTransform.getMatrixForModel(e1, t);
                    }
                },
                {
                    key: "getProjectionDataForCustomLayer",
                    value: function getProjectionDataForCustomLayer() {
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                        var _$t = this._mercatorTransform.getProjectionDataForCustomLayer(_$e);
                        if (!this.isGlobeRendering) return _$t;
                        var i = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(_$e);
                        return i.fallbackMatrix = _$t.mainMatrix, i;
                    }
                },
                {
                    key: "getFastPathSimpleProjectionMatrix",
                    value: function getFastPathSimpleProjectionMatrix(e1) {
                        return this.currentTransform.getFastPathSimpleProjectionMatrix(e1);
                    }
                }
            ]);
            return Ri;
        }();
        var zi = /*#__PURE__*/ function() {
            function zi() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, zi);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(zi, [
                {
                    key: "useGlobeControls",
                    get: function get() {
                        return !0;
                    }
                },
                {
                    key: "handlePanInertia",
                    value: function handlePanInertia(e1, i) {
                        var a = bi(e1, i);
                        return Math.abs(a.lng - i.center.lng) > 180 && (a.lng = i.center.lng + 179.5 * Math.sign(a.lng - i.center.lng)), {
                            easingCenter: a,
                            easingOffset: new t.P(0, 0)
                        };
                    }
                },
                {
                    key: "handleMapControlsRollPitchBearingZoom",
                    value: function handleMapControlsRollPitchBearingZoom(e1, i) {
                        var a = e1.around, r = i.screenPointToLocation(a);
                        e1.bearingDelta && i.setBearing(i.bearing + e1.bearingDelta), e1.pitchDelta && i.setPitch(i.pitch + e1.pitchDelta), e1.rollDelta && i.setRoll(i.roll + e1.rollDelta);
                        var o = i.zoom;
                        e1.zoomDelta && i.setZoom(i.zoom + e1.zoomDelta);
                        var s = i.zoom - o;
                        if (0 === s) return;
                        var n = t.bK(i.center.lng, r.lng), l = n / (Math.abs(n / 180) + 1), _$c = t.bK(i.center.lat, r.lat), h = i.getRayDirectionFromPixel(a), u = i.cameraPosition, d = -1 * t.b5(u, h), _ = t.bz();
                        t.b0(_, u, [
                            h[0] * d,
                            h[1] * d,
                            h[2] * d
                        ]);
                        var p = t.b7(_) - 1, m = Math.exp(.5 * -Math.max(p - .3, 0)), f = fi(i.worldSize, i.center.lat) / Math.min(i.width, i.height), g = t.bx(f, .9, .5, 1, .25), v = (1 - t.aq(-s)) * Math.min(m, g), x = i.center.lat, b = i.zoom, y = new t.V(i.center.lng + l * v, t.an(i.center.lat + _$c * v, -t.ao, t.ao));
                        i.setLocationAtPoint(r, a);
                        var w = i.center, T = t.bx(Math.abs(n), 45, 85, 0, 1), P = t.bx(f, .75, .35, 0, 1), C = Math.pow(Math.max(T, P), .25), I = t.bK(w.lng, y.lng), M = t.bK(w.lat, y.lat);
                        i.setCenter(new t.V(w.lng + I * C, w.lat + M * C).wrap()), i.setZoom(b + xi(x, i.center.lat));
                    }
                },
                {
                    key: "handleMapControlsPan",
                    value: function handleMapControlsPan(e1, t, i) {
                        if (!e1.panDelta) return;
                        var a = t.center.lat, r = t.zoom;
                        t.setCenter(bi(e1.panDelta, t).wrap()), t.setZoom(r + xi(a, t.center.lat));
                    }
                },
                {
                    key: "cameraForBoxAndBearing",
                    value: function cameraForBoxAndBearing(e1, i, a, r, o) {
                        var s = Kt(e1, i, a, r, o), n = i.left / o.width * 2 - 1, l = (o.width - i.right) / o.width * 2 - 1, _$c = i.top / o.height * -2 + 1, h = (o.height - i.bottom) / o.height * -2 + 1, u = t.bK(a.getWest(), a.getEast()) < 0, d = u ? a.getEast() : a.getWest(), _ = u ? a.getWest() : a.getEast(), p = Math.max(a.getNorth(), a.getSouth()), m = Math.min(a.getNorth(), a.getSouth()), f = d + .5 * t.bK(d, _), g = p + .5 * t.bK(p, m), v = o.clone();
                        v.setCenter(s.center), v.setBearing(s.bearing), v.setPitch(0), v.setRoll(0), v.setZoom(s.zoom);
                        var x = v.modelViewProjectionMatrix, b = [
                            mi(a.getNorthWest()),
                            mi(a.getNorthEast()),
                            mi(a.getSouthWest()),
                            mi(a.getSouthEast()),
                            mi(new t.V(_, g)),
                            mi(new t.V(d, g)),
                            mi(new t.V(f, p)),
                            mi(new t.V(f, m))
                        ], y = mi(s.center);
                        var w = Number.POSITIVE_INFINITY;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = b[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                n < 0 && (w = zi.getLesserNonNegativeNonNull(w, zi.solveVectorScale(_$e, y, x, "x", n))), l > 0 && (w = zi.getLesserNonNegativeNonNull(w, zi.solveVectorScale(_$e, y, x, "x", l))), _$c > 0 && (w = zi.getLesserNonNegativeNonNull(w, zi.solveVectorScale(_$e, y, x, "y", _$c))), h < 0 && (w = zi.getLesserNonNegativeNonNull(w, zi.solveVectorScale(_$e, y, x, "y", h)));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (Number.isFinite(w) && 0 !== w) return s.zoom = v.zoom + t.at(w), s;
                        Ht();
                    }
                },
                {
                    key: "handleJumpToCenterZoom",
                    value: function handleJumpToCenterZoom(e1, i) {
                        var a = e1.center.lat, r = e1.applyConstrain(i.center ? t.V.convert(i.center) : e1.center, e1.zoom).center;
                        e1.setCenter(r.wrap());
                        var o = void 0 !== i.zoom ? +i.zoom : e1.zoom + xi(a, r.lat);
                        e1.zoom !== o && e1.setZoom(o);
                    }
                },
                {
                    key: "handleEaseTo",
                    value: function handleEaseTo(e1, i) {
                        var a = e1.zoom, r = e1.center, o = e1.padding, s = {
                            roll: e1.roll,
                            pitch: e1.pitch,
                            bearing: e1.bearing
                        }, n = {
                            roll: void 0 === i.roll ? e1.roll : i.roll,
                            pitch: void 0 === i.pitch ? e1.pitch : i.pitch,
                            bearing: void 0 === i.bearing ? e1.bearing : i.bearing
                        }, l = void 0 !== i.zoom, _$c = !e1.isPaddingEqual(i.padding);
                        var h = !1;
                        var u = i.center ? t.V.convert(i.center) : r, d = e1.applyConstrain(u, a).center;
                        Zt(e1, d);
                        var _ = e1.clone();
                        _.setCenter(d), _.setZoom(l ? +i.zoom : a + xi(r.lat, u.lat)), _.setBearing(i.bearing);
                        var p = new t.P(t.an(e1.centerPoint.x + i.offsetAsPoint.x, 0, e1.width), t.an(e1.centerPoint.y + i.offsetAsPoint.y, 0, e1.height));
                        _.setLocationAtPoint(d, p);
                        var m = (i.offset && i.offsetAsPoint.mag()) > 0 ? _.center : d, f = l ? +i.zoom : a + xi(r.lat, m.lat), g = a + xi(r.lat, 0), v = f + xi(m.lat, 0), x = t.bK(r.lng, m.lng), b = t.bK(r.lat, m.lat), y = t.aq(v - g);
                        return h = f !== a, {
                            easeFunc: function(a) {
                                if (t.bo(s, n) || Xt({
                                    startEulerAngles: s,
                                    endEulerAngles: n,
                                    tr: e1,
                                    k: a,
                                    useSlerp: s.roll != n.roll
                                }), _$c && e1.interpolatePadding(o, i.padding, a), i.around) t.w("Easing around a point is not supported under globe projection."), e1.setLocationAtPoint(i.around, i.aroundPoint);
                                else {
                                    var _$t = v > g ? Math.min(2, y) : Math.max(.5, y), _$i = Math.pow(_$t, 1 - a), o1 = wi(r, x, b, a * _$i);
                                    e1.setCenter(o1.wrap());
                                }
                                if (h) {
                                    var _$i1 = t.G.number(g, v, a) + xi(0, e1.center.lat);
                                    e1.setZoom(_$i1);
                                }
                            },
                            isZooming: h,
                            elevationCenter: m
                        };
                    }
                },
                {
                    key: "handleFlyTo",
                    value: function handleFlyTo(e1, i) {
                        var a = void 0 !== i.zoom, r = e1.center, o = e1.zoom, s = e1.padding, n = !e1.isPaddingEqual(i.padding), l = e1.applyConstrain(t.V.convert(i.center || i.locationAtOffset), o).center, _$c = a ? +i.zoom : e1.zoom + xi(e1.center.lat, l.lat), h = e1.clone();
                        h.setCenter(l), h.setZoom(_$c), h.setBearing(i.bearing);
                        var u = new t.P(t.an(e1.centerPoint.x + i.offsetAsPoint.x, 0, e1.width), t.an(e1.centerPoint.y + i.offsetAsPoint.y, 0, e1.height));
                        h.setLocationAtPoint(l, u);
                        var d = h.center;
                        Zt(e1, d);
                        var _ = function(e1, i, a) {
                            var r = mi(i), o = mi(a), s = t.b5(r, o), n = Math.acos(s), l = _i(e1);
                            return n / (2 * Math.PI) * l;
                        }(e1, r, d), p = o + xi(r.lat, 0), m = _$c + xi(d.lat, 0), f = t.aq(m - p);
                        var g;
                        if ("number" == typeof i.minZoom) {
                            var a1 = +i.minZoom + xi(d.lat, 0), r1 = Math.min(a1, p, m) + xi(0, d.lat), o1 = e1.applyConstrain(d, r1).zoom + xi(d.lat, 0);
                            g = t.aq(o1 - p);
                        }
                        var v = t.bK(r.lng, d.lng), x = t.bK(r.lat, d.lat);
                        return {
                            easeFunc: function(a, o, l, h) {
                                var u = wi(r, v, x, l);
                                n && e1.interpolatePadding(s, i.padding, a);
                                var _ = 1 === a ? d : u;
                                e1.setCenter(_.wrap());
                                var m = p + t.at(o);
                                e1.setZoom(1 === a ? _$c : m + xi(0, _.lat));
                            },
                            scaleOfZoom: f,
                            targetCenter: d,
                            scaleOfMinZoom: g,
                            pixelPathLength: _
                        };
                    }
                }
            ], [
                {
                    key: "solveVectorScale",
                    value: function solveVectorScale(e1, t, i, a, r) {
                        var o = "x" === a ? [
                            i[0],
                            i[4],
                            i[8],
                            i[12]
                        ] : [
                            i[1],
                            i[5],
                            i[9],
                            i[13]
                        ], s = [
                            i[3],
                            i[7],
                            i[11],
                            i[15]
                        ], n = e1[0] * o[0] + e1[1] * o[1] + e1[2] * o[2], l = e1[0] * s[0] + e1[1] * s[1] + e1[2] * s[2], _$c = t[0] * o[0] + t[1] * o[1] + t[2] * o[2], h = t[0] * s[0] + t[1] * s[1] + t[2] * s[2];
                        return _$c + r * l === n + r * h || s[3] * (n - _$c) + o[3] * (h - l) + n * h == _$c * l ? null : (_$c + o[3] - r * h - r * s[3]) / (_$c - n - r * h + r * l);
                    }
                },
                {
                    key: "getLesserNonNegativeNonNull",
                    value: function getLesserNonNegativeNonNull(e1, t) {
                        return null !== t && t >= 0 && t < e1 ? t : e1;
                    }
                }
            ]);
            return zi;
        }();
        var Di = /*#__PURE__*/ function() {
            function Di(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Di);
                this._globe = e1, this._mercatorCameraHelper = new Yt, this._verticalPerspectiveCameraHelper = new zi;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Di, [
                {
                    key: "useGlobeControls",
                    get: function get() {
                        return this._globe.useGlobeRendering;
                    }
                },
                {
                    key: "currentHelper",
                    get: function get() {
                        return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
                    }
                },
                {
                    key: "handlePanInertia",
                    value: function handlePanInertia(e1, t) {
                        return this.currentHelper.handlePanInertia(e1, t);
                    }
                },
                {
                    key: "handleMapControlsRollPitchBearingZoom",
                    value: function handleMapControlsRollPitchBearingZoom(e1, t) {
                        return this.currentHelper.handleMapControlsRollPitchBearingZoom(e1, t);
                    }
                },
                {
                    key: "handleMapControlsPan",
                    value: function handleMapControlsPan(e1, t, i) {
                        this.currentHelper.handleMapControlsPan(e1, t, i);
                    }
                },
                {
                    key: "cameraForBoxAndBearing",
                    value: function cameraForBoxAndBearing(e1, t, i, a, r) {
                        return this.currentHelper.cameraForBoxAndBearing(e1, t, i, a, r);
                    }
                },
                {
                    key: "handleJumpToCenterZoom",
                    value: function handleJumpToCenterZoom(e1, t) {
                        this.currentHelper.handleJumpToCenterZoom(e1, t);
                    }
                },
                {
                    key: "handleEaseTo",
                    value: function handleEaseTo(e1, t) {
                        return this.currentHelper.handleEaseTo(e1, t);
                    }
                },
                {
                    key: "handleFlyTo",
                    value: function handleFlyTo(e1, t) {
                        return this.currentHelper.handleFlyTo(e1, t);
                    }
                }
            ]);
            return Di;
        }();
        var Ai = function(e1, i) {
            return t.B(e1, i && i.filter(function(e1) {
                return "source.canvas" !== e1.identifier;
            }));
        }, Li = t.bO();
        var ki = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ki, _t_E);
            function ki(e1) {
                var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ki);
                var _this;
                var a, r;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ki), _this._rtlPluginLoaded = function() {
                    for(var _$e in _this.tileManagers){
                        var _$t = _this.tileManagers[_$e].getSource().type;
                        "vector" !== _$t && "geojson" !== _$t || _this.tileManagers[_$e].reload();
                    }
                }, _this.map = e1, _this.dispatcher = new N(j(), e1._getMapId()), _this.dispatcher.registerMessageHandler("GG", function(e1, t) {
                    return _this.getGlyphs(e1, t);
                }), _this.dispatcher.registerMessageHandler("GI", function(e1, t) {
                    return _this.getImages(e1, t);
                }), _this.dispatcher.registerMessageHandler("GDA", function(e1, t) {
                    return _this.getDashes(e1, t);
                }), _this.imageManager = new w, _this.imageManager.setEventedParent(_this);
                var o = (null === (a = e1._container) || void 0 === a ? void 0 : a.lang) || "undefined" != typeof document && (null === (r = document.documentElement) || void 0 === r ? void 0 : r.lang) || void 0;
                _this.glyphManager = new M(e1._requestManager, i.localIdeographFontFamily, o), _this.lineAtlas = new A(256, 512), _this.crossTileSymbolIndex = new zt, _this._setInitialValues(), _this._resetUpdates(), _this.dispatcher.broadcast("SR", t.bP()), ce().on(se, _this._rtlPluginLoaded), _this.on("data", function(e1) {
                    if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
                    var _$t = _this.tileManagers[e1.sourceId];
                    if (!_$t) return;
                    var i = _$t.getSource();
                    if (i && i.vectorLayerIds) for(var _$e in _this._layers){
                        var _$t1 = _this._layers[_$e];
                        _$t1.source === i.id && _this._validateLayer(_$t1);
                    }
                });
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ki, [
                {
                    key: "_setInitialValues",
                    value: function _setInitialValues() {
                        var _$e;
                        this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.tileManagers = {}, this.zoomHistory = new t.bQ, this._availableImages = [], this._globalState = {}, this._serializedLayers = {}, this.stylesheet = null, this.light = null, this.sky = null, this.projection && (this.projection.destroy(), delete this.projection), this._loaded = !1, this._changed = !1, this._updatedLayers = {}, this._updatedSources = {}, this._changedImages = {}, this._glyphsDidChange = !1, this._updatedPaintProps = {}, this._layerOrderChanged = !1, this.crossTileSymbolIndex = new ((null === (_$e = this.crossTileSymbolIndex) || void 0 === _$e ? void 0 : _$e.constructor) || Object), this.pauseablePlacement = void 0, this.placement = void 0, this.z = 0;
                    }
                },
                {
                    key: "setGlobalStateProperty",
                    value: function setGlobalStateProperty(e1, i) {
                        var a, r, o;
                        this._checkLoaded();
                        var s = null === i ? null !== (o = null === (r = null === (a = this.stylesheet.state) || void 0 === a ? void 0 : a[e1]) || void 0 === r ? void 0 : r.default) && void 0 !== o ? o : null : i;
                        if (t.bR(s, this._globalState[e1])) return this;
                        this._globalState[e1] = s, this._applyGlobalStateChanges([
                            e1
                        ]);
                    }
                },
                {
                    key: "getGlobalState",
                    value: function getGlobalState() {
                        return this._globalState;
                    }
                },
                {
                    key: "setGlobalState",
                    value: function setGlobalState(e1) {
                        this._checkLoaded();
                        var i = [];
                        for(var a in e1)!t.bR(this._globalState[a], e1[a].default) && (i.push(a), this._globalState[a] = e1[a].default);
                        this._applyGlobalStateChanges(i);
                    }
                },
                {
                    key: "_applyGlobalStateChanges",
                    value: function _applyGlobalStateChanges(e1) {
                        if (0 === e1.length) return;
                        var _$t = new Set, i = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var a = _step.value;
                                i[a] = this._globalState[a];
                                for(var _$e in this._layers){
                                    var i1 = this._layers[_$e], r = i1.getLayoutAffectingGlobalStateRefs(), o = i1.getPaintAffectingGlobalStateRefs(), s = i1.getVisibilityAffectingGlobalStateRefs();
                                    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                    if (r.has(a) && _$t.add(i1.source), o.has(a)) try {
                                        for(var _iterator1 = o.get(a)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                            var _step_value = _step1.value, _$e1 = _step_value.name, _$t1 = _step_value.value;
                                            this._updatePaintProperty(i1, _$e1, _$t1);
                                        }
                                    } catch (err) {
                                        _didIteratorError1 = true;
                                        _iteratorError1 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                _iterator1.return();
                                            }
                                        } finally{
                                            if (_didIteratorError1) {
                                                throw _iteratorError1;
                                            }
                                        }
                                    }
                                    (null == s ? void 0 : s.has(a)) && (i1.recalculateVisibility(), this._updateLayer(i1));
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this.dispatcher.broadcast("UGS", i);
                        for(var _$e2 in this.tileManagers)_$t.has(_$e2) && (this._reloadSource(_$e2), this._changed = !0);
                    }
                },
                {
                    key: "loadURL",
                    value: function loadURL(e1) {
                        var _this = this;
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 ? arguments[2] : void 0;
                        this.fire(new t.l("dataloading", {
                            dataType: "style"
                        })), i.validate = "boolean" != typeof i.validate || i.validate;
                        var r = this.map._requestManager.transformRequest(e1, "Style");
                        this._loadStyleRequest = new AbortController;
                        var o = this._loadStyleRequest;
                        t.j(r, this._loadStyleRequest).then(function(e1) {
                            _this._loadStyleRequest = null, _this._load(e1.data, i, a);
                        }).catch(function(e1) {
                            _this._loadStyleRequest = null, e1 && !o.signal.aborted && _this.fire(new t.k(e1));
                        });
                    }
                },
                {
                    key: "loadJSON",
                    value: function loadJSON(e1) {
                        var _this = this;
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 ? arguments[2] : void 0;
                        this.fire(new t.l("dataloading", {
                            dataType: "style"
                        })), this._frameRequest = new AbortController, n.frameAsync(this._frameRequest).then(function() {
                            _this._frameRequest = null, i.validate = !1 !== i.validate, _this._load(e1, i, a);
                        }).catch(function() {});
                    }
                },
                {
                    key: "loadEmpty",
                    value: function loadEmpty() {
                        this.fire(new t.l("dataloading", {
                            dataType: "style"
                        })), this._load(Li, {
                            validate: !1
                        });
                    }
                },
                {
                    key: "_load",
                    value: function _load(e1, i, a) {
                        var r, o;
                        var s = i.transformStyle ? i.transformStyle(a, e1) : e1;
                        if (!i.validate || !Ai(this, t.C(s))) {
                            s = Object.assign({}, s), this._loaded = !0, this.stylesheet = s;
                            for(var _$e in s.sources)this.addSource(_$e, s.sources[_$e], {
                                validate: !1
                            });
                            s.sprite ? this._loadSprite(s.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(s.glyphs), this._createLayers(), this.light = new R(this.stylesheet.light), this._setProjectionInternal((null === (r = this.stylesheet.projection) || void 0 === r ? void 0 : r.type) || "mercator"), this.sky = new D(this.stylesheet.sky), this.map.setTerrain(null !== (o = this.stylesheet.terrain) && void 0 !== o ? o : null), this.fire(new t.l("data", {
                                dataType: "style"
                            })), this.fire(new t.l("style.load"));
                        }
                    }
                },
                {
                    key: "_createLayers",
                    value: function _createLayers() {
                        var _$e, i, a;
                        var r = t.bS(this.stylesheet.layers);
                        this.setGlobalState(null !== (_$e = this.stylesheet.state) && void 0 !== _$e ? _$e : null), this.dispatcher.broadcast("SL", r), this._order = r.map(function(e1) {
                            return e1.id;
                        }), this._layers = {}, this._serializedLayers = null;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e1 = _step.value;
                                var r1 = t.bT(_$e1, this._globalState);
                                if (r1.setEventedParent(this, {
                                    layer: {
                                        id: _$e1.id
                                    }
                                }), this._layers[_$e1.id] = r1, t.bU(r1) && this.tileManagers[r1.source]) {
                                    var _$t = null !== (a = null === (i = _$e1.paint) || void 0 === i ? void 0 : i["raster-fade-duration"]) && void 0 !== a ? a : r1.paint.get("raster-fade-duration");
                                    this.tileManagers[r1.source].setRasterFadeDuration(_$t);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_loadSprite",
                    value: function _loadSprite(e1) {
                        var _this = this;
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1, a = arguments.length > 2 ? arguments[2] : void 0;
                        this.imageManager.setLoaded(!1);
                        var r = new AbortController;
                        var o;
                        this._spriteRequest = r, (function(e1, i, a, r) {
                            return t._(this, void 0, void 0, function() {
                                var o, s, l, _$c, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, _$e, _$a, o1, n1;
                                return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            o = x(e1), s = a > 1 ? "@2x" : "", l = {}, _$c = {};
                                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                            try {
                                                for(_iterator = o[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                    _step_value = _step.value, _$e = _step_value.id, _$a = _step_value.url;
                                                    o1 = i.transformRequest(b(_$a, s, ".json"), "SpriteJSON");
                                                    l[_$e] = t.j(o1, r);
                                                    n1 = i.transformRequest(b(_$a, s, ".png"), "SpriteImage");
                                                    _$c[_$e] = g.getImage(n1, r);
                                                }
                                            } catch (err) {
                                                _didIteratorError = true;
                                                _iteratorError = err;
                                            } finally{
                                                try {
                                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                        _iterator.return();
                                                    }
                                                } finally{
                                                    if (_didIteratorError) {
                                                        throw _iteratorError;
                                                    }
                                                }
                                            }
                                            return [
                                                4,
                                                Promise.all((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(Object.values(l)).concat((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(Object.values(_$c))))
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                (_state.sent(), function(e1, i) {
                                                    return t._(this, void 0, void 0, function() {
                                                        var _$t, _tmp, _tmp1, _i, _$a, _$r, o, _, _$e, _o_e, _$i, s, n1, l, _$c, h, u, d, _1, p, m;
                                                        return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    _$t = {};
                                                                    _tmp = [];
                                                                    for(_tmp1 in e1)_tmp.push(_tmp1);
                                                                    _i = 0;
                                                                    _state.label = 1;
                                                                case 1:
                                                                    if (!(_i < _tmp.length)) return [
                                                                        3,
                                                                        5
                                                                    ];
                                                                    _$a = _tmp[_i];
                                                                    _$t[_$a] = {};
                                                                    _ = n.getImageCanvasContext;
                                                                    return [
                                                                        4,
                                                                        i[_$a]
                                                                    ];
                                                                case 2:
                                                                    _$r = _.apply(n, [
                                                                        _state.sent().data
                                                                    ]);
                                                                    return [
                                                                        4,
                                                                        e1[_$a]
                                                                    ];
                                                                case 3:
                                                                    o = _state.sent().data;
                                                                    for(var _$e in o){
                                                                        _o_e = o[_$e], _$i = _o_e.width, s = _o_e.height, n1 = _o_e.x, l = _o_e.y, _$c = _o_e.sdf, h = _o_e.pixelRatio, u = _o_e.stretchX, d = _o_e.stretchY, _1 = _o_e.content, p = _o_e.textFitWidth, m = _o_e.textFitHeight;
                                                                        _$t[_$a][_$e] = {
                                                                            data: null,
                                                                            pixelRatio: h,
                                                                            sdf: _$c,
                                                                            stretchX: u,
                                                                            stretchY: d,
                                                                            content: _1,
                                                                            textFitWidth: p,
                                                                            textFitHeight: m,
                                                                            spriteData: {
                                                                                width: _$i,
                                                                                height: s,
                                                                                x: n1,
                                                                                y: l,
                                                                                context: _$r
                                                                            }
                                                                        };
                                                                    }
                                                                    _state.label = 4;
                                                                case 4:
                                                                    _i++;
                                                                    return [
                                                                        3,
                                                                        1
                                                                    ];
                                                                case 5:
                                                                    return [
                                                                        2,
                                                                        _$t
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                }(l, _$c))
                                            ];
                                    }
                                });
                            });
                        })(e1, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then(function(e1) {
                            if (_this._spriteRequest = null, e1) for(var _$t in e1){
                                _this._spritesImagesIds[_$t] = [];
                                var a = _this._spritesImagesIds[_$t] ? _this._spritesImagesIds[_$t].filter(function(t) {
                                    return !(t in e1);
                                }) : [];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$e = _step.value;
                                        _this.imageManager.removeImage(_$e), _this._changedImages[_$e] = !0;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                for(var a1 in e1[_$t]){
                                    var r = "default" === _$t ? a1 : "".concat(_$t, ":").concat(a1);
                                    _this._spritesImagesIds[_$t].push(r), r in _this.imageManager.images ? _this.imageManager.updateImage(r, e1[_$t][a1], !1) : _this.imageManager.addImage(r, e1[_$t][a1]), i && (_this._changedImages[r] = !0);
                                }
                            }
                        }).catch(function(e1) {
                            _this._spriteRequest = null, o = e1, r.signal.aborted || _this.fire(new t.k(o));
                        }).finally(function() {
                            _this.imageManager.setLoaded(!0), _this._availableImages = _this.imageManager.listImages(), i && (_this._changed = !0), _this.dispatcher.broadcast("SI", _this._availableImages), _this.fire(new t.l("data", {
                                dataType: "style"
                            })), a && a(o);
                        });
                    }
                },
                {
                    key: "_unloadSprite",
                    value: function _unloadSprite() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.values(this._spritesImagesIds).flat()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                this.imageManager.removeImage(_$e), this._changedImages[_$e] = !0;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                            dataType: "style"
                        }));
                    }
                },
                {
                    key: "_validateLayer",
                    value: function _validateLayer(e1) {
                        var i = this.tileManagers[e1.source];
                        if (!i) return;
                        var a = e1.sourceLayer;
                        if (!a) return;
                        var r = i.getSource();
                        ("geojson" === r.type || r.vectorLayerIds && -1 === r.vectorLayerIds.indexOf(a)) && this.fire(new t.k(new Error('Source layer "'.concat(a, '" does not exist on source "').concat(r.id, '" as specified by style layer "').concat(e1.id, '".'))));
                    }
                },
                {
                    key: "loaded",
                    value: function loaded() {
                        if (!this._loaded) return !1;
                        if (Object.keys(this._updatedSources).length) return !1;
                        for(var _$e in this.tileManagers)if (!this.tileManagers[_$e].loaded()) return !1;
                        return !!this.imageManager.isLoaded();
                    }
                },
                {
                    key: "_serializeByIds",
                    value: function _serializeByIds(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !1;
                        var a = this._serializedAllLayers();
                        if (!e1 || 0 === e1.length) return Object.values(i ? t.bV(a) : a);
                        var r = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var o = _step.value;
                                if (a[o]) {
                                    var _$e = i ? t.bV(a[o]) : a[o];
                                    r.push(_$e);
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return r;
                    }
                },
                {
                    key: "_serializedAllLayers",
                    value: function _serializedAllLayers() {
                        var _$e = this._serializedLayers;
                        if (_$e) return _$e;
                        _$e = this._serializedLayers = {};
                        var _$t = Object.keys(this._layers);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = _$t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                var _$t1 = this._layers[i];
                                "custom" !== _$t1.type && (_$e[i] = _$t1.serialize());
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$e;
                    }
                },
                {
                    key: "hasTransitions",
                    value: function hasTransitions() {
                        var _$e, _$t, i;
                        if (null === (_$e = this.light) || void 0 === _$e ? void 0 : _$e.hasTransition()) return !0;
                        if (null === (_$t = this.sky) || void 0 === _$t ? void 0 : _$t.hasTransition()) return !0;
                        if (null === (i = this.projection) || void 0 === i ? void 0 : i.hasTransition()) return !0;
                        for(var _$e1 in this.tileManagers)if (this.tileManagers[_$e1].hasTransition()) return !0;
                        for(var _$e2 in this._layers)if (this._layers[_$e2].hasTransition()) return !0;
                        return !1;
                    }
                },
                {
                    key: "_checkLoaded",
                    value: function _checkLoaded() {
                        if (!this._loaded) throw new Error("Style is not done loading.");
                    }
                },
                {
                    key: "update",
                    value: function update(e1) {
                        if (!this._loaded) return;
                        var i = this._changed;
                        if (i) {
                            var _$t = Object.keys(this._updatedLayers), i1 = Object.keys(this._removedLayers);
                            (_$t.length || i1.length) && this._updateWorkerLayers(_$t, i1);
                            for(var _$e in this._updatedSources){
                                var _$t1 = this._updatedSources[_$e];
                                if ("reload" === _$t1) this._reloadSource(_$e);
                                else {
                                    if ("clear" !== _$t1) throw new Error("Invalid action ".concat(_$t1));
                                    this._clearSource(_$e);
                                }
                            }
                            this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                            for(var _$t2 in this._updatedPaintProps)this._layers[_$t2].updateTransitions(e1);
                            this.light.updateTransitions(e1), this.sky.updateTransitions(e1), this._resetUpdates();
                        }
                        var a = {};
                        for(var _$e1 in this.tileManagers){
                            var _$t3 = this.tileManagers[_$e1];
                            a[_$e1] = _$t3.used, _$t3.used = !1;
                        }
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._order[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t4 = _step.value;
                                var i2 = this._layers[_$t4];
                                i2.recalculate(e1, this._availableImages), !i2.isHidden(e1.zoom) && i2.source && (this.tileManagers[i2.source].used = !0);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        for(var _$e2 in a){
                            var i3 = this.tileManagers[_$e2];
                            !!a[_$e2] != !!i3.used && i3.fire(new t.l("data", {
                                sourceDataType: "visibility",
                                dataType: "source",
                                sourceId: _$e2
                            }));
                        }
                        this.light.recalculate(e1), this.sky.recalculate(e1), this.projection.recalculate(e1), this.z = e1.zoom, i && this.fire(new t.l("data", {
                            dataType: "style"
                        }));
                    }
                },
                {
                    key: "_updateTilesForChangedImages",
                    value: function _updateTilesForChangedImages() {
                        var _$e = Object.keys(this._changedImages);
                        if (_$e.length) {
                            for(var _$t in this.tileManagers)this.tileManagers[_$t].reloadTilesForDependencies([
                                "icons",
                                "patterns"
                            ], _$e);
                            this._changedImages = {};
                        }
                    }
                },
                {
                    key: "_updateTilesForChangedGlyphs",
                    value: function _updateTilesForChangedGlyphs() {
                        if (this._glyphsDidChange) {
                            for(var _$e in this.tileManagers)this.tileManagers[_$e].reloadTilesForDependencies([
                                "glyphs"
                            ], [
                                ""
                            ]);
                            this._glyphsDidChange = !1;
                        }
                    }
                },
                {
                    key: "_updateWorkerLayers",
                    value: function _updateWorkerLayers(e1, t) {
                        this.dispatcher.broadcast("UL", {
                            layers: this._serializeByIds(e1, !1),
                            removedIds: t
                        });
                    }
                },
                {
                    key: "_resetUpdates",
                    value: function _resetUpdates() {
                        this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
                    }
                },
                {
                    key: "setState",
                    value: function setState(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        var a;
                        this._checkLoaded();
                        var r = this.serialize();
                        if (e1 = i.transformStyle ? i.transformStyle(r, e1) : e1, (null === (a = i.validate) || void 0 === a || a) && Ai(this, t.C(e1))) return !1;
                        (e1 = t.bV(e1)).layers = t.bS(e1.layers);
                        var o = t.bW(r, e1), s = this._getOperationsToPerform(o);
                        if (s.unimplemented.length > 0) throw new Error("Unimplemented: ".concat(s.unimplemented.join(", "), "."));
                        if (0 === s.operations.length) return !1;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = s.operations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                _$e();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return this.stylesheet = e1, this._serializedLayers = null, !0;
                    }
                },
                {
                    key: "_getOperationsToPerform",
                    value: function _getOperationsToPerform(e1) {
                        var _this = this;
                        var _$t = [], i = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _this1, _loop = function() {
                                var a = _step.value;
                                switch(a.command){
                                    case "setCenter":
                                    case "setZoom":
                                    case "setBearing":
                                    case "setPitch":
                                    case "setRoll":
                                        return "continue";
                                    case "addLayer":
                                        _$t.push(function() {
                                            return _this.addLayer.apply(_this, a.args);
                                        });
                                        break;
                                    case "removeLayer":
                                        _$t.push(function() {
                                            return _this.removeLayer.apply(_this, a.args);
                                        });
                                        break;
                                    case "setPaintProperty":
                                        _$t.push(function() {
                                            return _this.setPaintProperty.apply(_this, a.args);
                                        });
                                        break;
                                    case "setLayoutProperty":
                                        _$t.push(function() {
                                            return _this.setLayoutProperty.apply(_this, a.args);
                                        });
                                        break;
                                    case "setFilter":
                                        _$t.push(function() {
                                            return _this.setFilter.apply(_this, a.args);
                                        });
                                        break;
                                    case "addSource":
                                        _$t.push(function() {
                                            return _this.addSource.apply(_this, a.args);
                                        });
                                        break;
                                    case "removeSource":
                                        _$t.push(function() {
                                            return _this.removeSource.apply(_this, a.args);
                                        });
                                        break;
                                    case "setLayerZoomRange":
                                        _$t.push(function() {
                                            return _this.setLayerZoomRange.apply(_this, a.args);
                                        });
                                        break;
                                    case "setLight":
                                        _$t.push(function() {
                                            return _this.setLight.apply(_this, a.args);
                                        });
                                        break;
                                    case "setGeoJSONSourceData":
                                        _$t.push(function() {
                                            return _this.setGeoJSONSourceData.apply(_this, a.args);
                                        });
                                        break;
                                    case "setGlyphs":
                                        _$t.push(function() {
                                            return _this.setGlyphs.apply(_this, a.args);
                                        });
                                        break;
                                    case "setSprite":
                                        _$t.push(function() {
                                            return _this.setSprite.apply(_this, a.args);
                                        });
                                        break;
                                    case "setTerrain":
                                        _$t.push(function() {
                                            return _this.map.setTerrain.apply(_this, a.args);
                                        });
                                        break;
                                    case "setSky":
                                        _$t.push(function() {
                                            return _this.setSky.apply(_this, a.args);
                                        });
                                        break;
                                    case "setProjection":
                                        _this1.setProjection.apply(_this1, a.args);
                                        break;
                                    case "setGlobalState":
                                        _$t.push(function() {
                                            return _this.setGlobalState.apply(_this, a.args);
                                        });
                                        break;
                                    case "setTransition":
                                        _$t.push(function() {});
                                        break;
                                    default:
                                        i.push(a.command);
                                }
                            };
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this1 = this, _loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return {
                            operations: _$t,
                            unimplemented: i
                        };
                    }
                },
                {
                    key: "addImage",
                    value: function addImage(e1, i) {
                        if (this.getImage(e1)) return this.fire(new t.k(new Error('An image named "'.concat(e1, '" already exists.'))));
                        this.imageManager.addImage(e1, i), this._afterImageUpdated(e1);
                    }
                },
                {
                    key: "updateImage",
                    value: function updateImage(e1, t) {
                        this.imageManager.updateImage(e1, t);
                    }
                },
                {
                    key: "getImage",
                    value: function getImage(e1) {
                        return this.imageManager.getImage(e1);
                    }
                },
                {
                    key: "removeImage",
                    value: function removeImage(e1) {
                        if (!this.getImage(e1)) return this.fire(new t.k(new Error('An image named "'.concat(e1, '" does not exist.'))));
                        this.imageManager.removeImage(e1), this._afterImageUpdated(e1);
                    }
                },
                {
                    key: "_afterImageUpdated",
                    value: function _afterImageUpdated(e1) {
                        this._availableImages = this.imageManager.listImages(), this._changedImages[e1] = !0, this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                            dataType: "style"
                        }));
                    }
                },
                {
                    key: "listImages",
                    value: function listImages() {
                        return this._checkLoaded(), this.imageManager.listImages();
                    }
                },
                {
                    key: "addSource",
                    value: function addSource(e1, i) {
                        var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        if (this._checkLoaded(), void 0 !== this.tileManagers[e1]) throw new Error('Source "'.concat(e1, '" already exists.'));
                        if (!i.type) throw new Error("The type property must be defined, but only the following properties were given: ".concat(Object.keys(i).join(", "), "."));
                        if ([
                            "vector",
                            "raster",
                            "geojson",
                            "video",
                            "image"
                        ].indexOf(i.type) >= 0 && this._validate(t.C.source, "sources.".concat(e1), i, null, a)) return;
                        this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                        var r = this.tileManagers[e1] = new ke(e1, i, this.dispatcher);
                        r.style = this, r.setEventedParent(this, function() {
                            return {
                                isSourceLoaded: r.loaded(),
                                source: r.serialize(),
                                sourceId: e1
                            };
                        }), r.onAdd(this.map), this._changed = !0;
                    }
                },
                {
                    key: "removeSource",
                    value: function removeSource(e1) {
                        if (this._checkLoaded(), void 0 === this.tileManagers[e1]) throw new Error("There is no source with this ID");
                        for(var i in this._layers)if (this._layers[i].source === e1) return this.fire(new t.k(new Error('Source "'.concat(e1, '" cannot be removed while layer "').concat(i, '" is using it.'))));
                        var i1 = this.tileManagers[e1];
                        delete this.tileManagers[e1], delete this._updatedSources[e1], i1.fire(new t.l("data", {
                            sourceDataType: "metadata",
                            dataType: "source",
                            sourceId: e1
                        })), i1.setEventedParent(null), i1.onRemove(this.map), this._changed = !0;
                    }
                },
                {
                    key: "setGeoJSONSourceData",
                    value: function setGeoJSONSourceData(e1, t) {
                        if (this._checkLoaded(), void 0 === this.tileManagers[e1]) throw new Error("There is no source with this ID=".concat(e1));
                        var i = this.tileManagers[e1].getSource();
                        if ("geojson" !== i.type) throw new Error("geojsonSource.type is ".concat(i.type, ", which is !== 'geojson"));
                        i.setData(t), this._changed = !0;
                    }
                },
                {
                    key: "getSource",
                    value: function getSource(e1) {
                        return this.tileManagers[e1] && this.tileManagers[e1].getSource();
                    }
                },
                {
                    key: "addLayer",
                    value: function addLayer(e1, i) {
                        var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        this._checkLoaded();
                        var r = e1.id;
                        if (this.getLayer(r)) return void this.fire(new t.k(new Error('Layer "'.concat(r, '" already exists on this map.'))));
                        var o;
                        if ("custom" === e1.type) {
                            if (Ai(this, t.bX(e1))) return;
                            o = t.bT(e1, this._globalState);
                        } else {
                            if ("source" in e1 && "object" == (0, $dvYFb._)(e1.source) && (this.addSource(r, e1.source), e1 = t.bV(e1), e1 = t.e(e1, {
                                source: r
                            })), this._validate(t.C.layer, "layers.".concat(r), e1, {
                                arrayIndex: -1
                            }, a)) return;
                            o = t.bT(e1, this._globalState), this._validateLayer(o), o.setEventedParent(this, {
                                layer: {
                                    id: r
                                }
                            });
                        }
                        var s = i ? this._order.indexOf(i) : this._order.length;
                        if (i && -1 === s) this.fire(new t.k(new Error('Cannot add layer "'.concat(r, '" before non-existing layer "').concat(i, '".'))));
                        else {
                            if (this._order.splice(s, 0, r), this._layerOrderChanged = !0, this._layers[r] = o, this._removedLayers[r] && o.source && "custom" !== o.type) {
                                var _$e = this._removedLayers[r];
                                delete this._removedLayers[r], _$e.type !== o.type ? this._updatedSources[o.source] = "clear" : (this._updatedSources[o.source] = "reload", this.tileManagers[o.source].pause());
                            }
                            this._updateLayer(o), o.onAdd && o.onAdd(this.map);
                        }
                    }
                },
                {
                    key: "moveLayer",
                    value: function moveLayer(e1, i) {
                        if (this._checkLoaded(), this._changed = !0, !this._layers[e1]) return void this.fire(new t.k(new Error("The layer '".concat(e1, "' does not exist in the map's style and cannot be moved."))));
                        if (e1 === i) return;
                        var a = this._order.indexOf(e1);
                        this._order.splice(a, 1);
                        var r = i ? this._order.indexOf(i) : this._order.length;
                        i && -1 === r ? this.fire(new t.k(new Error('Cannot move layer "'.concat(e1, '" before non-existing layer "').concat(i, '".')))) : (this._order.splice(r, 0, e1), this._layerOrderChanged = !0);
                    }
                },
                {
                    key: "removeLayer",
                    value: function removeLayer(e1) {
                        this._checkLoaded();
                        var i = this._layers[e1];
                        if (!i) return void this.fire(new t.k(new Error('Cannot remove non-existing layer "'.concat(e1, '".'))));
                        i.setEventedParent(null);
                        var a = this._order.indexOf(e1);
                        this._order.splice(a, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[e1] = i, delete this._layers[e1], this._serializedLayers && delete this._serializedLayers[e1], delete this._updatedLayers[e1], delete this._updatedPaintProps[e1], i.onRemove && i.onRemove(this.map);
                    }
                },
                {
                    key: "getLayer",
                    value: function getLayer(e1) {
                        return this._layers[e1];
                    }
                },
                {
                    key: "getLayersOrder",
                    value: function getLayersOrder() {
                        return (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(this._order);
                    }
                },
                {
                    key: "hasLayer",
                    value: function hasLayer(e1) {
                        return e1 in this._layers;
                    }
                },
                {
                    key: "setLayerZoomRange",
                    value: function setLayerZoomRange(e1, i, a) {
                        this._checkLoaded();
                        var r = this.getLayer(e1);
                        r ? r.minzoom === i && r.maxzoom === a || (null != i && (r.minzoom = i), null != a && (r.maxzoom = a), this._updateLayer(r)) : this.fire(new t.k(new Error('Cannot set the zoom range of non-existing layer "'.concat(e1, '".'))));
                    }
                },
                {
                    key: "setFilter",
                    value: function setFilter(e1, i) {
                        var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        this._checkLoaded();
                        var r = this.getLayer(e1);
                        if (r) {
                            if (!t.bR(r.filter, i)) return null == i ? (r.setFilter(void 0), void this._updateLayer(r)) : void (this._validate(t.C.filter, "layers.".concat(r.id, ".filter"), i, null, a) || (r.setFilter(t.bV(i)), this._updateLayer(r)));
                        } else this.fire(new t.k(new Error('Cannot filter non-existing layer "'.concat(e1, '".'))));
                    }
                },
                {
                    key: "getFilter",
                    value: function getFilter(e1) {
                        return t.bV(this.getLayer(e1).filter);
                    }
                },
                {
                    key: "setLayoutProperty",
                    value: function setLayoutProperty(e1, i, a) {
                        var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                        this._checkLoaded();
                        var o = this.getLayer(e1);
                        o ? t.bR(o.getLayoutProperty(i), a) || (o.setLayoutProperty(i, a, r), this._updateLayer(o)) : this.fire(new t.k(new Error('Cannot style non-existing layer "'.concat(e1, '".'))));
                    }
                },
                {
                    key: "getLayoutProperty",
                    value: function getLayoutProperty(e1, i) {
                        var a = this.getLayer(e1);
                        if (a) return a.getLayoutProperty(i);
                        this.fire(new t.k(new Error('Cannot get style of non-existing layer "'.concat(e1, '".'))));
                    }
                },
                {
                    key: "setPaintProperty",
                    value: function setPaintProperty(e1, i, a) {
                        var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                        this._checkLoaded();
                        var o = this.getLayer(e1);
                        o ? t.bR(o.getPaintProperty(i), a) || this._updatePaintProperty(o, i, a, r) : this.fire(new t.k(new Error('Cannot style non-existing layer "'.concat(e1, '".'))));
                    }
                },
                {
                    key: "_updatePaintProperty",
                    value: function _updatePaintProperty(e1, i, a) {
                        var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                        e1.setPaintProperty(i, a, r) && this._updateLayer(e1), t.bU(e1) && "raster-fade-duration" === i && this.tileManagers[e1.source].setRasterFadeDuration(a), this._changed = !0, this._updatedPaintProps[e1.id] = !0, this._serializedLayers = null;
                    }
                },
                {
                    key: "getPaintProperty",
                    value: function getPaintProperty(e1, t) {
                        return this.getLayer(e1).getPaintProperty(t);
                    }
                },
                {
                    key: "setFeatureState",
                    value: function setFeatureState(e1, i) {
                        this._checkLoaded();
                        var a = e1.source, r = e1.sourceLayer, o = this.tileManagers[a];
                        if (void 0 === o) return void this.fire(new t.k(new Error("The source '".concat(a, "' does not exist in the map's style."))));
                        var s = o.getSource().type;
                        "geojson" === s && r ? this.fire(new t.k(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== s || r ? (void 0 === e1.id && this.fire(new t.k(new Error("The feature id parameter must be provided."))), o.setFeatureState(r, e1.id, i)) : this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                    }
                },
                {
                    key: "removeFeatureState",
                    value: function removeFeatureState(e1, i) {
                        this._checkLoaded();
                        var a = e1.source, r = this.tileManagers[a];
                        if (void 0 === r) return void this.fire(new t.k(new Error("The source '".concat(a, "' does not exist in the map's style."))));
                        var o = r.getSource().type, s = "vector" === o ? e1.sourceLayer : void 0;
                        "vector" !== o || s ? i && "string" != typeof e1.id && "number" != typeof e1.id ? this.fire(new t.k(new Error("A feature id is required to remove its specific state property."))) : r.removeFeatureState(s, e1.id, i) : this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                    }
                },
                {
                    key: "getFeatureState",
                    value: function getFeatureState(e1) {
                        this._checkLoaded();
                        var i = e1.source, a = e1.sourceLayer, r = this.tileManagers[i];
                        if (void 0 !== r) return "vector" !== r.getSource().type || a ? (void 0 === e1.id && this.fire(new t.k(new Error("The feature id parameter must be provided."))), r.getFeatureState(a, e1.id)) : void this.fire(new t.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                        this.fire(new t.k(new Error("The source '".concat(i, "' does not exist in the map's style."))));
                    }
                },
                {
                    key: "getTransition",
                    value: function getTransition() {
                        return t.e({
                            duration: 300,
                            delay: 0
                        }, this.stylesheet && this.stylesheet.transition);
                    }
                },
                {
                    key: "serialize",
                    value: function serialize() {
                        if (!this._loaded) return;
                        var _$e = t.bY(this.tileManagers, function(e1) {
                            return e1.serialize();
                        }), i = this._serializeByIds(this._order, !0), a = this.map.getTerrain() || void 0, r = this.stylesheet;
                        return t.bZ({
                            version: r.version,
                            name: r.name,
                            metadata: r.metadata,
                            light: r.light,
                            sky: r.sky,
                            center: r.center,
                            zoom: r.zoom,
                            bearing: r.bearing,
                            pitch: r.pitch,
                            sprite: r.sprite,
                            glyphs: r.glyphs,
                            transition: r.transition,
                            projection: r.projection,
                            sources: _$e,
                            layers: i,
                            terrain: a
                        }, function(e1) {
                            return void 0 !== e1;
                        });
                    }
                },
                {
                    key: "_updateLayer",
                    value: function _updateLayer(e1) {
                        this._updatedLayers[e1.id] = !0, e1.source && !this._updatedSources[e1.source] && "raster" !== this.tileManagers[e1.source].getSource().type && (this._updatedSources[e1.source] = "reload", this.tileManagers[e1.source].pause()), this._serializedLayers = null, this._changed = !0;
                    }
                },
                {
                    key: "_flattenAndSortRenderedFeatures",
                    value: function _flattenAndSortRenderedFeatures(e1) {
                        var _this = this;
                        var _$t = function(e1) {
                            return "fill-extrusion" === _this._layers[e1].type;
                        }, i = {}, a = [];
                        for(var r = this._order.length - 1; r >= 0; r--){
                            var o = this._order[r];
                            if (_$t(o)) {
                                i[o] = r;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$t1 = _step.value;
                                        var _$e = _$t1[o];
                                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                        if (_$e) try {
                                            for(var _iterator1 = _$e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                                var _$t2 = _step1.value;
                                                a.push(_$t2);
                                            }
                                        } catch (err) {
                                            _didIteratorError1 = true;
                                            _iteratorError1 = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                                    _iterator1.return();
                                                }
                                            } finally{
                                                if (_didIteratorError1) {
                                                    throw _iteratorError1;
                                                }
                                            }
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                        }
                        a.sort(function(e1, t) {
                            return t.intersectionZ - e1.intersectionZ;
                        });
                        var r1 = [];
                        for(var o1 = this._order.length - 1; o1 >= 0; o1--){
                            var s = this._order[o1];
                            var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            if (_$t(s)) for(var _$e1 = a.length - 1; _$e1 >= 0; _$e1--){
                                var _$t3 = a[_$e1].feature;
                                if (i[_$t3.layer.id] < o1) break;
                                r1.push(_$t3), a.pop();
                            }
                            else try {
                                for(var _iterator2 = e1[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    var _$t4 = _step2.value;
                                    var _$e2 = _$t4[s];
                                    var _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                                    if (_$e2) try {
                                        for(var _iterator3 = _$e2[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                                            var _$t5 = _step3.value;
                                            r1.push(_$t5.feature);
                                        }
                                    } catch (err) {
                                        _didIteratorError3 = true;
                                        _iteratorError3 = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                                _iterator3.return();
                                            }
                                        } finally{
                                            if (_didIteratorError3) {
                                                throw _iteratorError3;
                                            }
                                        }
                                    }
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                        return r1;
                    }
                },
                {
                    key: "queryRenderedFeatures",
                    value: function queryRenderedFeatures(e1, i, a) {
                        var _this = this;
                        i && i.filter && this._validate(t.C.filter, "queryRenderedFeatures.filter", i.filter, null, i);
                        var r = {};
                        if (i && i.layers) {
                            if (!(Array.isArray(i.layers) || i.layers instanceof Set)) return this.fire(new t.k(new Error("parameters.layers must be an Array or a Set of strings"))), [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = i.layers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    var _$i = this._layers[_$e];
                                    if (!_$i) return this.fire(new t.k(new Error("The layer '".concat(_$e, "' does not exist in the map's style and cannot be queried for features.")))), [];
                                    r[_$i.source] = !0;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        var o = [];
                        i.availableImages = this._availableImages;
                        var s = this._serializedAllLayers(), n = i.layers instanceof Set ? i.layers : Array.isArray(i.layers) ? new Set(i.layers) : null, l = Object.assign(Object.assign({}, i), {
                            layers: n,
                            globalState: this._globalState
                        });
                        for(var _$t in this.tileManagers)i.layers && !r[_$t] || o.push(U(this.tileManagers[_$t], this._layers, s, e1, l, a, this.map.terrain ? function(e1, t, i) {
                            return _this.map.terrain.getElevation(e1, t, i);
                        } : void 0));
                        return this.placement && o.push(function(e1, t, i, a, r, o, s) {
                            var n = {}, l = o.queryRenderedSymbols(a), _$c = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = Object.keys(l).map(Number)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    _$c.push(s[_$e]);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            _$c.sort(V);
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                var _loop = function() {
                                    var _$i = _step1.value;
                                    var _$a = _$i.featureIndex.lookupSymbolFeatures(l[_$i.bucketInstanceId], t, _$i.bucketIndex, _$i.sourceLayerIndex, {
                                        filterSpec: r.filter,
                                        globalState: r.globalState
                                    }, r.layers, r.availableImages, e1);
                                    for(var _$e in _$a){
                                        var _$t = n[_$e] = n[_$e] || [], _$r = _$a[_$e];
                                        _$r.sort(function(e1, t) {
                                            var _$a = _$i.featureSortOrder;
                                            if (_$a) {
                                                var _$i1 = _$a.indexOf(e1.featureIndex);
                                                return _$a.indexOf(t.featureIndex) - _$i1;
                                            }
                                            return t.featureIndex - e1.featureIndex;
                                        });
                                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                        try {
                                            for(var _iterator = _$r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                                var _$e1 = _step.value;
                                                _$t.push(_$e1);
                                            }
                                        } catch (err) {
                                            _didIteratorError = true;
                                            _iteratorError = err;
                                        } finally{
                                            try {
                                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                    _iterator.return();
                                                }
                                            } finally{
                                                if (_didIteratorError) {
                                                    throw _iteratorError;
                                                }
                                            }
                                        }
                                    }
                                };
                                for(var _iterator1 = _$c[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop();
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                            return function(e1, t, i) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                for(var _$a in e1)try {
                                    for(var _iterator = e1[_$a][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$r = _step.value;
                                        q(_$r, i[t[_$a].source]);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return e1;
                            }(n, e1, i);
                        }(this._layers, s, this.tileManagers, e1, l, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(o);
                    }
                },
                {
                    key: "querySourceFeatures",
                    value: function querySourceFeatures(e1, i) {
                        (null == i ? void 0 : i.filter) && this._validate(t.C.filter, "querySourceFeatures.filter", i.filter, null, i);
                        var a = this.tileManagers[e1];
                        return a ? function(e1, t) {
                            var _$i = e1.getRenderableIds().map(function(t) {
                                return e1.getTileByID(t);
                            }), a = [], r = {};
                            for(var _$e = 0; _$e < _$i.length; _$e++){
                                var o = _$i[_$e], s = o.tileID.canonical.key;
                                r[s] || (r[s] = !0, o.querySourceFeatures(a, t));
                            }
                            return a;
                        }(a, i ? Object.assign(Object.assign({}, i), {
                            globalState: this._globalState
                        }) : {
                            globalState: this._globalState
                        }) : [];
                    }
                },
                {
                    key: "getLight",
                    value: function getLight() {
                        return this.light.getLight();
                    }
                },
                {
                    key: "setLight",
                    value: function setLight(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        this._checkLoaded();
                        var a = this.light.getLight();
                        var r = !1;
                        for(var i1 in e1)if (!t.bR(e1[i1], a[i1])) {
                            r = !0;
                            break;
                        }
                        if (!r) return;
                        var o = {
                            now: c(),
                            transition: t.e({
                                duration: 300,
                                delay: 0
                            }, this.stylesheet.transition)
                        };
                        this.light.setLight(e1, i), this.light.updateTransitions(o);
                    }
                },
                {
                    key: "getProjection",
                    value: function getProjection() {
                        var _$e;
                        return null === (_$e = this.stylesheet) || void 0 === _$e ? void 0 : _$e.projection;
                    }
                },
                {
                    key: "setProjection",
                    value: function setProjection(e1) {
                        if (this._checkLoaded(), this.projection) {
                            if (this.projection.name === e1.type) return;
                            this.projection.destroy(), delete this.projection;
                        }
                        this.stylesheet.projection = e1, this._setProjectionInternal(e1.type);
                    }
                },
                {
                    key: "getSky",
                    value: function getSky() {
                        var _$e;
                        return null === (_$e = this.stylesheet) || void 0 === _$e ? void 0 : _$e.sky;
                    }
                },
                {
                    key: "setSky",
                    value: function setSky(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        this._checkLoaded();
                        var a = this.getSky();
                        var r = !1;
                        if (!e1 && !a) return;
                        if (e1 && !a) r = !0;
                        else if (!e1 && a) r = !0;
                        else for(var i1 in e1)if (!t.bR(e1[i1], a[i1])) {
                            r = !0;
                            break;
                        }
                        if (!r) return;
                        var o = {
                            now: c(),
                            transition: t.e({
                                duration: 300,
                                delay: 0
                            }, this.stylesheet.transition)
                        };
                        this.stylesheet.sky = e1, this.sky.setSky(e1, i), this.sky.updateTransitions(o);
                    }
                },
                {
                    key: "_setProjectionInternal",
                    value: function _setProjectionInternal(e1) {
                        var i = function(e1, i) {
                            var a = {
                                constrainOverride: i
                            };
                            if (Array.isArray(e1)) {
                                var _$t = new di({
                                    type: e1
                                });
                                return {
                                    projection: _$t,
                                    transform: new Ri(a),
                                    cameraHelper: new Di(_$t)
                                };
                            }
                            switch(e1){
                                case "mercator":
                                    return {
                                        projection: new jt,
                                        transform: new $t(a),
                                        cameraHelper: new Yt
                                    };
                                case "globe":
                                    {
                                        var _$e = new di({
                                            type: [
                                                "interpolate",
                                                [
                                                    "linear"
                                                ],
                                                [
                                                    "zoom"
                                                ],
                                                11,
                                                "vertical-perspective",
                                                12,
                                                "mercator"
                                            ]
                                        });
                                        return {
                                            projection: _$e,
                                            transform: new Ri(a),
                                            cameraHelper: new Di(_$e)
                                        };
                                    }
                                case "vertical-perspective":
                                    return {
                                        projection: new hi,
                                        transform: new Si(a),
                                        cameraHelper: new zi
                                    };
                                default:
                                    return t.w("Unknown projection name: ".concat(e1, ". Falling back to mercator projection.")), {
                                        projection: new jt,
                                        transform: new $t(a),
                                        cameraHelper: new Yt
                                    };
                            }
                        }(e1, this.map.transformConstrain);
                        this.projection = i.projection, this.map.migrateProjection(i.transform, i.cameraHelper);
                        for(var _$e in this.tileManagers)this.tileManagers[_$e].reload();
                    }
                },
                {
                    key: "_validate",
                    value: function _validate(e1, i, a, r) {
                        var o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {};
                        return (!o || !1 !== o.validate) && Ai(this, e1.call(t.C, t.e({
                            key: i,
                            style: this.serialize(),
                            value: a,
                            styleSpec: t.u
                        }, r)));
                    }
                },
                {
                    key: "_remove",
                    value: function _remove() {
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                        this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), ce().off(se, this._rtlPluginLoaded);
                        for(var _$e1 in this._layers)this._layers[_$e1].setEventedParent(null);
                        for(var _$e2 in this.tileManagers){
                            var _$t = this.tileManagers[_$e2];
                            _$t.setEventedParent(null), _$t.onRemove(this.map);
                        }
                        this.imageManager.setEventedParent(null), this.setEventedParent(null), _$e && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(_$e);
                    }
                },
                {
                    key: "_clearSource",
                    value: function _clearSource(e1) {
                        this.tileManagers[e1].clearTiles();
                    }
                },
                {
                    key: "_reloadSource",
                    value: function _reloadSource(e1) {
                        this.tileManagers[e1].resume(), this.tileManagers[e1].reload();
                    }
                },
                {
                    key: "_updateSources",
                    value: function _updateSources(e1) {
                        for(var _$t in this.tileManagers)this.tileManagers[_$t].update(e1, this.map.terrain);
                    }
                },
                {
                    key: "_generateCollisionBoxes",
                    value: function _generateCollisionBoxes() {
                        for(var _$e in this.tileManagers)this._reloadSource(_$e);
                    }
                },
                {
                    key: "_updatePlacement",
                    value: function _updatePlacement(e1, t, i, a) {
                        var r = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : !1;
                        var o = !1, s = !1;
                        var n = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _this, _loop = function() {
                                var _$t = _step.value;
                                var _$i = _this._layers[_$t];
                                if ("symbol" !== _$i.type) return "continue";
                                if (!n[_$i.source]) {
                                    var _$e = _this.tileManagers[_$i.source];
                                    n[_$i.source] = _$e.getRenderableIds(!0).map(function(t) {
                                        return _$e.getTileByID(t);
                                    }).sort(function(e1, t) {
                                        return t.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t.tileID) ? -1 : 1);
                                    });
                                }
                                var _$a = _this.crossTileSymbolIndex.addLayer(_$i, n[_$i.source], e1.center.lng);
                                o = o || _$a;
                            };
                            for(var _iterator = this._order[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_this = this, _loop();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((r = r || this._layerOrderChanged || 0 === i) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(c(), e1.zoom)) && (this.pauseablePlacement = new It(e1, this.map.terrain, this._order, r, t, i, a, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, n), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(c()), s = !0), o && this.pauseablePlacement.placement.setStale()), s || o) try {
                            for(var _iterator1 = this._order[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$e = _step1.value;
                                var _$t = this._layers[_$e];
                                "symbol" === _$t.type && this.placement.updateLayerOpacities(_$t, n[_$t.source]);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(c());
                    }
                },
                {
                    key: "_releaseSymbolFadeTiles",
                    value: function _releaseSymbolFadeTiles() {
                        for(var _$e in this.tileManagers)this.tileManagers[_$e].releaseSymbolFadeTiles();
                    }
                },
                {
                    key: "getImages",
                    value: function getImages(e1, i) {
                        return t._(this, void 0, void 0, function() {
                            var _$e, _$t;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            this.imageManager.getImages(i.icons)
                                        ];
                                    case 1:
                                        _$e = _state.sent();
                                        this._updateTilesForChangedImages();
                                        _$t = this.tileManagers[i.source];
                                        return [
                                            2,
                                            (_$t && _$t.setDependencies(i.tileID.key, i.type, i.icons), _$e)
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "getGlyphs",
                    value: function getGlyphs(e1, i) {
                        return t._(this, void 0, void 0, function() {
                            var _$e, _$t;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            this.glyphManager.getGlyphs(i.stacks)
                                        ];
                                    case 1:
                                        _$e = _state.sent(), _$t = this.tileManagers[i.source];
                                        return [
                                            2,
                                            (_$t && _$t.setDependencies(i.tileID.key, i.type, [
                                                ""
                                            ]), _$e)
                                        ];
                                }
                            });
                        });
                    }
                },
                {
                    key: "getGlyphsUrl",
                    value: function getGlyphsUrl() {
                        return this.stylesheet.glyphs || null;
                    }
                },
                {
                    key: "setGlyphs",
                    value: function setGlyphs(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        this._checkLoaded(), e1 && this._validate(t.C.glyphs, "glyphs", e1, null, i) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = e1, this.glyphManager.entries = {}, this.glyphManager.setURL(e1));
                    }
                },
                {
                    key: "getDashes",
                    value: function getDashes(e1, i) {
                        return t._(this, void 0, void 0, function() {
                            var _$e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _step_value, _$t, a;
                            return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                _$e = {};
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(_iterator = Object.entries(i.dashes)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 2), _$t = _step_value[0], a = _step_value[1];
                                        _$e[_$t] = this.lineAtlas.getDash(a.dasharray, a.round);
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                return [
                                    2,
                                    _$e
                                ];
                            });
                        });
                    }
                },
                {
                    key: "addSprite",
                    value: function addSprite(e1, i) {
                        var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, r = arguments.length > 3 ? arguments[3] : void 0;
                        this._checkLoaded();
                        var o = [
                            {
                                id: e1,
                                url: i
                            }
                        ], s = (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(x(this.stylesheet.sprite)).concat((0, $eb3e8a8ee265ba96$export$71511d61b312f219)(o));
                        this._validate(t.C.sprite, "sprite", s, null, a) || (this.stylesheet.sprite = s, this._loadSprite(o, !0, r));
                    }
                },
                {
                    key: "removeSprite",
                    value: function removeSprite(e1) {
                        this._checkLoaded();
                        var i = x(this.stylesheet.sprite);
                        if (i.find(function(t) {
                            return t.id === e1;
                        })) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            if (this._spritesImagesIds[e1]) try {
                                for(var _iterator = this._spritesImagesIds[e1][Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step.value;
                                    this.imageManager.removeImage(_$t), this._changedImages[_$t] = !0;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            i.splice(i.findIndex(function(t) {
                                return t.id === e1;
                            }), 1), this.stylesheet.sprite = i.length > 0 ? i : void 0, delete this._spritesImagesIds[e1], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new t.l("data", {
                                dataType: "style"
                            }));
                        } else this.fire(new t.k(new Error('Sprite "'.concat(e1, "\" doesn't exists on this map."))));
                    }
                },
                {
                    key: "getSprite",
                    value: function getSprite() {
                        return x(this.stylesheet.sprite);
                    }
                },
                {
                    key: "setSprite",
                    value: function setSprite(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, a = arguments.length > 2 ? arguments[2] : void 0;
                        this._checkLoaded(), e1 && this._validate(t.C.sprite, "sprite", e1, null, i) || (this.stylesheet.sprite = e1, e1 ? this._loadSprite(e1, !0, a) : (this._unloadSprite(), a && a(null)));
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null);
                        for(var _$e in this.tileManagers){
                            var _$t = this.tileManagers[_$e];
                            _$t.setEventedParent(null), _$t.onRemove(this.map);
                        }
                        this.tileManagers = {}, this.imageManager && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this._availableImages = [], this._spritesImagesIds = {}), this.glyphManager && this.glyphManager.destroy();
                        for(var _$e1 in this._layers){
                            var _$t1 = this._layers[_$e1];
                            _$t1.setEventedParent(null), _$t1.onRemove && _$t1.onRemove(this.map);
                        }
                        this._setInitialValues(), this.setEventedParent(null), this.dispatcher.unregisterMessageHandler("GG"), this.dispatcher.unregisterMessageHandler("GI"), this.dispatcher.unregisterMessageHandler("GDA"), this.dispatcher.remove(!0), this._listeners = {}, this._oneTimeListeners = {};
                    }
                }
            ]);
            return ki;
        }(t.E);
        var Fi = t.aU([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Int16",
                components: 2
            }
        ]);
        var Bi = /*#__PURE__*/ function() {
            function Bi() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Bi);
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Bi, [
                {
                    key: "bind",
                    value: function bind(e1, t, i, a, r, o, s, n, l) {
                        this.context = e1;
                        var _$c = this.boundPaintVertexBuffers.length !== a.length;
                        for(var _$e = 0; !_$c && _$e < a.length; _$e++)this.boundPaintVertexBuffers[_$e] !== a[_$e] && (_$c = !0);
                        !this.vao || this.boundProgram !== t || this.boundLayoutVertexBuffer !== i || _$c || this.boundIndexBuffer !== r || this.boundVertexOffset !== o || this.boundDynamicVertexBuffer !== s || this.boundDynamicVertexBuffer2 !== n || this.boundDynamicVertexBuffer3 !== l ? this.freshBind(t, i, a, r, o, s, n, l) : (e1.bindVertexArray.set(this.vao), s && s.bind(), r && r.dynamicDraw && r.bind(), n && n.bind(), l && l.bind());
                    }
                },
                {
                    key: "freshBind",
                    value: function freshBind(e1, t, i, a, r, o, s, n) {
                        var l = e1.numAttributes, _$c = this.context, h = _$c.gl;
                        this.vao && this.destroy(), this.vao = _$c.createVertexArray(), _$c.bindVertexArray.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = a, this.boundVertexOffset = r, this.boundDynamicVertexBuffer = o, this.boundDynamicVertexBuffer2 = s, this.boundDynamicVertexBuffer3 = n, t.enableAttributes(h, e1);
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                _$t.enableAttributes(h, e1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        o && o.enableAttributes(h, e1), s && s.enableAttributes(h, e1), n && n.enableAttributes(h, e1), t.bind(), t.setVertexAttribPointers(h, e1, r);
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = i[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$t1 = _step1.value;
                                _$t1.bind(), _$t1.setVertexAttribPointers(h, e1, r);
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        o && (o.bind(), o.setVertexAttribPointers(h, e1, r)), a && a.bind(), s && (s.bind(), s.setVertexAttribPointers(h, e1, r)), n && (n.bind(), n.setVertexAttribPointers(h, e1, r)), _$c.currentNumAttributes = l;
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
                    }
                }
            ]);
            return Bi;
        }();
        var Oi = function(e1, i, a, r, o) {
            return {
                u_texture: 0,
                u_ele_delta: e1,
                u_fog_matrix: i,
                u_fog_color: a ? a.properties.get("fog-color") : t.bp.white,
                u_fog_ground_blend: a ? a.properties.get("fog-ground-blend") : 1,
                u_fog_ground_blend_opacity: o ? 0 : a ? a.calculateFogBlendOpacity(r) : 0,
                u_horizon_color: a ? a.properties.get("horizon-color") : t.bp.white,
                u_horizon_fog_blend: a ? a.properties.get("horizon-fog-blend") : 1,
                u_is_globe_mode: o ? 1 : 0
            };
        }, ji = {
            mainMatrix: "u_projection_matrix",
            tileMercatorCoords: "u_projection_tile_mercator_coords",
            clippingPlane: "u_projection_clipping_plane",
            projectionTransition: "u_projection_transition",
            fallbackMatrix: "u_projection_fallback_matrix"
        };
        function Ni(e1) {
            var _$t = [];
            for(var i = 0; i < e1.length; i++){
                if (null === e1[i]) continue;
                var a = e1[i].split(" ");
                _$t.push(a.pop());
            }
            return _$t;
        }
        var Zi = /*#__PURE__*/ function() {
            function Zi(e1, i, a, r, o, s, n, l) {
                var _$c = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : [];
                var _b;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Zi);
                var h = e1.gl;
                this.program = h.createProgram();
                var u = Ni(i.staticAttributes), d = a ? a.getBinderAttributes() : [], _ = u.concat(d), p = At.prelude.staticUniforms ? Ni(At.prelude.staticUniforms) : [], m = n.staticUniforms ? Ni(n.staticUniforms) : [], f = i.staticUniforms ? Ni(i.staticUniforms) : [], g = a ? a.getBinderUniforms() : [], v = p.concat(m).concat(f).concat(g), x = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = v[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$e = _step.value;
                        x.indexOf(_$e) < 0 && x.push(_$e);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                var b = a ? a.defines() : [];
                oi(h) && b.unshift("#version 300 es"), o && b.push("#define OVERDRAW_INSPECTOR;"), s && b.push("#define TERRAIN3D;"), l && b.push(l), _$c && (_b = b).push.apply(_b, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$c));
                var y = b.concat(At.prelude.fragmentSource, n.fragmentSource, i.fragmentSource).join("\n"), w = b.concat(At.prelude.vertexSource, n.vertexSource, i.vertexSource).join("\n");
                oi(h) || (y = function(e1) {
                    return e1.replace(/\bin\s/g, "varying ").replace("out highp vec4 fragColor;", "").replace(/fragColor/g, "gl_FragColor").replace(/texture\(/g, "texture2D(");
                }(y), w = function(e1) {
                    return e1.replace(/\bin\s/g, "attribute ").replace(/\bout\s/g, "varying ").replace(/texture\(/g, "texture2D(");
                }(w));
                var T = h.createShader(h.FRAGMENT_SHADER);
                if (h.isContextLost()) return void (this.failedToCreate = !0);
                if (h.shaderSource(T, y), h.compileShader(T), !h.getShaderParameter(T, h.COMPILE_STATUS)) throw new Error("Could not compile fragment shader: ".concat(h.getShaderInfoLog(T)));
                h.attachShader(this.program, T);
                var P = h.createShader(h.VERTEX_SHADER);
                if (h.isContextLost()) return void (this.failedToCreate = !0);
                if (h.shaderSource(P, w), h.compileShader(P), !h.getShaderParameter(P, h.COMPILE_STATUS)) throw new Error("Could not compile vertex shader: ".concat(h.getShaderInfoLog(P)));
                h.attachShader(this.program, P), this.attributes = {};
                var C = {};
                this.numAttributes = _.length;
                for(var _$e1 = 0; _$e1 < this.numAttributes; _$e1++)_[_$e1] && (h.bindAttribLocation(this.program, _$e1, _[_$e1]), this.attributes[_[_$e1]] = _$e1);
                if (h.linkProgram(this.program), !h.getProgramParameter(this.program, h.LINK_STATUS)) throw new Error("Program failed to link: ".concat(h.getProgramInfoLog(this.program)));
                h.deleteShader(P), h.deleteShader(T);
                for(var _$e2 = 0; _$e2 < x.length; _$e2++){
                    var _$t = x[_$e2];
                    if (_$t && !C[_$t]) {
                        var _$e3 = h.getUniformLocation(this.program, _$t);
                        _$e3 && (C[_$t] = _$e3);
                    }
                }
                this.fixedUniforms = r(e1, C), this.terrainUniforms = function(e1, i) {
                    return {
                        u_depth: new t.b_(e1, i.u_depth),
                        u_terrain: new t.b_(e1, i.u_terrain),
                        u_terrain_dim: new t.bq(e1, i.u_terrain_dim),
                        u_terrain_matrix: new t.c0(e1, i.u_terrain_matrix),
                        u_terrain_unpack: new t.c1(e1, i.u_terrain_unpack),
                        u_terrain_exaggeration: new t.bq(e1, i.u_terrain_exaggeration)
                    };
                }(e1, C), this.projectionUniforms = function(e1, i) {
                    return {
                        u_projection_matrix: new t.c0(e1, i.u_projection_matrix),
                        u_projection_tile_mercator_coords: new t.c1(e1, i.u_projection_tile_mercator_coords),
                        u_projection_clipping_plane: new t.c1(e1, i.u_projection_clipping_plane),
                        u_projection_transition: new t.bq(e1, i.u_projection_transition),
                        u_projection_fallback_matrix: new t.c0(e1, i.u_projection_fallback_matrix)
                    };
                }(e1, C), this.binderUniforms = a ? a.getUniforms(e1, C) : [];
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Zi, [
                {
                    key: "draw",
                    value: function draw(e1, t, i, a, r, o, s, n, l, c, h, u, d, _, p, m, f, g, v) {
                        var x = e1.gl;
                        if (this.failedToCreate) return;
                        if (e1.program.set(this.program), e1.setDepthMode(i), e1.setStencilMode(a), e1.setColorMode(r), e1.setCullFace(o), n) {
                            e1.activeTexture.set(x.TEXTURE2), x.bindTexture(x.TEXTURE_2D, n.depthTexture), e1.activeTexture.set(x.TEXTURE3), x.bindTexture(x.TEXTURE_2D, n.texture);
                            for(var _$e in this.terrainUniforms)this.terrainUniforms[_$e].set(n[_$e]);
                        }
                        if (l) for(var _$e1 in l)this.projectionUniforms[ji[_$e1]].set(l[_$e1]);
                        if (s) for(var _$e2 in this.fixedUniforms)this.fixedUniforms[_$e2].set(s[_$e2]);
                        m && m.setUniforms(e1, this.binderUniforms, _, {
                            zoom: p
                        });
                        var b = 0;
                        switch(t){
                            case x.LINES:
                                b = 2;
                                break;
                            case x.TRIANGLES:
                                b = 3;
                                break;
                            case x.LINE_STRIP:
                                b = 1;
                        }
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = d.get()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$i = _step.value;
                                var _$a = _$i.vaos || (_$i.vaos = {});
                                (_$a[c] || (_$a[c] = new Bi)).bind(e1, this, h, m ? m.getPaintVertexBuffers() : [], u, _$i.vertexOffset, f, g, v), x.drawElements(t, _$i.primitiveLength * b, x.UNSIGNED_SHORT, _$i.primitiveOffset * b * 2);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                }
            ]);
            return Zi;
        }();
        function Gi(e1, i, a) {
            var r = 1 / t.aN(a, 1, i.transform.tileZoom), o = Math.pow(2, a.tileID.overscaledZ), s = a.tileSize * Math.pow(2, i.transform.tileZoom) / o, n = s * (a.tileID.canonical.x + a.tileID.wrap * o), l = s * a.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: a.imageAtlasTexture.size,
                u_scale: [
                    r,
                    e1.fromScale,
                    e1.toScale
                ],
                u_fade: e1.t,
                u_pixel_coord_upper: [
                    n >> 16,
                    l >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & n,
                    65535 & l
                ]
            };
        }
        var Ui = function(e1, i, a, r) {
            var o = e1.style.light, s = o.properties.get("position"), n = [
                s.x,
                s.y,
                s.z
            ], l = t.c4();
            "viewport" === o.properties.get("anchor") && t.c5(l, e1.transform.bearingInRadians), t.c6(n, n, l);
            var _$c = e1.transform.transformLightDirection(n), h = o.properties.get("color");
            return {
                u_lightpos: n,
                u_lightpos_globe: _$c,
                u_lightintensity: o.properties.get("intensity"),
                u_lightcolor: [
                    h.r,
                    h.g,
                    h.b
                ],
                u_vertical_gradient: +i,
                u_opacity: a,
                u_fill_translate: r
            };
        }, Vi = function(e1, i, a, r, o, s, n) {
            return t.e(Ui(e1, i, a, r), Gi(s, e1, n), {
                u_height_factor: -Math.pow(2, o.overscaledZ) / n.tileSize / 8
            });
        }, qi = function(e1, i, a, r) {
            return t.e(Gi(i, e1, a), {
                u_fill_translate: r
            });
        }, Wi = function(e1, t) {
            return {
                u_world: e1,
                u_fill_translate: t
            };
        }, $i = function(e1, i, a, r, o) {
            return t.e(qi(e1, i, a, o), {
                u_world: r
            });
        }, Hi = function(e1, i, a, r, o) {
            var s = e1.transform;
            var n, l, _$c = 0;
            if ("map" === a.paint.get("circle-pitch-alignment")) {
                var _$e = t.aN(i, 1, s.zoom);
                n = !0, l = [
                    _$e,
                    _$e
                ], _$c = _$e / (t.a5 * Math.pow(2, i.tileID.overscaledZ)) * 2 * Math.PI * o;
            } else n = !1, l = s.pixelsToGLUnits;
            return {
                u_camera_to_center_distance: s.cameraToCenterDistance,
                u_scale_with_map: +("map" === a.paint.get("circle-pitch-scale")),
                u_pitch_with_map: +n,
                u_device_pixel_ratio: e1.pixelRatio,
                u_extrude_scale: l,
                u_globe_extrude_scale: _$c,
                u_translate: r
            };
        }, Xi = function(e1) {
            return {
                u_pixel_extrude_scale: [
                    1 / e1.width,
                    1 / e1.height
                ]
            };
        }, Ki = function(e1) {
            return {
                u_viewport_size: [
                    e1.width,
                    e1.height
                ]
            };
        }, Yi = function(e1) {
            var _$t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
            return {
                u_color: e1,
                u_overlay: 0,
                u_overlay_scale: _$t
            };
        }, Qi = function(e1, i, a, r) {
            var o = t.aN(e1, 1, i) / (t.a5 * Math.pow(2, e1.tileID.overscaledZ)) * 2 * Math.PI * r;
            return {
                u_extrude_scale: t.aN(e1, 1, i),
                u_intensity: a,
                u_globe_extrude_scale: o
            };
        }, Ji = function(e1, i, a, r) {
            var o = t.N();
            t.c7(o, 0, e1.width, e1.height, 0, 0, 1);
            var s = e1.context.gl;
            return {
                u_matrix: o,
                u_world: [
                    s.drawingBufferWidth,
                    s.drawingBufferHeight
                ],
                u_image: a,
                u_color_ramp: r,
                u_opacity: i.paint.get("heatmap-opacity")
            };
        }, ea = function(e1, t, i) {
            var a = i.paint.get("hillshade-accent-color");
            var r;
            switch(i.paint.get("hillshade-method")){
                case "basic":
                    r = 4;
                    break;
                case "combined":
                    r = 1;
                    break;
                case "igor":
                    r = 2;
                    break;
                case "multidirectional":
                    r = 3;
                    break;
                default:
                    r = 0;
            }
            var o = i.getIlluminationProperties();
            for(var _$t = 0; _$t < o.directionRadians.length; _$t++)"viewport" === i.paint.get("hillshade-illumination-anchor") && (o.directionRadians[_$t] += e1.transform.bearingInRadians);
            return {
                u_image: 0,
                u_latrange: ia(0, t.tileID),
                u_exaggeration: i.paint.get("hillshade-exaggeration"),
                u_altitudes: o.altitudeRadians,
                u_azimuths: o.directionRadians,
                u_accent: a,
                u_method: r,
                u_highlights: o.highlightColor,
                u_shadows: o.shadowColor
            };
        }, ta = function(e1, i) {
            var a = i.stride, r = t.N();
            return t.c7(r, 0, t.a5, -t.a5, 0, 0, 1), t.O(r, r, [
                0,
                -t.a5,
                0
            ]), {
                u_matrix: r,
                u_image: 1,
                u_dimension: [
                    a,
                    a
                ],
                u_zoom: e1.overscaledZ,
                u_unpack: i.getUnpackVector()
            };
        };
        function ia(e1, i) {
            var a = Math.pow(2, i.canonical.z), r = i.canonical.y;
            return [
                new t.a9(0, r / a).toLngLat().lat,
                new t.a9(0, (r + 1) / a).toLngLat().lat
            ];
        }
        var aa = function(e1, t) {
            var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
            return {
                u_image: 0,
                u_unpack: t.getUnpackVector(),
                u_dimension: [
                    t.stride,
                    t.stride
                ],
                u_elevation_stops: 1,
                u_color_stops: 4,
                u_color_ramp_size: i,
                u_opacity: e1.paint.get("color-relief-opacity")
            };
        }, ra = function(e1, i, a, r) {
            var o = e1.transform;
            return {
                u_translation: ha(e1, i, a),
                u_ratio: r / t.aN(i, 1, o.zoom),
                u_device_pixel_ratio: e1.pixelRatio,
                u_units_to_pixels: [
                    1 / o.pixelsToGLUnits[0],
                    1 / o.pixelsToGLUnits[1]
                ]
            };
        }, oa = function(e1, i, a, r, o) {
            return t.e(ra(e1, i, a, r), {
                u_image: 0,
                u_image_height: o
            });
        }, sa = function(e1, i, a, r, o) {
            var s = e1.transform, n = ca(i, s);
            return {
                u_translation: ha(e1, i, a),
                u_texsize: i.imageAtlasTexture.size,
                u_ratio: r / t.aN(i, 1, s.zoom),
                u_device_pixel_ratio: e1.pixelRatio,
                u_image: 0,
                u_scale: [
                    n,
                    o.fromScale,
                    o.toScale
                ],
                u_fade: o.t,
                u_units_to_pixels: [
                    1 / s.pixelsToGLUnits[0],
                    1 / s.pixelsToGLUnits[1]
                ]
            };
        }, na = function(e1, i, a, r, o) {
            var s = ca(i, e1.transform);
            return t.e(ra(e1, i, a, r), {
                u_tileratio: s,
                u_crossfade_from: o.fromScale,
                u_crossfade_to: o.toScale,
                u_image: 0,
                u_mix: o.t,
                u_lineatlas_width: e1.lineAtlas.width,
                u_lineatlas_height: e1.lineAtlas.height
            });
        }, la = function(e1, i, a, r, o, s) {
            var n = ca(i, e1.transform);
            return t.e(ra(e1, i, a, r), {
                u_image: 0,
                u_image_height: s,
                u_tileratio: n,
                u_crossfade_from: o.fromScale,
                u_crossfade_to: o.toScale,
                u_image_dash: 1,
                u_mix: o.t,
                u_lineatlas_width: e1.lineAtlas.width,
                u_lineatlas_height: e1.lineAtlas.height
            });
        };
        function ca(e1, i) {
            return 1 / t.aN(e1, 1, i.tileZoom);
        }
        function ha(e1, i, a) {
            return t.aO(e1.transform, i, a.paint.get("line-translate"), a.paint.get("line-translate-anchor"));
        }
        var ua = function(e1, t, i, a, r) {
            var o, s;
            return {
                u_tl_parent: e1,
                u_scale_parent: t,
                u_buffer_scale: 1,
                u_fade_t: i.mix,
                u_opacity: i.opacity * a.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: a.paint.get("raster-brightness-min"),
                u_brightness_high: a.paint.get("raster-brightness-max"),
                u_saturation_factor: (s = a.paint.get("raster-saturation"), s > 0 ? 1 - 1 / (1.001 - s) : -s),
                u_contrast_factor: (o = a.paint.get("raster-contrast"), o > 0 ? 1 / (1 - o) : 1 + o),
                u_spin_weights: da(a.paint.get("raster-hue-rotate")),
                u_coords_top: [
                    r[0].x,
                    r[0].y,
                    r[1].x,
                    r[1].y
                ],
                u_coords_bottom: [
                    r[3].x,
                    r[3].y,
                    r[2].x,
                    r[2].y
                ]
            };
        };
        function da(e1) {
            e1 *= Math.PI / 180;
            var _$t = Math.sin(e1), i = Math.cos(e1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * _$t - i + 1) / 3,
                (Math.sqrt(3) * _$t - i + 1) / 3
            ];
        }
        var _a = function(e1, t, i, a, r, o, s, n, l, c, h, u, d) {
            var _ = s.transform;
            return {
                u_is_size_zoom_constant: +("constant" === e1 || "source" === e1),
                u_is_size_feature_constant: +("constant" === e1 || "camera" === e1),
                u_size_t: t ? t.uSizeT : 0,
                u_size: t ? t.uSize : 0,
                u_camera_to_center_distance: _.cameraToCenterDistance,
                u_pitch: _.pitch / 360 * 2 * Math.PI,
                u_rotate_symbol: +i,
                u_aspect_ratio: _.width / _.height,
                u_fade_change: s.options.fadeDuration ? s.symbolFadeChange : 1,
                u_label_plane_matrix: n,
                u_coord_matrix: l,
                u_is_text: +h,
                u_pitch_with_map: +a,
                u_is_along_line: r,
                u_is_variable_anchor: o,
                u_texsize: u,
                u_texture: 0,
                u_translation: c,
                u_pitched_scale: d
            };
        }, pa = function(e1, i, a, r, o, s, n, l, c, h, u, d, _, p) {
            var m = n.transform;
            return t.e(_a(e1, i, a, r, o, s, n, l, c, h, u, d, p), {
                u_gamma_scale: r ? Math.cos(m.pitch * Math.PI / 180) * m.cameraToCenterDistance : 1,
                u_device_pixel_ratio: n.pixelRatio,
                u_is_halo: 1
            });
        }, ma = function(e1, i, a, r, o, s, n, l, c, h, u, d, _) {
            return t.e(pa(e1, i, a, r, o, s, n, l, c, h, !0, u, 0, _), {
                u_texsize_icon: d,
                u_texture_icon: 1
            });
        }, fa = function(e1, t) {
            return {
                u_opacity: e1,
                u_color: t
            };
        }, ga = function(e1, i, a, r, o) {
            return t.e(function(e1, i, a, r) {
                var _$o = a.imageManager.getPattern(e1.from.toString()), s = a.imageManager.getPattern(e1.to.toString()), _a_imageManager_getPixelSize = a.imageManager.getPixelSize(), n = _a_imageManager_getPixelSize.width, l = _a_imageManager_getPixelSize.height, _$c = Math.pow(2, r.tileID.overscaledZ), h = r.tileSize * Math.pow(2, a.transform.tileZoom) / _$c, u = h * (r.tileID.canonical.x + r.tileID.wrap * _$c), d = h * r.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl_a: _$o.tl,
                    u_pattern_br_a: _$o.br,
                    u_pattern_tl_b: s.tl,
                    u_pattern_br_b: s.br,
                    u_texsize: [
                        n,
                        l
                    ],
                    u_mix: i.t,
                    u_pattern_size_a: _$o.displaySize,
                    u_pattern_size_b: s.displaySize,
                    u_scale_a: i.fromScale,
                    u_scale_b: i.toScale,
                    u_tile_units_to_pixels: 1 / t.aN(r, 1, a.transform.tileZoom),
                    u_pixel_coord_upper: [
                        u >> 16,
                        d >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & u,
                        65535 & d
                    ]
                };
            }(a, o, i, r), {
                u_opacity: e1
            });
        }, va = function(e1, t) {}, xa = {
            fillExtrusion: function(e1, i) {
                return {
                    u_lightpos: new t.c2(e1, i.u_lightpos),
                    u_lightpos_globe: new t.c2(e1, i.u_lightpos_globe),
                    u_lightintensity: new t.bq(e1, i.u_lightintensity),
                    u_lightcolor: new t.c2(e1, i.u_lightcolor),
                    u_vertical_gradient: new t.bq(e1, i.u_vertical_gradient),
                    u_opacity: new t.bq(e1, i.u_opacity),
                    u_fill_translate: new t.c3(e1, i.u_fill_translate)
                };
            },
            fillExtrusionPattern: function(e1, i) {
                return {
                    u_lightpos: new t.c2(e1, i.u_lightpos),
                    u_lightpos_globe: new t.c2(e1, i.u_lightpos_globe),
                    u_lightintensity: new t.bq(e1, i.u_lightintensity),
                    u_lightcolor: new t.c2(e1, i.u_lightcolor),
                    u_vertical_gradient: new t.bq(e1, i.u_vertical_gradient),
                    u_height_factor: new t.bq(e1, i.u_height_factor),
                    u_opacity: new t.bq(e1, i.u_opacity),
                    u_fill_translate: new t.c3(e1, i.u_fill_translate),
                    u_image: new t.b_(e1, i.u_image),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_pixel_coord_upper: new t.c3(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c3(e1, i.u_pixel_coord_lower),
                    u_scale: new t.c2(e1, i.u_scale),
                    u_fade: new t.bq(e1, i.u_fade)
                };
            },
            fill: function(e1, i) {
                return {
                    u_fill_translate: new t.c3(e1, i.u_fill_translate)
                };
            },
            fillPattern: function(e1, i) {
                return {
                    u_image: new t.b_(e1, i.u_image),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_pixel_coord_upper: new t.c3(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c3(e1, i.u_pixel_coord_lower),
                    u_scale: new t.c2(e1, i.u_scale),
                    u_fade: new t.bq(e1, i.u_fade),
                    u_fill_translate: new t.c3(e1, i.u_fill_translate)
                };
            },
            fillOutline: function(e1, i) {
                return {
                    u_world: new t.c3(e1, i.u_world),
                    u_fill_translate: new t.c3(e1, i.u_fill_translate)
                };
            },
            fillOutlinePattern: function(e1, i) {
                return {
                    u_world: new t.c3(e1, i.u_world),
                    u_image: new t.b_(e1, i.u_image),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_pixel_coord_upper: new t.c3(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c3(e1, i.u_pixel_coord_lower),
                    u_scale: new t.c2(e1, i.u_scale),
                    u_fade: new t.bq(e1, i.u_fade),
                    u_fill_translate: new t.c3(e1, i.u_fill_translate)
                };
            },
            circle: function(e1, i) {
                return {
                    u_camera_to_center_distance: new t.bq(e1, i.u_camera_to_center_distance),
                    u_scale_with_map: new t.b_(e1, i.u_scale_with_map),
                    u_pitch_with_map: new t.b_(e1, i.u_pitch_with_map),
                    u_extrude_scale: new t.c3(e1, i.u_extrude_scale),
                    u_device_pixel_ratio: new t.bq(e1, i.u_device_pixel_ratio),
                    u_globe_extrude_scale: new t.bq(e1, i.u_globe_extrude_scale),
                    u_translate: new t.c3(e1, i.u_translate)
                };
            },
            collisionBox: function(e1, i) {
                return {
                    u_pixel_extrude_scale: new t.c3(e1, i.u_pixel_extrude_scale)
                };
            },
            collisionCircle: function(e1, i) {
                return {
                    u_viewport_size: new t.c3(e1, i.u_viewport_size)
                };
            },
            debug: function(e1, i) {
                return {
                    u_color: new t.b$(e1, i.u_color),
                    u_overlay: new t.b_(e1, i.u_overlay),
                    u_overlay_scale: new t.bq(e1, i.u_overlay_scale)
                };
            },
            depth: va,
            clippingMask: va,
            heatmap: function(e1, i) {
                return {
                    u_extrude_scale: new t.bq(e1, i.u_extrude_scale),
                    u_intensity: new t.bq(e1, i.u_intensity),
                    u_globe_extrude_scale: new t.bq(e1, i.u_globe_extrude_scale)
                };
            },
            heatmapTexture: function(e1, i) {
                return {
                    u_matrix: new t.c0(e1, i.u_matrix),
                    u_world: new t.c3(e1, i.u_world),
                    u_image: new t.b_(e1, i.u_image),
                    u_color_ramp: new t.b_(e1, i.u_color_ramp),
                    u_opacity: new t.bq(e1, i.u_opacity)
                };
            },
            hillshade: function(e1, i) {
                return {
                    u_image: new t.b_(e1, i.u_image),
                    u_latrange: new t.c3(e1, i.u_latrange),
                    u_exaggeration: new t.bq(e1, i.u_exaggeration),
                    u_altitudes: new t.c9(e1, i.u_altitudes),
                    u_azimuths: new t.c9(e1, i.u_azimuths),
                    u_accent: new t.b$(e1, i.u_accent),
                    u_method: new t.b_(e1, i.u_method),
                    u_shadows: new t.c8(e1, i.u_shadows),
                    u_highlights: new t.c8(e1, i.u_highlights)
                };
            },
            hillshadePrepare: function(e1, i) {
                return {
                    u_matrix: new t.c0(e1, i.u_matrix),
                    u_image: new t.b_(e1, i.u_image),
                    u_dimension: new t.c3(e1, i.u_dimension),
                    u_zoom: new t.bq(e1, i.u_zoom),
                    u_unpack: new t.c1(e1, i.u_unpack)
                };
            },
            colorRelief: function(e1, i) {
                return {
                    u_image: new t.b_(e1, i.u_image),
                    u_unpack: new t.c1(e1, i.u_unpack),
                    u_dimension: new t.c3(e1, i.u_dimension),
                    u_elevation_stops: new t.b_(e1, i.u_elevation_stops),
                    u_color_stops: new t.b_(e1, i.u_color_stops),
                    u_color_ramp_size: new t.b_(e1, i.u_color_ramp_size),
                    u_opacity: new t.bq(e1, i.u_opacity)
                };
            },
            line: function(e1, i) {
                return {
                    u_translation: new t.c3(e1, i.u_translation),
                    u_ratio: new t.bq(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bq(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c3(e1, i.u_units_to_pixels)
                };
            },
            lineGradient: function(e1, i) {
                return {
                    u_translation: new t.c3(e1, i.u_translation),
                    u_ratio: new t.bq(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bq(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c3(e1, i.u_units_to_pixels),
                    u_image: new t.b_(e1, i.u_image),
                    u_image_height: new t.bq(e1, i.u_image_height)
                };
            },
            linePattern: function(e1, i) {
                return {
                    u_translation: new t.c3(e1, i.u_translation),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_ratio: new t.bq(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bq(e1, i.u_device_pixel_ratio),
                    u_image: new t.b_(e1, i.u_image),
                    u_units_to_pixels: new t.c3(e1, i.u_units_to_pixels),
                    u_scale: new t.c2(e1, i.u_scale),
                    u_fade: new t.bq(e1, i.u_fade)
                };
            },
            lineSDF: function(e1, i) {
                return {
                    u_translation: new t.c3(e1, i.u_translation),
                    u_ratio: new t.bq(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bq(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c3(e1, i.u_units_to_pixels),
                    u_image: new t.b_(e1, i.u_image),
                    u_mix: new t.bq(e1, i.u_mix),
                    u_tileratio: new t.bq(e1, i.u_tileratio),
                    u_crossfade_from: new t.bq(e1, i.u_crossfade_from),
                    u_crossfade_to: new t.bq(e1, i.u_crossfade_to),
                    u_lineatlas_width: new t.bq(e1, i.u_lineatlas_width),
                    u_lineatlas_height: new t.bq(e1, i.u_lineatlas_height)
                };
            },
            lineGradientSDF: function(e1, i) {
                return {
                    u_translation: new t.c3(e1, i.u_translation),
                    u_ratio: new t.bq(e1, i.u_ratio),
                    u_device_pixel_ratio: new t.bq(e1, i.u_device_pixel_ratio),
                    u_units_to_pixels: new t.c3(e1, i.u_units_to_pixels),
                    u_image: new t.b_(e1, i.u_image),
                    u_image_height: new t.bq(e1, i.u_image_height),
                    u_tileratio: new t.bq(e1, i.u_tileratio),
                    u_crossfade_from: new t.bq(e1, i.u_crossfade_from),
                    u_crossfade_to: new t.bq(e1, i.u_crossfade_to),
                    u_image_dash: new t.b_(e1, i.u_image_dash),
                    u_mix: new t.bq(e1, i.u_mix),
                    u_lineatlas_width: new t.bq(e1, i.u_lineatlas_width),
                    u_lineatlas_height: new t.bq(e1, i.u_lineatlas_height)
                };
            },
            raster: function(e1, i) {
                return {
                    u_tl_parent: new t.c3(e1, i.u_tl_parent),
                    u_scale_parent: new t.bq(e1, i.u_scale_parent),
                    u_buffer_scale: new t.bq(e1, i.u_buffer_scale),
                    u_fade_t: new t.bq(e1, i.u_fade_t),
                    u_opacity: new t.bq(e1, i.u_opacity),
                    u_image0: new t.b_(e1, i.u_image0),
                    u_image1: new t.b_(e1, i.u_image1),
                    u_brightness_low: new t.bq(e1, i.u_brightness_low),
                    u_brightness_high: new t.bq(e1, i.u_brightness_high),
                    u_saturation_factor: new t.bq(e1, i.u_saturation_factor),
                    u_contrast_factor: new t.bq(e1, i.u_contrast_factor),
                    u_spin_weights: new t.c2(e1, i.u_spin_weights),
                    u_coords_top: new t.c1(e1, i.u_coords_top),
                    u_coords_bottom: new t.c1(e1, i.u_coords_bottom)
                };
            },
            symbolIcon: function(e1, i) {
                return {
                    u_is_size_zoom_constant: new t.b_(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.b_(e1, i.u_is_size_feature_constant),
                    u_size_t: new t.bq(e1, i.u_size_t),
                    u_size: new t.bq(e1, i.u_size),
                    u_camera_to_center_distance: new t.bq(e1, i.u_camera_to_center_distance),
                    u_pitch: new t.bq(e1, i.u_pitch),
                    u_rotate_symbol: new t.b_(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t.bq(e1, i.u_aspect_ratio),
                    u_fade_change: new t.bq(e1, i.u_fade_change),
                    u_label_plane_matrix: new t.c0(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t.c0(e1, i.u_coord_matrix),
                    u_is_text: new t.b_(e1, i.u_is_text),
                    u_pitch_with_map: new t.b_(e1, i.u_pitch_with_map),
                    u_is_along_line: new t.b_(e1, i.u_is_along_line),
                    u_is_variable_anchor: new t.b_(e1, i.u_is_variable_anchor),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_texture: new t.b_(e1, i.u_texture),
                    u_translation: new t.c3(e1, i.u_translation),
                    u_pitched_scale: new t.bq(e1, i.u_pitched_scale)
                };
            },
            symbolSDF: function(e1, i) {
                return {
                    u_is_size_zoom_constant: new t.b_(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.b_(e1, i.u_is_size_feature_constant),
                    u_size_t: new t.bq(e1, i.u_size_t),
                    u_size: new t.bq(e1, i.u_size),
                    u_camera_to_center_distance: new t.bq(e1, i.u_camera_to_center_distance),
                    u_pitch: new t.bq(e1, i.u_pitch),
                    u_rotate_symbol: new t.b_(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t.bq(e1, i.u_aspect_ratio),
                    u_fade_change: new t.bq(e1, i.u_fade_change),
                    u_label_plane_matrix: new t.c0(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t.c0(e1, i.u_coord_matrix),
                    u_is_text: new t.b_(e1, i.u_is_text),
                    u_pitch_with_map: new t.b_(e1, i.u_pitch_with_map),
                    u_is_along_line: new t.b_(e1, i.u_is_along_line),
                    u_is_variable_anchor: new t.b_(e1, i.u_is_variable_anchor),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_texture: new t.b_(e1, i.u_texture),
                    u_gamma_scale: new t.bq(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.bq(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t.b_(e1, i.u_is_halo),
                    u_translation: new t.c3(e1, i.u_translation),
                    u_pitched_scale: new t.bq(e1, i.u_pitched_scale)
                };
            },
            symbolTextAndIcon: function(e1, i) {
                return {
                    u_is_size_zoom_constant: new t.b_(e1, i.u_is_size_zoom_constant),
                    u_is_size_feature_constant: new t.b_(e1, i.u_is_size_feature_constant),
                    u_size_t: new t.bq(e1, i.u_size_t),
                    u_size: new t.bq(e1, i.u_size),
                    u_camera_to_center_distance: new t.bq(e1, i.u_camera_to_center_distance),
                    u_pitch: new t.bq(e1, i.u_pitch),
                    u_rotate_symbol: new t.b_(e1, i.u_rotate_symbol),
                    u_aspect_ratio: new t.bq(e1, i.u_aspect_ratio),
                    u_fade_change: new t.bq(e1, i.u_fade_change),
                    u_label_plane_matrix: new t.c0(e1, i.u_label_plane_matrix),
                    u_coord_matrix: new t.c0(e1, i.u_coord_matrix),
                    u_is_text: new t.b_(e1, i.u_is_text),
                    u_pitch_with_map: new t.b_(e1, i.u_pitch_with_map),
                    u_is_along_line: new t.b_(e1, i.u_is_along_line),
                    u_is_variable_anchor: new t.b_(e1, i.u_is_variable_anchor),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_texsize_icon: new t.c3(e1, i.u_texsize_icon),
                    u_texture: new t.b_(e1, i.u_texture),
                    u_texture_icon: new t.b_(e1, i.u_texture_icon),
                    u_gamma_scale: new t.bq(e1, i.u_gamma_scale),
                    u_device_pixel_ratio: new t.bq(e1, i.u_device_pixel_ratio),
                    u_is_halo: new t.b_(e1, i.u_is_halo),
                    u_translation: new t.c3(e1, i.u_translation),
                    u_pitched_scale: new t.bq(e1, i.u_pitched_scale)
                };
            },
            background: function(e1, i) {
                return {
                    u_opacity: new t.bq(e1, i.u_opacity),
                    u_color: new t.b$(e1, i.u_color)
                };
            },
            backgroundPattern: function(e1, i) {
                return {
                    u_opacity: new t.bq(e1, i.u_opacity),
                    u_image: new t.b_(e1, i.u_image),
                    u_pattern_tl_a: new t.c3(e1, i.u_pattern_tl_a),
                    u_pattern_br_a: new t.c3(e1, i.u_pattern_br_a),
                    u_pattern_tl_b: new t.c3(e1, i.u_pattern_tl_b),
                    u_pattern_br_b: new t.c3(e1, i.u_pattern_br_b),
                    u_texsize: new t.c3(e1, i.u_texsize),
                    u_mix: new t.bq(e1, i.u_mix),
                    u_pattern_size_a: new t.c3(e1, i.u_pattern_size_a),
                    u_pattern_size_b: new t.c3(e1, i.u_pattern_size_b),
                    u_scale_a: new t.bq(e1, i.u_scale_a),
                    u_scale_b: new t.bq(e1, i.u_scale_b),
                    u_pixel_coord_upper: new t.c3(e1, i.u_pixel_coord_upper),
                    u_pixel_coord_lower: new t.c3(e1, i.u_pixel_coord_lower),
                    u_tile_units_to_pixels: new t.bq(e1, i.u_tile_units_to_pixels)
                };
            },
            terrain: function(e1, i) {
                return {
                    u_texture: new t.b_(e1, i.u_texture),
                    u_ele_delta: new t.bq(e1, i.u_ele_delta),
                    u_fog_matrix: new t.c0(e1, i.u_fog_matrix),
                    u_fog_color: new t.b$(e1, i.u_fog_color),
                    u_fog_ground_blend: new t.bq(e1, i.u_fog_ground_blend),
                    u_fog_ground_blend_opacity: new t.bq(e1, i.u_fog_ground_blend_opacity),
                    u_horizon_color: new t.b$(e1, i.u_horizon_color),
                    u_horizon_fog_blend: new t.bq(e1, i.u_horizon_fog_blend),
                    u_is_globe_mode: new t.bq(e1, i.u_is_globe_mode)
                };
            },
            terrainDepth: function(e1, i) {
                return {
                    u_ele_delta: new t.bq(e1, i.u_ele_delta)
                };
            },
            terrainCoords: function(e1, i) {
                return {
                    u_texture: new t.b_(e1, i.u_texture),
                    u_terrain_coords_id: new t.bq(e1, i.u_terrain_coords_id),
                    u_ele_delta: new t.bq(e1, i.u_ele_delta)
                };
            },
            projectionErrorMeasurement: function(e1, i) {
                return {
                    u_input: new t.bq(e1, i.u_input),
                    u_output_expected: new t.bq(e1, i.u_output_expected)
                };
            },
            atmosphere: function(e1, i) {
                return {
                    u_sun_pos: new t.c2(e1, i.u_sun_pos),
                    u_atmosphere_blend: new t.bq(e1, i.u_atmosphere_blend),
                    u_globe_position: new t.c2(e1, i.u_globe_position),
                    u_globe_radius: new t.bq(e1, i.u_globe_radius),
                    u_inv_proj_matrix: new t.c0(e1, i.u_inv_proj_matrix)
                };
            },
            sky: function(e1, i) {
                return {
                    u_sky_color: new t.b$(e1, i.u_sky_color),
                    u_horizon_color: new t.b$(e1, i.u_horizon_color),
                    u_horizon: new t.c3(e1, i.u_horizon),
                    u_horizon_normal: new t.c3(e1, i.u_horizon_normal),
                    u_sky_horizon_blend: new t.bq(e1, i.u_sky_horizon_blend),
                    u_sky_blend: new t.bq(e1, i.u_sky_blend)
                };
            }
        };
        var ba = /*#__PURE__*/ function() {
            function ba(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ba);
                this.context = e1;
                var a = e1.gl;
                this.buffer = a.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), a.bufferData(a.ELEMENT_ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? a.DYNAMIC_DRAW : a.STATIC_DRAW), this.dynamicDraw || delete t.arrayBuffer;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ba, [
                {
                    key: "bind",
                    value: function bind() {
                        this.context.bindElementBuffer.set(this.buffer);
                    }
                },
                {
                    key: "updateData",
                    value: function updateData(e1) {
                        var _$t = this.context.gl;
                        if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                        this.context.unbindVAO(), this.bind(), _$t.bufferSubData(_$t.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
                    }
                }
            ]);
            return ba;
        }();
        var ya = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        var wa = /*#__PURE__*/ function() {
            function wa(e1, t, i, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, wa);
                this.length = t.length, this.attributes = i, this.itemSize = t.bytesPerElement, this.dynamicDraw = a, this.context = e1;
                var r = e1.gl;
                this.buffer = r.createBuffer(), e1.bindVertexBuffer.set(this.buffer), r.bufferData(r.ARRAY_BUFFER, t.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || delete t.arrayBuffer;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(wa, [
                {
                    key: "bind",
                    value: function bind() {
                        this.context.bindVertexBuffer.set(this.buffer);
                    }
                },
                {
                    key: "updateData",
                    value: function updateData(e1) {
                        if (e1.length !== this.length) throw new Error("Length of new data is ".concat(e1.length, ", which doesn't match current length of ").concat(this.length));
                        var _$t = this.context.gl;
                        this.bind(), _$t.bufferSubData(_$t.ARRAY_BUFFER, 0, e1.arrayBuffer);
                    }
                },
                {
                    key: "enableAttributes",
                    value: function enableAttributes(e1, t) {
                        for(var i = 0; i < this.attributes.length; i++){
                            var a = t.attributes[this.attributes[i].name];
                            void 0 !== a && e1.enableVertexAttribArray(a);
                        }
                    }
                },
                {
                    key: "setVertexAttribPointers",
                    value: function setVertexAttribPointers(e1, t, i) {
                        for(var a = 0; a < this.attributes.length; a++){
                            var r = this.attributes[a], o = t.attributes[r.name];
                            void 0 !== o && e1.vertexAttribPointer(o, r.components, e1[ya[r.type]], !1, this.itemSize, r.offset + this.itemSize * (i || 0));
                        }
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
                    }
                }
            ]);
            return wa;
        }();
        var Ta = /*#__PURE__*/ function() {
            function Ta(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ta);
                this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ta, [
                {
                    key: "get",
                    value: function get() {
                        return this.current;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {}
                },
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return this.default;
                    }
                },
                {
                    key: "setDefault",
                    value: function setDefault() {
                        this.set(this.default);
                    }
                }
            ]);
            return Ta;
        }();
        var Pa = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Pa, Ta);
            function Pa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Pa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Pa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Pa, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return t.bp.transparent;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        var _$t = this.current;
                        (e1.r !== _$t.r || e1.g !== _$t.g || e1.b !== _$t.b || e1.a !== _$t.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Pa;
        }(Ta);
        var Ca = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ca, Ta);
            function Ca() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ca);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ca, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ca, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return 1;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Ca;
        }(Ta);
        var Ia = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ia, Ta);
            function Ia() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ia);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ia, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ia, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return 0;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Ia;
        }(Ta);
        var Ma = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ma, Ta);
            function Ma() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ma);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ma, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ma, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return [
                            !0,
                            !0,
                            !0,
                            !0
                        ];
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        var _$t = this.current;
                        (e1[0] !== _$t[0] || e1[1] !== _$t[1] || e1[2] !== _$t[2] || e1[3] !== _$t[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Ma;
        }(Ta);
        var Ea = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ea, Ta);
            function Ea() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ea);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ea, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ea, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return !0;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Ea;
        }(Ta);
        var Sa = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Sa, Ta);
            function Sa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Sa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Sa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Sa, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return 255;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Sa;
        }(Ta);
        var Ra = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ra, Ta);
            function Ra() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ra);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ra, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ra, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return {
                            func: this.gl.ALWAYS,
                            ref: 0,
                            mask: 255
                        };
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        var _$t = this.current;
                        (e1.func !== _$t.func || e1.ref !== _$t.ref || e1.mask !== _$t.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Ra;
        }(Ta);
        var za = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(za, Ta);
            function za() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, za);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, za, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(za, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        var _$e = this.gl;
                        return [
                            _$e.KEEP,
                            _$e.KEEP,
                            _$e.KEEP
                        ];
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        var _$t = this.current;
                        (e1[0] !== _$t[0] || e1[1] !== _$t[1] || e1[2] !== _$t[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return za;
        }(Ta);
        var Da = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Da, Ta);
            function Da() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Da);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Da, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Da, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return !1;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        e1 ? _$t.enable(_$t.STENCIL_TEST) : _$t.disable(_$t.STENCIL_TEST), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return Da;
        }(Ta);
        var Aa = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Aa, Ta);
            function Aa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Aa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Aa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Aa, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return [
                            0,
                            1
                        ];
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        var _$t = this.current;
                        (e1[0] !== _$t[0] || e1[1] !== _$t[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Aa;
        }(Ta);
        var La = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(La, Ta);
            function La() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, La);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, La, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(La, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return !1;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        e1 ? _$t.enable(_$t.DEPTH_TEST) : _$t.disable(_$t.DEPTH_TEST), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return La;
        }(Ta);
        var ka = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ka, Ta);
            function ka() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ka);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ka, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ka, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return this.gl.LESS;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return ka;
        }(Ta);
        var Fa = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Fa, Ta);
            function Fa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Fa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Fa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Fa, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return !1;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        e1 ? _$t.enable(_$t.BLEND) : _$t.disable(_$t.BLEND), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return Fa;
        }(Ta);
        var Ba = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ba, Ta);
            function Ba() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ba);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ba, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ba, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        var _$e = this.gl;
                        return [
                            _$e.ONE,
                            _$e.ZERO
                        ];
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        var _$t = this.current;
                        (e1[0] !== _$t[0] || e1[1] !== _$t[1] || this.dirty) && (this.gl.blendFunc(e1[0], e1[1]), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Ba;
        }(Ta);
        var Oa = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Oa, Ta);
            function Oa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Oa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Oa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Oa, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return t.bp.transparent;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        var _$t = this.current;
                        (e1.r !== _$t.r || e1.g !== _$t.g || e1.b !== _$t.b || e1.a !== _$t.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Oa;
        }(Ta);
        var ja = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ja, Ta);
            function ja() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ja);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ja, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ja, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return this.gl.FUNC_ADD;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        (e1 !== this.current || this.dirty) && (this.gl.blendEquation(e1), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return ja;
        }(Ta);
        var Na = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Na, Ta);
            function Na() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Na);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Na, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Na, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return !1;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        e1 ? _$t.enable(_$t.CULL_FACE) : _$t.disable(_$t.CULL_FACE), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return Na;
        }(Ta);
        var Za = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Za, Ta);
            function Za() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Za);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Za, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Za, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return this.gl.BACK;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Za;
        }(Ta);
        var Ga = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ga, Ta);
            function Ga() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ga);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ga, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ga, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return this.gl.CCW;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Ga;
        }(Ta);
        var Ua = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ua, Ta);
            function Ua() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ua);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ua, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ua, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return null;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Ua;
        }(Ta);
        var Va = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Va, Ta);
            function Va() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Va);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Va, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Va, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return this.gl.TEXTURE0;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return Va;
        }(Ta);
        var qa = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(qa, Ta);
            function qa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, qa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, qa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(qa, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        var _$e = this.gl;
                        return [
                            0,
                            0,
                            _$e.drawingBufferWidth,
                            _$e.drawingBufferHeight
                        ];
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        var _$t = this.current;
                        (e1[0] !== _$t[0] || e1[1] !== _$t[1] || e1[2] !== _$t[2] || e1[3] !== _$t[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
                    }
                }
            ]);
            return qa;
        }(Ta);
        var Wa = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Wa, Ta);
            function Wa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Wa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Wa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Wa, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return null;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        _$t.bindFramebuffer(_$t.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return Wa;
        }(Ta);
        var $a = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)($a, Ta);
            function $a() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, $a);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, $a, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)($a, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return null;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        _$t.bindRenderbuffer(_$t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return $a;
        }(Ta);
        var Ha = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ha, Ta);
            function Ha() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ha);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ha, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ha, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return null;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        _$t.bindTexture(_$t.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return Ha;
        }(Ta);
        var Xa = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Xa, Ta);
            function Xa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Xa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Xa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Xa, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return null;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        _$t.bindBuffer(_$t.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return Xa;
        }(Ta);
        var Ka = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ka, Ta);
            function Ka() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ka);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ka, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ka, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return null;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        var _$t = this.gl;
                        _$t.bindBuffer(_$t.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return Ka;
        }(Ta);
        var Ya = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ya, Ta);
            function Ya() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ya);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ya, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ya, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return null;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        var _$t;
                        if (e1 === this.current && !this.dirty) return;
                        var i = this.gl;
                        oi(i) ? i.bindVertexArray(e1) : null === (_$t = i.getExtension("OES_vertex_array_object")) || void 0 === _$t || _$t.bindVertexArrayOES(e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return Ya;
        }(Ta);
        var Qa = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Qa, Ta);
            function Qa() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Qa);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Qa, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Qa, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return 4;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        _$t.pixelStorei(_$t.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return Qa;
        }(Ta);
        var Ja = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Ja, Ta);
            function Ja() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ja);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Ja, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ja, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return !1;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        _$t.pixelStorei(_$t.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return Ja;
        }(Ta);
        var er = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(er, Ta);
            function er() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, er);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, er, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(er, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return !1;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        var _$t = this.gl;
                        _$t.pixelStorei(_$t.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return er;
        }(Ta);
        var tr = /*#__PURE__*/ function(Ta) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(tr, Ta);
            function tr(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, tr);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, tr, [
                    e1
                ]), _this.context = e1, _this.parent = t;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(tr, [
                {
                    key: "getDefault",
                    value: function getDefault() {
                        return null;
                    }
                }
            ]);
            return tr;
        }(Ta);
        var ir = /*#__PURE__*/ function(tr) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ir, tr);
            function ir() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ir);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ir, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ir, [
                {
                    key: "setDirty",
                    value: function setDirty() {
                        this.dirty = !0;
                    }
                },
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        this.context.bindFramebuffer.set(this.parent);
                        var _$t = this.gl;
                        _$t.framebufferTexture2D(_$t.FRAMEBUFFER, _$t.COLOR_ATTACHMENT0, _$t.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return ir;
        }(tr);
        var ar = /*#__PURE__*/ function(tr) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ar, tr);
            function ar() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ar);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, ar, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ar, [
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        this.context.bindFramebuffer.set(this.parent);
                        var _$t = this.gl;
                        _$t.framebufferRenderbuffer(_$t.FRAMEBUFFER, _$t.DEPTH_ATTACHMENT, _$t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return ar;
        }(tr);
        var rr = /*#__PURE__*/ function(tr) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(rr, tr);
            function rr() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, rr);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, rr, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(rr, [
                {
                    key: "set",
                    value: function set(e1) {
                        if (e1 === this.current && !this.dirty) return;
                        this.context.bindFramebuffer.set(this.parent);
                        var _$t = this.gl;
                        _$t.framebufferRenderbuffer(_$t.FRAMEBUFFER, _$t.DEPTH_STENCIL_ATTACHMENT, _$t.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
                    }
                }
            ]);
            return rr;
        }(tr);
        var or = "Framebuffer is not complete";
        var sr = /*#__PURE__*/ function() {
            function sr(e1, t, i, a, r) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, sr);
                this.context = e1, this.width = t, this.height = i;
                var o = e1.gl, s = this.framebuffer = o.createFramebuffer();
                if (this.colorAttachment = new ir(e1, s), a) this.depthAttachment = r ? new rr(e1, s) : new ar(e1, s);
                else if (r) throw new Error("Stencil cannot be set without depth");
                if (o.checkFramebufferStatus(o.FRAMEBUFFER) !== o.FRAMEBUFFER_COMPLETE) throw new Error(or);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(sr, [
                {
                    key: "destroy",
                    value: function destroy() {
                        var _$e = this.context.gl, _$t = this.colorAttachment.get();
                        if (_$t && _$e.deleteTexture(_$t), this.depthAttachment) {
                            var _$t1 = this.depthAttachment.get();
                            _$t1 && _$e.deleteRenderbuffer(_$t1);
                        }
                        _$e.deleteFramebuffer(this.framebuffer);
                    }
                }
            ]);
            return sr;
        }();
        var nr = /*#__PURE__*/ function() {
            function nr(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, nr);
                var _$t, i;
                if (this.gl = e1, this.clearColor = new Pa(this), this.clearDepth = new Ca(this), this.clearStencil = new Ia(this), this.colorMask = new Ma(this), this.depthMask = new Ea(this), this.stencilMask = new Sa(this), this.stencilFunc = new Ra(this), this.stencilOp = new za(this), this.stencilTest = new Da(this), this.depthRange = new Aa(this), this.depthTest = new La(this), this.depthFunc = new ka(this), this.blend = new Fa(this), this.blendFunc = new Ba(this), this.blendColor = new Oa(this), this.blendEquation = new ja(this), this.cullFace = new Na(this), this.cullFaceSide = new Za(this), this.frontFace = new Ga(this), this.program = new Ua(this), this.activeTexture = new Va(this), this.viewport = new qa(this), this.bindFramebuffer = new Wa(this), this.bindRenderbuffer = new $a(this), this.bindTexture = new Ha(this), this.bindVertexBuffer = new Xa(this), this.bindElementBuffer = new Ka(this), this.bindVertexArray = new Ya(this), this.pixelStoreUnpack = new Qa(this), this.pixelStoreUnpackPremultiplyAlpha = new Ja(this), this.pixelStoreUnpackFlipY = new er(this), this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE), oi(e1)) {
                    this.HALF_FLOAT = e1.HALF_FLOAT;
                    var a = e1.getExtension("EXT_color_buffer_half_float");
                    this.RGBA16F = null !== (_$t = e1.RGBA16F) && void 0 !== _$t ? _$t : null == a ? void 0 : a.RGBA16F_EXT, this.RGB16F = null !== (i = e1.RGB16F) && void 0 !== i ? i : null == a ? void 0 : a.RGB16F_EXT, e1.getExtension("EXT_color_buffer_float");
                } else {
                    e1.getExtension("EXT_color_buffer_half_float"), e1.getExtension("OES_texture_half_float_linear");
                    var _$t1 = e1.getExtension("OES_texture_half_float");
                    this.HALF_FLOAT = null == _$t1 ? void 0 : _$t1.HALF_FLOAT_OES;
                }
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(nr, [
                {
                    key: "setDefault",
                    value: function setDefault() {
                        this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
                    }
                },
                {
                    key: "setDirty",
                    value: function setDirty() {
                        this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
                    }
                },
                {
                    key: "createIndexBuffer",
                    value: function createIndexBuffer(e1, t) {
                        return new ba(this, e1, t);
                    }
                },
                {
                    key: "createVertexBuffer",
                    value: function createVertexBuffer(e1, t, i) {
                        return new wa(this, e1, t, i);
                    }
                },
                {
                    key: "createRenderbuffer",
                    value: function createRenderbuffer(e1, t, i) {
                        var a = this.gl, r = a.createRenderbuffer();
                        return this.bindRenderbuffer.set(r), a.renderbufferStorage(a.RENDERBUFFER, e1, t, i), this.bindRenderbuffer.set(null), r;
                    }
                },
                {
                    key: "createFramebuffer",
                    value: function createFramebuffer(e1, t, i, a) {
                        return new sr(this, e1, t, i, a);
                    }
                },
                {
                    key: "clear",
                    value: function clear(param) {
                        var _$e = param.color, _$t = param.depth, i = param.stencil;
                        var a = this.gl;
                        var r = 0;
                        _$e && (r |= a.COLOR_BUFFER_BIT, this.clearColor.set(_$e), this.colorMask.set([
                            !0,
                            !0,
                            !0,
                            !0
                        ])), void 0 !== _$t && (r |= a.DEPTH_BUFFER_BIT, this.depthRange.set([
                            0,
                            1
                        ]), this.clearDepth.set(_$t), this.depthMask.set(!0)), void 0 !== i && (r |= a.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), a.clear(r);
                    }
                },
                {
                    key: "setCullFace",
                    value: function setCullFace(e1) {
                        !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
                    }
                },
                {
                    key: "setDepthMode",
                    value: function setDepthMode(e1) {
                        e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
                    }
                },
                {
                    key: "setStencilMode",
                    value: function setStencilMode(e1) {
                        e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
                            e1.fail,
                            e1.depthFail,
                            e1.pass
                        ]), this.stencilFunc.set({
                            func: e1.test.func,
                            ref: e1.ref,
                            mask: e1.test.mask
                        })) : this.stencilTest.set(!1);
                    }
                },
                {
                    key: "setColorMode",
                    value: function setColorMode(e1) {
                        t.bR(e1.blendFunction, Qt.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(e1.blendFunction), this.blendColor.set(e1.blendColor)), this.colorMask.set(e1.mask);
                    }
                },
                {
                    key: "createVertexArray",
                    value: function createVertexArray() {
                        var _$e;
                        return oi(this.gl) ? this.gl.createVertexArray() : null === (_$e = this.gl.getExtension("OES_vertex_array_object")) || void 0 === _$e ? void 0 : _$e.createVertexArrayOES();
                    }
                },
                {
                    key: "deleteVertexArray",
                    value: function deleteVertexArray(e1) {
                        var _$t;
                        return oi(this.gl) ? this.gl.deleteVertexArray(e1) : null === (_$t = this.gl.getExtension("OES_vertex_array_object")) || void 0 === _$t ? void 0 : _$t.deleteVertexArrayOES(e1);
                    }
                },
                {
                    key: "unbindVAO",
                    value: function unbindVAO() {
                        this.bindVertexArray.set(null);
                    }
                }
            ]);
            return nr;
        }();
        var lr;
        function cr(e1, i, a, r, o) {
            var s = e1.context, n = e1.transform, l = s.gl, _$c = e1.useProgram("collisionBox"), h = [];
            var u = 0, d = 0;
            for(var _$t = 0; _$t < r.length; _$t++){
                var _ = r[_$t], p = i.getTile(_).getBucket(a);
                if (!p) continue;
                var m = o ? p.textCollisionBox : p.iconCollisionBox, f = p.collisionCircleArray;
                f.length > 0 && (h.push({
                    circleArray: f,
                    circleOffset: d,
                    coord: _
                }), u += f.length / 4, d = u), m && _$c.draw(s, l.LINES, ti.disabled, ai.disabled, e1.colorModeForRenderPass(), ei.disabled, Xi(e1.transform), e1.style.map.terrain && e1.style.map.terrain.getTerrainData(_), n.getProjectionData({
                    overscaledTileID: _,
                    applyGlobeMatrix: !0,
                    applyTerrainMatrix: !0
                }), a.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, null, e1.transform.zoom, null, null, m.collisionVertexBuffer);
            }
            if (!o || !h.length) return;
            var _1 = e1.useProgram("collisionCircle"), p1 = new t.ca;
            p1.resize(4 * u), p1._trim();
            var m1 = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = h[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$e = _step.value;
                    for(var _$t1 = 0; _$t1 < _$e.circleArray.length / 4; _$t1++){
                        var _$i = 4 * _$t1, _$a = _$e.circleArray[_$i + 0], _$r = _$e.circleArray[_$i + 1], _$o = _$e.circleArray[_$i + 2], s1 = _$e.circleArray[_$i + 3];
                        p1.emplace(m1++, _$a, _$r, _$o, s1, 0), p1.emplace(m1++, _$a, _$r, _$o, s1, 1), p1.emplace(m1++, _$a, _$r, _$o, s1, 2), p1.emplace(m1++, _$a, _$r, _$o, s1, 3);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            (!lr || lr.length < 2 * u) && (lr = function(e1) {
                var _$i = 2 * e1, _$a = new t.cc;
                _$a.resize(_$i), _$a._trim();
                for(var _$e = 0; _$e < _$i; _$e++){
                    var _$t = 6 * _$e;
                    _$a.uint16[_$t + 0] = 4 * _$e + 0, _$a.uint16[_$t + 1] = 4 * _$e + 1, _$a.uint16[_$t + 2] = 4 * _$e + 2, _$a.uint16[_$t + 3] = 4 * _$e + 2, _$a.uint16[_$t + 4] = 4 * _$e + 3, _$a.uint16[_$t + 5] = 4 * _$e + 0;
                }
                return _$a;
            }(u));
            var f1 = s.createIndexBuffer(lr, !0), g = s.createVertexBuffer(p1, t.cb.members, !0);
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = h[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _$i1 = _step1.value;
                    var _$r1 = Ki(e1.transform);
                    _1.draw(s, l.TRIANGLES, ti.disabled, ai.disabled, e1.colorModeForRenderPass(), ei.disabled, _$r1, e1.style.map.terrain && e1.style.map.terrain.getTerrainData(_$i1.coord), null, a.id, g, f1, t.aX.simpleSegment(0, 2 * _$i1.circleOffset, _$i1.circleArray.length, _$i1.circleArray.length / 2), null, e1.transform.zoom, null, null, null);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            g.destroy(), f1.destroy();
        }
        var hr = t.ar(new Float32Array(16));
        function ur(e1, i, a, r, o, s) {
            var _t_aS = t.aS(e1), n = _t_aS.horizontalAlign, l = _t_aS.verticalAlign;
            return new t.P((-(n - .5) * i / o + r[0]) * s, (-(l - .5) * a / o + r[1]) * s);
        }
        function dr(e1, i, a, r, o, s) {
            var n = i.tileAnchorPoint.add(new t.P(i.translation[0], i.translation[1]));
            if (i.pitchWithMap) {
                var _$e = r.mult(s);
                a || (_$e = _$e.rotate(-o));
                var _$t = n.add(_$e);
                return Ge(_$t.x, _$t.y, i.pitchedLabelPlaneMatrix, i.getElevation).point;
            }
            if (a) {
                var _$t1 = Ye(i.tileAnchorPoint.x + 1, i.tileAnchorPoint.y, i).point.sub(e1), _$a = Math.atan(_$t1.y / _$t1.x) + (_$t1.x < 0 ? Math.PI : 0);
                return e1.add(r.rotate(_$a));
            }
            return e1.add(r);
        }
        function _r(e1, i, a, r, o, s, n, l, c, h, u, d) {
            var _ = e1.text.placedSymbolArray, p = e1.text.dynamicLayoutVertexArray, m = e1.icon.dynamicLayoutVertexArray, f = {};
            p.clear();
            for(var m1 = 0; m1 < _.length; m1++){
                var g = _.get(m1), v = g.hidden || !g.crossTileID || e1.allowVerticalPlacement && !g.placedOrientation ? null : r[g.crossTileID];
                if (v) {
                    var _$r = new t.P(g.anchorX, g.anchorY), _1 = {
                        getElevation: d,
                        width: o.width,
                        height: o.height,
                        pitchedLabelPlaneMatrix: s,
                        pitchWithMap: a,
                        transform: o,
                        tileAnchorPoint: _$r,
                        translation: h,
                        unwrappedTileID: u
                    }, m2 = a ? Je(_$r.x, _$r.y, _1) : Ye(_$r.x, _$r.y, _1), x = Ue(o.cameraToCenterDistance, m2.signedDistanceFromCamera);
                    var b = t.aA(e1.textSizeData, l, g) * x / t.aM;
                    a && (b *= e1.tilePixelRatio / n);
                    var y = v.width, w = v.height, T = v.anchor, P = v.textOffset, C = v.textBoxScale, I = ur(T, y, w, P, C, b), M = o.getPitchedTextCorrection(_$r.x + h[0], _$r.y + h[1], u), E = dr(m2.point, _1, i, I, -o.bearingInRadians, M), S = e1.allowVerticalPlacement && g.placedOrientation === t.az.vertical ? Math.PI / 2 : 0;
                    for(var _$e = 0; _$e < g.numGlyphs; _$e++)t.aG(p, E, S);
                    c && g.associatedIconIndex >= 0 && (f[g.associatedIconIndex] = {
                        shiftedAnchor: E,
                        angle: S
                    });
                } else rt(g.numGlyphs, p);
            }
            if (c) {
                m.clear();
                var _$i = e1.icon.placedSymbolArray;
                for(var _$e1 = 0; _$e1 < _$i.length; _$e1++){
                    var _$a = _$i.get(_$e1);
                    if (_$a.hidden) rt(_$a.numGlyphs, m);
                    else {
                        var _$i1 = f[_$e1];
                        if (_$i1) for(var _$e2 = 0; _$e2 < _$a.numGlyphs; _$e2++)t.aG(m, _$i1.shiftedAnchor, _$i1.angle);
                        else rt(_$a.numGlyphs, m);
                    }
                }
                e1.icon.dynamicLayoutVertexBuffer.updateData(m);
            }
            e1.text.dynamicLayoutVertexBuffer.updateData(p);
        }
        function pr(e1, t, i) {
            return i.iconsInText && t ? "symbolTextAndIcon" : e1 ? "symbolSDF" : "symbolIcon";
        }
        function mr(e1, i, a, r, o, s, n, l, c, h, u, d, _) {
            var p = e1.context, m = p.gl, f = e1.transform, g = "map" === l, v = "map" === c, x = "viewport" !== l && "point" !== a.layout.get("symbol-placement"), b = g && !v && !x, y = !a.layout.get("symbol-sort-key").isConstant();
            var w = !1;
            var T = e1.getDepthModeForSublayer(0, ti.ReadOnly), P = a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset"), C = [], I = f.getCircleRadiusCorrection();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                var _loop = function() {
                    var _$l = _step.value;
                    var _$r = i.getTile(_$l), _$c = _$r.getBucket(a);
                    if (!_$c) return "continue";
                    var _$u = o ? _$c.text : _$c.icon;
                    if (!_$u || !_$u.segments.get().length || !_$u.hasVisibleVertices) return "continue";
                    var _$d = _$u.programConfigurations.get(a.id), p = o || _$c.sdfIcons, T = o ? _$c.textSizeData : _$c.iconSizeData, M = v || 0 !== f.pitch, E = e1.useProgram(pr(p, o, _$c), _$d), S = t.ay(T, f.zoom), R = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(_$l);
                    var z = void 0, D = void 0, A = void 0, L = void 0, k = [
                        0,
                        0
                    ], F = null;
                    if (o) D = _$r.glyphAtlasTexture, A = m.LINEAR, z = _$r.glyphAtlasTexture.size, _$c.iconsInText && (k = _$r.imageAtlasTexture.size, F = _$r.imageAtlasTexture, L = M || e1.options.rotating || e1.options.zooming || "composite" === T.kind || "camera" === T.kind ? m.LINEAR : m.NEAREST);
                    else {
                        var _$t = 1 !== a.layout.get("icon-size").constantOr(0) || _$c.iconsNeedLinear;
                        D = _$r.imageAtlasTexture, A = p || e1.options.rotating || e1.options.zooming || _$t || M ? m.LINEAR : m.NEAREST, z = _$r.imageAtlasTexture.size;
                    }
                    var B = t.aN(_$r, 1, e1.transform.zoom), O = je(g, e1.transform, B), j = t.N();
                    t.aB(j, O);
                    var N = Ne(v, g, e1.transform, B), Z = t.aO(f, _$r, s, n), G = f.getProjectionData({
                        overscaledTileID: _$l,
                        applyGlobeMatrix: !_,
                        applyTerrainMatrix: !0
                    }), U = P && _$c.hasTextData(), V = "none" !== a.layout.get("icon-text-fit") && U && _$c.hasIconData();
                    if (x) {
                        var _$t1 = e1.style.map.terrain ? function(t, i) {
                            return e1.style.map.terrain.getElevation(_$l, t, i);
                        } : null, _$i = "map" === a.layout.get("text-rotation-alignment");
                        qe(_$c, e1, o, O, j, v, h, _$i, _$l.toUnwrapped(), f.width, f.height, Z, _$t1);
                    }
                    var q = o && P || V, W = x || q ? hr : v ? O : e1.transform.clipSpaceToPixelsMatrix, $ = p && 0 !== a.paint.get(o ? "text-halo-width" : "icon-halo-width").constantOr(1);
                    var H = void 0;
                    H = p ? _$c.iconsInText ? ma(T.kind, S, b, v, x, q, e1, W, N, Z, z, k, I) : pa(T.kind, S, b, v, x, q, e1, W, N, Z, o, z, 0, I) : _a(T.kind, S, b, v, x, q, e1, W, N, Z, o, z, I);
                    var X = {
                        program: E,
                        buffers: _$u,
                        uniformValues: H,
                        projectionData: G,
                        atlasTexture: D,
                        atlasTextureIcon: F,
                        atlasInterpolation: A,
                        atlasInterpolationIcon: L,
                        isSDF: p,
                        hasHalo: $
                    };
                    if (y && _$c.canOverlap) {
                        w = !0;
                        var _$e = _$u.segments.get();
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = _$e[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$i1 = _step1.value;
                                C.push({
                                    segments: new t.aX([
                                        _$i1
                                    ]),
                                    sortKey: _$i1.sortKey,
                                    state: X,
                                    terrainData: R
                                });
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    } else C.push({
                        segments: _$u.segments,
                        sortKey: 0,
                        state: X,
                        terrainData: R
                    });
                };
                for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            w && C.sort(function(e1, t) {
                return e1.sortKey - t.sortKey;
            });
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = C[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _$t = _step1.value;
                    var _$i = _$t.state;
                    if (p.activeTexture.set(m.TEXTURE0), _$i.atlasTexture.bind(_$i.atlasInterpolation, m.CLAMP_TO_EDGE), _$i.atlasTextureIcon && (p.activeTexture.set(m.TEXTURE1), _$i.atlasTextureIcon && _$i.atlasTextureIcon.bind(_$i.atlasInterpolationIcon, m.CLAMP_TO_EDGE)), _$i.isSDF) {
                        var _$r = _$i.uniformValues;
                        _$i.hasHalo && (_$r.u_is_halo = 1, fr(_$i.buffers, _$t.segments, a, e1, _$i.program, T, u, d, _$r, _$i.projectionData, _$t.terrainData)), _$r.u_is_halo = 0;
                    }
                    fr(_$i.buffers, _$t.segments, a, e1, _$i.program, T, u, d, _$i.uniformValues, _$i.projectionData, _$t.terrainData);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
        function fr(e1, t, i, a, r, o, s, n, l, c, h) {
            var u = a.context;
            r.draw(u, u.gl.TRIANGLES, o, s, n, ei.backCCW, l, h, c, i.id, e1.layoutVertexBuffer, e1.indexBuffer, t, i.paint, a.transform.zoom, e1.programConfigurations.get(i.id), e1.dynamicLayoutVertexBuffer, e1.opacityVertexBuffer);
        }
        function gr(e1, i, a, r, o) {
            var s = e1.context, n = s.gl, l = ai.disabled, _$c = new Qt([
                n.ONE,
                n.ONE
            ], t.bp.transparent, [
                !0,
                !0,
                !0,
                !0
            ]), h = i.getBucket(a);
            if (!h) return;
            var u = r.key;
            var d = a.heatmapFbos.get(u);
            d || (d = xr(s, i.tileSize, i.tileSize), a.heatmapFbos.set(u, d)), s.bindFramebuffer.set(d.framebuffer), s.viewport.set([
                0,
                0,
                i.tileSize,
                i.tileSize
            ]), s.clear({
                color: t.bp.transparent
            });
            var _ = h.programConfigurations.get(a.id), p = e1.useProgram("heatmap", _, !o), m = e1.transform.getProjectionData({
                overscaledTileID: i.tileID,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            }), f = e1.style.map.terrain.getTerrainData(r);
            p.draw(s, n.TRIANGLES, ti.disabled, l, _$c, ei.disabled, Qi(i, e1.transform.zoom, a.paint.get("heatmap-intensity"), 1), f, m, a.id, h.layoutVertexBuffer, h.indexBuffer, h.segments, a.paint, e1.transform.zoom, _);
        }
        function vr(e1, t, i, a, r) {
            var o = e1.context, s = o.gl, n = e1.transform;
            o.setColorMode(e1.colorModeForRenderPass());
            var l = br(o, t), _$c = i.key, h = t.heatmapFbos.get(_$c);
            if (!h) return;
            o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, h.colorAttachment.get()), o.activeTexture.set(s.TEXTURE1), l.bind(s.LINEAR, s.CLAMP_TO_EDGE);
            var u = n.getProjectionData({
                overscaledTileID: i,
                applyTerrainMatrix: r,
                applyGlobeMatrix: !a
            });
            e1.useProgram("heatmapTexture").draw(o, s.TRIANGLES, ti.disabled, ai.disabled, e1.colorModeForRenderPass(), ei.disabled, Ji(e1, t, 0, 1), null, u, t.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments, t.paint, n.zoom), h.destroy(), t.heatmapFbos.delete(_$c);
        }
        function xr(e1, t, i) {
            var a, r;
            var o = e1.gl, s = o.createTexture();
            o.bindTexture(o.TEXTURE_2D, s), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_S, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_WRAP_T, o.CLAMP_TO_EDGE), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MIN_FILTER, o.LINEAR), o.texParameteri(o.TEXTURE_2D, o.TEXTURE_MAG_FILTER, o.LINEAR);
            var n = null !== (a = e1.HALF_FLOAT) && void 0 !== a ? a : o.UNSIGNED_BYTE, l = null !== (r = e1.RGBA16F) && void 0 !== r ? r : o.RGBA;
            o.texImage2D(o.TEXTURE_2D, 0, l, t, i, 0, o.RGBA, n, null);
            var _$c = e1.createFramebuffer(t, i, !1, !1);
            return _$c.colorAttachment.set(s), _$c;
        }
        function br(e1, i) {
            return i.colorRampTexture || (i.colorRampTexture = new t.T(e1, i.colorRamp, e1.gl.RGBA)), i.colorRampTexture;
        }
        function yr(e1, i, a, r, o, s, n, l) {
            var _$c = 256;
            if (o.stepInterpolant) {
                var _$r = i.getSource().maxzoom, _$o = n.canonical.z === _$r ? Math.ceil(1 << e1.transform.maxZoom - n.canonical.z) : 1;
                _$c = t.an(t.ce(s.maxLineLength / t.a5 * 1024 * _$o), 256, a.maxTextureSize);
            }
            return l.gradient = t.cf({
                expression: o.gradientExpression(),
                evaluationKey: "lineProgress",
                resolution: _$c,
                image: l.gradient || void 0,
                clips: s.lineClipsArray
            }), l.texture ? l.texture.update(l.gradient) : l.texture = new t.T(a, l.gradient, r.RGBA), l.version = o.gradientVersion, l.texture;
        }
        function wr(e1, t, i, a, r) {
            e1.activeTexture.set(t.TEXTURE0), i.imageAtlasTexture.bind(t.LINEAR, t.CLAMP_TO_EDGE), a.updatePaintBuffers(r);
        }
        function Tr(e1, t, i, a, r, o) {
            (r || e1.lineAtlas.dirty) && (t.activeTexture.set(i.TEXTURE0), e1.lineAtlas.bind(t)), a.updatePaintBuffers(o);
        }
        function Pr(e1, t, i, a, r, o, s) {
            var n = o.gradients[r.id];
            var l = n.texture;
            r.gradientVersion !== n.version && (l = yr(e1, t, i, a, r, o, s, n)), i.activeTexture.set(a.TEXTURE0), l.bind(r.stepInterpolant ? a.NEAREST : a.LINEAR, a.CLAMP_TO_EDGE);
        }
        function Cr(e1, t, i, a, r, o, s, n, l) {
            var _$c = o.gradients[r.id];
            var h = _$c.texture;
            r.gradientVersion !== _$c.version && (h = yr(e1, t, i, a, r, o, s, _$c)), i.activeTexture.set(a.TEXTURE0), h.bind(r.stepInterpolant ? a.NEAREST : a.LINEAR, a.CLAMP_TO_EDGE), i.activeTexture.set(a.TEXTURE1), e1.lineAtlas.bind(i), n.updatePaintBuffers(l);
        }
        function Ir(e1, t, i, a, r) {
            if (!i || !a || !a.imageAtlas) return;
            var o = a.imageAtlas.patternPositions;
            var s = o[i.to.toString()], n = o[i.from.toString()];
            if (!s && n && (s = n), !n && s && (n = s), !s || !n) {
                var _$e = r.getPaintProperty(t);
                s = o[_$e], n = o[_$e];
            }
            s && n && e1.setConstantPatternPositions(s, n);
        }
        function Mr(e1, i, a, r, o, s, n, l) {
            var _$c = e1.context.gl, h = "fill-pattern", u = a.paint.get(h), d = u && u.constantOr(1), _ = a.getCrossfadeParameters();
            var p, m, f, g, v;
            var x = e1.transform, b = a.paint.get("fill-translate"), y = a.paint.get("fill-translate-anchor");
            n ? (m = d && !a.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", p = _$c.LINES) : (m = d ? "fillPattern" : "fill", p = _$c.TRIANGLES);
            var w = u.constantOr(null);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var u1 = _step.value;
                    var _$r = i.getTile(u1);
                    if (d && !_$r.patternsLoaded()) continue;
                    var T = _$r.getBucket(a);
                    if (!T) continue;
                    var P = T.programConfigurations.get(a.id), C = e1.useProgram(m, P), I = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(u1);
                    d && (e1.context.activeTexture.set(_$c.TEXTURE0), _$r.imageAtlasTexture.bind(_$c.LINEAR, _$c.CLAMP_TO_EDGE), P.updatePaintBuffers(_)), Ir(P, h, w, _$r, a);
                    var M = x.getProjectionData({
                        overscaledTileID: u1,
                        applyGlobeMatrix: !l,
                        applyTerrainMatrix: !0
                    }), E = t.aO(x, _$r, b, y);
                    if (n) {
                        g = T.indexBuffer2, v = T.segments2;
                        var _$t = [
                            _$c.drawingBufferWidth,
                            _$c.drawingBufferHeight
                        ];
                        f = "fillOutlinePattern" === m && d ? $i(e1, _, _$r, _$t, E) : Wi(_$t, E);
                    } else g = T.indexBuffer, v = T.segments, f = d ? qi(e1, _, _$r, E) : {
                        u_fill_translate: E
                    };
                    var S = e1.stencilModeForClipping(u1);
                    C.draw(e1.context, p, o, S, s, ei.backCCW, f, I, M, a.id, T.layoutVertexBuffer, g, v, a.paint, e1.transform.zoom, P);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        function Er(e1, i, a, r, o, s, n, l) {
            var _$c = e1.context, h = _$c.gl, u = "fill-extrusion-pattern", d = a.paint.get(u), _ = d.constantOr(1), p = a.getCrossfadeParameters(), m = a.paint.get("fill-extrusion-opacity"), f = d.constantOr(null), g = e1.transform;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var d1 = _step.value;
                    var _$r = i.getTile(d1), v = _$r.getBucket(a);
                    if (!v) continue;
                    var x = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(d1), b = v.programConfigurations.get(a.id), y = e1.useProgram(_ ? "fillExtrusionPattern" : "fillExtrusion", b);
                    _ && (e1.context.activeTexture.set(h.TEXTURE0), _$r.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), b.updatePaintBuffers(p));
                    var w = g.getProjectionData({
                        overscaledTileID: d1,
                        applyGlobeMatrix: !l,
                        applyTerrainMatrix: !0
                    });
                    Ir(b, u, f, _$r, a);
                    var T = t.aO(g, _$r, a.paint.get("fill-extrusion-translate"), a.paint.get("fill-extrusion-translate-anchor")), P = a.paint.get("fill-extrusion-vertical-gradient"), C = _ ? Vi(e1, P, m, T, d1, p, _$r) : Ui(e1, P, m, T);
                    y.draw(_$c, _$c.gl.TRIANGLES, o, s, n, ei.backCCW, C, x, w, a.id, v.layoutVertexBuffer, v.indexBuffer, v.segments, a.paint, e1.transform.zoom, b, e1.style.map.terrain && v.centroidVertexBuffer);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        function Sr(e1, t, i, a, r, o, s, n, l) {
            var _$c;
            var h = e1.style.projection, u = e1.context, d = e1.transform, _ = u.gl, p = [
                "#define NUM_ILLUMINATION_SOURCES ".concat(i.paint.get("hillshade-highlight-color").values.length)
            ], m = e1.useProgram("hillshade", null, !1, p), f = !e1.options.moving;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var p1 = _step.value;
                    var _$a = t.getTile(p1), g = _$a.fbo;
                    if (!g) continue;
                    var v = h.getMeshFromTileID(u, p1.canonical, n, !0, "raster"), x = null === (_$c = e1.style.map.terrain) || void 0 === _$c ? void 0 : _$c.getTerrainData(p1);
                    u.activeTexture.set(_.TEXTURE0), _.bindTexture(_.TEXTURE_2D, g.colorAttachment.get());
                    var b = d.getProjectionData({
                        overscaledTileID: p1,
                        aligned: f,
                        applyGlobeMatrix: !l,
                        applyTerrainMatrix: !0
                    });
                    m.draw(u, _.TRIANGLES, o, r[p1.overscaledZ], s, ei.backCCW, ea(e1, _$a, i), x, b, i.id, v.vertexBuffer, v.indexBuffer, v.segments);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        function Rr(e1, i, a, r, o, s, n, l, c) {
            var h;
            var u = e1.style.projection, d = e1.context, _ = e1.transform, p = d.gl, m = e1.useProgram("colorRelief"), f = !e1.options.moving;
            var g = !0, v = 0;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var x = _step.value;
                    var _$r = i.getTile(x), b = _$r.dem;
                    if (g) {
                        var _$e = p.getParameter(p.MAX_TEXTURE_SIZE), _a_getColorRampTextures = a.getColorRampTextures(d, _$e, b.getUnpackVector()), _$t = _a_getColorRampTextures.elevationTexture, _$i = _a_getColorRampTextures.colorTexture;
                        d.activeTexture.set(p.TEXTURE1), _$t.bind(p.NEAREST, p.CLAMP_TO_EDGE), d.activeTexture.set(p.TEXTURE4), _$i.bind(p.LINEAR, p.CLAMP_TO_EDGE), g = !1, v = _$t.size[0];
                    }
                    if (!b || !b.data) continue;
                    var y = b.stride, w = b.getPixels();
                    if (d.activeTexture.set(p.TEXTURE0), d.pixelStoreUnpackPremultiplyAlpha.set(!1), _$r.demTexture = _$r.demTexture || e1.getTileTexture(y), _$r.demTexture) {
                        var _$e1 = _$r.demTexture;
                        _$e1.update(w, {
                            premultiply: !1
                        }), _$e1.bind(p.LINEAR, p.CLAMP_TO_EDGE);
                    } else _$r.demTexture = new t.T(d, w, p.RGBA, {
                        premultiply: !1
                    }), _$r.demTexture.bind(p.LINEAR, p.CLAMP_TO_EDGE);
                    var T = u.getMeshFromTileID(d, x.canonical, l, !0, "raster"), P = null === (h = e1.style.map.terrain) || void 0 === h ? void 0 : h.getTerrainData(x), C = _.getProjectionData({
                        overscaledTileID: x,
                        aligned: f,
                        applyGlobeMatrix: !c,
                        applyTerrainMatrix: !0
                    });
                    m.draw(d, p.TRIANGLES, s, o[x.overscaledZ], n, ei.backCCW, aa(a, _$r.dem, v), P, C, a.id, T.vertexBuffer, T.indexBuffer, T.segments);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        var zr = [
            new t.P(0, 0),
            new t.P(t.a5, 0),
            new t.P(t.a5, t.a5),
            new t.P(0, t.a5)
        ];
        function Dr(e1, t, i, a, r, o, s, n) {
            var l = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : !1, _$c = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : !1;
            var h = a[a.length - 1].overscaledZ, u = e1.context, d = u.gl, _ = e1.useProgram("raster"), p = e1.transform, m = e1.style.projection, f = e1.colorModeForRenderPass(), g = !e1.options.moving, v = i.paint.get("raster-opacity"), x = i.paint.get("raster-resampling"), b = i.paint.get("raster-fade-duration"), y = !!e1.style.map.terrain;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var w = _step.value;
                    var _$a = e1.getDepthModeForSublayer(w.overscaledZ - h, 1 === v ? ti.ReadWrite : ti.ReadOnly, d.LESS), T = t.getTile(w), P = "nearest" === x ? d.NEAREST : d.LINEAR;
                    u.activeTexture.set(d.TEXTURE0), T.texture.bind(P, d.CLAMP_TO_EDGE, d.LINEAR_MIPMAP_NEAREST), u.activeTexture.set(d.TEXTURE1);
                    var _Ar = Ar(T, t, b, y), C = _Ar.parentTile, I = _Ar.parentScaleBy, M = _Ar.parentTopLeft, E = _Ar.fadeValues;
                    T.fadeOpacity = E.tileOpacity, C ? (C.fadeOpacity = E.parentTileOpacity, C.texture.bind(P, d.CLAMP_TO_EDGE, d.LINEAR_MIPMAP_NEAREST)) : T.texture.bind(P, d.CLAMP_TO_EDGE, d.LINEAR_MIPMAP_NEAREST), T.texture.useMipmap && u.extTextureFilterAnisotropic && e1.transform.pitch > 20 && d.texParameterf(d.TEXTURE_2D, u.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, u.extTextureFilterAnisotropicMax);
                    var S = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(w), R = p.getProjectionData({
                        overscaledTileID: w,
                        aligned: g,
                        applyGlobeMatrix: !_$c,
                        applyTerrainMatrix: !0
                    }), z = ua(M, I, E.fadeMix, i, n), D = m.getMeshFromTileID(u, w.canonical, o, s, "raster");
                    _.draw(u, d.TRIANGLES, _$a, r ? r[w.overscaledZ] : ai.disabled, f, l ? ei.frontCCW : ei.backCCW, z, S, R, i.id, D.vertexBuffer, D.indexBuffer, D.segments);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        function Ar(e1, i, a, r) {
            var o = {
                parentTile: null,
                parentScaleBy: 1,
                parentTopLeft: [
                    0,
                    0
                ],
                fadeValues: {
                    tileOpacity: 1,
                    parentTileOpacity: 1,
                    fadeMix: {
                        opacity: 1,
                        mix: 0
                    }
                }
            };
            if (0 === a || r) return o;
            if (e1.fadingParentID) {
                var _$r = i.getLoadedTile(e1.fadingParentID);
                if (!_$r) return o;
                var s = Math.pow(2, _$r.tileID.overscaledZ - e1.tileID.overscaledZ), n = [
                    e1.tileID.canonical.x * s % 1,
                    e1.tileID.canonical.y * s % 1
                ], l = function(e1, i, a) {
                    var _$r = c(), o = (_$r - i.timeAdded) / a, s = e1.fadingDirection === ue.Incoming, n = t.an((_$r - e1.timeAdded) / a, 0, 1), l = t.an(1 - o, 0, 1), h = s ? n : l;
                    return {
                        tileOpacity: h,
                        parentTileOpacity: s ? l : n,
                        fadeMix: {
                            opacity: 1,
                            mix: 1 - h
                        }
                    };
                }(e1, _$r, a);
                return {
                    parentTile: _$r,
                    parentScaleBy: s,
                    parentTopLeft: n,
                    fadeValues: l
                };
            }
            if (e1.selfFading) {
                var _$i = function(e1, i) {
                    var _$a = (c() - e1.timeAdded) / i, _$r = t.an(_$a, 0, 1);
                    return {
                        tileOpacity: _$r,
                        fadeMix: {
                            opacity: _$r,
                            mix: 0
                        }
                    };
                }(e1, a);
                return {
                    parentTile: null,
                    parentScaleBy: 1,
                    parentTopLeft: [
                        0,
                        0
                    ],
                    fadeValues: _$i
                };
            }
            return o;
        }
        var Lr = new t.bp(1, 0, 0, 1), kr = new t.bp(0, 1, 0, 1), Fr = new t.bp(0, 0, 1, 1), Br = new t.bp(1, 0, 1, 1), Or = new t.bp(0, 1, 1, 1);
        function jr(e1, t, i, a) {
            Zr(e1, 0, t + i / 2, e1.transform.width, i, a);
        }
        function Nr(e1, t, i, a) {
            Zr(e1, t - i / 2, 0, i, e1.transform.height, a);
        }
        function Zr(e1, t, i, a, r, o) {
            var s = e1.context, n = s.gl;
            n.enable(n.SCISSOR_TEST), n.scissor(t * e1.pixelRatio, i * e1.pixelRatio, a * e1.pixelRatio, r * e1.pixelRatio), s.clear({
                color: o
            }), n.disable(n.SCISSOR_TEST);
        }
        function Gr(e1, i, a) {
            var r = e1.context, o = r.gl, s = e1.useProgram("debug"), n = ti.disabled, l = ai.disabled, _$c = e1.colorModeForRenderPass(), h = "$debug", u = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(a);
            r.activeTexture.set(o.TEXTURE0);
            var d = i.getTileByID(a.key).latestRawTileData, _ = Math.floor((d && d.byteLength || 0) / 1024), p = i.getTile(a).tileSize, m = 512 / Math.min(p, 512) * (a.overscaledZ / e1.transform.zoom) * .5;
            var f = a.canonical.toString();
            a.overscaledZ !== a.canonical.z && (f += " => ".concat(a.overscaledZ)), function(e1, t) {
                e1.initDebugOverlayCanvas();
                var _$i = e1.debugOverlayCanvas, _$a = e1.context.gl, r = e1.debugOverlayCanvas.getContext("2d");
                r.clearRect(0, 0, _$i.width, _$i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(t, 5, 5), r.strokeText(t, 5, 5), e1.debugOverlayTexture.update(_$i), e1.debugOverlayTexture.bind(_$a.LINEAR, _$a.CLAMP_TO_EDGE);
            }(e1, "".concat(f, " ").concat(_, "kB"));
            var g = e1.transform.getProjectionData({
                overscaledTileID: a,
                applyGlobeMatrix: !0,
                applyTerrainMatrix: !0
            });
            s.draw(r, o.TRIANGLES, n, l, Qt.alphaBlended, ei.disabled, Yi(t.bp.transparent, m), null, g, h, e1.debugBuffer, e1.quadTriangleIndexBuffer, e1.debugSegments), s.draw(r, o.LINE_STRIP, n, l, _$c, ei.disabled, Yi(t.bp.red), u, g, h, e1.debugBuffer, e1.tileBorderIndexBuffer, e1.debugSegments);
        }
        function Ur(e1, t, i, a) {
            var r = a.isRenderingGlobe, o = e1.context, s = o.gl, n = e1.transform, l = e1.colorModeForRenderPass(), _$c = e1.getDepthModeFor3D(), h = e1.useProgram("terrain");
            o.bindFramebuffer.set(null), o.viewport.set([
                0,
                0,
                e1.width,
                e1.height
            ]);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _$a = _step.value;
                    var _$i = t.getTerrainMesh(_$a.tileID), u = e1.renderToTexture.getTexture(_$a), d = t.getTerrainData(_$a.tileID);
                    o.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, u.texture);
                    var _ = t.getMeshFrameDelta(n.zoom), p = n.calculateFogMatrix(_$a.tileID.toUnwrapped()), m = Oi(_, p, e1.style.sky, n.pitch, r), f = n.getProjectionData({
                        overscaledTileID: _$a.tileID,
                        applyTerrainMatrix: !1,
                        applyGlobeMatrix: !0
                    });
                    h.draw(o, s.TRIANGLES, _$c, ai.disabled, l, ei.backCCW, m, d, f, "terrain", _$i.vertexBuffer, _$i.indexBuffer, _$i.segments);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
        function Vr(e1, i) {
            if (!i.mesh) {
                var a = new t.aW;
                a.emplaceBack(-1, -1), a.emplaceBack(1, -1), a.emplaceBack(1, 1), a.emplaceBack(-1, 1);
                var r = new t.aY;
                r.emplaceBack(0, 1, 2), r.emplaceBack(0, 2, 3), i.mesh = new kt(e1.createVertexBuffer(a, Ft.members), e1.createIndexBuffer(r), t.aX.simpleSegment(0, 0, a.length, r.length));
            }
            return i.mesh;
        }
        var qr = /*#__PURE__*/ function() {
            function qr(e1, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, qr);
                this.context = new nr(e1), this.transform = i, this._tileTextures = {}, this.terrainFacilitator = {
                    dirty: !0,
                    matrix: t.ar(new Float64Array(16)),
                    renderTime: 0
                }, this.setup(), this.numSublayers = ke.maxOverzooming + ke.maxUnderzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new zt;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(qr, [
                {
                    key: "resize",
                    value: function resize(e1, t, i) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (this.width = Math.floor(e1 * i), this.height = Math.floor(t * i), this.pixelRatio = i, this.context.viewport.set([
                            0,
                            0,
                            this.width,
                            this.height
                        ]), this.style) try {
                            for(var _iterator = this.style._order[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                this.style._layers[_$e].resize();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "setup",
                    value: function setup() {
                        var _$e = this.context, i = new t.aW;
                        i.emplaceBack(0, 0), i.emplaceBack(t.a5, 0), i.emplaceBack(0, t.a5), i.emplaceBack(t.a5, t.a5), this.tileExtentBuffer = _$e.createVertexBuffer(i, Ft.members), this.tileExtentSegments = t.aX.simpleSegment(0, 0, 4, 2);
                        var a = new t.aW;
                        a.emplaceBack(0, 0), a.emplaceBack(t.a5, 0), a.emplaceBack(0, t.a5), a.emplaceBack(t.a5, t.a5), this.debugBuffer = _$e.createVertexBuffer(a, Ft.members), this.debugSegments = t.aX.simpleSegment(0, 0, 4, 5);
                        var r = new t.ch;
                        r.emplaceBack(0, 0, 0, 0), r.emplaceBack(t.a5, 0, t.a5, 0), r.emplaceBack(0, t.a5, 0, t.a5), r.emplaceBack(t.a5, t.a5, t.a5, t.a5), this.rasterBoundsBuffer = _$e.createVertexBuffer(r, Fi.members), this.rasterBoundsSegments = t.aX.simpleSegment(0, 0, 4, 2);
                        var o = new t.aW;
                        o.emplaceBack(0, 0), o.emplaceBack(t.a5, 0), o.emplaceBack(0, t.a5), o.emplaceBack(t.a5, t.a5), this.rasterBoundsBufferPosOnly = _$e.createVertexBuffer(o, Ft.members), this.rasterBoundsSegmentsPosOnly = t.aX.simpleSegment(0, 0, 4, 5);
                        var s = new t.aW;
                        s.emplaceBack(0, 0), s.emplaceBack(1, 0), s.emplaceBack(0, 1), s.emplaceBack(1, 1), this.viewportBuffer = _$e.createVertexBuffer(s, Ft.members), this.viewportSegments = t.aX.simpleSegment(0, 0, 4, 2);
                        var n = new t.ci;
                        n.emplaceBack(0), n.emplaceBack(1), n.emplaceBack(3), n.emplaceBack(2), n.emplaceBack(0), this.tileBorderIndexBuffer = _$e.createIndexBuffer(n);
                        var l = new t.aY;
                        l.emplaceBack(1, 0, 2), l.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = _$e.createIndexBuffer(l);
                        var _$c = this.context.gl;
                        this.stencilClearMode = new ai({
                            func: _$c.ALWAYS,
                            mask: 0
                        }, 0, 255, _$c.ZERO, _$c.ZERO, _$c.ZERO), this.tileExtentMesh = new kt(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                    }
                },
                {
                    key: "clearStencil",
                    value: function clearStencil() {
                        var _$e = this.context, i = _$e.gl;
                        this.nextStencilID = 1, this.currentStencilSource = void 0;
                        var a = t.N();
                        t.c7(a, 0, this.width, this.height, 0, 0, 1), t.Q(a, a, [
                            i.drawingBufferWidth,
                            i.drawingBufferHeight,
                            0
                        ]);
                        var r = {
                            mainMatrix: a,
                            tileMercatorCoords: [
                                0,
                                0,
                                1,
                                1
                            ],
                            clippingPlane: [
                                0,
                                0,
                                0,
                                0
                            ],
                            projectionTransition: 0,
                            fallbackMatrix: a
                        };
                        this.useProgram("clippingMask", null, !0).draw(_$e, i.TRIANGLES, ti.disabled, this.stencilClearMode, Qt.disabled, ei.disabled, null, null, r, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
                    }
                },
                {
                    key: "_renderTileClippingMasks",
                    value: function _renderTileClippingMasks(e1, t, i) {
                        if (this.currentStencilSource === e1.source || !e1.isTileClipped() || !t || !t.length) return;
                        this.currentStencilSource = e1.source, this.nextStencilID + t.length > 256 && this.clearStencil();
                        var a = this.context;
                        a.setColorMode(Qt.disabled), a.setDepthMode(ti.disabled);
                        var r = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                r[_$e.key] = this.nextStencilID++;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._renderTileMasks(r, t, i, !0), this._renderTileMasks(r, t, i, !1), this._tileClippingMaskIDs = r;
                    }
                },
                {
                    key: "_renderTileMasks",
                    value: function _renderTileMasks(e1, t, i, a) {
                        var r = this.context, o = r.gl, s = this.style.projection, n = this.transform, l = this.useProgram("clippingMask");
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$c = _step.value;
                                var _$t = e1[_$c.key], h = this.style.map.terrain && this.style.map.terrain.getTerrainData(_$c), u = s.getMeshFromTileID(this.context, _$c.canonical, a, !0, "stencil"), d = n.getProjectionData({
                                    overscaledTileID: _$c,
                                    applyGlobeMatrix: !i,
                                    applyTerrainMatrix: !0
                                });
                                l.draw(r, o.TRIANGLES, ti.disabled, new ai({
                                    func: o.ALWAYS,
                                    mask: 0
                                }, _$t, 255, o.KEEP, o.KEEP, o.REPLACE), Qt.disabled, i ? ei.disabled : ei.backCCW, null, h, d, "$clipping", u.vertexBuffer, u.indexBuffer, u.segments);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_renderTilesDepthBuffer",
                    value: function _renderTilesDepthBuffer() {
                        var _$e = this.context, _$t = _$e.gl, i = this.style.projection, a = this.transform, r = this.useProgram("depth"), o = this.getDepthModeFor3D(), s = Ie(a, {
                            tileSize: a.tileSize
                        });
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var n = _step.value;
                                var s1 = this.style.map.terrain && this.style.map.terrain.getTerrainData(n), l = i.getMeshFromTileID(this.context, n.canonical, !0, !0, "raster"), _$c = a.getProjectionData({
                                    overscaledTileID: n,
                                    applyGlobeMatrix: !0,
                                    applyTerrainMatrix: !0
                                });
                                r.draw(_$e, _$t.TRIANGLES, o, ai.disabled, Qt.disabled, ei.backCCW, null, s1, _$c, "$clipping", l.vertexBuffer, l.indexBuffer, l.segments);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "stencilModeFor3D",
                    value: function stencilModeFor3D() {
                        this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                        var _$e = this.nextStencilID++, _$t = this.context.gl;
                        return new ai({
                            func: _$t.NOTEQUAL,
                            mask: 255
                        }, _$e, 255, _$t.KEEP, _$t.KEEP, _$t.REPLACE);
                    }
                },
                {
                    key: "stencilModeForClipping",
                    value: function stencilModeForClipping(e1) {
                        var _$t = this.context.gl;
                        return new ai({
                            func: _$t.EQUAL,
                            mask: 255
                        }, this._tileClippingMaskIDs[e1.key], 0, _$t.KEEP, _$t.KEEP, _$t.REPLACE);
                    }
                },
                {
                    key: "getStencilConfigForOverlapAndUpdateStencilID",
                    value: function getStencilConfigForOverlapAndUpdateStencilID(e1) {
                        var _$t = this.context.gl, i = e1.sort(function(e1, t) {
                            return t.overscaledZ - e1.overscaledZ;
                        }), a = i[i.length - 1].overscaledZ, r = i[0].overscaledZ - a + 1;
                        if (r > 1) {
                            this.currentStencilSource = void 0, this.nextStencilID + r > 256 && this.clearStencil();
                            var _$e = {};
                            for(var i1 = 0; i1 < r; i1++)_$e[i1 + a] = new ai({
                                func: _$t.GEQUAL,
                                mask: 255
                            }, i1 + this.nextStencilID, 255, _$t.KEEP, _$t.KEEP, _$t.REPLACE);
                            return this.nextStencilID += r, [
                                _$e,
                                i
                            ];
                        }
                        return [
                            (0, $6194eebaf067e4d1$export$71511d61b312f219)({}, a, ai.disabled),
                            i
                        ];
                    }
                },
                {
                    key: "stencilConfigForOverlapTwoPass",
                    value: function stencilConfigForOverlapTwoPass(e1) {
                        var _$t = this.context.gl, i = e1.sort(function(e1, t) {
                            return t.overscaledZ - e1.overscaledZ;
                        }), a = i[i.length - 1].overscaledZ, r = i[0].overscaledZ - a + 1;
                        if (this.clearStencil(), r > 1) {
                            var _$e = {}, o = {};
                            for(var i1 = 0; i1 < r; i1++)_$e[i1 + a] = new ai({
                                func: _$t.GREATER,
                                mask: 255
                            }, r + 1 + i1, 255, _$t.KEEP, _$t.KEEP, _$t.REPLACE), o[i1 + a] = new ai({
                                func: _$t.GREATER,
                                mask: 255
                            }, 1 + i1, 255, _$t.KEEP, _$t.KEEP, _$t.REPLACE);
                            return this.nextStencilID = 2 * r + 1, [
                                _$e,
                                o,
                                i
                            ];
                        }
                        return this.nextStencilID = 3, [
                            (0, $6194eebaf067e4d1$export$71511d61b312f219)({}, a, new ai({
                                func: _$t.GREATER,
                                mask: 255
                            }, 2, 255, _$t.KEEP, _$t.KEEP, _$t.REPLACE)),
                            (0, $6194eebaf067e4d1$export$71511d61b312f219)({}, a, new ai({
                                func: _$t.GREATER,
                                mask: 255
                            }, 1, 255, _$t.KEEP, _$t.KEEP, _$t.REPLACE)),
                            i
                        ];
                    }
                },
                {
                    key: "colorModeForRenderPass",
                    value: function colorModeForRenderPass() {
                        var _$e = this.context.gl;
                        if (this._showOverdrawInspector) {
                            var i = 1 / 8;
                            return new Qt([
                                _$e.CONSTANT_COLOR,
                                _$e.ONE
                            ], new t.bp(i, i, i, 0), [
                                !0,
                                !0,
                                !0,
                                !0
                            ]);
                        }
                        return "opaque" === this.renderPass ? Qt.unblended : Qt.alphaBlended;
                    }
                },
                {
                    key: "getDepthModeForSublayer",
                    value: function getDepthModeForSublayer(e1, t, i) {
                        if (!this.opaquePassEnabledForLayer()) return ti.disabled;
                        var a = 1 - ((1 + this.currentLayer) * this.numSublayers + e1) * this.depthEpsilon;
                        return new ti(i || this.context.gl.LEQUAL, t, [
                            a,
                            a
                        ]);
                    }
                },
                {
                    key: "getDepthModeFor3D",
                    value: function getDepthModeFor3D() {
                        return new ti(this.context.gl.LEQUAL, ti.ReadWrite, this.depthRangeFor3D);
                    }
                },
                {
                    key: "opaquePassEnabledForLayer",
                    value: function opaquePassEnabledForLayer() {
                        return this.currentLayer < this.opaquePassCutoff;
                    }
                },
                {
                    key: "render",
                    value: function render(e1, i) {
                        var _this = this;
                        var a, r;
                        this.style = e1, this.options = i, this.lineAtlas = e1.lineAtlas, this.imageManager = e1.imageManager, this.glyphManager = e1.glyphManager, this.symbolFadeChange = e1.placement.symbolFadeChange(c()), this.imageManager.beginFrame();
                        var o = this.style._order, s = this.style.tileManagers, n = {}, l = {}, h = {}, u = {
                            isRenderingToTexture: !1,
                            isRenderingGlobe: (null === (a = e1.projection) || void 0 === a ? void 0 : a.transitionState) > 0
                        };
                        for(var _$e in s){
                            var _$t = s[_$e];
                            _$t.used && _$t.prepare(this.context), n[_$e] = _$t.getVisibleCoordinates(!1), l[_$e] = n[_$e].slice().reverse(), h[_$e] = _$t.getVisibleCoordinates(!0).reverse();
                        }
                        this.opaquePassCutoff = 1 / 0;
                        for(var _$e1 = 0; _$e1 < o.length; _$e1++)if (this.style._layers[o[_$e1]].is3D()) {
                            this.opaquePassCutoff = _$e1;
                            break;
                        }
                        this.maybeDrawDepthAndCoords(!1), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = "offscreen";
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = o[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e2 = _step.value;
                                var _$t1 = this.style._layers[_$e2];
                                if (!_$t1.hasOffscreenPass() || _$t1.isHidden(this.transform.zoom)) continue;
                                var _$i = l[_$t1.source];
                                ("custom" === _$t1.type || _$i.length) && this.renderLayer(this, s[_$t1.source], _$t1, _$i, u);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (null === (r = this.style.projection) || void 0 === r || r.updateGPUdependent({
                            context: this.context,
                            useProgram: function(e1) {
                                return _this.useProgram(e1);
                            }
                        }), this.context.viewport.set([
                            0,
                            0,
                            this.width,
                            this.height
                        ]), this.context.bindFramebuffer.set(null), this.context.clear({
                            color: i.showOverdrawInspector ? t.bp.black : t.bp.transparent,
                            depth: 1
                        }), this.clearStencil(), this.style.sky && function(e1, t) {
                            var _$i = e1.context, a = _$i.gl, r = function(e1, t, i) {
                                var a = Math.cos(t.rollInRadians), r = Math.sin(t.rollInRadians), o = ge(t), s = t.getProjectionData({
                                    overscaledTileID: null,
                                    applyGlobeMatrix: !0,
                                    applyTerrainMatrix: !0
                                }).projectionTransition;
                                return {
                                    u_sky_color: e1.properties.get("sky-color"),
                                    u_horizon_color: e1.properties.get("horizon-color"),
                                    u_horizon: [
                                        (t.width / 2 - o * r) * i,
                                        (t.height / 2 + o * a) * i
                                    ],
                                    u_horizon_normal: [
                                        -r,
                                        a
                                    ],
                                    u_sky_horizon_blend: e1.properties.get("sky-horizon-blend") * t.height / 2 * i,
                                    u_sky_blend: s
                                };
                            }(t, e1.style.map.transform, e1.pixelRatio), o = new ti(a.LEQUAL, ti.ReadWrite, [
                                0,
                                1
                            ]), s = ai.disabled, n = e1.colorModeForRenderPass(), l = e1.useProgram("sky"), _$c = Vr(_$i, t);
                            l.draw(_$i, a.TRIANGLES, o, s, n, ei.disabled, r, null, void 0, "sky", _$c.vertexBuffer, _$c.indexBuffer, _$c.segments);
                        }(this, this.style.sky), this._showOverdrawInspector = i.showOverdrawInspector, this.depthRangeFor3D = [
                            0,
                            1 - (e1._order.length + 2) * this.numSublayers * this.depthEpsilon
                        ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = o.length - 1; this.currentLayer >= 0; this.currentLayer--){
                            var _$e3 = this.style._layers[o[this.currentLayer]], _$t2 = s[_$e3.source], _$i1 = n[_$e3.source];
                            this._renderTileClippingMasks(_$e3, _$i1, !1), this.renderLayer(this, _$t2, _$e3, _$i1, u);
                        }
                        this.renderPass = "translucent";
                        var d = !1;
                        for(this.currentLayer = 0; this.currentLayer < o.length; this.currentLayer++){
                            var _$e4 = this.style._layers[o[this.currentLayer]], _$t3 = s[_$e4.source];
                            if (this.renderToTexture && this.renderToTexture.renderLayer(_$e4, u)) continue;
                            this.opaquePassEnabledForLayer() || d || (d = !0, u.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
                            var _$i2 = ("symbol" === _$e4.type ? h : l)[_$e4.source];
                            this._renderTileClippingMasks(_$e4, n[_$e4.source], !!this.renderToTexture), this.renderLayer(this, _$t3, _$e4, _$i2, u);
                        }
                        if (u.isRenderingGlobe && function(e1, i, a) {
                            var r = e1.context, o = r.gl, s = e1.useProgram("atmosphere"), n = new ti(o.LEQUAL, ti.ReadOnly, [
                                0,
                                1
                            ]), l = e1.transform, _$c = function(e1, i) {
                                var _$a = e1.properties.get("position"), r = [
                                    -_$a.x,
                                    -_$a.y,
                                    -_$a.z
                                ], o = t.ar(new Float64Array(16));
                                return "map" === e1.properties.get("anchor") && (t.bg(o, o, i.rollInRadians), t.bh(o, o, -i.pitchInRadians), t.bg(o, o, i.bearingInRadians), t.bh(o, o, i.center.lat * Math.PI / 180), t.bJ(o, o, -i.center.lng * Math.PI / 180)), t.cg(r, r, o), r;
                            }(a, e1.transform), h = l.getProjectionData({
                                overscaledTileID: null,
                                applyGlobeMatrix: !0,
                                applyTerrainMatrix: !0
                            }), u = i.properties.get("atmosphere-blend") * h.projectionTransition;
                            if (0 === u) return;
                            var d = fi(l.worldSize, l.center.lat), _ = l.inverseProjectionMatrix, p = new Float64Array(4);
                            p[3] = 1, t.aH(p, p, l.modelViewProjectionMatrix), p[0] /= p[3], p[1] /= p[3], p[2] /= p[3], p[3] = 1, t.aH(p, p, _), p[0] /= p[3], p[1] /= p[3], p[2] /= p[3], p[3] = 1;
                            var m = function(e1, t, i, a, r) {
                                return {
                                    u_sun_pos: e1,
                                    u_atmosphere_blend: t,
                                    u_globe_position: i,
                                    u_globe_radius: a,
                                    u_inv_proj_matrix: r
                                };
                            }(_$c, u, [
                                p[0],
                                p[1],
                                p[2]
                            ], d, _), f = Vr(r, i);
                            s.draw(r, o.TRIANGLES, n, ai.disabled, Qt.alphaBlended, ei.disabled, m, null, null, "atmosphere", f.vertexBuffer, f.indexBuffer, f.segments);
                        }(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
                            var _$e5 = function(e1, t) {
                                var _$i = null;
                                var a = Object.values(e1._layers).flatMap(function(i) {
                                    return i.source && !i.isHidden(t) ? [
                                        e1.tileManagers[i.source]
                                    ] : [];
                                }), r = a.filter(function(e1) {
                                    return "vector" === e1.getSource().type;
                                }), o = a.filter(function(e1) {
                                    return "vector" !== e1.getSource().type;
                                }), s = function(e1) {
                                    (!_$i || _$i.getSource().maxzoom < e1.getSource().maxzoom) && (_$i = e1);
                                };
                                return r.forEach(function(e1) {
                                    return s(e1);
                                }), _$i || o.forEach(function(e1) {
                                    return s(e1);
                                }), _$i;
                            }(this.style, this.transform.zoom);
                            _$e5 && function(e1, t, i) {
                                for(var a = 0; a < i.length; a++)Gr(e1, t, i[a]);
                            }(this, _$e5, _$e5.getVisibleCoordinates());
                        }
                        this.options.showPadding && function(e1) {
                            var _$t = e1.transform.padding;
                            jr(e1, e1.transform.height - (_$t.top || 0), 3, Lr), jr(e1, _$t.bottom || 0, 3, kr), Nr(e1, _$t.left || 0, 3, Fr), Nr(e1, e1.transform.width - (_$t.right || 0), 3, Br);
                            var _$i = e1.transform.centerPoint;
                            !function(e1, t, i, a) {
                                Zr(e1, t - 1, i - 10, 2, 20, a), Zr(e1, t - 10, i - 1, 20, 2, a);
                            }(e1, _$i.x, e1.transform.height - _$i.y, Or);
                        }(this), this.context.setDefault();
                    }
                },
                {
                    key: "maybeDrawDepthAndCoords",
                    value: function maybeDrawDepthAndCoords(e1) {
                        if (!this.style || !this.style.map || !this.style.map.terrain) return;
                        var i = this.terrainFacilitator.matrix, a = this.transform.modelViewProjectionMatrix;
                        var r = this.terrainFacilitator.dirty;
                        r || (r = e1 ? !t.cj(i, a) : !t.ck(i, a)), r || (r = this.style.map.terrain.tileManager.anyTilesAfterTime(this.terrainFacilitator.renderTime)), r && (t.cl(i, a), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(e1, i) {
                            var a = e1.context, r = a.gl, o = e1.transform, s = Qt.unblended, n = new ti(r.LEQUAL, ti.ReadWrite, [
                                0,
                                1
                            ]), l = i.tileManager.getRenderableTiles(), _$c = e1.useProgram("terrainDepth");
                            a.bindFramebuffer.set(i.getFramebuffer("depth").framebuffer), a.viewport.set([
                                0,
                                0,
                                e1.width / devicePixelRatio,
                                e1.height / devicePixelRatio
                            ]), a.clear({
                                color: t.bp.transparent,
                                depth: 1
                            });
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = l[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    var _$t = i.getTerrainMesh(_$e.tileID), l1 = i.getTerrainData(_$e.tileID), h = o.getProjectionData({
                                        overscaledTileID: _$e.tileID,
                                        applyTerrainMatrix: !1,
                                        applyGlobeMatrix: !0
                                    }), u = {
                                        u_ele_delta: i.getMeshFrameDelta(o.zoom)
                                    };
                                    _$c.draw(a, r.TRIANGLES, n, ai.disabled, s, ei.backCCW, u, l1, h, "terrain", _$t.vertexBuffer, _$t.indexBuffer, _$t.segments);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            a.bindFramebuffer.set(null), a.viewport.set([
                                0,
                                0,
                                e1.width,
                                e1.height
                            ]);
                        }(this, this.style.map.terrain), function(e1, i) {
                            var a = e1.context, r = a.gl, o = e1.transform, s = Qt.unblended, n = new ti(r.LEQUAL, ti.ReadWrite, [
                                0,
                                1
                            ]), l = i.getCoordsTexture(), _$c = i.tileManager.getRenderableTiles(), h = e1.useProgram("terrainCoords");
                            a.bindFramebuffer.set(i.getFramebuffer("coords").framebuffer), a.viewport.set([
                                0,
                                0,
                                e1.width / devicePixelRatio,
                                e1.height / devicePixelRatio
                            ]), a.clear({
                                color: t.bp.transparent,
                                depth: 1
                            }), i.coordsIndex = [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = _$c[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    var _$t = i.getTerrainMesh(_$e.tileID), _$c1 = i.getTerrainData(_$e.tileID);
                                    a.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, l.texture);
                                    var u = {
                                        u_terrain_coords_id: (255 - i.coordsIndex.length) / 255,
                                        u_texture: 0,
                                        u_ele_delta: i.getMeshFrameDelta(o.zoom)
                                    }, d = o.getProjectionData({
                                        overscaledTileID: _$e.tileID,
                                        applyTerrainMatrix: !1,
                                        applyGlobeMatrix: !0
                                    });
                                    h.draw(a, r.TRIANGLES, n, ai.disabled, s, ei.backCCW, u, _$c1, d, "terrain", _$t.vertexBuffer, _$t.indexBuffer, _$t.segments), i.coordsIndex.push(_$e.tileID.key);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            a.bindFramebuffer.set(null), a.viewport.set([
                                0,
                                0,
                                e1.width,
                                e1.height
                            ]);
                        }(this, this.style.map.terrain));
                    }
                },
                {
                    key: "renderLayer",
                    value: function renderLayer(e1, i, a, r, o) {
                        a.isHidden(this.transform.zoom) || ("background" === a.type || "custom" === a.type || (r || []).length) && (this.id = a.id, t.cm(a) ? function(e1, i, a, r, o, s) {
                            if ("translucent" !== e1.renderPass) return;
                            var n = s.isRenderingToTexture, l = ai.disabled, _$c = e1.colorModeForRenderPass();
                            (a._unevaluatedLayout.hasValue("text-variable-anchor") || a._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(e1, i, a, r, o, s, n, l, c) {
                                var h = i.transform, u = i.style.map.terrain, d = "map" === o, _ = "map" === s;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    var _loop = function() {
                                        var _$o = _step.value;
                                        var _$e = r.getTile(_$o), _$s = _$e.getBucket(a);
                                        if (!_$s || !_$s.text || !_$s.text.segments.get().length) return "continue";
                                        var p = t.ay(_$s.textSizeData, h.zoom), m = t.aN(_$e, 1, i.transform.zoom), f = je(d, i.transform, m), g = "none" !== a.layout.get("icon-text-fit") && _$s.hasIconData();
                                        if (p) {
                                            var _$i = Math.pow(2, h.zoom - _$e.tileID.overscaledZ), _$a = u ? function(e1, t) {
                                                return u.getElevation(_$o, e1, t);
                                            } : null;
                                            _r(_$s, d, _, c, h, f, _$i, p, g, t.aO(h, _$e, n, l), _$o.toUnwrapped(), _$a);
                                        }
                                    };
                                    for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }(r, e1, a, i, a.layout.get("text-rotation-alignment"), a.layout.get("text-pitch-alignment"), a.paint.get("text-translate"), a.paint.get("text-translate-anchor"), o), 0 !== a.paint.get("icon-opacity").constantOr(1) && mr(e1, i, a, r, !1, a.paint.get("icon-translate"), a.paint.get("icon-translate-anchor"), a.layout.get("icon-rotation-alignment"), a.layout.get("icon-pitch-alignment"), a.layout.get("icon-keep-upright"), l, _$c, n), 0 !== a.paint.get("text-opacity").constantOr(1) && mr(e1, i, a, r, !0, a.paint.get("text-translate"), a.paint.get("text-translate-anchor"), a.layout.get("text-rotation-alignment"), a.layout.get("text-pitch-alignment"), a.layout.get("text-keep-upright"), l, _$c, n), i.map.showCollisionBoxes && (cr(e1, i, a, r, !0), cr(e1, i, a, r, !1));
                        }(e1, i, a, r, this.style.placement.variableOffsets, o) : t.cn(a) ? function(e1, i, a, r, o) {
                            if ("translucent" !== e1.renderPass) return;
                            var s = o.isRenderingToTexture, n = a.paint.get("circle-opacity"), l = a.paint.get("circle-stroke-width"), _$c = a.paint.get("circle-stroke-opacity"), h = !a.layout.get("circle-sort-key").isConstant();
                            if (0 === n.constantOr(1) && (0 === l.constantOr(1) || 0 === _$c.constantOr(1))) return;
                            var u = e1.context, d = u.gl, _ = e1.transform, p = e1.getDepthModeForSublayer(0, ti.ReadOnly), m = ai.disabled, f = e1.colorModeForRenderPass(), g = [], v = _.getCircleRadiusCorrection();
                            for(var _$o = 0; _$o < r.length; _$o++){
                                var n1 = r[_$o], l1 = i.getTile(n1), _$c1 = l1.getBucket(a);
                                if (!_$c1) continue;
                                var u1 = a.paint.get("circle-translate"), d1 = a.paint.get("circle-translate-anchor"), p1 = t.aO(_, l1, u1, d1), m1 = _$c1.programConfigurations.get(a.id), f1 = e1.useProgram("circle", m1), x = _$c1.layoutVertexBuffer, b = _$c1.indexBuffer, y = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(n1), w = {
                                    programConfiguration: m1,
                                    program: f1,
                                    layoutVertexBuffer: x,
                                    indexBuffer: b,
                                    uniformValues: Hi(e1, l1, a, p1, v),
                                    terrainData: y,
                                    projectionData: _.getProjectionData({
                                        overscaledTileID: n1,
                                        applyGlobeMatrix: !s,
                                        applyTerrainMatrix: !0
                                    })
                                };
                                if (h) {
                                    var _$e = _$c1.segments.get();
                                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                    try {
                                        for(var _iterator = _$e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                            var _$i = _step.value;
                                            g.push({
                                                segments: new t.aX([
                                                    _$i
                                                ]),
                                                sortKey: _$i.sortKey,
                                                state: w
                                            });
                                        }
                                    } catch (err) {
                                        _didIteratorError = true;
                                        _iteratorError = err;
                                    } finally{
                                        try {
                                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                                _iterator.return();
                                            }
                                        } finally{
                                            if (_didIteratorError) {
                                                throw _iteratorError;
                                            }
                                        }
                                    }
                                } else g.push({
                                    segments: _$c1.segments,
                                    sortKey: 0,
                                    state: w
                                });
                            }
                            h && g.sort(function(e1, t) {
                                return e1.sortKey - t.sortKey;
                            });
                            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                            try {
                                for(var _iterator1 = g[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                    var _$t = _step1.value;
                                    var _t_state = _$t.state, _$i1 = _t_state.programConfiguration, _$r = _t_state.program, _$o1 = _t_state.layoutVertexBuffer, s1 = _t_state.indexBuffer, n2 = _t_state.uniformValues, l2 = _t_state.terrainData, _$c2 = _t_state.projectionData;
                                    _$r.draw(u, d.TRIANGLES, p, m, f, ei.backCCW, n2, l2, _$c2, a.id, _$o1, s1, _$t.segments, a.paint, e1.transform.zoom, _$i1);
                                }
                            } catch (err) {
                                _didIteratorError1 = true;
                                _iteratorError1 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError1) {
                                        throw _iteratorError1;
                                    }
                                }
                            }
                        }(e1, i, a, r, o) : t.co(a) ? function(e1, i, a, r, o) {
                            if (0 === a.paint.get("heatmap-opacity")) return;
                            var s = e1.context, n = o.isRenderingToTexture, l = o.isRenderingGlobe;
                            if (e1.style.map.terrain) {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = r[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$t = _step.value;
                                        var _$r = i.getTile(_$t);
                                        i.hasRenderableParent(_$t) || ("offscreen" === e1.renderPass ? gr(e1, _$r, a, _$t, l) : "translucent" === e1.renderPass && vr(e1, a, _$t, n, l));
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                s.viewport.set([
                                    0,
                                    0,
                                    e1.width,
                                    e1.height
                                ]);
                            } else "offscreen" === e1.renderPass ? function(e1, i, a, r) {
                                var _$o = e1.context, s = _$o.gl, n = e1.transform, l = ai.disabled, _$c = new Qt([
                                    s.ONE,
                                    s.ONE
                                ], t.bp.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                (function(e1, i, a) {
                                    var _$r = e1.gl;
                                    e1.activeTexture.set(_$r.TEXTURE1), e1.viewport.set([
                                        0,
                                        0,
                                        i.width / 4,
                                        i.height / 4
                                    ]);
                                    var _$o = a.heatmapFbos.get(t.cd);
                                    _$o ? (_$r.bindTexture(_$r.TEXTURE_2D, _$o.colorAttachment.get()), e1.bindFramebuffer.set(_$o.framebuffer)) : (_$o = xr(e1, i.width / 4, i.height / 4), a.heatmapFbos.set(t.cd, _$o));
                                })(_$o, e1, a), _$o.clear({
                                    color: t.bp.transparent
                                });
                                for(var _$t = 0; _$t < r.length; _$t++){
                                    var h = r[_$t];
                                    if (i.hasRenderableParent(h)) continue;
                                    var u = i.getTile(h), d = u.getBucket(a);
                                    if (!d) continue;
                                    var _ = d.programConfigurations.get(a.id), p = e1.useProgram("heatmap", _), m = n.getProjectionData({
                                        overscaledTileID: h,
                                        applyGlobeMatrix: !0,
                                        applyTerrainMatrix: !1
                                    }), f = n.getCircleRadiusCorrection();
                                    p.draw(_$o, s.TRIANGLES, ti.disabled, l, _$c, ei.backCCW, Qi(u, n.zoom, a.paint.get("heatmap-intensity"), f), null, m, a.id, d.layoutVertexBuffer, d.indexBuffer, d.segments, a.paint, n.zoom, _);
                                }
                                _$o.viewport.set([
                                    0,
                                    0,
                                    e1.width,
                                    e1.height
                                ]);
                            }(e1, i, a, r) : "translucent" === e1.renderPass && function(e1, i) {
                                var _$a = e1.context, _$r = _$a.gl;
                                _$a.setColorMode(e1.colorModeForRenderPass());
                                var _$o = i.heatmapFbos.get(t.cd);
                                _$o && (_$a.activeTexture.set(_$r.TEXTURE0), _$r.bindTexture(_$r.TEXTURE_2D, _$o.colorAttachment.get()), _$a.activeTexture.set(_$r.TEXTURE1), br(_$a, i).bind(_$r.LINEAR, _$r.CLAMP_TO_EDGE), e1.useProgram("heatmapTexture").draw(_$a, _$r.TRIANGLES, ti.disabled, ai.disabled, e1.colorModeForRenderPass(), ei.disabled, Ji(e1, i, 0, 1), null, null, i.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, i.paint, e1.transform.zoom));
                            }(e1, a);
                        }(e1, i, a, r, o) : t.cp(a) ? function(e1, t, i, a, r) {
                            if ("translucent" !== e1.renderPass) return;
                            var _$o = r.isRenderingToTexture, s = i.paint.get("line-opacity"), n = i.paint.get("line-width");
                            if (0 === s.constantOr(1) || 0 === n.constantOr(1)) return;
                            var l = e1.getDepthModeForSublayer(0, ti.ReadOnly), _$c = e1.colorModeForRenderPass(), h = i.paint.get("line-dasharray"), u = h.constantOr(1), d = i.paint.get("line-pattern"), _ = d.constantOr(1), p = i.paint.get("line-gradient"), m = i.getCrossfadeParameters();
                            var f;
                            f = _ ? "linePattern" : u && p ? "lineGradientSDF" : u ? "lineSDF" : p ? "lineGradient" : "line";
                            var g = e1.context, v = g.gl, x = e1.transform;
                            var b = !0;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$r = _step.value;
                                    var _$a = t.getTile(_$r);
                                    if (_ && !_$a.patternsLoaded()) continue;
                                    var s1 = _$a.getBucket(i);
                                    if (!s1) continue;
                                    var n1 = s1.programConfigurations.get(i.id), y = e1.context.program.get(), w = e1.useProgram(f, n1), T = b || w.program !== y, P = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(_$r), C = d.constantOr(null), I = h && h.constantOr(null);
                                    if (C && _$a.imageAtlas) {
                                        var _$e = _$a.imageAtlas, _$t = _$e.patternPositions[C.to.toString()], _$i = _$e.patternPositions[C.from.toString()];
                                        _$t && _$i && n1.setConstantPatternPositions(_$t, _$i);
                                    } else if (I) {
                                        var _$t1 = "round" === i.layout.get("line-cap"), _$a1 = e1.lineAtlas.getDash(I.to, _$t1), _$r1 = e1.lineAtlas.getDash(I.from, _$t1);
                                        n1.setConstantDashPositions(_$a1, _$r1);
                                    }
                                    var M = x.getProjectionData({
                                        overscaledTileID: _$r,
                                        applyGlobeMatrix: !_$o,
                                        applyTerrainMatrix: !0
                                    }), E = x.getPixelScale();
                                    var S = void 0;
                                    _ ? (S = sa(e1, _$a, i, E, m), wr(g, v, _$a, n1, m)) : u && p ? (S = la(e1, _$a, i, E, m, s1.lineClipsArray.length), Cr(e1, t, g, v, i, s1, _$r, n1, m)) : u ? (S = na(e1, _$a, i, E, m), Tr(e1, g, v, n1, T, m)) : p ? (S = oa(e1, _$a, i, E, s1.lineClipsArray.length), Pr(e1, t, g, v, i, s1, _$r)) : S = ra(e1, _$a, i, E);
                                    var R = e1.stencilModeForClipping(_$r);
                                    w.draw(g, v.TRIANGLES, l, R, _$c, ei.disabled, S, P, M, i.id, s1.layoutVertexBuffer, s1.indexBuffer, s1.segments, i.paint, e1.transform.zoom, n1, s1.layoutVertexBuffer2), b = !1;
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }(e1, i, a, r, o) : t.cq(a) ? function(e1, i, a, r, o) {
                            var s = a.paint.get("fill-color"), n = a.paint.get("fill-opacity");
                            if (0 === n.constantOr(1)) return;
                            var l = o.isRenderingToTexture, _$c = e1.colorModeForRenderPass(), h = a.paint.get("fill-pattern"), u = e1.opaquePassEnabledForLayer() && !h.constantOr(1) && 1 === s.constantOr(t.bp.transparent).a && 1 === n.constantOr(0) ? "opaque" : "translucent";
                            if (e1.renderPass === u) {
                                var _$t = e1.getDepthModeForSublayer(1, "opaque" === e1.renderPass ? ti.ReadWrite : ti.ReadOnly);
                                Mr(e1, i, a, r, _$t, _$c, !1, l);
                            }
                            if ("translucent" === e1.renderPass && a.paint.get("fill-antialias")) {
                                var _$t1 = e1.getDepthModeForSublayer(a.getPaintProperty("fill-outline-color") ? 2 : 0, ti.ReadOnly);
                                Mr(e1, i, a, r, _$t1, _$c, !0, l);
                            }
                        }(e1, i, a, r, o) : t.cr(a) ? function(e1, t, i, a, r) {
                            var _$o = i.paint.get("fill-extrusion-opacity");
                            if (0 === _$o) return;
                            var s = r.isRenderingToTexture;
                            if ("translucent" === e1.renderPass) {
                                var _$r = new ti(e1.context.gl.LEQUAL, ti.ReadWrite, e1.depthRangeFor3D);
                                if (1 !== _$o || i.paint.get("fill-extrusion-pattern").constantOr(1)) Er(e1, t, i, a, _$r, ai.disabled, Qt.disabled, s), Er(e1, t, i, a, _$r, e1.stencilModeFor3D(), e1.colorModeForRenderPass(), s);
                                else {
                                    var _$o1 = e1.colorModeForRenderPass();
                                    Er(e1, t, i, a, _$r, ai.disabled, _$o1, s);
                                }
                            }
                        }(e1, i, a, r, o) : t.cs(a) ? function(e1, i, a, r, o) {
                            if ("offscreen" !== e1.renderPass && "translucent" !== e1.renderPass) return;
                            var s = o.isRenderingToTexture, n = e1.context, l = e1.style.projection.useSubdivision, _$c = e1.getDepthModeForSublayer(0, ti.ReadOnly), h = e1.colorModeForRenderPass();
                            if ("offscreen" === e1.renderPass) !function(e1, i, a, r, o, s, n) {
                                var l = e1.context, _$c = l.gl;
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = a[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var h = _step.value;
                                        var _$a = i.getTile(h), u = _$a.dem;
                                        if (!u || !u.data) continue;
                                        if (!_$a.needsHillshadePrepare) continue;
                                        var d = u.dim, _ = u.stride, p = u.getPixels();
                                        if (l.activeTexture.set(_$c.TEXTURE1), l.pixelStoreUnpackPremultiplyAlpha.set(!1), _$a.demTexture = _$a.demTexture || e1.getTileTexture(_), _$a.demTexture) {
                                            var _$e = _$a.demTexture;
                                            _$e.update(p, {
                                                premultiply: !1
                                            }), _$e.bind(_$c.NEAREST, _$c.CLAMP_TO_EDGE);
                                        } else _$a.demTexture = new t.T(l, p, _$c.RGBA, {
                                            premultiply: !1
                                        }), _$a.demTexture.bind(_$c.NEAREST, _$c.CLAMP_TO_EDGE);
                                        l.activeTexture.set(_$c.TEXTURE0);
                                        var m = _$a.fbo;
                                        if (!m) {
                                            var _$e1 = new t.T(l, {
                                                width: d,
                                                height: d,
                                                data: null
                                            }, _$c.RGBA);
                                            _$e1.bind(_$c.LINEAR, _$c.CLAMP_TO_EDGE), m = _$a.fbo = l.createFramebuffer(d, d, !0, !1), m.colorAttachment.set(_$e1.texture);
                                        }
                                        l.bindFramebuffer.set(m.framebuffer), l.viewport.set([
                                            0,
                                            0,
                                            d,
                                            d
                                        ]), e1.useProgram("hillshadePrepare").draw(l, _$c.TRIANGLES, o, s, n, ei.disabled, ta(_$a.tileID, u), null, null, r.id, e1.rasterBoundsBuffer, e1.quadTriangleIndexBuffer, e1.rasterBoundsSegments), _$a.needsHillshadePrepare = !1;
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }(e1, i, r, a, _$c, ai.disabled, h), n.viewport.set([
                                0,
                                0,
                                e1.width,
                                e1.height
                            ]);
                            else if ("translucent" === e1.renderPass) {
                                if (l) {
                                    var _e_stencilConfigForOverlapTwoPass = (0, $db95b225ee8036d6$export$71511d61b312f219)(e1.stencilConfigForOverlapTwoPass(r), 3), _$t = _e_stencilConfigForOverlapTwoPass[0], _$o = _e_stencilConfigForOverlapTwoPass[1], n1 = _e_stencilConfigForOverlapTwoPass[2];
                                    Sr(e1, i, a, n1, _$t, _$c, h, !1, s), Sr(e1, i, a, n1, _$o, _$c, h, !0, s);
                                } else {
                                    var _e_getStencilConfigForOverlapAndUpdateStencilID = (0, $db95b225ee8036d6$export$71511d61b312f219)(e1.getStencilConfigForOverlapAndUpdateStencilID(r), 2), _$t1 = _e_getStencilConfigForOverlapAndUpdateStencilID[0], _$o1 = _e_getStencilConfigForOverlapAndUpdateStencilID[1];
                                    Sr(e1, i, a, _$o1, _$t1, _$c, h, !1, s);
                                }
                            }
                        }(e1, i, a, r, o) : t.ct(a) ? function(e1, t, i, a, r) {
                            if ("translucent" !== e1.renderPass) return;
                            if (!a.length) return;
                            var _$o = r.isRenderingToTexture, s = e1.style.projection.useSubdivision, n = e1.getDepthModeForSublayer(0, ti.ReadOnly), l = e1.colorModeForRenderPass();
                            if (s) {
                                var _e_stencilConfigForOverlapTwoPass = (0, $db95b225ee8036d6$export$71511d61b312f219)(e1.stencilConfigForOverlapTwoPass(a), 3), _$r = _e_stencilConfigForOverlapTwoPass[0], s1 = _e_stencilConfigForOverlapTwoPass[1], _$c = _e_stencilConfigForOverlapTwoPass[2];
                                Rr(e1, t, i, _$c, _$r, n, l, !1, _$o), Rr(e1, t, i, _$c, s1, n, l, !0, _$o);
                            } else {
                                var _e_getStencilConfigForOverlapAndUpdateStencilID = (0, $db95b225ee8036d6$export$71511d61b312f219)(e1.getStencilConfigForOverlapAndUpdateStencilID(a), 2), _$r1 = _e_getStencilConfigForOverlapAndUpdateStencilID[0], s2 = _e_getStencilConfigForOverlapAndUpdateStencilID[1];
                                Rr(e1, t, i, s2, _$r1, n, l, !1, _$o);
                            }
                        }(e1, i, a, r, o) : t.bU(a) ? function(e1, t, i, a, r) {
                            if ("translucent" !== e1.renderPass) return;
                            if (0 === i.paint.get("raster-opacity")) return;
                            if (!a.length) return;
                            var _$o = r.isRenderingToTexture, s = t.getSource(), n = e1.style.projection.useSubdivision;
                            if (s instanceof te) Dr(e1, t, i, a, null, !1, !1, s.tileCoords, s.flippedWindingOrder, _$o);
                            else if (n) {
                                var _e_stencilConfigForOverlapTwoPass = (0, $db95b225ee8036d6$export$71511d61b312f219)(e1.stencilConfigForOverlapTwoPass(a), 3), _$r = _e_stencilConfigForOverlapTwoPass[0], s1 = _e_stencilConfigForOverlapTwoPass[1], n1 = _e_stencilConfigForOverlapTwoPass[2];
                                Dr(e1, t, i, n1, _$r, !1, !0, zr, !1, _$o), Dr(e1, t, i, n1, s1, !0, !0, zr, !1, _$o);
                            } else {
                                var _e_getStencilConfigForOverlapAndUpdateStencilID = (0, $db95b225ee8036d6$export$71511d61b312f219)(e1.getStencilConfigForOverlapAndUpdateStencilID(a), 2), _$r1 = _e_getStencilConfigForOverlapAndUpdateStencilID[0], s2 = _e_getStencilConfigForOverlapAndUpdateStencilID[1];
                                Dr(e1, t, i, s2, _$r1, !1, !0, zr, !1, _$o);
                            }
                        }(e1, i, a, r, o) : t.cu(a) ? function(e1, t, i, a, r) {
                            var _$o = i.paint.get("background-color"), s = i.paint.get("background-opacity");
                            if (0 === s) return;
                            var n = r.isRenderingToTexture, l = e1.context, _$c = l.gl, h = e1.style.projection, u = e1.transform, d = u.tileSize, _ = i.paint.get("background-pattern");
                            if (e1.isPatternMissing(_)) return;
                            var p = !_ && 1 === _$o.a && 1 === s && e1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                            if (e1.renderPass !== p) return;
                            var m = ai.disabled, f = e1.getDepthModeForSublayer(0, "opaque" === p ? ti.ReadWrite : ti.ReadOnly), g = e1.colorModeForRenderPass(), v = e1.useProgram(_ ? "backgroundPattern" : "background"), x = a || Ie(u, {
                                tileSize: d,
                                terrain: e1.style.map.terrain
                            });
                            _ && (l.activeTexture.set(_$c.TEXTURE0), e1.imageManager.bind(e1.context));
                            var b = i.getCrossfadeParameters();
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = x[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step.value;
                                    var _$a = u.getProjectionData({
                                        overscaledTileID: _$t,
                                        applyGlobeMatrix: !n,
                                        applyTerrainMatrix: !0
                                    }), _$r = _ ? ga(s, e1, _, {
                                        tileID: _$t,
                                        tileSize: d
                                    }, b) : fa(s, _$o), p1 = e1.style.map.terrain && e1.style.map.terrain.getTerrainData(_$t), x1 = h.getMeshFromTileID(l, _$t.canonical, !1, !0, "raster");
                                    v.draw(l, _$c.TRIANGLES, f, m, g, ei.backCCW, _$r, p1, _$a, i.id, x1.vertexBuffer, x1.indexBuffer, x1.segments);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }(e1, 0, a, r, o) : t.cv(a) && function(e1, t, i, a) {
                            var _$r = a.isRenderingGlobe, _$o = e1.context, s = i.implementation, n = e1.style.projection, l = e1.transform, _$c = l.getProjectionDataForCustomLayer(_$r), h = {
                                farZ: l.farZ,
                                nearZ: l.nearZ,
                                fov: l.fov * Math.PI / 180,
                                modelViewProjectionMatrix: l.modelViewProjectionMatrix,
                                projectionMatrix: l.projectionMatrix,
                                shaderData: {
                                    variantName: n.shaderVariantName,
                                    vertexShaderPrelude: "const float PI = 3.141592653589793;\nuniform mat4 u_projection_matrix;\n".concat(n.shaderPreludeCode.vertexSource),
                                    define: n.shaderDefine
                                },
                                defaultProjectionData: _$c
                            }, u = s.renderingMode ? s.renderingMode : "2d";
                            if ("offscreen" === e1.renderPass) {
                                var _$t = s.prerender;
                                _$t && (e1.setCustomLayerDefaults(), _$o.setColorMode(e1.colorModeForRenderPass()), _$t.call(s, _$o.gl, h), _$o.setDirty(), e1.setBaseState());
                            } else if ("translucent" === e1.renderPass) {
                                e1.setCustomLayerDefaults(), _$o.setColorMode(e1.colorModeForRenderPass()), _$o.setStencilMode(ai.disabled);
                                var _$t1 = "3d" === u ? e1.getDepthModeFor3D() : e1.getDepthModeForSublayer(0, ti.ReadOnly);
                                _$o.setDepthMode(_$t1), s.render(_$o.gl, h), _$o.setDirty(), e1.setBaseState(), _$o.bindFramebuffer.set(null);
                            }
                        }(e1, 0, a, o));
                    }
                },
                {
                    key: "saveTileTexture",
                    value: function saveTileTexture(e1) {
                        var _$t = this._tileTextures[e1.size[0]];
                        _$t ? _$t.push(e1) : this._tileTextures[e1.size[0]] = [
                            e1
                        ];
                    }
                },
                {
                    key: "getTileTexture",
                    value: function getTileTexture(e1) {
                        var _$t = this._tileTextures[e1];
                        return _$t && _$t.length > 0 ? _$t.pop() : null;
                    }
                },
                {
                    key: "isPatternMissing",
                    value: function isPatternMissing(e1) {
                        if (!e1) return !1;
                        if (!e1.from || !e1.to) return !0;
                        var _$t = this.imageManager.getPattern(e1.from.toString()), i = this.imageManager.getPattern(e1.to.toString());
                        return !_$t || !i;
                    }
                },
                {
                    key: "useProgram",
                    value: function useProgram(e1, t) {
                        var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1, a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
                        this.cache = this.cache || {};
                        var r = !!this.style.map.terrain, o = this.style.projection, s = i ? At.projectionMercator : o.shaderPreludeCode, n = i ? Bt : o.shaderDefine, l = e1 + (t ? t.cacheKey : "") + "/".concat(i ? Ot : o.shaderVariantName) + (this._showOverdrawInspector ? "/overdraw" : "") + (r ? "/terrain" : "") + (a ? "/".concat(a.join("/")) : "");
                        return this.cache[l] || (this.cache[l] = new Zi(this.context, At[e1], t, xa[e1], this._showOverdrawInspector, r, s, n, a)), this.cache[l];
                    }
                },
                {
                    key: "setCustomLayerDefaults",
                    value: function setCustomLayerDefaults() {
                        this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
                    }
                },
                {
                    key: "setBaseState",
                    value: function setBaseState() {
                        var _$e = this.context.gl;
                        this.context.cullFace.set(!1), this.context.viewport.set([
                            0,
                            0,
                            this.width,
                            this.height
                        ]), this.context.blendEquation.set(_$e.FUNC_ADD);
                    }
                },
                {
                    key: "initDebugOverlayCanvas",
                    value: function initDebugOverlayCanvas() {
                        null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new t.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
                    }
                },
                {
                    key: "destroy",
                    value: function destroy() {
                        var _$e, _$t;
                        if (this._tileTextures) {
                            for(var _$e1 in this._tileTextures){
                                var _$t1 = this._tileTextures[_$e1];
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (_$t1) try {
                                    for(var _iterator = _$t1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var _$e2 = _step.value;
                                        _$e2.destroy();
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                            }
                            this._tileTextures = {};
                        }
                        if (this.tileExtentBuffer && this.tileExtentBuffer.destroy(), this.debugBuffer && this.debugBuffer.destroy(), this.rasterBoundsBuffer && this.rasterBoundsBuffer.destroy(), this.rasterBoundsBufferPosOnly && this.rasterBoundsBufferPosOnly.destroy(), this.viewportBuffer && this.viewportBuffer.destroy(), this.tileBorderIndexBuffer && this.tileBorderIndexBuffer.destroy(), this.quadTriangleIndexBuffer && this.quadTriangleIndexBuffer.destroy(), this.tileExtentMesh && (null === (_$e = this.tileExtentMesh.vertexBuffer) || void 0 === _$e || _$e.destroy()), this.tileExtentMesh && (null === (_$t = this.tileExtentMesh.indexBuffer) || void 0 === _$t || _$t.destroy()), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this.cache) {
                            for(var _$e3 in this.cache){
                                var _$t2 = this.cache[_$e3];
                                _$t2 && _$t2.program && this.context.gl.deleteProgram(_$t2.program);
                            }
                            this.cache = {};
                        }
                        this.context && this.context.setDefault();
                    }
                },
                {
                    key: "overLimit",
                    value: function overLimit() {
                        var _this_context_gl = this.context.gl, _$e = _this_context_gl.drawingBufferWidth, _$t = _this_context_gl.drawingBufferHeight;
                        return this.width !== _$e || this.height !== _$t;
                    }
                }
            ]);
            return qr;
        }();
        function Wr(e1, t) {
            var _this = this;
            var i, a = !1, r = null, o = null;
            var s = function() {
                r = null, a && (e1.apply(o, i), r = setTimeout(s, t), a = !1);
            };
            return function() {
                for(var _len = arguments.length, _$e = new Array(_len), _key = 0; _key < _len; _key++){
                    _$e[_key] = arguments[_key];
                }
                return a = !0, o = _this, i = _$e, r || s(), r;
            };
        }
        var $r = /*#__PURE__*/ function() {
            function $r(e1) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, $r);
                this._getCurrentHash = function() {
                    var _$e = window.location.hash.replace("#", "");
                    if (_this._hashName) {
                        var _$t;
                        return _$e.split("&").map(function(e1) {
                            return e1.split("=");
                        }).forEach(function(e1) {
                            e1[0] === _this._hashName && (_$t = e1);
                        }), (_$t && _$t[1] || "").split("/");
                    }
                    return _$e.split("/");
                }, this._onHashChange = function() {
                    var _$e = _this._getCurrentHash();
                    if (!_this._isValidHash(_$e)) return !1;
                    var _$t = _this._map.dragRotate.isEnabled() && _this._map.touchZoomRotate.isEnabled() ? +(_$e[3] || 0) : _this._map.getBearing();
                    return _this._map.jumpTo({
                        center: [
                            +_$e[2],
                            +_$e[1]
                        ],
                        zoom: +_$e[0],
                        bearing: _$t,
                        pitch: +(_$e[4] || 0)
                    }), !0;
                }, this._updateHashUnthrottled = function() {
                    var _$e = window.location.href.replace(/(#.*)?$/, _this.getHashString());
                    window.history.replaceState(window.history.state, null, _$e);
                }, this._removeHash = function() {
                    var _$e = _this._getCurrentHash();
                    if (0 === _$e.length) return;
                    var _$t = _$e.join("/");
                    var i = _$t;
                    i.split("&").length > 0 && (i = i.split("&")[0]), _this._hashName && (i = "".concat(_this._hashName, "=").concat(_$t));
                    var a = window.location.hash.replace(i, "");
                    a.startsWith("#&") ? a = a.slice(0, 1) + a.slice(2) : "#" === a && (a = "");
                    var r = window.location.href.replace(/(#.+)?$/, a);
                    r = r.replace("&&", "&"), window.history.replaceState(window.history.state, null, r);
                }, this._updateHash = Wr(this._updateHashUnthrottled, 300), this._hashName = e1 && encodeURIComponent(e1);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)($r, [
                {
                    key: "addTo",
                    value: function addTo(e1) {
                        return this._map = e1, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
                    }
                },
                {
                    key: "remove",
                    value: function remove() {
                        return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
                    }
                },
                {
                    key: "getHashString",
                    value: function getHashString(e1) {
                        var _$t = this._map.getCenter(), i = Math.round(100 * this._map.getZoom()) / 100, a = Math.ceil((i * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), r = Math.pow(10, a), o = Math.round(_$t.lng * r) / r, s = Math.round(_$t.lat * r) / r, n = this._map.getBearing(), l = this._map.getPitch();
                        var _$c = "";
                        if (_$c += e1 ? "/".concat(o, "/").concat(s, "/").concat(i) : "".concat(i, "/").concat(s, "/").concat(o), (n || l) && (_$c += "/" + Math.round(10 * n) / 10), l && (_$c += "/".concat(Math.round(l))), this._hashName) {
                            var _$e = this._hashName;
                            var _$t1 = !1;
                            var i1 = window.location.hash.slice(1).split("&").map(function(i) {
                                var a = i.split("=")[0];
                                return a === _$e ? (_$t1 = !0, "".concat(a, "=").concat(_$c)) : i;
                            }).filter(function(e1) {
                                return e1;
                            });
                            return _$t1 || i1.push("".concat(_$e, "=").concat(_$c)), "#".concat(i1.join("&"));
                        }
                        return "#".concat(_$c);
                    }
                },
                {
                    key: "_isValidHash",
                    value: function _isValidHash(e1) {
                        if (e1.length < 3 || e1.some(isNaN)) return !1;
                        try {
                            new t.V(+e1[2], +e1[1]);
                        } catch (e1) {
                            return !1;
                        }
                        var i = +e1[0], a = +(e1[3] || 0), r = +(e1[4] || 0);
                        return i >= this._map.getMinZoom() && i <= this._map.getMaxZoom() && a >= -180 && a <= 180 && r >= this._map.getMinPitch() && r <= this._map.getMaxPitch();
                    }
                }
            ]);
            return $r;
        }();
        var Hr = {
            linearity: .3,
            easing: t.cw(0, 0, .3, 1)
        }, Xr = t.e({
            deceleration: 2500,
            maxSpeed: 1400
        }, Hr), Kr = t.e({
            deceleration: 20,
            maxSpeed: 1400
        }, Hr), Yr = t.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, Hr), Qr = t.e({
            deceleration: 1e3,
            maxSpeed: 90
        }, Hr), Jr = t.e({
            deceleration: 1e3,
            maxSpeed: 360
        }, Hr);
        var eo = /*#__PURE__*/ function() {
            function eo(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, eo);
                this._map = e1, this.clear();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(eo, [
                {
                    key: "clear",
                    value: function clear() {
                        this._inertiaBuffer = [];
                    }
                },
                {
                    key: "record",
                    value: function record(e1) {
                        this._drainInertiaBuffer(), this._inertiaBuffer.push({
                            time: c(),
                            settings: e1
                        });
                    }
                },
                {
                    key: "_drainInertiaBuffer",
                    value: function _drainInertiaBuffer() {
                        var _$e = this._inertiaBuffer, _$t = c();
                        for(; _$e.length > 0 && _$t - _$e[0].time > 160;)_$e.shift();
                    }
                },
                {
                    key: "_onMoveEnd",
                    value: function _onMoveEnd(e1) {
                        if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                        var i = {
                            zoom: 0,
                            bearing: 0,
                            pitch: 0,
                            roll: 0,
                            pan: new t.P(0, 0),
                            pinchAround: void 0,
                            around: void 0
                        };
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._inertiaBuffer[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, _$e = _step_value.settings;
                                i.zoom += _$e.zoomDelta || 0, i.bearing += _$e.bearingDelta || 0, i.pitch += _$e.pitchDelta || 0, i.roll += _$e.rollDelta || 0, _$e.panDelta && i.pan._add(_$e.panDelta), _$e.around && (i.around = _$e.around), _$e.pinchAround && (i.pinchAround = _$e.pinchAround);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        var a = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r = {};
                        if (i.pan.mag()) {
                            var o = io(i.pan.mag(), a, t.e({}, Xr, e1 || {})), s = i.pan.mult(o.amount / i.pan.mag()), n = this._map.cameraHelper.handlePanInertia(s, this._map.transform);
                            r.center = n.easingCenter, r.offset = n.easingOffset, to(r, o);
                        }
                        if (i.zoom) {
                            var _$e1 = io(i.zoom, a, Kr);
                            r.zoom = this._map.transform.zoom + _$e1.amount, to(r, _$e1);
                        }
                        if (i.bearing) {
                            var _$e2 = io(i.bearing, a, Yr);
                            r.bearing = this._map.transform.bearing + t.an(_$e2.amount, -179, 179), to(r, _$e2);
                        }
                        if (i.pitch) {
                            var _$e3 = io(i.pitch, a, Qr);
                            r.pitch = this._map.transform.pitch + _$e3.amount, to(r, _$e3);
                        }
                        if (i.roll) {
                            var _$e4 = io(i.roll, a, Jr);
                            r.roll = this._map.transform.roll + t.an(_$e4.amount, -179, 179), to(r, _$e4);
                        }
                        if (r.zoom || r.bearing) {
                            var _$e5 = void 0 === i.pinchAround ? i.around : i.pinchAround;
                            r.around = _$e5 ? this._map.unproject(_$e5) : this._map.getCenter();
                        }
                        return this.clear(), t.e(r, {
                            noMoveStart: !0
                        });
                    }
                }
            ]);
            return eo;
        }();
        function to(e1, t) {
            (!e1.duration || e1.duration < t.duration) && (e1.duration = t.duration, e1.easing = t.easing);
        }
        function io(e1, i, a) {
            var r = a.maxSpeed, o = a.linearity, s = a.deceleration, n = t.an(e1 * o / (i / 1e3), -r, r), l = Math.abs(n) / (s * o);
            return {
                easing: a.easing,
                duration: 1e3 * l,
                amount: n * (l / 2)
            };
        }
        var ao = /*#__PURE__*/ function(_t_l) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ao, _t_l);
            function ao(e1, i, a) {
                var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ao);
                var _this;
                a = a instanceof MouseEvent ? a : new MouseEvent(e1, a);
                var o = h.mousePos(i.getCanvas(), a), s = i.unproject(o);
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ao, [
                    e1,
                    t.e({
                        point: o,
                        lngLat: s,
                        originalEvent: a
                    }, r)
                ]), _this._defaultPrevented = !1, _this.target = i;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ao, [
                {
                    key: "preventDefault",
                    value: function preventDefault() {
                        this._defaultPrevented = !0;
                    }
                },
                {
                    key: "defaultPrevented",
                    get: function get() {
                        return this._defaultPrevented;
                    }
                }
            ]);
            return ao;
        }(t.l);
        var ro = /*#__PURE__*/ function(_t_l) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ro, _t_l);
            function ro(e1, i, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ro);
                var _this;
                var r = "touchend" === e1 ? a.changedTouches : a.touches, o = h.touchPos(i.getCanvasContainer(), r), s = o.map(function(e1) {
                    return i.unproject(e1);
                }), n = o.reduce(function(e1, t, i, a) {
                    return e1.add(t.div(a.length));
                }, new t.P(0, 0));
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ro, [
                    e1,
                    {
                        points: o,
                        point: n,
                        lngLats: s,
                        lngLat: i.unproject(n),
                        originalEvent: a
                    }
                ]), _this._defaultPrevented = !1;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ro, [
                {
                    key: "preventDefault",
                    value: function preventDefault() {
                        this._defaultPrevented = !0;
                    }
                },
                {
                    key: "defaultPrevented",
                    get: function get() {
                        return this._defaultPrevented;
                    }
                }
            ]);
            return ro;
        }(t.l);
        var oo = /*#__PURE__*/ function(_t_l) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(oo, _t_l);
            function oo(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, oo);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, oo, [
                    e1,
                    {
                        originalEvent: i
                    }
                ]), _this._defaultPrevented = !1;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(oo, [
                {
                    key: "preventDefault",
                    value: function preventDefault() {
                        this._defaultPrevented = !0;
                    }
                },
                {
                    key: "defaultPrevented",
                    get: function get() {
                        return this._defaultPrevented;
                    }
                }
            ]);
            return oo;
        }(t.l);
        var so = /*#__PURE__*/ function() {
            function so(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, so);
                this._map = e1, this._clickTolerance = t.clickTolerance;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(so, [
                {
                    key: "reset",
                    value: function reset() {
                        delete this._mousedownPos;
                    }
                },
                {
                    key: "wheel",
                    value: function wheel(e1) {
                        return this._firePreventable(new oo(e1.type, this._map, e1));
                    }
                },
                {
                    key: "mousedown",
                    value: function mousedown(e1, t) {
                        return this._mousedownPos = t, this._firePreventable(new ao(e1.type, this._map, e1));
                    }
                },
                {
                    key: "mouseup",
                    value: function mouseup(e1) {
                        this._map.fire(new ao(e1.type, this._map, e1));
                    }
                },
                {
                    key: "click",
                    value: function click(e1, t) {
                        this._mousedownPos && this._mousedownPos.dist(t) >= this._clickTolerance || this._map.fire(new ao(e1.type, this._map, e1));
                    }
                },
                {
                    key: "dblclick",
                    value: function dblclick(e1) {
                        return this._firePreventable(new ao(e1.type, this._map, e1));
                    }
                },
                {
                    key: "mouseover",
                    value: function mouseover(e1) {
                        this._map.fire(new ao(e1.type, this._map, e1));
                    }
                },
                {
                    key: "mouseout",
                    value: function mouseout(e1) {
                        this._map.fire(new ao(e1.type, this._map, e1));
                    }
                },
                {
                    key: "touchstart",
                    value: function touchstart(e1) {
                        return this._firePreventable(new ro(e1.type, this._map, e1));
                    }
                },
                {
                    key: "touchmove",
                    value: function touchmove(e1) {
                        this._map.fire(new ro(e1.type, this._map, e1));
                    }
                },
                {
                    key: "touchend",
                    value: function touchend(e1) {
                        this._map.fire(new ro(e1.type, this._map, e1));
                    }
                },
                {
                    key: "touchcancel",
                    value: function touchcancel(e1) {
                        this._map.fire(new ro(e1.type, this._map, e1));
                    }
                },
                {
                    key: "_firePreventable",
                    value: function _firePreventable(e1) {
                        if (this._map.fire(e1), e1.defaultPrevented) return {};
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return !0;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return !1;
                    }
                },
                {
                    key: "enable",
                    value: function enable() {}
                },
                {
                    key: "disable",
                    value: function disable() {}
                }
            ]);
            return so;
        }();
        var no = /*#__PURE__*/ function() {
            function no(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, no);
                this._map = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(no, [
                {
                    key: "reset",
                    value: function reset() {
                        this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
                    }
                },
                {
                    key: "mousemove",
                    value: function mousemove(e1) {
                        this._map.fire(new ao(e1.type, this._map, e1));
                    }
                },
                {
                    key: "mousedown",
                    value: function mousedown() {
                        this._delayContextMenu = !0, this._ignoreContextMenu = !1;
                    }
                },
                {
                    key: "mouseup",
                    value: function mouseup() {
                        this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new ao("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
                    }
                },
                {
                    key: "contextmenu",
                    value: function contextmenu(e1) {
                        this._delayContextMenu ? this._contextMenuEvent = e1 : this._ignoreContextMenu || this._map.fire(new ao(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return !0;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return !1;
                    }
                },
                {
                    key: "enable",
                    value: function enable() {}
                },
                {
                    key: "disable",
                    value: function disable() {}
                }
            ]);
            return no;
        }();
        var lo = /*#__PURE__*/ function() {
            function lo(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, lo);
                this._map = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(lo, [
                {
                    key: "transform",
                    get: function get() {
                        return this._map._requestedCameraState || this._map.transform;
                    }
                },
                {
                    key: "center",
                    get: function get() {
                        return {
                            lng: this.transform.center.lng,
                            lat: this.transform.center.lat
                        };
                    }
                },
                {
                    key: "zoom",
                    get: function get() {
                        return this.transform.zoom;
                    }
                },
                {
                    key: "pitch",
                    get: function get() {
                        return this.transform.pitch;
                    }
                },
                {
                    key: "bearing",
                    get: function get() {
                        return this.transform.bearing;
                    }
                },
                {
                    key: "unproject",
                    value: function unproject(e1) {
                        return this.transform.screenPointToLocation(t.P.convert(e1), this._map.terrain);
                    }
                }
            ]);
            return lo;
        }();
        var co = /*#__PURE__*/ function() {
            function co(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, co);
                this._map = e1, this._tr = new lo(e1), this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t.clickTolerance || 1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(co, [
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return !!this._enabled;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return !!this._active;
                    }
                },
                {
                    key: "enable",
                    value: function enable() {
                        this.isEnabled() || (this._enabled = !0);
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this.isEnabled() && (this._enabled = !1);
                    }
                },
                {
                    key: "mousedown",
                    value: function mousedown(e1, t) {
                        this.isEnabled() && e1.shiftKey && 0 === e1.button && (h.disableDrag(), this._startPos = this._lastPos = t, this._active = !0);
                    }
                },
                {
                    key: "mousemoveWindow",
                    value: function mousemoveWindow(e1, t) {
                        if (!this._active) return;
                        var i = t;
                        if (this._lastPos.equals(i) || !this._box && i.dist(this._startPos) < this._clickTolerance) return;
                        var a = this._startPos;
                        this._lastPos = i, this._box || (this._box = h.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", e1));
                        var r = Math.min(a.x, i.x), o = Math.max(a.x, i.x), s = Math.min(a.y, i.y), n = Math.max(a.y, i.y);
                        h.setTransform(this._box, "translate(".concat(r, "px,").concat(s, "px)")), this._box.style.width = o - r + "px", this._box.style.height = n - s + "px";
                    }
                },
                {
                    key: "mouseupWindow",
                    value: function mouseupWindow(e1, i) {
                        var _this = this;
                        if (!this._active) return;
                        if (0 !== e1.button) return;
                        var a = this._startPos, r = i;
                        if (this.reset(), h.suppressClick(), a.x !== r.x || a.y !== r.y) return this._map.fire(new t.l("boxzoomend", {
                            originalEvent: e1
                        })), {
                            cameraAnimation: function(e1) {
                                return e1.fitScreenCoordinates(a, r, _this._tr.bearing, {
                                    linear: !0
                                });
                            }
                        };
                        this._fireEvent("boxzoomcancel", e1);
                    }
                },
                {
                    key: "keydown",
                    value: function keydown(e1) {
                        this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
                    }
                },
                {
                    key: "reset",
                    value: function reset() {
                        this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (h.remove(this._box), this._box = null), h.enableDrag(), delete this._startPos, delete this._lastPos;
                    }
                },
                {
                    key: "_fireEvent",
                    value: function _fireEvent(e1, i) {
                        return this._map.fire(new t.l(e1, {
                            originalEvent: i
                        }));
                    }
                }
            ]);
            return co;
        }();
        function ho(e1, t) {
            if (e1.length !== t.length) throw new Error("The number of touches and points are not equal - touches ".concat(e1.length, ", points ").concat(t.length));
            var i = {};
            for(var a = 0; a < e1.length; a++)i[e1[a].identifier] = t[a];
            return i;
        }
        var uo = /*#__PURE__*/ function() {
            function uo(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, uo);
                this.reset(), this.numTouches = e1.numTouches;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(uo, [
                {
                    key: "reset",
                    value: function reset() {
                        delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
                    }
                },
                {
                    key: "touchstart",
                    value: function touchstart(e1, i, a) {
                        (this.centroid || a.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = e1.timeStamp), a.length === this.numTouches && (this.centroid = function(e1) {
                            var _$i = new t.P(0, 0);
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$t = _step.value;
                                    _$i._add(_$t);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return _$i.div(e1.length);
                        }(i), this.touches = ho(a, i)));
                    }
                },
                {
                    key: "touchmove",
                    value: function touchmove(e1, t, i) {
                        if (this.aborted || !this.centroid) return;
                        var a = ho(i, t);
                        for(var _$e in this.touches){
                            var _$t = a[_$e];
                            (!_$t || _$t.dist(this.touches[_$e]) > 30) && (this.aborted = !0);
                        }
                    }
                },
                {
                    key: "touchend",
                    value: function touchend(e1, t, i) {
                        if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                            var _$e = !this.aborted && this.centroid;
                            if (this.reset(), _$e) return _$e;
                        }
                    }
                }
            ]);
            return uo;
        }();
        var _o = /*#__PURE__*/ function() {
            function _o(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _o);
                this.singleTap = new uo(e1), this.numTaps = e1.numTaps, this.reset();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_o, [
                {
                    key: "reset",
                    value: function reset() {
                        this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
                    }
                },
                {
                    key: "touchstart",
                    value: function touchstart(e1, t, i) {
                        this.singleTap.touchstart(e1, t, i);
                    }
                },
                {
                    key: "touchmove",
                    value: function touchmove(e1, t, i) {
                        this.singleTap.touchmove(e1, t, i);
                    }
                },
                {
                    key: "touchend",
                    value: function touchend(e1, t, i) {
                        var a = this.singleTap.touchend(e1, t, i);
                        if (a) {
                            var _$t = e1.timeStamp - this.lastTime < 500, _$i = !this.lastTap || this.lastTap.dist(a) < 30;
                            if (_$t && _$i || this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = a, this.count === this.numTaps) return this.reset(), a;
                        }
                    }
                }
            ]);
            return _o;
        }();
        var po = /*#__PURE__*/ function() {
            function po(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, po);
                this._tr = new lo(e1), this._zoomIn = new _o({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new _o({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(po, [
                {
                    key: "reset",
                    value: function reset() {
                        this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
                    }
                },
                {
                    key: "touchstart",
                    value: function touchstart(e1, t, i) {
                        this._zoomIn.touchstart(e1, t, i), this._zoomOut.touchstart(e1, t, i);
                    }
                },
                {
                    key: "touchmove",
                    value: function touchmove(e1, t, i) {
                        this._zoomIn.touchmove(e1, t, i), this._zoomOut.touchmove(e1, t, i);
                    }
                },
                {
                    key: "touchend",
                    value: function touchend(e1, t, i) {
                        var _this = this;
                        var a = this._zoomIn.touchend(e1, t, i), r = this._zoomOut.touchend(e1, t, i), o = this._tr;
                        return a ? (this._active = !0, e1.preventDefault(), setTimeout(function() {
                            return _this.reset();
                        }, 0), {
                            cameraAnimation: function(t) {
                                return t.easeTo({
                                    duration: 300,
                                    zoom: o.zoom + 1,
                                    around: o.unproject(a)
                                }, {
                                    originalEvent: e1
                                });
                            }
                        }) : r ? (this._active = !0, e1.preventDefault(), setTimeout(function() {
                            return _this.reset();
                        }, 0), {
                            cameraAnimation: function(t) {
                                return t.easeTo({
                                    duration: 300,
                                    zoom: o.zoom - 1,
                                    around: o.unproject(r)
                                }, {
                                    originalEvent: e1
                                });
                            }
                        }) : void 0;
                    }
                },
                {
                    key: "touchcancel",
                    value: function touchcancel() {
                        this.reset();
                    }
                },
                {
                    key: "enable",
                    value: function enable() {
                        this._enabled = !0;
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._enabled = !1, this.reset();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._enabled;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return this._active;
                    }
                }
            ]);
            return po;
        }();
        var mo = /*#__PURE__*/ function() {
            function mo(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, mo);
                this._enabled = !!e1.enable, this._moveStateManager = e1.moveStateManager, this._clickTolerance = e1.clickTolerance || 1, this._moveFunction = e1.move, this._activateOnStart = !!e1.activateOnStart, e1.assignEvents(this), this.reset();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(mo, [
                {
                    key: "reset",
                    value: function reset(e1) {
                        this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(e1);
                    }
                },
                {
                    key: "_move",
                    value: function _move() {
                        for(var _len = arguments.length, _$e = new Array(_len), _key = 0; _key < _len; _key++){
                            _$e[_key] = arguments[_key];
                        }
                        var _$t = this._moveFunction.apply(this, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$e));
                        if (_$t.bearingDelta || _$t.pitchDelta || _$t.rollDelta || _$t.around || _$t.panDelta) return this._active = !0, _$t;
                    }
                },
                {
                    key: "dragStart",
                    value: function dragStart(e1, t) {
                        this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(e1) && (this._moveStateManager.startMove(e1), this._lastPoint = Array.isArray(t) ? t[0] : t, this._activateOnStart && this._lastPoint && (this._active = !0));
                    }
                },
                {
                    key: "dragMove",
                    value: function dragMove(e1, t) {
                        if (!this.isEnabled()) return;
                        var i = this._lastPoint;
                        if (!i) return;
                        if (e1.preventDefault(), !this._moveStateManager.isValidMoveEvent(e1)) return void this.reset(e1);
                        var a = Array.isArray(t) ? t[0] : t;
                        return !this._moved && a.dist(i) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = a, this._move(i, a));
                    }
                },
                {
                    key: "dragEnd",
                    value: function dragEnd(e1) {
                        this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(e1) && (this._moved && h.suppressClick(), this.reset(e1));
                    }
                },
                {
                    key: "enable",
                    value: function enable() {
                        this._enabled = !0;
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._enabled = !1, this.reset();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._enabled;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return this._active;
                    }
                },
                {
                    key: "getClickTolerance",
                    value: function getClickTolerance() {
                        return this._clickTolerance;
                    }
                }
            ]);
            return mo;
        }();
        var _obj;
        var fo = 0, go = 2, vo = (_obj = {}, (0, $6194eebaf067e4d1$export$71511d61b312f219)(_obj, fo, 1), (0, $6194eebaf067e4d1$export$71511d61b312f219)(_obj, go, 2), _obj);
        var xo = /*#__PURE__*/ function() {
            function xo(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, xo);
                this._correctEvent = e1.checkCorrectEvent;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(xo, [
                {
                    key: "startMove",
                    value: function startMove(e1) {
                        var _$t = h.mouseButton(e1);
                        this._eventButton = _$t;
                    }
                },
                {
                    key: "endMove",
                    value: function endMove(e1) {
                        delete this._eventButton;
                    }
                },
                {
                    key: "isValidStartEvent",
                    value: function isValidStartEvent(e1) {
                        return this._correctEvent(e1);
                    }
                },
                {
                    key: "isValidMoveEvent",
                    value: function isValidMoveEvent(e1) {
                        return !function(e1, t) {
                            var i = vo[t];
                            return void 0 === e1.buttons || (e1.buttons & i) !== i;
                        }(e1, this._eventButton);
                    }
                },
                {
                    key: "isValidEndEvent",
                    value: function isValidEndEvent(e1) {
                        return h.mouseButton(e1) === this._eventButton;
                    }
                }
            ]);
            return xo;
        }();
        var bo = /*#__PURE__*/ function() {
            function bo() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, bo);
                this._firstTouch = void 0;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(bo, [
                {
                    key: "_isOneFingerTouch",
                    value: function _isOneFingerTouch(e1) {
                        return 1 === e1.targetTouches.length;
                    }
                },
                {
                    key: "_isSameTouchEvent",
                    value: function _isSameTouchEvent(e1) {
                        return e1.targetTouches[0].identifier === this._firstTouch;
                    }
                },
                {
                    key: "startMove",
                    value: function startMove(e1) {
                        this._firstTouch = e1.targetTouches[0].identifier;
                    }
                },
                {
                    key: "endMove",
                    value: function endMove(e1) {
                        delete this._firstTouch;
                    }
                },
                {
                    key: "isValidStartEvent",
                    value: function isValidStartEvent(e1) {
                        return this._isOneFingerTouch(e1);
                    }
                },
                {
                    key: "isValidMoveEvent",
                    value: function isValidMoveEvent(e1) {
                        return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
                    }
                },
                {
                    key: "isValidEndEvent",
                    value: function isValidEndEvent(e1) {
                        return this._isOneFingerTouch(e1) && this._isSameTouchEvent(e1);
                    }
                }
            ]);
            return bo;
        }();
        var yo = /*#__PURE__*/ function() {
            function yo() {
                var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : new xo({
                    checkCorrectEvent: function() {
                        return !0;
                    }
                }), _$t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : new bo;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, yo);
                this.mouseMoveStateManager = _$e, this.oneFingerTouchMoveStateManager = _$t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(yo, [
                {
                    key: "_executeRelevantHandler",
                    value: function _executeRelevantHandler(e1, t, i) {
                        return e1 instanceof MouseEvent ? t(e1) : "undefined" != typeof TouchEvent && e1 instanceof TouchEvent ? i(e1) : void 0;
                    }
                },
                {
                    key: "startMove",
                    value: function startMove(e1) {
                        var _this = this;
                        this._executeRelevantHandler(e1, function(e1) {
                            return _this.mouseMoveStateManager.startMove(e1);
                        }, function(e1) {
                            return _this.oneFingerTouchMoveStateManager.startMove(e1);
                        });
                    }
                },
                {
                    key: "endMove",
                    value: function endMove(e1) {
                        var _this = this;
                        this._executeRelevantHandler(e1, function(e1) {
                            return _this.mouseMoveStateManager.endMove(e1);
                        }, function(e1) {
                            return _this.oneFingerTouchMoveStateManager.endMove(e1);
                        });
                    }
                },
                {
                    key: "isValidStartEvent",
                    value: function isValidStartEvent(e1) {
                        var _this = this;
                        return this._executeRelevantHandler(e1, function(e1) {
                            return _this.mouseMoveStateManager.isValidStartEvent(e1);
                        }, function(e1) {
                            return _this.oneFingerTouchMoveStateManager.isValidStartEvent(e1);
                        });
                    }
                },
                {
                    key: "isValidMoveEvent",
                    value: function isValidMoveEvent(e1) {
                        var _this = this;
                        return this._executeRelevantHandler(e1, function(e1) {
                            return _this.mouseMoveStateManager.isValidMoveEvent(e1);
                        }, function(e1) {
                            return _this.oneFingerTouchMoveStateManager.isValidMoveEvent(e1);
                        });
                    }
                },
                {
                    key: "isValidEndEvent",
                    value: function isValidEndEvent(e1) {
                        var _this = this;
                        return this._executeRelevantHandler(e1, function(e1) {
                            return _this.mouseMoveStateManager.isValidEndEvent(e1);
                        }, function(e1) {
                            return _this.oneFingerTouchMoveStateManager.isValidEndEvent(e1);
                        });
                    }
                }
            ]);
            return yo;
        }();
        var wo = function(e1) {
            e1.mousedown = e1.dragStart, e1.mousemoveWindow = e1.dragMove, e1.mouseup = e1.dragEnd, e1.contextmenu = function(e1) {
                e1.preventDefault();
            };
        };
        var To = /*#__PURE__*/ function() {
            function To(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, To);
                this._clickTolerance = e1.clickTolerance || 1, this._map = t, this.reset();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(To, [
                {
                    key: "reset",
                    value: function reset() {
                        this._active = !1, this._touches = {}, this._sum = new t.P(0, 0);
                    }
                },
                {
                    key: "_shouldBePrevented",
                    value: function _shouldBePrevented(e1) {
                        return e1 < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
                    }
                },
                {
                    key: "touchstart",
                    value: function touchstart(e1, t, i) {
                        return this._calculateTransform(e1, t, i);
                    }
                },
                {
                    key: "touchmove",
                    value: function touchmove(e1, t, i) {
                        if (this._active) {
                            if (!this._shouldBePrevented(i.length)) return e1.preventDefault(), this._calculateTransform(e1, t, i);
                            this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", e1);
                        }
                    }
                },
                {
                    key: "touchend",
                    value: function touchend(e1, t, i) {
                        this._calculateTransform(e1, t, i), this._active && this._shouldBePrevented(i.length) && this.reset();
                    }
                },
                {
                    key: "touchcancel",
                    value: function touchcancel() {
                        this.reset();
                    }
                },
                {
                    key: "_calculateTransform",
                    value: function _calculateTransform(e1, i, a) {
                        a.length > 0 && (this._active = !0);
                        var r = ho(a, i), o = new t.P(0, 0), s = new t.P(0, 0);
                        var n = 0;
                        for(var _$e in r){
                            var _$t = r[_$e], _$i = this._touches[_$e];
                            _$i && (o._add(_$t), s._add(_$t.sub(_$i)), n++, r[_$e] = _$t);
                        }
                        if (this._touches = r, this._shouldBePrevented(n) || !s.mag()) return;
                        var l = s.div(n);
                        return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                            around: o.div(n),
                            panDelta: l
                        };
                    }
                },
                {
                    key: "enable",
                    value: function enable() {
                        this._enabled = !0;
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._enabled = !1, this.reset();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._enabled;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return this._active;
                    }
                }
            ]);
            return To;
        }();
        var Po = /*#__PURE__*/ function() {
            function Po() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Po);
                this.reset();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Po, [
                {
                    key: "reset",
                    value: function reset() {
                        this._active = !1, delete this._firstTwoTouches;
                    }
                },
                {
                    key: "touchstart",
                    value: function touchstart(e1, t, i) {
                        this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                            i[0].identifier,
                            i[1].identifier
                        ], this._start([
                            t[0],
                            t[1]
                        ]));
                    }
                },
                {
                    key: "touchmove",
                    value: function touchmove(e1, t, i) {
                        if (!this._firstTwoTouches) return;
                        e1.preventDefault();
                        var _this__firstTwoTouches = (0, $db95b225ee8036d6$export$71511d61b312f219)(this._firstTwoTouches, 2), a = _this__firstTwoTouches[0], r = _this__firstTwoTouches[1], o = Co(i, t, a), s = Co(i, t, r);
                        if (!o || !s) return;
                        var n = this._aroundCenter ? null : o.add(s).div(2);
                        return this._move([
                            o,
                            s
                        ], n, e1);
                    }
                },
                {
                    key: "touchend",
                    value: function touchend(e1, t, i) {
                        if (!this._firstTwoTouches) return;
                        var _this__firstTwoTouches = (0, $db95b225ee8036d6$export$71511d61b312f219)(this._firstTwoTouches, 2), a = _this__firstTwoTouches[0], r = _this__firstTwoTouches[1], o = Co(i, t, a), s = Co(i, t, r);
                        o && s || (this._active && h.suppressClick(), this.reset());
                    }
                },
                {
                    key: "touchcancel",
                    value: function touchcancel() {
                        this.reset();
                    }
                },
                {
                    key: "enable",
                    value: function enable(e1) {
                        this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._enabled = !1, this.reset();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return !!this._enabled;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return !!this._active;
                    }
                }
            ]);
            return Po;
        }();
        function Co(e1, t, i) {
            for(var a = 0; a < e1.length; a++)if (e1[a].identifier === i) return t[a];
        }
        function Io(e1, t) {
            return Math.log(e1 / t) / Math.LN2;
        }
        var Mo = /*#__PURE__*/ function(Po) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Mo, Po);
            function Mo() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Mo);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Mo, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Mo, [
                {
                    key: "reset",
                    value: function reset() {
                        (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(Mo.prototype), "reset", this).call(this), delete this._distance, delete this._startDistance;
                    }
                },
                {
                    key: "_start",
                    value: function _start(e1) {
                        this._startDistance = this._distance = e1[0].dist(e1[1]);
                    }
                },
                {
                    key: "_move",
                    value: function _move(e1, t) {
                        var i = this._distance;
                        if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs(Io(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                            zoomDelta: Io(this._distance, i),
                            pinchAround: t
                        };
                    }
                }
            ]);
            return Mo;
        }(Po);
        function Eo(e1, t) {
            return 180 * e1.angleWith(t) / Math.PI;
        }
        var So = /*#__PURE__*/ function(Po) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(So, Po);
            function So() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, So);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, So, arguments);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(So, [
                {
                    key: "reset",
                    value: function reset() {
                        (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(So.prototype), "reset", this).call(this), delete this._minDiameter, delete this._startVector, delete this._vector;
                    }
                },
                {
                    key: "_start",
                    value: function _start(e1) {
                        this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
                    }
                },
                {
                    key: "_move",
                    value: function _move(e1, t, i) {
                        var a = this._vector;
                        if (this._vector = e1[0].sub(e1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                            bearingDelta: Eo(this._vector, a),
                            pinchAround: t
                        };
                    }
                },
                {
                    key: "_isBelowThreshold",
                    value: function _isBelowThreshold(e1) {
                        this._minDiameter = Math.min(this._minDiameter, e1.mag());
                        var _$t = 25 / (Math.PI * this._minDiameter) * 360, i = Eo(e1, this._startVector);
                        return Math.abs(i) < _$t;
                    }
                }
            ]);
            return So;
        }(Po);
        function Ro(e1) {
            return Math.abs(e1.y) > Math.abs(e1.x);
        }
        var zo = /*#__PURE__*/ function(Po) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(zo, Po);
            function zo(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, zo);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, zo), _this._currentTouchCount = 0, _this._map = e1;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(zo, [
                {
                    key: "reset",
                    value: function reset() {
                        (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(zo.prototype), "reset", this).call(this), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
                    }
                },
                {
                    key: "touchstart",
                    value: function touchstart(e1, t, i) {
                        (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(zo.prototype), "touchstart", this).call(this, e1, t, i), this._currentTouchCount = i.length;
                    }
                },
                {
                    key: "_start",
                    value: function _start(e1) {
                        this._lastPoints = e1, Ro(e1[0].sub(e1[1])) && (this._valid = !1);
                    }
                },
                {
                    key: "_move",
                    value: function _move(e1, t, i) {
                        if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
                        var a = e1[0].sub(this._lastPoints[0]), r = e1[1].sub(this._lastPoints[1]);
                        return this._valid = this.gestureBeginsVertically(a, r, i.timeStamp), this._valid ? (this._lastPoints = e1, this._active = !0, {
                            pitchDelta: (a.y + r.y) / 2 * -0.5
                        }) : void 0;
                    }
                },
                {
                    key: "gestureBeginsVertically",
                    value: function gestureBeginsVertically(e1, t, i) {
                        if (void 0 !== this._valid) return this._valid;
                        var a = e1.mag() >= 2, r = t.mag() >= 2;
                        if (!a && !r) return;
                        if (!a || !r) return void 0 === this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                        var o = e1.y > 0 == t.y > 0;
                        return Ro(e1) && Ro(t) && o;
                    }
                }
            ]);
            return zo;
        }(Po);
        var Do = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        var Ao = /*#__PURE__*/ function() {
            function Ao(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ao);
                this._tr = new lo(e1);
                var _$t = Do;
                this._panStep = _$t.panStep, this._bearingStep = _$t.bearingStep, this._pitchStep = _$t.pitchStep, this._rotationDisabled = !1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ao, [
                {
                    key: "reset",
                    value: function reset() {
                        this._active = !1;
                    }
                },
                {
                    key: "keydown",
                    value: function keydown(e1) {
                        var _this = this;
                        if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
                        var _$t = 0, i = 0, a = 0, r = 0, o = 0;
                        switch(e1.keyCode){
                            case 61:
                            case 107:
                            case 171:
                            case 187:
                                _$t = 1;
                                break;
                            case 189:
                            case 109:
                            case 173:
                                _$t = -1;
                                break;
                            case 37:
                                e1.shiftKey ? i = -1 : (e1.preventDefault(), r = -1);
                                break;
                            case 39:
                                e1.shiftKey ? i = 1 : (e1.preventDefault(), r = 1);
                                break;
                            case 38:
                                e1.shiftKey ? a = 1 : (e1.preventDefault(), o = -1);
                                break;
                            case 40:
                                e1.shiftKey ? a = -1 : (e1.preventDefault(), o = 1);
                                break;
                            default:
                                return;
                        }
                        return this._rotationDisabled && (i = 0, a = 0), {
                            cameraAnimation: function(s) {
                                var n = _this._tr;
                                s.easeTo({
                                    duration: 300,
                                    easeId: "keyboardHandler",
                                    easing: Lo,
                                    zoom: _$t ? Math.round(n.zoom) + _$t * (e1.shiftKey ? 2 : 1) : n.zoom,
                                    bearing: n.bearing + i * _this._bearingStep,
                                    pitch: n.pitch + a * _this._pitchStep,
                                    offset: [
                                        -r * _this._panStep,
                                        -o * _this._panStep
                                    ],
                                    center: n.center
                                }, {
                                    originalEvent: e1
                                });
                            }
                        };
                    }
                },
                {
                    key: "enable",
                    value: function enable() {
                        this._enabled = !0;
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._enabled = !1, this.reset();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._enabled;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return this._active;
                    }
                },
                {
                    key: "disableRotation",
                    value: function disableRotation() {
                        this._rotationDisabled = !0;
                    }
                },
                {
                    key: "enableRotation",
                    value: function enableRotation() {
                        this._rotationDisabled = !1;
                    }
                }
            ]);
            return Ao;
        }();
        function Lo(e1) {
            return e1 * (2 - e1);
        }
        var ko = 4.000244140625, Fo = 1 / 450;
        var Bo = /*#__PURE__*/ function() {
            function Bo(e1, t) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Bo);
                this._onTimeout = function(e1) {
                    _this._type = "wheel", _this._delta -= _this._lastValue, _this._active || _this._start(e1);
                }, this._map = e1, this._tr = new lo(e1), this._triggerRenderFrame = t, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = Fo;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Bo, [
                {
                    key: "setZoomRate",
                    value: function setZoomRate(e1) {
                        this._defaultZoomRate = e1;
                    }
                },
                {
                    key: "setWheelZoomRate",
                    value: function setWheelZoomRate(e1) {
                        this._wheelZoomRate = e1;
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return !!this._enabled;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return !!this._active || void 0 !== this._finishTimeout;
                    }
                },
                {
                    key: "isZooming",
                    value: function isZooming() {
                        return !!this._zooming;
                    }
                },
                {
                    key: "enable",
                    value: function enable(e1) {
                        this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around);
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this.isEnabled() && (this._enabled = !1);
                    }
                },
                {
                    key: "_shouldBePrevented",
                    value: function _shouldBePrevented(e1) {
                        return !!this._map.cooperativeGestures.isEnabled() && !(e1.ctrlKey || this._map.cooperativeGestures.isBypassed(e1));
                    }
                },
                {
                    key: "wheel",
                    value: function wheel(e1) {
                        if (!this.isEnabled()) return;
                        if (this._shouldBePrevented(e1)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", e1);
                        var _$t = e1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * e1.deltaY : e1.deltaY;
                        var i = c(), a = i - (this._lastWheelEventTime || 0);
                        this._lastWheelEventTime = i, 0 !== _$t && _$t % ko == 0 ? this._type = "wheel" : 0 !== _$t && Math.abs(_$t) < 4 ? this._type = "trackpad" : a > 400 ? (this._type = null, this._lastValue = _$t, this._timeout = setTimeout(this._onTimeout, 40, e1)) : this._type || (this._type = Math.abs(a * _$t) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, _$t += this._lastValue)), e1.shiftKey && _$t && (_$t /= 4), this._type && (this._lastWheelEvent = e1, this._delta -= _$t, this._active || this._start(e1)), e1.preventDefault();
                    }
                },
                {
                    key: "_start",
                    value: function _start(e1) {
                        if (!this._delta) return;
                        this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                        var i = h.mousePos(this._map.getCanvas(), e1), a = this._tr;
                        this._aroundPoint = this._aroundCenter ? a.transform.locationToScreenPoint(t.V.convert(a.center)) : i, this._frameId || (this._frameId = !0, this._triggerRenderFrame());
                    }
                },
                {
                    key: "renderFrame",
                    value: function renderFrame() {
                        var _this = this;
                        if (!this._frameId) return;
                        if (this._frameId = null, !this.isActive()) return;
                        var _$e = this._tr.transform;
                        if ("number" == typeof this._lastExpectedZoom) {
                            var _$t = _$e.zoom - this._lastExpectedZoom;
                            "number" == typeof this._startZoom && (this._startZoom += _$t), "number" == typeof this._targetZoom && (this._targetZoom += _$t);
                        }
                        if (0 !== this._delta) {
                            var i = "wheel" === this._type && Math.abs(this._delta) > ko ? this._wheelZoomRate : this._defaultZoomRate;
                            var a = 2 / (1 + Math.exp(-Math.abs(this._delta * i)));
                            this._delta < 0 && 0 !== a && (a = 1 / a);
                            var r = "number" != typeof this._targetZoom ? _$e.scale : t.aq(this._targetZoom);
                            this._targetZoom = _$e.applyConstrain(_$e.getCameraLngLat(), t.at(r * a)).zoom, "wheel" === this._type && (this._startZoom = _$e.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                        }
                        var i1 = "number" != typeof this._targetZoom ? _$e.zoom : this._targetZoom, a1 = this._startZoom, r1 = this._easing;
                        var o, s = !1;
                        if ("wheel" === this._type && a1 && r1) {
                            var _$e1 = c() - this._lastWheelEventTime, n = Math.min((_$e1 + 5) / 200, 1), l = r1(n);
                            o = t.G.number(a1, i1, l), n < 1 ? this._frameId || (this._frameId = !0) : s = !0;
                        } else o = i1, s = !0;
                        return this._active = !0, s && (this._active = !1, this._finishTimeout = setTimeout(function() {
                            _this._zooming = !1, _this._triggerRenderFrame(), delete _this._targetZoom, delete _this._lastExpectedZoom, delete _this._finishTimeout;
                        }, 200)), this._lastExpectedZoom = o, {
                            noInertia: !0,
                            needsRenderFrame: !s,
                            zoomDelta: o - _$e.zoom,
                            around: this._aroundPoint,
                            originalEvent: this._lastWheelEvent
                        };
                    }
                },
                {
                    key: "_smoothOutEasing",
                    value: function _smoothOutEasing(e1) {
                        var i = t.cy;
                        if (this._prevEase) {
                            var _$e = this._prevEase, a = (c() - _$e.start) / _$e.duration, r = _$e.easing(a + .01) - _$e.easing(a), o = .27 / Math.sqrt(r * r + 1e-4) * .01, s = Math.sqrt(.0729 - o * o);
                            i = t.cw(o, s, .25, 1);
                        }
                        return this._prevEase = {
                            start: c(),
                            duration: e1,
                            easing: i
                        }, i;
                    }
                },
                {
                    key: "reset",
                    value: function reset() {
                        this._active = !1, this._zooming = !1, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                    }
                }
            ]);
            return Bo;
        }();
        var Oo = /*#__PURE__*/ function() {
            function Oo(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Oo);
                this._clickZoom = e1, this._tapZoom = t;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Oo, [
                {
                    key: "enable",
                    value: function enable() {
                        this._clickZoom.enable(), this._tapZoom.enable();
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._clickZoom.disable(), this._tapZoom.disable();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return this._clickZoom.isActive() || this._tapZoom.isActive();
                    }
                }
            ]);
            return Oo;
        }();
        var jo = /*#__PURE__*/ function() {
            function jo(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, jo);
                this._tr = new lo(e1), this.reset();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(jo, [
                {
                    key: "reset",
                    value: function reset() {
                        this._active = !1;
                    }
                },
                {
                    key: "dblclick",
                    value: function dblclick(e1, t) {
                        var _this = this;
                        return e1.preventDefault(), {
                            cameraAnimation: function(i) {
                                i.easeTo({
                                    duration: 300,
                                    zoom: _this._tr.zoom + (e1.shiftKey ? -1 : 1),
                                    around: _this._tr.unproject(t)
                                }, {
                                    originalEvent: e1
                                });
                            }
                        };
                    }
                },
                {
                    key: "enable",
                    value: function enable() {
                        this._enabled = !0;
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._enabled = !1, this.reset();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._enabled;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return this._active;
                    }
                }
            ]);
            return jo;
        }();
        var No = /*#__PURE__*/ function() {
            function No() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, No);
                this._tap = new _o({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(No, [
                {
                    key: "reset",
                    value: function reset() {
                        this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
                    }
                },
                {
                    key: "touchstart",
                    value: function touchstart(e1, t, i) {
                        if (!this._swipePoint) {
                            if (this._tapTime) {
                                var a = t[0], r = e1.timeStamp - this._tapTime < 500, o = this._tapPoint.dist(a) < 30;
                                r && o ? i.length > 0 && (this._swipePoint = a, this._swipeTouch = i[0].identifier) : this.reset();
                            } else this._tap.touchstart(e1, t, i);
                        }
                    }
                },
                {
                    key: "touchmove",
                    value: function touchmove(e1, t, i) {
                        if (this._tapTime) {
                            if (this._swipePoint) {
                                if (i[0].identifier !== this._swipeTouch) return;
                                var a = t[0], r = a.y - this._swipePoint.y;
                                return this._swipePoint = a, e1.preventDefault(), this._active = !0, {
                                    zoomDelta: r / 128
                                };
                            }
                        } else this._tap.touchmove(e1, t, i);
                    }
                },
                {
                    key: "touchend",
                    value: function touchend(e1, t, i) {
                        if (this._tapTime) this._swipePoint && 0 === i.length && this.reset();
                        else {
                            var a = this._tap.touchend(e1, t, i);
                            a && (this._tapTime = e1.timeStamp, this._tapPoint = a);
                        }
                    }
                },
                {
                    key: "touchcancel",
                    value: function touchcancel() {
                        this.reset();
                    }
                },
                {
                    key: "enable",
                    value: function enable() {
                        this._enabled = !0;
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._enabled = !1, this.reset();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._enabled;
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return this._active;
                    }
                }
            ]);
            return No;
        }();
        var Zo = /*#__PURE__*/ function() {
            function Zo(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Zo);
                this._el = e1, this._mousePan = t, this._touchPan = i;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Zo, [
                {
                    key: "enable",
                    value: function enable(e1) {
                        this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._mousePan.isEnabled() && this._touchPan.isEnabled();
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return this._mousePan.isActive() || this._touchPan.isActive();
                    }
                }
            ]);
            return Zo;
        }();
        var Go = /*#__PURE__*/ function() {
            function Go(e1, t, i, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Go);
                this._pitchWithRotate = e1.pitchWithRotate, this._rollEnabled = e1.rollEnabled, this._mouseRotate = t, this._mousePitch = i, this._mouseRoll = a;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Go, [
                {
                    key: "enable",
                    value: function enable() {
                        this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
                    }
                }
            ]);
            return Go;
        }();
        var Uo = /*#__PURE__*/ function() {
            function Uo(e1, t, i, a) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Uo);
                this._el = e1, this._touchZoom = t, this._touchRotate = i, this._tapDragZoom = a, this._rotationDisabled = !1, this._enabled = !0;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Uo, [
                {
                    key: "enable",
                    value: function enable(e1) {
                        this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
                    }
                },
                {
                    key: "disableRotation",
                    value: function disableRotation() {
                        this._rotationDisabled = !0, this._touchRotate.disable();
                    }
                },
                {
                    key: "enableRotation",
                    value: function enableRotation() {
                        this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
                    }
                }
            ]);
            return Uo;
        }();
        var Vo = /*#__PURE__*/ function() {
            function Vo(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Vo);
                this._bypassKey = -1 !== navigator.userAgent.indexOf("Mac") ? "metaKey" : "ctrlKey", this._map = e1, this._options = t, this._enabled = !1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Vo, [
                {
                    key: "isActive",
                    value: function isActive() {
                        return !1;
                    }
                },
                {
                    key: "reset",
                    value: function reset() {}
                },
                {
                    key: "_setupUI",
                    value: function _setupUI() {
                        if (this._container) return;
                        var _$e = this._map.getCanvasContainer();
                        _$e.classList.add("maplibregl-cooperative-gestures"), this._container = h.create("div", "maplibregl-cooperative-gesture-screen", _$e);
                        var _$t = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
                        "metaKey" === this._bypassKey && (_$t = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
                        var i = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), a = document.createElement("div");
                        a.className = "maplibregl-desktop-message", a.textContent = _$t, this._container.appendChild(a);
                        var r = document.createElement("div");
                        r.className = "maplibregl-mobile-message", r.textContent = i, this._container.appendChild(r), this._container.setAttribute("aria-hidden", "true");
                    }
                },
                {
                    key: "_destroyUI",
                    value: function _destroyUI() {
                        this._container && (h.remove(this._container), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
                    }
                },
                {
                    key: "enable",
                    value: function enable() {
                        this._setupUI(), this._enabled = !0;
                    }
                },
                {
                    key: "disable",
                    value: function disable() {
                        this._enabled = !1, this._destroyUI();
                    }
                },
                {
                    key: "isEnabled",
                    value: function isEnabled() {
                        return this._enabled;
                    }
                },
                {
                    key: "isBypassed",
                    value: function isBypassed(e1) {
                        return e1[this._bypassKey];
                    }
                },
                {
                    key: "notifyGestureBlocked",
                    value: function notifyGestureBlocked(e1, i) {
                        var _this = this;
                        this._enabled && (this._map.fire(new t.l("cooperativegestureprevented", {
                            gestureType: e1,
                            originalEvent: i
                        })), this._container.classList.add("maplibregl-show"), setTimeout(function() {
                            _this._container.classList.remove("maplibregl-show");
                        }, 100));
                    }
                }
            ]);
            return Vo;
        }();
        var qo = function(e1) {
            return e1.zoom || e1.drag || e1.roll || e1.pitch || e1.rotate;
        };
        var Wo = /*#__PURE__*/ function(_t_l) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Wo, _t_l);
            function Wo() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Wo);
                return (0, $44950fec9206880e$export$71511d61b312f219)(this, Wo, arguments);
            }
            return Wo;
        }(t.l);
        function $o(e1) {
            return e1.panDelta && e1.panDelta.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta || e1.rollDelta;
        }
        var Ho = /*#__PURE__*/ function() {
            function Ho(e1, i) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Ho);
                this.handleWindowEvent = function(e1) {
                    _this.handleEvent(e1, "".concat(e1.type, "Window"));
                }, this.handleEvent = function(e1, i) {
                    if ("blur" === e1.type) return void _this.stop(!0);
                    _this._updatingCamera = !0;
                    var a = "renderFrame" === e1.type ? void 0 : e1, r = {
                        needsRenderFrame: !1
                    }, o = {}, s = {};
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = _this._handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = _step.value, n = _step_value.handlerName, l = _step_value.handler, _$c = _step_value.allowed;
                            if (!l.isEnabled()) continue;
                            var u = void 0;
                            if (_this._blockedByActive(s, _$c, n)) l.reset();
                            else if (l[i || e1.type]) {
                                if (t.cz(e1, i || e1.type)) {
                                    var _$t = h.mousePos(_this._map.getCanvas(), e1);
                                    u = l[i || e1.type](e1, _$t);
                                } else if (t.cA(e1, i || e1.type)) {
                                    var _$t1 = _this._getMapTouches(e1.touches), a1 = h.touchPos(_this._map.getCanvas(), _$t1);
                                    u = l[i || e1.type](e1, a1, _$t1);
                                } else t.cB(i || e1.type) || (u = l[i || e1.type](e1));
                                _this.mergeHandlerResult(r, o, u, n, a), u && u.needsRenderFrame && _this._triggerRenderFrame();
                            }
                            (u || l.isActive()) && (s[n] = l);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var n1 = {};
                    for(var _$e in _this._previousActiveHandlers)s[_$e] || (n1[_$e] = a);
                    _this._previousActiveHandlers = s, (Object.keys(n1).length || $o(r)) && (_this._changes.push([
                        r,
                        o,
                        n1
                    ]), _this._triggerRenderFrame()), (Object.keys(s).length || $o(r)) && _this._map._stop(!0), _this._updatingCamera = !1;
                    var l1 = r.cameraAnimation;
                    l1 && (_this._inertia.clear(), _this._fireEvents({}, {}, !0), _this._changes = [], l1(_this._map));
                }, this._map = e1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new eo(e1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(i);
                var a = this._el;
                this._listeners = [
                    [
                        a,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        a,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        a,
                        "touchend",
                        void 0
                    ],
                    [
                        a,
                        "touchcancel",
                        void 0
                    ],
                    [
                        a,
                        "mousedown",
                        void 0
                    ],
                    [
                        a,
                        "mousemove",
                        void 0
                    ],
                    [
                        a,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        a,
                        "mouseover",
                        void 0
                    ],
                    [
                        a,
                        "mouseout",
                        void 0
                    ],
                    [
                        a,
                        "dblclick",
                        void 0
                    ],
                    [
                        a,
                        "click",
                        void 0
                    ],
                    [
                        a,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        a,
                        "keyup",
                        void 0
                    ],
                    [
                        a,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        a,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = this._listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 3), _$e = _step_value[0], _$t = _step_value[1], _$i = _step_value[2];
                        h.addEventListener(_$e, _$t, _$e === document ? this.handleWindowEvent : this.handleEvent, _$i);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Ho, [
                {
                    key: "destroy",
                    value: function destroy() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._listeners[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 3), _$e = _step_value[0], _$t = _step_value[1], i = _step_value[2];
                                h.removeEventListener(_$e, _$t, _$e === document ? this.handleWindowEvent : this.handleEvent, i);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_addDefaultHandlers",
                    value: function _addDefaultHandlers(e1) {
                        var _this = this;
                        var i = this._map, a = i.getCanvasContainer();
                        this._add("mapEvent", new so(i, e1));
                        var r = i.boxZoom = new co(i, e1);
                        this._add("boxZoom", r), e1.interactive && e1.boxZoom && r.enable();
                        var o = i.cooperativeGestures = new Vo(i, e1.cooperativeGestures);
                        this._add("cooperativeGestures", o), e1.cooperativeGestures && o.enable();
                        var s = new po(i), n = new jo(i);
                        i.doubleClickZoom = new Oo(n, s), this._add("tapZoom", s), this._add("clickZoom", n), e1.interactive && e1.doubleClickZoom && i.doubleClickZoom.enable();
                        var l = new No;
                        this._add("tapDragZoom", l);
                        var _$c = i.touchPitch = new zo(i);
                        this._add("touchPitch", _$c), e1.interactive && e1.touchPitch && i.touchPitch.enable(e1.touchPitch);
                        var u = function() {
                            return i.project(i.getCenter());
                        }, d = function(param, s) {
                            var _$e = param.enable, i = param.clickTolerance, tmp = param.aroundCenter, a = tmp === void 0 ? !0 : tmp, tmp1 = param.minPixelCenterThreshold, r = tmp1 === void 0 ? 100 : tmp1, tmp2 = param.rotateDegreesPerPixelMoved, o = tmp2 === void 0 ? .8 : tmp2;
                            var n = new xo({
                                checkCorrectEvent: function(e1) {
                                    return 0 === h.mouseButton(e1) && e1.ctrlKey || 2 === h.mouseButton(e1) && !e1.ctrlKey;
                                }
                            });
                            return new mo({
                                clickTolerance: i,
                                move: function(e1, i) {
                                    var n = s();
                                    if (a && Math.abs(n.y - e1.y) > r) return {
                                        bearingDelta: t.cx(new t.P(e1.x, i.y), i, n)
                                    };
                                    var l = (i.x - e1.x) * o;
                                    return a && i.y < n.y && (l = -l), {
                                        bearingDelta: l
                                    };
                                },
                                moveStateManager: n,
                                enable: _$e,
                                assignEvents: wo
                            });
                        }(e1, u), _ = function(param) {
                            var _$e = param.enable, _$t = param.clickTolerance, tmp = param.pitchDegreesPerPixelMoved, i = tmp === void 0 ? -0.5 : tmp;
                            var a = new xo({
                                checkCorrectEvent: function(e1) {
                                    return 0 === h.mouseButton(e1) && e1.ctrlKey || 2 === h.mouseButton(e1);
                                }
                            });
                            return new mo({
                                clickTolerance: _$t,
                                move: function(e1, t) {
                                    return {
                                        pitchDelta: (t.y - e1.y) * i
                                    };
                                },
                                moveStateManager: a,
                                enable: _$e,
                                assignEvents: wo
                            });
                        }(e1), p = function(param, a) {
                            var _$e = param.enable, _$t = param.clickTolerance, tmp = param.rollDegreesPerPixelMoved, i = tmp === void 0 ? .3 : tmp;
                            var r = new xo({
                                checkCorrectEvent: function(e1) {
                                    return 2 === h.mouseButton(e1) && e1.ctrlKey;
                                }
                            });
                            return new mo({
                                clickTolerance: _$t,
                                move: function(e1, t) {
                                    var r = a();
                                    var o = (t.x - e1.x) * i;
                                    return t.y < r.y && (o = -o), {
                                        rollDelta: o
                                    };
                                },
                                moveStateManager: r,
                                enable: _$e,
                                assignEvents: wo
                            });
                        }(e1, u);
                        i.dragRotate = new Go(e1, d, _, p), this._add("mouseRotate", d, [
                            "mousePitch"
                        ]), this._add("mousePitch", _, [
                            "mouseRotate",
                            "mouseRoll"
                        ]), this._add("mouseRoll", p, [
                            "mousePitch"
                        ]), e1.interactive && e1.dragRotate && i.dragRotate.enable();
                        var m = function(param) {
                            var _$e = param.enable, _$t = param.clickTolerance;
                            var i = new xo({
                                checkCorrectEvent: function(e1) {
                                    return 0 === h.mouseButton(e1) && !e1.ctrlKey;
                                }
                            });
                            return new mo({
                                clickTolerance: _$t,
                                move: function(e1, t) {
                                    return {
                                        around: t,
                                        panDelta: t.sub(e1)
                                    };
                                },
                                activateOnStart: !0,
                                moveStateManager: i,
                                enable: _$e,
                                assignEvents: wo
                            });
                        }(e1), f = new To(e1, i);
                        i.dragPan = new Zo(a, m, f), this._add("mousePan", m), this._add("touchPan", f, [
                            "touchZoom",
                            "touchRotate"
                        ]), e1.interactive && e1.dragPan && i.dragPan.enable(e1.dragPan);
                        var g = new So, v = new Mo;
                        i.touchZoomRotate = new Uo(a, v, g, l), this._add("touchRotate", g, [
                            "touchPan",
                            "touchZoom"
                        ]), this._add("touchZoom", v, [
                            "touchPan",
                            "touchRotate"
                        ]), e1.interactive && e1.touchZoomRotate && i.touchZoomRotate.enable(e1.touchZoomRotate), this._add("blockableMapEvent", new no(i));
                        var x = i.scrollZoom = new Bo(i, function() {
                            return _this._triggerRenderFrame();
                        });
                        this._add("scrollZoom", x, [
                            "mousePan"
                        ]), e1.interactive && e1.scrollZoom && i.scrollZoom.enable(e1.scrollZoom);
                        var b = i.keyboard = new Ao(i);
                        this._add("keyboard", b), e1.interactive && e1.keyboard && i.keyboard.enable();
                    }
                },
                {
                    key: "_add",
                    value: function _add(e1, t, i) {
                        this._handlers.push({
                            handlerName: e1,
                            handler: t,
                            allowed: i
                        }), this._handlersById[e1] = t;
                    }
                },
                {
                    key: "stop",
                    value: function stop(e1) {
                        if (!this._updatingCamera) {
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = this._handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _step_value = _step.value, _$e = _step_value.handler;
                                    _$e.reset();
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [];
                        }
                    }
                },
                {
                    key: "isActive",
                    value: function isActive() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._handlers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = _step.value, _$e = _step_value.handler;
                                if (_$e.isActive()) return !0;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return !1;
                    }
                },
                {
                    key: "isZooming",
                    value: function isZooming() {
                        return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
                    }
                },
                {
                    key: "isRotating",
                    value: function isRotating() {
                        return !!this._eventsInProgress.rotate;
                    }
                },
                {
                    key: "isMoving",
                    value: function isMoving() {
                        return Boolean(qo(this._eventsInProgress)) || this.isZooming();
                    }
                },
                {
                    key: "_blockedByActive",
                    value: function _blockedByActive(e1, t, i) {
                        for(var a in e1)if (a !== i && (!t || t.indexOf(a) < 0)) return !0;
                        return !1;
                    }
                },
                {
                    key: "_getMapTouches",
                    value: function _getMapTouches(e1) {
                        var _$t = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = e1[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                this._el.contains(i.target) && _$t.push(i);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return _$t;
                    }
                },
                {
                    key: "mergeHandlerResult",
                    value: function mergeHandlerResult(e1, i, a, r, o) {
                        if (!a) return;
                        t.e(e1, a);
                        var s = {
                            handlerName: r,
                            originalEvent: a.originalEvent || o
                        };
                        void 0 !== a.zoomDelta && (i.zoom = s), void 0 !== a.panDelta && (i.drag = s), void 0 !== a.rollDelta && (i.roll = s), void 0 !== a.pitchDelta && (i.pitch = s), void 0 !== a.bearingDelta && (i.rotate = s);
                    }
                },
                {
                    key: "_applyChanges",
                    value: function _applyChanges() {
                        var _$e = {}, i = {}, a = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._changes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step.value, 3), r = _step_value[0], o = _step_value[1], s = _step_value[2];
                                r.panDelta && (_$e.panDelta = (_$e.panDelta || new t.P(0, 0))._add(r.panDelta)), r.zoomDelta && (_$e.zoomDelta = (_$e.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (_$e.bearingDelta = (_$e.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (_$e.pitchDelta = (_$e.pitchDelta || 0) + r.pitchDelta), r.rollDelta && (_$e.rollDelta = (_$e.rollDelta || 0) + r.rollDelta), void 0 !== r.around && (_$e.around = r.around), void 0 !== r.pinchAround && (_$e.pinchAround = r.pinchAround), r.noInertia && (_$e.noInertia = r.noInertia), t.e(i, o), t.e(a, s);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._updateMapTransform(_$e, i, a), this._changes = [];
                    }
                },
                {
                    key: "_updateMapTransform",
                    value: function _updateMapTransform(e1, t, i) {
                        var a = this._map, r = a._getTransformForUpdate(), o = a.terrain;
                        if (!($o(e1) || o && this._terrainMovement)) return this._fireEvents(t, i, !0);
                        a._stop(!0);
                        var s = e1.panDelta, n = e1.zoomDelta, l = e1.bearingDelta, _$c = e1.pitchDelta, h = e1.rollDelta, u = e1.around, d = e1.pinchAround;
                        void 0 !== d && (u = d), u = u || a.transform.centerPoint, o && !r.isPointOnMapSurface(u) && (u = r.centerPoint);
                        var _ = {
                            panDelta: s,
                            zoomDelta: n,
                            rollDelta: h,
                            pitchDelta: _$c,
                            bearingDelta: l,
                            around: u
                        };
                        this._map.cameraHelper.useGlobeControls && !r.isPointOnMapSurface(u) && (u = r.centerPoint);
                        var p = u.distSqr(r.centerPoint) < .01 ? r.center : r.screenPointToLocation(s ? u.sub(s) : u);
                        this._handleMapControls({
                            terrain: o,
                            tr: r,
                            deltasForHelper: _,
                            preZoomAroundLoc: p,
                            combinedEventsInProgress: t,
                            panDelta: s
                        }), a._applyUpdatedTransform(r), this._map._update(), e1.noInertia || this._inertia.record(e1), this._fireEvents(t, i, !0);
                    }
                },
                {
                    key: "_handleMapControls",
                    value: function _handleMapControls(param) {
                        var _$e = param.terrain, _$t = param.tr, i = param.deltasForHelper, a = param.preZoomAroundLoc, r = param.combinedEventsInProgress, o = param.panDelta;
                        var s = this._map.cameraHelper;
                        if (s.handleMapControlsRollPitchBearingZoom(i, _$t), _$e) return s.useGlobeControls ? (this._terrainMovement || !r.drag && !r.zoom || (this._terrainMovement = !0, this._map._elevationFreeze = !0), void s.handleMapControlsPan(i, _$t, a)) : this._terrainMovement || !r.drag && !r.zoom ? void (r.drag && this._terrainMovement && o ? _$t.setCenter(_$t.screenPointToLocation(_$t.centerPoint.sub(o))) : s.handleMapControlsPan(i, _$t, a)) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, void s.handleMapControlsPan(i, _$t, a));
                        s.handleMapControlsPan(i, _$t, a);
                    }
                },
                {
                    key: "_fireEvents",
                    value: function _fireEvents(e1, i, a) {
                        var _this = this;
                        var r = qo(this._eventsInProgress), o = qo(e1), s = {};
                        for(var _$t in e1){
                            var _e_t = e1[_$t], _$i = _e_t.originalEvent;
                            this._eventsInProgress[_$t] || (s["".concat(_$t, "start")] = _$i), this._eventsInProgress[_$t] = e1[_$t];
                        }
                        !r && o && this._fireEvent("movestart", o.originalEvent);
                        for(var _$e in s)this._fireEvent(_$e, s[_$e]);
                        o && this._fireEvent("move", o.originalEvent);
                        for(var _$t1 in e1){
                            var _e_t1 = e1[_$t1], _$i1 = _e_t1.originalEvent;
                            this._fireEvent(_$t1, _$i1);
                        }
                        var l = {};
                        var _$c;
                        for(var _$e1 in this._eventsInProgress){
                            var _this__eventsInProgress_e = this._eventsInProgress[_$e1], _$t2 = _this__eventsInProgress_e.handlerName, _$a = _this__eventsInProgress_e.originalEvent;
                            this._handlersById[_$t2].isActive() || (delete this._eventsInProgress[_$e1], _$c = i[_$t2] || _$a, l["".concat(_$e1, "end")] = _$c);
                        }
                        for(var _$e2 in l)this._fireEvent(_$e2, l[_$e2]);
                        var h = qo(this._eventsInProgress), u = (r || o) && !h;
                        if (u && this._terrainMovement) {
                            this._map._elevationFreeze = !1, this._terrainMovement = !1;
                            var _$e3 = this._map._getTransformForUpdate();
                            this._map.getCenterClampedToGround() && _$e3.recalculateZoomAndCenter(this._map.terrain), this._map._applyUpdatedTransform(_$e3);
                        }
                        if (a && u) {
                            this._updatingCamera = !0;
                            var _$e4 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), _$i2 = function(e1) {
                                return 0 !== e1 && -_this._bearingSnap < e1 && e1 < _this._bearingSnap;
                            };
                            !_$e4 || !_$e4.essential && n.prefersReducedMotion ? (this._map.fire(new t.l("moveend", {
                                originalEvent: _$c
                            })), _$i2(this._map.getBearing()) && this._map.resetNorth()) : (_$i2(_$e4.bearing || this._map.getBearing()) && (_$e4.bearing = 0), _$e4.freezeElevation = !0, this._map.easeTo(_$e4, {
                                originalEvent: _$c
                            })), this._updatingCamera = !1;
                        }
                    }
                },
                {
                    key: "_fireEvent",
                    value: function _fireEvent(e1, i) {
                        this._map.fire(new t.l(e1, i ? {
                            originalEvent: i
                        } : {}));
                    }
                },
                {
                    key: "_requestFrame",
                    value: function _requestFrame() {
                        var _this = this;
                        return this._map.triggerRepaint(), this._map._renderTaskQueue.add(function(e1) {
                            delete _this._frameId, _this.handleEvent(new Wo("renderFrame", {
                                timeStamp: e1
                            })), _this._applyChanges();
                        });
                    }
                },
                {
                    key: "_triggerRenderFrame",
                    value: function _triggerRenderFrame() {
                        void 0 === this._frameId && (this._frameId = this._requestFrame());
                    }
                }
            ]);
            return Ho;
        }();
        var Xo = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(Xo, _t_E);
            function Xo(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Xo);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, Xo), _this._renderFrameCallback = function() {
                    var _$e = Math.min((c() - _this._easeStart) / _this._easeOptions.duration, 1);
                    _this._onEaseFrame(_this._easeOptions.easing(_$e)), _$e < 1 && _this._easeFrameId ? _this._easeFrameId = _this._requestRenderFrame(_this._renderFrameCallback) : _this.stop();
                }, _this._moving = !1, _this._zooming = !1, _this.transform = e1, _this._bearingSnap = i.bearingSnap, _this.cameraHelper = t, _this.on("moveend", function() {
                    delete _this._requestedCameraState;
                });
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Xo, [
                {
                    key: "migrateProjection",
                    value: function migrateProjection(e1, t) {
                        e1.apply(this.transform), this.transform = e1, this.cameraHelper = t;
                    }
                },
                {
                    key: "getCenter",
                    value: function getCenter() {
                        return new t.V(this.transform.center.lng, this.transform.center.lat);
                    }
                },
                {
                    key: "setCenter",
                    value: function setCenter(e1, t) {
                        return this.jumpTo({
                            center: e1
                        }, t);
                    }
                },
                {
                    key: "getCenterElevation",
                    value: function getCenterElevation() {
                        return this.transform.elevation;
                    }
                },
                {
                    key: "setCenterElevation",
                    value: function setCenterElevation(e1, t) {
                        return this.jumpTo({
                            elevation: e1
                        }, t), this;
                    }
                },
                {
                    key: "getCenterClampedToGround",
                    value: function getCenterClampedToGround() {
                        return this._centerClampedToGround;
                    }
                },
                {
                    key: "setCenterClampedToGround",
                    value: function setCenterClampedToGround(e1) {
                        this._centerClampedToGround = e1;
                    }
                },
                {
                    key: "panBy",
                    value: function panBy(e1, i, a) {
                        return e1 = t.P.convert(e1).mult(-1), this.panTo(this.transform.center, t.e({
                            offset: e1
                        }, i), a);
                    }
                },
                {
                    key: "panTo",
                    value: function panTo(e1, i, a) {
                        return this.easeTo(t.e({
                            center: e1
                        }, i), a);
                    }
                },
                {
                    key: "getZoom",
                    value: function getZoom() {
                        return this.transform.zoom;
                    }
                },
                {
                    key: "setZoom",
                    value: function setZoom(e1, t) {
                        return this.jumpTo({
                            zoom: e1
                        }, t), this;
                    }
                },
                {
                    key: "zoomTo",
                    value: function zoomTo(e1, i, a) {
                        return this.easeTo(t.e({
                            zoom: e1
                        }, i), a);
                    }
                },
                {
                    key: "zoomIn",
                    value: function zoomIn(e1, t) {
                        return this.zoomTo(this.getZoom() + 1, e1, t), this;
                    }
                },
                {
                    key: "zoomOut",
                    value: function zoomOut(e1, t) {
                        return this.zoomTo(this.getZoom() - 1, e1, t), this;
                    }
                },
                {
                    key: "getVerticalFieldOfView",
                    value: function getVerticalFieldOfView() {
                        return this.transform.fov;
                    }
                },
                {
                    key: "setVerticalFieldOfView",
                    value: function setVerticalFieldOfView(e1, i) {
                        return e1 != this.transform.fov && (this.transform.setFov(e1), this.fire(new t.l("movestart", i)).fire(new t.l("move", i)).fire(new t.l("moveend", i))), this;
                    }
                },
                {
                    key: "getBearing",
                    value: function getBearing() {
                        return this.transform.bearing;
                    }
                },
                {
                    key: "setBearing",
                    value: function setBearing(e1, t) {
                        return this.jumpTo({
                            bearing: e1
                        }, t), this;
                    }
                },
                {
                    key: "getPadding",
                    value: function getPadding() {
                        return this.transform.padding;
                    }
                },
                {
                    key: "setPadding",
                    value: function setPadding(e1, t) {
                        return this.jumpTo({
                            padding: e1
                        }, t), this;
                    }
                },
                {
                    key: "rotateTo",
                    value: function rotateTo(e1, i, a) {
                        return this.easeTo(t.e({
                            bearing: e1
                        }, i), a);
                    }
                },
                {
                    key: "resetNorth",
                    value: function resetNorth(e1, i) {
                        return this.rotateTo(0, t.e({
                            duration: 1e3
                        }, e1), i), this;
                    }
                },
                {
                    key: "resetNorthPitch",
                    value: function resetNorthPitch(e1, i) {
                        return this.easeTo(t.e({
                            bearing: 0,
                            pitch: 0,
                            roll: 0,
                            duration: 1e3
                        }, e1), i), this;
                    }
                },
                {
                    key: "snapToNorth",
                    value: function snapToNorth(e1, t) {
                        return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t) : this;
                    }
                },
                {
                    key: "getPitch",
                    value: function getPitch() {
                        return this.transform.pitch;
                    }
                },
                {
                    key: "setPitch",
                    value: function setPitch(e1, t) {
                        return this.jumpTo({
                            pitch: e1
                        }, t), this;
                    }
                },
                {
                    key: "getRoll",
                    value: function getRoll() {
                        return this.transform.roll;
                    }
                },
                {
                    key: "setRoll",
                    value: function setRoll(e1, t) {
                        return this.jumpTo({
                            roll: e1
                        }, t), this;
                    }
                },
                {
                    key: "cameraForBounds",
                    value: function cameraForBounds(e1, t) {
                        e1 = $.convert(e1).adjustAntiMeridian();
                        var i = t && t.bearing || 0;
                        return this._cameraForBoxAndBearing(e1.getNorthWest(), e1.getSouthEast(), i, t);
                    }
                },
                {
                    key: "_cameraForBoxAndBearing",
                    value: function _cameraForBoxAndBearing(e1, i, a, r) {
                        var o = {
                            top: 0,
                            bottom: 0,
                            right: 0,
                            left: 0
                        };
                        if ("number" == typeof (r = t.e({
                            padding: o,
                            offset: [
                                0,
                                0
                            ],
                            maxZoom: this.transform.maxZoom
                        }, r)).padding) {
                            var _$e = r.padding;
                            r.padding = {
                                top: _$e,
                                bottom: _$e,
                                right: _$e,
                                left: _$e
                            };
                        }
                        var s = t.e(o, r.padding);
                        r.padding = s;
                        var n = this.transform, l = new $(e1, i);
                        return this.cameraHelper.cameraForBoxAndBearing(r, s, l, a, n);
                    }
                },
                {
                    key: "fitBounds",
                    value: function fitBounds(e1, t, i) {
                        return this._fitInternal(this.cameraForBounds(e1, t), t, i);
                    }
                },
                {
                    key: "fitScreenCoordinates",
                    value: function fitScreenCoordinates(e1, i, a, r, o) {
                        return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation(t.P.convert(e1)), this.transform.screenPointToLocation(t.P.convert(i)), a, r), r, o);
                    }
                },
                {
                    key: "_fitInternal",
                    value: function _fitInternal(e1, i, a) {
                        return e1 ? (delete (i = t.e(e1, i)).padding, i.linear ? this.easeTo(i, a) : this.flyTo(i, a)) : this;
                    }
                },
                {
                    key: "jumpTo",
                    value: function jumpTo(e1, i) {
                        this.stop();
                        var a = this._getTransformForUpdate();
                        var r = !1, o = !1, s = !1;
                        var n = a.zoom;
                        this.cameraHelper.handleJumpToCenterZoom(a, e1);
                        var l = a.zoom !== n;
                        return "elevation" in e1 && a.elevation !== +e1.elevation && a.setElevation(+e1.elevation), "bearing" in e1 && a.bearing !== +e1.bearing && (r = !0, a.setBearing(+e1.bearing)), "pitch" in e1 && a.pitch !== +e1.pitch && (o = !0, a.setPitch(+e1.pitch)), "roll" in e1 && a.roll !== +e1.roll && (s = !0, a.setRoll(+e1.roll)), null == e1.padding || a.isPaddingEqual(e1.padding) || a.setPadding(e1.padding), this._applyUpdatedTransform(a), this.fire(new t.l("movestart", i)).fire(new t.l("move", i)), l && this.fire(new t.l("zoomstart", i)).fire(new t.l("zoom", i)).fire(new t.l("zoomend", i)), r && this.fire(new t.l("rotatestart", i)).fire(new t.l("rotate", i)).fire(new t.l("rotateend", i)), o && this.fire(new t.l("pitchstart", i)).fire(new t.l("pitch", i)).fire(new t.l("pitchend", i)), s && this.fire(new t.l("rollstart", i)).fire(new t.l("roll", i)).fire(new t.l("rollend", i)), this.fire(new t.l("moveend", i));
                    }
                },
                {
                    key: "calculateCameraOptionsFromTo",
                    value: function calculateCameraOptionsFromTo(e1, i, a) {
                        var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
                        var o = t.a9.fromLngLat(e1, i), s = t.a9.fromLngLat(a, r), n = s.x - o.x, l = s.y - o.y, _$c = s.z - o.z, h = Math.hypot(n, l, _$c);
                        if (0 === h) throw new Error("Can't calculate camera options with same From and To");
                        var u = Math.hypot(n, l), d = t.at(this.transform.cameraToCenterDistance / h / this.transform.tileSize), _ = 180 * Math.atan2(n, -l) / Math.PI;
                        var p = 180 * Math.acos(u / h) / Math.PI;
                        return p = _$c < 0 ? 90 - p : 90 + p, {
                            center: s.toLngLat(),
                            elevation: r,
                            zoom: d,
                            pitch: p,
                            bearing: _
                        };
                    }
                },
                {
                    key: "calculateCameraOptionsFromCameraLngLatAltRotation",
                    value: function calculateCameraOptionsFromCameraLngLatAltRotation(e1, t, i, a, r) {
                        var o = this.transform.calculateCenterFromCameraLngLatAlt(e1, t, i, a);
                        return {
                            center: o.center,
                            elevation: o.elevation,
                            zoom: o.zoom,
                            bearing: i,
                            pitch: a,
                            roll: r
                        };
                    }
                },
                {
                    key: "easeTo",
                    value: function easeTo(e1, i) {
                        var _this = this;
                        this._stop(!1, e1.easeId), (!1 === (e1 = t.e({
                            offset: [
                                0,
                                0
                            ],
                            duration: 500,
                            easing: t.cy
                        }, e1)).animate || !e1.essential && n.prefersReducedMotion) && (e1.duration = 0);
                        var a = this._getTransformForUpdate(), r = this.getBearing(), o = a.pitch, s = a.roll, l = "bearing" in e1 ? this._normalizeBearing(e1.bearing, r) : r, _$c = "pitch" in e1 ? +e1.pitch : o, h = "roll" in e1 ? this._normalizeBearing(e1.roll, s) : s, u = "padding" in e1 ? e1.padding : a.padding, d = t.P.convert(e1.offset);
                        var _, p;
                        e1.around && (_ = t.V.convert(e1.around), p = a.locationToScreenPoint(_));
                        var m = {
                            moving: this._moving,
                            zooming: this._zooming,
                            rotating: this._rotating,
                            pitching: this._pitching,
                            rolling: this._rolling
                        }, f = this.cameraHelper.handleEaseTo(a, {
                            bearing: l,
                            pitch: _$c,
                            roll: h,
                            padding: u,
                            around: _,
                            aroundPoint: p,
                            offsetAsPoint: d,
                            offset: e1.offset,
                            zoom: e1.zoom,
                            center: e1.center
                        });
                        return this._rotating = this._rotating || r !== l, this._pitching = this._pitching || _$c !== o, this._rolling = this._rolling || h !== s, this._padding = !a.isPaddingEqual(u), this._zooming = this._zooming || f.isZooming, this._easeId = e1.easeId, this._prepareEase(i, e1.noMoveStart, m), this.terrain && this._prepareElevation(f.elevationCenter), this._ease(function(t) {
                            f.easeFunc(t), _this.terrain && !e1.freezeElevation && _this._updateElevation(t), _this._applyUpdatedTransform(a), _this._fireMoveEvents(i);
                        }, function(t) {
                            _this.terrain && e1.freezeElevation && _this._finalizeElevation(), _this._afterEase(i, t);
                        }, e1), this;
                    }
                },
                {
                    key: "_prepareEase",
                    value: function _prepareEase(e1, i) {
                        var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        this._moving = !0, i || a.moving || this.fire(new t.l("movestart", e1)), this._zooming && !a.zooming && this.fire(new t.l("zoomstart", e1)), this._rotating && !a.rotating && this.fire(new t.l("rotatestart", e1)), this._pitching && !a.pitching && this.fire(new t.l("pitchstart", e1)), this._rolling && !a.rolling && this.fire(new t.l("rollstart", e1));
                    }
                },
                {
                    key: "_prepareElevation",
                    value: function _prepareElevation(e1) {
                        this._elevationCenter = e1, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(e1, this.transform.tileZoom), this._elevationFreeze = !0;
                    }
                },
                {
                    key: "_updateElevation",
                    value: function _updateElevation(e1) {
                        void 0 !== this._elevationStart && void 0 !== this._elevationCenter || this._prepareElevation(this.transform.center), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom));
                        var i = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                        if (e1 < 1 && i !== this._elevationTarget) {
                            var _$t = this._elevationTarget - this._elevationStart;
                            this._elevationStart += e1 * (_$t - (i - (_$t * e1 + this._elevationStart)) / (1 - e1)), this._elevationTarget = i;
                        }
                        this.transform.setElevation(t.G.number(this._elevationStart, this._elevationTarget, e1));
                    }
                },
                {
                    key: "_finalizeElevation",
                    value: function _finalizeElevation() {
                        this._elevationFreeze = !1, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
                    }
                },
                {
                    key: "_getTransformForUpdate",
                    value: function _getTransformForUpdate() {
                        return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
                    }
                },
                {
                    key: "_elevateCameraIfInsideTerrain",
                    value: function _elevateCameraIfInsideTerrain(e1) {
                        if (!this.terrain && e1.elevation >= 0 && e1.pitch <= 90) return {};
                        var _$t = e1.getCameraLngLat(), i = e1.getCameraAltitude(), a = this.terrain ? this.terrain.getElevationForLngLatZoom(_$t, e1.zoom) : 0;
                        if (i < a) {
                            var i1 = this.calculateCameraOptionsFromTo(_$t, a, e1.center, e1.elevation);
                            return {
                                pitch: i1.pitch,
                                zoom: i1.zoom
                            };
                        }
                        return {};
                    }
                },
                {
                    key: "_applyUpdatedTransform",
                    value: function _applyUpdatedTransform(e1) {
                        var _this = this;
                        var _$t = [];
                        if (_$t.push(function(e1) {
                            return _this._elevateCameraIfInsideTerrain(e1);
                        }), this.transformCameraUpdate && _$t.push(function(e1) {
                            return _this.transformCameraUpdate(e1);
                        }), !_$t.length) return;
                        var i = e1.clone();
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = _$t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                var _$t1 = i.clone(), _e = _$e(_$t1), a = _e.center, r = _e.zoom, o = _e.roll, s = _e.pitch, n = _e.bearing, l = _e.elevation;
                                a && _$t1.setCenter(a), void 0 !== l && _$t1.setElevation(l), void 0 !== r && _$t1.setZoom(r), void 0 !== o && _$t1.setRoll(o), void 0 !== s && _$t1.setPitch(s), void 0 !== n && _$t1.setBearing(n), i.apply(_$t1);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this.transform.apply(i);
                    }
                },
                {
                    key: "_fireMoveEvents",
                    value: function _fireMoveEvents(e1) {
                        this.fire(new t.l("move", e1)), this._zooming && this.fire(new t.l("zoom", e1)), this._rotating && this.fire(new t.l("rotate", e1)), this._pitching && this.fire(new t.l("pitch", e1)), this._rolling && this.fire(new t.l("roll", e1));
                    }
                },
                {
                    key: "_afterEase",
                    value: function _afterEase(e1, i) {
                        if (this._easeId && i && this._easeId === i) return;
                        delete this._easeId;
                        var a = this._zooming, r = this._rotating, o = this._pitching, s = this._rolling;
                        this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._rolling = !1, this._padding = !1, a && this.fire(new t.l("zoomend", e1)), r && this.fire(new t.l("rotateend", e1)), o && this.fire(new t.l("pitchend", e1)), s && this.fire(new t.l("rollend", e1)), this.fire(new t.l("moveend", e1));
                    }
                },
                {
                    key: "flyTo",
                    value: function flyTo(e1, i) {
                        var _this = this;
                        if (!e1.essential && n.prefersReducedMotion) {
                            var a = t.U(e1, [
                                "center",
                                "zoom",
                                "bearing",
                                "pitch",
                                "roll",
                                "elevation",
                                "padding"
                            ]);
                            return this.jumpTo(a, i);
                        }
                        this.stop(), e1 = t.e({
                            offset: [
                                0,
                                0
                            ],
                            speed: 1.2,
                            curve: 1.42,
                            easing: t.cy
                        }, e1);
                        var a1 = this._getTransformForUpdate(), r = a1.bearing, o = a1.pitch, s = a1.roll, l = a1.padding, _$c = "bearing" in e1 ? this._normalizeBearing(e1.bearing, r) : r, h = "pitch" in e1 ? +e1.pitch : o, u = "roll" in e1 ? this._normalizeBearing(e1.roll, s) : s, d = "padding" in e1 ? e1.padding : a1.padding, _ = t.P.convert(e1.offset);
                        var p = a1.centerPoint.add(_);
                        var m = a1.screenPointToLocation(p), f = this.cameraHelper.handleFlyTo(a1, {
                            bearing: _$c,
                            pitch: h,
                            roll: u,
                            padding: d,
                            locationAtOffset: m,
                            offsetAsPoint: _,
                            center: e1.center,
                            minZoom: e1.minZoom,
                            zoom: e1.zoom
                        });
                        var g = e1.curve;
                        var v = Math.max(a1.width, a1.height), x = v / f.scaleOfZoom, b = f.pixelPathLength;
                        "number" == typeof f.scaleOfMinZoom && (g = Math.sqrt(v / f.scaleOfMinZoom / b * 2));
                        var y = g * g;
                        function w(e1) {
                            var _$t = (x * x - v * v + (e1 ? -1 : 1) * y * y * b * b) / (2 * (e1 ? x : v) * y * b);
                            return Math.log(Math.sqrt(_$t * _$t + 1) - _$t);
                        }
                        function T(e1) {
                            return (Math.exp(e1) - Math.exp(-e1)) / 2;
                        }
                        function P(e1) {
                            return (Math.exp(e1) + Math.exp(-e1)) / 2;
                        }
                        var C = w(!1);
                        var I = function I(e1) {
                            return P(C) / P(C + g * e1);
                        }, M = function M(e1) {
                            var _$t;
                            return v * ((P(C) * (T(_$t = C + g * e1) / P(_$t)) - T(C)) / y) / b;
                        }, E = (w(!0) - C) / g;
                        if (Math.abs(b) < 2e-6 || !isFinite(E)) {
                            if (Math.abs(v - x) < 1e-6) return this.easeTo(e1, i);
                            var _$t = x < v ? -1 : 1;
                            E = Math.abs(Math.log(x / v)) / g, M = function() {
                                return 0;
                            }, I = function(e1) {
                                return Math.exp(_$t * g * e1);
                            };
                        }
                        return e1.duration = "duration" in e1 ? +e1.duration : 1e3 * E / ("screenSpeed" in e1 ? +e1.screenSpeed / g : +e1.speed), e1.maxDuration && e1.duration > e1.maxDuration && (e1.duration = 0), this._zooming = !0, this._rotating = r !== _$c, this._pitching = h !== o, this._rolling = u !== s, this._padding = !a1.isPaddingEqual(d), this._prepareEase(i, !1), this.terrain && this._prepareElevation(f.targetCenter), this._ease(function(n) {
                            var m = n * E, g = 1 / I(m), v = M(m);
                            _this._rotating && a1.setBearing(t.G.number(r, _$c, n)), _this._pitching && a1.setPitch(t.G.number(o, h, n)), _this._rolling && a1.setRoll(t.G.number(s, u, n)), _this._padding && (a1.interpolatePadding(l, d, n), p = a1.centerPoint.add(_)), f.easeFunc(n, g, v, p), _this.terrain && !e1.freezeElevation && _this._updateElevation(n), _this._applyUpdatedTransform(a1), _this._fireMoveEvents(i);
                        }, function() {
                            _this.terrain && e1.freezeElevation && _this._finalizeElevation(), _this._afterEase(i);
                        }, e1), this;
                    }
                },
                {
                    key: "isEasing",
                    value: function isEasing() {
                        return !!this._easeFrameId;
                    }
                },
                {
                    key: "stop",
                    value: function stop() {
                        return this._stop();
                    }
                },
                {
                    key: "_stop",
                    value: function _stop(e1, t) {
                        var i;
                        if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                            var _$e = this._onEaseEnd;
                            delete this._onEaseEnd, _$e.call(this, t);
                        }
                        return e1 || null === (i = this.handlers) || void 0 === i || i.stop(!1), this;
                    }
                },
                {
                    key: "_ease",
                    value: function _ease(e1, t, i) {
                        !1 === i.animate || 0 === i.duration ? (e1(1), t()) : (this._easeStart = c(), this._easeOptions = i, this._onEaseFrame = e1, this._onEaseEnd = t, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
                    }
                },
                {
                    key: "_normalizeBearing",
                    value: function _normalizeBearing(e1, i) {
                        e1 = t.W(e1, -180, 180);
                        var a = Math.abs(e1 - i);
                        return Math.abs(e1 - 360 - i) < a && (e1 -= 360), Math.abs(e1 + 360 - i) < a && (e1 += 360), e1;
                    }
                },
                {
                    key: "queryTerrainElevation",
                    value: function queryTerrainElevation(e1) {
                        return this.terrain ? this.terrain.getElevationForLngLat(t.V.convert(e1), this.transform) : null;
                    }
                }
            ]);
            return Xo;
        }(t.E);
        var Ko = {
            compact: !0,
            customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
        };
        var Yo = /*#__PURE__*/ function() {
            function Yo() {
                var _this = this;
                var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Ko;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Yo);
                this._toggleAttribution = function() {
                    _this._container.classList.contains("maplibregl-compact") && (_this._container.classList.contains("maplibregl-compact-show") ? (_this._container.setAttribute("open", ""), _this._container.classList.remove("maplibregl-compact-show")) : (_this._container.classList.add("maplibregl-compact-show"), _this._container.removeAttribute("open")));
                }, this._updateData = function(e1) {
                    !e1 || "metadata" !== e1.sourceDataType && "visibility" !== e1.sourceDataType && "style" !== e1.dataType && "terrain" !== e1.type || _this._updateAttributions();
                }, this._updateCompact = function() {
                    _this._map.getCanvasContainer().offsetWidth <= 640 || _this._compact ? !1 === _this._compact ? _this._container.setAttribute("open", "") : _this._container.classList.contains("maplibregl-compact") || _this._container.classList.contains("maplibregl-attrib-empty") || (_this._container.setAttribute("open", ""), _this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (_this._container.setAttribute("open", ""), _this._container.classList.contains("maplibregl-compact") && _this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                }, this._updateCompactMinimize = function() {
                    _this._container.classList.contains("maplibregl-compact") && _this._container.classList.contains("maplibregl-compact-show") && _this._container.classList.remove("maplibregl-compact-show");
                }, this.options = _$e;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Yo, [
                {
                    key: "getDefaultPosition",
                    value: function getDefaultPosition() {
                        return "bottom-right";
                    }
                },
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        return this._map = e1, this._compact = this.options.compact, this._container = h.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = h.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = h.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        h.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
                    }
                },
                {
                    key: "_setElementTitle",
                    value: function _setElementTitle(e1, t) {
                        var i = this._map._getUIString("AttributionControl.".concat(t));
                        e1.title = i, e1.setAttribute("aria-label", i);
                    }
                },
                {
                    key: "_updateAttributions",
                    value: function _updateAttributions() {
                        if (!this._map.style) return;
                        var _$e = [];
                        if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? _$e = _$e.concat(this.options.customAttribution.map(function(e1) {
                            return "string" != typeof e1 ? "" : e1;
                        })) : "string" == typeof this.options.customAttribution && _$e.push(this.options.customAttribution)), this._map.style.stylesheet) {
                            var _$e1 = this._map.style.stylesheet;
                            this.styleOwner = _$e1.owner, this.styleId = _$e1.id;
                        }
                        var _$t = this._map.style.tileManagers;
                        for(var i in _$t){
                            var a = _$t[i];
                            if (a.used || a.usedForTerrain) {
                                var _$t1 = a.getSource();
                                _$t1.attribution && _$e.indexOf(_$t1.attribution) < 0 && _$e.push(_$t1.attribution);
                            }
                        }
                        _$e = _$e.filter(function(e1) {
                            return String(e1).trim();
                        }), _$e.sort(function(e1, t) {
                            return e1.length - t.length;
                        }), _$e = _$e.filter(function(t, i) {
                            for(var a = i + 1; a < _$e.length; a++)if (_$e[a].indexOf(t) >= 0) return !1;
                            return !0;
                        });
                        var i1 = _$e.join(" | ");
                        i1 !== this._attribHTML && (this._attribHTML = i1, _$e.length ? (this._innerContainer.innerHTML = h.sanitize(i1), this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
                    }
                }
            ]);
            return Yo;
        }();
        var Qo = /*#__PURE__*/ function() {
            function Qo() {
                var _this = this;
                var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Qo);
                this._updateCompact = function() {
                    var _$e = _this._container.children;
                    if (_$e.length) {
                        var _$t = _$e[0];
                        _this._map.getCanvasContainer().offsetWidth <= 640 || _this._compact ? !1 !== _this._compact && _$t.classList.add("maplibregl-compact") : _$t.classList.remove("maplibregl-compact");
                    }
                }, this.options = _$e;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Qo, [
                {
                    key: "getDefaultPosition",
                    value: function getDefaultPosition() {
                        return "bottom-left";
                    }
                },
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        this._map = e1, this._compact = this.options && this.options.compact, this._container = h.create("div", "maplibregl-ctrl");
                        var _$t = h.create("a", "maplibregl-ctrl-logo");
                        return _$t.target = "_blank", _$t.rel = "noopener nofollow", _$t.href = "https://maplibre.org/", _$t.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), _$t.setAttribute("rel", "noopener nofollow"), this._container.appendChild(_$t), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        h.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
                    }
                }
            ]);
            return Qo;
        }();
        var Jo = /*#__PURE__*/ function() {
            function Jo() {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, Jo);
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(Jo, [
                {
                    key: "add",
                    value: function add(e1) {
                        var _$t = ++this._id;
                        return this._queue.push({
                            callback: e1,
                            id: _$t,
                            cancelled: !1
                        }), _$t;
                    }
                },
                {
                    key: "remove",
                    value: function remove(e1) {
                        var _$t = this._currentlyRunning, i = _$t ? this._queue.concat(_$t) : this._queue;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t1 = _step.value;
                                if (_$t1.id === e1) return void (_$t1.cancelled = !0);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "run",
                    value: function run() {
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
                        if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                        var _$t = this._currentlyRunning = this._queue;
                        this._queue = [];
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = _$t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var i = _step.value;
                                if (!i.cancelled && (i.callback(_$e), this._cleared)) break;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._cleared = !1, this._currentlyRunning = !1;
                    }
                },
                {
                    key: "clear",
                    value: function clear() {
                        this._currentlyRunning && (this._cleared = !0), this._queue = [];
                    }
                }
            ]);
            return Jo;
        }();
        var es = t.aU([
            {
                name: "a_pos3d",
                type: "Int16",
                components: 3
            }
        ]);
        var ts = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ts, _t_E);
            function ts(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ts);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ts), _this._lastTilesetChange = c(), _this.tileManager = e1, _this._tiles = {}, _this._renderableTilesKeys = [], _this._sourceTileCache = {}, _this.minzoom = 0, _this.maxzoom = 22, _this.deltaZoom = 1, _this.tileSize = e1._source.tileSize * Math.pow(2, _this.deltaZoom), e1.usedForTerrain = !0, e1.tileSize = _this.tileSize;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ts, [
                {
                    key: "destruct",
                    value: function destruct() {
                        this.tileManager.usedForTerrain = !1, this.tileManager.tileSize = null;
                    }
                },
                {
                    key: "getSource",
                    value: function getSource() {
                        return this.tileManager._source;
                    }
                },
                {
                    key: "update",
                    value: function update(e1, i) {
                        this.tileManager.update(e1, i), this._renderableTilesKeys = [];
                        var a = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Ie(e1, {
                                tileSize: this.tileSize,
                                minzoom: this.minzoom,
                                maxzoom: this.maxzoom,
                                reparseOverscaled: !1,
                                terrain: i,
                                calculateTileZoom: this.tileManager._source.calculateTileZoom
                            })[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var r = _step.value;
                                a[r.key] = !0, this._renderableTilesKeys.push(r.key), this._tiles[r.key] || (r.terrainRttPosMatrix32f = new Float64Array(16), t.c7(r.terrainRttPosMatrix32f, 0, t.a5, t.a5, 0, 0, 1), this._tiles[r.key] = new de(r, this.tileSize), this._lastTilesetChange = c());
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        for(var _$e in this._tiles)a[_$e] || delete this._tiles[_$e];
                    }
                },
                {
                    key: "freeRtt",
                    value: function freeRtt(e1) {
                        for(var _$t in this._tiles){
                            var i = this._tiles[_$t];
                            (!e1 || i.tileID.equals(e1) || i.tileID.isChildOf(e1) || e1.isChildOf(i.tileID)) && (i.rtt = []);
                        }
                    }
                },
                {
                    key: "getRenderableTiles",
                    value: function getRenderableTiles() {
                        var _this = this;
                        return this._renderableTilesKeys.map(function(e1) {
                            return _this.getTileByID(e1);
                        });
                    }
                },
                {
                    key: "getTileByID",
                    value: function getTileByID(e1) {
                        return this._tiles[e1];
                    }
                },
                {
                    key: "getTerrainCoords",
                    value: function getTerrainCoords(e1, t) {
                        return t ? this._getTerrainCoordsForTileRanges(e1, t) : this._getTerrainCoordsForRegularTile(e1);
                    }
                },
                {
                    key: "_getTerrainCoordsForRegularTile",
                    value: function _getTerrainCoordsForRegularTile(e1) {
                        var i = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._renderableTilesKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var a = _step.value;
                                var r = this._tiles[a].tileID, o = e1.clone(), s = t.bk();
                                if (r.canonical.equals(e1.canonical)) t.c7(s, 0, t.a5, t.a5, 0, 0, 1);
                                else if (r.canonical.isChildOf(e1.canonical)) {
                                    var i1 = r.canonical.z - e1.canonical.z, a1 = r.canonical.x - (r.canonical.x >> i1 << i1), o1 = r.canonical.y - (r.canonical.y >> i1 << i1), n = t.a5 >> i1;
                                    t.c7(s, 0, n, n, 0, 0, 1), t.O(s, s, [
                                        -a1 * n,
                                        -o1 * n,
                                        0
                                    ]);
                                } else {
                                    if (!e1.canonical.isChildOf(r.canonical)) continue;
                                    {
                                        var i2 = e1.canonical.z - r.canonical.z, a2 = e1.canonical.x - (e1.canonical.x >> i2 << i2), o2 = e1.canonical.y - (e1.canonical.y >> i2 << i2), n1 = t.a5 >> i2;
                                        t.c7(s, 0, t.a5, t.a5, 0, 0, 1), t.O(s, s, [
                                            a2 * n1,
                                            o2 * n1,
                                            0
                                        ]), t.Q(s, s, [
                                            1 / Math.pow(2, i2),
                                            1 / Math.pow(2, i2),
                                            0
                                        ]);
                                    }
                                }
                                o.terrainRttPosMatrix32f = new Float32Array(s), i[a] = o;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return i;
                    }
                },
                {
                    key: "_getTerrainCoordsForTileRanges",
                    value: function _getTerrainCoordsForTileRanges(e1, i) {
                        var a = {};
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._renderableTilesKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var r = _step.value;
                                var o = this._tiles[r].tileID;
                                if (!this._isWithinTileRanges(o, i)) continue;
                                var s = e1.clone(), n = t.bk();
                                if (o.canonical.z === e1.canonical.z) {
                                    var _$i = e1.canonical.x - o.canonical.x, a1 = e1.canonical.y - o.canonical.y;
                                    t.c7(n, 0, t.a5, t.a5, 0, 0, 1), t.O(n, n, [
                                        _$i * t.a5,
                                        a1 * t.a5,
                                        0
                                    ]);
                                } else if (o.canonical.z > e1.canonical.z) {
                                    var _$i1 = o.canonical.z - e1.canonical.z, a2 = o.canonical.x - (o.canonical.x >> _$i1 << _$i1), r1 = o.canonical.y - (o.canonical.y >> _$i1 << _$i1), s1 = e1.canonical.x - (o.canonical.x >> _$i1), l = e1.canonical.y - (o.canonical.y >> _$i1), _$c = t.a5 >> _$i1;
                                    t.c7(n, 0, _$c, _$c, 0, 0, 1), t.O(n, n, [
                                        -a2 * _$c + s1 * t.a5,
                                        -r1 * _$c + l * t.a5,
                                        0
                                    ]);
                                } else {
                                    var _$i2 = e1.canonical.z - o.canonical.z, a3 = e1.canonical.x - (e1.canonical.x >> _$i2 << _$i2), r2 = e1.canonical.y - (e1.canonical.y >> _$i2 << _$i2), s2 = (e1.canonical.x >> _$i2) - o.canonical.x, l1 = (e1.canonical.y >> _$i2) - o.canonical.y, _$c1 = t.a5 << _$i2;
                                    t.c7(n, 0, _$c1, _$c1, 0, 0, 1), t.O(n, n, [
                                        a3 * t.a5 + s2 * _$c1,
                                        r2 * t.a5 + l1 * _$c1,
                                        0
                                    ]);
                                }
                                s.terrainRttPosMatrix32f = new Float32Array(n), a[r] = s;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return a;
                    }
                },
                {
                    key: "getSourceTile",
                    value: function getSourceTile(e1, t) {
                        var i = this.tileManager._source;
                        var a = e1.overscaledZ - this.deltaZoom;
                        if (a > i.maxzoom && (a = i.maxzoom), a < i.minzoom) return;
                        this._sourceTileCache[e1.key] || (this._sourceTileCache[e1.key] = e1.scaledTo(a).key);
                        var r = this.findTileInCaches(this._sourceTileCache[e1.key]);
                        if (!(null == r ? void 0 : r.dem) && t) for(; a >= i.minzoom && !(null == r ? void 0 : r.dem);)r = this.findTileInCaches(e1.scaledTo(a--).key);
                        return r;
                    }
                },
                {
                    key: "findTileInCaches",
                    value: function findTileInCaches(e1) {
                        var _$t = this.tileManager.getTileByID(e1);
                        return _$t || (_$t = this.tileManager._outOfViewCache.getByKey(e1), _$t);
                    }
                },
                {
                    key: "anyTilesAfterTime",
                    value: function anyTilesAfterTime() {
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : Date.now();
                        return this._lastTilesetChange >= _$e;
                    }
                },
                {
                    key: "_isWithinTileRanges",
                    value: function _isWithinTileRanges(e1, t) {
                        return t[e1.canonical.z] && e1.canonical.x >= t[e1.canonical.z].minTileX && e1.canonical.x <= t[e1.canonical.z].maxTileX && e1.canonical.y >= t[e1.canonical.z].minTileY && e1.canonical.y <= t[e1.canonical.z].maxTileY;
                    }
                }
            ]);
            return ts;
        }(t.E);
        var is = /*#__PURE__*/ function() {
            function is(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, is);
                this._meshCache = {}, this.painter = e1, this.tileManager = new ts(t), this.options = i, this.exaggeration = "number" == typeof i.exaggeration ? i.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(is, [
                {
                    key: "getDEMElevation",
                    value: function getDEMElevation(e1, i, a) {
                        var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : t.a5;
                        var o;
                        if (!(i >= 0 && i < r && a >= 0 && a < r)) return 0;
                        var s = this.getTerrainData(e1), n = null === (o = s.tile) || void 0 === o ? void 0 : o.dem;
                        if (!n) return 0;
                        var l = t.cC([], [
                            i / r * t.a5,
                            a / r * t.a5
                        ], s.u_terrain_matrix), _$c = [
                            l[0] * n.dim,
                            l[1] * n.dim
                        ], h = Math.floor(_$c[0]), u = Math.floor(_$c[1]), d = _$c[0] - h, _ = _$c[1] - u;
                        return n.get(h, u) * (1 - d) * (1 - _) + n.get(h + 1, u) * d * (1 - _) + n.get(h, u + 1) * (1 - d) * _ + n.get(h + 1, u + 1) * d * _;
                    }
                },
                {
                    key: "getElevationForLngLatZoom",
                    value: function getElevationForLngLatZoom(e1, i) {
                        if (!t.cD(i, e1.wrap())) return 0;
                        var _this__getOverscaledTileIDFromLngLatZoom = this._getOverscaledTileIDFromLngLatZoom(e1, i), a = _this__getOverscaledTileIDFromLngLatZoom.tileID, r = _this__getOverscaledTileIDFromLngLatZoom.mercatorX, o = _this__getOverscaledTileIDFromLngLatZoom.mercatorY;
                        return this.getElevation(a, r % t.a5, o % t.a5, t.a5);
                    }
                },
                {
                    key: "getElevationForLngLat",
                    value: function getElevationForLngLat(e1, t) {
                        var i = Ie(t, {
                            maxzoom: this.tileManager.maxzoom,
                            minzoom: this.tileManager.minzoom,
                            tileSize: 512,
                            terrain: this
                        });
                        var a = 0;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                _$e.canonical.z > a && (a = Math.min(_$e.canonical.z, this.tileManager.maxzoom));
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return this.getElevationForLngLatZoom(e1, a);
                    }
                },
                {
                    key: "getElevation",
                    value: function getElevation(e1, i, a) {
                        var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : t.a5;
                        return this.getDEMElevation(e1, i, a, r) * this.exaggeration;
                    }
                },
                {
                    key: "getTerrainData",
                    value: function getTerrainData(e1) {
                        if (!this._emptyDemTexture) {
                            var _$e = this.painter.context, i = new t.R({
                                width: 1,
                                height: 1
                            }, new Uint8Array(4));
                            this._emptyDepthTexture = new t.T(_$e, i, _$e.gl.RGBA, {
                                premultiply: !1
                            }), this._emptyDemUnpack = [
                                0,
                                0,
                                0,
                                0
                            ], this._emptyDemTexture = new t.T(_$e, new t.R({
                                width: 1,
                                height: 1
                            }), _$e.gl.RGBA, {
                                premultiply: !1
                            }), this._emptyDemTexture.bind(_$e.gl.NEAREST, _$e.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = t.ar([]);
                        }
                        var i1 = this.tileManager.getSourceTile(e1, !0);
                        if (i1 && i1.dem && (!i1.demTexture || i1.needsTerrainPrepare)) {
                            var _$e1 = this.painter.context;
                            i1.demTexture = this.painter.getTileTexture(i1.dem.stride), i1.demTexture ? i1.demTexture.update(i1.dem.getPixels(), {
                                premultiply: !1
                            }) : i1.demTexture = new t.T(_$e1, i1.dem.getPixels(), _$e1.gl.RGBA, {
                                premultiply: !1
                            }), i1.demTexture.bind(_$e1.gl.NEAREST, _$e1.gl.CLAMP_TO_EDGE), i1.needsTerrainPrepare = !1;
                        }
                        var a = i1 && i1.toString() + i1.tileID.key + e1.key;
                        if (a && !this._demMatrixCache[a]) {
                            var a1 = this.tileManager.getSource().maxzoom;
                            var r = e1.canonical.z - i1.tileID.canonical.z;
                            e1.overscaledZ > e1.canonical.z && (e1.canonical.z >= a1 ? r = e1.canonical.z - a1 : t.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                            var o = e1.canonical.x - (e1.canonical.x >> r << r), s = e1.canonical.y - (e1.canonical.y >> r << r), n = t.cE(new Float64Array(16), [
                                1 / (t.a5 << r),
                                1 / (t.a5 << r),
                                0
                            ]);
                            t.O(n, n, [
                                o * t.a5,
                                s * t.a5,
                                0
                            ]), this._demMatrixCache[e1.key] = {
                                matrix: n,
                                coord: e1
                            };
                        }
                        return {
                            u_depth: 2,
                            u_terrain: 3,
                            u_terrain_dim: i1 && i1.dem && i1.dem.dim || 1,
                            u_terrain_matrix: a ? this._demMatrixCache[e1.key].matrix : this._emptyDemMatrix,
                            u_terrain_unpack: i1 && i1.dem && i1.dem.getUnpackVector() || this._emptyDemUnpack,
                            u_terrain_exaggeration: this.exaggeration,
                            texture: (i1 && i1.demTexture || this._emptyDemTexture).texture,
                            depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                            tile: i1
                        };
                    }
                },
                {
                    key: "getFramebuffer",
                    value: function getFramebuffer(e1) {
                        var i = this.painter, a = i.width / devicePixelRatio, r = i.height / devicePixelRatio;
                        return !this._fbo || this._fbo.width === a && this._fbo.height === r || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new t.T(i.context, {
                            width: a,
                            height: r,
                            data: null
                        }, i.context.gl.RGBA, {
                            premultiply: !1
                        }), this._fboCoordsTexture.bind(i.context.gl.NEAREST, i.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new t.T(i.context, {
                            width: a,
                            height: r,
                            data: null
                        }, i.context.gl.RGBA, {
                            premultiply: !1
                        }), this._fboDepthTexture.bind(i.context.gl.NEAREST, i.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = i.context.createFramebuffer(a, r, !0, !1), this._fbo.depthAttachment.set(i.context.createRenderbuffer(i.context.gl.DEPTH_COMPONENT16, a, r))), this._fbo.colorAttachment.set("coords" === e1 ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
                    }
                },
                {
                    key: "getCoordsTexture",
                    value: function getCoordsTexture() {
                        var _$e = this.painter.context;
                        if (this._coordsTexture) return this._coordsTexture;
                        var i = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                        for(var _$e1 = 0, _$t = 0; _$e1 < this._coordsTextureSize; _$e1++)for(var a = 0; a < this._coordsTextureSize; a++, _$t += 4)i[_$t + 0] = 255 & a, i[_$t + 1] = 255 & _$e1, i[_$t + 2] = a >> 8 << 4 | _$e1 >> 8, i[_$t + 3] = 0;
                        var a1 = new t.R({
                            width: this._coordsTextureSize,
                            height: this._coordsTextureSize
                        }, new Uint8Array(i.buffer)), r = new t.T(_$e, a1, _$e.gl.RGBA, {
                            premultiply: !1
                        });
                        return r.bind(_$e.gl.NEAREST, _$e.gl.CLAMP_TO_EDGE), this._coordsTexture = r, r;
                    }
                },
                {
                    key: "pointCoordinate",
                    value: function pointCoordinate(e1) {
                        this.painter.maybeDrawDepthAndCoords(!0);
                        var i = new Uint8Array(4), a = this.painter.context, r = a.gl, o = Math.round(e1.x * this.painter.pixelRatio / devicePixelRatio), s = Math.round(e1.y * this.painter.pixelRatio / devicePixelRatio), n = Math.round(this.painter.height / devicePixelRatio);
                        a.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), r.readPixels(o, n - s - 1, 1, 1, r.RGBA, r.UNSIGNED_BYTE, i), a.bindFramebuffer.set(null);
                        var l = i[0] + (i[2] >> 4 << 8), _$c = i[1] + ((15 & i[2]) << 8), h = this.coordsIndex[255 - i[3]], u = h && this.tileManager.getTileByID(h);
                        if (!u) return null;
                        var d = this._coordsTextureSize, _ = (1 << u.tileID.canonical.z) * d;
                        return new t.a9((u.tileID.canonical.x * d + l) / _ + u.tileID.wrap, (u.tileID.canonical.y * d + _$c) / _, this.getElevation(u.tileID, l, _$c, d));
                    }
                },
                {
                    key: "depthAtPoint",
                    value: function depthAtPoint(e1) {
                        var _$t = new Uint8Array(4), i = this.painter.context, a = i.gl;
                        return i.bindFramebuffer.set(this.getFramebuffer("depth").framebuffer), a.readPixels(e1.x, this.painter.height / devicePixelRatio - e1.y - 1, 1, 1, a.RGBA, a.UNSIGNED_BYTE, _$t), i.bindFramebuffer.set(null), (_$t[0] / 16777216 + _$t[1] / 65536 + _$t[2] / 256 + _$t[3]) / 256;
                    }
                },
                {
                    key: "getTerrainMesh",
                    value: function getTerrainMesh(e1) {
                        var i;
                        var a = (null === (i = this.painter.style.projection) || void 0 === i ? void 0 : i.transitionState) > 0, r = a && 0 === e1.canonical.y, o = a && e1.canonical.y === (1 << e1.canonical.z) - 1, s = "m_".concat(r ? "n" : "", "_").concat(o ? "s" : "");
                        if (this._meshCache[s]) return this._meshCache[s];
                        var n = this.painter.context, l = new t.cF, _$c = new t.aY, h = this.meshSize, u = t.a5 / h, d = h * h;
                        for(var _$e = 0; _$e <= h; _$e++)for(var _$t = 0; _$t <= h; _$t++)l.emplaceBack(_$t * u, _$e * u, 0);
                        for(var _$e1 = 0; _$e1 < d; _$e1 += h + 1)for(var _$t1 = 0; _$t1 < h; _$t1++)_$c.emplaceBack(_$t1 + _$e1, h + _$t1 + _$e1 + 1, h + _$t1 + _$e1 + 2), _$c.emplaceBack(_$t1 + _$e1, h + _$t1 + _$e1 + 2, _$t1 + _$e1 + 1);
                        var _ = l.length, p = _ + (h + 1), m = (h + 1) * h, f = r ? t.br : 0, g = r ? 0 : 1, v = o ? t.bs : t.a5, x = o ? 0 : 1;
                        for(var _$e2 = 0; _$e2 <= h; _$e2++)l.emplaceBack(_$e2 * u, f, g);
                        for(var _$e3 = 0; _$e3 <= h; _$e3++)l.emplaceBack(_$e3 * u, v, x);
                        for(var _$e4 = 0; _$e4 < h; _$e4++)_$c.emplaceBack(m + _$e4, p + _$e4, p + _$e4 + 1), _$c.emplaceBack(m + _$e4, p + _$e4 + 1, m + _$e4 + 1), _$c.emplaceBack(0 + _$e4, _ + _$e4 + 1, _ + _$e4), _$c.emplaceBack(0 + _$e4, 0 + _$e4 + 1, _ + _$e4 + 1);
                        var b = l.length, y = b + 2 * (h + 1);
                        for(var _i = 0, _iter = [
                            0,
                            1
                        ]; _i < _iter.length; _i++){
                            var _$e5 = _iter[_i];
                            for(var i1 = 0; i1 <= h; i1++)for(var _i1 = 0, _iter1 = [
                                0,
                                1
                            ]; _i1 < _iter1.length; _i1++){
                                var a1 = _iter1[_i1];
                                l.emplaceBack(_$e5 * t.a5, i1 * u, a1);
                            }
                        }
                        for(var _$e6 = 0; _$e6 < 2 * h; _$e6 += 2)_$c.emplaceBack(b + _$e6, b + _$e6 + 1, b + _$e6 + 3), _$c.emplaceBack(b + _$e6, b + _$e6 + 3, b + _$e6 + 2), _$c.emplaceBack(y + _$e6, y + _$e6 + 3, y + _$e6 + 1), _$c.emplaceBack(y + _$e6, y + _$e6 + 2, y + _$e6 + 3);
                        var w = new kt(n.createVertexBuffer(l, es.members), n.createIndexBuffer(_$c), t.aX.simpleSegment(0, 0, l.length, _$c.length));
                        return this._meshCache[s] = w, w;
                    }
                },
                {
                    key: "getMeshFrameDelta",
                    value: function getMeshFrameDelta(e1) {
                        return 2 * Math.PI * t.bE / Math.pow(2, Math.max(e1, 0)) / 5;
                    }
                },
                {
                    key: "getMinTileElevationForLngLatZoom",
                    value: function getMinTileElevationForLngLatZoom(e1, i) {
                        var a;
                        if (!t.cD(i, e1.wrap())) return 0;
                        var _this__getOverscaledTileIDFromLngLatZoom = this._getOverscaledTileIDFromLngLatZoom(e1, i), r = _this__getOverscaledTileIDFromLngLatZoom.tileID;
                        return null !== (a = this.getMinMaxElevation(r).minElevation) && void 0 !== a ? a : 0;
                    }
                },
                {
                    key: "getMinMaxElevation",
                    value: function getMinMaxElevation(e1) {
                        var _$t = this.getTerrainData(e1).tile, i = {
                            minElevation: null,
                            maxElevation: null
                        };
                        return _$t && _$t.dem && (i.minElevation = _$t.dem.min * this.exaggeration, i.maxElevation = _$t.dem.max * this.exaggeration), i;
                    }
                },
                {
                    key: "_getOverscaledTileIDFromLngLatZoom",
                    value: function _getOverscaledTileIDFromLngLatZoom(e1, i) {
                        var a = t.a9.fromLngLat(e1.wrap()), r = (1 << i) * t.a5, o = a.x * r, s = a.y * r, n = Math.floor(o / t.a5), l = Math.floor(s / t.a5);
                        return {
                            tileID: new t.a2(i, 0, i, n, l),
                            mercatorX: o,
                            mercatorY: s
                        };
                    }
                }
            ]);
            return is;
        }();
        var as = /*#__PURE__*/ function() {
            function as(e1, t, i) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, as);
                this._context = e1, this._size = t, this._tileSize = i, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(as, [
                {
                    key: "destruct",
                    value: function destruct() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._objects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                _$e.texture.destroy(), _$e.fbo.destroy();
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "_createObject",
                    value: function _createObject(e1) {
                        var i = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), a = new t.T(this._context, {
                            width: this._tileSize,
                            height: this._tileSize,
                            data: null
                        }, this._context.gl.RGBA);
                        return a.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), this._context.extTextureFilterAnisotropic && this._context.gl.texParameterf(this._context.gl.TEXTURE_2D, this._context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this._context.extTextureFilterAnisotropicMax), i.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), i.colorAttachment.set(a.texture), {
                            id: e1,
                            fbo: i,
                            texture: a,
                            stamp: -1,
                            inUse: !1
                        };
                    }
                },
                {
                    key: "getObjectForId",
                    value: function getObjectForId(e1) {
                        return this._objects[e1];
                    }
                },
                {
                    key: "useObject",
                    value: function useObject(e1) {
                        e1.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter(function(t) {
                            return e1.id !== t;
                        }), this._recentlyUsed.push(e1.id);
                    }
                },
                {
                    key: "stampObject",
                    value: function stampObject(e1) {
                        e1.stamp = ++this._stamp;
                    }
                },
                {
                    key: "getOrCreateFreeObject",
                    value: function getOrCreateFreeObject() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._recentlyUsed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                if (!this._objects[_$e].inUse) return this._objects[_$e];
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                        var _$e1 = this._createObject(this._objects.length);
                        return this._objects.push(_$e1), _$e1;
                    }
                },
                {
                    key: "freeObject",
                    value: function freeObject(e1) {
                        e1.inUse = !1;
                    }
                },
                {
                    key: "freeAllObjects",
                    value: function freeAllObjects() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._objects[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                this.freeObject(_$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                },
                {
                    key: "isFull",
                    value: function isFull() {
                        return !(this._objects.length < this._size) && !1 === this._objects.some(function(e1) {
                            return !e1.inUse;
                        });
                    }
                }
            ]);
            return as;
        }();
        var rs = {
            background: !0,
            fill: !0,
            line: !0,
            raster: !0,
            hillshade: !0,
            "color-relief": !0
        };
        var os = /*#__PURE__*/ function() {
            function os(e1, t) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, os);
                this.painter = e1, this.terrain = t, this.pool = new as(e1.context, 30, t.tileManager.tileSize * t.qualityFactor);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(os, [
                {
                    key: "destruct",
                    value: function destruct() {
                        this.pool.destruct();
                    }
                },
                {
                    key: "getTexture",
                    value: function getTexture(e1) {
                        return this.pool.getObjectForId(e1.rtt[this._stacks.length - 1].id).texture;
                    }
                },
                {
                    key: "prepareForRender",
                    value: function prepareForRender(e1, t) {
                        this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.tileManager.getRenderableTiles(), this._renderableLayerIds = e1._order.filter(function(i) {
                            return !e1._layers[i].isHidden(t);
                        }), this._coordsAscending = {};
                        for(var _$t in e1.tileManagers){
                            this._coordsAscending[_$t] = {};
                            var i = e1.tileManagers[_$t].getVisibleCoordinates(), a = e1.tileManagers[_$t].getSource(), r = a instanceof te ? a.terrainTileRanges : null;
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var _$e = _step.value;
                                    var i1 = this.terrain.tileManager.getTerrainCoords(_$e, r);
                                    for(var _$e1 in i1)this._coordsAscending[_$t][_$e1] || (this._coordsAscending[_$t][_$e1] = []), this._coordsAscending[_$t][_$e1].push(i1[_$e1]);
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        this._coordsAscendingStr = {};
                        var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        try {
                            for(var _iterator1 = e1._order[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                var _$t1 = _step1.value;
                                var i2 = e1._layers[_$t1], a1 = i2.source;
                                if (rs[i2.type] && !this._coordsAscendingStr[a1]) {
                                    this._coordsAscendingStr[a1] = {};
                                    for(var _$e2 in this._coordsAscending[a1])this._coordsAscendingStr[a1][_$e2] = this._coordsAscending[a1][_$e2].map(function(e1) {
                                        return e1.key;
                                    }).sort().join();
                                }
                            }
                        } catch (err) {
                            _didIteratorError1 = true;
                            _iteratorError1 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                    _iterator1.return();
                                }
                            } finally{
                                if (_didIteratorError1) {
                                    throw _iteratorError1;
                                }
                            }
                        }
                        var _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        try {
                            for(var _iterator2 = this._renderableTiles[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                var _$e3 = _step2.value;
                                for(var _$t2 in this._coordsAscendingStr){
                                    var i3 = this._coordsAscendingStr[_$t2][_$e3.tileID.key];
                                    i3 && i3 !== _$e3.rttCoords[_$t2] && (_$e3.rtt = []);
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                },
                {
                    key: "renderLayer",
                    value: function renderLayer(e1, i) {
                        if (e1.isHidden(this.painter.transform.zoom)) return !1;
                        var a = Object.assign(Object.assign({}, i), {
                            isRenderingToTexture: !0
                        }), r = e1.type, o = this.painter, s = this._renderableLayerIds[this._renderableLayerIds.length - 1] === e1.id;
                        if (rs[r] && (this._prevType && rs[this._prevType] || this._stacks.push([]), this._prevType = r, this._stacks[this._stacks.length - 1].push(e1.id), !s)) return !0;
                        if (rs[this._prevType] || rs[r] && s) {
                            this._prevType = r;
                            var _$e = this._stacks.length - 1, _$i = this._stacks[_$e] || [];
                            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(var _iterator = this._renderableTiles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    var r1 = _step.value;
                                    if (this.pool.isFull() && (Ur(this.painter, this.terrain, this._rttTiles, a), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(r1), r1.rtt[_$e]) {
                                        var _$t = this.pool.getObjectForId(r1.rtt[_$e].id);
                                        if (_$t.stamp === r1.rtt[_$e].stamp) {
                                            this.pool.useObject(_$t);
                                            continue;
                                        }
                                    }
                                    var s1 = this.pool.getOrCreateFreeObject();
                                    this.pool.useObject(s1), this.pool.stampObject(s1), r1.rtt[_$e] = {
                                        id: s1.id,
                                        stamp: s1.stamp
                                    }, o.context.bindFramebuffer.set(s1.fbo.framebuffer), o.context.clear({
                                        color: t.bp.transparent,
                                        stencil: 0
                                    }), o.currentStencilSource = void 0;
                                    for(var _$e1 = 0; _$e1 < _$i.length; _$e1++){
                                        var _$t1 = o.style._layers[_$i[_$e1]], n = _$t1.source ? this._coordsAscending[_$t1.source][r1.tileID.key] : [
                                            r1.tileID
                                        ];
                                        o.context.viewport.set([
                                            0,
                                            0,
                                            s1.fbo.width,
                                            s1.fbo.height
                                        ]), o._renderTileClippingMasks(_$t1, n, !0), o.renderLayer(o, o.style.tileManagers[_$t1.source], _$t1, n, a), _$t1.source && (r1.rttCoords[_$t1.source] = this._coordsAscendingStr[_$t1.source][r1.tileID.key]);
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return Ur(this.painter, this.terrain, this._rttTiles, a), this._rttTiles = [], this.pool.freeAllObjects(), rs[r];
                        }
                        return !1;
                    }
                }
            ]);
            return os;
        }();
        var ss = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "AttributionControl.MapFeedback": "Map feedback",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "MapLibre logo",
            "Map.Title": "Map",
            "Marker.Title": "Map marker",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "Popup.Close": "Close popup",
            "ScaleControl.Feet": "ft",
            "ScaleControl.Meters": "m",
            "ScaleControl.Kilometers": "km",
            "ScaleControl.Miles": "mi",
            "ScaleControl.NauticalMiles": "nm",
            "GlobeControl.Enable": "Enable globe",
            "GlobeControl.Disable": "Disable globe",
            "TerrainControl.Enable": "Enable terrain",
            "TerrainControl.Disable": "Disable terrain",
            "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
            "CooperativeGesturesHandler.MacHelpText": "Use \u2318 + scroll to zoom the map",
            "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
        }, ns = i, ls = {
            hash: !1,
            interactive: !0,
            bearingSnap: 7,
            attributionControl: Ko,
            maplibreLogo: !1,
            refreshExpiredTiles: !0,
            canvasContextAttributes: {
                antialias: !1,
                preserveDrawingBuffer: !1,
                powerPreference: "high-performance",
                failIfMajorPerformanceCaveat: !1,
                desynchronized: !1,
                contextType: void 0
            },
            scrollZoom: !0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 60,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            trackResize: !0,
            center: [
                0,
                0
            ],
            elevation: 0,
            zoom: 0,
            bearing: 0,
            pitch: 0,
            roll: 0,
            renderWorldCopies: !0,
            maxTileCacheSize: null,
            maxTileCacheZoomLevels: t.c.MAX_TILE_CACHE_ZOOM_LEVELS,
            transformRequest: null,
            transformCameraUpdate: null,
            transformConstrain: null,
            fadeDuration: 300,
            crossSourceCollisions: !0,
            clickTolerance: 3,
            localIdeographFontFamily: "sans-serif",
            pitchWithRotate: !0,
            rollEnabled: !1,
            reduceMotion: void 0,
            validateStyle: !0,
            maxCanvasSize: [
                4096,
                4096
            ],
            cancelPendingTileRequestsWhileZooming: !0,
            centerClampedToGround: !0,
            experimentalZoomLevelsToOverscale: void 0
        }, cs = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1,
            visualizeRoll: !0
        };
        var hs = /*#__PURE__*/ function() {
            function hs(e1, i) {
                var _this = this;
                var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, hs);
                this.mousedown = function(e1) {
                    _this.startMove(e1, h.mousePos(_this.element, e1)), h.addEventListener(window, "mousemove", _this.mousemove), h.addEventListener(window, "mouseup", _this.mouseup);
                }, this.mousemove = function(e1) {
                    _this.move(e1, h.mousePos(_this.element, e1));
                }, this.mouseup = function(e1) {
                    _this._rotatePitchHandler.dragEnd(e1), _this.offTemp();
                }, this.touchstart = function(e1) {
                    1 !== e1.targetTouches.length ? _this.reset() : (_this._startPos = _this._lastPos = h.touchPos(_this.element, e1.targetTouches)[0], _this.startMove(e1, _this._startPos), h.addEventListener(window, "touchmove", _this.touchmove, {
                        passive: !1
                    }), h.addEventListener(window, "touchend", _this.touchend));
                }, this.touchmove = function(e1) {
                    1 !== e1.targetTouches.length ? _this.reset() : (_this._lastPos = h.touchPos(_this.element, e1.targetTouches)[0], _this.move(e1, _this._lastPos));
                }, this.touchend = function(e1) {
                    0 === e1.targetTouches.length && _this._startPos && _this._lastPos && _this._startPos.dist(_this._lastPos) < _this._clickTolerance && _this.element.click(), delete _this._startPos, delete _this._lastPos, _this.offTemp();
                }, this.reset = function() {
                    _this._rotatePitchHandler.reset(), delete _this._startPos, delete _this._lastPos, _this.offTemp();
                }, this._clickTolerance = 10, this.element = i;
                var r = new yo;
                this._rotatePitchHandler = new mo({
                    clickTolerance: 3,
                    move: function(e1, r) {
                        var o = i.getBoundingClientRect(), s = new t.P((o.bottom - o.top) / 2, (o.right - o.left) / 2);
                        return {
                            bearingDelta: t.cx(new t.P(e1.x, r.y), r, s),
                            pitchDelta: a ? -0.5 * (r.y - e1.y) : void 0
                        };
                    },
                    moveStateManager: r,
                    enable: !0,
                    assignEvents: function() {}
                }), this.map = e1, h.addEventListener(i, "mousedown", this.mousedown), h.addEventListener(i, "touchstart", this.touchstart, {
                    passive: !1
                }), h.addEventListener(i, "touchcancel", this.reset);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(hs, [
                {
                    key: "startMove",
                    value: function startMove(e1, t) {
                        this._rotatePitchHandler.dragStart(e1, t), h.disableDrag();
                    }
                },
                {
                    key: "move",
                    value: function move(e1, t) {
                        var i = this.map, _ref = this._rotatePitchHandler.dragMove(e1, t) || {}, a = _ref.bearingDelta, r = _ref.pitchDelta;
                        a && i.setBearing(i.getBearing() + a), r && i.setPitch(i.getPitch() + r);
                    }
                },
                {
                    key: "off",
                    value: function off() {
                        var _$e = this.element;
                        h.removeEventListener(_$e, "mousedown", this.mousedown), h.removeEventListener(_$e, "touchstart", this.touchstart, {
                            passive: !1
                        }), h.removeEventListener(window, "touchmove", this.touchmove, {
                            passive: !1
                        }), h.removeEventListener(window, "touchend", this.touchend), h.removeEventListener(_$e, "touchcancel", this.reset), this.offTemp();
                    }
                },
                {
                    key: "offTemp",
                    value: function offTemp() {
                        h.enableDrag(), h.removeEventListener(window, "mousemove", this.mousemove), h.removeEventListener(window, "mouseup", this.mouseup), h.removeEventListener(window, "touchmove", this.touchmove, {
                            passive: !1
                        }), h.removeEventListener(window, "touchend", this.touchend);
                    }
                }
            ]);
            return hs;
        }();
        var us;
        function ds(e1, i, a) {
            var r = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : !1;
            if (r || !a.getCoveringTilesDetailsProvider().allowWorldCopies()) return null == e1 ? void 0 : e1.wrap();
            var o = new t.V(e1.lng, e1.lat);
            if (e1 = new t.V(e1.lng, e1.lat), i) {
                var r1 = new t.V(e1.lng - 360, e1.lat), o1 = new t.V(e1.lng + 360, e1.lat), s = a.locationToScreenPoint(e1).distSqr(i);
                a.locationToScreenPoint(r1).distSqr(i) < s ? e1 = r1 : a.locationToScreenPoint(o1).distSqr(i) < s && (e1 = o1);
            }
            for(; Math.abs(e1.lng - a.center.lng) > 180;){
                var _$t = a.locationToScreenPoint(e1);
                if (_$t.x >= 0 && _$t.y >= 0 && _$t.x <= a.width && _$t.y <= a.height) break;
                e1.lng > a.center.lng ? e1.lng -= 360 : e1.lng += 360;
            }
            return e1.lng !== o.lng && a.isPointOnMapSurface(a.locationToScreenPoint(e1)) ? e1 : o;
        }
        var _s = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        };
        function ps(e1, t, i) {
            var a = e1.classList;
            for(var _$e in _s)a.remove("maplibregl-".concat(i, "-anchor-").concat(_$e));
            a.add("maplibregl-".concat(i, "-anchor-").concat(t));
        }
        var ms = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(ms, _t_E);
            function ms(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, ms);
                var _this;
                if (_this = (0, $44950fec9206880e$export$71511d61b312f219)(this, ms), _this._onKeyPress = function(e1) {
                    var _$t = e1.code, i = e1.charCode || e1.keyCode;
                    "Space" !== _$t && "Enter" !== _$t && 32 !== i && 13 !== i || _this.togglePopup();
                }, _this._onMapClick = function(e1) {
                    var _$t = e1.originalEvent.target, i = _this._element;
                    _this._popup && (_$t === i || i.contains(_$t)) && _this.togglePopup();
                }, _this._update = function(e1) {
                    if (!_this._map) return;
                    var _$t = _this._map.loaded() && !_this._map.isMoving();
                    ("terrain" === (null == e1 ? void 0 : e1.type) || "render" === (null == e1 ? void 0 : e1.type) && !_$t) && _this._map.once("render", _this._update), _this._lngLat = ds(_this._lngLat, _this._flatPos, _this._map.transform), _this._flatPos = _this._pos = _this._map.project(_this._lngLat)._add(_this._offset), _this._map.terrain && (_this._flatPos = _this._map.transform.locationToScreenPoint(_this._lngLat)._add(_this._offset));
                    var i = "";
                    "viewport" === _this._rotationAlignment || "auto" === _this._rotationAlignment ? i = "rotateZ(".concat(_this._rotation, "deg)") : "map" === _this._rotationAlignment && (i = "rotateZ(".concat(_this._rotation - _this._map.getBearing(), "deg)"));
                    var a = "";
                    "viewport" === _this._pitchAlignment || "auto" === _this._pitchAlignment ? a = "rotateX(0deg)" : "map" === _this._pitchAlignment && (a = "rotateX(".concat(_this._map.getPitch(), "deg)")), _this._subpixelPositioning || e1 && "moveend" !== e1.type || (_this._pos = _this._pos.round()), h.setTransform(_this._element, "".concat(_s[_this._anchor], " translate(").concat(_this._pos.x, "px, ").concat(_this._pos.y, "px) ").concat(a, " ").concat(i)), n.frameAsync(new AbortController).then(function() {
                        _this._updateOpacity(e1 && "moveend" === e1.type);
                    }).catch(function() {});
                }, _this._onMove = function(e1) {
                    if (!_this._isDragging) {
                        var _$t = _this._clickTolerance || _this._map._clickTolerance;
                        _this._isDragging = e1.point.dist(_this._pointerdownPos) >= _$t;
                    }
                    _this._isDragging && (_this._pos = e1.point.sub(_this._positionDelta), _this._lngLat = _this._map.unproject(_this._pos), _this.setLngLat(_this._lngLat), _this._element.style.pointerEvents = "none", "pending" === _this._state && (_this._state = "active", _this.fire(new t.l("dragstart"))), _this.fire(new t.l("drag")));
                }, _this._onUp = function() {
                    _this._element.style.pointerEvents = "auto", _this._positionDelta = null, _this._pointerdownPos = null, _this._isDragging = !1, _this._map.off("mousemove", _this._onMove), _this._map.off("touchmove", _this._onMove), "active" === _this._state && _this.fire(new t.l("dragend")), _this._state = "inactive";
                }, _this._addDragHandler = function(e1) {
                    _this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), _this._positionDelta = e1.point.sub(_this._pos).add(_this._offset), _this._pointerdownPos = e1.point, _this._state = "pending", _this._map.on("mousemove", _this._onMove), _this._map.on("touchmove", _this._onMove), _this._map.once("mouseup", _this._onUp), _this._map.once("touchend", _this._onUp));
                }, _this._anchor = e1 && e1.anchor || "center", _this._color = e1 && e1.color || "#3FB1CE", _this._scale = e1 && e1.scale || 1, _this._draggable = e1 && e1.draggable || !1, _this._clickTolerance = e1 && e1.clickTolerance || 0, _this._subpixelPositioning = e1 && e1.subpixelPositioning || !1, _this._isDragging = !1, _this._state = "inactive", _this._rotation = e1 && e1.rotation || 0, _this._rotationAlignment = e1 && e1.rotationAlignment || "auto", _this._pitchAlignment = e1 && e1.pitchAlignment && "auto" !== e1.pitchAlignment ? e1.pitchAlignment : _this._rotationAlignment, _this.setOpacity(null == e1 ? void 0 : e1.opacity, null == e1 ? void 0 : e1.opacityWhenCovered), e1 && e1.element) _this._element = e1.element, _this._offset = t.P.convert(e1 && e1.offset || [
                    0,
                    0
                ]);
                else {
                    _this._defaultMarker = !0, _this._element = h.create("div");
                    var i = h.createNS("http://www.w3.org/2000/svg", "svg"), a = 41, r = 27;
                    i.setAttributeNS(null, "display", "block"), i.setAttributeNS(null, "height", "".concat(a, "px")), i.setAttributeNS(null, "width", "".concat(r, "px")), i.setAttributeNS(null, "viewBox", "0 0 ".concat(r, " ").concat(a));
                    var o = h.createNS("http://www.w3.org/2000/svg", "g");
                    o.setAttributeNS(null, "stroke", "none"), o.setAttributeNS(null, "stroke-width", "1"), o.setAttributeNS(null, "fill", "none"), o.setAttributeNS(null, "fill-rule", "evenodd");
                    var s = h.createNS("http://www.w3.org/2000/svg", "g");
                    s.setAttributeNS(null, "fill-rule", "nonzero");
                    var n1 = h.createNS("http://www.w3.org/2000/svg", "g");
                    n1.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), n1.setAttributeNS(null, "fill", "#000000");
                    var l = [
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "10.5",
                            ry: "5.25002273"
                        },
                        {
                            rx: "9.5",
                            ry: "4.77275007"
                        },
                        {
                            rx: "8.5",
                            ry: "4.29549936"
                        },
                        {
                            rx: "7.5",
                            ry: "3.81822308"
                        },
                        {
                            rx: "6.5",
                            ry: "3.34094679"
                        },
                        {
                            rx: "5.5",
                            ry: "2.86367051"
                        },
                        {
                            rx: "4.5",
                            ry: "2.38636864"
                        }
                    ];
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = l[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _$e = _step.value;
                            var _$t = h.createNS("http://www.w3.org/2000/svg", "ellipse");
                            _$t.setAttributeNS(null, "opacity", "0.04"), _$t.setAttributeNS(null, "cx", "10.5"), _$t.setAttributeNS(null, "cy", "5.80029008"), _$t.setAttributeNS(null, "rx", _$e.rx), _$t.setAttributeNS(null, "ry", _$e.ry), n1.appendChild(_$t);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var _$c = h.createNS("http://www.w3.org/2000/svg", "g");
                    _$c.setAttributeNS(null, "fill", _this._color);
                    var u = h.createNS("http://www.w3.org/2000/svg", "path");
                    u.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), _$c.appendChild(u);
                    var d = h.createNS("http://www.w3.org/2000/svg", "g");
                    d.setAttributeNS(null, "opacity", "0.25"), d.setAttributeNS(null, "fill", "#000000");
                    var _ = h.createNS("http://www.w3.org/2000/svg", "path");
                    _.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), d.appendChild(_);
                    var p = h.createNS("http://www.w3.org/2000/svg", "g");
                    p.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), p.setAttributeNS(null, "fill", "#FFFFFF");
                    var m = h.createNS("http://www.w3.org/2000/svg", "g");
                    m.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                    var f = h.createNS("http://www.w3.org/2000/svg", "circle");
                    f.setAttributeNS(null, "fill", "#000000"), f.setAttributeNS(null, "opacity", "0.25"), f.setAttributeNS(null, "cx", "5.5"), f.setAttributeNS(null, "cy", "5.5"), f.setAttributeNS(null, "r", "5.4999962");
                    var g = h.createNS("http://www.w3.org/2000/svg", "circle");
                    g.setAttributeNS(null, "fill", "#FFFFFF"), g.setAttributeNS(null, "cx", "5.5"), g.setAttributeNS(null, "cy", "5.5"), g.setAttributeNS(null, "r", "5.4999962"), m.appendChild(f), m.appendChild(g), s.appendChild(n1), s.appendChild(_$c), s.appendChild(d), s.appendChild(p), s.appendChild(m), i.appendChild(s), i.setAttributeNS(null, "height", a * _this._scale + "px"), i.setAttributeNS(null, "width", r * _this._scale + "px"), _this._element.appendChild(i), _this._offset = t.P.convert(e1 && e1.offset || [
                        0,
                        -14
                    ]);
                }
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                if (_this._element.classList.add("maplibregl-marker"), _this._element.addEventListener("dragstart", function(e1) {
                    e1.preventDefault();
                }), _this._element.addEventListener("mousedown", function(e1) {
                    e1.preventDefault();
                }), ps(_this._element, _this._anchor, "marker"), e1 && e1.className) try {
                    for(var _iterator1 = e1.className.split(" ")[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var _$t1 = _step1.value;
                        _this._element.classList.add(_$t1);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                _this._popup = null;
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(ms, [
                {
                    key: "addTo",
                    value: function addTo(e1) {
                        return this.remove(), this._map = e1, this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", e1._getUIString("Marker.Title")), this._element.hasAttribute("role") || this._element.setAttribute("role", "button"), e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._update), e1.on("moveend", this._update), e1.on("terrain", this._update), e1.on("projectiontransition", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
                    }
                },
                {
                    key: "remove",
                    value: function remove() {
                        return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("projectiontransition", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), h.remove(this._element), this._popup && this._popup.remove(), this;
                    }
                },
                {
                    key: "getLngLat",
                    value: function getLngLat() {
                        return this._lngLat;
                    }
                },
                {
                    key: "setLngLat",
                    value: function setLngLat(e1) {
                        return this._lngLat = t.V.convert(e1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
                    }
                },
                {
                    key: "getElement",
                    value: function getElement() {
                        return this._element;
                    }
                },
                {
                    key: "setPopup",
                    value: function setPopup(e1) {
                        if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e1) {
                            if (!("offset" in e1.options)) {
                                var _$t = 38.1, i = 13.5, a = Math.abs(i) / Math.SQRT2;
                                e1.options.offset = this._defaultMarker ? {
                                    top: [
                                        0,
                                        0
                                    ],
                                    "top-left": [
                                        0,
                                        0
                                    ],
                                    "top-right": [
                                        0,
                                        0
                                    ],
                                    bottom: [
                                        0,
                                        -_$t
                                    ],
                                    "bottom-left": [
                                        a,
                                        -1 * (_$t - i + a)
                                    ],
                                    "bottom-right": [
                                        -a,
                                        -1 * (_$t - i + a)
                                    ],
                                    left: [
                                        i,
                                        -1 * (_$t - i)
                                    ],
                                    right: [
                                        -i,
                                        -1 * (_$t - i)
                                    ]
                                } : this._offset;
                            }
                            this._popup = e1, this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                        }
                        return this;
                    }
                },
                {
                    key: "setSubpixelPositioning",
                    value: function setSubpixelPositioning(e1) {
                        return this._subpixelPositioning = e1, this;
                    }
                },
                {
                    key: "getPopup",
                    value: function getPopup() {
                        return this._popup;
                    }
                },
                {
                    key: "togglePopup",
                    value: function togglePopup() {
                        var _$e = this._popup;
                        return this._element.style.opacity === this._opacityWhenCovered ? this : _$e ? (_$e.isOpen() ? _$e.remove() : (_$e.setLngLat(this._lngLat), _$e.addTo(this._map)), this) : this;
                    }
                },
                {
                    key: "_updateOpacity",
                    value: function _updateOpacity() {
                        var _this = this;
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !1;
                        var i, a;
                        var r = null === (i = this._map) || void 0 === i ? void 0 : i.terrain, o = this._map.transform.isLocationOccluded(this._lngLat);
                        if (!r || o) {
                            var _$e1 = o ? this._opacityWhenCovered : this._opacity;
                            return void (this._element.style.opacity !== _$e1 && (this._element.style.opacity = _$e1));
                        }
                        if (_$e) this._opacityTimeout = null;
                        else {
                            if (this._opacityTimeout) return;
                            this._opacityTimeout = setTimeout(function() {
                                _this._opacityTimeout = null;
                            }, 100);
                        }
                        var s = this._map, n = s.terrain.depthAtPoint(this._pos), l = s.terrain.getElevationForLngLat(this._lngLat, s.transform);
                        if (s.transform.lngLatToCameraDepth(this._lngLat, l) - n < .006) return void (this._element.style.opacity = this._opacity);
                        var _$c = -this._offset.y / s.transform.pixelsPerMeter, h = Math.sin(s.getPitch() * Math.PI / 180) * _$c, u = s.terrain.depthAtPoint(new t.P(this._pos.x, this._pos.y - this._offset.y)), d = s.transform.lngLatToCameraDepth(this._lngLat, l + h) - u > .006;
                        (null === (a = this._popup) || void 0 === a ? void 0 : a.isOpen()) && d && this._popup.remove(), this._element.style.opacity = d ? this._opacityWhenCovered : this._opacity;
                    }
                },
                {
                    key: "getOffset",
                    value: function getOffset() {
                        return this._offset;
                    }
                },
                {
                    key: "setOffset",
                    value: function setOffset(e1) {
                        return this._offset = t.P.convert(e1), this._update(), this;
                    }
                },
                {
                    key: "addClassName",
                    value: function addClassName(e1) {
                        this._element.classList.add(e1);
                    }
                },
                {
                    key: "removeClassName",
                    value: function removeClassName(e1) {
                        this._element.classList.remove(e1);
                    }
                },
                {
                    key: "toggleClassName",
                    value: function toggleClassName(e1) {
                        return this._element.classList.toggle(e1);
                    }
                },
                {
                    key: "setDraggable",
                    value: function setDraggable(e1) {
                        return this._draggable = !!e1, this._map && (e1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
                    }
                },
                {
                    key: "isDraggable",
                    value: function isDraggable() {
                        return this._draggable;
                    }
                },
                {
                    key: "setRotation",
                    value: function setRotation(e1) {
                        return this._rotation = e1 || 0, this._update(), this;
                    }
                },
                {
                    key: "getRotation",
                    value: function getRotation() {
                        return this._rotation;
                    }
                },
                {
                    key: "setRotationAlignment",
                    value: function setRotationAlignment(e1) {
                        return this._rotationAlignment = e1 || "auto", this._update(), this;
                    }
                },
                {
                    key: "getRotationAlignment",
                    value: function getRotationAlignment() {
                        return this._rotationAlignment;
                    }
                },
                {
                    key: "setPitchAlignment",
                    value: function setPitchAlignment(e1) {
                        return this._pitchAlignment = e1 && "auto" !== e1 ? e1 : this._rotationAlignment, this._update(), this;
                    }
                },
                {
                    key: "getPitchAlignment",
                    value: function getPitchAlignment() {
                        return this._pitchAlignment;
                    }
                },
                {
                    key: "setOpacity",
                    value: function setOpacity(e1, t) {
                        return (void 0 === this._opacity || void 0 === e1 && void 0 === t) && (this._opacity = "1", this._opacityWhenCovered = "0.2"), void 0 !== e1 && (this._opacity = e1), void 0 !== t && (this._opacityWhenCovered = t), this._map && this._updateOpacity(!0), this;
                    }
                }
            ]);
            return ms;
        }(t.E);
        var fs = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0
        };
        var gs = 0, vs = !1;
        var xs = {
            maxWidth: 100,
            unit: "metric"
        };
        function bs(e1, t, i) {
            var a = i && i.maxWidth || 100, r = e1._container.clientHeight / 2, o = e1._container.clientWidth / 2, s = e1.unproject([
                o - a / 2,
                r
            ]), n = e1.unproject([
                o + a / 2,
                r
            ]), l = Math.round(e1.project(n).x - e1.project(s).x), _$c = Math.min(a, l, e1._container.clientWidth), h = s.distanceTo(n);
            if (i && "imperial" === i.unit) {
                var _$i = 3.2808 * h;
                _$i > 5280 ? ys(t, _$c, _$i / 5280, e1._getUIString("ScaleControl.Miles")) : ys(t, _$c, _$i, e1._getUIString("ScaleControl.Feet"));
            } else i && "nautical" === i.unit ? ys(t, _$c, h / 1852, e1._getUIString("ScaleControl.NauticalMiles")) : h >= 1e3 ? ys(t, _$c, h / 1e3, e1._getUIString("ScaleControl.Kilometers")) : ys(t, _$c, h, e1._getUIString("ScaleControl.Meters"));
        }
        function ys(e1, t, i, a) {
            var r = function(e1) {
                var _$t = Math.pow(10, "".concat(Math.floor(e1)).length - 1);
                var _$i = e1 / _$t;
                return _$i = _$i >= 10 ? 10 : _$i >= 5 ? 5 : _$i >= 3 ? 3 : _$i >= 2 ? 2 : _$i >= 1 ? 1 : function(e1) {
                    var _$t = Math.pow(10, Math.ceil(-Math.log(e1) / Math.LN10));
                    return Math.round(e1 * _$t) / _$t;
                }(_$i), _$t * _$i;
            }(i);
            e1.style.width = t * (r / i) + "px", e1.innerHTML = "".concat(r, "&nbsp;").concat(a);
        }
        var ws = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px",
            subpixelPositioning: !1,
            locationOccludedOpacity: void 0
        }, Ts = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function Ps(e1) {
            if (e1) {
                if ("number" == typeof e1) {
                    var i = Math.round(Math.abs(e1) / Math.SQRT2);
                    return {
                        center: new t.P(0, 0),
                        top: new t.P(0, e1),
                        "top-left": new t.P(i, i),
                        "top-right": new t.P(-i, i),
                        bottom: new t.P(0, -e1),
                        "bottom-left": new t.P(i, -i),
                        "bottom-right": new t.P(-i, -i),
                        left: new t.P(e1, 0),
                        right: new t.P(-e1, 0)
                    };
                }
                if (e1 instanceof t.P || Array.isArray(e1)) {
                    var i1 = t.P.convert(e1);
                    return {
                        center: i1,
                        top: i1,
                        "top-left": i1,
                        "top-right": i1,
                        bottom: i1,
                        "bottom-left": i1,
                        "bottom-right": i1,
                        left: i1,
                        right: i1
                    };
                }
                return {
                    center: t.P.convert(e1.center || [
                        0,
                        0
                    ]),
                    top: t.P.convert(e1.top || [
                        0,
                        0
                    ]),
                    "top-left": t.P.convert(e1["top-left"] || [
                        0,
                        0
                    ]),
                    "top-right": t.P.convert(e1["top-right"] || [
                        0,
                        0
                    ]),
                    bottom: t.P.convert(e1.bottom || [
                        0,
                        0
                    ]),
                    "bottom-left": t.P.convert(e1["bottom-left"] || [
                        0,
                        0
                    ]),
                    "bottom-right": t.P.convert(e1["bottom-right"] || [
                        0,
                        0
                    ]),
                    left: t.P.convert(e1.left || [
                        0,
                        0
                    ]),
                    right: t.P.convert(e1.right || [
                        0,
                        0
                    ])
                };
            }
            return Ps(new t.P(0, 0));
        }
        var Cs = i;
        e1.AJAXError = t.cI, e1.Event = t.l, e1.Evented = t.E, e1.LngLat = t.V, e1.MercatorCoordinate = t.a9, e1.Point = t.P, e1.addProtocol = t.cJ, e1.config = t.c, e1.removeProtocol = t.cK, e1.AttributionControl = Yo, e1.BoxZoomHandler = co, e1.CanvasSource = ae, e1.CooperativeGesturesHandler = Vo, e1.DoubleClickZoomHandler = Oo, e1.DragPanHandler = Zo, e1.DragRotateHandler = Go, e1.EdgeInsets = Nt, e1.FullscreenControl = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, _t_E);
            function _class() {
                var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _class), _this._onFullscreenChange = function() {
                    var _$e;
                    var _$t = window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement;
                    for(; null === (_$e = null == _$t ? void 0 : _$t.shadowRoot) || void 0 === _$e ? void 0 : _$e.fullscreenElement;)_$t = _$t.shadowRoot.fullscreenElement;
                    _$t === _this._container !== _this._fullscreen && _this._handleFullscreenChange();
                }, _this._onClickFullscreen = function() {
                    _this._isFullscreen() ? _this._exitFullscreen() : _this._requestFullscreen();
                }, _this._fullscreen = !1, _$e && _$e.container && (_$e.container instanceof HTMLElement ? _this._container = _$e.container : t.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? _this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? _this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? _this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (_this._fullscreenchange = "MSFullscreenChange");
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        return this._map = e1, this._container || (this._container = this._map.getContainer()), this._controlContainer = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        h.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
                    }
                },
                {
                    key: "_setupUI",
                    value: function _setupUI() {
                        var _$e = this._fullscreenButton = h.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                        h.create("span", "maplibregl-ctrl-icon", _$e).setAttribute("aria-hidden", "true"), _$e.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
                    }
                },
                {
                    key: "_updateTitle",
                    value: function _updateTitle() {
                        var _$e = this._getTitle();
                        this._fullscreenButton.setAttribute("aria-label", _$e), this._fullscreenButton.title = _$e;
                    }
                },
                {
                    key: "_getTitle",
                    value: function _getTitle() {
                        return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                    }
                },
                {
                    key: "_isFullscreen",
                    value: function _isFullscreen() {
                        return this._fullscreen;
                    }
                },
                {
                    key: "_handleFullscreenChange",
                    value: function _handleFullscreenChange() {
                        this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new t.l("fullscreenstart")), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new t.l("fullscreenend")), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
                    }
                },
                {
                    key: "_exitFullscreen",
                    value: function _exitFullscreen() {
                        window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
                    }
                },
                {
                    key: "_requestFullscreen",
                    value: function _requestFullscreen() {
                        this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
                    }
                },
                {
                    key: "_togglePseudoFullScreen",
                    value: function _togglePseudoFullScreen() {
                        this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
                    }
                }
            ]);
            return _class;
        }(t.E), e1.GeoJSONSource = ee, e1.GeolocateControl = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, _t_E);
            function _class(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _class), _this._onSuccess = function(e1) {
                    if (_this._map) {
                        if (_this._isOutOfMapMaxBounds(e1)) return _this._setErrorState(), _this.fire(new t.l("outofmaxbounds", e1)), _this._updateMarker(), void _this._finish();
                        if (_this.options.trackUserLocation) switch(_this._lastKnownPosition = e1, _this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                _this._watchState = "ACTIVE_LOCK", _this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), _this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), _this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                _this._watchState = "BACKGROUND", _this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), _this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), _this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                break;
                            default:
                                throw new Error("Unexpected watchState ".concat(_this._watchState));
                        }
                        _this.options.showUserLocation && "OFF" !== _this._watchState && _this._updateMarker(e1), _this.options.trackUserLocation && "ACTIVE_LOCK" !== _this._watchState || _this._updateCamera(e1), _this.options.showUserLocation && _this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), _this.fire(new t.l("geolocate", e1)), _this._finish();
                    }
                }, _this._updateCamera = function(e1) {
                    var i = new t.V(e1.coords.longitude, e1.coords.latitude), a = e1.coords.accuracy, r = _this._map.getBearing(), o = t.e({
                        bearing: r
                    }, _this.options.fitBoundsOptions), s = $.fromLngLat(i, a);
                    _this._map.fitBounds(s, o, {
                        geolocateSource: !0
                    });
                }, _this._updateMarker = function(e1) {
                    if (e1) {
                        var i = new t.V(e1.coords.longitude, e1.coords.latitude);
                        _this._accuracyCircleMarker.setLngLat(i).addTo(_this._map), _this._userLocationDotMarker.setLngLat(i).addTo(_this._map), _this._accuracy = e1.coords.accuracy, _this._updateCircleRadiusIfNeeded();
                    } else _this._userLocationDotMarker.remove(), _this._accuracyCircleMarker.remove();
                }, _this._onUpdate = function() {
                    _this._updateCircleRadiusIfNeeded();
                }, _this._onError = function(e1) {
                    if (_this._map) {
                        if (1 === e1.code) {
                            _this._watchState = "OFF", _this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), _this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), _this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), _this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), _this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), _this._geolocateButton.disabled = !0;
                            var _$e = _this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            _this._geolocateButton.title = _$e, _this._geolocateButton.setAttribute("aria-label", _$e), void 0 !== _this._geolocationWatchID && _this._clearWatch();
                        } else {
                            if (3 === e1.code && vs) return;
                            _this._setErrorState();
                        }
                        "OFF" !== _this._watchState && _this.options.showUserLocation && _this._dotElement.classList.add("maplibregl-user-location-dot-stale"), _this.fire(new t.l("error", e1)), _this._finish();
                    }
                }, _this._finish = function() {
                    _this._timeoutId && clearTimeout(_this._timeoutId), _this._timeoutId = void 0;
                }, _this._setupUI = function() {
                    _this._map && (_this._container.addEventListener("contextmenu", function(e1) {
                        return e1.preventDefault();
                    }), _this._geolocateButton = h.create("button", "maplibregl-ctrl-geolocate", _this._container), h.create("span", "maplibregl-ctrl-icon", _this._geolocateButton).setAttribute("aria-hidden", "true"), _this._geolocateButton.type = "button", _this._geolocateButton.disabled = !0);
                }, _this._finishSetupUI = function(e1) {
                    if (_this._map) {
                        if (!1 === e1) {
                            t.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            var _$e = _this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            _this._geolocateButton.disabled = !0, _this._geolocateButton.title = _$e, _this._geolocateButton.setAttribute("aria-label", _$e);
                        } else {
                            var _$e1 = _this._map._getUIString("GeolocateControl.FindMyLocation");
                            _this._geolocateButton.disabled = !1, _this._geolocateButton.title = _$e1, _this._geolocateButton.setAttribute("aria-label", _$e1);
                        }
                        _this.options.trackUserLocation && (_this._geolocateButton.setAttribute("aria-pressed", "false"), _this._watchState = "OFF"), _this.options.showUserLocation && (_this._dotElement = h.create("div", "maplibregl-user-location-dot"), _this._userLocationDotMarker = new ms({
                            element: _this._dotElement
                        }), _this._circleElement = h.create("div", "maplibregl-user-location-accuracy-circle"), _this._accuracyCircleMarker = new ms({
                            element: _this._circleElement,
                            pitchAlignment: "map"
                        }), _this.options.trackUserLocation && (_this._watchState = "OFF"), _this._map.on("zoom", _this._onUpdate), _this._map.on("move", _this._onUpdate), _this._map.on("rotate", _this._onUpdate), _this._map.on("pitch", _this._onUpdate)), _this._geolocateButton.addEventListener("click", function() {
                            return _this.trigger();
                        }), _this._setup = !0, _this.options.trackUserLocation && _this._map.on("movestart", function(e1) {
                            var i = (null == e1 ? void 0 : e1[0]) instanceof ResizeObserverEntry;
                            e1.geolocateSource || "ACTIVE_LOCK" !== _this._watchState || i || _this._map.isZooming() || (_this._watchState = "BACKGROUND", _this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), _this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), _this.fire(new t.l("trackuserlocationend")), _this.fire(new t.l("userlocationlostfocus")));
                        });
                    }
                }, _this.options = t.e({}, fs, e1);
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        var _this = this;
                        return this._map = e1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), (function() {
                            return t._(this, arguments, void 0, function() {
                                var _$e, _$e1, e1;
                                var _arguments = arguments;
                                return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _$e = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : !1;
                                            if (void 0 !== us && !_$e) return [
                                                2,
                                                us
                                            ];
                                            if (void 0 === window.navigator.permissions) return [
                                                2,
                                                (us = !!window.navigator.geolocation, us)
                                            ];
                                            _state.label = 1;
                                        case 1:
                                            _state.trys.push([
                                                1,
                                                3,
                                                ,
                                                4
                                            ]);
                                            return [
                                                4,
                                                window.navigator.permissions.query({
                                                    name: "geolocation"
                                                })
                                            ];
                                        case 2:
                                            _$e1 = _state.sent();
                                            us = "denied" !== _$e1.state;
                                            return [
                                                3,
                                                4
                                            ];
                                        case 3:
                                            e1 = _state.sent();
                                            us = !!window.navigator.geolocation;
                                            return [
                                                3,
                                                4
                                            ];
                                        case 4:
                                            return [
                                                2,
                                                us
                                            ];
                                    }
                                });
                            });
                        })().then(function(e1) {
                            return _this._finishSetupUI(e1);
                        }), this._container;
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), h.remove(this._container), this._map.off("zoom", this._onUpdate), this._map.off("move", this._onUpdate), this._map.off("rotate", this._onUpdate), this._map.off("pitch", this._onUpdate), this._map = void 0, gs = 0, vs = !1;
                    }
                },
                {
                    key: "_isOutOfMapMaxBounds",
                    value: function _isOutOfMapMaxBounds(e1) {
                        var _$t = this._map.getMaxBounds(), i = e1.coords;
                        return _$t && (i.longitude < _$t.getWest() || i.longitude > _$t.getEast() || i.latitude < _$t.getSouth() || i.latitude > _$t.getNorth());
                    }
                },
                {
                    key: "_setErrorState",
                    value: function _setErrorState() {
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                                break;
                            case "ACTIVE_LOCK":
                                this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                                break;
                            case "BACKGROUND":
                                this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                                break;
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                            case "OFF":
                            case void 0:
                                break;
                            default:
                                throw new Error("Unexpected watchState ".concat(this._watchState));
                        }
                    }
                },
                {
                    key: "_updateCircleRadiusIfNeeded",
                    value: function _updateCircleRadiusIfNeeded() {
                        var _$e = this._userLocationDotMarker.getLngLat();
                        if (!(this.options.showUserLocation && this.options.showAccuracyCircle && this._accuracy && _$e)) return;
                        var _$t = this._map.project(_$e), i = this._map.unproject([
                            _$t.x + 100,
                            _$t.y
                        ]), a = _$e.distanceTo(i) / 100, r = 2 * this._accuracy / a;
                        this._circleElement.style.width = "".concat(r.toFixed(2), "px"), this._circleElement.style.height = "".concat(r.toFixed(2), "px");
                    }
                },
                {
                    key: "trigger",
                    value: function trigger() {
                        if (!this._setup) return t.w("Geolocate control triggered before added to a map"), !1;
                        if (this.options.trackUserLocation) {
                            switch(this._watchState){
                                case "OFF":
                                    this._watchState = "WAITING_ACTIVE", this.fire(new t.l("trackuserlocationstart"));
                                    break;
                                case "WAITING_ACTIVE":
                                case "ACTIVE_LOCK":
                                case "ACTIVE_ERROR":
                                case "BACKGROUND_ERROR":
                                    gs--, vs = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new t.l("trackuserlocationend"));
                                    break;
                                case "BACKGROUND":
                                    this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new t.l("trackuserlocationstart")), this.fire(new t.l("userlocationfocus"));
                                    break;
                                default:
                                    throw new Error("Unexpected watchState ".concat(this._watchState));
                            }
                            switch(this._watchState){
                                case "WAITING_ACTIVE":
                                    this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                    break;
                                case "ACTIVE_LOCK":
                                    this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                    break;
                                case "OFF":
                                    break;
                                default:
                                    throw new Error("Unexpected watchState ".concat(this._watchState));
                            }
                            if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                            else if (void 0 === this._geolocationWatchID) {
                                var _$e;
                                this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), gs++, gs > 1 ? (_$e = {
                                    maximumAge: 6e5,
                                    timeout: 0
                                }, vs = !0) : (_$e = this.options.positionOptions, vs = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, _$e);
                            }
                        } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                        return !0;
                    }
                },
                {
                    key: "_clearWatch",
                    value: function _clearWatch() {
                        window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                    }
                }
            ]);
            return _class;
        }(t.E), e1.GlobeControl = /*#__PURE__*/ function() {
            function _class() {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this._toggleProjection = function() {
                    var _$e;
                    var _$t = null === (_$e = _this._map.getProjection()) || void 0 === _$e ? void 0 : _$e.type;
                    _this._map.setProjection("mercator" !== _$t && _$t ? {
                        type: "mercator"
                    } : {
                        type: "globe"
                    }), _this._updateGlobeIcon();
                }, this._updateGlobeIcon = function() {
                    var _$e;
                    _this._globeButton.classList.remove("maplibregl-ctrl-globe"), _this._globeButton.classList.remove("maplibregl-ctrl-globe-enabled"), "globe" === (null === (_$e = _this._map.getProjection()) || void 0 === _$e ? void 0 : _$e.type) ? (_this._globeButton.classList.add("maplibregl-ctrl-globe-enabled"), _this._globeButton.title = _this._map._getUIString("GlobeControl.Disable")) : (_this._globeButton.classList.add("maplibregl-ctrl-globe"), _this._globeButton.title = _this._map._getUIString("GlobeControl.Enable"));
                };
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        return this._map = e1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._globeButton = h.create("button", "maplibregl-ctrl-globe", this._container), h.create("span", "maplibregl-ctrl-icon", this._globeButton).setAttribute("aria-hidden", "true"), this._globeButton.type = "button", this._globeButton.addEventListener("click", this._toggleProjection), this._updateGlobeIcon(), this._map.on("styledata", this._updateGlobeIcon), this._container;
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        h.remove(this._container), this._map.off("styledata", this._updateGlobeIcon), this._globeButton.removeEventListener("click", this._toggleProjection), this._map = void 0;
                    }
                }
            ]);
            return _class;
        }(), e1.Hash = $r, e1.ImageSource = te, e1.KeyboardHandler = Ao, e1.LngLatBounds = $, e1.LogoControl = Qo, e1.Map = /*#__PURE__*/ function(Xo) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, Xo);
            function _class(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                var _this;
                var i, a;
                t.cG.mark(t.cH.create);
                var r = Object.assign(Object.assign(Object.assign({}, ls), e1), {
                    canvasContextAttributes: Object.assign(Object.assign({}, ls.canvasContextAttributes), e1.canvasContextAttributes)
                });
                if (null != r.minZoom && null != r.maxZoom && r.minZoom > r.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                if (null != r.minPitch && null != r.maxPitch && r.minPitch > r.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                if (null != r.minPitch && r.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                if (null != r.maxPitch && r.maxPitch > 180) throw new Error("maxPitch must be less than or equal to 180");
                var o = new $t, s = new Yt;
                if (void 0 !== r.minZoom && o.setMinZoom(r.minZoom), void 0 !== r.maxZoom && o.setMaxZoom(r.maxZoom), void 0 !== r.minPitch && o.setMinPitch(r.minPitch), void 0 !== r.maxPitch && o.setMaxPitch(r.maxPitch), void 0 !== r.renderWorldCopies && o.setRenderWorldCopies(r.renderWorldCopies), null !== r.transformConstrain && o.setConstrainOverride(r.transformConstrain), _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _class, [
                    o,
                    s,
                    {
                        bearingSnap: r.bearingSnap
                    }
                ]), _this._idleTriggered = !1, _this._crossFadingFactor = 1, _this._renderTaskQueue = new Jo, _this._controls = [], _this._mapId = t.af(), _this._lostContextStyle = {
                    style: null,
                    images: null
                }, _this._contextLost = function(e1) {
                    e1.preventDefault(), _this._frameRequest && (_this._frameRequest.abort(), _this._frameRequest = null), _this.painter.destroy();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(var _iterator = Object.values(_this.style._layers)[Symbol.iterator](), _step; !(_iteratorNormalCompletion1 = (_step = _iterator.next()).done); _iteratorNormalCompletion1 = true){
                            var _$e = _step.value;
                            if ("custom" === _$e.type && console.warn("Custom layer with id '".concat(_$e.id, "' cannot be restored after WebGL context loss. You will need to re-add it manually after context restoration.")), _$e._listeners) try {
                                for(var _iterator1 = Object.entries(_$e._listeners)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion = true){
                                    var _step_value = (0, $db95b225ee8036d6$export$71511d61b312f219)(_step1.value, 1), _$t = _step_value[0];
                                    console.warn("Custom layer with id '".concat(_$e.id, "' had event listeners for event '").concat(_$t, "' which cannot be restored after WebGL context loss. You will need to re-add them manually after context restoration."));
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator1.return != null) {
                                        _iterator1.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    _this._lostContextStyle = _this._getStyleAndImages(), _this.style.destroy(), _this.style = null, _this.fire(new t.l("webglcontextlost", {
                        originalEvent: e1
                    }));
                }, _this._contextRestored = function(e1) {
                    _this._lostContextStyle.style && _this.setStyle(_this._lostContextStyle.style, {
                        diff: !1
                    }), _this._lostContextStyle.images && (_this.style.imageManager.images = _this._lostContextStyle.images), _this._setupPainter(), _this.resize(), _this._update(), _this.fire(new t.l("webglcontextrestored", {
                        originalEvent: e1
                    }));
                }, _this._onMapScroll = function(e1) {
                    if (e1.target === _this._container) return _this._container.scrollTop = 0, _this._container.scrollLeft = 0, !1;
                }, _this._onWindowOnline = function() {
                    _this._update();
                }, _this._interactive = r.interactive, _this._maxTileCacheSize = r.maxTileCacheSize, _this._maxTileCacheZoomLevels = r.maxTileCacheZoomLevels, _this._canvasContextAttributes = Object.assign({}, r.canvasContextAttributes), _this._trackResize = !0 === r.trackResize, _this._bearingSnap = r.bearingSnap, _this._centerClampedToGround = r.centerClampedToGround, _this._refreshExpiredTiles = !0 === r.refreshExpiredTiles, _this._fadeDuration = r.fadeDuration, _this._crossSourceCollisions = !0 === r.crossSourceCollisions, _this._collectResourceTiming = !0 === r.collectResourceTiming, _this._locale = Object.assign(Object.assign({}, ss), r.locale), _this._clickTolerance = r.clickTolerance, _this._overridePixelRatio = r.pixelRatio, _this._maxCanvasSize = r.maxCanvasSize, _this._zoomLevelsToOverscale = r.experimentalZoomLevelsToOverscale, _this.transformCameraUpdate = r.transformCameraUpdate, _this.transformConstrain = r.transformConstrain, _this.cancelPendingTileRequestsWhileZooming = !0 === r.cancelPendingTileRequestsWhileZooming, void 0 !== r.reduceMotion && (n.prefersReducedMotion = r.reduceMotion), _this._imageQueueHandle = g.addThrottleControl(function() {
                    return _this.isMoving();
                }), _this._requestManager = new v(r.transformRequest), "string" == typeof r.container) {
                    if (_this._container = document.getElementById(r.container), !_this._container) throw new Error("Container '".concat(r.container, "' not found."));
                } else {
                    if (!(r.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                    _this._container = r.container;
                }
                if (r.maxBounds && _this.setMaxBounds(r.maxBounds), _this._setupContainer(), _this._setupPainter(), _this.on("move", function() {
                    return _this._update(!1);
                }), _this.on("moveend", function() {
                    return _this._update(!1);
                }), _this.on("zoom", function() {
                    return _this._update(!0);
                }), _this.on("terrain", function() {
                    _this.painter.terrainFacilitator.dirty = !0, _this._update(!0);
                }), _this.once("idle", function() {
                    _this._idleTriggered = !0;
                }), "undefined" != typeof window) {
                    addEventListener("online", _this._onWindowOnline, !1);
                    var _$e = !1;
                    var _$t = Wr(function(e1) {
                        _this._trackResize && !_this._removed && (_this.resize(e1), _this.redraw());
                    }, 50);
                    _this._resizeObserver = new ResizeObserver(function(i) {
                        _$e ? _$t(i) : _$e = !0;
                    }), _this._resizeObserver.observe(_this._container);
                }
                _this.handlers = new Ho(_this, r), _this._hash = r.hash && new $r("string" == typeof r.hash && r.hash || void 0).addTo(_this), _this._hash && _this._hash._onHashChange() || (_this.jumpTo({
                    center: r.center,
                    elevation: r.elevation,
                    zoom: r.zoom,
                    bearing: r.bearing,
                    pitch: r.pitch,
                    roll: r.roll
                }), r.bounds && (_this.resize(), _this.fitBounds(r.bounds, t.e({}, r.fitBoundsOptions, {
                    duration: 0
                }))));
                var l = "string" == typeof r.style || !("globe" === (null === (a = null === (i = r.style) || void 0 === i ? void 0 : i.projection) || void 0 === a ? void 0 : a.type));
                _this.resize(null, l), _this._localIdeographFontFamily = r.localIdeographFontFamily, _this._validateStyle = r.validateStyle, r.style && _this.setStyle(r.style, {
                    localIdeographFontFamily: r.localIdeographFontFamily
                }), r.attributionControl && _this.addControl(new Yo("boolean" == typeof r.attributionControl ? void 0 : r.attributionControl)), r.maplibreLogo && _this.addControl(new Qo, r.logoPosition), _this.on("style.load", function() {
                    if (l || _this._resizeTransform(), _this.transform.unmodified) {
                        var _$e = t.U(_this.style.stylesheet, [
                            "center",
                            "zoom",
                            "bearing",
                            "pitch",
                            "roll"
                        ]);
                        _this.jumpTo(_$e);
                    }
                }), _this.on("data", function(e1) {
                    _this._update("style" === e1.dataType), _this.fire(new t.l("".concat(e1.dataType, "data"), e1));
                }), _this.on("dataloading", function(e1) {
                    _this.fire(new t.l("".concat(e1.dataType, "dataloading"), e1));
                }), _this.on("dataabort", function(e1) {
                    _this.fire(new t.l("sourcedataabort", e1));
                });
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "_getMapId",
                    value: function _getMapId() {
                        return this._mapId;
                    }
                },
                {
                    key: "setGlobalStateProperty",
                    value: function setGlobalStateProperty(e1, t) {
                        return this.style.setGlobalStateProperty(e1, t), this._update(!0);
                    }
                },
                {
                    key: "getGlobalState",
                    value: function getGlobalState() {
                        return this.style.getGlobalState();
                    }
                },
                {
                    key: "addControl",
                    value: function addControl(e1, i) {
                        if (void 0 === i && (i = e1.getDefaultPosition ? e1.getDefaultPosition() : "top-right"), !e1 || !e1.onAdd) return this.fire(new t.k(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                        var a = e1.onAdd(this);
                        this._controls.push(e1);
                        var r = this._controlPositions[i];
                        return -1 !== i.indexOf("bottom") ? r.insertBefore(a, r.firstChild) : r.appendChild(a), this;
                    }
                },
                {
                    key: "removeControl",
                    value: function removeControl(e1) {
                        if (!e1 || !e1.onRemove) return this.fire(new t.k(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                        var i = this._controls.indexOf(e1);
                        return i > -1 && this._controls.splice(i, 1), e1.onRemove(this), this;
                    }
                },
                {
                    key: "hasControl",
                    value: function hasControl(e1) {
                        return this._controls.indexOf(e1) > -1;
                    }
                },
                {
                    key: "coveringTiles",
                    value: function coveringTiles(e1) {
                        return Ie(this.transform, e1);
                    }
                },
                {
                    key: "calculateCameraOptionsFromTo",
                    value: function calculateCameraOptionsFromTo(e1, t, i, a) {
                        return null == a && this.terrain && (a = this.terrain.getElevationForLngLat(i, this.transform)), (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(_class.prototype), "calculateCameraOptionsFromTo", this).call(this, e1, t, i, a);
                    }
                },
                {
                    key: "resize",
                    value: function resize(e1) {
                        var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
                        var _this__containerDimensions = (0, $db95b225ee8036d6$export$71511d61b312f219)(this._containerDimensions(), 2), a = _this__containerDimensions[0], r = _this__containerDimensions[1], o = this._getClampedPixelRatio(a, r);
                        if (this._resizeCanvas(a, r, o), this.painter.resize(a, r, o), this.painter.overLimit()) {
                            var _$e = this.painter.context.gl;
                            this._maxCanvasSize = [
                                _$e.drawingBufferWidth,
                                _$e.drawingBufferHeight
                            ];
                            var _$t = this._getClampedPixelRatio(a, r);
                            this._resizeCanvas(a, r, _$t), this.painter.resize(a, r, _$t);
                        }
                        this._resizeTransform(i);
                        var s = !this._moving;
                        return s && (this.stop(), this.fire(new t.l("movestart", e1)).fire(new t.l("move", e1))), this.fire(new t.l("resize", e1)), s && this.fire(new t.l("moveend", e1)), this;
                    }
                },
                {
                    key: "_resizeTransform",
                    value: function _resizeTransform() {
                        var _$e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
                        var _$t;
                        var _this__containerDimensions = (0, $db95b225ee8036d6$export$71511d61b312f219)(this._containerDimensions(), 2), i = _this__containerDimensions[0], a = _this__containerDimensions[1];
                        this.transform.resize(i, a, _$e), null === (_$t = this._requestedCameraState) || void 0 === _$t || _$t.resize(i, a, _$e);
                    }
                },
                {
                    key: "_getClampedPixelRatio",
                    value: function _getClampedPixelRatio(e1, t) {
                        var _this__maxCanvasSize = this._maxCanvasSize, i = _this__maxCanvasSize[0], a = _this__maxCanvasSize[1], r = this.getPixelRatio(), o = e1 * r, s = t * r;
                        return Math.min(o > i ? i / o : 1, s > a ? a / s : 1) * r;
                    }
                },
                {
                    key: "getPixelRatio",
                    value: function getPixelRatio() {
                        var _$e;
                        return null !== (_$e = this._overridePixelRatio) && void 0 !== _$e ? _$e : devicePixelRatio;
                    }
                },
                {
                    key: "setPixelRatio",
                    value: function setPixelRatio(e1) {
                        this._overridePixelRatio = e1, this.resize();
                    }
                },
                {
                    key: "getBounds",
                    value: function getBounds() {
                        return this.transform.getBounds();
                    }
                },
                {
                    key: "getMaxBounds",
                    value: function getMaxBounds() {
                        return this.transform.getMaxBounds();
                    }
                },
                {
                    key: "setMaxBounds",
                    value: function setMaxBounds(e1) {
                        return this.transform.setMaxBounds($.convert(e1)), this._update();
                    }
                },
                {
                    key: "setMinZoom",
                    value: function setMinZoom(e1) {
                        if ((e1 = null == e1 ? -2 : e1) >= -2 && e1 <= this.transform.maxZoom) {
                            var _$t = this._getTransformForUpdate();
                            return _$t.setMinZoom(e1), this._applyUpdatedTransform(_$t), this._update(), this;
                        }
                        throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                    }
                },
                {
                    key: "getMinZoom",
                    value: function getMinZoom() {
                        return this.transform.minZoom;
                    }
                },
                {
                    key: "setMaxZoom",
                    value: function setMaxZoom(e1) {
                        if ((e1 = null == e1 ? 22 : e1) >= this.transform.minZoom) {
                            var _$t = this._getTransformForUpdate();
                            return _$t.setMaxZoom(e1), this._applyUpdatedTransform(_$t), this._update(), this;
                        }
                        throw new Error("maxZoom must be greater than the current minZoom");
                    }
                },
                {
                    key: "getMaxZoom",
                    value: function getMaxZoom() {
                        return this.transform.maxZoom;
                    }
                },
                {
                    key: "setMinPitch",
                    value: function setMinPitch(e1) {
                        if ((e1 = null == e1 ? 0 : e1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                        if (e1 >= 0 && e1 <= this.transform.maxPitch) return this.transform.setMinPitch(e1), this._update(), this.getPitch() < e1 && this.setPitch(e1), this;
                        throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                    }
                },
                {
                    key: "getMinPitch",
                    value: function getMinPitch() {
                        return this.transform.minPitch;
                    }
                },
                {
                    key: "setMaxPitch",
                    value: function setMaxPitch(e1) {
                        if ((e1 = null == e1 ? 60 : e1) > 180) throw new Error("maxPitch must be less than or equal to 180");
                        if (e1 >= this.transform.minPitch) return this.transform.setMaxPitch(e1), this._update(), this.getPitch() > e1 && this.setPitch(e1), this;
                        throw new Error("maxPitch must be greater than the current minPitch");
                    }
                },
                {
                    key: "getMaxPitch",
                    value: function getMaxPitch() {
                        return this.transform.maxPitch;
                    }
                },
                {
                    key: "getRenderWorldCopies",
                    value: function getRenderWorldCopies() {
                        return this.transform.renderWorldCopies;
                    }
                },
                {
                    key: "setRenderWorldCopies",
                    value: function setRenderWorldCopies(e1) {
                        return this.transform.setRenderWorldCopies(e1), this._update();
                    }
                },
                {
                    key: "setTransformConstrain",
                    value: function setTransformConstrain(e1) {
                        return this.transform.setConstrainOverride(e1), this._update();
                    }
                },
                {
                    key: "project",
                    value: function project(e1) {
                        return this.transform.locationToScreenPoint(t.V.convert(e1), this.style && this.terrain);
                    }
                },
                {
                    key: "unproject",
                    value: function unproject(e1) {
                        return this.transform.screenPointToLocation(t.P.convert(e1), this.terrain);
                    }
                },
                {
                    key: "isMoving",
                    value: function isMoving() {
                        var _$e;
                        return this._moving || (null === (_$e = this.handlers) || void 0 === _$e ? void 0 : _$e.isMoving());
                    }
                },
                {
                    key: "isZooming",
                    value: function isZooming() {
                        var _$e;
                        return this._zooming || (null === (_$e = this.handlers) || void 0 === _$e ? void 0 : _$e.isZooming());
                    }
                },
                {
                    key: "isRotating",
                    value: function isRotating() {
                        var _$e;
                        return this._rotating || (null === (_$e = this.handlers) || void 0 === _$e ? void 0 : _$e.isRotating());
                    }
                },
                {
                    key: "_createDelegatedListener",
                    value: function _createDelegatedListener(e1, t, i) {
                        var _this = this;
                        if ("mouseenter" === e1 || "mouseover" === e1) {
                            var a = !1;
                            var r = function(r) {
                                var o = t.filter(function(e1) {
                                    return _this.getLayer(e1);
                                }), s = 0 !== o.length ? _this.queryRenderedFeatures(r.point, {
                                    layers: o
                                }) : [];
                                s.length ? a || (a = !0, i.call(_this, new ao(e1, _this, r.originalEvent, {
                                    features: s
                                }))) : a = !1;
                            };
                            return {
                                layers: t,
                                listener: i,
                                delegates: {
                                    mousemove: r,
                                    mouseout: function() {
                                        a = !1;
                                    }
                                }
                            };
                        }
                        if ("mouseleave" === e1 || "mouseout" === e1) {
                            var a1 = !1;
                            var r1 = function(r) {
                                var o = t.filter(function(e1) {
                                    return _this.getLayer(e1);
                                });
                                (0 !== o.length ? _this.queryRenderedFeatures(r.point, {
                                    layers: o
                                }) : []).length ? a1 = !0 : a1 && (a1 = !1, i.call(_this, new ao(e1, _this, r.originalEvent)));
                            }, o = function(t) {
                                a1 && (a1 = !1, i.call(_this, new ao(e1, _this, t.originalEvent)));
                            };
                            return {
                                layers: t,
                                listener: i,
                                delegates: {
                                    mousemove: r1,
                                    mouseout: o
                                }
                            };
                        }
                        {
                            var a2 = function(e1) {
                                var a = t.filter(function(e1) {
                                    return _this.getLayer(e1);
                                }), r = 0 !== a.length ? _this.queryRenderedFeatures(e1.point, {
                                    layers: a
                                }) : [];
                                r.length && (e1.features = r, i.call(_this, e1), delete e1.features);
                            };
                            return {
                                layers: t,
                                listener: i,
                                delegates: (0, $6194eebaf067e4d1$export$71511d61b312f219)({}, e1, a2)
                            };
                        }
                    }
                },
                {
                    key: "_saveDelegatedListener",
                    value: function _saveDelegatedListener(e1, t) {
                        this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e1] = this._delegatedListeners[e1] || [], this._delegatedListeners[e1].push(t);
                    }
                },
                {
                    key: "_removeDelegatedListener",
                    value: function _removeDelegatedListener(e1, t, i) {
                        if (!this._delegatedListeners || !this._delegatedListeners[e1]) return;
                        var a = this._delegatedListeners[e1];
                        for(var _$e = 0; _$e < a.length; _$e++){
                            var r = a[_$e];
                            if (r.listener === i && r.layers.length === t.length && r.layers.every(function(e1) {
                                return t.includes(e1);
                            })) {
                                for(var _$e1 in r.delegates)this.off(_$e1, r.delegates[_$e1]);
                                return void a.splice(_$e, 1);
                            }
                        }
                    }
                },
                {
                    key: "on",
                    value: function on(e1, t, i) {
                        var _this = this;
                        if (void 0 === i) return (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(_class.prototype), "on", this).call(this, e1, t);
                        var a = "string" == typeof t ? [
                            t
                        ] : t, r = this._createDelegatedListener(e1, a, i);
                        this._saveDelegatedListener(e1, r);
                        for(var _$e in r.delegates)this.on(_$e, r.delegates[_$e]);
                        return {
                            unsubscribe: function() {
                                _this._removeDelegatedListener(e1, a, i);
                            }
                        };
                    }
                },
                {
                    key: "once",
                    value: function once(e1, t, i) {
                        var _this, _loop = function(_$t) {
                            var _this1 = _this;
                            var o = r.delegates[_$t];
                            r.delegates[_$t] = function() {
                                for(var _len = arguments.length, _$t = new Array(_len), _key = 0; _key < _len; _key++){
                                    _$t[_key] = arguments[_key];
                                }
                                _this1._removeDelegatedListener(e1, a, i), o.apply(void 0, (0, $eb3e8a8ee265ba96$export$71511d61b312f219)(_$t));
                            };
                        };
                        if (void 0 === i) return (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(_class.prototype), "once", this).call(this, e1, t);
                        var a = "string" == typeof t ? [
                            t
                        ] : t, r = this._createDelegatedListener(e1, a, i);
                        for(var _$t in r.delegates)_this = this, _loop(_$t);
                        this._saveDelegatedListener(e1, r);
                        for(var _$e in r.delegates)this.once(_$e, r.delegates[_$e]);
                        return this;
                    }
                },
                {
                    key: "off",
                    value: function off(e1, t, i) {
                        return void 0 === i ? (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(_class.prototype), "off", this).call(this, e1, t) : (this._removeDelegatedListener(e1, "string" == typeof t ? [
                            t
                        ] : t, i), this);
                    }
                },
                {
                    key: "queryRenderedFeatures",
                    value: function queryRenderedFeatures(e1, i) {
                        if (!this.style) return [];
                        var a;
                        var r = e1 instanceof t.P || Array.isArray(e1), o = r ? e1 : [
                            [
                                0,
                                0
                            ],
                            [
                                this.transform.width,
                                this.transform.height
                            ]
                        ];
                        if (i = i || (r ? {} : e1) || {}, o instanceof t.P || "number" == typeof o[0]) a = [
                            t.P.convert(o)
                        ];
                        else {
                            var _$e = t.P.convert(o[0]), _$i = t.P.convert(o[1]);
                            a = [
                                _$e,
                                new t.P(_$i.x, _$e.y),
                                _$i,
                                new t.P(_$e.x, _$i.y),
                                _$e
                            ];
                        }
                        return this.style.queryRenderedFeatures(a, i, this.transform);
                    }
                },
                {
                    key: "querySourceFeatures",
                    value: function querySourceFeatures(e1, t) {
                        return this.style.querySourceFeatures(e1, t);
                    }
                },
                {
                    key: "setStyle",
                    value: function setStyle(e1, i) {
                        return !1 !== (i = t.e({}, {
                            localIdeographFontFamily: this._localIdeographFontFamily,
                            validate: this._validateStyle
                        }, i)).diff && i.localIdeographFontFamily === this._localIdeographFontFamily && this.style && e1 ? (this._diffStyle(e1, i), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._updateStyle(e1, i));
                    }
                },
                {
                    key: "setTransformRequest",
                    value: function setTransformRequest(e1) {
                        return this._requestManager.setTransformRequest(e1), this;
                    }
                },
                {
                    key: "_getUIString",
                    value: function _getUIString(e1) {
                        var _$t = this._locale[e1];
                        if (null == _$t) throw new Error("Missing UI string '".concat(e1, "'"));
                        return _$t;
                    }
                },
                {
                    key: "_updateStyle",
                    value: function _updateStyle(e1, t) {
                        var _this = this;
                        var i, a;
                        if (t.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", function() {
                            return _this._updateStyle(e1, t);
                        });
                        var r = this.style && t.transformStyle ? this.style.serialize() : void 0;
                        return this.style && (this.style.setEventedParent(null), this.style._remove(!e1)), e1 ? (this.style = new ki(this, t || {}), this.style.setEventedParent(this, {
                            style: this.style
                        }), "string" == typeof e1 ? this.style.loadURL(e1, t, r) : this.style.loadJSON(e1, t, r), this) : (null === (a = null === (i = this.style) || void 0 === i ? void 0 : i.projection) || void 0 === a || a.destroy(), delete this.style, this);
                    }
                },
                {
                    key: "_lazyInitEmptyStyle",
                    value: function _lazyInitEmptyStyle() {
                        this.style || (this.style = new ki(this, {}), this.style.setEventedParent(this, {
                            style: this.style
                        }), this.style.loadEmpty());
                    }
                },
                {
                    key: "_diffStyle",
                    value: function _diffStyle(e1, i) {
                        var _this = this;
                        if ("string" == typeof e1) {
                            var a = this._requestManager.transformRequest(e1, "Style");
                            t.j(a, new AbortController).then(function(e1) {
                                _this._updateDiff(e1.data, i);
                            }).catch(function(e1) {
                                e1 && _this.fire(new t.k(e1));
                            });
                        } else "object" == (typeof e1 === "undefined" ? "undefined" : (0, $dvYFb._)(e1)) && this._updateDiff(e1, i);
                    }
                },
                {
                    key: "_updateDiff",
                    value: function _updateDiff(e1, i) {
                        try {
                            this.style.setState(e1, i) && this._update(!0);
                        } catch (a) {
                            t.w("Unable to perform style diff: ".concat(a.message || a.error || a, ".  Rebuilding the style from scratch.")), this._updateStyle(e1, i);
                        }
                    }
                },
                {
                    key: "getStyle",
                    value: function getStyle() {
                        if (this.style) return this.style.serialize();
                    }
                },
                {
                    key: "_getStyleAndImages",
                    value: function _getStyleAndImages() {
                        return this.style ? {
                            style: this.style.serialize(),
                            images: this.style.imageManager.cloneImages()
                        } : {
                            style: null,
                            images: {}
                        };
                    }
                },
                {
                    key: "isStyleLoaded",
                    value: function isStyleLoaded() {
                        return this.style ? this.style.loaded() : t.w("There is no style added to the map.");
                    }
                },
                {
                    key: "addSource",
                    value: function addSource(e1, t) {
                        return this._lazyInitEmptyStyle(), this.style.addSource(e1, t), this._update(!0);
                    }
                },
                {
                    key: "isSourceLoaded",
                    value: function isSourceLoaded(e1) {
                        var i = this.style && this.style.tileManagers[e1];
                        if (void 0 !== i) return i.loaded();
                        this.fire(new t.k(new Error("There is no tile manager with ID '".concat(e1, "'"))));
                    }
                },
                {
                    key: "setTerrain",
                    value: function setTerrain(e1) {
                        var _this = this;
                        if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), e1) {
                            var i = this.style.tileManagers[e1.source];
                            if (!i) throw new Error("cannot load terrain, because there exists no source with ID: ".concat(e1.source));
                            null === this.terrain && i.reload();
                            for(var i1 in this.style._layers){
                                var a = this.style._layers[i1];
                                "hillshade" === a.type && a.source === e1.source && t.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality."), "color-relief" === a.type && a.source === e1.source && t.w("You are using the same source for a color-relief layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                            }
                            this.terrain = new is(this.painter, i, e1), this.painter.renderToTexture = new os(this.painter, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._terrainDataCallback = function(t) {
                                var i;
                                "style" === t.dataType ? _this.terrain.tileManager.freeRtt() : "source" === t.dataType && t.tile && (t.sourceId !== e1.source || _this._elevationFreeze || (_this.transform.setMinElevationForCurrentTile(_this.terrain.getMinTileElevationForLngLatZoom(_this.transform.center, _this.transform.tileZoom)), _this._centerClampedToGround && _this.transform.setElevation(_this.terrain.getElevationForLngLatZoom(_this.transform.center, _this.transform.tileZoom))), "image" === (null === (i = t.source) || void 0 === i ? void 0 : i.type) ? _this.terrain.tileManager.freeRtt() : _this.terrain.tileManager.freeRtt(t.tile.tileID));
                            }, this.style.on("data", this._terrainDataCallback);
                        } else this.terrain && this.terrain.tileManager.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0);
                        return this.fire(new t.l("terrain", {
                            terrain: e1
                        })), this;
                    }
                },
                {
                    key: "getTerrain",
                    value: function getTerrain() {
                        var _$e, _$t;
                        return null !== (_$t = null === (_$e = this.terrain) || void 0 === _$e ? void 0 : _$e.options) && void 0 !== _$t ? _$t : null;
                    }
                },
                {
                    key: "areTilesLoaded",
                    value: function areTilesLoaded() {
                        var _$e = this.style && this.style.tileManagers;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.values(_$e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$t = _step.value;
                                if (!_$t.areTilesLoaded()) return !1;
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        return !0;
                    }
                },
                {
                    key: "removeSource",
                    value: function removeSource(e1) {
                        return this.style.removeSource(e1), this._update(!0);
                    }
                },
                {
                    key: "getSource",
                    value: function getSource(e1) {
                        return this.style.getSource(e1);
                    }
                },
                {
                    key: "setSourceTileLodParams",
                    value: function setSourceTileLodParams(e1, t, i) {
                        if (i) {
                            var a = this.getSource(i);
                            if (!a) throw new Error('There is no source with ID "'.concat(i, '", cannot set LOD parameters'));
                            a.calculateTileZoom = Te(Math.max(1, e1), Math.max(1, t));
                        } else for(var _$i in this.style.tileManagers)this.style.tileManagers[_$i].getSource().calculateTileZoom = Te(Math.max(1, e1), Math.max(1, t));
                        return this._update(!0), this;
                    }
                },
                {
                    key: "refreshTiles",
                    value: function refreshTiles(e1, i) {
                        var a = this.style.tileManagers[e1];
                        if (!a) throw new Error('There is no tile manager with ID "'.concat(e1, '", cannot refresh tile'));
                        void 0 === i ? a.reload(!0) : a.refreshTiles(i.map(function(e1) {
                            return new t.ac(e1.z, e1.x, e1.y);
                        }));
                    }
                },
                {
                    key: "addImage",
                    value: function addImage(e1, i) {
                        var a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        var tmp = a.pixelRatio, r = tmp === void 0 ? 1 : tmp, tmp1 = a.sdf, o = tmp1 === void 0 ? !1 : tmp1, s = a.stretchX, l = a.stretchY, _$c = a.content, h = a.textFitWidth, u = a.textFitHeight;
                        if (this._lazyInitEmptyStyle(), !(i instanceof HTMLImageElement || t.b(i))) {
                            if (void 0 === i.width || void 0 === i.height) return this.fire(new t.k(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                            {
                                var a1 = i.width, n1 = i.height, d = i.data, _ = i;
                                return this.style.addImage(e1, {
                                    data: new t.R({
                                        width: a1,
                                        height: n1
                                    }, new Uint8Array(d)),
                                    pixelRatio: r,
                                    stretchX: s,
                                    stretchY: l,
                                    content: _$c,
                                    textFitWidth: h,
                                    textFitHeight: u,
                                    sdf: o,
                                    version: 0,
                                    userImage: _
                                }), _.onAdd && _.onAdd(this, e1), this;
                            }
                        }
                        {
                            var _n_getImageData = n.getImageData(i), a2 = _n_getImageData.width, d1 = _n_getImageData.height, _1 = _n_getImageData.data;
                            this.style.addImage(e1, {
                                data: new t.R({
                                    width: a2,
                                    height: d1
                                }, _1),
                                pixelRatio: r,
                                stretchX: s,
                                stretchY: l,
                                content: _$c,
                                textFitWidth: h,
                                textFitHeight: u,
                                sdf: o,
                                version: 0
                            });
                        }
                    }
                },
                {
                    key: "updateImage",
                    value: function updateImage(e1, i) {
                        var a = this.style.getImage(e1);
                        if (!a) return this.fire(new t.k(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                        var r = i instanceof HTMLImageElement || t.b(i) ? n.getImageData(i) : i, o = r.width, s = r.height, l = r.data;
                        if (void 0 === o || void 0 === s) return this.fire(new t.k(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                        if (o !== a.data.width || s !== a.data.height) return this.fire(new t.k(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                        var _$c = !(i instanceof HTMLImageElement || t.b(i));
                        return a.data.replace(l, _$c), this.style.updateImage(e1, a), this;
                    }
                },
                {
                    key: "getImage",
                    value: function getImage(e1) {
                        return this.style.getImage(e1);
                    }
                },
                {
                    key: "hasImage",
                    value: function hasImage(e1) {
                        return e1 ? !!this.style.getImage(e1) : (this.fire(new t.k(new Error("Missing required image id"))), !1);
                    }
                },
                {
                    key: "removeImage",
                    value: function removeImage(e1) {
                        this.style.removeImage(e1);
                    }
                },
                {
                    key: "loadImage",
                    value: function loadImage(e1) {
                        return g.getImage(this._requestManager.transformRequest(e1, "Image"), new AbortController);
                    }
                },
                {
                    key: "listImages",
                    value: function listImages() {
                        return this.style.listImages();
                    }
                },
                {
                    key: "addLayer",
                    value: function addLayer(e1, t) {
                        return this._lazyInitEmptyStyle(), this.style.addLayer(e1, t), this._update(!0);
                    }
                },
                {
                    key: "moveLayer",
                    value: function moveLayer(e1, t) {
                        return this.style.moveLayer(e1, t), this._update(!0);
                    }
                },
                {
                    key: "removeLayer",
                    value: function removeLayer(e1) {
                        return this.style.removeLayer(e1), this._update(!0);
                    }
                },
                {
                    key: "getLayer",
                    value: function getLayer(e1) {
                        return this.style.getLayer(e1);
                    }
                },
                {
                    key: "getLayersOrder",
                    value: function getLayersOrder() {
                        return this.style.getLayersOrder();
                    }
                },
                {
                    key: "setLayerZoomRange",
                    value: function setLayerZoomRange(e1, t, i) {
                        return this.style.setLayerZoomRange(e1, t, i), this._update(!0);
                    }
                },
                {
                    key: "setFilter",
                    value: function setFilter(e1, t) {
                        var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        return this.style.setFilter(e1, t, i), this._update(!0);
                    }
                },
                {
                    key: "getFilter",
                    value: function getFilter(e1) {
                        return this.style.getFilter(e1);
                    }
                },
                {
                    key: "setPaintProperty",
                    value: function setPaintProperty(e1, t, i) {
                        var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                        return this.style.setPaintProperty(e1, t, i, a), this._update(!0);
                    }
                },
                {
                    key: "getPaintProperty",
                    value: function getPaintProperty(e1, t) {
                        return this.style.getPaintProperty(e1, t);
                    }
                },
                {
                    key: "setLayoutProperty",
                    value: function setLayoutProperty(e1, t, i) {
                        var a = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
                        return this.style.setLayoutProperty(e1, t, i, a), this._update(!0);
                    }
                },
                {
                    key: "getLayoutProperty",
                    value: function getLayoutProperty(e1, t) {
                        return this.style.getLayoutProperty(e1, t);
                    }
                },
                {
                    key: "setGlyphs",
                    value: function setGlyphs(e1) {
                        var _$t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        return this._lazyInitEmptyStyle(), this.style.setGlyphs(e1, _$t), this._update(!0);
                    }
                },
                {
                    key: "getGlyphs",
                    value: function getGlyphs() {
                        return this.style.getGlyphsUrl();
                    }
                },
                {
                    key: "addSprite",
                    value: function addSprite(e1, t) {
                        var _this = this;
                        var i = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                        return this._lazyInitEmptyStyle(), this.style.addSprite(e1, t, i, function(e1) {
                            e1 || _this._update(!0);
                        }), this;
                    }
                },
                {
                    key: "removeSprite",
                    value: function removeSprite(e1) {
                        return this._lazyInitEmptyStyle(), this.style.removeSprite(e1), this._update(!0);
                    }
                },
                {
                    key: "getSprite",
                    value: function getSprite() {
                        return this.style.getSprite();
                    }
                },
                {
                    key: "setSprite",
                    value: function setSprite(e1) {
                        var _this = this;
                        var _$t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        return this._lazyInitEmptyStyle(), this.style.setSprite(e1, _$t, function(e1) {
                            e1 || _this._update(!0);
                        }), this;
                    }
                },
                {
                    key: "setLight",
                    value: function setLight(e1) {
                        var _$t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        return this._lazyInitEmptyStyle(), this.style.setLight(e1, _$t), this._update(!0);
                    }
                },
                {
                    key: "getLight",
                    value: function getLight() {
                        return this.style.getLight();
                    }
                },
                {
                    key: "setSky",
                    value: function setSky(e1) {
                        var _$t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                        return this._lazyInitEmptyStyle(), this.style.setSky(e1, _$t), this._update(!0);
                    }
                },
                {
                    key: "getSky",
                    value: function getSky() {
                        return this.style.getSky();
                    }
                },
                {
                    key: "setFeatureState",
                    value: function setFeatureState(e1, t) {
                        return this.style.setFeatureState(e1, t), this._update();
                    }
                },
                {
                    key: "removeFeatureState",
                    value: function removeFeatureState(e1, t) {
                        return this.style.removeFeatureState(e1, t), this._update();
                    }
                },
                {
                    key: "getFeatureState",
                    value: function getFeatureState(e1) {
                        return this.style.getFeatureState(e1);
                    }
                },
                {
                    key: "getContainer",
                    value: function getContainer() {
                        return this._container;
                    }
                },
                {
                    key: "getCanvasContainer",
                    value: function getCanvasContainer() {
                        return this._canvasContainer;
                    }
                },
                {
                    key: "getCanvas",
                    value: function getCanvas() {
                        return this._canvas;
                    }
                },
                {
                    key: "_containerDimensions",
                    value: function _containerDimensions() {
                        var _$e = 0, _$t = 0;
                        return this._container && (_$e = this._container.clientWidth || 400, _$t = this._container.clientHeight || 300), [
                            _$e,
                            _$t
                        ];
                    }
                },
                {
                    key: "_setupContainer",
                    value: function _setupContainer() {
                        var _$e = this._container;
                        _$e.classList.add("maplibregl-map");
                        var _$t = this._canvasContainer = h.create("div", "maplibregl-canvas-container", _$e);
                        this._interactive && _$t.classList.add("maplibregl-interactive"), this._canvas = h.create("canvas", "maplibregl-canvas", _$t), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
                        var i = this._containerDimensions(), a = this._getClampedPixelRatio(i[0], i[1]);
                        this._resizeCanvas(i[0], i[1], a);
                        var r = this._controlContainer = h.create("div", "maplibregl-control-container", _$e), o = this._controlPositions = {};
                        [
                            "top-left",
                            "top-right",
                            "bottom-left",
                            "bottom-right"
                        ].forEach(function(e1) {
                            o[e1] = h.create("div", "maplibregl-ctrl-".concat(e1, " "), r);
                        }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                    }
                },
                {
                    key: "_resizeCanvas",
                    value: function _resizeCanvas(e1, t, i) {
                        this._canvas.width = Math.floor(i * e1), this._canvas.height = Math.floor(i * t), this._canvas.style.width = "".concat(e1, "px"), this._canvas.style.height = "".concat(t, "px");
                    }
                },
                {
                    key: "_setupPainter",
                    value: function _setupPainter() {
                        var _$e = Object.assign(Object.assign({}, this._canvasContextAttributes), {
                            alpha: !0,
                            depth: !0,
                            stencil: !0,
                            premultipliedAlpha: !0
                        });
                        var _$t = null;
                        this._canvas.addEventListener("webglcontextcreationerror", function(i) {
                            _$t = {
                                requestedAttributes: _$e
                            }, i && (_$t.statusMessage = i.statusMessage, _$t.type = i.type);
                        }, {
                            once: !0
                        });
                        var i = null;
                        if (i = this._canvasContextAttributes.contextType ? this._canvas.getContext(this._canvasContextAttributes.contextType, _$e) : this._canvas.getContext("webgl2", _$e) || this._canvas.getContext("webgl", _$e), !i) {
                            var _$e1 = "Failed to initialize WebGL";
                            throw _$t ? (_$t.message = _$e1, new Error(JSON.stringify(_$t))) : new Error(_$e1);
                        }
                        this.painter = new qr(i, this.transform), u.testSupport(i);
                    }
                },
                {
                    key: "migrateProjection",
                    value: function migrateProjection(e1, i) {
                        (0, $c10a0453d6c10b57$export$71511d61b312f219)((0, $f35a8e455e15bfdc$export$71511d61b312f219)(_class.prototype), "migrateProjection", this).call(this, e1, i), this.painter.transform = e1, this.fire(new t.l("projectiontransition", {
                            newProjection: this.style.projection.name
                        }));
                    }
                },
                {
                    key: "loaded",
                    value: function loaded() {
                        return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                    }
                },
                {
                    key: "_update",
                    value: function _update(e1) {
                        return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                    }
                },
                {
                    key: "_requestRenderFrame",
                    value: function _requestRenderFrame(e1) {
                        return this._update(), this._renderTaskQueue.add(e1);
                    }
                },
                {
                    key: "_cancelRenderFrame",
                    value: function _cancelRenderFrame(e1) {
                        this._renderTaskQueue.remove(e1);
                    }
                },
                {
                    key: "_render",
                    value: function _render(e1) {
                        var i, a, r, o, s;
                        var n = this._idleTriggered ? this._fadeDuration : 0, l = (null === (i = this.style.projection) || void 0 === i ? void 0 : i.transitionState) > 0;
                        if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(e1), this._removed) return;
                        var h = !1;
                        if (this.style && this._styleDirty) {
                            this._styleDirty = !1;
                            var _$e = this.transform.zoom, i1 = c();
                            this.style.zoomHistory.update(_$e, i1);
                            var a1 = new t.H(_$e, {
                                now: i1,
                                fadeDuration: n,
                                zoomHistory: this.style.zoomHistory,
                                transition: this.style.getTransition()
                            }), r1 = a1.crossFadingFactor();
                            1 === r1 && r1 === this._crossFadingFactor || (h = !0, this._crossFadingFactor = r1), this.style.update(a1);
                        }
                        var u = (null === (a = this.style.projection) || void 0 === a ? void 0 : a.transitionState) > 0 !== l;
                        null === (r = this.style.projection) || void 0 === r || r.setErrorQueryLatitudeDegrees(this.transform.center.lat), this.transform.setTransitionState(null === (o = this.style.projection) || void 0 === o ? void 0 : o.transitionState, null === (s = this.style.projection) || void 0 === s ? void 0 : s.latitudeErrorCorrectionRadians), this.style && (this._sourcesDirty || u) && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.tileManager.update(this.transform, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), !this._elevationFreeze && this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0)), this._placementDirty = this.style && this.style._updatePlacement(this.transform, this.showCollisionBoxes, n, this._crossSourceCollisions, u), this.painter.render(this.style, {
                            showTileBoundaries: this.showTileBoundaries,
                            showOverdrawInspector: this._showOverdrawInspector,
                            rotating: this.isRotating(),
                            zooming: this.isZooming(),
                            moving: this.isMoving(),
                            fadeDuration: n,
                            showPadding: this.showPadding
                        }), this.fire(new t.l("render")), this.loaded() && !this._loaded && (this._loaded = !0, t.cG.mark(t.cH.load), this.fire(new t.l("load"))), this.style && (this.style.hasTransitions() || h) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                        var d = this._sourcesDirty || this._styleDirty || this._placementDirty;
                        return d || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new t.l("idle")), !this._loaded || this._fullyLoaded || d || (this._fullyLoaded = !0, t.cG.mark(t.cH.fullLoad)), this;
                    }
                },
                {
                    key: "redraw",
                    value: function redraw() {
                        return this.style && (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._render(0)), this;
                    }
                },
                {
                    key: "remove",
                    value: function remove() {
                        var _$e;
                        this._hash && this._hash.remove();
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = this._controls[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e1 = _step.value;
                                _$e1.onRemove(this);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        this._controls = [], this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && removeEventListener("online", this._onWindowOnline, !1), g.removeThrottleControl(this._imageQueueHandle), null === (_$e = this._resizeObserver) || void 0 === _$e || _$e.disconnect();
                        var i = this.painter.context.gl.getExtension("WEBGL_lose_context");
                        (null == i ? void 0 : i.loseContext) && i.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), h.remove(this._canvasContainer), h.remove(this._controlContainer), this._container.removeEventListener("scroll", this._onMapScroll, !1), this._container.classList.remove("maplibregl-map"), t.cG.clearMetrics(), this._removed = !0, this.fire(new t.l("remove"));
                    }
                },
                {
                    key: "triggerRepaint",
                    value: function triggerRepaint() {
                        var _this = this;
                        this.style && !this._frameRequest && (this._frameRequest = new AbortController, n.frame(this._frameRequest, function(e1) {
                            t.cG.frame(e1), _this._frameRequest = null;
                            try {
                                _this._render(e1);
                            } catch (e1) {
                                if (!t.Z(e1) && !function(e1) {
                                    return e1.message === or;
                                }(e1)) throw e1;
                            }
                        }, function() {}));
                    }
                },
                {
                    key: "showTileBoundaries",
                    get: function get() {
                        return !!this._showTileBoundaries;
                    },
                    set: function set(e1) {
                        this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
                    }
                },
                {
                    key: "showPadding",
                    get: function get() {
                        return !!this._showPadding;
                    },
                    set: function set(e1) {
                        this._showPadding !== e1 && (this._showPadding = e1, this._update());
                    }
                },
                {
                    key: "showCollisionBoxes",
                    get: function get() {
                        return !!this._showCollisionBoxes;
                    },
                    set: function set(e1) {
                        this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, e1 ? this.style._generateCollisionBoxes() : this._update());
                    }
                },
                {
                    key: "showOverdrawInspector",
                    get: function get() {
                        return !!this._showOverdrawInspector;
                    },
                    set: function set(e1) {
                        this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
                    }
                },
                {
                    key: "repaint",
                    get: function get() {
                        return !!this._repaint;
                    },
                    set: function set(e1) {
                        this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
                    }
                },
                {
                    key: "vertices",
                    get: function get() {
                        return !!this._vertices;
                    },
                    set: function set(e1) {
                        this._vertices = e1, this._update();
                    }
                },
                {
                    key: "version",
                    get: function get() {
                        return ns;
                    }
                },
                {
                    key: "getCameraTargetElevation",
                    value: function getCameraTargetElevation() {
                        return this.transform.elevation;
                    }
                },
                {
                    key: "getProjection",
                    value: function getProjection() {
                        return this.style.getProjection();
                    }
                },
                {
                    key: "setProjection",
                    value: function setProjection(e1) {
                        return this._lazyInitEmptyStyle(), this.style.setProjection(e1), this._update(!0);
                    }
                }
            ]);
            return _class;
        }(Xo), e1.MapMouseEvent = ao, e1.MapTouchEvent = ro, e1.MapWheelEvent = oo, e1.Marker = ms, e1.NavigationControl = /*#__PURE__*/ function() {
            function _class(e1) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this._updateZoomButtons = function() {
                    var _$e = _this._map.getZoom(), _$t = _$e === _this._map.getMaxZoom(), i = _$e === _this._map.getMinZoom();
                    _this._zoomInButton.disabled = _$t, _this._zoomOutButton.disabled = i, _this._zoomInButton.setAttribute("aria-disabled", _$t.toString()), _this._zoomOutButton.setAttribute("aria-disabled", i.toString());
                }, this._rotateCompassArrow = function() {
                    _this._compassIcon.style.transform = _this.options.visualizePitch && _this.options.visualizeRoll ? "scale(".concat(1 / Math.pow(Math.cos(_this._map.transform.pitchInRadians), .5), ") rotateZ(").concat(-_this._map.transform.roll, "deg) rotateX(").concat(_this._map.transform.pitch, "deg) rotateZ(").concat(-_this._map.transform.bearing, "deg)") : _this.options.visualizePitch ? "scale(".concat(1 / Math.pow(Math.cos(_this._map.transform.pitchInRadians), .5), ") rotateX(").concat(_this._map.transform.pitch, "deg) rotateZ(").concat(-_this._map.transform.bearing, "deg)") : _this.options.visualizeRoll ? "rotate(".concat(-_this._map.transform.bearing - _this._map.transform.roll, "deg)") : "rotate(".concat(-_this._map.transform.bearing, "deg)");
                }, this._setButtonTitle = function(e1, t) {
                    var i = _this._map._getUIString("NavigationControl.".concat(t));
                    e1.title = i, e1.setAttribute("aria-label", i);
                }, this.options = t.e({}, cs, e1), this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", function(e1) {
                    return e1.preventDefault();
                }), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", function(e1) {
                    return _this._map.zoomIn({}, {
                        originalEvent: e1
                    });
                }), h.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", function(e1) {
                    return _this._map.zoomOut({}, {
                        originalEvent: e1
                    });
                }), h.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", function(e1) {
                    _this.options.visualizePitch ? _this._map.resetNorthPitch({}, {
                        originalEvent: e1
                    }) : _this._map.resetNorth({}, {
                        originalEvent: e1
                    });
                }), this._compassIcon = h.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.on("roll", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new hs(this._map, this._compass, this.options.visualizePitch)), this._container;
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        h.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.off("roll", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
                    }
                },
                {
                    key: "_createButton",
                    value: function _createButton(e1, t) {
                        var i = h.create("button", e1, this._container);
                        return i.type = "button", i.addEventListener("click", t), i;
                    }
                }
            ]);
            return _class;
        }(), e1.Popup = /*#__PURE__*/ function(_t_E) {
            (0, $cdf6b0397ffac486$export$71511d61b312f219)(_class, _t_E);
            function _class(e1) {
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                var _this;
                _this = (0, $44950fec9206880e$export$71511d61b312f219)(this, _class), _this._updateOpacity = function() {
                    void 0 !== _this.options.locationOccludedOpacity && (_this._container.style.opacity = _this._map.transform.isLocationOccluded(_this.getLngLat()) ? "".concat(_this.options.locationOccludedOpacity) : "");
                }, _this.remove = function() {
                    return _this._content && h.remove(_this._content), _this._container && (h.remove(_this._container), delete _this._container), _this._map && (_this._map.off("move", _this._update), _this._map.off("move", _this._onClose), _this._map.off("click", _this._onClose), _this._map.off("remove", _this.remove), _this._map.off("mousemove", _this._onMouseMove), _this._map.off("mouseup", _this._onMouseUp), _this._map.off("drag", _this._onDrag), _this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete _this._map, _this.fire(new t.l("close"))), _this;
                }, _this._onMouseUp = function(e1) {
                    _this._update(e1.point);
                }, _this._onMouseMove = function(e1) {
                    _this._update(e1.point);
                }, _this._onDrag = function(e1) {
                    _this._update(e1.point);
                }, _this._update = function(e1) {
                    if (!_this._map || !_this._lngLat && !_this._trackPointer || !_this._content) return;
                    if (!_this._container) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (_this._container = h.create("div", "maplibregl-popup", _this._map.getContainer()), _this._tip = h.create("div", "maplibregl-popup-tip", _this._container), _this._container.appendChild(_this._content), _this.options.className) try {
                            for(var _iterator = _this.options.className.split(" ")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var _$e = _step.value;
                                _this._container.classList.add(_$e);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        _this._closeButton && _this._closeButton.setAttribute("aria-label", _this._map._getUIString("Popup.Close")), _this._trackPointer && _this._container.classList.add("maplibregl-popup-track-pointer");
                    }
                    if (_this.options.maxWidth && _this._container.style.maxWidth !== _this.options.maxWidth && (_this._container.style.maxWidth = _this.options.maxWidth), _this._lngLat = ds(_this._lngLat, _this._flatPos, _this._map.transform, _this._trackPointer), _this._trackPointer && !e1) return;
                    var _$t = _this._flatPos = _this._pos = _this._trackPointer && e1 ? e1 : _this._map.project(_this._lngLat);
                    _this._map.terrain && (_this._flatPos = _this._trackPointer && e1 ? e1 : _this._map.transform.locationToScreenPoint(_this._lngLat));
                    var i = _this.options.anchor;
                    var a = Ps(_this.options.offset);
                    if (!i) {
                        var _$e1 = _this._container.offsetWidth, r = _this._container.offsetHeight;
                        var o;
                        o = _$t.y + a.bottom.y < r ? [
                            "top"
                        ] : _$t.y > _this._map.transform.height - r ? [
                            "bottom"
                        ] : [], _$t.x < _$e1 / 2 ? o.push("left") : _$t.x > _this._map.transform.width - _$e1 / 2 && o.push("right"), i = 0 === o.length ? "bottom" : o.join("-");
                    }
                    var r1 = _$t.add(a[i]);
                    _this.options.subpixelPositioning || (r1 = r1.round()), h.setTransform(_this._container, "".concat(_s[i], " translate(").concat(r1.x, "px,").concat(r1.y, "px)")), ps(_this._container, i, "popup"), _this._updateOpacity();
                }, _this._onClose = function() {
                    _this.remove();
                }, _this.options = t.e(Object.create(ws), e1);
                return _this;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "addTo",
                    value: function addTo(e1) {
                        return this._map && this.remove(), this._map = e1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new t.l("open")), this;
                    }
                },
                {
                    key: "isOpen",
                    value: function isOpen() {
                        return !!this._map;
                    }
                },
                {
                    key: "getLngLat",
                    value: function getLngLat() {
                        return this._lngLat;
                    }
                },
                {
                    key: "setLngLat",
                    value: function setLngLat(e1) {
                        return this._lngLat = t.V.convert(e1), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
                    }
                },
                {
                    key: "trackPointer",
                    value: function trackPointer() {
                        return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
                    }
                },
                {
                    key: "getElement",
                    value: function getElement() {
                        return this._container;
                    }
                },
                {
                    key: "setText",
                    value: function setText(e1) {
                        return this.setDOMContent(document.createTextNode(e1));
                    }
                },
                {
                    key: "setHTML",
                    value: function setHTML(e1) {
                        var _$t = document.createDocumentFragment(), i = document.createElement("body");
                        var a;
                        for(i.innerHTML = e1; a = i.firstChild, a;)_$t.appendChild(a);
                        return this.setDOMContent(_$t);
                    }
                },
                {
                    key: "getMaxWidth",
                    value: function getMaxWidth() {
                        var _$e;
                        return null === (_$e = this._container) || void 0 === _$e ? void 0 : _$e.style.maxWidth;
                    }
                },
                {
                    key: "setMaxWidth",
                    value: function setMaxWidth(e1) {
                        return this.options.maxWidth = e1, this._update(), this;
                    }
                },
                {
                    key: "setDOMContent",
                    value: function setDOMContent(e1) {
                        if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                        else this._content = h.create("div", "maplibregl-popup-content", this._container);
                        return this._content.appendChild(e1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
                    }
                },
                {
                    key: "addClassName",
                    value: function addClassName(e1) {
                        return this._container && this._container.classList.add(e1), this;
                    }
                },
                {
                    key: "removeClassName",
                    value: function removeClassName(e1) {
                        return this._container && this._container.classList.remove(e1), this;
                    }
                },
                {
                    key: "setOffset",
                    value: function setOffset(e1) {
                        return this.options.offset = e1, this._update(), this;
                    }
                },
                {
                    key: "toggleClassName",
                    value: function toggleClassName(e1) {
                        if (this._container) return this._container.classList.toggle(e1);
                    }
                },
                {
                    key: "setSubpixelPositioning",
                    value: function setSubpixelPositioning(e1) {
                        this.options.subpixelPositioning = e1;
                    }
                },
                {
                    key: "_createCloseButton",
                    value: function _createCloseButton() {
                        this.options.closeButton && (this._closeButton = h.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
                    }
                },
                {
                    key: "_focusFirstElement",
                    value: function _focusFirstElement() {
                        if (!this.options.focusAfterOpen || !this._container) return;
                        var _$e = this._container.querySelector(Ts);
                        _$e && _$e.focus();
                    }
                }
            ]);
            return _class;
        }(t.E), e1.RasterDEMTileSource = Y, e1.RasterTileSource = K, e1.ScaleControl = /*#__PURE__*/ function() {
            function _class(e1) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this._onMove = function() {
                    bs(_this._map, _this._container, _this.options);
                }, this.setUnit = function(e1) {
                    _this.options.unit = e1, bs(_this._map, _this._container, _this.options);
                }, this.options = Object.assign(Object.assign({}, xs), e1);
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "getDefaultPosition",
                    value: function getDefaultPosition() {
                        return "bottom-left";
                    }
                },
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        return this._map = e1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", e1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        h.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
                    }
                }
            ]);
            return _class;
        }(), e1.ScrollZoomHandler = Bo, e1.Style = ki, e1.TerrainControl = /*#__PURE__*/ function() {
            function _class(e1) {
                var _this = this;
                (0, $7417b380464c38c1$export$71511d61b312f219)(this, _class);
                this._toggleTerrain = function() {
                    _this._map.getTerrain() ? _this._map.setTerrain(null) : _this._map.setTerrain(_this.options), _this._updateTerrainIcon();
                }, this._updateTerrainIcon = function() {
                    _this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), _this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), _this._map.terrain ? (_this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), _this._terrainButton.title = _this._map._getUIString("TerrainControl.Disable")) : (_this._terrainButton.classList.add("maplibregl-ctrl-terrain"), _this._terrainButton.title = _this._map._getUIString("TerrainControl.Enable"));
                }, this.options = e1;
            }
            (0, $c546c01220e295dd$export$71511d61b312f219)(_class, [
                {
                    key: "onAdd",
                    value: function onAdd(e1) {
                        return this._map = e1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = h.create("button", "maplibregl-ctrl-terrain", this._container), h.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
                    }
                },
                {
                    key: "onRemove",
                    value: function onRemove() {
                        h.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
                    }
                }
            ]);
            return _class;
        }(), e1.TwoFingersTouchPitchHandler = zo, e1.TwoFingersTouchRotateHandler = So, e1.TwoFingersTouchZoomHandler = Mo, e1.TwoFingersTouchZoomRotateHandler = Uo, e1.VectorTileSource = X, e1.VideoSource = ie, e1.addSourceType = function(e1, i) {
            return t._(void 0, void 0, void 0, function() {
                return (0, $a8d2d094d9f0b05d$export$67ebef60e6f28a6)(this, function(_state) {
                    if (oe(e1)) throw new Error('A source type called "'.concat(e1, '" already exists.'));
                    (function(e1, t) {
                        re[e1] = t;
                    })(e1, i);
                    return [
                        2
                    ];
                });
            });
        }, e1.clearPrewarmedResources = function() {
            var _$e = B;
            _$e && (_$e.isPreloaded() && 1 === _$e.numActive() ? (_$e.release(L), B = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
        }, e1.createTileMesh = li, e1.getMaxParallelImageRequests = function() {
            return t.c.MAX_PARALLEL_IMAGE_REQUESTS;
        }, e1.getRTLTextPluginStatus = function() {
            return ce().getRTLTextPluginStatus();
        }, e1.getVersion = function() {
            return Cs;
        }, e1.getWorkerCount = function() {
            return k.workerCount;
        }, e1.getWorkerUrl = function() {
            return t.c.WORKER_URL;
        }, e1.importScriptInWorkers = function(e1) {
            return Z().broadcast("IS", e1);
        }, e1.isTimeFrozen = function() {
            return l.isFrozen();
        }, e1.now = c, e1.prewarm = function() {
            j().acquire(L);
        }, e1.restoreNow = function() {
            l.restoreNow();
        }, e1.setMaxParallelImageRequests = function(e1) {
            t.c.MAX_PARALLEL_IMAGE_REQUESTS = e1;
        }, e1.setNow = function(e1) {
            l.setNow(e1);
        }, e1.setRTLTextPlugin = function(e1, t) {
            return ce().setRTLTextPlugin(e1, t);
        }, e1.setWorkerCount = function(e1) {
            k.workerCount = e1;
        }, e1.setWorkerUrl = function(e1) {
            t.c.WORKER_URL = e1;
        };
    });
    //
    // Our custom intro provides a specialized "define()" function, called by the
    // AMD modules below, that sets up the worker blob URL and then executes the
    // main module, storing its exported value as 'maplibregl'
    var maplibregl$1 = maplibregl;
    return maplibregl$1;
});



var $f2b5c824377585d3$var$MAPTILER_KEY = '1WQsKGA3sGiTASXAr8hf';
var $f2b5c824377585d3$var$silayCityCoords = [
    123.0187,
    10.805
];
function $f2b5c824377585d3$export$b08464e47b7a3a8() {
    var map = new (0, (/*@__PURE__*/$parcel$interopDefault($f44405b77549bdaa$exports))).Map({
        container: 'map',
        style: "https://api.maptiler.com/maps/basic-v2/style.json?key=".concat($f2b5c824377585d3$var$MAPTILER_KEY),
        center: $f2b5c824377585d3$var$silayCityCoords,
        zoom: 15.5,
        minZoom: 10,
        maxZoom: 20,
        pitch: 60,
        bearing: -15,
        antialias: true
    });
    map.addControl(new (0, (/*@__PURE__*/$parcel$interopDefault($f44405b77549bdaa$exports))).NavigationControl());
    // Disable scroll zoom by default
    map.scrollZoom.disable();
    map.on('load', function() {
        // Enable scroll zoom only after click
        map.getCanvas().addEventListener('click', function() {
            map.scrollZoom.enable();
        });
        new (0, (/*@__PURE__*/$parcel$interopDefault($f44405b77549bdaa$exports))).Marker({
            color: '#be1e1e'
        }).setLngLat($f2b5c824377585d3$var$silayCityCoords).setPopup(new (0, (/*@__PURE__*/$parcel$interopDefault($f44405b77549bdaa$exports))).Popup({
            offset: 25
        }).setText("Silay City, Negros Occidental \uD83D\uDCCD")).addTo(map);
        map.addSource('openmaptiles', {
            type: 'vector',
            url: "https://api.maptiler.com/tiles/v3/tiles.json?key=".concat($f2b5c824377585d3$var$MAPTILER_KEY)
        });
        map.addLayer({
            id: '3d-buildings-uniform',
            source: 'openmaptiles',
            'source-layer': 'building',
            type: 'fill-extrusion',
            minzoom: 14,
            paint: {
                'fill-extrusion-color': '#138DA0',
                'fill-extrusion-height': [
                    '*',
                    [
                        'get',
                        'render_height'
                    ],
                    1.5
                ],
                'fill-extrusion-base': [
                    'get',
                    'render_min_height'
                ],
                'fill-extrusion-opacity': 0.9
            }
        });
    });
}


// Match height
document.addEventListener('DOMContentLoaded', function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($3LkHX)))('.icon-wrapper').matchHeight();
    (0, (/*@__PURE__*/$parcel$interopDefault($3LkHX)))('.text-title').matchHeight();
    var menuIcon = document.querySelector('#navToggle');
    var nav = document.getElementById('myTopnav');
    document.querySelectorAll('.topnav a:not(.icon)').forEach(function(navItem) {
        navItem.addEventListener('click', function() {
            document.querySelectorAll('.topnav a').forEach(function(item) {
                item.classList.remove('active');
            });
            this.classList.add('active');
            nav.classList.remove('responsive');
        });
    });
    window.addEventListener('resize', function() {
        var nav = document.getElementById('myTopnav');
        if (window.innerWidth > 600 && nav.classList.contains('responsive')) nav.classList.remove('responsive');
    });
    if (menuIcon && nav) menuIcon.addEventListener('click', function() {
        nav.classList.toggle('responsive');
    });
    var animatedElements = document.querySelectorAll('.animate');
    var observerOptions = {
        root: null,
        threshold: 0.2
    };
    var observer = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('animate-active');
                observer.unobserve(entry.target);
            }
        });
    }, observerOptions);
    animatedElements.forEach(function(el) {
        observer.observe(el);
    });
    var sections = document.querySelectorAll('section[id]');
    var navLinks = document.querySelectorAll('.topnav a:not(.icon)');
    var sectionObserverOptions = {
        root: null,
        threshold: 0.5
    };
    var sectionObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            if (entry.isIntersecting) {
                navLinks.forEach(function(link) {
                    return link.classList.remove('active');
                });
                var id = entry.target.id;
                var activeLink = document.querySelector('.topnav a[href="#'.concat(id, '"]'));
                if (activeLink) activeLink.classList.add('active');
            }
        });
    }, sectionObserverOptions);
    sections.forEach(function(section) {
        sectionObserver.observe(section);
    });
});
window.addEventListener('load', function() {
    document.body.classList.add('page-loaded');
});
// MapLibre
document.addEventListener('DOMContentLoaded', function() {
    var mapEl = document.getElementById('map');
    if (mapEl) (0, $f2b5c824377585d3$export$b08464e47b7a3a8)();
});



var $3LkHX = parcelRequire("3LkHX");
var $3afecb08e92b0eea$exports = {};
/*
     _ _      _       _
 ___| (_) ___| | __  (_)___
/ __| | |/ __| |/ /  | / __|
\__ \ | | (__|   < _ | \__ \
|___/_|_|\___|_|\_(_)/ |___/
                   |__/

 Version: 1.8.1
  Author: Ken Wheeler
 Website: http://kenwheeler.github.io
    Docs: http://kenwheeler.github.io/slick
    Repo: http://github.com/kenwheeler/slick
  Issues: http://github.com/kenwheeler/slick/issues

 */ /* global window, document, define, jQuery, setInterval, clearInterval */ 
var $dvYFb = parcelRequire("dvYFb");

(function(factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) define([
        'jquery'
    ], factory);
    else $3afecb08e92b0eea$exports = factory((parcelRequire("3LkHX")));
})(function($) {
    'use strict';
    var Slick = window.Slick || {};
    Slick = function() {
        var instanceUid = 0;
        function Slick(element, settings) {
            var _ = this, dataSettings;
            _.defaults = {
                accessibility: true,
                adaptiveHeight: false,
                appendArrows: $(element),
                appendDots: $(element),
                arrows: true,
                asNavFor: null,
                prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
                autoplay: false,
                autoplaySpeed: 3000,
                centerMode: false,
                centerPadding: '50px',
                cssEase: 'ease',
                customPaging: function customPaging(slider, i) {
                    return $('<button type="button" />').text(i + 1);
                },
                dots: false,
                dotsClass: 'slick-dots',
                draggable: true,
                easing: 'linear',
                edgeFriction: 0.35,
                fade: false,
                focusOnSelect: false,
                focusOnChange: false,
                infinite: true,
                initialSlide: 0,
                lazyLoad: 'ondemand',
                mobileFirst: false,
                pauseOnHover: true,
                pauseOnFocus: true,
                pauseOnDotsHover: false,
                respondTo: 'window',
                responsive: null,
                rows: 1,
                rtl: false,
                slide: '',
                slidesPerRow: 1,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 500,
                swipe: true,
                swipeToSlide: false,
                touchMove: true,
                touchThreshold: 5,
                useCSS: true,
                useTransform: true,
                variableWidth: false,
                vertical: false,
                verticalSwiping: false,
                waitForAnimate: true,
                zIndex: 1000
            };
            _.initials = {
                animating: false,
                dragging: false,
                autoPlayTimer: null,
                currentDirection: 0,
                currentLeft: null,
                currentSlide: 0,
                direction: 1,
                $dots: null,
                listWidth: null,
                listHeight: null,
                loadIndex: 0,
                $nextArrow: null,
                $prevArrow: null,
                scrolling: false,
                slideCount: null,
                slideWidth: null,
                $slideTrack: null,
                $slides: null,
                sliding: false,
                slideOffset: 0,
                swipeLeft: null,
                swiping: false,
                $list: null,
                touchObject: {},
                transformsEnabled: false,
                unslicked: false
            };
            $.extend(_, _.initials);
            _.activeBreakpoint = null;
            _.animType = null;
            _.animProp = null;
            _.breakpoints = [];
            _.breakpointSettings = [];
            _.cssTransitions = false;
            _.focussed = false;
            _.interrupted = false;
            _.hidden = 'hidden';
            _.paused = true;
            _.positionProp = null;
            _.respondTo = null;
            _.rowCount = 1;
            _.shouldClick = true;
            _.$slider = $(element);
            _.$slidesCache = null;
            _.transformType = null;
            _.transitionType = null;
            _.visibilityChange = 'visibilitychange';
            _.windowWidth = 0;
            _.windowTimer = null;
            dataSettings = $(element).data('slick') || {};
            _.options = $.extend({}, _.defaults, settings, dataSettings);
            _.currentSlide = _.options.initialSlide;
            _.originalSettings = _.options;
            if (typeof document.mozHidden !== 'undefined') {
                _.hidden = 'mozHidden';
                _.visibilityChange = 'mozvisibilitychange';
            } else if (typeof document.webkitHidden !== 'undefined') {
                _.hidden = 'webkitHidden';
                _.visibilityChange = 'webkitvisibilitychange';
            }
            _.autoPlay = $.proxy(_.autoPlay, _);
            _.autoPlayClear = $.proxy(_.autoPlayClear, _);
            _.autoPlayIterator = $.proxy(_.autoPlayIterator, _);
            _.changeSlide = $.proxy(_.changeSlide, _);
            _.clickHandler = $.proxy(_.clickHandler, _);
            _.selectHandler = $.proxy(_.selectHandler, _);
            _.setPosition = $.proxy(_.setPosition, _);
            _.swipeHandler = $.proxy(_.swipeHandler, _);
            _.dragHandler = $.proxy(_.dragHandler, _);
            _.keyHandler = $.proxy(_.keyHandler, _);
            _.instanceUid = instanceUid++;
            // A simple way to check for HTML strings
            // Strict HTML recognition (must start with <)
            // Extracted from jQuery v1.11 source
            _.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/;
            _.registerBreakpoints();
            _.init(true);
        }
        return Slick;
    }();
    Slick.prototype.activateADA = function() {
        var _ = this;
        _.$slideTrack.find('.slick-active').attr({
            'aria-hidden': 'false'
        }).find('a, input, button, select').attr({
            'tabindex': '0'
        });
    };
    Slick.prototype.addSlide = Slick.prototype.slickAdd = function(markup, index, addBefore) {
        var _ = this;
        if (typeof index === 'boolean') {
            addBefore = index;
            index = null;
        } else if (index < 0 || index >= _.slideCount) return false;
        _.unload();
        if (typeof index === 'number') {
            if (index === 0 && _.$slides.length === 0) $(markup).appendTo(_.$slideTrack);
            else if (addBefore) $(markup).insertBefore(_.$slides.eq(index));
            else $(markup).insertAfter(_.$slides.eq(index));
        } else if (addBefore === true) $(markup).prependTo(_.$slideTrack);
        else $(markup).appendTo(_.$slideTrack);
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index);
        });
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.animateHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.animate({
                height: targetHeight
            }, _.options.speed);
        }
    };
    Slick.prototype.animateSlide = function(targetLeft, callback) {
        var animProps = {}, _ = this;
        _.animateHeight();
        if (_.options.rtl === true && _.options.vertical === false) targetLeft = -targetLeft;
        if (_.transformsEnabled === false) {
            if (_.options.vertical === false) _.$slideTrack.animate({
                left: targetLeft
            }, _.options.speed, _.options.easing, callback);
            else _.$slideTrack.animate({
                top: targetLeft
            }, _.options.speed, _.options.easing, callback);
        } else if (_.cssTransitions === false) {
            if (_.options.rtl === true) _.currentLeft = -_.currentLeft;
            $({
                animStart: _.currentLeft
            }).animate({
                animStart: targetLeft
            }, {
                duration: _.options.speed,
                easing: _.options.easing,
                step: function step(now) {
                    now = Math.ceil(now);
                    if (_.options.vertical === false) {
                        animProps[_.animType] = 'translate(' + now + 'px, 0px)';
                        _.$slideTrack.css(animProps);
                    } else {
                        animProps[_.animType] = 'translate(0px,' + now + 'px)';
                        _.$slideTrack.css(animProps);
                    }
                },
                complete: function complete() {
                    if (callback) callback.call();
                }
            });
        } else {
            _.applyTransition();
            targetLeft = Math.ceil(targetLeft);
            if (_.options.vertical === false) animProps[_.animType] = 'translate3d(' + targetLeft + 'px, 0px, 0px)';
            else animProps[_.animType] = 'translate3d(0px,' + targetLeft + 'px, 0px)';
            _.$slideTrack.css(animProps);
            if (callback) setTimeout(function() {
                _.disableTransition();
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.getNavTarget = function() {
        var _ = this, asNavFor = _.options.asNavFor;
        if (asNavFor && asNavFor !== null) asNavFor = $(asNavFor).not(_.$slider);
        return asNavFor;
    };
    Slick.prototype.asNavFor = function(index) {
        var _ = this, asNavFor = _.getNavTarget();
        if (asNavFor !== null && (typeof asNavFor === "undefined" ? "undefined" : (0, $dvYFb._)(asNavFor)) === 'object') asNavFor.each(function() {
            var target = $(this).slick('getSlick');
            if (!target.unslicked) target.slideHandler(index, true);
        });
    };
    Slick.prototype.applyTransition = function(slide) {
        var _ = this, transition = {};
        if (_.options.fade === false) transition[_.transitionType] = _.transformType + ' ' + _.options.speed + 'ms ' + _.options.cssEase;
        else transition[_.transitionType] = 'opacity ' + _.options.speed + 'ms ' + _.options.cssEase;
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.autoPlay = function() {
        var _ = this;
        _.autoPlayClear();
        if (_.slideCount > _.options.slidesToShow) _.autoPlayTimer = setInterval(_.autoPlayIterator, _.options.autoplaySpeed);
    };
    Slick.prototype.autoPlayClear = function() {
        var _ = this;
        if (_.autoPlayTimer) clearInterval(_.autoPlayTimer);
    };
    Slick.prototype.autoPlayIterator = function() {
        var _ = this, slideTo = _.currentSlide + _.options.slidesToScroll;
        if (!_.paused && !_.interrupted && !_.focussed) {
            if (_.options.infinite === false) {
                if (_.direction === 1 && _.currentSlide + 1 === _.slideCount - 1) _.direction = 0;
                else if (_.direction === 0) {
                    slideTo = _.currentSlide - _.options.slidesToScroll;
                    if (_.currentSlide - 1 === 0) _.direction = 1;
                }
            }
            _.slideHandler(slideTo);
        }
    };
    Slick.prototype.buildArrows = function() {
        var _ = this;
        if (_.options.arrows === true) {
            _.$prevArrow = $(_.options.prevArrow).addClass('slick-arrow');
            _.$nextArrow = $(_.options.nextArrow).addClass('slick-arrow');
            if (_.slideCount > _.options.slidesToShow) {
                _.$prevArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                _.$nextArrow.removeClass('slick-hidden').removeAttr('aria-hidden tabindex');
                if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.prependTo(_.options.appendArrows);
                if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.appendTo(_.options.appendArrows);
                if (_.options.infinite !== true) _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
            } else _.$prevArrow.add(_.$nextArrow).addClass('slick-hidden').attr({
                'aria-disabled': 'true',
                'tabindex': '-1'
            });
        }
    };
    Slick.prototype.buildDots = function() {
        var _ = this, i, dot;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            _.$slider.addClass('slick-dotted');
            dot = $('<ul />').addClass(_.options.dotsClass);
            for(i = 0; i <= _.getDotCount(); i += 1)dot.append($('<li />').append(_.options.customPaging.call(this, _, i)));
            _.$dots = dot.appendTo(_.options.appendDots);
            _.$dots.find('li').first().addClass('slick-active');
        }
    };
    Slick.prototype.buildOut = function() {
        var _ = this;
        _.$slides = _.$slider.children(_.options.slide + ':not(.slick-cloned)').addClass('slick-slide');
        _.slideCount = _.$slides.length;
        _.$slides.each(function(index, element) {
            $(element).attr('data-slick-index', index).data('originalStyling', $(element).attr('style') || '');
        });
        _.$slider.addClass('slick-slider');
        _.$slideTrack = _.slideCount === 0 ? $('<div class="slick-track"/>').appendTo(_.$slider) : _.$slides.wrapAll('<div class="slick-track"/>').parent();
        _.$list = _.$slideTrack.wrap('<div class="slick-list"/>').parent();
        _.$slideTrack.css('opacity', 0);
        if (_.options.centerMode === true || _.options.swipeToSlide === true) _.options.slidesToScroll = 1;
        $('img[data-lazy]', _.$slider).not('[src]').addClass('slick-loading');
        _.setupInfinite();
        _.buildArrows();
        _.buildDots();
        _.updateDots();
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        if (_.options.draggable === true) _.$list.addClass('draggable');
    };
    Slick.prototype.buildRows = function() {
        var _ = this, a, b, c, newSlides, numOfSlides, originalSlides, slidesPerSection;
        newSlides = document.createDocumentFragment();
        originalSlides = _.$slider.children();
        if (_.options.rows > 0) {
            slidesPerSection = _.options.slidesPerRow * _.options.rows;
            numOfSlides = Math.ceil(originalSlides.length / slidesPerSection);
            for(a = 0; a < numOfSlides; a++){
                var slide = document.createElement('div');
                for(b = 0; b < _.options.rows; b++){
                    var row = document.createElement('div');
                    for(c = 0; c < _.options.slidesPerRow; c++){
                        var target = a * slidesPerSection + (b * _.options.slidesPerRow + c);
                        if (originalSlides.get(target)) row.appendChild(originalSlides.get(target));
                    }
                    slide.appendChild(row);
                }
                newSlides.appendChild(slide);
            }
            _.$slider.empty().append(newSlides);
            _.$slider.children().children().children().css({
                'width': 100 / _.options.slidesPerRow + '%',
                'display': 'inline-block'
            });
        }
    };
    Slick.prototype.checkResponsive = function(initial, forceUpdate) {
        var _ = this, breakpoint, targetBreakpoint, respondToWidth, triggerBreakpoint = false;
        var sliderWidth = _.$slider.width();
        var windowWidth = window.innerWidth || $(window).width();
        if (_.respondTo === 'window') respondToWidth = windowWidth;
        else if (_.respondTo === 'slider') respondToWidth = sliderWidth;
        else if (_.respondTo === 'min') respondToWidth = Math.min(windowWidth, sliderWidth);
        if (_.options.responsive && _.options.responsive.length && _.options.responsive !== null) {
            targetBreakpoint = null;
            for(breakpoint in _.breakpoints)if (_.breakpoints.hasOwnProperty(breakpoint)) {
                if (_.originalSettings.mobileFirst === false) {
                    if (respondToWidth < _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
                } else if (respondToWidth > _.breakpoints[breakpoint]) targetBreakpoint = _.breakpoints[breakpoint];
            }
            if (targetBreakpoint !== null) {
                if (_.activeBreakpoint !== null) {
                    if (targetBreakpoint !== _.activeBreakpoint || forceUpdate) {
                        _.activeBreakpoint = targetBreakpoint;
                        if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                        else {
                            _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                            if (initial === true) _.currentSlide = _.options.initialSlide;
                            _.refresh(initial);
                        }
                        triggerBreakpoint = targetBreakpoint;
                    }
                } else {
                    _.activeBreakpoint = targetBreakpoint;
                    if (_.breakpointSettings[targetBreakpoint] === 'unslick') _.unslick(targetBreakpoint);
                    else {
                        _.options = $.extend({}, _.originalSettings, _.breakpointSettings[targetBreakpoint]);
                        if (initial === true) _.currentSlide = _.options.initialSlide;
                        _.refresh(initial);
                    }
                    triggerBreakpoint = targetBreakpoint;
                }
            } else if (_.activeBreakpoint !== null) {
                _.activeBreakpoint = null;
                _.options = _.originalSettings;
                if (initial === true) _.currentSlide = _.options.initialSlide;
                _.refresh(initial);
                triggerBreakpoint = targetBreakpoint;
            }
            // only trigger breakpoints during an actual break. not on initialize.
            if (!initial && triggerBreakpoint !== false) _.$slider.trigger('breakpoint', [
                _,
                triggerBreakpoint
            ]);
        }
    };
    Slick.prototype.changeSlide = function(event, dontAnimate) {
        var _ = this, $target = $(event.currentTarget), indexOffset, slideOffset, unevenOffset;
        // If target is a link, prevent default action.
        if ($target.is('a')) event.preventDefault();
        // If target is not the <li> element (ie: a child), find the <li>.
        if (!$target.is('li')) $target = $target.closest('li');
        unevenOffset = _.slideCount % _.options.slidesToScroll !== 0;
        indexOffset = unevenOffset ? 0 : (_.slideCount - _.currentSlide) % _.options.slidesToScroll;
        switch(event.data.message){
            case 'previous':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : _.options.slidesToShow - indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide - slideOffset, false, dontAnimate);
                break;
            case 'next':
                slideOffset = indexOffset === 0 ? _.options.slidesToScroll : indexOffset;
                if (_.slideCount > _.options.slidesToShow) _.slideHandler(_.currentSlide + slideOffset, false, dontAnimate);
                break;
            case 'index':
                var index = event.data.index === 0 ? 0 : event.data.index || $target.index() * _.options.slidesToScroll;
                _.slideHandler(_.checkNavigable(index), false, dontAnimate);
                $target.children().trigger('focus');
                break;
            default:
                return;
        }
    };
    Slick.prototype.checkNavigable = function(index) {
        var _ = this, navigables, prevNavigable;
        navigables = _.getNavigableIndexes();
        prevNavigable = 0;
        if (index > navigables[navigables.length - 1]) index = navigables[navigables.length - 1];
        else for(var n in navigables){
            if (index < navigables[n]) {
                index = prevNavigable;
                break;
            }
            prevNavigable = navigables[n];
        }
        return index;
    };
    Slick.prototype.cleanUpEvents = function() {
        var _ = this;
        if (_.options.dots && _.$dots !== null) {
            $('li', _.$dots).off('click.slick', _.changeSlide).off('mouseenter.slick', $.proxy(_.interrupt, _, true)).off('mouseleave.slick', $.proxy(_.interrupt, _, false));
            if (_.options.accessibility === true) _.$dots.off('keydown.slick', _.keyHandler);
        }
        _.$slider.off('focus.slick blur.slick');
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow && _.$prevArrow.off('click.slick', _.changeSlide);
            _.$nextArrow && _.$nextArrow.off('click.slick', _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow && _.$prevArrow.off('keydown.slick', _.keyHandler);
                _.$nextArrow && _.$nextArrow.off('keydown.slick', _.keyHandler);
            }
        }
        _.$list.off('touchstart.slick mousedown.slick', _.swipeHandler);
        _.$list.off('touchmove.slick mousemove.slick', _.swipeHandler);
        _.$list.off('touchend.slick mouseup.slick', _.swipeHandler);
        _.$list.off('touchcancel.slick mouseleave.slick', _.swipeHandler);
        _.$list.off('click.slick', _.clickHandler);
        $(document).off(_.visibilityChange, _.visibility);
        _.cleanUpSlideEvents();
        if (_.options.accessibility === true) _.$list.off('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().off('click.slick', _.selectHandler);
        $(window).off('orientationchange.slick.slick-' + _.instanceUid, _.orientationChange);
        $(window).off('resize.slick.slick-' + _.instanceUid, _.resize);
        $('[draggable!=true]', _.$slideTrack).off('dragstart', _.preventDefault);
        $(window).off('load.slick.slick-' + _.instanceUid, _.setPosition);
    };
    Slick.prototype.cleanUpSlideEvents = function() {
        var _ = this;
        _.$list.off('mouseenter.slick', $.proxy(_.interrupt, _, true));
        _.$list.off('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.cleanUpRows = function() {
        var _ = this, originalSlides;
        if (_.options.rows > 0) {
            originalSlides = _.$slides.children().children();
            originalSlides.removeAttr('style');
            _.$slider.empty().append(originalSlides);
        }
    };
    Slick.prototype.clickHandler = function(event) {
        var _ = this;
        if (_.shouldClick === false) {
            event.stopImmediatePropagation();
            event.stopPropagation();
            event.preventDefault();
        }
    };
    Slick.prototype.destroy = function(refresh) {
        var _ = this;
        _.autoPlayClear();
        _.touchObject = {};
        _.cleanUpEvents();
        $('.slick-cloned', _.$slider).detach();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.$prevArrow.length) {
            _.$prevArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        }
        if (_.$nextArrow && _.$nextArrow.length) {
            _.$nextArrow.removeClass('slick-disabled slick-arrow slick-hidden').removeAttr('aria-hidden aria-disabled tabindex').css('display', '');
            if (_.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        }
        if (_.$slides) {
            _.$slides.removeClass('slick-slide slick-active slick-center slick-visible slick-current').removeAttr('aria-hidden').removeAttr('data-slick-index').each(function() {
                $(this).attr('style', $(this).data('originalStyling'));
            });
            _.$slideTrack.children(this.options.slide).detach();
            _.$slideTrack.detach();
            _.$list.detach();
            _.$slider.append(_.$slides);
        }
        _.cleanUpRows();
        _.$slider.removeClass('slick-slider');
        _.$slider.removeClass('slick-initialized');
        _.$slider.removeClass('slick-dotted');
        _.unslicked = true;
        if (!refresh) _.$slider.trigger('destroy', [
            _
        ]);
    };
    Slick.prototype.disableTransition = function(slide) {
        var _ = this, transition = {};
        transition[_.transitionType] = '';
        if (_.options.fade === false) _.$slideTrack.css(transition);
        else _.$slides.eq(slide).css(transition);
    };
    Slick.prototype.fadeSlide = function(slideIndex, callback) {
        var _ = this;
        if (_.cssTransitions === false) {
            _.$slides.eq(slideIndex).css({
                zIndex: _.options.zIndex
            });
            _.$slides.eq(slideIndex).animate({
                opacity: 1
            }, _.options.speed, _.options.easing, callback);
        } else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 1,
                zIndex: _.options.zIndex
            });
            if (callback) setTimeout(function() {
                _.disableTransition(slideIndex);
                callback.call();
            }, _.options.speed);
        }
    };
    Slick.prototype.fadeSlideOut = function(slideIndex) {
        var _ = this;
        if (_.cssTransitions === false) _.$slides.eq(slideIndex).animate({
            opacity: 0,
            zIndex: _.options.zIndex - 2
        }, _.options.speed, _.options.easing);
        else {
            _.applyTransition(slideIndex);
            _.$slides.eq(slideIndex).css({
                opacity: 0,
                zIndex: _.options.zIndex - 2
            });
        }
    };
    Slick.prototype.filterSlides = Slick.prototype.slickFilter = function(filter) {
        var _ = this;
        if (filter !== null) {
            _.$slidesCache = _.$slides;
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.filter(filter).appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.focusHandler = function() {
        var _ = this;
        _.$slider.off('focus.slick blur.slick').on('focus.slick blur.slick', '*', function(event) {
            event.stopImmediatePropagation();
            var $sf = $(this);
            setTimeout(function() {
                if (_.options.pauseOnFocus) {
                    _.focussed = $sf.is(':focus');
                    _.autoPlay();
                }
            }, 0);
        });
    };
    Slick.prototype.getCurrent = Slick.prototype.slickCurrentSlide = function() {
        var _ = this;
        return _.currentSlide;
    };
    Slick.prototype.getDotCount = function() {
        var _ = this;
        var breakPoint = 0;
        var counter = 0;
        var pagerQty = 0;
        if (_.options.infinite === true) {
            if (_.slideCount <= _.options.slidesToShow) ++pagerQty;
            else while(breakPoint < _.slideCount){
                ++pagerQty;
                breakPoint = counter + _.options.slidesToScroll;
                counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
            }
        } else if (_.options.centerMode === true) pagerQty = _.slideCount;
        else if (!_.options.asNavFor) pagerQty = 1 + Math.ceil((_.slideCount - _.options.slidesToShow) / _.options.slidesToScroll);
        else while(breakPoint < _.slideCount){
            ++pagerQty;
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return pagerQty - 1;
    };
    Slick.prototype.getLeft = function(slideIndex) {
        var _ = this, targetLeft, verticalHeight, verticalOffset = 0, targetSlide, coef;
        _.slideOffset = 0;
        verticalHeight = _.$slides.first().outerHeight(true);
        if (_.options.infinite === true) {
            if (_.slideCount > _.options.slidesToShow) {
                _.slideOffset = _.slideWidth * _.options.slidesToShow * -1;
                coef = -1;
                if (_.options.vertical === true && _.options.centerMode === true) {
                    if (_.options.slidesToShow === 2) coef = -1.5;
                    else if (_.options.slidesToShow === 1) coef = -2;
                }
                verticalOffset = verticalHeight * _.options.slidesToShow * coef;
            }
            if (_.slideCount % _.options.slidesToScroll !== 0) {
                if (slideIndex + _.options.slidesToScroll > _.slideCount && _.slideCount > _.options.slidesToShow) {
                    if (slideIndex > _.slideCount) {
                        _.slideOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * _.slideWidth * -1;
                        verticalOffset = (_.options.slidesToShow - (slideIndex - _.slideCount)) * verticalHeight * -1;
                    } else {
                        _.slideOffset = _.slideCount % _.options.slidesToScroll * _.slideWidth * -1;
                        verticalOffset = _.slideCount % _.options.slidesToScroll * verticalHeight * -1;
                    }
                }
            }
        } else if (slideIndex + _.options.slidesToShow > _.slideCount) {
            _.slideOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * _.slideWidth;
            verticalOffset = (slideIndex + _.options.slidesToShow - _.slideCount) * verticalHeight;
        }
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideOffset = 0;
            verticalOffset = 0;
        }
        if (_.options.centerMode === true && _.slideCount <= _.options.slidesToShow) _.slideOffset = _.slideWidth * Math.floor(_.options.slidesToShow) / 2 - _.slideWidth * _.slideCount / 2;
        else if (_.options.centerMode === true && _.options.infinite === true) _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2) - _.slideWidth;
        else if (_.options.centerMode === true) {
            _.slideOffset = 0;
            _.slideOffset += _.slideWidth * Math.floor(_.options.slidesToShow / 2);
        }
        if (_.options.vertical === false) targetLeft = slideIndex * _.slideWidth * -1 + _.slideOffset;
        else targetLeft = slideIndex * verticalHeight * -1 + verticalOffset;
        if (_.options.variableWidth === true) {
            if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
            else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow);
            if (_.options.rtl === true) {
                if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                else targetLeft = 0;
            } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
            if (_.options.centerMode === true) {
                if (_.slideCount <= _.options.slidesToShow || _.options.infinite === false) targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex);
                else targetSlide = _.$slideTrack.children('.slick-slide').eq(slideIndex + _.options.slidesToShow + 1);
                if (_.options.rtl === true) {
                    if (targetSlide[0]) targetLeft = (_.$slideTrack.width() - targetSlide[0].offsetLeft - targetSlide.width()) * -1;
                    else targetLeft = 0;
                } else targetLeft = targetSlide[0] ? targetSlide[0].offsetLeft * -1 : 0;
                targetLeft += (_.$list.width() - targetSlide.outerWidth()) / 2;
            }
        }
        return targetLeft;
    };
    Slick.prototype.getOption = Slick.prototype.slickGetOption = function(option) {
        var _ = this;
        return _.options[option];
    };
    Slick.prototype.getNavigableIndexes = function() {
        var _ = this, breakPoint = 0, counter = 0, indexes = [], max;
        if (_.options.infinite === false) max = _.slideCount;
        else {
            breakPoint = _.options.slidesToScroll * -1;
            counter = _.options.slidesToScroll * -1;
            max = _.slideCount * 2;
        }
        while(breakPoint < max){
            indexes.push(breakPoint);
            breakPoint = counter + _.options.slidesToScroll;
            counter += _.options.slidesToScroll <= _.options.slidesToShow ? _.options.slidesToScroll : _.options.slidesToShow;
        }
        return indexes;
    };
    Slick.prototype.getSlick = function() {
        return this;
    };
    Slick.prototype.getSlideCount = function() {
        var _ = this, slidesTraversed, swipedSlide, centerOffset;
        centerOffset = _.options.centerMode === true ? _.slideWidth * Math.floor(_.options.slidesToShow / 2) : 0;
        if (_.options.swipeToSlide === true) {
            _.$slideTrack.find('.slick-slide').each(function(index, slide) {
                if (slide.offsetLeft - centerOffset + $(slide).outerWidth() / 2 > _.swipeLeft * -1) {
                    swipedSlide = slide;
                    return false;
                }
            });
            slidesTraversed = Math.abs($(swipedSlide).attr('data-slick-index') - _.currentSlide) || 1;
            return slidesTraversed;
        } else return _.options.slidesToScroll;
    };
    Slick.prototype.goTo = Slick.prototype.slickGoTo = function(slide, dontAnimate) {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'index',
                index: parseInt(slide)
            }
        }, dontAnimate);
    };
    Slick.prototype.init = function(creation) {
        var _ = this;
        if (!$(_.$slider).hasClass('slick-initialized')) {
            $(_.$slider).addClass('slick-initialized');
            _.buildRows();
            _.buildOut();
            _.setProps();
            _.startLoad();
            _.loadSlider();
            _.initializeEvents();
            _.updateArrows();
            _.updateDots();
            _.checkResponsive(true);
            _.focusHandler();
        }
        if (creation) _.$slider.trigger('init', [
            _
        ]);
        if (_.options.accessibility === true) _.initADA();
        if (_.options.autoplay) {
            _.paused = false;
            _.autoPlay();
        }
    };
    Slick.prototype.initADA = function() {
        var _ = this, numDotGroups = Math.ceil(_.slideCount / _.options.slidesToShow), tabControlIndexes = _.getNavigableIndexes().filter(function(val) {
            return val >= 0 && val < _.slideCount;
        });
        _.$slides.add(_.$slideTrack.find('.slick-cloned')).attr({
            'aria-hidden': 'true',
            'tabindex': '-1'
        }).find('a, input, button, select').attr({
            'tabindex': '-1'
        });
        if (_.$dots !== null) {
            _.$slides.not(_.$slideTrack.find('.slick-cloned')).each(function(i) {
                var slideControlIndex = tabControlIndexes.indexOf(i);
                $(this).attr({
                    'role': 'tabpanel',
                    'id': 'slick-slide' + _.instanceUid + i,
                    'tabindex': -1
                });
                if (slideControlIndex !== -1) {
                    var ariaButtonControl = 'slick-slide-control' + _.instanceUid + slideControlIndex;
                    if ($('#' + ariaButtonControl).length) $(this).attr({
                        'aria-describedby': ariaButtonControl
                    });
                }
            });
            _.$dots.attr('role', 'tablist').find('li').each(function(i) {
                var mappedSlideIndex = tabControlIndexes[i];
                $(this).attr({
                    'role': 'presentation'
                });
                $(this).find('button').first().attr({
                    'role': 'tab',
                    'id': 'slick-slide-control' + _.instanceUid + i,
                    'aria-controls': 'slick-slide' + _.instanceUid + mappedSlideIndex,
                    'aria-label': i + 1 + ' of ' + numDotGroups,
                    'aria-selected': null,
                    'tabindex': '-1'
                });
            }).eq(_.currentSlide).find('button').attr({
                'aria-selected': 'true',
                'tabindex': '0'
            }).end();
        }
        for(var i = _.currentSlide, max = i + _.options.slidesToShow; i < max; i++)if (_.options.focusOnChange) _.$slides.eq(i).attr({
            'tabindex': '0'
        });
        else _.$slides.eq(i).removeAttr('tabindex');
        _.activateADA();
    };
    Slick.prototype.initArrowEvents = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.off('click.slick').on('click.slick', {
                message: 'previous'
            }, _.changeSlide);
            _.$nextArrow.off('click.slick').on('click.slick', {
                message: 'next'
            }, _.changeSlide);
            if (_.options.accessibility === true) {
                _.$prevArrow.on('keydown.slick', _.keyHandler);
                _.$nextArrow.on('keydown.slick', _.keyHandler);
            }
        }
    };
    Slick.prototype.initDotEvents = function() {
        var _ = this;
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) {
            $('li', _.$dots).on('click.slick', {
                message: 'index'
            }, _.changeSlide);
            if (_.options.accessibility === true) _.$dots.on('keydown.slick', _.keyHandler);
        }
        if (_.options.dots === true && _.options.pauseOnDotsHover === true && _.slideCount > _.options.slidesToShow) $('li', _.$dots).on('mouseenter.slick', $.proxy(_.interrupt, _, true)).on('mouseleave.slick', $.proxy(_.interrupt, _, false));
    };
    Slick.prototype.initSlideEvents = function() {
        var _ = this;
        if (_.options.pauseOnHover) {
            _.$list.on('mouseenter.slick', $.proxy(_.interrupt, _, true));
            _.$list.on('mouseleave.slick', $.proxy(_.interrupt, _, false));
        }
    };
    Slick.prototype.initializeEvents = function() {
        var _ = this;
        _.initArrowEvents();
        _.initDotEvents();
        _.initSlideEvents();
        _.$list.on('touchstart.slick mousedown.slick', {
            action: 'start'
        }, _.swipeHandler);
        _.$list.on('touchmove.slick mousemove.slick', {
            action: 'move'
        }, _.swipeHandler);
        _.$list.on('touchend.slick mouseup.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('touchcancel.slick mouseleave.slick', {
            action: 'end'
        }, _.swipeHandler);
        _.$list.on('click.slick', _.clickHandler);
        $(document).on(_.visibilityChange, $.proxy(_.visibility, _));
        if (_.options.accessibility === true) _.$list.on('keydown.slick', _.keyHandler);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        $(window).on('orientationchange.slick.slick-' + _.instanceUid, $.proxy(_.orientationChange, _));
        $(window).on('resize.slick.slick-' + _.instanceUid, $.proxy(_.resize, _));
        $('[draggable!=true]', _.$slideTrack).on('dragstart', _.preventDefault);
        $(window).on('load.slick.slick-' + _.instanceUid, _.setPosition);
        $(_.setPosition);
    };
    Slick.prototype.initUI = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.show();
            _.$nextArrow.show();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.show();
    };
    Slick.prototype.keyHandler = function(event) {
        var _ = this;
        //Dont slide if the cursor is inside the form fields and arrow keys are pressed
        if (!event.target.tagName.match('TEXTAREA|INPUT|SELECT')) {
            if (event.keyCode === 37 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'next' : 'previous'
                }
            });
            else if (event.keyCode === 39 && _.options.accessibility === true) _.changeSlide({
                data: {
                    message: _.options.rtl === true ? 'previous' : 'next'
                }
            });
        }
    };
    Slick.prototype.lazyLoad = function() {
        var _ = this, loadRange, cloneRange, rangeStart, rangeEnd;
        function loadImages(imagesScope) {
            $('img[data-lazy]', imagesScope).each(function() {
                var image = $(this), imageSource = $(this).attr('data-lazy'), imageSrcSet = $(this).attr('data-srcset'), imageSizes = $(this).attr('data-sizes') || _.$slider.attr('data-sizes'), imageToLoad = document.createElement('img');
                imageToLoad.onload = function() {
                    image.animate({
                        opacity: 0
                    }, 100, function() {
                        if (imageSrcSet) {
                            image.attr('srcset', imageSrcSet);
                            if (imageSizes) image.attr('sizes', imageSizes);
                        }
                        image.attr('src', imageSource).animate({
                            opacity: 1
                        }, 200, function() {
                            image.removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                        });
                        _.$slider.trigger('lazyLoaded', [
                            _,
                            image,
                            imageSource
                        ]);
                    });
                };
                imageToLoad.onerror = function() {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                };
                imageToLoad.src = imageSource;
            });
        }
        if (_.options.centerMode === true) {
            if (_.options.infinite === true) {
                rangeStart = _.currentSlide + (_.options.slidesToShow / 2 + 1);
                rangeEnd = rangeStart + _.options.slidesToShow + 2;
            } else {
                rangeStart = Math.max(0, _.currentSlide - (_.options.slidesToShow / 2 + 1));
                rangeEnd = 2 + (_.options.slidesToShow / 2 + 1) + _.currentSlide;
            }
        } else {
            rangeStart = _.options.infinite ? _.options.slidesToShow + _.currentSlide : _.currentSlide;
            rangeEnd = Math.ceil(rangeStart + _.options.slidesToShow);
            if (_.options.fade === true) {
                if (rangeStart > 0) rangeStart--;
                if (rangeEnd <= _.slideCount) rangeEnd++;
            }
        }
        loadRange = _.$slider.find('.slick-slide').slice(rangeStart, rangeEnd);
        if (_.options.lazyLoad === 'anticipated') {
            var prevSlide = rangeStart - 1, nextSlide = rangeEnd, $slides = _.$slider.find('.slick-slide');
            for(var i = 0; i < _.options.slidesToScroll; i++){
                if (prevSlide < 0) prevSlide = _.slideCount - 1;
                loadRange = loadRange.add($slides.eq(prevSlide));
                loadRange = loadRange.add($slides.eq(nextSlide));
                prevSlide--;
                nextSlide++;
            }
        }
        loadImages(loadRange);
        if (_.slideCount <= _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-slide');
            loadImages(cloneRange);
        } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow) {
            cloneRange = _.$slider.find('.slick-cloned').slice(0, _.options.slidesToShow);
            loadImages(cloneRange);
        } else if (_.currentSlide === 0) {
            cloneRange = _.$slider.find('.slick-cloned').slice(_.options.slidesToShow * -1);
            loadImages(cloneRange);
        }
    };
    Slick.prototype.loadSlider = function() {
        var _ = this;
        _.setPosition();
        _.$slideTrack.css({
            opacity: 1
        });
        _.$slider.removeClass('slick-loading');
        _.initUI();
        if (_.options.lazyLoad === 'progressive') _.progressiveLazyLoad();
    };
    Slick.prototype.next = Slick.prototype.slickNext = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'next'
            }
        });
    };
    Slick.prototype.orientationChange = function() {
        var _ = this;
        _.checkResponsive();
        _.setPosition();
    };
    Slick.prototype.pause = Slick.prototype.slickPause = function() {
        var _ = this;
        _.autoPlayClear();
        _.paused = true;
    };
    Slick.prototype.play = Slick.prototype.slickPlay = function() {
        var _ = this;
        _.autoPlay();
        _.options.autoplay = true;
        _.paused = false;
        _.focussed = false;
        _.interrupted = false;
    };
    Slick.prototype.postSlide = function(index) {
        var _ = this;
        if (!_.unslicked) {
            _.$slider.trigger('afterChange', [
                _,
                index
            ]);
            _.animating = false;
            if (_.slideCount > _.options.slidesToShow) _.setPosition();
            _.swipeLeft = null;
            if (_.options.autoplay) _.autoPlay();
            if (_.options.accessibility === true) {
                _.initADA();
                if (_.options.focusOnChange) {
                    var $currentSlide = $(_.$slides.get(_.currentSlide));
                    $currentSlide.attr('tabindex', 0).focus();
                }
            }
        }
    };
    Slick.prototype.prev = Slick.prototype.slickPrev = function() {
        var _ = this;
        _.changeSlide({
            data: {
                message: 'previous'
            }
        });
    };
    Slick.prototype.preventDefault = function(event) {
        event.preventDefault();
    };
    Slick.prototype.progressiveLazyLoad = function(tryCount) {
        tryCount = tryCount || 1;
        var _ = this, $imgsToLoad = $('img[data-lazy]', _.$slider), image, imageSource, imageSrcSet, imageSizes, imageToLoad;
        if ($imgsToLoad.length) {
            image = $imgsToLoad.first();
            imageSource = image.attr('data-lazy');
            imageSrcSet = image.attr('data-srcset');
            imageSizes = image.attr('data-sizes') || _.$slider.attr('data-sizes');
            imageToLoad = document.createElement('img');
            imageToLoad.onload = function() {
                if (imageSrcSet) {
                    image.attr('srcset', imageSrcSet);
                    if (imageSizes) image.attr('sizes', imageSizes);
                }
                image.attr('src', imageSource).removeAttr('data-lazy data-srcset data-sizes').removeClass('slick-loading');
                if (_.options.adaptiveHeight === true) _.setPosition();
                _.$slider.trigger('lazyLoaded', [
                    _,
                    image,
                    imageSource
                ]);
                _.progressiveLazyLoad();
            };
            imageToLoad.onerror = function() {
                if (tryCount < 3) /**
                     * try to load the image 3 times,
                     * leave a slight delay so we don't get
                     * servers blocking the request.
                     */ setTimeout(function() {
                    _.progressiveLazyLoad(tryCount + 1);
                }, 500);
                else {
                    image.removeAttr('data-lazy').removeClass('slick-loading').addClass('slick-lazyload-error');
                    _.$slider.trigger('lazyLoadError', [
                        _,
                        image,
                        imageSource
                    ]);
                    _.progressiveLazyLoad();
                }
            };
            imageToLoad.src = imageSource;
        } else _.$slider.trigger('allImagesLoaded', [
            _
        ]);
    };
    Slick.prototype.refresh = function(initializing) {
        var _ = this, currentSlide, lastVisibleIndex;
        lastVisibleIndex = _.slideCount - _.options.slidesToShow;
        // in non-infinite sliders, we don't want to go past the
        // last visible index.
        if (!_.options.infinite && _.currentSlide > lastVisibleIndex) _.currentSlide = lastVisibleIndex;
        // if less slides than to show, go to start.
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        currentSlide = _.currentSlide;
        _.destroy(true);
        $.extend(_, _.initials, {
            currentSlide: currentSlide
        });
        _.init();
        if (!initializing) _.changeSlide({
            data: {
                message: 'index',
                index: currentSlide
            }
        }, false);
    };
    Slick.prototype.registerBreakpoints = function() {
        var _ = this, breakpoint, currentBreakpoint, l, responsiveSettings = _.options.responsive || null;
        if ($.type(responsiveSettings) === 'array' && responsiveSettings.length) {
            _.respondTo = _.options.respondTo || 'window';
            for(breakpoint in responsiveSettings){
                l = _.breakpoints.length - 1;
                if (responsiveSettings.hasOwnProperty(breakpoint)) {
                    currentBreakpoint = responsiveSettings[breakpoint].breakpoint;
                    // loop through the breakpoints and cut out any existing
                    // ones with the same breakpoint number, we don't want dupes.
                    while(l >= 0){
                        if (_.breakpoints[l] && _.breakpoints[l] === currentBreakpoint) _.breakpoints.splice(l, 1);
                        l--;
                    }
                    _.breakpoints.push(currentBreakpoint);
                    _.breakpointSettings[currentBreakpoint] = responsiveSettings[breakpoint].settings;
                }
            }
            _.breakpoints.sort(function(a, b) {
                return _.options.mobileFirst ? a - b : b - a;
            });
        }
    };
    Slick.prototype.reinit = function() {
        var _ = this;
        _.$slides = _.$slideTrack.children(_.options.slide).addClass('slick-slide');
        _.slideCount = _.$slides.length;
        if (_.currentSlide >= _.slideCount && _.currentSlide !== 0) _.currentSlide = _.currentSlide - _.options.slidesToScroll;
        if (_.slideCount <= _.options.slidesToShow) _.currentSlide = 0;
        _.registerBreakpoints();
        _.setProps();
        _.setupInfinite();
        _.buildArrows();
        _.updateArrows();
        _.initArrowEvents();
        _.buildDots();
        _.updateDots();
        _.initDotEvents();
        _.cleanUpSlideEvents();
        _.initSlideEvents();
        _.checkResponsive(false, true);
        if (_.options.focusOnSelect === true) $(_.$slideTrack).children().on('click.slick', _.selectHandler);
        _.setSlideClasses(typeof _.currentSlide === 'number' ? _.currentSlide : 0);
        _.setPosition();
        _.focusHandler();
        _.paused = !_.options.autoplay;
        _.autoPlay();
        _.$slider.trigger('reInit', [
            _
        ]);
    };
    Slick.prototype.resize = function() {
        var _ = this;
        if ($(window).width() !== _.windowWidth) {
            clearTimeout(_.windowDelay);
            _.windowDelay = window.setTimeout(function() {
                _.windowWidth = $(window).width();
                _.checkResponsive();
                if (!_.unslicked) _.setPosition();
            }, 50);
        }
    };
    Slick.prototype.removeSlide = Slick.prototype.slickRemove = function(index, removeBefore, removeAll) {
        var _ = this;
        if (typeof index === 'boolean') {
            removeBefore = index;
            index = removeBefore === true ? 0 : _.slideCount - 1;
        } else index = removeBefore === true ? --index : index;
        if (_.slideCount < 1 || index < 0 || index > _.slideCount - 1) return false;
        _.unload();
        if (removeAll === true) _.$slideTrack.children().remove();
        else _.$slideTrack.children(this.options.slide).eq(index).remove();
        _.$slides = _.$slideTrack.children(this.options.slide);
        _.$slideTrack.children(this.options.slide).detach();
        _.$slideTrack.append(_.$slides);
        _.$slidesCache = _.$slides;
        _.reinit();
    };
    Slick.prototype.setCSS = function(position) {
        var _ = this, positionProps = {}, x, y;
        if (_.options.rtl === true) position = -position;
        x = _.positionProp == 'left' ? Math.ceil(position) + 'px' : '0px';
        y = _.positionProp == 'top' ? Math.ceil(position) + 'px' : '0px';
        positionProps[_.positionProp] = position;
        if (_.transformsEnabled === false) _.$slideTrack.css(positionProps);
        else {
            positionProps = {};
            if (_.cssTransitions === false) {
                positionProps[_.animType] = 'translate(' + x + ', ' + y + ')';
                _.$slideTrack.css(positionProps);
            } else {
                positionProps[_.animType] = 'translate3d(' + x + ', ' + y + ', 0px)';
                _.$slideTrack.css(positionProps);
            }
        }
    };
    Slick.prototype.setDimensions = function() {
        var _ = this;
        if (_.options.vertical === false) {
            if (_.options.centerMode === true) _.$list.css({
                padding: '0px ' + _.options.centerPadding
            });
        } else {
            _.$list.height(_.$slides.first().outerHeight(true) * _.options.slidesToShow);
            if (_.options.centerMode === true) _.$list.css({
                padding: _.options.centerPadding + ' 0px'
            });
        }
        _.listWidth = _.$list.width();
        _.listHeight = _.$list.height();
        if (_.options.vertical === false && _.options.variableWidth === false) {
            _.slideWidth = Math.ceil(_.listWidth / _.options.slidesToShow);
            _.$slideTrack.width(Math.ceil(_.slideWidth * _.$slideTrack.children('.slick-slide').length));
        } else if (_.options.variableWidth === true) _.$slideTrack.width(5000 * _.slideCount);
        else {
            _.slideWidth = Math.ceil(_.listWidth);
            _.$slideTrack.height(Math.ceil(_.$slides.first().outerHeight(true) * _.$slideTrack.children('.slick-slide').length));
        }
        var offset = _.$slides.first().outerWidth(true) - _.$slides.first().width();
        if (_.options.variableWidth === false) _.$slideTrack.children('.slick-slide').width(_.slideWidth - offset);
    };
    Slick.prototype.setFade = function() {
        var _ = this, targetLeft;
        _.$slides.each(function(index, element) {
            targetLeft = _.slideWidth * index * -1;
            if (_.options.rtl === true) $(element).css({
                position: 'relative',
                right: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
            else $(element).css({
                position: 'relative',
                left: targetLeft,
                top: 0,
                zIndex: _.options.zIndex - 2,
                opacity: 0
            });
        });
        _.$slides.eq(_.currentSlide).css({
            zIndex: _.options.zIndex - 1,
            opacity: 1
        });
    };
    Slick.prototype.setHeight = function() {
        var _ = this;
        if (_.options.slidesToShow === 1 && _.options.adaptiveHeight === true && _.options.vertical === false) {
            var targetHeight = _.$slides.eq(_.currentSlide).outerHeight(true);
            _.$list.css('height', targetHeight);
        }
    };
    Slick.prototype.setOption = Slick.prototype.slickSetOption = function() {
        /**
         * accepts arguments in format of:
         *
         *  - for changing a single option's value:
         *     .slick("setOption", option, value, refresh )
         *
         *  - for changing a set of responsive options:
         *     .slick("setOption", 'responsive', [{}, ...], refresh )
         *
         *  - for updating multiple values at once (not responsive)
         *     .slick("setOption", { 'option': value, ... }, refresh )
         */ var _ = this, l, item, option, value, refresh = false, type;
        if ($.type(arguments[0]) === 'object') {
            option = arguments[0];
            refresh = arguments[1];
            type = 'multiple';
        } else if ($.type(arguments[0]) === 'string') {
            option = arguments[0];
            value = arguments[1];
            refresh = arguments[2];
            if (arguments[0] === 'responsive' && $.type(arguments[1]) === 'array') type = 'responsive';
            else if (typeof arguments[1] !== 'undefined') type = 'single';
        }
        if (type === 'single') _.options[option] = value;
        else if (type === 'multiple') $.each(option, function(opt, val) {
            _.options[opt] = val;
        });
        else if (type === 'responsive') {
            for(item in value)if ($.type(_.options.responsive) !== 'array') _.options.responsive = [
                value[item]
            ];
            else {
                l = _.options.responsive.length - 1;
                // loop through the responsive object and splice out duplicates.
                while(l >= 0){
                    if (_.options.responsive[l].breakpoint === value[item].breakpoint) _.options.responsive.splice(l, 1);
                    l--;
                }
                _.options.responsive.push(value[item]);
            }
        }
        if (refresh) {
            _.unload();
            _.reinit();
        }
    };
    Slick.prototype.setPosition = function() {
        var _ = this;
        _.setDimensions();
        _.setHeight();
        if (_.options.fade === false) _.setCSS(_.getLeft(_.currentSlide));
        else _.setFade();
        _.$slider.trigger('setPosition', [
            _
        ]);
    };
    Slick.prototype.setProps = function() {
        var _ = this, bodyStyle = document.body.style;
        _.positionProp = _.options.vertical === true ? 'top' : 'left';
        if (_.positionProp === 'top') _.$slider.addClass('slick-vertical');
        else _.$slider.removeClass('slick-vertical');
        if (bodyStyle.WebkitTransition !== undefined || bodyStyle.MozTransition !== undefined || bodyStyle.msTransition !== undefined) {
            if (_.options.useCSS === true) _.cssTransitions = true;
        }
        if (_.options.fade) {
            if (typeof _.options.zIndex === 'number') {
                if (_.options.zIndex < 3) _.options.zIndex = 3;
            } else _.options.zIndex = _.defaults.zIndex;
        }
        if (bodyStyle.OTransform !== undefined) {
            _.animType = 'OTransform';
            _.transformType = '-o-transform';
            _.transitionType = 'OTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.MozTransform !== undefined) {
            _.animType = 'MozTransform';
            _.transformType = '-moz-transform';
            _.transitionType = 'MozTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.MozPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.webkitTransform !== undefined) {
            _.animType = 'webkitTransform';
            _.transformType = '-webkit-transform';
            _.transitionType = 'webkitTransition';
            if (bodyStyle.perspectiveProperty === undefined && bodyStyle.webkitPerspective === undefined) _.animType = false;
        }
        if (bodyStyle.msTransform !== undefined) {
            _.animType = 'msTransform';
            _.transformType = '-ms-transform';
            _.transitionType = 'msTransition';
            if (bodyStyle.msTransform === undefined) _.animType = false;
        }
        if (bodyStyle.transform !== undefined && _.animType !== false) {
            _.animType = 'transform';
            _.transformType = 'transform';
            _.transitionType = 'transition';
        }
        _.transformsEnabled = _.options.useTransform && _.animType !== null && _.animType !== false;
    };
    Slick.prototype.setSlideClasses = function(index) {
        var _ = this, centerOffset, allSlides, indexOffset, remainder;
        allSlides = _.$slider.find('.slick-slide').removeClass('slick-active slick-center slick-current').attr('aria-hidden', 'true');
        _.$slides.eq(index).addClass('slick-current');
        if (_.options.centerMode === true) {
            var evenCoef = _.options.slidesToShow % 2 === 0 ? 1 : 0;
            centerOffset = Math.floor(_.options.slidesToShow / 2);
            if (_.options.infinite === true) {
                if (index >= centerOffset && index <= _.slideCount - 1 - centerOffset) _.$slides.slice(index - centerOffset + evenCoef, index + centerOffset + 1).addClass('slick-active').attr('aria-hidden', 'false');
                else {
                    indexOffset = _.options.slidesToShow + index;
                    allSlides.slice(indexOffset - centerOffset + 1 + evenCoef, indexOffset + centerOffset + 2).addClass('slick-active').attr('aria-hidden', 'false');
                }
                if (index === 0) allSlides.eq(allSlides.length - 1 - _.options.slidesToShow).addClass('slick-center');
                else if (index === _.slideCount - 1) allSlides.eq(_.options.slidesToShow).addClass('slick-center');
            }
            _.$slides.eq(index).addClass('slick-center');
        } else {
            if (index >= 0 && index <= _.slideCount - _.options.slidesToShow) _.$slides.slice(index, index + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            else if (allSlides.length <= _.options.slidesToShow) allSlides.addClass('slick-active').attr('aria-hidden', 'false');
            else {
                remainder = _.slideCount % _.options.slidesToShow;
                indexOffset = _.options.infinite === true ? _.options.slidesToShow + index : index;
                if (_.options.slidesToShow == _.options.slidesToScroll && _.slideCount - index < _.options.slidesToShow) allSlides.slice(indexOffset - (_.options.slidesToShow - remainder), indexOffset + remainder).addClass('slick-active').attr('aria-hidden', 'false');
                else allSlides.slice(indexOffset, indexOffset + _.options.slidesToShow).addClass('slick-active').attr('aria-hidden', 'false');
            }
        }
        if (_.options.lazyLoad === 'ondemand' || _.options.lazyLoad === 'anticipated') _.lazyLoad();
    };
    Slick.prototype.setupInfinite = function() {
        var _ = this, i, slideIndex, infiniteCount;
        if (_.options.fade === true) _.options.centerMode = false;
        if (_.options.infinite === true && _.options.fade === false) {
            slideIndex = null;
            if (_.slideCount > _.options.slidesToShow) {
                if (_.options.centerMode === true) infiniteCount = _.options.slidesToShow + 1;
                else infiniteCount = _.options.slidesToShow;
                for(i = _.slideCount; i > _.slideCount - infiniteCount; i -= 1){
                    slideIndex = i - 1;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex - _.slideCount).prependTo(_.$slideTrack).addClass('slick-cloned');
                }
                for(i = 0; i < infiniteCount + _.slideCount; i += 1){
                    slideIndex = i;
                    $(_.$slides[slideIndex]).clone(true).attr('id', '').attr('data-slick-index', slideIndex + _.slideCount).appendTo(_.$slideTrack).addClass('slick-cloned');
                }
                _.$slideTrack.find('.slick-cloned').find('[id]').each(function() {
                    $(this).attr('id', '');
                });
            }
        }
    };
    Slick.prototype.interrupt = function(toggle) {
        var _ = this;
        if (!toggle) _.autoPlay();
        _.interrupted = toggle;
    };
    Slick.prototype.selectHandler = function(event) {
        var _ = this;
        var targetElement = $(event.target).is('.slick-slide') ? $(event.target) : $(event.target).parents('.slick-slide');
        var index = parseInt(targetElement.attr('data-slick-index'));
        if (!index) index = 0;
        if (_.slideCount <= _.options.slidesToShow) {
            _.slideHandler(index, false, true);
            return;
        }
        _.slideHandler(index);
    };
    Slick.prototype.slideHandler = function(index, sync, dontAnimate) {
        var targetSlide, animSlide, oldSlide, slideLeft, targetLeft = null, _ = this, navTarget;
        sync = sync || false;
        if (_.animating === true && _.options.waitForAnimate === true) return;
        if (_.options.fade === true && _.currentSlide === index) return;
        if (sync === false) _.asNavFor(index);
        targetSlide = index;
        targetLeft = _.getLeft(targetSlide);
        slideLeft = _.getLeft(_.currentSlide);
        _.currentLeft = _.swipeLeft === null ? slideLeft : _.swipeLeft;
        if (_.options.infinite === false && _.options.centerMode === false && (index < 0 || index > _.getDotCount() * _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        } else if (_.options.infinite === false && _.options.centerMode === true && (index < 0 || index > _.slideCount - _.options.slidesToScroll)) {
            if (_.options.fade === false) {
                targetSlide = _.currentSlide;
                if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(slideLeft, function() {
                    _.postSlide(targetSlide);
                });
                else _.postSlide(targetSlide);
            }
            return;
        }
        if (_.options.autoplay) clearInterval(_.autoPlayTimer);
        if (targetSlide < 0) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = _.slideCount - _.slideCount % _.options.slidesToScroll;
            else animSlide = _.slideCount + targetSlide;
        } else if (targetSlide >= _.slideCount) {
            if (_.slideCount % _.options.slidesToScroll !== 0) animSlide = 0;
            else animSlide = targetSlide - _.slideCount;
        } else animSlide = targetSlide;
        _.animating = true;
        _.$slider.trigger('beforeChange', [
            _,
            _.currentSlide,
            animSlide
        ]);
        oldSlide = _.currentSlide;
        _.currentSlide = animSlide;
        _.setSlideClasses(_.currentSlide);
        if (_.options.asNavFor) {
            navTarget = _.getNavTarget();
            navTarget = navTarget.slick('getSlick');
            if (navTarget.slideCount <= navTarget.options.slidesToShow) navTarget.setSlideClasses(_.currentSlide);
        }
        _.updateDots();
        _.updateArrows();
        if (_.options.fade === true) {
            if (dontAnimate !== true) {
                _.fadeSlideOut(oldSlide);
                _.fadeSlide(animSlide, function() {
                    _.postSlide(animSlide);
                });
            } else _.postSlide(animSlide);
            _.animateHeight();
            return;
        }
        if (dontAnimate !== true && _.slideCount > _.options.slidesToShow) _.animateSlide(targetLeft, function() {
            _.postSlide(animSlide);
        });
        else _.postSlide(animSlide);
    };
    Slick.prototype.startLoad = function() {
        var _ = this;
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow) {
            _.$prevArrow.hide();
            _.$nextArrow.hide();
        }
        if (_.options.dots === true && _.slideCount > _.options.slidesToShow) _.$dots.hide();
        _.$slider.addClass('slick-loading');
    };
    Slick.prototype.swipeDirection = function() {
        var xDist, yDist, r, swipeAngle, _ = this;
        xDist = _.touchObject.startX - _.touchObject.curX;
        yDist = _.touchObject.startY - _.touchObject.curY;
        r = Math.atan2(yDist, xDist);
        swipeAngle = Math.round(r * 180 / Math.PI);
        if (swipeAngle < 0) swipeAngle = 360 - Math.abs(swipeAngle);
        if (swipeAngle <= 45 && swipeAngle >= 0) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle <= 360 && swipeAngle >= 315) return _.options.rtl === false ? 'left' : 'right';
        if (swipeAngle >= 135 && swipeAngle <= 225) return _.options.rtl === false ? 'right' : 'left';
        if (_.options.verticalSwiping === true) {
            if (swipeAngle >= 35 && swipeAngle <= 135) return 'down';
            else return 'up';
        }
        return 'vertical';
    };
    Slick.prototype.swipeEnd = function(event) {
        var _ = this, slideCount, direction;
        _.dragging = false;
        _.swiping = false;
        if (_.scrolling) {
            _.scrolling = false;
            return false;
        }
        _.interrupted = false;
        _.shouldClick = _.touchObject.swipeLength > 10 ? false : true;
        if (_.touchObject.curX === undefined) return false;
        if (_.touchObject.edgeHit === true) _.$slider.trigger('edge', [
            _,
            _.swipeDirection()
        ]);
        if (_.touchObject.swipeLength >= _.touchObject.minSwipe) {
            direction = _.swipeDirection();
            switch(direction){
                case 'left':
                case 'down':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide + _.getSlideCount()) : _.currentSlide + _.getSlideCount();
                    _.currentDirection = 0;
                    break;
                case 'right':
                case 'up':
                    slideCount = _.options.swipeToSlide ? _.checkNavigable(_.currentSlide - _.getSlideCount()) : _.currentSlide - _.getSlideCount();
                    _.currentDirection = 1;
                    break;
                default:
            }
            if (direction != 'vertical') {
                _.slideHandler(slideCount);
                _.touchObject = {};
                _.$slider.trigger('swipe', [
                    _,
                    direction
                ]);
            }
        } else if (_.touchObject.startX !== _.touchObject.curX) {
            _.slideHandler(_.currentSlide);
            _.touchObject = {};
        }
    };
    Slick.prototype.swipeHandler = function(event) {
        var _ = this;
        if (_.options.swipe === false || 'ontouchend' in document && _.options.swipe === false) return;
        else if (_.options.draggable === false && event.type.indexOf('mouse') !== -1) return;
        _.touchObject.fingerCount = event.originalEvent && event.originalEvent.touches !== undefined ? event.originalEvent.touches.length : 1;
        _.touchObject.minSwipe = _.listWidth / _.options.touchThreshold;
        if (_.options.verticalSwiping === true) _.touchObject.minSwipe = _.listHeight / _.options.touchThreshold;
        switch(event.data.action){
            case 'start':
                _.swipeStart(event);
                break;
            case 'move':
                _.swipeMove(event);
                break;
            case 'end':
                _.swipeEnd(event);
                break;
        }
    };
    Slick.prototype.swipeMove = function(event) {
        var _ = this, edgeWasHit = false, curLeft, swipeDirection, swipeLength, positionOffset, touches, verticalSwipeLength;
        touches = event.originalEvent !== undefined ? event.originalEvent.touches : null;
        if (!_.dragging || _.scrolling || touches && touches.length !== 1) return false;
        curLeft = _.getLeft(_.currentSlide);
        _.touchObject.curX = touches !== undefined ? touches[0].pageX : event.clientX;
        _.touchObject.curY = touches !== undefined ? touches[0].pageY : event.clientY;
        _.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curX - _.touchObject.startX, 2)));
        verticalSwipeLength = Math.round(Math.sqrt(Math.pow(_.touchObject.curY - _.touchObject.startY, 2)));
        if (!_.options.verticalSwiping && !_.swiping && verticalSwipeLength > 4) {
            _.scrolling = true;
            return false;
        }
        if (_.options.verticalSwiping === true) _.touchObject.swipeLength = verticalSwipeLength;
        swipeDirection = _.swipeDirection();
        if (event.originalEvent !== undefined && _.touchObject.swipeLength > 4) {
            _.swiping = true;
            event.preventDefault();
        }
        positionOffset = (_.options.rtl === false ? 1 : -1) * (_.touchObject.curX > _.touchObject.startX ? 1 : -1);
        if (_.options.verticalSwiping === true) positionOffset = _.touchObject.curY > _.touchObject.startY ? 1 : -1;
        swipeLength = _.touchObject.swipeLength;
        _.touchObject.edgeHit = false;
        if (_.options.infinite === false) {
            if (_.currentSlide === 0 && swipeDirection === 'right' || _.currentSlide >= _.getDotCount() && swipeDirection === 'left') {
                swipeLength = _.touchObject.swipeLength * _.options.edgeFriction;
                _.touchObject.edgeHit = true;
            }
        }
        if (_.options.vertical === false) _.swipeLeft = curLeft + swipeLength * positionOffset;
        else _.swipeLeft = curLeft + swipeLength * (_.$list.height() / _.listWidth) * positionOffset;
        if (_.options.verticalSwiping === true) _.swipeLeft = curLeft + swipeLength * positionOffset;
        if (_.options.fade === true || _.options.touchMove === false) return false;
        if (_.animating === true) {
            _.swipeLeft = null;
            return false;
        }
        _.setCSS(_.swipeLeft);
    };
    Slick.prototype.swipeStart = function(event) {
        var _ = this, touches;
        _.interrupted = true;
        if (_.touchObject.fingerCount !== 1 || _.slideCount <= _.options.slidesToShow) {
            _.touchObject = {};
            return false;
        }
        if (event.originalEvent !== undefined && event.originalEvent.touches !== undefined) touches = event.originalEvent.touches[0];
        _.touchObject.startX = _.touchObject.curX = touches !== undefined ? touches.pageX : event.clientX;
        _.touchObject.startY = _.touchObject.curY = touches !== undefined ? touches.pageY : event.clientY;
        _.dragging = true;
    };
    Slick.prototype.unfilterSlides = Slick.prototype.slickUnfilter = function() {
        var _ = this;
        if (_.$slidesCache !== null) {
            _.unload();
            _.$slideTrack.children(this.options.slide).detach();
            _.$slidesCache.appendTo(_.$slideTrack);
            _.reinit();
        }
    };
    Slick.prototype.unload = function() {
        var _ = this;
        $('.slick-cloned', _.$slider).remove();
        if (_.$dots) _.$dots.remove();
        if (_.$prevArrow && _.htmlExpr.test(_.options.prevArrow)) _.$prevArrow.remove();
        if (_.$nextArrow && _.htmlExpr.test(_.options.nextArrow)) _.$nextArrow.remove();
        _.$slides.removeClass('slick-slide slick-active slick-visible slick-current').attr('aria-hidden', 'true').css('width', '');
    };
    Slick.prototype.unslick = function(fromBreakpoint) {
        var _ = this;
        _.$slider.trigger('unslick', [
            _,
            fromBreakpoint
        ]);
        _.destroy();
    };
    Slick.prototype.updateArrows = function() {
        var _ = this, centerOffset;
        centerOffset = Math.floor(_.options.slidesToShow / 2);
        if (_.options.arrows === true && _.slideCount > _.options.slidesToShow && !_.options.infinite) {
            _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            if (_.currentSlide === 0) {
                _.$prevArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$nextArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - _.options.slidesToShow && _.options.centerMode === false) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            } else if (_.currentSlide >= _.slideCount - 1 && _.options.centerMode === true) {
                _.$nextArrow.addClass('slick-disabled').attr('aria-disabled', 'true');
                _.$prevArrow.removeClass('slick-disabled').attr('aria-disabled', 'false');
            }
        }
    };
    Slick.prototype.updateDots = function() {
        var _ = this;
        if (_.$dots !== null) {
            _.$dots.find('li').removeClass('slick-active').end();
            _.$dots.find('li').eq(Math.floor(_.currentSlide / _.options.slidesToScroll)).addClass('slick-active');
        }
    };
    Slick.prototype.visibility = function() {
        var _ = this;
        if (_.options.autoplay) {
            if (document[_.hidden]) _.interrupted = true;
            else _.interrupted = false;
        }
    };
    $.fn.slick = function() {
        var _ = this, opt = arguments[0], args = Array.prototype.slice.call(arguments, 1), l = _.length, i, ret;
        for(i = 0; i < l; i++){
            if ((typeof opt === "undefined" ? "undefined" : (0, $dvYFb._)(opt)) == 'object' || typeof opt == 'undefined') _[i].slick = new Slick(_[i], opt);
            else ret = _[i].slick[opt].apply(_[i].slick, args);
            if (typeof ret != 'undefined') return ret;
        }
        return _;
    };
});




(0, (/*@__PURE__*/$parcel$interopDefault($3LkHX)))(document).ready(function() {
    (0, (/*@__PURE__*/$parcel$interopDefault($3LkHX)))('.responsive').slick({
        dots: false,
        infinite: true,
        slidesToShow: 2,
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7000,
        cssEase: 'linear',
        arrows: false,
        pauseOnHover: false,
        pauseOnFocus: false,
        swipe: false,
        draggable: false,
        touchMove: false,
        accessibility: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });
    (0, (/*@__PURE__*/$parcel$interopDefault($3LkHX)))(window).on('resize', function() {
        (0, (/*@__PURE__*/$parcel$interopDefault($3LkHX)))('.responsive').slick('slickPlay');
    });
});


var $2545262ca62cda48$var$themeSwitcher = document.getElementById('theme-switcher');
var $2545262ca62cda48$var$bodyElement = document.body;
var $2545262ca62cda48$var$storedValue = localStorage.getItem('light-mode');
if ($2545262ca62cda48$var$storedValue !== null) {
    var $2545262ca62cda48$var$isLight = $2545262ca62cda48$var$storedValue === 'true';
    $2545262ca62cda48$var$bodyElement.classList.toggle('light-mode', $2545262ca62cda48$var$isLight);
    $2545262ca62cda48$var$themeSwitcher.checked = $2545262ca62cda48$var$isLight;
}
$2545262ca62cda48$var$themeSwitcher.addEventListener('change', function() {
    var isLight = $2545262ca62cda48$var$themeSwitcher.checked;
    $2545262ca62cda48$var$bodyElement.classList.toggle('light-mode', isLight);
    localStorage.setItem('light-mode', isLight);
});


var $437c1211147a2971$export$6f57813fe9f31bf9 = {
    _origin: 'https://api.emailjs.com'
};


var $25abd42ee0db088a$export$2cd8252107eb640b = function(userID) {
    var origin = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'https://api.emailjs.com';
    (0, $437c1211147a2971$export$6f57813fe9f31bf9)._userID = userID;
    (0, $437c1211147a2971$export$6f57813fe9f31bf9)._origin = origin;
};



var $7ad51954087e72e8$export$1f3bf48e9edf7d72 = function(userID, serviceID, templateID) {
    if (!userID) throw 'The user ID is required. Visit https://dashboard.emailjs.com/admin/integration';
    if (!serviceID) throw 'The service ID is required. Visit https://dashboard.emailjs.com/admin';
    if (!templateID) throw 'The template ID is required. Visit https://dashboard.emailjs.com/admin/templates';
    return true;
};



var $5e9a078eaed94617$export$29b488039e3d4c2d = function EmailJSResponseStatus(httpResponse) {
    "use strict";
    (0, $7417b380464c38c1$export$71511d61b312f219)(this, EmailJSResponseStatus);
    this.status = httpResponse.status;
    this.text = httpResponse.responseText;
};



var $2a48de50d8da0e52$export$4a68059d3a005c64 = function(url, data) {
    var headers = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.addEventListener('load', function(param) {
            var target = param.target;
            var responseStatus = new (0, $5e9a078eaed94617$export$29b488039e3d4c2d)(target);
            if (responseStatus.status === 200 || responseStatus.text === 'OK') resolve(responseStatus);
            else reject(responseStatus);
        });
        xhr.addEventListener('error', function(param) {
            var target = param.target;
            reject(new (0, $5e9a078eaed94617$export$29b488039e3d4c2d)(target));
        });
        xhr.open('POST', (0, $437c1211147a2971$export$6f57813fe9f31bf9)._origin + url, true);
        Object.keys(headers).forEach(function(key) {
            xhr.setRequestHeader(key, headers[key]);
        });
        xhr.send(data);
    });
};


var $20a97db28d6a4af9$export$89db4734f6c919c4 = function(serviceID, templateID, templatePrams, userID) {
    var uID = userID || (0, $437c1211147a2971$export$6f57813fe9f31bf9)._userID;
    (0, $7ad51954087e72e8$export$1f3bf48e9edf7d72)(uID, serviceID, templateID);
    var params = {
        lib_version: '3.2.0',
        user_id: uID,
        service_id: serviceID,
        template_id: templateID,
        template_params: templatePrams
    };
    return (0, $2a48de50d8da0e52$export$4a68059d3a005c64)('/api/v1.0/email/send', JSON.stringify(params), {
        'Content-type': 'application/json'
    });
};





var $43284cfdec91e1e6$var$findHTMLForm = function(form) {
    var currentForm;
    if (typeof form === 'string') currentForm = document.querySelector(form);
    else currentForm = form;
    if (!currentForm || currentForm.nodeName !== 'FORM') throw 'The 3rd parameter is expected to be the HTML form element or the style selector of form';
    return currentForm;
};
var $43284cfdec91e1e6$export$c13a0f9407ffb567 = function(serviceID, templateID, form, userID) {
    var uID = userID || (0, $437c1211147a2971$export$6f57813fe9f31bf9)._userID;
    var currentForm = $43284cfdec91e1e6$var$findHTMLForm(form);
    (0, $7ad51954087e72e8$export$1f3bf48e9edf7d72)(uID, serviceID, templateID);
    var formData = new FormData(currentForm);
    formData.append('lib_version', '3.2.0');
    formData.append('service_id', serviceID);
    formData.append('template_id', templateID);
    formData.append('user_id', uID);
    return (0, $2a48de50d8da0e52$export$4a68059d3a005c64)('/api/v1.0/email/send-form', formData);
};


var $82347046137e53a1$export$2e2bcd8739ae039 = {
    init: (0, $25abd42ee0db088a$export$2cd8252107eb640b),
    send: (0, $20a97db28d6a4af9$export$89db4734f6c919c4),
    sendForm: (0, $43284cfdec91e1e6$export$c13a0f9407ffb567)
};


(0, $82347046137e53a1$export$2e2bcd8739ae039).init('mvWecfFXFh1VT12ni');



document.addEventListener('DOMContentLoaded', function() {
    var form = document.getElementById('contact-us-form');
    form.addEventListener('submit', function(e) {
        e.preventDefault();
        var serviceID = 'service_1igewl4';
        var templateID = 'template_fmp3git';
        (0, $82347046137e53a1$export$2e2bcd8739ae039).sendForm(serviceID, templateID, this).then(function() {
            alert(' Message sent successfully!');
            form.reset();
        }, function(err) {
            console.error('Failed to send message:', err);
            alert('Failed to send message. Check console for details.');
        });
    });
});


document.addEventListener("DOMContentLoaded", function() {
    var nav = document.getElementById("topnav");
    var icon = document.querySelector(".topnav .icon");
    if (icon && nav) icon.addEventListener("click", function() {
        nav.classList.toggle("responsive");
    });
});


(function() {
    // Horizontal Timeline - by CodyHouse.co
    var HorizontalTimeline = function HorizontalTimeline(element) {
        this.element = element;
        this.datesContainer = this.element.getElementsByClassName('cd-h-timeline__dates')[0];
        this.line = this.datesContainer.getElementsByClassName('cd-h-timeline__line')[0]; // grey line in the top timeline section
        this.fillingLine = this.datesContainer.getElementsByClassName('cd-h-timeline__filling-line')[0]; // green filling line in the top timeline section  
        this.date = this.line.getElementsByClassName('cd-h-timeline__date');
        this.selectedDate = this.line.getElementsByClassName('cd-h-timeline__date--selected')[0];
        this.dateValues = parseDate(this);
        this.minLapse = calcMinLapse(this);
        this.navigation = this.element.getElementsByClassName('cd-h-timeline__navigation');
        this.contentWrapper = this.element.getElementsByClassName('cd-h-timeline__events')[0];
        this.content = this.contentWrapper.getElementsByClassName('cd-h-timeline__event');
        this.eventsMinDistance = 60; // min distance between two consecutive events (in px)
        this.eventsMaxDistance = 200; // max distance between two consecutive events (in px)
        this.translate = 0; // this will be used to store the translate value of this.line
        this.lineLength = 0; //total length of this.line
        // store index of selected and previous selected dates
        this.oldDateIndex = Util.getIndexInArray(this.date, this.selectedDate);
        this.newDateIndex = this.oldDateIndex;
        initTimeline(this);
        initEvents(this);
    };
    function initTimeline(timeline) {
        // set dates left position
        var left = 0;
        for(var i = 0; i < timeline.dateValues.length; i++){
            var j = i == 0 ? 0 : i - 1;
            var distance = daydiff(timeline.dateValues[j], timeline.dateValues[i]), distanceNorm = (Math.round(distance / timeline.minLapse) + 2) * timeline.eventsMinDistance;
            if (distanceNorm < timeline.eventsMinDistance) distanceNorm = timeline.eventsMinDistance;
            else if (distanceNorm > timeline.eventsMaxDistance) distanceNorm = timeline.eventsMaxDistance;
            left = left + distanceNorm;
            timeline.date[i].setAttribute('style', 'left:' + left + 'px');
        }
        // set line/filling line dimensions
        timeline.line.style.width = left + timeline.eventsMinDistance + 'px';
        timeline.lineLength = left + timeline.eventsMinDistance;
        // reveal timeline
        Util.addClass(timeline.element, 'cd-h-timeline--loaded');
        selectNewDate(timeline, timeline.selectedDate);
        resetTimelinePosition(timeline, 'next');
    }
    function initEvents(timeline) {
        var self = timeline;
        // click on arrow navigation
        self.navigation[0].addEventListener('click', function(event) {
            event.preventDefault();
            translateTimeline(self, 'prev');
        });
        self.navigation[1].addEventListener('click', function(event) {
            event.preventDefault();
            translateTimeline(self, 'next');
        });
        //swipe on timeline
        new SwipeContent(self.datesContainer);
        self.datesContainer.addEventListener('swipeLeft', function(event) {
            translateTimeline(self, 'next');
        });
        self.datesContainer.addEventListener('swipeRight', function(event) {
            translateTimeline(self, 'prev');
        });
        //select a new event
        for(var i = 0; i < self.date.length; i++)(function(i) {
            self.date[i].addEventListener('click', function(event) {
                event.preventDefault();
                selectNewDate(self, event.target);
            });
            self.content[i].addEventListener('animationend', function(event) {
                if (i == self.newDateIndex && self.newDateIndex != self.oldDateIndex) resetAnimation(self);
            });
        })(i);
    }
    function updateFilling(timeline) {
        var dateStyle = window.getComputedStyle(timeline.selectedDate, null), left = dateStyle.getPropertyValue("left"), width = dateStyle.getPropertyValue("width");
        left = Number(left.replace('px', '')) + Number(width.replace('px', '')) / 2;
        timeline.fillingLine.style.transform = 'scaleX(' + left / timeline.lineLength + ')';
    }
    function translateTimeline(timeline, direction) {
        var containerWidth = timeline.datesContainer.offsetWidth;
        if (direction) timeline.translate = direction == 'next' ? timeline.translate - containerWidth + timeline.eventsMinDistance : timeline.translate + containerWidth - timeline.eventsMinDistance;
        if (0 - timeline.translate > timeline.lineLength - containerWidth) timeline.translate = containerWidth - timeline.lineLength;
        if (timeline.translate > 0) timeline.translate = 0;
        timeline.line.style.transform = 'translateX(' + timeline.translate + 'px)';
        // update the navigation items status (toggle inactive class)
        timeline.translate == 0 ? Util.addClass(timeline.navigation[0], 'cd-h-timeline__navigation--inactive') : Util.removeClass(timeline.navigation[0], 'cd-h-timeline__navigation--inactive');
        timeline.translate == containerWidth - timeline.lineLength ? Util.addClass(timeline.navigation[1], 'cd-h-timeline__navigation--inactive') : Util.removeClass(timeline.navigation[1], 'cd-h-timeline__navigation--inactive');
    }
    function selectNewDate(timeline, target) {
        timeline.newDateIndex = Util.getIndexInArray(timeline.date, target);
        timeline.oldDateIndex = Util.getIndexInArray(timeline.date, timeline.selectedDate);
        Util.removeClass(timeline.selectedDate, 'cd-h-timeline__date--selected');
        Util.addClass(timeline.date[timeline.newDateIndex], 'cd-h-timeline__date--selected');
        timeline.selectedDate = timeline.date[timeline.newDateIndex];
        updateOlderEvents(timeline);
        updateVisibleContent(timeline);
        updateFilling(timeline);
    }
    function updateOlderEvents(timeline) {
        for(var i = 0; i < timeline.date.length; i++)i < timeline.newDateIndex ? Util.addClass(timeline.date[i], 'cd-h-timeline__date--older-event') : Util.removeClass(timeline.date[i], 'cd-h-timeline__date--older-event');
    }
    function updateVisibleContent(timeline) {
        if (timeline.newDateIndex > timeline.oldDateIndex) var classEntering = 'cd-h-timeline__event--selected cd-h-timeline__event--enter-right', classLeaving = 'cd-h-timeline__event--leave-left';
        else if (timeline.newDateIndex < timeline.oldDateIndex) var classEntering = 'cd-h-timeline__event--selected cd-h-timeline__event--enter-left', classLeaving = 'cd-h-timeline__event--leave-right';
        else var classEntering = 'cd-h-timeline__event--selected', classLeaving = '';
        Util.addClass(timeline.content[timeline.newDateIndex], classEntering);
        if (timeline.newDateIndex != timeline.oldDateIndex) {
            Util.removeClass(timeline.content[timeline.oldDateIndex], 'cd-h-timeline__event--selected');
            Util.addClass(timeline.content[timeline.oldDateIndex], classLeaving);
            timeline.contentWrapper.style.height = timeline.content[timeline.newDateIndex].offsetHeight + 'px';
        }
    }
    function resetAnimation(timeline) {
        timeline.contentWrapper.style.height = null;
        Util.removeClass(timeline.content[timeline.newDateIndex], 'cd-h-timeline__event--enter-right cd-h-timeline__event--enter-left');
        Util.removeClass(timeline.content[timeline.oldDateIndex], 'cd-h-timeline__event--leave-right cd-h-timeline__event--leave-left');
    }
    function keyNavigateTimeline(timeline, direction) {
        var newIndex = direction == 'next' ? timeline.newDateIndex + 1 : timeline.newDateIndex - 1;
        if (newIndex < 0 || newIndex >= timeline.date.length) return;
        selectNewDate(timeline, timeline.date[newIndex]);
        resetTimelinePosition(timeline, direction);
    }
    function resetTimelinePosition(timeline, direction) {
        var eventStyle = window.getComputedStyle(timeline.selectedDate, null), eventLeft = Number(eventStyle.getPropertyValue('left').replace('px', '')), timelineWidth = timeline.datesContainer.offsetWidth;
        if (direction == 'next' && eventLeft >= timelineWidth - timeline.translate || direction == 'prev' && eventLeft <= -timeline.translate) {
            timeline.translate = timelineWidth / 2 - eventLeft;
            translateTimeline(timeline, false);
        }
    }
    function parseDate(timeline) {
        var dateArrays = [];
        for(var i = 0; i < timeline.date.length; i++){
            var singleDate = timeline.date[i].getAttribute('data-date'), dateComp = singleDate.split('T');
            if (dateComp.length > 1) var dayComp = dateComp[0].split('/'), timeComp = dateComp[1].split(':');
            else if (dateComp[0].indexOf(':') >= 0) var dayComp = [
                "2000",
                "0",
                "0"
            ], timeComp = dateComp[0].split(':');
            else var dayComp = dateComp[0].split('/'), timeComp = [
                "0",
                "0"
            ];
            var newDate = new Date(dayComp[2], dayComp[1] - 1, dayComp[0], timeComp[0], timeComp[1]);
            dateArrays.push(newDate);
        }
        return dateArrays;
    }
    function calcMinLapse(timeline) {
        var dateDistances = [];
        for(var i = 1; i < timeline.dateValues.length; i++){
            var distance = daydiff(timeline.dateValues[i - 1], timeline.dateValues[i]);
            if (distance > 0) dateDistances.push(distance);
        }
        return dateDistances.length > 0 ? Math.min.apply(null, dateDistances) : 86400000;
    }
    function daydiff(first, second) {
        return Math.round(second - first);
    }
    window.HorizontalTimeline = HorizontalTimeline;
    var horizontalTimeline = document.getElementsByClassName('js-cd-h-timeline'), horizontalTimelineTimelineArray = [];
    if (horizontalTimeline.length > 0) {
        for(var i = 0; i < horizontalTimeline.length; i++)horizontalTimelineTimelineArray.push(new HorizontalTimeline(horizontalTimeline[i]));
        // navigate the timeline when inside the viewport using the keyboard
        document.addEventListener('keydown', function(event) {
            if (event.keyCode && event.keyCode == 39 || event.key && event.key.toLowerCase() == 'arrowright') updateHorizontalTimeline('next'); // move to next event
            else if (event.keyCode && event.keyCode == 37 || event.key && event.key.toLowerCase() == 'arrowleft') updateHorizontalTimeline('prev'); // move to prev event
        });
    }
    function updateHorizontalTimeline(direction) {
        for(var i = 0; i < horizontalTimelineTimelineArray.length; i++)if (elementInViewport(horizontalTimeline[i])) keyNavigateTimeline(horizontalTimelineTimelineArray[i], direction);
    }
    /*
		How to tell if a DOM element is visible in the current viewport?
		http://stackoverflow.com/questions/123999/how-to-tell-if-a-dom-element-is-visible-in-the-current-viewport
	*/ function elementInViewport(el) {
        var top = el.offsetTop;
        var left = el.offsetLeft;
        var width = el.offsetWidth;
        var height = el.offsetHeight;
        while(el.offsetParent){
            el = el.offsetParent;
            top += el.offsetTop;
            left += el.offsetLeft;
        }
        return top < window.pageYOffset + window.innerHeight && left < window.pageXOffset + window.innerWidth && top + height > window.pageYOffset && left + width > window.pageXOffset;
    }
})();


document.addEventListener('DOMContentLoaded', function() {
    var updateTimeline = function updateTimeline(index) {
        years.forEach(function(el, i) {
            return el.classList.toggle('active', i === index);
        });
        items.forEach(function(el, i) {
            return el.classList.toggle('active', i === index);
        });
        activeIndex = index;
        prevBtn.disabled = activeIndex === 0;
        nextBtn.disabled = activeIndex === years.length - 1;
        var li = years[index];
        var trackWidth = track.offsetWidth;
        var liCenter = li.offsetLeft + li.offsetWidth / 2;
        var scrollPos = liCenter - trackWidth / 2;
        scrollPos = Math.max(0, Math.min(scrollPos, track.scrollWidth - trackWidth));
        track.scrollTo({
            left: scrollPos,
            behavior: 'smooth'
        });
    };
    var years = document.querySelectorAll('.timeline-years li');
    var items = document.querySelectorAll('.timeline-item');
    var prevBtn = document.querySelector('.timeline-btn.prev');
    var nextBtn = document.querySelector('.timeline-btn.next');
    var track = document.querySelector('.timeline-track');
    var activeIndex = 0;
    // Click on years
    years.forEach(function(year, index) {
        year.addEventListener('click', function() {
            return updateTimeline(index);
        });
    });
    // Prev button
    prevBtn.addEventListener('click', function() {
        if (activeIndex > 0) updateTimeline(activeIndex - 1);
    });
    // Next button
    nextBtn.addEventListener('click', function() {
        if (activeIndex < years.length - 1) updateTimeline(activeIndex + 1);
    });
    // Initialize timeline
    updateTimeline(0);
});




})();
//# sourceMappingURL=repo.19376bbb.js.map
